
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8e71"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8e71"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = jsx;
    $587db01302e19550$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.2.0";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("3y30c", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2956e04298bc31b1$export$ae55be85d98224ed, (v) => $2956e04298bc31b1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2956e04298bc31b1$export$882461b6382ed46c, (v) => $2956e04298bc31b1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2956e04298bc31b1$export$466bfc07425424d5, (v) => $2956e04298bc31b1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2956e04298bc31b1$export$fa8d919ba61d84db, (v) => $2956e04298bc31b1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2956e04298bc31b1$export$757ceba2d55c277e, (v) => $2956e04298bc31b1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2956e04298bc31b1$export$b3890eb0ae9dca99, (v) => $2956e04298bc31b1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2956e04298bc31b1$export$502457920280e6be, (v) => $2956e04298bc31b1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2956e04298bc31b1$export$dc54d992c10e8a18, (v) => $2956e04298bc31b1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$ae55be85d98224ed;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$882461b6382ed46c;
var $2956e04298bc31b1$export$466bfc07425424d5;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$fa8d919ba61d84db;
var $2956e04298bc31b1$export$757ceba2d55c277e;
var $2956e04298bc31b1$export$b3890eb0ae9dca99;
var $2956e04298bc31b1$export$502457920280e6be;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$dc54d992c10e8a18;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var Scheduler = (parcelRequire("fO90s"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = false; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {}; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = resolvedInst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.2.0";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $2956e04298bc31b1$export$ae55be85d98224ed = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = createPortal$1;
    $2956e04298bc31b1$export$882461b6382ed46c = createRoot$1;
    $2956e04298bc31b1$export$466bfc07425424d5 = findDOMNode;
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = flushSync$1;
    $2956e04298bc31b1$export$fa8d919ba61d84db = hydrate;
    $2956e04298bc31b1$export$757ceba2d55c277e = hydrateRoot$1;
    $2956e04298bc31b1$export$b3890eb0ae9dca99 = render;
    $2956e04298bc31b1$export$502457920280e6be = unmountComponentAtNode;
    $2956e04298bc31b1$export$c78a37762a8d58e1 = batchedUpdates$1;
    $2956e04298bc31b1$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $2956e04298bc31b1$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $553b3f9a1c62156e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = forceFrameRate;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("jZhQX", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && "object" === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ("number" === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && "object" === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === "string") {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === "number") return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes["f" + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes["numpad " + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("1WntU", function(module, exports) {
"use strict";

var $eDick = parcelRequire("eDick");
var $169d6c2963909da7$var$httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
    if (decodeResponseBody === void 0) decodeResponseBody = false;
    return function(err, response, responseBody) {
        // if the XHR failed, return that error
        if (err) {
            callback(err);
            return;
        } // if the HTTP status code is 4xx or 5xx, the request also failed
        if (response.statusCode >= 400 && response.statusCode <= 599) {
            var cause = responseBody;
            if (decodeResponseBody) {
                if ($eDick.TextDecoder) {
                    var charset = $169d6c2963909da7$var$getCharset(response.headers && response.headers["content-type"]);
                    try {
                        cause = new TextDecoder(charset).decode(responseBody);
                    } catch (e) {}
                } else cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
            }
            callback({
                cause: cause
            });
            return;
        } // otherwise, request succeeded
        callback(null, responseBody);
    };
};
function $169d6c2963909da7$var$getCharset(contentTypeHeader) {
    if (contentTypeHeader === void 0) contentTypeHeader = "";
    return contentTypeHeader.toLowerCase().split(";").reduce(function(charset, contentType) {
        var _contentType$split = contentType.split("="), type = _contentType$split[0], value = _contentType$split[1];
        if (type.trim() === "charset") return value.trim();
        return charset;
    }, "utf-8");
}
module.exports = $169d6c2963909da7$var$httpResponseHandler;

});
parcelRegister("eDick", function(module, exports) {
var $aa72d2e69fd2fe14$var$win;
if (typeof window !== "undefined") $aa72d2e69fd2fe14$var$win = window;
else if (typeof $parcel$global !== "undefined") $aa72d2e69fd2fe14$var$win = $parcel$global;
else if (typeof self !== "undefined") $aa72d2e69fd2fe14$var$win = self;
else $aa72d2e69fd2fe14$var$win = {};
module.exports = $aa72d2e69fd2fe14$var$win;

});


parcelRegister("65ElS", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */ /* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */ 
var $7pNCM = parcelRequire("7pNCM");
var $46f282c1f2cd4950$var$_objCreate = Object.create || function() {
    function F() {}
    return function(o) {
        if (arguments.length !== 1) throw new Error("Object.create shim only accepts one parameter.");
        F.prototype = o;
        return new F();
    };
}();
// Creates a new ParserError object from an errorData object. The errorData
// object should have default code and message properties. The default message
// property can be overriden by passing in a message parameter.
// See ParsingError.Errors below for acceptable errors.
function $46f282c1f2cd4950$var$ParsingError(errorData, message) {
    this.name = "ParsingError";
    this.code = errorData.code;
    this.message = message || errorData.message;
}
$46f282c1f2cd4950$var$ParsingError.prototype = $46f282c1f2cd4950$var$_objCreate(Error.prototype);
$46f282c1f2cd4950$var$ParsingError.prototype.constructor = $46f282c1f2cd4950$var$ParsingError;
// ParsingError metadata for acceptable ParsingErrors.
$46f282c1f2cd4950$var$ParsingError.Errors = {
    BadSignature: {
        code: 0,
        message: "Malformed WebVTT signature."
    },
    BadTimeStamp: {
        code: 1,
        message: "Malformed time stamp."
    }
};
// Try to parse input as a time stamp.
function $46f282c1f2cd4950$var$parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
    }
    var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
    if (!m) return null;
    if (m[3]) // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
    else if (m[1] > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0, m[4]);
    else // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function $46f282c1f2cd4950$var$Settings() {
    this.values = $46f282c1f2cd4950$var$_objCreate(null);
}
$46f282c1f2cd4950$var$Settings.prototype = {
    // Only accept the first assignment to any key.
    set: function(k, v) {
        if (!this.get(k) && v !== "") this.values[k] = v;
    },
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get: function(k, dflt, defaultKey) {
        if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
        return this.has(k) ? this.values[k] : dflt;
    },
    // Check whether we have a value for a key.
    has: function(k) {
        return k in this.values;
    },
    // Accept a setting if its one of the given alternatives.
    alt: function(k, v, a) {
        for(var n = 0; n < a.length; ++n)if (v === a[n]) {
            this.set(k, v);
            break;
        }
    },
    // Accept a setting if its a valid (signed) integer.
    integer: function(k, v) {
        if (/^-?\d+$/.test(v)) this.set(k, parseInt(v, 10));
    },
    // Accept a setting if its a valid percentage.
    percent: function(k, v) {
        var m;
        if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
            v = parseFloat(v);
            if (v >= 0 && v <= 100) {
                this.set(k, v);
                return true;
            }
        }
        return false;
    }
};
// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function $46f282c1f2cd4950$var$parseOptions(input, callback, keyValueDelim, groupDelim) {
    var groups = groupDelim ? input.split(groupDelim) : [
        input
    ];
    for(var i in groups){
        if (typeof groups[i] !== "string") continue;
        var kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) continue;
        var k = kv[0].trim();
        var v = kv[1].trim();
        callback(k, v);
    }
}
function $46f282c1f2cd4950$var$parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    var oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        var ts = $46f282c1f2cd4950$var$parseTimeStamp(input);
        if (ts === null) throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadTimeStamp, "Malformed timestamp: " + oInput);
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, "");
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        var settings = new $46f282c1f2cd4950$var$Settings();
        $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
            switch(k){
                case "region":
                    // Find the last region we parsed with the same region id.
                    for(var i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                        settings.set(k, regionList[i].region);
                        break;
                    }
                    break;
                case "vertical":
                    settings.alt(k, v, [
                        "rl",
                        "lr"
                    ]);
                    break;
                case "line":
                    var vals = v.split(","), vals0 = vals[0];
                    settings.integer(k, vals0);
                    settings.percent(k, vals0) && settings.set("snapToLines", false);
                    settings.alt(k, vals0, [
                        "auto"
                    ]);
                    if (vals.length === 2) settings.alt("lineAlign", vals[1], [
                        "start",
                        "center",
                        "end"
                    ]);
                    break;
                case "position":
                    vals = v.split(",");
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) settings.alt("positionAlign", vals[1], [
                        "start",
                        "center",
                        "end"
                    ]);
                    break;
                case "size":
                    settings.percent(k, v);
                    break;
                case "align":
                    settings.alt(k, v, [
                        "start",
                        "center",
                        "end",
                        "left",
                        "right"
                    ]);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get("region", null);
        cue.vertical = settings.get("vertical", "");
        try {
            cue.line = settings.get("line", "auto");
        } catch (e) {}
        cue.lineAlign = settings.get("lineAlign", "start");
        cue.snapToLines = settings.get("snapToLines", true);
        cue.size = settings.get("size", 100);
        // Safari still uses the old middle value and won't accept center
        try {
            cue.align = settings.get("align", "center");
        } catch (e) {
            cue.align = settings.get("align", "middle");
        }
        try {
            cue.position = settings.get("position", "auto");
        } catch (e) {
            cue.position = settings.get("position", {
                start: 0,
                left: 0,
                center: 50,
                middle: 50,
                end: 100,
                right: 100
            }, cue.align);
        }
        cue.positionAlign = settings.get("positionAlign", {
            start: "start",
            left: "start",
            center: "center",
            middle: "center",
            end: "end",
            right: "end"
        }, cue.align);
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, "");
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.substr(0, 3) !== "-->") throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
    input = input.substr(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
// When evaluating this file as part of a Webpack bundle for server
// side rendering, `document` is an empty object.
var $46f282c1f2cd4950$var$TEXTAREA_ELEMENT = $7pNCM.createElement && $7pNCM.createElement("textarea");
var $46f282c1f2cd4950$var$TAG_NAME = {
    c: "span",
    i: "i",
    b: "b",
    u: "u",
    ruby: "ruby",
    rt: "rt",
    v: "span",
    lang: "span"
};
// 5.1 default text color
// 5.2 default text background color is equivalent to text color with bg_ prefix
var $46f282c1f2cd4950$var$DEFAULT_COLOR_CLASS = {
    white: "rgba(255,255,255,1)",
    lime: "rgba(0,255,0,1)",
    cyan: "rgba(0,255,255,1)",
    red: "rgba(255,0,0,1)",
    yellow: "rgba(255,255,0,1)",
    magenta: "rgba(255,0,255,1)",
    blue: "rgba(0,0,255,1)",
    black: "rgba(0,0,0,1)"
};
var $46f282c1f2cd4950$var$TAG_ANNOTATION = {
    v: "title",
    lang: "lang"
};
var $46f282c1f2cd4950$var$NEEDS_PARENT = {
    rt: "ruby"
};
// Parse content into a document fragment.
function $46f282c1f2cd4950$var$parseContent(window, input) {
    function nextToken() {
        // Check for end-of-string.
        if (!input) return null;
        // Consume 'n' characters from the input.
        function consume(result) {
            input = input.substr(result.length);
            return result;
        }
        var m = input.match(/^([^<]*)(<[^>]*>?)?/);
        // If there is some text before the next tag, return it, otherwise return
        // the tag.
        return consume(m[1] ? m[1] : m[2]);
    }
    function unescape(s) {
        $46f282c1f2cd4950$var$TEXTAREA_ELEMENT.innerHTML = s;
        s = $46f282c1f2cd4950$var$TEXTAREA_ELEMENT.textContent;
        $46f282c1f2cd4950$var$TEXTAREA_ELEMENT.textContent = "";
        return s;
    }
    function shouldAdd(current, element) {
        return !$46f282c1f2cd4950$var$NEEDS_PARENT[element.localName] || $46f282c1f2cd4950$var$NEEDS_PARENT[element.localName] === current.localName;
    }
    // Create an element for this tag.
    function createElement(type, annotation) {
        var tagName = $46f282c1f2cd4950$var$TAG_NAME[type];
        if (!tagName) return null;
        var element = window.document.createElement(tagName);
        var name = $46f282c1f2cd4950$var$TAG_ANNOTATION[type];
        if (name && annotation) element[name] = annotation.trim();
        return element;
    }
    var rootDiv = window.document.createElement("div"), current = rootDiv, t, tagStack = [];
    while((t = nextToken()) !== null){
        if (t[0] === "<") {
            if (t[1] === "/") {
                // If the closing tag matches, move back up to the parent node.
                if (tagStack.length && tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
                    tagStack.pop();
                    current = current.parentNode;
                }
                continue;
            }
            var ts = $46f282c1f2cd4950$var$parseTimeStamp(t.substr(1, t.length - 2));
            var node;
            if (ts) {
                // Timestamps are lead nodes as well.
                node = window.document.createProcessingInstruction("timestamp", ts);
                current.appendChild(node);
                continue;
            }
            var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
            // If we can't parse the tag, skip to the next tag.
            if (!m) continue;
            // Try to construct an element, and ignore the tag if we couldn't.
            node = createElement(m[1], m[3]);
            if (!node) continue;
            // Determine if the tag should be added based on the context of where it
            // is placed in the cuetext.
            if (!shouldAdd(current, node)) continue;
            // Set the class list (as a list of classes, separated by space).
            if (m[2]) {
                var classes = m[2].split(".");
                classes.forEach(function(cl) {
                    var bgColor = /^bg_/.test(cl);
                    // slice out `bg_` if it's a background color
                    var colorName = bgColor ? cl.slice(3) : cl;
                    if ($46f282c1f2cd4950$var$DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
                        var propName = bgColor ? "background-color" : "color";
                        var propValue = $46f282c1f2cd4950$var$DEFAULT_COLOR_CLASS[colorName];
                        node.style[propName] = propValue;
                    }
                });
                node.className = classes.join(" ");
            }
            // Append the node to the current node, and enter the scope of the new
            // node.
            tagStack.push(m[1]);
            current.appendChild(node);
            current = node;
            continue;
        }
        // Text nodes are leaf nodes.
        current.appendChild(window.document.createTextNode(unescape(t)));
    }
    return rootDiv;
}
// This is a list of all the Unicode characters that have a strong
// right-to-left category. What this means is that these characters are
// written right-to-left for sure. It was generated by pulling all the strong
// right-to-left characters out of the Unicode data table. That table can
// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
var $46f282c1f2cd4950$var$strongRTLRanges = [
    [
        0x5be,
        0x5be
    ],
    [
        0x5c0,
        0x5c0
    ],
    [
        0x5c3,
        0x5c3
    ],
    [
        0x5c6,
        0x5c6
    ],
    [
        0x5d0,
        0x5ea
    ],
    [
        0x5f0,
        0x5f4
    ],
    [
        0x608,
        0x608
    ],
    [
        0x60b,
        0x60b
    ],
    [
        0x60d,
        0x60d
    ],
    [
        0x61b,
        0x61b
    ],
    [
        0x61e,
        0x64a
    ],
    [
        0x66d,
        0x66f
    ],
    [
        0x671,
        0x6d5
    ],
    [
        0x6e5,
        0x6e6
    ],
    [
        0x6ee,
        0x6ef
    ],
    [
        0x6fa,
        0x70d
    ],
    [
        0x70f,
        0x710
    ],
    [
        0x712,
        0x72f
    ],
    [
        0x74d,
        0x7a5
    ],
    [
        0x7b1,
        0x7b1
    ],
    [
        0x7c0,
        0x7ea
    ],
    [
        0x7f4,
        0x7f5
    ],
    [
        0x7fa,
        0x7fa
    ],
    [
        0x800,
        0x815
    ],
    [
        0x81a,
        0x81a
    ],
    [
        0x824,
        0x824
    ],
    [
        0x828,
        0x828
    ],
    [
        0x830,
        0x83e
    ],
    [
        0x840,
        0x858
    ],
    [
        0x85e,
        0x85e
    ],
    [
        0x8a0,
        0x8a0
    ],
    [
        0x8a2,
        0x8ac
    ],
    [
        0x200f,
        0x200f
    ],
    [
        0xfb1d,
        0xfb1d
    ],
    [
        0xfb1f,
        0xfb28
    ],
    [
        0xfb2a,
        0xfb36
    ],
    [
        0xfb38,
        0xfb3c
    ],
    [
        0xfb3e,
        0xfb3e
    ],
    [
        0xfb40,
        0xfb41
    ],
    [
        0xfb43,
        0xfb44
    ],
    [
        0xfb46,
        0xfbc1
    ],
    [
        0xfbd3,
        0xfd3d
    ],
    [
        0xfd50,
        0xfd8f
    ],
    [
        0xfd92,
        0xfdc7
    ],
    [
        0xfdf0,
        0xfdfc
    ],
    [
        0xfe70,
        0xfe74
    ],
    [
        0xfe76,
        0xfefc
    ],
    [
        0x10800,
        0x10805
    ],
    [
        0x10808,
        0x10808
    ],
    [
        0x1080a,
        0x10835
    ],
    [
        0x10837,
        0x10838
    ],
    [
        0x1083c,
        0x1083c
    ],
    [
        0x1083f,
        0x10855
    ],
    [
        0x10857,
        0x1085f
    ],
    [
        0x10900,
        0x1091b
    ],
    [
        0x10920,
        0x10939
    ],
    [
        0x1093f,
        0x1093f
    ],
    [
        0x10980,
        0x109b7
    ],
    [
        0x109be,
        0x109bf
    ],
    [
        0x10a00,
        0x10a00
    ],
    [
        0x10a10,
        0x10a13
    ],
    [
        0x10a15,
        0x10a17
    ],
    [
        0x10a19,
        0x10a33
    ],
    [
        0x10a40,
        0x10a47
    ],
    [
        0x10a50,
        0x10a58
    ],
    [
        0x10a60,
        0x10a7f
    ],
    [
        0x10b00,
        0x10b35
    ],
    [
        0x10b40,
        0x10b55
    ],
    [
        0x10b58,
        0x10b72
    ],
    [
        0x10b78,
        0x10b7f
    ],
    [
        0x10c00,
        0x10c48
    ],
    [
        0x1ee00,
        0x1ee03
    ],
    [
        0x1ee05,
        0x1ee1f
    ],
    [
        0x1ee21,
        0x1ee22
    ],
    [
        0x1ee24,
        0x1ee24
    ],
    [
        0x1ee27,
        0x1ee27
    ],
    [
        0x1ee29,
        0x1ee32
    ],
    [
        0x1ee34,
        0x1ee37
    ],
    [
        0x1ee39,
        0x1ee39
    ],
    [
        0x1ee3b,
        0x1ee3b
    ],
    [
        0x1ee42,
        0x1ee42
    ],
    [
        0x1ee47,
        0x1ee47
    ],
    [
        0x1ee49,
        0x1ee49
    ],
    [
        0x1ee4b,
        0x1ee4b
    ],
    [
        0x1ee4d,
        0x1ee4f
    ],
    [
        0x1ee51,
        0x1ee52
    ],
    [
        0x1ee54,
        0x1ee54
    ],
    [
        0x1ee57,
        0x1ee57
    ],
    [
        0x1ee59,
        0x1ee59
    ],
    [
        0x1ee5b,
        0x1ee5b
    ],
    [
        0x1ee5d,
        0x1ee5d
    ],
    [
        0x1ee5f,
        0x1ee5f
    ],
    [
        0x1ee61,
        0x1ee62
    ],
    [
        0x1ee64,
        0x1ee64
    ],
    [
        0x1ee67,
        0x1ee6a
    ],
    [
        0x1ee6c,
        0x1ee72
    ],
    [
        0x1ee74,
        0x1ee77
    ],
    [
        0x1ee79,
        0x1ee7c
    ],
    [
        0x1ee7e,
        0x1ee7e
    ],
    [
        0x1ee80,
        0x1ee89
    ],
    [
        0x1ee8b,
        0x1ee9b
    ],
    [
        0x1eea1,
        0x1eea3
    ],
    [
        0x1eea5,
        0x1eea9
    ],
    [
        0x1eeab,
        0x1eebb
    ],
    [
        0x10fffd,
        0x10fffd
    ]
];
function $46f282c1f2cd4950$var$isStrongRTLChar(charCode) {
    for(var i = 0; i < $46f282c1f2cd4950$var$strongRTLRanges.length; i++){
        var currentRange = $46f282c1f2cd4950$var$strongRTLRanges[i];
        if (charCode >= currentRange[0] && charCode <= currentRange[1]) return true;
    }
    return false;
}
function $46f282c1f2cd4950$var$determineBidi(cueDiv) {
    var nodeStack = [], text = "", charCode;
    if (!cueDiv || !cueDiv.childNodes) return "ltr";
    function pushNodes(nodeStack, node) {
        for(var i = node.childNodes.length - 1; i >= 0; i--)nodeStack.push(node.childNodes[i]);
    }
    function nextTextNode(nodeStack) {
        if (!nodeStack || !nodeStack.length) return null;
        var node = nodeStack.pop(), text = node.textContent || node.innerText;
        if (text) {
            // TODO: This should match all unicode type B characters (paragraph
            // separator characters). See issue #115.
            var m = text.match(/^.*(\n|\r)/);
            if (m) {
                nodeStack.length = 0;
                return m[0];
            }
            return text;
        }
        if (node.tagName === "ruby") return nextTextNode(nodeStack);
        if (node.childNodes) {
            pushNodes(nodeStack, node);
            return nextTextNode(nodeStack);
        }
    }
    pushNodes(nodeStack, cueDiv);
    while(text = nextTextNode(nodeStack))for(var i = 0; i < text.length; i++){
        charCode = text.charCodeAt(i);
        if ($46f282c1f2cd4950$var$isStrongRTLChar(charCode)) return "rtl";
    }
    return "ltr";
}
function $46f282c1f2cd4950$var$computeLinePos(cue) {
    if (typeof cue.line === "number" && (cue.snapToLines || cue.line >= 0 && cue.line <= 100)) return cue.line;
    if (!cue.track || !cue.track.textTrackList || !cue.track.textTrackList.mediaElement) return -1;
    var track = cue.track, trackList = track.textTrackList, count = 0;
    for(var i = 0; i < trackList.length && trackList[i] !== track; i++)if (trackList[i].mode === "showing") count++;
    return ++count * -1;
}
function $46f282c1f2cd4950$var$StyleBox() {}
// Apply styles to a div. If there is no div passed then it defaults to the
// div on 'this'.
$46f282c1f2cd4950$var$StyleBox.prototype.applyStyles = function(styles, div) {
    div = div || this.div;
    for(var prop in styles)if (styles.hasOwnProperty(prop)) div.style[prop] = styles[prop];
};
$46f282c1f2cd4950$var$StyleBox.prototype.formatStyle = function(val, unit) {
    return val === 0 ? 0 : val + unit;
};
// Constructs the computed display state of the cue (a div). Places the div
// into the overlay which should be a block level element (usually a div).
function $46f282c1f2cd4950$var$CueStyleBox(window, cue, styleOptions) {
    $46f282c1f2cd4950$var$StyleBox.call(this);
    this.cue = cue;
    // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
    // have inline positioning and will function as the cue background box.
    this.cueDiv = $46f282c1f2cd4950$var$parseContent(window, cue.text);
    var styles = {
        color: "rgba(255, 255, 255, 1)",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        position: "relative",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "inline",
        writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
        unicodeBidi: "plaintext"
    };
    this.applyStyles(styles, this.cueDiv);
    // Create an absolutely positioned div that will be used to position the cue
    // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
    // mirrors of them except middle instead of center on Safari.
    this.div = window.document.createElement("div");
    styles = {
        direction: $46f282c1f2cd4950$var$determineBidi(this.cueDiv),
        writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
        unicodeBidi: "plaintext",
        textAlign: cue.align === "middle" ? "center" : cue.align,
        font: styleOptions.font,
        whiteSpace: "pre-line",
        position: "absolute"
    };
    this.applyStyles(styles);
    this.div.appendChild(this.cueDiv);
    // Calculate the distance from the reference edge of the viewport to the text
    // position of the cue box. The reference edge will be resolved later when
    // the box orientation styles are applied.
    var textPos = 0;
    switch(cue.positionAlign){
        case "start":
        case "line-left":
            textPos = cue.position;
            break;
        case "center":
            textPos = cue.position - cue.size / 2;
            break;
        case "end":
        case "line-right":
            textPos = cue.position - cue.size;
            break;
    }
    // Horizontal box orientation; textPos is the distance from the left edge of the
    // area to the left edge of the box and cue.size is the distance extending to
    // the right from there.
    if (cue.vertical === "") this.applyStyles({
        left: this.formatStyle(textPos, "%"),
        width: this.formatStyle(cue.size, "%")
    });
    else this.applyStyles({
        top: this.formatStyle(textPos, "%"),
        height: this.formatStyle(cue.size, "%")
    });
    this.move = function(box) {
        this.applyStyles({
            top: this.formatStyle(box.top, "px"),
            bottom: this.formatStyle(box.bottom, "px"),
            left: this.formatStyle(box.left, "px"),
            right: this.formatStyle(box.right, "px"),
            height: this.formatStyle(box.height, "px"),
            width: this.formatStyle(box.width, "px")
        });
    };
}
$46f282c1f2cd4950$var$CueStyleBox.prototype = $46f282c1f2cd4950$var$_objCreate($46f282c1f2cd4950$var$StyleBox.prototype);
$46f282c1f2cd4950$var$CueStyleBox.prototype.constructor = $46f282c1f2cd4950$var$CueStyleBox;
// Represents the co-ordinates of an Element in a way that we can easily
// compute things with such as if it overlaps or intersects with another Element.
// Can initialize it with either a StyleBox or another BoxPosition.
function $46f282c1f2cd4950$var$BoxPosition(obj) {
    // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
    // was passed in and we need to copy the results of 'getBoundingClientRect'
    // as the object returned is readonly. All co-ordinate values are in reference
    // to the viewport origin (top left).
    var lh, height, width, top;
    if (obj.div) {
        height = obj.div.offsetHeight;
        width = obj.div.offsetWidth;
        top = obj.div.offsetTop;
        var rects = (rects = obj.div.childNodes) && (rects = rects[0]) && rects.getClientRects && rects.getClientRects();
        obj = obj.div.getBoundingClientRect();
        // In certain cases the outter div will be slightly larger then the sum of
        // the inner div's lines. This could be due to bold text, etc, on some platforms.
        // In this case we should get the average line height and use that. This will
        // result in the desired behaviour.
        lh = rects ? Math.max(rects[0] && rects[0].height || 0, obj.height / rects.length) : 0;
    }
    this.left = obj.left;
    this.right = obj.right;
    this.top = obj.top || top;
    this.height = obj.height || height;
    this.bottom = obj.bottom || top + (obj.height || height);
    this.width = obj.width || width;
    this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
}
// Move the box along a particular axis. Optionally pass in an amount to move
// the box. If no amount is passed then the default is the line height of the
// box.
$46f282c1f2cd4950$var$BoxPosition.prototype.move = function(axis, toMove) {
    toMove = toMove !== undefined ? toMove : this.lineHeight;
    switch(axis){
        case "+x":
            this.left += toMove;
            this.right += toMove;
            break;
        case "-x":
            this.left -= toMove;
            this.right -= toMove;
            break;
        case "+y":
            this.top += toMove;
            this.bottom += toMove;
            break;
        case "-y":
            this.top -= toMove;
            this.bottom -= toMove;
            break;
    }
};
// Check if this box overlaps another box, b2.
$46f282c1f2cd4950$var$BoxPosition.prototype.overlaps = function(b2) {
    return this.left < b2.right && this.right > b2.left && this.top < b2.bottom && this.bottom > b2.top;
};
// Check if this box overlaps any other boxes in boxes.
$46f282c1f2cd4950$var$BoxPosition.prototype.overlapsAny = function(boxes) {
    for(var i = 0; i < boxes.length; i++){
        if (this.overlaps(boxes[i])) return true;
    }
    return false;
};
// Check if this box is within another box.
$46f282c1f2cd4950$var$BoxPosition.prototype.within = function(container) {
    return this.top >= container.top && this.bottom <= container.bottom && this.left >= container.left && this.right <= container.right;
};
// Check if this box is entirely within the container or it is overlapping
// on the edge opposite of the axis direction passed. For example, if "+x" is
// passed and the box is overlapping on the left edge of the container, then
// return true.
$46f282c1f2cd4950$var$BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
    switch(axis){
        case "+x":
            return this.left < container.left;
        case "-x":
            return this.right > container.right;
        case "+y":
            return this.top < container.top;
        case "-y":
            return this.bottom > container.bottom;
    }
};
// Find the percentage of the area that this box is overlapping with another
// box.
$46f282c1f2cd4950$var$BoxPosition.prototype.intersectPercentage = function(b2) {
    var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)), y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)), intersectArea = x * y;
    return intersectArea / (this.height * this.width);
};
// Convert the positions from this box to CSS compatible positions using
// the reference container's positions. This has to be done because this
// box's positions are in reference to the viewport origin, whereas, CSS
// values are in referecne to their respective edges.
$46f282c1f2cd4950$var$BoxPosition.prototype.toCSSCompatValues = function(reference) {
    return {
        top: this.top - reference.top,
        bottom: reference.bottom - this.bottom,
        left: this.left - reference.left,
        right: reference.right - this.right,
        height: this.height,
        width: this.width
    };
};
// Get an object that represents the box's position without anything extra.
// Can pass a StyleBox, HTMLElement, or another BoxPositon.
$46f282c1f2cd4950$var$BoxPosition.getSimpleBoxPosition = function(obj) {
    var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
    var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
    var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
    obj = obj.div ? obj.div.getBoundingClientRect() : obj.tagName ? obj.getBoundingClientRect() : obj;
    var ret = {
        left: obj.left,
        right: obj.right,
        top: obj.top || top,
        height: obj.height || height,
        bottom: obj.bottom || top + (obj.height || height),
        width: obj.width || width
    };
    return ret;
};
// Move a StyleBox to its specified, or next best, position. The containerBox
// is the box that contains the StyleBox, such as a div. boxPositions are
// a list of other boxes that the styleBox can't overlap with.
function $46f282c1f2cd4950$var$moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
    // Find the best position for a cue box, b, on the video. The axis parameter
    // is a list of axis, the order of which, it will move the box along. For example:
    // Passing ["+x", "-x"] will move the box first along the x axis in the positive
    // direction. If it doesn't find a good position for it there it will then move
    // it along the x axis in the negative direction.
    function findBestPosition(b, axis) {
        var bestPosition, specifiedPosition = new $46f282c1f2cd4950$var$BoxPosition(b), percentage = 1; // Highest possible so the first thing we get is better.
        for(var i = 0; i < axis.length; i++){
            while(b.overlapsOppositeAxis(containerBox, axis[i]) || b.within(containerBox) && b.overlapsAny(boxPositions))b.move(axis[i]);
            // We found a spot where we aren't overlapping anything. This is our
            // best position.
            if (b.within(containerBox)) return b;
            var p = b.intersectPercentage(containerBox);
            // If we're outside the container box less then we were on our last try
            // then remember this position as the best position.
            if (percentage > p) {
                bestPosition = new $46f282c1f2cd4950$var$BoxPosition(b);
                percentage = p;
            }
            // Reset the box position to the specified position.
            b = new $46f282c1f2cd4950$var$BoxPosition(specifiedPosition);
        }
        return bestPosition || specifiedPosition;
    }
    var boxPosition = new $46f282c1f2cd4950$var$BoxPosition(styleBox), cue = styleBox.cue, linePos = $46f282c1f2cd4950$var$computeLinePos(cue), axis = [];
    // If we have a line number to align the cue to.
    if (cue.snapToLines) {
        var size;
        switch(cue.vertical){
            case "":
                axis = [
                    "+y",
                    "-y"
                ];
                size = "height";
                break;
            case "rl":
                axis = [
                    "+x",
                    "-x"
                ];
                size = "width";
                break;
            case "lr":
                axis = [
                    "-x",
                    "+x"
                ];
                size = "width";
                break;
        }
        var step = boxPosition.lineHeight, position = step * Math.round(linePos), maxPosition = containerBox[size] + step, initialAxis = axis[0];
        // If the specified intial position is greater then the max position then
        // clamp the box to the amount of steps it would take for the box to
        // reach the max position.
        if (Math.abs(position) > maxPosition) {
            position = position < 0 ? -1 : 1;
            position *= Math.ceil(maxPosition / step) * step;
        }
        // If computed line position returns negative then line numbers are
        // relative to the bottom of the video instead of the top. Therefore, we
        // need to increase our initial position by the length or width of the
        // video, depending on the writing direction, and reverse our axis directions.
        if (linePos < 0) {
            position += cue.vertical === "" ? containerBox.height : containerBox.width;
            axis = axis.reverse();
        }
        // Move the box to the specified position. This may not be its best
        // position.
        boxPosition.move(initialAxis, position);
    } else {
        // If we have a percentage line value for the cue.
        var calculatedPercentage = boxPosition.lineHeight / containerBox.height * 100;
        switch(cue.lineAlign){
            case "center":
                linePos -= calculatedPercentage / 2;
                break;
            case "end":
                linePos -= calculatedPercentage;
                break;
        }
        // Apply initial line position to the cue box.
        switch(cue.vertical){
            case "":
                styleBox.applyStyles({
                    top: styleBox.formatStyle(linePos, "%")
                });
                break;
            case "rl":
                styleBox.applyStyles({
                    left: styleBox.formatStyle(linePos, "%")
                });
                break;
            case "lr":
                styleBox.applyStyles({
                    right: styleBox.formatStyle(linePos, "%")
                });
                break;
        }
        axis = [
            "+y",
            "-x",
            "+x",
            "-y"
        ];
        // Get the box position again after we've applied the specified positioning
        // to it.
        boxPosition = new $46f282c1f2cd4950$var$BoxPosition(styleBox);
    }
    var bestPosition = findBestPosition(boxPosition, axis);
    styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}
function $46f282c1f2cd4950$var$WebVTT() {
// Nothing
}
// Helper to allow strings to be decoded instead of the default binary utf8 data.
$46f282c1f2cd4950$var$WebVTT.StringDecoder = function() {
    return {
        decode: function(data) {
            if (!data) return "";
            if (typeof data !== "string") throw new Error("Error - expected string data.");
            return decodeURIComponent(encodeURIComponent(data));
        }
    };
};
$46f282c1f2cd4950$var$WebVTT.convertCueToDOMTree = function(window, cuetext) {
    if (!window || !cuetext) return null;
    return $46f282c1f2cd4950$var$parseContent(window, cuetext);
};
var $46f282c1f2cd4950$var$FONT_SIZE_PERCENT = 0.05;
var $46f282c1f2cd4950$var$FONT_STYLE = "sans-serif";
var $46f282c1f2cd4950$var$CUE_BACKGROUND_PADDING = "1.5%";
// Runs the processing model over the cues and regions passed to it.
// @param overlay A block level element (usually a div) that the computed cues
//                and regions will be placed into.
$46f282c1f2cd4950$var$WebVTT.processCues = function(window, cues, overlay) {
    if (!window || !cues || !overlay) return null;
    // Remove all previous children.
    while(overlay.firstChild)overlay.removeChild(overlay.firstChild);
    var paddedOverlay = window.document.createElement("div");
    paddedOverlay.style.position = "absolute";
    paddedOverlay.style.left = "0";
    paddedOverlay.style.right = "0";
    paddedOverlay.style.top = "0";
    paddedOverlay.style.bottom = "0";
    paddedOverlay.style.margin = $46f282c1f2cd4950$var$CUE_BACKGROUND_PADDING;
    overlay.appendChild(paddedOverlay);
    // Determine if we need to compute the display states of the cues. This could
    // be the case if a cue's state has been changed since the last computation or
    // if it has not been computed yet.
    function shouldCompute(cues) {
        for(var i = 0; i < cues.length; i++){
            if (cues[i].hasBeenReset || !cues[i].displayState) return true;
        }
        return false;
    }
    // We don't need to recompute the cues' display states. Just reuse them.
    if (!shouldCompute(cues)) {
        for(var i = 0; i < cues.length; i++)paddedOverlay.appendChild(cues[i].displayState);
        return;
    }
    var boxPositions = [], containerBox = $46f282c1f2cd4950$var$BoxPosition.getSimpleBoxPosition(paddedOverlay), fontSize = Math.round(containerBox.height * $46f282c1f2cd4950$var$FONT_SIZE_PERCENT * 100) / 100;
    var styleOptions = {
        font: fontSize + "px " + $46f282c1f2cd4950$var$FONT_STYLE
    };
    (function() {
        var styleBox, cue;
        for(var i = 0; i < cues.length; i++){
            cue = cues[i];
            // Compute the intial position and styles of the cue div.
            styleBox = new $46f282c1f2cd4950$var$CueStyleBox(window, cue, styleOptions);
            paddedOverlay.appendChild(styleBox.div);
            // Move the cue div to it's correct line position.
            $46f282c1f2cd4950$var$moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
            // Remember the computed div so that we don't have to recompute it later
            // if we don't have too.
            cue.displayState = styleBox.div;
            boxPositions.push($46f282c1f2cd4950$var$BoxPosition.getSimpleBoxPosition(styleBox));
        }
    })();
};
$46f282c1f2cd4950$var$WebVTT.Parser = function(window, vttjs, decoder) {
    if (!decoder) {
        decoder = vttjs;
        vttjs = {};
    }
    if (!vttjs) vttjs = {};
    this.window = window;
    this.vttjs = vttjs;
    this.state = "INITIAL";
    this.buffer = "";
    this.decoder = decoder || new TextDecoder("utf8");
    this.regionList = [];
};
$46f282c1f2cd4950$var$WebVTT.Parser.prototype = {
    // If the error is a ParsingError then report it to the consumer if
    // possible. If it's not a ParsingError then throw it like normal.
    reportOrThrowError: function(e) {
        if (e instanceof $46f282c1f2cd4950$var$ParsingError) this.onparsingerror && this.onparsingerror(e);
        else throw e;
    },
    parse: function(data) {
        var self = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) // Try to decode the data that we received.
        self.buffer += self.decoder.decode(data, {
            stream: true
        });
        function collectNextLine() {
            var buffer = self.buffer;
            var pos = 0;
            while(pos < buffer.length && buffer[pos] !== "\r" && buffer[pos] !== "\n")++pos;
            var line = buffer.substr(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === "\r") ++pos;
            if (buffer[pos] === "\n") ++pos;
            self.buffer = buffer.substr(pos);
            return line;
        }
        // 3.4 WebVTT region and WebVTT region settings syntax
        function parseRegion(input) {
            var settings = new $46f282c1f2cd4950$var$Settings();
            $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "id":
                        settings.set(k, v);
                        break;
                    case "width":
                        settings.percent(k, v);
                        break;
                    case "lines":
                        settings.integer(k, v);
                        break;
                    case "regionanchor":
                    case "viewportanchor":
                        var xy = v.split(",");
                        if (xy.length !== 2) break;
                        // We have to make sure both x and y parse, so use a temporary
                        // settings object here.
                        var anchor = new $46f282c1f2cd4950$var$Settings();
                        anchor.percent("x", xy[0]);
                        anchor.percent("y", xy[1]);
                        if (!anchor.has("x") || !anchor.has("y")) break;
                        settings.set(k + "X", anchor.get("x"));
                        settings.set(k + "Y", anchor.get("y"));
                        break;
                    case "scroll":
                        settings.alt(k, v, [
                            "up"
                        ]);
                        break;
                }
            }, /=/, /\s/);
            // Create the region, using default values for any values that were not
            // specified.
            if (settings.has("id")) {
                var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
                region.width = settings.get("width", 100);
                region.lines = settings.get("lines", 3);
                region.regionAnchorX = settings.get("regionanchorX", 0);
                region.regionAnchorY = settings.get("regionanchorY", 100);
                region.viewportAnchorX = settings.get("viewportanchorX", 0);
                region.viewportAnchorY = settings.get("viewportanchorY", 100);
                region.scroll = settings.get("scroll", "");
                // Register the region.
                self.onregion && self.onregion(region);
                // Remember the VTTRegion for later in case we parse any VTTCues that
                // reference it.
                self.regionList.push({
                    id: settings.get("id"),
                    region: region
                });
            }
        }
        // draft-pantos-http-live-streaming-20
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
        // 3.5 WebVTT
        function parseTimestampMap(input) {
            var settings = new $46f282c1f2cd4950$var$Settings();
            $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "MPEGT":
                        settings.integer(k + "S", v);
                        break;
                    case "LOCA":
                        settings.set(k + "L", $46f282c1f2cd4950$var$parseTimeStamp(v));
                        break;
                }
            }, /[^\d]:/, /,/);
            self.ontimestampmap && self.ontimestampmap({
                "MPEGTS": settings.get("MPEGTS"),
                "LOCAL": settings.get("LOCAL")
            });
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            if (input.match(/X-TIMESTAMP-MAP/)) // This line contains HLS X-TIMESTAMP-MAP metadata
            $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "X-TIMESTAMP-MAP":
                        parseTimestampMap(v);
                        break;
                }
            }, /=/);
            else $46f282c1f2cd4950$var$parseOptions(input, function(k, v) {
                switch(k){
                    case "Region":
                        // 3.3 WebVTT region metadata header syntax
                        parseRegion(v);
                        break;
                }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            var line;
            if (self.state === "INITIAL") {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(self.buffer)) return this;
                line = collectNextLine();
                var m = line.match(/^WEBVTT([ \t].*)?$/);
                if (!m || !m[0]) throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadSignature);
                self.state = "HEADER";
            }
            var alreadyCollectedLine = false;
            while(self.buffer){
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(self.buffer)) return this;
                if (!alreadyCollectedLine) line = collectNextLine();
                else alreadyCollectedLine = false;
                switch(self.state){
                    case "HEADER":
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) parseHeader(line);
                        else if (!line) // An empty line terminates the header and starts the body (cues).
                        self.state = "ID";
                        continue;
                    case "NOTE":
                        // Ignore NOTE blocks.
                        if (!line) self.state = "ID";
                        continue;
                    case "ID":
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            self.state = "NOTE";
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) continue;
                        self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
                        // Safari still uses the old middle value and won't accept center
                        try {
                            self.cue.align = "center";
                        } catch (e) {
                            self.cue.align = "middle";
                        }
                        self.state = "CUE";
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf("-->") === -1) {
                            self.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /*falls through*/ case "CUE":
                        // 40 - Collect cue timings and settings.
                        try {
                            $46f282c1f2cd4950$var$parseCue(line, self.cue, self.regionList);
                        } catch (e) {
                            self.reportOrThrowError(e);
                            // In case of an error ignore rest of the cue.
                            self.cue = null;
                            self.state = "BADCUE";
                            continue;
                        }
                        self.state = "CUETEXT";
                        continue;
                    case "CUETEXT":
                        var hasSubstring = line.indexOf("-->") !== -1;
                        // 34 - If we have an empty line then report the cue.
                        // 35 - If we have the special substring '-->' then report the cue,
                        // but do not collect the line as we need to process the current
                        // one as a new cue.
                        if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                            // We are done parsing self cue.
                            self.oncue && self.oncue(self.cue);
                            self.cue = null;
                            self.state = "ID";
                            continue;
                        }
                        if (self.cue.text) self.cue.text += "\n";
                        self.cue.text += line.replace(/\u2028/g, "\n").replace(/u2029/g, "\n");
                        continue;
                    case "BADCUE":
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) self.state = "ID";
                        continue;
                }
            }
        } catch (e) {
            self.reportOrThrowError(e);
            // If we are currently parsing a cue, report what we have.
            if (self.state === "CUETEXT" && self.cue && self.oncue) self.oncue(self.cue);
            self.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
        }
        return this;
    },
    flush: function() {
        var self = this;
        try {
            // Finish decoding the stream.
            self.buffer += self.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (self.cue || self.state === "HEADER") {
                self.buffer += "\n\n";
                self.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (self.state === "INITIAL") throw new $46f282c1f2cd4950$var$ParsingError($46f282c1f2cd4950$var$ParsingError.Errors.BadSignature);
        } catch (e) {
            self.reportOrThrowError(e);
        }
        self.onflush && self.onflush();
        return this;
    }
};
module.exports = $46f282c1f2cd4950$var$WebVTT;

});
parcelRegister("7pNCM", function(module, exports) {
var $56615c93f45a88ca$var$topLevel = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : {};

var $kjyEk = parcelRequire("kjyEk");
var $56615c93f45a88ca$var$doccy;
if (typeof document !== "undefined") $56615c93f45a88ca$var$doccy = document;
else {
    $56615c93f45a88ca$var$doccy = $56615c93f45a88ca$var$topLevel["__GLOBAL_DOCUMENT_CACHE@4"];
    if (!$56615c93f45a88ca$var$doccy) $56615c93f45a88ca$var$doccy = $56615c93f45a88ca$var$topLevel["__GLOBAL_DOCUMENT_CACHE@4"] = $kjyEk;
}
module.exports = $56615c93f45a88ca$var$doccy;

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("aWh86", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7f6c9bbd3c21d754$var$autoKeyword = "auto";
var $7f6c9bbd3c21d754$var$directionSetting = {
    "": 1,
    "lr": 1,
    "rl": 1
};
var $7f6c9bbd3c21d754$var$alignSetting = {
    "start": 1,
    "center": 1,
    "end": 1,
    "left": 1,
    "right": 1,
    "auto": 1,
    "line-left": 1,
    "line-right": 1
};
function $7f6c9bbd3c21d754$var$findDirectionSetting(value) {
    if (typeof value !== "string") return false;
    var dir = $7f6c9bbd3c21d754$var$directionSetting[value.toLowerCase()];
    return dir ? value.toLowerCase() : false;
}
function $7f6c9bbd3c21d754$var$findAlignSetting(value) {
    if (typeof value !== "string") return false;
    var align = $7f6c9bbd3c21d754$var$alignSetting[value.toLowerCase()];
    return align ? value.toLowerCase() : false;
}
function $7f6c9bbd3c21d754$var$VTTCue(startTime, endTime, text) {
    /**
   * Shim implementation specific properties. These properties are not in
   * the spec.
   */ // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    this.hasBeenReset = false;
    /**
   * VTTCue and TextTrackCue properties
   * http://dev.w3.org/html5/webvtt/#vttcue-interface
   */ var _id = "";
    var _pauseOnExit = false;
    var _startTime = startTime;
    var _endTime = endTime;
    var _text = text;
    var _region = null;
    var _vertical = "";
    var _snapToLines = true;
    var _line = "auto";
    var _lineAlign = "start";
    var _position = "auto";
    var _positionAlign = "auto";
    var _size = 100;
    var _align = "center";
    Object.defineProperties(this, {
        "id": {
            enumerable: true,
            get: function() {
                return _id;
            },
            set: function(value) {
                _id = "" + value;
            }
        },
        "pauseOnExit": {
            enumerable: true,
            get: function() {
                return _pauseOnExit;
            },
            set: function(value) {
                _pauseOnExit = !!value;
            }
        },
        "startTime": {
            enumerable: true,
            get: function() {
                return _startTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("Start time must be set to a number.");
                _startTime = value;
                this.hasBeenReset = true;
            }
        },
        "endTime": {
            enumerable: true,
            get: function() {
                return _endTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("End time must be set to a number.");
                _endTime = value;
                this.hasBeenReset = true;
            }
        },
        "text": {
            enumerable: true,
            get: function() {
                return _text;
            },
            set: function(value) {
                _text = "" + value;
                this.hasBeenReset = true;
            }
        },
        "region": {
            enumerable: true,
            get: function() {
                return _region;
            },
            set: function(value) {
                _region = value;
                this.hasBeenReset = true;
            }
        },
        "vertical": {
            enumerable: true,
            get: function() {
                return _vertical;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
                _vertical = setting;
                this.hasBeenReset = true;
            }
        },
        "snapToLines": {
            enumerable: true,
            get: function() {
                return _snapToLines;
            },
            set: function(value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        },
        "line": {
            enumerable: true,
            get: function() {
                return _line;
            },
            set: function(value) {
                if (typeof value !== "number" && value !== $7f6c9bbd3c21d754$var$autoKeyword) throw new SyntaxError("Line: an invalid number or illegal string was specified.");
                _line = value;
                this.hasBeenReset = true;
            }
        },
        "lineAlign": {
            enumerable: true,
            get: function() {
                return _lineAlign;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findAlignSetting(value);
                if (!setting) console.warn("lineAlign: an invalid or illegal string was specified.");
                else {
                    _lineAlign = setting;
                    this.hasBeenReset = true;
                }
            }
        },
        "position": {
            enumerable: true,
            get: function() {
                return _position;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Position must be between 0 and 100.");
                _position = value;
                this.hasBeenReset = true;
            }
        },
        "positionAlign": {
            enumerable: true,
            get: function() {
                return _positionAlign;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findAlignSetting(value);
                if (!setting) console.warn("positionAlign: an invalid or illegal string was specified.");
                else {
                    _positionAlign = setting;
                    this.hasBeenReset = true;
                }
            }
        },
        "size": {
            enumerable: true,
            get: function() {
                return _size;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Size must be between 0 and 100.");
                _size = value;
                this.hasBeenReset = true;
            }
        },
        "align": {
            enumerable: true,
            get: function() {
                return _align;
            },
            set: function(value) {
                var setting = $7f6c9bbd3c21d754$var$findAlignSetting(value);
                if (!setting) throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
                _align = setting;
                this.hasBeenReset = true;
            }
        }
    });
    /**
   * Other <track> spec defined properties
   */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    this.displayState = undefined;
}
/**
 * VTTCue methods
 */ $7f6c9bbd3c21d754$var$VTTCue.prototype.getCueAsHTML = function() {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    return WebVTT.convertCueToDOMTree(window, this.text);
};
module.exports = $7f6c9bbd3c21d754$var$VTTCue;

});

parcelRegister("f8lRN", function(module, exports) {
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b04890a7ae393ca1$var$scrollSetting = {
    "": true,
    "up": true
};
function $b04890a7ae393ca1$var$findScrollSetting(value) {
    if (typeof value !== "string") return false;
    var scroll = $b04890a7ae393ca1$var$scrollSetting[value.toLowerCase()];
    return scroll ? value.toLowerCase() : false;
}
function $b04890a7ae393ca1$var$isValidPercentValue(value) {
    return typeof value === "number" && value >= 0 && value <= 100;
}
// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
function $b04890a7ae393ca1$var$VTTRegion() {
    var _width = 100;
    var _lines = 3;
    var _regionAnchorX = 0;
    var _regionAnchorY = 100;
    var _viewportAnchorX = 0;
    var _viewportAnchorY = 100;
    var _scroll = "";
    Object.defineProperties(this, {
        "width": {
            enumerable: true,
            get: function() {
                return _width;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("Width must be between 0 and 100.");
                _width = value;
            }
        },
        "lines": {
            enumerable: true,
            get: function() {
                return _lines;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("Lines must be set to a number.");
                _lines = value;
            }
        },
        "regionAnchorY": {
            enumerable: true,
            get: function() {
                return _regionAnchorY;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("RegionAnchorX must be between 0 and 100.");
                _regionAnchorY = value;
            }
        },
        "regionAnchorX": {
            enumerable: true,
            get: function() {
                return _regionAnchorX;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("RegionAnchorY must be between 0 and 100.");
                _regionAnchorX = value;
            }
        },
        "viewportAnchorY": {
            enumerable: true,
            get: function() {
                return _viewportAnchorY;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("ViewportAnchorY must be between 0 and 100.");
                _viewportAnchorY = value;
            }
        },
        "viewportAnchorX": {
            enumerable: true,
            get: function() {
                return _viewportAnchorX;
            },
            set: function(value) {
                if (!$b04890a7ae393ca1$var$isValidPercentValue(value)) throw new Error("ViewportAnchorX must be between 0 and 100.");
                _viewportAnchorX = value;
            }
        },
        "scroll": {
            enumerable: true,
            get: function() {
                return _scroll;
            },
            set: function(value) {
                var setting = $b04890a7ae393ca1$var$findScrollSetting(value);
                // Have to check for false as an empty string is a legal value.
                if (setting === false) console.warn("Scroll: an invalid or illegal string was specified.");
                else _scroll = setting;
            }
        }
    });
}
module.exports = $b04890a7ae393ca1$var$VTTRegion;

});

parcelRegister("c1Wy2", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $8c22fe72d8589809$export$1059c6e7d2ce5669, (v) => $8c22fe72d8589809$export$1059c6e7d2ce5669 = v);
var $8c22fe72d8589809$export$181392475aa39887;
var $8c22fe72d8589809$export$ba13e0e2f19e61a1;
var $8c22fe72d8589809$export$1059c6e7d2ce5669;

var $hkG9E = parcelRequire("hkG9E");

var $2YubT = parcelRequire("2YubT");

var $2NAtx = parcelRequire("2NAtx");

var $1fO4L = parcelRequire("1fO4L");
var $8c22fe72d8589809$var$DOMImplementation = $2YubT.DOMImplementation;
var $8c22fe72d8589809$var$NAMESPACE = $hkG9E.NAMESPACE;
var $8c22fe72d8589809$var$ParseError = $1fO4L.ParseError;
var $8c22fe72d8589809$var$XMLReader = $1fO4L.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $8c22fe72d8589809$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $8c22fe72d8589809$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$8c22fe72d8589809$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $8c22fe72d8589809$var$XMLReader();
    var domBuilder = options.domBuilder || new $8c22fe72d8589809$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $2NAtx.HTML_ENTITIES : $2NAtx.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $8c22fe72d8589809$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[""] = $8c22fe72d8589809$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $8c22fe72d8589809$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $8c22fe72d8589809$var$normalizeLineEndings;
    if (source && typeof source === "string") sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error("invalid doc source");
    return domBuilder.doc;
};
function $8c22fe72d8589809$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $8c22fe72d8589809$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn("[xmldom " + key + "]	" + msg + $8c22fe72d8589809$var$_locator(locator));
        } || function() {};
    }
    build("warning");
    build("error");
    build("fatalError");
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $8c22fe72d8589809$var$DOMHandler() {
    this.cdata = false;
}
function $8c22fe72d8589809$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $8c22fe72d8589809$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $8c22fe72d8589809$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $8c22fe72d8589809$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $8c22fe72d8589809$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $8c22fe72d8589809$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $8c22fe72d8589809$var$position(this.locator, ins);
        $8c22fe72d8589809$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $8c22fe72d8589809$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $8c22fe72d8589809$var$position(this.locator, comm);
        $8c22fe72d8589809$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $8c22fe72d8589809$var$position(this.locator, dt);
            $8c22fe72d8589809$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn("[xmldom warning]	" + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    error: function(error) {
        console.error("[xmldom error]	" + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $8c22fe72d8589809$var$ParseError(error, this.locator);
    }
};
function $8c22fe72d8589809$var$_locator(l) {
    if (l) return "\n@" + (l.systemId || "") + "#[line:" + l.lineNumber + ",col:" + l.columnNumber + "]";
}
function $8c22fe72d8589809$var$_toString(chars, start, length) {
    if (typeof chars == "string") return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + "";
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $8c22fe72d8589809$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $8c22fe72d8589809$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$8c22fe72d8589809$export$181392475aa39887 = $8c22fe72d8589809$var$DOMHandler;
$8c22fe72d8589809$export$ba13e0e2f19e61a1 = $8c22fe72d8589809$var$normalizeLineEndings;
$8c22fe72d8589809$export$1059c6e7d2ce5669 = $8c22fe72d8589809$var$DOMParser;

});
parcelRegister("hkG9E", function(module, exports) {

$parcel$export(module.exports, "find", () => $c9e500f3e8ddaab6$export$71aa6c912b956294, (v) => $c9e500f3e8ddaab6$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "freeze", () => $c9e500f3e8ddaab6$export$792f3d81ea979f55, (v) => $c9e500f3e8ddaab6$export$792f3d81ea979f55 = v);
$parcel$export(module.exports, "NAMESPACE", () => $c9e500f3e8ddaab6$export$6aad947bda0f3f46, (v) => $c9e500f3e8ddaab6$export$6aad947bda0f3f46 = v);
var $c9e500f3e8ddaab6$export$e6e34fd1f2686227;
var $c9e500f3e8ddaab6$export$71aa6c912b956294;
var $c9e500f3e8ddaab6$export$792f3d81ea979f55;
var $c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa;
var $c9e500f3e8ddaab6$export$6aad947bda0f3f46;
"use strict";
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $c9e500f3e8ddaab6$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === "function") return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $c9e500f3e8ddaab6$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === "function" ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $c9e500f3e8ddaab6$var$assign(target, source) {
    if (target === null || typeof target !== "object") throw new TypeError("target is not an object");
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $c9e500f3e8ddaab6$var$MIME_TYPE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: "text/html",
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $c9e500f3e8ddaab6$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: "application/xml",
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: "text/xml",
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: "application/xhtml+xml",
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: "image/svg+xml"
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $c9e500f3e8ddaab6$var$NAMESPACE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: "http://www.w3.org/1999/xhtml",
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $c9e500f3e8ddaab6$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: "http://www.w3.org/2000/svg",
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: "http://www.w3.org/XML/1998/namespace",
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: "http://www.w3.org/2000/xmlns/"
});
$c9e500f3e8ddaab6$export$e6e34fd1f2686227 = $c9e500f3e8ddaab6$var$assign;
$c9e500f3e8ddaab6$export$71aa6c912b956294 = $c9e500f3e8ddaab6$var$find;
$c9e500f3e8ddaab6$export$792f3d81ea979f55 = $c9e500f3e8ddaab6$var$freeze;
$c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa = $c9e500f3e8ddaab6$var$MIME_TYPE;
$c9e500f3e8ddaab6$export$6aad947bda0f3f46 = $c9e500f3e8ddaab6$var$NAMESPACE;

});

parcelRegister("2YubT", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", () => $22a89a9d1d5ce29e$export$455426655eab1d48, (v) => $22a89a9d1d5ce29e$export$455426655eab1d48 = v);
$parcel$export(module.exports, "XMLSerializer", () => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24, (v) => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = v);
//if(typeof require == 'function'){
var $22a89a9d1d5ce29e$export$d1d99cf900472499;
var $22a89a9d1d5ce29e$export$fe58bcf938607f6a;
var $22a89a9d1d5ce29e$export$455426655eab1d48;
var $22a89a9d1d5ce29e$export$db77ccec0bb4ccac;
var $22a89a9d1d5ce29e$export$85c928794f8d04d4;
var $22a89a9d1d5ce29e$export$79b41aa5d56abdff;
var $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24;

var $hkG9E = parcelRequire("hkG9E");
var $22a89a9d1d5ce29e$var$find = $hkG9E.find;
var $22a89a9d1d5ce29e$var$NAMESPACE = $hkG9E.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$notEmptyString(input) {
    return input !== "";
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($22a89a9d1d5ce29e$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $22a89a9d1d5ce29e$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $22a89a9d1d5ce29e$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($22a89a9d1d5ce29e$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $22a89a9d1d5ce29e$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $22a89a9d1d5ce29e$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $22a89a9d1d5ce29e$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $22a89a9d1d5ce29e$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != "function") console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $22a89a9d1d5ce29e$var$NodeType = {};
var $22a89a9d1d5ce29e$var$ELEMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.ELEMENT_NODE = 1;
var $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE = $22a89a9d1d5ce29e$var$NodeType.ATTRIBUTE_NODE = 2;
var $22a89a9d1d5ce29e$var$TEXT_NODE = $22a89a9d1d5ce29e$var$NodeType.TEXT_NODE = 3;
var $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE = $22a89a9d1d5ce29e$var$NodeType.CDATA_SECTION_NODE = 4;
var $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $22a89a9d1d5ce29e$var$ENTITY_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_NODE = 6;
var $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE = $22a89a9d1d5ce29e$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $22a89a9d1d5ce29e$var$COMMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.COMMENT_NODE = 8;
var $22a89a9d1d5ce29e$var$DOCUMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_NODE = 9;
var $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $22a89a9d1d5ce29e$var$NOTATION_NODE = $22a89a9d1d5ce29e$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $22a89a9d1d5ce29e$var$ExceptionCode = {};
var $22a89a9d1d5ce29e$var$ExceptionMessage = {};
var $22a89a9d1d5ce29e$var$INDEX_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INDEX_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[1] = "Index size error", 1);
var $22a89a9d1d5ce29e$var$DOMSTRING_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[2] = "DOMString size error", 2);
var $22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $22a89a9d1d5ce29e$var$WRONG_DOCUMENT_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[4] = "Wrong document", 4);
var $22a89a9d1d5ce29e$var$INVALID_CHARACTER_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_CHARACTER_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[5] = "Invalid character", 5);
var $22a89a9d1d5ce29e$var$NO_DATA_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[6] = "No data allowed", 6);
var $22a89a9d1d5ce29e$var$NO_MODIFICATION_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[7] = "No modification allowed", 7);
var $22a89a9d1d5ce29e$var$NOT_FOUND_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_FOUND_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[8] = "Not found", 8);
var $22a89a9d1d5ce29e$var$NOT_SUPPORTED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_SUPPORTED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[9] = "Not supported", 9);
var $22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $22a89a9d1d5ce29e$var$INVALID_STATE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_STATE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[11] = "Invalid state", 11);
var $22a89a9d1d5ce29e$var$SYNTAX_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.SYNTAX_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[12] = "Syntax error", 12);
var $22a89a9d1d5ce29e$var$INVALID_MODIFICATION_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[13] = "Invalid modification", 13);
var $22a89a9d1d5ce29e$var$NAMESPACE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NAMESPACE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $22a89a9d1d5ce29e$var$INVALID_ACCESS_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_ACCESS_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $22a89a9d1d5ce29e$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $22a89a9d1d5ce29e$var$ExceptionMessage[code]);
        this.message = $22a89a9d1d5ce29e$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $22a89a9d1d5ce29e$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$22a89a9d1d5ce29e$var$DOMException.prototype = Error.prototype;
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$ExceptionCode, $22a89a9d1d5ce29e$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $22a89a9d1d5ce29e$var$NodeList() {}
$22a89a9d1d5ce29e$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter) {
        for(var buf = [], i = 0; i < this.length; i++)$22a89a9d1d5ce29e$var$serializeToString(this[i], buf, isHTML, nodeFilter);
        return buf.join("");
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $22a89a9d1d5ce29e$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
}
function $22a89a9d1d5ce29e$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $22a89a9d1d5ce29e$var$__set__(list, "length", ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; (i in list); i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $22a89a9d1d5ce29e$var$copy(ls, list);
        list._inc = inc;
    }
}
$22a89a9d1d5ce29e$var$LiveNodeList.prototype.item = function(i) {
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
    return this[i] || null;
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$LiveNodeList, $22a89a9d1d5ce29e$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $22a89a9d1d5ce29e$var$NamedNodeMap() {}
function $22a89a9d1d5ce29e$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $22a89a9d1d5ce29e$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$22a89a9d1d5ce29e$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, oldAttr);
            $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $22a89a9d1d5ce29e$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $22a89a9d1d5ce29e$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, new Error(el.tagName + "@" + attr));
}
$22a89a9d1d5ce29e$var$NamedNodeMap.prototype = {
    length: 0,
    item: $22a89a9d1d5ce29e$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $22a89a9d1d5ce29e$var$DOMImplementation() {}
$22a89a9d1d5ce29e$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $22a89a9d1d5ce29e$var$Document();
        doc.implementation = this;
        doc.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This behavior is slightly different from the in the specs__:
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * @param {string} [systemId]
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $22a89a9d1d5ce29e$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || "";
        node.systemId = systemId || "";
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $22a89a9d1d5ce29e$var$Node() {}
$22a89a9d1d5ce29e$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $22a89a9d1d5ce29e$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    normalize: function() {
        var child = this.firstChild;
        while(child){
            var next = child.nextSibling;
            if (next && next.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE && child.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE) {
                this.removeChild(next);
                child.appendData(next.data);
            } else {
                child.normalize();
                child = next;
            }
        }
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $22a89a9d1d5ce29e$var$_xmlEncoder(c) {
    return c == "<" && "&lt;" || c == ">" && "&gt;" || c == "&" && "&amp;" || c == '"' && "&quot;" || "&#" + c.charCodeAt() + ";";
}
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node);
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node.prototype);
/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */ function $22a89a9d1d5ce29e$var$_visitNode(node, callback) {
    if (callback(node)) return true;
    if (node = node.firstChild) do {
        if ($22a89a9d1d5ce29e$var$_visitNode(node, callback)) return true;
    }while (node = node.nextSibling);
}
function $22a89a9d1d5ce29e$var$Document() {
    this.ownerDocument = this;
}
function $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ""] = newAttr.value;
}
function $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ""];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $22a89a9d1d5ce29e$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $22a89a9d1d5ce29e$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasInsertableNodeType(node) {
    return node && ($22a89a9d1d5ce29e$var$isElementNode(node) || $22a89a9d1d5ce29e$var$isTextNode(node) || $22a89a9d1d5ce29e$var$isDocTypeNode(node) || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.COMMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isDocTypeNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isElementNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isTextNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode) || $22a89a9d1d5ce29e$var$isDocTypeNode(child)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $22a89a9d1d5ce29e$var$isElementNode(node) && node !== child;
    }
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$22a89a9d1d5ce29e$var$hasValidParentNodeType(parent)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Unexpected parent node type " + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, "child not in parent");
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$22a89a9d1d5ce29e$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $22a89a9d1d5ce29e$var$isDocTypeNode(node) && parent.nodeType !== $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Unexpected node type " + node.nodeType + " for parent node type " + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can not be appended since element is present");
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $22a89a9d1d5ce29e$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do newFirst.parentNode = parent;
    while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $22a89a9d1d5ce29e$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $22a89a9d1d5ce29e$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    return newChild;
}
$22a89a9d1d5ce29e$var$Document.prototype = {
    //implementation : null,
    nodeName: "#document",
    nodeType: $22a89a9d1d5ce29e$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
        newChild.ownerDocument = this;
        if (this.documentElement === null && newChild.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        newChild.ownerDocument = this;
        if (oldChild) this.removeChild(oldChild);
        if ($22a89a9d1d5ce29e$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $22a89a9d1d5ce29e$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $22a89a9d1d5ce29e$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                if (node.getAttribute("id") == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(classNames);
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $22a89a9d1d5ce29e$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute("class");
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($22a89a9d1d5ce29e$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $22a89a9d1d5ce29e$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createCDATASection: function(data) {
        var node = new $22a89a9d1d5ce29e$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createProcessingInstruction: function(target, data) {
        var node = new $22a89a9d1d5ce29e$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $22a89a9d1d5ce29e$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        var pl = qualifiedName.split(":");
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        var pl = qualifiedName.split(":");
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Document, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Element() {
    this._nsMap = {};
}
$22a89a9d1d5ce29e$var$Element.prototype = {
    nodeType: $22a89a9d1d5ce29e$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || "";
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $22a89a9d1d5ce29e$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || "";
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE && (tagName === "*" || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE && (namespaceURI === "*" || node.namespaceURI === namespaceURI) && (localName === "*" || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagName = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagName;
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagNameNS = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagNameNS;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Element, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Attr() {}
$22a89a9d1d5ce29e$var$Attr.prototype.nodeType = $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Attr, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$CharacterData() {}
$22a89a9d1d5ce29e$var$CharacterData.prototype = {
    data: "",
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($22a89a9d1d5ce29e$var$ExceptionMessage[$22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CharacterData, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Text() {}
$22a89a9d1d5ce29e$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $22a89a9d1d5ce29e$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Text, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$Comment() {}
$22a89a9d1d5ce29e$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $22a89a9d1d5ce29e$var$COMMENT_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Comment, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$CDATASection() {}
$22a89a9d1d5ce29e$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CDATASection, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$DocumentType() {}
$22a89a9d1d5ce29e$var$DocumentType.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentType, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Notation() {}
$22a89a9d1d5ce29e$var$Notation.prototype.nodeType = $22a89a9d1d5ce29e$var$NOTATION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Notation, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Entity() {}
$22a89a9d1d5ce29e$var$Entity.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Entity, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$EntityReference() {}
$22a89a9d1d5ce29e$var$EntityReference.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$EntityReference, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$DocumentFragment() {}
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentFragment, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$ProcessingInstruction() {}
$22a89a9d1d5ce29e$var$ProcessingInstruction.prototype.nodeType = $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$ProcessingInstruction, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$XMLSerializer() {}
$22a89a9d1d5ce29e$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter) {
    return $22a89a9d1d5ce29e$var$nodeSerializeToString.call(node, isHtml, nodeFilter);
};
$22a89a9d1d5ce29e$var$Node.prototype.toString = $22a89a9d1d5ce29e$var$nodeSerializeToString;
function $22a89a9d1d5ce29e$var$nodeSerializeToString(isHtml, nodeFilter) {
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $22a89a9d1d5ce29e$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join("");
}
function $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || "";
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $22a89a9d1d5ce29e$var$NAMESPACE.XML || uri === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(" ", qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $22a89a9d1d5ce29e$var$_xmlEncoder), '"');
}
function $22a89a9d1d5ce29e$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
    if (!visibleNamespaces) visibleNamespaces = [];
    if (nodeFilter) {
        node = nodeFilter(node);
        if (node) {
            if (typeof node == "string") {
                buf.push(node);
                return;
            }
        } else return;
    //buf.sort.apply(attrs, attributeSorter);
    }
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var len = attrs.length;
            var child = node.firstChild;
            var nodeName = node.tagName;
            isHTML = $22a89a9d1d5ce29e$var$NAMESPACE.isHTML(node.namespaceURI) || isHTML;
            var prefixedNodeName = nodeName;
            if (!isHTML && !node.prefix && node.namespaceURI) {
                var defaultNS;
                // lookup current default ns from `xmlns` attribute
                for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === "xmlns") {
                    defaultNS = attrs.item(ai).value;
                    break;
                }
                if (!defaultNS) // lookup current default ns in visibleNamespaces
                for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.prefix === "" && namespace.namespace === node.namespaceURI) {
                        defaultNS = namespace.namespace;
                        break;
                    }
                }
                if (defaultNS !== node.namespaceURI) for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.namespace === node.namespaceURI) {
                        if (namespace.prefix) prefixedNodeName = namespace.prefix + ":" + nodeName;
                        break;
                    }
                }
            }
            buf.push("<", prefixedNodeName);
            for(var i = 0; i < len; i++){
                // add namespaces for attributes
                var attr = attrs.item(i);
                if (attr.prefix == "xmlns") visibleNamespaces.push({
                    prefix: attr.localName,
                    namespace: attr.value
                });
                else if (attr.nodeName == "xmlns") visibleNamespaces.push({
                    prefix: "",
                    namespace: attr.value
                });
            }
            for(var i = 0; i < len; i++){
                var attr = attrs.item(i);
                if ($22a89a9d1d5ce29e$var$needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
                    var prefix = attr.prefix || "";
                    var uri = attr.namespaceURI;
                    $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
                    visibleNamespaces.push({
                        prefix: prefix,
                        namespace: uri
                    });
                }
                $22a89a9d1d5ce29e$var$serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
            }
            // add namespace for current node
            if (nodeName === prefixedNodeName && $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces)) {
                var prefix = node.prefix || "";
                var uri = node.namespaceURI;
                $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
                visibleNamespaces.push({
                    prefix: prefix,
                    namespace: uri
                });
            }
            if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                buf.push(">");
                //if is cdata child node
                if (isHTML && /^script$/i.test(nodeName)) while(child){
                    if (child.data) buf.push(child.data);
                    else $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                else while(child){
                    $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                buf.push("</", prefixedNodeName, ">");
            } else buf.push("/>");
            // remove added visible namespaces
            //visibleNamespaces.length = startVisibleNamespaces;
            return;
        case $22a89a9d1d5ce29e$var$DOCUMENT_NODE:
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            var child = node.firstChild;
            while(child){
                $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                child = child.nextSibling;
            }
            return;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            return $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, node.name, node.value);
        case $22a89a9d1d5ce29e$var$TEXT_NODE:
            /**
		 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
		 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
		 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
		 * `&amp;` and `&lt;` respectively.
		 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
		 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
		 * when that string is not marking the end of a CDATA section.
		 *
		 * In the content of elements, character data is any string of characters
		 * which does not contain the start-delimiter of any markup
		 * and does not include the CDATA-section-close delimiter, `]]>`.
		 *
		 * @see https://www.w3.org/TR/xml/#NT-CharData
		 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
		 */ return buf.push(node.data.replace(/[<&>]/g, $22a89a9d1d5ce29e$var$_xmlEncoder));
        case $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE:
            return buf.push("<![CDATA[", node.data, "]]>");
        case $22a89a9d1d5ce29e$var$COMMENT_NODE:
            return buf.push("<!--", node.data, "-->");
        case $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE:
            var pubid = node.publicId;
            var sysid = node.systemId;
            buf.push("<!DOCTYPE ", node.name);
            if (pubid) {
                buf.push(" PUBLIC ", pubid);
                if (sysid && sysid != ".") buf.push(" ", sysid);
                buf.push(">");
            } else if (sysid && sysid != ".") buf.push(" SYSTEM ", sysid, ">");
            else {
                var sub = node.internalSubset;
                if (sub) buf.push(" [", sub, "]");
                buf.push(">");
            }
            return;
        case $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE:
            return buf.push("<?", node.target, " ", node.data, "?>");
        case $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE:
            return buf.push("&", node.nodeName, ";");
        //case ENTITY_NODE:
        //case NOTATION_NODE:
        default:
            buf.push("??", node.nodeName);
    }
}
function $22a89a9d1d5ce29e$var$importNode(doc, node, deep) {
    var node2;
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            node2 = node.cloneNode(false);
            node2.ownerDocument = doc;
        //var attrs = node2.attributes;
        //var len = attrs.length;
        //for(var i=0;i<len;i++){
        //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
        //}
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
            break;
    }
    if (!node2) node2 = node.cloneNode(false); //false
    node2.ownerDocument = doc;
    node2.parentNode = null;
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$importNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $22a89a9d1d5ce29e$var$cloneNode(doc, node, deep) {
    var node2 = new node.constructor();
    for(var n in node)if (Object.prototype.hasOwnProperty.call(node, n)) {
        var v = node[n];
        if (typeof v != "object") {
            if (v != node2[n]) node2[n] = v;
        }
    }
    if (node.childNodes) node2.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
    node2.ownerDocument = doc;
    switch(node2.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var attrs2 = node2.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
            var len = attrs.length;
            attrs2._ownerElement = node2;
            for(var i = 0; i < len; i++)node2.setAttributeNode($22a89a9d1d5ce29e$var$cloneNode(doc, attrs.item(i), true));
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
    }
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$cloneNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
function $22a89a9d1d5ce29e$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($22a89a9d1d5ce29e$var$LiveNodeList.prototype, "length", {
            get: function() {
                $22a89a9d1d5ce29e$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        Object.defineProperty($22a89a9d1d5ce29e$var$Node.prototype, "textContent", {
            get: function() {
                return getTextContent(this);
            },
            set: function(data) {
                switch(this.nodeType){
                    case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                    case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        function getTextContent(node) {
            switch(node.nodeType){
                case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                    var buf = [];
                    node = node.firstChild;
                    while(node){
                        if (node.nodeType !== 7 && node.nodeType !== 8) buf.push(getTextContent(node));
                        node = node.nextSibling;
                    }
                    return buf.join("");
                default:
                    return node.nodeValue;
            }
        }
        $22a89a9d1d5ce29e$var$__set__ = function(object, key, value) {
            //console.log(value)
            object["$$" + key] = value;
        };
    }
} catch (e) {}
$22a89a9d1d5ce29e$export$d1d99cf900472499 = $22a89a9d1d5ce29e$var$DocumentType;
$22a89a9d1d5ce29e$export$fe58bcf938607f6a = $22a89a9d1d5ce29e$var$DOMException;
$22a89a9d1d5ce29e$export$455426655eab1d48 = $22a89a9d1d5ce29e$var$DOMImplementation;
$22a89a9d1d5ce29e$export$db77ccec0bb4ccac = $22a89a9d1d5ce29e$var$Element;
$22a89a9d1d5ce29e$export$85c928794f8d04d4 = $22a89a9d1d5ce29e$var$Node;
$22a89a9d1d5ce29e$export$79b41aa5d56abdff = $22a89a9d1d5ce29e$var$NodeList;
$22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = $22a89a9d1d5ce29e$var$XMLSerializer; //}

});

parcelRegister("2NAtx", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", () => $209c739ee170ce7f$export$91f0e5ff03dc84f, (v) => $209c739ee170ce7f$export$91f0e5ff03dc84f = v);
$parcel$export(module.exports, "HTML_ENTITIES", () => $209c739ee170ce7f$export$b7e4d4631df36afa, (v) => $209c739ee170ce7f$export$b7e4d4631df36afa = v);
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $209c739ee170ce7f$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $209c739ee170ce7f$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $209c739ee170ce7f$export$79451380caed3f98;
"use strict";

var $hkG9E = parcelRequire("hkG9E");
var $209c739ee170ce7f$require$freeze = $hkG9E.freeze;
$209c739ee170ce7f$export$91f0e5ff03dc84f = $209c739ee170ce7f$require$freeze({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
});
$209c739ee170ce7f$export$b7e4d4631df36afa = $209c739ee170ce7f$require$freeze({
    Aacute: "\xc1",
    aacute: "\xe1",
    Abreve: "\u0102",
    abreve: "\u0103",
    ac: "\u223E",
    acd: "\u223F",
    acE: "\u223E\u0333",
    Acirc: "\xc2",
    acirc: "\xe2",
    acute: "\xb4",
    Acy: "\u0410",
    acy: "\u0430",
    AElig: "\xc6",
    aelig: "\xe6",
    af: "\u2061",
    Afr: "\uD835\uDD04",
    afr: "\uD835\uDD1E",
    Agrave: "\xc0",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    Alpha: "\u0391",
    alpha: "\u03B1",
    Amacr: "\u0100",
    amacr: "\u0101",
    amalg: "\u2A3F",
    AMP: "&",
    amp: "&",
    And: "\u2A53",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    Aogon: "\u0104",
    aogon: "\u0105",
    Aopf: "\uD835\uDD38",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apacir: "\u2A6F",
    apE: "\u2A70",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    ApplyFunction: "\u2061",
    approx: "\u2248",
    approxeq: "\u224A",
    Aring: "\xc5",
    aring: "\xe5",
    Ascr: "\uD835\uDC9C",
    ascr: "\uD835\uDCB6",
    Assign: "\u2254",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    Atilde: "\xc3",
    atilde: "\xe3",
    Auml: "\xc4",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    barvee: "\u22BD",
    Barwed: "\u2306",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    Bcy: "\u0411",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    Because: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    Bfr: "\uD835\uDD05",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bNot: "\u2AED",
    bnot: "\u2310",
    Bopf: "\uD835\uDD39",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxbox: "\u29C9",
    boxDL: "\u2557",
    boxDl: "\u2556",
    boxdL: "\u2555",
    boxdl: "\u2510",
    boxDR: "\u2554",
    boxDr: "\u2553",
    boxdR: "\u2552",
    boxdr: "\u250C",
    boxH: "\u2550",
    boxh: "\u2500",
    boxHD: "\u2566",
    boxHd: "\u2564",
    boxhD: "\u2565",
    boxhd: "\u252C",
    boxHU: "\u2569",
    boxHu: "\u2567",
    boxhU: "\u2568",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxUL: "\u255D",
    boxUl: "\u255C",
    boxuL: "\u255B",
    boxul: "\u2518",
    boxUR: "\u255A",
    boxUr: "\u2559",
    boxuR: "\u2558",
    boxur: "\u2514",
    boxV: "\u2551",
    boxv: "\u2502",
    boxVH: "\u256C",
    boxVh: "\u256B",
    boxvH: "\u256A",
    boxvh: "\u253C",
    boxVL: "\u2563",
    boxVl: "\u2562",
    boxvL: "\u2561",
    boxvl: "\u2524",
    boxVR: "\u2560",
    boxVr: "\u255F",
    boxvR: "\u255E",
    boxvr: "\u251C",
    bprime: "\u2035",
    Breve: "\u02D8",
    breve: "\u02D8",
    brvbar: "\xa6",
    Bscr: "\u212C",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    Bumpeq: "\u224E",
    bumpeq: "\u224F",
    Cacute: "\u0106",
    cacute: "\u0107",
    Cap: "\u22D2",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    CapitalDifferentialD: "\u2145",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    Cayleys: "\u212D",
    ccaps: "\u2A4D",
    Ccaron: "\u010C",
    ccaron: "\u010D",
    Ccedil: "\xc7",
    ccedil: "\xe7",
    Ccirc: "\u0108",
    ccirc: "\u0109",
    Cconint: "\u2230",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    Cdot: "\u010A",
    cdot: "\u010B",
    cedil: "\xb8",
    Cedilla: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    CenterDot: "\xb7",
    centerdot: "\xb7",
    Cfr: "\u212D",
    cfr: "\uD835\uDD20",
    CHcy: "\u0427",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    Chi: "\u03A7",
    chi: "\u03C7",
    cir: "\u25CB",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    CircleDot: "\u2299",
    circledR: "\xae",
    circledS: "\u24C8",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    cirE: "\u29C3",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    clubs: "\u2663",
    clubsuit: "\u2663",
    Colon: "\u2237",
    colon: ":",
    Colone: "\u2A74",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    Congruent: "\u2261",
    Conint: "\u222F",
    conint: "\u222E",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    Coproduct: "\u2210",
    COPY: "\xa9",
    copy: "\xa9",
    copysr: "\u2117",
    CounterClockwiseContourIntegral: "\u2233",
    crarr: "\u21B5",
    Cross: "\u2A2F",
    cross: "\u2717",
    Cscr: "\uD835\uDC9E",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    Cup: "\u22D3",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    CupCap: "\u224D",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    Dagger: "\u2021",
    dagger: "\u2020",
    daleth: "\u2138",
    Darr: "\u21A1",
    dArr: "\u21D3",
    darr: "\u2193",
    dash: "\u2010",
    Dashv: "\u2AE4",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    Dcaron: "\u010E",
    dcaron: "\u010F",
    Dcy: "\u0414",
    dcy: "\u0434",
    DD: "\u2145",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    DDotrahd: "\u2911",
    ddotseq: "\u2A77",
    deg: "\xb0",
    Del: "\u2207",
    Delta: "\u0394",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    Dfr: "\uD835\uDD07",
    dfr: "\uD835\uDD21",
    dHar: "\u2965",
    dharl: "\u21C3",
    dharr: "\u21C2",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    diam: "\u22C4",
    Diamond: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    DifferentialD: "\u2146",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    DJcy: "\u0402",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    Dopf: "\uD835\uDD3B",
    dopf: "\uD835\uDD55",
    Dot: "\xa8",
    dot: "\u02D9",
    DotDot: "\u20DC",
    doteq: "\u2250",
    doteqdot: "\u2251",
    DotEqual: "\u2250",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    Downarrow: "\u21D3",
    downarrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    Dscr: "\uD835\uDC9F",
    dscr: "\uD835\uDCB9",
    DScy: "\u0405",
    dscy: "\u0455",
    dsol: "\u29F6",
    Dstrok: "\u0110",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    DZcy: "\u040F",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    Eacute: "\xc9",
    eacute: "\xe9",
    easter: "\u2A6E",
    Ecaron: "\u011A",
    ecaron: "\u011B",
    ecir: "\u2256",
    Ecirc: "\xca",
    ecirc: "\xea",
    ecolon: "\u2255",
    Ecy: "\u042D",
    ecy: "\u044D",
    eDDot: "\u2A77",
    Edot: "\u0116",
    eDot: "\u2251",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    Efr: "\uD835\uDD08",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    Egrave: "\xc8",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    Element: "\u2208",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    Emacr: "\u0112",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    EmptySmallSquare: "\u25FB",
    emptyv: "\u2205",
    EmptyVerySmallSquare: "\u25AB",
    emsp: "\u2003",
    emsp13: "\u2004",
    emsp14: "\u2005",
    ENG: "\u014A",
    eng: "\u014B",
    ensp: "\u2002",
    Eogon: "\u0118",
    eogon: "\u0119",
    Eopf: "\uD835\uDD3C",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    Epsilon: "\u0395",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    Equal: "\u2A75",
    equals: "=",
    EqualTilde: "\u2242",
    equest: "\u225F",
    Equilibrium: "\u21CC",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erarr: "\u2971",
    erDot: "\u2253",
    Escr: "\u2130",
    escr: "\u212F",
    esdot: "\u2250",
    Esim: "\u2A73",
    esim: "\u2242",
    Eta: "\u0397",
    eta: "\u03B7",
    ETH: "\xd0",
    eth: "\xf0",
    Euml: "\xcb",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    Exists: "\u2203",
    expectation: "\u2130",
    ExponentialE: "\u2147",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    Fcy: "\u0424",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    Ffr: "\uD835\uDD09",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    Fopf: "\uD835\uDD3D",
    fopf: "\uD835\uDD57",
    ForAll: "\u2200",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    Fouriertrf: "\u2131",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    Fscr: "\u2131",
    fscr: "\uD835\uDCBB",
    gacute: "\u01F5",
    Gamma: "\u0393",
    gamma: "\u03B3",
    Gammad: "\u03DC",
    gammad: "\u03DD",
    gap: "\u2A86",
    Gbreve: "\u011E",
    gbreve: "\u011F",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    gcirc: "\u011D",
    Gcy: "\u0413",
    gcy: "\u0433",
    Gdot: "\u0120",
    gdot: "\u0121",
    gE: "\u2267",
    ge: "\u2265",
    gEl: "\u2A8C",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    Gfr: "\uD835\uDD0A",
    gfr: "\uD835\uDD24",
    Gg: "\u22D9",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    GJcy: "\u0403",
    gjcy: "\u0453",
    gl: "\u2277",
    gla: "\u2AA5",
    glE: "\u2A92",
    glj: "\u2AA4",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gnE: "\u2269",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    Gopf: "\uD835\uDD3E",
    gopf: "\uD835\uDD58",
    grave: "`",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    Gt: "\u226B",
    GT: ">",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    Hacek: "\u02C7",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    HARDcy: "\u042A",
    hardcy: "\u044A",
    hArr: "\u21D4",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    Hat: "^",
    hbar: "\u210F",
    Hcirc: "\u0124",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    Hfr: "\u210C",
    hfr: "\uD835\uDD25",
    HilbertSpace: "\u210B",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    Hopf: "\u210D",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    Hstrok: "\u0126",
    hstrok: "\u0127",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    hybull: "\u2043",
    hyphen: "\u2010",
    Iacute: "\xcd",
    iacute: "\xed",
    ic: "\u2063",
    Icirc: "\xce",
    icirc: "\xee",
    Icy: "\u0418",
    icy: "\u0438",
    Idot: "\u0130",
    IEcy: "\u0415",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    Ifr: "\u2111",
    ifr: "\uD835\uDD26",
    Igrave: "\xcc",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    IJlig: "\u0132",
    ijlig: "\u0133",
    Im: "\u2111",
    Imacr: "\u012A",
    imacr: "\u012B",
    image: "\u2111",
    ImaginaryI: "\u2148",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    Implies: "\u21D2",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    Int: "\u222C",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    Integral: "\u222B",
    intercal: "\u22BA",
    Intersection: "\u22C2",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    IOcy: "\u0401",
    iocy: "\u0451",
    Iogon: "\u012E",
    iogon: "\u012F",
    Iopf: "\uD835\uDD40",
    iopf: "\uD835\uDD5A",
    Iota: "\u0399",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    Iscr: "\u2110",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isindot: "\u22F5",
    isinE: "\u22F9",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    Itilde: "\u0128",
    itilde: "\u0129",
    Iukcy: "\u0406",
    iukcy: "\u0456",
    Iuml: "\xcf",
    iuml: "\xef",
    Jcirc: "\u0134",
    jcirc: "\u0135",
    Jcy: "\u0419",
    jcy: "\u0439",
    Jfr: "\uD835\uDD0D",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    Jopf: "\uD835\uDD41",
    jopf: "\uD835\uDD5B",
    Jscr: "\uD835\uDCA5",
    jscr: "\uD835\uDCBF",
    Jsercy: "\u0408",
    jsercy: "\u0458",
    Jukcy: "\u0404",
    jukcy: "\u0454",
    Kappa: "\u039A",
    kappa: "\u03BA",
    kappav: "\u03F0",
    Kcedil: "\u0136",
    kcedil: "\u0137",
    Kcy: "\u041A",
    kcy: "\u043A",
    Kfr: "\uD835\uDD0E",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    KHcy: "\u0425",
    khcy: "\u0445",
    KJcy: "\u040C",
    kjcy: "\u045C",
    Kopf: "\uD835\uDD42",
    kopf: "\uD835\uDD5C",
    Kscr: "\uD835\uDCA6",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    Lacute: "\u0139",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    Lambda: "\u039B",
    lambda: "\u03BB",
    Lang: "\u27EA",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    Laplacetrf: "\u2112",
    laquo: "\xab",
    Larr: "\u219E",
    lArr: "\u21D0",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    lAtail: "\u291B",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lBarr: "\u290E",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    Lcaron: "\u013D",
    lcaron: "\u013E",
    Lcedil: "\u013B",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    Lcy: "\u041B",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    lE: "\u2266",
    le: "\u2264",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    Leftarrow: "\u21D0",
    leftarrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    leftarrowtail: "\u21A2",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    LeftRightArrow: "\u2194",
    Leftrightarrow: "\u21D4",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    leftthreetimes: "\u22CB",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    lEg: "\u2A8B",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    lessgtr: "\u2276",
    LessLess: "\u2AA1",
    lesssim: "\u2272",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    Lfr: "\uD835\uDD0F",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lHar: "\u2962",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    LJcy: "\u0409",
    ljcy: "\u0459",
    Ll: "\u22D8",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    Lleftarrow: "\u21DA",
    llhard: "\u296B",
    lltri: "\u25FA",
    Lmidot: "\u013F",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lnE: "\u2268",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    LongLeftArrow: "\u27F5",
    Longleftarrow: "\u27F8",
    longleftarrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    Longleftrightarrow: "\u27FA",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    LongRightArrow: "\u27F6",
    Longrightarrow: "\u27F9",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    Lopf: "\uD835\uDD43",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    Lscr: "\u2112",
    lscr: "\uD835\uDCC1",
    Lsh: "\u21B0",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    Lstrok: "\u0141",
    lstrok: "\u0142",
    Lt: "\u226A",
    LT: "<",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    ltrPar: "\u2996",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    Map: "\u2905",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    Mcy: "\u041C",
    mcy: "\u043C",
    mdash: "\u2014",
    mDDot: "\u223A",
    measuredangle: "\u2221",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    MinusPlus: "\u2213",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    Mopf: "\uD835\uDD44",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    Mscr: "\u2133",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    Mu: "\u039C",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nabla: "\u2207",
    Nacute: "\u0143",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    Ncaron: "\u0147",
    ncaron: "\u0148",
    Ncedil: "\u0145",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    Ncy: "\u041D",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    nearhk: "\u2924",
    neArr: "\u21D7",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    nexist: "\u2204",
    nexists: "\u2204",
    Nfr: "\uD835\uDD11",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    nGg: "\u22D9\u0338",
    ngsim: "\u2275",
    nGt: "\u226B\u20D2",
    ngt: "\u226F",
    ngtr: "\u226F",
    nGtv: "\u226B\u0338",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    NJcy: "\u040A",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlarr: "\u219A",
    nldr: "\u2025",
    nlE: "\u2266\u0338",
    nle: "\u2270",
    nLeftarrow: "\u21CD",
    nleftarrow: "\u219A",
    nLeftrightarrow: "\u21CE",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nLl: "\u22D8\u0338",
    nlsim: "\u2274",
    nLt: "\u226A\u20D2",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nLtv: "\u226A\u0338",
    nmid: "\u2224",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    nopf: "\uD835\uDD5F",
    Not: "\u2AEC",
    not: "\xac",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    notin: "\u2209",
    notindot: "\u22F5\u0338",
    notinE: "\u22F9\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nRightarrow: "\u21CF",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    Nscr: "\uD835\uDCA9",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    Ntilde: "\xd1",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    Nu: "\u039D",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvap: "\u224D\u20D2",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nvDash: "\u22AD",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvHarr: "\u2904",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwarhk: "\u2923",
    nwArr: "\u21D6",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    Oacute: "\xd3",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    Ocirc: "\xd4",
    ocirc: "\xf4",
    Ocy: "\u041E",
    ocy: "\u043E",
    odash: "\u229D",
    Odblac: "\u0150",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    OElig: "\u0152",
    oelig: "\u0153",
    ofcir: "\u29BF",
    Ofr: "\uD835\uDD12",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    Ograve: "\xd2",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    Omacr: "\u014C",
    omacr: "\u014D",
    Omega: "\u03A9",
    omega: "\u03C9",
    Omicron: "\u039F",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    Oopf: "\uD835\uDD46",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    operp: "\u29B9",
    oplus: "\u2295",
    Or: "\u2A54",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oS: "\u24C8",
    Oscr: "\uD835\uDCAA",
    oscr: "\u2134",
    Oslash: "\xd8",
    oslash: "\xf8",
    osol: "\u2298",
    Otilde: "\xd5",
    otilde: "\xf5",
    Otimes: "\u2A37",
    otimes: "\u2297",
    otimesas: "\u2A36",
    Ouml: "\xd6",
    ouml: "\xf6",
    ovbar: "\u233D",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    PartialD: "\u2202",
    Pcy: "\u041F",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    Pfr: "\uD835\uDD13",
    pfr: "\uD835\uDD2D",
    Phi: "\u03A6",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    Pi: "\u03A0",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    PlusMinus: "\xb1",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    Poincareplane: "\u210C",
    pointint: "\u2A15",
    Popf: "\u2119",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    Pr: "\u2ABB",
    pr: "\u227A",
    prap: "\u2AB7",
    prcue: "\u227C",
    prE: "\u2AB3",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    Prime: "\u2033",
    prime: "\u2032",
    primes: "\u2119",
    prnap: "\u2AB9",
    prnE: "\u2AB5",
    prnsim: "\u22E8",
    prod: "\u220F",
    Product: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    Proportion: "\u2237",
    Proportional: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    Pscr: "\uD835\uDCAB",
    pscr: "\uD835\uDCC5",
    Psi: "\u03A8",
    psi: "\u03C8",
    puncsp: "\u2008",
    Qfr: "\uD835\uDD14",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    Qopf: "\u211A",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    Qscr: "\uD835\uDCAC",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    QUOT: '"',
    quot: '"',
    rAarr: "\u21DB",
    race: "\u223D\u0331",
    Racute: "\u0154",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    Rang: "\u27EB",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    Rarr: "\u21A0",
    rArr: "\u21D2",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    Rarrtl: "\u2916",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    rAtail: "\u291C",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    RBarr: "\u2910",
    rBarr: "\u290F",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    Rcaron: "\u0158",
    rcaron: "\u0159",
    Rcedil: "\u0156",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    Rcy: "\u0420",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    Re: "\u211C",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    REG: "\xae",
    reg: "\xae",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    rfisht: "\u297D",
    rfloor: "\u230B",
    Rfr: "\u211C",
    rfr: "\uD835\uDD2F",
    rHar: "\u2964",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    Rho: "\u03A1",
    rho: "\u03C1",
    rhov: "\u03F1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    Rightarrow: "\u21D2",
    rightarrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    rightarrowtail: "\u21A3",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    rightthreetimes: "\u22CC",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    Ropf: "\u211D",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    RoundImplies: "\u2970",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    Rrightarrow: "\u21DB",
    rsaquo: "\u203A",
    Rscr: "\u211B",
    rscr: "\uD835\uDCC7",
    Rsh: "\u21B1",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    RuleDelayed: "\u29F4",
    ruluhar: "\u2968",
    rx: "\u211E",
    Sacute: "\u015A",
    sacute: "\u015B",
    sbquo: "\u201A",
    Sc: "\u2ABC",
    sc: "\u227B",
    scap: "\u2AB8",
    Scaron: "\u0160",
    scaron: "\u0161",
    sccue: "\u227D",
    scE: "\u2AB4",
    sce: "\u2AB0",
    Scedil: "\u015E",
    scedil: "\u015F",
    Scirc: "\u015C",
    scirc: "\u015D",
    scnap: "\u2ABA",
    scnE: "\u2AB6",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    Scy: "\u0421",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    searhk: "\u2925",
    seArr: "\u21D8",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    Sfr: "\uD835\uDD16",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    SHCHcy: "\u0429",
    shchcy: "\u0449",
    SHcy: "\u0428",
    shcy: "\u0448",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    shy: "\xad",
    Sigma: "\u03A3",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    SmallCircle: "\u2218",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    SOFTcy: "\u042C",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    Sopf: "\uD835\uDD4A",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    Sqrt: "\u221A",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    Square: "\u25A1",
    square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    Sscr: "\uD835\uDCAE",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    Star: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    Sub: "\u22D0",
    sub: "\u2282",
    subdot: "\u2ABD",
    subE: "\u2AC5",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    Subset: "\u22D0",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    SubsetEqual: "\u2286",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    sum: "\u2211",
    sung: "\u266A",
    Sup: "\u22D1",
    sup: "\u2283",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supE: "\u2AC6",
    supe: "\u2287",
    supedot: "\u2AC4",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    Supset: "\u22D1",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swarhk: "\u2926",
    swArr: "\u21D9",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    Tab: "	",
    target: "\u2316",
    Tau: "\u03A4",
    tau: "\u03C4",
    tbrk: "\u23B4",
    Tcaron: "\u0164",
    tcaron: "\u0165",
    Tcedil: "\u0162",
    tcedil: "\u0163",
    Tcy: "\u0422",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    Tfr: "\uD835\uDD17",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    Therefore: "\u2234",
    therefore: "\u2234",
    Theta: "\u0398",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    ThickSpace: "\u205F\u200A",
    thinsp: "\u2009",
    ThinSpace: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    THORN: "\xde",
    thorn: "\xfe",
    Tilde: "\u223C",
    tilde: "\u02DC",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    Topf: "\uD835\uDD4B",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    TRADE: "\u2122",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    TripleDot: "\u20DB",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    Tscr: "\uD835\uDCAF",
    tscr: "\uD835\uDCC9",
    TScy: "\u0426",
    tscy: "\u0446",
    TSHcy: "\u040B",
    tshcy: "\u045B",
    Tstrok: "\u0166",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    Uacute: "\xda",
    uacute: "\xfa",
    Uarr: "\u219F",
    uArr: "\u21D1",
    uarr: "\u2191",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    ubrcy: "\u045E",
    Ubreve: "\u016C",
    ubreve: "\u016D",
    Ucirc: "\xdb",
    ucirc: "\xfb",
    Ucy: "\u0423",
    ucy: "\u0443",
    udarr: "\u21C5",
    Udblac: "\u0170",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    Ufr: "\uD835\uDD18",
    ufr: "\uD835\uDD32",
    Ugrave: "\xd9",
    ugrave: "\xf9",
    uHar: "\u2963",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    Umacr: "\u016A",
    umacr: "\u016B",
    uml: "\xa8",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    uogon: "\u0173",
    Uopf: "\uD835\uDD4C",
    uopf: "\uD835\uDD66",
    UpArrow: "\u2191",
    Uparrow: "\u21D1",
    uparrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    Updownarrow: "\u21D5",
    updownarrow: "\u2195",
    UpEquilibrium: "\u296E",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    upsi: "\u03C5",
    upsih: "\u03D2",
    Upsilon: "\u03A5",
    upsilon: "\u03C5",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    Uring: "\u016E",
    uring: "\u016F",
    urtri: "\u25F9",
    Uscr: "\uD835\uDCB0",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    Utilde: "\u0168",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    Uuml: "\xdc",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    vArr: "\u21D5",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    Vbar: "\u2AEB",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    Vcy: "\u0412",
    vcy: "\u0432",
    VDash: "\u22AB",
    Vdash: "\u22A9",
    vDash: "\u22A8",
    vdash: "\u22A2",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    Verbar: "\u2016",
    verbar: "|",
    Vert: "\u2016",
    vert: "|",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    Vopf: "\uD835\uDD4D",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    Vscr: "\uD835\uDCB1",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    Vvdash: "\u22AA",
    vzigzag: "\u299A",
    Wcirc: "\u0174",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    Wedge: "\u22C0",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    Wfr: "\uD835\uDD1A",
    wfr: "\uD835\uDD34",
    Wopf: "\uD835\uDD4E",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    Wscr: "\uD835\uDCB2",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    Xfr: "\uD835\uDD1B",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    Xi: "\u039E",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    Xopf: "\uD835\uDD4F",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    Xscr: "\uD835\uDCB3",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    Yacute: "\xdd",
    yacute: "\xfd",
    YAcy: "\u042F",
    yacy: "\u044F",
    Ycirc: "\u0176",
    ycirc: "\u0177",
    Ycy: "\u042B",
    ycy: "\u044B",
    yen: "\xa5",
    Yfr: "\uD835\uDD1C",
    yfr: "\uD835\uDD36",
    YIcy: "\u0407",
    yicy: "\u0457",
    Yopf: "\uD835\uDD50",
    yopf: "\uD835\uDD6A",
    Yscr: "\uD835\uDCB4",
    yscr: "\uD835\uDCCE",
    YUcy: "\u042E",
    yucy: "\u044E",
    Yuml: "\u0178",
    yuml: "\xff",
    Zacute: "\u0179",
    zacute: "\u017A",
    Zcaron: "\u017D",
    zcaron: "\u017E",
    Zcy: "\u0417",
    zcy: "\u0437",
    Zdot: "\u017B",
    zdot: "\u017C",
    zeetrf: "\u2128",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    zeta: "\u03B6",
    Zfr: "\u2128",
    zfr: "\uD835\uDD37",
    ZHcy: "\u0416",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    Zopf: "\u2124",
    zopf: "\uD835\uDD6B",
    Zscr: "\uD835\uDCB5",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
});
$209c739ee170ce7f$export$79451380caed3f98 = $209c739ee170ce7f$export$b7e4d4631df36afa;

});

parcelRegister("1fO4L", function(module, exports) {

$parcel$export(module.exports, "XMLReader", () => $0e9e0929092947dd$export$ccbc9f9f018333e9, (v) => $0e9e0929092947dd$export$ccbc9f9f018333e9 = v);
$parcel$export(module.exports, "ParseError", () => $0e9e0929092947dd$export$f9c837a54db411d, (v) => $0e9e0929092947dd$export$f9c837a54db411d = v);
var $0e9e0929092947dd$export$ccbc9f9f018333e9;
var $0e9e0929092947dd$export$f9c837a54db411d;

var $hkG9E = parcelRequire("hkG9E");
var $0e9e0929092947dd$require$NAMESPACE = $hkG9E.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $0e9e0929092947dd$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $0e9e0929092947dd$var$nameChar = new RegExp("[\\-\\.0-9" + $0e9e0929092947dd$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $0e9e0929092947dd$var$tagNamePattern = new RegExp("^" + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + "*(?::" + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + "*)?$");
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $0e9e0929092947dd$var$S_TAG = 0; //tag name offerring
var $0e9e0929092947dd$var$S_ATTR = 1; //attr name offerring
var $0e9e0929092947dd$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $0e9e0929092947dd$var$S_EQ = 3; //=space?
var $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $0e9e0929092947dd$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $0e9e0929092947dd$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $0e9e0929092947dd$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $0e9e0929092947dd$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $0e9e0929092947dd$var$ParseError);
}
$0e9e0929092947dd$var$ParseError.prototype = new Error();
$0e9e0929092947dd$var$ParseError.prototype.name = $0e9e0929092947dd$var$ParseError.name;
function $0e9e0929092947dd$var$XMLReader() {}
$0e9e0929092947dd$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $0e9e0929092947dd$var$_copy(defaultNSMap, defaultNSMap = {});
        $0e9e0929092947dd$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $0e9e0929092947dd$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === "#") return fixedFromCharCode(parseInt(k.substr(1).replace("x", "0x")));
        else {
            errorHandler.error("entity not found:" + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf("<", start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case "/":
                    var end = source.indexOf(">", tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, "");
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, "");
                        errorHandler.error("end tag name: " + tagName + " is not complete:" + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, "");
                        errorHandler.error("end tag name: " + tagName + " maybe not complete");
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + " is not match the current start tagName:" + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case "?":
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case "!":
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $0e9e0929092947dd$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $0e9e0929092947dd$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $0e9e0929092947dd$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning("unclosed xml attribute");
                    }
                    if (locator && len) {
                        var locator2 = $0e9e0929092947dd$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $0e9e0929092947dd$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($0e9e0929092947dd$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $0e9e0929092947dd$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $0e9e0929092947dd$var$ParseError) throw e;
            errorHandler.error("element parse error: " + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $0e9e0929092947dd$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $0e9e0929092947dd$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError("Attribute " + qname + " redefined");
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $0e9e0929092947dd$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case "=":
                if (s === $0e9e0929092947dd$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $0e9e0929092947dd$var$S_EQ;
                } else if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) s = $0e9e0929092947dd$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error("attribute equal must after attrName"); // No known test case
                break;
            case "'":
            case '"':
                if (s === $0e9e0929092947dd$var$S_EQ || s === $0e9e0929092947dd$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $0e9e0929092947dd$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $0e9e0929092947dd$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error("attribute value no end '" + c + "' match");
                } else if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ")!!");
                    start = p + 1;
                    s = $0e9e0929092947dd$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case "/":
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        s = $0e9e0929092947dd$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case "":
                errorHandler.error("unexpected end of input");
                if (s == $0e9e0929092947dd$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case ">":
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        break; //normal
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === "/") {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) value = attrName;
                        if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap[""]) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        throw new Error("attribute value missed!!");
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case "\x80":
                c = " ";
            default:
                if (c <= " ") switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $0e9e0929092947dd$var$S_ATTR_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap[""]) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $0e9e0929092947dd$var$S_ATTR;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                        s = $0e9e0929092947dd$var$S_ATTR;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        s = $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(":");
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === "xmlns" && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === "xmlns" && "";
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $0e9e0929092947dd$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $0e9e0929092947dd$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === "xml") a.uri = $0e9e0929092947dd$require$NAMESPACE.XML;
            if (prefix !== "xmlns") a.uri = currentNSMap[prefix || ""];
        }
    }
    var nsp = tagName.indexOf(":");
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ""];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $0e9e0929092947dd$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf("</" + tagName + ">", elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $0e9e0929092947dd$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf("</" + tagName + ">");
        if (pos < elStartEnd) pos = source.lastIndexOf("</" + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $0e9e0929092947dd$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $0e9e0929092947dd$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case "-":
            if (source.charAt(start + 3) === "-") {
                var end = source.indexOf("-->", start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == "CDATA[") {
                var end = source.indexOf("]]>", start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $0e9e0929092947dd$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $0e9e0929092947dd$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf("?>", start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $0e9e0929092947dd$var$ElementAttributes() {
    this.attributeNames = {};
}
$0e9e0929092947dd$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(tagName)) throw new Error("invalid tagName:" + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(qName)) throw new Error("invalid attribute:" + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $0e9e0929092947dd$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$0e9e0929092947dd$export$ccbc9f9f018333e9 = $0e9e0929092947dd$var$XMLReader;
$0e9e0929092947dd$export$f9c837a54db411d = $0e9e0929092947dd$var$ParseError;

});


parcelRegister("R5nvG", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof $parcel$global !== "undefined" && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        var global1 = typeof globalThis1 !== "undefined" && globalThis1 || typeof self !== "undefined" && self || typeof global1 !== "undefined" && global1;
        var support = {
            searchParams: "URLSearchParams" in global1,
            iterable: "Symbol" in global1 && "iterator" in Symbol,
            blob: "FileReader" in global1 && "Blob" in global1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in global1,
            arrayBuffer: "ArrayBuffer" in global1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = global1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && global1.location.href ? global1.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer && request.headers.get("Content-Type") && request.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!global1.fetch) {
            global1.fetch = fetch;
            global1.Headers = Headers;
            global1.Request = Request;
            global1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

// /// <reference types="@angular/localize" />
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { AppModule } from './app/app.module';
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("7B2bR"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

$11492dca620dcaa5$exports = (parcelRequire("3y30c"));


var $7e96a608cb33bf79$var$i = $11492dca620dcaa5$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$7e96a608cb33bf79$export$882461b6382ed46c = function(c, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.createRoot(c, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};
$7e96a608cb33bf79$export$757ceba2d55c277e = function(c, h, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.hydrateRoot(c, h, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};



var $acw62 = parcelRequire("acw62");

/**
 * React Router DOM v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state, {
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$3add0d5dce533e2e.displayName = "DataRouter";
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$145dfa71566a64dc.displayName = "DataRouterState";
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$26749e8557646306.displayName = "Navigation";
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$c7914228fb69b0f5.displayName = "Location";
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$7939e29d663dd3ed$export$9072aa6dd1f93057.displayName = "Route";
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(activeRef.current, $7939e29d663dd3ed$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $7939e29d663dd3ed$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + parentPathname + '" (under <Route path="' + parentPath + '">) but the ') + 'parent route path has no trailing "*". This means if you navigate ' + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ('Please change the parent <Route path="' + parentPath + '"> to <Route ') + ('path="' + (parentPath === "/" ? "*" : parentPath + "/*") + '">.'));
    }
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + parentPathnameBase + '" ') + ('but pathname "' + parsedLocationArg.pathname + '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(parentRoute || matches != null, 'No routes matched location "' + location.pathname + location.search + location.hash + '" ');
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined, 'Matched leaf route at location "' + location.pathname + location.search + location.hash + '" ' + "does not have an element or Component. This means it will render an <Outlet /> with a " + 'null value by default resulting in an "empty" page.');
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, hookName + ' can only be used on routes that contain a unique "id"');
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useActionData must be used inside a RouteContext");
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(activeRef.current, $7939e29d663dd3ed$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) {
        $7939e29d663dd3ed$var$alreadyWarned[key] = true;
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, message);
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(!$acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(locationContext != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $acw62.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) {
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, '"' + encType + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + $040dbb9c344a508d$var$defaultEncType + '"'));
        return null;
    }
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
$040dbb9c344a508d$export$7ad602f0e94e62d1.displayName = "ViewTransition";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        optInStartTransition,
        transition,
        renderDfd,
        router.window
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement)))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$040dbb9c344a508d$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, '<Link to="' + to + '"> contains an invalid URL which will probably break ' + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$040dbb9c344a508d$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$040dbb9c344a508d$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
$040dbb9c344a508d$export$a7fed597f4b8afd8.displayName = "Form";
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$040dbb9c344a508d$var$FormImpl.displayName = "FormImpl";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$040dbb9c344a508d$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $040dbb9c344a508d$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $040dbb9c344a508d$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params\n\nIf you're unsure how to load polyfills, we recommend you check out https://polyfill.io/v3/ which provides some recommendations about how to load polyfills only for users that need them, instead of for every user.");
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for useFetcher()");
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    FetcherForm.displayName = "fetcher.Form";
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, 'useFetcher can only be used on routes that contain a unique "id"');
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for fetcher.Form()");
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No router available for fetcher.load()");
            !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {
            (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref11) {
    let { when: when, message: message } = _ref11;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}






var $acw62 = parcelRequire("acw62");
var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;



var $acw62 = parcelRequire("acw62");
var $9a6b6bc51884b56d$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $9a6b6bc51884b56d$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($9a6b6bc51884b56d$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(...args);
}
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
}
function $cfb6e0167e0b350d$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316
};
function $4f75eea5b29ffc65$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
}
function $4f75eea5b29ffc65$export$212bb2fc580a90a8() {
    return $4f75eea5b29ffc65$var$defaultOptions;
}


let $1d04edb3ddd0d89e$var$i18nInstance;
function $1d04edb3ddd0d89e$export$a039134f2fc7e0(instance) {
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
}
function $1d04edb3ddd0d89e$export$64af334f494c2f47() {
    return $1d04edb3ddd0d89e$var$i18nInstance;
}


function $acffcb171536f8e9$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $acffcb171536f8e9$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
}
function $acffcb171536f8e9$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $acw62.isValidElement)(child));
}
function $acffcb171536f8e9$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $acffcb171536f8e9$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $acffcb171536f8e9$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $acw62.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $acffcb171536f8e9$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if (typeof child === "object" && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
}
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = $acffcb171536f8e9$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $e04d9533328ca578$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");


const $3765cebd031b52c0$var$usePrevious = (value, ignore)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $3765cebd031b52c0$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $acw62.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    const isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $acw62 = parcelRequire("acw62");


function $d9bd4545752f9667$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $868685a400877801$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $d97c91d803f78bcc$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $afd5c8e3ef499392$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>"";
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>"";
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>"";
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>"";
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>"";
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>"";




var $acw62 = parcelRequire("acw62");


"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $2f71637df772b183$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $2f71637df772b183$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $2f71637df772b183$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $2f71637df772b183$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
function $79f0a48d5eb7919b$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if (!requestHeaders.getContentType(/^\s*multipart\/form-data/)) requestHeaders.setContentType("multipart/form-data"); // mobile/desktop app frameworks
            else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(contentType = requestHeaders.getContentType())) // fix semicolon duplication issue for ReactNative FormData implementation
            requestHeaders.setContentType(contentType.replace(/^\s*(multipart\/form-data);+/, "$1"));
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            // regarding CVE-2023-45857 config.withCredentials condition was removed temporarily
            const xsrfValue = (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(fullPath) && config.xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $2f71637df772b183$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.6.0";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


function $b4b570ff6b0b04ee$export$2e2bcd8739ae039() {
    const urlParams = new URLSearchParams(window.location.search);
    const regionParam = urlParams.get("region") ?? "eu-west-2";
    const euServices = {
        shareableApi: "https://test.eu.nextbase.cloud/shareable/api/v1",
        witnessApi: "https://test.eu.nextbase.cloud/witnessmode/api/v2"
    };
    const usServices = {
        shareableApi: "https://test.au.nextbase.cloud/shareable/api/v1",
        witnessApi: "https://test.au.nextbase.cloud/witnessmode/api/v2"
    };
    const auServices = {
        shareableApi: "https://dev.au.nextbase.cloud/shareable/api/v1",
        witnessApi: "https://dev.au.nextbase.cloud/witnessmode/api/v2"
    };
    switch(regionParam){
        case "us-east-2":
            return usServices;
        case "ap-southeast-2":
            return auServices;
        default:
            return euServices;
    }
}


function $33feeae903d89f94$export$2e2bcd8739ae039() {
    (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).defaults.headers.common["Content-Type"] = "application/json";
    function getLinks(code) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $b4b570ff6b0b04ee$export$2e2bcd8739ae039)().shareableApi}/videoportal/video-thumbnails/${code}`);
    }
    function getVideos(code) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $b4b570ff6b0b04ee$export$2e2bcd8739ae039)().shareableApi}/videoportal/videos/${code}`);
    }
    function validateCode(code) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(`${(0, $b4b570ff6b0b04ee$export$2e2bcd8739ae039)().shareableApi}/videoportal/validate-code`, {
            code: code
        });
    }
    return {
        getLinks: getLinks,
        getVideos: getVideos,
        validateCode: validateCode
    };
}



function $131e30fdd2754bff$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [keyCode0, setKeyCode0] = (0, $acw62.useState)("");
    const [keyCode1, setKeyCode1] = (0, $acw62.useState)("");
    const [keyCode2, setKeyCode2] = (0, $acw62.useState)("");
    const [keyCode3, setKeyCode3] = (0, $acw62.useState)("");
    const [keyCode4, setKeyCode4] = (0, $acw62.useState)("");
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [submitError, setSubmitError] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("paste", (ev)=>{
            ev.preventDefault();
            let clipboardContents = ev.clipboardData?.getData("text").trim();
            if (clipboardContents?.length !== 5) return;
            for(let i = 0; i < clipboardContents.length; i++){
                if (!allowedCodeKeys.test(clipboardContents[i])) return;
            }
            setKeyCode0(clipboardContents[0]);
            setKeyCode1(clipboardContents[1]);
            setKeyCode2(clipboardContents[2]);
            setKeyCode3(clipboardContents[3]);
            setKeyCode4(clipboardContents[4]);
        });
    }, []);
    const allowedCodeKeys = /[2-9A-HJ-NP-Za-hj-np-z]/;
    function onCodeChange(ev, codeIdx) {
        const target = ev.target.value;
        if (target.length > 1) return;
        switch(codeIdx){
            case 0:
                if (target === "" || keyCode0 === "" && allowedCodeKeys.test(target)) {
                    setKeyCode0(target);
                    setSubmitError(false);
                    if (target.length > 0) findAndFocusNextInput(0);
                }
                break;
            case 1:
                if (target === "" || keyCode1 === "" && allowedCodeKeys.test(target)) {
                    setKeyCode1(target);
                    setSubmitError(false);
                    if (target.length === 0) findAndFocusPreviousInput(1);
                    else if (target.length > 0) findAndFocusNextInput(1);
                }
                break;
            case 2:
                if (target === "" || keyCode2 === "" && allowedCodeKeys.test(target)) {
                    setKeyCode2(target);
                    setSubmitError(false);
                    if (target.length === 0) findAndFocusPreviousInput(2);
                    else if (target.length > 0) findAndFocusNextInput(2);
                }
                break;
            case 3:
                if (target === "" || keyCode3 === "" && allowedCodeKeys.test(target)) {
                    setKeyCode3(target);
                    setSubmitError(false);
                    if (target.length === 0) findAndFocusPreviousInput(3);
                    else if (target.length > 0) findAndFocusNextInput(3);
                }
                break;
            case 4:
                if (target === "" || keyCode4 === "" && allowedCodeKeys.test(target)) {
                    setKeyCode4(target);
                    setSubmitError(false);
                    if (target.length === 0) findAndFocusPreviousInput(4);
                }
                break;
        }
    }
    function findAndFocusPreviousInput(currentIdx) {
        const prevInput = document.querySelector(`input[name=keyCode${currentIdx - 1}]`);
        if (prevInput) prevInput.focus();
    }
    function findAndFocusNextInput(currentIdx) {
        const nextInput = document.querySelector(`input[name=keyCode${currentIdx + 1}]`);
        if (nextInput) nextInput.focus();
    }
    function onKeyUp(ev, codeIdx) {
        if (ev.key === "Enter" && validateCode()) {
            submit();
            return;
        }
        if (ev.key !== "Backspace" || codeIdx === 0) return;
        switch(codeIdx){
            case 1:
                if (keyCode1 !== "") return;
                break;
            case 2:
                if (keyCode2 !== "") return;
                break;
            case 3:
                if (keyCode3 !== "") return;
                break;
            case 4:
                if (keyCode4 !== "") return;
                break;
        }
        findAndFocusPreviousInput(codeIdx);
    }
    function onKeyDown(ev, codeIdx) {
        const keyDownEvents = [
            "ArrowLeft",
            "ArrowRight"
        ];
        if (keyDownEvents.indexOf(ev.key) < 0) return;
        const input = document.querySelector(`input[name=keyCode${codeIdx}]`);
        if (!input) return;
        if (ev.key === "ArrowLeft" && codeIdx !== 0 && input.selectionEnd === 0) findAndFocusPreviousInput(codeIdx);
        if (ev.key === "ArrowRight" && codeIdx !== 4 && input.selectionEnd === input.value.length) findAndFocusNextInput(codeIdx);
    }
    function validateCode() {
        return keyCode0 !== "" && keyCode1 !== "" && keyCode2 !== "" && keyCode3 !== "" && keyCode4 !== "";
    }
    function getCode() {
        return `${keyCode0}${keyCode1}${keyCode2}${keyCode3}${keyCode4}`.toUpperCase();
    }
    function submit() {
        if (validateCode()) {
            setSubmitting(true);
            setSubmitError(false);
            (0, $33feeae903d89f94$export$2e2bcd8739ae039)().validateCode(getCode()).then((res)=>{
                if (res.data.valid) navigate(`/video/${getCode()}`);
                else {
                    setSubmitting(false);
                    setSubmitError(true);
                }
            }).catch((err)=>{
                setSubmitting(false);
                setSubmitError(true);
            });
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "d-flex justify-content-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: "keyCode0",
                        className: `code-input form-control ${submitError && "error"}`,
                        value: keyCode0,
                        onChange: (e)=>onCodeChange(e, 0),
                        onKeyUp: (e)=>onKeyUp(e, 0),
                        onKeyDown: (e)=>onKeyDown(e, 0)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: "keyCode1",
                        className: `code-input form-control ${submitError && "error"}`,
                        value: keyCode1,
                        onChange: (e)=>onCodeChange(e, 1),
                        onKeyUp: (e)=>onKeyUp(e, 1),
                        onKeyDown: (e)=>onKeyDown(e, 1)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: "keyCode2",
                        className: `code-input form-control ${submitError && "error"}`,
                        value: keyCode2,
                        onChange: (e)=>onCodeChange(e, 2),
                        onKeyUp: (e)=>onKeyUp(e, 2),
                        onKeyDown: (e)=>onKeyDown(e, 2)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: "keyCode3",
                        className: `code-input form-control ${submitError && "error"}`,
                        value: keyCode3,
                        onChange: (e)=>onCodeChange(e, 3),
                        onKeyUp: (e)=>onKeyUp(e, 3),
                        onKeyDown: (e)=>onKeyDown(e, 3)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: "keyCode4",
                        className: `code-input form-control ${submitError && "error"}`,
                        value: keyCode4,
                        onChange: (e)=>onCodeChange(e, 4),
                        onKeyUp: (e)=>onKeyUp(e, 4),
                        onKeyDown: (e)=>onKeyDown(e, 4)
                    })
                ]
            }),
            submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "invalid-code mt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        className: "bi bi-info-circle-fill",
                        viewBox: "0 0 16 16",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ms-2 text-white",
                        children: t("invalid_code")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "d-flex justify-content-center m-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    className: "btn btn-primary btn-submit",
                    disabled: !validateCode(),
                    onClick: submit,
                    children: [
                        submitting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "spinner-border text-white"
                        }),
                        !submitting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t("submit")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "small mt-2 text-center",
                children: t("obtain_code")
            })
        ]
    });
}



function $367491e86d055a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "d-flex justify-content-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                width: "120",
                height: "121",
                viewBox: "0 0 120 121",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        clipPath: "url(#clip0_27259_153469)",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M89.7486 86.5263C92.7317 88.8992 95.9995 90.4992 99.9995 90.4992V99.5025C92.7995 99.5025 87.5113 96.3975 82.9961 92.4517C80.7588 93.9975 78.3723 95.3127 75.8503 96.3839C70.9689 98.4449 65.7893 99.5025 60.4469 99.5025C55.1045 99.5025 49.9249 98.4585 45.0435 96.3839C41.8706 95.0415 38.9147 93.3059 36.2164 91.2178V78.6619C41.8164 85.9025 50.5757 90.5534 60.4334 90.5534C66.3181 90.5534 71.8232 88.8856 76.4876 86.011C71.5384 80.8042 66.8876 76.072 60.4334 76.072V67.0686C71.1723 67.0686 77.4096 73.9703 83.3079 80.289C88.1215 74.8788 91.0503 67.7602 91.0503 59.95C91.0503 43.0415 77.3554 29.3466 60.4469 29.3466C46.1961 29.3466 34.2232 39.0822 30.8062 52.2619C29.2198 51.3398 27.3757 50.8246 25.4232 50.8246C24.1622 50.8246 22.9418 51.0415 21.8164 51.4483C22.3317 49.1025 23.0639 46.7975 24.013 44.5602C26.0062 39.8551 28.8537 35.6246 32.4876 31.9907C36.1215 28.3568 40.352 25.5093 45.0571 23.5161C49.9384 21.4551 55.1181 20.3975 60.4605 20.3975C65.7893 20.3975 70.9825 21.4415 75.8639 23.5161C80.569 25.5093 84.7995 28.3568 88.4334 31.9907C92.0673 35.6246 94.9147 39.8551 96.9079 44.5602C98.9689 49.4415 100.013 54.6212 100.013 59.9636C100.013 65.3059 98.9689 70.4856 96.9079 75.367C95.1452 79.4754 92.7452 83.2178 89.7486 86.5263Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M30.8339 94.0925C30.8339 97.0755 28.4068 99.5026 25.4237 99.5026C22.4407 99.5026 20.0136 97.0755 20.0136 94.0925H20V71.0552C21.6 71.9772 23.4441 72.506 25.4237 72.506C27.3898 72.506 29.2339 71.9772 30.8339 71.0552C30.8339 77.7806 30.8339 94.0247 30.8339 94.0925Z",
                                fill: "#FFC107"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M30.8321 61.6719C30.8321 64.655 28.4049 67.0821 25.4219 67.0821C22.4253 67.0821 20.0117 64.655 20.0117 61.6719C20.0117 58.6889 22.4388 56.2618 25.4219 56.2618C28.4049 56.2482 30.8321 58.6753 30.8321 61.6719Z",
                                fill: "#FFC107"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                            id: "clip0_27259_153469",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                width: "80",
                                height: "79.1051",
                                fill: "white",
                                transform: "translate(20 20.3975)"
                            })
                        })
                    })
                ]
            })
        })
    });
}



function $7ad3099a4963f3ff$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-view home",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "col-md-5 p-3 code-view",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "iq-logo",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $367491e86d055a33$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "d-flex justify-content-center mb-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                        children: t("enter_code")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "share-code-container mb-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $131e30fdd2754bff$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        })
    });
}







function $04c53ce994145c65$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: "header",
        className: location.pathname.indexOf("witness") > -1 ? "header-dark" : "header-default",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "d-flex justify-content-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "logo-wrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    width: "152",
                    height: "18",
                    viewBox: "0 0 152 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M150.101 2.86044C146.993 2.86044 143.691 2.86044 140.362 2.86044C140.153 3.26312 139.94 3.6658 139.731 4.06848C142.536 4.0789 145.34 4.08584 148.148 4.09625C147.722 5.01617 147.361 5.79029 146.997 6.58176C144.2 6.5644 141.407 6.54705 138.61 6.52969C138.417 6.92196 138.223 7.31769 138.033 7.70996C141.331 7.72384 144.629 7.73773 147.924 7.75162C147.51 8.57433 147.095 9.39358 146.677 10.2163C141.289 10.2163 135.966 10.2163 130.483 10.2163C131.497 7.7655 132.516 5.31123 133.53 2.86044C129.419 2.86738 125.307 2.87433 121.2 2.88127C120.497 2.8778 119.98 3.05137 119.893 3.33602C119.866 3.42628 119.889 3.50265 119.9 3.53736C120.068 4.006 121.325 4.08237 121.652 4.07195C122.112 4.0546 129.711 3.81854 130.806 6.57135C131.007 7.0747 130.931 7.52945 130.897 7.67872C130.551 9.06727 128.374 10.0497 125.38 10.251C119.722 10.2545 114.064 10.258 108.402 10.2614C108.22 9.78585 108.03 9.29985 107.825 8.76873C105.655 8.76873 103.478 8.76873 101.13 8.76873C100.586 9.19224 99.9212 9.706 99.2715 10.2094C91.7175 10.2094 84.1446 10.2094 76.4311 10.2094C77.5862 7.73773 78.6957 5.35289 79.8281 2.9264C78.0232 2.9264 76.1879 2.9264 74.2728 2.9264C73.1177 5.35983 71.9663 7.7898 70.8112 10.2232C68.6909 10.2232 66.7379 10.2232 64.6404 10.2232C65.7765 7.81063 66.9127 5.39802 68.0488 2.98541C64.8 2.94375 61.5474 2.90557 58.2986 2.86391C57.2726 3.53042 56.2505 4.19692 55.2246 4.8669C60.3239 9.19571 65.4231 13.5211 70.5224 17.8499C69.3977 17.954 67.4864 17.9957 65.2598 17.3743C63.0901 16.7668 61.5626 15.7879 60.6962 15.1387C57.5348 12.5768 54.3734 10.0184 51.2158 7.45655C49.8517 8.31398 48.4078 9.22348 46.8081 10.2267C38.5094 10.2232 30.2107 10.2198 21.9082 10.2198C23.3901 6.87336 24.8682 3.52347 26.3501 0.177063C31.8522 0.17012 37.3581 0.159706 42.8601 0.152764C42.4535 1.07615 42.0888 1.90928 41.6974 2.80143C38.346 2.80143 34.9946 2.80143 31.6432 2.80143C31.4038 3.23882 31.1644 3.67621 30.9251 4.11361C33.7825 4.10667 36.6361 4.1032 39.4935 4.09625C39.0756 4.99881 38.7336 5.73821 38.3764 6.50886C35.4772 6.50886 32.6273 6.50886 29.7699 6.50886C29.6255 6.91501 29.5001 7.27604 29.3595 7.67177C34.2802 7.73079 39.2009 7.7898 44.1216 7.84881C45.6681 6.85253 47.1159 5.9222 48.4762 5.04741C46.6105 3.41586 44.8322 1.85721 42.8905 0.156235C45.3034 0.156235 47.4768 0.156235 49.7377 0.156235C50.5205 0.888696 51.383 1.69406 52.2835 2.5376C53.6021 1.72183 54.9206 0.906053 56.2391 0.09375C70.663 0.124992 82.0053 0.156235 89.5859 0.0972215C91.1628 0.0833359 97.1398 0.031265 97.782 1.944C97.9758 2.52719 97.7782 3.59637 96.9726 4.23858C96.2735 4.79747 95.3995 4.80441 95.1031 4.794C95.8479 5.1342 96.585 5.46745 97.3678 5.825C99.2601 3.97475 101.27 2.01342 103.231 0.09375C105.917 0.09375 108.501 0.09375 111.104 0.09375C111.788 2.64521 112.476 5.20015 113.16 7.75162C118.335 7.74815 122.116 7.73773 123.29 7.75162C123.59 7.75509 124.472 7.76897 124.654 7.39406C124.726 7.24479 124.662 7.08511 124.654 7.06775C124.494 6.69284 123.803 6.60606 123.495 6.57482C121.39 6.34223 119.296 6.40472 117.564 5.96385C116.914 5.79723 114.93 5.28346 114.311 3.8116C114.22 3.59637 114.018 3.0236 114.189 2.3918C114.52 1.16641 116.12 0.236077 118.168 0.131935C129.248 0.121521 140.332 0.107636 151.412 0.0972215C150.979 1.01367 150.538 1.93705 150.101 2.86044ZM83.7874 7.79327C85.4631 7.78633 87.1388 7.78286 88.8145 7.77592C89.8557 7.5468 90.4978 7.13024 90.4522 6.83864C90.4142 6.58176 89.8291 6.38736 89.1185 6.32141C87.6176 6.30752 86.1167 6.29364 84.6158 6.27628C84.3726 6.72409 84.1256 7.17884 83.7874 7.79327ZM103.789 6.19991C105.203 6.19991 106.176 6.19991 107.289 6.19991C107.065 5.32512 106.844 4.45033 106.62 3.57902C105.674 4.45033 104.732 5.32512 103.789 6.19991ZM89.9202 2.60703C88.7841 2.60703 87.7316 2.60703 86.66 2.60703C86.4207 2.98888 86.2041 3.33949 85.9267 3.7873C87.1692 3.7873 88.4155 3.78383 89.6581 3.78383C90.4218 3.74217 90.8892 3.38115 90.8702 3.12774C90.8512 2.9021 90.4522 2.67299 89.9202 2.60703Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M9.99579 5.21144C9.15225 6.97838 8.36569 8.62034 7.60194 10.2241C5.58806 10.2241 3.63498 10.2241 1.49951 10.2241C3.11061 6.86035 4.72171 3.49658 6.33662 0.132812C8.48729 0.132812 10.5506 0.132812 12.7658 0.132812C14.2059 1.82338 15.7068 3.58337 17.3369 5.4961C18.2299 3.64238 19.0582 1.92057 19.9132 0.146698C21.7257 0.146698 23.5648 0.146698 25.495 0.146698C24.0321 3.51047 22.5654 6.87076 21.1025 10.2345C18.9594 10.2345 16.8316 10.2345 14.5973 10.2345C13.0584 8.56133 11.5271 6.88465 9.99579 5.21144Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M146.093 11.5391C145.899 11.9661 145.743 12.3028 145.572 12.6812C118.894 12.6812 92.2006 12.6812 65.7124 12.6812C65.226 12.2438 64.8384 11.9001 64.4395 11.5391C91.6002 11.5391 118.784 11.5391 146.093 11.5391Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M55.0994 11.5391C55.4565 11.8654 55.8479 12.2264 56.3077 12.6465C47.1768 12.6465 38.046 12.6465 28.9152 12.6465C19.4727 12.6465 10.0303 12.6465 0.587891 12.6465C0.739881 12.2785 0.891872 11.907 1.04386 11.5391C19.0168 11.5391 37.0505 11.5391 55.0994 11.5391Z",
                            fill: "white"
                        })
                    ]
                })
            })
        })
    });
}




function $51be5972587a4482$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: "animated fadeInUp delay-3s",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "https://www.nextbase.com",
                target: "_blank",
                children: t("nextbase_website")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: "|"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "https://nextbase.co.uk/privacy-policy/",
                target: "_blank",
                children: t("privacy_policy")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: "|"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "https://www.nextbase.com/en-gb/contact-us/",
                target: "_blank",
                children: t("contact_us")
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
function $48c43979d6890df9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    function getLocalisedServiceForPath(pathName) {
        if (pathName.indexOf("witness") > -1) return t("witness_mode");
        return "Nextbase";
    }
    (0, $acw62.useEffect)(()=>{
        document.title = t("title", {
            service: getLocalisedServiceForPath(location.pathname)
        });
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04c53ce994145c65$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51be5972587a4482$export$2e2bcd8739ae039), {})
        ]
    });
}









function $ba865323121b4875$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04c53ce994145c65$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "page-view not-found",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "d-flex justify-content-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "col-md-5 p-3 code-view",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "iq-logo",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $367491e86d055a33$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "d-flex justify-content-center mb-3",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: t("not_found")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "small mt-2 text-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: t("back_to_home")
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51be5972587a4482$export$2e2bcd8739ae039), {})
        ]
    });
}




var $acw62 = parcelRequire("acw62");
var $9f39a4be534e41e6$export$cacd6541cfeeb6c1;
(function(Direction) {
    Direction[Direction["Front"] = 0] = "Front";
    Direction[Direction["Cabin"] = 1] = "Cabin";
    Direction[Direction["Rear"] = 2] = "Rear";
})($9f39a4be534e41e6$export$cacd6541cfeeb6c1 || ($9f39a4be534e41e6$export$cacd6541cfeeb6c1 = {}));
function $9f39a4be534e41e6$export$7be13381b28f0165(direction) {
    switch(direction){
        case "cabin":
            return 1;
        case "rear":
            return 2;
        default:
            return 0;
    }
}
function $9f39a4be534e41e6$export$75bba6bbd9c160c9(direction) {
    switch(direction){
        case 1:
            return "cabin";
        case 0:
            return "front";
        case 2:
            return "rear";
    }
}






var $acw62 = parcelRequire("acw62");
/**
 * @license
 * Video.js 8.6.1 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */ 
var $eDick = parcelRequire("eDick");

var $7pNCM = parcelRequire("7pNCM");

var $jZhQX = parcelRequire("jZhQX");
var $fe6c02a05a802c0a$exports = {};
$fe6c02a05a802c0a$exports = $fe6c02a05a802c0a$var$SafeParseTuple;
function $fe6c02a05a802c0a$var$SafeParseTuple(obj, reviver) {
    var json;
    var error = null;
    try {
        json = JSON.parse(obj, reviver);
    } catch (err) {
        error = err;
    }
    return [
        error,
        json
    ];
}


var $cfb0541156229cda$exports = {};
"use strict";

var $eDick = parcelRequire("eDick");

var $2bb7d1829c4e2ce1$exports = {};
$2bb7d1829c4e2ce1$exports = $2bb7d1829c4e2ce1$var$isFunction;
var $2bb7d1829c4e2ce1$var$toString = Object.prototype.toString;
function $2bb7d1829c4e2ce1$var$isFunction(fn) {
    if (!fn) return false;
    var string = $2bb7d1829c4e2ce1$var$toString.call(fn);
    return string === "[object Function]" || typeof fn === "function" && string !== "[object RegExp]" || typeof window !== "undefined" && // IE8 and below
    (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}



$cfb0541156229cda$var$createXHR.httpHandler = (parcelRequire("1WntU"));
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */ var $cfb0541156229cda$var$parseHeaders = function parseHeaders(headers) {
    var result = {};
    if (!headers) return result;
    headers.trim().split("\n").forEach(function(row) {
        var index = row.indexOf(":");
        var key = row.slice(0, index).trim().toLowerCase();
        var value = row.slice(index + 1).trim();
        if (typeof result[key] === "undefined") result[key] = value;
        else if (Array.isArray(result[key])) result[key].push(value);
        else result[key] = [
            result[key],
            value
        ];
    });
    return result;
};
$cfb0541156229cda$exports = $cfb0541156229cda$var$createXHR; // Allow use of default import syntax in TypeScript
$cfb0541156229cda$exports.default = $cfb0541156229cda$var$createXHR;
$cfb0541156229cda$var$createXHR.XMLHttpRequest = $eDick.XMLHttpRequest || $cfb0541156229cda$var$noop;
$cfb0541156229cda$var$createXHR.XDomainRequest = "withCredentials" in new $cfb0541156229cda$var$createXHR.XMLHttpRequest() ? $cfb0541156229cda$var$createXHR.XMLHttpRequest : $eDick.XDomainRequest;
$cfb0541156229cda$var$forEachArray([
    "get",
    "put",
    "post",
    "patch",
    "head",
    "delete"
], function(method) {
    $cfb0541156229cda$var$createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = $cfb0541156229cda$var$initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return $cfb0541156229cda$var$_createXHR(options);
    };
});
function $cfb0541156229cda$var$forEachArray(array, iterator) {
    for(var i = 0; i < array.length; i++)iterator(array[i]);
}
function $cfb0541156229cda$var$isEmpty(obj) {
    for(var i in obj){
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}
function $cfb0541156229cda$var$initParams(uri, options, callback) {
    var params = uri;
    if ($2bb7d1829c4e2ce1$exports(options)) {
        callback = options;
        if (typeof uri === "string") params = {
            uri: uri
        };
    } else params = $27ab08c24269de64$exports({}, options, {
        uri: uri
    });
    params.callback = callback;
    return params;
}
function $cfb0541156229cda$var$createXHR(uri, options, callback) {
    options = $cfb0541156229cda$var$initParams(uri, options, callback);
    return $cfb0541156229cda$var$_createXHR(options);
}
function $cfb0541156229cda$var$_createXHR(options) {
    if (typeof options.callback === "undefined") throw new Error("callback argument missing");
    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };
    function readystatechange() {
        if (xhr.readyState === 4) setTimeout(loadFunc, 0);
    }
    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;
        if (xhr.response) body = xhr.response;
        else body = xhr.responseText || $cfb0541156229cda$var$getXml(xhr);
        if (isJson) try {
            body = JSON.parse(body);
        } catch (e) {}
        return body;
    }
    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        evt.statusCode = 0;
        return callback(evt, failureResponse);
    } // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) //IE8 CORS GET successful response doesn't have a status field, but body is fine
        status = 200;
        else status = xhr.status === 1223 ? 204 : xhr.status;
        var response = failureResponse;
        var err = null;
        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) //remember xhr can in fact be XDR for CORS in IE
            response.headers = $cfb0541156229cda$var$parseHeaders(xhr.getAllResponseHeaders());
        } else err = new Error("Internal XMLHttpRequest Error");
        return callback(err, response, response.body);
    }
    var xhr = options.xhr || null;
    if (!xhr) {
        if (options.cors || options.useXDR) xhr = new $cfb0541156229cda$var$createXHR.XDomainRequest();
        else xhr = new $cfb0541156229cda$var$createXHR.XMLHttpRequest();
    }
    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };
    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }
    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function() {};
    xhr.onabort = function() {
        aborted = true;
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password); //has to be after open
    if (!sync) xhr.withCredentials = !!options.withCredentials;
     // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) timeoutTimer = setTimeout(function() {
        if (aborted) return;
        aborted = true; //IE9 may still call readystatechange
        xhr.abort("timeout");
        var e = new Error("XMLHttpRequest timeout");
        e.code = "ETIMEDOUT";
        errorFunc(e);
    }, options.timeout);
    if (xhr.setRequestHeader) {
        for(key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    } else if (options.headers && !$cfb0541156229cda$var$isEmpty(options.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
    if ("responseType" in options) xhr.responseType = options.responseType;
    if ("beforeSend" in options && typeof options.beforeSend === "function") options.beforeSend(xhr);
     // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);
    return xhr;
}
function $cfb0541156229cda$var$getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") return xhr.responseXML;
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) return xhr.responseXML;
    } catch (e) {}
    return null;
}
function $cfb0541156229cda$var$noop() {}


var $75606c86739c45ca$exports = {};
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Default exports for Node. Export the extended versions of VTTCue and
// VTTRegion in Node since we likely want the capability to convert back and
// forth between JSON. If we don't then it's not that big of a deal since we're
// off browser.

var $eDick = parcelRequire("eDick");



var $75606c86739c45ca$var$vttjs = $75606c86739c45ca$exports = {
    WebVTT: (parcelRequire("65ElS")),
    VTTCue: (parcelRequire("aWh86")),
    VTTRegion: (parcelRequire("f8lRN"))
};
$eDick.vttjs = $75606c86739c45ca$var$vttjs;
$eDick.WebVTT = $75606c86739c45ca$var$vttjs.WebVTT;
var $75606c86739c45ca$var$cueShim = $75606c86739c45ca$var$vttjs.VTTCue;
var $75606c86739c45ca$var$regionShim = $75606c86739c45ca$var$vttjs.VTTRegion;
var $75606c86739c45ca$var$nativeVTTCue = $eDick.VTTCue;
var $75606c86739c45ca$var$nativeVTTRegion = $eDick.VTTRegion;
$75606c86739c45ca$var$vttjs.shim = function() {
    $eDick.VTTCue = $75606c86739c45ca$var$cueShim;
    $eDick.VTTRegion = $75606c86739c45ca$var$regionShim;
};
$75606c86739c45ca$var$vttjs.restore = function() {
    $eDick.VTTCue = $75606c86739c45ca$var$nativeVTTCue;
    $eDick.VTTRegion = $75606c86739c45ca$var$nativeVTTRegion;
};
if (!$eDick.VTTCue) $75606c86739c45ca$var$vttjs.shim();


var $b06999a781b3e073$exports = {};
// see https://tools.ietf.org/html/rfc1808
(function(root) {
    var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
    var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
    var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
    var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
    var URLToolkit = {
        // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
        // E.g
        // With opts.alwaysNormalize = false (default, spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
        // With opts.alwaysNormalize = true (not spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
        buildAbsoluteURL: function(baseURL, relativeURL, opts) {
            opts = opts || {};
            // remove any remaining space and CRLF
            baseURL = baseURL.trim();
            relativeURL = relativeURL.trim();
            if (!relativeURL) {
                // 2a) If the embedded URL is entirely empty, it inherits the
                // entire base URL (i.e., is set equal to the base URL)
                // and we are done.
                if (!opts.alwaysNormalize) return baseURL;
                var basePartsForNormalise = URLToolkit.parseURL(baseURL);
                if (!basePartsForNormalise) throw new Error("Error trying to parse base URL.");
                basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
                return URLToolkit.buildURLFromParts(basePartsForNormalise);
            }
            var relativeParts = URLToolkit.parseURL(relativeURL);
            if (!relativeParts) throw new Error("Error trying to parse relative URL.");
            if (relativeParts.scheme) {
                // 2b) If the embedded URL starts with a scheme name, it is
                // interpreted as an absolute URL and we are done.
                if (!opts.alwaysNormalize) return relativeURL;
                relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
                return URLToolkit.buildURLFromParts(relativeParts);
            }
            var baseParts = URLToolkit.parseURL(baseURL);
            if (!baseParts) throw new Error("Error trying to parse base URL.");
            if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== "/") {
                // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
                // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
                var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
                baseParts.netLoc = pathParts[1];
                baseParts.path = pathParts[2];
            }
            if (baseParts.netLoc && !baseParts.path) baseParts.path = "/";
            var builtParts = {
                // 2c) Otherwise, the embedded URL inherits the scheme of
                // the base URL.
                scheme: baseParts.scheme,
                netLoc: relativeParts.netLoc,
                path: null,
                params: relativeParts.params,
                query: relativeParts.query,
                fragment: relativeParts.fragment
            };
            if (!relativeParts.netLoc) {
                // 3) If the embedded URL's <net_loc> is non-empty, we skip to
                // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
                // (if any) of the base URL.
                builtParts.netLoc = baseParts.netLoc;
                // 4) If the embedded URL path is preceded by a slash "/", the
                // path is not relative and we skip to Step 7.
                if (relativeParts.path[0] !== "/") {
                    if (!relativeParts.path) {
                        // 5) If the embedded URL path is empty (and not preceded by a
                        // slash), then the embedded URL inherits the base URL path
                        builtParts.path = baseParts.path;
                        // 5a) if the embedded URL's <params> is non-empty, we skip to
                        // step 7; otherwise, it inherits the <params> of the base
                        // URL (if any) and
                        if (!relativeParts.params) {
                            builtParts.params = baseParts.params;
                            // 5b) if the embedded URL's <query> is non-empty, we skip to
                            // step 7; otherwise, it inherits the <query> of the base
                            // URL (if any) and we skip to step 7.
                            if (!relativeParts.query) builtParts.query = baseParts.query;
                        }
                    } else {
                        // 6) The last segment of the base URL's path (anything
                        // following the rightmost slash "/", or the entire path if no
                        // slash is present) is removed and the embedded URL's path is
                        // appended in its place.
                        var baseURLPath = baseParts.path;
                        var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf("/") + 1) + relativeParts.path;
                        builtParts.path = URLToolkit.normalizePath(newPath);
                    }
                }
            }
            if (builtParts.path === null) builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
            return URLToolkit.buildURLFromParts(builtParts);
        },
        parseURL: function(url) {
            var parts = URL_REGEX.exec(url);
            if (!parts) return null;
            return {
                scheme: parts[1] || "",
                netLoc: parts[2] || "",
                path: parts[3] || "",
                params: parts[4] || "",
                query: parts[5] || "",
                fragment: parts[6] || ""
            };
        },
        normalizePath: function(path) {
            // The following operations are
            // then applied, in order, to the new path:
            // 6a) All occurrences of "./", where "." is a complete path
            // segment, are removed.
            // 6b) If the path ends with "." as a complete path segment,
            // that "." is removed.
            path = path.split("").reverse().join("").replace(SLASH_DOT_REGEX, "");
            // 6c) All occurrences of "<segment>/../", where <segment> is a
            // complete path segment not equal to "..", are removed.
            // Removal of these path segments is performed iteratively,
            // removing the leftmost matching pattern on each iteration,
            // until no matching pattern remains.
            // 6d) If the path ends with "<segment>/..", where <segment> is a
            // complete path segment not equal to "..", that
            // "<segment>/.." is removed.
            while(path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, "")).length);
            return path.split("").reverse().join("");
        },
        buildURLFromParts: function(parts) {
            return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
        }
    };
    $b06999a781b3e073$exports = URLToolkit;
})($b06999a781b3e073$exports);



var $eDick = parcelRequire("eDick");
var $42da3e152bb58681$var$DEFAULT_LOCATION = "http://example.com";
var $42da3e152bb58681$var$resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
    // return early if we don't need to resolve
    if (/^[a-z]+:/i.test(relativeUrl)) return relativeUrl;
     // if baseUrl is a data URI, ignore it and resolve everything relative to window.location
    if (/^data:/.test(baseUrl)) baseUrl = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href || "";
     // IE11 supports URL but not the URL constructor
    // feature detect the behavior we want
    var nativeURL = typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL === "function";
    var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
    // and if baseUrl isn't an absolute url
    var removeLocation = !(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location
    if (nativeURL) baseUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(baseUrl, (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location || $42da3e152bb58681$var$DEFAULT_LOCATION);
    else if (!/\/\//i.test(baseUrl)) baseUrl = (0, (/*@__PURE__*/$parcel$interopDefault($b06999a781b3e073$exports))).buildAbsoluteURL((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href || "", baseUrl);
    if (nativeURL) {
        var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
        // and if we're location-less, remove the location
        // otherwise, return the url unmodified
        if (removeLocation) return newUrl.href.slice($42da3e152bb58681$var$DEFAULT_LOCATION.length);
        else if (protocolLess) return newUrl.href.slice(newUrl.protocol.length);
        return newUrl.href;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($b06999a781b3e073$exports))).buildAbsoluteURL(baseUrl, relativeUrl);
};
var $42da3e152bb58681$export$2e2bcd8739ae039 = $42da3e152bb58681$var$resolveUrl;



/*! @name m3u8-parser @version 6.2.0 @license Apache-2.0 */ /**
 * @file stream.js
 */ /**
 * A lightweight readable stream implemention that handles event dispatching.
 *
 * @class Stream
 */ var $69db79c511710385$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Stream() {
        this.listeners = {};
    }
    /**
   * Add a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener the callback to be invoked when an event of
   * the specified type occurs
   */ var _proto = Stream.prototype;
    _proto.on = function on(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        this.listeners[type].push(listener);
    } /**
   * Remove a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener  a function previously registered for this
   * type of event through `on`
   * @return {boolean} if we could turn it off or not
   */ ;
    _proto.off = function off(type, listener) {
        if (!this.listeners[type]) return false;
        var index = this.listeners[type].indexOf(listener); // TODO: which is better?
        // In Video.js we slice listener functions
        // on trigger so that it does not mess up the order
        // while we loop through.
        //
        // Here we slice on off so that the loop in trigger
        // can continue using it's old reference to loop without
        // messing up the order.
        this.listeners[type] = this.listeners[type].slice(0);
        this.listeners[type].splice(index, 1);
        return index > -1;
    } /**
   * Trigger an event of the specified type on this stream. Any additional
   * arguments to this function are passed as parameters to event listeners.
   *
   * @param {string} type the event name
   */ ;
    _proto.trigger = function trigger(type) {
        var callbacks = this.listeners[type];
        if (!callbacks) return;
         // Slicing the arguments on every invocation of this method
        // can add a significant amount of overhead. Avoid the
        // intermediate object creation for the common case of a
        // single callback argument
        if (arguments.length === 2) {
            var length = callbacks.length;
            for(var i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
        } else {
            var args = Array.prototype.slice.call(arguments, 1);
            var _length = callbacks.length;
            for(var _i = 0; _i < _length; ++_i)callbacks[_i].apply(this, args);
        }
    } /**
   * Destroys the stream and cleans up.
   */ ;
    _proto.dispose = function dispose() {
        this.listeners = {};
    } /**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   *
   * @param {Stream} destination the stream that will receive all `data` events
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */ ;
    _proto.pipe = function pipe(destination) {
        this.on("data", function(data) {
            destination.push(data);
        });
    };
    return Stream;
}();




var $eDick = parcelRequire("eDick");

var $0beeee2e4c945ccf$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $0beeee2e4c945ccf$var$atob = function atob(s) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob(s) : $0beeee2e4c945ccf$require$Buffer.from(s, "base64").toString("binary");
};
function $0beeee2e4c945ccf$export$2e2bcd8739ae039(b64Text) {
    var decodedString = $0beeee2e4c945ccf$var$atob(b64Text);
    var array = new Uint8Array(decodedString.length);
    for(var i = 0; i < decodedString.length; i++)array[i] = decodedString.charCodeAt(i);
    return array;
}


/**
 * @file m3u8/line-stream.js
 */ /**
 * A stream that buffers string input and generates a `data` event for each
 * line.
 *
 * @class LineStream
 * @extends Stream
 */ class $17dbf2814389b162$export$307ab5c52b11c33e extends (0, $69db79c511710385$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buffer = "";
    }
    /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */ push(data) {
        let nextNewline;
        this.buffer += data;
        nextNewline = this.buffer.indexOf("\n");
        for(; nextNewline > -1; nextNewline = this.buffer.indexOf("\n")){
            this.trigger("data", this.buffer.substring(0, nextNewline));
            this.buffer = this.buffer.substring(nextNewline + 1);
        }
    }
}
const $17dbf2814389b162$var$TAB = String.fromCharCode(0x09);
const $17dbf2814389b162$var$parseByterange = function(byterangeString) {
    // optionally match and capture 0+ digits before `@`
    // optionally match and capture 0+ digits after `@`
    const match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || "");
    const result = {};
    if (match[1]) result.length = parseInt(match[1], 10);
    if (match[2]) result.offset = parseInt(match[2], 10);
    return result;
};
/**
 * "forgiving" attribute list psuedo-grammar:
 * attributes -> keyvalue (',' keyvalue)*
 * keyvalue   -> key '=' value
 * key        -> [^=]*
 * value      -> '"' [^"]* '"' | [^,]*
 */ const $17dbf2814389b162$var$attributeSeparator = function() {
    const key = "[^=]*";
    const value = '"[^"]*"|[^,]*';
    const keyvalue = "(?:" + key + ")=(?:" + value + ")";
    return new RegExp("(?:^|,)(" + keyvalue + ")");
};
/**
 * Parse attributes from a line given the separator
 *
 * @param {string} attributes the attribute line to parse
 */ const $17dbf2814389b162$var$parseAttributes = function(attributes) {
    const result = {};
    if (!attributes) return result;
     // split the string using attributes as the separator
    const attrs = attributes.split($17dbf2814389b162$var$attributeSeparator());
    let i = attrs.length;
    let attr;
    while(i--){
        // filter out unmatched portions of the string
        if (attrs[i] === "") continue;
         // split the key and value
        attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value
        attr[0] = attr[0].replace(/^\s+|\s+$/g, "");
        attr[1] = attr[1].replace(/^\s+|\s+$/g, "");
        attr[1] = attr[1].replace(/^['"](.*)['"]$/g, "$1");
        result[attr[0]] = attr[1];
    }
    return result;
};
/**
 * A line-level M3U8 parser event stream. It expects to receive input one
 * line at a time and performs a context-free parse of its contents. A stream
 * interpretation of a manifest can be useful if the manifest is expected to
 * be too large to fit comfortably into memory or the entirety of the input
 * is not immediately available. Otherwise, it's probably much easier to work
 * with a regular `Parser` object.
 *
 * Produces `data` events with an object that captures the parser's
 * interpretation of the input. That object has a property `tag` that is one
 * of `uri`, `comment`, or `tag`. URIs only have a single additional
 * property, `line`, which captures the entirety of the input without
 * interpretation. Comments similarly have a single additional property
 * `text` which is the input without the leading `#`.
 *
 * Tags always have a property `tagType` which is the lower-cased version of
 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
 * tags are given the tag type `unknown` and a single additional property
 * `data` with the remainder of the input.
 *
 * @class ParseStream
 * @extends Stream
 */ class $17dbf2814389b162$export$bc65cb5a6d9da573 extends (0, $69db79c511710385$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.customParsers = [];
        this.tagMappers = [];
    }
    /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */ push(line) {
        let match;
        let event; // strip whitespace
        line = line.trim();
        if (line.length === 0) // ignore empty lines
        return;
         // URIs
        if (line[0] !== "#") {
            this.trigger("data", {
                type: "uri",
                uri: line
            });
            return;
        } // map tags
        const newLines = this.tagMappers.reduce((acc, mapper)=>{
            const mappedLine = mapper(line); // skip if unchanged
            if (mappedLine === line) return acc;
            return acc.concat([
                mappedLine
            ]);
        }, [
            line
        ]);
        newLines.forEach((newLine)=>{
            for(let i = 0; i < this.customParsers.length; i++){
                if (this.customParsers[i].call(this, newLine)) return;
            } // Comments
            if (newLine.indexOf("#EXT") !== 0) {
                this.trigger("data", {
                    type: "comment",
                    text: newLine.slice(1)
                });
                return;
            } // strip off any carriage returns here so the regex matching
            // doesn't have to account for them.
            newLine = newLine.replace("\r", ""); // Tags
            match = /^#EXTM3U/.exec(newLine);
            if (match) {
                this.trigger("data", {
                    type: "tag",
                    tagType: "m3u"
                });
                return;
            }
            match = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "inf"
                };
                if (match[1]) event.duration = parseFloat(match[1]);
                if (match[2]) event.title = match[2];
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "targetduration"
                };
                if (match[1]) event.duration = parseInt(match[1], 10);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-VERSION:([0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "version"
                };
                if (match[1]) event.version = parseInt(match[1], 10);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "media-sequence"
                };
                if (match[1]) event.number = parseInt(match[1], 10);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "discontinuity-sequence"
                };
                if (match[1]) event.number = parseInt(match[1], 10);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "playlist-type"
                };
                if (match[1]) event.playlistType = match[1];
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-BYTERANGE:(.*)?$/.exec(newLine);
            if (match) {
                event = (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))($17dbf2814389b162$var$parseByterange(match[1]), {
                    type: "tag",
                    tagType: "byterange"
                });
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "allow-cache"
                };
                if (match[1]) event.allowed = !/NO/.test(match[1]);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-MAP:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "map"
                };
                if (match[1]) {
                    const attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                    if (attributes.URI) event.uri = attributes.URI;
                    if (attributes.BYTERANGE) event.byterange = $17dbf2814389b162$var$parseByterange(attributes.BYTERANGE);
                }
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-STREAM-INF:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "stream-inf"
                };
                if (match[1]) {
                    event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                    if (event.attributes.RESOLUTION) {
                        const split = event.attributes.RESOLUTION.split("x");
                        const resolution = {};
                        if (split[0]) resolution.width = parseInt(split[0], 10);
                        if (split[1]) resolution.height = parseInt(split[1], 10);
                        event.attributes.RESOLUTION = resolution;
                    }
                    if (event.attributes.BANDWIDTH) event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
                    if (event.attributes["FRAME-RATE"]) event.attributes["FRAME-RATE"] = parseFloat(event.attributes["FRAME-RATE"]);
                    if (event.attributes["PROGRAM-ID"]) event.attributes["PROGRAM-ID"] = parseInt(event.attributes["PROGRAM-ID"], 10);
                }
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-MEDIA:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "media"
                };
                if (match[1]) event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-ENDLIST/.exec(newLine);
            if (match) {
                this.trigger("data", {
                    type: "tag",
                    tagType: "endlist"
                });
                return;
            }
            match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
            if (match) {
                this.trigger("data", {
                    type: "tag",
                    tagType: "discontinuity"
                });
                return;
            }
            match = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "program-date-time"
                };
                if (match[1]) {
                    event.dateTimeString = match[1];
                    event.dateTimeObject = new Date(match[1]);
                }
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-KEY:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "key"
                };
                if (match[1]) {
                    event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]); // parse the IV string into a Uint32Array
                    if (event.attributes.IV) {
                        if (event.attributes.IV.substring(0, 2).toLowerCase() === "0x") event.attributes.IV = event.attributes.IV.substring(2);
                        event.attributes.IV = event.attributes.IV.match(/.{8}/g);
                        event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
                        event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
                        event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
                        event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
                        event.attributes.IV = new Uint32Array(event.attributes.IV);
                    }
                }
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-START:(.*)$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "start"
                };
                if (match[1]) {
                    event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                    event.attributes["TIME-OFFSET"] = parseFloat(event.attributes["TIME-OFFSET"]);
                    event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
                }
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "cue-out-cont"
                };
                if (match[1]) event.data = match[1];
                else event.data = "";
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-CUE-OUT:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "cue-out"
                };
                if (match[1]) event.data = match[1];
                else event.data = "";
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-CUE-IN:(.*)?$/.exec(newLine);
            if (match) {
                event = {
                    type: "tag",
                    tagType: "cue-in"
                };
                if (match[1]) event.data = match[1];
                else event.data = "";
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: "tag",
                    tagType: "skip"
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                if (event.attributes.hasOwnProperty("SKIPPED-SEGMENTS")) event.attributes["SKIPPED-SEGMENTS"] = parseInt(event.attributes["SKIPPED-SEGMENTS"], 10);
                if (event.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES")) event.attributes["RECENTLY-REMOVED-DATERANGES"] = event.attributes["RECENTLY-REMOVED-DATERANGES"].split($17dbf2814389b162$var$TAB);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-PART:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: "tag",
                    tagType: "part"
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    "DURATION"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    "INDEPENDENT",
                    "GAP"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/.test(event.attributes[key]);
                });
                if (event.attributes.hasOwnProperty("BYTERANGE")) event.attributes.byterange = $17dbf2814389b162$var$parseByterange(event.attributes.BYTERANGE);
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: "tag",
                    tagType: "server-control"
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    "CAN-SKIP-UNTIL",
                    "PART-HOLD-BACK",
                    "HOLD-BACK"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    "CAN-SKIP-DATERANGES",
                    "CAN-BLOCK-RELOAD"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/.test(event.attributes[key]);
                });
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: "tag",
                    tagType: "part-inf"
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    "PART-TARGET"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: "tag",
                    tagType: "preload-hint"
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    "BYTERANGE-START",
                    "BYTERANGE-LENGTH"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) {
                        event.attributes[key] = parseInt(event.attributes[key], 10);
                        const subkey = key === "BYTERANGE-LENGTH" ? "length" : "offset";
                        event.attributes.byterange = event.attributes.byterange || {};
                        event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.
                        delete event.attributes[key];
                    }
                });
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: "tag",
                    tagType: "rendition-report"
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    "LAST-MSN",
                    "LAST-PART"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseInt(event.attributes[key], 10);
                });
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-DATERANGE:(.*)$/.exec(newLine);
            if (match && match[1]) {
                event = {
                    type: "tag",
                    tagType: "daterange"
                };
                event.attributes = $17dbf2814389b162$var$parseAttributes(match[1]);
                [
                    "ID",
                    "CLASS"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = String(event.attributes[key]);
                });
                [
                    "START-DATE",
                    "END-DATE"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = new Date(event.attributes[key]);
                });
                [
                    "DURATION",
                    "PLANNED-DURATION"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = parseFloat(event.attributes[key]);
                });
                [
                    "END-ON-NEXT"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = /YES/i.test(event.attributes[key]);
                });
                [
                    "SCTE35-CMD",
                    " SCTE35-OUT",
                    "SCTE35-IN"
                ].forEach(function(key) {
                    if (event.attributes.hasOwnProperty(key)) event.attributes[key] = event.attributes[key].toString(16);
                });
                const clientAttributePattern = /^X-([A-Z]+-)+[A-Z]+$/;
                for(const key in event.attributes){
                    if (!clientAttributePattern.test(key)) continue;
                    const isHexaDecimal = /[0-9A-Fa-f]{6}/g.test(event.attributes[key]);
                    const isDecimalFloating = /^\d+(\.\d+)?$/.test(event.attributes[key]);
                    event.attributes[key] = isHexaDecimal ? event.attributes[key].toString(16) : isDecimalFloating ? parseFloat(event.attributes[key]) : String(event.attributes[key]);
                }
                this.trigger("data", event);
                return;
            }
            match = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(newLine);
            if (match) {
                this.trigger("data", {
                    type: "tag",
                    tagType: "independent-segments"
                });
                return;
            } // unknown tag type
            this.trigger("data", {
                type: "tag",
                data: newLine.slice(4)
            });
        });
    }
    /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */ addParser({ expression: expression, customType: customType, dataParser: dataParser, segment: segment }) {
        if (typeof dataParser !== "function") dataParser = (line)=>line;
        this.customParsers.push((line)=>{
            const match = expression.exec(line);
            if (match) {
                this.trigger("data", {
                    type: "custom",
                    data: dataParser(line),
                    customType: customType,
                    segment: segment
                });
                return true;
            }
        });
    }
    /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */ addTagMapper({ expression: expression, map: map }) {
        const mapFn = (line)=>{
            if (expression.test(line)) return map(line);
            return line;
        };
        this.tagMappers.push(mapFn);
    }
}
const $17dbf2814389b162$var$camelCase = (str)=>str.toLowerCase().replace(/-(\w)/g, (a)=>a[1].toUpperCase());
const $17dbf2814389b162$var$camelCaseKeys = function(attributes) {
    const result = {};
    Object.keys(attributes).forEach(function(key) {
        result[$17dbf2814389b162$var$camelCase(key)] = attributes[key];
    });
    return result;
}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
// we need this helper because defaults are based upon targetDuration and
// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
// target durations are set.
const $17dbf2814389b162$var$setHoldBack = function(manifest) {
    const { serverControl: serverControl, targetDuration: targetDuration, partTargetDuration: partTargetDuration } = manifest;
    if (!serverControl) return;
    const tag = "#EXT-X-SERVER-CONTROL";
    const hb = "holdBack";
    const phb = "partHoldBack";
    const minTargetDuration = targetDuration && targetDuration * 3;
    const minPartDuration = partTargetDuration && partTargetDuration * 2;
    if (targetDuration && !serverControl.hasOwnProperty(hb)) {
        serverControl[hb] = minTargetDuration;
        this.trigger("info", {
            message: `${tag} defaulting HOLD-BACK to targetDuration * 3 (${minTargetDuration}).`
        });
    }
    if (minTargetDuration && serverControl[hb] < minTargetDuration) {
        this.trigger("warn", {
            message: `${tag} clamping HOLD-BACK (${serverControl[hb]}) to targetDuration * 3 (${minTargetDuration})`
        });
        serverControl[hb] = minTargetDuration;
    } // default no part hold back to part target duration * 3
    if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
        serverControl[phb] = partTargetDuration * 3;
        this.trigger("info", {
            message: `${tag} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${serverControl[phb]}).`
        });
    } // if part hold back is too small default it to part target duration * 2
    if (partTargetDuration && serverControl[phb] < minPartDuration) {
        this.trigger("warn", {
            message: `${tag} clamping PART-HOLD-BACK (${serverControl[phb]}) to partTargetDuration * 2 (${minPartDuration}).`
        });
        serverControl[phb] = minPartDuration;
    }
};
/**
 * A parser for M3U8 files. The current interpretation of the input is
 * exposed as a property `manifest` on parser objects. It's just two lines to
 * create and parse a manifest once you have the contents available as a string:
 *
 * ```js
 * var parser = new m3u8.Parser();
 * parser.push(xhr.responseText);
 * ```
 *
 * New input can later be applied to update the manifest object by calling
 * `push` again.
 *
 * The parser attempts to create a usable manifest object even if the
 * underlying input is somewhat nonsensical. It emits `info` and `warning`
 * events during the parse if it encounters input that seems invalid or
 * requires some property of the manifest object to be defaulted.
 *
 * @class Parser
 * @extends Stream
 */ class $17dbf2814389b162$export$7acfa6ed01010e37 extends (0, $69db79c511710385$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.lineStream = new $17dbf2814389b162$export$307ab5c52b11c33e();
        this.parseStream = new $17dbf2814389b162$export$bc65cb5a6d9da573();
        this.lineStream.pipe(this.parseStream);
        /* eslint-disable consistent-this */ const self = this;
        /* eslint-enable consistent-this */ const uris = [];
        let currentUri = {}; // if specified, the active EXT-X-MAP definition
        let currentMap; // if specified, the active decryption key
        let key;
        let hasParts = false;
        const noop = function() {};
        const defaultMediaGroups = {
            "AUDIO": {},
            "VIDEO": {},
            "CLOSED-CAPTIONS": {},
            "SUBTITLES": {}
        }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
        // used in MPDs with Widevine encrypted streams.
        const widevineUuid = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"; // group segments into numbered timelines delineated by discontinuities
        let currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data
        this.manifest = {
            allowCache: true,
            discontinuityStarts: [],
            segments: []
        }; // keep track of the last seen segment's byte range end, as segments are not required
        // to provide the offset, in which case it defaults to the next byte after the
        // previous segment
        let lastByterangeEnd = 0; // keep track of the last seen part's byte range end.
        let lastPartByterangeEnd = 0;
        const daterangeTags = {};
        this.on("end", ()=>{
            // only add preloadSegment if we don't yet have a uri for it.
            // and we actually have parts/preloadHints
            if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) return;
            if (!currentUri.map && currentMap) currentUri.map = currentMap;
            if (!currentUri.key && key) currentUri.key = key;
            if (!currentUri.timeline && typeof currentTimeline === "number") currentUri.timeline = currentTimeline;
            this.manifest.preloadSegment = currentUri;
        }); // update the manifest with the m3u8 entry from the parse stream
        this.parseStream.on("data", function(entry) {
            let mediaGroup;
            let rendition;
            ({
                tag () {
                    // switch based on the tag type
                    (({
                        version () {
                            if (entry.version) this.manifest.version = entry.version;
                        },
                        "allow-cache" () {
                            this.manifest.allowCache = entry.allowed;
                            if (!("allowed" in entry)) {
                                this.trigger("info", {
                                    message: "defaulting allowCache to YES"
                                });
                                this.manifest.allowCache = true;
                            }
                        },
                        byterange () {
                            const byterange = {};
                            if ("length" in entry) {
                                currentUri.byterange = byterange;
                                byterange.length = entry.length;
                                if (!("offset" in entry)) /*
                   * From the latest spec (as of this writing):
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
                   *
                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
                   *
                   * "If o [offset] is not present, the sub-range begins at the next byte
                   * following the sub-range of the previous media segment."
                   */ entry.offset = lastByterangeEnd;
                            }
                            if ("offset" in entry) {
                                currentUri.byterange = byterange;
                                byterange.offset = entry.offset;
                            }
                            lastByterangeEnd = byterange.offset + byterange.length;
                        },
                        endlist () {
                            this.manifest.endList = true;
                        },
                        inf () {
                            if (!("mediaSequence" in this.manifest)) {
                                this.manifest.mediaSequence = 0;
                                this.trigger("info", {
                                    message: "defaulting media sequence to zero"
                                });
                            }
                            if (!("discontinuitySequence" in this.manifest)) {
                                this.manifest.discontinuitySequence = 0;
                                this.trigger("info", {
                                    message: "defaulting discontinuity sequence to zero"
                                });
                            }
                            if (entry.duration > 0) currentUri.duration = entry.duration;
                            if (entry.duration === 0) {
                                currentUri.duration = 0.01;
                                this.trigger("info", {
                                    message: "updating zero segment duration to a small value"
                                });
                            }
                            this.manifest.segments = uris;
                        },
                        key () {
                            if (!entry.attributes) {
                                this.trigger("warn", {
                                    message: "ignoring key declaration without attribute list"
                                });
                                return;
                            } // clear the active encryption key
                            if (entry.attributes.METHOD === "NONE") {
                                key = null;
                                return;
                            }
                            if (!entry.attributes.URI) {
                                this.trigger("warn", {
                                    message: "ignoring key declaration without URI"
                                });
                                return;
                            }
                            if (entry.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
                                this.manifest.contentProtection["com.apple.fps.1_0"] = {
                                    attributes: entry.attributes
                                };
                                return;
                            }
                            if (entry.attributes.KEYFORMAT === "com.microsoft.playready") {
                                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
                                this.manifest.contentProtection["com.microsoft.playready"] = {
                                    uri: entry.attributes.URI
                                };
                                return;
                            } // check if the content is encrypted for Widevine
                            // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf
                            if (entry.attributes.KEYFORMAT === widevineUuid) {
                                const VALID_METHODS = [
                                    "SAMPLE-AES",
                                    "SAMPLE-AES-CTR",
                                    "SAMPLE-AES-CENC"
                                ];
                                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
                                    this.trigger("warn", {
                                        message: "invalid key method provided for Widevine"
                                    });
                                    return;
                                }
                                if (entry.attributes.METHOD === "SAMPLE-AES-CENC") this.trigger("warn", {
                                    message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                                });
                                if (entry.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                                    this.trigger("warn", {
                                        message: "invalid key URI provided for Widevine"
                                    });
                                    return;
                                }
                                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === "0x")) {
                                    this.trigger("warn", {
                                        message: "invalid key ID provided for Widevine"
                                    });
                                    return;
                                } // if Widevine key attributes are valid, store them as `contentProtection`
                                // on the manifest to emulate Widevine tag structure in a DASH mpd
                                this.manifest.contentProtection = this.manifest.contentProtection || {};
                                this.manifest.contentProtection["com.widevine.alpha"] = {
                                    attributes: {
                                        schemeIdUri: entry.attributes.KEYFORMAT,
                                        // remove '0x' from the key id string
                                        keyId: entry.attributes.KEYID.substring(2)
                                    },
                                    // decode the base64-encoded PSSH box
                                    pssh: (0, $0beeee2e4c945ccf$export$2e2bcd8739ae039)(entry.attributes.URI.split(",")[1])
                                };
                                return;
                            }
                            if (!entry.attributes.METHOD) this.trigger("warn", {
                                message: "defaulting key method to AES-128"
                            });
                             // setup an encryption key for upcoming segments
                            key = {
                                method: entry.attributes.METHOD || "AES-128",
                                uri: entry.attributes.URI
                            };
                            if (typeof entry.attributes.IV !== "undefined") key.iv = entry.attributes.IV;
                        },
                        "media-sequence" () {
                            if (!isFinite(entry.number)) {
                                this.trigger("warn", {
                                    message: "ignoring invalid media sequence: " + entry.number
                                });
                                return;
                            }
                            this.manifest.mediaSequence = entry.number;
                        },
                        "discontinuity-sequence" () {
                            if (!isFinite(entry.number)) {
                                this.trigger("warn", {
                                    message: "ignoring invalid discontinuity sequence: " + entry.number
                                });
                                return;
                            }
                            this.manifest.discontinuitySequence = entry.number;
                            currentTimeline = entry.number;
                        },
                        "playlist-type" () {
                            if (!/VOD|EVENT/.test(entry.playlistType)) {
                                this.trigger("warn", {
                                    message: "ignoring unknown playlist type: " + entry.playlist
                                });
                                return;
                            }
                            this.manifest.playlistType = entry.playlistType;
                        },
                        map () {
                            currentMap = {};
                            if (entry.uri) currentMap.uri = entry.uri;
                            if (entry.byterange) currentMap.byterange = entry.byterange;
                            if (key) currentMap.key = key;
                        },
                        "stream-inf" () {
                            this.manifest.playlists = uris;
                            this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
                            if (!entry.attributes) {
                                this.trigger("warn", {
                                    message: "ignoring empty stream-inf attributes"
                                });
                                return;
                            }
                            if (!currentUri.attributes) currentUri.attributes = {};
                            (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))(currentUri.attributes, entry.attributes);
                        },
                        media () {
                            this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
                            if (!(entry.attributes && entry.attributes.TYPE && entry.attributes["GROUP-ID"] && entry.attributes.NAME)) {
                                this.trigger("warn", {
                                    message: "ignoring incomplete or missing media group"
                                });
                                return;
                            } // find the media group, creating defaults as necessary
                            const mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
                            mediaGroupType[entry.attributes["GROUP-ID"]] = mediaGroupType[entry.attributes["GROUP-ID"]] || {};
                            mediaGroup = mediaGroupType[entry.attributes["GROUP-ID"]]; // collect the rendition metadata
                            rendition = {
                                default: /yes/i.test(entry.attributes.DEFAULT)
                            };
                            if (rendition.default) rendition.autoselect = true;
                            else rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
                            if (entry.attributes.LANGUAGE) rendition.language = entry.attributes.LANGUAGE;
                            if (entry.attributes.URI) rendition.uri = entry.attributes.URI;
                            if (entry.attributes["INSTREAM-ID"]) rendition.instreamId = entry.attributes["INSTREAM-ID"];
                            if (entry.attributes.CHARACTERISTICS) rendition.characteristics = entry.attributes.CHARACTERISTICS;
                            if (entry.attributes.FORCED) rendition.forced = /yes/i.test(entry.attributes.FORCED);
                             // insert the new rendition
                            mediaGroup[entry.attributes.NAME] = rendition;
                        },
                        discontinuity () {
                            currentTimeline += 1;
                            currentUri.discontinuity = true;
                            this.manifest.discontinuityStarts.push(uris.length);
                        },
                        "program-date-time" () {
                            if (typeof this.manifest.dateTimeString === "undefined") {
                                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
                                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
                                // to the manifest object
                                // TODO: Consider removing this in future major version
                                this.manifest.dateTimeString = entry.dateTimeString;
                                this.manifest.dateTimeObject = entry.dateTimeObject;
                            }
                            currentUri.dateTimeString = entry.dateTimeString;
                            currentUri.dateTimeObject = entry.dateTimeObject;
                        },
                        targetduration () {
                            if (!isFinite(entry.duration) || entry.duration < 0) {
                                this.trigger("warn", {
                                    message: "ignoring invalid target duration: " + entry.duration
                                });
                                return;
                            }
                            this.manifest.targetDuration = entry.duration;
                            $17dbf2814389b162$var$setHoldBack.call(this, this.manifest);
                        },
                        start () {
                            if (!entry.attributes || isNaN(entry.attributes["TIME-OFFSET"])) {
                                this.trigger("warn", {
                                    message: "ignoring start declaration without appropriate attribute list"
                                });
                                return;
                            }
                            this.manifest.start = {
                                timeOffset: entry.attributes["TIME-OFFSET"],
                                precise: entry.attributes.PRECISE
                            };
                        },
                        "cue-out" () {
                            currentUri.cueOut = entry.data;
                        },
                        "cue-out-cont" () {
                            currentUri.cueOutCont = entry.data;
                        },
                        "cue-in" () {
                            currentUri.cueIn = entry.data;
                        },
                        "skip" () {
                            this.manifest.skip = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_("#EXT-X-SKIP", entry.attributes, [
                                "SKIPPED-SEGMENTS"
                            ]);
                        },
                        "part" () {
                            hasParts = true; // parts are always specifed before a segment
                            const segmentIndex = this.manifest.segments.length;
                            const part = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            currentUri.parts = currentUri.parts || [];
                            currentUri.parts.push(part);
                            if (part.byterange) {
                                if (!part.byterange.hasOwnProperty("offset")) part.byterange.offset = lastPartByterangeEnd;
                                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
                            }
                            const partIndex = currentUri.parts.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-PART #${partIndex} for segment #${segmentIndex}`, entry.attributes, [
                                "URI",
                                "DURATION"
                            ]);
                            if (this.manifest.renditionReports) this.manifest.renditionReports.forEach((r, i)=>{
                                if (!r.hasOwnProperty("lastPart")) this.trigger("warn", {
                                    message: `#EXT-X-RENDITION-REPORT #${i} lacks required attribute(s): LAST-PART`
                                });
                            });
                        },
                        "server-control" () {
                            const attrs = this.manifest.serverControl = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            if (!attrs.hasOwnProperty("canBlockReload")) {
                                attrs.canBlockReload = false;
                                this.trigger("info", {
                                    message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
                                });
                            }
                            $17dbf2814389b162$var$setHoldBack.call(this, this.manifest);
                            if (attrs.canSkipDateranges && !attrs.hasOwnProperty("canSkipUntil")) this.trigger("warn", {
                                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
                            });
                        },
                        "preload-hint" () {
                            // parts are always specifed before a segment
                            const segmentIndex = this.manifest.segments.length;
                            const hint = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            const isPart = hint.type && hint.type === "PART";
                            currentUri.preloadHints = currentUri.preloadHints || [];
                            currentUri.preloadHints.push(hint);
                            if (hint.byterange) {
                                if (!hint.byterange.hasOwnProperty("offset")) {
                                    // use last part byterange end or zero if not a part.
                                    hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
                                    if (isPart) lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
                                }
                            }
                            const index = currentUri.preloadHints.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${index} for segment #${segmentIndex}`, entry.attributes, [
                                "TYPE",
                                "URI"
                            ]);
                            if (!hint.type) return;
                             // search through all preload hints except for the current one for
                            // a duplicate type.
                            for(let i = 0; i < currentUri.preloadHints.length - 1; i++){
                                const otherHint = currentUri.preloadHints[i];
                                if (!otherHint.type) continue;
                                if (otherHint.type === hint.type) this.trigger("warn", {
                                    message: `#EXT-X-PRELOAD-HINT #${index} for segment #${segmentIndex} has the same TYPE ${hint.type} as preload hint #${i}`
                                });
                            }
                        },
                        "rendition-report" () {
                            const report = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            this.manifest.renditionReports = this.manifest.renditionReports || [];
                            this.manifest.renditionReports.push(report);
                            const index = this.manifest.renditionReports.length - 1;
                            const required = [
                                "LAST-MSN",
                                "URI"
                            ];
                            if (hasParts) required.push("LAST-PART");
                            this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${index}`, entry.attributes, required);
                        },
                        "part-inf" () {
                            this.manifest.partInf = $17dbf2814389b162$var$camelCaseKeys(entry.attributes);
                            this.warnOnMissingAttributes_("#EXT-X-PART-INF", entry.attributes, [
                                "PART-TARGET"
                            ]);
                            if (this.manifest.partInf.partTarget) this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
                            $17dbf2814389b162$var$setHoldBack.call(this, this.manifest);
                        },
                        "daterange" () {
                            this.manifest.daterange = this.manifest.daterange || [];
                            this.manifest.daterange.push($17dbf2814389b162$var$camelCaseKeys(entry.attributes));
                            const index = this.manifest.daterange.length - 1;
                            this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${index}`, entry.attributes, [
                                "ID",
                                "START-DATE"
                            ]);
                            const daterange = this.manifest.daterange[index];
                            if (daterange.endDate && daterange.startDate && new Date(daterange.endDate) < new Date(daterange.startDate)) this.trigger("warn", {
                                message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE"
                            });
                            if (daterange.duration && daterange.duration < 0) this.trigger("warn", {
                                message: "EXT-X-DATERANGE DURATION must not be negative"
                            });
                            if (daterange.plannedDuration && daterange.plannedDuration < 0) this.trigger("warn", {
                                message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative"
                            });
                            const endOnNextYes = !!daterange.endOnNext;
                            if (endOnNextYes && !daterange.class) this.trigger("warn", {
                                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute"
                            });
                            if (endOnNextYes && (daterange.duration || daterange.endDate)) this.trigger("warn", {
                                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes"
                            });
                            if (daterange.duration && daterange.endDate) {
                                const startDate = daterange.startDate;
                                const newDateInSeconds = startDate.setSeconds(startDate.getSeconds() + daterange.duration);
                                this.manifest.daterange[index].endDate = new Date(newDateInSeconds);
                            }
                            if (daterange && !this.manifest.dateTimeString) this.trigger("warn", {
                                message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag"
                            });
                            if (!daterangeTags[daterange.id]) daterangeTags[daterange.id] = daterange;
                            else {
                                for(const attribute in daterangeTags[daterange.id])if (daterangeTags[daterange.id][attribute] !== daterange[attribute]) {
                                    this.trigger("warn", {
                                        message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes and same attribute values"
                                    });
                                    break;
                                }
                            }
                        },
                        "independent-segments" () {
                            this.manifest.independentSegments = true;
                        }
                    })[entry.tagType] || noop).call(self);
                },
                uri () {
                    currentUri.uri = entry.uri;
                    uris.push(currentUri); // if no explicit duration was declared, use the target duration
                    if (this.manifest.targetDuration && !("duration" in currentUri)) {
                        this.trigger("warn", {
                            message: "defaulting segment duration to the target duration"
                        });
                        currentUri.duration = this.manifest.targetDuration;
                    } // annotate with encryption information, if necessary
                    if (key) currentUri.key = key;
                    currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary
                    if (currentMap) currentUri.map = currentMap;
                     // reset the last byterange end as it needs to be 0 between parts
                    lastPartByterangeEnd = 0; // prepare for the next URI
                    currentUri = {};
                },
                comment () {},
                custom () {
                    // if this is segment-level data attach the output to the segment
                    if (entry.segment) {
                        currentUri.custom = currentUri.custom || {};
                        currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
                    } else {
                        this.manifest.custom = this.manifest.custom || {};
                        this.manifest.custom[entry.customType] = entry.data;
                    }
                }
            })[entry.type].call(self);
        });
    }
    warnOnMissingAttributes_(identifier, attributes, required) {
        const missing = [];
        required.forEach(function(key) {
            if (!attributes.hasOwnProperty(key)) missing.push(key);
        });
        if (missing.length) this.trigger("warn", {
            message: `${identifier} lacks required attribute(s): ${missing.join(", ")}`
        });
    }
    /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */ push(chunk) {
        this.lineStream.push(chunk);
    }
    /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */ end() {
        // flush any buffered input
        this.lineStream.push("\n");
        this.trigger("end");
    }
    /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.type         the type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */ addParser(options) {
        this.parseStream.addParser(options);
    }
    /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */ addTagMapper(options) {
        this.parseStream.addTagMapper(options);
    }
}



var $eDick = parcelRequire("eDick");
var $e324d09415701181$var$regexs = {
    // to determine mime types
    mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
    webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
    ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
    // to determine if a codec is audio or video
    video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
    audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
    text: /^(stpp.ttml.im1t)/,
    // mux.js support regex
    muxerVideo: /^(avc0?1)/,
    muxerAudio: /^(mp4a)/,
    // match nothing as muxer does not support text right now.
    // there cannot never be a character before the start of a string
    // so this matches nothing.
    muxerText: /a^/
};
var $e324d09415701181$var$mediaTypes = [
    "video",
    "audio",
    "text"
];
var $e324d09415701181$var$upperMediaTypes = [
    "Video",
    "Audio",
    "Text"
];
var $e324d09415701181$export$4e61c3c458a5b005 = function translateLegacyCodec(codec) {
    if (!codec) return codec;
    return codec.replace(/avc1\.(\d+)\.(\d+)/i, function(orig, profile, avcLevel) {
        var profileHex = ("00" + Number(profile).toString(16)).slice(-2);
        var avcLevelHex = ("00" + Number(avcLevel).toString(16)).slice(-2);
        return "avc1." + profileHex + "00" + avcLevelHex;
    });
};
var $e324d09415701181$export$2fa1fd5760053cdc = function translateLegacyCodecs(codecs) {
    return codecs.map($e324d09415701181$export$4e61c3c458a5b005);
};
var $e324d09415701181$export$ff37541a73872ef0 = function mapLegacyAvcCodecs(codecString) {
    return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function(match) {
        return $e324d09415701181$export$2fa1fd5760053cdc([
            match
        ])[0];
    });
};
var $e324d09415701181$export$56679b562aa2891c = function parseCodecs(codecString) {
    if (codecString === void 0) codecString = "";
    var codecs = codecString.split(",");
    var result = [];
    codecs.forEach(function(codec) {
        codec = codec.trim();
        var codecType;
        $e324d09415701181$var$mediaTypes.forEach(function(name) {
            var match = $e324d09415701181$var$regexs[name].exec(codec.toLowerCase());
            if (!match || match.length <= 1) return;
            codecType = name; // maintain codec case
            var type = codec.substring(0, match[1].length);
            var details = codec.replace(type, "");
            result.push({
                type: type,
                details: details,
                mediaType: name
            });
        });
        if (!codecType) result.push({
            type: codec,
            details: "",
            mediaType: "unknown"
        });
    });
    return result;
};
var $e324d09415701181$export$e192782a4d0b5c5c = function codecsFromDefault(master, audioGroupId) {
    if (!master.mediaGroups.AUDIO || !audioGroupId) return null;
    var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
    if (!audioGroup) return null;
    for(var name in audioGroup){
        var audioType = audioGroup[name];
        if (audioType.default && audioType.playlists) // codec should be the same for all playlists within the audio type
        return $e324d09415701181$export$56679b562aa2891c(audioType.playlists[0].attributes.CODECS);
    }
    return null;
};
var $e324d09415701181$export$601d10c6a66cb34c = function isVideoCodec(codec) {
    if (codec === void 0) codec = "";
    return $e324d09415701181$var$regexs.video.test(codec.trim().toLowerCase());
};
var $e324d09415701181$export$c642d74e895e3217 = function isAudioCodec(codec) {
    if (codec === void 0) codec = "";
    return $e324d09415701181$var$regexs.audio.test(codec.trim().toLowerCase());
};
var $e324d09415701181$export$256d4a55aa322b7e = function isTextCodec(codec) {
    if (codec === void 0) codec = "";
    return $e324d09415701181$var$regexs.text.test(codec.trim().toLowerCase());
};
var $e324d09415701181$export$4b64fc0a026b9981 = function getMimeForCodec(codecString) {
    if (!codecString || typeof codecString !== "string") return;
    var codecs = codecString.toLowerCase().split(",").map(function(c) {
        return $e324d09415701181$export$4e61c3c458a5b005(c.trim());
    }); // default to video type
    var type = "video"; // only change to audio type if the only codec we have is
    // audio
    if (codecs.length === 1 && $e324d09415701181$export$c642d74e895e3217(codecs[0])) type = "audio";
    else if (codecs.length === 1 && $e324d09415701181$export$256d4a55aa322b7e(codecs[0])) // text uses application/<container> for now
    type = "application";
     // default the container to mp4
    var container = "mp4"; // every codec must be able to go into the container
    // for that container to be the correct one
    if (codecs.every(function(c) {
        return $e324d09415701181$var$regexs.mp4.test(c);
    })) container = "mp4";
    else if (codecs.every(function(c) {
        return $e324d09415701181$var$regexs.webm.test(c);
    })) container = "webm";
    else if (codecs.every(function(c) {
        return $e324d09415701181$var$regexs.ogg.test(c);
    })) container = "ogg";
    return type + "/" + container + ';codecs="' + codecString + '"';
};
var $e324d09415701181$export$3ee949df8fbc592f = function browserSupportsCodec(codecString) {
    if (codecString === void 0) codecString = "";
    return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.isTypeSupported && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.isTypeSupported($e324d09415701181$export$4b64fc0a026b9981(codecString)) || false;
};
var $e324d09415701181$export$614fda2d02e4a9d7 = function muxerSupportsCodec(codecString) {
    if (codecString === void 0) codecString = "";
    return codecString.toLowerCase().split(",").every(function(codec) {
        codec = codec.trim(); // any match is supported.
        for(var i = 0; i < $e324d09415701181$var$upperMediaTypes.length; i++){
            var type = $e324d09415701181$var$upperMediaTypes[i];
            if ($e324d09415701181$var$regexs["muxer" + type].test(codec)) return true;
        }
        return false;
    });
};
var $e324d09415701181$export$615de1d7b49571dc = "mp4a.40.2";
var $e324d09415701181$export$77d6196664053611 = "avc1.4d400d";


var $72433138d4bc8325$var$MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
var $72433138d4bc8325$var$DASH_REGEX = /^application\/dash\+xml/i;
var $72433138d4bc8325$export$c4f0bf48244d4c05 = function simpleTypeFromSourceType(type) {
    if ($72433138d4bc8325$var$MPEGURL_REGEX.test(type)) return "hls";
    if ($72433138d4bc8325$var$DASH_REGEX.test(type)) return "dash";
     // Denotes the special case of a manifest object passed to http-streaming instead of a
    // source URL.
    //
    // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
    //
    // In this case, vnd stands for vendor, video.js for the organization, VHS for this
    // project, and the +json suffix identifies the structure of the media type.
    if (type === "application/vnd.videojs.vhs+json") return "vhs-json";
    return null;
};



var $eDick = parcelRequire("eDick");
var $4bd18e93e919945b$var$repeat = function repeat(str, len) {
    var acc = "";
    while(len--)acc += str;
    return acc;
}; // count the number of bits it would take to represent a number
var $4bd18e93e919945b$export$33de6ea056a4cdbb = function countBits(x) {
    return x.toString(2).length;
}; // count the number of whole bytes it would take to represent a number
var $4bd18e93e919945b$export$42cd407004f34122 = function countBytes(x) {
    return Math.ceil($4bd18e93e919945b$export$33de6ea056a4cdbb(x) / 8);
};
var $4bd18e93e919945b$export$36cf564d487b5178 = function padStart(b, len, str) {
    if (str === void 0) str = " ";
    return ($4bd18e93e919945b$var$repeat(str, len) + b.toString()).slice(-len);
};
var $4bd18e93e919945b$export$ef047080f6507ccc = function isArrayBufferView(obj) {
    if (ArrayBuffer.isView === "function") return ArrayBuffer.isView(obj);
    return obj && obj.buffer instanceof ArrayBuffer;
};
var $4bd18e93e919945b$export$b119cc7e1840e59c = function isTypedArray(obj) {
    return $4bd18e93e919945b$export$ef047080f6507ccc(obj);
};
var $4bd18e93e919945b$export$63c3de442720649 = function toUint8(bytes) {
    if (bytes instanceof Uint8Array) return bytes;
    if (!Array.isArray(bytes) && !$4bd18e93e919945b$export$b119cc7e1840e59c(bytes) && !(bytes instanceof ArrayBuffer)) {
        // any non-number or NaN leads to empty uint8array
        // eslint-disable-next-line
        if (typeof bytes !== "number" || typeof bytes === "number" && bytes !== bytes) bytes = 0;
        else bytes = [
            bytes
        ];
    }
    return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
};
var $4bd18e93e919945b$export$f4915efbb94d4d01 = function toHexString(bytes) {
    bytes = $4bd18e93e919945b$export$63c3de442720649(bytes);
    var str = "";
    for(var i = 0; i < bytes.length; i++)str += $4bd18e93e919945b$export$36cf564d487b5178(bytes[i].toString(16), 2, "0");
    return str;
};
var $4bd18e93e919945b$export$9a7d75f397723250 = function toBinaryString(bytes) {
    bytes = $4bd18e93e919945b$export$63c3de442720649(bytes);
    var str = "";
    for(var i = 0; i < bytes.length; i++)str += $4bd18e93e919945b$export$36cf564d487b5178(bytes[i].toString(2), 8, "0");
    return str;
};
var $4bd18e93e919945b$var$BigInt = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt || Number;
var $4bd18e93e919945b$var$BYTE_TABLE = [
    $4bd18e93e919945b$var$BigInt("0x1"),
    $4bd18e93e919945b$var$BigInt("0x100"),
    $4bd18e93e919945b$var$BigInt("0x10000"),
    $4bd18e93e919945b$var$BigInt("0x1000000"),
    $4bd18e93e919945b$var$BigInt("0x100000000"),
    $4bd18e93e919945b$var$BigInt("0x10000000000"),
    $4bd18e93e919945b$var$BigInt("0x1000000000000"),
    $4bd18e93e919945b$var$BigInt("0x100000000000000"),
    $4bd18e93e919945b$var$BigInt("0x10000000000000000")
];
var $4bd18e93e919945b$export$44623b3161268f13 = function() {
    var a = new Uint16Array([
        0xFFCC
    ]);
    var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    if (b[0] === 0xFF) return "big";
    if (b[0] === 0xCC) return "little";
    return "unknown";
}();
var $4bd18e93e919945b$export$71d08edba63ee40 = $4bd18e93e919945b$export$44623b3161268f13 === "big";
var $4bd18e93e919945b$export$c362788a4d6d6a65 = $4bd18e93e919945b$export$44623b3161268f13 === "little";
var $4bd18e93e919945b$export$c0cca17bcf674749 = function bytesToNumber(bytes, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$signed = _ref.signed, signed = _ref$signed === void 0 ? false : _ref$signed, _ref$le = _ref.le, le = _ref$le === void 0 ? false : _ref$le;
    bytes = $4bd18e93e919945b$export$63c3de442720649(bytes);
    var fn = le ? "reduce" : "reduceRight";
    var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
    var number = obj.call(bytes, function(total, byte, i) {
        var exponent = le ? i : Math.abs(i + 1 - bytes.length);
        return total + $4bd18e93e919945b$var$BigInt(byte) * $4bd18e93e919945b$var$BYTE_TABLE[exponent];
    }, $4bd18e93e919945b$var$BigInt(0));
    if (signed) {
        var max = $4bd18e93e919945b$var$BYTE_TABLE[bytes.length] / $4bd18e93e919945b$var$BigInt(2) - $4bd18e93e919945b$var$BigInt(1);
        number = $4bd18e93e919945b$var$BigInt(number);
        if (number > max) {
            number -= max;
            number -= max;
            number -= $4bd18e93e919945b$var$BigInt(2);
        }
    }
    return Number(number);
};
var $4bd18e93e919945b$export$49ad9be85c347998 = function numberToBytes(number, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$le = _ref2.le, le = _ref2$le === void 0 ? false : _ref2$le;
    // eslint-disable-next-line
    if (typeof number !== "bigint" && typeof number !== "number" || typeof number === "number" && number !== number) number = 0;
    number = $4bd18e93e919945b$var$BigInt(number);
    var byteCount = $4bd18e93e919945b$export$42cd407004f34122(number);
    var bytes = new Uint8Array(new ArrayBuffer(byteCount));
    for(var i = 0; i < byteCount; i++){
        var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
        bytes[byteIndex] = Number(number / $4bd18e93e919945b$var$BYTE_TABLE[i] & $4bd18e93e919945b$var$BigInt(0xFF));
        if (number < 0) {
            bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
            bytes[byteIndex] -= i === 0 ? 1 : 2;
        }
    }
    return bytes;
};
var $4bd18e93e919945b$export$7c746b75f47c9c7d = function bytesToString(bytes) {
    if (!bytes) return "";
     // TODO: should toUint8 handle cases where we only have 8 bytes
    // but report more since this is a Uint16+ Array?
    bytes = Array.prototype.slice.call(bytes);
    var string = String.fromCharCode.apply(null, $4bd18e93e919945b$export$63c3de442720649(bytes));
    try {
        return decodeURIComponent(escape(string));
    } catch (e) {
    // or full non string data. Just return the potentially garbled string.
    }
    return string;
};
var $4bd18e93e919945b$export$c8dd6bc66a63753c = function stringToBytes(string, stringIsBytes) {
    if (typeof string !== "string" && string && typeof string.toString === "function") string = string.toString();
    if (typeof string !== "string") return new Uint8Array();
     // If the string already is bytes, we don't have to do this
    // otherwise we do this so that we split multi length characters
    // into individual bytes
    if (!stringIsBytes) string = unescape(encodeURIComponent(string));
    var view = new Uint8Array(string.length);
    for(var i = 0; i < string.length; i++)view[i] = string.charCodeAt(i);
    return view;
};
var $4bd18e93e919945b$export$229a3d5e59c9dd55 = function concatTypedArrays() {
    for(var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++)buffers[_key] = arguments[_key];
    buffers = buffers.filter(function(b) {
        return b && (b.byteLength || b.length) && typeof b !== "string";
    });
    if (buffers.length <= 1) // for 0 length we will return empty uint8
    // for 1 length we return the first uint8
    return $4bd18e93e919945b$export$63c3de442720649(buffers[0]);
    var totalLen = buffers.reduce(function(total, buf, i) {
        return total + (buf.byteLength || buf.length);
    }, 0);
    var tempBuffer = new Uint8Array(totalLen);
    var offset = 0;
    buffers.forEach(function(buf) {
        buf = $4bd18e93e919945b$export$63c3de442720649(buf);
        tempBuffer.set(buf, offset);
        offset += buf.byteLength;
    });
    return tempBuffer;
};
var $4bd18e93e919945b$export$a20f7b76e5cfd223 = function bytesMatch(a, b, _temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$offset = _ref3.offset, offset = _ref3$offset === void 0 ? 0 : _ref3$offset, _ref3$mask = _ref3.mask, mask = _ref3$mask === void 0 ? [] : _ref3$mask;
    a = $4bd18e93e919945b$export$63c3de442720649(a);
    b = $4bd18e93e919945b$export$63c3de442720649(b); // ie 11 does not support uint8 every
    var fn = b.every ? b.every : Array.prototype.every;
    return b.length && a.length - offset >= b.length && // ie 11 doesn't support every on uin8
    fn.call(b, function(bByte, i) {
        var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
        return bByte === aByte;
    });
};
var $4bd18e93e919945b$export$8bac03c8c1da551 = function sliceBytes(src, start, end) {
    if (Uint8Array.prototype.slice) return Uint8Array.prototype.slice.call(src, start, end);
    return new Uint8Array(Array.prototype.slice.call(src, start, end));
};
var $4bd18e93e919945b$export$8f563933fe97d489 = function reverseBytes(src) {
    if (src.reverse) return src.reverse();
    return Array.prototype.reverse.call(src);
};


/*! @name mpd-parser @version 1.2.2 @license Apache-2.0 */ 

var $eDick = parcelRequire("eDick");
var $b6abcbe366420ffb$var$DEFAULT_LOCATION = "http://example.com";
var $b6abcbe366420ffb$var$resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
    // return early if we don't need to resolve
    if (/^[a-z]+:/i.test(relativeUrl)) return relativeUrl;
     // if baseUrl is a data URI, ignore it and resolve everything relative to window.location
    if (/^data:/.test(baseUrl)) baseUrl = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href || "";
     // IE11 supports URL but not the URL constructor
    // feature detect the behavior we want
    var nativeURL = typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL === "function";
    var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
    // and if baseUrl isn't an absolute url
    var removeLocation = !(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location
    if (nativeURL) baseUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(baseUrl, (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location || $b6abcbe366420ffb$var$DEFAULT_LOCATION);
    else if (!/\/\//i.test(baseUrl)) baseUrl = (0, (/*@__PURE__*/$parcel$interopDefault($b06999a781b3e073$exports))).buildAbsoluteURL((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href || "", baseUrl);
    if (nativeURL) {
        var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
        // and if we're location-less, remove the location
        // otherwise, return the url unmodified
        if (removeLocation) return newUrl.href.slice($b6abcbe366420ffb$var$DEFAULT_LOCATION.length);
        else if (protocolLess) return newUrl.href.slice(newUrl.protocol.length);
        return newUrl.href;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($b06999a781b3e073$exports))).buildAbsoluteURL(baseUrl, relativeUrl);
};
var $b6abcbe366420ffb$export$2e2bcd8739ae039 = $b6abcbe366420ffb$var$resolveUrl;



var $eDick = parcelRequire("eDick");
/**
 * Loops through all supported media groups in master and calls the provided
 * callback for each group
 *
 * @param {Object} master
 *        The parsed master manifest object
 * @param {string[]} groups
 *        The media groups to call the callback for
 * @param {Function} callback
 *        Callback to call for each media group
 */ var $b150011c7a8ed92d$export$308de5e7fb801aab = function forEachMediaGroup(master, groups, callback) {
    groups.forEach(function(mediaType) {
        for(var groupKey in master.mediaGroups[mediaType])for(var labelKey in master.mediaGroups[mediaType][groupKey]){
            var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
            callback(mediaProperties, mediaType, groupKey, labelKey);
        }
    });
};



var $eDick = parcelRequire("eDick");

var $82b8ded315bc5530$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $82b8ded315bc5530$var$atob = function atob(s) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob(s) : $82b8ded315bc5530$require$Buffer.from(s, "base64").toString("binary");
};
function $82b8ded315bc5530$export$2e2bcd8739ae039(b64Text) {
    var decodedString = $82b8ded315bc5530$var$atob(b64Text);
    var array = new Uint8Array(decodedString.length);
    for(var i = 0; i < decodedString.length; i++)array[i] = decodedString.charCodeAt(i);
    return array;
}


var $515447b9158f86cb$export$455426655eab1d48;
var $515447b9158f86cb$export$64f0bed4ae6f0f24;
var $515447b9158f86cb$export$1059c6e7d2ce5669;

var $2YubT = parcelRequire("2YubT");
$515447b9158f86cb$export$455426655eab1d48 = $2YubT.DOMImplementation;
$515447b9158f86cb$export$64f0bed4ae6f0f24 = $2YubT.XMLSerializer;

$515447b9158f86cb$export$1059c6e7d2ce5669 = (parcelRequire("c1Wy2")).DOMParser;


var $0ffb3c35bf172c1a$var$version = "1.2.2";
const $0ffb3c35bf172c1a$var$isObject = (obj)=>{
    return !!obj && typeof obj === "object";
};
const $0ffb3c35bf172c1a$var$merge = (...objects)=>{
    return objects.reduce((result, source)=>{
        if (typeof source !== "object") return result;
        Object.keys(source).forEach((key)=>{
            if (Array.isArray(result[key]) && Array.isArray(source[key])) result[key] = result[key].concat(source[key]);
            else if ($0ffb3c35bf172c1a$var$isObject(result[key]) && $0ffb3c35bf172c1a$var$isObject(source[key])) result[key] = $0ffb3c35bf172c1a$var$merge(result[key], source[key]);
            else result[key] = source[key];
        });
        return result;
    }, {});
};
const $0ffb3c35bf172c1a$var$values = (o)=>Object.keys(o).map((k)=>o[k]);
const $0ffb3c35bf172c1a$var$range = (start, end)=>{
    const result = [];
    for(let i = start; i < end; i++)result.push(i);
    return result;
};
const $0ffb3c35bf172c1a$var$flatten = (lists)=>lists.reduce((x, y)=>x.concat(y), []);
const $0ffb3c35bf172c1a$var$from = (list)=>{
    if (!list.length) return [];
    const result = [];
    for(let i = 0; i < list.length; i++)result.push(list[i]);
    return result;
};
const $0ffb3c35bf172c1a$var$findIndexes = (l, key)=>l.reduce((a, e, i)=>{
        if (e[key]) a.push(i);
        return a;
    }, []);
/**
 * Returns a union of the included lists provided each element can be identified by a key.
 *
 * @param {Array} list - list of lists to get the union of
 * @param {Function} keyFunction - the function to use as a key for each element
 *
 * @return {Array} the union of the arrays
 */ const $0ffb3c35bf172c1a$var$union = (lists, keyFunction)=>{
    return $0ffb3c35bf172c1a$var$values(lists.reduce((acc, list)=>{
        list.forEach((el)=>{
            acc[keyFunction(el)] = el;
        });
        return acc;
    }, {}));
};
var $0ffb3c35bf172c1a$var$errors = {
    INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
    INVALID_NUMBER_OF_CONTENT_STEERING: "INVALID_NUMBER_OF_CONTENT_STEERING",
    DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
    DASH_INVALID_XML: "DASH_INVALID_XML",
    NO_BASE_URL: "NO_BASE_URL",
    MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
    SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
    UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
};
/**
 * @typedef {Object} SingleUri
 * @property {string} uri - relative location of segment
 * @property {string} resolvedUri - resolved location of segment
 * @property {Object} byterange - Object containing information on how to make byte range
 *   requests following byte-range-spec per RFC2616.
 * @property {String} byterange.length - length of range request
 * @property {String} byterange.offset - byte offset of range request
 *
 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
 */ /**
 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
 * that conforms to how m3u8-parser is structured
 *
 * @see https://github.com/videojs/m3u8-parser
 *
 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
 * @param {string} source - source url for segment
 * @param {string} range - optional range used for range calls,
 *   follows  RFC 2616, Clause 14.35.1
 * @return {SingleUri} full segment information transformed into a format similar
 *   to m3u8-parser
 */ const $0ffb3c35bf172c1a$var$urlTypeToSegment = ({ baseUrl: baseUrl = "", source: source = "", range: range = "", indexRange: indexRange = "" })=>{
    const segment = {
        uri: source,
        resolvedUri: (0, $b6abcbe366420ffb$export$2e2bcd8739ae039)(baseUrl || "", source)
    };
    if (range || indexRange) {
        const rangeStr = range ? range : indexRange;
        const ranges = rangeStr.split("-"); // default to parsing this as a BigInt if possible
        let startRange = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(ranges[0]) : parseInt(ranges[0], 10);
        let endRange = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER
        if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === "bigint") startRange = Number(startRange);
        if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === "bigint") endRange = Number(endRange);
        let length;
        if (typeof endRange === "bigint" || typeof startRange === "bigint") length = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(endRange) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(startRange) + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
        else length = endRange - startRange + 1;
        if (typeof length === "bigint" && length < Number.MAX_SAFE_INTEGER) length = Number(length);
         // byterange should be inclusive according to
        // RFC 2616, Clause 14.35.1
        segment.byterange = {
            length: length,
            offset: startRange
        };
    }
    return segment;
};
const $0ffb3c35bf172c1a$var$byteRangeToString = (byterange)=>{
    // `endRange` is one less than `offset + length` because the HTTP range
    // header uses inclusive ranges
    let endRange;
    if (typeof byterange.offset === "bigint" || typeof byterange.length === "bigint") endRange = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.offset) + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.length) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
    else endRange = byterange.offset + byterange.length - 1;
    return `${byterange.offset}-${endRange}`;
};
/**
 * parse the end number attribue that can be a string
 * number, or undefined.
 *
 * @param {string|number|undefined} endNumber
 *        The end number attribute.
 *
 * @return {number|null}
 *          The result of parsing the end number.
 */ const $0ffb3c35bf172c1a$var$parseEndNumber = (endNumber)=>{
    if (endNumber && typeof endNumber !== "number") endNumber = parseInt(endNumber, 10);
    if (isNaN(endNumber)) return null;
    return endNumber;
};
/**
 * Functions for calculating the range of available segments in static and dynamic
 * manifests.
 */ const $0ffb3c35bf172c1a$var$segmentRange = {
    /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */ static (attributes) {
        const { duration: duration, timescale: timescale = 1, sourceDuration: sourceDuration, periodDuration: periodDuration } = attributes;
        const endNumber = $0ffb3c35bf172c1a$var$parseEndNumber(attributes.endNumber);
        const segmentDuration = duration / timescale;
        if (typeof endNumber === "number") return {
            start: 0,
            end: endNumber
        };
        if (typeof periodDuration === "number") return {
            start: 0,
            end: periodDuration / segmentDuration
        };
        return {
            start: 0,
            end: sourceDuration / segmentDuration
        };
    },
    /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */ dynamic (attributes) {
        const { NOW: NOW, clientOffset: clientOffset, availabilityStartTime: availabilityStartTime, timescale: timescale = 1, duration: duration, periodStart: periodStart = 0, minimumUpdatePeriod: minimumUpdatePeriod = 0, timeShiftBufferDepth: timeShiftBufferDepth = Infinity } = attributes;
        const endNumber = $0ffb3c35bf172c1a$var$parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
        // after retrieving UTC server time.
        const now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
        // Convert the period start time to EPOCH.
        const periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.
        const periodEndWC = now + minimumUpdatePeriod;
        const periodDuration = periodEndWC - periodStartWC;
        const segmentCount = Math.ceil(periodDuration * timescale / duration);
        const availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
        const availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
        return {
            start: Math.max(0, availableStart),
            end: typeof endNumber === "number" ? endNumber : Math.min(segmentCount, availableEnd)
        };
    }
};
/**
 * Maps a range of numbers to objects with information needed to build the corresponding
 * segment list
 *
 * @name toSegmentsCallback
 * @function
 * @param {number} number
 *        Number of the segment
 * @param {number} index
 *        Index of the number in the range list
 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
 *         Object with segment timing and duration info
 */ /**
 * Returns a callback for Array.prototype.map for mapping a range of numbers to
 * information needed to build the segment list.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {toSegmentsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$toSegments = (attributes)=>(number)=>{
        const { duration: duration, timescale: timescale = 1, periodStart: periodStart, startNumber: startNumber = 1 } = attributes;
        return {
            number: startNumber + number,
            duration: duration / timescale,
            timeline: periodStart,
            time: number * duration
        };
    };
/**
 * Returns a list of objects containing segment timing and duration info used for
 * building the list of segments. This uses the @duration attribute specified
 * in the MPD manifest to derive the range of segments.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $0ffb3c35bf172c1a$var$parseByDuration = (attributes)=>{
    const { type: type, duration: duration, timescale: timescale = 1, periodDuration: periodDuration, sourceDuration: sourceDuration } = attributes;
    const { start: start, end: end } = $0ffb3c35bf172c1a$var$segmentRange[type](attributes);
    const segments = $0ffb3c35bf172c1a$var$range(start, end).map($0ffb3c35bf172c1a$var$toSegments(attributes));
    if (type === "static") {
        const index = segments.length - 1; // section is either a period or the full source
        const sectionDuration = typeof periodDuration === "number" ? periodDuration : sourceDuration; // final segment may be less than full segment duration
        segments[index].duration = sectionDuration - duration / timescale * index;
    }
    return segments;
};
/**
 * Translates SegmentBase into a set of segments.
 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @return {Object.<Array>} list of segments
 */ const $0ffb3c35bf172c1a$var$segmentsFromBase = (attributes)=>{
    const { baseUrl: baseUrl, initialization: initialization = {}, sourceDuration: sourceDuration, indexRange: indexRange = "", periodStart: periodStart, presentationTime: presentationTime, number: number = 0, duration: duration } = attributes; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)
    if (!baseUrl) throw new Error($0ffb3c35bf172c1a$var$errors.NO_BASE_URL);
    const initSegment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: initialization.sourceURL,
        range: initialization.range
    });
    const segment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: baseUrl,
        indexRange: indexRange
    });
    segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
    // (since SegmentBase is only for one total segment)
    if (duration) {
        const segmentTimeInfo = $0ffb3c35bf172c1a$var$parseByDuration(attributes);
        if (segmentTimeInfo.length) {
            segment.duration = segmentTimeInfo[0].duration;
            segment.timeline = segmentTimeInfo[0].timeline;
        }
    } else if (sourceDuration) {
        segment.duration = sourceDuration;
        segment.timeline = periodStart;
    } // If presentation time is provided, these segments are being generated by SIDX
    // references, and should use the time provided. For the general case of SegmentBase,
    // there should only be one segment in the period, so its presentation time is the same
    // as its period start.
    segment.presentationTime = presentationTime || periodStart;
    segment.number = number;
    return [
        segment
    ];
};
/**
 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
 * according to the sidx information given.
 *
 * playlist.sidx has metadadata about the sidx where-as the sidx param
 * is the parsed sidx box itself.
 *
 * @param {Object} playlist the playlist to update the sidx information for
 * @param {Object} sidx the parsed sidx box
 * @return {Object} the playlist object with the updated sidx information
 */ const $0ffb3c35bf172c1a$export$2243d5aa7d4f4800 = (playlist, sidx, baseUrl)=>{
    // Retain init segment information
    const initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing
    const sourceDuration = playlist.sidx.duration; // Retain source timeline
    const timeline = playlist.timeline || 0;
    const sidxByteRange = playlist.sidx.byterange;
    const sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx
    const timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes
    const mediaReferences = sidx.references.filter((r)=>r.referenceType !== 1);
    const segments = [];
    const type = playlist.endList ? "static" : "dynamic";
    const periodStart = playlist.sidx.timeline;
    let presentationTime = periodStart;
    let number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box
    let startIndex; // eslint-disable-next-line
    if (typeof sidx.firstOffset === "bigint") startIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(sidxEnd) + sidx.firstOffset;
    else startIndex = sidxEnd + sidx.firstOffset;
    for(let i = 0; i < mediaReferences.length; i++){
        const reference = sidx.references[i]; // size of the referenced (sub)segment
        const size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
        // this will be converted to seconds when generating segments
        const duration = reference.subsegmentDuration; // should be an inclusive range
        let endIndex; // eslint-disable-next-line
        if (typeof startIndex === "bigint") endIndex = startIndex + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(size) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
        else endIndex = startIndex + size - 1;
        const indexRange = `${startIndex}-${endIndex}`;
        const attributes = {
            baseUrl: baseUrl,
            timescale: timescale,
            timeline: timeline,
            periodStart: periodStart,
            presentationTime: presentationTime,
            number: number,
            duration: duration,
            sourceDuration: sourceDuration,
            indexRange: indexRange,
            type: type
        };
        const segment = $0ffb3c35bf172c1a$var$segmentsFromBase(attributes)[0];
        if (initSegment) segment.map = initSegment;
        segments.push(segment);
        if (typeof startIndex === "bigint") startIndex += (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(size);
        else startIndex += size;
        presentationTime += duration / timescale;
        number++;
    }
    playlist.segments = segments;
    return playlist;
};
const $0ffb3c35bf172c1a$var$SUPPORTED_MEDIA_TYPES = [
    "AUDIO",
    "SUBTITLES"
]; // allow one 60fps frame as leniency (arbitrarily chosen)
const $0ffb3c35bf172c1a$var$TIME_FUDGE = 1 / 60;
/**
 * Given a list of timelineStarts, combines, dedupes, and sorts them.
 *
 * @param {TimelineStart[]} timelineStarts - list of timeline starts
 *
 * @return {TimelineStart[]} the combined and deduped timeline starts
 */ const $0ffb3c35bf172c1a$var$getUniqueTimelineStarts = (timelineStarts)=>{
    return $0ffb3c35bf172c1a$var$union(timelineStarts, ({ timeline: timeline })=>timeline).sort((a, b)=>a.timeline > b.timeline ? 1 : -1);
};
/**
 * Finds the playlist with the matching NAME attribute.
 *
 * @param {Array} playlists - playlists to search through
 * @param {string} name - the NAME attribute to search for
 *
 * @return {Object|null} the matching playlist object, or null
 */ const $0ffb3c35bf172c1a$var$findPlaylistWithName = (playlists, name)=>{
    for(let i = 0; i < playlists.length; i++){
        if (playlists[i].attributes.NAME === name) return playlists[i];
    }
    return null;
};
/**
 * Gets a flattened array of media group playlists.
 *
 * @param {Object} manifest - the main manifest object
 *
 * @return {Array} the media group playlists
 */ const $0ffb3c35bf172c1a$var$getMediaGroupPlaylists = (manifest)=>{
    let mediaGroupPlaylists = [];
    (0, $b150011c7a8ed92d$export$308de5e7fb801aab)(manifest, $0ffb3c35bf172c1a$var$SUPPORTED_MEDIA_TYPES, (properties, type, group, label)=>{
        mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
    });
    return mediaGroupPlaylists;
};
/**
 * Updates the playlist's media sequence numbers.
 *
 * @param {Object} config - options object
 * @param {Object} config.playlist - the playlist to update
 * @param {number} config.mediaSequence - the mediaSequence number to start with
 */ const $0ffb3c35bf172c1a$var$updateMediaSequenceForPlaylist = ({ playlist: playlist, mediaSequence: mediaSequence })=>{
    playlist.mediaSequence = mediaSequence;
    playlist.segments.forEach((segment, index)=>{
        segment.number = playlist.mediaSequence + index;
    });
};
/**
 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
 * and a complete list of timeline starts.
 *
 * If no matching playlist is found, only the discontinuity sequence number of the playlist
 * will be updated.
 *
 * Since early available timelines are not supported, at least one segment must be present.
 *
 * @param {Object} config - options object
 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
 * @param {Object[]} newPlaylists - the new playlists to update
 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
 */ const $0ffb3c35bf172c1a$var$updateSequenceNumbers = ({ oldPlaylists: oldPlaylists, newPlaylists: newPlaylists, timelineStarts: timelineStarts })=>{
    newPlaylists.forEach((playlist)=>{
        playlist.discontinuitySequence = timelineStarts.findIndex(function({ timeline: timeline }) {
            return timeline === playlist.timeline;
        }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
        // (see ISO_23009-1-2012 5.3.5.2).
        //
        // If the same Representation existed in a prior Period, it will retain the same NAME.
        const oldPlaylist = $0ffb3c35bf172c1a$var$findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
        if (!oldPlaylist) // Since this is a new playlist, the media sequence values can start from 0 without
        // consequence.
        return;
         // TODO better support for live SIDX
        //
        // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
        // This is evident by a playlist only having a single SIDX reference. In a multiperiod
        // playlist there would need to be multiple SIDX references. In addition, live SIDX is
        // not supported when the SIDX properties change on refreshes.
        //
        // In the future, if support needs to be added, the merging logic here can be called
        // after SIDX references are resolved. For now, exit early to prevent exceptions being
        // thrown due to undefined references.
        if (playlist.sidx) return;
         // Since we don't yet support early available timelines, we don't need to support
        // playlists with no segments.
        const firstNewSegment = playlist.segments[0];
        const oldMatchingSegmentIndex = oldPlaylist.segments.findIndex(function(oldSegment) {
            return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < $0ffb3c35bf172c1a$var$TIME_FUDGE;
        }); // No matching segment from the old playlist means the entire playlist was refreshed.
        // In this case the media sequence should account for this update, and the new segments
        // should be marked as discontinuous from the prior content, since the last prior
        // timeline was removed.
        if (oldMatchingSegmentIndex === -1) {
            $0ffb3c35bf172c1a$var$updateMediaSequenceForPlaylist({
                playlist: playlist,
                mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
            });
            playlist.segments[0].discontinuity = true;
            playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
            //
            // If the new playlist's timeline is the same as the last seen segment's timeline,
            // then a discontinuity can be added to identify that there's potentially missing
            // content. If there's no missing content, the discontinuity should still be rather
            // harmless. It's possible that if segment durations are accurate enough, that the
            // existence of a gap can be determined using the presentation times and durations,
            // but if the segment timing info is off, it may introduce more problems than simply
            // adding the discontinuity.
            //
            // If the new playlist's timeline is different from the last seen segment's timeline,
            // then a discontinuity can be added to identify that this is the first seen segment
            // of a new timeline. However, the logic at the start of this function that
            // determined the disconinuity sequence by timeline index is now off by one (the
            // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
            // we added it), so the disconinuity sequence must be decremented.
            //
            // A period may also have a duration of zero, so the case of no segments is handled
            // here even though we don't yet support early available periods.
            if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) playlist.discontinuitySequence--;
            return;
        } // If the first segment matched with a prior segment on a discontinuity (it's matching
        // on the first segment of a period), then the discontinuitySequence shouldn't be the
        // timeline's matching one, but instead should be the one prior, and the first segment
        // of the new manifest should be marked with a discontinuity.
        //
        // The reason for this special case is that discontinuity sequence shows how many
        // discontinuities have fallen off of the playlist, and discontinuities are marked on
        // the first segment of a new "timeline." Because of this, while DASH will retain that
        // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
        // sequence, and that first segment is an indicator, but can be removed before that
        // timeline is gone.
        const oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
        if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
            firstNewSegment.discontinuity = true;
            playlist.discontinuityStarts.unshift(0);
            playlist.discontinuitySequence--;
        }
        $0ffb3c35bf172c1a$var$updateMediaSequenceForPlaylist({
            playlist: playlist,
            mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
        });
    });
};
/**
 * Given an old parsed manifest object and a new parsed manifest object, updates the
 * sequence and timing values within the new manifest to ensure that it lines up with the
 * old.
 *
 * @param {Array} oldManifest - the old main manifest object
 * @param {Array} newManifest - the new main manifest object
 *
 * @return {Object} the updated new manifest object
 */ const $0ffb3c35bf172c1a$var$positionManifestOnTimeline = ({ oldManifest: oldManifest, newManifest: newManifest })=>{
    // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
    //
    // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
    //
    // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
    //
    // Because of this change, and the difficulty of supporting periods with changing start
    // times, periods with changing start times are not supported. This makes the logic much
    // simpler, since periods with the same start time can be considerred the same period
    // across refreshes.
    //
    // To give an example as to the difficulty of handling periods where the start time may
    // change, if a single period manifest is refreshed with another manifest with a single
    // period, and both the start and end times are increased, then the only way to determine
    // if it's a new period or an old one that has changed is to look through the segments of
    // each playlist and determine the presentation time bounds to find a match. In addition,
    // if the period start changed to exceed the old period end, then there would be no
    // match, and it would not be possible to determine whether the refreshed period is a new
    // one or the old one.
    const oldPlaylists = oldManifest.playlists.concat($0ffb3c35bf172c1a$var$getMediaGroupPlaylists(oldManifest));
    const newPlaylists = newManifest.playlists.concat($0ffb3c35bf172c1a$var$getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
    // there's a "memory leak" in that it will never stop growing, in reality, only a couple
    // of properties are saved for each seen Period. Even long running live streams won't
    // generate too many Periods, unless the stream is watched for decades. In the future,
    // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
    // but it may not become an issue, and the additional info can be useful for debugging.
    newManifest.timelineStarts = $0ffb3c35bf172c1a$var$getUniqueTimelineStarts([
        oldManifest.timelineStarts,
        newManifest.timelineStarts
    ]);
    $0ffb3c35bf172c1a$var$updateSequenceNumbers({
        oldPlaylists: oldPlaylists,
        newPlaylists: newPlaylists,
        timelineStarts: newManifest.timelineStarts
    });
    return newManifest;
};
const $0ffb3c35bf172c1a$export$2d92360466eb0b01 = (sidx)=>sidx && sidx.uri + "-" + $0ffb3c35bf172c1a$var$byteRangeToString(sidx.byterange);
const $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists = (playlists)=>{
    // Break out playlists into groups based on their baseUrl
    const playlistsByBaseUrl = playlists.reduce(function(acc, cur) {
        if (!acc[cur.attributes.baseUrl]) acc[cur.attributes.baseUrl] = [];
        acc[cur.attributes.baseUrl].push(cur);
        return acc;
    }, {});
    let allPlaylists = [];
    Object.values(playlistsByBaseUrl).forEach((playlistGroup)=>{
        const mergedPlaylists = $0ffb3c35bf172c1a$var$values(playlistGroup.reduce((acc, playlist)=>{
            // assuming playlist IDs are the same across periods
            // TODO: handle multiperiod where representation sets are not the same
            // across periods
            const name = playlist.attributes.id + (playlist.attributes.lang || "");
            if (!acc[name]) {
                // First Period
                acc[name] = playlist;
                acc[name].attributes.timelineStarts = [];
            } else {
                // Subsequent Periods
                if (playlist.segments) {
                    // first segment of subsequent periods signal a discontinuity
                    if (playlist.segments[0]) playlist.segments[0].discontinuity = true;
                    acc[name].segments.push(...playlist.segments);
                } // bubble up contentProtection, this assumes all DRM content
                // has the same contentProtection
                if (playlist.attributes.contentProtection) acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
            }
            acc[name].attributes.timelineStarts.push({
                // Although they represent the same number, it's important to have both to make it
                // compatible with HLS potentially having a similar attribute.
                start: playlist.attributes.periodStart,
                timeline: playlist.attributes.periodStart
            });
            return acc;
        }, {}));
        allPlaylists = allPlaylists.concat(mergedPlaylists);
    });
    return allPlaylists.map((playlist)=>{
        playlist.discontinuityStarts = $0ffb3c35bf172c1a$var$findIndexes(playlist.segments || [], "discontinuity");
        return playlist;
    });
};
const $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist = (playlist, sidxMapping)=>{
    const sidxKey = $0ffb3c35bf172c1a$export$2d92360466eb0b01(playlist.sidx);
    const sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
    if (sidxMatch) $0ffb3c35bf172c1a$export$2243d5aa7d4f4800(playlist, sidxMatch, playlist.sidx.resolvedUri);
    return playlist;
};
const $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylists = (playlists, sidxMapping = {})=>{
    if (!Object.keys(sidxMapping).length) return playlists;
    for(const i in playlists)playlists[i] = $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
    return playlists;
};
const $0ffb3c35bf172c1a$var$formatAudioPlaylist = ({ attributes: attributes, segments: segments, sidx: sidx, mediaSequence: mediaSequence, discontinuitySequence: discontinuitySequence, discontinuityStarts: discontinuityStarts }, isAudioOnly)=>{
    const playlist = {
        attributes: {
            NAME: attributes.id,
            BANDWIDTH: attributes.bandwidth,
            CODECS: attributes.codecs,
            ["PROGRAM-ID"]: 1
        },
        uri: "",
        endList: attributes.type === "static",
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || "",
        targetDuration: attributes.duration,
        discontinuitySequence: discontinuitySequence,
        discontinuityStarts: discontinuityStarts,
        timelineStarts: attributes.timelineStarts,
        mediaSequence: mediaSequence,
        segments: segments
    };
    if (attributes.contentProtection) playlist.contentProtection = attributes.contentProtection;
    if (attributes.serviceLocation) playlist.attributes.serviceLocation = attributes.serviceLocation;
    if (sidx) playlist.sidx = sidx;
    if (isAudioOnly) {
        playlist.attributes.AUDIO = "audio";
        playlist.attributes.SUBTITLES = "subs";
    }
    return playlist;
};
const $0ffb3c35bf172c1a$var$formatVttPlaylist = ({ attributes: attributes, segments: segments, mediaSequence: mediaSequence, discontinuityStarts: discontinuityStarts, discontinuitySequence: discontinuitySequence })=>{
    if (typeof segments === "undefined") {
        // vtt tracks may use single file in BaseURL
        segments = [
            {
                uri: attributes.baseUrl,
                timeline: attributes.periodStart,
                resolvedUri: attributes.baseUrl || "",
                duration: attributes.sourceDuration,
                number: 0
            }
        ]; // targetDuration should be the same duration as the only segment
        attributes.duration = attributes.sourceDuration;
    }
    const m3u8Attributes = {
        NAME: attributes.id,
        BANDWIDTH: attributes.bandwidth,
        ["PROGRAM-ID"]: 1
    };
    if (attributes.codecs) m3u8Attributes.CODECS = attributes.codecs;
    const vttPlaylist = {
        attributes: m3u8Attributes,
        uri: "",
        endList: attributes.type === "static",
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || "",
        targetDuration: attributes.duration,
        timelineStarts: attributes.timelineStarts,
        discontinuityStarts: discontinuityStarts,
        discontinuitySequence: discontinuitySequence,
        mediaSequence: mediaSequence,
        segments: segments
    };
    if (attributes.serviceLocation) vttPlaylist.attributes.serviceLocation = attributes.serviceLocation;
    return vttPlaylist;
};
const $0ffb3c35bf172c1a$var$organizeAudioPlaylists = (playlists, sidxMapping = {}, isAudioOnly = false)=>{
    let mainPlaylist;
    const formattedPlaylists = playlists.reduce((a, playlist)=>{
        const role = playlist.attributes.role && playlist.attributes.role.value || "";
        const language = playlist.attributes.lang || "";
        let label = playlist.attributes.label || "main";
        if (language && !playlist.attributes.label) {
            const roleLabel = role ? ` (${role})` : "";
            label = `${playlist.attributes.lang}${roleLabel}`;
        }
        if (!a[label]) a[label] = {
            language: language,
            autoselect: true,
            default: role === "main",
            playlists: [],
            uri: ""
        };
        const formatted = $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist($0ffb3c35bf172c1a$var$formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
        a[label].playlists.push(formatted);
        if (typeof mainPlaylist === "undefined" && role === "main") {
            mainPlaylist = playlist;
            mainPlaylist.default = true;
        }
        return a;
    }, {}); // if no playlists have role "main", mark the first as main
    if (!mainPlaylist) {
        const firstLabel = Object.keys(formattedPlaylists)[0];
        formattedPlaylists[firstLabel].default = true;
    }
    return formattedPlaylists;
};
const $0ffb3c35bf172c1a$var$organizeVttPlaylists = (playlists, sidxMapping = {})=>{
    return playlists.reduce((a, playlist)=>{
        const label = playlist.attributes.label || playlist.attributes.lang || "text";
        if (!a[label]) a[label] = {
            language: label,
            default: false,
            autoselect: false,
            playlists: [],
            uri: ""
        };
        a[label].playlists.push($0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylist($0ffb3c35bf172c1a$var$formatVttPlaylist(playlist), sidxMapping));
        return a;
    }, {});
};
const $0ffb3c35bf172c1a$var$organizeCaptionServices = (captionServices)=>captionServices.reduce((svcObj, svc)=>{
        if (!svc) return svcObj;
        svc.forEach((service)=>{
            const { channel: channel, language: language } = service;
            svcObj[language] = {
                autoselect: false,
                default: false,
                instreamId: channel,
                language: language
            };
            if (service.hasOwnProperty("aspectRatio")) svcObj[language].aspectRatio = service.aspectRatio;
            if (service.hasOwnProperty("easyReader")) svcObj[language].easyReader = service.easyReader;
            if (service.hasOwnProperty("3D")) svcObj[language]["3D"] = service["3D"];
        });
        return svcObj;
    }, {});
const $0ffb3c35bf172c1a$var$formatVideoPlaylist = ({ attributes: attributes, segments: segments, sidx: sidx, discontinuityStarts: discontinuityStarts })=>{
    const playlist = {
        attributes: {
            NAME: attributes.id,
            AUDIO: "audio",
            SUBTITLES: "subs",
            RESOLUTION: {
                width: attributes.width,
                height: attributes.height
            },
            CODECS: attributes.codecs,
            BANDWIDTH: attributes.bandwidth,
            ["PROGRAM-ID"]: 1
        },
        uri: "",
        endList: attributes.type === "static",
        timeline: attributes.periodStart,
        resolvedUri: attributes.baseUrl || "",
        targetDuration: attributes.duration,
        discontinuityStarts: discontinuityStarts,
        timelineStarts: attributes.timelineStarts,
        segments: segments
    };
    if (attributes.frameRate) playlist.attributes["FRAME-RATE"] = attributes.frameRate;
    if (attributes.contentProtection) playlist.contentProtection = attributes.contentProtection;
    if (attributes.serviceLocation) playlist.attributes.serviceLocation = attributes.serviceLocation;
    if (sidx) playlist.sidx = sidx;
    return playlist;
};
const $0ffb3c35bf172c1a$var$videoOnly = ({ attributes: attributes })=>attributes.mimeType === "video/mp4" || attributes.mimeType === "video/webm" || attributes.contentType === "video";
const $0ffb3c35bf172c1a$var$audioOnly = ({ attributes: attributes })=>attributes.mimeType === "audio/mp4" || attributes.mimeType === "audio/webm" || attributes.contentType === "audio";
const $0ffb3c35bf172c1a$var$vttOnly = ({ attributes: attributes })=>attributes.mimeType === "text/vtt" || attributes.contentType === "text";
/**
 * Contains start and timeline properties denoting a timeline start. For DASH, these will
 * be the same number.
 *
 * @typedef {Object} TimelineStart
 * @property {number} start - the start time of the timeline
 * @property {number} timeline - the timeline number
 */ /**
 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
 *
 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
 * DASH specific attribute used in constructing segment URI's from templates. However, from
 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
 * value, which should start at the original media sequence value (or 0) and increment by 1
 * for each segment thereafter. Since DASH's `startNumber` values are independent per
 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
 * from a 0 mediaSequence value and increment from there.
 *
 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
 * debugging and making sense of the manifest.
 *
 * For live playlists, to account for values increasing in manifests when periods are
 * removed on refreshes, merging logic should be used to update the numbers to their
 * appropriate values (to ensure they're sequential and increasing).
 *
 * @param {Object[]} playlists - the playlists to update
 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
 */ const $0ffb3c35bf172c1a$var$addMediaSequenceValues = (playlists, timelineStarts)=>{
    // increment all segments sequentially
    playlists.forEach((playlist)=>{
        playlist.mediaSequence = 0;
        playlist.discontinuitySequence = timelineStarts.findIndex(function({ timeline: timeline }) {
            return timeline === playlist.timeline;
        });
        if (!playlist.segments) return;
        playlist.segments.forEach((segment, index)=>{
            segment.number = index;
        });
    });
};
/**
 * Given a media group object, flattens all playlists within the media group into a single
 * array.
 *
 * @param {Object} mediaGroupObject - the media group object
 *
 * @return {Object[]}
 *         The media group playlists
 */ const $0ffb3c35bf172c1a$var$flattenMediaGroupPlaylists = (mediaGroupObject)=>{
    if (!mediaGroupObject) return [];
    return Object.keys(mediaGroupObject).reduce((acc, label)=>{
        const labelContents = mediaGroupObject[label];
        return acc.concat(labelContents.playlists);
    }, []);
};
const $0ffb3c35bf172c1a$export$c90e7d9f067c8f2c = ({ dashPlaylists: dashPlaylists, locations: locations, contentSteering: contentSteering, sidxMapping: sidxMapping = {}, previousManifest: previousManifest, eventStream: eventStream })=>{
    if (!dashPlaylists.length) return {};
     // grab all main manifest attributes
    const { sourceDuration: duration, type: type, suggestedPresentationDelay: suggestedPresentationDelay, minimumUpdatePeriod: minimumUpdatePeriod } = dashPlaylists[0].attributes;
    const videoPlaylists = $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($0ffb3c35bf172c1a$var$videoOnly)).map($0ffb3c35bf172c1a$var$formatVideoPlaylist);
    const audioPlaylists = $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($0ffb3c35bf172c1a$var$audioOnly));
    const vttPlaylists = $0ffb3c35bf172c1a$var$mergeDiscontiguousPlaylists(dashPlaylists.filter($0ffb3c35bf172c1a$var$vttOnly));
    const captions = dashPlaylists.map((playlist)=>playlist.attributes.captionServices).filter(Boolean);
    const manifest = {
        allowCache: true,
        discontinuityStarts: [],
        segments: [],
        endList: true,
        mediaGroups: {
            AUDIO: {},
            VIDEO: {},
            ["CLOSED-CAPTIONS"]: {},
            SUBTITLES: {}
        },
        uri: "",
        duration: duration,
        playlists: $0ffb3c35bf172c1a$var$addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
    };
    if (minimumUpdatePeriod >= 0) manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
    if (locations) manifest.locations = locations;
    if (contentSteering) manifest.contentSteering = contentSteering;
    if (type === "dynamic") manifest.suggestedPresentationDelay = suggestedPresentationDelay;
    if (eventStream && eventStream.length > 0) manifest.eventStream = eventStream;
    const isAudioOnly = manifest.playlists.length === 0;
    const organizedAudioGroup = audioPlaylists.length ? $0ffb3c35bf172c1a$var$organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
    const organizedVttGroup = vttPlaylists.length ? $0ffb3c35bf172c1a$var$organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
    const formattedPlaylists = videoPlaylists.concat($0ffb3c35bf172c1a$var$flattenMediaGroupPlaylists(organizedAudioGroup), $0ffb3c35bf172c1a$var$flattenMediaGroupPlaylists(organizedVttGroup));
    const playlistTimelineStarts = formattedPlaylists.map(({ timelineStarts: timelineStarts })=>timelineStarts);
    manifest.timelineStarts = $0ffb3c35bf172c1a$var$getUniqueTimelineStarts(playlistTimelineStarts);
    $0ffb3c35bf172c1a$var$addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
    if (organizedAudioGroup) manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
    if (organizedVttGroup) manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
    if (captions.length) manifest.mediaGroups["CLOSED-CAPTIONS"].cc = $0ffb3c35bf172c1a$var$organizeCaptionServices(captions);
    if (previousManifest) return $0ffb3c35bf172c1a$var$positionManifestOnTimeline({
        oldManifest: previousManifest,
        newManifest: manifest
    });
    return manifest;
};
/**
 * Calculates the R (repetition) value for a live stream (for the final segment
 * in a manifest where the r value is negative 1)
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {number} time
 *        current time (typically the total time up until the final segment)
 * @param {number} duration
 *        duration property for the given <S />
 *
 * @return {number}
 *        R value to reach the end of the given period
 */ const $0ffb3c35bf172c1a$var$getLiveRValue = (attributes, time, duration)=>{
    const { NOW: NOW, clientOffset: clientOffset, availabilityStartTime: availabilityStartTime, timescale: timescale = 1, periodStart: periodStart = 0, minimumUpdatePeriod: minimumUpdatePeriod = 0 } = attributes;
    const now = (NOW + clientOffset) / 1000;
    const periodStartWC = availabilityStartTime + periodStart;
    const periodEndWC = now + minimumUpdatePeriod;
    const periodDuration = periodEndWC - periodStartWC;
    return Math.ceil((periodDuration * timescale - time) / duration);
};
/**
 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
 * timing and duration
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $0ffb3c35bf172c1a$var$parseByTimeline = (attributes, segmentTimeline)=>{
    const { type: type, minimumUpdatePeriod: minimumUpdatePeriod = 0, media: media = "", sourceDuration: sourceDuration, timescale: timescale = 1, startNumber: startNumber = 1, periodStart: timeline } = attributes;
    const segments = [];
    let time = -1;
    for(let sIndex = 0; sIndex < segmentTimeline.length; sIndex++){
        const S = segmentTimeline[sIndex];
        const duration = S.d;
        const repeat = S.r || 0;
        const segmentTime = S.t || 0;
        if (time < 0) // first segment
        time = segmentTime;
        if (segmentTime && segmentTime > time) // discontinuity
        // TODO: How to handle this type of discontinuity
        // timeline++ here would treat it like HLS discontuity and content would
        // get appended without gap
        // E.G.
        //  <S t="0" d="1" />
        //  <S d="1" />
        //  <S d="1" />
        //  <S t="5" d="1" />
        // would have $Time$ values of [0, 1, 2, 5]
        // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
        // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
        // does the value of sourceDuration consider this when calculating arbitrary
        // negative @r repeat value?
        // E.G. Same elements as above with this added at the end
        //  <S d="1" r="-1" />
        //  with a sourceDuration of 10
        // Would the 2 gaps be included in the time duration calculations resulting in
        // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
        // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
        time = segmentTime;
        let count;
        if (repeat < 0) {
            const nextS = sIndex + 1;
            if (nextS === segmentTimeline.length) {
                // last segment
                if (type === "dynamic" && minimumUpdatePeriod > 0 && media.indexOf("$Number$") > 0) count = $0ffb3c35bf172c1a$var$getLiveRValue(attributes, time, duration);
                else // TODO: This may be incorrect depending on conclusion of TODO above
                count = (sourceDuration * timescale - time) / duration;
            } else count = (segmentTimeline[nextS].t - time) / duration;
        } else count = repeat + 1;
        const end = startNumber + segments.length + count;
        let number = startNumber + segments.length;
        while(number < end){
            segments.push({
                number: number,
                duration: duration / timescale,
                time: time,
                timeline: timeline
            });
            time += duration;
            number++;
        }
    }
    return segments;
};
const $0ffb3c35bf172c1a$var$identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
/**
 * Replaces template identifiers with corresponding values. To be used as the callback
 * for String.prototype.replace
 *
 * @name replaceCallback
 * @function
 * @param {string} match
 *        Entire match of identifier
 * @param {string} identifier
 *        Name of matched identifier
 * @param {string} format
 *        Format tag string. Its presence indicates that padding is expected
 * @param {string} width
 *        Desired length of the replaced value. Values less than this width shall be left
 *        zero padded
 * @return {string}
 *         Replacement for the matched identifier
 */ /**
 * Returns a function to be used as a callback for String.prototype.replace to replace
 * template identifiers
 *
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {replaceCallback}
 *         Callback to be used with String.prototype.replace to replace identifiers
 */ const $0ffb3c35bf172c1a$var$identifierReplacement = (values)=>(match, identifier, format, width)=>{
        if (match === "$$") // escape sequence
        return "$";
        if (typeof values[identifier] === "undefined") return match;
        const value = "" + values[identifier];
        if (identifier === "RepresentationID") // Format tag shall not be present with RepresentationID
        return value;
        if (!format) width = 1;
        else width = parseInt(width, 10);
        if (value.length >= width) return value;
        return `${new Array(width - value.length + 1).join("0")}${value}`;
    };
/**
 * Constructs a segment url from a template string
 *
 * @param {string} url
 *        Template string to construct url from
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {string}
 *         Segment url with identifiers replaced
 */ const $0ffb3c35bf172c1a$var$constructTemplateUrl = (url, values)=>url.replace($0ffb3c35bf172c1a$var$identifierPattern, $0ffb3c35bf172c1a$var$identifierReplacement(values));
/**
 * Generates a list of objects containing timing and duration information about each
 * segment needed to generate segment uris and the complete segment object
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */ const $0ffb3c35bf172c1a$var$parseTemplateInfo = (attributes, segmentTimeline)=>{
    if (!attributes.duration && !segmentTimeline) // if neither @duration or SegmentTimeline are present, then there shall be exactly
    // one media segment
    return [
        {
            number: attributes.startNumber || 1,
            duration: attributes.sourceDuration,
            time: 0,
            timeline: attributes.periodStart
        }
    ];
    if (attributes.duration) return $0ffb3c35bf172c1a$var$parseByDuration(attributes);
    return $0ffb3c35bf172c1a$var$parseByTimeline(attributes, segmentTimeline);
};
/**
 * Generates a list of segments using information provided by the SegmentTemplate element
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object[]}
 *         List of segment objects
 */ const $0ffb3c35bf172c1a$var$segmentsFromTemplate = (attributes, segmentTimeline)=>{
    const templateValues = {
        RepresentationID: attributes.id,
        Bandwidth: attributes.bandwidth || 0
    };
    const { initialization: initialization = {
        sourceURL: "",
        range: ""
    } } = attributes;
    const mapSegment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: attributes.baseUrl,
        source: $0ffb3c35bf172c1a$var$constructTemplateUrl(initialization.sourceURL, templateValues),
        range: initialization.range
    });
    const segments = $0ffb3c35bf172c1a$var$parseTemplateInfo(attributes, segmentTimeline);
    return segments.map((segment)=>{
        templateValues.Number = segment.number;
        templateValues.Time = segment.time;
        const uri = $0ffb3c35bf172c1a$var$constructTemplateUrl(attributes.media || "", templateValues); // See DASH spec section 5.3.9.2.2
        // - if timescale isn't present on any level, default to 1.
        const timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
        const presentationTimeOffset = attributes.presentationTimeOffset || 0;
        const presentationTime = // calculated in mpd-parser prior to this, so it's assumed to be available.
        attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
        const map = {
            uri: uri,
            timeline: segment.timeline,
            duration: segment.duration,
            resolvedUri: (0, $b6abcbe366420ffb$export$2e2bcd8739ae039)(attributes.baseUrl || "", uri),
            map: mapSegment,
            number: segment.number,
            presentationTime: presentationTime
        };
        return map;
    });
};
/**
 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
 * to an object that matches the output of a segment in videojs/mpd-parser
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object} segmentUrl
 *   <SegmentURL> node to translate into a segment object
 * @return {Object} translated segment object
 */ const $0ffb3c35bf172c1a$var$SegmentURLToSegmentObject = (attributes, segmentUrl)=>{
    const { baseUrl: baseUrl, initialization: initialization = {} } = attributes;
    const initSegment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: initialization.sourceURL,
        range: initialization.range
    });
    const segment = $0ffb3c35bf172c1a$var$urlTypeToSegment({
        baseUrl: baseUrl,
        source: segmentUrl.media,
        range: segmentUrl.mediaRange
    });
    segment.map = initSegment;
    return segment;
};
/**
 * Generates a list of segments using information provided by the SegmentList element
 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object.<Array>} list of segments
 */ const $0ffb3c35bf172c1a$var$segmentsFromList = (attributes, segmentTimeline)=>{
    const { duration: duration, segmentUrls: segmentUrls = [], periodStart: periodStart } = attributes; // Per spec (5.3.9.2.1) no way to determine segment duration OR
    // if both SegmentTimeline and @duration are defined, it is outside of spec.
    if (!duration && !segmentTimeline || duration && segmentTimeline) throw new Error($0ffb3c35bf172c1a$var$errors.SEGMENT_TIME_UNSPECIFIED);
    const segmentUrlMap = segmentUrls.map((segmentUrlObject)=>$0ffb3c35bf172c1a$var$SegmentURLToSegmentObject(attributes, segmentUrlObject));
    let segmentTimeInfo;
    if (duration) segmentTimeInfo = $0ffb3c35bf172c1a$var$parseByDuration(attributes);
    if (segmentTimeline) segmentTimeInfo = $0ffb3c35bf172c1a$var$parseByTimeline(attributes, segmentTimeline);
    const segments = segmentTimeInfo.map((segmentTime, index)=>{
        if (segmentUrlMap[index]) {
            const segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
            // - if timescale isn't present on any level, default to 1.
            const timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
            const presentationTimeOffset = attributes.presentationTimeOffset || 0;
            segment.timeline = segmentTime.timeline;
            segment.duration = segmentTime.duration;
            segment.number = segmentTime.number;
            segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
            return segment;
        } // Since we're mapping we should get rid of any blank segments (in case
    // the given SegmentTimeline is handling for more elements than we have
    // SegmentURLs for).
    }).filter((segment)=>segment);
    return segments;
};
const $0ffb3c35bf172c1a$var$generateSegments = ({ attributes: attributes, segmentInfo: segmentInfo })=>{
    let segmentAttributes;
    let segmentsFn;
    if (segmentInfo.template) {
        segmentsFn = $0ffb3c35bf172c1a$var$segmentsFromTemplate;
        segmentAttributes = $0ffb3c35bf172c1a$var$merge(attributes, segmentInfo.template);
    } else if (segmentInfo.base) {
        segmentsFn = $0ffb3c35bf172c1a$var$segmentsFromBase;
        segmentAttributes = $0ffb3c35bf172c1a$var$merge(attributes, segmentInfo.base);
    } else if (segmentInfo.list) {
        segmentsFn = $0ffb3c35bf172c1a$var$segmentsFromList;
        segmentAttributes = $0ffb3c35bf172c1a$var$merge(attributes, segmentInfo.list);
    }
    const segmentsInfo = {
        attributes: attributes
    };
    if (!segmentsFn) return segmentsInfo;
    const segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
    // must be in seconds. Since we've generated the segment list, we no longer need
    // @duration to be in @timescale units, so we can convert it here.
    if (segmentAttributes.duration) {
        const { duration: duration, timescale: timescale = 1 } = segmentAttributes;
        segmentAttributes.duration = duration / timescale;
    } else if (segments.length) // if there is no @duration attribute, use the largest segment duration as
    // as target duration
    segmentAttributes.duration = segments.reduce((max, segment)=>{
        return Math.max(max, Math.ceil(segment.duration));
    }, 0);
    else segmentAttributes.duration = 0;
    segmentsInfo.attributes = segmentAttributes;
    segmentsInfo.segments = segments; // This is a sidx box without actual segment information
    if (segmentInfo.base && segmentAttributes.indexRange) {
        segmentsInfo.sidx = segments[0];
        segmentsInfo.segments = [];
    }
    return segmentsInfo;
};
const $0ffb3c35bf172c1a$export$4362d710904f703f = (representations)=>representations.map($0ffb3c35bf172c1a$var$generateSegments);
const $0ffb3c35bf172c1a$var$findChildren = (element, name)=>$0ffb3c35bf172c1a$var$from(element.childNodes).filter(({ tagName: tagName })=>tagName === name);
const $0ffb3c35bf172c1a$var$getContent = (element)=>element.textContent.trim();
/**
 * Converts the provided string that may contain a division operation to a number.
 *
 * @param {string} value - the provided string value
 *
 * @return {number} the parsed string value
 */ const $0ffb3c35bf172c1a$var$parseDivisionValue = (value)=>{
    return parseFloat(value.split("/").reduce((prev, current)=>prev / current));
};
const $0ffb3c35bf172c1a$var$parseDuration = (str)=>{
    const SECONDS_IN_YEAR = 31536000;
    const SECONDS_IN_MONTH = 2592000;
    const SECONDS_IN_DAY = 86400;
    const SECONDS_IN_HOUR = 3600;
    const SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S
    const durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
    const match = durationRegex.exec(str);
    if (!match) return 0;
    const [year, month, day, hour, minute, second] = match.slice(1);
    return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
};
const $0ffb3c35bf172c1a$var$parseDate = (str)=>{
    // Date format without timezone according to ISO 8601
    // YYY-MM-DDThh:mm:ss.ssssss
    const dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
    // expressed by ending with 'Z'
    if (dateRegex.test(str)) str += "Z";
    return Date.parse(str);
};
const $0ffb3c35bf172c1a$var$parsers = {
    /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ mediaPresentationDuration (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */ availabilityStartTime (value) {
        return $0ffb3c35bf172c1a$var$parseDate(value) / 1000;
    },
    /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ minimumUpdatePeriod (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ suggestedPresentationDelay (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */ type (value) {
        return value;
    },
    /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ timeShiftBufferDepth (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */ start (value) {
        return $0ffb3c35bf172c1a$var$parseDuration(value);
    },
    /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */ width (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */ height (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */ bandwidth (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */ frameRate (value) {
        return $0ffb3c35bf172c1a$var$parseDivisionValue(value);
    },
    /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */ startNumber (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */ timescale (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */ presentationTimeOffset (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */ duration (value) {
        const parsedValue = parseInt(value, 10);
        if (isNaN(parsedValue)) return $0ffb3c35bf172c1a$var$parseDuration(value);
        return parsedValue;
    },
    /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */ d (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */ t (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */ r (value) {
        return parseInt(value, 10);
    },
    /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */ presentationTime (value) {
        return parseInt(value, 10);
    },
    /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */ DEFAULT (value) {
        return value;
    }
};
/**
 * Gets all the attributes and values of the provided node, parses attributes with known
 * types, and returns an object with attribute names mapped to values.
 *
 * @param {Node} el
 *        The node to parse attributes from
 * @return {Object}
 *         Object with all attributes of el parsed
 */ const $0ffb3c35bf172c1a$var$parseAttributes = (el)=>{
    if (!(el && el.attributes)) return {};
    return $0ffb3c35bf172c1a$var$from(el.attributes).reduce((a, e)=>{
        const parseFn = $0ffb3c35bf172c1a$var$parsers[e.name] || $0ffb3c35bf172c1a$var$parsers.DEFAULT;
        a[e.name] = parseFn(e.value);
        return a;
    }, {});
};
const $0ffb3c35bf172c1a$var$keySystemsMap = {
    "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
    "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
    "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
    "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
};
/**
 * Builds a list of urls that is the product of the reference urls and BaseURL values
 *
 * @param {Object[]} references
 *        List of objects containing the reference URL as well as its attributes
 * @param {Node[]} baseUrlElements
 *        List of BaseURL nodes from the mpd
 * @return {Object[]}
 *         List of objects with resolved urls and attributes
 */ const $0ffb3c35bf172c1a$var$buildBaseUrls = (references, baseUrlElements)=>{
    if (!baseUrlElements.length) return references;
    return $0ffb3c35bf172c1a$var$flatten(references.map(function(reference) {
        return baseUrlElements.map(function(baseUrlElement) {
            const initialBaseUrl = $0ffb3c35bf172c1a$var$getContent(baseUrlElement);
            const resolvedBaseUrl = (0, $b6abcbe366420ffb$export$2e2bcd8739ae039)(reference.baseUrl, initialBaseUrl);
            const finalBaseUrl = $0ffb3c35bf172c1a$var$merge($0ffb3c35bf172c1a$var$parseAttributes(baseUrlElement), {
                baseUrl: resolvedBaseUrl
            }); // If the URL is resolved, we want to get the serviceLocation from the reference
            // assuming there is no serviceLocation on the initialBaseUrl
            if (resolvedBaseUrl !== initialBaseUrl && !finalBaseUrl.serviceLocation && reference.serviceLocation) finalBaseUrl.serviceLocation = reference.serviceLocation;
            return finalBaseUrl;
        });
    }));
};
/**
 * Contains all Segment information for its containing AdaptationSet
 *
 * @typedef {Object} SegmentInformation
 * @property {Object|undefined} template
 *           Contains the attributes for the SegmentTemplate node
 * @property {Object[]|undefined} segmentTimeline
 *           Contains a list of atrributes for each S node within the SegmentTimeline node
 * @property {Object|undefined} list
 *           Contains the attributes for the SegmentList node
 * @property {Object|undefined} base
 *           Contains the attributes for the SegmentBase node
 */ /**
 * Returns all available Segment information contained within the AdaptationSet node
 *
 * @param {Node} adaptationSet
 *        The AdaptationSet node to get Segment information from
 * @return {SegmentInformation}
 *         The Segment information contained within the provided AdaptationSet
 */ const $0ffb3c35bf172c1a$var$getSegmentInformation = (adaptationSet)=>{
    const segmentTemplate = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "SegmentTemplate")[0];
    const segmentList = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "SegmentList")[0];
    const segmentUrls = segmentList && $0ffb3c35bf172c1a$var$findChildren(segmentList, "SegmentURL").map((s)=>$0ffb3c35bf172c1a$var$merge({
            tag: "SegmentURL"
        }, $0ffb3c35bf172c1a$var$parseAttributes(s)));
    const segmentBase = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "SegmentBase")[0];
    const segmentTimelineParentNode = segmentList || segmentTemplate;
    const segmentTimeline = segmentTimelineParentNode && $0ffb3c35bf172c1a$var$findChildren(segmentTimelineParentNode, "SegmentTimeline")[0];
    const segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
    const segmentInitialization = segmentInitializationParentNode && $0ffb3c35bf172c1a$var$findChildren(segmentInitializationParentNode, "Initialization")[0]; // SegmentTemplate is handled slightly differently, since it can have both
    // @initialization and an <Initialization> node.  @initialization can be templated,
    // while the node can have a url and range specified.  If the <SegmentTemplate> has
    // both @initialization and an <Initialization> subelement we opt to override with
    // the node, as this interaction is not defined in the spec.
    const template = segmentTemplate && $0ffb3c35bf172c1a$var$parseAttributes(segmentTemplate);
    if (template && segmentInitialization) template.initialization = segmentInitialization && $0ffb3c35bf172c1a$var$parseAttributes(segmentInitialization);
    else if (template && template.initialization) // If it is @initialization we convert it to an object since this is the format that
    // later functions will rely on for the initialization segment.  This is only valid
    // for <SegmentTemplate>
    template.initialization = {
        sourceURL: template.initialization
    };
    const segmentInfo = {
        template: template,
        segmentTimeline: segmentTimeline && $0ffb3c35bf172c1a$var$findChildren(segmentTimeline, "S").map((s)=>$0ffb3c35bf172c1a$var$parseAttributes(s)),
        list: segmentList && $0ffb3c35bf172c1a$var$merge($0ffb3c35bf172c1a$var$parseAttributes(segmentList), {
            segmentUrls: segmentUrls,
            initialization: $0ffb3c35bf172c1a$var$parseAttributes(segmentInitialization)
        }),
        base: segmentBase && $0ffb3c35bf172c1a$var$merge($0ffb3c35bf172c1a$var$parseAttributes(segmentBase), {
            initialization: $0ffb3c35bf172c1a$var$parseAttributes(segmentInitialization)
        })
    };
    Object.keys(segmentInfo).forEach((key)=>{
        if (!segmentInfo[key]) delete segmentInfo[key];
    });
    return segmentInfo;
};
/**
 * Contains Segment information and attributes needed to construct a Playlist object
 * from a Representation
 *
 * @typedef {Object} RepresentationInformation
 * @property {SegmentInformation} segmentInfo
 *           Segment information for this Representation
 * @property {Object} attributes
 *           Inherited attributes for this Representation
 */ /**
 * Maps a Representation node to an object containing Segment information and attributes
 *
 * @name inheritBaseUrlsCallback
 * @function
 * @param {Node} representation
 *        Representation node from the mpd
 * @return {RepresentationInformation}
 *         Representation information needed to construct a Playlist object
 */ /**
 * Returns a callback for Array.prototype.map for mapping Representation nodes to
 * Segment information and attributes using inherited BaseURL nodes.
 *
 * @param {Object} adaptationSetAttributes
 *        Contains attributes inherited by the AdaptationSet
 * @param {Object[]} adaptationSetBaseUrls
 *        List of objects containing resolved base URLs and attributes
 *        inherited by the AdaptationSet
 * @param {SegmentInformation} adaptationSetSegmentInfo
 *        Contains Segment information for the AdaptationSet
 * @return {inheritBaseUrlsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$inheritBaseUrls = (adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo)=>(representation)=>{
        const repBaseUrlElements = $0ffb3c35bf172c1a$var$findChildren(representation, "BaseURL");
        const repBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
        const attributes = $0ffb3c35bf172c1a$var$merge(adaptationSetAttributes, $0ffb3c35bf172c1a$var$parseAttributes(representation));
        const representationSegmentInfo = $0ffb3c35bf172c1a$var$getSegmentInformation(representation);
        return repBaseUrls.map((baseUrl)=>{
            return {
                segmentInfo: $0ffb3c35bf172c1a$var$merge(adaptationSetSegmentInfo, representationSegmentInfo),
                attributes: $0ffb3c35bf172c1a$var$merge(attributes, baseUrl)
            };
        });
    };
/**
 * Tranforms a series of content protection nodes to
 * an object containing pssh data by key system
 *
 * @param {Node[]} contentProtectionNodes
 *        Content protection nodes
 * @return {Object}
 *        Object containing pssh data by key system
 */ const $0ffb3c35bf172c1a$var$generateKeySystemInformation = (contentProtectionNodes)=>{
    return contentProtectionNodes.reduce((acc, node)=>{
        const attributes = $0ffb3c35bf172c1a$var$parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
        // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
        // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
        // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).
        if (attributes.schemeIdUri) attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
        const keySystem = $0ffb3c35bf172c1a$var$keySystemsMap[attributes.schemeIdUri];
        if (keySystem) {
            acc[keySystem] = {
                attributes: attributes
            };
            const psshNode = $0ffb3c35bf172c1a$var$findChildren(node, "cenc:pssh")[0];
            if (psshNode) {
                const pssh = $0ffb3c35bf172c1a$var$getContent(psshNode);
                acc[keySystem].pssh = pssh && (0, $82b8ded315bc5530$export$2e2bcd8739ae039)(pssh);
            }
        }
        return acc;
    }, {});
}; // defined in ANSI_SCTE 214-1 2016
const $0ffb3c35bf172c1a$var$parseCaptionServiceMetadata = (service)=>{
    // 608 captions
    if (service.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") {
        const values = typeof service.value !== "string" ? [] : service.value.split(";");
        return values.map((value)=>{
            let channel;
            let language; // default language to value
            language = value;
            if (/^CC\d=/.test(value)) [channel, language] = value.split("=");
            else if (/^CC\d$/.test(value)) channel = value;
            return {
                channel: channel,
                language: language
            };
        });
    } else if (service.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") {
        const values = typeof service.value !== "string" ? [] : service.value.split(";");
        return values.map((value)=>{
            const flags = {
                // service or channel number 1-63
                "channel": undefined,
                // language is a 3ALPHA per ISO 639.2/B
                // field is required
                "language": undefined,
                // BIT 1/0 or ?
                // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
                "aspectRatio": 1,
                // BIT 1/0
                // easy reader flag indicated the text is tailed to the needs of beginning readers
                // default 0, or off
                "easyReader": 0,
                // BIT 1/0
                // If 3d metadata is present (CEA-708.1) then 1
                // default 0
                "3D": 0
            };
            if (/=/.test(value)) {
                const [channel, opts = ""] = value.split("=");
                flags.channel = channel;
                flags.language = value;
                opts.split(",").forEach((opt)=>{
                    const [name, val] = opt.split(":");
                    if (name === "lang") flags.language = val; // er for easyReadery
                    else if (name === "er") flags.easyReader = Number(val); // war for wide aspect ratio
                    else if (name === "war") flags.aspectRatio = Number(val);
                    else if (name === "3D") flags["3D"] = Number(val);
                });
            } else flags.language = value;
            if (flags.channel) flags.channel = "SERVICE" + flags.channel;
            return flags;
        });
    }
};
/**
 * A map callback that will parse all event stream data for a collection of periods
 * DASH ISO_IEC_23009 5.10.2.2
 * https://dashif-documents.azurewebsites.net/Events/master/event.html#mpd-event-timing
 *
 * @param {PeriodInformation} period object containing necessary period information
 * @return a collection of parsed eventstream event objects
 */ const $0ffb3c35bf172c1a$var$toEventStream = (period)=>{
    // get and flatten all EventStreams tags and parse attributes and children
    return $0ffb3c35bf172c1a$var$flatten($0ffb3c35bf172c1a$var$findChildren(period.node, "EventStream").map((eventStream)=>{
        const eventStreamAttributes = $0ffb3c35bf172c1a$var$parseAttributes(eventStream);
        const schemeIdUri = eventStreamAttributes.schemeIdUri; // find all Events per EventStream tag and map to return objects
        return $0ffb3c35bf172c1a$var$findChildren(eventStream, "Event").map((event)=>{
            const eventAttributes = $0ffb3c35bf172c1a$var$parseAttributes(event);
            const presentationTime = eventAttributes.presentationTime || 0;
            const timescale = eventStreamAttributes.timescale || 1;
            const duration = eventAttributes.duration || 0;
            const start = presentationTime / timescale + period.attributes.start;
            return {
                schemeIdUri: schemeIdUri,
                value: eventStreamAttributes.value,
                id: eventAttributes.id,
                start: start,
                end: start + duration / timescale,
                messageData: $0ffb3c35bf172c1a$var$getContent(event) || eventAttributes.messageData,
                contentEncoding: eventStreamAttributes.contentEncoding,
                presentationTimeOffset: eventStreamAttributes.presentationTimeOffset || 0
            };
        });
    }));
};
/**
 * Maps an AdaptationSet node to a list of Representation information objects
 *
 * @name toRepresentationsCallback
 * @function
 * @param {Node} adaptationSet
 *        AdaptationSet node from the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */ /**
 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
 * Representation information objects
 *
 * @param {Object} periodAttributes
 *        Contains attributes inherited by the Period
 * @param {Object[]} periodBaseUrls
 *        Contains list of objects with resolved base urls and attributes
 *        inherited by the Period
 * @param {string[]} periodSegmentInfo
 *        Contains Segment Information at the period level
 * @return {toRepresentationsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$toRepresentations = (periodAttributes, periodBaseUrls, periodSegmentInfo)=>(adaptationSet)=>{
        const adaptationSetAttributes = $0ffb3c35bf172c1a$var$parseAttributes(adaptationSet);
        const adaptationSetBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls(periodBaseUrls, $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "BaseURL"));
        const role = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "Role")[0];
        const roleAttributes = {
            role: $0ffb3c35bf172c1a$var$parseAttributes(role)
        };
        let attrs = $0ffb3c35bf172c1a$var$merge(periodAttributes, adaptationSetAttributes, roleAttributes);
        const accessibility = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "Accessibility")[0];
        const captionServices = $0ffb3c35bf172c1a$var$parseCaptionServiceMetadata($0ffb3c35bf172c1a$var$parseAttributes(accessibility));
        if (captionServices) attrs = $0ffb3c35bf172c1a$var$merge(attrs, {
            captionServices: captionServices
        });
        const label = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "Label")[0];
        if (label && label.childNodes.length) {
            const labelVal = label.childNodes[0].nodeValue.trim();
            attrs = $0ffb3c35bf172c1a$var$merge(attrs, {
                label: labelVal
            });
        }
        const contentProtection = $0ffb3c35bf172c1a$var$generateKeySystemInformation($0ffb3c35bf172c1a$var$findChildren(adaptationSet, "ContentProtection"));
        if (Object.keys(contentProtection).length) attrs = $0ffb3c35bf172c1a$var$merge(attrs, {
            contentProtection: contentProtection
        });
        const segmentInfo = $0ffb3c35bf172c1a$var$getSegmentInformation(adaptationSet);
        const representations = $0ffb3c35bf172c1a$var$findChildren(adaptationSet, "Representation");
        const adaptationSetSegmentInfo = $0ffb3c35bf172c1a$var$merge(periodSegmentInfo, segmentInfo);
        return $0ffb3c35bf172c1a$var$flatten(representations.map($0ffb3c35bf172c1a$var$inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
    };
/**
 * Contains all period information for mapping nodes onto adaptation sets.
 *
 * @typedef {Object} PeriodInformation
 * @property {Node} period.node
 *           Period node from the mpd
 * @property {Object} period.attributes
 *           Parsed period attributes from node plus any added
 */ /**
 * Maps a PeriodInformation object to a list of Representation information objects for all
 * AdaptationSet nodes contained within the Period.
 *
 * @name toAdaptationSetsCallback
 * @function
 * @param {PeriodInformation} period
 *        Period object containing necessary period information
 * @param {number} periodStart
 *        Start time of the Period within the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */ /**
 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
 * Representation information objects
 *
 * @param {Object} mpdAttributes
 *        Contains attributes inherited by the mpd
  * @param {Object[]} mpdBaseUrls
 *        Contains list of objects with resolved base urls and attributes
 *        inherited by the mpd
 * @return {toAdaptationSetsCallback}
 *         Callback map function
 */ const $0ffb3c35bf172c1a$var$toAdaptationSets = (mpdAttributes, mpdBaseUrls)=>(period, index)=>{
        const periodBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls(mpdBaseUrls, $0ffb3c35bf172c1a$var$findChildren(period.node, "BaseURL"));
        const periodAttributes = $0ffb3c35bf172c1a$var$merge(mpdAttributes, {
            periodStart: period.attributes.start
        });
        if (typeof period.attributes.duration === "number") periodAttributes.periodDuration = period.attributes.duration;
        const adaptationSets = $0ffb3c35bf172c1a$var$findChildren(period.node, "AdaptationSet");
        const periodSegmentInfo = $0ffb3c35bf172c1a$var$getSegmentInformation(period.node);
        return $0ffb3c35bf172c1a$var$flatten(adaptationSets.map($0ffb3c35bf172c1a$var$toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
    };
/**
 * Tranforms an array of content steering nodes into an object
 * containing CDN content steering information from the MPD manifest.
 *
 * For more information on the DASH spec for Content Steering parsing, see:
 * https://dashif.org/docs/DASH-IF-CTS-00XX-Content-Steering-Community-Review.pdf
 *
 * @param {Node[]} contentSteeringNodes
 *        Content steering nodes
 * @param {Function} eventHandler
 *        The event handler passed into the parser options to handle warnings
 * @return {Object}
 *        Object containing content steering data
 */ const $0ffb3c35bf172c1a$var$generateContentSteeringInformation = (contentSteeringNodes, eventHandler)=>{
    // If there are more than one ContentSteering tags, throw an error
    if (contentSteeringNodes.length > 1) eventHandler({
        type: "warn",
        message: "The MPD manifest should contain no more than one ContentSteering tag"
    });
     // Return a null value if there are no ContentSteering tags
    if (!contentSteeringNodes.length) return null;
    const infoFromContentSteeringTag = $0ffb3c35bf172c1a$var$merge({
        serverURL: $0ffb3c35bf172c1a$var$getContent(contentSteeringNodes[0])
    }, $0ffb3c35bf172c1a$var$parseAttributes(contentSteeringNodes[0])); // Converts `queryBeforeStart` to a boolean, as well as setting the default value
    // to `false` if it doesn't exist
    infoFromContentSteeringTag.queryBeforeStart = infoFromContentSteeringTag.queryBeforeStart === "true";
    return infoFromContentSteeringTag;
};
/**
 * Gets Period@start property for a given period.
 *
 * @param {Object} options
 *        Options object
 * @param {Object} options.attributes
 *        Period attributes
 * @param {Object} [options.priorPeriodAttributes]
 *        Prior period attributes (if prior period is available)
 * @param {string} options.mpdType
 *        The MPD@type these periods came from
 * @return {number|null}
 *         The period start, or null if it's an early available period or error
 */ const $0ffb3c35bf172c1a$var$getPeriodStart = ({ attributes: attributes, priorPeriodAttributes: priorPeriodAttributes, mpdType: mpdType })=>{
    // Summary of period start time calculation from DASH spec section 5.3.2.1
    //
    // A period's start is the first period's start + time elapsed after playing all
    // prior periods to this one. Periods continue one after the other in time (without
    // gaps) until the end of the presentation.
    //
    // The value of Period@start should be:
    // 1. if Period@start is present: value of Period@start
    // 2. if previous period exists and it has @duration: previous Period@start +
    //    previous Period@duration
    // 3. if this is first period and MPD@type is 'static': 0
    // 4. in all other cases, consider the period an "early available period" (note: not
    //    currently supported)
    // (1)
    if (typeof attributes.start === "number") return attributes.start;
     // (2)
    if (priorPeriodAttributes && typeof priorPeriodAttributes.start === "number" && typeof priorPeriodAttributes.duration === "number") return priorPeriodAttributes.start + priorPeriodAttributes.duration;
     // (3)
    if (!priorPeriodAttributes && mpdType === "static") return 0;
     // (4)
    // There is currently no logic for calculating the Period@start value if there is
    // no Period@start or prior Period@start and Period@duration available. This is not made
    // explicit by the DASH interop guidelines or the DASH spec, however, since there's
    // nothing about any other resolution strategies, it's implied. Thus, this case should
    // be considered an early available period, or error, and null should suffice for both
    // of those cases.
    return null;
};
/**
 * Traverses the mpd xml tree to generate a list of Representation information objects
 * that have inherited attributes from parent nodes
 *
 * @param {Node} mpd
 *        The root node of the mpd
 * @param {Object} options
 *        Available options for inheritAttributes
 * @param {string} options.manifestUri
 *        The uri source of the mpd
 * @param {number} options.NOW
 *        Current time per DASH IOP.  Default is current time in ms since epoch
 * @param {number} options.clientOffset
 *        Client time difference from NOW (in milliseconds)
 * @return {RepresentationInformation[]}
 *         List of objects containing Representation information
 */ const $0ffb3c35bf172c1a$export$1d58e194e30f14d4 = (mpd, options = {})=>{
    const { manifestUri: manifestUri = "", NOW: NOW = Date.now(), clientOffset: clientOffset = 0, eventHandler: // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler = function() {} } = options;
    const periodNodes = $0ffb3c35bf172c1a$var$findChildren(mpd, "Period");
    if (!periodNodes.length) throw new Error($0ffb3c35bf172c1a$var$errors.INVALID_NUMBER_OF_PERIOD);
    const locations = $0ffb3c35bf172c1a$var$findChildren(mpd, "Location");
    const mpdAttributes = $0ffb3c35bf172c1a$var$parseAttributes(mpd);
    const mpdBaseUrls = $0ffb3c35bf172c1a$var$buildBaseUrls([
        {
            baseUrl: manifestUri
        }
    ], $0ffb3c35bf172c1a$var$findChildren(mpd, "BaseURL"));
    const contentSteeringNodes = $0ffb3c35bf172c1a$var$findChildren(mpd, "ContentSteering"); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.
    mpdAttributes.type = mpdAttributes.type || "static";
    mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
    mpdAttributes.NOW = NOW;
    mpdAttributes.clientOffset = clientOffset;
    if (locations.length) mpdAttributes.locations = locations.map($0ffb3c35bf172c1a$var$getContent);
    const periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
    // adding properties that require looking at prior periods is to parse attributes and add
    // missing ones before toAdaptationSets is called. If more such properties are added, it
    // may be better to refactor toAdaptationSets.
    periodNodes.forEach((node, index)=>{
        const attributes = $0ffb3c35bf172c1a$var$parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
        // for this period.
        const priorPeriod = periods[index - 1];
        attributes.start = $0ffb3c35bf172c1a$var$getPeriodStart({
            attributes: attributes,
            priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
            mpdType: mpdAttributes.type
        });
        periods.push({
            node: node,
            attributes: attributes
        });
    });
    return {
        locations: mpdAttributes.locations,
        contentSteeringInfo: $0ffb3c35bf172c1a$var$generateContentSteeringInformation(contentSteeringNodes, eventHandler),
        // TODO: There are occurences where this `representationInfo` array contains undesired
        // duplicates. This generally occurs when there are multiple BaseURL nodes that are
        // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
        // parent BaseURL and a child BaseURL, and the value does not resolve,
        // we end up returning the child BaseURL multiple times.
        // We need to determine a way to remove these duplicates in a safe way.
        // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
        representationInfo: $0ffb3c35bf172c1a$var$flatten(periods.map($0ffb3c35bf172c1a$var$toAdaptationSets(mpdAttributes, mpdBaseUrls))),
        eventStream: $0ffb3c35bf172c1a$var$flatten(periods.map($0ffb3c35bf172c1a$var$toEventStream))
    };
};
const $0ffb3c35bf172c1a$export$d9d51d4eae920a2a = (manifestString)=>{
    if (manifestString === "") throw new Error($0ffb3c35bf172c1a$var$errors.DASH_EMPTY_MANIFEST);
    const parser = new (0, $515447b9158f86cb$export$1059c6e7d2ce5669)();
    let xml;
    let mpd;
    try {
        xml = parser.parseFromString(manifestString, "application/xml");
        mpd = xml && xml.documentElement.tagName === "MPD" ? xml.documentElement : null;
    } catch (e) {}
    if (!mpd || mpd && mpd.getElementsByTagName("parsererror").length > 0) throw new Error($0ffb3c35bf172c1a$var$errors.DASH_INVALID_XML);
    return mpd;
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} mpd
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */ const $0ffb3c35bf172c1a$var$parseUTCTimingScheme = (mpd)=>{
    const UTCTimingNode = $0ffb3c35bf172c1a$var$findChildren(mpd, "UTCTiming")[0];
    if (!UTCTimingNode) return null;
    const attributes = $0ffb3c35bf172c1a$var$parseAttributes(UTCTimingNode);
    switch(attributes.schemeIdUri){
        case "urn:mpeg:dash:utc:http-head:2014":
        case "urn:mpeg:dash:utc:http-head:2012":
            attributes.method = "HEAD";
            break;
        case "urn:mpeg:dash:utc:http-xsdate:2014":
        case "urn:mpeg:dash:utc:http-iso:2014":
        case "urn:mpeg:dash:utc:http-xsdate:2012":
        case "urn:mpeg:dash:utc:http-iso:2012":
            attributes.method = "GET";
            break;
        case "urn:mpeg:dash:utc:direct:2014":
        case "urn:mpeg:dash:utc:direct:2012":
            attributes.method = "DIRECT";
            attributes.value = Date.parse(attributes.value);
            break;
        case "urn:mpeg:dash:utc:http-ntp:2014":
        case "urn:mpeg:dash:utc:ntp:2014":
        case "urn:mpeg:dash:utc:sntp:2014":
        default:
            throw new Error($0ffb3c35bf172c1a$var$errors.UNSUPPORTED_UTC_TIMING_SCHEME);
    }
    return attributes;
};
const $0ffb3c35bf172c1a$export$a4ad2735b021c132 = $0ffb3c35bf172c1a$var$version;
/*
 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
 *
 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
 * parsed DASH manifest will have its media sequence and discontinuity sequence values
 * updated to reflect its position relative to the prior manifest.
 *
 * @param {string} manifestString - the DASH manifest as a string
 * @param {options} [options] - any options
 *
 * @return {Object} the manifest object
 */ const $0ffb3c35bf172c1a$export$98e6a39c04603d36 = (manifestString, options = {})=>{
    const parsedManifestInfo = $0ffb3c35bf172c1a$export$1d58e194e30f14d4($0ffb3c35bf172c1a$export$d9d51d4eae920a2a(manifestString), options);
    const playlists = $0ffb3c35bf172c1a$export$4362d710904f703f(parsedManifestInfo.representationInfo);
    return $0ffb3c35bf172c1a$export$c90e7d9f067c8f2c({
        dashPlaylists: playlists,
        locations: parsedManifestInfo.locations,
        contentSteering: parsedManifestInfo.contentSteeringInfo,
        sidxMapping: options.sidxMapping,
        previousManifest: options.previousManifest,
        eventStream: parsedManifestInfo.eventStream
    });
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} manifestString
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */ const $0ffb3c35bf172c1a$export$734c7278b5d0068c = (manifestString)=>$0ffb3c35bf172c1a$var$parseUTCTimingScheme($0ffb3c35bf172c1a$export$d9d51d4eae920a2a(manifestString));


var $7d9f1a0178bc82dd$exports = {};
var $4c5fef9166c0ab70$exports = {};
var $4c5fef9166c0ab70$var$MAX_UINT32 = Math.pow(2, 32);
var $4c5fef9166c0ab70$var$getUint64 = function(uint8) {
    var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
    var value;
    if (dv.getBigUint64) {
        value = dv.getBigUint64(0);
        if (value < Number.MAX_SAFE_INTEGER) return Number(value);
        return value;
    }
    return dv.getUint32(0) * $4c5fef9166c0ab70$var$MAX_UINT32 + dv.getUint32(4);
};
$4c5fef9166c0ab70$exports = {
    getUint64: $4c5fef9166c0ab70$var$getUint64,
    MAX_UINT32: $4c5fef9166c0ab70$var$MAX_UINT32
};


var $7d9f1a0178bc82dd$require$getUint64 = $4c5fef9166c0ab70$exports.getUint64;
var $7d9f1a0178bc82dd$var$parseSidx = function(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
        version: data[0],
        flags: new Uint8Array(data.subarray(1, 4)),
        references: [],
        referenceId: view.getUint32(4),
        timescale: view.getUint32(8)
    }, i = 12;
    if (result.version === 0) {
        result.earliestPresentationTime = view.getUint32(i);
        result.firstOffset = view.getUint32(i + 4);
        i += 8;
    } else {
        // read 64 bits
        result.earliestPresentationTime = $7d9f1a0178bc82dd$require$getUint64(data.subarray(i));
        result.firstOffset = $7d9f1a0178bc82dd$require$getUint64(data.subarray(i + 8));
        i += 16;
    }
    i += 2; // reserved
    var referenceCount = view.getUint16(i);
    i += 2; // start of references
    for(; referenceCount > 0; i += 12, referenceCount--)result.references.push({
        referenceType: (data[i] & 0x80) >>> 7,
        referencedSize: view.getUint32(i) & 0x7FFFFFFF,
        subsegmentDuration: view.getUint32(i + 4),
        startsWithSap: !!(data[i + 8] & 0x80),
        sapType: (data[i + 8] & 0x70) >>> 4,
        sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
    });
    return result;
};
$7d9f1a0178bc82dd$exports = $7d9f1a0178bc82dd$var$parseSidx;



var $862e4a4ff1392639$var$ID3 = (0, $4bd18e93e919945b$export$63c3de442720649)([
    0x49,
    0x44,
    0x33
]);
var $862e4a4ff1392639$export$1d0ef9131773159b = function getId3Size(bytes, offset) {
    if (offset === void 0) offset = 0;
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    var flags = bytes[offset + 5];
    var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
    var footerPresent = (flags & 16) >> 4;
    if (footerPresent) return returnSize + 20;
    return returnSize + 10;
};
var $862e4a4ff1392639$export$56b6cacf09ec1126 = function getId3Offset(bytes, offset) {
    if (offset === void 0) offset = 0;
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    if (bytes.length - offset < 10 || !(0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $862e4a4ff1392639$var$ID3, {
        offset: offset
    })) return offset;
    offset += $862e4a4ff1392639$export$1d0ef9131773159b(bytes, offset); // recursive check for id3 tags as some files
    // have multiple ID3 tag sections even though
    // they should not.
    return getId3Offset(bytes, offset);
};





var $68f6ae2afedf5ec2$export$5ff37217be0e6718 = function getAv1Codec(bytes) {
    var codec = "";
    var profile = bytes[1] >>> 3;
    var level = bytes[1] & 0x1F;
    var tier = bytes[2] >>> 7;
    var highBitDepth = (bytes[2] & 0x40) >> 6;
    var twelveBit = (bytes[2] & 0x20) >> 5;
    var monochrome = (bytes[2] & 0x10) >> 4;
    var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
    var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
    var chromaSamplePosition = bytes[2] & 0x03;
    codec += profile + "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(level, 2, "0");
    if (tier === 0) codec += "M";
    else if (tier === 1) codec += "H";
    var bitDepth;
    if (profile === 2 && highBitDepth) bitDepth = twelveBit ? 12 : 10;
    else bitDepth = highBitDepth ? 10 : 8;
    codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(bitDepth, 2, "0"); // TODO: can we parse color range??
    codec += "." + monochrome;
    codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
    return codec;
};
var $68f6ae2afedf5ec2$export$f316fb16efba7de9 = function getAvcCodec(bytes) {
    var profileId = (0, $4bd18e93e919945b$export$f4915efbb94d4d01)(bytes[1]);
    var constraintFlags = (0, $4bd18e93e919945b$export$f4915efbb94d4d01)(bytes[2] & 0xFC);
    var levelId = (0, $4bd18e93e919945b$export$f4915efbb94d4d01)(bytes[3]);
    return "" + profileId + constraintFlags + levelId;
};
var $68f6ae2afedf5ec2$export$57f4fb41d46b44d9 = function getHvcCodec(bytes) {
    var codec = "";
    var profileSpace = bytes[1] >> 6;
    var profileId = bytes[1] & 0x1F;
    var tierFlag = (bytes[1] & 0x20) >> 5;
    var profileCompat = bytes.subarray(2, 6);
    var constraintIds = bytes.subarray(6, 12);
    var levelId = bytes[12];
    if (profileSpace === 1) codec += "A";
    else if (profileSpace === 2) codec += "B";
    else if (profileSpace === 3) codec += "C";
    codec += profileId + "."; // ffmpeg does this in big endian
    var profileCompatVal = parseInt((0, $4bd18e93e919945b$export$9a7d75f397723250)(profileCompat).split("").reverse().join(""), 2); // apple does this in little endian...
    if (profileCompatVal > 255) profileCompatVal = parseInt((0, $4bd18e93e919945b$export$9a7d75f397723250)(profileCompat), 2);
    codec += profileCompatVal.toString(16) + ".";
    if (tierFlag === 0) codec += "L";
    else codec += "H";
    codec += levelId;
    var constraints = "";
    for(var i = 0; i < constraintIds.length; i++){
        var v = constraintIds[i];
        if (v) {
            if (constraints) constraints += ".";
            constraints += v.toString(16);
        }
    }
    if (constraints) codec += "." + constraints;
    return codec;
};


var $459c05fa11483ba1$export$bbdb118c36f58091 = new Uint8Array([
    0x4f,
    0x70,
    0x75,
    0x73,
    0x48,
    0x65,
    0x61,
    0x64
]); // https://wiki.xiph.org/OggOpus
var $459c05fa11483ba1$export$162487c51ffd8212 = function parseOpusHead(bytes) {
    var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.
    var littleEndian = version !== 0;
    var config = {
        version: version,
        channels: view.getUint8(1),
        preSkip: view.getUint16(2, littleEndian),
        sampleRate: view.getUint32(4, littleEndian),
        outputGain: view.getUint16(8, littleEndian),
        channelMappingFamily: view.getUint8(10)
    };
    if (config.channelMappingFamily > 0 && bytes.length > 10) {
        config.streamCount = view.getUint8(11);
        config.twoChannelStreamCount = view.getUint8(12);
        config.channelMapping = [];
        for(var c = 0; c < config.channels; c++)config.channelMapping.push(view.getUint8(13 + c));
    }
    return config;
};
var $459c05fa11483ba1$export$57dc6f8263af01df = function setOpusHead(config) {
    var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
    var view = new DataView(new ArrayBuffer(size));
    var littleEndian = config.version !== 0;
    view.setUint8(0, config.version);
    view.setUint8(1, config.channels);
    view.setUint16(2, config.preSkip, littleEndian);
    view.setUint32(4, config.sampleRate, littleEndian);
    view.setUint16(8, config.outputGain, littleEndian);
    view.setUint8(10, config.channelMappingFamily);
    if (config.channelMappingFamily > 0) {
        view.setUint8(11, config.streamCount);
        config.channelMapping.foreach(function(cm, i) {
            view.setUint8(12 + i, cm);
        });
    }
    return new Uint8Array(view.buffer);
};


var $b432346f74fe917b$var$normalizePath = function normalizePath(path) {
    if (typeof path === "string") return (0, $4bd18e93e919945b$export$c8dd6bc66a63753c)(path);
    if (typeof path === "number") return path;
    return path;
};
var $b432346f74fe917b$var$normalizePaths = function normalizePaths(paths) {
    if (!Array.isArray(paths)) return [
        $b432346f74fe917b$var$normalizePath(paths)
    ];
    return paths.map(function(p) {
        return $b432346f74fe917b$var$normalizePath(p);
    });
};
var $b432346f74fe917b$var$DESCRIPTORS;
var $b432346f74fe917b$export$fe4700066a34ac73 = function parseDescriptors(bytes) {
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    var results = [];
    var i = 0;
    while(bytes.length > i){
        var tag = bytes[i];
        var size = 0;
        var headerSize = 0; // tag
        headerSize++;
        var byte = bytes[headerSize]; // first byte
        headerSize++;
        while(byte & 0x80){
            size = (byte & 0x7F) << 7;
            byte = bytes[headerSize];
            headerSize++;
        }
        size += byte & 0x7F;
        for(var z = 0; z < $b432346f74fe917b$var$DESCRIPTORS.length; z++){
            var _DESCRIPTORS$z = $b432346f74fe917b$var$DESCRIPTORS[z], id = _DESCRIPTORS$z.id, parser = _DESCRIPTORS$z.parser;
            if (tag === id) {
                results.push(parser(bytes.subarray(headerSize, headerSize + size)));
                break;
            }
        }
        i += size + headerSize;
    }
    return results;
};
$b432346f74fe917b$var$DESCRIPTORS = [
    {
        id: 0x03,
        parser: function parser(bytes) {
            var desc = {
                tag: 0x03,
                id: bytes[0] << 8 | bytes[1],
                flags: bytes[2],
                size: 3,
                dependsOnEsId: 0,
                ocrEsId: 0,
                descriptors: [],
                url: ""
            }; // depends on es id
            if (desc.flags & 0x80) {
                desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
                desc.size += 2;
            } // url
            if (desc.flags & 0x40) {
                var len = bytes[desc.size];
                desc.url = (0, $4bd18e93e919945b$export$7c746b75f47c9c7d)(bytes.subarray(desc.size + 1, desc.size + 1 + len));
                desc.size += len;
            } // ocr es id
            if (desc.flags & 0x20) {
                desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
                desc.size += 2;
            }
            desc.descriptors = $b432346f74fe917b$export$fe4700066a34ac73(bytes.subarray(desc.size)) || [];
            return desc;
        }
    },
    {
        id: 0x04,
        parser: function parser(bytes) {
            // DecoderConfigDescriptor
            var desc = {
                tag: 0x04,
                oti: bytes[0],
                streamType: bytes[1],
                bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
                maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
                avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
                descriptors: $b432346f74fe917b$export$fe4700066a34ac73(bytes.subarray(13))
            };
            return desc;
        }
    },
    {
        id: 0x05,
        parser: function parser(bytes) {
            // DecoderSpecificInfo
            return {
                tag: 0x05,
                bytes: bytes
            };
        }
    },
    {
        id: 0x06,
        parser: function parser(bytes) {
            // SLConfigDescriptor
            return {
                tag: 0x06,
                bytes: bytes
            };
        }
    }
];
var $b432346f74fe917b$export$d81d43b46e2012ef = function findBox(bytes, paths, complete) {
    if (complete === void 0) complete = false;
    paths = $b432346f74fe917b$var$normalizePaths(paths);
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    var results = [];
    if (!paths.length) // short-circuit the search for empty paths
    return results;
    var i = 0;
    while(i < bytes.length){
        var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
        var type = bytes.subarray(i + 4, i + 8); // invalid box format.
        if (size === 0) break;
        var end = i + size;
        if (end > bytes.length) {
            // this box is bigger than the number of bytes we have
            // and complete is set, we cannot find any more boxes.
            if (complete) break;
            end = bytes.length;
        }
        var data = bytes.subarray(i + 8, end);
        if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(type, paths[0])) {
            if (paths.length === 1) // this is the end of the path and we've found the box we were
            // looking for
            results.push(data);
            else // recursively search for the next box along the path
            results.push.apply(results, findBox(data, paths.slice(1), complete));
        }
        i = end;
    } // we've finished searching all of bytes
    return results;
};
var $b432346f74fe917b$export$610b5b08fd0ffeb4 = function findNamedBox(bytes, name) {
    name = $b432346f74fe917b$var$normalizePath(name);
    if (!name.length) // short-circuit the search for empty paths
    return bytes.subarray(bytes.length);
    var i = 0;
    while(i < bytes.length){
        if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes.subarray(i, i + name.length), name)) {
            var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
            var end = size > 1 ? i + size : bytes.byteLength;
            return bytes.subarray(i + 4, end);
        }
        i++;
    } // we've finished searching all of bytes
    return bytes.subarray(bytes.length);
};
var $b432346f74fe917b$var$parseSamples = function parseSamples(data, entrySize, parseEntry) {
    if (entrySize === void 0) entrySize = 4;
    if (parseEntry === void 0) parseEntry = function parseEntry(d) {
        return (0, $4bd18e93e919945b$export$c0cca17bcf674749)(d);
    };
    var entries = [];
    if (!data || !data.length) return entries;
    var entryCount = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(data.subarray(4, 8));
    for(var i = 8; entryCount; i += entrySize, entryCount--)entries.push(parseEntry(data.subarray(i, i + entrySize)));
    return entries;
};
var $b432346f74fe917b$export$78870b2844ff6386 = function buildFrameTable(stbl, timescale) {
    var keySamples = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        "stss"
    ])[0]);
    var chunkOffsets = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        "stco"
    ])[0]);
    var timeToSamples = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        "stts"
    ])[0], 8, function(entry) {
        return {
            sampleCount: (0, $4bd18e93e919945b$export$c0cca17bcf674749)(entry.subarray(0, 4)),
            sampleDelta: (0, $4bd18e93e919945b$export$c0cca17bcf674749)(entry.subarray(4, 8))
        };
    });
    var samplesToChunks = $b432346f74fe917b$var$parseSamples($b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        "stsc"
    ])[0], 12, function(entry) {
        return {
            firstChunk: (0, $4bd18e93e919945b$export$c0cca17bcf674749)(entry.subarray(0, 4)),
            samplesPerChunk: (0, $4bd18e93e919945b$export$c0cca17bcf674749)(entry.subarray(4, 8)),
            sampleDescriptionIndex: (0, $4bd18e93e919945b$export$c0cca17bcf674749)(entry.subarray(8, 12))
        };
    });
    var stsz = $b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
        "stsz"
    ])[0]; // stsz starts with a 4 byte sampleSize which we don't need
    var sampleSizes = $b432346f74fe917b$var$parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
    var frames = [];
    for(var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++){
        var samplesInChunk = void 0;
        for(var i = 0; i < samplesToChunks.length; i++){
            var sampleToChunk = samplesToChunks[i];
            var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
            if (isThisOne) {
                samplesInChunk = sampleToChunk.samplesPerChunk;
                break;
            }
        }
        var chunkOffset = chunkOffsets[chunkIndex];
        for(var _i = 0; _i < samplesInChunk; _i++){
            var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe
            var keyframe = !keySamples.length;
            if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) keyframe = true;
            var frame = {
                keyframe: keyframe,
                start: chunkOffset,
                end: chunkOffset + frameEnd
            };
            for(var k = 0; k < timeToSamples.length; k++){
                var _timeToSamples$k = timeToSamples[k], sampleCount = _timeToSamples$k.sampleCount, sampleDelta = _timeToSamples$k.sampleDelta;
                if (frames.length <= sampleCount) {
                    // ms to ns
                    var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
                    frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
                    frame.duration = sampleDelta;
                    break;
                }
            }
            frames.push(frame);
            chunkOffset += frameEnd;
        }
    }
    return frames;
};
var $b432346f74fe917b$export$56fdd13a804135bf = function addSampleDescription(track, bytes) {
    var codec = (0, $4bd18e93e919945b$export$7c746b75f47c9c7d)(bytes.subarray(0, 4));
    if (track.type === "video") {
        track.info = track.info || {};
        track.info.width = bytes[28] << 8 | bytes[29];
        track.info.height = bytes[30] << 8 | bytes[31];
    } else if (track.type === "audio") {
        track.info = track.info || {};
        track.info.channels = bytes[20] << 8 | bytes[21];
        track.info.bitDepth = bytes[22] << 8 | bytes[23];
        track.info.sampleRate = bytes[28] << 8 | bytes[29];
    }
    if (codec === "avc1") {
        var avcC = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, "avcC"); // AVCDecoderConfigurationRecord
        codec += "." + (0, $68f6ae2afedf5ec2$export$f316fb16efba7de9)(avcC);
        track.info.avcC = avcC; // TODO: do we need to parse all this?
    /* {
      configurationVersion: avcC[0],
      profile: avcC[1],
      profileCompatibility: avcC[2],
      level: avcC[3],
      lengthSizeMinusOne: avcC[4] & 0x3
    };
     let spsNalUnitCount = avcC[5] & 0x1F;
    const spsNalUnits = track.info.avc.spsNalUnits = [];
     // past spsNalUnitCount
    let offset = 6;
     while (spsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }
    let ppsNalUnitCount = avcC[offset];
    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
     // past ppsNalUnitCount
    offset += 1;
     while (ppsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }*/ // HEVCDecoderConfigurationRecord
    } else if (codec === "hvc1" || codec === "hev1") codec += "." + (0, $68f6ae2afedf5ec2$export$57f4fb41d46b44d9)($b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, "hvcC"));
    else if (codec === "mp4a" || codec === "mp4v") {
        var esds = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, "esds");
        var esDescriptor = $b432346f74fe917b$export$fe4700066a34ac73(esds.subarray(4))[0];
        var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function(_ref) {
            var tag = _ref.tag;
            return tag === 0x04;
        })[0];
        if (decoderConfig) {
            // most codecs do not have a further '.'
            // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
            codec += "." + (0, $4bd18e93e919945b$export$f4915efbb94d4d01)(decoderConfig.oti);
            if (decoderConfig.oti === 0x40) codec += "." + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
            else if (decoderConfig.oti === 0x20) codec += "." + decoderConfig.descriptors[0].bytes[4].toString();
            else if (decoderConfig.oti === 0xdd) codec = "vorbis";
        } else if (track.type === "audio") codec += ".40.2";
        else codec += ".20.9";
    } else if (codec === "av01") // AV1DecoderConfigurationRecord
    codec += "." + (0, $68f6ae2afedf5ec2$export$5ff37217be0e6718)($b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, "av1C"));
    else if (codec === "vp09") {
        // VPCodecConfigurationRecord
        var vpcC = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, "vpcC"); // https://www.webmproject.org/vp9/mp4/
        var profile = vpcC[0];
        var level = vpcC[1];
        var bitDepth = vpcC[2] >> 4;
        var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
        var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
        var colourPrimaries = vpcC[3];
        var transferCharacteristics = vpcC[4];
        var matrixCoefficients = vpcC[5];
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(profile, 2, "0");
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(level, 2, "0");
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(bitDepth, 2, "0");
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(chromaSubsampling, 2, "0");
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(colourPrimaries, 2, "0");
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(transferCharacteristics, 2, "0");
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(matrixCoefficients, 2, "0");
        codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(videoFullRangeFlag, 2, "0");
    } else if (codec === "theo") codec = "theora";
    else if (codec === "spex") codec = "speex";
    else if (codec === ".mp3") codec = "mp4a.40.34";
    else if (codec === "msVo") codec = "vorbis";
    else if (codec === "Opus") {
        codec = "opus";
        var dOps = $b432346f74fe917b$export$610b5b08fd0ffeb4(bytes, "dOps");
        track.info.opus = (0, $459c05fa11483ba1$export$162487c51ffd8212)(dOps); // TODO: should this go into the webm code??
        // Firefox requires a codecDelay for opus playback
        // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238
        track.info.codecDelay = 6500000;
    } else codec = codec.toLowerCase();
    /* eslint-enable */ // flac, ac-3, ec-3, opus
    track.codec = codec;
};
var $b432346f74fe917b$export$b9400b1cdedffc2a = function parseTracks(bytes, frameTable) {
    if (frameTable === void 0) frameTable = true;
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    var traks = $b432346f74fe917b$export$d81d43b46e2012ef(bytes, [
        "moov",
        "trak"
    ], true);
    var tracks = [];
    traks.forEach(function(trak) {
        var track = {
            bytes: trak
        };
        var mdia = $b432346f74fe917b$export$d81d43b46e2012ef(trak, [
            "mdia"
        ])[0];
        var hdlr = $b432346f74fe917b$export$d81d43b46e2012ef(mdia, [
            "hdlr"
        ])[0];
        var trakType = (0, $4bd18e93e919945b$export$7c746b75f47c9c7d)(hdlr.subarray(8, 12));
        if (trakType === "soun") track.type = "audio";
        else if (trakType === "vide") track.type = "video";
        else track.type = trakType;
        var tkhd = $b432346f74fe917b$export$d81d43b46e2012ef(trak, [
            "tkhd"
        ])[0];
        if (tkhd) {
            var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
            var tkhdVersion = view.getUint8(0);
            track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
        }
        var mdhd = $b432346f74fe917b$export$d81d43b46e2012ef(mdia, [
            "mdhd"
        ])[0];
        if (mdhd) {
            // mdhd is a FullBox, meaning it will have its own version as the first byte
            var version = mdhd[0];
            var index = version === 0 ? 12 : 20;
            track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
        }
        var stbl = $b432346f74fe917b$export$d81d43b46e2012ef(mdia, [
            "minf",
            "stbl"
        ])[0];
        var stsd = $b432346f74fe917b$export$d81d43b46e2012ef(stbl, [
            "stsd"
        ])[0];
        var descriptionCount = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(stsd.subarray(4, 8));
        var offset = 8; // add codec and codec info
        while(descriptionCount--){
            var len = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(stsd.subarray(offset, offset + 4));
            var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
            $b432346f74fe917b$export$56fdd13a804135bf(track, sampleDescriptor);
            offset += 4 + len;
        }
        if (frameTable) track.frameTable = $b432346f74fe917b$export$78870b2844ff6386(stbl, track.timescale);
         // codec has no sub parameters
        tracks.push(track);
    });
    return tracks;
};
var $b432346f74fe917b$export$bd2f7582ee199747 = function parseMediaInfo(bytes) {
    var mvhd = $b432346f74fe917b$export$d81d43b46e2012ef(bytes, [
        "moov",
        "mvhd"
    ], true)[0];
    if (!mvhd || !mvhd.length) return;
    var info = {}; // ms to ns
    // mvhd v1 has 8 byte duration and other fields too
    if (mvhd[0] === 1) {
        info.timestampScale = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(mvhd.subarray(20, 24));
        info.duration = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(mvhd.subarray(24, 32));
    } else {
        info.timestampScale = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(mvhd.subarray(12, 16));
        info.duration = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(mvhd.subarray(16, 20));
    }
    info.bytes = mvhd;
    return info;
};




var $024d2dab5c6dc55e$export$3dc3c695a37e4653 = {
    EBML: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x1A,
        0x45,
        0xDF,
        0xA3
    ]),
    DocType: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x42,
        0x82
    ]),
    Segment: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x18,
        0x53,
        0x80,
        0x67
    ]),
    SegmentInfo: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x15,
        0x49,
        0xA9,
        0x66
    ]),
    Tracks: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x16,
        0x54,
        0xAE,
        0x6B
    ]),
    Track: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xAE
    ]),
    TrackNumber: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xd7
    ]),
    DefaultDuration: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x23,
        0xe3,
        0x83
    ]),
    TrackEntry: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xAE
    ]),
    TrackType: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x83
    ]),
    FlagDefault: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x88
    ]),
    CodecID: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x86
    ]),
    CodecPrivate: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x63,
        0xA2
    ]),
    VideoTrack: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xe0
    ]),
    AudioTrack: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xe1
    ]),
    // Not used yet, but will be used for live webm/mkv
    // see https://www.matroska.org/technical/basics.html#block-structure
    // see https://www.matroska.org/technical/basics.html#simpleblock-structure
    Cluster: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x1F,
        0x43,
        0xB6,
        0x75
    ]),
    Timestamp: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xE7
    ]),
    TimestampScale: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x2A,
        0xD7,
        0xB1
    ]),
    BlockGroup: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xA0
    ]),
    BlockDuration: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x9B
    ]),
    Block: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xA1
    ]),
    SimpleBlock: (0, $4bd18e93e919945b$export$63c3de442720649)([
        0xA3
    ])
};
/**
 * This is a simple table to determine the length
 * of things in ebml. The length is one based (starts at 1,
 * rather than zero) and for every zero bit before a one bit
 * we add one to length. We also need this table because in some
 * case we have to xor all the length bits from another value.
 */ var $024d2dab5c6dc55e$var$LENGTH_TABLE = [
    128,
    64,
    32,
    16,
    8,
    4,
    2,
    1
];
var $024d2dab5c6dc55e$var$getLength = function getLength(byte) {
    var len = 1;
    for(var i = 0; i < $024d2dab5c6dc55e$var$LENGTH_TABLE.length; i++){
        if (byte & $024d2dab5c6dc55e$var$LENGTH_TABLE[i]) break;
        len++;
    }
    return len;
}; // length in ebml is stored in the first 4 to 8 bits
// of the first byte. 4 for the id length and 8 for the
// data size length. Length is measured by converting the number to binary
// then 1 + the number of zeros before a 1 is encountered starting
// from the left.
var $024d2dab5c6dc55e$var$getvint = function getvint(bytes, offset, removeLength, signed) {
    if (removeLength === void 0) removeLength = true;
    if (signed === void 0) signed = false;
    var length = $024d2dab5c6dc55e$var$getLength(bytes[offset]);
    var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
    // as they will be modified below to remove the dataSizeLen bits and we do not
    // want to modify the original data. normally we could just call slice on
    // uint8array but ie 11 does not support that...
    if (removeLength) {
        valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
        valueBytes[0] ^= $024d2dab5c6dc55e$var$LENGTH_TABLE[length - 1];
    }
    return {
        length: length,
        value: (0, $4bd18e93e919945b$export$c0cca17bcf674749)(valueBytes, {
            signed: signed
        }),
        bytes: valueBytes
    };
};
var $024d2dab5c6dc55e$var$normalizePath = function normalizePath(path) {
    if (typeof path === "string") return path.match(/.{1,2}/g).map(function(p) {
        return normalizePath(p);
    });
    if (typeof path === "number") return (0, $4bd18e93e919945b$export$49ad9be85c347998)(path);
    return path;
};
var $024d2dab5c6dc55e$var$normalizePaths = function normalizePaths(paths) {
    if (!Array.isArray(paths)) return [
        $024d2dab5c6dc55e$var$normalizePath(paths)
    ];
    return paths.map(function(p) {
        return $024d2dab5c6dc55e$var$normalizePath(p);
    });
};
var $024d2dab5c6dc55e$var$getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
    if (offset >= bytes.length) return bytes.length;
    var innerid = $024d2dab5c6dc55e$var$getvint(bytes, offset, false);
    if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(id.bytes, innerid.bytes)) return offset;
    var dataHeader = $024d2dab5c6dc55e$var$getvint(bytes, offset + innerid.length);
    return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
};
var $024d2dab5c6dc55e$export$826a5b7de63531e6 = function findEbml(bytes, paths) {
    paths = $024d2dab5c6dc55e$var$normalizePaths(paths);
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    var results = [];
    if (!paths.length) return results;
    var i = 0;
    while(i < bytes.length){
        var id = $024d2dab5c6dc55e$var$getvint(bytes, i, false);
        var dataHeader = $024d2dab5c6dc55e$var$getvint(bytes, i + id.length);
        var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream
        if (dataHeader.value === 0x7f) {
            dataHeader.value = $024d2dab5c6dc55e$var$getInfinityDataSize(id, bytes, dataStart);
            if (dataHeader.value !== bytes.length) dataHeader.value -= dataStart;
        }
        var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
        var data = bytes.subarray(dataStart, dataEnd);
        if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(paths[0], id.bytes)) {
            if (paths.length === 1) // this is the end of the paths and we've found the tag we were
            // looking for
            results.push(data);
            else // recursively search for the next tag inside of the data
            // of this one
            results = results.concat(findEbml(data, paths.slice(1)));
        }
        var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it
        i += totalLength;
    }
    return results;
}; // see https://www.matroska.org/technical/basics.html#block-structure
var $024d2dab5c6dc55e$export$cd5299e345c81b3 = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
    var duration;
    if (type === "group") {
        duration = $024d2dab5c6dc55e$export$826a5b7de63531e6(block, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.BlockDuration
        ])[0];
        if (duration) {
            duration = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(duration);
            duration = 1 / timestampScale * duration * timestampScale / 1000;
        }
        block = $024d2dab5c6dc55e$export$826a5b7de63531e6(block, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.Block
        ])[0];
        type = "block"; // treat data as a block after this point
    }
    var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
    var trackNumber = $024d2dab5c6dc55e$var$getvint(block, 0);
    var timestamp = dv.getInt16(trackNumber.length, false);
    var flags = block[trackNumber.length + 2];
    var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds
    var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame
    var parsed = {
        duration: duration,
        trackNumber: trackNumber.value,
        keyframe: type === "simple" && flags >> 7 === 1,
        invisible: (flags & 0x08) >> 3 === 1,
        lacing: (flags & 0x06) >> 1,
        discardable: type === "simple" && (flags & 0x01) === 1,
        frames: [],
        pts: ptsdts,
        dts: ptsdts,
        timestamp: timestamp
    };
    if (!parsed.lacing) {
        parsed.frames.push(data);
        return parsed;
    }
    var numberOfFrames = data[0] + 1;
    var frameSizes = [];
    var offset = 1; // Fixed
    if (parsed.lacing === 2) {
        var sizeOfFrame = (data.length - offset) / numberOfFrames;
        for(var i = 0; i < numberOfFrames; i++)frameSizes.push(sizeOfFrame);
    } // xiph
    if (parsed.lacing === 1) for(var _i = 0; _i < numberOfFrames - 1; _i++){
        var size = 0;
        do {
            size += data[offset];
            offset++;
        }while (data[offset - 1] === 0xFF);
        frameSizes.push(size);
    }
     // ebml
    if (parsed.lacing === 3) {
        // first vint is unsinged
        // after that vints are singed and
        // based on a compounding size
        var _size = 0;
        for(var _i2 = 0; _i2 < numberOfFrames - 1; _i2++){
            var vint = _i2 === 0 ? $024d2dab5c6dc55e$var$getvint(data, offset) : $024d2dab5c6dc55e$var$getvint(data, offset, true, true);
            _size += vint.value;
            frameSizes.push(_size);
            offset += vint.length;
        }
    }
    frameSizes.forEach(function(size) {
        parsed.frames.push(data.subarray(offset, offset + size));
        offset += size;
    });
    return parsed;
}; // VP9 Codec Feature Metadata (CodecPrivate)
// https://www.webmproject.org/docs/container/
var $024d2dab5c6dc55e$var$parseVp9Private = function parseVp9Private(bytes) {
    var i = 0;
    var params = {};
    while(i < bytes.length){
        var id = bytes[i] & 0x7f;
        var len = bytes[i + 1];
        var val = void 0;
        if (len === 1) val = bytes[i + 2];
        else val = bytes.subarray(i + 2, i + 2 + len);
        if (id === 1) params.profile = val;
        else if (id === 2) params.level = val;
        else if (id === 3) params.bitDepth = val;
        else if (id === 4) params.chromaSubsampling = val;
        else params[id] = val;
        i += 2 + len;
    }
    return params;
};
var $024d2dab5c6dc55e$export$b9400b1cdedffc2a = function parseTracks(bytes) {
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    var decodedTracks = [];
    var tracks = $024d2dab5c6dc55e$export$826a5b7de63531e6(bytes, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Segment,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Tracks,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) tracks = $024d2dab5c6dc55e$export$826a5b7de63531e6(bytes, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Tracks,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) tracks = $024d2dab5c6dc55e$export$826a5b7de63531e6(bytes, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Track
    ]);
    if (!tracks.length) return decodedTracks;
    tracks.forEach(function(track) {
        var trackType = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, $024d2dab5c6dc55e$export$3dc3c695a37e4653.TrackType)[0];
        if (!trackType || !trackType.length) return;
         // 1 is video, 2 is audio, 17 is subtitle
        // other values are unimportant in this context
        if (trackType[0] === 1) trackType = "video";
        else if (trackType[0] === 2) trackType = "audio";
        else if (trackType[0] === 17) trackType = "subtitle";
        else return;
         // todo parse language
        var decodedTrack = {
            rawCodec: (0, $4bd18e93e919945b$export$7c746b75f47c9c7d)($024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.CodecID
            ])[0]),
            type: trackType,
            codecPrivate: $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.CodecPrivate
            ])[0],
            number: (0, $4bd18e93e919945b$export$c0cca17bcf674749)($024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.TrackNumber
            ])[0]),
            defaultDuration: (0, $4bd18e93e919945b$export$c0cca17bcf674749)($024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.DefaultDuration
            ])[0]),
            default: $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                $024d2dab5c6dc55e$export$3dc3c695a37e4653.FlagDefault
            ])[0],
            rawData: track
        };
        var codec = "";
        if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) codec = "avc1." + (0, $68f6ae2afedf5ec2$export$f316fb16efba7de9)(decodedTrack.codecPrivate);
        else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) codec = "hev1." + (0, $68f6ae2afedf5ec2$export$57f4fb41d46b44d9)(decodedTrack.codecPrivate);
        else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) codec = "mp4v.20." + decodedTrack.codecPrivate[4].toString();
            else codec = "mp4v.20.9";
        } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) codec = "theora";
        else if (/^V_VP8/.test(decodedTrack.rawCodec)) codec = "vp8";
        else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) {
                var _parseVp9Private = $024d2dab5c6dc55e$var$parseVp9Private(decodedTrack.codecPrivate), profile = _parseVp9Private.profile, level = _parseVp9Private.level, bitDepth = _parseVp9Private.bitDepth, chromaSubsampling = _parseVp9Private.chromaSubsampling;
                codec = "vp09.";
                codec += (0, $4bd18e93e919945b$export$36cf564d487b5178)(profile, 2, "0") + ".";
                codec += (0, $4bd18e93e919945b$export$36cf564d487b5178)(level, 2, "0") + ".";
                codec += (0, $4bd18e93e919945b$export$36cf564d487b5178)(bitDepth, 2, "0") + ".";
                codec += "" + (0, $4bd18e93e919945b$export$36cf564d487b5178)(chromaSubsampling, 2, "0"); // Video -> Colour -> Ebml name
                var matrixCoefficients = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xB1
                    ]
                ])[0] || [];
                var videoFullRangeFlag = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xB9
                    ]
                ])[0] || [];
                var transferCharacteristics = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xBA
                    ]
                ])[0] || [];
                var colourPrimaries = $024d2dab5c6dc55e$export$826a5b7de63531e6(track, [
                    0xE0,
                    [
                        0x55,
                        0xB0
                    ],
                    [
                        0x55,
                        0xBB
                    ]
                ])[0] || []; // if we find any optional codec parameter specify them all.
                if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
                    codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(colourPrimaries[0], 2, "0");
                    codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(transferCharacteristics[0], 2, "0");
                    codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(matrixCoefficients[0], 2, "0");
                    codec += "." + (0, $4bd18e93e919945b$export$36cf564d487b5178)(videoFullRangeFlag[0], 2, "0");
                }
            } else codec = "vp9";
        } else if (/^V_AV1/.test(decodedTrack.rawCodec)) codec = "av01." + (0, $68f6ae2afedf5ec2$export$5ff37217be0e6718)(decodedTrack.codecPrivate);
        else if (/A_ALAC/.test(decodedTrack.rawCodec)) codec = "alac";
        else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) codec = "mp2";
        else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) codec = "mp3";
        else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
            if (decodedTrack.codecPrivate) codec = "mp4a.40." + (decodedTrack.codecPrivate[0] >>> 3).toString();
            else codec = "mp4a.40.2";
        } else if (/^A_AC3/.test(decodedTrack.rawCodec)) codec = "ac-3";
        else if (/^A_PCM/.test(decodedTrack.rawCodec)) codec = "pcm";
        else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) codec = "speex";
        else if (/^A_EAC3/.test(decodedTrack.rawCodec)) codec = "ec-3";
        else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) codec = "vorbis";
        else if (/^A_FLAC/.test(decodedTrack.rawCodec)) codec = "flac";
        else if (/^A_OPUS/.test(decodedTrack.rawCodec)) codec = "opus";
        decodedTrack.codec = codec;
        decodedTracks.push(decodedTrack);
    });
    return decodedTracks.sort(function(a, b) {
        return a.number - b.number;
    });
};
var $024d2dab5c6dc55e$export$4c0e6fff2d4abe18 = function parseData(data, tracks) {
    var allBlocks = [];
    var segment = $024d2dab5c6dc55e$export$826a5b7de63531e6(data, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Segment
    ])[0];
    var timestampScale = $024d2dab5c6dc55e$export$826a5b7de63531e6(segment, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.SegmentInfo,
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.TimestampScale
    ])[0]; // in nanoseconds, defaults to 1ms
    if (timestampScale && timestampScale.length) timestampScale = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(timestampScale);
    else timestampScale = 1000000;
    var clusters = $024d2dab5c6dc55e$export$826a5b7de63531e6(segment, [
        $024d2dab5c6dc55e$export$3dc3c695a37e4653.Cluster
    ]);
    if (!tracks) tracks = $024d2dab5c6dc55e$export$b9400b1cdedffc2a(segment);
    clusters.forEach(function(cluster, ci) {
        var simpleBlocks = $024d2dab5c6dc55e$export$826a5b7de63531e6(cluster, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.SimpleBlock
        ]).map(function(b) {
            return {
                type: "simple",
                data: b
            };
        });
        var blockGroups = $024d2dab5c6dc55e$export$826a5b7de63531e6(cluster, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.BlockGroup
        ]).map(function(b) {
            return {
                type: "group",
                data: b
            };
        });
        var timestamp = $024d2dab5c6dc55e$export$826a5b7de63531e6(cluster, [
            $024d2dab5c6dc55e$export$3dc3c695a37e4653.Timestamp
        ])[0] || 0;
        if (timestamp && timestamp.length) timestamp = (0, $4bd18e93e919945b$export$c0cca17bcf674749)(timestamp);
         // get all blocks then sort them into the correct order
        var blocks = simpleBlocks.concat(blockGroups).sort(function(a, b) {
            return a.data.byteOffset - b.data.byteOffset;
        });
        blocks.forEach(function(block, bi) {
            var decoded = $024d2dab5c6dc55e$export$cd5299e345c81b3(block.data, block.type, timestampScale, timestamp);
            allBlocks.push(decoded);
        });
    });
    return {
        tracks: tracks,
        blocks: allBlocks
    };
};




var $d1417422e6d698b2$export$c685721194c7e8f3 = (0, $4bd18e93e919945b$export$63c3de442720649)([
    0x00,
    0x00,
    0x00,
    0x01
]);
var $d1417422e6d698b2$export$5e56cd062936486 = (0, $4bd18e93e919945b$export$63c3de442720649)([
    0x00,
    0x00,
    0x01
]);
var $d1417422e6d698b2$export$c6449e11a0e55652 = (0, $4bd18e93e919945b$export$63c3de442720649)([
    0x00,
    0x00,
    0x03
]);
var $d1417422e6d698b2$export$1a44f7c1c8cc8def = function discardEmulationPreventionBytes(bytes) {
    var positions = [];
    var i = 1; // Find all `Emulation Prevention Bytes`
    while(i < bytes.length - 2){
        if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes.subarray(i, i + 3), $d1417422e6d698b2$export$c6449e11a0e55652)) {
            positions.push(i + 2);
            i++;
        }
        i++;
    } // If no Emulation Prevention Bytes were found just return the original
    // array
    if (positions.length === 0) return bytes;
     // Create a new array to hold the NAL unit data
    var newLength = bytes.length - positions.length;
    var newData = new Uint8Array(newLength);
    var sourceIndex = 0;
    for(i = 0; i < newLength; sourceIndex++, i++){
        if (sourceIndex === positions[0]) {
            // Skip this byte
            sourceIndex++; // Remove this position index
            positions.shift();
        }
        newData[i] = bytes[sourceIndex];
    }
    return newData;
};
var $d1417422e6d698b2$export$17fd5d00213a3829 = function findNal(bytes, dataType, types, nalLimit) {
    if (nalLimit === void 0) nalLimit = Infinity;
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    types = [].concat(types);
    var i = 0;
    var nalStart;
    var nalsFound = 0; // keep searching until:
    // we reach the end of bytes
    // we reach the maximum number of nals they want to seach
    // NOTE: that we disregard nalLimit when we have found the start
    // of the nal we want so that we can find the end of the nal we want.
    while(i < bytes.length && (nalsFound < nalLimit || nalStart)){
        var nalOffset = void 0;
        if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes.subarray(i), $d1417422e6d698b2$export$c685721194c7e8f3)) nalOffset = 4;
        else if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes.subarray(i), $d1417422e6d698b2$export$5e56cd062936486)) nalOffset = 3;
         // we are unsynced,
        // find the next nal unit
        if (!nalOffset) {
            i++;
            continue;
        }
        nalsFound++;
        if (nalStart) return $d1417422e6d698b2$export$1a44f7c1c8cc8def(bytes.subarray(nalStart, i));
        var nalType = void 0;
        if (dataType === "h264") nalType = bytes[i + nalOffset] & 0x1f;
        else if (dataType === "h265") nalType = bytes[i + nalOffset] >> 1 & 0x3f;
        if (types.indexOf(nalType) !== -1) nalStart = i + nalOffset;
         // nal header is 1 length for h264, and 2 for h265
        i += nalOffset + (dataType === "h264" ? 1 : 2);
    }
    return bytes.subarray(0, 0);
};
var $d1417422e6d698b2$export$d9a366c79c59ccda = function findH264Nal(bytes, type, nalLimit) {
    return $d1417422e6d698b2$export$17fd5d00213a3829(bytes, "h264", type, nalLimit);
};
var $d1417422e6d698b2$export$4b55988b6a40a3f0 = function findH265Nal(bytes, type, nalLimit) {
    return $d1417422e6d698b2$export$17fd5d00213a3829(bytes, "h265", type, nalLimit);
};


var $87512779f8f2edc4$var$CONSTANTS = {
    // "webm" string literal in hex
    "webm": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x77,
        0x65,
        0x62,
        0x6d
    ]),
    // "matroska" string literal in hex
    "matroska": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x6d,
        0x61,
        0x74,
        0x72,
        0x6f,
        0x73,
        0x6b,
        0x61
    ]),
    // "fLaC" string literal in hex
    "flac": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x66,
        0x4c,
        0x61,
        0x43
    ]),
    // "OggS" string literal in hex
    "ogg": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x4f,
        0x67,
        0x67,
        0x53
    ]),
    // ac-3 sync byte, also works for ec-3 as that is simply a codec
    // of ac-3
    "ac3": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x0b,
        0x77
    ]),
    // "RIFF" string literal in hex used for wav and avi
    "riff": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x52,
        0x49,
        0x46,
        0x46
    ]),
    // "AVI" string literal in hex
    "avi": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x41,
        0x56,
        0x49
    ]),
    // "WAVE" string literal in hex
    "wav": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x57,
        0x41,
        0x56,
        0x45
    ]),
    // "ftyp3g" string literal in hex
    "3gp": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x66,
        0x74,
        0x79,
        0x70,
        0x33,
        0x67
    ]),
    // "ftyp" string literal in hex
    "mp4": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x66,
        0x74,
        0x79,
        0x70
    ]),
    // "styp" string literal in hex
    "fmp4": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x73,
        0x74,
        0x79,
        0x70
    ]),
    // "ftypqt" string literal in hex
    "mov": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x66,
        0x74,
        0x79,
        0x70,
        0x71,
        0x74
    ]),
    // moov string literal in hex
    "moov": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x6D,
        0x6F,
        0x6F,
        0x76
    ]),
    // moof string literal in hex
    "moof": (0, $4bd18e93e919945b$export$63c3de442720649)([
        0x6D,
        0x6F,
        0x6F,
        0x66
    ])
};
var $87512779f8f2edc4$var$_isLikely = {
    aac: function aac(bytes) {
        var offset = (0, $862e4a4ff1392639$export$56b6cacf09ec1126)(bytes);
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, [
            0xFF,
            0x10
        ], {
            offset: offset,
            mask: [
                0xFF,
                0x16
            ]
        });
    },
    mp3: function mp3(bytes) {
        var offset = (0, $862e4a4ff1392639$export$56b6cacf09ec1126)(bytes);
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, [
            0xFF,
            0x02
        ], {
            offset: offset,
            mask: [
                0xFF,
                0x06
            ]
        });
    },
    webm: function webm(bytes) {
        var docType = (0, $024d2dab5c6dc55e$export$826a5b7de63531e6)(bytes, [
            (0, $024d2dab5c6dc55e$export$3dc3c695a37e4653).EBML,
            (0, $024d2dab5c6dc55e$export$3dc3c695a37e4653).DocType
        ])[0]; // check if DocType EBML tag is webm
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(docType, $87512779f8f2edc4$var$CONSTANTS.webm);
    },
    mkv: function mkv(bytes) {
        var docType = (0, $024d2dab5c6dc55e$export$826a5b7de63531e6)(bytes, [
            (0, $024d2dab5c6dc55e$export$3dc3c695a37e4653).EBML,
            (0, $024d2dab5c6dc55e$export$3dc3c695a37e4653).DocType
        ])[0]; // check if DocType EBML tag is matroska
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(docType, $87512779f8f2edc4$var$CONSTANTS.matroska);
    },
    mp4: function mp4(bytes) {
        // if this file is another base media file format, it is not mp4
        if ($87512779f8f2edc4$var$_isLikely["3gp"](bytes) || $87512779f8f2edc4$var$_isLikely.mov(bytes)) return false;
         // if this file starts with a ftyp or styp box its mp4
        if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.mp4, {
            offset: 4
        }) || (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.fmp4, {
            offset: 4
        })) return true;
         // if this file starts with a moof/moov box its mp4
        if ((0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.moof, {
            offset: 4
        }) || (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.moov, {
            offset: 4
        })) return true;
    },
    mov: function mov(bytes) {
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.mov, {
            offset: 4
        });
    },
    "3gp": function gp(bytes) {
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS["3gp"], {
            offset: 4
        });
    },
    ac3: function ac3(bytes) {
        var offset = (0, $862e4a4ff1392639$export$56b6cacf09ec1126)(bytes);
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.ac3, {
            offset: offset
        });
    },
    ts: function ts(bytes) {
        if (bytes.length < 189 && bytes.length >= 1) return bytes[0] === 0x47;
        var i = 0; // check the first 376 bytes for two matching sync bytes
        while(i + 188 < bytes.length && i < 188){
            if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) return true;
            i += 1;
        }
        return false;
    },
    flac: function flac(bytes) {
        var offset = (0, $862e4a4ff1392639$export$56b6cacf09ec1126)(bytes);
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.flac, {
            offset: offset
        });
    },
    ogg: function ogg(bytes) {
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.ogg);
    },
    avi: function avi(bytes) {
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.riff) && (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.avi, {
            offset: 8
        });
    },
    wav: function wav(bytes) {
        return (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.riff) && (0, $4bd18e93e919945b$export$a20f7b76e5cfd223)(bytes, $87512779f8f2edc4$var$CONSTANTS.wav, {
            offset: 8
        });
    },
    "h264": function h264(bytes) {
        // find seq_parameter_set_rbsp
        return (0, $d1417422e6d698b2$export$d9a366c79c59ccda)(bytes, 7, 3).length;
    },
    "h265": function h265(bytes) {
        // find video_parameter_set_rbsp or seq_parameter_set_rbsp
        return (0, $d1417422e6d698b2$export$4b55988b6a40a3f0)(bytes, [
            32,
            33
        ], 3).length;
    }
}; // get all the isLikely functions
// but make sure 'ts' is above h264 and h265
// but below everything else as it is the least specific
var $87512779f8f2edc4$var$isLikelyTypes = Object.keys($87512779f8f2edc4$var$_isLikely) // remove ts, h264, h265
.filter(function(t) {
    return t !== "ts" && t !== "h264" && t !== "h265";
}) // add it back to the bottom
.concat([
    "ts",
    "h264",
    "h265"
]); // make sure we are dealing with uint8 data.
$87512779f8f2edc4$var$isLikelyTypes.forEach(function(type) {
    var isLikelyFn = $87512779f8f2edc4$var$_isLikely[type];
    $87512779f8f2edc4$var$_isLikely[type] = function(bytes) {
        return isLikelyFn((0, $4bd18e93e919945b$export$63c3de442720649)(bytes));
    };
}); // export after wrapping
var $87512779f8f2edc4$export$4d8d080fd201ee1b = $87512779f8f2edc4$var$_isLikely; // A useful list of file signatures can be found here
var $87512779f8f2edc4$export$894319e75ed840c3 = function detectContainerForBytes(bytes) {
    bytes = (0, $4bd18e93e919945b$export$63c3de442720649)(bytes);
    for(var i = 0; i < $87512779f8f2edc4$var$isLikelyTypes.length; i++){
        var type = $87512779f8f2edc4$var$isLikelyTypes[i];
        if ($87512779f8f2edc4$export$4d8d080fd201ee1b[type](bytes)) return type;
    }
    return "";
}; // fmp4 is not a container
var $87512779f8f2edc4$export$7d0b693bd7ec7827 = function isLikelyFmp4MediaSegment(bytes) {
    return (0, $b432346f74fe917b$export$d81d43b46e2012ef)(bytes, [
        "moof"
    ]).length > 0;
};


var $2a252b448d50d133$exports = {};
/**
 * mux.js
 *
 * Copyright (c) Brightcove
 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
 */ var $2a252b448d50d133$var$ONE_SECOND_IN_TS = 90000, $2a252b448d50d133$var$secondsToVideoTs, $2a252b448d50d133$var$secondsToAudioTs, $2a252b448d50d133$var$videoTsToSeconds, $2a252b448d50d133$var$audioTsToSeconds, $2a252b448d50d133$var$audioTsToVideoTs, $2a252b448d50d133$var$videoTsToAudioTs, $2a252b448d50d133$var$metadataTsToSeconds;
$2a252b448d50d133$var$secondsToVideoTs = function(seconds) {
    return seconds * $2a252b448d50d133$var$ONE_SECOND_IN_TS;
};
$2a252b448d50d133$var$secondsToAudioTs = function(seconds, sampleRate) {
    return seconds * sampleRate;
};
$2a252b448d50d133$var$videoTsToSeconds = function(timestamp) {
    return timestamp / $2a252b448d50d133$var$ONE_SECOND_IN_TS;
};
$2a252b448d50d133$var$audioTsToSeconds = function(timestamp, sampleRate) {
    return timestamp / sampleRate;
};
$2a252b448d50d133$var$audioTsToVideoTs = function(timestamp, sampleRate) {
    return $2a252b448d50d133$var$secondsToVideoTs($2a252b448d50d133$var$audioTsToSeconds(timestamp, sampleRate));
};
$2a252b448d50d133$var$videoTsToAudioTs = function(timestamp, sampleRate) {
    return $2a252b448d50d133$var$secondsToAudioTs($2a252b448d50d133$var$videoTsToSeconds(timestamp), sampleRate);
};
/**
 * Adjust ID3 tag or caption timing information by the timeline pts values
 * (if keepOriginalTimestamps is false) and convert to seconds
 */ $2a252b448d50d133$var$metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
    return $2a252b448d50d133$var$videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
};
$2a252b448d50d133$exports = {
    ONE_SECOND_IN_TS: $2a252b448d50d133$var$ONE_SECOND_IN_TS,
    secondsToVideoTs: $2a252b448d50d133$var$secondsToVideoTs,
    secondsToAudioTs: $2a252b448d50d133$var$secondsToAudioTs,
    videoTsToSeconds: $2a252b448d50d133$var$videoTsToSeconds,
    audioTsToSeconds: $2a252b448d50d133$var$audioTsToSeconds,
    audioTsToVideoTs: $2a252b448d50d133$var$audioTsToVideoTs,
    videoTsToAudioTs: $2a252b448d50d133$var$videoTsToAudioTs,
    metadataTsToSeconds: $2a252b448d50d133$var$metadataTsToSeconds
};


var $cb03b711053a4297$var$version$6 = "8.6.1";
/**
 * An Object that contains lifecycle hooks as keys which point to an array
 * of functions that are run when a lifecycle is triggered
 *
 * @private
 */ const $cb03b711053a4297$var$hooks_ = {};
/**
 * Get a list of hooks for a specific lifecycle
 *
 * @param  {string} type
 *         the lifecycle to get hooks from
 *
 * @param  {Function|Function[]} [fn]
 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
 *
 * @return {Array}
 *         an array of hooks, or an empty array if there are none.
 */ const $cb03b711053a4297$var$hooks = function(type, fn) {
    $cb03b711053a4297$var$hooks_[type] = $cb03b711053a4297$var$hooks_[type] || [];
    if (fn) $cb03b711053a4297$var$hooks_[type] = $cb03b711053a4297$var$hooks_[type].concat(fn);
    return $cb03b711053a4297$var$hooks_[type];
};
/**
 * Add a function hook to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */ const $cb03b711053a4297$var$hook = function(type, fn) {
    $cb03b711053a4297$var$hooks(type, fn);
};
/**
 * Remove a hook from a specific videojs lifecycle.
 *
 * @param  {string} type
 *         the lifecycle that the function hooked to
 *
 * @param  {Function} fn
 *         The hooked function to remove
 *
 * @return {boolean}
 *         The function that was removed or undef
 */ const $cb03b711053a4297$var$removeHook = function(type, fn) {
    const index = $cb03b711053a4297$var$hooks(type).indexOf(fn);
    if (index <= -1) return false;
    $cb03b711053a4297$var$hooks_[type] = $cb03b711053a4297$var$hooks_[type].slice();
    $cb03b711053a4297$var$hooks_[type].splice(index, 1);
    return true;
};
/**
 * Add a function hook that will only run once to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */ const $cb03b711053a4297$var$hookOnce = function(type, fn) {
    $cb03b711053a4297$var$hooks(type, [].concat(fn).map((original)=>{
        const wrapper = (...args)=>{
            $cb03b711053a4297$var$removeHook(type, wrapper);
            return original(...args);
        };
        return wrapper;
    }));
};
/**
 * @file fullscreen-api.js
 * @module fullscreen-api
 */ /**
 * Store the browser-specific methods for the fullscreen API.
 *
 * @type {Object}
 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
 */ const $cb03b711053a4297$var$FullscreenApi = {
    prefixed: true
};
// browser API methods
const $cb03b711053a4297$var$apiMap = [
    [
        "requestFullscreen",
        "exitFullscreen",
        "fullscreenElement",
        "fullscreenEnabled",
        "fullscreenchange",
        "fullscreenerror",
        "fullscreen"
    ],
    // WebKit
    [
        "webkitRequestFullscreen",
        "webkitExitFullscreen",
        "webkitFullscreenElement",
        "webkitFullscreenEnabled",
        "webkitfullscreenchange",
        "webkitfullscreenerror",
        "-webkit-full-screen"
    ]
];
const $cb03b711053a4297$var$specApi = $cb03b711053a4297$var$apiMap[0];
let $cb03b711053a4297$var$browserApi;
// determine the supported set of functions
for(let i = 0; i < $cb03b711053a4297$var$apiMap.length; i++)// check for exitFullscreen function
if ($cb03b711053a4297$var$apiMap[i][1] in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) {
    $cb03b711053a4297$var$browserApi = $cb03b711053a4297$var$apiMap[i];
    break;
}
// map the browser API names to the spec API names
if ($cb03b711053a4297$var$browserApi) {
    for(let i = 0; i < $cb03b711053a4297$var$browserApi.length; i++)$cb03b711053a4297$var$FullscreenApi[$cb03b711053a4297$var$specApi[i]] = $cb03b711053a4297$var$browserApi[i];
    $cb03b711053a4297$var$FullscreenApi.prefixed = $cb03b711053a4297$var$browserApi[0] !== $cb03b711053a4297$var$specApi[0];
}
/**
 * @file create-logger.js
 * @module create-logger
 */ // This is the private tracking variable for the logging history.
let $cb03b711053a4297$var$history = [];
/**
 * Log messages to the console and history based on the type of message
 *
 * @private
 * @param  {string} name
 *         The name of the console method to use.
 *
 * @param  {Object} log
 *         The arguments to be passed to the matching console method.
 *
 * @param {string} [styles]
 *        styles for name
 */ const $cb03b711053a4297$var$LogByTypeFactory = (name, log, styles)=>(type, level, args)=>{
        const lvl = log.levels[level];
        const lvlRegExp = new RegExp(`^(${lvl})$`);
        let resultName = name;
        if (type !== "log") // Add the type to the front of the message when it's not "log".
        args.unshift(type.toUpperCase() + ":");
        if (styles) {
            resultName = `%c${name}`;
            args.unshift(styles);
        }
        // Add console prefix after adding to history.
        args.unshift(resultName + ":");
        // Add a clone of the args at this point to history.
        if ($cb03b711053a4297$var$history) {
            $cb03b711053a4297$var$history.push([].concat(args));
            // only store 1000 history entries
            const splice = $cb03b711053a4297$var$history.length - 1000;
            $cb03b711053a4297$var$history.splice(0, splice > 0 ? splice : 0);
        }
        // If there's no console then don't try to output messages, but they will
        // still be stored in history.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console) return;
        // Was setting these once outside of this function, but containing them
        // in the function makes it easier to test cases where console doesn't exist
        // when the module is executed.
        let fn = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console[type];
        if (!fn && type === "debug") // Certain browsers don't have support for console.debug. For those, we
        // should default to the closest comparable log.
        fn = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.info || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.log;
        // Bail out if there's no console or if this type is not allowed by the
        // current logging level.
        if (!fn || !lvl || !lvlRegExp.test(type)) return;
        fn[Array.isArray(args) ? "apply" : "call"]((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console, args);
    };
function $cb03b711053a4297$var$createLogger$1(name, delimiter = ":", styles = "") {
    // This is the private tracking variable for logging level.
    let level = "info";
    // the curried logByType bound to the specific log and history
    let logByType;
    /**
   * Logs plain debug messages. Similar to `console.log`.
   *
   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
   * of our JSDoc template, we cannot properly document this as both a function
   * and a namespace, so its function signature is documented here.
   *
   * #### Arguments
   * ##### *args
   * *[]
   *
   * Any combination of values that could be passed to `console.log()`.
   *
   * #### Return Value
   *
   * `undefined`
   *
   * @namespace
   * @param    {...*} args
   *           One or more messages or objects that should be logged.
   */ const log = function(...args) {
        logByType("log", level, args);
    };
    // This is the logByType helper that the logging methods below use
    logByType = $cb03b711053a4297$var$LogByTypeFactory(name, log, styles);
    /**
   * Create a new subLogger which chains the old name to the new name.
   *
   * For example, doing `videojs.log.createLogger('player')` and then using that logger will log the following:
   * ```js
   *  mylogger('foo');
   *  // > VIDEOJS: player: foo
   * ```
   *
   * @param {string} subName
   *        The name to add call the new logger
   * @param {string} [subDelimiter]
   *        Optional delimiter
   * @param {string} [subStyles]
   *        Optional styles
   * @return {Object}
   */ log.createLogger = (subName, subDelimiter, subStyles)=>{
        const resultDelimiter = subDelimiter !== undefined ? subDelimiter : delimiter;
        const resultStyles = subStyles !== undefined ? subStyles : styles;
        const resultName = `${name} ${resultDelimiter} ${subName}`;
        return $cb03b711053a4297$var$createLogger$1(resultName, resultDelimiter, resultStyles);
    };
    /**
   * Create a new logger.
   *
   * @param {string} newName
   *        The name for the new logger
   * @param {string} [newDelimiter]
   *        Optional delimiter
   * @param {string} [newStyles]
   *        Optional styles
   * @return {Object}
   */ log.createNewLogger = (newName, newDelimiter, newStyles)=>{
        return $cb03b711053a4297$var$createLogger$1(newName, newDelimiter, newStyles);
    };
    /**
   * Enumeration of available logging levels, where the keys are the level names
   * and the values are `|`-separated strings containing logging methods allowed
   * in that logging level. These strings are used to create a regular expression
   * matching the function name being called.
   *
   * Levels provided by Video.js are:
   *
   * - `off`: Matches no calls. Any value that can be cast to `false` will have
   *   this effect. The most restrictive.
   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
   *   `log.warn`, and `log.error`).
   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
   * - `warn`: Matches `log.warn` and `log.error` calls.
   * - `error`: Matches only `log.error` calls.
   *
   * @type {Object}
   */ log.levels = {
        all: "debug|log|warn|error",
        off: "",
        debug: "debug|log|warn|error",
        info: "log|warn|error",
        warn: "warn|error",
        error: "error",
        DEFAULT: level
    };
    /**
   * Get or set the current logging level.
   *
   * If a string matching a key from {@link module:log.levels} is provided, acts
   * as a setter.
   *
   * @param  {'all'|'debug'|'info'|'warn'|'error'|'off'} [lvl]
   *         Pass a valid level to set a new logging level.
   *
   * @return {string}
   *         The current logging level.
   */ log.level = (lvl)=>{
        if (typeof lvl === "string") {
            if (!log.levels.hasOwnProperty(lvl)) throw new Error(`"${lvl}" in not a valid log level`);
            level = lvl;
        }
        return level;
    };
    /**
   * Returns an array containing everything that has been logged to the history.
   *
   * This array is a shallow clone of the internal history record. However, its
   * contents are _not_ cloned; so, mutating objects inside this array will
   * mutate them in history.
   *
   * @return {Array}
   */ log.history = ()=>$cb03b711053a4297$var$history ? [].concat($cb03b711053a4297$var$history) : [];
    /**
   * Allows you to filter the history by the given logger name
   *
   * @param {string} fname
   *        The name to filter by
   *
   * @return {Array}
   *         The filtered list to return
   */ log.history.filter = (fname)=>{
        return ($cb03b711053a4297$var$history || []).filter((historyItem)=>{
            // if the first item in each historyItem includes `fname`, then it's a match
            return new RegExp(`.*${fname}.*`).test(historyItem[0]);
        });
    };
    /**
   * Clears the internal history tracking, but does not prevent further history
   * tracking.
   */ log.history.clear = ()=>{
        if ($cb03b711053a4297$var$history) $cb03b711053a4297$var$history.length = 0;
    };
    /**
   * Disable history tracking if it is currently enabled.
   */ log.history.disable = ()=>{
        if ($cb03b711053a4297$var$history !== null) {
            $cb03b711053a4297$var$history.length = 0;
            $cb03b711053a4297$var$history = null;
        }
    };
    /**
   * Enable history tracking if it is currently disabled.
   */ log.history.enable = ()=>{
        if ($cb03b711053a4297$var$history === null) $cb03b711053a4297$var$history = [];
    };
    /**
   * Logs error messages. Similar to `console.error`.
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as an error
   */ log.error = (...args)=>logByType("error", level, args);
    /**
   * Logs warning messages. Similar to `console.warn`.
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as a warning.
   */ log.warn = (...args)=>logByType("warn", level, args);
    /**
   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
   * log if `console.debug` is not available
   *
   * @param {...*} args
   *        One or more messages or objects that should be logged as debug.
   */ log.debug = (...args)=>logByType("debug", level, args);
    return log;
}
/**
 * @file log.js
 * @module log
 */ const $cb03b711053a4297$var$log$1 = $cb03b711053a4297$var$createLogger$1("VIDEOJS");
const $cb03b711053a4297$var$createLogger = $cb03b711053a4297$var$log$1.createLogger;
/**
 * @file obj.js
 * @module obj
 */ /**
 * @callback obj:EachCallback
 *
 * @param {*} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 */ /**
 * @callback obj:ReduceCallback
 *
 * @param {*} accum
 *        The value that is accumulating over the reduce loop.
 *
 * @param {*} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 *
 * @return {*}
 *         The new accumulated value.
 */ const $cb03b711053a4297$var$toString = Object.prototype.toString;
/**
 * Get the keys of an Object
 *
 * @param {Object}
 *        The Object to get the keys from
 *
 * @return {string[]}
 *         An array of the keys from the object. Returns an empty array if the
 *         object passed in was invalid or had no keys.
 *
 * @private
 */ const $cb03b711053a4297$var$keys = function(object) {
    return $cb03b711053a4297$var$isObject(object) ? Object.keys(object) : [];
};
/**
 * Array-like iteration for objects.
 *
 * @param {Object} object
 *        The object to iterate over
 *
 * @param {obj:EachCallback} fn
 *        The callback function which is called for each key in the object.
 */ function $cb03b711053a4297$var$each(object, fn) {
    $cb03b711053a4297$var$keys(object).forEach((key)=>fn(object[key], key));
}
/**
 * Array-like reduce for objects.
 *
 * @param {Object} object
 *        The Object that you want to reduce.
 *
 * @param {Function} fn
 *         A callback function which is called for each key in the object. It
 *         receives the accumulated value and the per-iteration value and key
 *         as arguments.
 *
 * @param {*} [initial = 0]
 *        Starting value
 *
 * @return {*}
 *         The final accumulated value.
 */ function $cb03b711053a4297$var$reduce(object, fn, initial = 0) {
    return $cb03b711053a4297$var$keys(object).reduce((accum, key)=>fn(accum, object[key], key), initial);
}
/**
 * Returns whether a value is an object of any kind - including DOM nodes,
 * arrays, regular expressions, etc. Not functions, though.
 *
 * This avoids the gotcha where using `typeof` on a `null` value
 * results in `'object'`.
 *
 * @param  {Object} value
 * @return {boolean}
 */ function $cb03b711053a4297$var$isObject(value) {
    return !!value && typeof value === "object";
}
/**
 * Returns whether an object appears to be a "plain" object - that is, a
 * direct instance of `Object`.
 *
 * @param  {Object} value
 * @return {boolean}
 */ function $cb03b711053a4297$var$isPlain(value) {
    return $cb03b711053a4297$var$isObject(value) && $cb03b711053a4297$var$toString.call(value) === "[object Object]" && value.constructor === Object;
}
/**
 * Merge two objects recursively.
 *
 * Performs a deep merge like
 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
 * plain objects (not arrays, elements, or anything else).
 *
 * Non-plain object values will be copied directly from the right-most
 * argument.
 *
 * @param   {Object[]} sources
 *          One or more objects to merge into a new object.
 *
 * @return {Object}
 *          A new object that is the merged result of all sources.
 */ function $cb03b711053a4297$var$merge$1(...sources) {
    const result = {};
    sources.forEach((source)=>{
        if (!source) return;
        $cb03b711053a4297$var$each(source, (value, key)=>{
            if (!$cb03b711053a4297$var$isPlain(value)) {
                result[key] = value;
                return;
            }
            if (!$cb03b711053a4297$var$isPlain(result[key])) result[key] = {};
            result[key] = $cb03b711053a4297$var$merge$1(result[key], value);
        });
    });
    return result;
}
/**
 * Returns an array of values for a given object
 *
 * @param  {Object} source - target object
 * @return {Array<unknown>} - object values
 */ function $cb03b711053a4297$var$values(source = {}) {
    const result = [];
    for(const key in source)if (source.hasOwnProperty(key)) {
        const value = source[key];
        result.push(value);
    }
    return result;
}
/**
 * Object.defineProperty but "lazy", which means that the value is only set after
 * it is retrieved the first time, rather than being set right away.
 *
 * @param {Object} obj the object to set the property on
 * @param {string} key the key for the property to set
 * @param {Function} getValue the function used to get the value when it is needed.
 * @param {boolean} setter whether a setter should be allowed or not
 */ function $cb03b711053a4297$var$defineLazyProperty(obj, key, getValue, setter = true) {
    const set = (value)=>Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            writable: true
        });
    const options = {
        configurable: true,
        enumerable: true,
        get () {
            const value = getValue();
            set(value);
            return value;
        }
    };
    if (setter) options.set = set;
    return Object.defineProperty(obj, key, options);
}
var $cb03b711053a4297$var$Obj = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    each: $cb03b711053a4297$var$each,
    reduce: $cb03b711053a4297$var$reduce,
    isObject: $cb03b711053a4297$var$isObject,
    isPlain: $cb03b711053a4297$var$isPlain,
    merge: $cb03b711053a4297$var$merge$1,
    values: $cb03b711053a4297$var$values,
    defineLazyProperty: $cb03b711053a4297$var$defineLazyProperty
});
/**
 * @file browser.js
 * @module browser
 */ /**
 * Whether or not this device is an iPod.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_IPOD = false;
/**
 * The detected iOS version - or `null`.
 *
 * @static
 * @type {string|null}
 */ let $cb03b711053a4297$var$IOS_VERSION = null;
/**
 * Whether or not this is an Android device.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_ANDROID = false;
/**
 * The detected Android version - or `null` if not Android or indeterminable.
 *
 * @static
 * @type {number|string|null}
 */ let $cb03b711053a4297$var$ANDROID_VERSION;
/**
 * Whether or not this is Mozilla Firefox.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_FIREFOX = false;
/**
 * Whether or not this is Microsoft Edge.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_EDGE = false;
/**
 * Whether or not this is any Chromium Browser
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_CHROMIUM = false;
/**
 * Whether or not this is any Chromium browser that is not Edge.
 *
 * This will also be `true` for Chrome on iOS, which will have different support
 * as it is actually Safari under the hood.
 *
 * Deprecated, as the behaviour to not match Edge was to prevent Legacy Edge's UA matching.
 * IS_CHROMIUM should be used instead.
 * "Chromium but not Edge" could be explicitly tested with IS_CHROMIUM && !IS_EDGE
 *
 * @static
 * @deprecated
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_CHROME = false;
/**
 * The detected Chromium version - or `null`.
 *
 * @static
 * @type {number|null}
 */ let $cb03b711053a4297$var$CHROMIUM_VERSION = null;
/**
 * The detected Google Chrome version - or `null`.
 * This has always been the _Chromium_ version, i.e. would return on Chromium Edge.
 * Deprecated, use CHROMIUM_VERSION instead.
 *
 * @static
 * @deprecated
 * @type {number|null}
 */ let $cb03b711053a4297$var$CHROME_VERSION = null;
/**
 * The detected Internet Explorer version - or `null`.
 *
 * @static
 * @deprecated
 * @type {number|null}
 */ let $cb03b711053a4297$var$IE_VERSION = null;
/**
 * Whether or not this is desktop Safari.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_SAFARI = false;
/**
 * Whether or not this is a Windows machine.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_WINDOWS = false;
/**
 * Whether or not this device is an iPad.
 *
 * @static
 * @type {Boolean}
 */ let $cb03b711053a4297$var$IS_IPAD = false;
/**
 * Whether or not this device is an iPhone.
 *
 * @static
 * @type {Boolean}
 */ // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
let $cb03b711053a4297$var$IS_IPHONE = false;
/**
 * Whether or not this device is touch-enabled.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $cb03b711053a4297$var$TOUCH_ENABLED = Boolean($cb03b711053a4297$var$isReal() && ("ontouchstart" in (0, (/*@__PURE__*/$parcel$interopDefault($eDick))) || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.maxTouchPoints || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).DocumentTouch && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).document instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).DocumentTouch));
const $cb03b711053a4297$var$UAD = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.userAgentData;
if ($cb03b711053a4297$var$UAD) {
    // If userAgentData is present, use it instead of userAgent to avoid warnings
    // Currently only implemented on Chromium
    // userAgentData does not expose Android version, so ANDROID_VERSION remains `null`
    $cb03b711053a4297$var$IS_ANDROID = $cb03b711053a4297$var$UAD.platform === "Android";
    $cb03b711053a4297$var$IS_EDGE = Boolean($cb03b711053a4297$var$UAD.brands.find((b)=>b.brand === "Microsoft Edge"));
    $cb03b711053a4297$var$IS_CHROMIUM = Boolean($cb03b711053a4297$var$UAD.brands.find((b)=>b.brand === "Chromium"));
    $cb03b711053a4297$var$IS_CHROME = !$cb03b711053a4297$var$IS_EDGE && $cb03b711053a4297$var$IS_CHROMIUM;
    $cb03b711053a4297$var$CHROMIUM_VERSION = $cb03b711053a4297$var$CHROME_VERSION = ($cb03b711053a4297$var$UAD.brands.find((b)=>b.brand === "Chromium") || {}).version || null;
    $cb03b711053a4297$var$IS_WINDOWS = $cb03b711053a4297$var$UAD.platform === "Windows";
}
// If the browser is not Chromium, either userAgentData is not present which could be an old Chromium browser,
//  or it's a browser that has added userAgentData since that we don't have tests for yet. In either case,
// the checks need to be made agiainst the regular userAgent string.
if (!$cb03b711053a4297$var$IS_CHROMIUM) {
    const USER_AGENT = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.userAgent || "";
    $cb03b711053a4297$var$IS_IPOD = /iPod/i.test(USER_AGENT);
    $cb03b711053a4297$var$IOS_VERSION = function() {
        const match = USER_AGENT.match(/OS (\d+)_/i);
        if (match && match[1]) return match[1];
        return null;
    }();
    $cb03b711053a4297$var$IS_ANDROID = /Android/i.test(USER_AGENT);
    $cb03b711053a4297$var$ANDROID_VERSION = function() {
        // This matches Android Major.Minor.Patch versions
        // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
        const match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
        if (!match) return null;
        const major = match[1] && parseFloat(match[1]);
        const minor = match[2] && parseFloat(match[2]);
        if (major && minor) return parseFloat(match[1] + "." + match[2]);
        else if (major) return major;
        return null;
    }();
    $cb03b711053a4297$var$IS_FIREFOX = /Firefox/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_EDGE = /Edg/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_CHROMIUM = /Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_CHROME = !$cb03b711053a4297$var$IS_EDGE && $cb03b711053a4297$var$IS_CHROMIUM;
    $cb03b711053a4297$var$CHROMIUM_VERSION = $cb03b711053a4297$var$CHROME_VERSION = function() {
        const match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
        if (match && match[2]) return parseFloat(match[2]);
        return null;
    }();
    $cb03b711053a4297$var$IE_VERSION = function() {
        const result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
        let version = result && parseFloat(result[1]);
        if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) // IE 11 has a different user agent string than other IE versions
        version = 11.0;
        return version;
    }();
    $cb03b711053a4297$var$IS_SAFARI = /Safari/i.test(USER_AGENT) && !$cb03b711053a4297$var$IS_CHROME && !$cb03b711053a4297$var$IS_ANDROID && !$cb03b711053a4297$var$IS_EDGE;
    $cb03b711053a4297$var$IS_WINDOWS = /Windows/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_IPAD = /iPad/i.test(USER_AGENT) || $cb03b711053a4297$var$IS_SAFARI && $cb03b711053a4297$var$TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
    $cb03b711053a4297$var$IS_IPHONE = /iPhone/i.test(USER_AGENT) && !$cb03b711053a4297$var$IS_IPAD;
}
/**
 * Whether or not this is an iOS device.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $cb03b711053a4297$var$IS_IOS = $cb03b711053a4297$var$IS_IPHONE || $cb03b711053a4297$var$IS_IPAD || $cb03b711053a4297$var$IS_IPOD;
/**
 * Whether or not this is any flavor of Safari - including iOS.
 *
 * @static
 * @const
 * @type {Boolean}
 */ const $cb03b711053a4297$var$IS_ANY_SAFARI = ($cb03b711053a4297$var$IS_SAFARI || $cb03b711053a4297$var$IS_IOS) && !$cb03b711053a4297$var$IS_CHROME;
var $cb03b711053a4297$var$browser = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get IS_IPOD () {
        return $cb03b711053a4297$var$IS_IPOD;
    },
    get IOS_VERSION () {
        return $cb03b711053a4297$var$IOS_VERSION;
    },
    get IS_ANDROID () {
        return $cb03b711053a4297$var$IS_ANDROID;
    },
    get ANDROID_VERSION () {
        return $cb03b711053a4297$var$ANDROID_VERSION;
    },
    get IS_FIREFOX () {
        return $cb03b711053a4297$var$IS_FIREFOX;
    },
    get IS_EDGE () {
        return $cb03b711053a4297$var$IS_EDGE;
    },
    get IS_CHROMIUM () {
        return $cb03b711053a4297$var$IS_CHROMIUM;
    },
    get IS_CHROME () {
        return $cb03b711053a4297$var$IS_CHROME;
    },
    get CHROMIUM_VERSION () {
        return $cb03b711053a4297$var$CHROMIUM_VERSION;
    },
    get CHROME_VERSION () {
        return $cb03b711053a4297$var$CHROME_VERSION;
    },
    get IE_VERSION () {
        return $cb03b711053a4297$var$IE_VERSION;
    },
    get IS_SAFARI () {
        return $cb03b711053a4297$var$IS_SAFARI;
    },
    get IS_WINDOWS () {
        return $cb03b711053a4297$var$IS_WINDOWS;
    },
    get IS_IPAD () {
        return $cb03b711053a4297$var$IS_IPAD;
    },
    get IS_IPHONE () {
        return $cb03b711053a4297$var$IS_IPHONE;
    },
    TOUCH_ENABLED: $cb03b711053a4297$var$TOUCH_ENABLED,
    IS_IOS: $cb03b711053a4297$var$IS_IOS,
    IS_ANY_SAFARI: $cb03b711053a4297$var$IS_ANY_SAFARI
});
/**
 * @file dom.js
 * @module dom
 */ /**
 * Detect if a value is a string with any non-whitespace characters.
 *
 * @private
 * @param  {string} str
 *         The string to check
 *
 * @return {boolean}
 *         Will be `true` if the string is non-blank, `false` otherwise.
 *
 */ function $cb03b711053a4297$var$isNonBlankString(str) {
    // we use str.trim as it will trim any whitespace characters
    // from the front or back of non-whitespace characters. aka
    // Any string that contains non-whitespace characters will
    // still contain them after `trim` but whitespace only strings
    // will have a length of 0, failing this check.
    return typeof str === "string" && Boolean(str.trim());
}
/**
 * Throws an error if the passed string has whitespace. This is used by
 * class methods to be relatively consistent with the classList API.
 *
 * @private
 * @param  {string} str
 *         The string to check for whitespace.
 *
 * @throws {Error}
 *         Throws an error if there is whitespace in the string.
 */ function $cb03b711053a4297$var$throwIfWhitespace(str) {
    // str.indexOf instead of regex because str.indexOf is faster performance wise.
    if (str.indexOf(" ") >= 0) throw new Error("class has illegal whitespace characters");
}
/**
 * Whether the current DOM interface appears to be real (i.e. not simulated).
 *
 * @return {boolean}
 *         Will be `true` if the DOM appears to be real, `false` otherwise.
 */ function $cb03b711053a4297$var$isReal() {
    // Both document and window will never be undefined thanks to `global`.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) === (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).document;
}
/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @param  {*} value
 *         The value to check.
 *
 * @return {boolean}
 *         Will be `true` if the value is a DOM element, `false` otherwise.
 */ function $cb03b711053a4297$var$isEl(value) {
    return $cb03b711053a4297$var$isObject(value) && value.nodeType === 1;
}
/**
 * Determines if the current DOM is embedded in an iframe.
 *
 * @return {boolean}
 *         Will be `true` if the DOM is embedded in an iframe, `false`
 *         otherwise.
 */ function $cb03b711053a4297$var$isInFrame() {
    // We need a try/catch here because Safari will throw errors when attempting
    // to get either `parent` or `self`
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).parent !== (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).self;
    } catch (x) {
        return true;
    }
}
/**
 * Creates functions to query the DOM using a given method.
 *
 * @private
 * @param   {string} method
 *          The method to create the query with.
 *
 * @return  {Function}
 *          The query method
 */ function $cb03b711053a4297$var$createQuerier(method) {
    return function(selector, context) {
        if (!$cb03b711053a4297$var$isNonBlankString(selector)) return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[method](null);
        if ($cb03b711053a4297$var$isNonBlankString(context)) context = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).querySelector(context);
        const ctx = $cb03b711053a4297$var$isEl(context) ? context : (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)));
        return ctx[method] && ctx[method](selector);
    };
}
/**
 * Creates an element and applies properties, attributes, and inserts content.
 *
 * @param  {string} [tagName='div']
 *         Name of tag to be created.
 *
 * @param  {Object} [properties={}]
 *         Element properties to be applied.
 *
 * @param  {Object} [attributes={}]
 *         Element attributes to be applied.
 *
 * @param {ContentDescriptor} [content]
 *        A content descriptor object.
 *
 * @return {Element}
 *         The element that was created.
 */ function $cb03b711053a4297$var$createEl(tagName = "div", properties = {}, attributes = {}, content) {
    const el = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement(tagName);
    Object.getOwnPropertyNames(properties).forEach(function(propName) {
        const val = properties[propName];
        // Handle textContent since it's not supported everywhere and we have a
        // method for it.
        if (propName === "textContent") $cb03b711053a4297$var$textContent(el, val);
        else if (el[propName] !== val || propName === "tabIndex") el[propName] = val;
    });
    Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
        el.setAttribute(attrName, attributes[attrName]);
    });
    if (content) $cb03b711053a4297$var$appendContent(el, content);
    return el;
}
/**
 * Injects text into an element, replacing any existing contents entirely.
 *
 * @param  {HTMLElement} el
 *         The element to add text content into
 *
 * @param  {string} text
 *         The text content to add.
 *
 * @return {Element}
 *         The element with added text content.
 */ function $cb03b711053a4297$var$textContent(el, text) {
    if (typeof el.textContent === "undefined") el.innerText = text;
    else el.textContent = text;
    return el;
}
/**
 * Insert an element as the first child node of another
 *
 * @param {Element} child
 *        Element to insert
 *
 * @param {Element} parent
 *        Element to insert child into
 */ function $cb03b711053a4297$var$prependTo(child, parent) {
    if (parent.firstChild) parent.insertBefore(child, parent.firstChild);
    else parent.appendChild(child);
}
/**
 * Check if an element has a class name.
 *
 * @param  {Element} element
 *         Element to check
 *
 * @param  {string} classToCheck
 *         Class name to check for
 *
 * @return {boolean}
 *         Will be `true` if the element has a class, `false` otherwise.
 *
 * @throws {Error}
 *         Throws an error if `classToCheck` has white space.
 */ function $cb03b711053a4297$var$hasClass(element, classToCheck) {
    $cb03b711053a4297$var$throwIfWhitespace(classToCheck);
    return element.classList.contains(classToCheck);
}
/**
 * Add a class name to an element.
 *
 * @param  {Element} element
 *         Element to add class name to.
 *
 * @param  {...string} classesToAdd
 *         One or more class name to add.
 *
 * @return {Element}
 *         The DOM element with the added class name.
 */ function $cb03b711053a4297$var$addClass(element, ...classesToAdd) {
    element.classList.add(...classesToAdd.reduce((prev, current)=>prev.concat(current.split(/\s+/)), []));
    return element;
}
/**
 * Remove a class name from an element.
 *
 * @param  {Element} element
 *         Element to remove a class name from.
 *
 * @param  {...string} classesToRemove
 *         One or more class name to remove.
 *
 * @return {Element}
 *         The DOM element with class name removed.
 */ function $cb03b711053a4297$var$removeClass(element, ...classesToRemove) {
    // Protect in case the player gets disposed
    if (!element) {
        $cb03b711053a4297$var$log$1.warn("removeClass was called with an element that doesn't exist");
        return null;
    }
    element.classList.remove(...classesToRemove.reduce((prev, current)=>prev.concat(current.split(/\s+/)), []));
    return element;
}
/**
 * The callback definition for toggleClass.
 *
 * @callback module:dom~PredicateCallback
 * @param    {Element} element
 *           The DOM element of the Component.
 *
 * @param    {string} classToToggle
 *           The `className` that wants to be toggled
 *
 * @return   {boolean|undefined}
 *           If `true` is returned, the `classToToggle` will be added to the
 *           `element`. If `false`, the `classToToggle` will be removed from
 *           the `element`. If `undefined`, the callback will be ignored.
 */ /**
 * Adds or removes a class name to/from an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @param  {Element} element
 *         The element to toggle a class name on.
 *
 * @param  {string} classToToggle
 *         The class that should be toggled.
 *
 * @param  {boolean|module:dom~PredicateCallback} [predicate]
 *         See the return value for {@link module:dom~PredicateCallback}
 *
 * @return {Element}
 *         The element with a class that has been toggled.
 */ function $cb03b711053a4297$var$toggleClass(element, classToToggle, predicate) {
    if (typeof predicate === "function") predicate = predicate(element, classToToggle);
    if (typeof predicate !== "boolean") predicate = undefined;
    classToToggle.split(/\s+/).forEach((className)=>element.classList.toggle(className, predicate));
    return element;
}
/**
 * Apply attributes to an HTML element.
 *
 * @param {Element} el
 *        Element to add attributes to.
 *
 * @param {Object} [attributes]
 *        Attributes to be applied.
 */ function $cb03b711053a4297$var$setAttributes(el, attributes) {
    Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
        const attrValue = attributes[attrName];
        if (attrValue === null || typeof attrValue === "undefined" || attrValue === false) el.removeAttribute(attrName);
        else el.setAttribute(attrName, attrValue === true ? "" : attrValue);
    });
}
/**
 * Get an element's attribute values, as defined on the HTML tag.
 *
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute.
 *
 * @param  {Element} tag
 *         Element from which to get tag attributes.
 *
 * @return {Object}
 *         All attributes of the element. Boolean attributes will be `true` or
 *         `false`, others will be strings.
 */ function $cb03b711053a4297$var$getAttributes(tag) {
    const obj = {};
    // known boolean attributes
    // we can check for matching boolean properties, but not all browsers
    // and not all tags know about these attributes, so, we still want to check them manually
    const knownBooleans = [
        "autoplay",
        "controls",
        "playsinline",
        "loop",
        "muted",
        "default",
        "defaultMuted"
    ];
    if (tag && tag.attributes && tag.attributes.length > 0) {
        const attrs = tag.attributes;
        for(let i = attrs.length - 1; i >= 0; i--){
            const attrName = attrs[i].name;
            /** @type {boolean|string} */ let attrVal = attrs[i].value;
            // check for known booleans
            // the matching element property will return a value for typeof
            if (knownBooleans.includes(attrName)) // the value of an included boolean attribute is typically an empty
            // string ('') which would equal false if we just check for a false value.
            // we also don't want support bad code like autoplay='false'
            attrVal = attrVal !== null ? true : false;
            obj[attrName] = attrVal;
        }
    }
    return obj;
}
/**
 * Get the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to get the value of.
 *
 * @return {string}
 *         The value of the attribute.
 */ function $cb03b711053a4297$var$getAttribute(el, attribute) {
    return el.getAttribute(attribute);
}
/**
 * Set the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to set.
 *
 * @param {string} value
 *        Value to set the attribute to.
 */ function $cb03b711053a4297$var$setAttribute(el, attribute, value) {
    el.setAttribute(attribute, value);
}
/**
 * Remove an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to remove.
 */ function $cb03b711053a4297$var$removeAttribute(el, attribute) {
    el.removeAttribute(attribute);
}
/**
 * Attempt to block the ability to select text.
 */ function $cb03b711053a4297$var$blockTextSelection() {
    (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body.focus();
    (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).onselectstart = function() {
        return false;
    };
}
/**
 * Turn off text selection blocking.
 */ function $cb03b711053a4297$var$unblockTextSelection() {
    (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).onselectstart = function() {
        return true;
    };
}
/**
 * Identical to the native `getBoundingClientRect` function, but ensures that
 * the method is supported at all (it is in all browsers we claim to support)
 * and that the element is in the DOM before continuing.
 *
 * This wrapper function also shims properties which are not provided by some
 * older browsers (namely, IE8).
 *
 * Additionally, some browsers do not support adding properties to a
 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
 * properties (except `x` and `y` which are not widely supported). This helps
 * avoid implementations where keys are non-enumerable.
 *
 * @param  {Element} el
 *         Element whose `ClientRect` we want to calculate.
 *
 * @return {Object|undefined}
 *         Always returns a plain object - or `undefined` if it cannot.
 */ function $cb03b711053a4297$var$getBoundingClientRect(el) {
    if (el && el.getBoundingClientRect && el.parentNode) {
        const rect = el.getBoundingClientRect();
        const result = {};
        [
            "bottom",
            "height",
            "left",
            "right",
            "top",
            "width"
        ].forEach((k)=>{
            if (rect[k] !== undefined) result[k] = rect[k];
        });
        if (!result.height) result.height = parseFloat($cb03b711053a4297$var$computedStyle(el, "height"));
        if (!result.width) result.width = parseFloat($cb03b711053a4297$var$computedStyle(el, "width"));
        return result;
    }
}
/**
 * Represents the position of a DOM element on the page.
 *
 * @typedef  {Object} module:dom~Position
 *
 * @property {number} left
 *           Pixels to the left.
 *
 * @property {number} top
 *           Pixels from the top.
 */ /**
 * Get the position of an element in the DOM.
 *
 * Uses `getBoundingClientRect` technique from John Resig.
 *
 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @param  {Element} el
 *         Element from which to get offset.
 *
 * @return {module:dom~Position}
 *         The position of the element that was passed in.
 */ function $cb03b711053a4297$var$findPosition(el) {
    if (!el || el && !el.offsetParent) return {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    };
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    let left = 0;
    let top = 0;
    while(el.offsetParent && el !== (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[$cb03b711053a4297$var$FullscreenApi.fullscreenElement]){
        left += el.offsetLeft;
        top += el.offsetTop;
        el = el.offsetParent;
    }
    return {
        left: left,
        top: top,
        width: width,
        height: height
    };
}
/**
 * Represents x and y coordinates for a DOM element or mouse pointer.
 *
 * @typedef  {Object} module:dom~Coordinates
 *
 * @property {number} x
 *           x coordinate in pixels
 *
 * @property {number} y
 *           y coordinate in pixels
 */ /**
 * Get the pointer position within an element.
 *
 * The base on the coordinates are the bottom left of the element.
 *
 * @param  {Element} el
 *         Element on which to get the pointer position on.
 *
 * @param  {Event} event
 *         Event object.
 *
 * @return {module:dom~Coordinates}
 *         A coordinates object corresponding to the mouse position.
 *
 */ function $cb03b711053a4297$var$getPointerPosition(el, event) {
    const translated = {
        x: 0,
        y: 0
    };
    if ($cb03b711053a4297$var$IS_IOS) {
        let item = el;
        while(item && item.nodeName.toLowerCase() !== "html"){
            const transform = $cb03b711053a4297$var$computedStyle(item, "transform");
            if (/^matrix/.test(transform)) {
                const values = transform.slice(7, -1).split(/,\s/).map(Number);
                translated.x += values[4];
                translated.y += values[5];
            } else if (/^matrix3d/.test(transform)) {
                const values = transform.slice(9, -1).split(/,\s/).map(Number);
                translated.x += values[12];
                translated.y += values[13];
            }
            item = item.parentNode;
        }
    }
    const position = {};
    const boxTarget = $cb03b711053a4297$var$findPosition(event.target);
    const box = $cb03b711053a4297$var$findPosition(el);
    const boxW = box.width;
    const boxH = box.height;
    let offsetY = event.offsetY - (box.top - boxTarget.top);
    let offsetX = event.offsetX - (box.left - boxTarget.left);
    if (event.changedTouches) {
        offsetX = event.changedTouches[0].pageX - box.left;
        offsetY = event.changedTouches[0].pageY + box.top;
        if ($cb03b711053a4297$var$IS_IOS) {
            offsetX -= translated.x;
            offsetY -= translated.y;
        }
    }
    position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
    position.x = Math.max(0, Math.min(1, offsetX / boxW));
    return position;
}
/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @param  {*} value
 *         Check if this value is a text node.
 *
 * @return {boolean}
 *         Will be `true` if the value is a text node, `false` otherwise.
 */ function $cb03b711053a4297$var$isTextNode(value) {
    return $cb03b711053a4297$var$isObject(value) && value.nodeType === 3;
}
/**
 * Empties the contents of an element.
 *
 * @param  {Element} el
 *         The element to empty children from
 *
 * @return {Element}
 *         The element with no children
 */ function $cb03b711053a4297$var$emptyEl(el) {
    while(el.firstChild)el.removeChild(el.firstChild);
    return el;
}
/**
 * This is a mixed value that describes content to be injected into the DOM
 * via some method. It can be of the following types:
 *
 * Type       | Description
 * -----------|-------------
 * `string`   | The value will be normalized into a text node.
 * `Element`  | The value will be accepted as-is.
 * `Text`     | A TextNode. The value will be accepted as-is.
 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
 *
 * @typedef {string|Element|Text|Array|Function} ContentDescriptor
 */ /**
 * Normalizes content for eventual insertion into the DOM.
 *
 * This allows a wide range of content definition methods, but helps protect
 * from falling into the trap of simply writing to `innerHTML`, which could
 * be an XSS concern.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Array}
 *         All of the content that was passed in, normalized to an array of
 *         elements or text nodes.
 */ function $cb03b711053a4297$var$normalizeContent(content) {
    // First, invoke content if it is a function. If it produces an array,
    // that needs to happen before normalization.
    if (typeof content === "function") content = content();
    // Next up, normalize to an array, so one or many items can be normalized,
    // filtered, and returned.
    return (Array.isArray(content) ? content : [
        content
    ]).map((value)=>{
        // First, invoke value if it is a function to produce a new value,
        // which will be subsequently normalized to a Node of some kind.
        if (typeof value === "function") value = value();
        if ($cb03b711053a4297$var$isEl(value) || $cb03b711053a4297$var$isTextNode(value)) return value;
        if (typeof value === "string" && /\S/.test(value)) return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(value);
    }).filter((value)=>value);
}
/**
 * Normalizes and appends content to an element.
 *
 * @param  {Element} el
 *         Element to append normalized content to.
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with appended normalized content.
 */ function $cb03b711053a4297$var$appendContent(el, content) {
    $cb03b711053a4297$var$normalizeContent(content).forEach((node)=>el.appendChild(node));
    return el;
}
/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * @param {Element} el
 *        Element to insert normalized content into.
 *
 * @param {ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with inserted normalized content.
 */ function $cb03b711053a4297$var$insertContent(el, content) {
    return $cb03b711053a4297$var$appendContent($cb03b711053a4297$var$emptyEl(el), content);
}
/**
 * Check if an event was a single left click.
 *
 * @param  {MouseEvent} event
 *         Event object.
 *
 * @return {boolean}
 *         Will be `true` if a single left click, `false` otherwise.
 */ function $cb03b711053a4297$var$isSingleLeftClick(event) {
    // Note: if you create something draggable, be sure to
    // call it on both `mousedown` and `mousemove` event,
    // otherwise `mousedown` should be enough for a button
    if (event.button === undefined && event.buttons === undefined) // Why do we need `buttons` ?
    // Because, middle mouse sometimes have this:
    // e.button === 0 and e.buttons === 4
    // Furthermore, we want to prevent combination click, something like
    // HOLD middlemouse then left click, that would be
    // e.button === 0, e.buttons === 5
    // just `button` is not gonna work
    // Alright, then what this block does ?
    // this is for chrome `simulate mobile devices`
    // I want to support this as well
    return true;
    if (event.button === 0 && event.buttons === undefined) // Touch screen, sometimes on some specific device, `buttons`
    // doesn't have anything (safari on ios, blackberry...)
    return true;
    // `mouseup` event on a single left click has
    // `button` and `buttons` equal to 0
    if (event.type === "mouseup" && event.button === 0 && event.buttons === 0) return true;
    if (event.button !== 0 || event.buttons !== 1) // This is the reason we have those if else block above
    // if any special case we can catch and let it slide
    // we do it above, when get to here, this definitely
    // is-not-left-click
    return false;
    return true;
}
/**
 * Finds a single DOM element matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelector`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {Element|null}
 *         The element that was found or null.
 */ const $cb03b711053a4297$var$$ = $cb03b711053a4297$var$createQuerier("querySelector");
/**
 * Finds a all DOM elements matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelectorAll`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {NodeList}
 *         A element list of elements that were found. Will be empty if none
 *         were found.
 *
 */ const $cb03b711053a4297$var$$$ = $cb03b711053a4297$var$createQuerier("querySelectorAll");
/**
 * A safe getComputedStyle.
 *
 * This is needed because in Firefox, if the player is loaded in an iframe with
 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
 * null-check to make sure that the player doesn't break in these cases.
 *
 * @param    {Element} el
 *           The element you want the computed style of
 *
 * @param    {string} prop
 *           The property name you want
 *
 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function $cb03b711053a4297$var$computedStyle(el, prop) {
    if (!el || !prop) return "";
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle === "function") {
        let computedStyleValue;
        try {
            computedStyleValue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(el);
        } catch (e) {
            return "";
        }
        return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : "";
    }
    return "";
}
/**
 * Copy document style sheets to another window.
 *
 * @param    {Window} win
 *           The window element you want to copy the document style sheets to.
 *
 */ function $cb03b711053a4297$var$copyStyleSheetsToWindow(win) {
    [
        ...(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).styleSheets
    ].forEach((styleSheet)=>{
        try {
            const cssRules = [
                ...styleSheet.cssRules
            ].map((rule)=>rule.cssText).join("");
            const style = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("style");
            style.textContent = cssRules;
            win.document.head.appendChild(style);
        } catch (e) {
            const link = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("link");
            link.rel = "stylesheet";
            link.type = styleSheet.type;
            // For older Safari this has to be the string; on other browsers setting the MediaList works
            link.media = styleSheet.media.mediaText;
            link.href = styleSheet.href;
            win.document.head.appendChild(link);
        }
    });
}
var $cb03b711053a4297$var$Dom = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isReal: $cb03b711053a4297$var$isReal,
    isEl: $cb03b711053a4297$var$isEl,
    isInFrame: $cb03b711053a4297$var$isInFrame,
    createEl: $cb03b711053a4297$var$createEl,
    textContent: $cb03b711053a4297$var$textContent,
    prependTo: $cb03b711053a4297$var$prependTo,
    hasClass: $cb03b711053a4297$var$hasClass,
    addClass: $cb03b711053a4297$var$addClass,
    removeClass: $cb03b711053a4297$var$removeClass,
    toggleClass: $cb03b711053a4297$var$toggleClass,
    setAttributes: $cb03b711053a4297$var$setAttributes,
    getAttributes: $cb03b711053a4297$var$getAttributes,
    getAttribute: $cb03b711053a4297$var$getAttribute,
    setAttribute: $cb03b711053a4297$var$setAttribute,
    removeAttribute: $cb03b711053a4297$var$removeAttribute,
    blockTextSelection: $cb03b711053a4297$var$blockTextSelection,
    unblockTextSelection: $cb03b711053a4297$var$unblockTextSelection,
    getBoundingClientRect: $cb03b711053a4297$var$getBoundingClientRect,
    findPosition: $cb03b711053a4297$var$findPosition,
    getPointerPosition: $cb03b711053a4297$var$getPointerPosition,
    isTextNode: $cb03b711053a4297$var$isTextNode,
    emptyEl: $cb03b711053a4297$var$emptyEl,
    normalizeContent: $cb03b711053a4297$var$normalizeContent,
    appendContent: $cb03b711053a4297$var$appendContent,
    insertContent: $cb03b711053a4297$var$insertContent,
    isSingleLeftClick: $cb03b711053a4297$var$isSingleLeftClick,
    $: $cb03b711053a4297$var$$,
    $$: $cb03b711053a4297$var$$$,
    computedStyle: $cb03b711053a4297$var$computedStyle,
    copyStyleSheetsToWindow: $cb03b711053a4297$var$copyStyleSheetsToWindow
});
/**
 * @file setup.js - Functions for setting up a player without
 * user interaction based on the data-setup `attribute` of the video tag.
 *
 * @module setup
 */ let $cb03b711053a4297$var$_windowLoaded = false;
let $cb03b711053a4297$var$videojs$1;
/**
 * Set up any tags that have a data-setup `attribute` when the player is started.
 */ const $cb03b711053a4297$var$autoSetup = function() {
    if ($cb03b711053a4297$var$videojs$1.options.autoSetup === false) return;
    const vids = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).getElementsByTagName("video"));
    const audios = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).getElementsByTagName("audio"));
    const divs = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).getElementsByTagName("video-js"));
    const mediaEls = vids.concat(audios, divs);
    // Check if any media elements exist
    if (mediaEls && mediaEls.length > 0) for(let i = 0, e = mediaEls.length; i < e; i++){
        const mediaEl = mediaEls[i];
        // Check if element exists, has getAttribute func.
        if (mediaEl && mediaEl.getAttribute) // Make sure this player hasn't already been set up.
        {
            if (mediaEl.player === undefined) {
                const options = mediaEl.getAttribute("data-setup");
                // Check if data-setup attr exists.
                // We only auto-setup if they've added the data-setup attr.
                if (options !== null) // Create new video.js instance.
                $cb03b711053a4297$var$videojs$1(mediaEl);
            }
        } else {
            $cb03b711053a4297$var$autoSetupTimeout(1);
            break;
        }
    }
    else if (!$cb03b711053a4297$var$_windowLoaded) $cb03b711053a4297$var$autoSetupTimeout(1);
};
/**
 * Wait until the page is loaded before running autoSetup. This will be called in
 * autoSetup if `hasLoaded` returns false.
 *
 * @param {number} wait
 *        How long to wait in ms
 *
 * @param {module:videojs} [vjs]
 *        The videojs library function
 */ function $cb03b711053a4297$var$autoSetupTimeout(wait, vjs) {
    // Protect against breakage in non-browser environments
    if (!$cb03b711053a4297$var$isReal()) return;
    if (vjs) $cb03b711053a4297$var$videojs$1 = vjs;
    (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout($cb03b711053a4297$var$autoSetup, wait);
}
/**
 * Used to set the internal tracking of window loaded state to true.
 *
 * @private
 */ function $cb03b711053a4297$var$setWindowLoaded() {
    $cb03b711053a4297$var$_windowLoaded = true;
    (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).removeEventListener("load", $cb03b711053a4297$var$setWindowLoaded);
}
if ($cb03b711053a4297$var$isReal()) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).readyState === "complete") $cb03b711053a4297$var$setWindowLoaded();
    else /**
     * Listen for the load event on window, and set _windowLoaded to true.
     *
     * We use a standard event listener here to avoid incrementing the GUID
     * before any players are created.
     *
     * @listens load
     */ (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).addEventListener("load", $cb03b711053a4297$var$setWindowLoaded);
}
/**
 * @file stylesheet.js
 * @module stylesheet
 */ /**
 * Create a DOM style element given a className for it.
 *
 * @param {string} className
 *        The className to add to the created style element.
 *
 * @return {Element}
 *         The element that was created.
 */ const $cb03b711053a4297$var$createStyleElement = function(className) {
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("style");
    style.className = className;
    return style;
};
/**
 * Add text to a DOM element.
 *
 * @param {Element} el
 *        The Element to add text content to.
 *
 * @param {string} content
 *        The text to add to the element.
 */ const $cb03b711053a4297$var$setTextContent = function(el, content) {
    if (el.styleSheet) el.styleSheet.cssText = content;
    else el.textContent = content;
};
/**
 * @file dom-data.js
 * @module dom-data
 */ /**
 * Element Data Store.
 *
 * Allows for binding data to an element without putting it directly on the
 * element. Ex. Event listeners are stored here.
 * (also from jsninja.com, slightly modified and updated for closure compiler)
 *
 * @type {Object}
 * @private
 */ var $cb03b711053a4297$var$DomData = new WeakMap();
/**
 * @file guid.js
 * @module guid
 */ // Default value for GUIDs. This allows us to reset the GUID counter in tests.
//
// The initial GUID is 3 because some users have come to rely on the first
// default player ID ending up as `vjs_video_3`.
//
// See: https://github.com/videojs/video.js/pull/6216
const $cb03b711053a4297$var$_initialGuid = 3;
/**
 * Unique ID for an element or function
 *
 * @type {Number}
 */ let $cb03b711053a4297$var$_guid = $cb03b711053a4297$var$_initialGuid;
/**
 * Get a unique auto-incrementing ID by number that has not been returned before.
 *
 * @return {number}
 *         A new unique ID.
 */ function $cb03b711053a4297$var$newGUID() {
    return $cb03b711053a4297$var$_guid++;
}
/**
 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
 * robust as jquery's, so there's probably some differences.
 *
 * @file events.js
 * @module events
 */ /**
 * Clean up the listener cache and dispatchers
 *
 * @param {Element|Object} elem
 *        Element to clean up
 *
 * @param {string} type
 *        Type of event to clean up
 */ function $cb03b711053a4297$var$_cleanUpEvents(elem, type) {
    if (!$cb03b711053a4297$var$DomData.has(elem)) return;
    const data = $cb03b711053a4297$var$DomData.get(elem);
    // Remove the events of a particular type if there are none left
    if (data.handlers[type].length === 0) {
        delete data.handlers[type];
        // data.handlers[type] = null;
        // Setting to null was causing an error with data.handlers
        // Remove the meta-handler from the element
        if (elem.removeEventListener) elem.removeEventListener(type, data.dispatcher, false);
        else if (elem.detachEvent) elem.detachEvent("on" + type, data.dispatcher);
    }
    // Remove the events object if there are no types left
    if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
        delete data.handlers;
        delete data.dispatcher;
        delete data.disabled;
    }
    // Finally remove the element data if there is no data left
    if (Object.getOwnPropertyNames(data).length === 0) $cb03b711053a4297$var$DomData.delete(elem);
}
/**
 * Loops through an array of event types and calls the requested method for each type.
 *
 * @param {Function} fn
 *        The event method we want to use.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string[]} types
 *        Type of event to bind to.
 *
 * @param {Function} callback
 *        Event listener.
 */ function $cb03b711053a4297$var$_handleMultipleEvents(fn, elem, types, callback) {
    types.forEach(function(type) {
        // Call the event method for each one of the types
        fn(elem, type, callback);
    });
}
/**
 * Fix a native event to have standard property values
 *
 * @param {Object} event
 *        Event object to fix.
 *
 * @return {Object}
 *         Fixed event object.
 */ function $cb03b711053a4297$var$fixEvent(event) {
    if (event.fixed_) return event;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Test if fixing up is needed
    // Used to check if !event.stopPropagation instead of isPropagationStopped
    // But native events return true for stopPropagation, but don't have
    // other expected methods like isPropagationStopped. Seems to be a problem
    // with the Javascript Ninja code. So we're just overriding all events now.
    if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
        const old = event || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).event;
        event = {};
        // Clone the old object so that we can modify the values event = {};
        // IE8 Doesn't like when you mess with native event properties
        // Firefox returns false for event.hasOwnProperty('type') and other props
        //  which makes copying more difficult.
        // TODO: Probably best to create a whitelist of event props
        for(const key in old){
            // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
            // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
            // and webkitMovementX/Y
            // Lighthouse complains if Event.path is copied
            if (key !== "layerX" && key !== "layerY" && key !== "keyLocation" && key !== "webkitMovementX" && key !== "webkitMovementY" && key !== "path") // Chrome 32+ warns if you try to copy deprecated returnValue, but
            // we still want to if preventDefault isn't supported (IE8).
            {
                if (!(key === "returnValue" && old.preventDefault)) event[key] = old[key];
            }
        }
        // The event occurred on this element
        if (!event.target) event.target = event.srcElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)));
        // Handle which other element the event is related to
        if (!event.relatedTarget) event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
        // Stop the default browser action
        event.preventDefault = function() {
            if (old.preventDefault) old.preventDefault();
            event.returnValue = false;
            old.returnValue = false;
            event.defaultPrevented = true;
        };
        event.defaultPrevented = false;
        // Stop the event from bubbling
        event.stopPropagation = function() {
            if (old.stopPropagation) old.stopPropagation();
            event.cancelBubble = true;
            old.cancelBubble = true;
            event.isPropagationStopped = returnTrue;
        };
        event.isPropagationStopped = returnFalse;
        // Stop the event from bubbling and executing other handlers
        event.stopImmediatePropagation = function() {
            if (old.stopImmediatePropagation) old.stopImmediatePropagation();
            event.isImmediatePropagationStopped = returnTrue;
            event.stopPropagation();
        };
        event.isImmediatePropagationStopped = returnFalse;
        // Handle mouse position
        if (event.clientX !== null && event.clientX !== undefined) {
            const doc = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement;
            const body = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body;
            event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
            event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
        }
        // Handle key presses
        event.which = event.charCode || event.keyCode;
        // Fix button for mouse clicks:
        // 0 == left; 1 == middle; 2 == right
        if (event.button !== null && event.button !== undefined) // The following is disabled because it does not pass videojs-standard
        // and... yikes.
        /* eslint-disable */ event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
    }
    event.fixed_ = true;
    // Returns fixed-up instance
    return event;
}
/**
 * Whether passive event listeners are supported
 */ let $cb03b711053a4297$var$_supportsPassive;
const $cb03b711053a4297$var$supportsPassive = function() {
    if (typeof $cb03b711053a4297$var$_supportsPassive !== "boolean") {
        $cb03b711053a4297$var$_supportsPassive = false;
        try {
            const opts = Object.defineProperty({}, "passive", {
                get () {
                    $cb03b711053a4297$var$_supportsPassive = true;
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).addEventListener("test", null, opts);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).removeEventListener("test", null, opts);
        } catch (e) {
        // disregard
        }
    }
    return $cb03b711053a4297$var$_supportsPassive;
};
/**
 * Touch events Chrome expects to be passive
 */ const $cb03b711053a4297$var$passiveEvents = [
    "touchstart",
    "touchmove"
];
/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string|string[]} type
 *        Type of event to bind to.
 *
 * @param {Function} fn
 *        Event listener.
 */ function $cb03b711053a4297$var$on(elem, type, fn) {
    if (Array.isArray(type)) return $cb03b711053a4297$var$_handleMultipleEvents($cb03b711053a4297$var$on, elem, type, fn);
    if (!$cb03b711053a4297$var$DomData.has(elem)) $cb03b711053a4297$var$DomData.set(elem, {});
    const data = $cb03b711053a4297$var$DomData.get(elem);
    // We need a place to store all our handler data
    if (!data.handlers) data.handlers = {};
    if (!data.handlers[type]) data.handlers[type] = [];
    if (!fn.guid) fn.guid = $cb03b711053a4297$var$newGUID();
    data.handlers[type].push(fn);
    if (!data.dispatcher) {
        data.disabled = false;
        data.dispatcher = function(event, hash) {
            if (data.disabled) return;
            event = $cb03b711053a4297$var$fixEvent(event);
            const handlers = data.handlers[event.type];
            if (handlers) {
                // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
                const handlersCopy = handlers.slice(0);
                for(let m = 0, n = handlersCopy.length; m < n; m++){
                    if (event.isImmediatePropagationStopped()) break;
                    else try {
                        handlersCopy[m].call(elem, event, hash);
                    } catch (e) {
                        $cb03b711053a4297$var$log$1.error(e);
                    }
                }
            }
        };
    }
    if (data.handlers[type].length === 1) {
        if (elem.addEventListener) {
            let options = false;
            if ($cb03b711053a4297$var$supportsPassive() && $cb03b711053a4297$var$passiveEvents.indexOf(type) > -1) options = {
                passive: true
            };
            elem.addEventListener(type, data.dispatcher, options);
        } else if (elem.attachEvent) elem.attachEvent("on" + type, data.dispatcher);
    }
}
/**
 * Removes event listeners from an element
 *
 * @param {Element|Object} elem
 *        Object to remove listeners from.
 *
 * @param {string|string[]} [type]
 *        Type of listener to remove. Don't include to remove all events from element.
 *
 * @param {Function} [fn]
 *        Specific listener to remove. Don't include to remove listeners for an event
 *        type.
 */ function $cb03b711053a4297$var$off(elem, type, fn) {
    // Don't want to add a cache object through getElData if not needed
    if (!$cb03b711053a4297$var$DomData.has(elem)) return;
    const data = $cb03b711053a4297$var$DomData.get(elem);
    // If no events exist, nothing to unbind
    if (!data.handlers) return;
    if (Array.isArray(type)) return $cb03b711053a4297$var$_handleMultipleEvents($cb03b711053a4297$var$off, elem, type, fn);
    // Utility function
    const removeType = function(el, t) {
        data.handlers[t] = [];
        $cb03b711053a4297$var$_cleanUpEvents(el, t);
    };
    // Are we removing all bound events?
    if (type === undefined) {
        for(const t in data.handlers)if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) removeType(elem, t);
        return;
    }
    const handlers = data.handlers[type];
    // If no handlers exist, nothing to unbind
    if (!handlers) return;
    // If no listener was provided, remove all listeners for type
    if (!fn) {
        removeType(elem, type);
        return;
    }
    // We're only removing a single handler
    if (fn.guid) {
        for(let n = 0; n < handlers.length; n++)if (handlers[n].guid === fn.guid) handlers.splice(n--, 1);
    }
    $cb03b711053a4297$var$_cleanUpEvents(elem, type);
}
/**
 * Trigger an event for an element
 *
 * @param {Element|Object} elem
 *        Element to trigger an event on
 *
 * @param {EventTarget~Event|string} event
 *        A string (the type) or an event object with a type attribute
 *
 * @param {Object} [hash]
 *        data hash to pass along with the event
 *
 * @return {boolean|undefined}
 *         Returns the opposite of `defaultPrevented` if default was
 *         prevented. Otherwise, returns `undefined`
 */ function $cb03b711053a4297$var$trigger(elem, event, hash) {
    // Fetches element data and a reference to the parent (for bubbling).
    // Don't want to add a data object to cache for every parent,
    // so checking hasElData first.
    const elemData = $cb03b711053a4297$var$DomData.has(elem) ? $cb03b711053a4297$var$DomData.get(elem) : {};
    const parent = elem.parentNode || elem.ownerDocument;
    // type = event.type || event,
    // handler;
    // If an event name was passed as a string, creates an event out of it
    if (typeof event === "string") event = {
        type: event,
        target: elem
    };
    else if (!event.target) event.target = elem;
    // Normalizes the event properties.
    event = $cb03b711053a4297$var$fixEvent(event);
    // If the passed element has a dispatcher, executes the established handlers.
    if (elemData.dispatcher) elemData.dispatcher.call(elem, event, hash);
    // Unless explicitly stopped or the event does not bubble (e.g. media events)
    // recursively calls this function to bubble the event up the DOM.
    if (parent && !event.isPropagationStopped() && event.bubbles === true) $cb03b711053a4297$var$trigger.call(null, parent, event, hash);
    else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
        if (!$cb03b711053a4297$var$DomData.has(event.target)) $cb03b711053a4297$var$DomData.set(event.target, {});
        const targetData = $cb03b711053a4297$var$DomData.get(event.target);
        // Checks if the target has a default action for this event.
        if (event.target[event.type]) {
            // Temporarily disables event dispatching on the target as we have already executed the handler.
            targetData.disabled = true;
            // Executes the default action.
            if (typeof event.target[event.type] === "function") event.target[event.type]();
            // Re-enables event dispatching.
            targetData.disabled = false;
        }
    }
    // Inform the triggerer if the default was prevented by returning false
    return !event.defaultPrevented;
}
/**
 * Trigger a listener only once for an event.
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */ function $cb03b711053a4297$var$one(elem, type, fn) {
    if (Array.isArray(type)) return $cb03b711053a4297$var$_handleMultipleEvents($cb03b711053a4297$var$one, elem, type, fn);
    const func = function() {
        $cb03b711053a4297$var$off(elem, type, func);
        fn.apply(this, arguments);
    };
    // copy the guid to the new function so it can removed using the original function's ID
    func.guid = fn.guid = fn.guid || $cb03b711053a4297$var$newGUID();
    $cb03b711053a4297$var$on(elem, type, func);
}
/**
 * Trigger a listener only once and then turn if off for all
 * configured events
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */ function $cb03b711053a4297$var$any(elem, type, fn) {
    const func = function() {
        $cb03b711053a4297$var$off(elem, type, func);
        fn.apply(this, arguments);
    };
    // copy the guid to the new function so it can removed using the original function's ID
    func.guid = fn.guid = fn.guid || $cb03b711053a4297$var$newGUID();
    // multiple ons, but one off for everything
    $cb03b711053a4297$var$on(elem, type, func);
}
var $cb03b711053a4297$var$Events = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    fixEvent: $cb03b711053a4297$var$fixEvent,
    on: $cb03b711053a4297$var$on,
    off: $cb03b711053a4297$var$off,
    trigger: $cb03b711053a4297$var$trigger,
    one: $cb03b711053a4297$var$one,
    any: $cb03b711053a4297$var$any
});
/**
 * @file fn.js
 * @module fn
 */ const $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL = 30;
/**
 * A private, internal-only function for changing the context of a function.
 *
 * It also stores a unique id on the function so it can be easily removed from
 * events.
 *
 * @private
 * @function
 * @param    {*} context
 *           The object to bind as scope.
 *
 * @param    {Function} fn
 *           The function to be bound to a scope.
 *
 * @param    {number} [uid]
 *           An optional unique ID for the function to be set
 *
 * @return   {Function}
 *           The new function that will be bound into the context given
 */ const $cb03b711053a4297$var$bind_ = function(context, fn, uid) {
    // Make sure the function has a unique ID
    if (!fn.guid) fn.guid = $cb03b711053a4297$var$newGUID();
    // Create the new function that changes the context
    const bound = fn.bind(context);
    // Allow for the ability to individualize this function
    // Needed in the case where multiple objects might share the same prototype
    // IF both items add an event listener with the same function, then you try to remove just one
    // it will remove both because they both have the same guid.
    // when using this, you need to use the bind method when you remove the listener as well.
    // currently used in text tracks
    bound.guid = uid ? uid + "_" + fn.guid : fn.guid;
    return bound;
};
/**
 * Wraps the given function, `fn`, with a new function that only invokes `fn`
 * at most once per every `wait` milliseconds.
 *
 * @function
 * @param    {Function} fn
 *           The function to be throttled.
 *
 * @param    {number}   wait
 *           The number of milliseconds by which to throttle.
 *
 * @return   {Function}
 */ const $cb03b711053a4297$var$throttle = function(fn, wait) {
    let last = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
    const throttled = function(...args) {
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
        if (now - last >= wait) {
            fn(...args);
            last = now;
        }
    };
    return throttled;
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked.
 *
 * Inspired by lodash and underscore implementations.
 *
 * @function
 * @param    {Function} func
 *           The function to wrap with debounce behavior.
 *
 * @param    {number} wait
 *           The number of milliseconds to wait after the last invocation.
 *
 * @param    {boolean} [immediate]
 *           Whether or not to invoke the function immediately upon creation.
 *
 * @param    {Object} [context=window]
 *           The "context" in which the debounced function should debounce. For
 *           example, if this function should be tied to a Video.js player,
 *           the player can be passed here. Alternatively, defaults to the
 *           global `window` object.
 *
 * @return   {Function}
 *           A debounced function.
 */ const $cb03b711053a4297$var$debounce = function(func, wait, immediate, context = (0, (/*@__PURE__*/$parcel$interopDefault($eDick)))) {
    let timeout;
    const cancel = ()=>{
        context.clearTimeout(timeout);
        timeout = null;
    };
    /* eslint-disable consistent-this */ const debounced = function() {
        const self1 = this;
        const args = arguments;
        let later = function() {
            timeout = null;
            later = null;
            if (!immediate) func.apply(self1, args);
        };
        if (!timeout && immediate) func.apply(self1, args);
        context.clearTimeout(timeout);
        timeout = context.setTimeout(later, wait);
    };
    /* eslint-enable consistent-this */ debounced.cancel = cancel;
    return debounced;
};
var $cb03b711053a4297$var$Fn = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    UPDATE_REFRESH_INTERVAL: $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL,
    bind_: $cb03b711053a4297$var$bind_,
    throttle: $cb03b711053a4297$var$throttle,
    debounce: $cb03b711053a4297$var$debounce
});
/**
 * @file src/js/event-target.js
 */ let $cb03b711053a4297$var$EVENT_MAP;
/**
 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
 * adds shorthand functions that wrap around lengthy functions. For example:
 * the `on` function is a wrapper around `addEventListener`.
 *
 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
 * @class EventTarget
 */ class $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */ on(type, fn) {
        // Remove the addEventListener alias before calling Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $cb03b711053a4297$var$on(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */ off(type, fn) {
        $cb03b711053a4297$var$off(this, type, fn);
    }
    /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ one(type, fn) {
        // Remove the addEventListener aliasing Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $cb03b711053a4297$var$one(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ any(type, fn) {
        // Remove the addEventListener aliasing Events.on
        // so we don't get into an infinite type loop
        const ael = this.addEventListener;
        this.addEventListener = ()=>{};
        $cb03b711053a4297$var$any(this, type, fn);
        this.addEventListener = ael;
    }
    /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */ trigger(event) {
        const type = event.type || event;
        // deprecation
        // In a future version we should default target to `this`
        // similar to how we default the target to `elem` in
        // `Events.trigger`. Right now the default `target` will be
        // `document` due to the `Event.fixEvent` call.
        if (typeof event === "string") event = {
            type: type
        };
        event = $cb03b711053a4297$var$fixEvent(event);
        if (this.allowedEvents_[type] && this["on" + type]) this["on" + type](event);
        $cb03b711053a4297$var$trigger(this, event);
    }
    queueTrigger(event) {
        // only set up EVENT_MAP if it'll be used
        if (!$cb03b711053a4297$var$EVENT_MAP) $cb03b711053a4297$var$EVENT_MAP = new Map();
        const type = event.type || event;
        let map = $cb03b711053a4297$var$EVENT_MAP.get(this);
        if (!map) {
            map = new Map();
            $cb03b711053a4297$var$EVENT_MAP.set(this, map);
        }
        const oldTimeout = map.get(type);
        map.delete(type);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(oldTimeout);
        const timeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            map.delete(type);
            // if we cleared out all timeouts for the current target, delete its map
            if (map.size === 0) {
                map = null;
                $cb03b711053a4297$var$EVENT_MAP.delete(this);
            }
            this.trigger(event);
        }, 0);
        map.set(type, timeout);
    }
}
/**
 * A Custom DOM event.
 *
 * @typedef {CustomEvent} Event
 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */ /**
 * All event listeners should follow the following format.
 *
 * @callback EventListener
 * @this {EventTarget}
 *
 * @param {Event} event
 *        the event that triggered this function
 *
 * @param {Object} [hash]
 *        hash of data sent during the event
 */ /**
 * An object containing event names as keys and booleans as values.
 *
 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
 *         will have extra functionality. See that function for more information.
 *
 * @property EventTarget.prototype.allowedEvents_
 * @protected
 */ $cb03b711053a4297$var$EventTarget$2.prototype.allowedEvents_ = {};
/**
 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#on}
 */ $cb03b711053a4297$var$EventTarget$2.prototype.addEventListener = $cb03b711053a4297$var$EventTarget$2.prototype.on;
/**
 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#off}
 */ $cb03b711053a4297$var$EventTarget$2.prototype.removeEventListener = $cb03b711053a4297$var$EventTarget$2.prototype.off;
/**
 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#trigger}
 */ $cb03b711053a4297$var$EventTarget$2.prototype.dispatchEvent = $cb03b711053a4297$var$EventTarget$2.prototype.trigger;
/**
 * @file mixins/evented.js
 * @module evented
 */ const $cb03b711053a4297$var$objName = (obj)=>{
    if (typeof obj.name === "function") return obj.name();
    if (typeof obj.name === "string") return obj.name;
    if (obj.name_) return obj.name_;
    if (obj.constructor && obj.constructor.name) return obj.constructor.name;
    return typeof obj;
};
/**
 * Returns whether or not an object has had the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to test.
 *
 * @return {boolean}
 *         Whether or not the object appears to be evented.
 */ const $cb03b711053a4297$var$isEvented = (object)=>object instanceof $cb03b711053a4297$var$EventTarget$2 || !!object.eventBusEl_ && [
        "on",
        "one",
        "off",
        "trigger"
    ].every((k)=>typeof object[k] === "function");
/**
 * Adds a callback to run after the evented mixin applied.
 *
 * @param  {Object} target
 *         An object to Add
 * @param  {Function} callback
 *         The callback to run.
 */ const $cb03b711053a4297$var$addEventedCallback = (target, callback)=>{
    if ($cb03b711053a4297$var$isEvented(target)) callback();
    else {
        if (!target.eventedCallbacks) target.eventedCallbacks = [];
        target.eventedCallbacks.push(callback);
    }
};
/**
 * Whether a value is a valid event type - non-empty string or array.
 *
 * @private
 * @param  {string|Array} type
 *         The type value to test.
 *
 * @return {boolean}
 *         Whether or not the type is a valid event type.
 */ const $cb03b711053a4297$var$isValidEventType = (type)=>// The regex here verifies that the `type` contains at least one non-
    // whitespace character.
    typeof type === "string" && /\S/.test(type) || Array.isArray(type) && !!type.length;
/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the target does not appear to be a valid event target.
 *
 * @param  {Object} target
 *         The object to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $cb03b711053a4297$var$validateTarget = (target, obj, fnName)=>{
    if (!target || !target.nodeName && !$cb03b711053a4297$var$isEvented(target)) throw new Error(`Invalid target for ${$cb03b711053a4297$var$objName(obj)}#${fnName}; must be a DOM node or evented object.`);
};
/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the type does not appear to be a valid event type.
 *
 * @param  {string|Array} type
 *         The type to test.
 *
 * @param  {Object} obj
*         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $cb03b711053a4297$var$validateEventType = (type, obj, fnName)=>{
    if (!$cb03b711053a4297$var$isValidEventType(type)) throw new Error(`Invalid event type for ${$cb03b711053a4297$var$objName(obj)}#${fnName}; must be a non-empty string or array.`);
};
/**
 * Validates a value to determine if it is a valid listener. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the listener is not a function.
 *
 * @param  {Function} listener
 *         The listener to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */ const $cb03b711053a4297$var$validateListener = (listener, obj, fnName)=>{
    if (typeof listener !== "function") throw new Error(`Invalid listener for ${$cb03b711053a4297$var$objName(obj)}#${fnName}; must be a function.`);
};
/**
 * Takes an array of arguments given to `on()` or `one()`, validates them, and
 * normalizes them into an object.
 *
 * @private
 * @param  {Object} self
 *         The evented object on which `on()` or `one()` was called. This
 *         object will be bound as the `this` value for the listener.
 *
 * @param  {Array} args
 *         An array of arguments passed to `on()` or `one()`.
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 *
 * @return {Object}
 *         An object containing useful values for `on()` or `one()` calls.
 */ const $cb03b711053a4297$var$normalizeListenArgs = (self1, args, fnName)=>{
    // If the number of arguments is less than 3, the target is always the
    // evented object itself.
    const isTargetingSelf = args.length < 3 || args[0] === self1 || args[0] === self1.eventBusEl_;
    let target;
    let type;
    let listener;
    if (isTargetingSelf) {
        target = self1.eventBusEl_;
        // Deal with cases where we got 3 arguments, but we are still listening to
        // the evented object itself.
        if (args.length >= 3) args.shift();
        [type, listener] = args;
    } else [target, type, listener] = args;
    $cb03b711053a4297$var$validateTarget(target, self1, fnName);
    $cb03b711053a4297$var$validateEventType(type, self1, fnName);
    $cb03b711053a4297$var$validateListener(listener, self1, fnName);
    listener = $cb03b711053a4297$var$bind_(self1, listener);
    return {
        isTargetingSelf: isTargetingSelf,
        target: target,
        type: type,
        listener: listener
    };
};
/**
 * Adds the listener to the event type(s) on the target, normalizing for
 * the type of target.
 *
 * @private
 * @param  {Element|Object} target
 *         A DOM node or evented object.
 *
 * @param  {string} method
 *         The event binding method to use ("on" or "one").
 *
 * @param  {string|Array} type
 *         One or more event type(s).
 *
 * @param  {Function} listener
 *         A listener function.
 */ const $cb03b711053a4297$var$listen = (target, method, type, listener)=>{
    $cb03b711053a4297$var$validateTarget(target, target, method);
    if (target.nodeName) $cb03b711053a4297$var$Events[method](target, type, listener);
    else target[method](type, listener);
};
/**
 * Contains methods that provide event capabilities to an object which is passed
 * to {@link module:evented|evented}.
 *
 * @mixin EventedMixin
 */ const $cb03b711053a4297$var$EventedMixin = {
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ on (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $cb03b711053a4297$var$normalizeListenArgs(this, args, "on");
        $cb03b711053a4297$var$listen(target, "on", type, listener);
        // If this object is listening to another evented object.
        if (!isTargetingSelf) {
            // If this object is disposed, remove the listener.
            const removeListenerOnDispose = ()=>this.off(target, type, listener);
            // Use the same function ID as the listener so we can remove it later it
            // using the ID of the original listener.
            removeListenerOnDispose.guid = listener.guid;
            // Add a listener to the target's dispose event as well. This ensures
            // that if the target is disposed BEFORE this object, we remove the
            // removal listener that was just added. Otherwise, we create a memory leak.
            const removeRemoverOnTargetDispose = ()=>this.off("dispose", removeListenerOnDispose);
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            removeRemoverOnTargetDispose.guid = listener.guid;
            $cb03b711053a4297$var$listen(this, "on", "dispose", removeListenerOnDispose);
            $cb03b711053a4297$var$listen(target, "on", "dispose", removeRemoverOnTargetDispose);
        }
    },
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ one (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $cb03b711053a4297$var$normalizeListenArgs(this, args, "one");
        // Targeting this evented object.
        if (isTargetingSelf) $cb03b711053a4297$var$listen(target, "one", type, listener);
        else {
            // TODO: This wrapper is incorrect! It should only
            //       remove the wrapper for the event type that called it.
            //       Instead all listeners are removed on the first trigger!
            //       see https://github.com/videojs/video.js/issues/5962
            const wrapper = (...largs)=>{
                this.off(target, type, wrapper);
                listener.apply(null, largs);
            };
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            wrapper.guid = listener.guid;
            $cb03b711053a4297$var$listen(target, "one", type, wrapper);
        }
    },
    /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */ any (...args) {
        const { isTargetingSelf: isTargetingSelf, target: target, type: type, listener: listener } = $cb03b711053a4297$var$normalizeListenArgs(this, args, "any");
        // Targeting this evented object.
        if (isTargetingSelf) $cb03b711053a4297$var$listen(target, "any", type, listener);
        else {
            const wrapper = (...largs)=>{
                this.off(target, type, wrapper);
                listener.apply(null, largs);
            };
            // Use the same function ID as the listener so we can remove it later
            // it using the ID of the original listener.
            wrapper.guid = listener.guid;
            $cb03b711053a4297$var$listen(target, "any", type, wrapper);
        }
    },
    /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */ off (targetOrType, typeOrListener, listener) {
        // Targeting this evented object.
        if (!targetOrType || $cb03b711053a4297$var$isValidEventType(targetOrType)) $cb03b711053a4297$var$off(this.eventBusEl_, targetOrType, typeOrListener);
        else {
            const target = targetOrType;
            const type = typeOrListener;
            // Fail fast and in a meaningful way!
            $cb03b711053a4297$var$validateTarget(target, this, "off");
            $cb03b711053a4297$var$validateEventType(type, this, "off");
            $cb03b711053a4297$var$validateListener(listener, this, "off");
            // Ensure there's at least a guid, even if the function hasn't been used
            listener = $cb03b711053a4297$var$bind_(this, listener);
            // Remove the dispose listener on this evented object, which was given
            // the same guid as the event listener in on().
            this.off("dispose", listener);
            if (target.nodeName) {
                $cb03b711053a4297$var$off(target, type, listener);
                $cb03b711053a4297$var$off(target, "dispose", listener);
            } else if ($cb03b711053a4297$var$isEvented(target)) {
                target.off(type, listener);
                target.off("dispose", listener);
            }
        }
    },
    /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */ trigger (event, hash) {
        $cb03b711053a4297$var$validateTarget(this.eventBusEl_, this, "trigger");
        const type = event && typeof event !== "string" ? event.type : event;
        if (!$cb03b711053a4297$var$isValidEventType(type)) throw new Error(`Invalid event type for ${$cb03b711053a4297$var$objName(this)}#trigger; ` + "must be a non-empty string or object with a type key that has a non-empty value.");
        return $cb03b711053a4297$var$trigger(this.eventBusEl_, event, hash);
    }
};
/**
 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
 *
 * @param  {Object} target
 *         The object to which to add event methods.
 *
 * @param  {Object} [options={}]
 *         Options for customizing the mixin behavior.
 *
 * @param  {string} [options.eventBusKey]
 *         By default, adds a `eventBusEl_` DOM element to the target object,
 *         which is used as an event bus. If the target object already has a
 *         DOM element that should be used, pass its key here.
 *
 * @return {Object}
 *         The target object.
 */ function $cb03b711053a4297$var$evented(target, options = {}) {
    const { eventBusKey: eventBusKey } = options;
    // Set or create the eventBusEl_.
    if (eventBusKey) {
        if (!target[eventBusKey].nodeName) throw new Error(`The eventBusKey "${eventBusKey}" does not refer to an element.`);
        target.eventBusEl_ = target[eventBusKey];
    } else target.eventBusEl_ = $cb03b711053a4297$var$createEl("span", {
        className: "vjs-event-bus"
    });
    Object.assign(target, $cb03b711053a4297$var$EventedMixin);
    if (target.eventedCallbacks) target.eventedCallbacks.forEach((callback)=>{
        callback();
    });
    // When any evented object is disposed, it removes all its listeners.
    target.on("dispose", ()=>{
        target.off();
        [
            target,
            target.el_,
            target.eventBusEl_
        ].forEach(function(val) {
            if (val && $cb03b711053a4297$var$DomData.has(val)) $cb03b711053a4297$var$DomData.delete(val);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            target.eventBusEl_ = null;
        }, 0);
    });
    return target;
}
/**
 * @file mixins/stateful.js
 * @module stateful
 */ /**
 * Contains methods that provide statefulness to an object which is passed
 * to {@link module:stateful}.
 *
 * @mixin StatefulMixin
 */ const $cb03b711053a4297$var$StatefulMixin = {
    /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */ state: {},
    /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */ setState (stateUpdates) {
        // Support providing the `stateUpdates` state as a function.
        if (typeof stateUpdates === "function") stateUpdates = stateUpdates();
        let changes;
        $cb03b711053a4297$var$each(stateUpdates, (value, key)=>{
            // Record the change if the value is different from what's in the
            // current state.
            if (this.state[key] !== value) {
                changes = changes || {};
                changes[key] = {
                    from: this.state[key],
                    to: value
                };
            }
            this.state[key] = value;
        });
        // Only trigger "statechange" if there were changes AND we have a trigger
        // function. This allows us to not require that the target object be an
        // evented object.
        if (changes && $cb03b711053a4297$var$isEvented(this)) /**
       * An event triggered on an object that is both
       * {@link module:stateful|stateful} and {@link module:evented|evented}
       * indicating that its state has changed.
       *
       * @event    module:stateful~StatefulMixin#statechanged
       * @type     {Object}
       * @property {Object} changes
       *           A hash containing the properties that were changed and
       *           the values they were changed `from` and `to`.
       */ this.trigger({
            changes: changes,
            type: "statechanged"
        });
        return changes;
    }
};
/**
 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
 * object.
 *
 * If the target object is {@link module:evented|evented} and has a
 * `handleStateChanged` method, that method will be automatically bound to the
 * `statechanged` event on itself.
 *
 * @param   {Object} target
 *          The object to be made stateful.
 *
 * @param   {Object} [defaultState]
 *          A default set of properties to populate the newly-stateful object's
 *          `state` property.
 *
 * @return {Object}
 *          Returns the `target`.
 */ function $cb03b711053a4297$var$stateful(target, defaultState) {
    Object.assign(target, $cb03b711053a4297$var$StatefulMixin);
    // This happens after the mixing-in because we need to replace the `state`
    // added in that step.
    target.state = Object.assign({}, target.state, defaultState);
    // Auto-bind the `handleStateChanged` method of the target object if it exists.
    if (typeof target.handleStateChanged === "function" && $cb03b711053a4297$var$isEvented(target)) target.on("statechanged", target.handleStateChanged);
    return target;
}
/**
 * @file str.js
 * @module to-lower-case
 */ /**
 * Lowercase the first letter of a string.
 *
 * @param {string} string
 *        String to be lowercased
 *
 * @return {string}
 *         The string with a lowercased first letter
 */ const $cb03b711053a4297$var$toLowerCase = function(string) {
    if (typeof string !== "string") return string;
    return string.replace(/./, (w)=>w.toLowerCase());
};
/**
 * Uppercase the first letter of a string.
 *
 * @param {string} string
 *        String to be uppercased
 *
 * @return {string}
 *         The string with an uppercased first letter
 */ const $cb03b711053a4297$var$toTitleCase$1 = function(string) {
    if (typeof string !== "string") return string;
    return string.replace(/./, (w)=>w.toUpperCase());
};
/**
 * Compares the TitleCase versions of the two strings for equality.
 *
 * @param {string} str1
 *        The first string to compare
 *
 * @param {string} str2
 *        The second string to compare
 *
 * @return {boolean}
 *         Whether the TitleCase versions of the strings are equal
 */ const $cb03b711053a4297$var$titleCaseEquals = function(str1, str2) {
    return $cb03b711053a4297$var$toTitleCase$1(str1) === $cb03b711053a4297$var$toTitleCase$1(str2);
};
var $cb03b711053a4297$var$Str = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    toLowerCase: $cb03b711053a4297$var$toLowerCase,
    toTitleCase: $cb03b711053a4297$var$toTitleCase$1,
    titleCaseEquals: $cb03b711053a4297$var$titleCaseEquals
});
/**
 * Player Component - Base class for all UI objects
 *
 * @file component.js
 */ /**
 * Base class for all UI Components.
 * Components are UI objects which represent both a javascript object and an element
 * in the DOM. They can be children of other components, and can have
 * children themselves.
 *
 * Components can also use methods from {@link EventTarget}
 */ class $cb03b711053a4297$var$Component$1 {
    /**
   * A callback that is called when a component is ready. Does not have any
   * parameters and any callback value will be ignored.
   *
   * @callback ReadyCallback
   * @this Component
   */ /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */ constructor(player, options, ready){
        // The component might be the player itself and we can't pass `this` to super
        if (!player && this.play) this.player_ = player = this; // eslint-disable-line
        else this.player_ = player;
        this.isDisposed_ = false;
        // Hold the reference to the parent component via `addChild` method
        this.parentComponent_ = null;
        // Make a copy of prototype.options_ to protect against overriding defaults
        this.options_ = $cb03b711053a4297$var$merge$1({}, this.options_);
        // Updated options with supplied options
        options = this.options_ = $cb03b711053a4297$var$merge$1(this.options_, options);
        // Get ID from options or options element if one is supplied
        this.id_ = options.id || options.el && options.el.id;
        // If there was no ID from the options, generate one
        if (!this.id_) {
            // Don't require the player ID function in the case of mock players
            const id = player && player.id && player.id() || "no_player";
            this.id_ = `${id}_component_${$cb03b711053a4297$var$newGUID()}`;
        }
        this.name_ = options.name || null;
        // Create element if one wasn't provided in options
        if (options.el) this.el_ = options.el;
        else if (options.createEl !== false) this.el_ = this.createEl();
        if (options.className && this.el_) options.className.split(" ").forEach((c)=>this.addClass(c));
        // Remove the placeholder event methods. If the component is evented, the
        // real methods are added next
        [
            "on",
            "off",
            "one",
            "any",
            "trigger"
        ].forEach((fn)=>{
            this[fn] = undefined;
        });
        // if evented is anything except false, we want to mixin in evented
        if (options.evented !== false) {
            // Make this an evented object and use `el_`, if available, as its event bus
            $cb03b711053a4297$var$evented(this, {
                eventBusKey: this.el_ ? "el_" : null
            });
            this.handleLanguagechange = this.handleLanguagechange.bind(this);
            this.on(this.player_, "languagechange", this.handleLanguagechange);
        }
        $cb03b711053a4297$var$stateful(this, this.constructor.defaultState);
        this.children_ = [];
        this.childIndex_ = {};
        this.childNameIndex_ = {};
        this.setTimeoutIds_ = new Set();
        this.setIntervalIds_ = new Set();
        this.rafIds_ = new Set();
        this.namedRafs_ = new Map();
        this.clearingTimersOnDispose_ = false;
        // Add any child components in options
        if (options.initChildren !== false) this.initChildren();
        // Don't want to trigger ready here or it will go before init is actually
        // finished for all children that run this constructor
        this.ready(ready);
        if (options.reportTouchActivity !== false) this.enableTouchActivity();
    }
    // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
    // They are replaced or removed in the constructor
    /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */ on(type, fn) {}
    /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */ off(type, fn) {}
    /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ one(type, fn) {}
    /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */ any(type, fn) {}
    /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */ trigger(event, hash) {}
    /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */ dispose(options = {}) {
        // Bail out if the component has already been disposed.
        if (this.isDisposed_) return;
        if (this.readyQueue_) this.readyQueue_.length = 0;
        /**
     * Triggered when a `Component` is disposed.
     *
     * @event Component#dispose
     * @type {Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the dispose event does not
     *           bubble up
     */ this.trigger({
            type: "dispose",
            bubbles: false
        });
        this.isDisposed_ = true;
        // Dispose all children.
        if (this.children_) {
            for(let i = this.children_.length - 1; i >= 0; i--)if (this.children_[i].dispose) this.children_[i].dispose();
        }
        // Delete child references
        this.children_ = null;
        this.childIndex_ = null;
        this.childNameIndex_ = null;
        this.parentComponent_ = null;
        if (this.el_) {
            // Remove element from DOM
            if (this.el_.parentNode) {
                if (options.restoreEl) this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
                else this.el_.parentNode.removeChild(this.el_);
            }
            this.el_ = null;
        }
        // remove reference to the player after disposing of the element
        this.player_ = null;
    }
    /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */ isDisposed() {
        return Boolean(this.isDisposed_);
    }
    /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return { import('./player').default }
   *         The player that this `Component` has attached to.
   */ player() {
        return this.player_;
    }
    /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */ options(obj) {
        if (!obj) return this.options_;
        this.options_ = $cb03b711053a4297$var$merge$1(this.options_, obj);
        return this.options_;
    }
    /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */ el() {
        return this.el_;
    }
    /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tagName, properties, attributes) {
        return $cb03b711053a4297$var$createEl(tagName, properties, attributes);
    }
    /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */ localize(string, tokens, defaultValue = string) {
        const code = this.player_.language && this.player_.language();
        const languages = this.player_.languages && this.player_.languages();
        const language = languages && languages[code];
        const primaryCode = code && code.split("-")[0];
        const primaryLang = languages && languages[primaryCode];
        let localizedString = defaultValue;
        if (language && language[string]) localizedString = language[string];
        else if (primaryLang && primaryLang[string]) localizedString = primaryLang[string];
        if (tokens) localizedString = localizedString.replace(/\{(\d+)\}/g, function(match, index) {
            const value = tokens[index - 1];
            let ret = value;
            if (typeof value === "undefined") ret = match;
            return ret;
        });
        return localizedString;
    }
    /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */ handleLanguagechange() {}
    /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */ contentEl() {
        return this.contentEl_ || this.el_;
    }
    /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */ id() {
        return this.id_;
    }
    /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */ name() {
        return this.name_;
    }
    /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */ children() {
        return this.children_;
    }
    /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */ getChildById(id) {
        return this.childIndex_[id];
    }
    /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */ getChild(name) {
        if (!name) return;
        return this.childNameIndex_[name];
    }
    /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */ getDescendant(...names) {
        // flatten array argument into the main array
        names = names.reduce((acc, n)=>acc.concat(n), []);
        let currentChild = this;
        for(let i = 0; i < names.length; i++){
            currentChild = currentChild.getChild(names[i]);
            if (!currentChild || !currentChild.getChild) return;
        }
        return currentChild;
    }
    /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */ setIcon(iconName, el = this.el()) {
        // TODO: In v9 of video.js, we will want to remove font icons entirely.
        // This means this check, as well as the others throughout the code, and
        // the unecessary CSS for font icons, will need to be removed.
        // See https://github.com/videojs/video.js/pull/8260 as to which components
        // need updating.
        if (!this.player_.options_.experimentalSvgIcons) return;
        const xmlnsURL = "http://www.w3.org/2000/svg";
        // The below creates an element in the format of:
        // <span><svg><use>....</use></svg></span>
        const iconContainer = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-icon-placeholder vjs-svg-icon"
        }, {
            "aria-hidden": "true"
        });
        const svgEl = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElementNS(xmlnsURL, "svg");
        svgEl.setAttributeNS(null, "viewBox", "0 0 512 512");
        const useEl = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElementNS(xmlnsURL, "use");
        svgEl.appendChild(useEl);
        useEl.setAttributeNS(null, "href", `#vjs-icon-${iconName}`);
        iconContainer.appendChild(svgEl);
        // Replace a pre-existing icon if one exists.
        if (this.iconIsSet_) el.replaceChild(iconContainer, el.querySelector(".vjs-icon-placeholder"));
        else el.appendChild(iconContainer);
        this.iconIsSet_ = true;
        return iconContainer;
    }
    /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */ addChild(child, options = {}, index = this.children_.length) {
        let component;
        let componentName;
        // If child is a string, create component with options
        if (typeof child === "string") {
            componentName = $cb03b711053a4297$var$toTitleCase$1(child);
            const componentClassName = options.componentClass || componentName;
            // Set name through options
            options.name = componentName;
            // Create a new object & element for this controls set
            // If there's no .player_, this is a player
            const ComponentClass = $cb03b711053a4297$var$Component$1.getComponent(componentClassName);
            if (!ComponentClass) throw new Error(`Component ${componentClassName} does not exist`);
            // data stored directly on the videojs object may be
            // misidentified as a component to retain
            // backwards-compatibility with 4.x. check to make sure the
            // component class can be instantiated.
            if (typeof ComponentClass !== "function") return null;
            component = new ComponentClass(this.player_ || this, options);
        // child is a component instance
        } else component = child;
        if (component.parentComponent_) component.parentComponent_.removeChild(component);
        this.children_.splice(index, 0, component);
        component.parentComponent_ = this;
        if (typeof component.id === "function") this.childIndex_[component.id()] = component;
        // If a name wasn't used to create the component, check if we can use the
        // name function of the component
        componentName = componentName || component.name && $cb03b711053a4297$var$toTitleCase$1(component.name());
        if (componentName) {
            this.childNameIndex_[componentName] = component;
            this.childNameIndex_[$cb03b711053a4297$var$toLowerCase(componentName)] = component;
        }
        // Add the UI object's element to the container div (box)
        // Having an element is not required
        if (typeof component.el === "function" && component.el()) {
            // If inserting before a component, insert before that component's element
            let refNode = null;
            if (this.children_[index + 1]) {
                // Most children are components, but the video tech is an HTML element
                if (this.children_[index + 1].el_) refNode = this.children_[index + 1].el_;
                else if ($cb03b711053a4297$var$isEl(this.children_[index + 1])) refNode = this.children_[index + 1];
            }
            this.contentEl().insertBefore(component.el(), refNode);
        }
        // Return so it can stored on parent object if desired.
        return component;
    }
    /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */ removeChild(component) {
        if (typeof component === "string") component = this.getChild(component);
        if (!component || !this.children_) return;
        let childFound = false;
        for(let i = this.children_.length - 1; i >= 0; i--)if (this.children_[i] === component) {
            childFound = true;
            this.children_.splice(i, 1);
            break;
        }
        if (!childFound) return;
        component.parentComponent_ = null;
        this.childIndex_[component.id()] = null;
        this.childNameIndex_[$cb03b711053a4297$var$toTitleCase$1(component.name())] = null;
        this.childNameIndex_[$cb03b711053a4297$var$toLowerCase(component.name())] = null;
        const compEl = component.el();
        if (compEl && compEl.parentNode === this.contentEl()) this.contentEl().removeChild(component.el());
    }
    /**
   * Add and initialize default child `Component`s based upon options.
   */ initChildren() {
        const children = this.options_.children;
        if (children) {
            // `this` is `parent`
            const parentOptions = this.options_;
            const handleAdd = (child)=>{
                const name = child.name;
                let opts = child.opts;
                // Allow options for children to be set at the parent options
                // e.g. videojs(id, { controlBar: false });
                // instead of videojs(id, { children: { controlBar: false });
                if (parentOptions[name] !== undefined) opts = parentOptions[name];
                // Allow for disabling default components
                // e.g. options['children']['posterImage'] = false
                if (opts === false) return;
                // Allow options to be passed as a simple boolean if no configuration
                // is necessary.
                if (opts === true) opts = {};
                // We also want to pass the original player options
                // to each component as well so they don't need to
                // reach back into the player for options later.
                opts.playerOptions = this.options_.playerOptions;
                // Create and add the child component.
                // Add a direct reference to the child by name on the parent instance.
                // If two of the same component are used, different names should be supplied
                // for each
                const newChild = this.addChild(name, opts);
                if (newChild) this[name] = newChild;
            };
            // Allow for an array of children details to passed in the options
            let workingChildren;
            const Tech = $cb03b711053a4297$var$Component$1.getComponent("Tech");
            if (Array.isArray(children)) workingChildren = children;
            else workingChildren = Object.keys(children);
            workingChildren// children that are in this.options_ but also in workingChildren  would
            // give us extra children we do not want. So, we want to filter them out.
            .concat(Object.keys(this.options_).filter(function(child) {
                return !workingChildren.some(function(wchild) {
                    if (typeof wchild === "string") return child === wchild;
                    return child === wchild.name;
                });
            })).map((child)=>{
                let name;
                let opts;
                if (typeof child === "string") {
                    name = child;
                    opts = children[name] || this.options_[name] || {};
                } else {
                    name = child.name;
                    opts = child;
                }
                return {
                    name: name,
                    opts: opts
                };
            }).filter((child)=>{
                // we have to make sure that child.name isn't in the techOrder since
                // techs are registered as Components but can't aren't compatible
                // See https://github.com/videojs/video.js/issues/2772
                const c = $cb03b711053a4297$var$Component$1.getComponent(child.opts.componentClass || $cb03b711053a4297$var$toTitleCase$1(child.name));
                return c && !Tech.isTech(c);
            }).forEach(handleAdd);
        }
    }
    /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */ buildCSSClass() {
        // Child classes can include a function that does:
        // return 'CLASS NAME' + this._super();
        return "";
    }
    /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   *
   * @return {Component}
   *         Returns itself; method can be chained.
   */ ready(fn, sync = false) {
        if (!fn) return;
        if (!this.isReady_) {
            this.readyQueue_ = this.readyQueue_ || [];
            this.readyQueue_.push(fn);
            return;
        }
        if (sync) fn.call(this);
        else // Call the function asynchronously by default for consistency
        this.setTimeout(fn, 1);
    }
    /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */ triggerReady() {
        this.isReady_ = true;
        // Ensure ready is triggered asynchronously
        this.setTimeout(function() {
            const readyQueue = this.readyQueue_;
            // Reset Ready Queue
            this.readyQueue_ = [];
            if (readyQueue && readyQueue.length > 0) readyQueue.forEach(function(fn) {
                fn.call(this);
            }, this);
            // Allow for using event listeners also
            /**
       * Triggered when a `Component` is ready.
       *
       * @event Component#ready
       * @type {Event}
       */ this.trigger("ready");
        }, 1);
    }
    /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */ $(selector, context) {
        return $cb03b711053a4297$var$$(selector, context || this.contentEl());
    }
    /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */ $$(selector, context) {
        return $cb03b711053a4297$var$$$(selector, context || this.contentEl());
    }
    /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */ hasClass(classToCheck) {
        return $cb03b711053a4297$var$hasClass(this.el_, classToCheck);
    }
    /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */ addClass(...classesToAdd) {
        $cb03b711053a4297$var$addClass(this.el_, ...classesToAdd);
    }
    /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */ removeClass(...classesToRemove) {
        $cb03b711053a4297$var$removeClass(this.el_, ...classesToRemove);
    }
    /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove based on (@link Component#hasClass}
   *
   * @param  {boolean|Dom~predicate} [predicate]
   *         An {@link Dom~predicate} function or a boolean
   */ toggleClass(classToToggle, predicate) {
        $cb03b711053a4297$var$toggleClass(this.el_, classToToggle, predicate);
    }
    /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */ show() {
        this.removeClass("vjs-hidden");
    }
    /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */ hide() {
        this.addClass("vjs-hidden");
    }
    /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */ lockShowing() {
        this.addClass("vjs-lock-showing");
    }
    /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */ unlockShowing() {
        this.removeClass("vjs-lock-showing");
    }
    /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */ getAttribute(attribute) {
        return $cb03b711053a4297$var$getAttribute(this.el_, attribute);
    }
    /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */ setAttribute(attribute, value) {
        $cb03b711053a4297$var$setAttribute(this.el_, attribute, value);
    }
    /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */ removeAttribute(attribute) {
        $cb03b711053a4297$var$removeAttribute(this.el_, attribute);
    }
    /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */ width(num, skipListeners) {
        return this.dimension("width", num, skipListeners);
    }
    /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */ height(num, skipListeners) {
        return this.dimension("height", num, skipListeners);
    }
    /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */ dimensions(width, height) {
        // Skip componentresize listeners on width for optimization
        this.width(width, true);
        this.height(height);
    }
    /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */ dimension(widthOrHeight, num, skipListeners) {
        if (num !== undefined) {
            // Set to zero if null or literally NaN (NaN !== NaN)
            if (num === null || num !== num) num = 0;
            // Check if using css width/height (% or px) and adjust
            if (("" + num).indexOf("%") !== -1 || ("" + num).indexOf("px") !== -1) this.el_.style[widthOrHeight] = num;
            else if (num === "auto") this.el_.style[widthOrHeight] = "";
            else this.el_.style[widthOrHeight] = num + "px";
            // skipListeners allows us to avoid triggering the resize event when setting both width and height
            if (!skipListeners) /**
         * Triggered when a component is resized.
         *
         * @event Component#componentresize
         * @type {Event}
         */ this.trigger("componentresize");
            return;
        }
        // Not setting a value, so getting it
        // Make sure element exists
        if (!this.el_) return 0;
        // Get dimension value from style
        const val = this.el_.style[widthOrHeight];
        const pxIndex = val.indexOf("px");
        if (pxIndex !== -1) // Return the pixel value with no 'px'
        return parseInt(val.slice(0, pxIndex), 10);
        // No px so using % or no style was set, so falling back to offsetWidth/height
        // If component has display:none, offset will return 0
        // TODO: handle display:none and no dimension style using px
        return parseInt(this.el_["offset" + $cb03b711053a4297$var$toTitleCase$1(widthOrHeight)], 10);
    }
    /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */ currentDimension(widthOrHeight) {
        let computedWidthOrHeight = 0;
        if (widthOrHeight !== "width" && widthOrHeight !== "height") throw new Error("currentDimension only accepts width or height value");
        computedWidthOrHeight = $cb03b711053a4297$var$computedStyle(this.el_, widthOrHeight);
        // remove 'px' from variable and parse as integer
        computedWidthOrHeight = parseFloat(computedWidthOrHeight);
        // if the computed value is still 0, it's possible that the browser is lying
        // and we want to check the offset values.
        // This code also runs wherever getComputedStyle doesn't exist.
        if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
            const rule = `offset${$cb03b711053a4297$var$toTitleCase$1(widthOrHeight)}`;
            computedWidthOrHeight = this.el_[rule];
        }
        return computedWidthOrHeight;
    }
    /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */ /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */ currentDimensions() {
        return {
            width: this.currentDimension("width"),
            height: this.currentDimension("height")
        };
    }
    /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */ currentWidth() {
        return this.currentDimension("width");
    }
    /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */ currentHeight() {
        return this.currentDimension("height");
    }
    /**
   * Set the focus to this component
   */ focus() {
        this.el_.focus();
    }
    /**
   * Remove the focus from this component
   */ blur() {
        this.el_.blur();
    }
    /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */ handleKeyDown(event) {
        if (this.player_) {
            // We only stop propagation here because we want unhandled events to fall
            // back to the browser. Exclude Tab for focus trapping.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Tab")) event.stopPropagation();
            this.player_.handleKeyDown(event);
        }
    }
    /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */ handleKeyPress(event) {
        this.handleKeyDown(event);
    }
    /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */ emitTapEvents() {
        // Track the start time so we can determine how long the touch lasted
        let touchStart = 0;
        let firstTouch = null;
        // Maximum movement allowed during a touch event to still be considered a tap
        // Other popular libs use anywhere from 2 (hammer.js) to 15,
        // so 10 seems like a nice, round number.
        const tapMovementThreshold = 10;
        // The maximum length a touch can be while still being considered a tap
        const touchTimeThreshold = 200;
        let couldBeTap;
        this.on("touchstart", function(event) {
            // If more than one finger, don't consider treating this as a click
            if (event.touches.length === 1) {
                // Copy pageX/pageY from the object
                firstTouch = {
                    pageX: event.touches[0].pageX,
                    pageY: event.touches[0].pageY
                };
                // Record start time so we can detect a tap vs. "touch and hold"
                touchStart = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
                // Reset couldBeTap tracking
                couldBeTap = true;
            }
        });
        this.on("touchmove", function(event) {
            // If more than one finger, don't consider treating this as a click
            if (event.touches.length > 1) couldBeTap = false;
            else if (firstTouch) {
                // Some devices will throw touchmoves for all but the slightest of taps.
                // So, if we moved only a small distance, this could still be a tap
                const xdiff = event.touches[0].pageX - firstTouch.pageX;
                const ydiff = event.touches[0].pageY - firstTouch.pageY;
                const touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                if (touchDistance > tapMovementThreshold) couldBeTap = false;
            }
        });
        const noTap = function() {
            couldBeTap = false;
        };
        // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
        this.on("touchleave", noTap);
        this.on("touchcancel", noTap);
        // When the touch ends, measure how long it took and trigger the appropriate
        // event
        this.on("touchend", function(event) {
            firstTouch = null;
            // Proceed only if the touchmove/leave/cancel event didn't happen
            if (couldBeTap === true) {
                // Measure how long the touch lasted
                const touchTime = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now() - touchStart;
                // Make sure the touch was less than the threshold to be considered a tap
                if (touchTime < touchTimeThreshold) {
                    // Don't let browser turn this into a click
                    event.preventDefault();
                    /**
           * Triggered when a `Component` is tapped.
           *
           * @event Component#tap
           * @type {MouseEvent}
           */ this.trigger("tap");
                // It may be good to copy the touchend event object and change the
                // type to tap, if the other event properties aren't exact after
                // Events.fixEvent runs (e.g. event.target)
                }
            }
        });
    }
    /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */ enableTouchActivity() {
        // Don't continue if the root player doesn't support reporting user activity
        if (!this.player() || !this.player().reportUserActivity) return;
        // listener for reporting that the user is active
        const report = $cb03b711053a4297$var$bind_(this.player(), this.player().reportUserActivity);
        let touchHolding;
        this.on("touchstart", function() {
            report();
            // For as long as the they are touching the device or have their mouse down,
            // we consider them active even if they're not moving their finger or mouse.
            // So we want to continue to update that they are active
            this.clearInterval(touchHolding);
            // report at the same interval as activityCheck
            touchHolding = this.setInterval(report, 250);
        });
        const touchEnd = function(event) {
            report();
            // stop the interval that maintains activity if the touch is holding
            this.clearInterval(touchHolding);
        };
        this.on("touchmove", report);
        this.on("touchend", touchEnd);
        this.on("touchcancel", touchEnd);
    }
    /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */ /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */ setTimeout(fn, timeout) {
        // declare as variables so they are properly available in timeout function
        // eslint-disable-next-line
        var timeoutId;
        fn = $cb03b711053a4297$var$bind_(this, fn);
        this.clearTimersOnDispose_();
        timeoutId = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            if (this.setTimeoutIds_.has(timeoutId)) this.setTimeoutIds_.delete(timeoutId);
            fn();
        }, timeout);
        this.setTimeoutIds_.add(timeoutId);
        return timeoutId;
    }
    /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */ clearTimeout(timeoutId) {
        if (this.setTimeoutIds_.has(timeoutId)) {
            this.setTimeoutIds_.delete(timeoutId);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(timeoutId);
        }
        return timeoutId;
    }
    /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */ setInterval(fn, interval) {
        fn = $cb03b711053a4297$var$bind_(this, fn);
        this.clearTimersOnDispose_();
        const intervalId = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setInterval(fn, interval);
        this.setIntervalIds_.add(intervalId);
        return intervalId;
    }
    /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */ clearInterval(intervalId) {
        if (this.setIntervalIds_.has(intervalId)) {
            this.setIntervalIds_.delete(intervalId);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearInterval(intervalId);
        }
        return intervalId;
    }
    /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */ requestAnimationFrame(fn) {
        this.clearTimersOnDispose_();
        // declare as variables so they are properly available in rAF function
        // eslint-disable-next-line
        var id;
        fn = $cb03b711053a4297$var$bind_(this, fn);
        id = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).requestAnimationFrame(()=>{
            if (this.rafIds_.has(id)) this.rafIds_.delete(id);
            fn();
        });
        this.rafIds_.add(id);
        return id;
    }
    /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */ requestNamedAnimationFrame(name, fn) {
        if (this.namedRafs_.has(name)) return;
        this.clearTimersOnDispose_();
        fn = $cb03b711053a4297$var$bind_(this, fn);
        const id = this.requestAnimationFrame(()=>{
            fn();
            if (this.namedRafs_.has(name)) this.namedRafs_.delete(name);
        });
        this.namedRafs_.set(name, id);
        return name;
    }
    /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */ cancelNamedAnimationFrame(name) {
        if (!this.namedRafs_.has(name)) return;
        this.cancelAnimationFrame(this.namedRafs_.get(name));
        this.namedRafs_.delete(name);
    }
    /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */ cancelAnimationFrame(id) {
        if (this.rafIds_.has(id)) {
            this.rafIds_.delete(id);
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).cancelAnimationFrame(id);
        }
        return id;
    }
    /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */ clearTimersOnDispose_() {
        if (this.clearingTimersOnDispose_) return;
        this.clearingTimersOnDispose_ = true;
        this.one("dispose", ()=>{
            [
                [
                    "namedRafs_",
                    "cancelNamedAnimationFrame"
                ],
                [
                    "rafIds_",
                    "cancelAnimationFrame"
                ],
                [
                    "setTimeoutIds_",
                    "clearTimeout"
                ],
                [
                    "setIntervalIds_",
                    "clearInterval"
                ]
            ].forEach(([idName, cancelName])=>{
                // for a `Set` key will actually be the value again
                // so forEach((val, val) =>` but for maps we want to use
                // the key.
                this[idName].forEach((val, key)=>this[cancelName](key));
            });
            this.clearingTimersOnDispose_ = false;
        });
    }
    /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */ static registerComponent(name, ComponentToRegister) {
        if (typeof name !== "string" || !name) throw new Error(`Illegal component name, "${name}"; must be a non-empty string.`);
        const Tech = $cb03b711053a4297$var$Component$1.getComponent("Tech");
        // We need to make sure this check is only done if Tech has been registered.
        const isTech = Tech && Tech.isTech(ComponentToRegister);
        const isComp = $cb03b711053a4297$var$Component$1 === ComponentToRegister || $cb03b711053a4297$var$Component$1.prototype.isPrototypeOf(ComponentToRegister.prototype);
        if (isTech || !isComp) {
            let reason;
            if (isTech) reason = "techs must be registered using Tech.registerTech()";
            else reason = "must be a Component subclass";
            throw new Error(`Illegal component, "${name}"; ${reason}.`);
        }
        name = $cb03b711053a4297$var$toTitleCase$1(name);
        if (!$cb03b711053a4297$var$Component$1.components_) $cb03b711053a4297$var$Component$1.components_ = {};
        const Player = $cb03b711053a4297$var$Component$1.getComponent("Player");
        if (name === "Player" && Player && Player.players) {
            const players = Player.players;
            const playerNames = Object.keys(players);
            // If we have players that were disposed, then their name will still be
            // in Players.players. So, we must loop through and verify that the value
            // for each item is not null. This allows registration of the Player component
            // after all players have been disposed or before any were created.
            if (players && playerNames.length > 0 && playerNames.map((pname)=>players[pname]).every(Boolean)) throw new Error("Can not register Player component after player has been created.");
        }
        $cb03b711053a4297$var$Component$1.components_[name] = ComponentToRegister;
        $cb03b711053a4297$var$Component$1.components_[$cb03b711053a4297$var$toLowerCase(name)] = ComponentToRegister;
        return ComponentToRegister;
    }
    /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {Component}
   *         The `Component` that got registered under the given name.
   */ static getComponent(name) {
        if (!name || !$cb03b711053a4297$var$Component$1.components_) return;
        return $cb03b711053a4297$var$Component$1.components_[name];
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("Component", $cb03b711053a4297$var$Component$1);
/**
 * @file time.js
 * @module time
 */ /**
 * Returns the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @typedef    {Function} TimeRangeIndex
 *
 * @param      {number} [index=0]
 *             The range number to return the time for.
 *
 * @return     {number}
 *             The time offset at the specified index.
 *
 * @deprecated The index argument must be provided.
 *             In the future, leaving it out will throw an error.
 */ /**
 * An object that contains ranges of time, which mimics {@link TimeRanges}.
 *
 * @typedef  {Object} TimeRange
 *
 * @property {number} length
 *           The number of time ranges represented by this object.
 *
 * @property {module:time~TimeRangeIndex} start
 *           Returns the time offset at which a specified time range begins.
 *
 * @property {module:time~TimeRangeIndex} end
 *           Returns the time offset at which a specified time range ends.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
 */ /**
 * Check if any of the time ranges are over the maximum index.
 *
 * @private
 * @param   {string} fnName
 *          The function name to use for logging
 *
 * @param   {number} index
 *          The index to check
 *
 * @param   {number} maxIndex
 *          The maximum possible index
 *
 * @throws  {Error} if the timeRanges provided are over the maxIndex
 */ function $cb03b711053a4297$var$rangeCheck(fnName, index, maxIndex) {
    if (typeof index !== "number" || index < 0 || index > maxIndex) throw new Error(`Failed to execute '${fnName}' on 'TimeRanges': The index provided (${index}) is non-numeric or out of bounds (0-${maxIndex}).`);
}
/**
 * Get the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @private
 * @param      {string} fnName
 *             The function name to use for logging
 *
 * @param      {string} valueIndex
 *             The property that should be used to get the time. should be
 *             'start' or 'end'
 *
 * @param      {Array} ranges
 *             An array of time ranges
 *
 * @param      {Array} [rangeIndex=0]
 *             The index to start the search at
 *
 * @return     {number}
 *             The time that offset at the specified index.
 *
 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
 * @throws     {Error} if rangeIndex is more than the length of ranges
 */ function $cb03b711053a4297$var$getRange(fnName, valueIndex, ranges, rangeIndex) {
    $cb03b711053a4297$var$rangeCheck(fnName, rangeIndex, ranges.length - 1);
    return ranges[rangeIndex][valueIndex];
}
/**
 * Create a time range object given ranges of time.
 *
 * @private
 * @param   {Array} [ranges]
 *          An array of time ranges.
 *
 * @return  {TimeRange}
 */ function $cb03b711053a4297$var$createTimeRangesObj(ranges) {
    let timeRangesObj;
    if (ranges === undefined || ranges.length === 0) timeRangesObj = {
        length: 0,
        start () {
            throw new Error("This TimeRanges object is empty");
        },
        end () {
            throw new Error("This TimeRanges object is empty");
        }
    };
    else timeRangesObj = {
        length: ranges.length,
        start: $cb03b711053a4297$var$getRange.bind(null, "start", 0, ranges),
        end: $cb03b711053a4297$var$getRange.bind(null, "end", 1, ranges)
    };
    if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Symbol && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Symbol.iterator) timeRangesObj[(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Symbol.iterator] = ()=>(ranges || []).values();
    return timeRangesObj;
}
/**
 * Create a `TimeRange` object which mimics an
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
 *
 * @param {number|Array[]} start
 *        The start of a single range (a number) or an array of ranges (an
 *        array of arrays of two numbers each).
 *
 * @param {number} end
 *        The end of a single range. Cannot be used with the array form of
 *        the `start` argument.
 *
 * @return {TimeRange}
 */ function $cb03b711053a4297$var$createTimeRanges$1(start, end) {
    if (Array.isArray(start)) return $cb03b711053a4297$var$createTimeRangesObj(start);
    else if (start === undefined || end === undefined) return $cb03b711053a4297$var$createTimeRangesObj();
    return $cb03b711053a4297$var$createTimeRangesObj([
        [
            start,
            end
        ]
    ]);
}
/**
 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
 * seconds) will force a number of leading zeros to cover the length of the
 * guide.
 *
 * @private
 * @param  {number} seconds
 *         Number of seconds to be turned into a string
 *
 * @param  {number} guide
 *         Number (in seconds) to model the string after
 *
 * @return {string}
 *         Time formatted as H:MM:SS or M:SS
 */ const $cb03b711053a4297$var$defaultImplementation = function(seconds, guide) {
    seconds = seconds < 0 ? 0 : seconds;
    let s = Math.floor(seconds % 60);
    let m = Math.floor(seconds / 60 % 60);
    let h = Math.floor(seconds / 3600);
    const gm = Math.floor(guide / 60 % 60);
    const gh = Math.floor(guide / 3600);
    // handle invalid times
    if (isNaN(seconds) || seconds === Infinity) // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = m = s = "-";
    // Check if we need to show hours
    h = h > 0 || gh > 0 ? h + ":" : "";
    // If hours are showing, we may need to add a leading zero.
    // Always show at least one digit of minutes.
    m = ((h || gm >= 10) && m < 10 ? "0" + m : m) + ":";
    // Check if leading zero is need for seconds
    s = s < 10 ? "0" + s : s;
    return h + m + s;
};
// Internal pointer to the current implementation.
let $cb03b711053a4297$var$implementation = $cb03b711053a4297$var$defaultImplementation;
/**
 * Replaces the default formatTime implementation with a custom implementation.
 *
 * @param {Function} customImplementation
 *        A function which will be used in place of the default formatTime
 *        implementation. Will receive the current time in seconds and the
 *        guide (in seconds) as arguments.
 */ function $cb03b711053a4297$var$setFormatTime(customImplementation) {
    $cb03b711053a4297$var$implementation = customImplementation;
}
/**
 * Resets formatTime to the default implementation.
 */ function $cb03b711053a4297$var$resetFormatTime() {
    $cb03b711053a4297$var$implementation = $cb03b711053a4297$var$defaultImplementation;
}
/**
 * Delegates to either the default time formatting function or a custom
 * function supplied via `setFormatTime`.
 *
 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
 * guide (in seconds) will force a number of leading zeros to cover the
 * length of the guide.
 *
 * @example  formatTime(125, 600) === "02:05"
 * @param    {number} seconds
 *           Number of seconds to be turned into a string
 *
 * @param    {number} guide
 *           Number (in seconds) to model the string after
 *
 * @return   {string}
 *           Time formatted as H:MM:SS or M:SS
 */ function $cb03b711053a4297$var$formatTime(seconds, guide = seconds) {
    return $cb03b711053a4297$var$implementation(seconds, guide);
}
var $cb03b711053a4297$var$Time = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createTimeRanges: $cb03b711053a4297$var$createTimeRanges$1,
    createTimeRange: $cb03b711053a4297$var$createTimeRanges$1,
    setFormatTime: $cb03b711053a4297$var$setFormatTime,
    resetFormatTime: $cb03b711053a4297$var$resetFormatTime,
    formatTime: $cb03b711053a4297$var$formatTime
});
/**
 * @file buffer.js
 * @module buffer
 */ /**
 * Compute the percentage of the media that has been buffered.
 *
 * @param { import('./time').TimeRange } buffered
 *        The current `TimeRanges` object representing buffered time ranges
 *
 * @param {number} duration
 *        Total duration of the media
 *
 * @return {number}
 *         Percent buffered of the total duration in decimal form.
 */ function $cb03b711053a4297$var$bufferedPercent(buffered, duration) {
    let bufferedDuration = 0;
    let start;
    let end;
    if (!duration) return 0;
    if (!buffered || !buffered.length) buffered = $cb03b711053a4297$var$createTimeRanges$1(0, 0);
    for(let i = 0; i < buffered.length; i++){
        start = buffered.start(i);
        end = buffered.end(i);
        // buffered end can be bigger than duration by a very small fraction
        if (end > duration) end = duration;
        bufferedDuration += end - start;
    }
    return bufferedDuration / duration;
}
/**
 * @file media-error.js
 */ /**
 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
 *
 * @param {number|string|Object|MediaError} value
 *        This can be of multiple types:
 *        - number: should be a standard error code
 *        - string: an error message (the code will be 0)
 *        - Object: arbitrary properties
 *        - `MediaError` (native): used to populate a video.js `MediaError` object
 *        - `MediaError` (video.js): will return itself if it's already a
 *          video.js `MediaError` object.
 *
 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
 *
 * @class MediaError
 */ function $cb03b711053a4297$var$MediaError(value) {
    // Allow redundant calls to this constructor to avoid having `instanceof`
    // checks peppered around the code.
    if (value instanceof $cb03b711053a4297$var$MediaError) return value;
    if (typeof value === "number") this.code = value;
    else if (typeof value === "string") // default code is zero, so this is a custom error
    this.message = value;
    else if ($cb03b711053a4297$var$isObject(value)) {
        // We assign the `code` property manually because native `MediaError` objects
        // do not expose it as an own/enumerable property of the object.
        if (typeof value.code === "number") this.code = value.code;
        Object.assign(this, value);
    }
    if (!this.message) this.message = $cb03b711053a4297$var$MediaError.defaultMessages[this.code] || "";
}
/**
 * The error code that refers two one of the defined `MediaError` types
 *
 * @type {Number}
 */ $cb03b711053a4297$var$MediaError.prototype.code = 0;
/**
 * An optional message that to show with the error. Message is not part of the HTML5
 * video spec but allows for more informative custom errors.
 *
 * @type {String}
 */ $cb03b711053a4297$var$MediaError.prototype.message = "";
/**
 * An optional status code that can be set by plugins to allow even more detail about
 * the error. For example a plugin might provide a specific HTTP status code and an
 * error message for that code. Then when the plugin gets that error this class will
 * know how to display an error message for it. This allows a custom message to show
 * up on the `Player` error overlay.
 *
 * @type {Array}
 */ $cb03b711053a4297$var$MediaError.prototype.status = null;
/**
 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
 * specification listed under {@link MediaError} for more information.
 *
 * @enum {array}
 * @readonly
 * @property {string} 0 - MEDIA_ERR_CUSTOM
 * @property {string} 1 - MEDIA_ERR_ABORTED
 * @property {string} 2 - MEDIA_ERR_NETWORK
 * @property {string} 3 - MEDIA_ERR_DECODE
 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
 */ $cb03b711053a4297$var$MediaError.errorTypes = [
    "MEDIA_ERR_CUSTOM",
    "MEDIA_ERR_ABORTED",
    "MEDIA_ERR_NETWORK",
    "MEDIA_ERR_DECODE",
    "MEDIA_ERR_SRC_NOT_SUPPORTED",
    "MEDIA_ERR_ENCRYPTED"
];
/**
 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
 *
 * @type {Array}
 * @constant
 */ $cb03b711053a4297$var$MediaError.defaultMessages = {
    1: "You aborted the media playback",
    2: "A network error caused the media download to fail part-way.",
    3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
    4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
    5: "The media is encrypted and we do not have the keys to decrypt it."
};
// Add types as properties on MediaError
// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
for(let errNum = 0; errNum < $cb03b711053a4297$var$MediaError.errorTypes.length; errNum++){
    $cb03b711053a4297$var$MediaError[$cb03b711053a4297$var$MediaError.errorTypes[errNum]] = errNum;
    // values should be accessible on both the class and instance
    $cb03b711053a4297$var$MediaError.prototype[$cb03b711053a4297$var$MediaError.errorTypes[errNum]] = errNum;
}
/**
 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
 *
 * @param  {Object}  value
 *         An object that may or may not be `Promise`-like.
 *
 * @return {boolean}
 *         Whether or not the object is `Promise`-like.
 */ function $cb03b711053a4297$var$isPromise(value) {
    return value !== undefined && value !== null && typeof value.then === "function";
}
/**
 * Silence a Promise-like object.
 *
 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
 * play promise" rejection error messages.
 *
 * @param  {Object} value
 *         An object that may or may not be `Promise`-like.
 */ function $cb03b711053a4297$var$silencePromise(value) {
    if ($cb03b711053a4297$var$isPromise(value)) value.then(null, (e)=>{});
}
/**
 * @file text-track-list-converter.js Utilities for capturing text track state and
 * re-creating tracks based on a capture.
 *
 * @module text-track-list-converter
 */ /**
 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
 * represents the {@link TextTrack}'s state.
 *
 * @param {TextTrack} track
 *        The text track to query.
 *
 * @return {Object}
 *         A serializable javascript representation of the TextTrack.
 * @private
 */ const $cb03b711053a4297$var$trackToJson_ = function(track) {
    const ret = [
        "kind",
        "label",
        "language",
        "id",
        "inBandMetadataTrackDispatchType",
        "mode",
        "src"
    ].reduce((acc, prop, i)=>{
        if (track[prop]) acc[prop] = track[prop];
        return acc;
    }, {
        cues: track.cues && Array.prototype.map.call(track.cues, function(cue) {
            return {
                startTime: cue.startTime,
                endTime: cue.endTime,
                text: cue.text,
                id: cue.id
            };
        })
    });
    return ret;
};
/**
 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
 * state of all {@link TextTrack}s currently configured. The return array is compatible with
 * {@link text-track-list-converter:jsonToTextTracks}.
 *
 * @param { import('../tech/tech').default } tech
 *        The tech object to query
 *
 * @return {Array}
 *         A serializable javascript representation of the {@link Tech}s
 *         {@link TextTrackList}.
 */ const $cb03b711053a4297$var$textTracksToJson = function(tech) {
    const trackEls = tech.$$("track");
    const trackObjs = Array.prototype.map.call(trackEls, (t)=>t.track);
    const tracks = Array.prototype.map.call(trackEls, function(trackEl) {
        const json = $cb03b711053a4297$var$trackToJson_(trackEl.track);
        if (trackEl.src) json.src = trackEl.src;
        return json;
    });
    return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function(track) {
        return trackObjs.indexOf(track) === -1;
    }).map($cb03b711053a4297$var$trackToJson_));
};
/**
 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
 * object {@link TextTrack} representations.
 *
 * @param {Array} json
 *        An array of `TextTrack` representation objects, like those that would be
 *        produced by `textTracksToJson`.
 *
 * @param {Tech} tech
 *        The `Tech` to create the `TextTrack`s on.
 */ const $cb03b711053a4297$var$jsonToTextTracks = function(json, tech) {
    json.forEach(function(track) {
        const addedTrack = tech.addRemoteTextTrack(track).track;
        if (!track.src && track.cues) track.cues.forEach((cue)=>addedTrack.addCue(cue));
    });
    return tech.textTracks();
};
var $cb03b711053a4297$var$textTrackConverter = {
    textTracksToJson: $cb03b711053a4297$var$textTracksToJson,
    jsonToTextTracks: $cb03b711053a4297$var$jsonToTextTracks,
    trackToJson_: $cb03b711053a4297$var$trackToJson_
};
/**
 * @file modal-dialog.js
 */ const $cb03b711053a4297$var$MODAL_CLASS_NAME = "vjs-modal-dialog";
/**
 * The `ModalDialog` displays over the video and its controls, which blocks
 * interaction with the player until it is closed.
 *
 * Modal dialogs include a "Close" button and will close when that button
 * is activated - or when ESC is pressed anywhere.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ModalDialog extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param { import('./utils/dom').ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */ constructor(player, options){
        super(player, options);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.close_ = (e)=>this.close(e);
        this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = false;
        this.closeable(!this.options_.uncloseable);
        this.content(this.options_.content);
        // Make sure the contentEl is defined AFTER any children are initialized
        // because we only want the contents of the modal in the contentEl
        // (not the UI elements like the close button).
        this.contentEl_ = $cb03b711053a4297$var$createEl("div", {
            className: `${$cb03b711053a4297$var$MODAL_CLASS_NAME}-content`
        }, {
            role: "document"
        });
        this.descEl_ = $cb03b711053a4297$var$createEl("p", {
            className: `${$cb03b711053a4297$var$MODAL_CLASS_NAME}-description vjs-control-text`,
            id: this.el().getAttribute("aria-describedby")
        });
        $cb03b711053a4297$var$textContent(this.descEl_, this.description());
        this.el_.appendChild(this.descEl_);
        this.el_.appendChild(this.contentEl_);
    }
    /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        return super.createEl("div", {
            className: this.buildCSSClass(),
            tabIndex: -1
        }, {
            "aria-describedby": `${this.id()}_description`,
            "aria-hidden": "true",
            "aria-label": this.label(),
            "role": "dialog"
        });
    }
    dispose() {
        this.contentEl_ = null;
        this.descEl_ = null;
        this.previouslyActiveEl_ = null;
        super.dispose();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `${$cb03b711053a4297$var$MODAL_CLASS_NAME} vjs-hidden ${super.buildCSSClass()}`;
    }
    /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */ label() {
        return this.localize(this.options_.label || "Modal Window");
    }
    /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */ description() {
        let desc = this.options_.description || this.localize("This is a modal window.");
        // Append a universal closeability message if the modal is closeable.
        if (this.closeable()) desc += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.");
        return desc;
    }
    /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */ open() {
        if (!this.opened_) {
            const player = this.player();
            /**
        * Fired just before a `ModalDialog` is opened.
        *
        * @event ModalDialog#beforemodalopen
        * @type {Event}
        */ this.trigger("beforemodalopen");
            this.opened_ = true;
            // Fill content if the modal has never opened before and
            // never been filled.
            if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) this.fill();
            // If the player was playing, pause it and take note of its previously
            // playing state.
            this.wasPlaying_ = !player.paused();
            if (this.options_.pauseOnOpen && this.wasPlaying_) player.pause();
            this.on("keydown", this.handleKeyDown_);
            // Hide controls and note if they were enabled.
            this.hadControls_ = player.controls();
            player.controls(false);
            this.show();
            this.conditionalFocus_();
            this.el().setAttribute("aria-hidden", "false");
            /**
        * Fired just after a `ModalDialog` is opened.
        *
        * @event ModalDialog#modalopen
        * @type {Event}
        */ this.trigger("modalopen");
            this.hasBeenOpened_ = true;
        }
    }
    /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */ opened(value) {
        if (typeof value === "boolean") this[value ? "open" : "close"]();
        return this.opened_;
    }
    /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */ close() {
        if (!this.opened_) return;
        const player = this.player();
        /**
      * Fired just before a `ModalDialog` is closed.
      *
      * @event ModalDialog#beforemodalclose
      * @type {Event}
      */ this.trigger("beforemodalclose");
        this.opened_ = false;
        if (this.wasPlaying_ && this.options_.pauseOnOpen) player.play();
        this.off("keydown", this.handleKeyDown_);
        if (this.hadControls_) player.controls(true);
        this.hide();
        this.el().setAttribute("aria-hidden", "true");
        /**
      * Fired just after a `ModalDialog` is closed.
      *
      * @event ModalDialog#modalclose
      * @type {Event}
      */ this.trigger("modalclose");
        this.conditionalBlur_();
        if (this.options_.temporary) this.dispose();
    }
    /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */ closeable(value) {
        if (typeof value === "boolean") {
            const closeable = this.closeable_ = !!value;
            let close = this.getChild("closeButton");
            // If this is being made closeable and has no close button, add one.
            if (closeable && !close) {
                // The close button should be a child of the modal - not its
                // content element, so temporarily change the content element.
                const temp = this.contentEl_;
                this.contentEl_ = this.el_;
                close = this.addChild("closeButton", {
                    controlText: "Close Modal Dialog"
                });
                this.contentEl_ = temp;
                this.on(close, "close", this.close_);
            }
            // If this is being made uncloseable and has a close button, remove it.
            if (!closeable && close) {
                this.off(close, "close", this.close_);
                this.removeChild(close);
                close.dispose();
            }
        }
        return this.closeable_;
    }
    /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */ fill() {
        this.fillWith(this.content());
    }
    /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param { import('./utils/dom').ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */ fillWith(content) {
        const contentEl = this.contentEl();
        const parentEl = contentEl.parentNode;
        const nextSiblingEl = contentEl.nextSibling;
        /**
      * Fired just before a `ModalDialog` is filled with content.
      *
      * @event ModalDialog#beforemodalfill
      * @type {Event}
      */ this.trigger("beforemodalfill");
        this.hasBeenFilled_ = true;
        // Detach the content element from the DOM before performing
        // manipulation to avoid modifying the live DOM multiple times.
        parentEl.removeChild(contentEl);
        this.empty();
        $cb03b711053a4297$var$insertContent(contentEl, content);
        /**
     * Fired just after a `ModalDialog` is filled with content.
     *
     * @event ModalDialog#modalfill
     * @type {Event}
     */ this.trigger("modalfill");
        // Re-inject the re-filled content element.
        if (nextSiblingEl) parentEl.insertBefore(contentEl, nextSiblingEl);
        else parentEl.appendChild(contentEl);
        // make sure that the close button is last in the dialog DOM
        const closeButton = this.getChild("closeButton");
        if (closeButton) parentEl.appendChild(closeButton.el_);
    }
    /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */ empty() {
        /**
    * Fired just before a `ModalDialog` is emptied.
    *
    * @event ModalDialog#beforemodalempty
    * @type {Event}
    */ this.trigger("beforemodalempty");
        $cb03b711053a4297$var$emptyEl(this.contentEl());
        /**
    * Fired just after a `ModalDialog` is emptied.
    *
    * @event ModalDialog#modalempty
    * @type {Event}
    */ this.trigger("modalempty");
    }
    /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  { import('./utils/dom').ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return { import('./utils/dom').ContentDescriptor}
   *         The current content of the modal dialog
   */ content(value) {
        if (typeof value !== "undefined") this.content_ = value;
        return this.content_;
    }
    /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */ conditionalFocus_() {
        const activeEl = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).activeElement;
        const playerEl = this.player_.el_;
        this.previouslyActiveEl_ = null;
        if (playerEl.contains(activeEl) || playerEl === activeEl) {
            this.previouslyActiveEl_ = activeEl;
            this.focus();
        }
    }
    /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */ conditionalBlur_() {
        if (this.previouslyActiveEl_) {
            this.previouslyActiveEl_.focus();
            this.previouslyActiveEl_ = null;
        }
    }
    /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Do not allow keydowns to reach out of the modal dialog.
        event.stopPropagation();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Escape") && this.closeable()) {
            event.preventDefault();
            this.close();
            return;
        }
        // exit early if it isn't a tab key
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Tab")) return;
        const focusableEls = this.focusableEls_();
        const activeEl = this.el_.querySelector(":focus");
        let focusIndex;
        for(let i = 0; i < focusableEls.length; i++)if (activeEl === focusableEls[i]) {
            focusIndex = i;
            break;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).activeElement === this.el_) focusIndex = 0;
        if (event.shiftKey && focusIndex === 0) {
            focusableEls[focusableEls.length - 1].focus();
            event.preventDefault();
        } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
            focusableEls[0].focus();
            event.preventDefault();
        }
    }
    /**
   * get all focusable elements
   *
   * @private
   */ focusableEls_() {
        const allChildren = this.el_.querySelectorAll("*");
        return Array.prototype.filter.call(allChildren, (child)=>{
            return (child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLAnchorElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLAreaElement) && child.hasAttribute("href") || (child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLInputElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLSelectElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLTextAreaElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLButtonElement) && !child.hasAttribute("disabled") || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLIFrameElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLObjectElement || child instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLEmbedElement || child.hasAttribute("tabindex") && child.getAttribute("tabindex") !== -1 || child.hasAttribute("contenteditable");
        });
    }
}
/**
 * Default options for `ModalDialog` default options.
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$ModalDialog.prototype.options_ = {
    pauseOnOpen: true,
    temporary: true
};
$cb03b711053a4297$var$Component$1.registerComponent("ModalDialog", $cb03b711053a4297$var$ModalDialog);
/**
 * @file track-list.js
 */ /**
 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
 * {@link VideoTrackList}
 *
 * @extends EventTarget
 */ class $cb03b711053a4297$var$TrackList extends $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Create an instance of this class
   *
   * @param { import('./track').default[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */ constructor(tracks = []){
        super();
        this.tracks_ = [];
        /**
     * @memberof TrackList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */ Object.defineProperty(this, "length", {
            get () {
                return this.tracks_.length;
            }
        });
        for(let i = 0; i < tracks.length; i++)this.addTrack(tracks[i]);
    }
    /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param { import('./track').default } track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        const index = this.tracks_.length;
        if (!("" + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.tracks_[index];
            }
        });
        // Do not add duplicate tracks
        if (this.tracks_.indexOf(track) === -1) {
            this.tracks_.push(track);
            /**
       * Triggered when a track is added to a track list.
       *
       * @event TrackList#addtrack
       * @type {Event}
       * @property {Track} track
       *           A reference to track that was added.
       */ this.trigger({
                track: track,
                type: "addtrack",
                target: this
            });
        }
        /**
     * Triggered when a track label is changed.
     *
     * @event TrackList#addtrack
     * @type {Event}
     * @property {Track} track
     *           A reference to track that was added.
     */ track.labelchange_ = ()=>{
            this.trigger({
                track: track,
                type: "labelchange",
                target: this
            });
        };
        if ($cb03b711053a4297$var$isEvented(track)) track.addEventListener("labelchange", track.labelchange_);
    }
    /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param { import('./track').default } rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */ removeTrack(rtrack) {
        let track;
        for(let i = 0, l = this.length; i < l; i++)if (this[i] === rtrack) {
            track = this[i];
            if (track.off) track.off();
            this.tracks_.splice(i, 1);
            break;
        }
        if (!track) return;
        /**
     * Triggered when a track is removed from track list.
     *
     * @event TrackList#removetrack
     * @type {Event}
     * @property {Track} track
     *           A reference to track that was removed.
     */ this.trigger({
            track: track,
            type: "removetrack",
            target: this
        });
    }
    /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return { import('./track').default }
   * @private
   */ getTrackById(id) {
        let result = null;
        for(let i = 0, l = this.length; i < l; i++){
            const track = this[i];
            if (track.id === id) {
                result = track;
                break;
            }
        }
        return result;
    }
}
/**
 * Triggered when a different track is selected/enabled.
 *
 * @event TrackList#change
 * @type {Event}
 */ /**
 * Events that can be called with on + eventName. See {@link EventHandler}.
 *
 * @property {Object} TrackList#allowedEvents_
 * @protected
 */ $cb03b711053a4297$var$TrackList.prototype.allowedEvents_ = {
    change: "change",
    addtrack: "addtrack",
    removetrack: "removetrack",
    labelchange: "labelchange"
};
// emulate attribute EventHandler support to allow for feature detection
for(const event in $cb03b711053a4297$var$TrackList.prototype.allowedEvents_)$cb03b711053a4297$var$TrackList.prototype["on" + event] = null;
/**
 * @file audio-track-list.js
 */ /**
 * Anywhere we call this function we diverge from the spec
 * as we only support one enabled audiotrack at a time
 *
 * @param {AudioTrackList} list
 *        list to work on
 *
 * @param { import('./audio-track').default } track
 *        The track to skip
 *
 * @private
 */ const $cb03b711053a4297$var$disableOthers$1 = function(list, track) {
    for(let i = 0; i < list.length; i++){
        if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
        // another audio track is enabled, disable it
        list[i].enabled = false;
    }
};
/**
 * The current list of {@link AudioTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
 * @extends TrackList
 */ class $cb03b711053a4297$var$AudioTrackList extends $cb03b711053a4297$var$TrackList {
    /**
   * Create an instance of this class.
   *
   * @param { import('./audio-track').default[] } [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */ constructor(tracks = []){
        // make sure only 1 track is enabled
        // sorted from last index to first index
        for(let i = tracks.length - 1; i >= 0; i--)if (tracks[i].enabled) {
            $cb03b711053a4297$var$disableOthers$1(tracks, tracks[i]);
            break;
        }
        super(tracks);
        this.changing_ = false;
    }
    /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param { import('./audio-track').default } track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        if (track.enabled) $cb03b711053a4297$var$disableOthers$1(this, track);
        super.addTrack(track);
        // native tracks don't have this
        if (!track.addEventListener) return;
        track.enabledChange_ = ()=>{
            // when we are disabling other tracks (since we don't support
            // more than one track at a time) we will set changing_
            // to true so that we don't trigger additional change events
            if (this.changing_) return;
            this.changing_ = true;
            $cb03b711053a4297$var$disableOthers$1(this, track);
            this.changing_ = false;
            this.trigger("change");
        };
        /**
     * @listens AudioTrack#enabledchange
     * @fires TrackList#change
     */ track.addEventListener("enabledchange", track.enabledChange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        if (rtrack.removeEventListener && rtrack.enabledChange_) {
            rtrack.removeEventListener("enabledchange", rtrack.enabledChange_);
            rtrack.enabledChange_ = null;
        }
    }
}
/**
 * @file video-track-list.js
 */ /**
 * Un-select all other {@link VideoTrack}s that are selected.
 *
 * @param {VideoTrackList} list
 *        list to work on
 *
 * @param { import('./video-track').default } track
 *        The track to skip
 *
 * @private
 */ const $cb03b711053a4297$var$disableOthers = function(list, track) {
    for(let i = 0; i < list.length; i++){
        if (!Object.keys(list[i]).length || track.id === list[i].id) continue;
        // another video track is enabled, disable it
        list[i].selected = false;
    }
};
/**
 * The current list of {@link VideoTrack} for a video.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
 * @extends TrackList
 */ class $cb03b711053a4297$var$VideoTrackList extends $cb03b711053a4297$var$TrackList {
    /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */ constructor(tracks = []){
        // make sure only 1 track is enabled
        // sorted from last index to first index
        for(let i = tracks.length - 1; i >= 0; i--)if (tracks[i].selected) {
            $cb03b711053a4297$var$disableOthers(tracks, tracks[i]);
            break;
        }
        super(tracks);
        this.changing_ = false;
        /**
     * @member {number} VideoTrackList#selectedIndex
     *         The current index of the selected {@link VideoTrack`}.
     */ Object.defineProperty(this, "selectedIndex", {
            get () {
                for(let i = 0; i < this.length; i++){
                    if (this[i].selected) return i;
                }
                return -1;
            },
            set () {}
        });
    }
    /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param { import('./video-track').default } track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        if (track.selected) $cb03b711053a4297$var$disableOthers(this, track);
        super.addTrack(track);
        // native tracks don't have this
        if (!track.addEventListener) return;
        track.selectedChange_ = ()=>{
            if (this.changing_) return;
            this.changing_ = true;
            $cb03b711053a4297$var$disableOthers(this, track);
            this.changing_ = false;
            this.trigger("change");
        };
        /**
     * @listens VideoTrack#selectedchange
     * @fires TrackList#change
     */ track.addEventListener("selectedchange", track.selectedChange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        if (rtrack.removeEventListener && rtrack.selectedChange_) {
            rtrack.removeEventListener("selectedchange", rtrack.selectedChange_);
            rtrack.selectedChange_ = null;
        }
    }
}
/**
 * @file text-track-list.js
 */ /**
 * The current list of {@link TextTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
 * @extends TrackList
 */ class $cb03b711053a4297$var$TextTrackList extends $cb03b711053a4297$var$TrackList {
    /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param { import('./text-track').default } track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */ addTrack(track) {
        super.addTrack(track);
        if (!this.queueChange_) this.queueChange_ = ()=>this.queueTrigger("change");
        if (!this.triggerSelectedlanguagechange) this.triggerSelectedlanguagechange_ = ()=>this.trigger("selectedlanguagechange");
        /**
     * @listens TextTrack#modechange
     * @fires TrackList#change
     */ track.addEventListener("modechange", this.queueChange_);
        const nonLanguageTextTrackKind = [
            "metadata",
            "chapters"
        ];
        if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) track.addEventListener("modechange", this.triggerSelectedlanguagechange_);
    }
    removeTrack(rtrack) {
        super.removeTrack(rtrack);
        // manually remove the event handlers we added
        if (rtrack.removeEventListener) {
            if (this.queueChange_) rtrack.removeEventListener("modechange", this.queueChange_);
            if (this.selectedlanguagechange_) rtrack.removeEventListener("modechange", this.triggerSelectedlanguagechange_);
        }
    }
}
/**
 * @file html-track-element-list.js
 */ /**
 * The current list of {@link HtmlTrackElement}s.
 */ class $cb03b711053a4297$var$HtmlTrackElementList {
    /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */ constructor(trackElements = []){
        this.trackElements_ = [];
        /**
     * @memberof HtmlTrackElementList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */ Object.defineProperty(this, "length", {
            get () {
                return this.trackElements_.length;
            }
        });
        for(let i = 0, length = trackElements.length; i < length; i++)this.addTrackElement_(trackElements[i]);
    }
    /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */ addTrackElement_(trackElement) {
        const index = this.trackElements_.length;
        if (!("" + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.trackElements_[index];
            }
        });
        // Do not add duplicate elements
        if (this.trackElements_.indexOf(trackElement) === -1) this.trackElements_.push(trackElement);
    }
    /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */ getTrackElementByTrack_(track) {
        let trackElement_;
        for(let i = 0, length = this.trackElements_.length; i < length; i++)if (track === this.trackElements_[i].track) {
            trackElement_ = this.trackElements_[i];
            break;
        }
        return trackElement_;
    }
    /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */ removeTrackElement_(trackElement) {
        for(let i = 0, length = this.trackElements_.length; i < length; i++)if (trackElement === this.trackElements_[i]) {
            if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === "function") this.trackElements_[i].track.off();
            if (typeof this.trackElements_[i].off === "function") this.trackElements_[i].off();
            this.trackElements_.splice(i, 1);
            break;
        }
    }
}
/**
 * @file text-track-cue-list.js
 */ /**
 * @typedef {Object} TextTrackCueList~TextTrackCue
 *
 * @property {string} id
 *           The unique id for this text track cue
 *
 * @property {number} startTime
 *           The start time for this text track cue
 *
 * @property {number} endTime
 *           The end time for this text track cue
 *
 * @property {boolean} pauseOnExit
 *           Pause when the end time is reached if true.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
 */ /**
 * A List of TextTrackCues.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
 */ class $cb03b711053a4297$var$TextTrackCueList {
    /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */ constructor(cues){
        $cb03b711053a4297$var$TextTrackCueList.prototype.setCues_.call(this, cues);
        /**
     * @memberof TextTrackCueList
     * @member {number} length
     *         The current number of `TextTrackCue`s in the TextTrackCueList.
     * @instance
     */ Object.defineProperty(this, "length", {
            get () {
                return this.length_;
            }
        });
    }
    /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */ setCues_(cues) {
        const oldLength = this.length || 0;
        let i = 0;
        const l = cues.length;
        this.cues_ = cues;
        this.length_ = cues.length;
        const defineProp = function(index) {
            if (!("" + index in this)) Object.defineProperty(this, "" + index, {
                get () {
                    return this.cues_[index];
                }
            });
        };
        if (oldLength < l) {
            i = oldLength;
            for(; i < l; i++)defineProp.call(this, i);
        }
    }
    /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */ getCueById(id) {
        let result = null;
        for(let i = 0, l = this.length; i < l; i++){
            const cue = this[i];
            if (cue.id === id) {
                result = cue;
                break;
            }
        }
        return result;
    }
}
/**
 * @file track-kinds.js
 */ /**
 * All possible `VideoTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
 * @typedef VideoTrack~Kind
 * @enum
 */ const $cb03b711053a4297$var$VideoTrackKind = {
    alternative: "alternative",
    captions: "captions",
    main: "main",
    sign: "sign",
    subtitles: "subtitles",
    commentary: "commentary"
};
/**
 * All possible `AudioTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
 * @typedef AudioTrack~Kind
 * @enum
 */ const $cb03b711053a4297$var$AudioTrackKind = {
    "alternative": "alternative",
    "descriptions": "descriptions",
    "main": "main",
    "main-desc": "main-desc",
    "translation": "translation",
    "commentary": "commentary"
};
/**
 * All possible `TextTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
 * @typedef TextTrack~Kind
 * @enum
 */ const $cb03b711053a4297$var$TextTrackKind = {
    subtitles: "subtitles",
    captions: "captions",
    descriptions: "descriptions",
    chapters: "chapters",
    metadata: "metadata"
};
/**
 * All possible `TextTrackMode`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
 * @typedef TextTrack~Mode
 * @enum
 */ const $cb03b711053a4297$var$TextTrackMode = {
    disabled: "disabled",
    hidden: "hidden",
    showing: "showing"
};
/**
 * @file track.js
 */ /**
 * A Track class that contains all of the common functionality for {@link AudioTrack},
 * {@link VideoTrack}, and {@link TextTrack}.
 *
 * > Note: This class should not be used directly
 *
 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
 * @extends EventTarget
 * @abstract
 */ class $cb03b711053a4297$var$Track extends $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */ constructor(options = {}){
        super();
        const trackProps = {
            id: options.id || "vjs_track_" + $cb03b711053a4297$var$newGUID(),
            kind: options.kind || "",
            language: options.language || ""
        };
        let label = options.label || "";
        /**
     * @memberof Track
     * @member {string} id
     *         The id of this track. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} kind
     *         The kind of track that this is. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} language
     *         The two letter language code for this track. Cannot be changed after
     *         creation.
     * @instance
     *
     * @readonly
     */ for(const key in trackProps)Object.defineProperty(this, key, {
            get () {
                return trackProps[key];
            },
            set () {}
        });
        /**
     * @memberof Track
     * @member {string} label
     *         The label of this track. Cannot be changed after creation.
     * @instance
     *
     * @fires Track#labelchange
     */ Object.defineProperty(this, "label", {
            get () {
                return label;
            },
            set (newLabel) {
                if (newLabel !== label) {
                    label = newLabel;
                    /**
           * An event that fires when label changes on this track.
           *
           * > Note: This is not part of the spec!
           *
           * @event Track#labelchange
           * @type {Event}
           */ this.trigger("labelchange");
                }
            }
        });
    }
}
/**
 * @file url.js
 * @module url
 */ /**
 * @typedef {Object} url:URLObject
 *
 * @property {string} protocol
 *           The protocol of the url that was parsed.
 *
 * @property {string} hostname
 *           The hostname of the url that was parsed.
 *
 * @property {string} port
 *           The port of the url that was parsed.
 *
 * @property {string} pathname
 *           The pathname of the url that was parsed.
 *
 * @property {string} search
 *           The search query of the url that was parsed.
 *
 * @property {string} hash
 *           The hash of the url that was parsed.
 *
 * @property {string} host
 *           The host of the url that was parsed.
 */ /**
 * Resolve and parse the elements of a URL.
 *
 * @function
 * @param    {String} url
 *           The url to parse
 *
 * @return   {url:URLObject}
 *           An object of url details
 */ const $cb03b711053a4297$var$parseUrl = function(url) {
    // This entire method can be replace with URL once we are able to drop IE11
    const props = [
        "protocol",
        "hostname",
        "port",
        "pathname",
        "search",
        "hash",
        "host"
    ];
    // add the url to an anchor and let the browser parse the URL
    const a = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("a");
    a.href = url;
    // Copy the specific URL properties to a new object
    // This is also needed for IE because the anchor loses its
    // properties when it's removed from the dom
    const details = {};
    for(let i = 0; i < props.length; i++)details[props[i]] = a[props[i]];
    // IE adds the port to the host property unlike everyone else. If
    // a port identifier is added for standard ports, strip it.
    if (details.protocol === "http:") details.host = details.host.replace(/:80$/, "");
    if (details.protocol === "https:") details.host = details.host.replace(/:443$/, "");
    if (!details.protocol) details.protocol = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.protocol;
    /* istanbul ignore if */ if (!details.host) details.host = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.host;
    return details;
};
/**
 * Get absolute version of relative URL.
 *
 * @function
 * @param    {string} url
 *           URL to make absolute
 *
 * @return   {string}
 *           Absolute URL
 *
 * @see      http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
 */ const $cb03b711053a4297$var$getAbsoluteURL = function(url) {
    // Check if absolute URL
    if (!url.match(/^https?:\/\//)) {
        // Add the url to an anchor and let the browser parse it to convert to an absolute url
        const a = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("a");
        a.href = url;
        url = a.href;
    }
    return url;
};
/**
 * Returns the extension of the passed file name. It will return an empty string
 * if passed an invalid path.
 *
 * @function
 * @param    {string} path
 *           The fileName path like '/path/to/file.mp4'
 *
 * @return  {string}
 *           The extension in lower case or an empty string if no
 *           extension could be found.
 */ const $cb03b711053a4297$var$getFileExtension = function(path) {
    if (typeof path === "string") {
        const splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/;
        const pathParts = splitPathRe.exec(path);
        if (pathParts) return pathParts.pop().toLowerCase();
    }
    return "";
};
/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @function
 * @param    {string} url
 *           The url to check.
 *
 * @param    {Object} [winLoc]
 *           the domain to check the url against, defaults to window.location
 *
 * @param    {string} [winLoc.protocol]
 *           The window location protocol defaults to window.location.protocol
 *
 * @param    {string} [winLoc.host]
 *           The window location host defaults to window.location.host
 *
 * @return   {boolean}
 *           Whether it is a cross domain request or not.
 */ const $cb03b711053a4297$var$isCrossOrigin = function(url, winLoc = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location) {
    const urlInfo = $cb03b711053a4297$var$parseUrl(url);
    // IE8 protocol relative urls will return ':' for protocol
    const srcProtocol = urlInfo.protocol === ":" ? winLoc.protocol : urlInfo.protocol;
    // Check if url is for another domain/origin
    // IE8 doesn't know location.origin, so we won't rely on it here
    const crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;
    return crossOrigin;
};
var $cb03b711053a4297$var$Url = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    parseUrl: $cb03b711053a4297$var$parseUrl,
    getAbsoluteURL: $cb03b711053a4297$var$getAbsoluteURL,
    getFileExtension: $cb03b711053a4297$var$getFileExtension,
    isCrossOrigin: $cb03b711053a4297$var$isCrossOrigin
});
/**
 * @file text-track.js
 */ /**
 * Takes a webvtt file contents and parses it into cues
 *
 * @param {string} srcContent
 *        webVTT file contents
 *
 * @param {TextTrack} track
 *        TextTrack to add cues to. Cues come from the srcContent.
 *
 * @private
 */ const $cb03b711053a4297$var$parseCues = function(srcContent, track) {
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.Parser((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).vttjs, (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.StringDecoder());
    const errors = [];
    parser.oncue = function(cue) {
        track.addCue(cue);
    };
    parser.onparsingerror = function(error) {
        errors.push(error);
    };
    parser.onflush = function() {
        track.trigger({
            type: "loadeddata",
            target: track
        });
    };
    parser.parse(srcContent);
    if (errors.length > 0) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupCollapsed) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupCollapsed(`Text Track parsing errors for ${track.src}`);
        errors.forEach((error)=>$cb03b711053a4297$var$log$1.error(error));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupEnd) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).console.groupEnd();
    }
    parser.flush();
};
/**
 * Load a `TextTrack` from a specified url.
 *
 * @param {string} src
 *        Url to load track from.
 *
 * @param {TextTrack} track
 *        Track to add cues to. Comes from the content at the end of `url`.
 *
 * @private
 */ const $cb03b711053a4297$var$loadTrack = function(src, track) {
    const opts = {
        uri: src
    };
    const crossOrigin = $cb03b711053a4297$var$isCrossOrigin(src);
    if (crossOrigin) opts.cors = crossOrigin;
    const withCredentials = track.tech_.crossOrigin() === "use-credentials";
    if (withCredentials) opts.withCredentials = withCredentials;
    (0, (/*@__PURE__*/$parcel$interopDefault($cfb0541156229cda$exports)))(opts, $cb03b711053a4297$var$bind_(this, function(err, response, responseBody) {
        if (err) return $cb03b711053a4297$var$log$1.error(err, response);
        track.loaded_ = true;
        // Make sure that vttjs has loaded, otherwise, wait till it finished loading
        // NOTE: this is only used for the alt/video.novtt.js build
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== "function") {
            if (track.tech_) // to prevent use before define eslint error, we define loadHandler
            // as a let here
            track.tech_.any([
                "vttjsloaded",
                "vttjserror"
            ], (event)=>{
                if (event.type === "vttjserror") {
                    $cb03b711053a4297$var$log$1.error(`vttjs failed to load, stopping trying to process ${track.src}`);
                    return;
                }
                return $cb03b711053a4297$var$parseCues(responseBody, track);
            });
        } else $cb03b711053a4297$var$parseCues(responseBody, track);
    }));
};
/**
 * A representation of a single `TextTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
 * @extends Track
 */ class $cb03b711053a4297$var$TextTrack extends $cb03b711053a4297$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param { import('../tech/tech').default } options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */ constructor(options = {}){
        if (!options.tech) throw new Error("A tech was not provided.");
        const settings = $cb03b711053a4297$var$merge$1(options, {
            kind: $cb03b711053a4297$var$TextTrackKind[options.kind] || "subtitles",
            language: options.language || options.srclang || ""
        });
        let mode = $cb03b711053a4297$var$TextTrackMode[settings.mode] || "disabled";
        const default_ = settings.default;
        if (settings.kind === "metadata" || settings.kind === "chapters") mode = "hidden";
        super(settings);
        this.tech_ = settings.tech;
        this.cues_ = [];
        this.activeCues_ = [];
        this.preload_ = this.tech_.preloadTextTracks !== false;
        const cues = new $cb03b711053a4297$var$TextTrackCueList(this.cues_);
        const activeCues = new $cb03b711053a4297$var$TextTrackCueList(this.activeCues_);
        let changed = false;
        this.timeupdateHandler = $cb03b711053a4297$var$bind_(this, function(event = {}) {
            if (this.tech_.isDisposed()) return;
            if (!this.tech_.isReady_) {
                if (event.type !== "timeupdate") this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
                return;
            }
            // Accessing this.activeCues for the side-effects of updating itself
            // due to its nature as a getter function. Do not remove or cues will
            // stop updating!
            // Use the setter to prevent deletion from uglify (pure_getters rule)
            this.activeCues = this.activeCues;
            if (changed) {
                this.trigger("cuechange");
                changed = false;
            }
            if (event.type !== "timeupdate") this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
        });
        const disposeHandler = ()=>{
            this.stopTracking();
        };
        this.tech_.one("dispose", disposeHandler);
        if (mode !== "disabled") this.startTracking();
        Object.defineProperties(this, {
            /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */ default: {
                get () {
                    return default_;
                },
                set () {}
            },
            /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */ mode: {
                get () {
                    return mode;
                },
                set (newMode) {
                    if (!$cb03b711053a4297$var$TextTrackMode[newMode]) return;
                    if (mode === newMode) return;
                    mode = newMode;
                    if (!this.preload_ && mode !== "disabled" && this.cues.length === 0) // On-demand load.
                    $cb03b711053a4297$var$loadTrack(this.src, this);
                    this.stopTracking();
                    if (mode !== "disabled") this.startTracking();
                    /**
           * An event that fires when mode changes on this track. This allows
           * the TextTrackList that holds this track to act accordingly.
           *
           * > Note: This is not part of the spec!
           *
           * @event TextTrack#modechange
           * @type {Event}
           */ this.trigger("modechange");
                }
            },
            /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */ cues: {
                get () {
                    if (!this.loaded_) return null;
                    return cues;
                },
                set () {}
            },
            /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */ activeCues: {
                get () {
                    if (!this.loaded_) return null;
                    // nothing to do
                    if (this.cues.length === 0) return activeCues;
                    const ct = this.tech_.currentTime();
                    const active = [];
                    for(let i = 0, l = this.cues.length; i < l; i++){
                        const cue = this.cues[i];
                        if (cue.startTime <= ct && cue.endTime >= ct) active.push(cue);
                    }
                    changed = false;
                    if (active.length !== this.activeCues_.length) changed = true;
                    else {
                        for(let i = 0; i < active.length; i++)if (this.activeCues_.indexOf(active[i]) === -1) changed = true;
                    }
                    this.activeCues_ = active;
                    activeCues.setCues_(this.activeCues_);
                    return activeCues;
                },
                // /!\ Keep this setter empty (see the timeupdate handler above)
                set () {}
            }
        });
        if (settings.src) {
            this.src = settings.src;
            if (!this.preload_) // Tracks will load on-demand.
            // Act like we're loaded for other purposes.
            this.loaded_ = true;
            if (this.preload_ || settings.kind !== "subtitles" && settings.kind !== "captions") $cb03b711053a4297$var$loadTrack(this.src, this);
        } else this.loaded_ = true;
    }
    startTracking() {
        // More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
        this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
        // Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
        this.tech_.on("timeupdate", this.timeupdateHandler);
    }
    stopTracking() {
        if (this.rvf_) {
            this.tech_.cancelVideoFrameCallback(this.rvf_);
            this.rvf_ = undefined;
        }
        this.tech_.off("timeupdate", this.timeupdateHandler);
    }
    /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */ addCue(originalCue) {
        let cue = originalCue;
        // Testing if the cue is a VTTCue in a way that survives minification
        if (!("getCueAsHTML" in cue)) {
            cue = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
            for(const prop in originalCue)if (!(prop in cue)) cue[prop] = originalCue[prop];
            // make sure that `id` is copied over
            cue.id = originalCue.id;
            cue.originalCue_ = originalCue;
        }
        const tracks = this.tech_.textTracks();
        for(let i = 0; i < tracks.length; i++)if (tracks[i] !== this) tracks[i].removeCue(cue);
        this.cues_.push(cue);
        this.cues.setCues_(this.cues_);
    }
    /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */ removeCue(removeCue) {
        let i = this.cues_.length;
        while(i--){
            const cue = this.cues_[i];
            if (cue === removeCue || cue.originalCue_ && cue.originalCue_ === removeCue) {
                this.cues_.splice(i, 1);
                this.cues.setCues_(this.cues_);
                break;
            }
        }
    }
}
/**
 * cuechange - One or more cues in the track have become active or stopped being active.
 * @protected
 */ $cb03b711053a4297$var$TextTrack.prototype.allowedEvents_ = {
    cuechange: "cuechange"
};
/**
 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
 * only one `AudioTrack` in the list will be enabled at a time.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
 * @extends Track
 */ class $cb03b711053a4297$var$AudioTrack extends $cb03b711053a4297$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */ constructor(options = {}){
        const settings = $cb03b711053a4297$var$merge$1(options, {
            kind: $cb03b711053a4297$var$AudioTrackKind[options.kind] || ""
        });
        super(settings);
        let enabled = false;
        /**
     * @memberof AudioTrack
     * @member {boolean} enabled
     *         If this `AudioTrack` is enabled or not. When setting this will
     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */ Object.defineProperty(this, "enabled", {
            get () {
                return enabled;
            },
            set (newEnabled) {
                // an invalid or unchanged value
                if (typeof newEnabled !== "boolean" || newEnabled === enabled) return;
                enabled = newEnabled;
                /**
         * An event that fires when enabled changes on this track. This allows
         * the AudioTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event AudioTrack#enabledchange
         * @type {Event}
         */ this.trigger("enabledchange");
            }
        });
        // if the user sets this track to selected then
        // set selected to that true value otherwise
        // we keep it false
        if (settings.enabled) this.enabled = settings.enabled;
        this.loaded_ = true;
    }
}
/**
 * A representation of a single `VideoTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
 * @extends Track
 */ class $cb03b711053a4297$var$VideoTrack extends $cb03b711053a4297$var$Track {
    /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */ constructor(options = {}){
        const settings = $cb03b711053a4297$var$merge$1(options, {
            kind: $cb03b711053a4297$var$VideoTrackKind[options.kind] || ""
        });
        super(settings);
        let selected = false;
        /**
     * @memberof VideoTrack
     * @member {boolean} selected
     *         If this `VideoTrack` is selected or not. When setting this will
     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */ Object.defineProperty(this, "selected", {
            get () {
                return selected;
            },
            set (newSelected) {
                // an invalid or unchanged value
                if (typeof newSelected !== "boolean" || newSelected === selected) return;
                selected = newSelected;
                /**
         * An event that fires when selected changes on this track. This allows
         * the VideoTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event VideoTrack#selectedchange
         * @type {Event}
         */ this.trigger("selectedchange");
            }
        });
        // if the user sets this track to selected then
        // set selected to that true value otherwise
        // we keep it false
        if (settings.selected) this.selected = settings.selected;
    }
}
/**
 * @file html-track-element.js
 */ /**
 * A single track represented in the DOM.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
 * @extends EventTarget
 */ class $cb03b711053a4297$var$HTMLTrackElement extends $cb03b711053a4297$var$EventTarget$2 {
    /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param { import('../tech/tech').default } options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */ constructor(options = {}){
        super();
        let readyState;
        const track = new $cb03b711053a4297$var$TextTrack(options);
        this.kind = track.kind;
        this.src = track.src;
        this.srclang = track.language;
        this.label = track.label;
        this.default = track.default;
        Object.defineProperties(this, {
            /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */ readyState: {
                get () {
                    return readyState;
                }
            },
            /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */ track: {
                get () {
                    return track;
                }
            }
        });
        readyState = $cb03b711053a4297$var$HTMLTrackElement.NONE;
        /**
     * @listens TextTrack#loadeddata
     * @fires HTMLTrackElement#load
     */ track.addEventListener("loadeddata", ()=>{
            readyState = $cb03b711053a4297$var$HTMLTrackElement.LOADED;
            this.trigger({
                type: "load",
                target: this
            });
        });
    }
}
/**
 * @protected
 */ $cb03b711053a4297$var$HTMLTrackElement.prototype.allowedEvents_ = {
    load: "load"
};
/**
 * The text track not loaded state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.NONE = 0;
/**
 * The text track loading state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.LOADING = 1;
/**
 * The text track loaded state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.LOADED = 2;
/**
 * The text track failed to load state.
 *
 * @type {number}
 * @static
 */ $cb03b711053a4297$var$HTMLTrackElement.ERROR = 3;
/*
 * This file contains all track properties that are used in
 * player.js, tech.js, html5.js and possibly other techs in the future.
 */ const $cb03b711053a4297$var$NORMAL = {
    audio: {
        ListClass: $cb03b711053a4297$var$AudioTrackList,
        TrackClass: $cb03b711053a4297$var$AudioTrack,
        capitalName: "Audio"
    },
    video: {
        ListClass: $cb03b711053a4297$var$VideoTrackList,
        TrackClass: $cb03b711053a4297$var$VideoTrack,
        capitalName: "Video"
    },
    text: {
        ListClass: $cb03b711053a4297$var$TextTrackList,
        TrackClass: $cb03b711053a4297$var$TextTrack,
        capitalName: "Text"
    }
};
Object.keys($cb03b711053a4297$var$NORMAL).forEach(function(type) {
    $cb03b711053a4297$var$NORMAL[type].getterName = `${type}Tracks`;
    $cb03b711053a4297$var$NORMAL[type].privateName = `${type}Tracks_`;
});
const $cb03b711053a4297$var$REMOTE = {
    remoteText: {
        ListClass: $cb03b711053a4297$var$TextTrackList,
        TrackClass: $cb03b711053a4297$var$TextTrack,
        capitalName: "RemoteText",
        getterName: "remoteTextTracks",
        privateName: "remoteTextTracks_"
    },
    remoteTextEl: {
        ListClass: $cb03b711053a4297$var$HtmlTrackElementList,
        TrackClass: $cb03b711053a4297$var$HTMLTrackElement,
        capitalName: "RemoteTextTrackEls",
        getterName: "remoteTextTrackEls",
        privateName: "remoteTextTrackEls_"
    }
};
const $cb03b711053a4297$var$ALL = Object.assign({}, $cb03b711053a4297$var$NORMAL, $cb03b711053a4297$var$REMOTE);
$cb03b711053a4297$var$REMOTE.names = Object.keys($cb03b711053a4297$var$REMOTE);
$cb03b711053a4297$var$NORMAL.names = Object.keys($cb03b711053a4297$var$NORMAL);
$cb03b711053a4297$var$ALL.names = [].concat($cb03b711053a4297$var$REMOTE.names).concat($cb03b711053a4297$var$NORMAL.names);
/**
 * @file tech.js
 */ /**
 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
 * that just contains the src url alone.
 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
   * `var SourceString = 'http://example.com/some-video.mp4';`
 *
 * @typedef {Object|string} SourceObject
 *
 * @property {string} src
 *           The url to the source
 *
 * @property {string} type
 *           The mime type of the source
 */ /**
 * A function used by {@link Tech} to create a new {@link TextTrack}.
 *
 * @private
 *
 * @param {Tech} self
 *        An instance of the Tech class.
 *
 * @param {string} kind
 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
 *
 * @param {string} [label]
 *        Label to identify the text track
 *
 * @param {string} [language]
 *        Two letter language abbreviation
 *
 * @param {Object} [options={}]
 *        An object with additional text track options
 *
 * @return {TextTrack}
 *          The text track that was created.
 */ function $cb03b711053a4297$var$createTrackHelper(self1, kind, label, language, options = {}) {
    const tracks = self1.textTracks();
    options.kind = kind;
    if (label) options.label = label;
    if (language) options.language = language;
    options.tech = self1;
    const track = new $cb03b711053a4297$var$ALL.text.TrackClass(options);
    tracks.addTrack(track);
    return track;
}
/**
 * This is the base class for media playback technology controllers, such as
 * {@link HTML5}
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Tech extends $cb03b711053a4297$var$Component$1 {
    /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */ constructor(options = {}, ready = function() {}){
        // we don't want the tech to report user activity automatically.
        // This is done manually in addControlsListeners
        options.reportTouchActivity = false;
        super(null, options, ready);
        this.onDurationChange_ = (e)=>this.onDurationChange(e);
        this.trackProgress_ = (e)=>this.trackProgress(e);
        this.trackCurrentTime_ = (e)=>this.trackCurrentTime(e);
        this.stopTrackingCurrentTime_ = (e)=>this.stopTrackingCurrentTime(e);
        this.disposeSourceHandler_ = (e)=>this.disposeSourceHandler(e);
        this.queuedHanders_ = new Set();
        // keep track of whether the current source has played at all to
        // implement a very limited played()
        this.hasStarted_ = false;
        this.on("playing", function() {
            this.hasStarted_ = true;
        });
        this.on("loadstart", function() {
            this.hasStarted_ = false;
        });
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            if (options && options[props.getterName]) this[props.privateName] = options[props.getterName];
        });
        // Manually track progress in cases where the browser/tech doesn't report it.
        if (!this.featuresProgressEvents) this.manualProgressOn();
        // Manually track timeupdates in cases where the browser/tech doesn't report it.
        if (!this.featuresTimeupdateEvents) this.manualTimeUpdatesOn();
        [
            "Text",
            "Audio",
            "Video"
        ].forEach((track)=>{
            if (options[`native${track}Tracks`] === false) this[`featuresNative${track}Tracks`] = false;
        });
        if (options.nativeCaptions === false || options.nativeTextTracks === false) this.featuresNativeTextTracks = false;
        else if (options.nativeCaptions === true || options.nativeTextTracks === true) this.featuresNativeTextTracks = true;
        if (!this.featuresNativeTextTracks) this.emulateTextTracks();
        this.preloadTextTracks = options.preloadTextTracks !== false;
        this.autoRemoteTextTracks_ = new $cb03b711053a4297$var$ALL.text.ListClass();
        this.initTrackListeners();
        // Turn on component tap events only if not using native controls
        if (!options.nativeControlsForTouch) this.emitTapEvents();
        if (this.constructor) this.name_ = this.constructor.name || "Unknown Tech";
    }
    /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */ triggerSourceset(src) {
        if (!this.isReady_) // on initial ready we have to trigger source set
        // 1ms after ready so that player can watch for it.
        this.one("ready", ()=>this.setTimeout(()=>this.triggerSourceset(src), 1));
        /**
     * Fired when the source is set on the tech causing the media element
     * to reload.
     *
     * @see {@link Player#event:sourceset}
     * @event Tech#sourceset
     * @type {Event}
     */ this.trigger({
            src: src,
            type: "sourceset"
        });
    }
    /* Fallbacks for unsupported event types
  ================================================================================ */ /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */ manualProgressOn() {
        this.on("durationchange", this.onDurationChange_);
        this.manualProgress = true;
        // Trigger progress watching when a source begins loading
        this.one("ready", this.trackProgress_);
    }
    /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */ manualProgressOff() {
        this.manualProgress = false;
        this.stopTrackingProgress();
        this.off("durationchange", this.onDurationChange_);
    }
    /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */ trackProgress(event) {
        this.stopTrackingProgress();
        this.progressInterval = this.setInterval($cb03b711053a4297$var$bind_(this, function() {
            // Don't trigger unless buffered amount is greater than last time
            const numBufferedPercent = this.bufferedPercent();
            if (this.bufferedPercent_ !== numBufferedPercent) /**
         * See {@link Player#progress}
         *
         * @event Tech#progress
         * @type {Event}
         */ this.trigger("progress");
            this.bufferedPercent_ = numBufferedPercent;
            if (numBufferedPercent === 1) this.stopTrackingProgress();
        }), 500);
    }
    /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */ onDurationChange(event) {
        this.duration_ = this.duration();
    }
    /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return { import('../utils/time').TimeRange }
   *         The time range object that was created.
   */ buffered() {
        return $cb03b711053a4297$var$createTimeRanges$1(0, 0);
    }
    /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */ bufferedPercent() {
        return $cb03b711053a4297$var$bufferedPercent(this.buffered(), this.duration_);
    }
    /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */ stopTrackingProgress() {
        this.clearInterval(this.progressInterval);
    }
    /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */ manualTimeUpdatesOn() {
        this.manualTimeUpdates = true;
        this.on("play", this.trackCurrentTime_);
        this.on("pause", this.stopTrackingCurrentTime_);
    }
    /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */ manualTimeUpdatesOff() {
        this.manualTimeUpdates = false;
        this.stopTrackingCurrentTime();
        this.off("play", this.trackCurrentTime_);
        this.off("pause", this.stopTrackingCurrentTime_);
    }
    /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */ trackCurrentTime() {
        if (this.currentTimeInterval) this.stopTrackingCurrentTime();
        this.currentTimeInterval = this.setInterval(function() {
            /**
       * Triggered at an interval of 250ms to indicated that time is passing in the video.
       *
       * @event Tech#timeupdate
       * @type {Event}
       */ this.trigger({
                type: "timeupdate",
                target: this,
                manuallyTriggered: true
            });
        // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
        }, 250);
    }
    /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */ stopTrackingCurrentTime() {
        this.clearInterval(this.currentTimeInterval);
        // #1002 - if the video ends right before the next timeupdate would happen,
        // the progress bar won't make it all the way to the end
        this.trigger({
            type: "timeupdate",
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */ dispose() {
        // clear out all tracks because we can't reuse them between techs
        this.clearTracks($cb03b711053a4297$var$NORMAL.names);
        // Turn off any manual progress or timeupdate tracking
        if (this.manualProgress) this.manualProgressOff();
        if (this.manualTimeUpdates) this.manualTimeUpdatesOff();
        super.dispose();
    }
    /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */ clearTracks(types) {
        types = [].concat(types);
        // clear out all tracks because we can't reuse them between techs
        types.forEach((type)=>{
            const list = this[`${type}Tracks`]() || [];
            let i = list.length;
            while(i--){
                const track = list[i];
                if (type === "text") this.removeRemoteTextTrack(track);
                list.removeTrack(track);
            }
        });
    }
    /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */ cleanupAutoTextTracks() {
        const list = this.autoRemoteTextTracks_ || [];
        let i = list.length;
        while(i--){
            const track = list[i];
            this.removeRemoteTextTrack(track);
        }
    }
    /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */ reset() {}
    /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */ crossOrigin() {}
    /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */ setCrossOrigin() {}
    /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */ error(err) {
        if (err !== undefined) {
            this.error_ = new $cb03b711053a4297$var$MediaError(err);
            this.trigger("error");
        }
        return this.error_;
    }
    /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return { import('../utils/time').TimeRange }
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */ played() {
        if (this.hasStarted_) return $cb03b711053a4297$var$createTimeRanges$1(0, 0);
        return $cb03b711053a4297$var$createTimeRanges$1();
    }
    /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */ play() {}
    /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */ setScrubbing(_isScrubbing) {}
    /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */ scrubbing() {}
    /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */ setCurrentTime(_seconds) {
        // improve the accuracy of manual timeupdates
        if (this.manualTimeUpdates) /**
       * A manual `timeupdate` event.
       *
       * @event Tech#timeupdate
       * @type {Event}
       */ this.trigger({
            type: "timeupdate",
            target: this,
            manuallyTriggered: true
        });
    }
    /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */ initTrackListeners() {
        /**
      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
      *
      * @event Tech#audiotrackchange
      * @type {Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
      *
      * @event Tech#videotrackchange
      * @type {Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
      *
      * @event Tech#texttrackchange
      * @type {Event}
      */ $cb03b711053a4297$var$NORMAL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$NORMAL[name];
            const trackListChanges = ()=>{
                this.trigger(`${name}trackchange`);
            };
            const tracks = this[props.getterName]();
            tracks.addEventListener("removetrack", trackListChanges);
            tracks.addEventListener("addtrack", trackListChanges);
            this.on("dispose", ()=>{
                tracks.removeEventListener("removetrack", trackListChanges);
                tracks.removeEventListener("addtrack", trackListChanges);
            });
        });
    }
    /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */ addWebVttScript_() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT) return;
        // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
        // signals that the Tech is ready at which point Tech.el_ is part of the DOM
        // before inserting the WebVTT script
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body.contains(this.el())) {
            // load via require if available and vtt.js script location was not passed in
            // as an option. novtt builds will turn the above require call into an empty object
            // which will cause this if check to always fail.
            if (!this.options_["vtt.js"] && $cb03b711053a4297$var$isPlain((0, (/*@__PURE__*/$parcel$interopDefault($75606c86739c45ca$exports)))) && Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($75606c86739c45ca$exports)))).length > 0) {
                this.trigger("vttjsloaded");
                return;
            }
            // load vtt.js via the script location option or the cdn of no location was
            // passed in
            const script = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("script");
            script.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js";
            script.onload = ()=>{
                /**
         * Fired when vtt.js is loaded.
         *
         * @event Tech#vttjsloaded
         * @type {Event}
         */ this.trigger("vttjsloaded");
            };
            script.onerror = ()=>{
                /**
         * Fired when vtt.js was not loaded due to an error
         *
         * @event Tech#vttjsloaded
         * @type {Event}
         */ this.trigger("vttjserror");
            };
            this.on("dispose", ()=>{
                script.onload = null;
                script.onerror = null;
            });
            // but have not loaded yet and we set it to true before the inject so that
            // we don't overwrite the injected window.WebVTT if it loads right away
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT = true;
            this.el().parentNode.appendChild(script);
        } else this.ready(this.addWebVttScript_);
    }
    /**
   * Emulate texttracks
   *
   */ emulateTextTracks() {
        const tracks = this.textTracks();
        const remoteTracks = this.remoteTextTracks();
        const handleAddTrack = (e)=>tracks.addTrack(e.track);
        const handleRemoveTrack = (e)=>tracks.removeTrack(e.track);
        remoteTracks.on("addtrack", handleAddTrack);
        remoteTracks.on("removetrack", handleRemoveTrack);
        this.addWebVttScript_();
        const updateDisplay = ()=>this.trigger("texttrackchange");
        const textTracksChanges = ()=>{
            updateDisplay();
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                track.removeEventListener("cuechange", updateDisplay);
                if (track.mode === "showing") track.addEventListener("cuechange", updateDisplay);
            }
        };
        textTracksChanges();
        tracks.addEventListener("change", textTracksChanges);
        tracks.addEventListener("addtrack", textTracksChanges);
        tracks.addEventListener("removetrack", textTracksChanges);
        this.on("dispose", function() {
            remoteTracks.off("addtrack", handleAddTrack);
            remoteTracks.off("removetrack", handleRemoveTrack);
            tracks.removeEventListener("change", textTracksChanges);
            tracks.removeEventListener("addtrack", textTracksChanges);
            tracks.removeEventListener("removetrack", textTracksChanges);
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                track.removeEventListener("cuechange", updateDisplay);
            }
        });
    }
    /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */ addTextTrack(kind, label, language) {
        if (!kind) throw new Error("TextTrack kind is required but was not provided");
        return $cb03b711053a4297$var$createTrackHelper(this, kind, label, language);
    }
    /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */ createRemoteTextTrack(options) {
        const track = $cb03b711053a4297$var$merge$1(options, {
            tech: this
        });
        return new $cb03b711053a4297$var$REMOTE.remoteTextEl.TrackClass(track);
    }
    /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */ addRemoteTextTrack(options = {}, manualCleanup) {
        const htmlTrackElement = this.createRemoteTextTrack(options);
        if (typeof manualCleanup !== "boolean") manualCleanup = false;
        // store HTMLTrackElement and TextTrack to remote list
        this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
        this.remoteTextTracks().addTrack(htmlTrackElement.track);
        if (manualCleanup === false) // create the TextTrackList if it doesn't exist
        this.ready(()=>this.autoRemoteTextTracks_.addTrack(htmlTrackElement.track));
        return htmlTrackElement;
    }
    /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */ removeRemoteTextTrack(track) {
        const trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
        // remove HTMLTrackElement and TextTrack from remote list
        this.remoteTextTrackEls().removeTrackElement_(trackElement);
        this.remoteTextTracks().removeTrack(track);
        this.autoRemoteTextTracks_.removeTrack(track);
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */ getVideoPlaybackQuality() {
        return {};
    }
    /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */ requestPictureInPicture() {
        return Promise.reject();
    }
    /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */ disablePictureInPicture() {
        return true;
    }
    /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */ setDisablePictureInPicture() {}
    /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */ requestVideoFrameCallback(cb) {
        const id = $cb03b711053a4297$var$newGUID();
        if (!this.isReady_ || this.paused()) {
            this.queuedHanders_.add(id);
            this.one("playing", ()=>{
                if (this.queuedHanders_.has(id)) {
                    this.queuedHanders_.delete(id);
                    cb();
                }
            });
        } else this.requestNamedAnimationFrame(id, cb);
        return id;
    }
    /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */ cancelVideoFrameCallback(id) {
        if (this.queuedHanders_.has(id)) this.queuedHanders_.delete(id);
        else this.cancelNamedAnimationFrame(id);
    }
    /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */ setPoster() {}
    /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */ playsinline() {}
    /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */ setPlaysinline() {}
    /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */ overrideNativeAudioTracks(override) {}
    /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */ overrideNativeVideoTracks(override) {}
    /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */ canPlayType(_type) {
        return "";
    }
    /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */ static canPlayType(_type) {
        return "";
    }
    /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */ static canPlaySource(srcObj, options) {
        return $cb03b711053a4297$var$Tech.canPlayType(srcObj.type);
    }
    /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */ static isTech(component) {
        return component.prototype instanceof $cb03b711053a4297$var$Tech || component instanceof $cb03b711053a4297$var$Tech || component === $cb03b711053a4297$var$Tech;
    }
    /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */ static registerTech(name, tech) {
        if (!$cb03b711053a4297$var$Tech.techs_) $cb03b711053a4297$var$Tech.techs_ = {};
        if (!$cb03b711053a4297$var$Tech.isTech(tech)) throw new Error(`Tech ${name} must be a Tech`);
        if (!$cb03b711053a4297$var$Tech.canPlayType) throw new Error("Techs must have a static canPlayType method on them");
        if (!$cb03b711053a4297$var$Tech.canPlaySource) throw new Error("Techs must have a static canPlaySource method on them");
        name = $cb03b711053a4297$var$toTitleCase$1(name);
        $cb03b711053a4297$var$Tech.techs_[name] = tech;
        $cb03b711053a4297$var$Tech.techs_[$cb03b711053a4297$var$toLowerCase(name)] = tech;
        if (name !== "Tech") // camel case the techName for use in techOrder
        $cb03b711053a4297$var$Tech.defaultTechOrder_.push(name);
        return tech;
    }
    /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */ static getTech(name) {
        if (!name) return;
        if ($cb03b711053a4297$var$Tech.techs_ && $cb03b711053a4297$var$Tech.techs_[name]) return $cb03b711053a4297$var$Tech.techs_[name];
        name = $cb03b711053a4297$var$toTitleCase$1(name);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))) && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).videojs && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).videojs[name]) {
            $cb03b711053a4297$var$log$1.warn(`The ${name} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).videojs[name];
        }
    }
}
/**
 * Get the {@link VideoTrackList}
 *
 * @returns {VideoTrackList}
 * @method Tech.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 *
 * @returns {AudioTrackList}
 * @method Tech.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.textTracks
 */ /**
 * Get the remote element {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.remoteTextTracks
 */ /**
 * Get the remote element {@link HtmlTrackElementList}
 *
 * @returns {HtmlTrackElementList}
 * @method Tech.prototype.remoteTextTrackEls
 */ $cb03b711053a4297$var$ALL.names.forEach(function(name) {
    const props = $cb03b711053a4297$var$ALL[name];
    $cb03b711053a4297$var$Tech.prototype[props.getterName] = function() {
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
/**
 * List of associated text tracks
 *
 * @type {TextTrackList}
 * @private
 * @property Tech#textTracks_
 */ /**
 * List of associated audio tracks.
 *
 * @type {AudioTrackList}
 * @private
 * @property Tech#audioTracks_
 */ /**
 * List of associated video tracks.
 *
 * @type {VideoTrackList}
 * @private
 * @property Tech#videoTracks_
 */ /**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresVolumeControl = true;
/**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresMuteControl = true;
/**
 * Boolean indicating whether the `Tech` supports fullscreen resize control.
 * Resizing plugins using request fullscreen reloads the plugin
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresFullscreenResize = false;
/**
 * Boolean indicating whether the `Tech` supports changing the speed at which the video
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresPlaybackRate = false;
/**
 * Boolean indicating whether the `Tech` supports the `progress` event.
 * This will be used to determine if {@link Tech#manualProgressOn} should be called.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresProgressEvents = false;
/**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
 * a new source.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresSourceset = false;
/**
 * Boolean indicating whether the `Tech` supports the `timeupdate` event.
 * This will be used to determine if {@link Tech#manualTimeUpdates} should be called.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresTimeupdateEvents = false;
/**
 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
 * This will help us integrate with native `TextTrack`s if the browser supports them.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresNativeTextTracks = false;
/**
 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Tech.prototype.featuresVideoFrameCallback = false;
/**
 * A functional mixin for techs that want to use the Source Handler pattern.
 * Source handlers are scripts for handling specific formats.
 * The source handler pattern is used for adaptive formats (HLS, DASH) that
 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
 * Example: `Tech.withSourceHandlers.call(MyTech);`
 *
 * @param {Tech} _Tech
 *        The tech to add source handler functions to.
 *
 * @mixes Tech~SourceHandlerAdditions
 */ $cb03b711053a4297$var$Tech.withSourceHandlers = function(_Tech) {
    /**
   * Register a source handler
   *
   * @param {Function} handler
   *        The source handler class
   *
   * @param {number} [index]
   *        Register it at the following index
   */ _Tech.registerSourceHandler = function(handler, index) {
        let handlers = _Tech.sourceHandlers;
        if (!handlers) handlers = _Tech.sourceHandlers = [];
        if (index === undefined) // add to the end of the list
        index = handlers.length;
        handlers.splice(index, 0, handler);
    };
    /**
   * Check if the tech can support the given type. Also checks the
   * Techs sourceHandlers.
   *
   * @param {string} type
   *         The mimetype to check.
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ _Tech.canPlayType = function(type) {
        const handlers = _Tech.sourceHandlers || [];
        let can;
        for(let i = 0; i < handlers.length; i++){
            can = handlers[i].canPlayType(type);
            if (can) return can;
        }
        return "";
    };
    /**
   * Returns the first source handler that supports the source.
   *
   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
   *
   * @param {SourceObject} source
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {SourceHandler|null}
   *          The first source handler that supports the source or null if
   *          no SourceHandler supports the source
   */ _Tech.selectSourceHandler = function(source, options) {
        const handlers = _Tech.sourceHandlers || [];
        let can;
        for(let i = 0; i < handlers.length; i++){
            can = handlers[i].canHandleSource(source, options);
            if (can) return handlers[i];
        }
        return null;
    };
    /**
   * Check if the tech can support the given source.
   *
   * @param {SourceObject} srcObj
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ _Tech.canPlaySource = function(srcObj, options) {
        const sh = _Tech.selectSourceHandler(srcObj, options);
        if (sh) return sh.canHandleSource(srcObj, options);
        return "";
    };
    /**
   * When using a source handler, prefer its implementation of
   * any function normally provided by the tech.
   */ const deferrable = [
        "seekable",
        "seeking",
        "duration"
    ];
    /**
   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
   * function if it exists, with a fallback to the Techs seekable function.
   *
   * @method _Tech.seekable
   */ /**
   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
   * function if it exists, otherwise it will fallback to the techs duration function.
   *
   * @method _Tech.duration
   */ deferrable.forEach(function(fnName) {
        const originalFn = this[fnName];
        if (typeof originalFn !== "function") return;
        this[fnName] = function() {
            if (this.sourceHandler_ && this.sourceHandler_[fnName]) return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
            return originalFn.apply(this, arguments);
        };
    }, _Tech.prototype);
    /**
   * Create a function for setting the source using a source object
   * and source handlers.
   * Should never be called unless a source handler was found.
   *
   * @param {SourceObject} source
   *        A source object with src and type keys
   */ _Tech.prototype.setSource = function(source) {
        let sh = _Tech.selectSourceHandler(source, this.options_);
        if (!sh) {
            // Fall back to a native source handler when unsupported sources are
            // deliberately set
            if (_Tech.nativeSourceHandler) sh = _Tech.nativeSourceHandler;
            else $cb03b711053a4297$var$log$1.error("No source handler found for the current source.");
        }
        // Dispose any existing source handler
        this.disposeSourceHandler();
        this.off("dispose", this.disposeSourceHandler_);
        if (sh !== _Tech.nativeSourceHandler) this.currentSource_ = source;
        this.sourceHandler_ = sh.handleSource(source, this, this.options_);
        this.one("dispose", this.disposeSourceHandler_);
    };
    /**
   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
   *
   * @listens Tech#dispose
   */ _Tech.prototype.disposeSourceHandler = function() {
        // if we have a source and get another one
        // then we are loading something new
        // than clear all of our current tracks
        if (this.currentSource_) {
            this.clearTracks([
                "audio",
                "video"
            ]);
            this.currentSource_ = null;
        }
        // always clean up auto-text tracks
        this.cleanupAutoTextTracks();
        if (this.sourceHandler_) {
            if (this.sourceHandler_.dispose) this.sourceHandler_.dispose();
            this.sourceHandler_ = null;
        }
    };
};
// The base Tech class needs to be registered as a Component. It is the only
// Tech that can be registered as a Component.
$cb03b711053a4297$var$Component$1.registerComponent("Tech", $cb03b711053a4297$var$Tech);
$cb03b711053a4297$var$Tech.registerTech("Tech", $cb03b711053a4297$var$Tech);
/**
 * A list of techs that should be added to techOrder on Players
 *
 * @private
 */ $cb03b711053a4297$var$Tech.defaultTechOrder_ = [];
/**
 * @file middleware.js
 * @module middleware
 */ const $cb03b711053a4297$var$middlewares = {};
const $cb03b711053a4297$var$middlewareInstances = {};
const $cb03b711053a4297$var$TERMINATOR = {};
/**
 * A middleware object is a plain JavaScript object that has methods that
 * match the {@link Tech} methods found in the lists of allowed
 * {@link module:middleware.allowedGetters|getters},
 * {@link module:middleware.allowedSetters|setters}, and
 * {@link module:middleware.allowedMediators|mediators}.
 *
 * @typedef {Object} MiddlewareObject
 */ /**
 * A middleware factory function that should return a
 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
 *
 * This factory will be called for each player when needed, with the player
 * passed in as an argument.
 *
 * @callback MiddlewareFactory
 * @param { import('../player').default } player
 *        A Video.js player.
 */ /**
 * Define a middleware that the player should use by way of a factory function
 * that returns a middleware object.
 *
 * @param  {string} type
 *         The MIME type to match or `"*"` for all MIME types.
 *
 * @param  {MiddlewareFactory} middleware
 *         A middleware factory function that will be executed for
 *         matching types.
 */ function $cb03b711053a4297$var$use(type, middleware) {
    $cb03b711053a4297$var$middlewares[type] = $cb03b711053a4297$var$middlewares[type] || [];
    $cb03b711053a4297$var$middlewares[type].push(middleware);
}
/**
 * Asynchronously sets a source using middleware by recursing through any
 * matching middlewares and calling `setSource` on each, passing along the
 * previous returned value each time.
 *
 * @param  { import('../player').default } player
 *         A {@link Player} instance.
 *
 * @param  {Tech~SourceObject} src
 *         A source object.
 *
 * @param  {Function}
 *         The next middleware to run.
 */ function $cb03b711053a4297$var$setSource(player, src, next) {
    player.setTimeout(()=>$cb03b711053a4297$var$setSourceHelper(src, $cb03b711053a4297$var$middlewares[src.type], next, player), 1);
}
/**
 * When the tech is set, passes the tech to each middleware's `setTech` method.
 *
 * @param {Object[]} middleware
 *        An array of middleware instances.
 *
 * @param { import('../tech/tech').default } tech
 *        A Video.js tech.
 */ function $cb03b711053a4297$var$setTech(middleware, tech) {
    middleware.forEach((mw)=>mw.setTech && mw.setTech(tech));
}
/**
 * Calls a getter on the tech first, through each middleware
 * from right to left to the player.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  { import('../tech/tech').default } tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @return {*}
 *         The final value from the tech after middleware has intercepted it.
 */ function $cb03b711053a4297$var$get(middleware, tech, method) {
    return middleware.reduceRight($cb03b711053a4297$var$middlewareIterator(method), tech[method]());
}
/**
 * Takes the argument given to the player and calls the setter method on each
 * middleware from left to right to the tech.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  { import('../tech/tech').default } tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {*} arg
 *         The value to set on the tech.
 *
 * @return {*}
 *         The return value of the `method` of the `tech`.
 */ function $cb03b711053a4297$var$set(middleware, tech, method, arg) {
    return tech[method](middleware.reduce($cb03b711053a4297$var$middlewareIterator(method), arg));
}
/**
 * Takes the argument given to the player and calls the `call` version of the
 * method on each middleware from left to right.
 *
 * Then, call the passed in method on the tech and return the result unchanged
 * back to the player, through middleware, this time from right to left.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  { import('../tech/tech').default } tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {*} arg
 *         The value to set on the tech.
 *
 * @return {*}
 *         The return value of the `method` of the `tech`, regardless of the
 *         return values of middlewares.
 */ function $cb03b711053a4297$var$mediate(middleware, tech, method, arg = null) {
    const callMethod = "call" + $cb03b711053a4297$var$toTitleCase$1(method);
    const middlewareValue = middleware.reduce($cb03b711053a4297$var$middlewareIterator(callMethod), arg);
    const terminated = middlewareValue === $cb03b711053a4297$var$TERMINATOR;
    // deprecated. The `null` return value should instead return TERMINATOR to
    // prevent confusion if a techs method actually returns null.
    const returnValue = terminated ? null : tech[method](middlewareValue);
    $cb03b711053a4297$var$executeRight(middleware, method, returnValue, terminated);
    return returnValue;
}
/**
 * Enumeration of allowed getters where the keys are method names.
 *
 * @type {Object}
 */ const $cb03b711053a4297$var$allowedGetters = {
    buffered: 1,
    currentTime: 1,
    duration: 1,
    muted: 1,
    played: 1,
    paused: 1,
    seekable: 1,
    volume: 1,
    ended: 1
};
/**
 * Enumeration of allowed setters where the keys are method names.
 *
 * @type {Object}
 */ const $cb03b711053a4297$var$allowedSetters = {
    setCurrentTime: 1,
    setMuted: 1,
    setVolume: 1
};
/**
 * Enumeration of allowed mediators where the keys are method names.
 *
 * @type {Object}
 */ const $cb03b711053a4297$var$allowedMediators = {
    play: 1,
    pause: 1
};
function $cb03b711053a4297$var$middlewareIterator(method) {
    return (value, mw)=>{
        // if the previous middleware terminated, pass along the termination
        if (value === $cb03b711053a4297$var$TERMINATOR) return $cb03b711053a4297$var$TERMINATOR;
        if (mw[method]) return mw[method](value);
        return value;
    };
}
function $cb03b711053a4297$var$executeRight(mws, method, value, terminated) {
    for(let i = mws.length - 1; i >= 0; i--){
        const mw = mws[i];
        if (mw[method]) mw[method](terminated, value);
    }
}
/**
 * Clear the middleware cache for a player.
 *
 * @param  { import('../player').default } player
 *         A {@link Player} instance.
 */ function $cb03b711053a4297$var$clearCacheForPlayer(player) {
    $cb03b711053a4297$var$middlewareInstances[player.id()] = null;
}
/**
 * {
 *  [playerId]: [[mwFactory, mwInstance], ...]
 * }
 *
 * @private
 */ function $cb03b711053a4297$var$getOrCreateFactory(player, mwFactory) {
    const mws = $cb03b711053a4297$var$middlewareInstances[player.id()];
    let mw = null;
    if (mws === undefined || mws === null) {
        mw = mwFactory(player);
        $cb03b711053a4297$var$middlewareInstances[player.id()] = [
            [
                mwFactory,
                mw
            ]
        ];
        return mw;
    }
    for(let i = 0; i < mws.length; i++){
        const [mwf, mwi] = mws[i];
        if (mwf !== mwFactory) continue;
        mw = mwi;
    }
    if (mw === null) {
        mw = mwFactory(player);
        mws.push([
            mwFactory,
            mw
        ]);
    }
    return mw;
}
function $cb03b711053a4297$var$setSourceHelper(src = {}, middleware = [], next, player, acc = [], lastRun = false) {
    const [mwFactory, ...mwrest] = middleware;
    // if mwFactory is a string, then we're at a fork in the road
    if (typeof mwFactory === "string") $cb03b711053a4297$var$setSourceHelper(src, $cb03b711053a4297$var$middlewares[mwFactory], next, player, acc, lastRun);
    else if (mwFactory) {
        const mw = $cb03b711053a4297$var$getOrCreateFactory(player, mwFactory);
        // if setSource isn't present, implicitly select this middleware
        if (!mw.setSource) {
            acc.push(mw);
            return $cb03b711053a4297$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
        }
        mw.setSource(Object.assign({}, src), function(err, _src) {
            // something happened, try the next middleware on the current level
            // make sure to use the old src
            if (err) return $cb03b711053a4297$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
            // we've succeeded, now we need to go deeper
            acc.push(mw);
            // if it's the same type, continue down the current chain
            // otherwise, we want to go down the new chain
            $cb03b711053a4297$var$setSourceHelper(_src, src.type === _src.type ? mwrest : $cb03b711053a4297$var$middlewares[_src.type], next, player, acc, lastRun);
        });
    } else if (mwrest.length) $cb03b711053a4297$var$setSourceHelper(src, mwrest, next, player, acc, lastRun);
    else if (lastRun) next(src, acc);
    else $cb03b711053a4297$var$setSourceHelper(src, $cb03b711053a4297$var$middlewares["*"], next, player, acc, true);
}
/**
 * Mimetypes
 *
 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
 * @typedef Mimetypes~Kind
 * @enum
 */ const $cb03b711053a4297$var$MimetypesKind = {
    opus: "video/ogg",
    ogv: "video/ogg",
    mp4: "video/mp4",
    mov: "video/mp4",
    m4v: "video/mp4",
    mkv: "video/x-matroska",
    m4a: "audio/mp4",
    mp3: "audio/mpeg",
    aac: "audio/aac",
    caf: "audio/x-caf",
    flac: "audio/flac",
    oga: "audio/ogg",
    wav: "audio/wav",
    m3u8: "application/x-mpegURL",
    mpd: "application/dash+xml",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    png: "image/png",
    svg: "image/svg+xml",
    webp: "image/webp"
};
/**
 * Get the mimetype of a given src url if possible
 *
 * @param {string} src
 *        The url to the src
 *
 * @return {string}
 *         return the mimetype if it was known or empty string otherwise
 */ const $cb03b711053a4297$var$getMimetype = function(src = "") {
    const ext = $cb03b711053a4297$var$getFileExtension(src);
    const mimetype = $cb03b711053a4297$var$MimetypesKind[ext.toLowerCase()];
    return mimetype || "";
};
/**
 * Find the mime type of a given source string if possible. Uses the player
 * source cache.
 *
 * @param { import('../player').default } player
 *        The player object
 *
 * @param {string} src
 *        The source string
 *
 * @return {string}
 *         The type that was found
 */ const $cb03b711053a4297$var$findMimetype = (player, src)=>{
    if (!src) return "";
    // 1. check for the type in the `source` cache
    if (player.cache_.source.src === src && player.cache_.source.type) return player.cache_.source.type;
    // 2. see if we have this source in our `currentSources` cache
    const matchingSources = player.cache_.sources.filter((s)=>s.src === src);
    if (matchingSources.length) return matchingSources[0].type;
    // 3. look for the src url in source elements and use the type there
    const sources = player.$$("source");
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        if (s.type && s.src && s.src === src) return s.type;
    }
    // 4. finally fallback to our list of mime types based on src url extension
    return $cb03b711053a4297$var$getMimetype(src);
};
/**
 * @module filter-source
 */ /**
 * Filter out single bad source objects or multiple source objects in an
 * array. Also flattens nested source object arrays into a 1 dimensional
 * array of source objects.
 *
 * @param {Tech~SourceObject|Tech~SourceObject[]} src
 *        The src object to filter
 *
 * @return {Tech~SourceObject[]}
 *         An array of sourceobjects containing only valid sources
 *
 * @private
 */ const $cb03b711053a4297$var$filterSource = function(src) {
    // traverse array
    if (Array.isArray(src)) {
        let newsrc = [];
        src.forEach(function(srcobj) {
            srcobj = $cb03b711053a4297$var$filterSource(srcobj);
            if (Array.isArray(srcobj)) newsrc = newsrc.concat(srcobj);
            else if ($cb03b711053a4297$var$isObject(srcobj)) newsrc.push(srcobj);
        });
        src = newsrc;
    } else if (typeof src === "string" && src.trim()) // convert string into object
    src = [
        $cb03b711053a4297$var$fixSource({
            src: src
        })
    ];
    else if ($cb03b711053a4297$var$isObject(src) && typeof src.src === "string" && src.src && src.src.trim()) // src is already valid
    src = [
        $cb03b711053a4297$var$fixSource(src)
    ];
    else // invalid source, turn it into an empty array
    src = [];
    return src;
};
/**
 * Checks src mimetype, adding it when possible
 *
 * @param {Tech~SourceObject} src
 *        The src object to check
 * @return {Tech~SourceObject}
 *        src Object with known type
 */ function $cb03b711053a4297$var$fixSource(src) {
    if (!src.type) {
        const mimetype = $cb03b711053a4297$var$getMimetype(src.src);
        if (mimetype) src.type = mimetype;
    }
    return src;
}
var $cb03b711053a4297$var$icons = '<svg xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-play">\n      <path d="M16 10v28l22-14z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-pause">\n      <path d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-audio">\n      <path d="M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-captions">\n      <path d="M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-subtitles">\n      <path d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-enter">\n      <path d="M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-exit">\n      <path d="M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-play-circle">\n      <path d="M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-mute">\n      <path d="M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-low">\n      <path d="M14 18v12h8l10 10V8L22 18h-8z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-medium">\n      <path d="M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-high">\n      <path d="M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-spinner">\n      <path d="M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z"></path>\n    </symbol>\n    <symbol viewBox="0 0 24 24" id="vjs-icon-hd">\n      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-chapters">\n      <path d="M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z"></path>\n    </symbol>\n    <symbol viewBox="0 0 40 40" id="vjs-icon-downloading">\n      <path d="M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download">\n      <path d="M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-done">\n      <path d="M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-off">\n      <path d="M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-share">\n      <path d="M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-cog">\n      <path d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-square">\n      <path d="M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-circle">\n      <circle cx="24" cy="24" r="20"></circle>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-outline">\n      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-inner-circle">\n      <path d="M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-cancel">\n      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-replay">\n      <path d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-repeat">\n      <path d="M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z"></path>\n    </symbol>\n    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-5">\n      <path d="M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z"></path>\n    </symbol>\n    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-10">\n      <path d="M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z"></path>\n    </symbol>\n    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-30">\n      <path d="M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z"></path>\n    </symbol>\n    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-5">\n      <path d="M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z"></path>\n    </symbol>\n    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-10">\n      <path d="M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z"></path>\n    </symbol>\n    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-30">\n      <path d="M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z"></path>\n    </symbol>\n    <symbol viewBox="0 0 512 512" id="vjs-icon-audio-description">\n      <g fill-rule="evenodd"><path d="M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57"></path><path d="M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z"></path></g>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-next-item">\n      <path d="M12 36l17-12-17-12v24zm20-24v24h4V12h-4z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-previous-item">\n      <path d="M12 12h4v24h-4zm7 12l17 12V12z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-shuffle">\n      <path d="M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-cast">\n      <path d="M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z"></path>\n    </symbol>\n    <symbol viewBox="0 0 48 48" id="vjs-icon-picture-in-picture-enter">\n      <path d="M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z"></path>\n    </symbol>\n    <symbol viewBox="0 0 22 18" id="vjs-icon-picture-in-picture-exit">\n      <path d="M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z"></path>\n      <path fill="none" d="M-1-3h24v24H-1z"></path>\n    </symbol>\n    <symbol viewBox="0 0 1792 1792" id="vjs-icon-facebook">\n      <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z"></path>\n    </symbol>\n    <symbol viewBox="0 0 1792 1792" id="vjs-icon-linkedin">\n      <path d="M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z"></path>\n    </symbol>\n    <symbol viewBox="0 0 1792 1792" id="vjs-icon-twitter">\n      <path d="M1684 408q-67 98-162 167 1 14 1 42 0 130-38 259.5T1369.5 1125 1185 1335.5t-258 146-323 54.5q-271 0-496-145 35 4 78 4 225 0 401-138-105-2-188-64.5T285 1033q33 5 61 5 43 0 85-11-112-23-185.5-111.5T172 710v-4q68 38 146 41-66-44-105-115t-39-154q0-88 44-163 121 149 294.5 238.5T884 653q-8-38-8-74 0-134 94.5-228.5T1199 256q140 0 236 102 109-21 205-78-37 115-142 178 93-10 186-50z"></path>\n    </symbol>\n    <symbol viewBox="0 0 1792 1792" id="vjs-icon-tumblr">\n      <path d="M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"></path>\n    </symbol>\n    <symbol viewBox="0 0 1792 1792" id="vjs-icon-pinterest">\n      <path d="M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z"></path>\n    </symbol>\n  </defs>\n</svg>';
/**
 * @file loader.js
 */ /**
 * The `MediaLoader` is the `Component` that decides which playback technology to load
 * when a player is initialized.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MediaLoader extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param { import('../player').default } player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */ constructor(player, options, ready){
        // MediaLoader has no element
        const options_ = $cb03b711053a4297$var$merge$1({
            createEl: false
        }, options);
        super(player, options_, ready);
        // If there are no sources when the player is initialized,
        // load the first supported playback technology.
        if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) for(let i = 0, j = options.playerOptions.techOrder; i < j.length; i++){
            const techName = $cb03b711053a4297$var$toTitleCase$1(j[i]);
            let tech = $cb03b711053a4297$var$Tech.getTech(techName);
            // Support old behavior of techs being registered as components.
            // Remove once that deprecated behavior is removed.
            if (!techName) tech = $cb03b711053a4297$var$Component$1.getComponent(techName);
            // Check if the browser supports this technology
            if (tech && tech.isSupported()) {
                player.loadTech_(techName);
                break;
            }
        }
        else // Loop through playback technologies (e.g. HTML5) and check for support.
        // Then load the best source.
        // A few assumptions here:
        //   All playback technologies respect preload false.
        player.src(options.playerOptions.sources);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("MediaLoader", $cb03b711053a4297$var$MediaLoader);
/**
 * @file clickable-component.js
 */ /**
 * Component which is clickable or keyboard actionable, but is not a
 * native HTML button.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ClickableComponent extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param  { import('./player').default } player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */ constructor(player, options){
        super(player, options);
        if (this.options_.controlText) this.controlText(this.options_.controlText);
        this.handleMouseOver_ = (e)=>this.handleMouseOver(e);
        this.handleMouseOut_ = (e)=>this.handleMouseOut(e);
        this.handleClick_ = (e)=>this.handleClick(e);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.emitTapEvents();
        this.enable();
    }
    /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tag = "div", props = {}, attributes = {}) {
        props = Object.assign({
            className: this.buildCSSClass(),
            tabIndex: 0
        }, props);
        if (tag === "button") $cb03b711053a4297$var$log$1.error(`Creating a ClickableComponent with an HTML element of ${tag} is not supported; use a Button instead.`);
        // Add ARIA attributes for clickable element which is not a native HTML button
        attributes = Object.assign({
            role: "button"
        }, attributes);
        this.tabIndex_ = props.tabIndex;
        const el = $cb03b711053a4297$var$createEl(tag, props, attributes);
        if (!this.player_.options_.experimentalSvgIcons) el.appendChild($cb03b711053a4297$var$createEl("span", {
            className: "vjs-icon-placeholder"
        }, {
            "aria-hidden": true
        }));
        this.createControlTextEl(el);
        return el;
    }
    dispose() {
        // remove controlTextEl_ on dispose
        this.controlTextEl_ = null;
        super.dispose();
    }
    /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */ createControlTextEl(el) {
        this.controlTextEl_ = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-control-text"
        }, {
            // let the screen reader user know that the text of the element may change
            "aria-live": "polite"
        });
        if (el) el.appendChild(this.controlTextEl_);
        this.controlText(this.controlText_, el);
        return this.controlTextEl_;
    }
    /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */ controlText(text, el = this.el()) {
        if (text === undefined) return this.controlText_ || "Need Text";
        const localizedText = this.localize(text);
        /** @protected */ this.controlText_ = text;
        $cb03b711053a4297$var$textContent(this.controlTextEl_, localizedText);
        if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) // Set title attribute if only an icon is shown
        el.setAttribute("title", localizedText);
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-control vjs-button ${super.buildCSSClass()}`;
    }
    /**
   * Enable this `ClickableComponent`
   */ enable() {
        if (!this.enabled_) {
            this.enabled_ = true;
            this.removeClass("vjs-disabled");
            this.el_.setAttribute("aria-disabled", "false");
            if (typeof this.tabIndex_ !== "undefined") this.el_.setAttribute("tabIndex", this.tabIndex_);
            this.on([
                "tap",
                "click"
            ], this.handleClick_);
            this.on("keydown", this.handleKeyDown_);
        }
    }
    /**
   * Disable this `ClickableComponent`
   */ disable() {
        this.enabled_ = false;
        this.addClass("vjs-disabled");
        this.el_.setAttribute("aria-disabled", "true");
        if (typeof this.tabIndex_ !== "undefined") this.el_.removeAttribute("tabIndex");
        this.off("mouseover", this.handleMouseOver_);
        this.off("mouseout", this.handleMouseOut_);
        this.off([
            "tap",
            "click"
        ], this.handleClick_);
        this.off("keydown", this.handleKeyDown_);
    }
    /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */ handleLanguagechange() {
        this.controlText(this.controlText_);
    }
    /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */ handleClick(event) {
        if (this.options_.clickHandler) this.options_.clickHandler.call(this, arguments);
    }
    /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Support Space or Enter key operation to fire a click event. Also,
        // prevent the event from propagating through the DOM and triggering
        // Player hotkeys.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Space") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Enter")) {
            event.preventDefault();
            event.stopPropagation();
            this.trigger("click");
        } else // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("ClickableComponent", $cb03b711053a4297$var$ClickableComponent);
/**
 * @file poster-image.js
 */ /**
 * A `ClickableComponent` that handles showing the poster image for the player.
 *
 * @extends ClickableComponent
 */ class $cb03b711053a4297$var$PosterImage extends $cb03b711053a4297$var$ClickableComponent {
    /**
   * Create an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update();
        this.update_ = (e)=>this.update(e);
        player.on("posterchange", this.update_);
    }
    /**
   * Clean up and dispose of the `PosterImage`.
   */ dispose() {
        this.player().off("posterchange", this.update_);
        super.dispose();
    }
    /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        // The el is an empty div to keep position in the DOM
        // A picture and img el will be inserted when a source is set
        return $cb03b711053a4297$var$createEl("div", {
            className: "vjs-poster"
        });
    }
    /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */ crossOrigin(value) {
        // `null` can be set to unset a value
        if (typeof value === "undefined") {
            if (this.$("img")) // If the poster's element exists, give its value
            return this.$("img").crossOrigin;
            else if (this.player_.tech_ && this.player_.tech_.isReady_) // If not but the tech is ready, query the tech
            return this.player_.crossOrigin();
            // Otherwise check options as the  poster is usually set before the state of crossorigin
            // can be retrieved by the getter
            return this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
        }
        if (value !== null && value !== "anonymous" && value !== "use-credentials") {
            this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
            return;
        }
        if (this.$("img")) this.$("img").crossOrigin = value;
        return;
    }
    /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */ update(event) {
        const url = this.player().poster();
        this.setSrc(url);
        // If there's no poster source we should display:none on this component
        // so it's not still clickable or right-clickable
        if (url) this.show();
        else this.hide();
    }
    /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */ setSrc(url) {
        if (!url) {
            this.el_.textContent = "";
            return;
        }
        if (!this.$("img")) this.el_.appendChild($cb03b711053a4297$var$createEl("picture", {
            className: "vjs-poster",
            // Don't want poster to be tabbable.
            tabIndex: -1
        }, {}, $cb03b711053a4297$var$createEl("img", {
            loading: "lazy",
            crossOrigin: this.crossOrigin()
        }, {
            alt: ""
        })));
        this.$("img").src = url;
    }
    /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */ handleClick(event) {
        // We don't want a click to trigger playback when controls are disabled
        if (!this.player_.controls()) return;
        if (this.player_.tech(true)) this.player_.tech(true).focus();
        if (this.player_.paused()) $cb03b711053a4297$var$silencePromise(this.player_.play());
        else this.player_.pause();
    }
}
/**
 * Get or set the `PosterImage`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<img>` tag to control the CORS
 * behavior.
 *
 * @param {string|null} [value]
 *        The value to set the `PosterImages`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|null|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */ $cb03b711053a4297$var$PosterImage.prototype.crossorigin = $cb03b711053a4297$var$PosterImage.prototype.crossOrigin;
$cb03b711053a4297$var$Component$1.registerComponent("PosterImage", $cb03b711053a4297$var$PosterImage);
/**
 * @file text-track-display.js
 */ const $cb03b711053a4297$var$darkGray = "#222";
const $cb03b711053a4297$var$lightGray = "#ccc";
const $cb03b711053a4297$var$fontMap = {
    monospace: "monospace",
    sansSerif: "sans-serif",
    serif: "serif",
    monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
    monospaceSerif: '"Courier New", monospace',
    proportionalSansSerif: "sans-serif",
    proportionalSerif: "serif",
    casual: '"Comic Sans MS", Impact, fantasy',
    script: '"Monotype Corsiva", cursive',
    smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
/**
 * Construct an rgba color from a given hex color code.
 *
 * @param {number} color
 *        Hex number for color, like #f0e or #f604e2.
 *
 * @param {number} opacity
 *        Value for opacity, 0.0 - 1.0.
 *
 * @return {string}
 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
 */ function $cb03b711053a4297$var$constructColor(color, opacity) {
    let hex;
    if (color.length === 4) // color looks like "#f0e"
    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
    else if (color.length === 7) // color looks like "#f604e2"
    hex = color.slice(1);
    else throw new Error("Invalid color code provided, " + color + "; must be formatted as e.g. #f0e or #f604e2.");
    return "rgba(" + parseInt(hex.slice(0, 2), 16) + "," + parseInt(hex.slice(2, 4), 16) + "," + parseInt(hex.slice(4, 6), 16) + "," + opacity + ")";
}
/**
 * Try to update the style of a DOM element. Some style changes will throw an error,
 * particularly in IE8. Those should be noops.
 *
 * @param {Element} el
 *        The DOM element to be styled.
 *
 * @param {string} style
 *        The CSS property on the element that should be styled.
 *
 * @param {string} rule
 *        The style rule that should be applied to the property.
 *
 * @private
 */ function $cb03b711053a4297$var$tryUpdateStyle(el, style, rule) {
    try {
        el.style[style] = rule;
    } catch (e) {
        // Satisfies linter.
        return;
    }
}
/**
 * Converts the CSS top/right/bottom/left property numeric value to string in pixels.
 *
 * @param {number} position
 *        The CSS top/right/bottom/left property value.
 *
 * @return {string}
 *          The CSS property value that was created, like '10px'.
 *
 * @private
 */ function $cb03b711053a4297$var$getCSSPositionValue(position) {
    return position ? `${position}px` : "";
}
/**
 * The component for displaying text track cues.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TextTrackDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        const updateDisplayTextHandler = (e)=>this.updateDisplay(e);
        const updateDisplayHandler = (e)=>{
            this.updateDisplayOverlay();
            this.updateDisplay(e);
        };
        player.on("loadstart", (e)=>this.toggleDisplay(e));
        player.on("texttrackchange", updateDisplayTextHandler);
        player.on("loadedmetadata", (e)=>{
            this.updateDisplayOverlay();
            this.preselectTrack(e);
        });
        // This used to be called during player init, but was causing an error
        // if a track should show by default and the display hadn't loaded yet.
        // Should probably be moved to an external track loader when we support
        // tracks that don't need a display.
        player.ready($cb03b711053a4297$var$bind_(this, function() {
            if (player.tech_ && player.tech_.featuresNativeTextTracks) {
                this.hide();
                return;
            }
            player.on("fullscreenchange", updateDisplayHandler);
            player.on("playerresize", updateDisplayHandler);
            const screenOrientation = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).screen.orientation || (0, (/*@__PURE__*/$parcel$interopDefault($eDick)));
            const changeOrientationEvent = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).screen.orientation ? "change" : "orientationchange";
            screenOrientation.addEventListener(changeOrientationEvent, updateDisplayHandler);
            player.on("dispose", ()=>screenOrientation.removeEventListener(changeOrientationEvent, updateDisplayHandler));
            const tracks = this.options_.playerOptions.tracks || [];
            for(let i = 0; i < tracks.length; i++)this.player_.addRemoteTextTrack(tracks[i], true);
            this.preselectTrack();
        }));
    }
    /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */ preselectTrack() {
        const modes = {
            captions: 1,
            subtitles: 1
        };
        const trackList = this.player_.textTracks();
        const userPref = this.player_.cache_.selectedLanguage;
        let firstDesc;
        let firstCaptions;
        let preferredTrack;
        for(let i = 0; i < trackList.length; i++){
            const track = trackList[i];
            if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
                // Always choose the track that matches both language and kind
                if (track.kind === userPref.kind) preferredTrack = track;
                else if (!preferredTrack) preferredTrack = track;
            // clear everything if offTextTrackMenuItem was clicked
            } else if (userPref && !userPref.enabled) {
                preferredTrack = null;
                firstDesc = null;
                firstCaptions = null;
            } else if (track.default) {
                if (track.kind === "descriptions" && !firstDesc) firstDesc = track;
                else if (track.kind in modes && !firstCaptions) firstCaptions = track;
            }
        }
        // The preferredTrack matches the user preference and takes
        // precedence over all the other tracks.
        // So, display the preferredTrack before the first default track
        // and the subtitles/captions track before the descriptions track
        if (preferredTrack) preferredTrack.mode = "showing";
        else if (firstCaptions) firstCaptions.mode = "showing";
        else if (firstDesc) firstDesc.mode = "showing";
    }
    /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */ toggleDisplay() {
        if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) this.hide();
        else this.show();
    }
    /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-text-track-display"
        }, {
            "translate": "yes",
            "aria-live": "off",
            "aria-atomic": "true"
        });
    }
    /**
   * Clear all displayed {@link TextTrack}s.
   */ clearDisplay() {
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT === "function") (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.processCues((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), [], this.el_);
    }
    /**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */ updateDisplay() {
        const tracks = this.player_.textTracks();
        const allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
        this.clearDisplay();
        if (allowMultipleShowingTracks) {
            const showingTracks = [];
            for(let i = 0; i < tracks.length; ++i){
                const track = tracks[i];
                if (track.mode !== "showing") continue;
                showingTracks.push(track);
            }
            this.updateForTrack(showingTracks);
            return;
        }
        //  Track display prioritization model: if multiple tracks are 'showing',
        //  display the first 'subtitles' or 'captions' track which is 'showing',
        //  otherwise display the first 'descriptions' track which is 'showing'
        let descriptionsTrack = null;
        let captionsSubtitlesTrack = null;
        let i = tracks.length;
        while(i--){
            const track = tracks[i];
            if (track.mode === "showing") {
                if (track.kind === "descriptions") descriptionsTrack = track;
                else captionsSubtitlesTrack = track;
            }
        }
        if (captionsSubtitlesTrack) {
            if (this.getAttribute("aria-live") !== "off") this.setAttribute("aria-live", "off");
            this.updateForTrack(captionsSubtitlesTrack);
        } else if (descriptionsTrack) {
            if (this.getAttribute("aria-live") !== "assertive") this.setAttribute("aria-live", "assertive");
            this.updateForTrack(descriptionsTrack);
        }
    }
    /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */ updateDisplayOverlay() {
        // inset-inline and inset-block are not supprted on old chrome, but these are
        // only likely to be used on TV devices
        if (!this.player_.videoHeight() || !(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).CSS.supports("inset-inline: 10px")) return;
        const playerWidth = this.player_.currentWidth();
        const playerHeight = this.player_.currentHeight();
        const playerAspectRatio = playerWidth / playerHeight;
        const videoAspectRatio = this.player_.videoWidth() / this.player_.videoHeight();
        let insetInlineMatch = 0;
        let insetBlockMatch = 0;
        if (Math.abs(playerAspectRatio - videoAspectRatio) > 0.1) {
            if (playerAspectRatio > videoAspectRatio) insetInlineMatch = Math.round((playerWidth - playerHeight * videoAspectRatio) / 2);
            else insetBlockMatch = Math.round((playerHeight - playerWidth / videoAspectRatio) / 2);
        }
        $cb03b711053a4297$var$tryUpdateStyle(this.el_, "insetInline", $cb03b711053a4297$var$getCSSPositionValue(insetInlineMatch));
        $cb03b711053a4297$var$tryUpdateStyle(this.el_, "insetBlock", $cb03b711053a4297$var$getCSSPositionValue(insetBlockMatch));
    }
    /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */ updateDisplayState(track) {
        const overrides = this.player_.textTrackSettings.getValues();
        const cues = track.activeCues;
        let i = cues.length;
        while(i--){
            const cue = cues[i];
            if (!cue) continue;
            const cueDiv = cue.displayState;
            if (overrides.color) cueDiv.firstChild.style.color = overrides.color;
            if (overrides.textOpacity) $cb03b711053a4297$var$tryUpdateStyle(cueDiv.firstChild, "color", $cb03b711053a4297$var$constructColor(overrides.color || "#fff", overrides.textOpacity));
            if (overrides.backgroundColor) cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
            if (overrides.backgroundOpacity) $cb03b711053a4297$var$tryUpdateStyle(cueDiv.firstChild, "backgroundColor", $cb03b711053a4297$var$constructColor(overrides.backgroundColor || "#000", overrides.backgroundOpacity));
            if (overrides.windowColor) {
                if (overrides.windowOpacity) $cb03b711053a4297$var$tryUpdateStyle(cueDiv, "backgroundColor", $cb03b711053a4297$var$constructColor(overrides.windowColor, overrides.windowOpacity));
                else cueDiv.style.backgroundColor = overrides.windowColor;
            }
            if (overrides.edgeStyle) {
                if (overrides.edgeStyle === "dropshadow") cueDiv.firstChild.style.textShadow = `2px 2px 3px ${$cb03b711053a4297$var$darkGray}, 2px 2px 4px ${$cb03b711053a4297$var$darkGray}, 2px 2px 5px ${$cb03b711053a4297$var$darkGray}`;
                else if (overrides.edgeStyle === "raised") cueDiv.firstChild.style.textShadow = `1px 1px ${$cb03b711053a4297$var$darkGray}, 2px 2px ${$cb03b711053a4297$var$darkGray}, 3px 3px ${$cb03b711053a4297$var$darkGray}`;
                else if (overrides.edgeStyle === "depressed") cueDiv.firstChild.style.textShadow = `1px 1px ${$cb03b711053a4297$var$lightGray}, 0 1px ${$cb03b711053a4297$var$lightGray}, -1px -1px ${$cb03b711053a4297$var$darkGray}, 0 -1px ${$cb03b711053a4297$var$darkGray}`;
                else if (overrides.edgeStyle === "uniform") cueDiv.firstChild.style.textShadow = `0 0 4px ${$cb03b711053a4297$var$darkGray}, 0 0 4px ${$cb03b711053a4297$var$darkGray}, 0 0 4px ${$cb03b711053a4297$var$darkGray}, 0 0 4px ${$cb03b711053a4297$var$darkGray}`;
            }
            if (overrides.fontPercent && overrides.fontPercent !== 1) {
                const fontSize = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).parseFloat(cueDiv.style.fontSize);
                cueDiv.style.fontSize = fontSize * overrides.fontPercent + "px";
                cueDiv.style.height = "auto";
                cueDiv.style.top = "auto";
            }
            if (overrides.fontFamily && overrides.fontFamily !== "default") {
                if (overrides.fontFamily === "small-caps") cueDiv.firstChild.style.fontVariant = "small-caps";
                else cueDiv.firstChild.style.fontFamily = $cb03b711053a4297$var$fontMap[overrides.fontFamily];
            }
        }
    }
    /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */ updateForTrack(tracks) {
        if (!Array.isArray(tracks)) tracks = [
            tracks
        ];
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== "function" || tracks.every((track)=>{
            return !track.activeCues;
        })) return;
        const cues = [];
        // push all active track cues
        for(let i = 0; i < tracks.length; ++i){
            const track = tracks[i];
            for(let j = 0; j < track.activeCues.length; ++j)cues.push(track.activeCues[j]);
        }
        // removes all cues before it processes new ones
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.processCues((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), cues, this.el_);
        // add unique class to each language text track & add settings styling if necessary
        for(let i = 0; i < tracks.length; ++i){
            const track = tracks[i];
            for(let j = 0; j < track.activeCues.length; ++j){
                const cueEl = track.activeCues[j].displayState;
                $cb03b711053a4297$var$addClass(cueEl, "vjs-text-track-cue", "vjs-text-track-cue-" + (track.language ? track.language : i));
                if (track.language) $cb03b711053a4297$var$setAttribute(cueEl, "lang", track.language);
            }
            if (this.player_.textTrackSettings) this.updateDisplayState(track);
        }
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TextTrackDisplay", $cb03b711053a4297$var$TextTrackDisplay);
/**
 * @file loading-spinner.js
 */ /**
 * A loading spinner for use during waiting/loading events.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$LoadingSpinner extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */ createEl() {
        const isAudio = this.player_.isAudio();
        const playerType = this.localize(isAudio ? "Audio Player" : "Video Player");
        const controlText = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-control-text",
            textContent: this.localize("{1} is loading.", [
                playerType
            ])
        });
        const el = super.createEl("div", {
            className: "vjs-loading-spinner",
            dir: "ltr"
        });
        el.appendChild(controlText);
        return el;
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [
            this.player_.isAudio() ? "Audio Player" : "Video Player"
        ]);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("LoadingSpinner", $cb03b711053a4297$var$LoadingSpinner);
/**
 * @file button.js
 */ /**
 * Base class for all buttons.
 *
 * @extends ClickableComponent
 */ class $cb03b711053a4297$var$Button extends $cb03b711053a4297$var$ClickableComponent {
    /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(tag, props = {}, attributes = {}) {
        tag = "button";
        props = Object.assign({
            className: this.buildCSSClass()
        }, props);
        // Add attributes for button element
        attributes = Object.assign({
            // Necessary since the default button type is "submit"
            type: "button"
        }, attributes);
        const el = $cb03b711053a4297$var$createEl(tag, props, attributes);
        if (!this.player_.options_.experimentalSvgIcons) el.appendChild($cb03b711053a4297$var$createEl("span", {
            className: "vjs-icon-placeholder"
        }, {
            "aria-hidden": true
        }));
        this.createControlTextEl(el);
        return el;
    }
    /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */ addChild(child, options = {}) {
        const className = this.constructor.name;
        $cb03b711053a4297$var$log$1.warn(`Adding an actionable (user controllable) child to a Button (${className}) is not supported; use a ClickableComponent instead.`);
        // Avoid the error message generated by ClickableComponent's addChild method
        return $cb03b711053a4297$var$Component$1.prototype.addChild.call(this, child, options);
    }
    /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */ enable() {
        super.enable();
        this.el_.removeAttribute("disabled");
    }
    /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */ disable() {
        super.disable();
        this.el_.setAttribute("disabled", "disabled");
    }
    /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Ignore Space or Enter key operation, which is handled by the browser for
        // a button - though not for its super class, ClickableComponent. Also,
        // prevent the event from propagating through the DOM and triggering Player
        // hotkeys. We do not preventDefault here because we _want_ the browser to
        // handle it.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Space") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Enter")) {
            event.stopPropagation();
            return;
        }
        // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("Button", $cb03b711053a4297$var$Button);
/**
 * @file big-play-button.js
 */ /**
 * The initial play button that shows before the video has played. The hiding of the
 * `BigPlayButton` get done via CSS and `Player` states.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$BigPlayButton extends $cb03b711053a4297$var$Button {
    constructor(player, options){
        super(player, options);
        this.mouseused_ = false;
        this.setIcon("play");
        this.on("mousedown", (e)=>this.handleMouseDown(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */ buildCSSClass() {
        return "vjs-big-play-button";
    }
    /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const playPromise = this.player_.play();
        // exit early if clicked via the mouse
        if (this.mouseused_ && "clientX" in event && "clientY" in event) {
            $cb03b711053a4297$var$silencePromise(playPromise);
            if (this.player_.tech(true)) this.player_.tech(true).focus();
            return;
        }
        const cb = this.player_.getChild("controlBar");
        const playToggle = cb && cb.getChild("playToggle");
        if (!playToggle) {
            this.player_.tech(true).focus();
            return;
        }
        const playFocus = ()=>playToggle.focus();
        if ($cb03b711053a4297$var$isPromise(playPromise)) playPromise.then(playFocus, ()=>{});
        else this.setTimeout(playFocus, 1);
    }
    /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        this.mouseused_ = false;
        super.handleKeyDown(event);
    }
    /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        this.mouseused_ = true;
    }
}
/**
 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$BigPlayButton.prototype.controlText_ = "Play Video";
$cb03b711053a4297$var$Component$1.registerComponent("BigPlayButton", $cb03b711053a4297$var$BigPlayButton);
/**
 * @file close-button.js
 */ /**
 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
 * it gets clicked.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$CloseButton extends $cb03b711053a4297$var$Button {
    /**
  * Creates an instance of the this class.
  *
  * @param  { import('./player').default } player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */ constructor(player, options){
        super(player, options);
        this.setIcon("cancel");
        this.controlText(options && options.controlText || this.localize("Close"));
    }
    /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */ buildCSSClass() {
        return `vjs-close-button ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */ handleClick(event) {
        /**
     * Triggered when the a `CloseButton` is clicked.
     *
     * @event CloseButton#close
     * @type {Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the close event does not
     *           bubble up to parents if there is no listener
     */ this.trigger({
            type: "close",
            bubbles: false
        });
    }
    /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Esc button will trigger `click` event
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Esc")) {
            event.preventDefault();
            event.stopPropagation();
            this.trigger("click");
        } else // Pass keypress handling up for unsupported keys
        super.handleKeyDown(event);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("CloseButton", $cb03b711053a4297$var$CloseButton);
/**
 * @file play-toggle.js
 */ /**
 * Button to toggle between play and pause.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$PlayToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        super(player, options);
        // show or hide replay icon
        options.replay = options.replay === undefined || options.replay;
        this.setIcon("play");
        this.on(player, "play", (e)=>this.handlePlay(e));
        this.on(player, "pause", (e)=>this.handlePause(e));
        if (options.replay) this.on(player, "ended", (e)=>this.handleEnded(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-play-control ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (this.player_.paused()) $cb03b711053a4297$var$silencePromise(this.player_.play());
        else this.player_.pause();
    }
    /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */ handleSeeked(event) {
        this.removeClass("vjs-ended");
        if (this.player_.paused()) this.handlePause(event);
        else this.handlePlay(event);
    }
    /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */ handlePlay(event) {
        this.removeClass("vjs-ended", "vjs-paused");
        this.addClass("vjs-playing");
        // change the button text to "Pause"
        this.setIcon("pause");
        this.controlText("Pause");
    }
    /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */ handlePause(event) {
        this.removeClass("vjs-playing");
        this.addClass("vjs-paused");
        // change the button text to "Play"
        this.setIcon("play");
        this.controlText("Play");
    }
    /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */ handleEnded(event) {
        this.removeClass("vjs-playing");
        this.addClass("vjs-ended");
        // change the button text to "Replay"
        this.setIcon("replay");
        this.controlText("Replay");
        // on the next seek remove the replay button
        this.one(this.player_, "seeked", (e)=>this.handleSeeked(e));
    }
}
/**
 * The text that should display over the `PlayToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$PlayToggle.prototype.controlText_ = "Play";
$cb03b711053a4297$var$Component$1.registerComponent("PlayToggle", $cb03b711053a4297$var$PlayToggle);
/**
 * @file time-display.js
 */ /**
 * Displays time information about the video
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TimeDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, [
            "timeupdate",
            "ended"
        ], (e)=>this.updateContent(e));
        this.updateTextNode_();
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const className = this.buildCSSClass();
        const el = super.createEl("div", {
            className: `${className} vjs-time-control vjs-control`
        });
        const span = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-control-text",
            textContent: `${this.localize(this.labelText_)}\u00a0`
        }, {
            role: "presentation"
        });
        el.appendChild(span);
        this.contentEl_ = $cb03b711053a4297$var$createEl("span", {
            className: `${className}-display`
        }, {
            // span elements have no implicit role, but some screen readers (notably VoiceOver)
            // treat them as a break between items in the DOM when using arrow keys
            // (or left-to-right swipes on iOS) to read contents of a page. Using
            // role='presentation' causes VoiceOver to NOT treat this span as a break.
            role: "presentation"
        });
        el.appendChild(this.contentEl_);
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        this.textNode_ = null;
        super.dispose();
    }
    /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */ updateTextNode_(time = 0) {
        time = $cb03b711053a4297$var$formatTime(time);
        if (this.formattedTime_ === time) return;
        this.formattedTime_ = time;
        this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", ()=>{
            if (!this.contentEl_) return;
            let oldNode = this.textNode_;
            if (oldNode && this.contentEl_.firstChild !== oldNode) {
                oldNode = null;
                $cb03b711053a4297$var$log$1.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.");
            }
            this.textNode_ = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(this.formattedTime_);
            if (!this.textNode_) return;
            if (oldNode) this.contentEl_.replaceChild(this.textNode_, oldNode);
            else this.contentEl_.appendChild(this.textNode_);
        });
    }
    /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */ updateContent(event) {}
}
/**
 * The text that is added to the `TimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$TimeDisplay.prototype.labelText_ = "Time";
/**
 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$TimeDisplay.prototype.controlText_ = "Time";
$cb03b711053a4297$var$Component$1.registerComponent("TimeDisplay", $cb03b711053a4297$var$TimeDisplay);
/**
 * @file current-time-display.js
 */ /**
 * Displays the current time
 *
 * @extends Component
 */ class $cb03b711053a4297$var$CurrentTimeDisplay extends $cb03b711053a4297$var$TimeDisplay {
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return "vjs-current-time";
    }
    /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */ updateContent(event) {
        // Allows for smooth scrubbing, when player can't keep up.
        let time;
        if (this.player_.ended()) time = this.player_.duration();
        else time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
        this.updateTextNode_(time);
    }
}
/**
 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$CurrentTimeDisplay.prototype.labelText_ = "Current Time";
/**
 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$CurrentTimeDisplay.prototype.controlText_ = "Current Time";
$cb03b711053a4297$var$Component$1.registerComponent("CurrentTimeDisplay", $cb03b711053a4297$var$CurrentTimeDisplay);
/**
 * @file duration-display.js
 */ /**
 * Displays the duration
 *
 * @extends Component
 */ class $cb03b711053a4297$var$DurationDisplay extends $cb03b711053a4297$var$TimeDisplay {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        const updateContent = (e)=>this.updateContent(e);
        // we do not want to/need to throttle duration changes,
        // as they should always display the changed duration as
        // it has changed
        this.on(player, "durationchange", updateContent);
        // Listen to loadstart because the player duration is reset when a new media element is loaded,
        // but the durationchange on the user agent will not fire.
        // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
        this.on(player, "loadstart", updateContent);
        // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
        // listeners could have broken dependent applications/libraries. These
        // can likely be removed for 7.0.
        this.on(player, "loadedmetadata", updateContent);
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return "vjs-duration";
    }
    /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */ updateContent(event) {
        const duration = this.player_.duration();
        this.updateTextNode_(duration);
    }
}
/**
 * The text that is added to the `DurationDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$DurationDisplay.prototype.labelText_ = "Duration";
/**
 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$DurationDisplay.prototype.controlText_ = "Duration";
$cb03b711053a4297$var$Component$1.registerComponent("DurationDisplay", $cb03b711053a4297$var$DurationDisplay);
/**
 * @file time-divider.js
 */ /**
 * The separator between the current time and duration.
 * Can be hidden if it's not needed in the design.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TimeDivider extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl("div", {
            className: "vjs-time-control vjs-time-divider"
        }, {
            // this element and its contents can be hidden from assistive techs since
            // it is made extraneous by the announcement of the control text
            // for the current time and duration displays
            "aria-hidden": true
        });
        const div = super.createEl("div");
        const span = super.createEl("span", {
            textContent: "/"
        });
        div.appendChild(span);
        el.appendChild(div);
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TimeDivider", $cb03b711053a4297$var$TimeDivider);
/**
 * @file remaining-time-display.js
 */ /**
 * Displays the time left in the video
 *
 * @extends Component
 */ class $cb03b711053a4297$var$RemainingTimeDisplay extends $cb03b711053a4297$var$TimeDisplay {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, "durationchange", (e)=>this.updateContent(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return "vjs-remaining-time";
    }
    /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl();
        if (this.options_.displayNegative !== false) el.insertBefore($cb03b711053a4297$var$createEl("span", {}, {
            "aria-hidden": true
        }, "-"), this.contentEl_);
        return el;
    }
    /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */ updateContent(event) {
        if (typeof this.player_.duration() !== "number") return;
        let time;
        // @deprecated We should only use remainingTimeDisplay
        // as of video.js 7
        if (this.player_.ended()) time = 0;
        else if (this.player_.remainingTimeDisplay) time = this.player_.remainingTimeDisplay();
        else time = this.player_.remainingTime();
        this.updateTextNode_(time);
    }
}
/**
 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$RemainingTimeDisplay.prototype.labelText_ = "Remaining Time";
/**
 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @protected
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */ $cb03b711053a4297$var$RemainingTimeDisplay.prototype.controlText_ = "Remaining Time";
$cb03b711053a4297$var$Component$1.registerComponent("RemainingTimeDisplay", $cb03b711053a4297$var$RemainingTimeDisplay);
/**
 * @file live-display.js
 */ // TODO - Future make it click to snap to live
/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$LiveDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.updateShowing();
        this.on(this.player(), "durationchange", (e)=>this.updateShowing(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl("div", {
            className: "vjs-live-control vjs-control"
        });
        this.contentEl_ = $cb03b711053a4297$var$createEl("div", {
            className: "vjs-live-display"
        }, {
            "aria-live": "off"
        });
        this.contentEl_.appendChild($cb03b711053a4297$var$createEl("span", {
            className: "vjs-control-text",
            textContent: `${this.localize("Stream Type")}\u00a0`
        }));
        this.contentEl_.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(this.localize("LIVE")));
        el.appendChild(this.contentEl_);
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        super.dispose();
    }
    /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */ updateShowing(event) {
        if (this.player().duration() === Infinity) this.show();
        else this.hide();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("LiveDisplay", $cb03b711053a4297$var$LiveDisplay);
/**
 * @file seek-to-live.js
 */ /**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$SeekToLive extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.updateLiveEdgeStatus();
        if (this.player_.liveTracker) {
            this.updateLiveEdgeStatusHandler_ = (e)=>this.updateLiveEdgeStatus(e);
            this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_);
        }
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl("button", {
            className: "vjs-seek-to-live-control vjs-control"
        });
        this.setIcon("circle", el);
        this.textEl_ = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-seek-to-live-text",
            textContent: this.localize("LIVE")
        }, {
            "aria-hidden": "true"
        });
        el.appendChild(this.textEl_);
        return el;
    }
    /**
   * Update the state of this button if we are at the live edge
   * or not
   */ updateLiveEdgeStatus() {
        // default to live edge
        if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
            this.setAttribute("aria-disabled", true);
            this.addClass("vjs-at-live-edge");
            this.controlText("Seek to live, currently playing live");
        } else {
            this.setAttribute("aria-disabled", false);
            this.removeClass("vjs-at-live-edge");
            this.controlText("Seek to live, currently behind live");
        }
    }
    /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */ handleClick() {
        this.player_.liveTracker.seekToLiveEdge();
    }
    /**
   * Dispose of the element and stop tracking
   */ dispose() {
        if (this.player_.liveTracker) this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_);
        this.textEl_ = null;
        super.dispose();
    }
}
/**
 * The text that should display over the `SeekToLive`s control. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$SeekToLive.prototype.controlText_ = "Seek to live, currently playing live";
$cb03b711053a4297$var$Component$1.registerComponent("SeekToLive", $cb03b711053a4297$var$SeekToLive);
/**
 * @file num.js
 * @module num
 */ /**
 * Keep a number between a min and a max value
 *
 * @param {number} number
 *        The number to clamp
 *
 * @param {number} min
 *        The minimum value
 * @param {number} max
 *        The maximum value
 *
 * @return {number}
 *         the clamped number
 */ function $cb03b711053a4297$var$clamp(number, min, max) {
    number = Number(number);
    return Math.min(max, Math.max(min, isNaN(number) ? min : number));
}
var $cb03b711053a4297$var$Num = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    clamp: $cb03b711053a4297$var$clamp
});
/**
 * @file slider.js
 */ /**
 * The base functionality for a slider. Can be vertical or horizontal.
 * For instance the volume bar or the seek bar on a video is a slider.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Slider extends $cb03b711053a4297$var$Component$1 {
    /**
  * Create an instance of this class
  *
  * @param { import('../player').default } player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */ constructor(player, options){
        super(player, options);
        this.handleMouseDown_ = (e)=>this.handleMouseDown(e);
        this.handleMouseUp_ = (e)=>this.handleMouseUp(e);
        this.handleKeyDown_ = (e)=>this.handleKeyDown(e);
        this.handleClick_ = (e)=>this.handleClick(e);
        this.handleMouseMove_ = (e)=>this.handleMouseMove(e);
        this.update_ = (e)=>this.update(e);
        // Set property names to bar to match with the child Slider class is looking for
        this.bar = this.getChild(this.options_.barName);
        // Set a horizontal or vertical class on the slider depending on the slider type
        this.vertical(!!this.options_.vertical);
        this.enable();
    }
    /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */ enabled() {
        return this.enabled_;
    }
    /**
   * Enable controls for this slider if they are disabled
   */ enable() {
        if (this.enabled()) return;
        this.on("mousedown", this.handleMouseDown_);
        this.on("touchstart", this.handleMouseDown_);
        this.on("keydown", this.handleKeyDown_);
        this.on("click", this.handleClick_);
        // TODO: deprecated, controlsvisible does not seem to be fired
        this.on(this.player_, "controlsvisible", this.update);
        if (this.playerEvent) this.on(this.player_, this.playerEvent, this.update);
        this.removeClass("disabled");
        this.setAttribute("tabindex", 0);
        this.enabled_ = true;
    }
    /**
   * Disable controls for this slider if they are enabled
   */ disable() {
        if (!this.enabled()) return;
        const doc = this.bar.el_.ownerDocument;
        this.off("mousedown", this.handleMouseDown_);
        this.off("touchstart", this.handleMouseDown_);
        this.off("keydown", this.handleKeyDown_);
        this.off("click", this.handleClick_);
        this.off(this.player_, "controlsvisible", this.update_);
        this.off(doc, "mousemove", this.handleMouseMove_);
        this.off(doc, "mouseup", this.handleMouseUp_);
        this.off(doc, "touchmove", this.handleMouseMove_);
        this.off(doc, "touchend", this.handleMouseUp_);
        this.removeAttribute("tabindex");
        this.addClass("disabled");
        if (this.playerEvent) this.off(this.player_, this.playerEvent, this.update);
        this.enabled_ = false;
    }
    /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(type, props = {}, attributes = {}) {
        // Add the slider element class to all sub classes
        props.className = props.className + " vjs-slider";
        props = Object.assign({
            tabIndex: 0
        }, props);
        attributes = Object.assign({
            "role": "slider",
            "aria-valuenow": 0,
            "aria-valuemin": 0,
            "aria-valuemax": 100
        }, attributes);
        return super.createEl(type, props, attributes);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */ handleMouseDown(event) {
        const doc = this.bar.el_.ownerDocument;
        if (event.type === "mousedown") event.preventDefault();
        // Do not call preventDefault() on touchstart in Chrome
        // to avoid console warnings. Use a 'touch-action: none' style
        // instead to prevent unintended scrolling.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        if (event.type === "touchstart" && !$cb03b711053a4297$var$IS_CHROME) event.preventDefault();
        $cb03b711053a4297$var$blockTextSelection();
        this.addClass("vjs-sliding");
        /**
     * Triggered when the slider is in an active state
     *
     * @event Slider#slideractive
     * @type {MouseEvent}
     */ this.trigger("slideractive");
        this.on(doc, "mousemove", this.handleMouseMove_);
        this.on(doc, "mouseup", this.handleMouseUp_);
        this.on(doc, "touchmove", this.handleMouseMove_);
        this.on(doc, "touchend", this.handleMouseUp_);
        this.handleMouseMove(event, true);
    }
    /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */ handleMouseMove(event) {}
    /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */ handleMouseUp(event) {
        const doc = this.bar.el_.ownerDocument;
        $cb03b711053a4297$var$unblockTextSelection();
        this.removeClass("vjs-sliding");
        /**
     * Triggered when the slider is no longer in an active state.
     *
     * @event Slider#sliderinactive
     * @type {Event}
     */ this.trigger("sliderinactive");
        this.off(doc, "mousemove", this.handleMouseMove_);
        this.off(doc, "mouseup", this.handleMouseUp_);
        this.off(doc, "touchmove", this.handleMouseMove_);
        this.off(doc, "touchend", this.handleMouseUp_);
        this.update();
    }
    /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */ update() {
        // In VolumeBar init we have a setTimeout for update that pops and update
        // to the end of the execution stack. The player is destroyed before then
        // update will cause an error
        // If there's no bar...
        if (!this.el_ || !this.bar) return;
        // clamp progress between 0 and 1
        // and only round to four decimal places, as we round to two below
        const progress = this.getProgress();
        if (progress === this.progress_) return progress;
        this.progress_ = progress;
        this.requestNamedAnimationFrame("Slider#update", ()=>{
            // Set the new bar width or height
            const sizeKey = this.vertical() ? "height" : "width";
            // Convert to a percentage for css value
            this.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + "%";
        });
        return progress;
    }
    /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */ getProgress() {
        return Number($cb03b711053a4297$var$clamp(this.getPercent(), 0, 1).toFixed(4));
    }
    /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */ calculateDistance(event) {
        const position = $cb03b711053a4297$var$getPointerPosition(this.el_, event);
        if (this.vertical()) return position.y;
        return position.x;
    }
    /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Left and Down Arrows
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Left") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Down")) {
            event.preventDefault();
            event.stopPropagation();
            this.stepBack();
        // Up and Right Arrows
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Right") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Up")) {
            event.preventDefault();
            event.stopPropagation();
            this.stepForward();
        } else // Pass keydown handling up for unsupported keys
        super.handleKeyDown(event);
    }
    /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */ handleClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */ vertical(bool) {
        if (bool === undefined) return this.vertical_ || false;
        this.vertical_ = !!bool;
        if (this.vertical_) this.addClass("vjs-slider-vertical");
        else this.addClass("vjs-slider-horizontal");
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("Slider", $cb03b711053a4297$var$Slider);
/**
 * @file load-progress-bar.js
 */ // get the percent width of a time compared to the total end
const $cb03b711053a4297$var$percentify = (time, end)=>$cb03b711053a4297$var$clamp(time / end * 100, 0, 100).toFixed(2) + "%";
/**
 * Shows loading progress
 *
 * @extends Component
 */ class $cb03b711053a4297$var$LoadProgressBar extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.partEls_ = [];
        this.on(player, "progress", (e)=>this.update(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl("div", {
            className: "vjs-load-progress"
        });
        const wrapper = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-control-text"
        });
        const loadedText = $cb03b711053a4297$var$createEl("span", {
            textContent: this.localize("Loaded")
        });
        const separator = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createTextNode(": ");
        this.percentageEl_ = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-control-text-loaded-percentage",
            textContent: "0%"
        });
        el.appendChild(wrapper);
        wrapper.appendChild(loadedText);
        wrapper.appendChild(separator);
        wrapper.appendChild(this.percentageEl_);
        return el;
    }
    dispose() {
        this.partEls_ = null;
        this.percentageEl_ = null;
        super.dispose();
    }
    /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */ update(event) {
        this.requestNamedAnimationFrame("LoadProgressBar#update", ()=>{
            const liveTracker = this.player_.liveTracker;
            const buffered = this.player_.buffered();
            const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
            const bufferedEnd = this.player_.bufferedEnd();
            const children = this.partEls_;
            const percent = $cb03b711053a4297$var$percentify(bufferedEnd, duration);
            if (this.percent_ !== percent) {
                // update the width of the progress bar
                this.el_.style.width = percent;
                // update the control-text
                $cb03b711053a4297$var$textContent(this.percentageEl_, percent);
                this.percent_ = percent;
            }
            // add child elements to represent the individual buffered time ranges
            for(let i = 0; i < buffered.length; i++){
                const start = buffered.start(i);
                const end = buffered.end(i);
                let part = children[i];
                if (!part) {
                    part = this.el_.appendChild($cb03b711053a4297$var$createEl());
                    children[i] = part;
                }
                //  only update if changed
                if (part.dataset.start === start && part.dataset.end === end) continue;
                part.dataset.start = start;
                part.dataset.end = end;
                // set the percent based on the width of the progress bar (bufferedEnd)
                part.style.left = $cb03b711053a4297$var$percentify(start, bufferedEnd);
                part.style.width = $cb03b711053a4297$var$percentify(end - start, bufferedEnd);
            }
            // remove unused buffered range elements
            for(let i = children.length; i > buffered.length; i--)this.el_.removeChild(children[i - 1]);
            children.length = buffered.length;
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("LoadProgressBar", $cb03b711053a4297$var$LoadProgressBar);
/**
 * @file time-tooltip.js
 */ /**
 * Time tooltips display a time above the progress bar.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TimeTooltip extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-time-tooltip"
        }, {
            "aria-hidden": "true"
        });
    }
    /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */ update(seekBarRect, seekBarPoint, content) {
        const tooltipRect = $cb03b711053a4297$var$findPosition(this.el_);
        const playerRect = $cb03b711053a4297$var$getBoundingClientRect(this.player_.el());
        const seekBarPointPx = seekBarRect.width * seekBarPoint;
        // do nothing if either rect isn't available
        // for example, if the player isn't in the DOM for testing
        if (!playerRect || !tooltipRect) return;
        // This is the space left of the `seekBarPoint` available within the bounds
        // of the player. We calculate any gap between the left edge of the player
        // and the left edge of the `SeekBar` and add the number of pixels in the
        // `SeekBar` before hitting the `seekBarPoint`
        const spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx;
        // This is the space right of the `seekBarPoint` available within the bounds
        // of the player. We calculate the number of pixels from the `seekBarPoint`
        // to the right edge of the `SeekBar` and add to that any gap between the
        // right edge of the `SeekBar` and the player.
        const spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right);
        // This is the number of pixels by which the tooltip will need to be pulled
        // further to the right to center it over the `seekBarPoint`.
        let pullTooltipBy = tooltipRect.width / 2;
        // Adjust the `pullTooltipBy` distance to the left or right depending on
        // the results of the space calculations above.
        if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
        else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
        // Due to the imprecision of decimal/ratio based calculations and varying
        // rounding behaviors, there are cases where the spacing adjustment is off
        // by a pixel or two. This adds insurance to these calculations.
        if (pullTooltipBy < 0) pullTooltipBy = 0;
        else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
        // prevent small width fluctuations within 0.4px from
        // changing the value below.
        // This really helps for live to prevent the play
        // progress time tooltip from jittering
        pullTooltipBy = Math.round(pullTooltipBy);
        this.el_.style.right = `-${pullTooltipBy}px`;
        this.write(content);
    }
    /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */ write(content) {
        $cb03b711053a4297$var$textContent(this.el_, content);
    }
    /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */ updateTime(seekBarRect, seekBarPoint, time, cb) {
        this.requestNamedAnimationFrame("TimeTooltip#updateTime", ()=>{
            let content;
            const duration = this.player_.duration();
            if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
                const liveWindow = this.player_.liveTracker.liveWindow();
                const secondsBehind = liveWindow - seekBarPoint * liveWindow;
                content = (secondsBehind < 1 ? "" : "-") + $cb03b711053a4297$var$formatTime(secondsBehind, liveWindow);
            } else content = $cb03b711053a4297$var$formatTime(time, duration);
            this.update(seekBarRect, seekBarPoint, content);
            if (cb) cb();
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TimeTooltip", $cb03b711053a4297$var$TimeTooltip);
/**
 * @file play-progress-bar.js
 */ /**
 * Used by {@link SeekBar} to display media playback progress as part of the
 * {@link ProgressControl}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$PlayProgressBar extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.setIcon("circle");
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-play-progress vjs-slider-bar"
        }, {
            "aria-hidden": "true"
        });
    }
    /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */ update(seekBarRect, seekBarPoint) {
        const timeTooltip = this.getChild("timeTooltip");
        if (!timeTooltip) return;
        const time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
        timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
    }
}
/**
 * Default options for {@link PlayProgressBar}.
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$PlayProgressBar.prototype.options_ = {
    children: []
};
// Time tooltips should not be added to a player on mobile devices
if (!$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID) $cb03b711053a4297$var$PlayProgressBar.prototype.options_.children.push("timeTooltip");
$cb03b711053a4297$var$Component$1.registerComponent("PlayProgressBar", $cb03b711053a4297$var$PlayProgressBar);
/**
 * @file mouse-time-display.js
 */ /**
 * The {@link MouseTimeDisplay} component tracks mouse movement over the
 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
 * indicating the time which is represented by a given point in the
 * {@link ProgressControl}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MouseTimeDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-mouse-display"
        });
    }
    /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */ update(seekBarRect, seekBarPoint) {
        const time = seekBarPoint * this.player_.duration();
        this.getChild("timeTooltip").updateTime(seekBarRect, seekBarPoint, time, ()=>{
            this.el_.style.left = `${seekBarRect.width * seekBarPoint}px`;
        });
    }
}
/**
 * Default options for `MouseTimeDisplay`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$MouseTimeDisplay.prototype.options_ = {
    children: [
        "timeTooltip"
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent("MouseTimeDisplay", $cb03b711053a4297$var$MouseTimeDisplay);
/**
 * @file seek-bar.js
 */ // The number of seconds the `step*` functions move the timeline.
const $cb03b711053a4297$var$STEP_SECONDS = 5;
// The multiplier of STEP_SECONDS that PgUp/PgDown move the timeline.
const $cb03b711053a4297$var$PAGE_KEY_MULTIPLIER = 12;
/**
 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
 * as its `bar`.
 *
 * @extends Slider
 */ class $cb03b711053a4297$var$SeekBar extends $cb03b711053a4297$var$Slider {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.setEventHandlers_();
    }
    /**
   * Sets the event handlers
   *
   * @private
   */ setEventHandlers_() {
        this.update_ = $cb03b711053a4297$var$bind_(this, this.update);
        this.update = $cb03b711053a4297$var$throttle(this.update_, $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.on(this.player_, [
            "ended",
            "durationchange",
            "timeupdate"
        ], this.update);
        if (this.player_.liveTracker) this.on(this.player_.liveTracker, "liveedgechange", this.update);
        // when playing, let's ensure we smoothly update the play progress bar
        // via an interval
        this.updateInterval = null;
        this.enableIntervalHandler_ = (e)=>this.enableInterval_(e);
        this.disableIntervalHandler_ = (e)=>this.disableInterval_(e);
        this.on(this.player_, [
            "playing"
        ], this.enableIntervalHandler_);
        this.on(this.player_, [
            "ended",
            "pause",
            "waiting"
        ], this.disableIntervalHandler_);
        // we don't need to update the play progress if the document is hidden,
        // also, this causes the CPU to spike and eventually crash the page on IE11.
        if ("hidden" in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) && "visibilityState" in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) this.on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "visibilitychange", this.toggleVisibility_);
    }
    toggleVisibility_(e) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).visibilityState === "hidden") {
            this.cancelNamedAnimationFrame("SeekBar#update");
            this.cancelNamedAnimationFrame("Slider#update");
            this.disableInterval_(e);
        } else {
            if (!this.player_.ended() && !this.player_.paused()) this.enableInterval_();
            // we just switched back to the page and someone may be looking, so, update ASAP
            this.update();
        }
    }
    enableInterval_() {
        if (this.updateInterval) return;
        this.updateInterval = this.setInterval(this.update, $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    disableInterval_(e) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended") return;
        if (!this.updateInterval) return;
        this.clearInterval(this.updateInterval);
        this.updateInterval = null;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-progress-holder"
        }, {
            "aria-label": this.localize("Progress Bar")
        });
    }
    /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */ update(event) {
        // ignore updates while the tab is hidden
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).visibilityState === "hidden") return;
        const percent = super.update();
        this.requestNamedAnimationFrame("SeekBar#update", ()=>{
            const currentTime = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_();
            const liveTracker = this.player_.liveTracker;
            let duration = this.player_.duration();
            if (liveTracker && liveTracker.isLive()) duration = this.player_.liveTracker.liveCurrentTime();
            if (this.percent_ !== percent) {
                // machine readable value of progress bar (percentage complete)
                this.el_.setAttribute("aria-valuenow", (percent * 100).toFixed(2));
                this.percent_ = percent;
            }
            if (this.currentTime_ !== currentTime || this.duration_ !== duration) {
                // human readable value of progress bar (time complete)
                this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [
                    $cb03b711053a4297$var$formatTime(currentTime, duration),
                    $cb03b711053a4297$var$formatTime(duration, duration)
                ], "{1} of {2}"));
                this.currentTime_ = currentTime;
                this.duration_ = duration;
            }
            // update the progress bar time tooltip with the current time
            if (this.bar) this.bar.update($cb03b711053a4297$var$getBoundingClientRect(this.el()), this.getProgress());
        });
        return percent;
    }
    /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */ userSeek_(ct) {
        if (this.player_.liveTracker && this.player_.liveTracker.isLive()) this.player_.liveTracker.nextSeekedFromUser();
        this.player_.currentTime(ct);
    }
    /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */ getCurrentTime_() {
        return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    }
    /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */ getPercent() {
        const currentTime = this.getCurrentTime_();
        let percent;
        const liveTracker = this.player_.liveTracker;
        if (liveTracker && liveTracker.isLive()) {
            percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow();
            // prevent the percent from changing at the live edge
            if (liveTracker.atLiveEdge()) percent = 1;
        } else percent = currentTime / this.player_.duration();
        return percent;
    }
    /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        if (!$cb03b711053a4297$var$isSingleLeftClick(event)) return;
        // Stop event propagation to prevent double fire in progress-control.js
        event.stopPropagation();
        this.videoWasPlaying = !this.player_.paused();
        this.player_.pause();
        super.handleMouseDown(event);
    }
    /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */ handleMouseMove(event, mouseDown = false) {
        if (!$cb03b711053a4297$var$isSingleLeftClick(event) || isNaN(this.player_.duration())) return;
        if (!mouseDown && !this.player_.scrubbing()) this.player_.scrubbing(true);
        let newTime;
        const distance = this.calculateDistance(event);
        const liveTracker = this.player_.liveTracker;
        if (!liveTracker || !liveTracker.isLive()) {
            newTime = distance * this.player_.duration();
            // Don't let video end while scrubbing.
            if (newTime === this.player_.duration()) newTime = newTime - 0.1;
        } else {
            if (distance >= 0.99) {
                liveTracker.seekToLiveEdge();
                return;
            }
            const seekableStart = liveTracker.seekableStart();
            const seekableEnd = liveTracker.liveCurrentTime();
            newTime = seekableStart + distance * liveTracker.liveWindow();
            // Don't let video end while scrubbing.
            if (newTime >= seekableEnd) newTime = seekableEnd;
            // Compensate for precision differences so that currentTime is not less
            // than seekable start
            if (newTime <= seekableStart) newTime = seekableStart + 0.1;
            // On android seekableEnd can be Infinity sometimes,
            // this will cause newTime to be Infinity, which is
            // not a valid currentTime.
            if (newTime === Infinity) return;
        }
        // Set new time (tell player to seek to new time)
        this.userSeek_(newTime);
    }
    enable() {
        super.enable();
        const mouseTimeDisplay = this.getChild("mouseTimeDisplay");
        if (!mouseTimeDisplay) return;
        mouseTimeDisplay.show();
    }
    disable() {
        super.disable();
        const mouseTimeDisplay = this.getChild("mouseTimeDisplay");
        if (!mouseTimeDisplay) return;
        mouseTimeDisplay.hide();
    }
    /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */ handleMouseUp(event) {
        super.handleMouseUp(event);
        // Stop event propagation to prevent double fire in progress-control.js
        if (event) event.stopPropagation();
        this.player_.scrubbing(false);
        /**
     * Trigger timeupdate because we're done seeking and the time has changed.
     * This is particularly useful for if the player is paused to time the time displays.
     *
     * @event Tech#timeupdate
     * @type {Event}
     */ this.player_.trigger({
            type: "timeupdate",
            target: this,
            manuallyTriggered: true
        });
        if (this.videoWasPlaying) $cb03b711053a4297$var$silencePromise(this.player_.play());
        else // We're done seeking and the time has changed.
        // If the player is paused, make sure we display the correct time on the seek bar.
        this.update_();
    }
    /**
   * Move more quickly fast forward for keyboard-only users
   */ stepForward() {
        this.userSeek_(this.player_.currentTime() + $cb03b711053a4297$var$STEP_SECONDS);
    }
    /**
   * Move more quickly rewind for keyboard-only users
   */ stepBack() {
        this.userSeek_(this.player_.currentTime() - $cb03b711053a4297$var$STEP_SECONDS);
    }
    /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */ handleAction(event) {
        if (this.player_.paused()) this.player_.play();
        else this.player_.pause();
    }
    /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const liveTracker = this.player_.liveTracker;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Space") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Enter")) {
            event.preventDefault();
            event.stopPropagation();
            this.handleAction(event);
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Home")) {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(0);
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "End")) {
            event.preventDefault();
            event.stopPropagation();
            if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.liveCurrentTime());
            else this.userSeek_(this.player_.duration());
        } else if (/^[0-9]$/.test((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX)))(event))) {
            event.preventDefault();
            event.stopPropagation();
            const gotoFraction = ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).codes[(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX)))(event)] - (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).codes["0"]) * 10.0 / 100.0;
            if (liveTracker && liveTracker.isLive()) this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
            else this.userSeek_(this.player_.duration() * gotoFraction);
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "PgDn")) {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(this.player_.currentTime() - $cb03b711053a4297$var$STEP_SECONDS * $cb03b711053a4297$var$PAGE_KEY_MULTIPLIER);
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "PgUp")) {
            event.preventDefault();
            event.stopPropagation();
            this.userSeek_(this.player_.currentTime() + $cb03b711053a4297$var$STEP_SECONDS * $cb03b711053a4297$var$PAGE_KEY_MULTIPLIER);
        } else // Pass keydown handling up for unsupported keys
        super.handleKeyDown(event);
    }
    dispose() {
        this.disableInterval_();
        this.off(this.player_, [
            "ended",
            "durationchange",
            "timeupdate"
        ], this.update);
        if (this.player_.liveTracker) this.off(this.player_.liveTracker, "liveedgechange", this.update);
        this.off(this.player_, [
            "playing"
        ], this.enableIntervalHandler_);
        this.off(this.player_, [
            "ended",
            "pause",
            "waiting"
        ], this.disableIntervalHandler_);
        // we don't need to update the play progress if the document is hidden,
        // also, this causes the CPU to spike and eventually crash the page on IE11.
        if ("hidden" in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) && "visibilityState" in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) this.off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "visibilitychange", this.toggleVisibility_);
        super.dispose();
    }
}
/**
 * Default options for the `SeekBar`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$SeekBar.prototype.options_ = {
    children: [
        "loadProgressBar",
        "playProgressBar"
    ],
    barName: "playProgressBar"
};
// MouseTimeDisplay tooltips should not be added to a player on mobile devices
if (!$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID) $cb03b711053a4297$var$SeekBar.prototype.options_.children.splice(1, 0, "mouseTimeDisplay");
$cb03b711053a4297$var$Component$1.registerComponent("SeekBar", $cb03b711053a4297$var$SeekBar);
/**
 * @file progress-control.js
 */ /**
 * The Progress Control component contains the seek bar, load progress,
 * and play progress.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ProgressControl extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.handleMouseMove = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.handleMouseMove), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.throttledHandleMouseSeek = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.handleMouseSeek), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.handleMouseUpHandler_ = (e)=>this.handleMouseUp(e);
        this.handleMouseDownHandler_ = (e)=>this.handleMouseDown(e);
        this.enable();
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-progress-control vjs-control"
        });
    }
    /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */ handleMouseMove(event) {
        const seekBar = this.getChild("seekBar");
        if (!seekBar) return;
        const playProgressBar = seekBar.getChild("playProgressBar");
        const mouseTimeDisplay = seekBar.getChild("mouseTimeDisplay");
        if (!playProgressBar && !mouseTimeDisplay) return;
        const seekBarEl = seekBar.el();
        const seekBarRect = $cb03b711053a4297$var$findPosition(seekBarEl);
        let seekBarPoint = $cb03b711053a4297$var$getPointerPosition(seekBarEl, event).x;
        // The default skin has a gap on either side of the `SeekBar`. This means
        // that it's possible to trigger this behavior outside the boundaries of
        // the `SeekBar`. This ensures we stay within it at all times.
        seekBarPoint = $cb03b711053a4297$var$clamp(seekBarPoint, 0, 1);
        if (mouseTimeDisplay) mouseTimeDisplay.update(seekBarRect, seekBarPoint);
        if (playProgressBar) playProgressBar.update(seekBarRect, seekBar.getProgress());
    }
    /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */ /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */ handleMouseSeek(event) {
        const seekBar = this.getChild("seekBar");
        if (seekBar) seekBar.handleMouseMove(event);
    }
    /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */ enabled() {
        return this.enabled_;
    }
    /**
   * Disable all controls on the progress control and its children
   */ disable() {
        this.children().forEach((child)=>child.disable && child.disable());
        if (!this.enabled()) return;
        this.off([
            "mousedown",
            "touchstart"
        ], this.handleMouseDownHandler_);
        this.off(this.el_, "mousemove", this.handleMouseMove);
        this.removeListenersAddedOnMousedownAndTouchstart();
        this.addClass("disabled");
        this.enabled_ = false;
        // Restore normal playback state if controls are disabled while scrubbing
        if (this.player_.scrubbing()) {
            const seekBar = this.getChild("seekBar");
            this.player_.scrubbing(false);
            if (seekBar.videoWasPlaying) $cb03b711053a4297$var$silencePromise(this.player_.play());
        }
    }
    /**
   * Enable all controls on the progress control and its children
   */ enable() {
        this.children().forEach((child)=>child.enable && child.enable());
        if (this.enabled()) return;
        this.on([
            "mousedown",
            "touchstart"
        ], this.handleMouseDownHandler_);
        this.on(this.el_, "mousemove", this.handleMouseMove);
        this.removeClass("disabled");
        this.enabled_ = true;
    }
    /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */ removeListenersAddedOnMousedownAndTouchstart() {
        const doc = this.el_.ownerDocument;
        this.off(doc, "mousemove", this.throttledHandleMouseSeek);
        this.off(doc, "touchmove", this.throttledHandleMouseSeek);
        this.off(doc, "mouseup", this.handleMouseUpHandler_);
        this.off(doc, "touchend", this.handleMouseUpHandler_);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseDown(event) {
        const doc = this.el_.ownerDocument;
        const seekBar = this.getChild("seekBar");
        if (seekBar) seekBar.handleMouseDown(event);
        this.on(doc, "mousemove", this.throttledHandleMouseSeek);
        this.on(doc, "touchmove", this.throttledHandleMouseSeek);
        this.on(doc, "mouseup", this.handleMouseUpHandler_);
        this.on(doc, "touchend", this.handleMouseUpHandler_);
    }
    /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */ handleMouseUp(event) {
        const seekBar = this.getChild("seekBar");
        if (seekBar) seekBar.handleMouseUp(event);
        this.removeListenersAddedOnMousedownAndTouchstart();
    }
}
/**
 * Default options for `ProgressControl`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$ProgressControl.prototype.options_ = {
    children: [
        "seekBar"
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent("ProgressControl", $cb03b711053a4297$var$ProgressControl);
/**
 * @file picture-in-picture-toggle.js
 */ /**
 * Toggle Picture-in-Picture mode
 *
 * @extends Button
 */ class $cb03b711053a4297$var$PictureInPictureToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */ constructor(player, options){
        super(player, options);
        this.setIcon("picture-in-picture-enter");
        this.on(player, [
            "enterpictureinpicture",
            "leavepictureinpicture"
        ], (e)=>this.handlePictureInPictureChange(e));
        this.on(player, [
            "disablepictureinpicturechanged",
            "loadedmetadata"
        ], (e)=>this.handlePictureInPictureEnabledChange(e));
        this.on(player, [
            "loadedmetadata",
            "audioonlymodechange",
            "audiopostermodechange"
        ], ()=>this.handlePictureInPictureAudioModeChange());
        // TODO: Deactivate button on player emptied event.
        this.disable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
    }
    /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */ handlePictureInPictureAudioModeChange() {
        // This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
        const isSourceAudio = this.player_.currentType().substring(0, 5) === "audio";
        const isAudioMode = isSourceAudio || this.player_.audioPosterMode() || this.player_.audioOnlyMode();
        if (!isAudioMode) {
            this.show();
            return;
        }
        if (this.player_.isInPictureInPicture()) this.player_.exitPictureInPicture();
        this.hide();
    }
    /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */ handlePictureInPictureEnabledChange() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).pictureInPictureEnabled && this.player_.disablePictureInPicture() === false || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in (0, (/*@__PURE__*/$parcel$interopDefault($eDick)))) this.enable();
        else this.disable();
    }
    /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */ handlePictureInPictureChange(event) {
        if (this.player_.isInPictureInPicture()) {
            this.setIcon("picture-in-picture-exit");
            this.controlText("Exit Picture-in-Picture");
        } else {
            this.setIcon("picture-in-picture-enter");
            this.controlText("Picture-in-Picture");
        }
        this.handlePictureInPictureEnabledChange();
    }
    /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (!this.player_.isInPictureInPicture()) this.player_.requestPictureInPicture();
        else this.player_.exitPictureInPicture();
    }
    /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */ show() {
        // Does not allow to display the pictureInPictureToggle in browsers that do not support the Picture-in-Picture API, e.g. Firefox.
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).exitPictureInPicture !== "function") return;
        super.show();
    }
}
/**
 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$PictureInPictureToggle.prototype.controlText_ = "Picture-in-Picture";
$cb03b711053a4297$var$Component$1.registerComponent("PictureInPictureToggle", $cb03b711053a4297$var$PictureInPictureToggle);
/**
 * @file fullscreen-toggle.js
 */ /**
 * Toggle fullscreen video
 *
 * @extends Button
 */ class $cb03b711053a4297$var$FullscreenToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.setIcon("fullscreen-enter");
        this.on(player, "fullscreenchange", (e)=>this.handleFullscreenChange(e));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[player.fsApi_.fullscreenEnabled] === false) this.disable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-fullscreen-control ${super.buildCSSClass()}`;
    }
    /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */ handleFullscreenChange(event) {
        if (this.player_.isFullscreen()) {
            this.controlText("Exit Fullscreen");
            this.setIcon("fullscreen-exit");
        } else {
            this.controlText("Fullscreen");
            this.setIcon("fullscreen-enter");
        }
    }
    /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (!this.player_.isFullscreen()) this.player_.requestFullscreen();
        else this.player_.exitFullscreen();
    }
}
/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$FullscreenToggle.prototype.controlText_ = "Fullscreen";
$cb03b711053a4297$var$Component$1.registerComponent("FullscreenToggle", $cb03b711053a4297$var$FullscreenToggle);
/**
 * Check if volume control is supported and if it isn't hide the
 * `Component` that was passed  using the `vjs-hidden` class.
 *
 * @param { import('../../component').default } self
 *        The component that should be hidden if volume is unsupported
 *
 * @param { import('../../player').default } player
 *        A reference to the player
 *
 * @private
 */ const $cb03b711053a4297$var$checkVolumeSupport = function(self1, player) {
    // hide volume controls when they're not supported by the current tech
    if (player.tech_ && !player.tech_.featuresVolumeControl) self1.addClass("vjs-hidden");
    self1.on(player, "loadstart", function() {
        if (!player.tech_.featuresVolumeControl) self1.addClass("vjs-hidden");
        else self1.removeClass("vjs-hidden");
    });
};
/**
 * @file volume-level.js
 */ /**
 * Shows volume level
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumeLevel extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl("div", {
            className: "vjs-volume-level"
        });
        this.setIcon("circle", el);
        el.appendChild(super.createEl("span", {
            className: "vjs-control-text"
        }));
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("VolumeLevel", $cb03b711053a4297$var$VolumeLevel);
/**
 * @file volume-level-tooltip.js
 */ /**
 * Volume level tooltips display a volume above or side by side the volume bar.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumeLevelTooltip extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-volume-tooltip"
        }, {
            "aria-hidden": "true"
        });
    }
    /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */ update(rangeBarRect, rangeBarPoint, vertical, content) {
        if (!vertical) {
            const tooltipRect = $cb03b711053a4297$var$getBoundingClientRect(this.el_);
            const playerRect = $cb03b711053a4297$var$getBoundingClientRect(this.player_.el());
            const volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
            if (!playerRect || !tooltipRect) return;
            const spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
            const spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
            let pullTooltipBy = tooltipRect.width / 2;
            if (spaceLeftOfPoint < pullTooltipBy) pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
            else if (spaceRightOfPoint < pullTooltipBy) pullTooltipBy = spaceRightOfPoint;
            if (pullTooltipBy < 0) pullTooltipBy = 0;
            else if (pullTooltipBy > tooltipRect.width) pullTooltipBy = tooltipRect.width;
            this.el_.style.right = `-${pullTooltipBy}px`;
        }
        this.write(`${content}%`);
    }
    /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */ write(content) {
        $cb03b711053a4297$var$textContent(this.el_, content);
    }
    /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */ updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb) {
        this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", ()=>{
            this.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
            if (cb) cb();
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("VolumeLevelTooltip", $cb03b711053a4297$var$VolumeLevelTooltip);
/**
 * @file mouse-volume-level-display.js
 */ /**
 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
 * indicating the volume level which is represented by a given point in the
 * {@link VolumeBar}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MouseVolumeLevelDisplay extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.update = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.update), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
    }
    /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-mouse-display"
        });
    }
    /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */ update(rangeBarRect, rangeBarPoint, vertical) {
        const volume = 100 * rangeBarPoint;
        this.getChild("volumeLevelTooltip").updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, ()=>{
            if (vertical) this.el_.style.bottom = `${rangeBarRect.height * rangeBarPoint}px`;
            else this.el_.style.left = `${rangeBarRect.width * rangeBarPoint}px`;
        });
    }
}
/**
 * Default options for `MouseVolumeLevelDisplay`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$MouseVolumeLevelDisplay.prototype.options_ = {
    children: [
        "volumeLevelTooltip"
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent("MouseVolumeLevelDisplay", $cb03b711053a4297$var$MouseVolumeLevelDisplay);
/**
 * @file volume-bar.js
 */ /**
 * The bar that contains the volume level and can be clicked on to adjust the level
 *
 * @extends Slider
 */ class $cb03b711053a4297$var$VolumeBar extends $cb03b711053a4297$var$Slider {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on("slideractive", (e)=>this.updateLastVolume_(e));
        this.on(player, "volumechange", (e)=>this.updateARIAAttributes(e));
        player.ready(()=>this.updateARIAAttributes());
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-volume-bar vjs-slider-bar"
        }, {
            "aria-label": this.localize("Volume Level"),
            "aria-live": "polite"
        });
    }
    /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */ handleMouseDown(event) {
        if (!$cb03b711053a4297$var$isSingleLeftClick(event)) return;
        super.handleMouseDown(event);
    }
    /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */ handleMouseMove(event) {
        const mouseVolumeLevelDisplay = this.getChild("mouseVolumeLevelDisplay");
        if (mouseVolumeLevelDisplay) {
            const volumeBarEl = this.el();
            const volumeBarRect = $cb03b711053a4297$var$getBoundingClientRect(volumeBarEl);
            const vertical = this.vertical();
            let volumeBarPoint = $cb03b711053a4297$var$getPointerPosition(volumeBarEl, event);
            volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x;
            // The default skin has a gap on either side of the `VolumeBar`. This means
            // that it's possible to trigger this behavior outside the boundaries of
            // the `VolumeBar`. This ensures we stay within it at all times.
            volumeBarPoint = $cb03b711053a4297$var$clamp(volumeBarPoint, 0, 1);
            mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
        }
        if (!$cb03b711053a4297$var$isSingleLeftClick(event)) return;
        this.checkMuted();
        this.player_.volume(this.calculateDistance(event));
    }
    /**
   * If the player is muted unmute it.
   */ checkMuted() {
        if (this.player_.muted()) this.player_.muted(false);
    }
    /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */ getPercent() {
        if (this.player_.muted()) return 0;
        return this.player_.volume();
    }
    /**
   * Increase volume level for keyboard users
   */ stepForward() {
        this.checkMuted();
        this.player_.volume(this.player_.volume() + 0.1);
    }
    /**
   * Decrease volume level for keyboard users
   */ stepBack() {
        this.checkMuted();
        this.player_.volume(this.player_.volume() - 0.1);
    }
    /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */ updateARIAAttributes(event) {
        const ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
        this.el_.setAttribute("aria-valuenow", ariaValue);
        this.el_.setAttribute("aria-valuetext", ariaValue + "%");
    }
    /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */ volumeAsPercentage_() {
        return Math.round(this.player_.volume() * 100);
    }
    /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */ updateLastVolume_() {
        const volumeBeforeDrag = this.player_.volume();
        this.one("sliderinactive", ()=>{
            if (this.player_.volume() === 0) this.player_.lastVolume_(volumeBeforeDrag);
        });
    }
}
/**
 * Default options for the `VolumeBar`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$VolumeBar.prototype.options_ = {
    children: [
        "volumeLevel"
    ],
    barName: "volumeLevel"
};
// MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
if (!$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID) $cb03b711053a4297$var$VolumeBar.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
/**
 * Call the update event for this Slider when this event happens on the player.
 *
 * @type {string}
 */ $cb03b711053a4297$var$VolumeBar.prototype.playerEvent = "volumechange";
$cb03b711053a4297$var$Component$1.registerComponent("VolumeBar", $cb03b711053a4297$var$VolumeBar);
/**
 * @file volume-control.js
 */ /**
 * The component for controlling the volume level
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumeControl extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.vertical = options.vertical || false;
        // Pass the vertical option down to the VolumeBar if
        // the VolumeBar is turned on.
        if (typeof options.volumeBar === "undefined" || $cb03b711053a4297$var$isPlain(options.volumeBar)) {
            options.volumeBar = options.volumeBar || {};
            options.volumeBar.vertical = options.vertical;
        }
        super(player, options);
        // hide this control if volume support is missing
        $cb03b711053a4297$var$checkVolumeSupport(this, player);
        this.throttledHandleMouseMove = $cb03b711053a4297$var$throttle($cb03b711053a4297$var$bind_(this, this.handleMouseMove), $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.handleMouseUpHandler_ = (e)=>this.handleMouseUp(e);
        this.on("mousedown", (e)=>this.handleMouseDown(e));
        this.on("touchstart", (e)=>this.handleMouseDown(e));
        this.on("mousemove", (e)=>this.handleMouseMove(e));
        // while the slider is active (the mouse has been pressed down and
        // is dragging) or in focus we do not want to hide the VolumeBar
        this.on(this.volumeBar, [
            "focus",
            "slideractive"
        ], ()=>{
            this.volumeBar.addClass("vjs-slider-active");
            this.addClass("vjs-slider-active");
            this.trigger("slideractive");
        });
        this.on(this.volumeBar, [
            "blur",
            "sliderinactive"
        ], ()=>{
            this.volumeBar.removeClass("vjs-slider-active");
            this.removeClass("vjs-slider-active");
            this.trigger("sliderinactive");
        });
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        let orientationClass = "vjs-volume-horizontal";
        if (this.options_.vertical) orientationClass = "vjs-volume-vertical";
        return super.createEl("div", {
            className: `vjs-volume-control vjs-control ${orientationClass}`
        });
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseDown(event) {
        const doc = this.el_.ownerDocument;
        this.on(doc, "mousemove", this.throttledHandleMouseMove);
        this.on(doc, "touchmove", this.throttledHandleMouseMove);
        this.on(doc, "mouseup", this.handleMouseUpHandler_);
        this.on(doc, "touchend", this.handleMouseUpHandler_);
    }
    /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */ handleMouseUp(event) {
        const doc = this.el_.ownerDocument;
        this.off(doc, "mousemove", this.throttledHandleMouseMove);
        this.off(doc, "touchmove", this.throttledHandleMouseMove);
        this.off(doc, "mouseup", this.handleMouseUpHandler_);
        this.off(doc, "touchend", this.handleMouseUpHandler_);
    }
    /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */ handleMouseMove(event) {
        this.volumeBar.handleMouseMove(event);
    }
}
/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$VolumeControl.prototype.options_ = {
    children: [
        "volumeBar"
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent("VolumeControl", $cb03b711053a4297$var$VolumeControl);
/**
 * Check if muting volume is supported and if it isn't hide the mute toggle
 * button.
 *
 * @param { import('../../component').default } self
 *        A reference to the mute toggle button
 *
 * @param { import('../../player').default } player
 *        A reference to the player
 *
 * @private
 */ const $cb03b711053a4297$var$checkMuteSupport = function(self1, player) {
    // hide mute toggle button if it's not supported by the current tech
    if (player.tech_ && !player.tech_.featuresMuteControl) self1.addClass("vjs-hidden");
    self1.on(player, "loadstart", function() {
        if (!player.tech_.featuresMuteControl) self1.addClass("vjs-hidden");
        else self1.removeClass("vjs-hidden");
    });
};
/**
 * @file mute-toggle.js
 */ /**
 * A button component for muting the audio.
 *
 * @extends Button
 */ class $cb03b711053a4297$var$MuteToggle extends $cb03b711053a4297$var$Button {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        // hide this control if volume support is missing
        $cb03b711053a4297$var$checkMuteSupport(this, player);
        this.on(player, [
            "loadstart",
            "volumechange"
        ], (e)=>this.update(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-mute-control ${super.buildCSSClass()}`;
    }
    /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const vol = this.player_.volume();
        const lastVolume = this.player_.lastVolume_();
        if (vol === 0) {
            const volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
            this.player_.volume(volumeToSet);
            this.player_.muted(false);
        } else this.player_.muted(this.player_.muted() ? false : true);
    }
    /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */ update(event) {
        this.updateIcon_();
        this.updateControlText_();
    }
    /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */ updateIcon_() {
        const vol = this.player_.volume();
        let level = 3;
        this.setIcon("volume-high");
        // in iOS when a player is loaded with muted attribute
        // and volume is changed with a native mute button
        // we want to make sure muted state is updated
        if ($cb03b711053a4297$var$IS_IOS && this.player_.tech_ && this.player_.tech_.el_) this.player_.muted(this.player_.tech_.el_.muted);
        if (vol === 0 || this.player_.muted()) {
            this.setIcon("volume-mute");
            level = 0;
        } else if (vol < 0.33) {
            this.setIcon("volume-low");
            level = 1;
        } else if (vol < 0.67) {
            this.setIcon("volume-medium");
            level = 2;
        }
        $cb03b711053a4297$var$removeClass(this.el_, [
            0,
            1,
            2,
            3
        ].reduce((str, i)=>str + `${i ? " " : ""}vjs-vol-${i}`, ""));
        $cb03b711053a4297$var$addClass(this.el_, `vjs-vol-${level}`);
    }
    /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */ updateControlText_() {
        const soundOff = this.player_.muted() || this.player_.volume() === 0;
        const text = soundOff ? "Unmute" : "Mute";
        if (this.controlText() !== text) this.controlText(text);
    }
}
/**
 * The text that should display over the `MuteToggle`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$MuteToggle.prototype.controlText_ = "Mute";
$cb03b711053a4297$var$Component$1.registerComponent("MuteToggle", $cb03b711053a4297$var$MuteToggle);
/**
 * @file volume-control.js
 */ /**
 * A Component to contain the MuteToggle and VolumeControl so that
 * they can work together.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$VolumePanel extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        if (typeof options.inline !== "undefined") options.inline = options.inline;
        else options.inline = true;
        // pass the inline option down to the VolumeControl as vertical if
        // the VolumeControl is on.
        if (typeof options.volumeControl === "undefined" || $cb03b711053a4297$var$isPlain(options.volumeControl)) {
            options.volumeControl = options.volumeControl || {};
            options.volumeControl.vertical = !options.inline;
        }
        super(player, options);
        // this handler is used by mouse handler methods below
        this.handleKeyPressHandler_ = (e)=>this.handleKeyPress(e);
        this.on(player, [
            "loadstart"
        ], (e)=>this.volumePanelState_(e));
        this.on(this.muteToggle, "keyup", (e)=>this.handleKeyPress(e));
        this.on(this.volumeControl, "keyup", (e)=>this.handleVolumeControlKeyUp(e));
        this.on("keydown", (e)=>this.handleKeyPress(e));
        this.on("mouseover", (e)=>this.handleMouseOver(e));
        this.on("mouseout", (e)=>this.handleMouseOut(e));
        // while the slider is active (the mouse has been pressed down and
        // is dragging) we do not want to hide the VolumeBar
        this.on(this.volumeControl, [
            "slideractive"
        ], this.sliderActive_);
        this.on(this.volumeControl, [
            "sliderinactive"
        ], this.sliderInactive_);
    }
    /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */ sliderActive_() {
        this.addClass("vjs-slider-active");
    }
    /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */ sliderInactive_() {
        this.removeClass("vjs-slider-active");
    }
    /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */ volumePanelState_() {
        // hide volume panel if neither volume control or mute toggle
        // are displayed
        if (this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden")) this.addClass("vjs-hidden");
        // if only mute toggle is visible we don't want
        // volume panel expanding when hovered or active
        if (this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden")) this.addClass("vjs-mute-toggle-only");
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        let orientationClass = "vjs-volume-panel-horizontal";
        if (!this.options_.inline) orientationClass = "vjs-volume-panel-vertical";
        return super.createEl("div", {
            className: `vjs-volume-panel vjs-control ${orientationClass}`
        });
    }
    /**
   * Dispose of the `volume-panel` and all child components.
   */ dispose() {
        this.handleMouseOut();
        super.dispose();
    }
    /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */ handleVolumeControlKeyUp(event) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Esc")) this.muteToggle.focus();
    }
    /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */ handleMouseOver(event) {
        this.addClass("vjs-hover");
        $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "keyup", this.handleKeyPressHandler_);
    }
    /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */ handleMouseOut(event) {
        this.removeClass("vjs-hover");
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "keyup", this.handleKeyPressHandler_);
    }
    /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */ handleKeyPress(event) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Esc")) this.handleMouseOut();
    }
}
/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$VolumePanel.prototype.options_ = {
    children: [
        "muteToggle",
        "volumeControl"
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent("VolumePanel", $cb03b711053a4297$var$VolumePanel);
/**
 * Button to skip forward a configurable amount of time
 * through a video. Renders in the control bar.
 *
 * e.g. options: {controlBar: {skipButtons: forward: 5}}
 *
 * @extends Button
 */ class $cb03b711053a4297$var$SkipForward extends $cb03b711053a4297$var$Button {
    constructor(player, options){
        super(player, options);
        this.validOptions = [
            5,
            10,
            30
        ];
        this.skipTime = this.getSkipForwardTime();
        if (this.skipTime && this.validOptions.includes(this.skipTime)) {
            this.setIcon(`forward-${this.skipTime}`);
            this.controlText(this.localize("Skip forward {1} seconds", [
                this.skipTime
            ]));
            this.show();
        } else this.hide();
    }
    getSkipForwardTime() {
        const playerOptions = this.options_.playerOptions;
        return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.forward;
    }
    buildCSSClass() {
        return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
    }
    /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */ handleClick(event) {
        if (isNaN(this.player_.duration())) return;
        const currentVideoTime = this.player_.currentTime();
        const liveTracker = this.player_.liveTracker;
        const duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : this.player_.duration();
        let newTime;
        if (currentVideoTime + this.skipTime <= duration) newTime = currentVideoTime + this.skipTime;
        else newTime = duration;
        this.player_.currentTime(newTime);
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.controlText(this.localize("Skip forward {1} seconds", [
            this.skipTime
        ]));
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("SkipForward", $cb03b711053a4297$var$SkipForward);
/**
 * Button to skip backward a configurable amount of time
 * through a video. Renders in the control bar.
 *
 *  * e.g. options: {controlBar: {skipButtons: backward: 5}}
 *
 * @extends Button
 */ class $cb03b711053a4297$var$SkipBackward extends $cb03b711053a4297$var$Button {
    constructor(player, options){
        super(player, options);
        this.validOptions = [
            5,
            10,
            30
        ];
        this.skipTime = this.getSkipBackwardTime();
        if (this.skipTime && this.validOptions.includes(this.skipTime)) {
            this.setIcon(`replay-${this.skipTime}`);
            this.controlText(this.localize("Skip backward {1} seconds", [
                this.skipTime
            ]));
            this.show();
        } else this.hide();
    }
    getSkipBackwardTime() {
        const playerOptions = this.options_.playerOptions;
        return playerOptions.controlBar && playerOptions.controlBar.skipButtons && playerOptions.controlBar.skipButtons.backward;
    }
    buildCSSClass() {
        return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
    }
    /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */ handleClick(event) {
        const currentVideoTime = this.player_.currentTime();
        const liveTracker = this.player_.liveTracker;
        const seekableStart = liveTracker && liveTracker.isLive() && liveTracker.seekableStart();
        let newTime;
        if (seekableStart && currentVideoTime - this.skipTime <= seekableStart) newTime = seekableStart;
        else if (currentVideoTime >= this.skipTime) newTime = currentVideoTime - this.skipTime;
        else newTime = 0;
        this.player_.currentTime(newTime);
    }
    /**
   * Update control text on languagechange
   */ handleLanguagechange() {
        this.controlText(this.localize("Skip backward {1} seconds", [
            this.skipTime
        ]));
    }
}
$cb03b711053a4297$var$SkipBackward.prototype.controlText_ = "Skip Backward";
$cb03b711053a4297$var$Component$1.registerComponent("SkipBackward", $cb03b711053a4297$var$SkipBackward);
/**
 * @file menu.js
 */ /**
 * The Menu component is used to build popup menus, including subtitle and
 * captions selection menus.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Menu extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param { import('../player').default } player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */ constructor(player, options){
        super(player, options);
        if (options) this.menuButton_ = options.menuButton;
        this.focusedChild_ = -1;
        this.on("keydown", (e)=>this.handleKeyDown(e));
        // All the menu item instances share the same blur handler provided by the menu container.
        this.boundHandleBlur_ = (e)=>this.handleBlur(e);
        this.boundHandleTapClick_ = (e)=>this.handleTapClick(e);
    }
    /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */ addEventListenerForItem(component) {
        if (!(component instanceof $cb03b711053a4297$var$Component$1)) return;
        this.on(component, "blur", this.boundHandleBlur_);
        this.on(component, [
            "tap",
            "click"
        ], this.boundHandleTapClick_);
    }
    /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */ removeEventListenerForItem(component) {
        if (!(component instanceof $cb03b711053a4297$var$Component$1)) return;
        this.off(component, "blur", this.boundHandleBlur_);
        this.off(component, [
            "tap",
            "click"
        ], this.boundHandleTapClick_);
    }
    /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */ removeChild(component) {
        if (typeof component === "string") component = this.getChild(component);
        this.removeEventListenerForItem(component);
        super.removeChild(component);
    }
    /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */ addItem(component) {
        const childComponent = this.addChild(component);
        if (childComponent) this.addEventListenerForItem(childComponent);
    }
    /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */ createEl() {
        const contentElType = this.options_.contentElType || "ul";
        this.contentEl_ = $cb03b711053a4297$var$createEl(contentElType, {
            className: "vjs-menu-content"
        });
        this.contentEl_.setAttribute("role", "menu");
        const el = super.createEl("div", {
            append: this.contentEl_,
            className: "vjs-menu"
        });
        el.appendChild(this.contentEl_);
        // Prevent clicks from bubbling up. Needed for Menu Buttons,
        // where a click on the parent is significant
        $cb03b711053a4297$var$on(el, "click", function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        });
        return el;
    }
    dispose() {
        this.contentEl_ = null;
        this.boundHandleBlur_ = null;
        this.boundHandleTapClick_ = null;
        super.dispose();
    }
    /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */ handleBlur(event) {
        const relatedTarget = event.relatedTarget || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).activeElement;
        // Close menu popup when a user clicks outside the menu
        if (!this.children().some((element)=>{
            return element.el() === relatedTarget;
        })) {
            const btn = this.menuButton_;
            if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) btn.unpressButton();
        }
    }
    /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */ handleTapClick(event) {
        // Unpress the associated MenuButton, and move focus back to it
        if (this.menuButton_) {
            this.menuButton_.unpressButton();
            const childComponents = this.children();
            if (!Array.isArray(childComponents)) return;
            const foundComponent = childComponents.filter((component)=>component.el() === event.target)[0];
            if (!foundComponent) return;
            // don't focus menu button if item is a caption settings item
            // because focus will move elsewhere
            if (foundComponent.name() !== "CaptionSettingsMenuItem") this.menuButton_.focus();
        }
    }
    /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Left and Down Arrows
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Left") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Down")) {
            event.preventDefault();
            event.stopPropagation();
            this.stepForward();
        // Up and Right Arrows
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Right") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Up")) {
            event.preventDefault();
            event.stopPropagation();
            this.stepBack();
        }
    }
    /**
   * Move to next (lower) menu item for keyboard users.
   */ stepForward() {
        let stepChild = 0;
        if (this.focusedChild_ !== undefined) stepChild = this.focusedChild_ + 1;
        this.focus(stepChild);
    }
    /**
   * Move to previous (higher) menu item for keyboard users.
   */ stepBack() {
        let stepChild = 0;
        if (this.focusedChild_ !== undefined) stepChild = this.focusedChild_ - 1;
        this.focus(stepChild);
    }
    /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */ focus(item = 0) {
        const children = this.children().slice();
        const haveTitle = children.length && children[0].hasClass("vjs-menu-title");
        if (haveTitle) children.shift();
        if (children.length > 0) {
            if (item < 0) item = 0;
            else if (item >= children.length) item = children.length - 1;
            this.focusedChild_ = item;
            children[item].el_.focus();
        }
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("Menu", $cb03b711053a4297$var$Menu);
/**
 * @file menu-button.js
 */ /**
 * A `MenuButton` class for any popup {@link Menu}.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$MenuButton extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        super(player, options);
        this.menuButton_ = new $cb03b711053a4297$var$Button(player, options);
        this.menuButton_.controlText(this.controlText_);
        this.menuButton_.el_.setAttribute("aria-haspopup", "true");
        // Add buildCSSClass values to the button, not the wrapper
        const buttonClass = $cb03b711053a4297$var$Button.prototype.buildCSSClass();
        this.menuButton_.el_.className = this.buildCSSClass() + " " + buttonClass;
        this.menuButton_.removeClass("vjs-control");
        this.addChild(this.menuButton_);
        this.update();
        this.enabled_ = true;
        const handleClick = (e)=>this.handleClick(e);
        this.handleMenuKeyUp_ = (e)=>this.handleMenuKeyUp(e);
        this.on(this.menuButton_, "tap", handleClick);
        this.on(this.menuButton_, "click", handleClick);
        this.on(this.menuButton_, "keydown", (e)=>this.handleKeyDown(e));
        this.on(this.menuButton_, "mouseenter", ()=>{
            this.addClass("vjs-hover");
            this.menu.show();
            $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "keyup", this.handleMenuKeyUp_);
        });
        this.on("mouseleave", (e)=>this.handleMouseLeave(e));
        this.on("keydown", (e)=>this.handleSubmenuKeyDown(e));
    }
    /**
   * Update the menu based on the current state of its items.
   */ update() {
        const menu = this.createMenu();
        if (this.menu) {
            this.menu.dispose();
            this.removeChild(this.menu);
        }
        this.menu = menu;
        this.addChild(menu);
        /**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */ this.buttonPressed_ = false;
        this.menuButton_.el_.setAttribute("aria-expanded", "false");
        if (this.items && this.items.length <= this.hideThreshold_) {
            this.hide();
            this.menu.contentEl_.removeAttribute("role");
        } else {
            this.show();
            this.menu.contentEl_.setAttribute("role", "menu");
        }
    }
    /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */ createMenu() {
        const menu = new $cb03b711053a4297$var$Menu(this.player_, {
            menuButton: this
        });
        /**
     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
     * it here because every time we run `createMenu` we need to reset the value.
     *
     * @protected
     * @type {Number}
     */ this.hideThreshold_ = 0;
        // Add a title list item to the top
        if (this.options_.title) {
            const titleEl = $cb03b711053a4297$var$createEl("li", {
                className: "vjs-menu-title",
                textContent: $cb03b711053a4297$var$toTitleCase$1(this.options_.title),
                tabIndex: -1
            });
            const titleComponent = new $cb03b711053a4297$var$Component$1(this.player_, {
                el: titleEl
            });
            menu.addItem(titleComponent);
        }
        this.items = this.createItems();
        if (this.items) // Add menu items to the menu
        for(let i = 0; i < this.items.length; i++)menu.addItem(this.items[i]);
        return menu;
    }
    /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */ createItems() {}
    /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        return super.createEl("div", {
            className: this.buildWrapperCSSClass()
        }, {});
    }
    /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   */ setIcon(name) {
        super.setIcon(name, this.menuButton_.el_);
    }
    /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */ buildWrapperCSSClass() {
        let menuButtonClass = "vjs-menu-button";
        // If the inline option is passed, we want to use different styles altogether.
        if (this.options_.inline === true) menuButtonClass += "-inline";
        else menuButtonClass += "-popup";
        // TODO: Fix the CSS so that this isn't necessary
        const buttonClass = $cb03b711053a4297$var$Button.prototype.buildCSSClass();
        return `vjs-menu-button ${menuButtonClass} ${buttonClass} ${super.buildCSSClass()}`;
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        let menuButtonClass = "vjs-menu-button";
        // If the inline option is passed, we want to use different styles altogether.
        if (this.options_.inline === true) menuButtonClass += "-inline";
        else menuButtonClass += "-popup";
        return `vjs-menu-button ${menuButtonClass} ${super.buildCSSClass()}`;
    }
    /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */ controlText(text, el = this.menuButton_.el()) {
        return this.menuButton_.controlText(text, el);
    }
    /**
   * Dispose of the `menu-button` and all child components.
   */ dispose() {
        this.handleMouseLeave();
        super.dispose();
    }
    /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        if (this.buttonPressed_) this.unpressButton();
        else this.pressButton();
    }
    /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */ handleMouseLeave(event) {
        this.removeClass("vjs-hover");
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "keyup", this.handleMenuKeyUp_);
    }
    /**
   * Set the focus to the actual button, not to this element
   */ focus() {
        this.menuButton_.focus();
    }
    /**
   * Remove the focus from the actual button, not this element
   */ blur() {
        this.menuButton_.blur();
    }
    /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        // Escape or Tab unpress the 'button'
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Esc") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Tab")) {
            if (this.buttonPressed_) this.unpressButton();
            // Don't preventDefault for Tab key - we still want to lose focus
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Tab")) {
                event.preventDefault();
                // Set focus back to the menu button's button
                this.menuButton_.focus();
            }
        // Up Arrow or Down Arrow also 'press' the button to open the menu
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Up") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Down")) {
            if (!this.buttonPressed_) {
                event.preventDefault();
                this.pressButton();
            }
        }
    }
    /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */ handleMenuKeyUp(event) {
        // Escape hides popup menu
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Esc") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Tab")) this.removeClass("vjs-hover");
    }
    /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */ handleSubmenuKeyPress(event) {
        this.handleSubmenuKeyDown(event);
    }
    /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */ handleSubmenuKeyDown(event) {
        // Escape or Tab unpress the 'button'
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Esc") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Tab")) {
            if (this.buttonPressed_) this.unpressButton();
            // Don't preventDefault for Tab key - we still want to lose focus
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Tab")) {
                event.preventDefault();
                // Set focus back to the menu button's button
                this.menuButton_.focus();
            }
        }
    }
    /**
   * Put the current `MenuButton` into a pressed state.
   */ pressButton() {
        if (this.enabled_) {
            this.buttonPressed_ = true;
            this.menu.show();
            this.menu.lockShowing();
            this.menuButton_.el_.setAttribute("aria-expanded", "true");
            // set the focus into the submenu, except on iOS where it is resulting in
            // undesired scrolling behavior when the player is in an iframe
            if ($cb03b711053a4297$var$IS_IOS && $cb03b711053a4297$var$isInFrame()) // Return early so that the menu isn't focused
            return;
            this.menu.focus();
        }
    }
    /**
   * Take the current `MenuButton` out of a pressed state.
   */ unpressButton() {
        if (this.enabled_) {
            this.buttonPressed_ = false;
            this.menu.unlockShowing();
            this.menu.hide();
            this.menuButton_.el_.setAttribute("aria-expanded", "false");
        }
    }
    /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */ disable() {
        this.unpressButton();
        this.enabled_ = false;
        this.addClass("vjs-disabled");
        this.menuButton_.disable();
    }
    /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */ enable() {
        this.enabled_ = true;
        this.removeClass("vjs-disabled");
        this.menuButton_.enable();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("MenuButton", $cb03b711053a4297$var$MenuButton);
/**
 * @file track-button.js
 */ /**
 * The base class for buttons that toggle specific  track types (e.g. subtitles).
 *
 * @extends MenuButton
 */ class $cb03b711053a4297$var$TrackButton extends $cb03b711053a4297$var$MenuButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const tracks = options.tracks;
        super(player, options);
        if (this.items.length <= 1) this.hide();
        if (!tracks) return;
        const updateHandler = $cb03b711053a4297$var$bind_(this, this.update);
        tracks.addEventListener("removetrack", updateHandler);
        tracks.addEventListener("addtrack", updateHandler);
        tracks.addEventListener("labelchange", updateHandler);
        this.player_.on("ready", updateHandler);
        this.player_.on("dispose", function() {
            tracks.removeEventListener("removetrack", updateHandler);
            tracks.removeEventListener("addtrack", updateHandler);
            tracks.removeEventListener("labelchange", updateHandler);
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TrackButton", $cb03b711053a4297$var$TrackButton);
/**
 * @file menu-keys.js
 */ /**
  * All keys used for operation of a menu (`MenuButton`, `Menu`, and `MenuItem`)
  * Note that 'Enter' and 'Space' are not included here (otherwise they would
  * prevent the `MenuButton` and `MenuItem` from being keyboard-clickable)
 *
  * @typedef MenuKeys
  * @array
  */ const $cb03b711053a4297$var$MenuKeys = [
    "Tab",
    "Esc",
    "Up",
    "Down",
    "Right",
    "Left"
];
/**
 * @file menu-item.js
 */ /**
 * The component for a menu item. `<li>`
 *
 * @extends ClickableComponent
 */ class $cb03b711053a4297$var$MenuItem extends $cb03b711053a4297$var$ClickableComponent {
    /**
   * Creates an instance of the this class.
   *
   * @param { import('../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */ constructor(player, options){
        super(player, options);
        this.selectable = options.selectable;
        this.isSelected_ = options.selected || false;
        this.multiSelectable = options.multiSelectable;
        this.selected(this.isSelected_);
        if (this.selectable) {
            if (this.multiSelectable) this.el_.setAttribute("role", "menuitemcheckbox");
            else this.el_.setAttribute("role", "menuitemradio");
        } else this.el_.setAttribute("role", "menuitem");
    }
    /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl(type, props, attrs) {
        // The control is textual, not just an icon
        this.nonIconControl = true;
        const el = super.createEl("li", Object.assign({
            className: "vjs-menu-item",
            tabIndex: -1
        }, props), attrs);
        // swap icon with menu item text.
        const menuItemEl = $cb03b711053a4297$var$createEl("span", {
            className: "vjs-menu-item-text",
            textContent: this.localize(this.options_.label)
        });
        // If using SVG icons, the element with vjs-icon-placeholder will be added separately.
        if (this.player_.options_.experimentalSvgIcons) el.appendChild(menuItemEl);
        else el.replaceChild(menuItemEl, el.querySelector(".vjs-icon-placeholder"));
        return el;
    }
    /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        if (!$cb03b711053a4297$var$MenuKeys.some((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, key))) // Pass keydown handling up for unused keys
        super.handleKeyDown(event);
    }
    /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        this.selected(true);
    }
    /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */ selected(selected) {
        if (this.selectable) {
            if (selected) {
                this.addClass("vjs-selected");
                this.el_.setAttribute("aria-checked", "true");
                // aria-checked isn't fully supported by browsers/screen readers,
                // so indicate selected state to screen reader in the control text.
                this.controlText(", selected");
                this.isSelected_ = true;
            } else {
                this.removeClass("vjs-selected");
                this.el_.setAttribute("aria-checked", "false");
                // Indicate un-selected state to screen reader
                this.controlText("");
                this.isSelected_ = false;
            }
        }
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("MenuItem", $cb03b711053a4297$var$MenuItem);
/**
 * @file text-track-menu-item.js
 */ /**
 * The specific menu item type for selecting a language within a text track kind
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$TextTrackMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const tracks = player.textTracks();
        // Modify options for parent MenuItem class's init.
        options.label = track.label || track.language || "Unknown";
        options.selected = track.mode === "showing";
        super(player, options);
        this.track = track;
        // Determine the relevant kind(s) of tracks for this component and filter
        // out empty kinds.
        this.kinds = (options.kinds || [
            options.kind || this.track.kind
        ]).filter(Boolean);
        const changeHandler = (...args)=>{
            this.handleTracksChange.apply(this, args);
        };
        const selectedLanguageChangeHandler = (...args)=>{
            this.handleSelectedLanguageChange.apply(this, args);
        };
        player.on([
            "loadstart",
            "texttrackchange"
        ], changeHandler);
        tracks.addEventListener("change", changeHandler);
        tracks.addEventListener("selectedlanguagechange", selectedLanguageChangeHandler);
        this.on("dispose", function() {
            player.off([
                "loadstart",
                "texttrackchange"
            ], changeHandler);
            tracks.removeEventListener("change", changeHandler);
            tracks.removeEventListener("selectedlanguagechange", selectedLanguageChangeHandler);
        });
        // iOS7 doesn't dispatch change events to TextTrackLists when an
        // associated track's mode changes. Without something like
        // Object.observe() (also not present on iOS7), it's not
        // possible to detect changes to the mode attribute and polyfill
        // the change event. As a poor substitute, we manually dispatch
        // change events whenever the controls modify the mode.
        if (tracks.onchange === undefined) {
            let event;
            this.on([
                "tap",
                "click"
            ], function() {
                if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Event !== "object") // Android 2.3 throws an Illegal Constructor error for window.Event
                try {
                    event = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Event("change");
                } catch (err) {
                // continue regardless of error
                }
                if (!event) {
                    event = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createEvent("Event");
                    event.initEvent("change", true, true);
                }
                tracks.dispatchEvent(event);
            });
        }
        // set the default state based on current tracks
        this.handleTracksChange();
    }
    /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        const referenceTrack = this.track;
        const tracks = this.player_.textTracks();
        super.handleClick(event);
        if (!tracks) return;
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            // If the track from the text tracks list is not of the right kind,
            // skip it. We do not want to affect tracks of incompatible kind(s).
            if (this.kinds.indexOf(track.kind) === -1) continue;
            // If this text track is the component's track and it is not showing,
            // set it to showing.
            if (track === referenceTrack) {
                if (track.mode !== "showing") track.mode = "showing";
            } else if (track.mode !== "disabled") track.mode = "disabled";
        }
    }
    /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */ handleTracksChange(event) {
        const shouldBeSelected = this.track.mode === "showing";
        // Prevent redundant selected() calls because they may cause
        // screen readers to read the appended control text unnecessarily
        if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
    }
    handleSelectedLanguageChange(event) {
        if (this.track.mode === "showing") {
            const selectedLanguage = this.player_.cache_.selectedLanguage;
            // Don't replace the kind of track across the same language
            if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) return;
            this.player_.cache_.selectedLanguage = {
                enabled: true,
                language: this.track.language,
                kind: this.track.kind
            };
        }
    }
    dispose() {
        // remove reference to track object on dispose
        this.track = null;
        super.dispose();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TextTrackMenuItem", $cb03b711053a4297$var$TextTrackMenuItem);
/**
 * @file off-text-track-menu-item.js
 */ /**
 * A special menu item for turning off a specific type of text track
 *
 * @extends TextTrackMenuItem
 */ class $cb03b711053a4297$var$OffTextTrackMenuItem extends $cb03b711053a4297$var$TextTrackMenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        // Create pseudo track info
        // Requires options['kind']
        options.track = {
            player: player,
            // it is no longer necessary to store `kind` or `kinds` on the track itself
            // since they are now stored in the `kinds` property of all instances of
            // TextTrackMenuItem, but this will remain for backwards compatibility
            kind: options.kind,
            kinds: options.kinds,
            default: false,
            mode: "disabled"
        };
        if (!options.kinds) options.kinds = [
            options.kind
        ];
        if (options.label) options.track.label = options.label;
        else options.track.label = options.kinds.join(" and ") + " off";
        // MenuItem is selectable
        options.selectable = true;
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        options.multiSelectable = false;
        super(player, options);
    }
    /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */ handleTracksChange(event) {
        const tracks = this.player().textTracks();
        let shouldBeSelected = true;
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === "showing") {
                shouldBeSelected = false;
                break;
            }
        }
        // Prevent redundant selected() calls because they may cause
        // screen readers to read the appended control text unnecessarily
        if (shouldBeSelected !== this.isSelected_) this.selected(shouldBeSelected);
    }
    handleSelectedLanguageChange(event) {
        const tracks = this.player().textTracks();
        let allHidden = true;
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if ([
                "captions",
                "descriptions",
                "subtitles"
            ].indexOf(track.kind) > -1 && track.mode === "showing") {
                allHidden = false;
                break;
            }
        }
        if (allHidden) this.player_.cache_.selectedLanguage = {
            enabled: false
        };
    }
    /**
   * Update control text and label on languagechange
   */ handleLanguagechange() {
        this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label);
        super.handleLanguagechange();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("OffTextTrackMenuItem", $cb03b711053a4297$var$OffTextTrackMenuItem);
/**
 * @file text-track-button.js
 */ /**
 * The base class for buttons that toggle specific text track types (e.g. subtitles)
 *
 * @extends MenuButton
 */ class $cb03b711053a4297$var$TextTrackButton extends $cb03b711053a4297$var$TrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.tracks = player.textTracks();
        super(player, options);
    }
    /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */ createItems(items = [], TrackMenuItem = $cb03b711053a4297$var$TextTrackMenuItem) {
        // Label is an override for the [track] off label
        // USed to localise captions/subtitles
        let label;
        if (this.label_) label = `${this.label_} off`;
        // Add an OFF menu item to turn all tracks off
        items.push(new $cb03b711053a4297$var$OffTextTrackMenuItem(this.player_, {
            kinds: this.kinds_,
            kind: this.kind_,
            label: label
        }));
        this.hideThreshold_ += 1;
        const tracks = this.player_.textTracks();
        if (!Array.isArray(this.kinds_)) this.kinds_ = [
            this.kind_
        ];
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            // only add tracks that are of an appropriate kind and have a label
            if (this.kinds_.indexOf(track.kind) > -1) {
                const item = new TrackMenuItem(this.player_, {
                    track: track,
                    kinds: this.kinds_,
                    kind: this.kind_,
                    // MenuItem is selectable
                    selectable: true,
                    // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                    multiSelectable: false
                });
                item.addClass(`vjs-${track.kind}-menu-item`);
                items.push(item);
            }
        }
        return items;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TextTrackButton", $cb03b711053a4297$var$TextTrackButton);
/**
 * @file chapters-track-menu-item.js
 */ /**
 * The chapter track menu item
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$ChaptersTrackMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const cue = options.cue;
        const currentTime = player.currentTime();
        // Modify options for parent MenuItem class's init.
        options.selectable = true;
        options.multiSelectable = false;
        options.label = cue.text;
        options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
        super(player, options);
        this.track = track;
        this.cue = cue;
    }
    /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick();
        this.player_.currentTime(this.cue.startTime);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("ChaptersTrackMenuItem", $cb03b711053a4297$var$ChaptersTrackMenuItem);
/**
 * @file chapters-button.js
 */ /**
 * The button component for toggling and selecting chapters
 * Chapters act much differently than other text tracks
 * Cues are navigation vs. other tracks of alternative languages
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$ChaptersButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon("chapters");
        this.selectCurrentItem_ = ()=>{
            this.items.forEach((item)=>{
                item.selected(this.track_.activeCues[0] === item.cue);
            });
        };
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-chapters-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */ update(event) {
        if (event && event.track && event.track.kind !== "chapters") return;
        const track = this.findChaptersTrack();
        if (track !== this.track_) {
            this.setTrack(track);
            super.update();
        } else if (!this.items || track && track.cues && track.cues.length !== this.items.length) // Update the menu initially or if the number of cues has changed since set
        super.update();
    }
    /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */ setTrack(track) {
        if (this.track_ === track) return;
        if (!this.updateHandler_) this.updateHandler_ = this.update.bind(this);
        // here this.track_ refers to the old track instance
        if (this.track_) {
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) remoteTextTrackEl.removeEventListener("load", this.updateHandler_);
            this.track_.removeEventListener("cuechange", this.selectCurrentItem_);
            this.track_ = null;
        }
        this.track_ = track;
        // here this.track_ refers to the new track instance
        if (this.track_) {
            this.track_.mode = "hidden";
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) remoteTextTrackEl.addEventListener("load", this.updateHandler_);
            this.track_.addEventListener("cuechange", this.selectCurrentItem_);
        }
    }
    /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */ findChaptersTrack() {
        const tracks = this.player_.textTracks() || [];
        for(let i = tracks.length - 1; i >= 0; i--){
            // We will always choose the last track as our chaptersTrack
            const track = tracks[i];
            if (track.kind === this.kind_) return track;
        }
    }
    /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */ getMenuCaption() {
        if (this.track_ && this.track_.label) return this.track_.label;
        return this.localize($cb03b711053a4297$var$toTitleCase$1(this.kind_));
    }
    /**
   * Create menu from chapter track
   *
   * @return { import('../../menu/menu').default }
   *         New menu for the chapter buttons
   */ createMenu() {
        this.options_.title = this.getMenuCaption();
        return super.createMenu();
    }
    /**
   * Create a menu item for each text track
   *
   * @return  { import('./text-track-menu-item').default[] }
   *         Array of menu items
   */ createItems() {
        const items = [];
        if (!this.track_) return items;
        const cues = this.track_.cues;
        if (!cues) return items;
        for(let i = 0, l = cues.length; i < l; i++){
            const cue = cues[i];
            const mi = new $cb03b711053a4297$var$ChaptersTrackMenuItem(this.player_, {
                track: this.track_,
                cue: cue
            });
            items.push(mi);
        }
        return items;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$ChaptersButton.prototype.kind_ = "chapters";
/**
 * The text that should display over the `ChaptersButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$ChaptersButton.prototype.controlText_ = "Chapters";
$cb03b711053a4297$var$Component$1.registerComponent("ChaptersButton", $cb03b711053a4297$var$ChaptersButton);
/**
 * @file descriptions-button.js
 */ /**
 * The button component for toggling and selecting descriptions
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$DescriptionsButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon("audio-description");
        const tracks = player.textTracks();
        const changeHandler = $cb03b711053a4297$var$bind_(this, this.handleTracksChange);
        tracks.addEventListener("change", changeHandler);
        this.on("dispose", function() {
            tracks.removeEventListener("change", changeHandler);
        });
    }
    /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */ handleTracksChange(event) {
        const tracks = this.player().textTracks();
        let disabled = false;
        // Check whether a track of a different kind is showing
        for(let i = 0, l = tracks.length; i < l; i++){
            const track = tracks[i];
            if (track.kind !== this.kind_ && track.mode === "showing") {
                disabled = true;
                break;
            }
        }
        // If another track is showing, disable this menu button
        if (disabled) this.disable();
        else this.enable();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-descriptions-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$DescriptionsButton.prototype.kind_ = "descriptions";
/**
 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$DescriptionsButton.prototype.controlText_ = "Descriptions";
$cb03b711053a4297$var$Component$1.registerComponent("DescriptionsButton", $cb03b711053a4297$var$DescriptionsButton);
/**
 * @file subtitles-button.js
 */ /**
 * The button component for toggling and selecting subtitles
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$SubtitlesButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon("subtitles");
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-subtitles-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$SubtitlesButton.prototype.kind_ = "subtitles";
/**
 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$SubtitlesButton.prototype.controlText_ = "Subtitles";
$cb03b711053a4297$var$Component$1.registerComponent("SubtitlesButton", $cb03b711053a4297$var$SubtitlesButton);
/**
 * @file caption-settings-menu-item.js
 */ /**
 * The menu item for caption track settings menu
 *
 * @extends TextTrackMenuItem
 */ class $cb03b711053a4297$var$CaptionSettingsMenuItem extends $cb03b711053a4297$var$TextTrackMenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        options.track = {
            player: player,
            kind: options.kind,
            label: options.kind + " settings",
            selectable: false,
            default: false,
            mode: "disabled"
        };
        // CaptionSettingsMenuItem has no concept of 'selected'
        options.selectable = false;
        options.name = "CaptionSettingsMenuItem";
        super(player, options);
        this.addClass("vjs-texttrack-settings");
        this.controlText(", opens " + options.kind + " settings dialog");
    }
    /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        this.player().getChild("textTrackSettings").open();
    }
    /**
   * Update control text and label on languagechange
   */ handleLanguagechange() {
        this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings");
        super.handleLanguagechange();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("CaptionSettingsMenuItem", $cb03b711053a4297$var$CaptionSettingsMenuItem);
/**
 * @file captions-button.js
 */ /**
 * The button component for toggling and selecting captions
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$CaptionsButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options, ready){
        super(player, options, ready);
        this.setIcon("captions");
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-captions-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */ createItems() {
        const items = [];
        if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings")) {
            items.push(new $cb03b711053a4297$var$CaptionSettingsMenuItem(this.player_, {
                kind: this.kind_
            }));
            this.hideThreshold_ += 1;
        }
        return super.createItems(items);
    }
}
/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$CaptionsButton.prototype.kind_ = "captions";
/**
 * The text that should display over the `CaptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$CaptionsButton.prototype.controlText_ = "Captions";
$cb03b711053a4297$var$Component$1.registerComponent("CaptionsButton", $cb03b711053a4297$var$CaptionsButton);
/**
 * @file subs-caps-menu-item.js
 */ /**
 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
 * in the SubsCapsMenu.
 *
 * @extends TextTrackMenuItem
 */ class $cb03b711053a4297$var$SubsCapsMenuItem extends $cb03b711053a4297$var$TextTrackMenuItem {
    createEl(type, props, attrs) {
        const el = super.createEl(type, props, attrs);
        const parentSpan = el.querySelector(".vjs-menu-item-text");
        if (this.options_.track.kind === "captions") {
            if (this.player_.options_.experimentalSvgIcons) this.setIcon("captions", el);
            else parentSpan.appendChild($cb03b711053a4297$var$createEl("span", {
                className: "vjs-icon-placeholder"
            }, {
                "aria-hidden": true
            }));
            parentSpan.appendChild($cb03b711053a4297$var$createEl("span", {
                className: "vjs-control-text",
                // space added as the text will visually flow with the
                // label
                textContent: ` ${this.localize("Captions")}`
            }));
        }
        return el;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("SubsCapsMenuItem", $cb03b711053a4297$var$SubsCapsMenuItem);
/**
 * @file sub-caps-button.js
 */ /**
 * The button component for toggling and selecting captions and/or subtitles
 *
 * @extends TextTrackButton
 */ class $cb03b711053a4297$var$SubsCapsButton extends $cb03b711053a4297$var$TextTrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */ constructor(player, options = {}){
        super(player, options);
        // Although North America uses "captions" in most cases for
        // "captions and subtitles" other locales use "subtitles"
        this.label_ = "subtitles";
        this.setIcon("subtitles");
        if ([
            "en",
            "en-us",
            "en-ca",
            "fr-ca"
        ].indexOf(this.player_.language_) > -1) {
            this.label_ = "captions";
            this.setIcon("captions");
        }
        this.menuButton_.controlText($cb03b711053a4297$var$toTitleCase$1(this.label_));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-subs-caps-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */ createItems() {
        let items = [];
        if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings")) {
            items.push(new $cb03b711053a4297$var$CaptionSettingsMenuItem(this.player_, {
                kind: this.label_
            }));
            this.hideThreshold_ += 1;
        }
        items = super.createItems(items, $cb03b711053a4297$var$SubsCapsMenuItem);
        return items;
    }
}
/**
 * `kind`s of TextTrack to look for to associate it with this menu.
 *
 * @type {array}
 * @private
 */ $cb03b711053a4297$var$SubsCapsButton.prototype.kinds_ = [
    "captions",
    "subtitles"
];
/**
 * The text that should display over the `SubsCapsButton`s controls.
 *
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$SubsCapsButton.prototype.controlText_ = "Subtitles";
$cb03b711053a4297$var$Component$1.registerComponent("SubsCapsButton", $cb03b711053a4297$var$SubsCapsButton);
/**
 * @file audio-track-menu-item.js
 */ /**
 * An {@link AudioTrack} {@link MenuItem}
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$AudioTrackMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const track = options.track;
        const tracks = player.audioTracks();
        // Modify options for parent MenuItem class's init.
        options.label = track.label || track.language || "Unknown";
        options.selected = track.enabled;
        super(player, options);
        this.track = track;
        this.addClass(`vjs-${track.kind}-menu-item`);
        const changeHandler = (...args)=>{
            this.handleTracksChange.apply(this, args);
        };
        tracks.addEventListener("change", changeHandler);
        this.on("dispose", ()=>{
            tracks.removeEventListener("change", changeHandler);
        });
    }
    createEl(type, props, attrs) {
        const el = super.createEl(type, props, attrs);
        const parentSpan = el.querySelector(".vjs-menu-item-text");
        if ([
            "main-desc",
            "description"
        ].indexOf(this.options_.track.kind) >= 0) {
            parentSpan.appendChild($cb03b711053a4297$var$createEl("span", {
                className: "vjs-icon-placeholder"
            }, {
                "aria-hidden": true
            }));
            parentSpan.appendChild($cb03b711053a4297$var$createEl("span", {
                className: "vjs-control-text",
                textContent: " " + this.localize("Descriptions")
            }));
        }
        return el;
    }
    /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick(event);
        // the audio track list will automatically toggle other tracks
        // off for us.
        this.track.enabled = true;
        // when native audio tracks are used, we want to make sure that other tracks are turned off
        if (this.player_.tech_.featuresNativeAudioTracks) {
            const tracks = this.player_.audioTracks();
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                // skip the current track since we enabled it above
                if (track === this.track) continue;
                track.enabled = track === this.track;
            }
        }
    }
    /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */ handleTracksChange(event) {
        this.selected(this.track.enabled);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("AudioTrackMenuItem", $cb03b711053a4297$var$AudioTrackMenuItem);
/**
 * @file audio-track-button.js
 */ /**
 * The base class for buttons that toggle specific {@link AudioTrack} types.
 *
 * @extends TrackButton
 */ class $cb03b711053a4297$var$AudioTrackButton extends $cb03b711053a4297$var$TrackButton {
    /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */ constructor(player, options = {}){
        options.tracks = player.audioTracks();
        super(player, options);
        this.setIcon("audio");
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-audio-button ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */ createItems(items = []) {
        // if there's only one audio track, there no point in showing it
        this.hideThreshold_ = 1;
        const tracks = this.player_.audioTracks();
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            items.push(new $cb03b711053a4297$var$AudioTrackMenuItem(this.player_, {
                track: track,
                // MenuItem is selectable
                selectable: true,
                // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                multiSelectable: false
            }));
        }
        return items;
    }
}
/**
 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$AudioTrackButton.prototype.controlText_ = "Audio Track";
$cb03b711053a4297$var$Component$1.registerComponent("AudioTrackButton", $cb03b711053a4297$var$AudioTrackButton);
/**
 * @file playback-rate-menu-item.js
 */ /**
 * The specific menu item type for selecting a playback rate.
 *
 * @extends MenuItem
 */ class $cb03b711053a4297$var$PlaybackRateMenuItem extends $cb03b711053a4297$var$MenuItem {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        const label = options.rate;
        const rate = parseFloat(label, 10);
        // Modify options for parent MenuItem class's init.
        options.label = label;
        options.selected = rate === player.playbackRate();
        options.selectable = true;
        options.multiSelectable = false;
        super(player, options);
        this.label = label;
        this.rate = rate;
        this.on(player, "ratechange", (e)=>this.update(e));
    }
    /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */ handleClick(event) {
        super.handleClick();
        this.player().playbackRate(this.rate);
    }
    /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */ update(event) {
        this.selected(this.player().playbackRate() === this.rate);
    }
}
/**
 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */ $cb03b711053a4297$var$PlaybackRateMenuItem.prototype.contentElType = "button";
$cb03b711053a4297$var$Component$1.registerComponent("PlaybackRateMenuItem", $cb03b711053a4297$var$PlaybackRateMenuItem);
/**
 * @file playback-rate-menu-button.js
 */ /**
 * The component for controlling the playback rate.
 *
 * @extends MenuButton
 */ class $cb03b711053a4297$var$PlaybackRateMenuButton extends $cb03b711053a4297$var$MenuButton {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../../player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_);
        this.updateVisibility();
        this.updateLabel();
        this.on(player, "loadstart", (e)=>this.updateVisibility(e));
        this.on(player, "ratechange", (e)=>this.updateLabel(e));
        this.on(player, "playbackrateschange", (e)=>this.handlePlaybackRateschange(e));
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        const el = super.createEl();
        this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_;
        this.labelEl_ = $cb03b711053a4297$var$createEl("div", {
            className: "vjs-playback-rate-value",
            id: this.labelElId_,
            textContent: "1x"
        });
        el.appendChild(this.labelEl_);
        return el;
    }
    dispose() {
        this.labelEl_ = null;
        super.dispose();
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-playback-rate ${super.buildCSSClass()}`;
    }
    buildWrapperCSSClass() {
        return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
    }
    /**
   * Create the list of menu items. Specific to each subclass.
   *
   */ createItems() {
        const rates = this.playbackRates();
        const items = [];
        for(let i = rates.length - 1; i >= 0; i--)items.push(new $cb03b711053a4297$var$PlaybackRateMenuItem(this.player(), {
            rate: rates[i] + "x"
        }));
        return items;
    }
    /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */ handlePlaybackRateschange(event) {
        this.update();
    }
    /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */ playbackRates() {
        const player = this.player();
        return player.playbackRates && player.playbackRates() || [];
    }
    /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */ playbackRateSupported() {
        return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
    }
    /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */ updateVisibility(event) {
        if (this.playbackRateSupported()) this.removeClass("vjs-hidden");
        else this.addClass("vjs-hidden");
    }
    /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */ updateLabel(event) {
        if (this.playbackRateSupported()) this.labelEl_.textContent = this.player().playbackRate() + "x";
    }
}
/**
 * The text that should display over the `PlaybackRateMenuButton`s controls.
 *
 * Added for localization.
 *
 * @type {string}
 * @protected
 */ $cb03b711053a4297$var$PlaybackRateMenuButton.prototype.controlText_ = "Playback Rate";
$cb03b711053a4297$var$Component$1.registerComponent("PlaybackRateMenuButton", $cb03b711053a4297$var$PlaybackRateMenuButton);
/**
 * @file spacer.js
 */ /**
 * Just an empty spacer element that can be used as an append point for plugins, etc.
 * Also can be used to create space between elements when necessary.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$Spacer extends $cb03b711053a4297$var$Component$1 {
    /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */ buildCSSClass() {
        return `vjs-spacer ${super.buildCSSClass()}`;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl(tag = "div", props = {}, attributes = {}) {
        if (!props.className) props.className = this.buildCSSClass();
        return super.createEl(tag, props, attributes);
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("Spacer", $cb03b711053a4297$var$Spacer);
/**
 * @file custom-control-spacer.js
 */ /**
 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
 *
 * @extends Spacer
 */ class $cb03b711053a4297$var$CustomControlSpacer extends $cb03b711053a4297$var$Spacer {
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */ buildCSSClass() {
        return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
    }
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: this.buildCSSClass(),
            // No-flex/table-cell mode requires there be some content
            // in the cell to fill the remaining space of the table.
            textContent: "\xa0"
        });
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("CustomControlSpacer", $cb03b711053a4297$var$CustomControlSpacer);
/**
 * @file control-bar.js
 */ /**
 * Container of main controls.
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ControlBar extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        return super.createEl("div", {
            className: "vjs-control-bar",
            dir: "ltr"
        });
    }
}
/**
 * Default options for `ControlBar`
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$ControlBar.prototype.options_ = {
    children: [
        "playToggle",
        "skipBackward",
        "skipForward",
        "volumePanel",
        "currentTimeDisplay",
        "timeDivider",
        "durationDisplay",
        "progressControl",
        "liveDisplay",
        "seekToLive",
        "remainingTimeDisplay",
        "customControlSpacer",
        "playbackRateMenuButton",
        "chaptersButton",
        "descriptionsButton",
        "subsCapsButton",
        "audioTrackButton",
        "pictureInPictureToggle",
        "fullscreenToggle"
    ]
};
$cb03b711053a4297$var$Component$1.registerComponent("ControlBar", $cb03b711053a4297$var$ControlBar);
/**
 * @file error-display.js
 */ /**
 * A display that indicates an error has occurred. This means that the video
 * is unplayable.
 *
 * @extends ModalDialog
 */ class $cb03b711053a4297$var$ErrorDisplay extends $cb03b711053a4297$var$ModalDialog {
    /**
   * Creates an instance of this class.
   *
   * @param  { import('./player').default } player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */ constructor(player, options){
        super(player, options);
        this.on(player, "error", (e)=>this.open(e));
    }
    /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */ buildCSSClass() {
        return `vjs-error-display ${super.buildCSSClass()}`;
    }
    /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */ content() {
        const error = this.player().error();
        return error ? this.localize(error.message) : "";
    }
}
/**
 * The default options for an `ErrorDisplay`.
 *
 * @private
 */ $cb03b711053a4297$var$ErrorDisplay.prototype.options_ = Object.assign({}, $cb03b711053a4297$var$ModalDialog.prototype.options_, {
    pauseOnOpen: false,
    fillAlways: true,
    temporary: false,
    uncloseable: true
});
$cb03b711053a4297$var$Component$1.registerComponent("ErrorDisplay", $cb03b711053a4297$var$ErrorDisplay);
/**
 * @file text-track-settings.js
 */ const $cb03b711053a4297$var$LOCAL_STORAGE_KEY$1 = "vjs-text-track-settings";
const $cb03b711053a4297$var$COLOR_BLACK = [
    "#000",
    "Black"
];
const $cb03b711053a4297$var$COLOR_BLUE = [
    "#00F",
    "Blue"
];
const $cb03b711053a4297$var$COLOR_CYAN = [
    "#0FF",
    "Cyan"
];
const $cb03b711053a4297$var$COLOR_GREEN = [
    "#0F0",
    "Green"
];
const $cb03b711053a4297$var$COLOR_MAGENTA = [
    "#F0F",
    "Magenta"
];
const $cb03b711053a4297$var$COLOR_RED = [
    "#F00",
    "Red"
];
const $cb03b711053a4297$var$COLOR_WHITE = [
    "#FFF",
    "White"
];
const $cb03b711053a4297$var$COLOR_YELLOW = [
    "#FF0",
    "Yellow"
];
const $cb03b711053a4297$var$OPACITY_OPAQUE = [
    "1",
    "Opaque"
];
const $cb03b711053a4297$var$OPACITY_SEMI = [
    "0.5",
    "Semi-Transparent"
];
const $cb03b711053a4297$var$OPACITY_TRANS = [
    "0",
    "Transparent"
];
// Configuration for the various <select> elements in the DOM of this component.
//
// Possible keys include:
//
// `default`:
//   The default option index. Only needs to be provided if not zero.
// `parser`:
//   A function which is used to parse the value from the selected option in
//   a customized way.
// `selector`:
//   The selector used to find the associated <select> element.
const $cb03b711053a4297$var$selectConfigs = {
    backgroundColor: {
        selector: ".vjs-bg-color > select",
        id: "captions-background-color-%s",
        label: "Color",
        options: [
            $cb03b711053a4297$var$COLOR_BLACK,
            $cb03b711053a4297$var$COLOR_WHITE,
            $cb03b711053a4297$var$COLOR_RED,
            $cb03b711053a4297$var$COLOR_GREEN,
            $cb03b711053a4297$var$COLOR_BLUE,
            $cb03b711053a4297$var$COLOR_YELLOW,
            $cb03b711053a4297$var$COLOR_MAGENTA,
            $cb03b711053a4297$var$COLOR_CYAN
        ]
    },
    backgroundOpacity: {
        selector: ".vjs-bg-opacity > select",
        id: "captions-background-opacity-%s",
        label: "Opacity",
        options: [
            $cb03b711053a4297$var$OPACITY_OPAQUE,
            $cb03b711053a4297$var$OPACITY_SEMI,
            $cb03b711053a4297$var$OPACITY_TRANS
        ]
    },
    color: {
        selector: ".vjs-text-color > select",
        id: "captions-foreground-color-%s",
        label: "Color",
        options: [
            $cb03b711053a4297$var$COLOR_WHITE,
            $cb03b711053a4297$var$COLOR_BLACK,
            $cb03b711053a4297$var$COLOR_RED,
            $cb03b711053a4297$var$COLOR_GREEN,
            $cb03b711053a4297$var$COLOR_BLUE,
            $cb03b711053a4297$var$COLOR_YELLOW,
            $cb03b711053a4297$var$COLOR_MAGENTA,
            $cb03b711053a4297$var$COLOR_CYAN
        ]
    },
    edgeStyle: {
        selector: ".vjs-edge-style > select",
        id: "%s",
        label: "Text Edge Style",
        options: [
            [
                "none",
                "None"
            ],
            [
                "raised",
                "Raised"
            ],
            [
                "depressed",
                "Depressed"
            ],
            [
                "uniform",
                "Uniform"
            ],
            [
                "dropshadow",
                "Drop shadow"
            ]
        ]
    },
    fontFamily: {
        selector: ".vjs-font-family > select",
        id: "captions-font-family-%s",
        label: "Font Family",
        options: [
            [
                "proportionalSansSerif",
                "Proportional Sans-Serif"
            ],
            [
                "monospaceSansSerif",
                "Monospace Sans-Serif"
            ],
            [
                "proportionalSerif",
                "Proportional Serif"
            ],
            [
                "monospaceSerif",
                "Monospace Serif"
            ],
            [
                "casual",
                "Casual"
            ],
            [
                "script",
                "Script"
            ],
            [
                "small-caps",
                "Small Caps"
            ]
        ]
    },
    fontPercent: {
        selector: ".vjs-font-percent > select",
        id: "captions-font-size-%s",
        label: "Font Size",
        options: [
            [
                "0.50",
                "50%"
            ],
            [
                "0.75",
                "75%"
            ],
            [
                "1.00",
                "100%"
            ],
            [
                "1.25",
                "125%"
            ],
            [
                "1.50",
                "150%"
            ],
            [
                "1.75",
                "175%"
            ],
            [
                "2.00",
                "200%"
            ],
            [
                "3.00",
                "300%"
            ],
            [
                "4.00",
                "400%"
            ]
        ],
        default: 2,
        parser: (v)=>v === "1.00" ? null : Number(v)
    },
    textOpacity: {
        selector: ".vjs-text-opacity > select",
        id: "captions-foreground-opacity-%s",
        label: "Opacity",
        options: [
            $cb03b711053a4297$var$OPACITY_OPAQUE,
            $cb03b711053a4297$var$OPACITY_SEMI
        ]
    },
    // Options for this object are defined below.
    windowColor: {
        selector: ".vjs-window-color > select",
        id: "captions-window-color-%s",
        label: "Color"
    },
    // Options for this object are defined below.
    windowOpacity: {
        selector: ".vjs-window-opacity > select",
        id: "captions-window-opacity-%s",
        label: "Opacity",
        options: [
            $cb03b711053a4297$var$OPACITY_TRANS,
            $cb03b711053a4297$var$OPACITY_SEMI,
            $cb03b711053a4297$var$OPACITY_OPAQUE
        ]
    }
};
$cb03b711053a4297$var$selectConfigs.windowColor.options = $cb03b711053a4297$var$selectConfigs.backgroundColor.options;
/**
 * Get the actual value of an option.
 *
 * @param  {string} value
 *         The value to get
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {*}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */ function $cb03b711053a4297$var$parseOptionValue(value, parser) {
    if (parser) value = parser(value);
    if (value && value !== "none") return value;
}
/**
 * Gets the value of the selected <option> element within a <select> element.
 *
 * @param  {Element} el
 *         the element to look in
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {*}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */ function $cb03b711053a4297$var$getSelectedOptionValue(el, parser) {
    const value = el.options[el.options.selectedIndex].value;
    return $cb03b711053a4297$var$parseOptionValue(value, parser);
}
/**
 * Sets the selected <option> element within a <select> element based on a
 * given value.
 *
 * @param {Element} el
 *        The element to look in.
 *
 * @param {string} value
 *        the property to look on.
 *
 * @param {Function} [parser]
 *        Optional function to adjust the value before comparing.
 *
 * @private
 */ function $cb03b711053a4297$var$setSelectedOption(el, value, parser) {
    if (!value) return;
    for(let i = 0; i < el.options.length; i++)if ($cb03b711053a4297$var$parseOptionValue(el.options[i].value, parser) === value) {
        el.selectedIndex = i;
        break;
    }
}
/**
 * Manipulate Text Tracks settings.
 *
 * @extends ModalDialog
 */ class $cb03b711053a4297$var$TextTrackSettings extends $cb03b711053a4297$var$ModalDialog {
    /**
   * Creates an instance of this class.
   *
   * @param { import('../player').default } player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */ constructor(player, options){
        options.temporary = false;
        super(player, options);
        this.updateDisplay = this.updateDisplay.bind(this);
        // fill the modal and pretend we have opened it
        this.fill();
        this.hasBeenOpened_ = this.hasBeenFilled_ = true;
        this.endDialog = $cb03b711053a4297$var$createEl("p", {
            className: "vjs-control-text",
            textContent: this.localize("End of dialog window.")
        });
        this.el().appendChild(this.endDialog);
        this.setDefaults();
        // Grab `persistTextTrackSettings` from the player options if not passed in child options
        if (options.persistTextTrackSettings === undefined) this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings;
        this.on(this.$(".vjs-done-button"), "click", ()=>{
            this.saveSettings();
            this.close();
        });
        this.on(this.$(".vjs-default-button"), "click", ()=>{
            this.setDefaults();
            this.updateDisplay();
        });
        $cb03b711053a4297$var$each($cb03b711053a4297$var$selectConfigs, (config)=>{
            this.on(this.$(config.selector), "change", this.updateDisplay);
        });
        if (this.options_.persistTextTrackSettings) this.restoreSettings();
    }
    dispose() {
        this.endDialog = null;
        super.dispose();
    }
    /**
   * Create a <select> element with configured options.
   *
   * @param {string} key
   *        Configuration key to use during creation.
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */ createElSelect_(key, legendId = "", type = "label") {
        const config = $cb03b711053a4297$var$selectConfigs[key];
        const id = config.id.replace("%s", this.id_);
        const selectLabelledbyIds = [
            legendId,
            id
        ].join(" ").trim();
        return [
            `<${type} id="${id}" class="${type === "label" ? "vjs-label" : ""}">`,
            this.localize(config.label),
            `</${type}>`,
            `<select aria-labelledby="${selectLabelledbyIds}">`
        ].concat(config.options.map((o)=>{
            const optionId = id + "-" + o[1].replace(/\W+/g, "");
            return [
                `<option id="${optionId}" value="${o[0]}" `,
                `aria-labelledby="${selectLabelledbyIds} ${optionId}">`,
                this.localize(o[1]),
                "</option>"
            ].join("");
        })).concat("</select>").join("");
    }
    /**
   * Create foreground color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */ createElFgColor_() {
        const legendId = `captions-text-legend-${this.id_}`;
        return [
            '<fieldset class="vjs-fg vjs-track-setting">',
            `<legend id="${legendId}">`,
            this.localize("Text"),
            "</legend>",
            '<span class="vjs-text-color">',
            this.createElSelect_("color", legendId),
            "</span>",
            '<span class="vjs-text-opacity vjs-opacity">',
            this.createElSelect_("textOpacity", legendId),
            "</span>",
            "</fieldset>"
        ].join("");
    }
    /**
   * Create background color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */ createElBgColor_() {
        const legendId = `captions-background-${this.id_}`;
        return [
            '<fieldset class="vjs-bg vjs-track-setting">',
            `<legend id="${legendId}">`,
            this.localize("Text Background"),
            "</legend>",
            '<span class="vjs-bg-color">',
            this.createElSelect_("backgroundColor", legendId),
            "</span>",
            '<span class="vjs-bg-opacity vjs-opacity">',
            this.createElSelect_("backgroundOpacity", legendId),
            "</span>",
            "</fieldset>"
        ].join("");
    }
    /**
   * Create window color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */ createElWinColor_() {
        const legendId = `captions-window-${this.id_}`;
        return [
            '<fieldset class="vjs-window vjs-track-setting">',
            `<legend id="${legendId}">`,
            this.localize("Caption Area Background"),
            "</legend>",
            '<span class="vjs-window-color">',
            this.createElSelect_("windowColor", legendId),
            "</span>",
            '<span class="vjs-window-opacity vjs-opacity">',
            this.createElSelect_("windowOpacity", legendId),
            "</span>",
            "</fieldset>"
        ].join("");
    }
    /**
   * Create color elements for the component
   *
   * @return {Element}
   *         The element that was created
   *
   * @private
   */ createElColors_() {
        return $cb03b711053a4297$var$createEl("div", {
            className: "vjs-track-settings-colors",
            innerHTML: [
                this.createElFgColor_(),
                this.createElBgColor_(),
                this.createElWinColor_()
            ].join("")
        });
    }
    /**
   * Create font elements for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */ createElFont_() {
        return $cb03b711053a4297$var$createEl("div", {
            className: "vjs-track-settings-font",
            innerHTML: [
                '<fieldset class="vjs-font-percent vjs-track-setting">',
                this.createElSelect_("fontPercent", "", "legend"),
                "</fieldset>",
                '<fieldset class="vjs-edge-style vjs-track-setting">',
                this.createElSelect_("edgeStyle", "", "legend"),
                "</fieldset>",
                '<fieldset class="vjs-font-family vjs-track-setting">',
                this.createElSelect_("fontFamily", "", "legend"),
                "</fieldset>"
            ].join("")
        });
    }
    /**
   * Create controls for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */ createElControls_() {
        const defaultsDescription = this.localize("restore all settings to the default values");
        return $cb03b711053a4297$var$createEl("div", {
            className: "vjs-track-settings-controls",
            innerHTML: [
                `<button type="button" class="vjs-default-button" title="${defaultsDescription}">`,
                this.localize("Reset"),
                `<span class="vjs-control-text"> ${defaultsDescription}</span>`,
                "</button>",
                `<button type="button" class="vjs-done-button">${this.localize("Done")}</button>`
            ].join("")
        });
    }
    content() {
        return [
            this.createElColors_(),
            this.createElFont_(),
            this.createElControls_()
        ];
    }
    label() {
        return this.localize("Caption Settings Dialog");
    }
    description() {
        return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
    }
    buildCSSClass() {
        return super.buildCSSClass() + " vjs-text-track-settings";
    }
    /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */ getValues() {
        return $cb03b711053a4297$var$reduce($cb03b711053a4297$var$selectConfigs, (accum, config, key)=>{
            const value = $cb03b711053a4297$var$getSelectedOptionValue(this.$(config.selector), config.parser);
            if (value !== undefined) accum[key] = value;
            return accum;
        }, {});
    }
    /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */ setValues(values) {
        $cb03b711053a4297$var$each($cb03b711053a4297$var$selectConfigs, (config, key)=>{
            $cb03b711053a4297$var$setSelectedOption(this.$(config.selector), values[key], config.parser);
        });
    }
    /**
   * Sets all `<select>` elements to their default values.
   */ setDefaults() {
        $cb03b711053a4297$var$each($cb03b711053a4297$var$selectConfigs, (config)=>{
            const index = config.hasOwnProperty("default") ? config.default : 0;
            this.$(config.selector).selectedIndex = index;
        });
    }
    /**
   * Restore texttrack settings from localStorage
   */ restoreSettings() {
        let values;
        try {
            values = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.getItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY$1));
        } catch (err) {
            $cb03b711053a4297$var$log$1.warn(err);
        }
        if (values) this.setValues(values);
    }
    /**
   * Save text track settings to localStorage
   */ saveSettings() {
        if (!this.options_.persistTextTrackSettings) return;
        const values = this.getValues();
        try {
            if (Object.keys(values).length) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.setItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY$1, JSON.stringify(values));
            else (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.removeItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY$1);
        } catch (err) {
            $cb03b711053a4297$var$log$1.warn(err);
        }
    }
    /**
   * Update display of text track settings
   */ updateDisplay() {
        const ttDisplay = this.player_.getChild("textTrackDisplay");
        if (ttDisplay) ttDisplay.updateDisplay();
    }
    /**
   * conditionally blur the element and refocus the captions button
   *
   * @private
   */ conditionalBlur_() {
        this.previouslyActiveEl_ = null;
        const cb = this.player_.controlBar;
        const subsCapsBtn = cb && cb.subsCapsButton;
        const ccBtn = cb && cb.captionsButton;
        if (subsCapsBtn) subsCapsBtn.focus();
        else if (ccBtn) ccBtn.focus();
    }
    /**
   * Repopulate dialog with new localizations on languagechange
   */ handleLanguagechange() {
        this.fill();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TextTrackSettings", $cb03b711053a4297$var$TextTrackSettings);
/**
 * @file resize-manager.js
 */ /**
 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
 *
 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
 *
 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
 *
 * @example <caption>How to disable the resize manager</caption>
 * const player = videojs('#vid', {
 *   resizeManager: false
 * });
 *
 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
 *
 * @extends Component
 */ class $cb03b711053a4297$var$ResizeManager extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */ constructor(player, options){
        let RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ResizeObserver;
        // if `null` was passed, we want to disable the ResizeObserver
        if (options.ResizeObserver === null) RESIZE_OBSERVER_AVAILABLE = false;
        // Only create an element when ResizeObserver isn't available
        const options_ = $cb03b711053a4297$var$merge$1({
            createEl: !RESIZE_OBSERVER_AVAILABLE,
            reportTouchActivity: false
        }, options);
        super(player, options_);
        this.ResizeObserver = options.ResizeObserver || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ResizeObserver;
        this.loadListener_ = null;
        this.resizeObserver_ = null;
        this.debouncedHandler_ = $cb03b711053a4297$var$debounce(()=>{
            this.resizeHandler();
        }, 100, false, this);
        if (RESIZE_OBSERVER_AVAILABLE) {
            this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_);
            this.resizeObserver_.observe(player.el());
        } else {
            this.loadListener_ = ()=>{
                if (!this.el_ || !this.el_.contentWindow) return;
                const debouncedHandler_ = this.debouncedHandler_;
                let unloadListener_ = this.unloadListener_ = function() {
                    $cb03b711053a4297$var$off(this, "resize", debouncedHandler_);
                    $cb03b711053a4297$var$off(this, "unload", unloadListener_);
                    unloadListener_ = null;
                };
                // safari and edge can unload the iframe before resizemanager dispose
                // we have to dispose of event handlers correctly before that happens
                $cb03b711053a4297$var$on(this.el_.contentWindow, "unload", unloadListener_);
                $cb03b711053a4297$var$on(this.el_.contentWindow, "resize", debouncedHandler_);
            };
            this.one("load", this.loadListener_);
        }
    }
    createEl() {
        return super.createEl("iframe", {
            className: "vjs-resize-manager",
            tabIndex: -1,
            title: this.localize("No content")
        }, {
            "aria-hidden": "true"
        });
    }
    /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */ resizeHandler() {
        /**
     * Called when the player size has changed
     *
     * @event Player#playerresize
     * @type {Event}
     */ // make sure player is still around to trigger
        // prevents this from causing an error after dispose
        if (!this.player_ || !this.player_.trigger) return;
        this.player_.trigger("playerresize");
    }
    dispose() {
        if (this.debouncedHandler_) this.debouncedHandler_.cancel();
        if (this.resizeObserver_) {
            if (this.player_.el()) this.resizeObserver_.unobserve(this.player_.el());
            this.resizeObserver_.disconnect();
        }
        if (this.loadListener_) this.off("load", this.loadListener_);
        if (this.el_ && this.el_.contentWindow && this.unloadListener_) this.unloadListener_.call(this.el_.contentWindow);
        this.ResizeObserver = null;
        this.resizeObserver = null;
        this.debouncedHandler_ = null;
        this.loadListener_ = null;
        super.dispose();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("ResizeManager", $cb03b711053a4297$var$ResizeManager);
const $cb03b711053a4297$var$defaults = {
    trackingThreshold: 20,
    liveTolerance: 15
};
/*
  track when we are at the live edge, and other helpers for live playback */ /**
 * A class for checking live current time and determining when the player
 * is at or behind the live edge.
 */ class $cb03b711053a4297$var$LiveTracker extends $cb03b711053a4297$var$Component$1 {
    /**
   * Creates an instance of this class.
   *
   * @param { import('./player').default } player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */ constructor(player, options){
        // LiveTracker does not need an element
        const options_ = $cb03b711053a4297$var$merge$1($cb03b711053a4297$var$defaults, options, {
            createEl: false
        });
        super(player, options_);
        this.trackLiveHandler_ = ()=>this.trackLive_();
        this.handlePlay_ = (e)=>this.handlePlay(e);
        this.handleFirstTimeupdate_ = (e)=>this.handleFirstTimeupdate(e);
        this.handleSeeked_ = (e)=>this.handleSeeked(e);
        this.seekToLiveEdge_ = (e)=>this.seekToLiveEdge(e);
        this.reset_();
        this.on(this.player_, "durationchange", (e)=>this.handleDurationchange(e));
        // we should try to toggle tracking on canplay as native playback engines, like Safari
        // may not have the proper values for things like seekableEnd until then
        this.on(this.player_, "canplay", ()=>this.toggleTracking());
    }
    /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */ trackLive_() {
        const seekable = this.player_.seekable();
        // skip undefined seekable
        if (!seekable || !seekable.length) return;
        const newTime = Number((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now().toFixed(4));
        const deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1000;
        this.lastTime_ = newTime;
        this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
        const liveCurrentTime = this.liveCurrentTime();
        const currentTime = this.player_.currentTime();
        // we are behind live if any are true
        // 1. the player is paused
        // 2. the user seeked to a location 2 seconds away from live
        // 3. the difference between live and current time is greater
        //    liveTolerance which defaults to 15s
        let isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance;
        // we cannot be behind if
        // 1. until we have not seen a timeupdate yet
        // 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
        if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) isBehind = false;
        if (isBehind !== this.behindLiveEdge_) {
            this.behindLiveEdge_ = isBehind;
            this.trigger("liveedgechange");
        }
    }
    /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */ handleDurationchange() {
        this.toggleTracking();
    }
    /**
   * start/stop tracking
   */ toggleTracking() {
        if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
            if (this.player_.options_.liveui) this.player_.addClass("vjs-liveui");
            this.startTracking();
        } else {
            this.player_.removeClass("vjs-liveui");
            this.stopTracking();
        }
    }
    /**
   * start tracking live playback
   */ startTracking() {
        if (this.isTracking()) return;
        // If we haven't seen a timeupdate, we need to check whether playback
        // began before this component started tracking. This can happen commonly
        // when using autoplay.
        if (!this.timeupdateSeen_) this.timeupdateSeen_ = this.player_.hasStarted();
        this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, $cb03b711053a4297$var$UPDATE_REFRESH_INTERVAL);
        this.trackLive_();
        this.on(this.player_, [
            "play",
            "pause"
        ], this.trackLiveHandler_);
        if (!this.timeupdateSeen_) {
            this.one(this.player_, "play", this.handlePlay_);
            this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_);
        } else this.on(this.player_, "seeked", this.handleSeeked_);
    }
    /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */ handleFirstTimeupdate() {
        this.timeupdateSeen_ = true;
        this.on(this.player_, "seeked", this.handleSeeked_);
    }
    /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */ handleSeeked() {
        const timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
        this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
        this.nextSeekedFromUser_ = false;
        this.trackLive_();
    }
    /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */ handlePlay() {
        this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
    }
    /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */ reset_() {
        this.lastTime_ = -1;
        this.pastSeekEnd_ = 0;
        this.lastSeekEnd_ = -1;
        this.behindLiveEdge_ = true;
        this.timeupdateSeen_ = false;
        this.seekedBehindLive_ = false;
        this.nextSeekedFromUser_ = false;
        this.clearInterval(this.trackingInterval_);
        this.trackingInterval_ = null;
        this.off(this.player_, [
            "play",
            "pause"
        ], this.trackLiveHandler_);
        this.off(this.player_, "seeked", this.handleSeeked_);
        this.off(this.player_, "play", this.handlePlay_);
        this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_);
        this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
    }
    /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */ nextSeekedFromUser() {
        this.nextSeekedFromUser_ = true;
    }
    /**
   * stop tracking live playback
   */ stopTracking() {
        if (!this.isTracking()) return;
        this.reset_();
        this.trigger("liveedgechange");
    }
    /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */ seekableEnd() {
        const seekable = this.player_.seekable();
        const seekableEnds = [];
        let i = seekable ? seekable.length : 0;
        while(i--)seekableEnds.push(seekable.end(i));
        // grab the furthest seekable end after sorting, or if there are none
        // default to Infinity
        return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
    }
    /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */ seekableStart() {
        const seekable = this.player_.seekable();
        const seekableStarts = [];
        let i = seekable ? seekable.length : 0;
        while(i--)seekableStarts.push(seekable.start(i));
        // grab the first seekable start after sorting, or if there are none
        // default to 0
        return seekableStarts.length ? seekableStarts.sort()[0] : 0;
    }
    /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */ liveWindow() {
        const liveCurrentTime = this.liveCurrentTime();
        // if liveCurrenTime is Infinity then we don't have a liveWindow at all
        if (liveCurrentTime === Infinity) return 0;
        return liveCurrentTime - this.seekableStart();
    }
    /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */ isLive() {
        return this.isTracking();
    }
    /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */ atLiveEdge() {
        return !this.behindLiveEdge();
    }
    /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */ liveCurrentTime() {
        return this.pastSeekEnd() + this.seekableEnd();
    }
    /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */ pastSeekEnd() {
        const seekableEnd = this.seekableEnd();
        if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) this.pastSeekEnd_ = 0;
        this.lastSeekEnd_ = seekableEnd;
        return this.pastSeekEnd_;
    }
    /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */ behindLiveEdge() {
        return this.behindLiveEdge_;
    }
    /**
   * Whether live tracker is currently tracking or not.
   */ isTracking() {
        return typeof this.trackingInterval_ === "number";
    }
    /**
   * Seek to the live edge if we are behind the live edge
   */ seekToLiveEdge() {
        this.seekedBehindLive_ = false;
        if (this.atLiveEdge()) return;
        this.nextSeekedFromUser_ = false;
        this.player_.currentTime(this.liveCurrentTime());
    }
    /**
   * Dispose of liveTracker
   */ dispose() {
        this.stopTracking();
        super.dispose();
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("LiveTracker", $cb03b711053a4297$var$LiveTracker);
/**
 * Displays an element over the player which contains an optional title and
 * description for the current content.
 *
 * Much of the code for this component originated in the now obsolete
 * videojs-dock plugin: https://github.com/brightcove/videojs-dock/
 *
 * @extends Component
 */ class $cb03b711053a4297$var$TitleBar extends $cb03b711053a4297$var$Component$1 {
    constructor(player, options){
        super(player, options);
        this.on("statechanged", (e)=>this.updateDom_());
        this.updateDom_();
    }
    /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */ createEl() {
        this.els = {
            title: $cb03b711053a4297$var$createEl("div", {
                className: "vjs-title-bar-title",
                id: `vjs-title-bar-title-${$cb03b711053a4297$var$newGUID()}`
            }),
            description: $cb03b711053a4297$var$createEl("div", {
                className: "vjs-title-bar-description",
                id: `vjs-title-bar-description-${$cb03b711053a4297$var$newGUID()}`
            })
        };
        return $cb03b711053a4297$var$createEl("div", {
            className: "vjs-title-bar"
        }, {}, $cb03b711053a4297$var$values(this.els));
    }
    /**
   * Updates the DOM based on the component's state object.
   */ updateDom_() {
        const tech = this.player_.tech_;
        const techEl = tech && tech.el_;
        const techAriaAttrs = {
            title: "aria-labelledby",
            description: "aria-describedby"
        };
        [
            "title",
            "description"
        ].forEach((k)=>{
            const value = this.state[k];
            const el = this.els[k];
            const techAriaAttr = techAriaAttrs[k];
            $cb03b711053a4297$var$emptyEl(el);
            if (value) $cb03b711053a4297$var$textContent(el, value);
            // If there is a tech element available, update its ARIA attributes
            // according to whether a title and/or description have been provided.
            if (techEl) {
                techEl.removeAttribute(techAriaAttr);
                if (value) techEl.setAttribute(techAriaAttr, el.id);
            }
        });
        if (this.state.title || this.state.description) this.show();
        else this.hide();
    }
    /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */ update(options) {
        this.setState(options);
    }
    /**
   * Dispose the component.
   */ dispose() {
        const tech = this.player_.tech_;
        const techEl = tech && tech.el_;
        if (techEl) {
            techEl.removeAttribute("aria-labelledby");
            techEl.removeAttribute("aria-describedby");
        }
        super.dispose();
        this.els = null;
    }
}
$cb03b711053a4297$var$Component$1.registerComponent("TitleBar", $cb03b711053a4297$var$TitleBar);
/**
 * This function is used to fire a sourceset when there is something
 * similar to `mediaEl.load()` being called. It will try to find the source via
 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
 * with the source that was found or empty string if we cannot know. If it cannot
 * find a source then `sourceset` will not be fired.
 *
 * @param { import('./html5').default } tech
 *        The tech object that sourceset was setup on
 *
 * @return {boolean}
 *         returns false if the sourceset was not fired and true otherwise.
 */ const $cb03b711053a4297$var$sourcesetLoad = (tech)=>{
    const el = tech.el();
    // if `el.src` is set, that source will be loaded.
    if (el.hasAttribute("src")) {
        tech.triggerSourceset(el.src);
        return true;
    }
    /**
   * Since there isn't a src property on the media element, source elements will be used for
   * implementing the source selection algorithm. This happens asynchronously and
   * for most cases were there is more than one source we cannot tell what source will
   * be loaded, without re-implementing the source selection algorithm. At this time we are not
   * going to do that. There are three special cases that we do handle here though:
   *
   * 1. If there are no sources, do not fire `sourceset`.
   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
   * 3. If there is more than one `<source>` but all of them have the same `src` url.
   *    That will be our src.
   */ const sources = tech.$$("source");
    const srcUrls = [];
    let src = "";
    // if there are no sources, do not fire sourceset
    if (!sources.length) return false;
    // only count valid/non-duplicate source elements
    for(let i = 0; i < sources.length; i++){
        const url = sources[i].src;
        if (url && srcUrls.indexOf(url) === -1) srcUrls.push(url);
    }
    // there were no valid sources
    if (!srcUrls.length) return false;
    // there is only one valid source element url
    // use that
    if (srcUrls.length === 1) src = srcUrls[0];
    tech.triggerSourceset(src);
    return true;
};
/**
 * our implementation of an `innerHTML` descriptor for browsers
 * that do not have one.
 */ const $cb03b711053a4297$var$innerHTMLDescriptorPolyfill = Object.defineProperty({}, "innerHTML", {
    get () {
        return this.cloneNode(true).innerHTML;
    },
    set (v) {
        // make a dummy node to use innerHTML on
        const dummy = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement(this.nodeName.toLowerCase());
        // set innerHTML to the value provided
        dummy.innerHTML = v;
        // make a document fragment to hold the nodes from dummy
        const docFrag = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createDocumentFragment();
        // copy all of the nodes created by the innerHTML on dummy
        // to the document fragment
        while(dummy.childNodes.length)docFrag.appendChild(dummy.childNodes[0]);
        // remove content
        this.innerText = "";
        // now we add all of that html in one by appending the
        // document fragment. This is how innerHTML does it.
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype.appendChild.call(this, docFrag);
        // then return the result that innerHTML's setter would
        return this.innerHTML;
    }
});
/**
 * Get a property descriptor given a list of priorities and the
 * property to get.
 */ const $cb03b711053a4297$var$getDescriptor = (priority, prop)=>{
    let descriptor = {};
    for(let i = 0; i < priority.length; i++){
        descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
        if (descriptor && descriptor.set && descriptor.get) break;
    }
    descriptor.enumerable = true;
    descriptor.configurable = true;
    return descriptor;
};
const $cb03b711053a4297$var$getInnerHTMLDescriptor = (tech)=>$cb03b711053a4297$var$getDescriptor([
        tech.el(),
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLMediaElement.prototype,
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype,
        $cb03b711053a4297$var$innerHTMLDescriptorPolyfill
    ], "innerHTML");
/**
 * Patches browser internal functions so that we can tell synchronously
 * if a `<source>` was appended to the media element. For some reason this
 * causes a `sourceset` if the the media element is ready and has no source.
 * This happens when:
 * - The page has just loaded and the media element does not have a source.
 * - The media element was emptied of all sources, then `load()` was called.
 *
 * It does this by patching the following functions/properties when they are supported:
 *
 * - `append()` - can be used to add a `<source>` element to the media element
 * - `appendChild()` - can be used to add a `<source>` element to the media element
 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
 * - `innerHTML` -  can be used to add a `<source>` element to the media element
 *
 * @param {Html5} tech
 *        The tech object that sourceset is being setup on.
 */ const $cb03b711053a4297$var$firstSourceWatch = function(tech) {
    const el = tech.el();
    // make sure firstSourceWatch isn't setup twice.
    if (el.resetSourceWatch_) return;
    const old = {};
    const innerDescriptor = $cb03b711053a4297$var$getInnerHTMLDescriptor(tech);
    const appendWrapper = (appendFn)=>(...args)=>{
            const retval = appendFn.apply(el, args);
            $cb03b711053a4297$var$sourcesetLoad(tech);
            return retval;
        };
    [
        "append",
        "appendChild",
        "insertAdjacentHTML"
    ].forEach((k)=>{
        if (!el[k]) return;
        // store the old function
        old[k] = el[k];
        // call the old function with a sourceset if a source
        // was loaded
        el[k] = appendWrapper(old[k]);
    });
    Object.defineProperty(el, "innerHTML", $cb03b711053a4297$var$merge$1(innerDescriptor, {
        set: appendWrapper(innerDescriptor.set)
    }));
    el.resetSourceWatch_ = ()=>{
        el.resetSourceWatch_ = null;
        Object.keys(old).forEach((k)=>{
            el[k] = old[k];
        });
        Object.defineProperty(el, "innerHTML", innerDescriptor);
    };
    // on the first sourceset, we need to revert our changes
    tech.one("sourceset", el.resetSourceWatch_);
};
/**
 * our implementation of a `src` descriptor for browsers
 * that do not have one
 */ const $cb03b711053a4297$var$srcDescriptorPolyfill = Object.defineProperty({}, "src", {
    get () {
        if (this.hasAttribute("src")) return $cb03b711053a4297$var$getAbsoluteURL((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype.getAttribute.call(this, "src"));
        return "";
    },
    set (v) {
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Element.prototype.setAttribute.call(this, "src", v);
        return v;
    }
});
const $cb03b711053a4297$var$getSrcDescriptor = (tech)=>$cb03b711053a4297$var$getDescriptor([
        tech.el(),
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).HTMLMediaElement.prototype,
        $cb03b711053a4297$var$srcDescriptorPolyfill
    ], "src");
/**
 * setup `sourceset` handling on the `Html5` tech. This function
 * patches the following element properties/functions:
 *
 * - `src` - to determine when `src` is set
 * - `setAttribute()` - to determine when `src` is set
 * - `load()` - this re-triggers the source selection algorithm, and can
 *              cause a sourceset.
 *
 * If there is no source when we are adding `sourceset` support or during a `load()`
 * we also patch the functions listed in `firstSourceWatch`.
 *
 * @param {Html5} tech
 *        The tech to patch
 */ const $cb03b711053a4297$var$setupSourceset = function(tech) {
    if (!tech.featuresSourceset) return;
    const el = tech.el();
    // make sure sourceset isn't setup twice.
    if (el.resetSourceset_) return;
    const srcDescriptor = $cb03b711053a4297$var$getSrcDescriptor(tech);
    const oldSetAttribute = el.setAttribute;
    const oldLoad = el.load;
    Object.defineProperty(el, "src", $cb03b711053a4297$var$merge$1(srcDescriptor, {
        set: (v)=>{
            const retval = srcDescriptor.set.call(el, v);
            // we use the getter here to get the actual value set on src
            tech.triggerSourceset(el.src);
            return retval;
        }
    }));
    el.setAttribute = (n, v)=>{
        const retval = oldSetAttribute.call(el, n, v);
        if (/src/i.test(n)) tech.triggerSourceset(el.src);
        return retval;
    };
    el.load = ()=>{
        const retval = oldLoad.call(el);
        // if load was called, but there was no source to fire
        // sourceset on. We have to watch for a source append
        // as that can trigger a `sourceset` when the media element
        // has no source
        if (!$cb03b711053a4297$var$sourcesetLoad(tech)) {
            tech.triggerSourceset("");
            $cb03b711053a4297$var$firstSourceWatch(tech);
        }
        return retval;
    };
    if (el.currentSrc) tech.triggerSourceset(el.currentSrc);
    else if (!$cb03b711053a4297$var$sourcesetLoad(tech)) $cb03b711053a4297$var$firstSourceWatch(tech);
    el.resetSourceset_ = ()=>{
        el.resetSourceset_ = null;
        el.load = oldLoad;
        el.setAttribute = oldSetAttribute;
        Object.defineProperty(el, "src", srcDescriptor);
        if (el.resetSourceWatch_) el.resetSourceWatch_();
    };
};
/**
 * @file html5.js
 */ /**
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 *
 * @mixes Tech~SourceHandlerAdditions
 * @extends Tech
 */ class $cb03b711053a4297$var$Html5 extends $cb03b711053a4297$var$Tech {
    /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */ constructor(options, ready){
        super(options, ready);
        const source = options.source;
        let crossoriginTracks = false;
        this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO";
        // Set the source if one is provided
        // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
        // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
        // anyway so the error gets fired.
        if (source && (this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) this.setSource(source);
        else this.handleLateInit_(this.el_);
        // setup sourceset after late sourceset/init
        if (options.enableSourceset) this.setupSourcesetHandling_();
        this.isScrubbing_ = false;
        if (this.el_.hasChildNodes()) {
            const nodes = this.el_.childNodes;
            let nodesLength = nodes.length;
            const removeNodes = [];
            while(nodesLength--){
                const node = nodes[nodesLength];
                const nodeName = node.nodeName.toLowerCase();
                if (nodeName === "track") {
                    if (!this.featuresNativeTextTracks) // Empty video tag tracks so the built-in player doesn't use them also.
                    // This may not be fast enough to stop HTML5 browsers from reading the tags
                    // so we'll need to turn off any default tracks if we're manually doing
                    // captions and subtitles. videoElement.textTracks
                    removeNodes.push(node);
                    else {
                        // store HTMLTrackElement and TextTrack to remote list
                        this.remoteTextTrackEls().addTrackElement_(node);
                        this.remoteTextTracks().addTrack(node.track);
                        this.textTracks().addTrack(node.track);
                        if (!crossoriginTracks && !this.el_.hasAttribute("crossorigin") && $cb03b711053a4297$var$isCrossOrigin(node.src)) crossoriginTracks = true;
                    }
                }
            }
            for(let i = 0; i < removeNodes.length; i++)this.el_.removeChild(removeNodes[i]);
        }
        this.proxyNativeTracks_();
        if (this.featuresNativeTextTracks && crossoriginTracks) $cb03b711053a4297$var$log$1.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading.");
        // prevent iOS Safari from disabling metadata text tracks during native playback
        this.restoreMetadataTracksInIOSNativePlayer_();
        // Determine if native controls should be used
        // Our goal should be to get the custom controls on mobile solid everywhere
        // so we can remove this all together. Right now this will block custom
        // controls on touch enabled laptops like the Chrome Pixel
        if (($cb03b711053a4297$var$TOUCH_ENABLED || $cb03b711053a4297$var$IS_IPHONE) && options.nativeControlsForTouch === true) this.setControls(true);
        // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
        // into a `fullscreenchange` event
        this.proxyWebkitFullscreen_();
        this.triggerReady();
    }
    /**
   * Dispose of `HTML5` media element and remove all tracks.
   */ dispose() {
        if (this.el_ && this.el_.resetSourceset_) this.el_.resetSourceset_();
        $cb03b711053a4297$var$Html5.disposeMediaElement(this.el_);
        this.options_ = null;
        // tech will handle clearing of the emulated track list
        super.dispose();
    }
    /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */ setupSourcesetHandling_() {
        $cb03b711053a4297$var$setupSourceset(this);
    }
    /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */ restoreMetadataTracksInIOSNativePlayer_() {
        const textTracks = this.textTracks();
        let metadataTracksPreFullscreenState;
        // captures a snapshot of every metadata track's current state
        const takeMetadataTrackSnapshot = ()=>{
            metadataTracksPreFullscreenState = [];
            for(let i = 0; i < textTracks.length; i++){
                const track = textTracks[i];
                if (track.kind === "metadata") metadataTracksPreFullscreenState.push({
                    track: track,
                    storedMode: track.mode
                });
            }
        };
        // snapshot each metadata track's initial state, and update the snapshot
        // each time there is a track 'change' event
        takeMetadataTrackSnapshot();
        textTracks.addEventListener("change", takeMetadataTrackSnapshot);
        this.on("dispose", ()=>textTracks.removeEventListener("change", takeMetadataTrackSnapshot));
        const restoreTrackMode = ()=>{
            for(let i = 0; i < metadataTracksPreFullscreenState.length; i++){
                const storedTrack = metadataTracksPreFullscreenState[i];
                if (storedTrack.track.mode === "disabled" && storedTrack.track.mode !== storedTrack.storedMode) storedTrack.track.mode = storedTrack.storedMode;
            }
            // we only want this handler to be executed on the first 'change' event
            textTracks.removeEventListener("change", restoreTrackMode);
        };
        // when we enter fullscreen playback, stop updating the snapshot and
        // restore all track modes to their pre-fullscreen state
        this.on("webkitbeginfullscreen", ()=>{
            textTracks.removeEventListener("change", takeMetadataTrackSnapshot);
            // remove the listener before adding it just in case it wasn't previously removed
            textTracks.removeEventListener("change", restoreTrackMode);
            textTracks.addEventListener("change", restoreTrackMode);
        });
        // start updating the snapshot again after leaving fullscreen
        this.on("webkitendfullscreen", ()=>{
            // remove the listener before adding it just in case it wasn't previously removed
            textTracks.removeEventListener("change", takeMetadataTrackSnapshot);
            textTracks.addEventListener("change", takeMetadataTrackSnapshot);
            // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
            textTracks.removeEventListener("change", restoreTrackMode);
        });
    }
    /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */ overrideNative_(type, override) {
        // If there is no behavioral change don't add/remove listeners
        if (override !== this[`featuresNative${type}Tracks`]) return;
        const lowerCaseType = type.toLowerCase();
        if (this[`${lowerCaseType}TracksListeners_`]) Object.keys(this[`${lowerCaseType}TracksListeners_`]).forEach((eventName)=>{
            const elTracks = this.el()[`${lowerCaseType}Tracks`];
            elTracks.removeEventListener(eventName, this[`${lowerCaseType}TracksListeners_`][eventName]);
        });
        this[`featuresNative${type}Tracks`] = !override;
        this[`${lowerCaseType}TracksListeners_`] = null;
        this.proxyNativeTracksForType_(lowerCaseType);
    }
    /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */ overrideNativeAudioTracks(override) {
        this.overrideNative_("Audio", override);
    }
    /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */ overrideNativeVideoTracks(override) {
        this.overrideNative_("Video", override);
    }
    /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */ proxyNativeTracksForType_(name) {
        const props = $cb03b711053a4297$var$NORMAL[name];
        const elTracks = this.el()[props.getterName];
        const techTracks = this[props.getterName]();
        if (!this[`featuresNative${props.capitalName}Tracks`] || !elTracks || !elTracks.addEventListener) return;
        const listeners = {
            change: (e)=>{
                const event = {
                    type: "change",
                    target: techTracks,
                    currentTarget: techTracks,
                    srcElement: techTracks
                };
                techTracks.trigger(event);
                // if we are a text track change event, we should also notify the
                // remote text track list. This can potentially cause a false positive
                // if we were to get a change event on a non-remote track and
                // we triggered the event on the remote text track list which doesn't
                // contain that track. However, best practices mean looping through the
                // list of tracks and searching for the appropriate mode value, so,
                // this shouldn't pose an issue
                if (name === "text") this[$cb03b711053a4297$var$REMOTE.remoteText.getterName]().trigger(event);
            },
            addtrack (e) {
                techTracks.addTrack(e.track);
            },
            removetrack (e) {
                techTracks.removeTrack(e.track);
            }
        };
        const removeOldTracks = function() {
            const removeTracks = [];
            for(let i = 0; i < techTracks.length; i++){
                let found = false;
                for(let j = 0; j < elTracks.length; j++)if (elTracks[j] === techTracks[i]) {
                    found = true;
                    break;
                }
                if (!found) removeTracks.push(techTracks[i]);
            }
            while(removeTracks.length)techTracks.removeTrack(removeTracks.shift());
        };
        this[props.getterName + "Listeners_"] = listeners;
        Object.keys(listeners).forEach((eventName)=>{
            const listener = listeners[eventName];
            elTracks.addEventListener(eventName, listener);
            this.on("dispose", (e)=>elTracks.removeEventListener(eventName, listener));
        });
        // Remove (native) tracks that are not used anymore
        this.on("loadstart", removeOldTracks);
        this.on("dispose", (e)=>this.off("loadstart", removeOldTracks));
    }
    /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */ proxyNativeTracks_() {
        $cb03b711053a4297$var$NORMAL.names.forEach((name)=>{
            this.proxyNativeTracksForType_(name);
        });
    }
    /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */ createEl() {
        let el = this.options_.tag;
        // Check if this browser supports moving the element into the box.
        // On the iPhone video will break if you move the element,
        // So we have to create a brand new element.
        // If we ingested the player div, we do not need to move the media element.
        if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
            // If the original tag is still there, clone and remove it.
            if (el) {
                const clone = el.cloneNode(true);
                if (el.parentNode) el.parentNode.insertBefore(clone, el);
                $cb03b711053a4297$var$Html5.disposeMediaElement(el);
                el = clone;
            } else {
                el = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("video");
                // determine if native controls should be used
                const tagAttributes = this.options_.tag && $cb03b711053a4297$var$getAttributes(this.options_.tag);
                const attributes = $cb03b711053a4297$var$merge$1({}, tagAttributes);
                if (!$cb03b711053a4297$var$TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) delete attributes.controls;
                $cb03b711053a4297$var$setAttributes(el, Object.assign(attributes, {
                    id: this.options_.techId,
                    class: "vjs-tech"
                }));
            }
            el.playerId = this.options_.playerId;
        }
        if (typeof this.options_.preload !== "undefined") $cb03b711053a4297$var$setAttribute(el, "preload", this.options_.preload);
        if (this.options_.disablePictureInPicture !== undefined) el.disablePictureInPicture = this.options_.disablePictureInPicture;
        // Update specific tag settings, in case they were overridden
        // `autoplay` has to be *last* so that `muted` and `playsinline` are present
        // when iOS/Safari or other browsers attempt to autoplay.
        const settingsAttrs = [
            "loop",
            "muted",
            "playsinline",
            "autoplay"
        ];
        for(let i = 0; i < settingsAttrs.length; i++){
            const attr = settingsAttrs[i];
            const value = this.options_[attr];
            if (typeof value !== "undefined") {
                if (value) $cb03b711053a4297$var$setAttribute(el, attr, attr);
                else $cb03b711053a4297$var$removeAttribute(el, attr);
                el[attr] = value;
            }
        }
        return el;
    }
    /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */ handleLateInit_(el) {
        if (el.networkState === 0 || el.networkState === 3) // The video element hasn't started loading the source yet
        // or didn't find a source
        return;
        if (el.readyState === 0) {
            // NetworkState is set synchronously BUT loadstart is fired at the
            // end of the current stack, usually before setInterval(fn, 0).
            // So at this point we know loadstart may have already fired or is
            // about to fire, and either way the player hasn't seen it yet.
            // We don't want to fire loadstart prematurely here and cause a
            // double loadstart so we'll wait and see if it happens between now
            // and the next loop, and fire it if not.
            // HOWEVER, we also want to make sure it fires before loadedmetadata
            // which could also happen between now and the next loop, so we'll
            // watch for that also.
            let loadstartFired = false;
            const setLoadstartFired = function() {
                loadstartFired = true;
            };
            this.on("loadstart", setLoadstartFired);
            const triggerLoadstart = function() {
                // We did miss the original loadstart. Make sure the player
                // sees loadstart before loadedmetadata
                if (!loadstartFired) this.trigger("loadstart");
            };
            this.on("loadedmetadata", triggerLoadstart);
            this.ready(function() {
                this.off("loadstart", setLoadstartFired);
                this.off("loadedmetadata", triggerLoadstart);
                if (!loadstartFired) // We did miss the original native loadstart. Fire it now.
                this.trigger("loadstart");
            });
            return;
        }
        // From here on we know that loadstart already fired and we missed it.
        // The other readyState events aren't as much of a problem if we double
        // them, so not going to go to as much trouble as loadstart to prevent
        // that unless we find reason to.
        const eventsToTrigger = [
            "loadstart"
        ];
        // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
        eventsToTrigger.push("loadedmetadata");
        // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
        if (el.readyState >= 2) eventsToTrigger.push("loadeddata");
        // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
        if (el.readyState >= 3) eventsToTrigger.push("canplay");
        // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
        if (el.readyState >= 4) eventsToTrigger.push("canplaythrough");
        // We still need to give the player time to add event listeners
        this.ready(function() {
            eventsToTrigger.forEach(function(type) {
                this.trigger(type);
            }, this);
        });
    }
    /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */ setScrubbing(isScrubbing) {
        this.isScrubbing_ = isScrubbing;
    }
    /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */ scrubbing() {
        return this.isScrubbing_;
    }
    /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */ setCurrentTime(seconds) {
        try {
            if (this.isScrubbing_ && this.el_.fastSeek && $cb03b711053a4297$var$IS_ANY_SAFARI) this.el_.fastSeek(seconds);
            else this.el_.currentTime = seconds;
        } catch (e) {
            $cb03b711053a4297$var$log$1(e, "Video is not ready. (Video.js)");
        // this.warning(VideoJS.warnings.videoNotReady);
        }
    }
    /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */ duration() {
        // Android Chrome will report duration as Infinity for VOD HLS until after
        // playback has started, which triggers the live display erroneously.
        // Return NaN if playback has not started and trigger a durationupdate once
        // the duration can be reliably known.
        if (this.el_.duration === Infinity && $cb03b711053a4297$var$IS_ANDROID && $cb03b711053a4297$var$IS_CHROME && this.el_.currentTime === 0) {
            // Wait for the first `timeupdate` with currentTime > 0 - there may be
            // several with 0
            const checkProgress = ()=>{
                if (this.el_.currentTime > 0) {
                    // Trigger durationchange for genuinely live video
                    if (this.el_.duration === Infinity) this.trigger("durationchange");
                    this.off("timeupdate", checkProgress);
                }
            };
            this.on("timeupdate", checkProgress);
            return NaN;
        }
        return this.el_.duration || NaN;
    }
    /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */ width() {
        return this.el_.offsetWidth;
    }
    /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */ height() {
        return this.el_.offsetHeight;
    }
    /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */ proxyWebkitFullscreen_() {
        if (!("webkitDisplayingFullscreen" in this.el_)) return;
        const endFn = function() {
            this.trigger("fullscreenchange", {
                isFullscreen: false
            });
            // Safari will sometimes set controls on the videoelement when existing fullscreen.
            if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) this.el_.controls = false;
        };
        const beginFn = function() {
            if ("webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture") {
                this.one("webkitendfullscreen", endFn);
                this.trigger("fullscreenchange", {
                    isFullscreen: true,
                    // set a flag in case another tech triggers fullscreenchange
                    nativeIOSFullscreen: true
                });
            }
        };
        this.on("webkitbeginfullscreen", beginFn);
        this.on("dispose", ()=>{
            this.off("webkitbeginfullscreen", beginFn);
            this.off("webkitendfullscreen", endFn);
        });
    }
    /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */ supportsFullScreen() {
        return typeof this.el_.webkitEnterFullScreen === "function";
    }
    /**
   * Request that the `HTML5` Tech enter fullscreen.
   */ enterFullScreen() {
        const video = this.el_;
        if (video.paused && video.networkState <= video.HAVE_METADATA) {
            // attempt to prime the video element for programmatic access
            // this isn't necessary on the desktop but shouldn't hurt
            $cb03b711053a4297$var$silencePromise(this.el_.play());
            // playing and pausing synchronously during the transition to fullscreen
            // can get iOS ~6.1 devices into a play/pause loop
            this.setTimeout(function() {
                video.pause();
                try {
                    video.webkitEnterFullScreen();
                } catch (e) {
                    this.trigger("fullscreenerror", e);
                }
            }, 0);
        } else try {
            video.webkitEnterFullScreen();
        } catch (e) {
            this.trigger("fullscreenerror", e);
        }
    }
    /**
   * Request that the `HTML5` Tech exit fullscreen.
   */ exitFullScreen() {
        if (!this.el_.webkitDisplayingFullscreen) {
            this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
            return;
        }
        this.el_.webkitExitFullScreen();
    }
    /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */ requestPictureInPicture() {
        return this.el_.requestPictureInPicture();
    }
    /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */ requestVideoFrameCallback(cb) {
        if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) return this.el_.requestVideoFrameCallback(cb);
        return super.requestVideoFrameCallback(cb);
    }
    /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */ cancelVideoFrameCallback(id) {
        if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) this.el_.cancelVideoFrameCallback(id);
        else super.cancelVideoFrameCallback(id);
    }
    /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */ src(src) {
        if (src === undefined) return this.el_.src;
        // Setting src through `src` instead of `setSrc` will be deprecated
        this.setSrc(src);
    }
    /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */ reset() {
        $cb03b711053a4297$var$Html5.resetMediaElement(this.el_);
    }
    /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */ currentSrc() {
        if (this.currentSource_) return this.currentSource_.src;
        return this.el_.currentSrc;
    }
    /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */ setControls(val) {
        this.el_.controls = !!val;
    }
    /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */ addTextTrack(kind, label, language) {
        if (!this.featuresNativeTextTracks) return super.addTextTrack(kind, label, language);
        return this.el_.addTextTrack(kind, label, language);
    }
    /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */ createRemoteTextTrack(options) {
        if (!this.featuresNativeTextTracks) return super.createRemoteTextTrack(options);
        const htmlTrackElement = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("track");
        if (options.kind) htmlTrackElement.kind = options.kind;
        if (options.label) htmlTrackElement.label = options.label;
        if (options.language || options.srclang) htmlTrackElement.srclang = options.language || options.srclang;
        if (options.default) htmlTrackElement.default = options.default;
        if (options.id) htmlTrackElement.id = options.id;
        if (options.src) htmlTrackElement.src = options.src;
        return htmlTrackElement;
    }
    /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */ addRemoteTextTrack(options, manualCleanup) {
        const htmlTrackElement = super.addRemoteTextTrack(options, manualCleanup);
        if (this.featuresNativeTextTracks) this.el().appendChild(htmlTrackElement);
        return htmlTrackElement;
    }
    /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */ removeRemoteTextTrack(track) {
        super.removeRemoteTextTrack(track);
        if (this.featuresNativeTextTracks) {
            const tracks = this.$$("track");
            let i = tracks.length;
            while(i--)if (track === tracks[i] || track === tracks[i].track) this.el().removeChild(tracks[i]);
        }
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */ getVideoPlaybackQuality() {
        if (typeof this.el().getVideoPlaybackQuality === "function") return this.el().getVideoPlaybackQuality();
        const videoPlaybackQuality = {};
        if (typeof this.el().webkitDroppedFrameCount !== "undefined" && typeof this.el().webkitDecodedFrameCount !== "undefined") {
            videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
            videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance) videoPlaybackQuality.creationTime = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).performance.now();
        return videoPlaybackQuality;
    }
}
/* HTML5 Support Testing ---------------------------------------------------- */ /**
 * Element for testing browser HTML5 media capabilities
 *
 * @type {Element}
 * @constant
 * @private
 */ $cb03b711053a4297$var$defineLazyProperty($cb03b711053a4297$var$Html5, "TEST_VID", function() {
    if (!$cb03b711053a4297$var$isReal()) return;
    const video = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("video");
    const track = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("track");
    track.kind = "captions";
    track.srclang = "en";
    track.label = "English";
    video.appendChild(track);
    return video;
});
/**
 * Check if HTML5 media is supported by this browser/device.
 *
 * @return {boolean}
 *         - True if HTML5 media is supported.
 *         - False if HTML5 media is not supported.
 */ $cb03b711053a4297$var$Html5.isSupported = function() {
    // IE with no Media Player is a LIAR! (#984)
    try {
        $cb03b711053a4297$var$Html5.TEST_VID.volume = 0.5;
    } catch (e) {
        return false;
    }
    return !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.canPlayType);
};
/**
 * Check if the tech can support the given type
 *
 * @param {string} type
 *        The mimetype to check
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */ $cb03b711053a4297$var$Html5.canPlayType = function(type) {
    return $cb03b711053a4297$var$Html5.TEST_VID.canPlayType(type);
};
/**
 * Check if the tech can support the given source
 *
 * @param {Object} srcObj
 *        The source object
 * @param {Object} options
 *        The options passed to the tech
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */ $cb03b711053a4297$var$Html5.canPlaySource = function(srcObj, options) {
    return $cb03b711053a4297$var$Html5.canPlayType(srcObj.type);
};
/**
 * Check if the volume can be changed in this browser/device.
 * Volume cannot be changed in a lot of mobile devices.
 * Specifically, it can't be changed from 1 on iOS.
 *
 * @return {boolean}
 *         - True if volume can be controlled
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.canControlVolume = function() {
    // IE will error if Windows Media Player not installed #3315
    try {
        const volume = $cb03b711053a4297$var$Html5.TEST_VID.volume;
        $cb03b711053a4297$var$Html5.TEST_VID.volume = volume / 2 + 0.1;
        const canControl = volume !== $cb03b711053a4297$var$Html5.TEST_VID.volume;
        // With the introduction of iOS 15, there are cases where the volume is read as
        // changed but reverts back to its original state at the start of the next tick.
        // To determine whether volume can be controlled on iOS,
        // a timeout is set and the volume is checked asynchronously.
        // Since `features` doesn't currently work asynchronously, the value is manually set.
        if (canControl && $cb03b711053a4297$var$IS_IOS) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                if ($cb03b711053a4297$var$Html5 && $cb03b711053a4297$var$Html5.prototype) $cb03b711053a4297$var$Html5.prototype.featuresVolumeControl = volume !== $cb03b711053a4297$var$Html5.TEST_VID.volume;
            });
            // default iOS to false, which will be updated in the timeout above.
            return false;
        }
        return canControl;
    } catch (e) {
        return false;
    }
};
/**
 * Check if the volume can be muted in this browser/device.
 * Some devices, e.g. iOS, don't allow changing volume
 * but permits muting/unmuting.
 *
 * @return {boolean}
 *      - True if volume can be muted
 *      - False otherwise
 */ $cb03b711053a4297$var$Html5.canMuteVolume = function() {
    try {
        const muted = $cb03b711053a4297$var$Html5.TEST_VID.muted;
        // in some versions of iOS muted property doesn't always
        // work, so we want to set both property and attribute
        $cb03b711053a4297$var$Html5.TEST_VID.muted = !muted;
        if ($cb03b711053a4297$var$Html5.TEST_VID.muted) $cb03b711053a4297$var$setAttribute($cb03b711053a4297$var$Html5.TEST_VID, "muted", "muted");
        else $cb03b711053a4297$var$removeAttribute($cb03b711053a4297$var$Html5.TEST_VID, "muted", "muted");
        return muted !== $cb03b711053a4297$var$Html5.TEST_VID.muted;
    } catch (e) {
        return false;
    }
};
/**
 * Check if the playback rate can be changed in this browser/device.
 *
 * @return {boolean}
 *         - True if playback rate can be controlled
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.canControlPlaybackRate = function() {
    // Playback rate API is implemented in Android Chrome, but doesn't do anything
    // https://github.com/videojs/video.js/issues/3180
    if ($cb03b711053a4297$var$IS_ANDROID && $cb03b711053a4297$var$IS_CHROME && $cb03b711053a4297$var$CHROME_VERSION < 58) return false;
    // IE will error if Windows Media Player not installed #3315
    try {
        const playbackRate = $cb03b711053a4297$var$Html5.TEST_VID.playbackRate;
        $cb03b711053a4297$var$Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
        return playbackRate !== $cb03b711053a4297$var$Html5.TEST_VID.playbackRate;
    } catch (e) {
        return false;
    }
};
/**
 * Check if we can override a video/audio elements attributes, with
 * Object.defineProperty.
 *
 * @return {boolean}
 *         - True if builtin attributes can be overridden
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.canOverrideAttributes = function() {
    // if we cannot overwrite the src/innerHTML property, there is no support
    // iOS 7 safari for instance cannot do this.
    try {
        const noop = ()=>{};
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("video"), "src", {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("audio"), "src", {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("video"), "innerHTML", {
            get: noop,
            set: noop
        });
        Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("audio"), "innerHTML", {
            get: noop,
            set: noop
        });
    } catch (e) {
        return false;
    }
    return true;
};
/**
 * Check to see if native `TextTrack`s are supported by this browser/device.
 *
 * @return {boolean}
 *         - True if native `TextTrack`s are supported.
 *         - False otherwise
 */ $cb03b711053a4297$var$Html5.supportsNativeTextTracks = function() {
    return $cb03b711053a4297$var$IS_ANY_SAFARI || $cb03b711053a4297$var$IS_IOS && $cb03b711053a4297$var$IS_CHROME;
};
/**
 * Check to see if native `VideoTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `VideoTrack`s are supported.
 *        - False otherwise
 */ $cb03b711053a4297$var$Html5.supportsNativeVideoTracks = function() {
    return !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.videoTracks);
};
/**
 * Check to see if native `AudioTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `AudioTrack`s are supported.
 *        - False otherwise
 */ $cb03b711053a4297$var$Html5.supportsNativeAudioTracks = function() {
    return !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.audioTracks);
};
/**
 * An array of events available on the Html5 tech.
 *
 * @private
 * @type {Array}
 */ $cb03b711053a4297$var$Html5.Events = [
    "loadstart",
    "suspend",
    "abort",
    "error",
    "emptied",
    "stalled",
    "loadedmetadata",
    "loadeddata",
    "canplay",
    "canplaythrough",
    "playing",
    "waiting",
    "seeking",
    "seeked",
    "ended",
    "durationchange",
    "timeupdate",
    "progress",
    "play",
    "pause",
    "ratechange",
    "resize",
    "volumechange"
];
/**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default {@link Html5.canControlVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {boolean}
 * @default {@link Html5.canMuteVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports changing the speed at which the media
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default {@link Html5.canControlPlaybackRate}
 */ /**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * @type {boolean}
 * @default
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeTextTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeVideoTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeAudioTracks}
 */ [
    [
        "featuresMuteControl",
        "canMuteVolume"
    ],
    [
        "featuresPlaybackRate",
        "canControlPlaybackRate"
    ],
    [
        "featuresSourceset",
        "canOverrideAttributes"
    ],
    [
        "featuresNativeTextTracks",
        "supportsNativeTextTracks"
    ],
    [
        "featuresNativeVideoTracks",
        "supportsNativeVideoTracks"
    ],
    [
        "featuresNativeAudioTracks",
        "supportsNativeAudioTracks"
    ]
].forEach(function([key, fn]) {
    $cb03b711053a4297$var$defineLazyProperty($cb03b711053a4297$var$Html5.prototype, key, ()=>$cb03b711053a4297$var$Html5[fn](), true);
});
$cb03b711053a4297$var$Html5.prototype.featuresVolumeControl = $cb03b711053a4297$var$Html5.canControlVolume();
/**
 * Boolean indicating whether the `HTML5` tech currently supports the media element
 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
 * false there. Everywhere else this should be true.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.movingMediaElementInDOM = !$cb03b711053a4297$var$IS_IOS;
// TODO: Previous comment: No longer appears to be used. Can probably be removed.
//       Is this true?
/**
 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
 * when going into fullscreen.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.featuresFullscreenResize = true;
/**
 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
 * If this is false, manual `progress` events will be triggered instead.
 *
 * @type {boolean}
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.featuresProgressEvents = true;
/**
 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
 * If this is false, manual `timeupdate` events will be triggered instead.
 *
 * @default
 */ $cb03b711053a4297$var$Html5.prototype.featuresTimeupdateEvents = true;
/**
 * Whether the HTML5 el supports `requestVideoFrameCallback`
 *
 * @type {boolean}
 */ $cb03b711053a4297$var$Html5.prototype.featuresVideoFrameCallback = !!($cb03b711053a4297$var$Html5.TEST_VID && $cb03b711053a4297$var$Html5.TEST_VID.requestVideoFrameCallback);
$cb03b711053a4297$var$Html5.disposeMediaElement = function(el) {
    if (!el) return;
    if (el.parentNode) el.parentNode.removeChild(el);
    // remove any child track or source nodes to prevent their loading
    while(el.hasChildNodes())el.removeChild(el.firstChild);
    // remove any src reference. not setting `src=''` because that causes a warning
    // in firefox
    el.removeAttribute("src");
    // force the media element to update its loading state by calling load()
    // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
    if (typeof el.load === "function") // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function() {
        try {
            el.load();
        } catch (e) {
        // not supported
        }
    })();
};
$cb03b711053a4297$var$Html5.resetMediaElement = function(el) {
    if (!el) return;
    const sources = el.querySelectorAll("source");
    let i = sources.length;
    while(i--)el.removeChild(sources[i]);
    // remove any src reference.
    // not setting `src=''` because that throws an error
    el.removeAttribute("src");
    if (typeof el.load === "function") // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function() {
        try {
            el.load();
        } catch (e) {
        // satisfy linter
        }
    })();
};
/* Native HTML5 element property wrapping ----------------------------------- */ // Wrap native boolean attributes with getters that check both property and attribute
// The list is as followed:
// muted, defaultMuted, autoplay, controls, loop, playsinline
[
    /**
 * Get the value of `muted` from the media element. `muted` indicates
 * that the volume for the media should be set to silent. This does not actually change
 * the `volume` attribute.
 *
 * @method Html5#muted
 * @return {boolean}
 *         - True if the value of `volume` should be ignored and the audio set to silent.
 *         - False if the value of `volume` should be used.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */ "muted",
    /**
 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
 * whether the media should start muted or not. Only changes the default state of the
 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
 * current state.
 *
 * @method Html5#defaultMuted
 * @return {boolean}
 *         - The value of `defaultMuted` from the media element.
 *         - True indicates that the media should start muted.
 *         - False indicates that the media should not start muted
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */ "defaultMuted",
    /**
 * Get the value of `autoplay` from the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#autoplay
 * @return {boolean}
 *         - The value of `autoplay` from the media element.
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */ "autoplay",
    /**
 * Get the value of `controls` from the media element. `controls` indicates
 * whether the native media controls should be shown or hidden.
 *
 * @method Html5#controls
 * @return {boolean}
 *         - The value of `controls` from the media element.
 *         - True indicates that native controls should be showing.
 *         - False indicates that native controls should be hidden.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
 */ "controls",
    /**
 * Get the value of `loop` from the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#loop
 * @return {boolean}
 *         - The value of `loop` from the media element.
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */ "loop",
    /**
 * Get the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#playsinline
 * @return {boolean}
 *         - The value of `playsinline` from the media element.
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */ "playsinline"
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype[prop] = function() {
        return this.el_[prop] || this.el_.hasAttribute(prop);
    };
});
// Wrap native boolean attributes with setters that set both property and attribute
// The list is as followed:
// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
// setControls is special-cased above
[
    /**
 * Set the value of `muted` on the media element. `muted` indicates that the current
 * audio level should be silent.
 *
 * @method Html5#setMuted
 * @param {boolean} muted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */ "muted",
    /**
 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
 * audio level should be silent, but will only effect the muted level on initial playback..
 *
 * @method Html5.prototype.setDefaultMuted
 * @param {boolean} defaultMuted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */ "defaultMuted",
    /**
 * Set the value of `autoplay` on the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#setAutoplay
 * @param {boolean} autoplay
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */ "autoplay",
    /**
 * Set the value of `loop` on the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#setLoop
 * @param {boolean} loop
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */ "loop",
    /**
 * Set the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#setPlaysinline
 * @param {boolean} playsinline
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */ "playsinline"
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype["set" + $cb03b711053a4297$var$toTitleCase$1(prop)] = function(v) {
        this.el_[prop] = v;
        if (v) this.el_.setAttribute(prop, prop);
        else this.el_.removeAttribute(prop);
    };
});
// Wrap native properties with a getter
// The list is as followed
// paused, currentTime, buffered, volume, poster, preload, error, seeking
// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
[
    /**
 * Get the value of `paused` from the media element. `paused` indicates whether the media element
 * is currently paused or not.
 *
 * @method Html5#paused
 * @return {boolean}
 *         The value of `paused` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
 */ "paused",
    /**
 * Get the value of `currentTime` from the media element. `currentTime` indicates
 * the current second that the media is at in playback.
 *
 * @method Html5#currentTime
 * @return {number}
 *         The value of `currentTime` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
 */ "currentTime",
    /**
 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
 * object that represents the parts of the media that are already downloaded and
 * available for playback.
 *
 * @method Html5#buffered
 * @return {TimeRange}
 *         The value of `buffered` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
 */ "buffered",
    /**
 * Get the value of `volume` from the media element. `volume` indicates
 * the current playback volume of audio for a media. `volume` will be a value from 0
 * (silent) to 1 (loudest and default).
 *
 * @method Html5#volume
 * @return {number}
 *         The value of `volume` from the media element. Value will be between 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */ "volume",
    /**
 * Get the value of `poster` from the media element. `poster` indicates
 * that the url of an image file that can/will be shown when no media data is available.
 *
 * @method Html5#poster
 * @return {string}
 *         The value of `poster` from the media element. Value will be a url to an
 *         image.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
 */ "poster",
    /**
 * Get the value of `preload` from the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#preload
 * @return {string}
 *         The value of `preload` from the media element. Will be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */ "preload",
    /**
 * Get the value of the `error` from the media element. `error` indicates any
 * MediaError that may have occurred during playback. If error returns null there is no
 * current error.
 *
 * @method Html5#error
 * @return {MediaError|null}
 *         The value of `error` from the media element. Will be `MediaError` if there
 *         is a current error and null otherwise.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
 */ "error",
    /**
 * Get the value of `seeking` from the media element. `seeking` indicates whether the
 * media is currently seeking to a new position or not.
 *
 * @method Html5#seeking
 * @return {boolean}
 *         - The value of `seeking` from the media element.
 *         - True indicates that the media is currently seeking to a new position.
 *         - False indicates that the media is not seeking to a new position at this time.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
 */ "seeking",
    /**
 * Get the value of `seekable` from the media element. `seekable` returns a
 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
 *
 * @method Html5#seekable
 * @return {TimeRange}
 *         The value of `seekable` from the media element. A `TimeRange` object
 *         indicating the current ranges of time that can be seeked to.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
 */ "seekable",
    /**
 * Get the value of `ended` from the media element. `ended` indicates whether
 * the media has reached the end or not.
 *
 * @method Html5#ended
 * @return {boolean}
 *         - The value of `ended` from the media element.
 *         - True indicates that the media has ended.
 *         - False indicates that the media has not ended.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
 */ "ended",
    /**
 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
 * the rate at which the media is currently playing back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#playbackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ "playbackRate",
    /**
 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
 * the rate at which the media is currently playing back. This value will not indicate the current
 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
 *
 * Examples:
 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.defaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ "defaultPlaybackRate",
    /**
 * Get the value of 'disablePictureInPicture' from the video element.
 *
 * @method Html5#disablePictureInPicture
 * @return {boolean} value
 *         - The value of `disablePictureInPicture` from the video element.
 *         - True indicates that the video can't be played in Picture-In-Picture mode
 *         - False indicates that the video can be played in Picture-In-Picture mode
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */ "disablePictureInPicture",
    /**
 * Get the value of `played` from the media element. `played` returns a `TimeRange`
 * object representing points in the media timeline that have been played.
 *
 * @method Html5#played
 * @return {TimeRange}
 *         The value of `played` from the media element. A `TimeRange` object indicating
 *         the ranges of time that have been played.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
 */ "played",
    /**
 * Get the value of `networkState` from the media element. `networkState` indicates
 * the current network state. It returns an enumeration from the following list:
 * - 0: NETWORK_EMPTY
 * - 1: NETWORK_IDLE
 * - 2: NETWORK_LOADING
 * - 3: NETWORK_NO_SOURCE
 *
 * @method Html5#networkState
 * @return {number}
 *         The value of `networkState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
 */ "networkState",
    /**
 * Get the value of `readyState` from the media element. `readyState` indicates
 * the current state of the media element. It returns an enumeration from the
 * following list:
 * - 0: HAVE_NOTHING
 * - 1: HAVE_METADATA
 * - 2: HAVE_CURRENT_DATA
 * - 3: HAVE_FUTURE_DATA
 * - 4: HAVE_ENOUGH_DATA
 *
 * @method Html5#readyState
 * @return {number}
 *         The value of `readyState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
 */ "readyState",
    /**
 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
 * the current width of the video in css pixels.
 *
 * @method Html5#videoWidth
 * @return {number}
 *         The value of `videoWidth` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */ "videoWidth",
    /**
 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
 * the current height of the video in css pixels.
 *
 * @method Html5#videoHeight
 * @return {number}
 *         The value of `videoHeight` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */ "videoHeight",
    /**
 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#crossOrigin
 * @return {string}
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */ "crossOrigin"
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype[prop] = function() {
        return this.el_[prop];
    };
});
// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
// The list is as follows:
// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
// setDisablePictureInPicture, setCrossOrigin
[
    /**
 * Set the value of `volume` on the media element. `volume` indicates the current
 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
 * so on.
 *
 * @method Html5#setVolume
 * @param {number} percentAsDecimal
 *        The volume percent as a decimal. Valid range is from 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */ "volume",
    /**
 * Set the value of `src` on the media element. `src` indicates the current
 * {@link Tech~SourceObject} for the media.
 *
 * @method Html5#setSrc
 * @param {Tech~SourceObject} src
 *        The source object to set as the current source.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
 */ "src",
    /**
 * Set the value of `poster` on the media element. `poster` is the url to
 * an image file that can/will be shown when no media data is available.
 *
 * @method Html5#setPoster
 * @param {string} poster
 *        The url to an image that should be used as the `poster` for the media
 *        element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
 */ "poster",
    /**
 * Set the value of `preload` on the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#setPreload
 * @param {string} preload
 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */ "preload",
    /**
 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
 * the rate at which the media should play back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#setPlaybackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */ "playbackRate",
    /**
 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
 * the rate at which the media should play back upon initial startup. Changing this value
 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
 *
 * Example Values:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.setDefaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
 */ "defaultPlaybackRate",
    /**
 * Prevents the browser from suggesting a Picture-in-Picture context menu
 * or to request Picture-in-Picture automatically in some cases.
 *
 * @method Html5#setDisablePictureInPicture
 * @param {boolean} value
 *         The true value will disable Picture-in-Picture mode.
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */ "disablePictureInPicture",
    /**
 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#setCrossOrigin
 * @param {string} crossOrigin
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */ "crossOrigin"
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype["set" + $cb03b711053a4297$var$toTitleCase$1(prop)] = function(v) {
        this.el_[prop] = v;
    };
});
// wrap native functions with a function
// The list is as follows:
// pause, load, play
[
    /**
 * A wrapper around the media elements `pause` function. This will call the `HTML5`
 * media elements `pause` function.
 *
 * @method Html5#pause
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
 */ "pause",
    /**
 * A wrapper around the media elements `load` function. This will call the `HTML5`s
 * media element `load` function.
 *
 * @method Html5#load
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
 */ "load",
    /**
 * A wrapper around the media elements `play` function. This will call the `HTML5`s
 * media element `play` function.
 *
 * @method Html5#play
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
 */ "play"
].forEach(function(prop) {
    $cb03b711053a4297$var$Html5.prototype[prop] = function() {
        return this.el_[prop]();
    };
});
$cb03b711053a4297$var$Tech.withSourceHandlers($cb03b711053a4297$var$Html5);
/**
 * Native source handler for Html5, simply passes the source to the media element.
 *
 * @property {Tech~SourceObject} source
 *        The source object
 *
 * @property {Html5} tech
 *        The instance of the HTML5 tech.
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler = {};
/**
 * Check if the media element can play the given mime type.
 *
 * @param {string} type
 *        The mimetype to check
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string)
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.canPlayType = function(type) {
    // IE without MediaPlayer throws an error (#519)
    try {
        return $cb03b711053a4297$var$Html5.TEST_VID.canPlayType(type);
    } catch (e) {
        return "";
    }
};
/**
 * Check if the media element can handle a source natively.
 *
 * @param {Tech~SourceObject} source
 *         The source object
 *
 * @param {Object} [options]
 *         Options to be passed to the tech.
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string).
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.canHandleSource = function(source, options) {
    // If a type was provided we should rely on that
    if (source.type) return $cb03b711053a4297$var$Html5.nativeSourceHandler.canPlayType(source.type);
    else if (source.src) {
        const ext = $cb03b711053a4297$var$getFileExtension(source.src);
        return $cb03b711053a4297$var$Html5.nativeSourceHandler.canPlayType(`video/${ext}`);
    }
    return "";
};
/**
 * Pass the source to the native media element.
 *
 * @param {Tech~SourceObject} source
 *        The source object
 *
 * @param {Html5} tech
 *        The instance of the Html5 tech
 *
 * @param {Object} [options]
 *        The options to pass to the source
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.handleSource = function(source, tech, options) {
    tech.setSrc(source.src);
};
/**
 * A noop for the native dispose function, as cleanup is not needed.
 */ $cb03b711053a4297$var$Html5.nativeSourceHandler.dispose = function() {};
// Register the native source handler
$cb03b711053a4297$var$Html5.registerSourceHandler($cb03b711053a4297$var$Html5.nativeSourceHandler);
$cb03b711053a4297$var$Tech.registerTech("Html5", $cb03b711053a4297$var$Html5);
/**
 * @file player.js
 */ // The following tech events are simply re-triggered
// on the player when they happen
const $cb03b711053a4297$var$TECH_EVENTS_RETRIGGER = [
    /**
 * Fired while the user agent is downloading media data.
 *
 * @event Player#progress
 * @type {Event}
 */ /**
 * Retrigger the `progress` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechProgress_
 * @fires Player#progress
 * @listens Tech#progress
 */ "progress",
    /**
 * Fires when the loading of an audio/video is aborted.
 *
 * @event Player#abort
 * @type {Event}
 */ /**
 * Retrigger the `abort` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechAbort_
 * @fires Player#abort
 * @listens Tech#abort
 */ "abort",
    /**
 * Fires when the browser is intentionally not getting media data.
 *
 * @event Player#suspend
 * @type {Event}
 */ /**
 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechSuspend_
 * @fires Player#suspend
 * @listens Tech#suspend
 */ "suspend",
    /**
 * Fires when the current playlist is empty.
 *
 * @event Player#emptied
 * @type {Event}
 */ /**
 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechEmptied_
 * @fires Player#emptied
 * @listens Tech#emptied
 */ "emptied",
    /**
 * Fires when the browser is trying to get media data, but data is not available.
 *
 * @event Player#stalled
 * @type {Event}
 */ /**
 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechStalled_
 * @fires Player#stalled
 * @listens Tech#stalled
 */ "stalled",
    /**
 * Fires when the browser has loaded meta data for the audio/video.
 *
 * @event Player#loadedmetadata
 * @type {Event}
 */ /**
 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoadedmetadata_
 * @fires Player#loadedmetadata
 * @listens Tech#loadedmetadata
 */ "loadedmetadata",
    /**
 * Fires when the browser has loaded the current frame of the audio/video.
 *
 * @event Player#loadeddata
 * @type {event}
 */ /**
 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoaddeddata_
 * @fires Player#loadeddata
 * @listens Tech#loadeddata
 */ "loadeddata",
    /**
 * Fires when the current playback position has changed.
 *
 * @event Player#timeupdate
 * @type {event}
 */ /**
 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTimeUpdate_
 * @fires Player#timeupdate
 * @listens Tech#timeupdate
 */ "timeupdate",
    /**
 * Fires when the video's intrinsic dimensions change
 *
 * @event Player#resize
 * @type {event}
 */ /**
 * Retrigger the `resize` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechResize_
 * @fires Player#resize
 * @listens Tech#resize
 */ "resize",
    /**
 * Fires when the volume has been changed
 *
 * @event Player#volumechange
 * @type {event}
 */ /**
 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechVolumechange_
 * @fires Player#volumechange
 * @listens Tech#volumechange
 */ "volumechange",
    /**
 * Fires when the text track has been changed
 *
 * @event Player#texttrackchange
 * @type {event}
 */ /**
 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTexttrackchange_
 * @fires Player#texttrackchange
 * @listens Tech#texttrackchange
 */ "texttrackchange"
];
// events to queue when playback rate is zero
// this is a hash for the sole purpose of mapping non-camel-cased event names
// to camel-cased function names
const $cb03b711053a4297$var$TECH_EVENTS_QUEUE = {
    canplay: "CanPlay",
    canplaythrough: "CanPlayThrough",
    playing: "Playing",
    seeked: "Seeked"
};
const $cb03b711053a4297$var$BREAKPOINT_ORDER = [
    "tiny",
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge",
    "huge"
];
const $cb03b711053a4297$var$BREAKPOINT_CLASSES = {};
// grep: vjs-layout-tiny
// grep: vjs-layout-x-small
// grep: vjs-layout-small
// grep: vjs-layout-medium
// grep: vjs-layout-large
// grep: vjs-layout-x-large
// grep: vjs-layout-huge
$cb03b711053a4297$var$BREAKPOINT_ORDER.forEach((k)=>{
    const v = k.charAt(0) === "x" ? `x-${k.substring(1)}` : k;
    $cb03b711053a4297$var$BREAKPOINT_CLASSES[k] = `vjs-layout-${v}`;
});
const $cb03b711053a4297$var$DEFAULT_BREAKPOINTS = {
    tiny: 210,
    xsmall: 320,
    small: 425,
    medium: 768,
    large: 1440,
    xlarge: 2560,
    huge: Infinity
};
/**
 * An instance of the `Player` class is created when any of the Video.js setup methods
 * are used to initialize a video.
 *
 * After an instance has been created it can be accessed globally in three ways:
 * 1. By calling `videojs.getPlayer('example_video_1');`
 * 2. By calling `videojs('example_video_1');` (not recommended)
 * 2. By using it directly via `videojs.players.example_video_1;`
 *
 * @extends Component
 * @global
 */ class $cb03b711053a4297$var$Player extends $cb03b711053a4297$var$Component$1 {
    /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {Function} [ready]
   *        Ready callback function.
   */ constructor(tag, options, ready){
        // Make sure tag ID exists
        // also here.. probably better
        tag.id = tag.id || options.id || `vjs_video_${$cb03b711053a4297$var$newGUID()}`;
        // Set Options
        // The options argument overrides options set in the video tag
        // which overrides globally set options.
        // This latter part coincides with the load order
        // (tag must exist before Player)
        options = Object.assign($cb03b711053a4297$var$Player.getTagSettings(tag), options);
        // Delay the initialization of children because we need to set up
        // player properties first, and can't use `this` before `super()`
        options.initChildren = false;
        // Same with creating the element
        options.createEl = false;
        // don't auto mixin the evented mixin
        options.evented = false;
        // we don't want the player to report touch activity on itself
        // see enableTouchActivity in Component
        options.reportTouchActivity = false;
        // If language is not set, get the closest lang attribute
        if (!options.language) {
            const closest = tag.closest("[lang]");
            if (closest) options.language = closest.getAttribute("lang");
        }
        // Run base component initializing with new options
        super(null, options, ready);
        // Create bound methods for document listeners.
        this.boundDocumentFullscreenChange_ = (e)=>this.documentFullscreenChange_(e);
        this.boundFullWindowOnEscKey_ = (e)=>this.fullWindowOnEscKey(e);
        this.boundUpdateStyleEl_ = (e)=>this.updateStyleEl_(e);
        this.boundApplyInitTime_ = (e)=>this.applyInitTime_(e);
        this.boundUpdateCurrentBreakpoint_ = (e)=>this.updateCurrentBreakpoint_(e);
        this.boundHandleTechClick_ = (e)=>this.handleTechClick_(e);
        this.boundHandleTechDoubleClick_ = (e)=>this.handleTechDoubleClick_(e);
        this.boundHandleTechTouchStart_ = (e)=>this.handleTechTouchStart_(e);
        this.boundHandleTechTouchMove_ = (e)=>this.handleTechTouchMove_(e);
        this.boundHandleTechTouchEnd_ = (e)=>this.handleTechTouchEnd_(e);
        this.boundHandleTechTap_ = (e)=>this.handleTechTap_(e);
        // default isFullscreen_ to false
        this.isFullscreen_ = false;
        // create logger
        this.log = $cb03b711053a4297$var$createLogger(this.id_);
        // Hold our own reference to fullscreen api so it can be mocked in tests
        this.fsApi_ = $cb03b711053a4297$var$FullscreenApi;
        // Tracks when a tech changes the poster
        this.isPosterFromTech_ = false;
        // Holds callback info that gets queued when playback rate is zero
        // and a seek is happening
        this.queuedCallbacks_ = [];
        // Turn off API access because we're loading a new tech that might load asynchronously
        this.isReady_ = false;
        // Init state hasStarted_
        this.hasStarted_ = false;
        // Init state userActive_
        this.userActive_ = false;
        // Init debugEnabled_
        this.debugEnabled_ = false;
        // Init state audioOnlyMode_
        this.audioOnlyMode_ = false;
        // Init state audioPosterMode_
        this.audioPosterMode_ = false;
        // Init state audioOnlyCache_
        this.audioOnlyCache_ = {
            playerHeight: null,
            hiddenChildren: []
        };
        // if the global option object was accidentally blown away by
        // someone, bail early with an informative error
        if (!this.options_ || !this.options_.techOrder || !this.options_.techOrder.length) throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
        // Store the original tag used to set options
        this.tag = tag;
        // Store the tag attributes used to restore html5 element
        this.tagAttributes = tag && $cb03b711053a4297$var$getAttributes(tag);
        // Update current language
        this.language(this.options_.language);
        // Update Supported Languages
        if (options.languages) {
            // Normalise player option languages to lowercase
            const languagesToLower = {};
            Object.getOwnPropertyNames(options.languages).forEach(function(name) {
                languagesToLower[name.toLowerCase()] = options.languages[name];
            });
            this.languages_ = languagesToLower;
        } else this.languages_ = $cb03b711053a4297$var$Player.prototype.options_.languages;
        this.resetCache_();
        // Set poster
        /** @type string */ this.poster_ = options.poster || "";
        // Set controls
        /** @type {boolean} */ this.controls_ = !!options.controls;
        // Original tag settings stored in options
        // now remove immediately so native controls don't flash.
        // May be turned back on by HTML5 tech if nativeControlsForTouch is true
        tag.controls = false;
        tag.removeAttribute("controls");
        this.changingSrc_ = false;
        this.playCallbacks_ = [];
        this.playTerminatedQueue_ = [];
        // the attribute overrides the option
        if (tag.hasAttribute("autoplay")) this.autoplay(true);
        else // otherwise use the setter to validate and
        // set the correct value.
        this.autoplay(this.options_.autoplay);
        // check plugins
        if (options.plugins) Object.keys(options.plugins).forEach((name)=>{
            if (typeof this[name] !== "function") throw new Error(`plugin "${name}" does not exist`);
        });
        /*
     * Store the internal state of scrubbing
     *
     * @private
     * @return {Boolean} True if the user is scrubbing
     */ this.scrubbing_ = false;
        this.el_ = this.createEl();
        // Make this an evented object and use `el_` as its event bus.
        $cb03b711053a4297$var$evented(this, {
            eventBusKey: "el_"
        });
        // listen to document and player fullscreenchange handlers so we receive those events
        // before a user can receive them so we can update isFullscreen appropriately.
        // make sure that we listen to fullscreenchange events before everything else to make sure that
        // our isFullscreen method is updated properly for internal components as well as external.
        if (this.fsApi_.requestFullscreen) {
            $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
            this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
        }
        if (this.fluid_) this.on([
            "playerreset",
            "resize"
        ], this.boundUpdateStyleEl_);
        // We also want to pass the original player options to each component and plugin
        // as well so they don't need to reach back into the player for options later.
        // We also need to do another copy of this.options_ so we don't end up with
        // an infinite loop.
        const playerOptionsCopy = $cb03b711053a4297$var$merge$1(this.options_);
        // Load plugins
        if (options.plugins) Object.keys(options.plugins).forEach((name)=>{
            this[name](options.plugins[name]);
        });
        // Enable debug mode to fire debugon event for all plugins.
        if (options.debug) this.debug(true);
        this.options_.playerOptions = playerOptionsCopy;
        this.middleware_ = [];
        this.playbackRates(options.playbackRates);
        if (options.experimentalSvgIcons) {
            // Add SVG Sprite to the DOM
            const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).DOMParser();
            const parsedSVG = parser.parseFromString($cb03b711053a4297$var$icons, "image/svg+xml");
            const errorNode = parsedSVG.querySelector("parsererror");
            if (errorNode) {
                $cb03b711053a4297$var$log$1.warn("Failed to load SVG Icons. Falling back to Font Icons.");
                this.options_.experimentalSvgIcons = null;
            } else {
                const sprite = parsedSVG.documentElement;
                sprite.style.display = "none";
                this.el_.appendChild(sprite);
                this.addClass("vjs-svg-icons-enabled");
            }
        }
        this.initChildren();
        // Set isAudio based on whether or not an audio tag was used
        this.isAudio(tag.nodeName.toLowerCase() === "audio");
        // Update controls className. Can't do this when the controls are initially
        // set because the element doesn't exist yet.
        if (this.controls()) this.addClass("vjs-controls-enabled");
        else this.addClass("vjs-controls-disabled");
        // Set ARIA label and region role depending on player type
        this.el_.setAttribute("role", "region");
        if (this.isAudio()) this.el_.setAttribute("aria-label", this.localize("Audio Player"));
        else this.el_.setAttribute("aria-label", this.localize("Video Player"));
        if (this.isAudio()) this.addClass("vjs-audio");
        // TODO: Make this smarter. Toggle user state between touching/mousing
        // using events, since devices can have both touch and mouse events.
        // TODO: Make this check be performed again when the window switches between monitors
        // (See https://github.com/videojs/video.js/issues/5683)
        if ($cb03b711053a4297$var$TOUCH_ENABLED) this.addClass("vjs-touch-enabled");
        // iOS Safari has broken hover handling
        if (!$cb03b711053a4297$var$IS_IOS) this.addClass("vjs-workinghover");
        // Make player easily findable by ID
        $cb03b711053a4297$var$Player.players[this.id_] = this;
        // Add a major version class to aid css in plugins
        const majorVersion = $cb03b711053a4297$var$version$6.split(".")[0];
        this.addClass(`vjs-v${majorVersion}`);
        // When the player is first initialized, trigger activity so components
        // like the control bar show themselves if needed
        this.userActive(true);
        this.reportUserActivity();
        this.one("play", (e)=>this.listenForUserActivity_(e));
        this.on("keydown", (e)=>this.handleKeyDown(e));
        this.on("languagechange", (e)=>this.handleLanguagechange(e));
        this.breakpoints(this.options_.breakpoints);
        this.responsive(this.options_.responsive);
        // Calling both the audio mode methods after the player is fully
        // setup to be able to listen to the events triggered by them
        this.on("ready", ()=>{
            // Calling the audioPosterMode method first so that
            // the audioOnlyMode can take precedence when both options are set to true
            this.audioPosterMode(this.options_.audioPosterMode);
            this.audioOnlyMode(this.options_.audioOnlyMode);
        });
    }
    /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */ dispose() {
        /**
     * Called when the player is being disposed of.
     *
     * @event Player#dispose
     * @type {Event}
     */ this.trigger("dispose");
        // prevent dispose from being called twice
        this.off("dispose");
        // Make sure all player-specific document listeners are unbound. This is
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "keydown", this.boundFullWindowOnEscKey_);
        if (this.styleEl_ && this.styleEl_.parentNode) {
            this.styleEl_.parentNode.removeChild(this.styleEl_);
            this.styleEl_ = null;
        }
        // Kill reference to this player
        $cb03b711053a4297$var$Player.players[this.id_] = null;
        if (this.tag && this.tag.player) this.tag.player = null;
        if (this.el_ && this.el_.player) this.el_.player = null;
        if (this.tech_) {
            this.tech_.dispose();
            this.isPosterFromTech_ = false;
            this.poster_ = "";
        }
        if (this.playerElIngest_) this.playerElIngest_ = null;
        if (this.tag) this.tag = null;
        $cb03b711053a4297$var$clearCacheForPlayer(this);
        // remove all event handlers for track lists
        // all tracks and track listeners are removed on
        // tech dispose
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            const list = this[props.getterName]();
            // if it is not a native list
            // we have to manually remove event listeners
            if (list && list.off) list.off();
        });
        // the actual .el_ is removed here, or replaced if
        super.dispose({
            restoreEl: this.options_.restoreEl
        });
    }
    /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */ createEl() {
        let tag = this.tag;
        let el;
        let playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute("data-vjs-player");
        const divEmbed = this.tag.tagName.toLowerCase() === "video-js";
        if (playerElIngest) el = this.el_ = tag.parentNode;
        else if (!divEmbed) el = this.el_ = super.createEl("div");
        // Copy over all the attributes from the tag, including ID and class
        // ID will now reference player box, not the video tag
        const attrs = $cb03b711053a4297$var$getAttributes(tag);
        if (divEmbed) {
            el = this.el_ = tag;
            tag = this.tag = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("video");
            while(el.children.length)tag.appendChild(el.firstChild);
            if (!$cb03b711053a4297$var$hasClass(el, "video-js")) $cb03b711053a4297$var$addClass(el, "video-js");
            el.appendChild(tag);
            playerElIngest = this.playerElIngest_ = el;
            // move properties over from our custom `video-js` element
            // to our new `video` element. This will move things like
            // `src` or `controls` that were set via js before the player
            // was initialized.
            Object.keys(el).forEach((k)=>{
                try {
                    tag[k] = el[k];
                } catch (e) {
                // we got a a property like outerHTML which we can't actually copy, ignore it
                }
            });
        }
        // set tabindex to -1 to remove the video element from the focus order
        tag.setAttribute("tabindex", "-1");
        attrs.tabindex = "-1";
        // Workaround for #4583 on Chrome (on Windows) with JAWS.
        // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
        // Note that we can't detect if JAWS is being used, but this ARIA attribute
        // doesn't change behavior of Chrome if JAWS is not being used
        if ($cb03b711053a4297$var$IS_CHROME && $cb03b711053a4297$var$IS_WINDOWS) {
            tag.setAttribute("role", "application");
            attrs.role = "application";
        }
        // Remove width/height attrs from tag so CSS can make it 100% width/height
        tag.removeAttribute("width");
        tag.removeAttribute("height");
        if ("width" in attrs) delete attrs.width;
        if ("height" in attrs) delete attrs.height;
        Object.getOwnPropertyNames(attrs).forEach(function(attr) {
            // don't copy over the class attribute to the player element when we're in a div embed
            // the class is already set up properly in the divEmbed case
            // and we want to make sure that the `video-js` class doesn't get lost
            if (!(divEmbed && attr === "class")) el.setAttribute(attr, attrs[attr]);
            if (divEmbed) tag.setAttribute(attr, attrs[attr]);
        });
        // Update tag id/class for use as HTML5 playback tech
        // Might think we should do this after embedding in container so .vjs-tech class
        // doesn't flash 100% width/height, but class only applies with .video-js parent
        tag.playerId = tag.id;
        tag.id += "_html5_api";
        tag.className = "vjs-tech";
        // Make player findable on elements
        tag.player = el.player = this;
        // Default state of video is paused
        this.addClass("vjs-paused");
        // Add a style element in the player that we'll use to set the width/height
        // of the player in a way that's still overridable by CSS, just like the
        // video element
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VIDEOJS_NO_DYNAMIC_STYLE !== true) {
            this.styleEl_ = $cb03b711053a4297$var$createStyleElement("vjs-styles-dimensions");
            const defaultsStyleEl = $cb03b711053a4297$var$$(".vjs-styles-defaults");
            const head = $cb03b711053a4297$var$$("head");
            head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
        }
        this.fill_ = false;
        this.fluid_ = false;
        // Pass in the width/height/aspectRatio options which will update the style el
        this.width(this.options_.width);
        this.height(this.options_.height);
        this.fill(this.options_.fill);
        this.fluid(this.options_.fluid);
        this.aspectRatio(this.options_.aspectRatio);
        // support both crossOrigin and crossorigin to reduce confusion and issues around the name
        this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
        // Hide any links within the video/audio tag,
        // because IE doesn't hide them completely from screen readers.
        const links = tag.getElementsByTagName("a");
        for(let i = 0; i < links.length; i++){
            const linkEl = links.item(i);
            $cb03b711053a4297$var$addClass(linkEl, "vjs-hidden");
            linkEl.setAttribute("hidden", "hidden");
        }
        // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
        // keep track of the original for later so we can know if the source originally failed
        tag.initNetworkState_ = tag.networkState;
        // Wrap video tag in div (el/box) container
        if (tag.parentNode && !playerElIngest) tag.parentNode.insertBefore(el, tag);
        // insert the tag as the first child of the player element
        // then manually add it to the children array so that this.addChild
        // will work properly for other components
        //
        // Breaks iPhone, fixed in HTML5 setup.
        $cb03b711053a4297$var$prependTo(tag, el);
        this.children_.unshift(tag);
        // Set lang attr on player to ensure CSS :lang() in consistent with player
        // if it's been set to something different to the doc
        this.el_.setAttribute("lang", this.language_);
        this.el_.setAttribute("translate", "no");
        this.el_ = el;
        return el;
    }
    /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */ crossOrigin(value) {
        // `null` can be set to unset a value
        if (typeof value === "undefined") return this.techGet_("crossOrigin");
        if (value !== null && value !== "anonymous" && value !== "use-credentials") {
            $cb03b711053a4297$var$log$1.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${value}"`);
            return;
        }
        this.techCall_("setCrossOrigin", value);
        if (this.posterImage) this.posterImage.crossOrigin(value);
        return;
    }
    /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */ width(value) {
        return this.dimension("width", value);
    }
    /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */ height(value) {
        return this.dimension("height", value);
    }
    /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */ dimension(dimension, value) {
        const privDimension = dimension + "_";
        if (value === undefined) return this[privDimension] || 0;
        if (value === "" || value === "auto") {
            // If an empty string is given, reset the dimension to be automatic
            this[privDimension] = undefined;
            this.updateStyleEl_();
            return;
        }
        const parsedVal = parseFloat(value);
        if (isNaN(parsedVal)) {
            $cb03b711053a4297$var$log$1.error(`Improper value "${value}" supplied for for ${dimension}`);
            return;
        }
        this[privDimension] = parsedVal;
        this.updateStyleEl_();
    }
    /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */ fluid(bool) {
        if (bool === undefined) return !!this.fluid_;
        this.fluid_ = !!bool;
        if ($cb03b711053a4297$var$isEvented(this)) this.off([
            "playerreset",
            "resize"
        ], this.boundUpdateStyleEl_);
        if (bool) {
            this.addClass("vjs-fluid");
            this.fill(false);
            $cb03b711053a4297$var$addEventedCallback(this, ()=>{
                this.on([
                    "playerreset",
                    "resize"
                ], this.boundUpdateStyleEl_);
            });
        } else this.removeClass("vjs-fluid");
        this.updateStyleEl_();
    }
    /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */ fill(bool) {
        if (bool === undefined) return !!this.fill_;
        this.fill_ = !!bool;
        if (bool) {
            this.addClass("vjs-fill");
            this.fluid(false);
        } else this.removeClass("vjs-fill");
    }
    /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */ /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */ aspectRatio(ratio) {
        if (ratio === undefined) return this.aspectRatio_;
        // Check for width:height format
        if (!/^\d+\:\d+$/.test(ratio)) throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
        this.aspectRatio_ = ratio;
        // We're assuming if you set an aspect ratio you want fluid mode,
        // because in fixed mode you could calculate width and height yourself.
        this.fluid(true);
        this.updateStyleEl_();
    }
    /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */ updateStyleEl_() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VIDEOJS_NO_DYNAMIC_STYLE === true) {
            const width = typeof this.width_ === "number" ? this.width_ : this.options_.width;
            const height = typeof this.height_ === "number" ? this.height_ : this.options_.height;
            const techEl = this.tech_ && this.tech_.el();
            if (techEl) {
                if (width >= 0) techEl.width = width;
                if (height >= 0) techEl.height = height;
            }
            return;
        }
        let width;
        let height;
        let aspectRatio;
        let idClass;
        // The aspect ratio is either used directly or to calculate width and height.
        if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== "auto") // Use any aspectRatio that's been specifically set
        aspectRatio = this.aspectRatio_;
        else if (this.videoWidth() > 0) // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = this.videoWidth() + ":" + this.videoHeight();
        else // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = "16:9";
        // Get the ratio as a decimal we can use to calculate dimensions
        const ratioParts = aspectRatio.split(":");
        const ratioMultiplier = ratioParts[1] / ratioParts[0];
        if (this.width_ !== undefined) // Use any width that's been specifically set
        width = this.width_;
        else if (this.height_ !== undefined) // Or calculate the width from the aspect ratio if a height has been set
        width = this.height_ / ratioMultiplier;
        else // Or use the video's metadata, or use the video el's default of 300
        width = this.videoWidth() || 300;
        if (this.height_ !== undefined) // Use any height that's been specifically set
        height = this.height_;
        else // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
        // Ensure the CSS class is valid by starting with an alpha character
        if (/^[^a-zA-Z]/.test(this.id())) idClass = "dimensions-" + this.id();
        else idClass = this.id() + "-dimensions";
        // Ensure the right class is still on the player for the style element
        this.addClass(idClass);
        $cb03b711053a4297$var$setTextContent(this.styleEl_, `
      .${idClass} {
        width: ${width}px;
        height: ${height}px;
      }

      .${idClass}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${ratioMultiplier * 100}%;
      }
    `);
    }
    /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */ loadTech_(techName, source) {
        // Pause and remove current playback technology
        if (this.tech_) this.unloadTech_();
        const titleTechName = $cb03b711053a4297$var$toTitleCase$1(techName);
        const camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);
        // get rid of the HTML5 video tag as soon as we are using another tech
        if (titleTechName !== "Html5" && this.tag) {
            $cb03b711053a4297$var$Tech.getTech("Html5").disposeMediaElement(this.tag);
            this.tag.player = null;
            this.tag = null;
        }
        this.techName_ = titleTechName;
        // Turn off API access because we're loading a new tech that might load asynchronously
        this.isReady_ = false;
        let autoplay = this.autoplay();
        // if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
        // because the player is going to handle autoplay on `loadstart`
        if (typeof this.autoplay() === "string" || this.autoplay() === true && this.options_.normalizeAutoplay) autoplay = false;
        // Grab tech-specific options from player options and add source and parent element to use.
        const techOptions = {
            source: source,
            autoplay: autoplay,
            "nativeControlsForTouch": this.options_.nativeControlsForTouch,
            "playerId": this.id(),
            "techId": `${this.id()}_${camelTechName}_api`,
            "playsinline": this.options_.playsinline,
            "preload": this.options_.preload,
            "loop": this.options_.loop,
            "disablePictureInPicture": this.options_.disablePictureInPicture,
            "muted": this.options_.muted,
            "poster": this.poster(),
            "language": this.language(),
            "playerElIngest": this.playerElIngest_ || false,
            "vtt.js": this.options_["vtt.js"],
            "canOverridePoster": !!this.options_.techCanOverridePoster,
            "enableSourceset": this.options_.enableSourceset
        };
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            techOptions[props.getterName] = this[props.privateName];
        });
        Object.assign(techOptions, this.options_[titleTechName]);
        Object.assign(techOptions, this.options_[camelTechName]);
        Object.assign(techOptions, this.options_[techName.toLowerCase()]);
        if (this.tag) techOptions.tag = this.tag;
        if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) techOptions.startTime = this.cache_.currentTime;
        // Initialize tech instance
        const TechClass = $cb03b711053a4297$var$Tech.getTech(techName);
        if (!TechClass) throw new Error(`No Tech named '${titleTechName}' exists! '${titleTechName}' should be registered using videojs.registerTech()'`);
        this.tech_ = new TechClass(techOptions);
        // player.triggerReady is always async, so don't need this to be async
        this.tech_.ready($cb03b711053a4297$var$bind_(this, this.handleTechReady_), true);
        $cb03b711053a4297$var$textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_);
        // Listen to all HTML5-defined events and trigger them on the player
        $cb03b711053a4297$var$TECH_EVENTS_RETRIGGER.forEach((event)=>{
            this.on(this.tech_, event, (e)=>this[`handleTech${$cb03b711053a4297$var$toTitleCase$1(event)}_`](e));
        });
        Object.keys($cb03b711053a4297$var$TECH_EVENTS_QUEUE).forEach((event)=>{
            this.on(this.tech_, event, (eventObj)=>{
                if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
                    this.queuedCallbacks_.push({
                        callback: this[`handleTech${$cb03b711053a4297$var$TECH_EVENTS_QUEUE[event]}_`].bind(this),
                        event: eventObj
                    });
                    return;
                }
                this[`handleTech${$cb03b711053a4297$var$TECH_EVENTS_QUEUE[event]}_`](eventObj);
            });
        });
        this.on(this.tech_, "loadstart", (e)=>this.handleTechLoadStart_(e));
        this.on(this.tech_, "sourceset", (e)=>this.handleTechSourceset_(e));
        this.on(this.tech_, "waiting", (e)=>this.handleTechWaiting_(e));
        this.on(this.tech_, "ended", (e)=>this.handleTechEnded_(e));
        this.on(this.tech_, "seeking", (e)=>this.handleTechSeeking_(e));
        this.on(this.tech_, "play", (e)=>this.handleTechPlay_(e));
        this.on(this.tech_, "pause", (e)=>this.handleTechPause_(e));
        this.on(this.tech_, "durationchange", (e)=>this.handleTechDurationChange_(e));
        this.on(this.tech_, "fullscreenchange", (e, data)=>this.handleTechFullscreenChange_(e, data));
        this.on(this.tech_, "fullscreenerror", (e, err)=>this.handleTechFullscreenError_(e, err));
        this.on(this.tech_, "enterpictureinpicture", (e)=>this.handleTechEnterPictureInPicture_(e));
        this.on(this.tech_, "leavepictureinpicture", (e)=>this.handleTechLeavePictureInPicture_(e));
        this.on(this.tech_, "error", (e)=>this.handleTechError_(e));
        this.on(this.tech_, "posterchange", (e)=>this.handleTechPosterChange_(e));
        this.on(this.tech_, "textdata", (e)=>this.handleTechTextData_(e));
        this.on(this.tech_, "ratechange", (e)=>this.handleTechRateChange_(e));
        this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_);
        this.usingNativeControls(this.techGet_("controls"));
        if (this.controls() && !this.usingNativeControls()) this.addTechControlsListeners_();
        // Add the tech element in the DOM if it was not already there
        // Make sure to not insert the original video element if using Html5
        if (this.tech_.el().parentNode !== this.el() && (titleTechName !== "Html5" || !this.tag)) $cb03b711053a4297$var$prependTo(this.tech_.el(), this.el());
        // Get rid of the original video tag reference after the first tech is loaded
        if (this.tag) {
            this.tag.player = null;
            this.tag = null;
        }
    }
    /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */ unloadTech_() {
        // Save the current text tracks so that we can reuse the same text tracks with the next tech
        $cb03b711053a4297$var$ALL.names.forEach((name)=>{
            const props = $cb03b711053a4297$var$ALL[name];
            this[props.privateName] = this[props.getterName]();
        });
        this.textTracksJson_ = $cb03b711053a4297$var$textTrackConverter.textTracksToJson(this.tech_);
        this.isReady_ = false;
        this.tech_.dispose();
        this.tech_ = false;
        if (this.isPosterFromTech_) {
            this.poster_ = "";
            this.trigger("posterchange");
        }
        this.isPosterFromTech_ = false;
    }
    /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */ tech(safety) {
        if (safety === undefined) $cb03b711053a4297$var$log$1.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n");
        return this.tech_;
    }
    /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */ addTechControlsListeners_() {
        // Make sure to remove all the previous listeners in case we are called multiple times.
        this.removeTechControlsListeners_();
        this.on(this.tech_, "click", this.boundHandleTechClick_);
        this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
        // If the controls were hidden we don't want that to change without a tap event
        // so we'll check if the controls were already showing before reporting user
        // activity
        this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_);
        this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_);
        this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_);
        // The tap listener needs to come after the touchend listener because the tap
        // listener cancels out any reportedUserActivity when setting userActive(false)
        this.on(this.tech_, "tap", this.boundHandleTechTap_);
    }
    /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */ removeTechControlsListeners_() {
        // We don't want to just use `this.off()` because there might be other needed
        // listeners added by techs that extend this.
        this.off(this.tech_, "tap", this.boundHandleTechTap_);
        this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_);
        this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_);
        this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_);
        this.off(this.tech_, "click", this.boundHandleTechClick_);
        this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
    }
    /**
   * Player waits for the tech to be ready
   *
   * @private
   */ handleTechReady_() {
        this.triggerReady();
        // Keep the same volume as before
        if (this.cache_.volume) this.techCall_("setVolume", this.cache_.volume);
        // Look if the tech found a higher resolution poster while loading
        this.handleTechPosterChange_();
        // Update the duration if available
        this.handleTechDurationChange_();
    }
    /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */ handleTechLoadStart_() {
        // TODO: Update to use `emptied` event instead. See #1277.
        this.removeClass("vjs-ended", "vjs-seeking");
        // reset the error state
        this.error(null);
        // Update the duration
        this.handleTechDurationChange_();
        if (!this.paused()) /**
       * Fired when the user agent begins looking for media data
       *
       * @event Player#loadstart
       * @type {Event}
       */ this.trigger("loadstart");
        else {
            // reset the hasStarted state
            this.hasStarted(false);
            this.trigger("loadstart");
        }
        // autoplay happens after loadstart for the browser,
        // so we mimic that behavior
        this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? "play" : this.autoplay());
    }
    /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */ manualAutoplay_(type) {
        if (!this.tech_ || typeof type !== "string") return;
        // Save original muted() value, set muted to true, and attempt to play().
        // On promise rejection, restore muted from saved value
        const resolveMuted = ()=>{
            const previouslyMuted = this.muted();
            this.muted(true);
            const restoreMuted = ()=>{
                this.muted(previouslyMuted);
            };
            // restore muted on play terminatation
            this.playTerminatedQueue_.push(restoreMuted);
            const mutedPromise = this.play();
            if (!$cb03b711053a4297$var$isPromise(mutedPromise)) return;
            return mutedPromise.catch((err)=>{
                restoreMuted();
                throw new Error(`Rejection at manualAutoplay. Restoring muted value. ${err ? err : ""}`);
            });
        };
        let promise;
        // if muted defaults to true
        // the only thing we can do is call play
        if (type === "any" && !this.muted()) {
            promise = this.play();
            if ($cb03b711053a4297$var$isPromise(promise)) promise = promise.catch(resolveMuted);
        } else if (type === "muted" && !this.muted()) promise = resolveMuted();
        else promise = this.play();
        if (!$cb03b711053a4297$var$isPromise(promise)) return;
        return promise.then(()=>{
            this.trigger({
                type: "autoplay-success",
                autoplay: type
            });
        }).catch(()=>{
            this.trigger({
                type: "autoplay-failure",
                autoplay: type
            });
        });
    }
    /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */ updateSourceCaches_(srcObj = "") {
        let src = srcObj;
        let type = "";
        if (typeof src !== "string") {
            src = srcObj.src;
            type = srcObj.type;
        }
        // make sure all the caches are set to default values
        // to prevent null checking
        this.cache_.source = this.cache_.source || {};
        this.cache_.sources = this.cache_.sources || [];
        // try to get the type of the src that was passed in
        if (src && !type) type = $cb03b711053a4297$var$findMimetype(this, src);
        // update `currentSource` cache always
        this.cache_.source = $cb03b711053a4297$var$merge$1({}, srcObj, {
            src: src,
            type: type
        });
        const matchingSources = this.cache_.sources.filter((s)=>s.src && s.src === src);
        const sourceElSources = [];
        const sourceEls = this.$$("source");
        const matchingSourceEls = [];
        for(let i = 0; i < sourceEls.length; i++){
            const sourceObj = $cb03b711053a4297$var$getAttributes(sourceEls[i]);
            sourceElSources.push(sourceObj);
            if (sourceObj.src && sourceObj.src === src) matchingSourceEls.push(sourceObj.src);
        }
        // if we have matching source els but not matching sources
        // the current source cache is not up to date
        if (matchingSourceEls.length && !matchingSources.length) this.cache_.sources = sourceElSources;
        else if (!matchingSources.length) this.cache_.sources = [
            this.cache_.source
        ];
        // update the tech `src` cache
        this.cache_.src = src;
    }
    /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */ /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */ handleTechSourceset_(event) {
        // only update the source cache when the source
        // was not updated using the player api
        if (!this.changingSrc_) {
            let updateSourceCaches = (src)=>this.updateSourceCaches_(src);
            const playerSrc = this.currentSource().src;
            const eventSrc = event.src;
            // if we have a playerSrc that is not a blob, and a tech src that is a blob
            if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) // if both the tech source and the player source were updated we assume
            // something like @videojs/http-streaming did the sourceset and skip updating the source cache.
            {
                if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) updateSourceCaches = ()=>{};
            }
            // update the source to the initial source right away
            // in some cases this will be empty string
            updateSourceCaches(eventSrc);
            // if the `sourceset` `src` was an empty string
            // wait for a `loadstart` to update the cache to `currentSrc`.
            // If a sourceset happens before a `loadstart`, we reset the state
            if (!event.src) this.tech_.any([
                "sourceset",
                "loadstart"
            ], (e)=>{
                // if a sourceset happens before a `loadstart` there
                // is nothing to do as this `handleTechSourceset_`
                // will be called again and this will be handled there.
                if (e.type === "sourceset") return;
                const techSrc = this.techGet_("currentSrc");
                this.lastSource_.tech = techSrc;
                this.updateSourceCaches_(techSrc);
            });
        }
        this.lastSource_ = {
            player: this.currentSource().src,
            tech: event.src
        };
        this.trigger({
            src: event.src,
            type: "sourceset"
        });
    }
    /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */ hasStarted(request) {
        if (request === undefined) // act as getter, if we have no request to change
        return this.hasStarted_;
        if (request === this.hasStarted_) return;
        this.hasStarted_ = request;
        if (this.hasStarted_) this.addClass("vjs-has-started");
        else this.removeClass("vjs-has-started");
    }
    /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */ handleTechPlay_() {
        this.removeClass("vjs-ended", "vjs-paused");
        this.addClass("vjs-playing");
        // hide the poster when the user hits play
        this.hasStarted(true);
        /**
     * Triggered whenever an {@link Tech#play} event happens. Indicates that
     * playback has started or resumed.
     *
     * @event Player#play
     * @type {Event}
     */ this.trigger("play");
    }
    /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */ handleTechRateChange_() {
        if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
            this.queuedCallbacks_.forEach((queued)=>queued.callback(queued.event));
            this.queuedCallbacks_ = [];
        }
        this.cache_.lastPlaybackRate = this.tech_.playbackRate();
        /**
     * Fires when the playing speed of the audio/video is changed
     *
     * @event Player#ratechange
     * @type {event}
     */ this.trigger("ratechange");
    }
    /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */ handleTechWaiting_() {
        this.addClass("vjs-waiting");
        /**
     * A readyState change on the DOM element has caused playback to stop.
     *
     * @event Player#waiting
     * @type {Event}
     */ this.trigger("waiting");
        // Browsers may emit a timeupdate event after a waiting event. In order to prevent
        // premature removal of the waiting class, wait for the time to change.
        const timeWhenWaiting = this.currentTime();
        const timeUpdateListener = ()=>{
            if (timeWhenWaiting !== this.currentTime()) {
                this.removeClass("vjs-waiting");
                this.off("timeupdate", timeUpdateListener);
            }
        };
        this.on("timeupdate", timeUpdateListener);
    }
    /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */ handleTechCanPlay_() {
        this.removeClass("vjs-waiting");
        /**
     * The media has a readyState of HAVE_FUTURE_DATA or greater.
     *
     * @event Player#canplay
     * @type {Event}
     */ this.trigger("canplay");
    }
    /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */ handleTechCanPlayThrough_() {
        this.removeClass("vjs-waiting");
        /**
     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
     * entire media file can be played without buffering.
     *
     * @event Player#canplaythrough
     * @type {Event}
     */ this.trigger("canplaythrough");
    }
    /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */ handleTechPlaying_() {
        this.removeClass("vjs-waiting");
        /**
     * The media is no longer blocked from playback, and has started playing.
     *
     * @event Player#playing
     * @type {Event}
     */ this.trigger("playing");
    }
    /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */ handleTechSeeking_() {
        this.addClass("vjs-seeking");
        /**
     * Fired whenever the player is jumping to a new time
     *
     * @event Player#seeking
     * @type {Event}
     */ this.trigger("seeking");
    }
    /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */ handleTechSeeked_() {
        this.removeClass("vjs-seeking", "vjs-ended");
        /**
     * Fired when the player has finished jumping to a new time
     *
     * @event Player#seeked
     * @type {Event}
     */ this.trigger("seeked");
    }
    /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */ handleTechPause_() {
        this.removeClass("vjs-playing");
        this.addClass("vjs-paused");
        /**
     * Fired whenever the media has been paused
     *
     * @event Player#pause
     * @type {Event}
     */ this.trigger("pause");
    }
    /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */ handleTechEnded_() {
        this.addClass("vjs-ended");
        this.removeClass("vjs-waiting");
        if (this.options_.loop) {
            this.currentTime(0);
            this.play();
        } else if (!this.paused()) this.pause();
        /**
     * Fired when the end of the media resource is reached (currentTime == duration)
     *
     * @event Player#ended
     * @type {Event}
     */ this.trigger("ended");
    }
    /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */ handleTechDurationChange_() {
        this.duration(this.techGet_("duration"));
    }
    /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */ handleTechClick_(event) {
        // When controls are disabled a click should not toggle playback because
        // the click is considered a control
        if (!this.controls_) return;
        if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.click === undefined || this.options_.userActions.click !== false) {
            if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.click === "function") this.options_.userActions.click.call(this, event);
            else if (this.paused()) $cb03b711053a4297$var$silencePromise(this.play());
            else this.pause();
        }
    }
    /**
   * Handle a double-click on the media element to enter/exit fullscreen
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */ handleTechDoubleClick_(event) {
        if (!this.controls_) return;
        // we do not want to toggle fullscreen state
        // when double-clicking inside a control bar or a modal
        const inAllowedEls = Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (el)=>el.contains(event.target));
        if (!inAllowedEls) /*
       * options.userActions.doubleClick
       *
       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
       * Set to `false` to disable double-click handling
       * Set to a function to substitute an external double-click handler
       */ {
            if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.doubleClick === undefined || this.options_.userActions.doubleClick !== false) {
                if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.doubleClick === "function") this.options_.userActions.doubleClick.call(this, event);
                else if (this.isFullscreen()) this.exitFullscreen();
                else this.requestFullscreen();
            }
        }
    }
    /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */ handleTechTap_() {
        this.userActive(!this.userActive());
    }
    /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */ handleTechTouchStart_() {
        this.userWasActive = this.userActive();
    }
    /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */ handleTechTouchMove_() {
        if (this.userWasActive) this.reportUserActivity();
    }
    /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */ handleTechTouchEnd_(event) {
        // Stop the mouse events from also happening
        if (event.cancelable) event.preventDefault();
    }
    /**
   * @private
   */ toggleFullscreenClass_() {
        if (this.isFullscreen()) this.addClass("vjs-fullscreen");
        else this.removeClass("vjs-fullscreen");
    }
    /**
   * when the document fschange event triggers it calls this
   */ documentFullscreenChange_(e) {
        const targetPlayer = e.target.player;
        // if another player was fullscreen
        // do a null check for targetPlayer because older firefox's would put document as e.target
        if (targetPlayer && targetPlayer !== this) return;
        const el = this.el();
        let isFs = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[this.fsApi_.fullscreenElement] === el;
        if (!isFs && el.matches) isFs = el.matches(":" + this.fsApi_.fullscreen);
        this.isFullscreen(isFs);
    }
    /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */ handleTechFullscreenChange_(event, data) {
        if (data) {
            if (data.nativeIOSFullscreen) {
                this.addClass("vjs-ios-native-fs");
                this.tech_.one("webkitendfullscreen", ()=>{
                    this.removeClass("vjs-ios-native-fs");
                });
            }
            this.isFullscreen(data.isFullscreen);
        }
    }
    handleTechFullscreenError_(event, err) {
        this.trigger("fullscreenerror", err);
    }
    /**
   * @private
   */ togglePictureInPictureClass_() {
        if (this.isInPictureInPicture()) this.addClass("vjs-picture-in-picture");
        else this.removeClass("vjs-picture-in-picture");
    }
    /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */ handleTechEnterPictureInPicture_(event) {
        this.isInPictureInPicture(true);
    }
    /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */ handleTechLeavePictureInPicture_(event) {
        this.isInPictureInPicture(false);
    }
    /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */ handleTechError_() {
        const error = this.tech_.error();
        if (error) this.error(error);
    }
    /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */ handleTechTextData_() {
        let data = null;
        if (arguments.length > 1) data = arguments[1];
        /**
     * Fires when we get a textdata event from tech
     *
     * @event Player#textdata
     * @type {Event}
     */ this.trigger("textdata", data);
    }
    /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */ getCache() {
        return this.cache_;
    }
    /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */ resetCache_() {
        this.cache_ = {
            // Right now, the currentTime is not _really_ cached because it is always
            // retrieved from the tech (see: currentTime). However, for completeness,
            // we set it to zero here to ensure that if we do start actually caching
            // it, we reset it along with everything else.
            currentTime: 0,
            initTime: 0,
            inactivityTimeout: this.options_.inactivityTimeout,
            duration: NaN,
            lastVolume: 1,
            lastPlaybackRate: this.defaultPlaybackRate(),
            media: null,
            src: "",
            source: {},
            sources: [],
            playbackRates: [],
            volume: 1
        };
    }
    /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */ techCall_(method, arg) {
        // If it's not ready yet, call method when it is
        this.ready(function() {
            if (method in $cb03b711053a4297$var$allowedSetters) return $cb03b711053a4297$var$set(this.middleware_, this.tech_, method, arg);
            else if (method in $cb03b711053a4297$var$allowedMediators) return $cb03b711053a4297$var$mediate(this.middleware_, this.tech_, method, arg);
            try {
                if (this.tech_) this.tech_[method](arg);
            } catch (e) {
                $cb03b711053a4297$var$log$1(e);
                throw e;
            }
        }, true);
    }
    /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */ techGet_(method) {
        if (!this.tech_ || !this.tech_.isReady_) return;
        if (method in $cb03b711053a4297$var$allowedGetters) return $cb03b711053a4297$var$get(this.middleware_, this.tech_, method);
        else if (method in $cb03b711053a4297$var$allowedMediators) return $cb03b711053a4297$var$mediate(this.middleware_, this.tech_, method);
        // Log error when playback tech object is present but method
        // is undefined or unavailable
        try {
            return this.tech_[method]();
        } catch (e) {
            // When building additional tech libs, an expected method may not be defined yet
            if (this.tech_[method] === undefined) {
                $cb03b711053a4297$var$log$1(`Video.js: ${method} method not defined for ${this.techName_} playback technology.`, e);
                throw e;
            }
            // When a method isn't available on the object it throws a TypeError
            if (e.name === "TypeError") {
                $cb03b711053a4297$var$log$1(`Video.js: ${method} unavailable on ${this.techName_} playback technology element.`, e);
                this.tech_.isReady_ = false;
                throw e;
            }
            // If error unknown, just log and throw
            $cb03b711053a4297$var$log$1(e);
            throw e;
        }
    }
    /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */ play() {
        return new Promise((resolve)=>{
            this.play_(resolve);
        });
    }
    /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */ play_(callback = $cb03b711053a4297$var$silencePromise) {
        this.playCallbacks_.push(callback);
        const isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
        const isSafariOrIOS = Boolean($cb03b711053a4297$var$IS_ANY_SAFARI || $cb03b711053a4297$var$IS_IOS);
        // treat calls to play_ somewhat like the `one` event function
        if (this.waitToPlay_) {
            this.off([
                "ready",
                "loadstart"
            ], this.waitToPlay_);
            this.waitToPlay_ = null;
        }
        // if the player/tech is not ready or the src itself is not ready
        // queue up a call to play on `ready` or `loadstart`
        if (!this.isReady_ || !isSrcReady) {
            this.waitToPlay_ = (e)=>{
                this.play_();
            };
            this.one([
                "ready",
                "loadstart"
            ], this.waitToPlay_);
            // if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
            // in that case, we need to prime the video element by calling load so it'll be ready in time
            if (!isSrcReady && isSafariOrIOS) this.load();
            return;
        }
        // If the player/tech is ready and we have a source, we can attempt playback.
        const val = this.techGet_("play");
        // For native playback, reset the progress bar if we get a play call from a replay.
        const isNativeReplay = isSafariOrIOS && this.hasClass("vjs-ended");
        if (isNativeReplay) this.resetProgressBar_();
        // play was terminated if the returned value is null
        if (val === null) this.runPlayTerminatedQueue_();
        else this.runPlayCallbacks_(val);
    }
    /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */ runPlayTerminatedQueue_() {
        const queue = this.playTerminatedQueue_.slice(0);
        this.playTerminatedQueue_ = [];
        queue.forEach(function(q) {
            q();
        });
    }
    /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */ runPlayCallbacks_(val) {
        const callbacks = this.playCallbacks_.slice(0);
        this.playCallbacks_ = [];
        // clear play terminatedQueue since we finished a real play
        this.playTerminatedQueue_ = [];
        callbacks.forEach(function(cb) {
            cb(val);
        });
    }
    /**
   * Pause the video playback
   */ pause() {
        this.techCall_("pause");
    }
    /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */ paused() {
        // The initial state of paused should be true (in Safari it's actually false)
        return this.techGet_("paused") === false ? false : true;
    }
    /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return { import('./utils/time').TimeRange }
   *         A time range object that represents all the increments of time that have
   *         been played.
   */ played() {
        return this.techGet_("played") || $cb03b711053a4297$var$createTimeRanges$1(0, 0);
    }
    /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */ scrubbing(isScrubbing) {
        if (typeof isScrubbing === "undefined") return this.scrubbing_;
        this.scrubbing_ = !!isScrubbing;
        this.techCall_("setScrubbing", this.scrubbing_);
        if (isScrubbing) this.addClass("vjs-scrubbing");
        else this.removeClass("vjs-scrubbing");
    }
    /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */ currentTime(seconds) {
        if (seconds === undefined) {
            // cache last currentTime and return. default to 0 seconds
            //
            // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
            // currentTime when scrubbing, but may not provide much performance benefit after all.
            // Should be tested. Also something has to read the actual current time or the cache will
            // never get updated.
            this.cache_.currentTime = this.techGet_("currentTime") || 0;
            return this.cache_.currentTime;
        }
        if (seconds < 0) seconds = 0;
        if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
            this.cache_.initTime = seconds;
            this.off("canplay", this.boundApplyInitTime_);
            this.one("canplay", this.boundApplyInitTime_);
            return;
        }
        this.techCall_("setCurrentTime", seconds);
        this.cache_.initTime = 0;
        if (isFinite(seconds)) this.cache_.currentTime = Number(seconds);
    }
    /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */ applyInitTime_() {
        this.currentTime(this.cache_.initTime);
    }
    /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */ duration(seconds) {
        if (seconds === undefined) // return NaN if the duration is not known
        return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
        seconds = parseFloat(seconds);
        // Standardize on Infinity for signaling video is live
        if (seconds < 0) seconds = Infinity;
        if (seconds !== this.cache_.duration) {
            // Cache the last set value for optimized scrubbing
            this.cache_.duration = seconds;
            if (seconds === Infinity) this.addClass("vjs-live");
            else this.removeClass("vjs-live");
            if (!isNaN(seconds)) // Do not fire durationchange unless the duration value is known.
            // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
            /**
         * @event Player#durationchange
         * @type {Event}
         */ this.trigger("durationchange");
        }
    }
    /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */ remainingTime() {
        return this.duration() - this.currentTime();
    }
    /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */ remainingTimeDisplay() {
        return Math.floor(this.duration()) - Math.floor(this.currentTime());
    }
    //
    // Kind of like an array of portions of the video that have been downloaded.
    /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return { import('./utils/time').TimeRange }
   *         A mock {@link TimeRanges} object (following HTML spec)
   */ buffered() {
        let buffered = this.techGet_("buffered");
        if (!buffered || !buffered.length) buffered = $cb03b711053a4297$var$createTimeRanges$1(0, 0);
        return buffered;
    }
    /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */ bufferedPercent() {
        return $cb03b711053a4297$var$bufferedPercent(this.buffered(), this.duration());
    }
    /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */ bufferedEnd() {
        const buffered = this.buffered();
        const duration = this.duration();
        let end = buffered.end(buffered.length - 1);
        if (end > duration) end = duration;
        return end;
    }
    /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */ volume(percentAsDecimal) {
        let vol;
        if (percentAsDecimal !== undefined) {
            // Force value to between 0 and 1
            vol = Math.max(0, Math.min(1, percentAsDecimal));
            this.cache_.volume = vol;
            this.techCall_("setVolume", vol);
            if (vol > 0) this.lastVolume_(vol);
            return;
        }
        // Default to 1 when returning current volume.
        vol = parseFloat(this.techGet_("volume"));
        return isNaN(vol) ? 1 : vol;
    }
    /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */ muted(muted) {
        if (muted !== undefined) {
            this.techCall_("setMuted", muted);
            return;
        }
        return this.techGet_("muted") || false;
    }
    /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */ defaultMuted(defaultMuted) {
        if (defaultMuted !== undefined) this.techCall_("setDefaultMuted", defaultMuted);
        return this.techGet_("defaultMuted") || false;
    }
    /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */ lastVolume_(percentAsDecimal) {
        if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
            this.cache_.lastVolume = percentAsDecimal;
            return;
        }
        return this.cache_.lastVolume;
    }
    /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */ supportsFullScreen() {
        return this.techGet_("supportsFullScreen") || false;
    }
    /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */ isFullscreen(isFS) {
        if (isFS !== undefined) {
            const oldValue = this.isFullscreen_;
            this.isFullscreen_ = Boolean(isFS);
            // if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
            // this is the only place where we trigger fullscreenchange events for older browsers
            // fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
            if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed) /**
           * @event Player#fullscreenchange
           * @type {Event}
           */ this.trigger("fullscreenchange");
            this.toggleFullscreenClass_();
            return;
        }
        return this.isFullscreen_;
    }
    /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */ requestFullscreen(fullscreenOptions) {
        if (this.isInPictureInPicture()) this.exitPictureInPicture();
        const self1 = this;
        return new Promise((resolve, reject)=>{
            function offHandler() {
                self1.off("fullscreenerror", errorHandler);
                self1.off("fullscreenchange", changeHandler);
            }
            function changeHandler() {
                offHandler();
                resolve();
            }
            function errorHandler(e, err) {
                offHandler();
                reject(err);
            }
            self1.one("fullscreenchange", changeHandler);
            self1.one("fullscreenerror", errorHandler);
            const promise = self1.requestFullscreenHelper_(fullscreenOptions);
            if (promise) {
                promise.then(offHandler, offHandler);
                promise.then(resolve, reject);
            }
        });
    }
    requestFullscreenHelper_(fullscreenOptions) {
        let fsOptions;
        // Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
        // Use defaults or player configured option unless passed directly to this method.
        if (!this.fsApi_.prefixed) {
            fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
            if (fullscreenOptions !== undefined) fsOptions = fullscreenOptions;
        }
        // This method works as follows:
        // 1. if a fullscreen api is available, use it
        //   1. call requestFullscreen with potential options
        //   2. if we got a promise from above, use it to update isFullscreen()
        // 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
        //   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
        // 3. otherwise, use "fullWindow" mode
        if (this.fsApi_.requestFullscreen) {
            const promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
            // Even on browsers with promise support this may not return a promise
            if (promise) promise.then(()=>this.isFullscreen(true), ()=>this.isFullscreen(false));
            return promise;
        } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) // we can't take the video.js controls fullscreen but we can go fullscreen
        // with native controls
        this.techCall_("enterFullScreen");
        else // fullscreen isn't supported so we'll just stretch the video element to
        // fill the viewport
        this.enterFullWindow();
    }
    /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */ exitFullscreen() {
        const self1 = this;
        return new Promise((resolve, reject)=>{
            function offHandler() {
                self1.off("fullscreenerror", errorHandler);
                self1.off("fullscreenchange", changeHandler);
            }
            function changeHandler() {
                offHandler();
                resolve();
            }
            function errorHandler(e, err) {
                offHandler();
                reject(err);
            }
            self1.one("fullscreenchange", changeHandler);
            self1.one("fullscreenerror", errorHandler);
            const promise = self1.exitFullscreenHelper_();
            if (promise) {
                promise.then(offHandler, offHandler);
                // map the promise to our resolve/reject methods
                promise.then(resolve, reject);
            }
        });
    }
    exitFullscreenHelper_() {
        if (this.fsApi_.requestFullscreen) {
            const promise = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[this.fsApi_.exitFullscreen]();
            // Even on browsers with promise support this may not return a promise
            if (promise) // we're splitting the promise here, so, we want to catch the
            // potential error so that this chain doesn't have unhandled errors
            $cb03b711053a4297$var$silencePromise(promise.then(()=>this.isFullscreen(false)));
            return promise;
        } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) this.techCall_("exitFullScreen");
        else this.exitFullWindow();
    }
    /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */ enterFullWindow() {
        this.isFullscreen(true);
        this.isFullWindow = true;
        // Storing original doc overflow value to return to when fullscreen is off
        this.docOrigOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.style.overflow;
        // Add listener for esc key to exit fullscreen
        $cb03b711053a4297$var$on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "keydown", this.boundFullWindowOnEscKey_);
        // Hide any scroll bars
        (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.style.overflow = "hidden";
        // Apply fullscreen styles
        $cb03b711053a4297$var$addClass((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body, "vjs-full-window");
        /**
     * @event Player#enterFullWindow
     * @type {Event}
     */ this.trigger("enterFullWindow");
    }
    /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */ fullWindowOnEscKey(event) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(event, "Esc")) {
            if (this.isFullscreen() === true) {
                if (!this.isFullWindow) this.exitFullscreen();
                else this.exitFullWindow();
            }
        }
    }
    /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */ exitFullWindow() {
        this.isFullscreen(false);
        this.isFullWindow = false;
        $cb03b711053a4297$var$off((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), "keydown", this.boundFullWindowOnEscKey_);
        // Unhide scroll bars.
        (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).documentElement.style.overflow = this.docOrigOverflow;
        // Remove fullscreen styles
        $cb03b711053a4297$var$removeClass((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).body, "vjs-full-window");
        // Resize the box, controller, and poster to original sizes
        // this.positionAll();
        /**
     * @event Player#exitFullWindow
     * @type {Event}
     */ this.trigger("exitFullWindow");
    }
    /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */ disablePictureInPicture(value) {
        if (value === undefined) return this.techGet_("disablePictureInPicture");
        this.techCall_("setDisablePictureInPicture", value);
        this.options_.disablePictureInPicture = value;
        this.trigger("disablepictureinpicturechanged");
    }
    /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */ isInPictureInPicture(isPiP) {
        if (isPiP !== undefined) {
            this.isInPictureInPicture_ = !!isPiP;
            this.togglePictureInPictureClass_();
            return;
        }
        return !!this.isInPictureInPicture_;
    }
    /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */ requestPictureInPicture() {
        if (this.options_.enableDocumentPictureInPicture && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture) {
            const pipContainer = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement(this.el().tagName);
            pipContainer.classList = this.el().classList;
            pipContainer.classList.add("vjs-pip-container");
            if (this.posterImage) pipContainer.appendChild(this.posterImage.el().cloneNode(true));
            if (this.titleBar) pipContainer.appendChild(this.titleBar.el().cloneNode(true));
            pipContainer.appendChild($cb03b711053a4297$var$createEl("p", {
                className: "vjs-pip-text"
            }, {}, this.localize("Playing in picture-in-picture")));
            return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture.requestWindow({
                // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
                width: this.videoWidth(),
                height: this.videoHeight()
            }).then((pipWindow)=>{
                $cb03b711053a4297$var$copyStyleSheetsToWindow(pipWindow);
                this.el_.parentNode.insertBefore(pipContainer, this.el_);
                pipWindow.document.body.appendChild(this.el_);
                pipWindow.document.body.classList.add("vjs-pip-window");
                this.player_.isInPictureInPicture(true);
                this.player_.trigger("enterpictureinpicture");
                // Listen for the PiP closing event to move the video back.
                pipWindow.addEventListener("pagehide", (event)=>{
                    const pipVideo = event.target.querySelector(".video-js");
                    pipContainer.parentNode.replaceChild(pipVideo, pipContainer);
                    this.player_.isInPictureInPicture(false);
                    this.player_.trigger("leavepictureinpicture");
                });
                return pipWindow;
            });
        }
        if ("pictureInPictureEnabled" in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) && this.disablePictureInPicture() === false) /**
       * This event fires when the player enters picture in picture mode
       *
       * @event Player#enterpictureinpicture
       * @type {Event}
       */ return this.techGet_("requestPictureInPicture");
        return Promise.reject("No PiP mode is available");
    }
    /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */ exitPictureInPicture() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture.window) {
            // With documentPictureInPicture, Player#leavepictureinpicture is fired in the pagehide handler
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).documentPictureInPicture.window.close();
            return Promise.resolve();
        }
        if ("pictureInPictureEnabled" in (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))) /**
       * This event fires when the player leaves picture in picture mode
       *
       * @event Player#leavepictureinpicture
       * @type {Event}
       */ return (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).exitPictureInPicture();
    }
    /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */ handleKeyDown(event) {
        const { userActions: userActions } = this.options_;
        // Bail out if hotkeys are not configured.
        if (!userActions || !userActions.hotkeys) return;
        // Function that determines whether or not to exclude an element from
        // hotkeys handling.
        const excludeElement = (el)=>{
            const tagName = el.tagName.toLowerCase();
            // The first and easiest test is for `contenteditable` elements.
            if (el.isContentEditable) return true;
            // Inputs matching these types will still trigger hotkey handling as
            // they are not text inputs.
            const allowedInputTypes = [
                "button",
                "checkbox",
                "hidden",
                "radio",
                "reset",
                "submit"
            ];
            if (tagName === "input") return allowedInputTypes.indexOf(el.type) === -1;
            // The final test is by tag name. These tags will be excluded entirely.
            const excludedTags = [
                "textarea"
            ];
            return excludedTags.indexOf(tagName) !== -1;
        };
        // Bail out if the user is focused on an interactive form element.
        if (excludeElement(this.el_.ownerDocument.activeElement)) return;
        if (typeof userActions.hotkeys === "function") userActions.hotkeys.call(this, event);
        else this.handleHotkeys(event);
    }
    /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */ handleHotkeys(event) {
        const hotkeys = this.options_.userActions ? this.options_.userActions.hotkeys : {};
        // set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
        const { fullscreenKey: fullscreenKey = (keydownEvent)=>(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(keydownEvent, "f"), muteKey: muteKey = (keydownEvent)=>(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(keydownEvent, "m"), playPauseKey: playPauseKey = (keydownEvent)=>(0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(keydownEvent, "k") || (0, (/*@__PURE__*/$parcel$interopDefault($jZhQX))).isEventKey(keydownEvent, "Space") } = hotkeys;
        if (fullscreenKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const FSToggle = $cb03b711053a4297$var$Component$1.getComponent("FullscreenToggle");
            if ((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM)))[this.fsApi_.fullscreenEnabled] !== false) FSToggle.prototype.handleClick.call(this, event);
        } else if (muteKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const MuteToggle = $cb03b711053a4297$var$Component$1.getComponent("MuteToggle");
            MuteToggle.prototype.handleClick.call(this, event);
        } else if (playPauseKey.call(this, event)) {
            event.preventDefault();
            event.stopPropagation();
            const PlayToggle = $cb03b711053a4297$var$Component$1.getComponent("PlayToggle");
            PlayToggle.prototype.handleClick.call(this, event);
        }
    }
    /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */ canPlayType(type) {
        let can;
        // Loop through each playback technology in the options order
        for(let i = 0, j = this.options_.techOrder; i < j.length; i++){
            const techName = j[i];
            let tech = $cb03b711053a4297$var$Tech.getTech(techName);
            // Support old behavior of techs being registered as components.
            // Remove once that deprecated behavior is removed.
            if (!tech) tech = $cb03b711053a4297$var$Component$1.getComponent(techName);
            // Check if the current tech is defined before continuing
            if (!tech) {
                $cb03b711053a4297$var$log$1.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
                continue;
            }
            // Check if the browser supports this technology
            if (tech.isSupported()) {
                can = tech.canPlayType(type);
                if (can) return can;
            }
        }
        return "";
    }
    /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */ selectSource(sources) {
        // Get only the techs specified in `techOrder` that exist and are supported by the
        // current platform
        const techs = this.options_.techOrder.map((techName)=>{
            return [
                techName,
                $cb03b711053a4297$var$Tech.getTech(techName)
            ];
        }).filter(([techName, tech])=>{
            // Check if the current tech is defined before continuing
            if (tech) // Check if the browser supports this technology
            return tech.isSupported();
            $cb03b711053a4297$var$log$1.error(`The "${techName}" tech is undefined. Skipped browser support check for that tech.`);
            return false;
        });
        // Iterate over each `innerArray` element once per `outerArray` element and execute
        // `tester` with both. If `tester` returns a non-falsy value, exit early and return
        // that value.
        const findFirstPassingTechSourcePair = function(outerArray, innerArray, tester) {
            let found;
            outerArray.some((outerChoice)=>{
                return innerArray.some((innerChoice)=>{
                    found = tester(outerChoice, innerChoice);
                    if (found) return true;
                });
            });
            return found;
        };
        let foundSourceAndTech;
        const flip = (fn)=>(a, b)=>fn(b, a);
        const finder = ([techName, tech], source)=>{
            if (tech.canPlaySource(source, this.options_[techName.toLowerCase()])) return {
                source: source,
                tech: techName
            };
        };
        // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
        // to select from them based on their priority.
        if (this.options_.sourceOrder) // Source-first ordering
        foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
        else // Tech-first ordering
        foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
        return foundSourceAndTech || false;
    }
    /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */ handleSrc_(source, isRetry) {
        // getter usage
        if (typeof source === "undefined") return this.cache_.src || "";
        // Reset retry behavior for new source
        if (this.resetRetryOnError_) this.resetRetryOnError_();
        // filter out invalid sources and turn our source into
        // an array of source objects
        const sources = $cb03b711053a4297$var$filterSource(source);
        // if a source was passed in then it is invalid because
        // it was filtered to a zero length Array. So we have to
        // show an error
        if (!sources.length) {
            this.setTimeout(function() {
                this.error({
                    code: 4,
                    message: this.options_.notSupportedMessage
                });
            }, 0);
            return;
        }
        // initial sources
        this.changingSrc_ = true;
        // Only update the cached source list if we are not retrying a new source after error,
        // since in that case we want to include the failed source(s) in the cache
        if (!isRetry) this.cache_.sources = sources;
        this.updateSourceCaches_(sources[0]);
        // middlewareSource is the source after it has been changed by middleware
        $cb03b711053a4297$var$setSource(this, sources[0], (middlewareSource, mws)=>{
            this.middleware_ = mws;
            // since sourceSet is async we have to update the cache again after we select a source since
            // the source that is selected could be out of order from the cache update above this callback.
            if (!isRetry) this.cache_.sources = sources;
            this.updateSourceCaches_(middlewareSource);
            const err = this.src_(middlewareSource);
            if (err) {
                if (sources.length > 1) return this.handleSrc_(sources.slice(1));
                this.changingSrc_ = false;
                // We need to wrap this in a timeout to give folks a chance to add error event handlers
                this.setTimeout(function() {
                    this.error({
                        code: 4,
                        message: this.options_.notSupportedMessage
                    });
                }, 0);
                // we could not find an appropriate tech, but let's still notify the delegate that this is it
                // this needs a better comment about why this is needed
                this.triggerReady();
                return;
            }
            $cb03b711053a4297$var$setTech(mws, this.tech_);
        });
        // Try another available source if this one fails before playback.
        if (sources.length > 1) {
            const retry = ()=>{
                // Remove the error modal
                this.error(null);
                this.handleSrc_(sources.slice(1), true);
            };
            const stopListeningForErrors = ()=>{
                this.off("error", retry);
            };
            this.one("error", retry);
            this.one("playing", stopListeningForErrors);
            this.resetRetryOnError_ = ()=>{
                this.off("error", retry);
                this.off("playing", stopListeningForErrors);
            };
        }
    }
    /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */ src(source) {
        return this.handleSrc_(source, false);
    }
    /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */ src_(source) {
        const sourceTech = this.selectSource([
            source
        ]);
        if (!sourceTech) return true;
        if (!$cb03b711053a4297$var$titleCaseEquals(sourceTech.tech, this.techName_)) {
            this.changingSrc_ = true;
            // load this technology with the chosen source
            this.loadTech_(sourceTech.tech, sourceTech.source);
            this.tech_.ready(()=>{
                this.changingSrc_ = false;
            });
            return false;
        }
        // wait until the tech is ready to set the source
        // and set it synchronously if possible (#2326)
        this.ready(function() {
            // The setSource tech method was added with source handlers
            // so older techs won't support it
            // We need to check the direct prototype for the case where subclasses
            // of the tech do not support source handlers
            if (this.tech_.constructor.prototype.hasOwnProperty("setSource")) this.techCall_("setSource", source);
            else this.techCall_("src", source.src);
            this.changingSrc_ = false;
        }, true);
        return false;
    }
    /**
   * Begin loading the src data.
   */ load() {
        // Workaround to use the load method with the VHS.
        // Does not cover the case when the load method is called directly from the mediaElement.
        if (this.tech_ && this.tech_.vhs) {
            this.src(this.currentSource());
            return;
        }
        this.techCall_("load");
    }
    /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */ reset() {
        if (this.paused()) this.doReset_();
        else {
            const playPromise = this.play();
            $cb03b711053a4297$var$silencePromise(playPromise.then(()=>this.doReset_()));
        }
    }
    doReset_() {
        if (this.tech_) this.tech_.clearTracks("text");
        this.resetCache_();
        this.poster("");
        this.loadTech_(this.options_.techOrder[0], null);
        this.techCall_("reset");
        this.resetControlBarUI_();
        if ($cb03b711053a4297$var$isEvented(this)) this.trigger("playerreset");
    }
    /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */ resetControlBarUI_() {
        this.resetProgressBar_();
        this.resetPlaybackRate_();
        this.resetVolumeBar_();
    }
    /**
   * Reset tech's progress so progress bar is reset in the UI
   */ resetProgressBar_() {
        this.currentTime(0);
        const { currentTimeDisplay: currentTimeDisplay, durationDisplay: durationDisplay, progressControl: progressControl, remainingTimeDisplay: remainingTimeDisplay } = this.controlBar || {};
        const { seekBar: seekBar } = progressControl || {};
        if (currentTimeDisplay) currentTimeDisplay.updateContent();
        if (durationDisplay) durationDisplay.updateContent();
        if (remainingTimeDisplay) remainingTimeDisplay.updateContent();
        if (seekBar) {
            seekBar.update();
            if (seekBar.loadProgressBar) seekBar.loadProgressBar.update();
        }
    }
    /**
   * Reset Playback ratio
   */ resetPlaybackRate_() {
        this.playbackRate(this.defaultPlaybackRate());
        this.handleTechRateChange_();
    }
    /**
   * Reset Volume bar
   */ resetVolumeBar_() {
        this.volume(1.0);
        this.trigger("volumechange");
    }
    /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */ currentSources() {
        const source = this.currentSource();
        const sources = [];
        // assume `{}` or `{ src }`
        if (Object.keys(source).length !== 0) sources.push(source);
        return this.cache_.sources || sources;
    }
    /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */ currentSource() {
        return this.cache_.source || {};
    }
    /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */ currentSrc() {
        return this.currentSource() && this.currentSource().src || "";
    }
    /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */ currentType() {
        return this.currentSource() && this.currentSource().type || "";
    }
    /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */ preload(value) {
        if (value !== undefined) {
            this.techCall_("setPreload", value);
            this.options_.preload = value;
            return;
        }
        return this.techGet_("preload");
    }
    /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */ autoplay(value) {
        // getter usage
        if (value === undefined) return this.options_.autoplay || false;
        let techAutoplay;
        // if the value is a valid string set it to that, or normalize `true` to 'play', if need be
        if (typeof value === "string" && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
            this.options_.autoplay = value;
            this.manualAutoplay_(typeof value === "string" ? value : "play");
            techAutoplay = false;
        // any falsy value sets autoplay to false in the browser,
        // lets do the same
        } else if (!value) this.options_.autoplay = false;
        else this.options_.autoplay = true;
        techAutoplay = typeof techAutoplay === "undefined" ? this.options_.autoplay : techAutoplay;
        // if we don't have a tech then we do not queue up
        // a setAutoplay call on tech ready. We do this because the
        // autoplay option will be passed in the constructor and we
        // do not need to set it twice
        if (this.tech_) this.techCall_("setAutoplay", techAutoplay);
    }
    /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */ playsinline(value) {
        if (value !== undefined) {
            this.techCall_("setPlaysinline", value);
            this.options_.playsinline = value;
        }
        return this.techGet_("playsinline");
    }
    /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */ loop(value) {
        if (value !== undefined) {
            this.techCall_("setLoop", value);
            this.options_.loop = value;
            return;
        }
        return this.techGet_("loop");
    }
    /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */ poster(src) {
        if (src === undefined) return this.poster_;
        // The correct way to remove a poster is to set as an empty string
        // other falsey values will throw errors
        if (!src) src = "";
        if (src === this.poster_) return;
        // update the internal poster variable
        this.poster_ = src;
        // update the tech's poster
        this.techCall_("setPoster", src);
        this.isPosterFromTech_ = false;
        // alert components that the poster has been set
        /**
     * This event fires when the poster image is changed on the player.
     *
     * @event Player#posterchange
     * @type {Event}
     */ this.trigger("posterchange");
    }
    /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */ handleTechPosterChange_() {
        if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
            const newPoster = this.tech_.poster() || "";
            if (newPoster !== this.poster_) {
                this.poster_ = newPoster;
                this.isPosterFromTech_ = true;
                // Let components know the poster has changed
                this.trigger("posterchange");
            }
        }
    }
    /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */ controls(bool) {
        if (bool === undefined) return !!this.controls_;
        bool = !!bool;
        // Don't trigger a change event unless it actually changed
        if (this.controls_ === bool) return;
        this.controls_ = bool;
        if (this.usingNativeControls()) this.techCall_("setControls", bool);
        if (this.controls_) {
            this.removeClass("vjs-controls-disabled");
            this.addClass("vjs-controls-enabled");
            /**
       * @event Player#controlsenabled
       * @type {Event}
       */ this.trigger("controlsenabled");
            if (!this.usingNativeControls()) this.addTechControlsListeners_();
        } else {
            this.removeClass("vjs-controls-enabled");
            this.addClass("vjs-controls-disabled");
            /**
       * @event Player#controlsdisabled
       * @type {Event}
       */ this.trigger("controlsdisabled");
            if (!this.usingNativeControls()) this.removeTechControlsListeners_();
        }
    }
    /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */ usingNativeControls(bool) {
        if (bool === undefined) return !!this.usingNativeControls_;
        bool = !!bool;
        // Don't trigger a change event unless it actually changed
        if (this.usingNativeControls_ === bool) return;
        this.usingNativeControls_ = bool;
        if (this.usingNativeControls_) {
            this.addClass("vjs-using-native-controls");
            /**
       * player is using the native device controls
       *
       * @event Player#usingnativecontrols
       * @type {Event}
       */ this.trigger("usingnativecontrols");
        } else {
            this.removeClass("vjs-using-native-controls");
            /**
       * player is using the custom HTML controls
       *
       * @event Player#usingcustomcontrols
       * @type {Event}
       */ this.trigger("usingcustomcontrols");
        }
    }
    /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */ error(err) {
        if (err === undefined) return this.error_ || null;
        // allow hooks to modify error object
        $cb03b711053a4297$var$hooks("beforeerror").forEach((hookFunction)=>{
            const newErr = hookFunction(this, err);
            if (!($cb03b711053a4297$var$isObject(newErr) && !Array.isArray(newErr) || typeof newErr === "string" || typeof newErr === "number" || newErr === null)) {
                this.log.error("please return a value that MediaError expects in beforeerror hooks");
                return;
            }
            err = newErr;
        });
        // Suppress the first error message for no compatible source until
        // user interaction
        if (this.options_.suppressNotSupportedError && err && err.code === 4) {
            const triggerSuppressedError = function() {
                this.error(err);
            };
            this.options_.suppressNotSupportedError = false;
            this.any([
                "click",
                "touchstart"
            ], triggerSuppressedError);
            this.one("loadstart", function() {
                this.off([
                    "click",
                    "touchstart"
                ], triggerSuppressedError);
            });
            return;
        }
        // restoring to default
        if (err === null) {
            this.error_ = null;
            this.removeClass("vjs-error");
            if (this.errorDisplay) this.errorDisplay.close();
            return;
        }
        this.error_ = new $cb03b711053a4297$var$MediaError(err);
        // add the vjs-error classname to the player
        this.addClass("vjs-error");
        // log the name of the error type and any message
        // IE11 logs "[object object]" and required you to expand message to see error object
        $cb03b711053a4297$var$log$1.error(`(CODE:${this.error_.code} ${$cb03b711053a4297$var$MediaError.errorTypes[this.error_.code]})`, this.error_.message, this.error_);
        /**
     * @event Player#error
     * @type {Event}
     */ this.trigger("error");
        // notify hooks of the per player error
        $cb03b711053a4297$var$hooks("error").forEach((hookFunction)=>hookFunction(this, this.error_));
        return;
    }
    /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */ reportUserActivity(event) {
        this.userActivity_ = true;
    }
    /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */ userActive(bool) {
        if (bool === undefined) return this.userActive_;
        bool = !!bool;
        if (bool === this.userActive_) return;
        this.userActive_ = bool;
        if (this.userActive_) {
            this.userActivity_ = true;
            this.removeClass("vjs-user-inactive");
            this.addClass("vjs-user-active");
            /**
       * @event Player#useractive
       * @type {Event}
       */ this.trigger("useractive");
            return;
        }
        // Chrome/Safari/IE have bugs where when you change the cursor it can
        // trigger a mousemove event. This causes an issue when you're hiding
        // the cursor when the user is inactive, and a mousemove signals user
        // activity. Making it impossible to go into inactive mode. Specifically
        // this happens in fullscreen when we really need to hide the cursor.
        //
        // When this gets resolved in ALL browsers it can be removed
        // https://code.google.com/p/chromium/issues/detail?id=103041
        if (this.tech_) this.tech_.one("mousemove", function(e) {
            e.stopPropagation();
            e.preventDefault();
        });
        this.userActivity_ = false;
        this.removeClass("vjs-user-active");
        this.addClass("vjs-user-inactive");
        /**
     * @event Player#userinactive
     * @type {Event}
     */ this.trigger("userinactive");
    }
    /**
   * Listen for user activity based on timeout value
   *
   * @private
   */ listenForUserActivity_() {
        let mouseInProgress;
        let lastMoveX;
        let lastMoveY;
        const handleActivity = $cb03b711053a4297$var$bind_(this, this.reportUserActivity);
        const handleMouseMove = function(e) {
            // #1068 - Prevent mousemove spamming
            // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
            if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
                lastMoveX = e.screenX;
                lastMoveY = e.screenY;
                handleActivity();
            }
        };
        const handleMouseDown = function() {
            handleActivity();
            // For as long as the they are touching the device or have their mouse down,
            // we consider them active even if they're not moving their finger or mouse.
            // So we want to continue to update that they are active
            this.clearInterval(mouseInProgress);
            // Setting userActivity=true now and setting the interval to the same time
            // as the activityCheck interval (250) should ensure we never miss the
            // next activityCheck
            mouseInProgress = this.setInterval(handleActivity, 250);
        };
        const handleMouseUpAndMouseLeave = function(event) {
            handleActivity();
            // Stop the interval that maintains activity if the mouse/touch is down
            this.clearInterval(mouseInProgress);
        };
        // Any mouse movement will be considered user activity
        this.on("mousedown", handleMouseDown);
        this.on("mousemove", handleMouseMove);
        this.on("mouseup", handleMouseUpAndMouseLeave);
        this.on("mouseleave", handleMouseUpAndMouseLeave);
        const controlBar = this.getChild("controlBar");
        // Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
        // controlBar would no longer be hidden by default timeout.
        if (controlBar && !$cb03b711053a4297$var$IS_IOS && !$cb03b711053a4297$var$IS_ANDROID) {
            controlBar.on("mouseenter", function(event) {
                if (this.player().options_.inactivityTimeout !== 0) this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
                this.player().options_.inactivityTimeout = 0;
            });
            controlBar.on("mouseleave", function(event) {
                this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
            });
        }
        // Listen for keyboard navigation
        // Shouldn't need to use inProgress interval because of key repeat
        this.on("keydown", handleActivity);
        this.on("keyup", handleActivity);
        // Run an interval every 250 milliseconds instead of stuffing everything into
        // the mousemove/touchmove function itself, to prevent performance degradation.
        // `this.reportUserActivity` simply sets this.userActivity_ to true, which
        // then gets picked up by this loop
        // http://ejohn.org/blog/learning-from-twitter/
        let inactivityTimeout;
        /** @this Player */ const activityCheck = function() {
            // Check to see if mouse/touch activity has happened
            if (!this.userActivity_) return;
            // Reset the activity tracker
            this.userActivity_ = false;
            // If the user state was inactive, set the state to active
            this.userActive(true);
            // Clear any existing inactivity timeout to start the timer over
            this.clearTimeout(inactivityTimeout);
            const timeout = this.options_.inactivityTimeout;
            if (timeout <= 0) return;
            // In <timeout> milliseconds, if no more activity has occurred the
            // user will be considered inactive
            inactivityTimeout = this.setTimeout(function() {
                // Protect against the case where the inactivityTimeout can trigger just
                // before the next user activity is picked up by the activity check loop
                // causing a flicker
                if (!this.userActivity_) this.userActive(false);
            }, timeout);
        };
        this.setInterval(activityCheck, 250);
    }
    /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */ playbackRate(rate) {
        if (rate !== undefined) {
            // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
            // that is registered above
            this.techCall_("setPlaybackRate", rate);
            return;
        }
        if (this.tech_ && this.tech_.featuresPlaybackRate) return this.cache_.lastPlaybackRate || this.techGet_("playbackRate");
        return 1.0;
    }
    /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */ defaultPlaybackRate(rate) {
        if (rate !== undefined) return this.techCall_("setDefaultPlaybackRate", rate);
        if (this.tech_ && this.tech_.featuresPlaybackRate) return this.techGet_("defaultPlaybackRate");
        return 1.0;
    }
    /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */ isAudio(bool) {
        if (bool !== undefined) {
            this.isAudio_ = !!bool;
            return;
        }
        return !!this.isAudio_;
    }
    enableAudioOnlyUI_() {
        // Update styling immediately to show the control bar so we can get its height
        this.addClass("vjs-audio-only-mode");
        const playerChildren = this.children();
        const controlBar = this.getChild("ControlBar");
        const controlBarHeight = controlBar && controlBar.currentHeight();
        // Hide all player components except the control bar. Control bar components
        // needed only for video are hidden with CSS
        playerChildren.forEach((child)=>{
            if (child === controlBar) return;
            if (child.el_ && !child.hasClass("vjs-hidden")) {
                child.hide();
                this.audioOnlyCache_.hiddenChildren.push(child);
            }
        });
        this.audioOnlyCache_.playerHeight = this.currentHeight();
        // Set the player height the same as the control bar
        this.height(controlBarHeight);
        this.trigger("audioonlymodechange");
    }
    disableAudioOnlyUI_() {
        this.removeClass("vjs-audio-only-mode");
        // Show player components that were previously hidden
        this.audioOnlyCache_.hiddenChildren.forEach((child)=>child.show());
        // Reset player height
        this.height(this.audioOnlyCache_.playerHeight);
        this.trigger("audioonlymodechange");
    }
    /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */ audioOnlyMode(value) {
        if (typeof value !== "boolean" || value === this.audioOnlyMode_) return this.audioOnlyMode_;
        this.audioOnlyMode_ = value;
        // Enable Audio Only Mode
        if (value) {
            const exitPromises = [];
            // Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
            if (this.isInPictureInPicture()) exitPromises.push(this.exitPictureInPicture());
            if (this.isFullscreen()) exitPromises.push(this.exitFullscreen());
            if (this.audioPosterMode()) exitPromises.push(this.audioPosterMode(false));
            return Promise.all(exitPromises).then(()=>this.enableAudioOnlyUI_());
        }
        // Disable Audio Only Mode
        return Promise.resolve().then(()=>this.disableAudioOnlyUI_());
    }
    enablePosterModeUI_() {
        // Hide the video element and show the poster image to enable posterModeUI
        const tech = this.tech_ && this.tech_;
        tech.hide();
        this.addClass("vjs-audio-poster-mode");
        this.trigger("audiopostermodechange");
    }
    disablePosterModeUI_() {
        // Show the video element and hide the poster image to disable posterModeUI
        const tech = this.tech_ && this.tech_;
        tech.show();
        this.removeClass("vjs-audio-poster-mode");
        this.trigger("audiopostermodechange");
    }
    /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */ audioPosterMode(value) {
        if (typeof value !== "boolean" || value === this.audioPosterMode_) return this.audioPosterMode_;
        this.audioPosterMode_ = value;
        if (value) {
            if (this.audioOnlyMode()) {
                const audioOnlyModePromise = this.audioOnlyMode(false);
                return audioOnlyModePromise.then(()=>{
                    // enable audio poster mode after audio only mode is disabled
                    this.enablePosterModeUI_();
                });
            }
            return Promise.resolve().then(()=>{
                // enable audio poster mode
                this.enablePosterModeUI_();
            });
        }
        return Promise.resolve().then(()=>{
            // disable audio poster mode
            this.disablePosterModeUI_();
        });
    }
    /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */ addTextTrack(kind, label, language) {
        if (this.tech_) return this.tech_.addTextTrack(kind, label, language);
    }
    /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return { import('./tracks/html-track-element').default }
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */ addRemoteTextTrack(options, manualCleanup) {
        if (this.tech_) return this.tech_.addRemoteTextTrack(options, manualCleanup);
    }
    /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */ removeRemoteTextTrack(obj = {}) {
        let { track: track } = obj;
        if (!track) track = obj;
        // destructure the input into an object with a track argument, defaulting to arguments[0]
        // default the whole argument to an empty object if nothing was passed in
        if (this.tech_) return this.tech_.removeRemoteTextTrack(track);
    }
    /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */ getVideoPlaybackQuality() {
        return this.techGet_("getVideoPlaybackQuality");
    }
    /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */ videoWidth() {
        return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
    }
    /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */ videoHeight() {
        return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
    }
    /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */ language(code) {
        if (code === undefined) return this.language_;
        if (this.language_ !== String(code).toLowerCase()) {
            this.language_ = String(code).toLowerCase();
            // during first init, it's possible some things won't be evented
            if ($cb03b711053a4297$var$isEvented(this)) /**
        * fires when the player language change
        *
        * @event Player#languagechange
        * @type {Event}
        */ this.trigger("languagechange");
        }
    }
    /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */ languages() {
        return $cb03b711053a4297$var$merge$1($cb03b711053a4297$var$Player.prototype.options_.languages, this.languages_);
    }
    /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */ toJSON() {
        const options = $cb03b711053a4297$var$merge$1(this.options_);
        const tracks = options.tracks;
        options.tracks = [];
        for(let i = 0; i < tracks.length; i++){
            let track = tracks[i];
            // deep merge tracks and null out player so no circular references
            track = $cb03b711053a4297$var$merge$1(track);
            track.player = undefined;
            options.tracks[i] = track;
        }
        return options;
    }
    /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */ createModal(content, options) {
        options = options || {};
        options.content = content || "";
        const modal = new $cb03b711053a4297$var$ModalDialog(this, options);
        this.addChild(modal);
        modal.on("dispose", ()=>{
            this.removeChild(modal);
        });
        modal.open();
        return modal;
    }
    /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */ updateCurrentBreakpoint_() {
        if (!this.responsive()) return;
        const currentBreakpoint = this.currentBreakpoint();
        const currentWidth = this.currentWidth();
        for(let i = 0; i < $cb03b711053a4297$var$BREAKPOINT_ORDER.length; i++){
            const candidateBreakpoint = $cb03b711053a4297$var$BREAKPOINT_ORDER[i];
            const maxWidth = this.breakpoints_[candidateBreakpoint];
            if (currentWidth <= maxWidth) {
                // The current breakpoint did not change, nothing to do.
                if (currentBreakpoint === candidateBreakpoint) return;
                // Only remove a class if there is a current breakpoint.
                if (currentBreakpoint) this.removeClass($cb03b711053a4297$var$BREAKPOINT_CLASSES[currentBreakpoint]);
                this.addClass($cb03b711053a4297$var$BREAKPOINT_CLASSES[candidateBreakpoint]);
                this.breakpoint_ = candidateBreakpoint;
                break;
            }
        }
    }
    /**
   * Removes the current breakpoint.
   *
   * @private
   */ removeCurrentBreakpoint_() {
        const className = this.currentBreakpointClass();
        this.breakpoint_ = "";
        if (className) this.removeClass(className);
    }
    /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */ breakpoints(breakpoints) {
        // Used as a getter.
        if (breakpoints === undefined) return Object.assign(this.breakpoints_);
        this.breakpoint_ = "";
        this.breakpoints_ = Object.assign({}, $cb03b711053a4297$var$DEFAULT_BREAKPOINTS, breakpoints);
        // When breakpoint definitions change, we need to update the currently
        // selected breakpoint.
        this.updateCurrentBreakpoint_();
        // Clone the breakpoints before returning.
        return Object.assign(this.breakpoints_);
    }
    /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */ responsive(value) {
        // Used as a getter.
        if (value === undefined) return this.responsive_;
        value = Boolean(value);
        const current = this.responsive_;
        // Nothing changed.
        if (value === current) return;
        // The value actually changed, set it.
        this.responsive_ = value;
        // Start listening for breakpoints and set the initial breakpoint if the
        // player is now responsive.
        if (value) {
            this.on("playerresize", this.boundUpdateCurrentBreakpoint_);
            this.updateCurrentBreakpoint_();
        // Stop listening for breakpoints if the player is no longer responsive.
        } else {
            this.off("playerresize", this.boundUpdateCurrentBreakpoint_);
            this.removeCurrentBreakpoint_();
        }
        return value;
    }
    /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */ currentBreakpoint() {
        return this.breakpoint_;
    }
    /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */ currentBreakpointClass() {
        return $cb03b711053a4297$var$BREAKPOINT_CLASSES[this.breakpoint_] || "";
    }
    /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */ /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */ loadMedia(media, ready) {
        if (!media || typeof media !== "object") return;
        const crossOrigin = this.crossOrigin();
        this.reset();
        // Clone the media object so it cannot be mutated from outside.
        this.cache_.media = $cb03b711053a4297$var$merge$1(media);
        const { artist: artist, artwork: artwork, description: description, poster: poster, src: src, textTracks: textTracks, title: title } = this.cache_.media;
        // If `artwork` is not given, create it using `poster`.
        if (!artwork && poster) this.cache_.media.artwork = [
            {
                src: poster,
                type: $cb03b711053a4297$var$getMimetype(poster)
            }
        ];
        if (crossOrigin) this.crossOrigin(crossOrigin);
        if (src) this.src(src);
        if (poster) this.poster(poster);
        if (Array.isArray(textTracks)) textTracks.forEach((tt)=>this.addRemoteTextTrack(tt, false));
        if (this.titleBar) this.titleBar.update({
            title: title,
            description: description || artist || ""
        });
        this.ready(ready);
    }
    /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */ getMedia() {
        if (!this.cache_.media) {
            const poster = this.poster();
            const src = this.currentSources();
            const textTracks = Array.prototype.map.call(this.remoteTextTracks(), (tt)=>({
                    kind: tt.kind,
                    label: tt.label,
                    language: tt.language,
                    src: tt.src
                }));
            const media = {
                src: src,
                textTracks: textTracks
            };
            if (poster) {
                media.poster = poster;
                media.artwork = [
                    {
                        src: media.poster,
                        type: $cb03b711053a4297$var$getMimetype(media.poster)
                    }
                ];
            }
            return media;
        }
        return $cb03b711053a4297$var$merge$1(this.cache_.media);
    }
    /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */ static getTagSettings(tag) {
        const baseOptions = {
            sources: [],
            tracks: []
        };
        const tagOptions = $cb03b711053a4297$var$getAttributes(tag);
        const dataSetup = tagOptions["data-setup"];
        if ($cb03b711053a4297$var$hasClass(tag, "vjs-fill")) tagOptions.fill = true;
        if ($cb03b711053a4297$var$hasClass(tag, "vjs-fluid")) tagOptions.fluid = true;
        // Check if data-setup attr exists.
        if (dataSetup !== null) {
            // Parse options JSON
            // If empty string, make it a parsable json object.
            const [err, data] = (0, (/*@__PURE__*/$parcel$interopDefault($fe6c02a05a802c0a$exports)))(dataSetup || "{}");
            if (err) $cb03b711053a4297$var$log$1.error(err);
            Object.assign(tagOptions, data);
        }
        Object.assign(baseOptions, tagOptions);
        // Get tag children settings
        if (tag.hasChildNodes()) {
            const children = tag.childNodes;
            for(let i = 0, j = children.length; i < j; i++){
                const child = children[i];
                // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
                const childName = child.nodeName.toLowerCase();
                if (childName === "source") baseOptions.sources.push($cb03b711053a4297$var$getAttributes(child));
                else if (childName === "track") baseOptions.tracks.push($cb03b711053a4297$var$getAttributes(child));
            }
        }
        return baseOptions;
    }
    /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */ debug(enabled) {
        if (enabled === undefined) return this.debugEnabled_;
        if (enabled) {
            this.trigger("debugon");
            this.previousLogLevel_ = this.log.level;
            this.log.level("debug");
            this.debugEnabled_ = true;
        } else {
            this.trigger("debugoff");
            this.log.level(this.previousLogLevel_);
            this.previousLogLevel_ = undefined;
            this.debugEnabled_ = false;
        }
    }
    /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} newRates
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */ playbackRates(newRates) {
        if (newRates === undefined) return this.cache_.playbackRates;
        // ignore any value that isn't an array
        if (!Array.isArray(newRates)) return;
        // ignore any arrays that don't only contain numbers
        if (!newRates.every((rate)=>typeof rate === "number")) return;
        this.cache_.playbackRates = newRates;
        /**
    * fires when the playback rates in a player are changed
    *
    * @event Player#playbackrateschange
    * @type {Event}
    */ this.trigger("playbackrateschange");
    }
}
/**
 * Get the {@link VideoTrackList}
 *
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
 *
 * @return {VideoTrackList}
 *         the current video track list
 *
 * @method Player.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 *
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
 *
 * @return {AudioTrackList}
 *         the current audio track list
 *
 * @method Player.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
 *
 * @return {TextTrackList}
 *         the current text track list
 *
 * @method Player.prototype.textTracks
 */ /**
 * Get the remote {@link TextTrackList}
 *
 * @return {TextTrackList}
 *         The current remote text track list
 *
 * @method Player.prototype.remoteTextTracks
 */ /**
 * Get the remote {@link HtmlTrackElementList} tracks.
 *
 * @return {HtmlTrackElementList}
 *         The current remote text track element list
 *
 * @method Player.prototype.remoteTextTrackEls
 */ $cb03b711053a4297$var$ALL.names.forEach(function(name) {
    const props = $cb03b711053a4297$var$ALL[name];
    $cb03b711053a4297$var$Player.prototype[props.getterName] = function() {
        if (this.tech_) return this.tech_[props.getterName]();
        // if we have not yet loadTech_, we create {video,audio,text}Tracks_
        // these will be passed to the tech during loading
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
/**
 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
 * behavior.
 *
 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
 *
 * @param {string} [value]
 *        The value to set the `Player`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */ $cb03b711053a4297$var$Player.prototype.crossorigin = $cb03b711053a4297$var$Player.prototype.crossOrigin;
/**
 * Global enumeration of players.
 *
 * The keys are the player IDs and the values are either the {@link Player}
 * instance or `null` for disposed players.
 *
 * @type {Object}
 */ $cb03b711053a4297$var$Player.players = {};
const $cb03b711053a4297$var$navigator = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator;
/*
 * Player instance options, surfaced using options
 * options = Player.prototype.options_
 * Make changes in options, not here.
 *
 * @type {Object}
 * @private
 */ $cb03b711053a4297$var$Player.prototype.options_ = {
    // Default order of fallback technology
    techOrder: $cb03b711053a4297$var$Tech.defaultTechOrder_,
    html5: {},
    // enable sourceset by default
    enableSourceset: true,
    // default inactivity timeout
    inactivityTimeout: 2000,
    // default playback rates
    playbackRates: [],
    // Add playback rate selection by adding rates
    // 'playbackRates': [0.5, 1, 1.5, 2],
    liveui: false,
    // Included control sets
    children: [
        "mediaLoader",
        "posterImage",
        "titleBar",
        "textTrackDisplay",
        "loadingSpinner",
        "bigPlayButton",
        "liveTracker",
        "controlBar",
        "errorDisplay",
        "textTrackSettings",
        "resizeManager"
    ],
    language: $cb03b711053a4297$var$navigator && ($cb03b711053a4297$var$navigator.languages && $cb03b711053a4297$var$navigator.languages[0] || $cb03b711053a4297$var$navigator.userLanguage || $cb03b711053a4297$var$navigator.language) || "en",
    // locales and their language translations
    languages: {},
    // Default message to show when a video cannot be played.
    notSupportedMessage: "No compatible source was found for this media.",
    normalizeAutoplay: false,
    fullscreen: {
        options: {
            navigationUI: "hide"
        }
    },
    breakpoints: {},
    responsive: false,
    audioOnlyMode: false,
    audioPosterMode: false
};
[
    /**
 * Returns whether or not the player is in the "ended" state.
 *
 * @return {Boolean} True if the player is in the ended state, false if not.
 * @method Player#ended
 */ "ended",
    /**
 * Returns whether or not the player is in the "seeking" state.
 *
 * @return {Boolean} True if the player is in the seeking state, false if not.
 * @method Player#seeking
 */ "seeking",
    /**
 * Returns the TimeRanges of the media that are currently available
 * for seeking to.
 *
 * @return {TimeRanges} the seekable intervals of the media timeline
 * @method Player#seekable
 */ "seekable",
    /**
 * Returns the current state of network activity for the element, from
 * the codes in the list below.
 * - NETWORK_EMPTY (numeric value 0)
 *   The element has not yet been initialised. All attributes are in
 *   their initial states.
 * - NETWORK_IDLE (numeric value 1)
 *   The element's resource selection algorithm is active and has
 *   selected a resource, but it is not actually using the network at
 *   this time.
 * - NETWORK_LOADING (numeric value 2)
 *   The user agent is actively trying to download data.
 * - NETWORK_NO_SOURCE (numeric value 3)
 *   The element's resource selection algorithm is active, but it has
 *   not yet found a resource to use.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
 * @return {number} the current network activity state
 * @method Player#networkState
 */ "networkState",
    /**
 * Returns a value that expresses the current state of the element
 * with respect to rendering the current playback position, from the
 * codes in the list below.
 * - HAVE_NOTHING (numeric value 0)
 *   No information regarding the media resource is available.
 * - HAVE_METADATA (numeric value 1)
 *   Enough of the resource has been obtained that the duration of the
 *   resource is available.
 * - HAVE_CURRENT_DATA (numeric value 2)
 *   Data for the immediate current playback position is available.
 * - HAVE_FUTURE_DATA (numeric value 3)
 *   Data for the immediate current playback position is available, as
 *   well as enough data for the user agent to advance the current
 *   playback position in the direction of playback.
 * - HAVE_ENOUGH_DATA (numeric value 4)
 *   The user agent estimates that enough data is available for
 *   playback to proceed uninterrupted.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
 * @return {number} the current playback rendering state
 * @method Player#readyState
 */ "readyState"
].forEach(function(fn) {
    $cb03b711053a4297$var$Player.prototype[fn] = function() {
        return this.techGet_(fn);
    };
});
$cb03b711053a4297$var$TECH_EVENTS_RETRIGGER.forEach(function(event) {
    $cb03b711053a4297$var$Player.prototype[`handleTech${$cb03b711053a4297$var$toTitleCase$1(event)}_`] = function() {
        return this.trigger(event);
    };
});
/**
 * Fired when the player has initial duration and dimension information
 *
 * @event Player#loadedmetadata
 * @type {Event}
 */ /**
 * Fired when the player has downloaded data at the current playback position
 *
 * @event Player#loadeddata
 * @type {Event}
 */ /**
 * Fired when the current playback position has changed *
 * During playback this is fired every 15-250 milliseconds, depending on the
 * playback technology in use.
 *
 * @event Player#timeupdate
 * @type {Event}
 */ /**
 * Fired when the volume changes
 *
 * @event Player#volumechange
 * @type {Event}
 */ /**
 * Reports whether or not a player has a plugin available.
 *
 * This does not report whether or not the plugin has ever been initialized
 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
 *
 * @method Player#hasPlugin
 * @param  {string}  name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player has the requested plugin available.
 */ /**
 * Reports whether or not a player is using a plugin by name.
 *
 * For basic plugins, this only reports whether the plugin has _ever_ been
 * initialized on this player.
 *
 * @method Player#usingPlugin
 * @param  {string} name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player is using the requested plugin.
 */ $cb03b711053a4297$var$Component$1.registerComponent("Player", $cb03b711053a4297$var$Player);
/**
 * @file plugin.js
 */ /**
 * The base plugin name.
 *
 * @private
 * @constant
 * @type {string}
 */ const $cb03b711053a4297$var$BASE_PLUGIN_NAME = "plugin";
/**
 * The key on which a player's active plugins cache is stored.
 *
 * @private
 * @constant
 * @type     {string}
 */ const $cb03b711053a4297$var$PLUGIN_CACHE_KEY = "activePlugins_";
/**
 * Stores registered plugins in a private space.
 *
 * @private
 * @type    {Object}
 */ const $cb03b711053a4297$var$pluginStorage = {};
/**
 * Reports whether or not a plugin has been registered.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {boolean}
 *          Whether or not the plugin has been registered.
 */ const $cb03b711053a4297$var$pluginExists = (name)=>$cb03b711053a4297$var$pluginStorage.hasOwnProperty(name);
/**
 * Get a single registered plugin by name.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {typeof Plugin|Function|undefined}
 *          The plugin (or undefined).
 */ const $cb03b711053a4297$var$getPlugin = (name)=>$cb03b711053a4297$var$pluginExists(name) ? $cb03b711053a4297$var$pluginStorage[name] : undefined;
/**
 * Marks a plugin as "active" on a player.
 *
 * Also, ensures that the player has an object for tracking active plugins.
 *
 * @private
 * @param   {Player} player
 *          A Video.js player instance.
 *
 * @param   {string} name
 *          The name of a plugin.
 */ const $cb03b711053a4297$var$markPluginAsActive = (player, name)=>{
    player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY] = player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY] || {};
    player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY][name] = true;
};
/**
 * Triggers a pair of plugin setup events.
 *
 * @private
 * @param  {Player} player
 *         A Video.js player instance.
 *
 * @param  {PluginEventHash} hash
 *         A plugin event hash.
 *
 * @param  {boolean} [before]
 *         If true, prefixes the event name with "before". In other words,
 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
 */ const $cb03b711053a4297$var$triggerSetupEvent = (player, hash, before)=>{
    const eventName = (before ? "before" : "") + "pluginsetup";
    player.trigger(eventName, hash);
    player.trigger(eventName + ":" + hash.name, hash);
};
/**
 * Takes a basic plugin function and returns a wrapper function which marks
 * on the player that the plugin has been activated.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Function} plugin
 *          The basic plugin.
 *
 * @return {Function}
 *          A wrapper function for the given plugin.
 */ const $cb03b711053a4297$var$createBasicPlugin = function(name, plugin) {
    const basicPluginWrapper = function() {
        // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
        // regardless, but we want the hash to be consistent with the hash provided
        // for advanced plugins.
        //
        // The only potentially counter-intuitive thing here is the `instance` in
        // the "pluginsetup" event is the value returned by the `plugin` function.
        $cb03b711053a4297$var$triggerSetupEvent(this, {
            name: name,
            plugin: plugin,
            instance: null
        }, true);
        const instance = plugin.apply(this, arguments);
        $cb03b711053a4297$var$markPluginAsActive(this, name);
        $cb03b711053a4297$var$triggerSetupEvent(this, {
            name: name,
            plugin: plugin,
            instance: instance
        });
        return instance;
    };
    Object.keys(plugin).forEach(function(prop) {
        basicPluginWrapper[prop] = plugin[prop];
    });
    return basicPluginWrapper;
};
/**
 * Takes a plugin sub-class and returns a factory function for generating
 * instances of it.
 *
 * This factory function will replace itself with an instance of the requested
 * sub-class of Plugin.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Plugin} PluginSubClass
 *          The advanced plugin.
 *
 * @return {Function}
 */ const $cb03b711053a4297$var$createPluginFactory = (name, PluginSubClass)=>{
    // Add a `name` property to the plugin prototype so that each plugin can
    // refer to itself by name.
    PluginSubClass.prototype.name = name;
    return function(...args) {
        $cb03b711053a4297$var$triggerSetupEvent(this, {
            name: name,
            plugin: PluginSubClass,
            instance: null
        }, true);
        const instance = new PluginSubClass(...[
            this,
            ...args
        ]);
        // The plugin is replaced by a function that returns the current instance.
        this[name] = ()=>instance;
        $cb03b711053a4297$var$triggerSetupEvent(this, instance.getEventHash());
        return instance;
    };
};
/**
 * Parent class for all advanced plugins.
 *
 * @mixes   module:evented~EventedMixin
 * @mixes   module:stateful~StatefulMixin
 * @fires   Player#beforepluginsetup
 * @fires   Player#beforepluginsetup:$name
 * @fires   Player#pluginsetup
 * @fires   Player#pluginsetup:$name
 * @listens Player#dispose
 * @throws  {Error}
 *          If attempting to instantiate the base {@link Plugin} class
 *          directly instead of via a sub-class.
 */ class $cb03b711053a4297$var$Plugin {
    /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */ constructor(player){
        if (this.constructor === $cb03b711053a4297$var$Plugin) throw new Error("Plugin must be sub-classed; not directly instantiated.");
        this.player = player;
        if (!this.log) this.log = this.player.log.createLogger(this.name);
        // Make this object evented, but remove the added `trigger` method so we
        // use the prototype version instead.
        $cb03b711053a4297$var$evented(this);
        delete this.trigger;
        $cb03b711053a4297$var$stateful(this, this.constructor.defaultState);
        $cb03b711053a4297$var$markPluginAsActive(player, this.name);
        // Auto-bind the dispose method so we can use it as a listener and unbind
        // it later easily.
        this.dispose = this.dispose.bind(this);
        // If the player is disposed, dispose the plugin.
        player.on("dispose", this.dispose);
    }
    /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */ version() {
        return this.constructor.VERSION;
    }
    /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */ getEventHash(hash = {}) {
        hash.name = this.name;
        hash.plugin = this.constructor;
        hash.instance = this;
        return hash;
    }
    /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */ trigger(event, hash = {}) {
        return $cb03b711053a4297$var$trigger(this.eventBusEl_, event, this.getEventHash(hash));
    }
    /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */ handleStateChanged(e) {}
    /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */ dispose() {
        const { name: name, player: player } = this;
        /**
     * Signals that a advanced plugin is about to be disposed.
     *
     * @event Plugin#dispose
     * @type  {Event}
     */ this.trigger("dispose");
        this.off();
        player.off("dispose", this.dispose);
        // Eliminate any possible sources of leaking memory by clearing up
        // references between the player and the plugin instance and nulling out
        // the plugin's state and replacing methods with a function that throws.
        player[$cb03b711053a4297$var$PLUGIN_CACHE_KEY][name] = false;
        this.player = this.state = null;
        // Finally, replace the plugin name on the player with a new factory
        // function, so that the plugin is ready to be set up again.
        player[name] = $cb03b711053a4297$var$createPluginFactory(name, $cb03b711053a4297$var$pluginStorage[name]);
    }
    /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */ static isBasic(plugin) {
        const p = typeof plugin === "string" ? $cb03b711053a4297$var$getPlugin(plugin) : plugin;
        return typeof p === "function" && !$cb03b711053a4297$var$Plugin.prototype.isPrototypeOf(p.prototype);
    }
    /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */ static registerPlugin(name, plugin) {
        if (typeof name !== "string") throw new Error(`Illegal plugin name, "${name}", must be a string, was ${typeof name}.`);
        if ($cb03b711053a4297$var$pluginExists(name)) $cb03b711053a4297$var$log$1.warn(`A plugin named "${name}" already exists. You may want to avoid re-registering plugins!`);
        else if ($cb03b711053a4297$var$Player.prototype.hasOwnProperty(name)) throw new Error(`Illegal plugin name, "${name}", cannot share a name with an existing player method!`);
        if (typeof plugin !== "function") throw new Error(`Illegal plugin for "${name}", must be a function, was ${typeof plugin}.`);
        $cb03b711053a4297$var$pluginStorage[name] = plugin;
        // Add a player prototype method for all sub-classed plugins (but not for
        // the base Plugin class).
        if (name !== $cb03b711053a4297$var$BASE_PLUGIN_NAME) {
            if ($cb03b711053a4297$var$Plugin.isBasic(plugin)) $cb03b711053a4297$var$Player.prototype[name] = $cb03b711053a4297$var$createBasicPlugin(name, plugin);
            else $cb03b711053a4297$var$Player.prototype[name] = $cb03b711053a4297$var$createPluginFactory(name, plugin);
        }
        return plugin;
    }
    /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */ static deregisterPlugin(name) {
        if (name === $cb03b711053a4297$var$BASE_PLUGIN_NAME) throw new Error("Cannot de-register base plugin.");
        if ($cb03b711053a4297$var$pluginExists(name)) {
            delete $cb03b711053a4297$var$pluginStorage[name];
            delete $cb03b711053a4297$var$Player.prototype[name];
        }
    }
    /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */ static getPlugins(names = Object.keys($cb03b711053a4297$var$pluginStorage)) {
        let result;
        names.forEach((name)=>{
            const plugin = $cb03b711053a4297$var$getPlugin(name);
            if (plugin) {
                result = result || {};
                result[name] = plugin;
            }
        });
        return result;
    }
    /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */ static getPluginVersion(name) {
        const plugin = $cb03b711053a4297$var$getPlugin(name);
        return plugin && plugin.VERSION || "";
    }
}
/**
 * Gets a plugin by name if it exists.
 *
 * @static
 * @method   getPlugin
 * @memberOf Plugin
 * @param    {string} name
 *           The name of a plugin.
 *
 * @returns  {typeof Plugin|Function|undefined}
 *           The plugin (or `undefined`).
 */ $cb03b711053a4297$var$Plugin.getPlugin = $cb03b711053a4297$var$getPlugin;
/**
 * The name of the base plugin class as it is registered.
 *
 * @type {string}
 */ $cb03b711053a4297$var$Plugin.BASE_PLUGIN_NAME = $cb03b711053a4297$var$BASE_PLUGIN_NAME;
$cb03b711053a4297$var$Plugin.registerPlugin($cb03b711053a4297$var$BASE_PLUGIN_NAME, $cb03b711053a4297$var$Plugin);
/**
 * Documented in player.js
 *
 * @ignore
 */ $cb03b711053a4297$var$Player.prototype.usingPlugin = function(name) {
    return !!this[$cb03b711053a4297$var$PLUGIN_CACHE_KEY] && this[$cb03b711053a4297$var$PLUGIN_CACHE_KEY][name] === true;
};
/**
 * Documented in player.js
 *
 * @ignore
 */ $cb03b711053a4297$var$Player.prototype.hasPlugin = function(name) {
    return !!$cb03b711053a4297$var$pluginExists(name);
};
/**
 * Signals that a plugin is about to be set up on a player.
 *
 * @event    Player#beforepluginsetup
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin is about to be set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#beforepluginsetup:$name
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player.
 *
 * @event    Player#pluginsetup
 * @type     {PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#pluginsetup:$name
 * @type     {PluginEventHash}
 */ /**
 * @typedef  {Object} PluginEventHash
 *
 * @property {string} instance
 *           For basic plugins, the return value of the plugin function. For
 *           advanced plugins, the plugin instance on which the event is fired.
 *
 * @property {string} name
 *           The name of the plugin.
 *
 * @property {string} plugin
 *           For basic plugins, the plugin function. For advanced plugins, the
 *           plugin class/constructor.
 */ /**
 * @file deprecate.js
 * @module deprecate
 */ /**
 * Decorate a function with a deprecation message the first time it is called.
 *
 * @param  {string}   message
 *         A deprecation message to log the first time the returned function
 *         is called.
 *
 * @param  {Function} fn
 *         The function to be deprecated.
 *
 * @return {Function}
 *         A wrapper function that will log a deprecation warning the first
 *         time it is called. The return value will be the return value of
 *         the wrapped function.
 */ function $cb03b711053a4297$var$deprecate(message, fn) {
    let warned = false;
    return function(...args) {
        if (!warned) $cb03b711053a4297$var$log$1.warn(message);
        warned = true;
        return fn.apply(this, args);
    };
}
/**
 * Internal function used to mark a function as deprecated in the next major
 * version with consistent messaging.
 *
 * @param  {number}   major   The major version where it will be removed
 * @param  {string}   oldName The old function name
 * @param  {string}   newName The new function name
 * @param  {Function} fn      The function to deprecate
 * @return {Function}         The decorated function
 */ function $cb03b711053a4297$var$deprecateForMajor(major, oldName, newName, fn) {
    return $cb03b711053a4297$var$deprecate(`${oldName} is deprecated and will be removed in ${major}.0; please use ${newName} instead.`, fn);
}
/**
 * @file video.js
 * @module videojs
 */ /**
 * Normalize an `id` value by trimming off a leading `#`
 *
 * @private
 * @param   {string} id
 *          A string, maybe with a leading `#`.
 *
 * @return {string}
 *          The string, without any leading `#`.
 */ const $cb03b711053a4297$var$normalizeId = (id)=>id.indexOf("#") === 0 ? id.slice(1) : id;
/**
 * A callback that is called when a component is ready. Does not have any
 * parameters and any callback value will be ignored. See: {@link Component~ReadyCallback}
 *
 * @callback ReadyCallback
 */ /**
 * The `videojs()` function doubles as the main function for users to create a
 * {@link Player} instance as well as the main library namespace.
 *
 * It can also be used as a getter for a pre-existing {@link Player} instance.
 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
 * purpose because it avoids any potential for unintended initialization.
 *
 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
 * of our JSDoc template, we cannot properly document this as both a function
 * and a namespace, so its function signature is documented here.
 *
 * #### Arguments
 * ##### id
 * string|Element, **required**
 *
 * Video element or video element ID.
 *
 * ##### options
 * Object, optional
 *
 * Options object for providing settings.
 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * ##### ready
 * {@link Component~ReadyCallback}, optional
 *
 * A function to be called when the {@link Player} and {@link Tech} are ready.
 *
 * #### Return Value
 *
 * The `videojs()` function returns a {@link Player} instance.
 *
 * @namespace
 *
 * @borrows AudioTrack as AudioTrack
 * @borrows Component.getComponent as getComponent
 * @borrows module:events.on as on
 * @borrows module:events.one as one
 * @borrows module:events.off as off
 * @borrows module:events.trigger as trigger
 * @borrows EventTarget as EventTarget
 * @borrows module:middleware.use as use
 * @borrows Player.players as players
 * @borrows Plugin.registerPlugin as registerPlugin
 * @borrows Plugin.deregisterPlugin as deregisterPlugin
 * @borrows Plugin.getPlugins as getPlugins
 * @borrows Plugin.getPlugin as getPlugin
 * @borrows Plugin.getPluginVersion as getPluginVersion
 * @borrows Tech.getTech as getTech
 * @borrows Tech.registerTech as registerTech
 * @borrows TextTrack as TextTrack
 * @borrows VideoTrack as VideoTrack
 *
 * @param  {string|Element} id
 *         Video element or video element ID.
 *
 * @param  {Object} [options]
 *         Options object for providing settings.
 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * @param  {ReadyCallback} [ready]
 *         A function to be called when the {@link Player} and {@link Tech} are
 *         ready.
 *
 * @return {Player}
 *         The `videojs()` function returns a {@link Player|Player} instance.
 */ function $cb03b711053a4297$export$2e2bcd8739ae039(id, options, ready) {
    let player = $cb03b711053a4297$export$2e2bcd8739ae039.getPlayer(id);
    if (player) {
        if (options) $cb03b711053a4297$var$log$1.warn(`Player "${id}" is already initialised. Options will not be applied.`);
        if (ready) player.ready(ready);
        return player;
    }
    const el = typeof id === "string" ? $cb03b711053a4297$var$$("#" + $cb03b711053a4297$var$normalizeId(id)) : id;
    if (!$cb03b711053a4297$var$isEl(el)) throw new TypeError("The element or ID supplied is not valid. (videojs)");
    // document.body.contains(el) will only check if el is contained within that one document.
    // This causes problems for elements in iframes.
    // Instead, use the element's ownerDocument instead of the global document.
    // This will make sure that the element is indeed in the dom of that document.
    // Additionally, check that the document in question has a default view.
    // If the document is no longer attached to the dom, the defaultView of the document will be null.
    // If element is inside Shadow DOM (e.g. is part of a Custom element), ownerDocument.body
    // always returns false. Instead, use the Shadow DOM root.
    const inShadowDom = "getRootNode" in el ? el.getRootNode() instanceof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).ShadowRoot : false;
    const rootNode = inShadowDom ? el.getRootNode() : el.ownerDocument.body;
    if (!el.ownerDocument.defaultView || !rootNode.contains(el)) $cb03b711053a4297$var$log$1.warn("The element supplied is not included in the DOM");
    options = options || {};
    // Store a copy of the el before modification, if it is to be restored in destroy()
    // If div ingest, store the parent div
    if (options.restoreEl === true) options.restoreEl = (el.parentNode && el.parentNode.hasAttribute("data-vjs-player") ? el.parentNode : el).cloneNode(true);
    $cb03b711053a4297$var$hooks("beforesetup").forEach((hookFunction)=>{
        const opts = hookFunction(el, $cb03b711053a4297$var$merge$1(options));
        if (!$cb03b711053a4297$var$isObject(opts) || Array.isArray(opts)) {
            $cb03b711053a4297$var$log$1.error("please return an object in beforesetup hooks");
            return;
        }
        options = $cb03b711053a4297$var$merge$1(options, opts);
    });
    // We get the current "Player" component here in case an integration has
    // replaced it with a custom player.
    const PlayerComponent = $cb03b711053a4297$var$Component$1.getComponent("Player");
    player = new PlayerComponent(el, options, ready);
    $cb03b711053a4297$var$hooks("setup").forEach((hookFunction)=>hookFunction(player));
    return player;
}
$cb03b711053a4297$export$2e2bcd8739ae039.hooks_ = $cb03b711053a4297$var$hooks_;
$cb03b711053a4297$export$2e2bcd8739ae039.hooks = $cb03b711053a4297$var$hooks;
$cb03b711053a4297$export$2e2bcd8739ae039.hook = $cb03b711053a4297$var$hook;
$cb03b711053a4297$export$2e2bcd8739ae039.hookOnce = $cb03b711053a4297$var$hookOnce;
$cb03b711053a4297$export$2e2bcd8739ae039.removeHook = $cb03b711053a4297$var$removeHook;
// Add default styles
if ((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VIDEOJS_NO_DYNAMIC_STYLE !== true && $cb03b711053a4297$var$isReal()) {
    let style = $cb03b711053a4297$var$$(".vjs-styles-defaults");
    if (!style) {
        style = $cb03b711053a4297$var$createStyleElement("vjs-styles-defaults");
        const head = $cb03b711053a4297$var$$("head");
        if (head) head.insertBefore(style, head.firstChild);
        $cb03b711053a4297$var$setTextContent(style, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
    }
}
// Run Auto-load players
// You have to wait at least once in case this script is loaded after your
// video in the DOM (weird behavior only with minified version)
$cb03b711053a4297$var$autoSetupTimeout(1, $cb03b711053a4297$export$2e2bcd8739ae039);
/**
 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
 *
 * @type {string}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.VERSION = $cb03b711053a4297$var$version$6;
/**
 * The global options object. These are the settings that take effect
 * if no overrides are specified when the player is created.
 *
 * @type {Object}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.options = $cb03b711053a4297$var$Player.prototype.options_;
/**
 * Get an object with the currently created players, keyed by player ID
 *
 * @return {Object}
 *         The created players
 */ $cb03b711053a4297$export$2e2bcd8739ae039.getPlayers = ()=>$cb03b711053a4297$var$Player.players;
/**
 * Get a single player based on an ID or DOM element.
 *
 * This is useful if you want to check if an element or ID has an associated
 * Video.js player, but not create one if it doesn't.
 *
 * @param   {string|Element} id
 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
 *          or a string matching the `id` of such an element.
 *
 * @return {Player|undefined}
 *          A player instance or `undefined` if there is no player instance
 *          matching the argument.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.getPlayer = (id)=>{
    const players = $cb03b711053a4297$var$Player.players;
    let tag;
    if (typeof id === "string") {
        const nId = $cb03b711053a4297$var$normalizeId(id);
        const player = players[nId];
        if (player) return player;
        tag = $cb03b711053a4297$var$$("#" + nId);
    } else tag = id;
    if ($cb03b711053a4297$var$isEl(tag)) {
        const { player: player, playerId: playerId } = tag;
        // Element may have a `player` property referring to an already created
        // player instance. If so, return that.
        if (player || players[playerId]) return player || players[playerId];
    }
};
/**
 * Returns an array of all current players.
 *
 * @return {Array}
 *         An array of all players. The array will be in the order that
 *         `Object.keys` provides, which could potentially vary between
 *         JavaScript engines.
 *
 */ $cb03b711053a4297$export$2e2bcd8739ae039.getAllPlayers = ()=>// Disposed players leave a key with a `null` value, so we need to make sure
    // we filter those out.
    Object.keys($cb03b711053a4297$var$Player.players).map((k)=>$cb03b711053a4297$var$Player.players[k]).filter(Boolean);
$cb03b711053a4297$export$2e2bcd8739ae039.players = $cb03b711053a4297$var$Player.players;
$cb03b711053a4297$export$2e2bcd8739ae039.getComponent = $cb03b711053a4297$var$Component$1.getComponent;
/**
 * Register a component so it can referred to by name. Used when adding to other
 * components, either through addChild `component.addChild('myComponent')` or through
 * default children options  `{ children: ['myComponent'] }`.
 *
 * > NOTE: You could also just initialize the component before adding.
 * `component.addChild(new MyComponent());`
 *
 * @param {string} name
 *        The class name of the component
 *
 * @param {typeof Component} comp
 *        The component class
 *
 * @return {typeof Component}
 *         The newly registered component
 */ $cb03b711053a4297$export$2e2bcd8739ae039.registerComponent = (name, comp)=>{
    if ($cb03b711053a4297$var$Tech.isTech(comp)) $cb03b711053a4297$var$log$1.warn(`The ${name} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`);
    return $cb03b711053a4297$var$Component$1.registerComponent.call($cb03b711053a4297$var$Component$1, name, comp);
};
$cb03b711053a4297$export$2e2bcd8739ae039.getTech = $cb03b711053a4297$var$Tech.getTech;
$cb03b711053a4297$export$2e2bcd8739ae039.registerTech = $cb03b711053a4297$var$Tech.registerTech;
$cb03b711053a4297$export$2e2bcd8739ae039.use = $cb03b711053a4297$var$use;
/**
 * An object that can be returned by a middleware to signify
 * that the middleware is being terminated.
 *
 * @type {object}
 * @property {object} middleware.TERMINATOR
 */ Object.defineProperty($cb03b711053a4297$export$2e2bcd8739ae039, "middleware", {
    value: {},
    writeable: false,
    enumerable: true
});
Object.defineProperty($cb03b711053a4297$export$2e2bcd8739ae039.middleware, "TERMINATOR", {
    value: $cb03b711053a4297$var$TERMINATOR,
    writeable: false,
    enumerable: true
});
/**
 * A reference to the {@link module:browser|browser utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:browser|browser}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.browser = $cb03b711053a4297$var$browser;
/**
 * A reference to the {@link module:obj|obj utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:obj|obj}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.obj = $cb03b711053a4297$var$Obj;
/**
 * Deprecated reference to the {@link module:obj.merge|merge function}
 *
 * @type {Function}
 * @see {@link module:obj.merge|merge}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.merge instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.mergeOptions = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.mergeOptions", "videojs.obj.merge", $cb03b711053a4297$var$merge$1);
/**
 * Deprecated reference to the {@link module:obj.defineLazyProperty|defineLazyProperty function}
 *
 * @type {Function}
 * @see {@link module:obj.defineLazyProperty|defineLazyProperty}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.obj.defineLazyProperty instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.defineLazyProperty = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", $cb03b711053a4297$var$defineLazyProperty);
/**
 * Deprecated reference to the {@link module:fn.bind_|fn.bind_ function}
 *
 * @type {Function}
 * @see {@link module:fn.bind_|fn.bind_}
 * @deprecated Deprecated and will be removed in 9.0. Please use native Function.prototype.bind instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.bind = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.bind", "native Function.prototype.bind", $cb03b711053a4297$var$bind_);
$cb03b711053a4297$export$2e2bcd8739ae039.registerPlugin = $cb03b711053a4297$var$Plugin.registerPlugin;
$cb03b711053a4297$export$2e2bcd8739ae039.deregisterPlugin = $cb03b711053a4297$var$Plugin.deregisterPlugin;
/**
 * Deprecated method to register a plugin with Video.js
 *
 * @deprecated Deprecated and will be removed in 9.0. Use videojs.registerPlugin() instead.
 *
 * @param {string} name
 *        The plugin name
*
 * @param {typeof Plugin|Function} plugin
 *         The plugin sub-class or function
 *
 * @return {typeof Plugin|Function}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.plugin = (name, plugin)=>{
    $cb03b711053a4297$var$log$1.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead");
    return $cb03b711053a4297$var$Plugin.registerPlugin(name, plugin);
};
$cb03b711053a4297$export$2e2bcd8739ae039.getPlugins = $cb03b711053a4297$var$Plugin.getPlugins;
$cb03b711053a4297$export$2e2bcd8739ae039.getPlugin = $cb03b711053a4297$var$Plugin.getPlugin;
$cb03b711053a4297$export$2e2bcd8739ae039.getPluginVersion = $cb03b711053a4297$var$Plugin.getPluginVersion;
/**
 * Adding languages so that they're available to all players.
 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
 *
 * @param {string} code
 *        The language code or dictionary property
 *
 * @param {Object} data
 *        The data values to be translated
 *
 * @return {Object}
 *         The resulting language dictionary object
 */ $cb03b711053a4297$export$2e2bcd8739ae039.addLanguage = function(code, data) {
    code = ("" + code).toLowerCase();
    $cb03b711053a4297$export$2e2bcd8739ae039.options.languages = $cb03b711053a4297$var$merge$1($cb03b711053a4297$export$2e2bcd8739ae039.options.languages, {
        [code]: data
    });
    return $cb03b711053a4297$export$2e2bcd8739ae039.options.languages[code];
};
/**
 * A reference to the {@link module:log|log utility module} as an object.
 *
 * @type {Function}
 * @see  {@link module:log|log}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.log = $cb03b711053a4297$var$log$1;
$cb03b711053a4297$export$2e2bcd8739ae039.createLogger = $cb03b711053a4297$var$createLogger;
/**
 * A reference to the {@link module:time|time utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:time|time}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.time = $cb03b711053a4297$var$Time;
/**
 * Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
 *
 * @type {Function}
 * @see {@link module:time.createTimeRanges|createTimeRanges}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.createTimeRange = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", $cb03b711053a4297$var$createTimeRanges$1);
/**
 * Deprecated reference to the {@link module:time.createTimeRanges|createTimeRanges function}
 *
 * @type {Function}
 * @see {@link module:time.createTimeRanges|createTimeRanges}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.createTimeRanges instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.createTimeRanges = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", $cb03b711053a4297$var$createTimeRanges$1);
/**
 * Deprecated reference to the {@link module:time.formatTime|formatTime function}
 *
 * @type {Function}
 * @see {@link module:time.formatTime|formatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.format instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.formatTime = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.formatTime", "videojs.time.formatTime", $cb03b711053a4297$var$formatTime);
/**
 * Deprecated reference to the {@link module:time.setFormatTime|setFormatTime function}
 *
 * @type {Function}
 * @see {@link module:time.setFormatTime|setFormatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.setFormat instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.setFormatTime = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.setFormatTime", "videojs.time.setFormatTime", $cb03b711053a4297$var$setFormatTime);
/**
 * Deprecated reference to the {@link module:time.resetFormatTime|resetFormatTime function}
 *
 * @type {Function}
 * @see {@link module:time.resetFormatTime|resetFormatTime}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.time.resetFormat instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.resetFormatTime = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", $cb03b711053a4297$var$resetFormatTime);
/**
 * Deprecated reference to the {@link module:url.parseUrl|Url.parseUrl function}
 *
 * @type {Function}
 * @see {@link module:url.parseUrl|parseUrl}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.parseUrl instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.parseUrl = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.parseUrl", "videojs.url.parseUrl", $cb03b711053a4297$var$parseUrl);
/**
 * Deprecated reference to the {@link module:url.isCrossOrigin|Url.isCrossOrigin function}
 *
 * @type {Function}
 * @see {@link module:url.isCrossOrigin|isCrossOrigin}
 * @deprecated Deprecated and will be removed in 9.0. Please use videojs.url.isCrossOrigin instead.
 */ $cb03b711053a4297$export$2e2bcd8739ae039.isCrossOrigin = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", $cb03b711053a4297$var$isCrossOrigin);
$cb03b711053a4297$export$2e2bcd8739ae039.EventTarget = $cb03b711053a4297$var$EventTarget$2;
$cb03b711053a4297$export$2e2bcd8739ae039.any = $cb03b711053a4297$var$any;
$cb03b711053a4297$export$2e2bcd8739ae039.on = $cb03b711053a4297$var$on;
$cb03b711053a4297$export$2e2bcd8739ae039.one = $cb03b711053a4297$var$one;
$cb03b711053a4297$export$2e2bcd8739ae039.off = $cb03b711053a4297$var$off;
$cb03b711053a4297$export$2e2bcd8739ae039.trigger = $cb03b711053a4297$var$trigger;
/**
 * A cross-browser XMLHttpRequest wrapper.
 *
 * @function
 * @param    {Object} options
 *           Settings for the request.
 *
 * @return   {XMLHttpRequest|XDomainRequest}
 *           The request object.
 *
 * @see      https://github.com/Raynos/xhr
 */ $cb03b711053a4297$export$2e2bcd8739ae039.xhr = (0, (/*@__PURE__*/$parcel$interopDefault($cfb0541156229cda$exports)));
$cb03b711053a4297$export$2e2bcd8739ae039.TextTrack = $cb03b711053a4297$var$TextTrack;
$cb03b711053a4297$export$2e2bcd8739ae039.AudioTrack = $cb03b711053a4297$var$AudioTrack;
$cb03b711053a4297$export$2e2bcd8739ae039.VideoTrack = $cb03b711053a4297$var$VideoTrack;
[
    "isEl",
    "isTextNode",
    "createEl",
    "hasClass",
    "addClass",
    "removeClass",
    "toggleClass",
    "setAttributes",
    "getAttributes",
    "emptyEl",
    "appendContent",
    "insertContent"
].forEach((k)=>{
    $cb03b711053a4297$export$2e2bcd8739ae039[k] = function() {
        $cb03b711053a4297$var$log$1.warn(`videojs.${k}() is deprecated; use videojs.dom.${k}() instead`);
        return $cb03b711053a4297$var$Dom[k].apply(null, arguments);
    };
});
$cb03b711053a4297$export$2e2bcd8739ae039.computedStyle = $cb03b711053a4297$var$deprecateForMajor(9, "videojs.computedStyle", "videojs.dom.computedStyle", $cb03b711053a4297$var$computedStyle);
/**
 * A reference to the {@link module:dom|DOM utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:dom|dom}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.dom = $cb03b711053a4297$var$Dom;
/**
 * A reference to the {@link module:fn|fn utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:fn|fn}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.fn = $cb03b711053a4297$var$Fn;
/**
 * A reference to the {@link module:num|num utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:num|num}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.num = $cb03b711053a4297$var$Num;
/**
 * A reference to the {@link module:str|str utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:str|str}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.str = $cb03b711053a4297$var$Str;
/**
 * A reference to the {@link module:url|URL utility module} as an object.
 *
 * @type {Object}
 * @see {@link module:url|url}
 */ $cb03b711053a4297$export$2e2bcd8739ae039.url = $cb03b711053a4297$var$Url;
/*! @name videojs-contrib-quality-levels @version 4.0.0 @license Apache-2.0 */ /**
 * A single QualityLevel.
 *
 * interface QualityLevel {
 *   readonly attribute DOMString id;
 *            attribute DOMString label;
 *   readonly attribute long width;
 *   readonly attribute long height;
 *   readonly attribute long bitrate;
 *            attribute boolean enabled;
 * };
 *
 * @class QualityLevel
 */ class $cb03b711053a4297$var$QualityLevel {
    /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */ constructor(representation){
        let level = this; // eslint-disable-line
        level.id = representation.id;
        level.label = level.id;
        level.width = representation.width;
        level.height = representation.height;
        level.bitrate = representation.bandwidth;
        level.frameRate = representation.frameRate;
        level.enabled_ = representation.enabled;
        Object.defineProperty(level, "enabled", {
            /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */ get () {
                return level.enabled_();
            },
            /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */ set (enable) {
                level.enabled_(enable);
            }
        });
        return level;
    }
}
/**
 * A list of QualityLevels.
 *
 * interface QualityLevelList : EventTarget {
 *   getter QualityLevel (unsigned long index);
 *   readonly attribute unsigned long length;
 *   readonly attribute long selectedIndex;
 *
 *   void addQualityLevel(QualityLevel qualityLevel)
 *   void removeQualityLevel(QualityLevel remove)
 *   QualityLevel? getQualityLevelById(DOMString id);
 *
 *   attribute EventHandler onchange;
 *   attribute EventHandler onaddqualitylevel;
 *   attribute EventHandler onremovequalitylevel;
 * };
 *
 * @extends videojs.EventTarget
 * @class QualityLevelList
 */ class $cb03b711053a4297$var$QualityLevelList extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    /**
   * Creates a QualityLevelList.
   */ constructor(){
        super();
        let list = this; // eslint-disable-line
        list.levels_ = [];
        list.selectedIndex_ = -1;
        /**
     * Get the index of the currently selected QualityLevel.
     *
     * @returns {number} The index of the selected QualityLevel. -1 if none selected.
     * @readonly
     */ Object.defineProperty(list, "selectedIndex", {
            get () {
                return list.selectedIndex_;
            }
        });
        /**
     * Get the length of the list of QualityLevels.
     *
     * @returns {number} The length of the list.
     * @readonly
     */ Object.defineProperty(list, "length", {
            get () {
                return list.levels_.length;
            }
        });
        list[Symbol.iterator] = ()=>list.levels_.values();
        return list;
    }
    /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */ addQualityLevel(representation) {
        let qualityLevel = this.getQualityLevelById(representation.id); // Do not add duplicate quality levels
        if (qualityLevel) return qualityLevel;
        const index = this.levels_.length;
        qualityLevel = new $cb03b711053a4297$var$QualityLevel(representation);
        if (!("" + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.levels_[index];
            }
        });
        this.levels_.push(qualityLevel);
        this.trigger({
            qualityLevel: qualityLevel,
            type: "addqualitylevel"
        });
        return qualityLevel;
    }
    /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */ removeQualityLevel(qualityLevel) {
        let removed = null;
        for(let i = 0, l = this.length; i < l; i++)if (this[i] === qualityLevel) {
            removed = this.levels_.splice(i, 1)[0];
            if (this.selectedIndex_ === i) this.selectedIndex_ = -1;
            else if (this.selectedIndex_ > i) this.selectedIndex_--;
            break;
        }
        if (removed) this.trigger({
            qualityLevel: qualityLevel,
            type: "removequalitylevel"
        });
        return removed;
    }
    /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */ getQualityLevelById(id) {
        for(let i = 0, l = this.length; i < l; i++){
            const level = this[i];
            if (level.id === id) return level;
        }
        return null;
    }
    /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */ dispose() {
        this.selectedIndex_ = -1;
        this.levels_.length = 0;
    }
}
/**
 * change - The selected QualityLevel has changed.
 * addqualitylevel - A QualityLevel has been added to the QualityLevelList.
 * removequalitylevel - A QualityLevel has been removed from the QualityLevelList.
 */ $cb03b711053a4297$var$QualityLevelList.prototype.allowedEvents_ = {
    change: "change",
    addqualitylevel: "addqualitylevel",
    removequalitylevel: "removequalitylevel"
}; // emulate attribute EventHandler support to allow for feature detection
for(const event in $cb03b711053a4297$var$QualityLevelList.prototype.allowedEvents_)$cb03b711053a4297$var$QualityLevelList.prototype["on" + event] = null;
var $cb03b711053a4297$var$version$5 = "4.0.0";
/**
 * Initialization function for the qualityLevels plugin. Sets up the QualityLevelList and
 * event handlers.
 *
 * @param {Player} player Player object.
 * @param {Object} options Plugin options object.
 * @return {QualityLevelList} a list of QualityLevels
 */ const $cb03b711053a4297$var$initPlugin$1 = function(player, options) {
    const originalPluginFn = player.qualityLevels;
    const qualityLevelList = new $cb03b711053a4297$var$QualityLevelList();
    const disposeHandler = function() {
        qualityLevelList.dispose();
        player.qualityLevels = originalPluginFn;
        player.off("dispose", disposeHandler);
    };
    player.on("dispose", disposeHandler);
    player.qualityLevels = ()=>qualityLevelList;
    player.qualityLevels.VERSION = $cb03b711053a4297$var$version$5;
    return qualityLevelList;
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @param {Object} options Plugin options object
 * @return {QualityLevelList} a list of QualityLevels
 */ const $cb03b711053a4297$var$qualityLevels = function(options) {
    return $cb03b711053a4297$var$initPlugin$1(this, $cb03b711053a4297$export$2e2bcd8739ae039.obj.merge({}, options));
}; // Register the plugin with video.js.
$cb03b711053a4297$export$2e2bcd8739ae039.registerPlugin("qualityLevels", $cb03b711053a4297$var$qualityLevels); // Include the version number.
$cb03b711053a4297$var$qualityLevels.VERSION = $cb03b711053a4297$var$version$5;
/*! @name @videojs/http-streaming @version 3.7.0 @license Apache-2.0 */ /**
 * @file resolve-url.js - Handling how URLs are resolved and manipulated
 */ const $cb03b711053a4297$var$resolveUrl = (0, $42da3e152bb58681$export$2e2bcd8739ae039);
/**
 * If the xhr request was redirected, return the responseURL, otherwise,
 * return the original url.
 *
 * @api private
 *
 * @param  {string} url - an url being requested
 * @param  {XMLHttpRequest} req - xhr request result
 *
 * @return {string}
 */ const $cb03b711053a4297$var$resolveManifestRedirect = (url, req)=>{
    // To understand how the responseURL below is set and generated:
    // - https://fetch.spec.whatwg.org/#concept-response-url
    // - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
    if (req && req.responseURL && url !== req.responseURL) return req.responseURL;
    return url;
};
const $cb03b711053a4297$var$logger = (source)=>{
    if ($cb03b711053a4297$export$2e2bcd8739ae039.log.debug) return $cb03b711053a4297$export$2e2bcd8739ae039.log.debug.bind($cb03b711053a4297$export$2e2bcd8739ae039, "VHS:", `${source} >`);
    return function() {};
};
/**
 * Provides a compatibility layer between Video.js 7 and 8 API changes for VHS.
 */ /**
 * Delegates to videojs.obj.merge (Video.js 8) or
 * videojs.mergeOptions (Video.js 7).
 */ function $cb03b711053a4297$var$merge(...args) {
    const context = $cb03b711053a4297$export$2e2bcd8739ae039.obj || $cb03b711053a4297$export$2e2bcd8739ae039;
    const fn = context.merge || context.mergeOptions;
    return fn.apply(context, args);
}
/**
 * Delegates to videojs.time.createTimeRanges (Video.js 8) or
 * videojs.createTimeRanges (Video.js 7).
 */ function $cb03b711053a4297$var$createTimeRanges(...args) {
    const context = $cb03b711053a4297$export$2e2bcd8739ae039.time || $cb03b711053a4297$export$2e2bcd8739ae039;
    const fn = context.createTimeRanges || context.createTimeRanges;
    return fn.apply(context, args);
}
/**
 * Converts any buffered time range to a descriptive string
 *
 * @param {TimeRanges} buffered - time ranges
 * @return {string} - descriptive string
 */ function $cb03b711053a4297$var$prettyBuffered(buffered) {
    let result = "";
    for(let i = 0; i < buffered.length; i++){
        const start = buffered.start(i);
        const end = buffered.end(i);
        const duration = end - start;
        if (result.length) result += "\n";
        result += `[${duration}](${start} -> ${end})`;
    }
    return result || "empty";
}
/**
 * ranges
 *
 * Utilities for working with TimeRanges.
 *
 */ const $cb03b711053a4297$var$TIME_FUDGE_FACTOR = 1 / 30; // Comparisons between time values such as current time and the end of the buffered range
// can be misleading because of precision differences or when the current media has poorly
// aligned audio and video, which can cause values to be slightly off from what you would
// expect. This value is what we consider to be safe to use in such comparisons to account
// for these scenarios.
const $cb03b711053a4297$var$SAFE_TIME_DELTA = $cb03b711053a4297$var$TIME_FUDGE_FACTOR * 3;
const $cb03b711053a4297$var$filterRanges = function(timeRanges, predicate) {
    const results = [];
    let i;
    if (timeRanges && timeRanges.length) {
        // Search for ranges that match the predicate
        for(i = 0; i < timeRanges.length; i++)if (predicate(timeRanges.start(i), timeRanges.end(i))) results.push([
            timeRanges.start(i),
            timeRanges.end(i)
        ]);
    }
    return $cb03b711053a4297$var$createTimeRanges(results);
};
/**
 * Attempts to find the buffered TimeRange that contains the specified
 * time.
 *
 * @param {TimeRanges} buffered - the TimeRanges object to query
 * @param {number} time  - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object
 */ const $cb03b711053a4297$var$findRange = function(buffered, time) {
    return $cb03b711053a4297$var$filterRanges(buffered, function(start, end) {
        return start - $cb03b711053a4297$var$SAFE_TIME_DELTA <= time && end + $cb03b711053a4297$var$SAFE_TIME_DELTA >= time;
    });
};
/**
 * Returns the TimeRanges that begin later than the specified time.
 *
 * @param {TimeRanges} timeRanges - the TimeRanges object to query
 * @param {number} time - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object.
 */ const $cb03b711053a4297$var$findNextRange = function(timeRanges, time) {
    return $cb03b711053a4297$var$filterRanges(timeRanges, function(start) {
        return start - $cb03b711053a4297$var$TIME_FUDGE_FACTOR >= time;
    });
};
/**
 * Returns gaps within a list of TimeRanges
 *
 * @param {TimeRanges} buffered - the TimeRanges object
 * @return {TimeRanges} a TimeRanges object of gaps
 */ const $cb03b711053a4297$var$findGaps = function(buffered) {
    if (buffered.length < 2) return $cb03b711053a4297$var$createTimeRanges();
    const ranges = [];
    for(let i = 1; i < buffered.length; i++){
        const start = buffered.end(i - 1);
        const end = buffered.start(i);
        ranges.push([
            start,
            end
        ]);
    }
    return $cb03b711053a4297$var$createTimeRanges(ranges);
};
/**
 * Calculate the intersection of two TimeRanges
 *
 * @param {TimeRanges} bufferA
 * @param {TimeRanges} bufferB
 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
 */ const $cb03b711053a4297$var$bufferIntersection = function(bufferA, bufferB) {
    let start = null;
    let end = null;
    let arity = 0;
    const extents = [];
    const ranges = [];
    if (!bufferA || !bufferA.length || !bufferB || !bufferB.length) return $cb03b711053a4297$var$createTimeRanges();
     // Handle the case where we have both buffers and create an
    // intersection of the two
    let count = bufferA.length; // A) Gather up all start and end times
    while(count--){
        extents.push({
            time: bufferA.start(count),
            type: "start"
        });
        extents.push({
            time: bufferA.end(count),
            type: "end"
        });
    }
    count = bufferB.length;
    while(count--){
        extents.push({
            time: bufferB.start(count),
            type: "start"
        });
        extents.push({
            time: bufferB.end(count),
            type: "end"
        });
    } // B) Sort them by time
    extents.sort(function(a, b) {
        return a.time - b.time;
    }); // C) Go along one by one incrementing arity for start and decrementing
    //    arity for ends
    for(count = 0; count < extents.length; count++){
        if (extents[count].type === "start") {
            arity++; // D) If arity is ever incremented to 2 we are entering an
            //    overlapping range
            if (arity === 2) start = extents[count].time;
        } else if (extents[count].type === "end") {
            arity--; // E) If arity is ever decremented to 1 we leaving an
            //    overlapping range
            if (arity === 1) end = extents[count].time;
        } // F) Record overlapping ranges
        if (start !== null && end !== null) {
            ranges.push([
                start,
                end
            ]);
            start = null;
            end = null;
        }
    }
    return $cb03b711053a4297$var$createTimeRanges(ranges);
};
/**
 * Gets a human readable string for a TimeRange
 *
 * @param {TimeRange} range
 * @return {string} a human readable string
 */ const $cb03b711053a4297$var$printableRange = (range)=>{
    const strArr = [];
    if (!range || !range.length) return "";
    for(let i = 0; i < range.length; i++)strArr.push(range.start(i) + " => " + range.end(i));
    return strArr.join(", ");
};
/**
 * Calculates the amount of time left in seconds until the player hits the end of the
 * buffer and causes a rebuffer
 *
 * @param {TimeRange} buffered
 *        The state of the buffer
 * @param {Numnber} currentTime
 *        The current time of the player
 * @param {number} playbackRate
 *        The current playback rate of the player. Defaults to 1.
 * @return {number}
 *         Time until the player has to start rebuffering in seconds.
 * @function timeUntilRebuffer
 */ const $cb03b711053a4297$var$timeUntilRebuffer = function(buffered, currentTime, playbackRate = 1) {
    const bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
    return (bufferedEnd - currentTime) / playbackRate;
};
/**
 * Converts a TimeRanges object into an array representation
 *
 * @param {TimeRanges} timeRanges
 * @return {Array}
 */ const $cb03b711053a4297$var$timeRangesToArray = (timeRanges)=>{
    const timeRangesList = [];
    for(let i = 0; i < timeRanges.length; i++)timeRangesList.push({
        start: timeRanges.start(i),
        end: timeRanges.end(i)
    });
    return timeRangesList;
};
/**
 * Determines if two time range objects are different.
 *
 * @param {TimeRange} a
 *        the first time range object to check
 *
 * @param {TimeRange} b
 *        the second time range object to check
 *
 * @return {Boolean}
 *         Whether the time range objects differ
 */ const $cb03b711053a4297$var$isRangeDifferent = function(a, b) {
    // same object
    if (a === b) return false;
     // one or the other is undefined
    if (!a && b || !b && a) return true;
     // length is different
    if (a.length !== b.length) return true;
     // see if any start/end pair is different
    for(let i = 0; i < a.length; i++){
        if (a.start(i) !== b.start(i) || a.end(i) !== b.end(i)) return true;
    } // if the length and every pair is the same
    // this is the same time range
    return false;
};
const $cb03b711053a4297$var$lastBufferedEnd = function(a) {
    if (!a || !a.length || !a.end) return;
    return a.end(a.length - 1);
};
/**
 * A utility function to add up the amount of time in a timeRange
 * after a specified startTime.
 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
 *     would return 40 as there are 40s seconds after 0 in the timeRange
 *
 * @param {TimeRange} range
 *        The range to check against
 * @param {number} startTime
 *        The time in the time range that you should start counting from
 *
 * @return {number}
 *          The number of seconds in the buffer passed the specified time.
 */ const $cb03b711053a4297$var$timeAheadOf = function(range, startTime) {
    let time = 0;
    if (!range || !range.length) return time;
    for(let i = 0; i < range.length; i++){
        const start = range.start(i);
        const end = range.end(i); // startTime is after this range entirely
        if (startTime > end) continue;
         // startTime is within this range
        if (startTime > start && startTime <= end) {
            time += end - startTime;
            continue;
        } // startTime is before this range.
        time += end - start;
    }
    return time;
};
/**
 * @file playlist.js
 *
 * Playlist related utilities.
 */ /**
 * Get the duration of a segment, with special cases for
 * llhls segments that do not have a duration yet.
 *
 * @param {Object} playlist
 *        the playlist that the segment belongs to.
 * @param {Object} segment
 *        the segment to get a duration for.
 *
 * @return {number}
 *          the segment duration
 */ const $cb03b711053a4297$var$segmentDurationWithParts = (playlist, segment)=>{
    // if this isn't a preload segment
    // then we will have a segment duration that is accurate.
    if (!segment.preload) return segment.duration;
     // otherwise we have to add up parts and preload hints
    // to get an up to date duration.
    let result = 0;
    (segment.parts || []).forEach(function(p) {
        result += p.duration;
    }); // for preload hints we have to use partTargetDuration
    // as they won't even have a duration yet.
    (segment.preloadHints || []).forEach(function(p) {
        if (p.type === "PART") result += playlist.partTargetDuration;
    });
    return result;
};
/**
 * A function to get a combined list of parts and segments with durations
 * and indexes.
 *
 * @param {Playlist} playlist the playlist to get the list for.
 *
 * @return {Array} The part/segment list.
 */ const $cb03b711053a4297$var$getPartsAndSegments = (playlist)=>(playlist.segments || []).reduce((acc, segment, si)=>{
        if (segment.parts) segment.parts.forEach(function(part, pi) {
            acc.push({
                duration: part.duration,
                segmentIndex: si,
                partIndex: pi,
                part: part,
                segment: segment
            });
        });
        else acc.push({
            duration: segment.duration,
            segmentIndex: si,
            partIndex: null,
            segment: segment,
            part: null
        });
        return acc;
    }, []);
const $cb03b711053a4297$var$getLastParts = (media)=>{
    const lastSegment = media.segments && media.segments.length && media.segments[media.segments.length - 1];
    return lastSegment && lastSegment.parts || [];
};
const $cb03b711053a4297$var$getKnownPartCount = ({ preloadSegment: preloadSegment })=>{
    if (!preloadSegment) return;
    const { parts: parts, preloadHints: preloadHints } = preloadSegment;
    let partCount = (preloadHints || []).reduce((count, hint)=>count + (hint.type === "PART" ? 1 : 0), 0);
    partCount += parts && parts.length ? parts.length : 0;
    return partCount;
};
/**
 * Get the number of seconds to delay from the end of a
 * live playlist.
 *
 * @param {Playlist} main the main playlist
 * @param {Playlist} media the media playlist
 * @return {number} the hold back in seconds.
 */ const $cb03b711053a4297$var$liveEdgeDelay = (main, media)=>{
    if (media.endList) return 0;
     // dash suggestedPresentationDelay trumps everything
    if (main && main.suggestedPresentationDelay) return main.suggestedPresentationDelay;
    const hasParts = $cb03b711053a4297$var$getLastParts(media).length > 0; // look for "part" delays from ll-hls first
    if (hasParts && media.serverControl && media.serverControl.partHoldBack) return media.serverControl.partHoldBack;
    else if (hasParts && media.partTargetDuration) return media.partTargetDuration * 3; // finally look for full segment delays
    else if (media.serverControl && media.serverControl.holdBack) return media.serverControl.holdBack;
    else if (media.targetDuration) return media.targetDuration * 3;
    return 0;
};
/**
 * walk backward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {Number} endSequence the mediaSequence to stop walking on
 */ const $cb03b711053a4297$var$backwardDuration = function(playlist, endSequence) {
    let result = 0;
    let i = endSequence - playlist.mediaSequence; // if a start time is available for segment immediately following
    // the interval, use it
    let segment = playlist.segments[i]; // Walk backward until we find the latest segment with timeline
    // information that is earlier than endSequence
    if (segment) {
        if (typeof segment.start !== "undefined") return {
            result: segment.start,
            precise: true
        };
        if (typeof segment.end !== "undefined") return {
            result: segment.end - segment.duration,
            precise: true
        };
    }
    while(i--){
        segment = playlist.segments[i];
        if (typeof segment.end !== "undefined") return {
            result: result + segment.end,
            precise: true
        };
        result += $cb03b711053a4297$var$segmentDurationWithParts(playlist, segment);
        if (typeof segment.start !== "undefined") return {
            result: result + segment.start,
            precise: true
        };
    }
    return {
        result: result,
        precise: false
    };
};
/**
 * walk forward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {number} endSequence the mediaSequence to stop walking on
 */ const $cb03b711053a4297$var$forwardDuration = function(playlist, endSequence) {
    let result = 0;
    let segment;
    let i = endSequence - playlist.mediaSequence; // Walk forward until we find the earliest segment with timeline
    // information
    for(; i < playlist.segments.length; i++){
        segment = playlist.segments[i];
        if (typeof segment.start !== "undefined") return {
            result: segment.start - result,
            precise: true
        };
        result += $cb03b711053a4297$var$segmentDurationWithParts(playlist, segment);
        if (typeof segment.end !== "undefined") return {
            result: segment.end - result,
            precise: true
        };
    } // indicate we didn't find a useful duration estimate
    return {
        result: -1,
        precise: false
    };
};
/**
  * Calculate the media duration from the segments associated with a
  * playlist. The duration of a subinterval of the available segments
  * may be calculated by specifying an end index.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper boundary
  * for the playlist.  Defaults to playlist length.
  * @param {number} expired the amount of time that has dropped
  * off the front of the playlist in a live scenario
  * @return {number} the duration between the first available segment
  * and end index.
  */ const $cb03b711053a4297$var$intervalDuration = function(playlist, endSequence, expired) {
    if (typeof endSequence === "undefined") endSequence = playlist.mediaSequence + playlist.segments.length;
    if (endSequence < playlist.mediaSequence) return 0;
     // do a backward walk to estimate the duration
    const backward = $cb03b711053a4297$var$backwardDuration(playlist, endSequence);
    if (backward.precise) // if we were able to base our duration estimate on timing
    // information provided directly from the Media Source, return
    // it
    return backward.result;
     // walk forward to see if a precise duration estimate can be made
    // that way
    const forward = $cb03b711053a4297$var$forwardDuration(playlist, endSequence);
    if (forward.precise) // we found a segment that has been buffered and so it's
    // position is known precisely
    return forward.result;
     // return the less-precise, playlist-based duration estimate
    return backward.result + expired;
};
/**
  * Calculates the duration of a playlist. If a start and end index
  * are specified, the duration will be for the subset of the media
  * timeline between those two indices. The total duration for live
  * playlists is always Infinity.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper
  * boundary for the playlist. Defaults to the playlist media
  * sequence number plus its length.
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @return {number} the duration between the start index and end
  * index.
  */ const $cb03b711053a4297$var$duration = function(playlist, endSequence, expired) {
    if (!playlist) return 0;
    if (typeof expired !== "number") expired = 0;
     // if a slice of the total duration is not requested, use
    // playlist-level duration indicators when they're present
    if (typeof endSequence === "undefined") {
        // if present, use the duration specified in the playlist
        if (playlist.totalDuration) return playlist.totalDuration;
         // duration should be Infinity for live playlists
        if (!playlist.endList) return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Infinity;
    } // calculate the total duration based on the segment durations
    return $cb03b711053a4297$var$intervalDuration(playlist, endSequence, expired);
};
/**
  * Calculate the time between two indexes in the current playlist
  * neight the start- nor the end-index need to be within the current
  * playlist in which case, the targetDuration of the playlist is used
  * to approximate the durations of the segments
  *
  * @param {Array} options.durationList list to iterate over for durations.
  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
  * @param {number} options.startIndex partsAndSegments index to start
  * @param {number} options.endIndex partsAndSegments index to end.
  * @return {number} the number of seconds between startIndex and endIndex
  */ const $cb03b711053a4297$var$sumDurations = function({ defaultDuration: defaultDuration, durationList: durationList, startIndex: startIndex, endIndex: endIndex }) {
    let durations = 0;
    if (startIndex > endIndex) [startIndex, endIndex] = [
        endIndex,
        startIndex
    ];
    if (startIndex < 0) {
        for(let i = startIndex; i < Math.min(0, endIndex); i++)durations += defaultDuration;
        startIndex = 0;
    }
    for(let i = startIndex; i < endIndex; i++)durations += durationList[i].duration;
    return durations;
};
/**
 * Calculates the playlist end time
 *
 * @param {Object} playlist a media playlist object
 * @param {number=} expired the amount of time that has
 *                  dropped off the front of the playlist in a live scenario
 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
 *                        playlist end calculation should consider the safe live end
 *                        (truncate the playlist end by three segments). This is normally
 *                        used for calculating the end of the playlist's seekable range.
 *                        This takes into account the value of liveEdgePadding.
 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
 *                 If this is provided, it is used in the safe live end calculation.
 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
 * @return {number} the end time of playlist
 * @function playlistEnd
 */ const $cb03b711053a4297$var$playlistEnd = function(playlist, expired, useSafeLiveEnd, liveEdgePadding) {
    if (!playlist || !playlist.segments) return null;
    if (playlist.endList) return $cb03b711053a4297$var$duration(playlist);
    if (expired === null) return null;
    expired = expired || 0;
    let lastSegmentEndTime = $cb03b711053a4297$var$intervalDuration(playlist, playlist.mediaSequence + playlist.segments.length, expired);
    if (useSafeLiveEnd) {
        liveEdgePadding = typeof liveEdgePadding === "number" ? liveEdgePadding : $cb03b711053a4297$var$liveEdgeDelay(null, playlist);
        lastSegmentEndTime -= liveEdgePadding;
    } // don't return a time less than zero
    return Math.max(0, lastSegmentEndTime);
};
/**
  * Calculates the interval of time that is currently seekable in a
  * playlist. The returned time ranges are relative to the earliest
  * moment in the specified playlist that is still available. A full
  * seekable implementation for live streams would need to offset
  * these values by the duration of content that has expired from the
  * stream.
  *
  * @param {Object} playlist a media playlist object
  * dropped off the front of the playlist in a live scenario
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
  *        Corresponds to suggestedPresentationDelay in DASH manifests.
  * @return {TimeRanges} the periods of time that are valid targets
  * for seeking
  */ const $cb03b711053a4297$var$seekable = function(playlist, expired, liveEdgePadding) {
    const useSafeLiveEnd = true;
    const seekableStart = expired || 0;
    let seekableEnd = $cb03b711053a4297$var$playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding);
    if (seekableEnd === null) return $cb03b711053a4297$var$createTimeRanges();
     // Clamp seekable end since it can not be less than the seekable start
    if (seekableEnd < seekableStart) seekableEnd = seekableStart;
    return $cb03b711053a4297$var$createTimeRanges(seekableStart, seekableEnd);
};
/**
 * Determine the index and estimated starting time of the segment that
 * contains a specified playback position in a media playlist.
 *
 * @param {Object} options.playlist the media playlist to query
 * @param {number} options.currentTime The number of seconds since the earliest
 * possible position to determine the containing segment for
 * @param {number} options.startTime the time when the segment/part starts
 * @param {number} options.startingSegmentIndex the segment index to start looking at.
 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
 *
 * @return {Object} an object with partIndex, segmentIndex, and startTime.
 */ const $cb03b711053a4297$var$getMediaInfoForTime = function({ playlist: playlist, currentTime: currentTime, startingSegmentIndex: startingSegmentIndex, startingPartIndex: startingPartIndex, startTime: startTime, exactManifestTimings: exactManifestTimings }) {
    let time = currentTime - startTime;
    const partsAndSegments = $cb03b711053a4297$var$getPartsAndSegments(playlist);
    let startIndex = 0;
    for(let i = 0; i < partsAndSegments.length; i++){
        const partAndSegment = partsAndSegments[i];
        if (startingSegmentIndex !== partAndSegment.segmentIndex) continue;
         // skip this if part index does not match.
        if (typeof startingPartIndex === "number" && typeof partAndSegment.partIndex === "number" && startingPartIndex !== partAndSegment.partIndex) continue;
        startIndex = i;
        break;
    }
    if (time < 0) {
        // Walk backward from startIndex in the playlist, adding durations
        // until we find a segment that contains `time` and return it
        if (startIndex > 0) for(let i = startIndex - 1; i >= 0; i--){
            const partAndSegment = partsAndSegments[i];
            time += partAndSegment.duration;
            if (exactManifestTimings) {
                if (time < 0) continue;
            } else if (time + $cb03b711053a4297$var$TIME_FUDGE_FACTOR <= 0) continue;
            return {
                partIndex: partAndSegment.partIndex,
                segmentIndex: partAndSegment.segmentIndex,
                startTime: startTime - $cb03b711053a4297$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: partsAndSegments,
                    startIndex: startIndex,
                    endIndex: i
                })
            };
        }
         // We were unable to find a good segment within the playlist
        // so select the first segment
        return {
            partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
            segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
            startTime: currentTime
        };
    } // When startIndex is negative, we first walk forward to first segment
    // adding target durations. If we "run out of time" before getting to
    // the first segment, return the first segment
    if (startIndex < 0) {
        for(let i = startIndex; i < 0; i++){
            time -= playlist.targetDuration;
            if (time < 0) return {
                partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
                segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
                startTime: currentTime
            };
        }
        startIndex = 0;
    } // Walk forward from startIndex in the playlist, subtracting durations
    // until we find a segment that contains `time` and return it
    for(let i = startIndex; i < partsAndSegments.length; i++){
        const partAndSegment = partsAndSegments[i];
        time -= partAndSegment.duration;
        if (exactManifestTimings) {
            if (time > 0) continue;
        } else if (time - $cb03b711053a4297$var$TIME_FUDGE_FACTOR >= 0) continue;
        return {
            partIndex: partAndSegment.partIndex,
            segmentIndex: partAndSegment.segmentIndex,
            startTime: startTime + $cb03b711053a4297$var$sumDurations({
                defaultDuration: playlist.targetDuration,
                durationList: partsAndSegments,
                startIndex: startIndex,
                endIndex: i
            })
        };
    } // We are out of possible candidates so load the last one...
    return {
        segmentIndex: partsAndSegments[partsAndSegments.length - 1].segmentIndex,
        partIndex: partsAndSegments[partsAndSegments.length - 1].partIndex,
        startTime: currentTime
    };
};
/**
 * Check whether the playlist is excluded or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is excluded or not
 * @function isExcluded
 */ const $cb03b711053a4297$var$isExcluded = function(playlist) {
    return playlist.excludeUntil && playlist.excludeUntil > Date.now();
};
/**
 * Check whether the playlist is compatible with current playback configuration or has
 * been excluded permanently for being incompatible.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is incompatible or not
 * @function isIncompatible
 */ const $cb03b711053a4297$var$isIncompatible = function(playlist) {
    return playlist.excludeUntil && playlist.excludeUntil === Infinity;
};
/**
 * Check whether the playlist is enabled or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is enabled or not
 * @function isEnabled
 */ const $cb03b711053a4297$var$isEnabled = function(playlist) {
    const excluded = $cb03b711053a4297$var$isExcluded(playlist);
    return !playlist.disabled && !excluded;
};
/**
 * Check whether the playlist has been manually disabled through the representations api.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is disabled manually or not
 * @function isDisabled
 */ const $cb03b711053a4297$var$isDisabled = function(playlist) {
    return playlist.disabled;
};
/**
 * Returns whether the current playlist is an AES encrypted HLS stream
 *
 * @return {boolean} true if it's an AES encrypted HLS stream
 */ const $cb03b711053a4297$var$isAes = function(media) {
    for(let i = 0; i < media.segments.length; i++){
        if (media.segments[i].key) return true;
    }
    return false;
};
/**
 * Checks if the playlist has a value for the specified attribute
 *
 * @param {string} attr
 *        Attribute to check for
 * @param {Object} playlist
 *        The media playlist object
 * @return {boolean}
 *         Whether the playlist contains a value for the attribute or not
 * @function hasAttribute
 */ const $cb03b711053a4297$var$hasAttribute = function(attr, playlist) {
    return playlist.attributes && playlist.attributes[attr];
};
/**
 * Estimates the time required to complete a segment download from the specified playlist
 *
 * @param {number} segmentDuration
 *        Duration of requested segment
 * @param {number} bandwidth
 *        Current measured bandwidth of the player
 * @param {Object} playlist
 *        The media playlist object
 * @param {number=} bytesReceived
 *        Number of bytes already received for the request. Defaults to 0
 * @return {number|NaN}
 *         The estimated time to request the segment. NaN if bandwidth information for
 *         the given playlist is unavailable
 * @function estimateSegmentRequestTime
 */ const $cb03b711053a4297$var$estimateSegmentRequestTime = function(segmentDuration, bandwidth, playlist, bytesReceived = 0) {
    if (!$cb03b711053a4297$var$hasAttribute("BANDWIDTH", playlist)) return NaN;
    const size = segmentDuration * playlist.attributes.BANDWIDTH;
    return (size - bytesReceived * 8) / bandwidth;
};
/*
 * Returns whether the current playlist is the lowest rendition
 *
 * @return {Boolean} true if on lowest rendition
 */ const $cb03b711053a4297$var$isLowestEnabledRendition = (main, media)=>{
    if (main.playlists.length === 1) return true;
    const currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
    return main.playlists.filter((playlist)=>{
        if (!$cb03b711053a4297$var$isEnabled(playlist)) return false;
        return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
    }).length === 0;
};
const $cb03b711053a4297$var$playlistMatch = (a, b)=>{
    // both playlits are null
    // or only one playlist is non-null
    // no match
    if (!a && !b || !a && b || a && !b) return false;
     // playlist objects are the same, match
    if (a === b) return true;
     // first try to use id as it should be the most
    // accurate
    if (a.id && b.id && a.id === b.id) return true;
     // next try to use reslovedUri as it should be the
    // second most accurate.
    if (a.resolvedUri && b.resolvedUri && a.resolvedUri === b.resolvedUri) return true;
     // finally try to use uri as it should be accurate
    // but might miss a few cases for relative uris
    if (a.uri && b.uri && a.uri === b.uri) return true;
    return false;
};
const $cb03b711053a4297$var$someAudioVariant = function(main, callback) {
    const AUDIO = main && main.mediaGroups && main.mediaGroups.AUDIO || {};
    let found = false;
    for(const groupName in AUDIO){
        for(const label in AUDIO[groupName]){
            found = callback(AUDIO[groupName][label]);
            if (found) break;
        }
        if (found) break;
    }
    return !!found;
};
const $cb03b711053a4297$var$isAudioOnly = (main)=>{
    // we are audio only if we have no main playlists but do
    // have media group playlists.
    if (!main || !main.playlists || !main.playlists.length) {
        // without audio variants or playlists this
        // is not an audio only main.
        const found = $cb03b711053a4297$var$someAudioVariant(main, (variant)=>variant.playlists && variant.playlists.length || variant.uri);
        return found;
    } // if every playlist has only an audio codec it is audio only
    for(let i = 0; i < main.playlists.length; i++){
        const playlist = main.playlists[i];
        const CODECS = playlist.attributes && playlist.attributes.CODECS; // all codecs are audio, this is an audio playlist.
        if (CODECS && CODECS.split(",").every((c)=>(0, $e324d09415701181$export$c642d74e895e3217)(c))) continue;
         // playlist is in an audio group it is audio only
        const found = $cb03b711053a4297$var$someAudioVariant(main, (variant)=>$cb03b711053a4297$var$playlistMatch(playlist, variant));
        if (found) continue;
         // if we make it here this playlist isn't audio and we
        // are not audio only
        return false;
    } // if we make it past every playlist without returning, then
    // this is an audio only playlist.
    return true;
}; // exports
var $cb03b711053a4297$var$Playlist = {
    liveEdgeDelay: $cb03b711053a4297$var$liveEdgeDelay,
    duration: $cb03b711053a4297$var$duration,
    seekable: $cb03b711053a4297$var$seekable,
    getMediaInfoForTime: $cb03b711053a4297$var$getMediaInfoForTime,
    isEnabled: $cb03b711053a4297$var$isEnabled,
    isDisabled: $cb03b711053a4297$var$isDisabled,
    isExcluded: $cb03b711053a4297$var$isExcluded,
    isIncompatible: $cb03b711053a4297$var$isIncompatible,
    playlistEnd: $cb03b711053a4297$var$playlistEnd,
    isAes: $cb03b711053a4297$var$isAes,
    hasAttribute: $cb03b711053a4297$var$hasAttribute,
    estimateSegmentRequestTime: $cb03b711053a4297$var$estimateSegmentRequestTime,
    isLowestEnabledRendition: $cb03b711053a4297$var$isLowestEnabledRendition,
    isAudioOnly: $cb03b711053a4297$var$isAudioOnly,
    playlistMatch: $cb03b711053a4297$var$playlistMatch,
    segmentDurationWithParts: $cb03b711053a4297$var$segmentDurationWithParts
};
const { log: $cb03b711053a4297$var$log } = $cb03b711053a4297$export$2e2bcd8739ae039;
const $cb03b711053a4297$var$createPlaylistID = (index, uri)=>{
    return `${index}-${uri}`;
}; // default function for creating a group id
const $cb03b711053a4297$var$groupID = (type, group, label)=>{
    return `placeholder-uri-${type}-${group}-${label}`;
};
/**
 * Parses a given m3u8 playlist
 *
 * @param {Function} [onwarn]
 *        a function to call when the parser triggers a warning event.
 * @param {Function} [oninfo]
 *        a function to call when the parser triggers an info event.
 * @param {string} manifestString
 *        The downloaded manifest string
 * @param {Object[]} [customTagParsers]
 *        An array of custom tag parsers for the m3u8-parser instance
 * @param {Object[]} [customTagMappers]
 *        An array of custom tag mappers for the m3u8-parser instance
 * @param {boolean} [llhls]
 *        Whether to keep ll-hls features in the manifest after parsing.
 * @return {Object}
 *         The manifest object
 */ const $cb03b711053a4297$var$parseManifest = ({ onwarn: onwarn, oninfo: oninfo, manifestString: manifestString, customTagParsers: customTagParsers = [], customTagMappers: customTagMappers = [], llhls: llhls })=>{
    const parser = new (0, $17dbf2814389b162$export$7acfa6ed01010e37)();
    if (onwarn) parser.on("warn", onwarn);
    if (oninfo) parser.on("info", oninfo);
    customTagParsers.forEach((customParser)=>parser.addParser(customParser));
    customTagMappers.forEach((mapper)=>parser.addTagMapper(mapper));
    parser.push(manifestString);
    parser.end();
    const manifest = parser.manifest; // remove llhls features from the parsed manifest
    // if we don't want llhls support.
    if (!llhls) {
        [
            "preloadSegment",
            "skip",
            "serverControl",
            "renditionReports",
            "partInf",
            "partTargetDuration"
        ].forEach(function(k) {
            if (manifest.hasOwnProperty(k)) delete manifest[k];
        });
        if (manifest.segments) manifest.segments.forEach(function(segment) {
            [
                "parts",
                "preloadHints"
            ].forEach(function(k) {
                if (segment.hasOwnProperty(k)) delete segment[k];
            });
        });
    }
    if (!manifest.targetDuration) {
        let targetDuration = 10;
        if (manifest.segments && manifest.segments.length) targetDuration = manifest.segments.reduce((acc, s)=>Math.max(acc, s.duration), 0);
        if (onwarn) onwarn(`manifest has no targetDuration defaulting to ${targetDuration}`);
        manifest.targetDuration = targetDuration;
    }
    const parts = $cb03b711053a4297$var$getLastParts(manifest);
    if (parts.length && !manifest.partTargetDuration) {
        const partTargetDuration = parts.reduce((acc, p)=>Math.max(acc, p.duration), 0);
        if (onwarn) {
            onwarn(`manifest has no partTargetDuration defaulting to ${partTargetDuration}`);
            $cb03b711053a4297$var$log.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.");
        }
        manifest.partTargetDuration = partTargetDuration;
    }
    return manifest;
};
/**
 * Loops through all supported media groups in main and calls the provided
 * callback for each group
 *
 * @param {Object} main
 *        The parsed main manifest object
 * @param {Function} callback
 *        Callback to call for each media group
 */ const $cb03b711053a4297$var$forEachMediaGroup = (main, callback)=>{
    if (!main.mediaGroups) return;
    [
        "AUDIO",
        "SUBTITLES"
    ].forEach((mediaType)=>{
        if (!main.mediaGroups[mediaType]) return;
        for(const groupKey in main.mediaGroups[mediaType])for(const labelKey in main.mediaGroups[mediaType][groupKey]){
            const mediaProperties = main.mediaGroups[mediaType][groupKey][labelKey];
            callback(mediaProperties, mediaType, groupKey, labelKey);
        }
    });
};
/**
 * Adds properties and attributes to the playlist to keep consistent functionality for
 * playlists throughout VHS.
 *
 * @param {Object} config
 *        Arguments object
 * @param {Object} config.playlist
 *        The media playlist
 * @param {string} [config.uri]
 *        The uri to the media playlist (if media playlist is not from within a main
 *        playlist)
 * @param {string} id
 *        ID to use for the playlist
 */ const $cb03b711053a4297$var$setupMediaPlaylist = ({ playlist: playlist, uri: uri, id: id })=>{
    playlist.id = id;
    playlist.playlistErrors_ = 0;
    if (uri) // For media playlists, m3u8-parser does not have access to a URI, as HLS media
    // playlists do not contain their own source URI, but one is needed for consistency in
    // VHS.
    playlist.uri = uri;
     // For HLS main playlists, even though certain attributes MUST be defined, the
    // stream may still be played without them.
    // For HLS media playlists, m3u8-parser does not attach an attributes object to the
    // manifest.
    //
    // To avoid undefined reference errors through the project, and make the code easier
    // to write/read, add an empty attributes object for these cases.
    playlist.attributes = playlist.attributes || {};
};
/**
 * Adds ID, resolvedUri, and attributes properties to each playlist of the main, where
 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
 * playlist references to the playlists array.
 *
 * @param {Object} main
 *        The main playlist
 */ const $cb03b711053a4297$var$setupMediaPlaylists = (main)=>{
    let i = main.playlists.length;
    while(i--){
        const playlist = main.playlists[i];
        $cb03b711053a4297$var$setupMediaPlaylist({
            playlist: playlist,
            id: $cb03b711053a4297$var$createPlaylistID(i, playlist.uri)
        });
        playlist.resolvedUri = $cb03b711053a4297$var$resolveUrl(main.uri, playlist.uri);
        main.playlists[playlist.id] = playlist; // URI reference added for backwards compatibility
        main.playlists[playlist.uri] = playlist; // Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
        // the stream can be played without it. Although an attributes property may have been
        // added to the playlist to prevent undefined references, issue a warning to fix the
        // manifest.
        if (!playlist.attributes.BANDWIDTH) $cb03b711053a4297$var$log.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
    }
};
/**
 * Adds resolvedUri properties to each media group.
 *
 * @param {Object} main
 *        The main playlist
 */ const $cb03b711053a4297$var$resolveMediaGroupUris = (main)=>{
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties)=>{
        if (properties.uri) properties.resolvedUri = $cb03b711053a4297$var$resolveUrl(main.uri, properties.uri);
    });
};
/**
 * Creates a main playlist wrapper to insert a sole media playlist into.
 *
 * @param {Object} media
 *        Media playlist
 * @param {string} uri
 *        The media URI
 *
 * @return {Object}
 *         main playlist
 */ const $cb03b711053a4297$var$mainForMedia = (media, uri)=>{
    const id = $cb03b711053a4297$var$createPlaylistID(0, uri);
    const main = {
        mediaGroups: {
            "AUDIO": {},
            "VIDEO": {},
            "CLOSED-CAPTIONS": {},
            "SUBTITLES": {}
        },
        uri: (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href,
        resolvedUri: (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href,
        playlists: [
            {
                uri: uri,
                id: id,
                resolvedUri: uri,
                // m3u8-parser does not attach an attributes property to media playlists so make
                // sure that the property is attached to avoid undefined reference errors
                attributes: {}
            }
        ]
    }; // set up ID reference
    main.playlists[id] = main.playlists[0]; // URI reference added for backwards compatibility
    main.playlists[uri] = main.playlists[0];
    return main;
};
/**
 * Does an in-place update of the main manifest to add updated playlist URI references
 * as well as other properties needed by VHS that aren't included by the parser.
 *
 * @param {Object} main
 *        main manifest object
 * @param {string} uri
 *        The source URI
 * @param {function} createGroupID
 *        A function to determine how to create the groupID for mediaGroups
 */ const $cb03b711053a4297$var$addPropertiesToMain = (main, uri, createGroupID = $cb03b711053a4297$var$groupID)=>{
    main.uri = uri;
    for(let i = 0; i < main.playlists.length; i++)if (!main.playlists[i].uri) {
        // Set up phony URIs for the playlists since playlists are referenced by their URIs
        // throughout VHS, but some formats (e.g., DASH) don't have external URIs
        // TODO: consider adding dummy URIs in mpd-parser
        const phonyUri = `placeholder-uri-${i}`;
        main.playlists[i].uri = phonyUri;
    }
    const audioOnlyMain = $cb03b711053a4297$var$isAudioOnly(main);
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        // add a playlist array under properties
        if (!properties.playlists || !properties.playlists.length) {
            // If the manifest is audio only and this media group does not have a uri, check
            // if the media group is located in the main list of playlists. If it is, don't add
            // placeholder properties as it shouldn't be considered an alternate audio track.
            if (audioOnlyMain && mediaType === "AUDIO" && !properties.uri) for(let i = 0; i < main.playlists.length; i++){
                const p = main.playlists[i];
                if (p.attributes && p.attributes.AUDIO && p.attributes.AUDIO === groupKey) return;
            }
            properties.playlists = [
                (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, properties)
            ];
        }
        properties.playlists.forEach(function(p, i) {
            const groupId = createGroupID(mediaType, groupKey, labelKey, p);
            const id = $cb03b711053a4297$var$createPlaylistID(i, groupId);
            if (p.uri) p.resolvedUri = p.resolvedUri || $cb03b711053a4297$var$resolveUrl(main.uri, p.uri);
            else {
                // DEPRECATED, this has been added to prevent a breaking change.
                // previously we only ever had a single media group playlist, so
                // we mark the first playlist uri without prepending the index as we used to
                // ideally we would do all of the playlists the same way.
                p.uri = i === 0 ? groupId : id; // don't resolve a placeholder uri to an absolute url, just use
                // the placeholder again
                p.resolvedUri = p.uri;
            }
            p.id = p.id || id; // add an empty attributes object, all playlists are
            // expected to have this.
            p.attributes = p.attributes || {}; // setup ID and URI references (URI for backwards compatibility)
            main.playlists[p.id] = p;
            main.playlists[p.uri] = p;
        });
    });
    $cb03b711053a4297$var$setupMediaPlaylists(main);
    $cb03b711053a4297$var$resolveMediaGroupUris(main);
};
class $cb03b711053a4297$var$DateRangesStorage {
    constructor(){
        this.offset_ = null;
        this.pendingDateRanges_ = new Map();
        this.processedDateRanges_ = new Map();
    }
    setOffset(segments = []) {
        // already set
        if (this.offset_ !== null) return;
         // no segment to process
        if (!segments.length) return;
        const [firstSegment] = segments; // no program date time
        if (firstSegment.programDateTime === undefined) return;
         // Set offset as ProgramDateTime for the very first segment of the very first playlist load:
        this.offset_ = firstSegment.programDateTime / 1000;
    }
    setPendingDateRanges(dateRanges = []) {
        if (!dateRanges.length) return;
        const [dateRange] = dateRanges;
        const startTime = dateRange.startDate.getTime();
        this.trimProcessedDateRanges_(startTime);
        this.pendingDateRanges_ = dateRanges.reduce((map, pendingDateRange)=>{
            map.set(pendingDateRange.id, pendingDateRange);
            return map;
        }, new Map());
    }
    processDateRange(dateRange) {
        this.pendingDateRanges_.delete(dateRange.id);
        this.processedDateRanges_.set(dateRange.id, dateRange);
    }
    getDateRangesToProcess() {
        if (this.offset_ === null) return [];
        const dateRangeClasses = {};
        const dateRangesToProcess = [];
        this.pendingDateRanges_.forEach((dateRange, id)=>{
            if (this.processedDateRanges_.has(id)) return;
            dateRange.startTime = dateRange.startDate.getTime() / 1000 - this.offset_;
            dateRange.processDateRange = ()=>this.processDateRange(dateRange);
            dateRangesToProcess.push(dateRange);
            if (!dateRange.class) return;
            if (dateRangeClasses[dateRange.class]) {
                const length = dateRangeClasses[dateRange.class].push(dateRange);
                dateRange.classListIndex = length - 1;
            } else {
                dateRangeClasses[dateRange.class] = [
                    dateRange
                ];
                dateRange.classListIndex = 0;
            }
        });
        for (const dateRange of dateRangesToProcess){
            const classList = dateRangeClasses[dateRange.class] || [];
            if (dateRange.endDate) dateRange.endTime = dateRange.endDate.getTime() / 1000 - this.offset_;
            else if (dateRange.endOnNext && classList[dateRange.classListIndex + 1]) dateRange.endTime = classList[dateRange.classListIndex + 1].startTime;
            else if (dateRange.duration) dateRange.endTime = dateRange.startTime + dateRange.duration;
            else if (dateRange.plannedDuration) dateRange.endTime = dateRange.startTime + dateRange.plannedDuration;
            else dateRange.endTime = dateRange.startTime;
        }
        return dateRangesToProcess;
    }
    trimProcessedDateRanges_(startTime) {
        const copy = new Map(this.processedDateRanges_);
        copy.forEach((dateRange, id)=>{
            if (dateRange.startDate.getTime() < startTime) this.processedDateRanges_.delete(id);
        });
    }
}
/**
 * @file playlist-loader.js
 *
 * A state machine that manages the loading, caching, and updating of
 * M3U8 playlists.
 *
 */ const { EventTarget: $cb03b711053a4297$var$EventTarget$1 } = $cb03b711053a4297$export$2e2bcd8739ae039;
const $cb03b711053a4297$var$addLLHLSQueryDirectives = (uri, media)=>{
    if (media.endList || !media.serverControl) return uri;
    const parameters = {};
    if (media.serverControl.canBlockReload) {
        const { preloadSegment: preloadSegment } = media; // next msn is a zero based value, length is not.
        let nextMSN = media.mediaSequence + media.segments.length; // If preload segment has parts then it is likely
        // that we are going to request a part of that preload segment.
        // the logic below is used to determine that.
        if (preloadSegment) {
            const parts = preloadSegment.parts || []; // _HLS_part is a zero based index
            const nextPart = $cb03b711053a4297$var$getKnownPartCount(media) - 1; // if nextPart is > -1 and not equal to just the
            // length of parts, then we know we had part preload hints
            // and we need to add the _HLS_part= query
            if (nextPart > -1 && nextPart !== parts.length - 1) // add existing parts to our preload hints
            // eslint-disable-next-line
            parameters._HLS_part = nextPart;
             // this if statement makes sure that we request the msn
            // of the preload segment if:
            // 1. the preload segment had parts (and was not yet a full segment)
            //    but was added to our segments array
            // 2. the preload segment had preload hints for parts that are not in
            //    the manifest yet.
            // in all other cases we want the segment after the preload segment
            // which will be given by using media.segments.length because it is 1 based
            // rather than 0 based.
            if (nextPart > -1 || parts.length) nextMSN--;
        } // add _HLS_msn= in front of any _HLS_part query
        // eslint-disable-next-line
        parameters._HLS_msn = nextMSN;
    }
    if (media.serverControl && media.serverControl.canSkipUntil) // add _HLS_skip= infront of all other queries.
    // eslint-disable-next-line
    parameters._HLS_skip = media.serverControl.canSkipDateranges ? "v2" : "YES";
    if (Object.keys(parameters).length) {
        const parsedUri = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(uri);
        [
            "_HLS_skip",
            "_HLS_msn",
            "_HLS_part"
        ].forEach(function(name) {
            if (!parameters.hasOwnProperty(name)) return;
            parsedUri.searchParams.set(name, parameters[name]);
        });
        uri = parsedUri.toString();
    }
    return uri;
};
/**
 * Returns a new segment object with properties and
 * the parts array merged.
 *
 * @param {Object} a the old segment
 * @param {Object} b the new segment
 *
 * @return {Object} the merged segment
 */ const $cb03b711053a4297$var$updateSegment = (a, b)=>{
    if (!a) return b;
    const result = $cb03b711053a4297$var$merge(a, b); // if only the old segment has preload hints
    // and the new one does not, remove preload hints.
    if (a.preloadHints && !b.preloadHints) delete result.preloadHints;
     // if only the old segment has parts
    // then the parts are no longer valid
    if (a.parts && !b.parts) delete result.parts; // if both segments have parts
    else if (a.parts && b.parts) {
        for(let i = 0; i < b.parts.length; i++)if (a.parts && a.parts[i]) result.parts[i] = $cb03b711053a4297$var$merge(a.parts[i], b.parts[i]);
    } // set skipped to false for segments that have
    // have had information merged from the old segment.
    if (!a.skipped && b.skipped) result.skipped = false;
     // set preload to false for segments that have
    // had information added in the new segment.
    if (a.preload && !b.preload) result.preload = false;
    return result;
};
/**
 * Returns a new array of segments that is the result of merging
 * properties from an older list of segments onto an updated
 * list. No properties on the updated playlist will be ovewritten.
 *
 * @param {Array} original the outdated list of segments
 * @param {Array} update the updated list of segments
 * @param {number=} offset the index of the first update
 * segment in the original segment list. For non-live playlists,
 * this should always be zero and does not need to be
 * specified. For live playlists, it should be the difference
 * between the media sequence numbers in the original and updated
 * playlists.
 * @return {Array} a list of merged segment objects
 */ const $cb03b711053a4297$var$updateSegments = (original, update, offset)=>{
    const oldSegments = original.slice();
    const newSegments = update.slice();
    offset = offset || 0;
    const result = [];
    let currentMap;
    for(let newIndex = 0; newIndex < newSegments.length; newIndex++){
        const oldSegment = oldSegments[newIndex + offset];
        const newSegment = newSegments[newIndex];
        if (oldSegment) {
            currentMap = oldSegment.map || currentMap;
            result.push($cb03b711053a4297$var$updateSegment(oldSegment, newSegment));
        } else {
            // carry over map to new segment if it is missing
            if (currentMap && !newSegment.map) newSegment.map = currentMap;
            result.push(newSegment);
        }
    }
    return result;
};
const $cb03b711053a4297$var$resolveSegmentUris = (segment, baseUri)=>{
    // preloadSegment will not have a uri at all
    // as the segment isn't actually in the manifest yet, only parts
    if (!segment.resolvedUri && segment.uri) segment.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.uri);
    if (segment.key && !segment.key.resolvedUri) segment.key.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.key.uri);
    if (segment.map && !segment.map.resolvedUri) segment.map.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.map.uri);
    if (segment.map && segment.map.key && !segment.map.key.resolvedUri) segment.map.key.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, segment.map.key.uri);
    if (segment.parts && segment.parts.length) segment.parts.forEach((p)=>{
        if (p.resolvedUri) return;
        p.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, p.uri);
    });
    if (segment.preloadHints && segment.preloadHints.length) segment.preloadHints.forEach((p)=>{
        if (p.resolvedUri) return;
        p.resolvedUri = $cb03b711053a4297$var$resolveUrl(baseUri, p.uri);
    });
};
const $cb03b711053a4297$var$getAllSegments = function(media) {
    const segments = media.segments || [];
    const preloadSegment = media.preloadSegment; // a preloadSegment with only preloadHints is not currently
    // a usable segment, only include a preloadSegment that has
    // parts.
    if (preloadSegment && preloadSegment.parts && preloadSegment.parts.length) {
        // if preloadHints has a MAP that means that the
        // init segment is going to change. We cannot use any of the parts
        // from this preload segment.
        if (preloadSegment.preloadHints) for(let i = 0; i < preloadSegment.preloadHints.length; i++){
            if (preloadSegment.preloadHints[i].type === "MAP") return segments;
        }
         // set the duration for our preload segment to target duration.
        preloadSegment.duration = media.targetDuration;
        preloadSegment.preload = true;
        segments.push(preloadSegment);
    }
    return segments;
}; // consider the playlist unchanged if the playlist object is the same or
// the number of segments is equal, the media sequence number is unchanged,
// and this playlist hasn't become the end of the playlist
const $cb03b711053a4297$var$isPlaylistUnchanged = (a, b)=>a === b || a.segments && b.segments && a.segments.length === b.segments.length && a.endList === b.endList && a.mediaSequence === b.mediaSequence && a.preloadSegment === b.preloadSegment;
/**
  * Returns a new main playlist that is the result of merging an
  * updated media playlist into the original version. If the
  * updated media playlist does not match any of the playlist
  * entries in the original main playlist, null is returned.
  *
  * @param {Object} main a parsed main M3U8 object
  * @param {Object} media a parsed media M3U8 object
  * @return {Object} a new object that represents the original
  * main playlist with the updated media playlist merged in, or
  * null if the merge produced no change.
  */ const $cb03b711053a4297$var$updateMain$1 = (main, newMedia, unchangedCheck = $cb03b711053a4297$var$isPlaylistUnchanged)=>{
    const result = $cb03b711053a4297$var$merge(main, {});
    const oldMedia = result.playlists[newMedia.id];
    if (!oldMedia) return null;
    if (unchangedCheck(oldMedia, newMedia)) return null;
    newMedia.segments = $cb03b711053a4297$var$getAllSegments(newMedia);
    const mergedPlaylist = $cb03b711053a4297$var$merge(oldMedia, newMedia); // always use the new media's preload segment
    if (mergedPlaylist.preloadSegment && !newMedia.preloadSegment) delete mergedPlaylist.preloadSegment;
     // if the update could overlap existing segment information, merge the two segment lists
    if (oldMedia.segments) {
        if (newMedia.skip) {
            newMedia.segments = newMedia.segments || []; // add back in objects for skipped segments, so that we merge
            // old properties into the new segments
            for(let i = 0; i < newMedia.skip.skippedSegments; i++)newMedia.segments.unshift({
                skipped: true
            });
        }
        mergedPlaylist.segments = $cb03b711053a4297$var$updateSegments(oldMedia.segments, newMedia.segments, newMedia.mediaSequence - oldMedia.mediaSequence);
    } // resolve any segment URIs to prevent us from having to do it later
    mergedPlaylist.segments.forEach((segment)=>{
        $cb03b711053a4297$var$resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
    }); // TODO Right now in the playlists array there are two references to each playlist, one
    // that is referenced by index, and one by URI. The index reference may no longer be
    // necessary.
    for(let i = 0; i < result.playlists.length; i++)if (result.playlists[i].id === newMedia.id) result.playlists[i] = mergedPlaylist;
    result.playlists[newMedia.id] = mergedPlaylist; // URI reference added for backwards compatibility
    result.playlists[newMedia.uri] = mergedPlaylist; // update media group playlist references.
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        if (!properties.playlists) return;
        for(let i = 0; i < properties.playlists.length; i++)if (newMedia.id === properties.playlists[i].id) properties.playlists[i] = mergedPlaylist;
    });
    return result;
};
/**
 * Calculates the time to wait before refreshing a live playlist
 *
 * @param {Object} media
 *        The current media
 * @param {boolean} update
 *        True if there were any updates from the last refresh, false otherwise
 * @return {number}
 *         The time in ms to wait before refreshing the live playlist
 */ const $cb03b711053a4297$var$refreshDelay = (media, update)=>{
    const segments = media.segments || [];
    const lastSegment = segments[segments.length - 1];
    const lastPart = lastSegment && lastSegment.parts && lastSegment.parts[lastSegment.parts.length - 1];
    const lastDuration = lastPart && lastPart.duration || lastSegment && lastSegment.duration;
    if (update && lastDuration) return lastDuration * 1000;
     // if the playlist is unchanged since the last reload or last segment duration
    // cannot be determined, try again after half the target duration
    return (media.partTargetDuration || media.targetDuration || 10) * 500;
};
/**
 * Load a playlist from a remote location
 *
 * @class PlaylistLoader
 * @extends Stream
 * @param {string|Object} src url or object of manifest
 * @param {boolean} withCredentials the withCredentials xhr option
 * @class
 */ class $cb03b711053a4297$var$PlaylistLoader extends $cb03b711053a4297$var$EventTarget$1 {
    constructor(src, vhs, options = {}){
        super();
        if (!src) throw new Error("A non-empty playlist URL or object is required");
        this.logger_ = $cb03b711053a4297$var$logger("PlaylistLoader");
        const { withCredentials: withCredentials = false } = options;
        this.src = src;
        this.vhs_ = vhs;
        this.withCredentials = withCredentials;
        this.addDateRangesToTextTrack_ = options.addDateRangesToTextTrack;
        const vhsOptions = vhs.options_;
        this.customTagParsers = vhsOptions && vhsOptions.customTagParsers || [];
        this.customTagMappers = vhsOptions && vhsOptions.customTagMappers || [];
        this.llhls = vhsOptions && vhsOptions.llhls;
        this.dateRangesStorage_ = new $cb03b711053a4297$var$DateRangesStorage(); // initialize the loader state
        this.state = "HAVE_NOTHING"; // live playlist staleness timeout
        this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this);
        this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_);
        this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
    }
    handleLoadedPlaylist_() {
        const mediaPlaylist = this.media();
        if (!mediaPlaylist) return;
        this.dateRangesStorage_.setOffset(mediaPlaylist.segments);
        this.dateRangesStorage_.setPendingDateRanges(mediaPlaylist.dateRanges);
        const availableDateRanges = this.dateRangesStorage_.getDateRangesToProcess();
        if (!availableDateRanges.length || !this.addDateRangesToTextTrack_) return;
        this.addDateRangesToTextTrack_(availableDateRanges);
    }
    handleMediaupdatetimeout_() {
        if (this.state !== "HAVE_METADATA") // only refresh the media playlist if no other activity is going on
        return;
        const media = this.media();
        let uri = $cb03b711053a4297$var$resolveUrl(this.main.uri, media.uri);
        if (this.llhls) uri = $cb03b711053a4297$var$addLLHLSQueryDirectives(uri, media);
        this.state = "HAVE_CURRENT_METADATA";
        this.request = this.vhs_.xhr({
            uri: uri,
            withCredentials: this.withCredentials
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            if (error) return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
            this.haveMetadata({
                playlistString: this.request.responseText,
                url: this.media().uri,
                id: this.media().id
            });
        });
    }
    playlistRequestError(xhr, playlist, startingState) {
        const { uri: uri, id: id } = playlist; // any in-flight request is now finished
        this.request = null;
        if (startingState) this.state = startingState;
        this.error = {
            playlist: this.main.playlists[id],
            status: xhr.status,
            message: `HLS playlist request error at URL: ${uri}.`,
            responseText: xhr.responseText,
            code: xhr.status >= 500 ? 4 : 2
        };
        this.trigger("error");
    }
    parseManifest_({ url: url, manifestString: manifestString }) {
        return $cb03b711053a4297$var$parseManifest({
            onwarn: ({ message: message })=>this.logger_(`m3u8-parser warn for ${url}: ${message}`),
            oninfo: ({ message: message })=>this.logger_(`m3u8-parser info for ${url}: ${message}`),
            manifestString: manifestString,
            customTagParsers: this.customTagParsers,
            customTagMappers: this.customTagMappers,
            llhls: this.llhls
        });
    }
    /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */ haveMetadata({ playlistString: playlistString, playlistObject: playlistObject, url: url, id: id }) {
        // any in-flight request is now finished
        this.request = null;
        this.state = "HAVE_METADATA";
        const playlist = playlistObject || this.parseManifest_({
            url: url,
            manifestString: playlistString
        });
        playlist.lastRequest = Date.now();
        $cb03b711053a4297$var$setupMediaPlaylist({
            playlist: playlist,
            uri: url,
            id: id
        }); // merge this playlist into the main manifest
        const update = $cb03b711053a4297$var$updateMain$1(this.main, playlist);
        this.targetDuration = playlist.partTargetDuration || playlist.targetDuration;
        this.pendingMedia_ = null;
        if (update) {
            this.main = update;
            this.media_ = this.main.playlists[id];
        } else this.trigger("playlistunchanged");
        this.updateMediaUpdateTimeout_($cb03b711053a4297$var$refreshDelay(this.media(), !!update));
        this.trigger("loadedplaylist");
    }
    /**
    * Abort any outstanding work and clean up.
    */ dispose() {
        this.trigger("dispose");
        this.stopRequest();
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.finalRenditionTimeout);
        this.dateRangesStorage_ = new $cb03b711053a4297$var$DateRangesStorage();
        this.off();
    }
    stopRequest() {
        if (this.request) {
            const oldRequest = this.request;
            this.request = null;
            oldRequest.onreadystatechange = null;
            oldRequest.abort();
        }
    }
    /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */ media(playlist, shouldDelay) {
        // getter
        if (!playlist) return this.media_;
         // setter
        if (this.state === "HAVE_NOTHING") throw new Error("Cannot switch media playlist from " + this.state);
         // find the playlist object if the target playlist has been
        // specified by URI
        if (typeof playlist === "string") {
            if (!this.main.playlists[playlist]) throw new Error("Unknown playlist URI: " + playlist);
            playlist = this.main.playlists[playlist];
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.finalRenditionTimeout);
        if (shouldDelay) {
            const delay = (playlist.partTargetDuration || playlist.targetDuration) / 2 * 1000 || 5000;
            this.finalRenditionTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.media.bind(this, playlist, false), delay);
            return;
        }
        const startingState = this.state;
        const mediaChange = !this.media_ || playlist.id !== this.media_.id;
        const mainPlaylistRef = this.main.playlists[playlist.id]; // switch to fully loaded playlists immediately
        if (mainPlaylistRef && mainPlaylistRef.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
        // media playlist or, for the case of demuxed audio, a resolved audio media group)
        playlist.endList && playlist.segments.length) {
            // abort outstanding playlist requests
            if (this.request) {
                this.request.onreadystatechange = null;
                this.request.abort();
                this.request = null;
            }
            this.state = "HAVE_METADATA";
            this.media_ = playlist; // trigger media change if the active media has been updated
            if (mediaChange) {
                this.trigger("mediachanging");
                if (startingState === "HAVE_MAIN_MANIFEST") // The initial playlist was a main manifest, and the first media selected was
                // also provided (in the form of a resolved playlist object) as part of the
                // source object (rather than just a URL). Therefore, since the media playlist
                // doesn't need to be requested, loadedmetadata won't trigger as part of the
                // normal flow, and needs an explicit trigger here.
                this.trigger("loadedmetadata");
                else this.trigger("mediachange");
            }
            return;
        } // We update/set the timeout here so that live playlists
        // that are not a media change will "start" the loader as expected.
        // We expect that this function will start the media update timeout
        // cycle again. This also prevents a playlist switch failure from
        // causing us to stall during live.
        this.updateMediaUpdateTimeout_($cb03b711053a4297$var$refreshDelay(playlist, true)); // switching to the active playlist is a no-op
        if (!mediaChange) return;
        this.state = "SWITCHING_MEDIA"; // there is already an outstanding playlist request
        if (this.request) {
            if (playlist.resolvedUri === this.request.url) // requesting to switch to the same playlist multiple times
            // has no effect after the first
            return;
            this.request.onreadystatechange = null;
            this.request.abort();
            this.request = null;
        } // request the new playlist
        if (this.media_) this.trigger("mediachanging");
        this.pendingMedia_ = playlist;
        this.request = this.vhs_.xhr({
            uri: playlist.resolvedUri,
            withCredentials: this.withCredentials
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            playlist.lastRequest = Date.now();
            playlist.resolvedUri = $cb03b711053a4297$var$resolveManifestRedirect(playlist.resolvedUri, req);
            if (error) return this.playlistRequestError(this.request, playlist, startingState);
            this.haveMetadata({
                playlistString: req.responseText,
                url: playlist.uri,
                id: playlist.id
            }); // fire loadedmetadata the first time a media playlist is loaded
            if (startingState === "HAVE_MAIN_MANIFEST") this.trigger("loadedmetadata");
            else this.trigger("mediachange");
        });
    }
    /**
   * pause loading of the playlist
   */ pause() {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        }
        this.stopRequest();
        if (this.state === "HAVE_NOTHING") // If we pause the loader before any data has been retrieved, its as if we never
        // started, so reset to an unstarted state.
        this.started = false;
         // Need to restore state now that no activity is happening
        if (this.state === "SWITCHING_MEDIA") {
            // if the loader was in the process of switching media, it should either return to
            // HAVE_MAIN_MANIFEST or HAVE_METADATA depending on if the loader has loaded a media
            // playlist yet. This is determined by the existence of loader.media_
            if (this.media_) this.state = "HAVE_METADATA";
            else this.state = "HAVE_MAIN_MANIFEST";
        } else if (this.state === "HAVE_CURRENT_METADATA") this.state = "HAVE_METADATA";
    }
    /**
   * start loading of the playlist
   */ load(shouldDelay) {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        }
        const media = this.media();
        if (shouldDelay) {
            const delay = media ? (media.partTargetDuration || media.targetDuration) / 2 * 1000 : 5000;
            this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                this.mediaUpdateTimeout = null;
                this.load();
            }, delay);
            return;
        }
        if (!this.started) {
            this.start();
            return;
        }
        if (media && !media.endList) this.trigger("mediaupdatetimeout");
        else this.trigger("loadedplaylist");
    }
    updateMediaUpdateTimeout_(delay) {
        if (this.mediaUpdateTimeout) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
            this.mediaUpdateTimeout = null;
        } // we only have use mediaupdatetimeout for live playlists.
        if (!this.media() || this.media().endList) return;
        this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            this.mediaUpdateTimeout = null;
            this.trigger("mediaupdatetimeout");
            this.updateMediaUpdateTimeout_(delay);
        }, delay);
    }
    /**
   * start loading of the playlist
   */ start() {
        this.started = true;
        if (typeof this.src === "object") {
            // in the case of an entirely constructed manifest object (meaning there's no actual
            // manifest on a server), default the uri to the page's href
            if (!this.src.uri) this.src.uri = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href;
             // resolvedUri is added on internally after the initial request. Since there's no
            // request for pre-resolved manifests, add on resolvedUri here.
            this.src.resolvedUri = this.src.uri; // Since a manifest object was passed in as the source (instead of a URL), the first
            // request can be skipped (since the top level of the manifest, at a minimum, is
            // already available as a parsed manifest object). However, if the manifest object
            // represents a main playlist, some media playlists may need to be resolved before
            // the starting segment list is available. Therefore, go directly to setup of the
            // initial playlist, and let the normal flow continue from there.
            //
            // Note that the call to setup is asynchronous, as other sections of VHS may assume
            // that the first request is asynchronous.
            setTimeout(()=>{
                this.setupInitialPlaylist(this.src);
            }, 0);
            return;
        } // request the specified URL
        this.request = this.vhs_.xhr({
            uri: this.src,
            withCredentials: this.withCredentials
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
             // clear the loader's request reference
            this.request = null;
            if (error) {
                this.error = {
                    status: req.status,
                    message: `HLS playlist request error at URL: ${this.src}.`,
                    responseText: req.responseText,
                    // MEDIA_ERR_NETWORK
                    code: 2
                };
                if (this.state === "HAVE_NOTHING") this.started = false;
                return this.trigger("error");
            }
            this.src = $cb03b711053a4297$var$resolveManifestRedirect(this.src, req);
            const manifest = this.parseManifest_({
                manifestString: req.responseText,
                url: this.src
            });
            this.setupInitialPlaylist(manifest);
        });
    }
    srcUri() {
        return typeof this.src === "string" ? this.src : this.src.uri;
    }
    /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */ setupInitialPlaylist(manifest) {
        this.state = "HAVE_MAIN_MANIFEST";
        if (manifest.playlists) {
            this.main = manifest;
            $cb03b711053a4297$var$addPropertiesToMain(this.main, this.srcUri()); // If the initial main playlist has playlists wtih segments already resolved,
            // then resolve URIs in advance, as they are usually done after a playlist request,
            // which may not happen if the playlist is resolved.
            manifest.playlists.forEach((playlist)=>{
                playlist.segments = $cb03b711053a4297$var$getAllSegments(playlist);
                playlist.segments.forEach((segment)=>{
                    $cb03b711053a4297$var$resolveSegmentUris(segment, playlist.resolvedUri);
                });
            });
            this.trigger("loadedplaylist");
            if (!this.request) // no media playlist was specifically selected so start
            // from the first listed one
            this.media(this.main.playlists[0]);
            return;
        } // In order to support media playlists passed in as vhs-json, the case where the uri
        // is not provided as part of the manifest should be considered, and an appropriate
        // default used.
        const uri = this.srcUri() || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).location.href;
        this.main = $cb03b711053a4297$var$mainForMedia(manifest, uri);
        this.haveMetadata({
            playlistObject: manifest,
            url: uri,
            id: this.main.playlists[0].id
        });
        this.trigger("loadedmetadata");
    }
}
/**
 * @file xhr.js
 */ const { xhr: $cb03b711053a4297$var$videojsXHR } = $cb03b711053a4297$export$2e2bcd8739ae039;
const $cb03b711053a4297$var$callbackWrapper = function(request, error, response, callback) {
    const reqResponse = request.responseType === "arraybuffer" ? request.response : request.responseText;
    if (!error && reqResponse) {
        request.responseTime = Date.now();
        request.roundTripTime = request.responseTime - request.requestTime;
        request.bytesReceived = reqResponse.byteLength || reqResponse.length;
        if (!request.bandwidth) request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8000);
    }
    if (response.headers) request.responseHeaders = response.headers;
     // videojs.xhr now uses a specific code on the error
    // object to signal that a request has timed out instead
    // of setting a boolean on the request object
    if (error && error.code === "ETIMEDOUT") request.timedout = true;
     // videojs.xhr no longer considers status codes outside of 200 and 0
    // (for file uris) to be errors, but the old XHR did, so emulate that
    // behavior. Status 206 may be used in response to byterange requests.
    if (!error && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) error = new Error("XHR Failed with a response of: " + (request && (reqResponse || request.responseText)));
    callback(error, request);
};
/**
 * Iterates over the request hooks Set and calls them in order
 *
 * @param {Set} hooks the hook Set to iterate over
 * @param {Object} options the request options to pass to the xhr wrapper
 * @return the callback hook function return value, the modified or new options Object.
 */ const $cb03b711053a4297$var$callAllRequestHooks = (requestSet, options)=>{
    if (!requestSet || !requestSet.size) return;
    let newOptions = options;
    requestSet.forEach((requestCallback)=>{
        newOptions = requestCallback(newOptions);
    });
    return newOptions;
};
/**
 * Iterates over the response hooks Set and calls them in order.
 *
 * @param {Set} hooks the hook Set to iterate over
 * @param {Object} request the xhr request object
 * @param {Object} error the xhr error object
 * @param {Object} response the xhr response object
 */ const $cb03b711053a4297$var$callAllResponseHooks = (responseSet, request, error, response)=>{
    if (!responseSet || !responseSet.size) return;
    responseSet.forEach((responseCallback)=>{
        responseCallback(request, error, response);
    });
};
const $cb03b711053a4297$var$xhrFactory = function() {
    const xhr = function XhrFunction(options, callback) {
        // Add a default timeout
        options = $cb03b711053a4297$var$merge({
            timeout: 45e3
        }, options); // Allow an optional user-specified function to modify the option
        // object before we construct the xhr request
        // TODO: Remove beforeRequest in the next major release.
        const beforeRequest = XhrFunction.beforeRequest || $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr.beforeRequest; // onRequest and onResponse hooks as a Set, at either the player or global level.
        // TODO: new Set added here for beforeRequest alias. Remove this when beforeRequest is removed.
        const _requestCallbackSet = XhrFunction._requestCallbackSet || $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr._requestCallbackSet || new Set();
        const _responseCallbackSet = XhrFunction._responseCallbackSet || $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr._responseCallbackSet;
        if (beforeRequest && typeof beforeRequest === "function") {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("beforeRequest is deprecated, use onRequest instead.");
            _requestCallbackSet.add(beforeRequest);
        } // Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
        // TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
        const xhrMethod = $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr.original === true ? $cb03b711053a4297$var$videojsXHR : $cb03b711053a4297$export$2e2bcd8739ae039.Vhs.xhr; // call all registered onRequest hooks, assign new options.
        const beforeRequestOptions = $cb03b711053a4297$var$callAllRequestHooks(_requestCallbackSet, options); // Remove the beforeRequest function from the hooks set so stale beforeRequest functions are not called.
        _requestCallbackSet.delete(beforeRequest); // xhrMethod will call XMLHttpRequest.open and XMLHttpRequest.send
        const request = xhrMethod(beforeRequestOptions || options, function(error, response) {
            // call all registered onResponse hooks
            $cb03b711053a4297$var$callAllResponseHooks(_responseCallbackSet, request, error, response);
            return $cb03b711053a4297$var$callbackWrapper(request, error, response, callback);
        });
        const originalAbort = request.abort;
        request.abort = function() {
            request.aborted = true;
            return originalAbort.apply(request, arguments);
        };
        request.uri = options.uri;
        request.requestTime = Date.now();
        return request;
    };
    xhr.original = true;
    return xhr;
};
/**
 * Turns segment byterange into a string suitable for use in
 * HTTP Range requests
 *
 * @param {Object} byterange - an object with two values defining the start and end
 *                             of a byte-range
 */ const $cb03b711053a4297$var$byterangeStr = function(byterange) {
    // `byterangeEnd` is one less than `offset + length` because the HTTP range
    // header uses inclusive ranges
    let byterangeEnd;
    const byterangeStart = byterange.offset;
    if (typeof byterange.offset === "bigint" || typeof byterange.length === "bigint") byterangeEnd = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.offset) + (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(byterange.length) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(1);
    else byterangeEnd = byterange.offset + byterange.length - 1;
    return "bytes=" + byterangeStart + "-" + byterangeEnd;
};
/**
 * Defines headers for use in the xhr request for a particular segment.
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 */ const $cb03b711053a4297$var$segmentXhrHeaders = function(segment) {
    const headers = {};
    if (segment.byterange) headers.Range = $cb03b711053a4297$var$byterangeStr(segment.byterange);
    return headers;
};
/**
 * @file bin-utils.js
 */ /**
 * convert a TimeRange to text
 *
 * @param {TimeRange} range the timerange to use for conversion
 * @param {number} i the iterator on the range to convert
 * @return {string} the range in string format
 */ const $cb03b711053a4297$var$textRange = function(range, i) {
    return range.start(i) + "-" + range.end(i);
};
/**
 * format a number as hex string
 *
 * @param {number} e The number
 * @param {number} i the iterator
 * @return {string} the hex formatted number as a string
 */ const $cb03b711053a4297$var$formatHexString = function(e, i) {
    const value = e.toString(16);
    return "00".substring(0, 2 - value.length) + value + (i % 2 ? " " : "");
};
const $cb03b711053a4297$var$formatAsciiString = function(e) {
    if (e >= 0x20 && e < 0x7e) return String.fromCharCode(e);
    return ".";
};
/**
 * Creates an object for sending to a web worker modifying properties that are TypedArrays
 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
 *
 * @param {Object} message
 *        Object of properties and values to send to the web worker
 * @return {Object}
 *         Modified message with TypedArray values expanded
 * @function createTransferableMessage
 */ const $cb03b711053a4297$var$createTransferableMessage = function(message) {
    const transferable = {};
    Object.keys(message).forEach((key)=>{
        const value = message[key];
        if ((0, $4bd18e93e919945b$export$ef047080f6507ccc)(value)) transferable[key] = {
            bytes: value.buffer,
            byteOffset: value.byteOffset,
            byteLength: value.byteLength
        };
        else transferable[key] = value;
    });
    return transferable;
};
/**
 * Returns a unique string identifier for a media initialization
 * segment.
 *
 * @param {Object} initSegment
 *        the init segment object.
 *
 * @return {string} the generated init segment id
 */ const $cb03b711053a4297$var$initSegmentId = function(initSegment) {
    const byterange = initSegment.byterange || {
        length: Infinity,
        offset: 0
    };
    return [
        byterange.length,
        byterange.offset,
        initSegment.resolvedUri
    ].join(",");
};
/**
 * Returns a unique string identifier for a media segment key.
 *
 * @param {Object} key the encryption key
 * @return {string} the unique id for the media segment key.
 */ const $cb03b711053a4297$var$segmentKeyId = function(key) {
    return key.resolvedUri;
};
/**
 * utils to help dump binary data to the console
 *
 * @param {Array|TypedArray} data
 *        data to dump to a string
 *
 * @return {string} the data as a hex string.
 */ const $cb03b711053a4297$var$hexDump = (data)=>{
    const bytes = Array.prototype.slice.call(data);
    const step = 16;
    let result = "";
    let hex;
    let ascii;
    for(let j = 0; j < bytes.length / step; j++){
        hex = bytes.slice(j * step, j * step + step).map($cb03b711053a4297$var$formatHexString).join("");
        ascii = bytes.slice(j * step, j * step + step).map($cb03b711053a4297$var$formatAsciiString).join("");
        result += hex + " " + ascii + "\n";
    }
    return result;
};
const $cb03b711053a4297$var$tagDump = ({ bytes: bytes })=>$cb03b711053a4297$var$hexDump(bytes);
const $cb03b711053a4297$var$textRanges = (ranges)=>{
    let result = "";
    let i;
    for(i = 0; i < ranges.length; i++)result += $cb03b711053a4297$var$textRange(ranges, i) + " ";
    return result;
};
var $cb03b711053a4297$var$utils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createTransferableMessage: $cb03b711053a4297$var$createTransferableMessage,
    initSegmentId: $cb03b711053a4297$var$initSegmentId,
    segmentKeyId: $cb03b711053a4297$var$segmentKeyId,
    hexDump: $cb03b711053a4297$var$hexDump,
    tagDump: $cb03b711053a4297$var$tagDump,
    textRanges: $cb03b711053a4297$var$textRanges
});
// TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
// 25% was arbitrarily chosen, and may need to be refined over time.
const $cb03b711053a4297$var$SEGMENT_END_FUDGE_PERCENT = 0.25;
/**
 * Converts a player time (any time that can be gotten/set from player.currentTime(),
 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
 *
 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
 * point" (a point where we have a mapping from program time to player time, with player
 * time being the post transmux start of the segment).
 *
 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
 *
 * @param {number} playerTime the player time
 * @param {Object} segment the segment which contains the player time
 * @return {Date} program time
 */ const $cb03b711053a4297$var$playerTimeToProgramTime = (playerTime, segment)=>{
    if (!segment.dateTimeObject) // Can't convert without an "anchor point" for the program time (i.e., a time that can
    // be used to map the start of a segment with a real world time).
    return null;
    const transmuxerPrependedSeconds = segment.videoTimingInfo.transmuxerPrependedSeconds;
    const transmuxedStart = segment.videoTimingInfo.transmuxedPresentationStart; // get the start of the content from before old content is prepended
    const startOfSegment = transmuxedStart + transmuxerPrependedSeconds;
    const offsetFromSegmentStart = playerTime - startOfSegment;
    return new Date(segment.dateTimeObject.getTime() + offsetFromSegmentStart * 1000);
};
const $cb03b711053a4297$var$originalSegmentVideoDuration = (videoTimingInfo)=>{
    return videoTimingInfo.transmuxedPresentationEnd - videoTimingInfo.transmuxedPresentationStart - videoTimingInfo.transmuxerPrependedSeconds;
};
/**
 * Finds a segment that contains the time requested given as an ISO-8601 string. The
 * returned segment might be an estimate or an accurate match.
 *
 * @param {string} programTime The ISO-8601 programTime to find a match for
 * @param {Object} playlist A playlist object to search within
 */ const $cb03b711053a4297$var$findSegmentForProgramTime = (programTime, playlist)=>{
    // Assumptions:
    //  - verifyProgramDateTimeTags has already been run
    //  - live streams have been started
    let dateTimeObject;
    try {
        dateTimeObject = new Date(programTime);
    } catch (e) {
        return null;
    }
    if (!playlist || !playlist.segments || playlist.segments.length === 0) return null;
    let segment = playlist.segments[0];
    if (dateTimeObject < new Date(segment.dateTimeObject)) // Requested time is before stream start.
    return null;
    for(let i = 0; i < playlist.segments.length - 1; i++){
        segment = playlist.segments[i];
        const nextSegmentStart = new Date(playlist.segments[i + 1].dateTimeObject);
        if (dateTimeObject < nextSegmentStart) break;
    }
    const lastSegment = playlist.segments[playlist.segments.length - 1];
    const lastSegmentStart = lastSegment.dateTimeObject;
    const lastSegmentDuration = lastSegment.videoTimingInfo ? $cb03b711053a4297$var$originalSegmentVideoDuration(lastSegment.videoTimingInfo) : lastSegment.duration + lastSegment.duration * $cb03b711053a4297$var$SEGMENT_END_FUDGE_PERCENT;
    const lastSegmentEnd = new Date(lastSegmentStart.getTime() + lastSegmentDuration * 1000);
    if (dateTimeObject > lastSegmentEnd) // Beyond the end of the stream, or our best guess of the end of the stream.
    return null;
    if (dateTimeObject > new Date(lastSegmentStart)) segment = lastSegment;
    return {
        segment: segment,
        estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : $cb03b711053a4297$var$Playlist.duration(playlist, playlist.mediaSequence + playlist.segments.indexOf(segment)),
        // Although, given that all segments have accurate date time objects, the segment
        // selected should be accurate, unless the video has been transmuxed at some point
        // (determined by the presence of the videoTimingInfo object), the segment's "player
        // time" (the start time in the player) can't be considered accurate.
        type: segment.videoTimingInfo ? "accurate" : "estimate"
    };
};
/**
 * Finds a segment that contains the given player time(in seconds).
 *
 * @param {number} time The player time to find a match for
 * @param {Object} playlist A playlist object to search within
 */ const $cb03b711053a4297$var$findSegmentForPlayerTime = (time, playlist)=>{
    // Assumptions:
    // - there will always be a segment.duration
    // - we can start from zero
    // - segments are in time order
    if (!playlist || !playlist.segments || playlist.segments.length === 0) return null;
    let segmentEnd = 0;
    let segment;
    for(let i = 0; i < playlist.segments.length; i++){
        segment = playlist.segments[i]; // videoTimingInfo is set after the segment is downloaded and transmuxed, and
        // should contain the most accurate values we have for the segment's player times.
        //
        // Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
        // back to an estimate based on the manifest derived (inaccurate) segment.duration, to
        // calculate an end value.
        segmentEnd = segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationEnd : segmentEnd + segment.duration;
        if (time <= segmentEnd) break;
    }
    const lastSegment = playlist.segments[playlist.segments.length - 1];
    if (lastSegment.videoTimingInfo && lastSegment.videoTimingInfo.transmuxedPresentationEnd < time) // The time requested is beyond the stream end.
    return null;
    if (time > segmentEnd) {
        // The time is within or beyond the last segment.
        //
        // Check to see if the time is beyond a reasonable guess of the end of the stream.
        if (time > segmentEnd + lastSegment.duration * $cb03b711053a4297$var$SEGMENT_END_FUDGE_PERCENT) // Technically, because the duration value is only an estimate, the time may still
        // exist in the last segment, however, there isn't enough information to make even
        // a reasonable estimate.
        return null;
        segment = lastSegment;
    }
    return {
        segment: segment,
        estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : segmentEnd - segment.duration,
        // Because videoTimingInfo is only set after transmux, it is the only way to get
        // accurate timing values.
        type: segment.videoTimingInfo ? "accurate" : "estimate"
    };
};
/**
 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
 * If the offset returned is positive, the programTime occurs after the
 * comparisonTimestamp.
 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
 *
 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
 * @param {string} programTime The programTime as an ISO-8601 string
 * @return {number} offset
 */ const $cb03b711053a4297$var$getOffsetFromTimestamp = (comparisonTimeStamp, programTime)=>{
    let segmentDateTime;
    let programDateTime;
    try {
        segmentDateTime = new Date(comparisonTimeStamp);
        programDateTime = new Date(programTime);
    } catch (e) {}
    const segmentTimeEpoch = segmentDateTime.getTime();
    const programTimeEpoch = programDateTime.getTime();
    return (programTimeEpoch - segmentTimeEpoch) / 1000;
};
/**
 * Checks that all segments in this playlist have programDateTime tags.
 *
 * @param {Object} playlist A playlist object
 */ const $cb03b711053a4297$var$verifyProgramDateTimeTags = (playlist)=>{
    if (!playlist.segments || playlist.segments.length === 0) return false;
    for(let i = 0; i < playlist.segments.length; i++){
        const segment = playlist.segments[i];
        if (!segment.dateTimeObject) return false;
    }
    return true;
};
/**
 * Returns the programTime of the media given a playlist and a playerTime.
 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
 * If the segments containing the time requested have not been buffered yet, an estimate
 * may be returned to the callback.
 *
 * @param {Object} args
 * @param {Object} args.playlist A playlist object to search within
 * @param {number} time A playerTime in seconds
 * @param {Function} callback(err, programTime)
 * @return {string} err.message A detailed error message
 * @return {Object} programTime
 * @return {number} programTime.mediaSeconds The streamTime in seconds
 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
 */ const $cb03b711053a4297$var$getProgramTime = ({ playlist: playlist, time: time, callback: callback })=>{
    if (!callback) throw new Error("getProgramTime: callback must be provided");
    if (!playlist || time === undefined) return callback({
        message: "getProgramTime: playlist and time must be provided"
    });
    const matchedSegment = $cb03b711053a4297$var$findSegmentForPlayerTime(time, playlist);
    if (!matchedSegment) return callback({
        message: "valid programTime was not found"
    });
    if (matchedSegment.type === "estimate") return callback({
        message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
        seekTime: matchedSegment.estimatedStart
    });
    const programTimeObject = {
        mediaSeconds: time
    };
    const programTime = $cb03b711053a4297$var$playerTimeToProgramTime(time, matchedSegment.segment);
    if (programTime) programTimeObject.programDateTime = programTime.toISOString();
    return callback(null, programTimeObject);
};
/**
 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
 *
 * @param {Object} args
 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
 * @param {Object} args.playlist A playlist to look within
 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
 * @param {Function} args.seekTo A method to perform a seek
 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
 * @param {Object} args.tech The tech to seek on
 * @param {Function} args.callback(err, newTime) A callback to return the new time to
 * @return {string} err.message A detailed error message
 * @return {number} newTime The exact time that was seeked to in seconds
 */ const $cb03b711053a4297$var$seekToProgramTime = ({ programTime: programTime, playlist: playlist, retryCount: retryCount = 2, seekTo: seekTo, pauseAfterSeek: pauseAfterSeek = true, tech: tech, callback: callback })=>{
    if (!callback) throw new Error("seekToProgramTime: callback must be provided");
    if (typeof programTime === "undefined" || !playlist || !seekTo) return callback({
        message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
    if (!playlist.endList && !tech.hasStarted_) return callback({
        message: "player must be playing a live stream to start buffering"
    });
    if (!$cb03b711053a4297$var$verifyProgramDateTimeTags(playlist)) return callback({
        message: "programDateTime tags must be provided in the manifest " + playlist.resolvedUri
    });
    const matchedSegment = $cb03b711053a4297$var$findSegmentForProgramTime(programTime, playlist); // no match
    if (!matchedSegment) return callback({
        message: `${programTime} was not found in the stream`
    });
    const segment = matchedSegment.segment;
    const mediaOffset = $cb03b711053a4297$var$getOffsetFromTimestamp(segment.dateTimeObject, programTime);
    if (matchedSegment.type === "estimate") {
        // we've run out of retries
        if (retryCount === 0) return callback({
            message: `${programTime} is not buffered yet. Try again`
        });
        seekTo(matchedSegment.estimatedStart + mediaOffset);
        tech.one("seeked", ()=>{
            $cb03b711053a4297$var$seekToProgramTime({
                programTime: programTime,
                playlist: playlist,
                retryCount: retryCount - 1,
                seekTo: seekTo,
                pauseAfterSeek: pauseAfterSeek,
                tech: tech,
                callback: callback
            });
        });
        return;
    } // Since the segment.start value is determined from the buffered end or ending time
    // of the prior segment, the seekToTime doesn't need to account for any transmuxer
    // modifications.
    const seekToTime = segment.start + mediaOffset;
    const seekedCallback = ()=>{
        return callback(null, tech.currentTime());
    }; // listen for seeked event
    tech.one("seeked", seekedCallback); // pause before seeking as video.js will restore this state
    if (pauseAfterSeek) tech.pause();
    seekTo(seekToTime);
};
// which will only happen if the request is complete.
const $cb03b711053a4297$var$callbackOnCompleted = (request, cb)=>{
    if (request.readyState === 4) return cb();
    return;
};
const $cb03b711053a4297$var$containerRequest = (uri, xhr, cb)=>{
    let bytes = [];
    let id3Offset;
    let finished = false;
    const endRequestAndCallback = function(err, req, type, _bytes) {
        req.abort();
        finished = true;
        return cb(err, req, type, _bytes);
    };
    const progressListener = function(error, request) {
        if (finished) return;
        if (error) return endRequestAndCallback(error, request, "", bytes);
         // grap the new part of content that was just downloaded
        const newPart = request.responseText.substring(bytes && bytes.byteLength || 0, request.responseText.length); // add that onto bytes
        bytes = (0, $4bd18e93e919945b$export$229a3d5e59c9dd55)(bytes, (0, $4bd18e93e919945b$export$c8dd6bc66a63753c)(newPart, true));
        id3Offset = id3Offset || (0, $862e4a4ff1392639$export$56b6cacf09ec1126)(bytes); // we need at least 10 bytes to determine a type
        // or we need at least two bytes after an id3Offset
        if (bytes.length < 10 || id3Offset && bytes.length < id3Offset + 2) return $cb03b711053a4297$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, "", bytes));
        const type = (0, $87512779f8f2edc4$export$894319e75ed840c3)(bytes); // if this looks like a ts segment but we don't have enough data
        // to see the second sync byte, wait until we have enough data
        // before declaring it ts
        if (type === "ts" && bytes.length < 188) return $cb03b711053a4297$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, "", bytes));
         // this may be an unsynced ts segment
        // wait for 376 bytes before detecting no container
        if (!type && bytes.length < 376) return $cb03b711053a4297$var$callbackOnCompleted(request, ()=>endRequestAndCallback(error, request, "", bytes));
        return endRequestAndCallback(null, request, type, bytes);
    };
    const options = {
        uri: uri,
        beforeSend (request) {
            // this forces the browser to pass the bytes to us unprocessed
            request.overrideMimeType("text/plain; charset=x-user-defined");
            request.addEventListener("progress", function({ total: total, loaded: loaded }) {
                return $cb03b711053a4297$var$callbackWrapper(request, null, {
                    statusCode: request.status
                }, progressListener);
            });
        }
    };
    const request = xhr(options, function(error, response) {
        return $cb03b711053a4297$var$callbackWrapper(request, error, response, progressListener);
    });
    return request;
};
const { EventTarget: $cb03b711053a4297$var$EventTarget } = $cb03b711053a4297$export$2e2bcd8739ae039;
const $cb03b711053a4297$var$dashPlaylistUnchanged = function(a, b) {
    if (!$cb03b711053a4297$var$isPlaylistUnchanged(a, b)) return false;
     // for dash the above check will often return true in scenarios where
    // the playlist actually has changed because mediaSequence isn't a
    // dash thing, and we often set it to 1. So if the playlists have the same amount
    // of segments we return true.
    // So for dash we need to make sure that the underlying segments are different.
    // if sidx changed then the playlists are different.
    if (a.sidx && b.sidx && (a.sidx.offset !== b.sidx.offset || a.sidx.length !== b.sidx.length)) return false;
    else if (!a.sidx && b.sidx || a.sidx && !b.sidx) return false;
     // one or the other does not have segments
    // there was a change.
    if (a.segments && !b.segments || !a.segments && b.segments) return false;
     // neither has segments nothing changed
    if (!a.segments && !b.segments) return true;
     // check segments themselves
    for(let i = 0; i < a.segments.length; i++){
        const aSegment = a.segments[i];
        const bSegment = b.segments[i]; // if uris are different between segments there was a change
        if (aSegment.uri !== bSegment.uri) return false;
         // neither segment has a byterange, there will be no byterange change.
        if (!aSegment.byterange && !bSegment.byterange) continue;
        const aByterange = aSegment.byterange;
        const bByterange = bSegment.byterange; // if byterange only exists on one of the segments, there was a change.
        if (aByterange && !bByterange || !aByterange && bByterange) return false;
         // if both segments have byterange with different offsets, there was a change.
        if (aByterange.offset !== bByterange.offset || aByterange.length !== bByterange.length) return false;
    } // if everything was the same with segments, this is the same playlist.
    return true;
};
/**
 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
 * periods without continuous playback this function may need modification as well as the parser.
 */ const $cb03b711053a4297$var$dashGroupId = (type, group, label, playlist)=>{
    // If the manifest somehow does not have an ID (non-dash compliant), use the label.
    const playlistId = playlist.attributes.NAME || label;
    return `placeholder-uri-${type}-${group}-${playlistId}`;
};
/**
 * Parses the main XML string and updates playlist URI references.
 *
 * @param {Object} config
 *        Object of arguments
 * @param {string} config.mainXml
 *        The mpd XML
 * @param {string} config.srcUrl
 *        The mpd URL
 * @param {Date} config.clientOffset
 *         A time difference between server and client
 * @param {Object} config.sidxMapping
 *        SIDX mappings for moof/mdat URIs and byte ranges
 * @return {Object}
 *         The parsed mpd manifest object
 */ const $cb03b711053a4297$var$parseMainXml = ({ mainXml: mainXml, srcUrl: srcUrl, clientOffset: clientOffset, sidxMapping: sidxMapping, previousManifest: previousManifest })=>{
    const manifest = (0, $0ffb3c35bf172c1a$export$98e6a39c04603d36)(mainXml, {
        manifestUri: srcUrl,
        clientOffset: clientOffset,
        sidxMapping: sidxMapping,
        previousManifest: previousManifest
    });
    $cb03b711053a4297$var$addPropertiesToMain(manifest, srcUrl, $cb03b711053a4297$var$dashGroupId);
    return manifest;
};
/**
 * Removes any mediaGroup labels that no longer exist in the newMain
 *
 * @param {Object} update
 *         The previous mpd object being updated
 * @param {Object} newMain
 *         The new mpd object
 */ const $cb03b711053a4297$var$removeOldMediaGroupLabels = (update, newMain)=>{
    $cb03b711053a4297$var$forEachMediaGroup(update, (properties, type, group, label)=>{
        if (!(label in newMain.mediaGroups[type][group])) delete update.mediaGroups[type][group][label];
    });
};
/**
 * Returns a new main manifest that is the result of merging an updated main manifest
 * into the original version.
 *
 * @param {Object} oldMain
 *        The old parsed mpd object
 * @param {Object} newMain
 *        The updated parsed mpd object
 * @return {Object}
 *         A new object representing the original main manifest with the updated media
 *         playlists merged in
 */ const $cb03b711053a4297$var$updateMain = (oldMain, newMain, sidxMapping)=>{
    let noChanges = true;
    let update = $cb03b711053a4297$var$merge(oldMain, {
        // These are top level properties that can be updated
        duration: newMain.duration,
        minimumUpdatePeriod: newMain.minimumUpdatePeriod,
        timelineStarts: newMain.timelineStarts
    }); // First update the playlists in playlist list
    for(let i = 0; i < newMain.playlists.length; i++){
        const playlist = newMain.playlists[i];
        if (playlist.sidx) {
            const sidxKey = (0, $0ffb3c35bf172c1a$export$2d92360466eb0b01)(playlist.sidx); // add sidx segments to the playlist if we have all the sidx info already
            if (sidxMapping && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx) (0, $0ffb3c35bf172c1a$export$2243d5aa7d4f4800)(playlist, sidxMapping[sidxKey].sidx, playlist.sidx.resolvedUri);
        }
        const playlistUpdate = $cb03b711053a4297$var$updateMain$1(update, playlist, $cb03b711053a4297$var$dashPlaylistUnchanged);
        if (playlistUpdate) {
            update = playlistUpdate;
            noChanges = false;
        }
    } // Then update media group playlists
    $cb03b711053a4297$var$forEachMediaGroup(newMain, (properties, type, group, label)=>{
        if (properties.playlists && properties.playlists.length) {
            const id = properties.playlists[0].id;
            const playlistUpdate = $cb03b711053a4297$var$updateMain$1(update, properties.playlists[0], $cb03b711053a4297$var$dashPlaylistUnchanged);
            if (playlistUpdate) {
                update = playlistUpdate; // add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
                if (!(label in update.mediaGroups[type][group])) update.mediaGroups[type][group][label] = properties;
                 // update the playlist reference within media groups
                update.mediaGroups[type][group][label].playlists[0] = update.playlists[id];
                noChanges = false;
            }
        }
    }); // remove mediaGroup labels and references that no longer exist in the newMain
    $cb03b711053a4297$var$removeOldMediaGroupLabels(update, newMain);
    if (newMain.minimumUpdatePeriod !== oldMain.minimumUpdatePeriod) noChanges = false;
    if (noChanges) return null;
    return update;
}; // SIDX should be equivalent if the URI and byteranges of the SIDX match.
// If the SIDXs have maps, the two maps should match,
// both `a` and `b` missing SIDXs is considered matching.
// If `a` or `b` but not both have a map, they aren't matching.
const $cb03b711053a4297$var$equivalentSidx = (a, b)=>{
    const neitherMap = Boolean(!a.map && !b.map);
    const equivalentMap = neitherMap || Boolean(a.map && b.map && a.map.byterange.offset === b.map.byterange.offset && a.map.byterange.length === b.map.byterange.length);
    return equivalentMap && a.uri === b.uri && a.byterange.offset === b.byterange.offset && a.byterange.length === b.byterange.length;
}; // exported for testing
const $cb03b711053a4297$var$compareSidxEntry = (playlists, oldSidxMapping)=>{
    const newSidxMapping = {};
    for(const id in playlists){
        const playlist = playlists[id];
        const currentSidxInfo = playlist.sidx;
        if (currentSidxInfo) {
            const key = (0, $0ffb3c35bf172c1a$export$2d92360466eb0b01)(currentSidxInfo);
            if (!oldSidxMapping[key]) break;
            const savedSidxInfo = oldSidxMapping[key].sidxInfo;
            if ($cb03b711053a4297$var$equivalentSidx(savedSidxInfo, currentSidxInfo)) newSidxMapping[key] = oldSidxMapping[key];
        }
    }
    return newSidxMapping;
};
/**
 *  A function that filters out changed items as they need to be requested separately.
 *
 *  The method is exported for testing
 *
 *  @param {Object} main the parsed mpd XML returned via mpd-parser
 *  @param {Object} oldSidxMapping the SIDX to compare against
 */ const $cb03b711053a4297$var$filterChangedSidxMappings = (main, oldSidxMapping)=>{
    const videoSidx = $cb03b711053a4297$var$compareSidxEntry(main.playlists, oldSidxMapping);
    let mediaGroupSidx = videoSidx;
    $cb03b711053a4297$var$forEachMediaGroup(main, (properties, mediaType, groupKey, labelKey)=>{
        if (properties.playlists && properties.playlists.length) {
            const playlists = properties.playlists;
            mediaGroupSidx = $cb03b711053a4297$var$merge(mediaGroupSidx, $cb03b711053a4297$var$compareSidxEntry(playlists, oldSidxMapping));
        }
    });
    return mediaGroupSidx;
};
class $cb03b711053a4297$var$DashPlaylistLoader extends $cb03b711053a4297$var$EventTarget {
    // DashPlaylistLoader must accept either a src url or a playlist because subsequent
    // playlist loader setups from media groups will expect to be able to pass a playlist
    // (since there aren't external URLs to media playlists with DASH)
    constructor(srcUrlOrPlaylist, vhs, options = {}, mainPlaylistLoader){
        super();
        this.mainPlaylistLoader_ = mainPlaylistLoader || this;
        if (!mainPlaylistLoader) this.isMain_ = true;
        const { withCredentials: withCredentials = false } = options;
        this.vhs_ = vhs;
        this.withCredentials = withCredentials;
        this.addMetadataToTextTrack = options.addMetadataToTextTrack;
        if (!srcUrlOrPlaylist) throw new Error("A non-empty playlist URL or object is required");
         // event naming?
        this.on("minimumUpdatePeriod", ()=>{
            this.refreshXml_();
        }); // live playlist staleness timeout
        this.on("mediaupdatetimeout", ()=>{
            // We handle live content steering in the playlist controller
            if (!this.media().attributes.serviceLocation) this.refreshMedia_(this.media().id);
        });
        this.state = "HAVE_NOTHING";
        this.loadedPlaylists_ = {};
        this.logger_ = $cb03b711053a4297$var$logger("DashPlaylistLoader"); // initialize the loader state
        // The mainPlaylistLoader will be created with a string
        if (this.isMain_) {
            this.mainPlaylistLoader_.srcUrl = srcUrlOrPlaylist; // TODO: reset sidxMapping between period changes
            // once multi-period is refactored
            this.mainPlaylistLoader_.sidxMapping_ = {};
        } else this.childPlaylist_ = srcUrlOrPlaylist;
    }
    requestErrored_(err, request, startingState) {
        // disposed
        if (!this.request) return true;
         // pending request is cleared
        this.request = null;
        if (err) {
            // use the provided error object or create one
            // based on the request/response
            this.error = typeof err === "object" && !(err instanceof Error) ? err : {
                status: request.status,
                message: "DASH request error at URL: " + request.uri,
                response: request.response,
                // MEDIA_ERR_NETWORK
                code: 2
            };
            if (startingState) this.state = startingState;
            this.trigger("error");
            return true;
        }
    }
    /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */ addSidxSegments_(playlist, startingState, cb) {
        const sidxKey = playlist.sidx && (0, $0ffb3c35bf172c1a$export$2d92360466eb0b01)(playlist.sidx); // playlist lacks sidx or sidx segments were added to this playlist already.
        if (!playlist.sidx || !sidxKey || this.mainPlaylistLoader_.sidxMapping_[sidxKey]) {
            // keep this function async
            this.mediaRequest_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>cb(false), 0);
            return;
        } // resolve the segment URL relative to the playlist
        const uri = $cb03b711053a4297$var$resolveManifestRedirect(playlist.sidx.resolvedUri);
        const fin = (err, request)=>{
            if (this.requestErrored_(err, request, startingState)) return;
            const sidxMapping = this.mainPlaylistLoader_.sidxMapping_;
            let sidx;
            try {
                sidx = (0, (/*@__PURE__*/$parcel$interopDefault($7d9f1a0178bc82dd$exports)))((0, $4bd18e93e919945b$export$63c3de442720649)(request.response).subarray(8));
            } catch (e) {
                // sidx parsing failed.
                this.requestErrored_(e, request, startingState);
                return;
            }
            sidxMapping[sidxKey] = {
                sidxInfo: playlist.sidx,
                sidx: sidx
            };
            (0, $0ffb3c35bf172c1a$export$2243d5aa7d4f4800)(playlist, sidx, playlist.sidx.resolvedUri);
            return cb(true);
        };
        this.request = $cb03b711053a4297$var$containerRequest(uri, this.vhs_.xhr, (err, request, container, bytes)=>{
            if (err) return fin(err, request);
            if (!container || container !== "mp4") return fin({
                status: request.status,
                message: `Unsupported ${container || "unknown"} container type for sidx segment at URL: ${uri}`,
                // response is just bytes in this case
                // but we really don't want to return that.
                response: "",
                playlist: playlist,
                internal: true,
                playlistExclusionDuration: Infinity,
                // MEDIA_ERR_NETWORK
                code: 2
            }, request);
             // if we already downloaded the sidx bytes in the container request, use them
            const { offset: offset, length: length } = playlist.sidx.byterange;
            if (bytes.length >= length + offset) return fin(err, {
                response: bytes.subarray(offset, offset + length),
                status: request.status,
                uri: request.uri
            });
             // otherwise request sidx bytes
            this.request = this.vhs_.xhr({
                uri: uri,
                responseType: "arraybuffer",
                headers: $cb03b711053a4297$var$segmentXhrHeaders({
                    byterange: playlist.sidx.byterange
                })
            }, fin);
        });
    }
    dispose() {
        this.trigger("dispose");
        this.stopRequest();
        this.loadedPlaylists_ = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.minimumUpdatePeriodTimeout_);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaRequest_);
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        this.mediaRequest_ = null;
        this.minimumUpdatePeriodTimeout_ = null;
        if (this.mainPlaylistLoader_.createMupOnMedia_) {
            this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_);
            this.mainPlaylistLoader_.createMupOnMedia_ = null;
        }
        this.off();
    }
    hasPendingRequest() {
        return this.request || this.mediaRequest_;
    }
    stopRequest() {
        if (this.request) {
            const oldRequest = this.request;
            this.request = null;
            oldRequest.onreadystatechange = null;
            oldRequest.abort();
        }
    }
    media(playlist) {
        // getter
        if (!playlist) return this.media_;
         // setter
        if (this.state === "HAVE_NOTHING") throw new Error("Cannot switch media playlist from " + this.state);
        const startingState = this.state; // find the playlist object if the target playlist has been specified by URI
        if (typeof playlist === "string") {
            if (!this.mainPlaylistLoader_.main.playlists[playlist]) throw new Error("Unknown playlist URI: " + playlist);
            playlist = this.mainPlaylistLoader_.main.playlists[playlist];
        }
        const mediaChange = !this.media_ || playlist.id !== this.media_.id; // switch to previously loaded playlists immediately
        if (mediaChange && this.loadedPlaylists_[playlist.id] && this.loadedPlaylists_[playlist.id].endList) {
            this.state = "HAVE_METADATA";
            this.media_ = playlist; // trigger media change if the active media has been updated
            if (mediaChange) {
                this.trigger("mediachanging");
                this.trigger("mediachange");
            }
            return;
        } // switching to the active playlist is a no-op
        if (!mediaChange) return;
         // switching from an already loaded playlist
        if (this.media_) this.trigger("mediachanging");
        this.addSidxSegments_(playlist, startingState, (sidxChanged)=>{
            // everything is ready just continue to haveMetadata
            this.haveMetadata({
                startingState: startingState,
                playlist: playlist
            });
        });
    }
    haveMetadata({ startingState: startingState, playlist: playlist }) {
        this.state = "HAVE_METADATA";
        this.loadedPlaylists_[playlist.id] = playlist;
        this.mediaRequest_ = null; // This will trigger loadedplaylist
        this.refreshMedia_(playlist.id); // fire loadedmetadata the first time a media playlist is loaded
        // to resolve setup of media groups
        if (startingState === "HAVE_MAIN_MANIFEST") this.trigger("loadedmetadata");
        else // trigger media change if the active media has been updated
        this.trigger("mediachange");
    }
    pause() {
        if (this.mainPlaylistLoader_.createMupOnMedia_) {
            this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_);
            this.mainPlaylistLoader_.createMupOnMedia_ = null;
        }
        this.stopRequest();
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        if (this.isMain_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_);
            this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null;
        }
        if (this.state === "HAVE_NOTHING") // If we pause the loader before any data has been retrieved, its as if we never
        // started, so reset to an unstarted state.
        this.started = false;
    }
    load(isFinalRendition) {
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.mediaUpdateTimeout);
        this.mediaUpdateTimeout = null;
        const media = this.media();
        if (isFinalRendition) {
            const delay = media ? media.targetDuration / 2 * 1000 : 5000;
            this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>this.load(), delay);
            return;
        } // because the playlists are internal to the manifest, load should either load the
        // main manifest, or do nothing but trigger an event
        if (!this.started) {
            this.start();
            return;
        }
        if (media && !media.endList) {
            // Check to see if this is the main loader and the MUP was cleared (this happens
            // when the loader was paused). `media` should be set at this point since one is always
            // set during `start()`.
            if (this.isMain_ && !this.minimumUpdatePeriodTimeout_) {
                // Trigger minimumUpdatePeriod to refresh the main manifest
                this.trigger("minimumUpdatePeriod"); // Since there was no prior minimumUpdatePeriodTimeout it should be recreated
                this.updateMinimumUpdatePeriodTimeout_();
            }
            this.trigger("mediaupdatetimeout");
        } else this.trigger("loadedplaylist");
    }
    start() {
        this.started = true; // We don't need to request the main manifest again
        // Call this asynchronously to match the xhr request behavior below
        if (!this.isMain_) {
            this.mediaRequest_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>this.haveMain_(), 0);
            return;
        }
        this.requestMain_((req, mainChanged)=>{
            this.haveMain_();
            if (!this.hasPendingRequest() && !this.media_) this.media(this.mainPlaylistLoader_.main.playlists[0]);
        });
    }
    requestMain_(cb) {
        this.request = this.vhs_.xhr({
            uri: this.mainPlaylistLoader_.srcUrl,
            withCredentials: this.withCredentials
        }, (error, req)=>{
            if (this.requestErrored_(error, req)) {
                if (this.state === "HAVE_NOTHING") this.started = false;
                return;
            }
            const mainChanged = req.responseText !== this.mainPlaylistLoader_.mainXml_;
            this.mainPlaylistLoader_.mainXml_ = req.responseText;
            if (req.responseHeaders && req.responseHeaders.date) this.mainLoaded_ = Date.parse(req.responseHeaders.date);
            else this.mainLoaded_ = Date.now();
            this.mainPlaylistLoader_.srcUrl = $cb03b711053a4297$var$resolveManifestRedirect(this.mainPlaylistLoader_.srcUrl, req);
            if (mainChanged) {
                this.handleMain_();
                this.syncClientServerClock_(()=>{
                    return cb(req, mainChanged);
                });
                return;
            }
            return cb(req, mainChanged);
        });
    }
    /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */ syncClientServerClock_(done) {
        const utcTiming = (0, $0ffb3c35bf172c1a$export$734c7278b5d0068c)(this.mainPlaylistLoader_.mainXml_); // No UTCTiming element found in the mpd. Use Date header from mpd request as the
        // server clock
        if (utcTiming === null) {
            this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now();
            return done();
        }
        if (utcTiming.method === "DIRECT") {
            this.mainPlaylistLoader_.clientOffset_ = utcTiming.value - Date.now();
            return done();
        }
        this.request = this.vhs_.xhr({
            uri: $cb03b711053a4297$var$resolveUrl(this.mainPlaylistLoader_.srcUrl, utcTiming.value),
            method: utcTiming.method,
            withCredentials: this.withCredentials
        }, (error, req)=>{
            // disposed
            if (!this.request) return;
            if (error) {
                // sync request failed, fall back to using date header from mpd
                // TODO: log warning
                this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now();
                return done();
            }
            let serverTime;
            if (utcTiming.method === "HEAD") {
                if (!req.responseHeaders || !req.responseHeaders.date) // expected date header not preset, fall back to using date header from mpd
                // TODO: log warning
                serverTime = this.mainLoaded_;
                else serverTime = Date.parse(req.responseHeaders.date);
            } else serverTime = Date.parse(req.responseText);
            this.mainPlaylistLoader_.clientOffset_ = serverTime - Date.now();
            done();
        });
    }
    haveMain_() {
        this.state = "HAVE_MAIN_MANIFEST";
        if (this.isMain_) // We have the main playlist at this point, so
        // trigger this to allow PlaylistController
        // to make an initial playlist selection
        this.trigger("loadedplaylist");
        else if (!this.media_) // no media playlist was specifically selected so select
        // the one the child playlist loader was created with
        this.media(this.childPlaylist_);
    }
    handleMain_() {
        // clear media request
        this.mediaRequest_ = null;
        const oldMain = this.mainPlaylistLoader_.main;
        let newMain = $cb03b711053a4297$var$parseMainXml({
            mainXml: this.mainPlaylistLoader_.mainXml_,
            srcUrl: this.mainPlaylistLoader_.srcUrl,
            clientOffset: this.mainPlaylistLoader_.clientOffset_,
            sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
            previousManifest: oldMain
        }); // if we have an old main to compare the new main against
        if (oldMain) newMain = $cb03b711053a4297$var$updateMain(oldMain, newMain, this.mainPlaylistLoader_.sidxMapping_);
         // only update main if we have a new main
        this.mainPlaylistLoader_.main = newMain ? newMain : oldMain;
        const location = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
        if (location && location !== this.mainPlaylistLoader_.srcUrl) this.mainPlaylistLoader_.srcUrl = location;
        if (!oldMain || newMain && newMain.minimumUpdatePeriod !== oldMain.minimumUpdatePeriod) this.updateMinimumUpdatePeriodTimeout_();
        this.addEventStreamToMetadataTrack_(newMain);
        return Boolean(newMain);
    }
    updateMinimumUpdatePeriodTimeout_() {
        const mpl = this.mainPlaylistLoader_; // cancel any pending creation of mup on media
        // a new one will be added if needed.
        if (mpl.createMupOnMedia_) {
            mpl.off("loadedmetadata", mpl.createMupOnMedia_);
            mpl.createMupOnMedia_ = null;
        } // clear any pending timeouts
        if (mpl.minimumUpdatePeriodTimeout_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(mpl.minimumUpdatePeriodTimeout_);
            mpl.minimumUpdatePeriodTimeout_ = null;
        }
        let mup = mpl.main && mpl.main.minimumUpdatePeriod; // If the minimumUpdatePeriod has a value of 0, that indicates that the current
        // MPD has no future validity, so a new one will need to be acquired when new
        // media segments are to be made available. Thus, we use the target duration
        // in this case
        if (mup === 0) {
            if (mpl.media()) mup = mpl.media().targetDuration * 1000;
            else {
                mpl.createMupOnMedia_ = mpl.updateMinimumUpdatePeriodTimeout_;
                mpl.one("loadedmetadata", mpl.createMupOnMedia_);
            }
        } // if minimumUpdatePeriod is invalid or <= zero, which
        // can happen when a live video becomes VOD. skip timeout
        // creation.
        if (typeof mup !== "number" || mup <= 0) {
            if (mup < 0) this.logger_(`found invalid minimumUpdatePeriod of ${mup}, not setting a timeout`);
            return;
        }
        this.createMUPTimeout_(mup);
    }
    createMUPTimeout_(mup) {
        const mpl = this.mainPlaylistLoader_;
        mpl.minimumUpdatePeriodTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            mpl.minimumUpdatePeriodTimeout_ = null;
            mpl.trigger("minimumUpdatePeriod");
            mpl.createMUPTimeout_(mup);
        }, mup);
    }
    /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */ refreshXml_() {
        this.requestMain_((req, mainChanged)=>{
            if (!mainChanged) return;
            if (this.media_) this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id];
             // This will filter out updated sidx info from the mapping
            this.mainPlaylistLoader_.sidxMapping_ = $cb03b711053a4297$var$filterChangedSidxMappings(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_);
            this.addSidxSegments_(this.media(), this.state, (sidxChanged)=>{
                // TODO: do we need to reload the current playlist?
                this.refreshMedia_(this.media().id);
            });
        });
    }
    /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */ refreshMedia_(mediaID) {
        if (!mediaID) throw new Error("refreshMedia_ must take a media id");
         // for main we have to reparse the main xml
        // to re-create segments based on current timing values
        // which may change media. We only skip updating the main manifest
        // if this is the first time this.media_ is being set.
        // as main was just parsed in that case.
        if (this.media_ && this.isMain_) this.handleMain_();
        const playlists = this.mainPlaylistLoader_.main.playlists;
        const mediaChanged = !this.media_ || this.media_ !== playlists[mediaID];
        if (mediaChanged) this.media_ = playlists[mediaID];
        else this.trigger("playlistunchanged");
        if (!this.mediaUpdateTimeout) {
            const createMediaUpdateTimeout = ()=>{
                if (this.media().endList) return;
                this.mediaUpdateTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                    this.trigger("mediaupdatetimeout");
                    createMediaUpdateTimeout();
                }, $cb03b711053a4297$var$refreshDelay(this.media(), Boolean(mediaChanged)));
            };
            createMediaUpdateTimeout();
        }
        this.trigger("loadedplaylist");
    }
    /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */ addEventStreamToMetadataTrack_(newMain) {
        // Only add new event stream metadata if we have a new manifest.
        if (newMain && this.mainPlaylistLoader_.main.eventStream) {
            // convert EventStream to ID3-like data.
            const metadataArray = this.mainPlaylistLoader_.main.eventStream.map((eventStreamNode)=>{
                return {
                    cueTime: eventStreamNode.start,
                    frames: [
                        {
                            data: eventStreamNode.messageData
                        }
                    ]
                };
            });
            this.addMetadataToTextTrack("EventStream", metadataArray, this.mainPlaylistLoader_.main.duration);
        }
    }
}
var $cb03b711053a4297$var$Config = {
    GOAL_BUFFER_LENGTH: 30,
    MAX_GOAL_BUFFER_LENGTH: 60,
    BACK_BUFFER_LENGTH: 30,
    GOAL_BUFFER_LENGTH_RATE: 1,
    // 0.5 MB/s
    INITIAL_BANDWIDTH: 4194304,
    // A fudge factor to apply to advertised playlist bitrates to account for
    // temporary flucations in client bandwidth
    BANDWIDTH_VARIANCE: 1.2,
    // How much of the buffer must be filled before we consider upswitching
    BUFFER_LOW_WATER_LINE: 0,
    MAX_BUFFER_LOW_WATER_LINE: 30,
    // TODO: Remove this when experimentalBufferBasedABR is removed
    EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
    BUFFER_LOW_WATER_LINE_RATE: 1,
    // If the buffer is greater than the high water line, we won't switch down
    BUFFER_HIGH_WATER_LINE: 30
};
const $cb03b711053a4297$var$stringToArrayBuffer = (string)=>{
    const view = new Uint8Array(new ArrayBuffer(string.length));
    for(let i = 0; i < string.length; i++)view[i] = string.charCodeAt(i);
    return view.buffer;
};
/* global Blob, BlobBuilder, Worker */ // unify worker interface
const $cb03b711053a4297$var$browserWorkerPolyFill = function(workerObj) {
    // node only supports on/off
    workerObj.on = workerObj.addEventListener;
    workerObj.off = workerObj.removeEventListener;
    return workerObj;
};
const $cb03b711053a4297$var$createObjectURL = function(str) {
    try {
        return URL.createObjectURL(new Blob([
            str
        ], {
            type: "application/javascript"
        }));
    } catch (e) {
        const blob = new BlobBuilder();
        blob.append(str);
        return URL.createObjectURL(blob.getBlob());
    }
};
const $cb03b711053a4297$var$factory = function(code) {
    return function() {
        const objectUrl = $cb03b711053a4297$var$createObjectURL(code);
        const worker = $cb03b711053a4297$var$browserWorkerPolyFill(new Worker(objectUrl));
        worker.objURL = objectUrl;
        const terminate = worker.terminate;
        worker.on = worker.addEventListener;
        worker.off = worker.removeEventListener;
        worker.terminate = function() {
            URL.revokeObjectURL(objectUrl);
            return terminate.call(this);
        };
        return worker;
    };
};
const $cb03b711053a4297$var$transform = function(code) {
    return `var browserWorkerPolyFill = ${$cb03b711053a4297$var$browserWorkerPolyFill.toString()};\n` + "browserWorkerPolyFill(self);\n" + code;
};
const $cb03b711053a4297$var$getWorkerString = function(fn) {
    return fn.toString().replace(/^function.+?{/, "").slice(0, -1);
};
/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */ const $cb03b711053a4297$var$workerCode$1 = $cb03b711053a4297$var$transform($cb03b711053a4297$var$getWorkerString(function() {
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A lightweight readable stream implemention that handles event dispatching.
   * Objects that inherit from streams should call init in their constructors.
   */ var Stream$8 = function() {
        this.init = function() {
            var listeners = {};
            /**
       * Add a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} the callback to be invoked when an event of
       * the specified type occurs
       */ this.on = function(type, listener) {
                if (!listeners[type]) listeners[type] = [];
                listeners[type] = listeners[type].concat(listener);
            };
            /**
       * Remove a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} a function previously registered for this
       * type of event through `on`
       */ this.off = function(type, listener) {
                var index;
                if (!listeners[type]) return false;
                index = listeners[type].indexOf(listener);
                listeners[type] = listeners[type].slice();
                listeners[type].splice(index, 1);
                return index > -1;
            };
            /**
       * Trigger an event of the specified type on this stream. Any additional
       * arguments to this function are passed as parameters to event listeners.
       * @param type {string} the event name
       */ this.trigger = function(type) {
                var callbacks, i, length, args;
                callbacks = listeners[type];
                if (!callbacks) return;
                 // Slicing the arguments on every invocation of this method
                // can add a significant amount of overhead. Avoid the
                // intermediate object creation for the common case of a
                // single callback argument
                if (arguments.length === 2) {
                    length = callbacks.length;
                    for(i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
                } else {
                    args = [];
                    i = arguments.length;
                    for(i = 1; i < arguments.length; ++i)args.push(arguments[i]);
                    length = callbacks.length;
                    for(i = 0; i < length; ++i)callbacks[i].apply(this, args);
                }
            };
            /**
       * Destroys the stream and cleans up.
       */ this.dispose = function() {
                listeners = {};
            };
        };
    };
    /**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   * @param destination {stream} the stream that will receive all `data` events
   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
   *                            when the current stream emits a 'done' event
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */ Stream$8.prototype.pipe = function(destination) {
        this.on("data", function(data) {
            destination.push(data);
        });
        this.on("done", function(flushSource) {
            destination.flush(flushSource);
        });
        this.on("partialdone", function(flushSource) {
            destination.partialFlush(flushSource);
        });
        this.on("endedtimeline", function(flushSource) {
            destination.endTimeline(flushSource);
        });
        this.on("reset", function(flushSource) {
            destination.reset(flushSource);
        });
        return destination;
    }; // Default stream functions that are expected to be overridden to perform
    // actual work. These are provided by the prototype as a sort of no-op
    // implementation so that we don't have to check for their existence in the
    // `pipe` function above.
    Stream$8.prototype.push = function(data) {
        this.trigger("data", data);
    };
    Stream$8.prototype.flush = function(flushSource) {
        this.trigger("done", flushSource);
    };
    Stream$8.prototype.partialFlush = function(flushSource) {
        this.trigger("partialdone", flushSource);
    };
    Stream$8.prototype.endTimeline = function(flushSource) {
        this.trigger("endedtimeline", flushSource);
    };
    Stream$8.prototype.reset = function(flushSource) {
        this.trigger("reset", flushSource);
    };
    var stream = Stream$8;
    var MAX_UINT32$1 = Math.pow(2, 32);
    var getUint64$3 = function(uint8) {
        var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
        var value;
        if (dv.getBigUint64) {
            value = dv.getBigUint64(0);
            if (value < Number.MAX_SAFE_INTEGER) return Number(value);
            return value;
        }
        return dv.getUint32(0) * MAX_UINT32$1 + dv.getUint32(4);
    };
    var numbers = {
        getUint64: getUint64$3,
        MAX_UINT32: MAX_UINT32$1
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Functions that generate fragmented MP4s suitable for use with Media
   * Source Extensions.
   */ var MAX_UINT32 = numbers.MAX_UINT32;
    var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun$1, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS; // pre-calculate constants
    (function() {
        var i;
        types = {
            avc1: [],
            // codingname
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            // codingname
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            smhd: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            styp: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: []
        }; // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
        // don't throw an error
        if (typeof Uint8Array === "undefined") return;
        for(i in types)if (types.hasOwnProperty(i)) types[i] = [
            i.charCodeAt(0),
            i.charCodeAt(1),
            i.charCodeAt(2),
            i.charCodeAt(3)
        ];
        MAJOR_BRAND = new Uint8Array([
            "i".charCodeAt(0),
            "s".charCodeAt(0),
            "o".charCodeAt(0),
            "m".charCodeAt(0)
        ]);
        AVC1_BRAND = new Uint8Array([
            "a".charCodeAt(0),
            "v".charCodeAt(0),
            "c".charCodeAt(0),
            "1".charCodeAt(0)
        ]);
        MINOR_VERSION = new Uint8Array([
            0,
            0,
            0,
            1
        ]);
        VIDEO_HDLR = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x76,
            0x69,
            0x64,
            0x65,
            // handler_type: 'vide'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x56,
            0x69,
            0x64,
            0x65,
            0x6f,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'VideoHandler'
        ]);
        AUDIO_HDLR = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x73,
            0x6f,
            0x75,
            0x6e,
            // handler_type: 'soun'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x53,
            0x6f,
            0x75,
            0x6e,
            0x64,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'SoundHandler'
        ]);
        HDLR_TYPES = {
            video: VIDEO_HDLR,
            audio: AUDIO_HDLR
        };
        DREF = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // entry_count
            0x00,
            0x00,
            0x00,
            0x0c,
            // entry_size
            0x75,
            0x72,
            0x6c,
            0x20,
            // 'url' type
            0x00,
            // version 0
            0x00,
            0x00,
            0x01 // entry_flags
        ]);
        SMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            // balance, 0 means centered
            0x00,
            0x00 // reserved
        ]);
        STCO = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00 // entry_count
        ]);
        STSC = STCO;
        STSZ = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // sample_size
            0x00,
            0x00,
            0x00,
            0x00 // sample_count
        ]);
        STTS = STCO;
        VMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x01,
            // flags
            0x00,
            0x00,
            // graphicsmode
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00 // opcolor
        ]);
    })();
    box = function(type) {
        var payload = [], size = 0, i, result, view;
        for(i = 1; i < arguments.length; i++)payload.push(arguments[i]);
        i = payload.length; // calculate the total size we need to allocate
        while(i--)size += payload[i].byteLength;
        result = new Uint8Array(size + 8);
        view = new DataView(result.buffer, result.byteOffset, result.byteLength);
        view.setUint32(0, result.byteLength);
        result.set(type, 4); // copy the payload into the result
        for(i = 0, size = 8; i < payload.length; i++){
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    };
    dinf = function() {
        return box(types.dinf, box(types.dref, DREF));
    };
    esds = function(track) {
        return box(types.esds, new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            // ES_Descriptor
            0x03,
            // tag, ES_DescrTag
            0x19,
            // length
            0x00,
            0x00,
            // ES_ID
            0x00,
            // streamDependenceFlag, URL_flag, reserved, streamPriority
            // DecoderConfigDescriptor
            0x04,
            // tag, DecoderConfigDescrTag
            0x11,
            // length
            0x40,
            // object type
            0x15,
            // streamType
            0x00,
            0x06,
            0x00,
            // bufferSizeDB
            0x00,
            0x00,
            0xda,
            0xc0,
            // maxBitrate
            0x00,
            0x00,
            0xda,
            0xc0,
            // avgBitrate
            // DecoderSpecificInfo
            0x05,
            // tag, DecoderSpecificInfoTag
            0x02,
            // length
            // ISO/IEC 14496-3, AudioSpecificConfig
            // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
            track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1,
            track.samplingfrequencyindex << 7 | track.channelcount << 3,
            0x06,
            0x01,
            0x02 // GASpecificConfig
        ]));
    };
    ftyp = function() {
        return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
    };
    hdlr = function(type) {
        return box(types.hdlr, HDLR_TYPES[type]);
    };
    mdat = function(data) {
        return box(types.mdat, data);
    };
    mdhd = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            0x00,
            0x01,
            0x5f,
            0x90,
            // timescale, 90,000 "ticks" per second
            track.duration >>> 24 & 0xFF,
            track.duration >>> 16 & 0xFF,
            track.duration >>> 8 & 0xFF,
            track.duration & 0xFF,
            // duration
            0x55,
            0xc4,
            // 'und' language (undetermined)
            0x00,
            0x00
        ]); // Use the sample rate from the track metadata, when it is
        // defined. The sample rate can be parsed out of an ADTS header, for
        // instance.
        if (track.samplerate) {
            result[12] = track.samplerate >>> 24 & 0xFF;
            result[13] = track.samplerate >>> 16 & 0xFF;
            result[14] = track.samplerate >>> 8 & 0xFF;
            result[15] = track.samplerate & 0xFF;
        }
        return box(types.mdhd, result);
    };
    mdia = function(track) {
        return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
    };
    mfhd = function(sequenceNumber) {
        return box(types.mfhd, new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00,
            // flags
            (sequenceNumber & 0xFF000000) >> 24,
            (sequenceNumber & 0xFF0000) >> 16,
            (sequenceNumber & 0xFF00) >> 8,
            sequenceNumber & 0xFF // sequence_number
        ]));
    };
    minf = function(track) {
        return box(types.minf, track.type === "video" ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
    };
    moof = function(sequenceNumber, tracks) {
        var trackFragments = [], i = tracks.length; // build traf boxes for each track fragment
        while(i--)trackFragments[i] = traf(tracks[i]);
        return box.apply(null, [
            types.moof,
            mfhd(sequenceNumber)
        ].concat(trackFragments));
    };
    /**
   * Returns a movie box.
   * @param tracks {array} the tracks associated with this movie
   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
   */ moov = function(tracks) {
        var i = tracks.length, boxes = [];
        while(i--)boxes[i] = trak(tracks[i]);
        return box.apply(null, [
            types.moov,
            mvhd(0xffffffff)
        ].concat(boxes).concat(mvex(tracks)));
    };
    mvex = function(tracks) {
        var i = tracks.length, boxes = [];
        while(i--)boxes[i] = trex(tracks[i]);
        return box.apply(null, [
            types.mvex
        ].concat(boxes));
    };
    mvhd = function(duration) {
        var bytes = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x02,
            // modification_time
            0x00,
            0x01,
            0x5f,
            0x90,
            // timescale, 90,000 "ticks" per second
            (duration & 0xFF000000) >> 24,
            (duration & 0xFF0000) >> 16,
            (duration & 0xFF00) >> 8,
            duration & 0xFF,
            // duration
            0x00,
            0x01,
            0x00,
            0x00,
            // 1.0 rate
            0x01,
            0x00,
            // 1.0 volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0xff,
            0xff,
            0xff,
            0xff // next_track_ID
        ]);
        return box(types.mvhd, bytes);
    };
    sdtp = function(track) {
        var samples = track.samples || [], bytes = new Uint8Array(4 + samples.length), flags, i; // leave the full box header (4 bytes) all zero
        // write the sample table
        for(i = 0; i < samples.length; i++){
            flags = samples[i].flags;
            bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
        }
        return box(types.sdtp, bytes);
    };
    stbl = function(track) {
        return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
    };
    (function() {
        var videoSample, audioSample;
        stsd = function(track) {
            return box(types.stsd, new Uint8Array([
                0x00,
                // version 0
                0x00,
                0x00,
                0x00,
                // flags
                0x00,
                0x00,
                0x00,
                0x01
            ]), track.type === "video" ? videoSample(track) : audioSample(track));
        };
        videoSample = function(track) {
            var sps = track.sps || [], pps = track.pps || [], sequenceParameterSets = [], pictureParameterSets = [], i, avc1Box; // assemble the SPSs
            for(i = 0; i < sps.length; i++){
                sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
                sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
                sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
            } // assemble the PPSs
            for(i = 0; i < pps.length; i++){
                pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
                pictureParameterSets.push(pps[i].byteLength & 0xFF);
                pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
            }
            avc1Box = [
                types.avc1,
                new Uint8Array([
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x01,
                    // data_reference_index
                    0x00,
                    0x00,
                    // pre_defined
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // pre_defined
                    (track.width & 0xff00) >> 8,
                    track.width & 0xff,
                    // width
                    (track.height & 0xff00) >> 8,
                    track.height & 0xff,
                    // height
                    0x00,
                    0x48,
                    0x00,
                    0x00,
                    // horizresolution
                    0x00,
                    0x48,
                    0x00,
                    0x00,
                    // vertresolution
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // reserved
                    0x00,
                    0x01,
                    // frame_count
                    0x13,
                    0x76,
                    0x69,
                    0x64,
                    0x65,
                    0x6f,
                    0x6a,
                    0x73,
                    0x2d,
                    0x63,
                    0x6f,
                    0x6e,
                    0x74,
                    0x72,
                    0x69,
                    0x62,
                    0x2d,
                    0x68,
                    0x6c,
                    0x73,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    // compressorname
                    0x00,
                    0x18,
                    // depth = 24
                    0x11,
                    0x11 // pre_defined = -1
                ]),
                box(types.avcC, new Uint8Array([
                    0x01,
                    // configurationVersion
                    track.profileIdc,
                    // AVCProfileIndication
                    track.profileCompatibility,
                    // profile_compatibility
                    track.levelIdc,
                    // AVCLevelIndication
                    0xff // lengthSizeMinusOne, hard-coded to 4 bytes
                ].concat([
                    sps.length
                ], // numOfSequenceParameterSets
                sequenceParameterSets, // "SPS"
                [
                    pps.length
                ], // numOfPictureParameterSets
                pictureParameterSets // "PPS"
                ))),
                box(types.btrt, new Uint8Array([
                    0x00,
                    0x1c,
                    0x9c,
                    0x80,
                    // bufferSizeDB
                    0x00,
                    0x2d,
                    0xc6,
                    0xc0,
                    // maxBitrate
                    0x00,
                    0x2d,
                    0xc6,
                    0xc0 // avgBitrate
                ]))
            ];
            if (track.sarRatio) {
                var hSpacing = track.sarRatio[0], vSpacing = track.sarRatio[1];
                avc1Box.push(box(types.pasp, new Uint8Array([
                    (hSpacing & 0xFF000000) >> 24,
                    (hSpacing & 0xFF0000) >> 16,
                    (hSpacing & 0xFF00) >> 8,
                    hSpacing & 0xFF,
                    (vSpacing & 0xFF000000) >> 24,
                    (vSpacing & 0xFF0000) >> 16,
                    (vSpacing & 0xFF00) >> 8,
                    vSpacing & 0xFF
                ])));
            }
            return box.apply(null, avc1Box);
        };
        audioSample = function(track) {
            return box(types.mp4a, new Uint8Array([
                // SampleEntry, ISO/IEC 14496-12
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                0x00,
                0x01,
                // data_reference_index
                // AudioSampleEntry, ISO/IEC 14496-12
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                0x00,
                0x00,
                0x00,
                0x00,
                // reserved
                (track.channelcount & 0xff00) >> 8,
                track.channelcount & 0xff,
                // channelcount
                (track.samplesize & 0xff00) >> 8,
                track.samplesize & 0xff,
                // samplesize
                0x00,
                0x00,
                // pre_defined
                0x00,
                0x00,
                // reserved
                (track.samplerate & 0xff00) >> 8,
                track.samplerate & 0xff,
                0x00,
                0x00 // samplerate, 16.16
            ]), esds(track));
        };
    })();
    tkhd = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x07,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            // modification_time
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            (track.duration & 0xFF000000) >> 24,
            (track.duration & 0xFF0000) >> 16,
            (track.duration & 0xFF00) >> 8,
            track.duration & 0xFF,
            // duration
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            // layer
            0x00,
            0x00,
            // alternate_group
            0x01,
            0x00,
            // non-audio track volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            (track.width & 0xFF00) >> 8,
            track.width & 0xFF,
            0x00,
            0x00,
            // width
            (track.height & 0xFF00) >> 8,
            track.height & 0xFF,
            0x00,
            0x00 // height
        ]);
        return box(types.tkhd, result);
    };
    /**
   * Generate a track fragment (traf) box. A traf box collects metadata
   * about tracks in a movie fragment (moof) box.
   */ traf = function(track) {
        var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
        trackFragmentHeader = box(types.tfhd, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x3a,
            // flags
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x00,
            0x00,
            0x00 // default_sample_flags
        ]));
        upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / MAX_UINT32);
        lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % MAX_UINT32);
        trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            // baseMediaDecodeTime
            upperWordBaseMediaDecodeTime >>> 24 & 0xFF,
            upperWordBaseMediaDecodeTime >>> 16 & 0xFF,
            upperWordBaseMediaDecodeTime >>> 8 & 0xFF,
            upperWordBaseMediaDecodeTime & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 24 & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 16 & 0xFF,
            lowerWordBaseMediaDecodeTime >>> 8 & 0xFF,
            lowerWordBaseMediaDecodeTime & 0xFF
        ])); // the data offset specifies the number of bytes from the start of
        // the containing moof to the first payload byte of the associated
        // mdat
        dataOffset = 92; // mdat header
        // audio tracks require less metadata
        if (track.type === "audio") {
            trackFragmentRun = trun$1(track, dataOffset);
            return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
        } // video tracks should contain an independent and disposable samples
        // box (sdtp)
        // generate one and adjust offsets to match
        sampleDependencyTable = sdtp(track);
        trackFragmentRun = trun$1(track, sampleDependencyTable.length + dataOffset);
        return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
    };
    /**
   * Generate a track box.
   * @param track {object} a track definition
   * @return {Uint8Array} the track box
   */ trak = function(track) {
        track.duration = track.duration || 0xffffffff;
        return box(types.trak, tkhd(track), mdia(track));
    };
    trex = function(track) {
        var result = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            (track.id & 0xFF000000) >> 24,
            (track.id & 0xFF0000) >> 16,
            (track.id & 0xFF00) >> 8,
            track.id & 0xFF,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // default_sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x01,
            0x00,
            0x01 // default_sample_flags
        ]); // the last two bytes of default_sample_flags is the sample
        // degradation priority, a hint about the importance of this sample
        // relative to others. Lower the degradation priority for all sample
        // types other than video.
        if (track.type !== "video") result[result.length - 1] = 0x00;
        return box(types.trex, result);
    };
    (function() {
        var audioTrun, videoTrun, trunHeader; // This method assumes all samples are uniform. That is, if a
        // duration is present for the first sample, it will be present for
        // all subsequent samples.
        // see ISO/IEC 14496-12:2012, Section 8.8.8.1
        trunHeader = function(samples, offset) {
            var durationPresent = 0, sizePresent = 0, flagsPresent = 0, compositionTimeOffset = 0; // trun flag constants
            if (samples.length) {
                if (samples[0].duration !== undefined) durationPresent = 0x1;
                if (samples[0].size !== undefined) sizePresent = 0x2;
                if (samples[0].flags !== undefined) flagsPresent = 0x4;
                if (samples[0].compositionTimeOffset !== undefined) compositionTimeOffset = 0x8;
            }
            return [
                0x00,
                // version 0
                0x00,
                durationPresent | sizePresent | flagsPresent | compositionTimeOffset,
                0x01,
                // flags
                (samples.length & 0xFF000000) >>> 24,
                (samples.length & 0xFF0000) >>> 16,
                (samples.length & 0xFF00) >>> 8,
                samples.length & 0xFF,
                // sample_count
                (offset & 0xFF000000) >>> 24,
                (offset & 0xFF0000) >>> 16,
                (offset & 0xFF00) >>> 8,
                offset & 0xFF // data_offset
            ];
        };
        videoTrun = function(track, offset) {
            var bytesOffest, bytes, header, samples, sample, i;
            samples = track.samples || [];
            offset += 20 + 16 * samples.length;
            header = trunHeader(samples, offset);
            bytes = new Uint8Array(header.length + samples.length * 16);
            bytes.set(header);
            bytesOffest = header.length;
            for(i = 0; i < samples.length; i++){
                sample = samples[i];
                bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
                bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
                bytes[bytesOffest++] = sample.flags.isLeading << 2 | sample.flags.dependsOn;
                bytes[bytesOffest++] = sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample;
                bytes[bytesOffest++] = sample.flags.degradationPriority & 61440;
                bytes[bytesOffest++] = sample.flags.degradationPriority & 0x0F; // sample_flags
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.compositionTimeOffset & 0xFF; // sample_composition_time_offset
            }
            return box(types.trun, bytes);
        };
        audioTrun = function(track, offset) {
            var bytes, bytesOffest, header, samples, sample, i;
            samples = track.samples || [];
            offset += 20 + 8 * samples.length;
            header = trunHeader(samples, offset);
            bytes = new Uint8Array(header.length + samples.length * 8);
            bytes.set(header);
            bytesOffest = header.length;
            for(i = 0; i < samples.length; i++){
                sample = samples[i];
                bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
                bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
                bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
                bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
                bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
            }
            return box(types.trun, bytes);
        };
        trun$1 = function(track, offset) {
            if (track.type === "audio") return audioTrun(track, offset);
            return videoTrun(track, offset);
        };
    })();
    var mp4Generator = {
        ftyp: ftyp,
        mdat: mdat,
        moof: moof,
        moov: moov,
        initSegment: function(tracks) {
            var fileType = ftyp(), movie = moov(tracks), result;
            result = new Uint8Array(fileType.byteLength + movie.byteLength);
            result.set(fileType);
            result.set(movie, fileType.byteLength);
            return result;
        }
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ // composed of the nal units that make up that frame
    // Also keep track of cummulative data about the frame from the nal units such
    // as the frame duration, starting pts, etc.
    var groupNalsIntoFrames = function(nalUnits) {
        var i, currentNal, currentFrame = [], frames = []; // TODO added for LHLS, make sure this is OK
        frames.byteLength = 0;
        frames.nalCount = 0;
        frames.duration = 0;
        currentFrame.byteLength = 0;
        for(i = 0; i < nalUnits.length; i++){
            currentNal = nalUnits[i]; // Split on 'aud'-type nal units
            if (currentNal.nalUnitType === "access_unit_delimiter_rbsp") {
                // Since the very first nal unit is expected to be an AUD
                // only push to the frames array when currentFrame is not empty
                if (currentFrame.length) {
                    currentFrame.duration = currentNal.dts - currentFrame.dts; // TODO added for LHLS, make sure this is OK
                    frames.byteLength += currentFrame.byteLength;
                    frames.nalCount += currentFrame.length;
                    frames.duration += currentFrame.duration;
                    frames.push(currentFrame);
                }
                currentFrame = [
                    currentNal
                ];
                currentFrame.byteLength = currentNal.data.byteLength;
                currentFrame.pts = currentNal.pts;
                currentFrame.dts = currentNal.dts;
            } else {
                // Specifically flag key frames for ease of use later
                if (currentNal.nalUnitType === "slice_layer_without_partitioning_rbsp_idr") currentFrame.keyFrame = true;
                currentFrame.duration = currentNal.dts - currentFrame.dts;
                currentFrame.byteLength += currentNal.data.byteLength;
                currentFrame.push(currentNal);
            }
        } // For the last frame, use the duration of the previous frame if we
        // have nothing better to go on
        if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) currentFrame.duration = frames[frames.length - 1].duration;
         // Push the final frame
        // TODO added for LHLS, make sure this is OK
        frames.byteLength += currentFrame.byteLength;
        frames.nalCount += currentFrame.length;
        frames.duration += currentFrame.duration;
        frames.push(currentFrame);
        return frames;
    }; // Convert an array of frames into an array of Gop with each Gop being composed
    // of the frames that make up that Gop
    // Also keep track of cummulative data about the Gop from the frames such as the
    // Gop duration, starting pts, etc.
    var groupFramesIntoGops = function(frames) {
        var i, currentFrame, currentGop = [], gops = []; // We must pre-set some of the values on the Gop since we
        // keep running totals of these values
        currentGop.byteLength = 0;
        currentGop.nalCount = 0;
        currentGop.duration = 0;
        currentGop.pts = frames[0].pts;
        currentGop.dts = frames[0].dts; // store some metadata about all the Gops
        gops.byteLength = 0;
        gops.nalCount = 0;
        gops.duration = 0;
        gops.pts = frames[0].pts;
        gops.dts = frames[0].dts;
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            if (currentFrame.keyFrame) {
                // Since the very first frame is expected to be an keyframe
                // only push to the gops array when currentGop is not empty
                if (currentGop.length) {
                    gops.push(currentGop);
                    gops.byteLength += currentGop.byteLength;
                    gops.nalCount += currentGop.nalCount;
                    gops.duration += currentGop.duration;
                }
                currentGop = [
                    currentFrame
                ];
                currentGop.nalCount = currentFrame.length;
                currentGop.byteLength = currentFrame.byteLength;
                currentGop.pts = currentFrame.pts;
                currentGop.dts = currentFrame.dts;
                currentGop.duration = currentFrame.duration;
            } else {
                currentGop.duration += currentFrame.duration;
                currentGop.nalCount += currentFrame.length;
                currentGop.byteLength += currentFrame.byteLength;
                currentGop.push(currentFrame);
            }
        }
        if (gops.length && currentGop.duration <= 0) currentGop.duration = gops[gops.length - 1].duration;
        gops.byteLength += currentGop.byteLength;
        gops.nalCount += currentGop.nalCount;
        gops.duration += currentGop.duration; // push the final Gop
        gops.push(currentGop);
        return gops;
    };
    /*
   * Search for the first keyframe in the GOPs and throw away all frames
   * until that keyframe. Then extend the duration of the pulled keyframe
   * and pull the PTS and DTS of the keyframe so that it covers the time
   * range of the frames that were disposed.
   *
   * @param {Array} gops video GOPs
   * @returns {Array} modified video GOPs
   */ var extendFirstKeyFrame = function(gops) {
        var currentGop;
        if (!gops[0][0].keyFrame && gops.length > 1) {
            // Remove the first GOP
            currentGop = gops.shift();
            gops.byteLength -= currentGop.byteLength;
            gops.nalCount -= currentGop.nalCount; // Extend the first frame of what is now the
            // first gop to cover the time period of the
            // frames we just removed
            gops[0][0].dts = currentGop.dts;
            gops[0][0].pts = currentGop.pts;
            gops[0][0].duration += currentGop.duration;
        }
        return gops;
    };
    /**
   * Default sample object
   * see ISO/IEC 14496-12:2012, section 8.6.4.3
   */ var createDefaultSample = function() {
        return {
            size: 0,
            flags: {
                isLeading: 0,
                dependsOn: 1,
                isDependedOn: 0,
                hasRedundancy: 0,
                degradationPriority: 0,
                isNonSyncSample: 1
            }
        };
    };
    /*
   * Collates information from a video frame into an object for eventual
   * entry into an MP4 sample table.
   *
   * @param {Object} frame the video frame
   * @param {Number} dataOffset the byte offset to position the sample
   * @return {Object} object containing sample table info for a frame
   */ var sampleForFrame = function(frame, dataOffset) {
        var sample = createDefaultSample();
        sample.dataOffset = dataOffset;
        sample.compositionTimeOffset = frame.pts - frame.dts;
        sample.duration = frame.duration;
        sample.size = 4 * frame.length; // Space for nal unit size
        sample.size += frame.byteLength;
        if (frame.keyFrame) {
            sample.flags.dependsOn = 2;
            sample.flags.isNonSyncSample = 0;
        }
        return sample;
    }; // generate the track's sample table from an array of gops
    var generateSampleTable$1 = function(gops, baseDataOffset) {
        var h, i, sample, currentGop, currentFrame, dataOffset = baseDataOffset || 0, samples = [];
        for(h = 0; h < gops.length; h++){
            currentGop = gops[h];
            for(i = 0; i < currentGop.length; i++){
                currentFrame = currentGop[i];
                sample = sampleForFrame(currentFrame, dataOffset);
                dataOffset += sample.size;
                samples.push(sample);
            }
        }
        return samples;
    }; // generate the track's raw mdat data from an array of gops
    var concatenateNalData = function(gops) {
        var h, i, j, currentGop, currentFrame, currentNal, dataOffset = 0, nalsByteLength = gops.byteLength, numberOfNals = gops.nalCount, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer); // For each Gop..
        for(h = 0; h < gops.length; h++){
            currentGop = gops[h]; // For each Frame..
            for(i = 0; i < currentGop.length; i++){
                currentFrame = currentGop[i]; // For each NAL..
                for(j = 0; j < currentFrame.length; j++){
                    currentNal = currentFrame[j];
                    view.setUint32(dataOffset, currentNal.data.byteLength);
                    dataOffset += 4;
                    data.set(currentNal.data, dataOffset);
                    dataOffset += currentNal.data.byteLength;
                }
            }
        }
        return data;
    }; // generate the track's sample table from a frame
    var generateSampleTableForFrame = function(frame, baseDataOffset) {
        var sample, dataOffset = baseDataOffset || 0, samples = [];
        sample = sampleForFrame(frame, dataOffset);
        samples.push(sample);
        return samples;
    }; // generate the track's raw mdat data from a frame
    var concatenateNalDataForFrame = function(frame) {
        var i, currentNal, dataOffset = 0, nalsByteLength = frame.byteLength, numberOfNals = frame.length, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer); // For each NAL..
        for(i = 0; i < frame.length; i++){
            currentNal = frame[i];
            view.setUint32(dataOffset, currentNal.data.byteLength);
            dataOffset += 4;
            data.set(currentNal.data, dataOffset);
            dataOffset += currentNal.data.byteLength;
        }
        return data;
    };
    var frameUtils$1 = {
        groupNalsIntoFrames: groupNalsIntoFrames,
        groupFramesIntoGops: groupFramesIntoGops,
        extendFirstKeyFrame: extendFirstKeyFrame,
        generateSampleTable: generateSampleTable$1,
        concatenateNalData: concatenateNalData,
        generateSampleTableForFrame: generateSampleTableForFrame,
        concatenateNalDataForFrame: concatenateNalDataForFrame
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var highPrefix = [
        33,
        16,
        5,
        32,
        164,
        27
    ];
    var lowPrefix = [
        33,
        65,
        108,
        84,
        1,
        2,
        4,
        8,
        168,
        2,
        4,
        8,
        17,
        191,
        252
    ];
    var zeroFill = function(count) {
        var a = [];
        while(count--)a.push(0);
        return a;
    };
    var makeTable = function(metaTable) {
        return Object.keys(metaTable).reduce(function(obj, key) {
            obj[key] = new Uint8Array(metaTable[key].reduce(function(arr, part) {
                return arr.concat(part);
            }, []));
            return obj;
        }, {});
    };
    var silence;
    var silence_1 = function() {
        if (!silence) {
            // Frames-of-silence to use for filling in missing AAC frames
            var coneOfSilence = {
                96000: [
                    highPrefix,
                    [
                        227,
                        64
                    ],
                    zeroFill(154),
                    [
                        56
                    ]
                ],
                88200: [
                    highPrefix,
                    [
                        231
                    ],
                    zeroFill(170),
                    [
                        56
                    ]
                ],
                64000: [
                    highPrefix,
                    [
                        248,
                        192
                    ],
                    zeroFill(240),
                    [
                        56
                    ]
                ],
                48000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        148,
                        128
                    ],
                    zeroFill(54),
                    [
                        112
                    ]
                ],
                44100: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        163,
                        128
                    ],
                    zeroFill(84),
                    [
                        112
                    ]
                ],
                32000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        234
                    ],
                    zeroFill(226),
                    [
                        112
                    ]
                ],
                24000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        255,
                        128
                    ],
                    zeroFill(268),
                    [
                        111,
                        112
                    ],
                    zeroFill(126),
                    [
                        224
                    ]
                ],
                16000: [
                    highPrefix,
                    [
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        255,
                        128
                    ],
                    zeroFill(268),
                    [
                        111,
                        255
                    ],
                    zeroFill(269),
                    [
                        223,
                        108
                    ],
                    zeroFill(195),
                    [
                        1,
                        192
                    ]
                ],
                12000: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        127,
                        248
                    ],
                    zeroFill(268),
                    [
                        6,
                        255,
                        240
                    ],
                    zeroFill(268),
                    [
                        13,
                        255,
                        224
                    ],
                    zeroFill(268),
                    [
                        27,
                        253,
                        128
                    ],
                    zeroFill(259),
                    [
                        56
                    ]
                ],
                11025: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        127,
                        248
                    ],
                    zeroFill(268),
                    [
                        6,
                        255,
                        240
                    ],
                    zeroFill(268),
                    [
                        13,
                        255,
                        224
                    ],
                    zeroFill(268),
                    [
                        27,
                        255,
                        192
                    ],
                    zeroFill(268),
                    [
                        55,
                        175,
                        128
                    ],
                    zeroFill(108),
                    [
                        112
                    ]
                ],
                8000: [
                    lowPrefix,
                    zeroFill(268),
                    [
                        3,
                        121,
                        16
                    ],
                    zeroFill(47),
                    [
                        7
                    ]
                ]
            };
            silence = makeTable(coneOfSilence);
        }
        return silence;
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ONE_SECOND_IN_TS$4 = 90000, // 90kHz clock
    secondsToVideoTs, secondsToAudioTs, videoTsToSeconds, audioTsToSeconds, audioTsToVideoTs, videoTsToAudioTs, metadataTsToSeconds;
    secondsToVideoTs = function(seconds) {
        return seconds * ONE_SECOND_IN_TS$4;
    };
    secondsToAudioTs = function(seconds, sampleRate) {
        return seconds * sampleRate;
    };
    videoTsToSeconds = function(timestamp) {
        return timestamp / ONE_SECOND_IN_TS$4;
    };
    audioTsToSeconds = function(timestamp, sampleRate) {
        return timestamp / sampleRate;
    };
    audioTsToVideoTs = function(timestamp, sampleRate) {
        return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
    };
    videoTsToAudioTs = function(timestamp, sampleRate) {
        return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
    };
    /**
   * Adjust ID3 tag or caption timing information by the timeline pts values
   * (if keepOriginalTimestamps is false) and convert to seconds
   */ metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
        return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
    };
    var clock$2 = {
        ONE_SECOND_IN_TS: ONE_SECOND_IN_TS$4,
        secondsToVideoTs: secondsToVideoTs,
        secondsToAudioTs: secondsToAudioTs,
        videoTsToSeconds: videoTsToSeconds,
        audioTsToSeconds: audioTsToSeconds,
        audioTsToVideoTs: audioTsToVideoTs,
        videoTsToAudioTs: videoTsToAudioTs,
        metadataTsToSeconds: metadataTsToSeconds
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var coneOfSilence = silence_1;
    var clock$1 = clock$2;
    /**
   * Sum the `byteLength` properties of the data in each AAC frame
   */ var sumFrameByteLengths = function(array) {
        var i, currentObj, sum = 0; // sum the byteLength's all each nal unit in the frame
        for(i = 0; i < array.length; i++){
            currentObj = array[i];
            sum += currentObj.data.byteLength;
        }
        return sum;
    }; // Possibly pad (prefix) the audio track with silence if appending this track
    // would lead to the introduction of a gap in the audio buffer
    var prefixWithSilence = function(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime) {
        var baseMediaDecodeTimeTs, frameDuration = 0, audioGapDuration = 0, audioFillFrameCount = 0, audioFillDuration = 0, silentFrame, i, firstFrame;
        if (!frames.length) return;
        baseMediaDecodeTimeTs = clock$1.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate); // determine frame clock duration based on sample rate, round up to avoid overfills
        frameDuration = Math.ceil(clock$1.ONE_SECOND_IN_TS / (track.samplerate / 1024));
        if (audioAppendStartTs && videoBaseMediaDecodeTime) {
            // insert the shortest possible amount (audio gap or audio to video gap)
            audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime); // number of full frames in the audio gap
            audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
            audioFillDuration = audioFillFrameCount * frameDuration;
        } // don't attempt to fill gaps smaller than a single frame or larger
        // than a half second
        if (audioFillFrameCount < 1 || audioFillDuration > clock$1.ONE_SECOND_IN_TS / 2) return;
        silentFrame = coneOfSilence()[track.samplerate];
        if (!silentFrame) // we don't have a silent frame pregenerated for the sample rate, so use a frame
        // from the content instead
        silentFrame = frames[0].data;
        for(i = 0; i < audioFillFrameCount; i++){
            firstFrame = frames[0];
            frames.splice(0, 0, {
                data: silentFrame,
                dts: firstFrame.dts - frameDuration,
                pts: firstFrame.pts - frameDuration
            });
        }
        track.baseMediaDecodeTime -= Math.floor(clock$1.videoTsToAudioTs(audioFillDuration, track.samplerate));
        return audioFillDuration;
    }; // If the audio segment extends before the earliest allowed dts
    // value, remove AAC frames until starts at or after the earliest
    // allowed DTS so that we don't end up with a negative baseMedia-
    // DecodeTime for the audio track
    var trimAdtsFramesByEarliestDts = function(adtsFrames, track, earliestAllowedDts) {
        if (track.minSegmentDts >= earliestAllowedDts) return adtsFrames;
         // We will need to recalculate the earliest segment Dts
        track.minSegmentDts = Infinity;
        return adtsFrames.filter(function(currentFrame) {
            // If this is an allowed frame, keep it and record it's Dts
            if (currentFrame.dts >= earliestAllowedDts) {
                track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
                track.minSegmentPts = track.minSegmentDts;
                return true;
            } // Otherwise, discard it
            return false;
        });
    }; // generate the track's raw mdat data from an array of frames
    var generateSampleTable = function(frames) {
        var i, currentFrame, samples = [];
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            samples.push({
                size: currentFrame.data.byteLength,
                duration: 1024 // For AAC audio, all samples contain 1024 samples
            });
        }
        return samples;
    }; // generate the track's sample table from an array of frames
    var concatenateFrameData = function(frames) {
        var i, currentFrame, dataOffset = 0, data = new Uint8Array(sumFrameByteLengths(frames));
        for(i = 0; i < frames.length; i++){
            currentFrame = frames[i];
            data.set(currentFrame.data, dataOffset);
            dataOffset += currentFrame.data.byteLength;
        }
        return data;
    };
    var audioFrameUtils$1 = {
        prefixWithSilence: prefixWithSilence,
        trimAdtsFramesByEarliestDts: trimAdtsFramesByEarliestDts,
        generateSampleTable: generateSampleTable,
        concatenateFrameData: concatenateFrameData
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ONE_SECOND_IN_TS$3 = clock$2.ONE_SECOND_IN_TS;
    /**
   * Store information about the start and end of the track and the
   * duration for each frame/sample we process in order to calculate
   * the baseMediaDecodeTime
   */ var collectDtsInfo = function(track, data) {
        if (typeof data.pts === "number") {
            if (track.timelineStartInfo.pts === undefined) track.timelineStartInfo.pts = data.pts;
            if (track.minSegmentPts === undefined) track.minSegmentPts = data.pts;
            else track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
            if (track.maxSegmentPts === undefined) track.maxSegmentPts = data.pts;
            else track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
        }
        if (typeof data.dts === "number") {
            if (track.timelineStartInfo.dts === undefined) track.timelineStartInfo.dts = data.dts;
            if (track.minSegmentDts === undefined) track.minSegmentDts = data.dts;
            else track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
            if (track.maxSegmentDts === undefined) track.maxSegmentDts = data.dts;
            else track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
        }
    };
    /**
   * Clear values used to calculate the baseMediaDecodeTime between
   * tracks
   */ var clearDtsInfo = function(track) {
        delete track.minSegmentDts;
        delete track.maxSegmentDts;
        delete track.minSegmentPts;
        delete track.maxSegmentPts;
    };
    /**
   * Calculate the track's baseMediaDecodeTime based on the earliest
   * DTS the transmuxer has ever seen and the minimum DTS for the
   * current track
   * @param track {object} track metadata configuration
   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ var calculateTrackBaseMediaDecodeTime = function(track, keepOriginalTimestamps) {
        var baseMediaDecodeTime, scale, minSegmentDts = track.minSegmentDts; // Optionally adjust the time so the first segment starts at zero.
        if (!keepOriginalTimestamps) minSegmentDts -= track.timelineStartInfo.dts;
         // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
        // we want the start of the first segment to be placed
        baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime; // Add to that the distance this segment is from the very first
        baseMediaDecodeTime += minSegmentDts; // baseMediaDecodeTime must not become negative
        baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
        if (track.type === "audio") {
            // Audio has a different clock equal to the sampling_rate so we need to
            // scale the PTS values into the clock rate of the track
            scale = track.samplerate / ONE_SECOND_IN_TS$3;
            baseMediaDecodeTime *= scale;
            baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
        }
        return baseMediaDecodeTime;
    };
    var trackDecodeInfo$1 = {
        clearDtsInfo: clearDtsInfo,
        calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
        collectDtsInfo: collectDtsInfo
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // payload type field to indicate how they are to be
    // interpreted. CEAS-708 caption content is always transmitted with
    // payload type 0x04.
    var USER_DATA_REGISTERED_ITU_T_T35 = 4, RBSP_TRAILING_BITS = 128;
    /**
    * Parse a supplemental enhancement information (SEI) NAL unit.
    * Stops parsing once a message of type ITU T T35 has been found.
    *
    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
    * @return {object} the parsed SEI payload
    * @see Rec. ITU-T H.264, 7.3.2.3.1
    */ var parseSei = function(bytes) {
        var i = 0, result = {
            payloadType: -1,
            payloadSize: 0
        }, payloadType = 0, payloadSize = 0; // go through the sei_rbsp parsing each each individual sei_message
        while(i < bytes.byteLength){
            // stop once we have hit the end of the sei_rbsp
            if (bytes[i] === RBSP_TRAILING_BITS) break;
             // Parse payload type
            while(bytes[i] === 0xFF){
                payloadType += 255;
                i++;
            }
            payloadType += bytes[i++]; // Parse payload size
            while(bytes[i] === 0xFF){
                payloadSize += 255;
                i++;
            }
            payloadSize += bytes[i++]; // this sei_message is a 608/708 caption so save it and break
            // there can only ever be one caption message in a frame's sei
            if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
                var userIdentifier = String.fromCharCode(bytes[i + 3], bytes[i + 4], bytes[i + 5], bytes[i + 6]);
                if (userIdentifier === "GA94") {
                    result.payloadType = payloadType;
                    result.payloadSize = payloadSize;
                    result.payload = bytes.subarray(i, i + payloadSize);
                    break;
                } else result.payload = void 0;
            } // skip the payload and parse the next message
            i += payloadSize;
            payloadType = 0;
            payloadSize = 0;
        }
        return result;
    }; // see ANSI/SCTE 128-1 (2013), section 8.1
    var parseUserData = function(sei) {
        // itu_t_t35_contry_code must be 181 (United States) for
        // captions
        if (sei.payload[0] !== 181) return null;
         // itu_t_t35_provider_code should be 49 (ATSC) for captions
        if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) return null;
         // the user_identifier should be "GA94" to indicate ATSC1 data
        if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== "GA94") return null;
         // finally, user_data_type_code should be 0x03 for caption data
        if (sei.payload[7] !== 0x03) return null;
         // return the user_data_type_structure and strip the trailing
        // marker bits
        return sei.payload.subarray(8, sei.payload.length - 1);
    }; // see CEA-708-D, section 4.4
    var parseCaptionPackets = function(pts, userData) {
        var results = [], i, count, offset, data; // if this is just filler, return immediately
        if (!(userData[0] & 0x40)) return results;
         // parse out the cc_data_1 and cc_data_2 fields
        count = userData[0] & 0x1f;
        for(i = 0; i < count; i++){
            offset = i * 3;
            data = {
                type: userData[offset + 2] & 0x03,
                pts: pts
            }; // capture cc data when cc_valid is 1
            if (userData[offset + 2] & 0x04) {
                data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
                results.push(data);
            }
        }
        return results;
    };
    var discardEmulationPreventionBytes$1 = function(data) {
        var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData; // Find all `Emulation Prevention Bytes`
        while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
            emulationPreventionBytesPositions.push(i + 2);
            i += 2;
        } else i++;
         // If no Emulation Prevention Bytes were found just return the original
        // array
        if (emulationPreventionBytesPositions.length === 0) return data;
         // Create a new array to hold the NAL unit data
        newLength = length - emulationPreventionBytesPositions.length;
        newData = new Uint8Array(newLength);
        var sourceIndex = 0;
        for(i = 0; i < newLength; sourceIndex++, i++){
            if (sourceIndex === emulationPreventionBytesPositions[0]) {
                // Skip this byte
                sourceIndex++; // Remove this position index
                emulationPreventionBytesPositions.shift();
            }
            newData[i] = data[sourceIndex];
        }
        return newData;
    }; // exports
    var captionPacketParser = {
        parseSei: parseSei,
        parseUserData: parseUserData,
        parseCaptionPackets: parseCaptionPackets,
        discardEmulationPreventionBytes: discardEmulationPreventionBytes$1,
        USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // Link To Transport
    // -----------------
    var Stream$7 = stream;
    var cea708Parser = captionPacketParser;
    var CaptionStream$2 = function(options) {
        options = options || {};
        CaptionStream$2.prototype.init.call(this); // parse708captions flag, default to true
        this.parse708captions_ = typeof options.parse708captions === "boolean" ? options.parse708captions : true;
        this.captionPackets_ = [];
        this.ccStreams_ = [
            new Cea608Stream(0, 0),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(0, 1),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(1, 0),
            // eslint-disable-line no-use-before-define
            new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
        ];
        if (this.parse708captions_) this.cc708Stream_ = new Cea708Stream({
            captionServices: options.captionServices
        }); // eslint-disable-line no-use-before-define
        this.reset(); // forward data and done events from CCs to this CaptionStream
        this.ccStreams_.forEach(function(cc) {
            cc.on("data", this.trigger.bind(this, "data"));
            cc.on("partialdone", this.trigger.bind(this, "partialdone"));
            cc.on("done", this.trigger.bind(this, "done"));
        }, this);
        if (this.parse708captions_) {
            this.cc708Stream_.on("data", this.trigger.bind(this, "data"));
            this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone"));
            this.cc708Stream_.on("done", this.trigger.bind(this, "done"));
        }
    };
    CaptionStream$2.prototype = new Stream$7();
    CaptionStream$2.prototype.push = function(event) {
        var sei, userData, newCaptionPackets; // only examine SEI NALs
        if (event.nalUnitType !== "sei_rbsp") return;
         // parse the sei
        sei = cea708Parser.parseSei(event.escapedRBSP); // no payload data, skip
        if (!sei.payload) return;
         // ignore everything but user_data_registered_itu_t_t35
        if (sei.payloadType !== cea708Parser.USER_DATA_REGISTERED_ITU_T_T35) return;
         // parse out the user data payload
        userData = cea708Parser.parseUserData(sei); // ignore unrecognized userData
        if (!userData) return;
         // Sometimes, the same segment # will be downloaded twice. To stop the
        // caption data from being processed twice, we track the latest dts we've
        // received and ignore everything with a dts before that. However, since
        // data for a specific dts can be split across packets on either side of
        // a segment boundary, we need to make sure we *don't* ignore the packets
        // from the *next* segment that have dts === this.latestDts_. By constantly
        // tracking the number of packets received with dts === this.latestDts_, we
        // know how many should be ignored once we start receiving duplicates.
        if (event.dts < this.latestDts_) {
            // We've started getting older data, so set the flag.
            this.ignoreNextEqualDts_ = true;
            return;
        } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
            this.numSameDts_--;
            if (!this.numSameDts_) // We've received the last duplicate packet, time to start processing again
            this.ignoreNextEqualDts_ = false;
            return;
        } // parse out CC data packets and save them for later
        newCaptionPackets = cea708Parser.parseCaptionPackets(event.pts, userData);
        this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
        if (this.latestDts_ !== event.dts) this.numSameDts_ = 0;
        this.numSameDts_++;
        this.latestDts_ = event.dts;
    };
    CaptionStream$2.prototype.flushCCStreams = function(flushType) {
        this.ccStreams_.forEach(function(cc) {
            return flushType === "flush" ? cc.flush() : cc.partialFlush();
        }, this);
    };
    CaptionStream$2.prototype.flushStream = function(flushType) {
        // make sure we actually parsed captions before proceeding
        if (!this.captionPackets_.length) {
            this.flushCCStreams(flushType);
            return;
        } // In Chrome, the Array#sort function is not stable so add a
        // presortIndex that we can use to ensure we get a stable-sort
        this.captionPackets_.forEach(function(elem, idx) {
            elem.presortIndex = idx;
        }); // sort caption byte-pairs based on their PTS values
        this.captionPackets_.sort(function(a, b) {
            if (a.pts === b.pts) return a.presortIndex - b.presortIndex;
            return a.pts - b.pts;
        });
        this.captionPackets_.forEach(function(packet) {
            if (packet.type < 2) // Dispatch packet to the right Cea608Stream
            this.dispatchCea608Packet(packet);
            else // Dispatch packet to the Cea708Stream
            this.dispatchCea708Packet(packet);
        }, this);
        this.captionPackets_.length = 0;
        this.flushCCStreams(flushType);
    };
    CaptionStream$2.prototype.flush = function() {
        return this.flushStream("flush");
    }; // Only called if handling partial data
    CaptionStream$2.prototype.partialFlush = function() {
        return this.flushStream("partialFlush");
    };
    CaptionStream$2.prototype.reset = function() {
        this.latestDts_ = null;
        this.ignoreNextEqualDts_ = false;
        this.numSameDts_ = 0;
        this.activeCea608Channel_ = [
            null,
            null
        ];
        this.ccStreams_.forEach(function(ccStream) {
            ccStream.reset();
        });
    }; // From the CEA-608 spec:
    /*
   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
   * to switch to captioning or Text.
  */ // With that in mind, we ignore any data between an XDS control code and a
    // subsequent closed-captioning control code.
    CaptionStream$2.prototype.dispatchCea608Packet = function(packet) {
        // NOTE: packet.type is the CEA608 field
        if (this.setsTextOrXDSActive(packet)) this.activeCea608Channel_[packet.type] = null;
        else if (this.setsChannel1Active(packet)) this.activeCea608Channel_[packet.type] = 0;
        else if (this.setsChannel2Active(packet)) this.activeCea608Channel_[packet.type] = 1;
        if (this.activeCea608Channel_[packet.type] === null) // If we haven't received anything to set the active channel, or the
        // packets are Text/XDS data, discard the data; we don't want jumbled
        // captions
        return;
        this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
    };
    CaptionStream$2.prototype.setsChannel1Active = function(packet) {
        return (packet.ccData & 0x7800) === 0x1000;
    };
    CaptionStream$2.prototype.setsChannel2Active = function(packet) {
        return (packet.ccData & 0x7800) === 0x1800;
    };
    CaptionStream$2.prototype.setsTextOrXDSActive = function(packet) {
        return (packet.ccData & 0x7100) === 0x0100 || (packet.ccData & 0x78fe) === 0x102a || (packet.ccData & 0x78fe) === 0x182a;
    };
    CaptionStream$2.prototype.dispatchCea708Packet = function(packet) {
        if (this.parse708captions_) this.cc708Stream_.push(packet);
    }; // ----------------------
    // Session to Application
    // ----------------------
    // This hash maps special and extended character codes to their
    // proper Unicode equivalent. The first one-byte key is just a
    // non-standard character code. The two-byte keys that follow are
    // the extended CEA708 character codes, along with the preceding
    // 0x10 extended character byte to distinguish these codes from
    // non-extended character codes. Every CEA708 character code that
    // is not in this object maps directly to a standard unicode
    // character code.
    // The transparent space and non-breaking transparent space are
    // technically not fully supported since there is no code to
    // make them transparent, so they have normal non-transparent
    // stand-ins.
    // The special closed caption (CC) character isn't a standard
    // unicode character, so a fairly similar unicode character was
    // chosen in it's place.
    var CHARACTER_TRANSLATION_708 = {
        0x7f: 0x266a,
        // ♪
        0x1020: 0x20,
        // Transparent Space
        0x1021: 0xa0,
        // Nob-breaking Transparent Space
        0x1025: 0x2026,
        // …
        0x102a: 0x0160,
        // Š
        0x102c: 0x0152,
        // Œ
        0x1030: 0x2588,
        // █
        0x1031: 0x2018,
        // ‘
        0x1032: 0x2019,
        // ’
        0x1033: 0x201c,
        // “
        0x1034: 0x201d,
        // ”
        0x1035: 0x2022,
        // •
        0x1039: 0x2122,
        // ™
        0x103a: 0x0161,
        // š
        0x103c: 0x0153,
        // œ
        0x103d: 0x2120,
        // ℠
        0x103f: 0x0178,
        // Ÿ
        0x1076: 0x215b,
        // ⅛
        0x1077: 0x215c,
        // ⅜
        0x1078: 0x215d,
        // ⅝
        0x1079: 0x215e,
        // ⅞
        0x107a: 0x23d0,
        // ⏐
        0x107b: 0x23a4,
        // ⎤
        0x107c: 0x23a3,
        // ⎣
        0x107d: 0x23af,
        // ⎯
        0x107e: 0x23a6,
        // ⎦
        0x107f: 0x23a1,
        // ⎡
        0x10a0: 0x3138 // ㄸ (CC char)
    };
    var get708CharFromCode = function(code) {
        var newCode = CHARACTER_TRANSLATION_708[code] || code;
        if (code & 0x1000 && code === newCode) // Invalid extended code
        return "";
        return String.fromCharCode(newCode);
    };
    var within708TextBlock = function(b) {
        return 0x20 <= b && b <= 0x7f || 0xa0 <= b && b <= 0xff;
    };
    var Cea708Window = function(windowNum) {
        this.windowNum = windowNum;
        this.reset();
    };
    Cea708Window.prototype.reset = function() {
        this.clearText();
        this.pendingNewLine = false;
        this.winAttr = {};
        this.penAttr = {};
        this.penLoc = {};
        this.penColor = {}; // These default values are arbitrary,
        // defineWindow will usually override them
        this.visible = 0;
        this.rowLock = 0;
        this.columnLock = 0;
        this.priority = 0;
        this.relativePositioning = 0;
        this.anchorVertical = 0;
        this.anchorHorizontal = 0;
        this.anchorPoint = 0;
        this.rowCount = 1;
        this.virtualRowCount = this.rowCount + 1;
        this.columnCount = 41;
        this.windowStyle = 0;
        this.penStyle = 0;
    };
    Cea708Window.prototype.getText = function() {
        return this.rows.join("\n");
    };
    Cea708Window.prototype.clearText = function() {
        this.rows = [
            ""
        ];
        this.rowIdx = 0;
    };
    Cea708Window.prototype.newLine = function(pts) {
        if (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow === "function") this.beforeRowOverflow(pts);
        if (this.rows.length > 0) {
            this.rows.push("");
            this.rowIdx++;
        } // Show all virtual rows since there's no visible scrolling
        while(this.rows.length > this.virtualRowCount){
            this.rows.shift();
            this.rowIdx--;
        }
    };
    Cea708Window.prototype.isEmpty = function() {
        if (this.rows.length === 0) return true;
        else if (this.rows.length === 1) return this.rows[0] === "";
        return false;
    };
    Cea708Window.prototype.addText = function(text) {
        this.rows[this.rowIdx] += text;
    };
    Cea708Window.prototype.backspace = function() {
        if (!this.isEmpty()) {
            var row = this.rows[this.rowIdx];
            this.rows[this.rowIdx] = row.substr(0, row.length - 1);
        }
    };
    var Cea708Service = function(serviceNum, encoding, stream) {
        this.serviceNum = serviceNum;
        this.text = "";
        this.currentWindow = new Cea708Window(-1);
        this.windows = [];
        this.stream = stream; // Try to setup a TextDecoder if an `encoding` value was provided
        if (typeof encoding === "string") this.createTextDecoder(encoding);
    };
    /**
   * Initialize service windows
   * Must be run before service use
   *
   * @param  {Integer}  pts               PTS value
   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
   */ Cea708Service.prototype.init = function(pts, beforeRowOverflow) {
        this.startPts = pts;
        for(var win = 0; win < 8; win++){
            this.windows[win] = new Cea708Window(win);
            if (typeof beforeRowOverflow === "function") this.windows[win].beforeRowOverflow = beforeRowOverflow;
        }
    };
    /**
   * Set current window of service to be affected by commands
   *
   * @param  {Integer} windowNum Window number
   */ Cea708Service.prototype.setCurrentWindow = function(windowNum) {
        this.currentWindow = this.windows[windowNum];
    };
    /**
   * Try to create a TextDecoder if it is natively supported
   */ Cea708Service.prototype.createTextDecoder = function(encoding) {
        if (typeof TextDecoder === "undefined") this.stream.trigger("log", {
            level: "warn",
            message: "The `encoding` option is unsupported without TextDecoder support"
        });
        else try {
            this.textDecoder_ = new TextDecoder(encoding);
        } catch (error) {
            this.stream.trigger("log", {
                level: "warn",
                message: "TextDecoder could not be created with " + encoding + " encoding. " + error
            });
        }
    };
    var Cea708Stream = function(options) {
        options = options || {};
        Cea708Stream.prototype.init.call(this);
        var self1 = this;
        var captionServices = options.captionServices || {};
        var captionServiceEncodings = {};
        var serviceProps; // Get service encodings from captionServices option block
        Object.keys(captionServices).forEach((serviceName)=>{
            serviceProps = captionServices[serviceName];
            if (/^SERVICE/.test(serviceName)) captionServiceEncodings[serviceName] = serviceProps.encoding;
        });
        this.serviceEncodings = captionServiceEncodings;
        this.current708Packet = null;
        this.services = {};
        this.push = function(packet) {
            if (packet.type === 3) {
                // 708 packet start
                self1.new708Packet();
                self1.add708Bytes(packet);
            } else {
                if (self1.current708Packet === null) // This should only happen at the start of a file if there's no packet start.
                self1.new708Packet();
                self1.add708Bytes(packet);
            }
        };
    };
    Cea708Stream.prototype = new Stream$7();
    /**
   * Push current 708 packet, create new 708 packet.
   */ Cea708Stream.prototype.new708Packet = function() {
        if (this.current708Packet !== null) this.push708Packet();
        this.current708Packet = {
            data: [],
            ptsVals: []
        };
    };
    /**
   * Add pts and both bytes from packet into current 708 packet.
   */ Cea708Stream.prototype.add708Bytes = function(packet) {
        var data = packet.ccData;
        var byte0 = data >>> 8;
        var byte1 = data & 0xff; // I would just keep a list of packets instead of bytes, but it isn't clear in the spec
        // that service blocks will always line up with byte pairs.
        this.current708Packet.ptsVals.push(packet.pts);
        this.current708Packet.data.push(byte0);
        this.current708Packet.data.push(byte1);
    };
    /**
   * Parse completed 708 packet into service blocks and push each service block.
   */ Cea708Stream.prototype.push708Packet = function() {
        var packet708 = this.current708Packet;
        var packetData = packet708.data;
        var serviceNum = null;
        var blockSize = null;
        var i = 0;
        var b = packetData[i++];
        packet708.seq = b >> 6;
        packet708.sizeCode = b & 0x3f; // 0b00111111;
        for(; i < packetData.length; i++){
            b = packetData[i++];
            serviceNum = b >> 5;
            blockSize = b & 0x1f; // 0b00011111
            if (serviceNum === 7 && blockSize > 0) {
                // Extended service num
                b = packetData[i++];
                serviceNum = b;
            }
            this.pushServiceBlock(serviceNum, i, blockSize);
            if (blockSize > 0) i += blockSize - 1;
        }
    };
    /**
   * Parse service block, execute commands, read text.
   *
   * Note: While many of these commands serve important purposes,
   * many others just parse out the parameters or attributes, but
   * nothing is done with them because this is not a full and complete
   * implementation of the entire 708 spec.
   *
   * @param  {Integer} serviceNum Service number
   * @param  {Integer} start      Start index of the 708 packet data
   * @param  {Integer} size       Block size
   */ Cea708Stream.prototype.pushServiceBlock = function(serviceNum, start, size) {
        var b;
        var i = start;
        var packetData = this.current708Packet.data;
        var service = this.services[serviceNum];
        if (!service) service = this.initService(serviceNum, i);
        for(; i < start + size && i < packetData.length; i++){
            b = packetData[i];
            if (within708TextBlock(b)) i = this.handleText(i, service);
            else if (b === 0x18) i = this.multiByteCharacter(i, service);
            else if (b === 0x10) i = this.extendedCommands(i, service);
            else if (0x80 <= b && b <= 0x87) i = this.setCurrentWindow(i, service);
            else if (0x98 <= b && b <= 0x9f) i = this.defineWindow(i, service);
            else if (b === 0x88) i = this.clearWindows(i, service);
            else if (b === 0x8c) i = this.deleteWindows(i, service);
            else if (b === 0x89) i = this.displayWindows(i, service);
            else if (b === 0x8a) i = this.hideWindows(i, service);
            else if (b === 0x8b) i = this.toggleWindows(i, service);
            else if (b === 0x97) i = this.setWindowAttributes(i, service);
            else if (b === 0x90) i = this.setPenAttributes(i, service);
            else if (b === 0x91) i = this.setPenColor(i, service);
            else if (b === 0x92) i = this.setPenLocation(i, service);
            else if (b === 0x8f) service = this.reset(i, service);
            else if (b === 0x08) // BS: Backspace
            service.currentWindow.backspace();
            else if (b === 0x0c) // FF: Form feed
            service.currentWindow.clearText();
            else if (b === 0x0d) // CR: Carriage return
            service.currentWindow.pendingNewLine = true;
            else if (b === 0x0e) // HCR: Horizontal carriage return
            service.currentWindow.clearText();
            else if (b === 0x8d) // DLY: Delay, nothing to do
            i++;
        }
    };
    /**
   * Execute an extended command
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.extendedCommands = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        if (within708TextBlock(b)) i = this.handleText(i, service, {
            isExtended: true
        });
        return i;
    };
    /**
   * Get PTS value of a given byte index
   *
   * @param  {Integer} byteIndex  Index of the byte
   * @return {Integer}            PTS
   */ Cea708Stream.prototype.getPts = function(byteIndex) {
        // There's 1 pts value per 2 bytes
        return this.current708Packet.ptsVals[Math.floor(byteIndex / 2)];
    };
    /**
   * Initializes a service
   *
   * @param  {Integer} serviceNum Service number
   * @return {Service}            Initialized service object
   */ Cea708Stream.prototype.initService = function(serviceNum, i) {
        var serviceName = "SERVICE" + serviceNum;
        var self1 = this;
        var serviceName;
        var encoding;
        if (serviceName in this.serviceEncodings) encoding = this.serviceEncodings[serviceName];
        this.services[serviceNum] = new Cea708Service(serviceNum, encoding, self1);
        this.services[serviceNum].init(this.getPts(i), function(pts) {
            self1.flushDisplayed(pts, self1.services[serviceNum]);
        });
        return this.services[serviceNum];
    };
    /**
   * Execute text writing to current window
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.handleText = function(i, service, options) {
        var isExtended = options && options.isExtended;
        var isMultiByte = options && options.isMultiByte;
        var packetData = this.current708Packet.data;
        var extended = isExtended ? 0x1000 : 0x0000;
        var currentByte = packetData[i];
        var nextByte = packetData[i + 1];
        var win = service.currentWindow;
        var char;
        var charCodeArray; // Converts an array of bytes to a unicode hex string.
        function toHexString(byteArray) {
            return byteArray.map((byte)=>{
                return ("0" + (byte & 0xFF).toString(16)).slice(-2);
            }).join("");
        }
        if (isMultiByte) {
            charCodeArray = [
                currentByte,
                nextByte
            ];
            i++;
        } else charCodeArray = [
            currentByte
        ];
         // Use the TextDecoder if one was created for this service
        if (service.textDecoder_ && !isExtended) char = service.textDecoder_.decode(new Uint8Array(charCodeArray));
        else // We assume any multi-byte char without a decoder is unicode.
        if (isMultiByte) {
            const unicode = toHexString(charCodeArray); // Takes a unicode hex string and creates a single character.
            char = String.fromCharCode(parseInt(unicode, 16));
        } else char = get708CharFromCode(extended | currentByte);
        if (win.pendingNewLine && !win.isEmpty()) win.newLine(this.getPts(i));
        win.pendingNewLine = false;
        win.addText(char);
        return i;
    };
    /**
   * Handle decoding of multibyte character
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.multiByteCharacter = function(i, service) {
        var packetData = this.current708Packet.data;
        var firstByte = packetData[i + 1];
        var secondByte = packetData[i + 2];
        if (within708TextBlock(firstByte) && within708TextBlock(secondByte)) i = this.handleText(++i, service, {
            isMultiByte: true
        });
        return i;
    };
    /**
   * Parse and execute the CW# command.
   *
   * Set the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setCurrentWindow = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var windowNum = b & 0x07;
        service.setCurrentWindow(windowNum);
        return i;
    };
    /**
   * Parse and execute the DF# command.
   *
   * Define a window and set it as the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.defineWindow = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var windowNum = b & 0x07;
        service.setCurrentWindow(windowNum);
        var win = service.currentWindow;
        b = packetData[++i];
        win.visible = (b & 0x20) >> 5; // v
        win.rowLock = (b & 0x10) >> 4; // rl
        win.columnLock = (b & 0x08) >> 3; // cl
        win.priority = b & 0x07; // p
        b = packetData[++i];
        win.relativePositioning = (b & 0x80) >> 7; // rp
        win.anchorVertical = b & 0x7f; // av
        b = packetData[++i];
        win.anchorHorizontal = b; // ah
        b = packetData[++i];
        win.anchorPoint = (b & 0xf0) >> 4; // ap
        win.rowCount = b & 0x0f; // rc
        b = packetData[++i];
        win.columnCount = b & 0x3f; // cc
        b = packetData[++i];
        win.windowStyle = (b & 0x38) >> 3; // ws
        win.penStyle = b & 0x07; // ps
        // The spec says there are (rowCount+1) "virtual rows"
        win.virtualRowCount = win.rowCount + 1;
        return i;
    };
    /**
   * Parse and execute the SWA command.
   *
   * Set attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setWindowAttributes = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var winAttr = service.currentWindow.winAttr;
        b = packetData[++i];
        winAttr.fillOpacity = (b & 0xc0) >> 6; // fo
        winAttr.fillRed = (b & 0x30) >> 4; // fr
        winAttr.fillGreen = (b & 0x0c) >> 2; // fg
        winAttr.fillBlue = b & 0x03; // fb
        b = packetData[++i];
        winAttr.borderType = (b & 0xc0) >> 6; // bt
        winAttr.borderRed = (b & 0x30) >> 4; // br
        winAttr.borderGreen = (b & 0x0c) >> 2; // bg
        winAttr.borderBlue = b & 0x03; // bb
        b = packetData[++i];
        winAttr.borderType += (b & 0x80) >> 5; // bt
        winAttr.wordWrap = (b & 0x40) >> 6; // ww
        winAttr.printDirection = (b & 0x30) >> 4; // pd
        winAttr.scrollDirection = (b & 0x0c) >> 2; // sd
        winAttr.justify = b & 0x03; // j
        b = packetData[++i];
        winAttr.effectSpeed = (b & 0xf0) >> 4; // es
        winAttr.effectDirection = (b & 0x0c) >> 2; // ed
        winAttr.displayEffect = b & 0x03; // de
        return i;
    };
    /**
   * Gather text from all displayed windows and push a caption to output.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   */ Cea708Stream.prototype.flushDisplayed = function(pts, service) {
        var displayedText = []; // TODO: Positioning not supported, displaying multiple windows will not necessarily
        // display text in the correct order, but sample files so far have not shown any issue.
        for(var winId = 0; winId < 8; winId++)if (service.windows[winId].visible && !service.windows[winId].isEmpty()) displayedText.push(service.windows[winId].getText());
        service.endPts = pts;
        service.text = displayedText.join("\n\n");
        this.pushCaption(service);
        service.startPts = pts;
    };
    /**
   * Push a caption to output if the caption contains text.
   *
   * @param  {Service} service  The service object to be affected
   */ Cea708Stream.prototype.pushCaption = function(service) {
        if (service.text !== "") {
            this.trigger("data", {
                startPts: service.startPts,
                endPts: service.endPts,
                text: service.text,
                stream: "cc708_" + service.serviceNum
            });
            service.text = "";
            service.startPts = service.endPts;
        }
    };
    /**
   * Parse and execute the DSW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.displayWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible = 1;
        return i;
    };
    /**
   * Parse and execute the HDW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.hideWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible = 0;
        return i;
    };
    /**
   * Parse and execute the TGW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.toggleWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].visible ^= 1;
        return i;
    };
    /**
   * Parse and execute the CLW command.
   *
   * Clear text of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.clearWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].clearText();
        return i;
    };
    /**
   * Parse and execute the DLW command.
   *
   * Re-initialize windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.deleteWindows = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[++i];
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        for(var winId = 0; winId < 8; winId++)if (b & 0x01 << winId) service.windows[winId].reset();
        return i;
    };
    /**
   * Parse and execute the SPA command.
   *
   * Set pen attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenAttributes = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penAttr = service.currentWindow.penAttr;
        b = packetData[++i];
        penAttr.textTag = (b & 0xf0) >> 4; // tt
        penAttr.offset = (b & 0x0c) >> 2; // o
        penAttr.penSize = b & 0x03; // s
        b = packetData[++i];
        penAttr.italics = (b & 0x80) >> 7; // i
        penAttr.underline = (b & 0x40) >> 6; // u
        penAttr.edgeType = (b & 0x38) >> 3; // et
        penAttr.fontStyle = b & 0x07; // fs
        return i;
    };
    /**
   * Parse and execute the SPC command.
   *
   * Set pen color of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenColor = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penColor = service.currentWindow.penColor;
        b = packetData[++i];
        penColor.fgOpacity = (b & 0xc0) >> 6; // fo
        penColor.fgRed = (b & 0x30) >> 4; // fr
        penColor.fgGreen = (b & 0x0c) >> 2; // fg
        penColor.fgBlue = b & 0x03; // fb
        b = packetData[++i];
        penColor.bgOpacity = (b & 0xc0) >> 6; // bo
        penColor.bgRed = (b & 0x30) >> 4; // br
        penColor.bgGreen = (b & 0x0c) >> 2; // bg
        penColor.bgBlue = b & 0x03; // bb
        b = packetData[++i];
        penColor.edgeRed = (b & 0x30) >> 4; // er
        penColor.edgeGreen = (b & 0x0c) >> 2; // eg
        penColor.edgeBlue = b & 0x03; // eb
        return i;
    };
    /**
   * Parse and execute the SPL command.
   *
   * Set pen location of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */ Cea708Stream.prototype.setPenLocation = function(i, service) {
        var packetData = this.current708Packet.data;
        var b = packetData[i];
        var penLoc = service.currentWindow.penLoc; // Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
        service.currentWindow.pendingNewLine = true;
        b = packetData[++i];
        penLoc.row = b & 0x0f; // r
        b = packetData[++i];
        penLoc.column = b & 0x3f; // c
        return i;
    };
    /**
   * Execute the RST command.
   *
   * Reset service to a clean slate. Re-initialize.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Service}          Re-initialized service
   */ Cea708Stream.prototype.reset = function(i, service) {
        var pts = this.getPts(i);
        this.flushDisplayed(pts, service);
        return this.initService(service.serviceNum, i);
    }; // This hash maps non-ASCII, special, and extended character codes to their
    // proper Unicode equivalent. The first keys that are only a single byte
    // are the non-standard ASCII characters, which simply map the CEA608 byte
    // to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
    // character codes, but have their MSB bitmasked with 0x03 so that a lookup
    // can be performed regardless of the field and data channel on which the
    // character code was received.
    var CHARACTER_TRANSLATION = {
        0x2a: 0xe1,
        // á
        0x5c: 0xe9,
        // é
        0x5e: 0xed,
        // í
        0x5f: 0xf3,
        // ó
        0x60: 0xfa,
        // ú
        0x7b: 0xe7,
        // ç
        0x7c: 0xf7,
        // ÷
        0x7d: 0xd1,
        // Ñ
        0x7e: 0xf1,
        // ñ
        0x7f: 0x2588,
        // █
        0x0130: 0xae,
        // ®
        0x0131: 0xb0,
        // °
        0x0132: 0xbd,
        // ½
        0x0133: 0xbf,
        // ¿
        0x0134: 0x2122,
        // ™
        0x0135: 0xa2,
        // ¢
        0x0136: 0xa3,
        // £
        0x0137: 0x266a,
        // ♪
        0x0138: 0xe0,
        // à
        0x0139: 0xa0,
        //
        0x013a: 0xe8,
        // è
        0x013b: 0xe2,
        // â
        0x013c: 0xea,
        // ê
        0x013d: 0xee,
        // î
        0x013e: 0xf4,
        // ô
        0x013f: 0xfb,
        // û
        0x0220: 0xc1,
        // Á
        0x0221: 0xc9,
        // É
        0x0222: 0xd3,
        // Ó
        0x0223: 0xda,
        // Ú
        0x0224: 0xdc,
        // Ü
        0x0225: 0xfc,
        // ü
        0x0226: 0x2018,
        // ‘
        0x0227: 0xa1,
        // ¡
        0x0228: 0x2a,
        // *
        0x0229: 0x27,
        // '
        0x022a: 0x2014,
        // —
        0x022b: 0xa9,
        // ©
        0x022c: 0x2120,
        // ℠
        0x022d: 0x2022,
        // •
        0x022e: 0x201c,
        // “
        0x022f: 0x201d,
        // ”
        0x0230: 0xc0,
        // À
        0x0231: 0xc2,
        // Â
        0x0232: 0xc7,
        // Ç
        0x0233: 0xc8,
        // È
        0x0234: 0xca,
        // Ê
        0x0235: 0xcb,
        // Ë
        0x0236: 0xeb,
        // ë
        0x0237: 0xce,
        // Î
        0x0238: 0xcf,
        // Ï
        0x0239: 0xef,
        // ï
        0x023a: 0xd4,
        // Ô
        0x023b: 0xd9,
        // Ù
        0x023c: 0xf9,
        // ù
        0x023d: 0xdb,
        // Û
        0x023e: 0xab,
        // «
        0x023f: 0xbb,
        // »
        0x0320: 0xc3,
        // Ã
        0x0321: 0xe3,
        // ã
        0x0322: 0xcd,
        // Í
        0x0323: 0xcc,
        // Ì
        0x0324: 0xec,
        // ì
        0x0325: 0xd2,
        // Ò
        0x0326: 0xf2,
        // ò
        0x0327: 0xd5,
        // Õ
        0x0328: 0xf5,
        // õ
        0x0329: 0x7b,
        // {
        0x032a: 0x7d,
        // }
        0x032b: 0x5c,
        // \
        0x032c: 0x5e,
        // ^
        0x032d: 0x5f,
        // _
        0x032e: 0x7c,
        // |
        0x032f: 0x7e,
        // ~
        0x0330: 0xc4,
        // Ä
        0x0331: 0xe4,
        // ä
        0x0332: 0xd6,
        // Ö
        0x0333: 0xf6,
        // ö
        0x0334: 0xdf,
        // ß
        0x0335: 0xa5,
        // ¥
        0x0336: 0xa4,
        // ¤
        0x0337: 0x2502,
        // │
        0x0338: 0xc5,
        // Å
        0x0339: 0xe5,
        // å
        0x033a: 0xd8,
        // Ø
        0x033b: 0xf8,
        // ø
        0x033c: 0x250c,
        // ┌
        0x033d: 0x2510,
        // ┐
        0x033e: 0x2514,
        // └
        0x033f: 0x2518 // ┘
    };
    var getCharFromCode = function(code) {
        if (code === null) return "";
        code = CHARACTER_TRANSLATION[code] || code;
        return String.fromCharCode(code);
    }; // the index of the last row in a CEA-608 display buffer
    var BOTTOM_ROW = 14; // This array is used for mapping PACs -> row #, since there's no way of
    // getting it through bit logic.
    var ROWS = [
        0x1100,
        0x1120,
        0x1200,
        0x1220,
        0x1500,
        0x1520,
        0x1600,
        0x1620,
        0x1700,
        0x1720,
        0x1000,
        0x1300,
        0x1320,
        0x1400,
        0x1420
    ]; // CEA-608 captions are rendered onto a 34x15 matrix of character
    // cells. The "bottom" row is the last element in the outer array.
    // We keep track of positioning information as we go by storing the
    // number of indentations and the tab offset in this buffer.
    var createDisplayBuffer = function() {
        var result = [], i = BOTTOM_ROW + 1;
        while(i--)result.push({
            text: "",
            indent: 0,
            offset: 0
        });
        return result;
    };
    var Cea608Stream = function(field, dataChannel) {
        Cea608Stream.prototype.init.call(this);
        this.field_ = field || 0;
        this.dataChannel_ = dataChannel || 0;
        this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1);
        this.setConstants();
        this.reset();
        this.push = function(packet) {
            var data, swap, char0, char1, text; // remove the parity bits
            data = packet.ccData & 0x7f7f; // ignore duplicate control codes; the spec demands they're sent twice
            if (data === this.lastControlCode_) {
                this.lastControlCode_ = null;
                return;
            } // Store control codes
            if ((data & 0xf000) === 0x1000) this.lastControlCode_ = data;
            else if (data !== this.PADDING_) this.lastControlCode_ = null;
            char0 = data >>> 8;
            char1 = data & 0xff;
            if (data === this.PADDING_) return;
            else if (data === this.RESUME_CAPTION_LOADING_) this.mode_ = "popOn";
            else if (data === this.END_OF_CAPTION_) {
                // If an EOC is received while in paint-on mode, the displayed caption
                // text should be swapped to non-displayed memory as if it was a pop-on
                // caption. Because of that, we should explicitly switch back to pop-on
                // mode
                this.mode_ = "popOn";
                this.clearFormatting(packet.pts); // if a caption was being displayed, it's gone now
                this.flushDisplayed(packet.pts); // flip memory
                swap = this.displayed_;
                this.displayed_ = this.nonDisplayed_;
                this.nonDisplayed_ = swap; // start measuring the time to display the caption
                this.startPts_ = packet.pts;
            } else if (data === this.ROLL_UP_2_ROWS_) {
                this.rollUpRows_ = 2;
                this.setRollUp(packet.pts);
            } else if (data === this.ROLL_UP_3_ROWS_) {
                this.rollUpRows_ = 3;
                this.setRollUp(packet.pts);
            } else if (data === this.ROLL_UP_4_ROWS_) {
                this.rollUpRows_ = 4;
                this.setRollUp(packet.pts);
            } else if (data === this.CARRIAGE_RETURN_) {
                this.clearFormatting(packet.pts);
                this.flushDisplayed(packet.pts);
                this.shiftRowsUp_();
                this.startPts_ = packet.pts;
            } else if (data === this.BACKSPACE_) {
                if (this.mode_ === "popOn") this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1);
                else this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
            } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
                this.flushDisplayed(packet.pts);
                this.displayed_ = createDisplayBuffer();
            } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) this.nonDisplayed_ = createDisplayBuffer();
            else if (data === this.RESUME_DIRECT_CAPTIONING_) {
                if (this.mode_ !== "paintOn") {
                    // NOTE: This should be removed when proper caption positioning is
                    // implemented
                    this.flushDisplayed(packet.pts);
                    this.displayed_ = createDisplayBuffer();
                }
                this.mode_ = "paintOn";
                this.startPts_ = packet.pts; // Append special characters to caption text
            } else if (this.isSpecialCharacter(char0, char1)) {
                // Bitmask char0 so that we can apply character transformations
                // regardless of field and data channel.
                // Then byte-shift to the left and OR with char1 so we can pass the
                // entire character code to `getCharFromCode`.
                char0 = (char0 & 0x03) << 8;
                text = getCharFromCode(char0 | char1);
                this[this.mode_](packet.pts, text);
                this.column_++; // Append extended characters to caption text
            } else if (this.isExtCharacter(char0, char1)) {
                // Extended characters always follow their "non-extended" equivalents.
                // IE if a "è" is desired, you'll always receive "eè"; non-compliant
                // decoders are supposed to drop the "è", while compliant decoders
                // backspace the "e" and insert "è".
                // Delete the previous character
                if (this.mode_ === "popOn") this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1);
                else this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
                 // Bitmask char0 so that we can apply character transformations
                // regardless of field and data channel.
                // Then byte-shift to the left and OR with char1 so we can pass the
                // entire character code to `getCharFromCode`.
                char0 = (char0 & 0x03) << 8;
                text = getCharFromCode(char0 | char1);
                this[this.mode_](packet.pts, text);
                this.column_++; // Process mid-row codes
            } else if (this.isMidRowCode(char0, char1)) {
                // Attributes are not additive, so clear all formatting
                this.clearFormatting(packet.pts); // According to the standard, mid-row codes
                // should be replaced with spaces, so add one now
                this[this.mode_](packet.pts, " ");
                this.column_++;
                if ((char1 & 0xe) === 0xe) this.addFormatting(packet.pts, [
                    "i"
                ]);
                if ((char1 & 0x1) === 0x1) this.addFormatting(packet.pts, [
                    "u"
                ]);
                 // Detect offset control codes and adjust cursor
            } else if (this.isOffsetControlCode(char0, char1)) {
                // Cursor position is set by indent PAC (see below) in 4-column
                // increments, with an additional offset code of 1-3 to reach any
                // of the 32 columns specified by CEA-608. So all we need to do
                // here is increment the column cursor by the given offset.
                const offset = char1 & 0x03; // For an offest value 1-3, set the offset for that caption
                // in the non-displayed array.
                this.nonDisplayed_[this.row_].offset = offset;
                this.column_ += offset; // Detect PACs (Preamble Address Codes)
            } else if (this.isPAC(char0, char1)) {
                // There's no logic for PAC -> row mapping, so we have to just
                // find the row code in an array and use its index :(
                var row = ROWS.indexOf(data & 0x1f20); // Configure the caption window if we're in roll-up mode
                if (this.mode_ === "rollUp") {
                    // This implies that the base row is incorrectly set.
                    // As per the recommendation in CEA-608(Base Row Implementation), defer to the number
                    // of roll-up rows set.
                    if (row - this.rollUpRows_ + 1 < 0) row = this.rollUpRows_ - 1;
                    this.setRollUp(packet.pts, row);
                }
                if (row !== this.row_) {
                    // formatting is only persistent for current row
                    this.clearFormatting(packet.pts);
                    this.row_ = row;
                } // All PACs can apply underline, so detect and apply
                // (All odd-numbered second bytes set underline)
                if (char1 & 0x1 && this.formatting_.indexOf("u") === -1) this.addFormatting(packet.pts, [
                    "u"
                ]);
                if ((data & 0x10) === 0x10) {
                    // We've got an indent level code. Each successive even number
                    // increments the column cursor by 4, so we can get the desired
                    // column position by bit-shifting to the right (to get n/2)
                    // and multiplying by 4.
                    const indentations = (data & 0xe) >> 1;
                    this.column_ = indentations * 4; // add to the number of indentations for positioning
                    this.nonDisplayed_[this.row_].indent += indentations;
                }
                if (this.isColorPAC(char1)) // it's a color code, though we only support white, which
                // can be either normal or italicized. white italics can be
                // either 0x4e or 0x6e depending on the row, so we just
                // bitwise-and with 0xe to see if italics should be turned on
                {
                    if ((char1 & 0xe) === 0xe) this.addFormatting(packet.pts, [
                        "i"
                    ]);
                } // We have a normal character in char0, and possibly one in char1
            } else if (this.isNormalChar(char0)) {
                if (char1 === 0x00) char1 = null;
                text = getCharFromCode(char0);
                text += getCharFromCode(char1);
                this[this.mode_](packet.pts, text);
                this.column_ += text.length;
            } // finish data processing
        };
    };
    Cea608Stream.prototype = new Stream$7(); // Trigger a cue point that captures the current state of the
    // display buffer
    Cea608Stream.prototype.flushDisplayed = function(pts) {
        const logWarning = (index)=>{
            this.trigger("log", {
                level: "warn",
                message: "Skipping a malformed 608 caption at index " + index + "."
            });
        };
        const content = [];
        this.displayed_.forEach((row, i)=>{
            if (row && row.text && row.text.length) {
                try {
                    // remove spaces from the start and end of the string
                    row.text = row.text.trim();
                } catch (e) {
                    // Ordinarily, this shouldn't happen. However, caption
                    // parsing errors should not throw exceptions and
                    // break playback.
                    logWarning(i);
                } // See the below link for more details on the following fields:
                // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                if (row.text.length) content.push({
                    // The text to be displayed in the caption from this specific row, with whitespace removed.
                    text: row.text,
                    // Value between 1 and 15 representing the PAC row used to calculate line height.
                    line: i + 1,
                    // A number representing the indent position by percentage (CEA-608 PAC indent code).
                    // The value will be a number between 10 and 80. Offset is used to add an aditional
                    // value to the position if necessary.
                    position: 10 + Math.min(70, row.indent * 10) + row.offset * 2.5
                });
            } else if (row === undefined || row === null) logWarning(i);
        });
        if (content.length) this.trigger("data", {
            startPts: this.startPts_,
            endPts: pts,
            content: content,
            stream: this.name_
        });
    };
    /**
   * Zero out the data, used for startup and on seek
   */ Cea608Stream.prototype.reset = function() {
        this.mode_ = "popOn"; // When in roll-up mode, the index of the last row that will
        // actually display captions. If a caption is shifted to a row
        // with a lower index than this, it is cleared from the display
        // buffer
        this.topRow_ = 0;
        this.startPts_ = 0;
        this.displayed_ = createDisplayBuffer();
        this.nonDisplayed_ = createDisplayBuffer();
        this.lastControlCode_ = null; // Track row and column for proper line-breaking and spacing
        this.column_ = 0;
        this.row_ = BOTTOM_ROW;
        this.rollUpRows_ = 2; // This variable holds currently-applied formatting
        this.formatting_ = [];
    };
    /**
   * Sets up control code and related constants for this instance
   */ Cea608Stream.prototype.setConstants = function() {
        // The following attributes have these uses:
        // ext_ :    char0 for mid-row codes, and the base for extended
        //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
        //           extended codes)
        // control_: char0 for control codes, except byte-shifted to the
        //           left so that we can do this.control_ | CONTROL_CODE
        // offset_:  char0 for tab offset codes
        //
        // It's also worth noting that control codes, and _only_ control codes,
        // differ between field 1 and field2. Field 2 control codes are always
        // their field 1 value plus 1. That's why there's the "| field" on the
        // control value.
        if (this.dataChannel_ === 0) {
            this.BASE_ = 0x10;
            this.EXT_ = 0x11;
            this.CONTROL_ = (0x14 | this.field_) << 8;
            this.OFFSET_ = 0x17;
        } else if (this.dataChannel_ === 1) {
            this.BASE_ = 0x18;
            this.EXT_ = 0x19;
            this.CONTROL_ = (0x1c | this.field_) << 8;
            this.OFFSET_ = 0x1f;
        } // Constants for the LSByte command codes recognized by Cea608Stream. This
        // list is not exhaustive. For a more comprehensive listing and semantics see
        // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
        // Padding
        this.PADDING_ = 0x0000; // Pop-on Mode
        this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 0x20;
        this.END_OF_CAPTION_ = this.CONTROL_ | 0x2f; // Roll-up Mode
        this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 0x25;
        this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 0x26;
        this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 0x27;
        this.CARRIAGE_RETURN_ = this.CONTROL_ | 0x2d; // paint-on mode
        this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 0x29; // Erasure
        this.BACKSPACE_ = this.CONTROL_ | 0x21;
        this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2c;
        this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
    };
    /**
   * Detects if the 2-byte packet data is a special character
   *
   * Special characters have a second byte in the range 0x30 to 0x3f,
   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an special character
   */ Cea608Stream.prototype.isSpecialCharacter = function(char0, char1) {
        return char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f;
    };
    /**
   * Detects if the 2-byte packet data is an extended character
   *
   * Extended characters have a second byte in the range 0x20 to 0x3f,
   * with the first byte being 0x12 or 0x13 (for data channel 1) or
   * 0x1a or 0x1b (for data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an extended character
   */ Cea608Stream.prototype.isExtCharacter = function(char0, char1) {
        return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 0x20 && char1 <= 0x3f;
    };
    /**
   * Detects if the 2-byte packet is a mid-row code
   *
   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
   * channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a mid-row code
   */ Cea608Stream.prototype.isMidRowCode = function(char0, char1) {
        return char0 === this.EXT_ && char1 >= 0x20 && char1 <= 0x2f;
    };
    /**
   * Detects if the 2-byte packet is an offset control code
   *
   * Offset control codes have a second byte in the range 0x21 to 0x23,
   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an offset control code
   */ Cea608Stream.prototype.isOffsetControlCode = function(char0, char1) {
        return char0 === this.OFFSET_ && char1 >= 0x21 && char1 <= 0x23;
    };
    /**
   * Detects if the 2-byte packet is a Preamble Address Code
   *
   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
   * range 0x40 to 0x7f.
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a PAC
   */ Cea608Stream.prototype.isPAC = function(char0, char1) {
        return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 0x40 && char1 <= 0x7f;
    };
    /**
   * Detects if a packet's second byte is in the range of a PAC color code
   *
   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
   * 0x60 to 0x6f.
   *
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the byte is a color PAC
   */ Cea608Stream.prototype.isColorPAC = function(char1) {
        return char1 >= 0x40 && char1 <= 0x4f || char1 >= 0x60 && char1 <= 0x7f;
    };
    /**
   * Detects if a single byte is in the range of a normal character
   *
   * Normal text bytes are in the range 0x20 to 0x7f.
   *
   * @param  {Integer} char  The byte
   * @return {Boolean}       Whether the byte is a normal character
   */ Cea608Stream.prototype.isNormalChar = function(char) {
        return char >= 0x20 && char <= 0x7f;
    };
    /**
   * Configures roll-up
   *
   * @param  {Integer} pts         Current PTS
   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
   *                               a new position
   */ Cea608Stream.prototype.setRollUp = function(pts, newBaseRow) {
        // Reset the base row to the bottom row when switching modes
        if (this.mode_ !== "rollUp") {
            this.row_ = BOTTOM_ROW;
            this.mode_ = "rollUp"; // Spec says to wipe memories when switching to roll-up
            this.flushDisplayed(pts);
            this.nonDisplayed_ = createDisplayBuffer();
            this.displayed_ = createDisplayBuffer();
        }
        if (newBaseRow !== undefined && newBaseRow !== this.row_) // move currently displayed captions (up or down) to the new base row
        for(var i = 0; i < this.rollUpRows_; i++){
            this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
            this.displayed_[this.row_ - i] = {
                text: "",
                indent: 0,
                offset: 0
            };
        }
        if (newBaseRow === undefined) newBaseRow = this.row_;
        this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
    }; // Adds the opening HTML tag for the passed character to the caption text,
    // and keeps track of it for later closing
    Cea608Stream.prototype.addFormatting = function(pts, format) {
        this.formatting_ = this.formatting_.concat(format);
        var text = format.reduce(function(text, format) {
            return text + "<" + format + ">";
        }, "");
        this[this.mode_](pts, text);
    }; // Adds HTML closing tags for current formatting to caption text and
    // clears remembered formatting
    Cea608Stream.prototype.clearFormatting = function(pts) {
        if (!this.formatting_.length) return;
        var text = this.formatting_.reverse().reduce(function(text, format) {
            return text + "</" + format + ">";
        }, "");
        this.formatting_ = [];
        this[this.mode_](pts, text);
    }; // Mode Implementations
    Cea608Stream.prototype.popOn = function(pts, text) {
        var baseRow = this.nonDisplayed_[this.row_].text; // buffer characters
        baseRow += text;
        this.nonDisplayed_[this.row_].text = baseRow;
    };
    Cea608Stream.prototype.rollUp = function(pts, text) {
        var baseRow = this.displayed_[this.row_].text;
        baseRow += text;
        this.displayed_[this.row_].text = baseRow;
    };
    Cea608Stream.prototype.shiftRowsUp_ = function() {
        var i; // clear out inactive rows
        for(i = 0; i < this.topRow_; i++)this.displayed_[i] = {
            text: "",
            indent: 0,
            offset: 0
        };
        for(i = this.row_ + 1; i < BOTTOM_ROW + 1; i++)this.displayed_[i] = {
            text: "",
            indent: 0,
            offset: 0
        };
         // shift displayed rows up
        for(i = this.topRow_; i < this.row_; i++)this.displayed_[i] = this.displayed_[i + 1];
         // clear out the bottom row
        this.displayed_[this.row_] = {
            text: "",
            indent: 0,
            offset: 0
        };
    };
    Cea608Stream.prototype.paintOn = function(pts, text) {
        var baseRow = this.displayed_[this.row_].text;
        baseRow += text;
        this.displayed_[this.row_].text = baseRow;
    }; // exports
    var captionStream = {
        CaptionStream: CaptionStream$2,
        Cea608Stream: Cea608Stream,
        Cea708Stream: Cea708Stream
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var streamTypes = {
        H264_STREAM_TYPE: 0x1B,
        ADTS_STREAM_TYPE: 0x0F,
        METADATA_STREAM_TYPE: 0x15
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Accepts program elementary stream (PES) data events and corrects
   * decode and presentation time stamps to account for a rollover
   * of the 33 bit value.
   */ var Stream$6 = stream;
    var MAX_TS = 8589934592;
    var RO_THRESH = 4294967296;
    var TYPE_SHARED = "shared";
    var handleRollover$1 = function(value, reference) {
        var direction = 1;
        if (value > reference) // If the current timestamp value is greater than our reference timestamp and we detect a
        // timestamp rollover, this means the roll over is happening in the opposite direction.
        // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
        // point will be set to a small number, e.g. 1. The user then seeks backwards over the
        // rollover point. In loading this segment, the timestamp values will be very large,
        // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
        // the time stamp to be `value - 2^33`.
        direction = -1;
         // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
        // cause an incorrect adjustment.
        while(Math.abs(reference - value) > RO_THRESH)value += direction * MAX_TS;
        return value;
    };
    var TimestampRolloverStream$1 = function(type) {
        var lastDTS, referenceDTS;
        TimestampRolloverStream$1.prototype.init.call(this); // The "shared" type is used in cases where a stream will contain muxed
        // video and audio. We could use `undefined` here, but having a string
        // makes debugging a little clearer.
        this.type_ = type || TYPE_SHARED;
        this.push = function(data) {
            // Any "shared" rollover streams will accept _all_ data. Otherwise,
            // streams will only accept data that matches their type.
            if (this.type_ !== TYPE_SHARED && data.type !== this.type_) return;
            if (referenceDTS === undefined) referenceDTS = data.dts;
            data.dts = handleRollover$1(data.dts, referenceDTS);
            data.pts = handleRollover$1(data.pts, referenceDTS);
            lastDTS = data.dts;
            this.trigger("data", data);
        };
        this.flush = function() {
            referenceDTS = lastDTS;
            this.trigger("done");
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger("endedtimeline");
        };
        this.discontinuity = function() {
            referenceDTS = void 0;
            lastDTS = void 0;
        };
        this.reset = function() {
            this.discontinuity();
            this.trigger("reset");
        };
    };
    TimestampRolloverStream$1.prototype = new Stream$6();
    var timestampRolloverStream = {
        TimestampRolloverStream: TimestampRolloverStream$1,
        handleRollover: handleRollover$1
    }; // Once IE11 support is dropped, this function should be removed.
    var typedArrayIndexOf$1 = (typedArray, element, fromIndex)=>{
        if (!typedArray) return -1;
        var currentIndex = fromIndex;
        for(; currentIndex < typedArray.length; currentIndex++){
            if (typedArray[currentIndex] === element) return currentIndex;
        }
        return -1;
    };
    var typedArray = {
        typedArrayIndexOf: typedArrayIndexOf$1
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Tools for parsing ID3 frame data
   * @see http://id3.org/id3v2.3.0
   */ var typedArrayIndexOf = typedArray.typedArrayIndexOf, // Frames that allow different types of text encoding contain a text
    // encoding description byte [ID3v2.4.0 section 4.]
    textEncodingDescriptionByte = {
        Iso88591: 0x00,
        // ISO-8859-1, terminated with \0.
        Utf16: 0x01,
        // UTF-16 encoded Unicode BOM, terminated with \0\0
        Utf16be: 0x02,
        // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
        Utf8: 0x03 // UTF-8 encoded Unicode, terminated with \0
    }, // return a percent-encoded representation of the specified byte range
    // @see http://en.wikipedia.org/wiki/Percent-encoding 
    percentEncode$1 = function(bytes, start, end) {
        var i, result = "";
        for(i = start; i < end; i++)result += "%" + ("00" + bytes[i].toString(16)).slice(-2);
        return result;
    }, // return the string representation of the specified byte range,
    // interpreted as UTf-8.
    parseUtf8 = function(bytes, start, end) {
        return decodeURIComponent(percentEncode$1(bytes, start, end));
    }, // return the string representation of the specified byte range,
    // interpreted as ISO-8859-1.
    parseIso88591$1 = function(bytes, start, end) {
        return unescape(percentEncode$1(bytes, start, end)); // jshint ignore:line
    }, parseSyncSafeInteger$1 = function(data) {
        return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
    }, frameParsers = {
        "APIC": function(frame) {
            var i = 1, mimeTypeEndIndex, descriptionEndIndex, LINK_MIME_TYPE = "-->";
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
             // parsing fields [ID3v2.4.0 section 4.14.]
            mimeTypeEndIndex = typedArrayIndexOf(frame.data, 0, i);
            if (mimeTypeEndIndex < 0) // malformed frame
            return;
             // parsing Mime type field (terminated with \0)
            frame.mimeType = parseIso88591$1(frame.data, i, mimeTypeEndIndex);
            i = mimeTypeEndIndex + 1; // parsing 1-byte Picture Type field
            frame.pictureType = frame.data[i];
            i++;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, i);
            if (descriptionEndIndex < 0) // malformed frame
            return;
             // parsing Description field (terminated with \0)
            frame.description = parseUtf8(frame.data, i, descriptionEndIndex);
            i = descriptionEndIndex + 1;
            if (frame.mimeType === LINK_MIME_TYPE) // parsing Picture Data field as URL (always represented as ISO-8859-1 [ID3v2.4.0 section 4.])
            frame.url = parseIso88591$1(frame.data, i, frame.data.length);
            else // parsing Picture Data field as binary data
            frame.pictureData = frame.data.subarray(i, frame.data.length);
        },
        "T*": function(frame) {
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
             // parse text field, do not include null terminator in the frame value
            // frames that allow different types of encoding contain terminated text [ID3v2.4.0 section 4.]
            frame.value = parseUtf8(frame.data, 1, frame.data.length).replace(/\0*$/, ""); // text information frames supports multiple strings, stored as a terminator separated list [ID3v2.4.0 section 4.2.]
            frame.values = frame.value.split("\x00");
        },
        "TXXX": function(frame) {
            var descriptionEndIndex;
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, 1);
            if (descriptionEndIndex === -1) return;
             // parse the text fields
            frame.description = parseUtf8(frame.data, 1, descriptionEndIndex); // do not include the null terminator in the tag value
            // frames that allow different types of encoding contain terminated text
            // [ID3v2.4.0 section 4.]
            frame.value = parseUtf8(frame.data, descriptionEndIndex + 1, frame.data.length).replace(/\0*$/, "");
            frame.data = frame.value;
        },
        "W*": function(frame) {
            // parse URL field; URL fields are always represented as ISO-8859-1 [ID3v2.4.0 section 4.]
            // if the value is followed by a string termination all the following information should be ignored [ID3v2.4.0 section 4.3]
            frame.url = parseIso88591$1(frame.data, 0, frame.data.length).replace(/\0.*$/, "");
        },
        "WXXX": function(frame) {
            var descriptionEndIndex;
            if (frame.data[0] !== textEncodingDescriptionByte.Utf8) // ignore frames with unrecognized character encodings
            return;
            descriptionEndIndex = typedArrayIndexOf(frame.data, 0, 1);
            if (descriptionEndIndex === -1) return;
             // parse the description and URL fields
            frame.description = parseUtf8(frame.data, 1, descriptionEndIndex); // URL fields are always represented as ISO-8859-1 [ID3v2.4.0 section 4.]
            // if the value is followed by a string termination all the following information
            // should be ignored [ID3v2.4.0 section 4.3]
            frame.url = parseIso88591$1(frame.data, descriptionEndIndex + 1, frame.data.length).replace(/\0.*$/, "");
        },
        "PRIV": function(frame) {
            var i;
            for(i = 0; i < frame.data.length; i++)if (frame.data[i] === 0) {
                // parse the description and URL fields
                frame.owner = parseIso88591$1(frame.data, 0, i);
                break;
            }
            frame.privateData = frame.data.subarray(i + 1);
            frame.data = frame.privateData;
        }
    };
    var parseId3Frames$1 = function(data) {
        var frameSize, frameHeader, frameStart = 10, tagSize = 0, frames = []; // If we don't have enough data for a header, 10 bytes, 
        // or 'ID3' in the first 3 bytes this is not a valid ID3 tag.
        if (data.length < 10 || data[0] !== "I".charCodeAt(0) || data[1] !== "D".charCodeAt(0) || data[2] !== "3".charCodeAt(0)) return;
         // the frame size is transmitted as a 28-bit integer in the
        // last four bytes of the ID3 header.
        // The most significant bit of each byte is dropped and the
        // results concatenated to recover the actual value.
        tagSize = parseSyncSafeInteger$1(data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
        // convenient for our comparisons to include it
        tagSize += 10; // check bit 6 of byte 5 for the extended header flag.
        var hasExtendedHeader = data[5] & 0x40;
        if (hasExtendedHeader) {
            // advance the frame start past the extended header
            frameStart += 4; // header size field
            frameStart += parseSyncSafeInteger$1(data.subarray(10, 14));
            tagSize -= parseSyncSafeInteger$1(data.subarray(16, 20)); // clip any padding off the end
        } // parse one or more ID3 frames
        // http://id3.org/id3v2.3.0#ID3v2_frame_overview
        do {
            // determine the number of bytes in this frame
            frameSize = parseSyncSafeInteger$1(data.subarray(frameStart + 4, frameStart + 8));
            if (frameSize < 1) break;
            frameHeader = String.fromCharCode(data[frameStart], data[frameStart + 1], data[frameStart + 2], data[frameStart + 3]);
            var frame = {
                id: frameHeader,
                data: data.subarray(frameStart + 10, frameStart + frameSize + 10)
            };
            frame.key = frame.id; // parse frame values
            if (frameParsers[frame.id]) // use frame specific parser
            frameParsers[frame.id](frame);
            else if (frame.id[0] === "T") // use text frame generic parser
            frameParsers["T*"](frame);
            else if (frame.id[0] === "W") // use URL link frame generic parser
            frameParsers["W*"](frame);
            frames.push(frame);
            frameStart += 10; // advance past the frame header
            frameStart += frameSize; // advance past the frame body
        }while (frameStart < tagSize);
        return frames;
    };
    var parseId3 = {
        parseId3Frames: parseId3Frames$1,
        parseSyncSafeInteger: parseSyncSafeInteger$1,
        frameParsers: frameParsers
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Accepts program elementary stream (PES) data events and parses out
   * ID3 metadata from them, if present.
   * @see http://id3.org/id3v2.3.0
   */ var Stream$5 = stream, StreamTypes$3 = streamTypes, id3 = parseId3, MetadataStream;
    MetadataStream = function(options) {
        var settings = {
            // the bytes of the program-level descriptor field in MP2T
            // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
            // program element descriptors"
            descriptor: options && options.descriptor
        }, // the total size in bytes of the ID3 tag being parsed
        tagSize = 0, // tag data that is not complete enough to be parsed
        buffer = [], // the total number of bytes currently in the buffer
        bufferSize = 0, i;
        MetadataStream.prototype.init.call(this); // calculate the text track in-band metadata track dispatch type
        // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
        this.dispatchType = StreamTypes$3.METADATA_STREAM_TYPE.toString(16);
        if (settings.descriptor) for(i = 0; i < settings.descriptor.length; i++)this.dispatchType += ("00" + settings.descriptor[i].toString(16)).slice(-2);
        this.push = function(chunk) {
            var tag, frameStart, frameSize, frame, i, frameHeader;
            if (chunk.type !== "timed-metadata") return;
             // if data_alignment_indicator is set in the PES header,
            // we must have the start of a new ID3 tag. Assume anything
            // remaining in the buffer was malformed and throw it out
            if (chunk.dataAlignmentIndicator) {
                bufferSize = 0;
                buffer.length = 0;
            } // ignore events that don't look like ID3 data
            if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== "I".charCodeAt(0) || chunk.data[1] !== "D".charCodeAt(0) || chunk.data[2] !== "3".charCodeAt(0))) {
                this.trigger("log", {
                    level: "warn",
                    message: "Skipping unrecognized metadata packet"
                });
                return;
            } // add this chunk to the data we've collected so far
            buffer.push(chunk);
            bufferSize += chunk.data.byteLength; // grab the size of the entire frame from the ID3 header
            if (buffer.length === 1) {
                // the frame size is transmitted as a 28-bit integer in the
                // last four bytes of the ID3 header.
                // The most significant bit of each byte is dropped and the
                // results concatenated to recover the actual value.
                tagSize = id3.parseSyncSafeInteger(chunk.data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
                // convenient for our comparisons to include it
                tagSize += 10;
            } // if the entire frame has not arrived, wait for more data
            if (bufferSize < tagSize) return;
             // collect the entire frame so it can be parsed
            tag = {
                data: new Uint8Array(tagSize),
                frames: [],
                pts: buffer[0].pts,
                dts: buffer[0].dts
            };
            for(i = 0; i < tagSize;){
                tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
                i += buffer[0].data.byteLength;
                bufferSize -= buffer[0].data.byteLength;
                buffer.shift();
            } // find the start of the first frame and the end of the tag
            frameStart = 10;
            if (tag.data[5] & 0x40) {
                // advance the frame start past the extended header
                frameStart += 4; // header size field
                frameStart += id3.parseSyncSafeInteger(tag.data.subarray(10, 14)); // clip any padding off the end
                tagSize -= id3.parseSyncSafeInteger(tag.data.subarray(16, 20));
            } // parse one or more ID3 frames
            // http://id3.org/id3v2.3.0#ID3v2_frame_overview
            do {
                // determine the number of bytes in this frame
                frameSize = id3.parseSyncSafeInteger(tag.data.subarray(frameStart + 4, frameStart + 8));
                if (frameSize < 1) {
                    this.trigger("log", {
                        level: "warn",
                        message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
                    }); // If the frame is malformed, don't parse any further frames but allow previous valid parsed frames
                    break;
                }
                frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
                frame = {
                    id: frameHeader,
                    data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
                };
                frame.key = frame.id; // parse frame values
                if (id3.frameParsers[frame.id]) // use frame specific parser
                id3.frameParsers[frame.id](frame);
                else if (frame.id[0] === "T") // use text frame generic parser
                id3.frameParsers["T*"](frame);
                else if (frame.id[0] === "W") // use URL link frame generic parser
                id3.frameParsers["W*"](frame);
                 // handle the special PRIV frame used to indicate the start
                // time for raw AAC data
                if (frame.owner === "com.apple.streaming.transportStreamTimestamp") {
                    var d = frame.data, size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
                    size *= 4;
                    size += d[7] & 0x03;
                    frame.timeStamp = size; // in raw AAC, all subsequent data will be timestamped based
                    // on the value of this frame
                    // we couldn't have known the appropriate pts and dts before
                    // parsing this ID3 tag so set those values now
                    if (tag.pts === undefined && tag.dts === undefined) {
                        tag.pts = frame.timeStamp;
                        tag.dts = frame.timeStamp;
                    }
                    this.trigger("timestamp", frame);
                }
                tag.frames.push(frame);
                frameStart += 10; // advance past the frame header
                frameStart += frameSize; // advance past the frame body
            }while (frameStart < tagSize);
            this.trigger("data", tag);
        };
    };
    MetadataStream.prototype = new Stream$5();
    var metadataStream = MetadataStream;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based mp2t to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream$4 = stream, CaptionStream$1 = captionStream, StreamTypes$2 = streamTypes, TimestampRolloverStream = timestampRolloverStream.TimestampRolloverStream; // object types
    var TransportPacketStream, TransportParseStream, ElementaryStream; // constants
    var MP2T_PACKET_LENGTH$1 = 188, // bytes
    SYNC_BYTE$1 = 0x47;
    /**
   * Splits an incoming stream of binary data into MPEG-2 Transport
   * Stream packets.
   */ TransportPacketStream = function() {
        var buffer = new Uint8Array(MP2T_PACKET_LENGTH$1), bytesInBuffer = 0;
        TransportPacketStream.prototype.init.call(this); // Deliver new bytes to the stream.
        /**
     * Split a stream of data into M2TS packets
    **/ this.push = function(bytes) {
            var startIndex = 0, endIndex = MP2T_PACKET_LENGTH$1, everything; // If there are bytes remaining from the last segment, prepend them to the
            // bytes that were pushed in
            if (bytesInBuffer) {
                everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
                everything.set(buffer.subarray(0, bytesInBuffer));
                everything.set(bytes, bytesInBuffer);
                bytesInBuffer = 0;
            } else everything = bytes;
             // While we have enough data for a packet
            while(endIndex < everything.byteLength){
                // Look for a pair of start and end sync bytes in the data..
                if (everything[startIndex] === SYNC_BYTE$1 && everything[endIndex] === SYNC_BYTE$1) {
                    // We found a packet so emit it and jump one whole packet forward in
                    // the stream
                    this.trigger("data", everything.subarray(startIndex, endIndex));
                    startIndex += MP2T_PACKET_LENGTH$1;
                    endIndex += MP2T_PACKET_LENGTH$1;
                    continue;
                } // If we get here, we have somehow become de-synchronized and we need to step
                // forward one byte at a time until we find a pair of sync bytes that denote
                // a packet
                startIndex++;
                endIndex++;
            } // If there was some data left over at the end of the segment that couldn't
            // possibly be a whole packet, keep it because it might be the start of a packet
            // that continues in the next segment
            if (startIndex < everything.byteLength) {
                buffer.set(everything.subarray(startIndex), 0);
                bytesInBuffer = everything.byteLength - startIndex;
            }
        };
        /**
     * Passes identified M2TS packets to the TransportParseStream to be parsed
    **/ this.flush = function() {
            // If the buffer contains a whole packet when we are being flushed, emit it
            // and empty the buffer. Otherwise hold onto the data because it may be
            // important for decoding the next segment
            if (bytesInBuffer === MP2T_PACKET_LENGTH$1 && buffer[0] === SYNC_BYTE$1) {
                this.trigger("data", buffer);
                bytesInBuffer = 0;
            }
            this.trigger("done");
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger("endedtimeline");
        };
        this.reset = function() {
            bytesInBuffer = 0;
            this.trigger("reset");
        };
    };
    TransportPacketStream.prototype = new Stream$4();
    /**
   * Accepts an MP2T TransportPacketStream and emits data events with parsed
   * forms of the individual transport stream packets.
   */ TransportParseStream = function() {
        var parsePsi, parsePat, parsePmt, self1;
        TransportParseStream.prototype.init.call(this);
        self1 = this;
        this.packetsWaitingForPmt = [];
        this.programMapTable = undefined;
        parsePsi = function(payload, psi) {
            var offset = 0; // PSI packets may be split into multiple sections and those
            // sections may be split into multiple packets. If a PSI
            // section starts in this packet, the payload_unit_start_indicator
            // will be true and the first byte of the payload will indicate
            // the offset from the current position to the start of the
            // section.
            if (psi.payloadUnitStartIndicator) offset += payload[offset] + 1;
            if (psi.type === "pat") parsePat(payload.subarray(offset), psi);
            else parsePmt(payload.subarray(offset), psi);
        };
        parsePat = function(payload, pat) {
            pat.section_number = payload[7]; // eslint-disable-line camelcase
            pat.last_section_number = payload[8]; // eslint-disable-line camelcase
            // skip the PSI header and parse the first PMT entry
            self1.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
            pat.pmtPid = self1.pmtPid;
        };
        /**
     * Parse out the relevant fields of a Program Map Table (PMT).
     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
     * packet. The first byte in this array should be the table_id
     * field.
     * @param pmt {object} the object that should be decorated with
     * fields parsed from the PMT.
     */ parsePmt = function(payload, pmt) {
            var sectionLength, tableEnd, programInfoLength, offset; // PMTs can be sent ahead of the time when they should actually
            // take effect. We don't believe this should ever be the case
            // for HLS but we'll ignore "forward" PMT declarations if we see
            // them. Future PMT declarations have the current_next_indicator
            // set to zero.
            if (!(payload[5] & 0x01)) return;
             // overwrite any existing program map table
            self1.programMapTable = {
                video: null,
                audio: null,
                "timed-metadata": {}
            }; // the mapping table ends at the end of the current section
            sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
            tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
            // long the program info descriptors are
            programInfoLength = (payload[10] & 0x0f) << 8 | payload[11]; // advance the offset to the first entry in the mapping table
            offset = 12 + programInfoLength;
            while(offset < tableEnd){
                var streamType = payload[offset];
                var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2]; // only map a single elementary_pid for audio and video stream types
                // TODO: should this be done for metadata too? for now maintain behavior of
                //       multiple metadata streams
                if (streamType === StreamTypes$2.H264_STREAM_TYPE && self1.programMapTable.video === null) self1.programMapTable.video = pid;
                else if (streamType === StreamTypes$2.ADTS_STREAM_TYPE && self1.programMapTable.audio === null) self1.programMapTable.audio = pid;
                else if (streamType === StreamTypes$2.METADATA_STREAM_TYPE) // map pid to stream type for metadata streams
                self1.programMapTable["timed-metadata"][pid] = streamType;
                 // move to the next table entry
                // skip past the elementary stream descriptors, if present
                offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
            } // record the map on the packet as well
            pmt.programMapTable = self1.programMapTable;
        };
        /**
     * Deliver a new MP2T packet to the next stream in the pipeline.
     */ this.push = function(packet) {
            var result = {}, offset = 4;
            result.payloadUnitStartIndicator = !!(packet[1] & 0x40); // pid is a 13-bit field starting at the last bit of packet[1]
            result.pid = packet[1] & 0x1f;
            result.pid <<= 8;
            result.pid |= packet[2]; // if an adaption field is present, its length is specified by the
            // fifth byte of the TS packet header. The adaptation field is
            // used to add stuffing to PES packets that don't fill a complete
            // TS packet, and to specify some forms of timing and control data
            // that we do not currently use.
            if ((packet[3] & 0x30) >>> 4 > 0x01) offset += packet[offset] + 1;
             // parse the rest of the packet based on the type
            if (result.pid === 0) {
                result.type = "pat";
                parsePsi(packet.subarray(offset), result);
                this.trigger("data", result);
            } else if (result.pid === this.pmtPid) {
                result.type = "pmt";
                parsePsi(packet.subarray(offset), result);
                this.trigger("data", result); // if there are any packets waiting for a PMT to be found, process them now
                while(this.packetsWaitingForPmt.length)this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
            } else if (this.programMapTable === undefined) // When we have not seen a PMT yet, defer further processing of
            // PES packets until one has been parsed
            this.packetsWaitingForPmt.push([
                packet,
                offset,
                result
            ]);
            else this.processPes_(packet, offset, result);
        };
        this.processPes_ = function(packet, offset, result) {
            // set the appropriate stream type
            if (result.pid === this.programMapTable.video) result.streamType = StreamTypes$2.H264_STREAM_TYPE;
            else if (result.pid === this.programMapTable.audio) result.streamType = StreamTypes$2.ADTS_STREAM_TYPE;
            else // if not video or audio, it is timed-metadata or unknown
            // if unknown, streamType will be undefined
            result.streamType = this.programMapTable["timed-metadata"][result.pid];
            result.type = "pes";
            result.data = packet.subarray(offset);
            this.trigger("data", result);
        };
    };
    TransportParseStream.prototype = new Stream$4();
    TransportParseStream.STREAM_TYPES = {
        h264: 0x1b,
        adts: 0x0f
    };
    /**
   * Reconsistutes program elementary stream (PES) packets from parsed
   * transport stream packets. That is, if you pipe an
   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
   * events will be events which capture the bytes for individual PES
   * packets plus relevant metadata that has been extracted from the
   * container.
   */ ElementaryStream = function() {
        var self1 = this, segmentHadPmt = false, // PES packet fragments
        video = {
            data: [],
            size: 0
        }, audio = {
            data: [],
            size: 0
        }, timedMetadata = {
            data: [],
            size: 0
        }, programMapTable, parsePes = function(payload, pes) {
            var ptsDtsFlags;
            const startPrefix = payload[0] << 16 | payload[1] << 8 | payload[2]; // default to an empty array
            pes.data = new Uint8Array(); // In certain live streams, the start of a TS fragment has ts packets
            // that are frame data that is continuing from the previous fragment. This
            // is to check that the pes data is the start of a new pes payload
            if (startPrefix !== 1) return;
             // get the packet length, this will be 0 for video
            pes.packetLength = 6 + (payload[4] << 8 | payload[5]); // find out if this packets starts a new keyframe
            pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0; // PES packets may be annotated with a PTS value, or a PTS value
            // and a DTS value. Determine what combination of values is
            // available to work with.
            ptsDtsFlags = payload[7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
            // performs all bitwise operations on 32-bit integers but javascript
            // supports a much greater range (52-bits) of integer using standard
            // mathematical operations.
            // We construct a 31-bit value using bitwise operators over the 31
            // most significant bits and then multiply by 4 (equal to a left-shift
            // of 2) before we add the final 2 least significant bits of the
            // timestamp (equal to an OR.)
            if (ptsDtsFlags & 0xC0) {
                // the PTS and DTS are not written out directly. For information
                // on how they are encoded, see
                // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
                pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
                pes.pts *= 4; // Left shift by 2
                pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
                pes.dts = pes.pts;
                if (ptsDtsFlags & 0x40) {
                    pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
                    pes.dts *= 4; // Left shift by 2
                    pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
                }
            } // the data section starts immediately after the PES header.
            // pes_header_data_length specifies the number of header bytes
            // that follow the last byte of the field.
            pes.data = payload.subarray(9 + payload[8]);
        }, /**
        * Pass completely parsed PES packets to the next stream in the pipeline
       **/ flushStream = function(stream, type, forceFlush) {
            var packetData = new Uint8Array(stream.size), event = {
                type: type
            }, i = 0, offset = 0, packetFlushable = false, fragment; // do nothing if there is not enough buffered data for a complete
            // PES header
            if (!stream.data.length || stream.size < 9) return;
            event.trackId = stream.data[0].pid; // reassemble the packet
            for(i = 0; i < stream.data.length; i++){
                fragment = stream.data[i];
                packetData.set(fragment.data, offset);
                offset += fragment.data.byteLength;
            } // parse assembled packet's PES header
            parsePes(packetData, event); // non-video PES packets MUST have a non-zero PES_packet_length
            // check that there is enough stream data to fill the packet
            packetFlushable = type === "video" || event.packetLength <= stream.size; // flush pending packets if the conditions are right
            if (forceFlush || packetFlushable) {
                stream.size = 0;
                stream.data.length = 0;
            } // only emit packets that are complete. this is to avoid assembling
            // incomplete PES packets due to poor segmentation
            if (packetFlushable) self1.trigger("data", event);
        };
        ElementaryStream.prototype.init.call(this);
        /**
     * Identifies M2TS packet types and parses PES packets using metadata
     * parsed from the PMT
     **/ this.push = function(data) {
            ({
                pat: function() {
                // have any meaningful metadata
                },
                pes: function() {
                    var stream, streamType;
                    switch(data.streamType){
                        case StreamTypes$2.H264_STREAM_TYPE:
                            stream = video;
                            streamType = "video";
                            break;
                        case StreamTypes$2.ADTS_STREAM_TYPE:
                            stream = audio;
                            streamType = "audio";
                            break;
                        case StreamTypes$2.METADATA_STREAM_TYPE:
                            stream = timedMetadata;
                            streamType = "timed-metadata";
                            break;
                        default:
                            // ignore unknown stream types
                            return;
                    } // if a new packet is starting, we can flush the completed
                    // packet
                    if (data.payloadUnitStartIndicator) flushStream(stream, streamType, true);
                     // buffer this fragment until we are sure we've received the
                    // complete payload
                    stream.data.push(data);
                    stream.size += data.data.byteLength;
                },
                pmt: function() {
                    var event = {
                        type: "metadata",
                        tracks: []
                    };
                    programMapTable = data.programMapTable; // translate audio and video streams to tracks
                    if (programMapTable.video !== null) event.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +programMapTable.video,
                        codec: "avc",
                        type: "video"
                    });
                    if (programMapTable.audio !== null) event.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +programMapTable.audio,
                        codec: "adts",
                        type: "audio"
                    });
                    segmentHadPmt = true;
                    self1.trigger("data", event);
                }
            })[data.type]();
        };
        this.reset = function() {
            video.size = 0;
            video.data.length = 0;
            audio.size = 0;
            audio.data.length = 0;
            this.trigger("reset");
        };
        /**
     * Flush any remaining input. Video PES packets may be of variable
     * length. Normally, the start of a new video packet can trigger the
     * finalization of the previous packet. That is not possible if no
     * more video is forthcoming, however. In that case, some other
     * mechanism (like the end of the file) has to be employed. When it is
     * clear that no additional data is forthcoming, calling this method
     * will flush the buffered packets.
     */ this.flushStreams_ = function() {
            // !!THIS ORDER IS IMPORTANT!!
            // video first then audio
            flushStream(video, "video");
            flushStream(audio, "audio");
            flushStream(timedMetadata, "timed-metadata");
        };
        this.flush = function() {
            // if on flush we haven't had a pmt emitted
            // and we have a pmt to emit. emit the pmt
            // so that we trigger a trackinfo downstream.
            if (!segmentHadPmt && programMapTable) {
                var pmt = {
                    type: "metadata",
                    tracks: []
                }; // translate audio and video streams to tracks
                if (programMapTable.video !== null) pmt.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +programMapTable.video,
                    codec: "avc",
                    type: "video"
                });
                if (programMapTable.audio !== null) pmt.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +programMapTable.audio,
                    codec: "adts",
                    type: "audio"
                });
                self1.trigger("data", pmt);
            }
            segmentHadPmt = false;
            this.flushStreams_();
            this.trigger("done");
        };
    };
    ElementaryStream.prototype = new Stream$4();
    var m2ts$1 = {
        PAT_PID: 0x0000,
        MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH$1,
        TransportPacketStream: TransportPacketStream,
        TransportParseStream: TransportParseStream,
        ElementaryStream: ElementaryStream,
        TimestampRolloverStream: TimestampRolloverStream,
        CaptionStream: CaptionStream$1.CaptionStream,
        Cea608Stream: CaptionStream$1.Cea608Stream,
        Cea708Stream: CaptionStream$1.Cea708Stream,
        MetadataStream: metadataStream
    };
    for(var type in StreamTypes$2)if (StreamTypes$2.hasOwnProperty(type)) m2ts$1[type] = StreamTypes$2[type];
    var m2ts_1 = m2ts$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var Stream$3 = stream;
    var ONE_SECOND_IN_TS$2 = clock$2.ONE_SECOND_IN_TS;
    var AdtsStream$1;
    var ADTS_SAMPLING_FREQUENCIES$1 = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    /*
   * Accepts a ElementaryStream and emits data events with parsed
   * AAC Audio Frames of the individual packets. Input audio in ADTS
   * format is unpacked and re-emitted as AAC frames.
   *
   * @see http://wiki.multimedia.cx/index.php?title=ADTS
   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
   */ AdtsStream$1 = function(handlePartialSegments) {
        var buffer, frameNum = 0;
        AdtsStream$1.prototype.init.call(this);
        this.skipWarn_ = function(start, end) {
            this.trigger("log", {
                level: "warn",
                message: `adts skiping bytes ${start} to ${end} in frame ${frameNum} outside syncword`
            });
        };
        this.push = function(packet) {
            var i = 0, frameLength, protectionSkipBytes, oldBuffer, sampleCount, adtsFrameDuration;
            if (!handlePartialSegments) frameNum = 0;
            if (packet.type !== "audio") // ignore non-audio data
            return;
             // Prepend any data in the buffer to the input data so that we can parse
            // aac frames the cross a PES packet boundary
            if (buffer && buffer.length) {
                oldBuffer = buffer;
                buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
                buffer.set(oldBuffer);
                buffer.set(packet.data, oldBuffer.byteLength);
            } else buffer = packet.data;
             // unpack any ADTS frames which have been fully received
            // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
            var skip; // We use i + 7 here because we want to be able to parse the entire header.
            // If we don't have enough bytes to do that, then we definitely won't have a full frame.
            while(i + 7 < buffer.length){
                // Look for the start of an ADTS header..
                if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
                    if (typeof skip !== "number") skip = i;
                     // If a valid header was not found,  jump one forward and attempt to
                    // find a valid ADTS header starting at the next byte
                    i++;
                    continue;
                }
                if (typeof skip === "number") {
                    this.skipWarn_(skip, i);
                    skip = null;
                } // The protection skip bit tells us if we have 2 bytes of CRC data at the
                // end of the ADTS header
                protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2; // Frame length is a 13 bit integer starting 16 bits from the
                // end of the sync sequence
                // NOTE: frame length includes the size of the header
                frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
                sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
                adtsFrameDuration = sampleCount * ONE_SECOND_IN_TS$2 / ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2]; // If we don't have enough data to actually finish this ADTS frame,
                // then we have to wait for more data
                if (buffer.byteLength - i < frameLength) break;
                 // Otherwise, deliver the complete AAC frame
                this.trigger("data", {
                    pts: packet.pts + frameNum * adtsFrameDuration,
                    dts: packet.dts + frameNum * adtsFrameDuration,
                    sampleCount: sampleCount,
                    audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
                    channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
                    samplerate: ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2],
                    samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
                    // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
                    samplesize: 16,
                    // data is the frame without it's header
                    data: buffer.subarray(i + 7 + protectionSkipBytes, i + frameLength)
                });
                frameNum++;
                i += frameLength;
            }
            if (typeof skip === "number") {
                this.skipWarn_(skip, i);
                skip = null;
            } // remove processed bytes from the buffer.
            buffer = buffer.subarray(i);
        };
        this.flush = function() {
            frameNum = 0;
            this.trigger("done");
        };
        this.reset = function() {
            buffer = void 0;
            this.trigger("reset");
        };
        this.endTimeline = function() {
            buffer = void 0;
            this.trigger("endedtimeline");
        };
    };
    AdtsStream$1.prototype = new Stream$3();
    var adts = AdtsStream$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var ExpGolomb$1;
    /**
   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
   * scheme used by h264.
   */ ExpGolomb$1 = function(workingData) {
        var // the number of bytes left to examine in workingData
        workingBytesAvailable = workingData.byteLength, // the current word being examined
        workingWord = 0, // :uint
        // the number of bits left to examine in the current word
        workingBitsAvailable = 0; // :uint;
        // ():uint
        this.length = function() {
            return 8 * workingBytesAvailable;
        }; // ():uint
        this.bitsAvailable = function() {
            return 8 * workingBytesAvailable + workingBitsAvailable;
        }; // ():void
        this.loadWord = function() {
            var position = workingData.byteLength - workingBytesAvailable, workingBytes = new Uint8Array(4), availableBytes = Math.min(4, workingBytesAvailable);
            if (availableBytes === 0) throw new Error("no bytes available");
            workingBytes.set(workingData.subarray(position, position + availableBytes));
            workingWord = new DataView(workingBytes.buffer).getUint32(0); // track the amount of workingData that has been processed
            workingBitsAvailable = availableBytes * 8;
            workingBytesAvailable -= availableBytes;
        }; // (count:int):void
        this.skipBits = function(count) {
            var skipBytes; // :int
            if (workingBitsAvailable > count) {
                workingWord <<= count;
                workingBitsAvailable -= count;
            } else {
                count -= workingBitsAvailable;
                skipBytes = Math.floor(count / 8);
                count -= skipBytes * 8;
                workingBytesAvailable -= skipBytes;
                this.loadWord();
                workingWord <<= count;
                workingBitsAvailable -= count;
            }
        }; // (size:int):uint
        this.readBits = function(size) {
            var bits = Math.min(workingBitsAvailable, size), // :uint
            valu = workingWord >>> 32 - bits; // :uint
            // if size > 31, handle error
            workingBitsAvailable -= bits;
            if (workingBitsAvailable > 0) workingWord <<= bits;
            else if (workingBytesAvailable > 0) this.loadWord();
            bits = size - bits;
            if (bits > 0) return valu << bits | this.readBits(bits);
            return valu;
        }; // ():uint
        this.skipLeadingZeros = function() {
            var leadingZeroCount; // :uint
            for(leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount)if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
                // the first bit of working word is 1
                workingWord <<= leadingZeroCount;
                workingBitsAvailable -= leadingZeroCount;
                return leadingZeroCount;
            }
             // we exhausted workingWord and still have not found a 1
            this.loadWord();
            return leadingZeroCount + this.skipLeadingZeros();
        }; // ():void
        this.skipUnsignedExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }; // ():void
        this.skipExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }; // ():uint
        this.readUnsignedExpGolomb = function() {
            var clz = this.skipLeadingZeros(); // :uint
            return this.readBits(clz + 1) - 1;
        }; // ():int
        this.readExpGolomb = function() {
            var valu = this.readUnsignedExpGolomb(); // :int
            if (0x01 & valu) // the number is odd if the low order bit is set
            return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
            return -1 * (valu >>> 1); // divide by two then make it negative
        }; // Some convenience functions
        // :Boolean
        this.readBoolean = function() {
            return this.readBits(1) === 1;
        }; // ():int
        this.readUnsignedByte = function() {
            return this.readBits(8);
        };
        this.loadWord();
    };
    var expGolomb = ExpGolomb$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var Stream$2 = stream;
    var ExpGolomb = expGolomb;
    var H264Stream$1, NalByteStream;
    var PROFILES_WITH_OPTIONAL_SPS_DATA;
    /**
   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
   */ NalByteStream = function() {
        var syncPoint = 0, i, buffer;
        NalByteStream.prototype.init.call(this);
        /*
     * Scans a byte stream and triggers a data event with the NAL units found.
     * @param {Object} data Event received from H264Stream
     * @param {Uint8Array} data.data The h264 byte stream to be scanned
     *
     * @see H264Stream.push
     */ this.push = function(data) {
            var swapBuffer;
            if (!buffer) buffer = data.data;
            else {
                swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
                swapBuffer.set(buffer);
                swapBuffer.set(data.data, buffer.byteLength);
                buffer = swapBuffer;
            }
            var len = buffer.byteLength; // Rec. ITU-T H.264, Annex B
            // scan for NAL unit boundaries
            // a match looks like this:
            // 0 0 1 .. NAL .. 0 0 1
            // ^ sync point        ^ i
            // or this:
            // 0 0 1 .. NAL .. 0 0 0
            // ^ sync point        ^ i
            // advance the sync point to a NAL start, if necessary
            for(; syncPoint < len - 3; syncPoint++)if (buffer[syncPoint + 2] === 1) {
                // the sync point is properly aligned
                i = syncPoint + 5;
                break;
            }
            while(i < len)// look at the current byte to determine if we've hit the end of
            // a NAL unit boundary
            switch(buffer[i]){
                case 0:
                    // skip past non-sync sequences
                    if (buffer[i - 1] !== 0) {
                        i += 2;
                        break;
                    } else if (buffer[i - 2] !== 0) {
                        i++;
                        break;
                    } // deliver the NAL unit if it isn't empty
                    if (syncPoint + 3 !== i - 2) this.trigger("data", buffer.subarray(syncPoint + 3, i - 2));
                     // drop trailing zeroes
                    do i++;
                    while (buffer[i] !== 1 && i < len);
                    syncPoint = i - 2;
                    i += 3;
                    break;
                case 1:
                    // skip past non-sync sequences
                    if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
                        i += 3;
                        break;
                    } // deliver the NAL unit
                    this.trigger("data", buffer.subarray(syncPoint + 3, i - 2));
                    syncPoint = i - 2;
                    i += 3;
                    break;
                default:
                    // the current byte isn't a one or zero, so it cannot be part
                    // of a sync sequence
                    i += 3;
                    break;
            }
             // filter out the NAL units that were delivered
            buffer = buffer.subarray(syncPoint);
            i -= syncPoint;
            syncPoint = 0;
        };
        this.reset = function() {
            buffer = null;
            syncPoint = 0;
            this.trigger("reset");
        };
        this.flush = function() {
            // deliver the last buffered NAL unit
            if (buffer && buffer.byteLength > 3) this.trigger("data", buffer.subarray(syncPoint + 3));
             // reset the stream state
            buffer = null;
            syncPoint = 0;
            this.trigger("done");
        };
        this.endTimeline = function() {
            this.flush();
            this.trigger("endedtimeline");
        };
    };
    NalByteStream.prototype = new Stream$2(); // values of profile_idc that indicate additional fields are included in the SPS
    // see Recommendation ITU-T H.264 (4/2013),
    // 7.3.2.1.1 Sequence parameter set data syntax
    PROFILES_WITH_OPTIONAL_SPS_DATA = {
        100: true,
        110: true,
        122: true,
        244: true,
        44: true,
        83: true,
        86: true,
        118: true,
        128: true,
        // TODO: the three profiles below don't
        // appear to have sps data in the specificiation anymore?
        138: true,
        139: true,
        134: true
    };
    /**
   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
   * events.
   */ H264Stream$1 = function() {
        var nalByteStream = new NalByteStream(), self1, trackId, currentPts, currentDts, discardEmulationPreventionBytes, readSequenceParameterSet, skipScalingList;
        H264Stream$1.prototype.init.call(this);
        self1 = this;
        /*
     * Pushes a packet from a stream onto the NalByteStream
     *
     * @param {Object} packet - A packet received from a stream
     * @param {Uint8Array} packet.data - The raw bytes of the packet
     * @param {Number} packet.dts - Decode timestamp of the packet
     * @param {Number} packet.pts - Presentation timestamp of the packet
     * @param {Number} packet.trackId - The id of the h264 track this packet came from
     * @param {('video'|'audio')} packet.type - The type of packet
     *
     */ this.push = function(packet) {
            if (packet.type !== "video") return;
            trackId = packet.trackId;
            currentPts = packet.pts;
            currentDts = packet.dts;
            nalByteStream.push(packet);
        };
        /*
     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
     * for the NALUs to the next stream component.
     * Also, preprocess caption and sequence parameter NALUs.
     *
     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
     * @see NalByteStream.push
     */ nalByteStream.on("data", function(data) {
            var event = {
                trackId: trackId,
                pts: currentPts,
                dts: currentDts,
                data: data,
                nalUnitTypeCode: data[0] & 0x1f
            };
            switch(event.nalUnitTypeCode){
                case 0x05:
                    event.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
                    break;
                case 0x06:
                    event.nalUnitType = "sei_rbsp";
                    event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
                    break;
                case 0x07:
                    event.nalUnitType = "seq_parameter_set_rbsp";
                    event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
                    event.config = readSequenceParameterSet(event.escapedRBSP);
                    break;
                case 0x08:
                    event.nalUnitType = "pic_parameter_set_rbsp";
                    break;
                case 0x09:
                    event.nalUnitType = "access_unit_delimiter_rbsp";
                    break;
            } // This triggers data on the H264Stream
            self1.trigger("data", event);
        });
        nalByteStream.on("done", function() {
            self1.trigger("done");
        });
        nalByteStream.on("partialdone", function() {
            self1.trigger("partialdone");
        });
        nalByteStream.on("reset", function() {
            self1.trigger("reset");
        });
        nalByteStream.on("endedtimeline", function() {
            self1.trigger("endedtimeline");
        });
        this.flush = function() {
            nalByteStream.flush();
        };
        this.partialFlush = function() {
            nalByteStream.partialFlush();
        };
        this.reset = function() {
            nalByteStream.reset();
        };
        this.endTimeline = function() {
            nalByteStream.endTimeline();
        };
        /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @param expGolombDecoder {object} an ExpGolomb pointed to the
     * start of a scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */ skipScalingList = function(count, expGolombDecoder) {
            var lastScale = 8, nextScale = 8, j, deltaScale;
            for(j = 0; j < count; j++){
                if (nextScale !== 0) {
                    deltaScale = expGolombDecoder.readExpGolomb();
                    nextScale = (lastScale + deltaScale + 256) % 256;
                }
                lastScale = nextScale === 0 ? lastScale : nextScale;
            }
        };
        /**
     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
     * Sequence Payload"
     * @param data {Uint8Array} the bytes of a RBSP from a NAL
     * unit
     * @return {Uint8Array} the RBSP without any Emulation
     * Prevention Bytes
     */ discardEmulationPreventionBytes = function(data) {
            var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData; // Find all `Emulation Prevention Bytes`
            while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
                emulationPreventionBytesPositions.push(i + 2);
                i += 2;
            } else i++;
             // If no Emulation Prevention Bytes were found just return the original
            // array
            if (emulationPreventionBytesPositions.length === 0) return data;
             // Create a new array to hold the NAL unit data
            newLength = length - emulationPreventionBytesPositions.length;
            newData = new Uint8Array(newLength);
            var sourceIndex = 0;
            for(i = 0; i < newLength; sourceIndex++, i++){
                if (sourceIndex === emulationPreventionBytesPositions[0]) {
                    // Skip this byte
                    sourceIndex++; // Remove this position index
                    emulationPreventionBytesPositions.shift();
                }
                newData[i] = data[sourceIndex];
            }
            return newData;
        };
        /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */ readSequenceParameterSet = function(data) {
            var frameCropLeftOffset = 0, frameCropRightOffset = 0, frameCropTopOffset = 0, frameCropBottomOffset = 0, expGolombDecoder, profileIdc, levelIdc, profileCompatibility, chromaFormatIdc, picOrderCntType, numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1, picHeightInMapUnitsMinus1, frameMbsOnlyFlag, scalingListCount, sarRatio = [
                1,
                1
            ], aspectRatioIdc, i;
            expGolombDecoder = new ExpGolomb(data);
            profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
            profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
            levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
            expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
            // some profiles have more optional data we don't need
            if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
                chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
                if (chromaFormatIdc === 3) expGolombDecoder.skipBits(1); // separate_colour_plane_flag
                expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
                expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
                expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
                if (expGolombDecoder.readBoolean()) {
                    // seq_scaling_matrix_present_flag
                    scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                    for(i = 0; i < scalingListCount; i++)if (expGolombDecoder.readBoolean()) {
                        // seq_scaling_list_present_flag[ i ]
                        if (i < 6) skipScalingList(16, expGolombDecoder);
                        else skipScalingList(64, expGolombDecoder);
                    }
                }
            }
            expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
            picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
            if (picOrderCntType === 0) expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
            else if (picOrderCntType === 1) {
                expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
                expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
                expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
                numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
                for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
            }
            expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
            expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
            picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
            picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
            frameMbsOnlyFlag = expGolombDecoder.readBits(1);
            if (frameMbsOnlyFlag === 0) expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
            expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
            if (expGolombDecoder.readBoolean()) {
                // frame_cropping_flag
                frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
                frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
            }
            if (expGolombDecoder.readBoolean()) // vui_parameters_present_flag
            {
                if (expGolombDecoder.readBoolean()) {
                    // aspect_ratio_info_present_flag
                    aspectRatioIdc = expGolombDecoder.readUnsignedByte();
                    switch(aspectRatioIdc){
                        case 1:
                            sarRatio = [
                                1,
                                1
                            ];
                            break;
                        case 2:
                            sarRatio = [
                                12,
                                11
                            ];
                            break;
                        case 3:
                            sarRatio = [
                                10,
                                11
                            ];
                            break;
                        case 4:
                            sarRatio = [
                                16,
                                11
                            ];
                            break;
                        case 5:
                            sarRatio = [
                                40,
                                33
                            ];
                            break;
                        case 6:
                            sarRatio = [
                                24,
                                11
                            ];
                            break;
                        case 7:
                            sarRatio = [
                                20,
                                11
                            ];
                            break;
                        case 8:
                            sarRatio = [
                                32,
                                11
                            ];
                            break;
                        case 9:
                            sarRatio = [
                                80,
                                33
                            ];
                            break;
                        case 10:
                            sarRatio = [
                                18,
                                11
                            ];
                            break;
                        case 11:
                            sarRatio = [
                                15,
                                11
                            ];
                            break;
                        case 12:
                            sarRatio = [
                                64,
                                33
                            ];
                            break;
                        case 13:
                            sarRatio = [
                                160,
                                99
                            ];
                            break;
                        case 14:
                            sarRatio = [
                                4,
                                3
                            ];
                            break;
                        case 15:
                            sarRatio = [
                                3,
                                2
                            ];
                            break;
                        case 16:
                            sarRatio = [
                                2,
                                1
                            ];
                            break;
                        case 255:
                            sarRatio = [
                                expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(),
                                expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()
                            ];
                            break;
                    }
                    if (sarRatio) sarRatio[0], sarRatio[1];
                }
            }
            return {
                profileIdc: profileIdc,
                levelIdc: levelIdc,
                profileCompatibility: profileCompatibility,
                width: (picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2,
                height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2,
                // sar is sample aspect ratio
                sarRatio: sarRatio
            };
        };
    };
    H264Stream$1.prototype = new Stream$2();
    var h264 = {
        H264Stream: H264Stream$1,
        NalByteStream: NalByteStream
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about Aac data.
   */ var ADTS_SAMPLING_FREQUENCIES = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    var parseId3TagSize = function(header, byteIndex) {
        var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9], flags = header[byteIndex + 5], footerPresent = (flags & 16) >> 4; // if we get a negative returnSize clamp it to 0
        returnSize = returnSize >= 0 ? returnSize : 0;
        if (footerPresent) return returnSize + 20;
        return returnSize + 10;
    };
    var getId3Offset = function(data, offset) {
        if (data.length - offset < 10 || data[offset] !== "I".charCodeAt(0) || data[offset + 1] !== "D".charCodeAt(0) || data[offset + 2] !== "3".charCodeAt(0)) return offset;
        offset += parseId3TagSize(data, offset);
        return getId3Offset(data, offset);
    }; // TODO: use vhs-utils
    var isLikelyAacData$1 = function(data) {
        var offset = getId3Offset(data, 0);
        return data.length >= offset + 2 && (data[offset] & 0xFF) === 0xFF && (data[offset + 1] & 0xF0) === 0xF0 && // verify that the 2 layer bits are 0, aka this
        // is not mp3 data but aac data.
        (data[offset + 1] & 0x16) === 0x10;
    };
    var parseSyncSafeInteger = function(data) {
        return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
    }; // return a percent-encoded representation of the specified byte range
    // @see http://en.wikipedia.org/wiki/Percent-encoding
    var percentEncode = function(bytes, start, end) {
        var i, result = "";
        for(i = start; i < end; i++)result += "%" + ("00" + bytes[i].toString(16)).slice(-2);
        return result;
    }; // return the string representation of the specified byte range,
    // interpreted as ISO-8859-1.
    var parseIso88591 = function(bytes, start, end) {
        return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
    };
    var parseAdtsSize = function(header, byteIndex) {
        var lowThree = (header[byteIndex + 5] & 0xE0) >> 5, middle = header[byteIndex + 4] << 3, highTwo = header[byteIndex + 3] & 6144;
        return highTwo | middle | lowThree;
    };
    var parseType$4 = function(header, byteIndex) {
        if (header[byteIndex] === "I".charCodeAt(0) && header[byteIndex + 1] === "D".charCodeAt(0) && header[byteIndex + 2] === "3".charCodeAt(0)) return "timed-metadata";
        else if (header[byteIndex] & true && (header[byteIndex + 1] & 0xf0) === 0xf0) return "audio";
        return null;
    };
    var parseSampleRate = function(packet) {
        var i = 0;
        while(i + 5 < packet.length){
            if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
                // If a valid header was not found,  jump one forward and attempt to
                // find a valid ADTS header starting at the next byte
                i++;
                continue;
            }
            return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
        }
        return null;
    };
    var parseAacTimestamp = function(packet) {
        var frameStart, frameSize, frame, frameHeader; // find the start of the first frame and the end of the tag
        frameStart = 10;
        if (packet[5] & 0x40) {
            // advance the frame start past the extended header
            frameStart += 4; // header size field
            frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
        } // parse one or more ID3 frames
        // http://id3.org/id3v2.3.0#ID3v2_frame_overview
        do {
            // determine the number of bytes in this frame
            frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
            if (frameSize < 1) return null;
            frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
            if (frameHeader === "PRIV") {
                frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
                for(var i = 0; i < frame.byteLength; i++)if (frame[i] === 0) {
                    var owner = parseIso88591(frame, 0, i);
                    if (owner === "com.apple.streaming.transportStreamTimestamp") {
                        var d = frame.subarray(i + 1);
                        var size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
                        size *= 4;
                        size += d[7] & 0x03;
                        return size;
                    }
                    break;
                }
            }
            frameStart += 10; // advance past the frame header
            frameStart += frameSize; // advance past the frame body
        }while (frameStart < packet.byteLength);
        return null;
    };
    var utils = {
        isLikelyAacData: isLikelyAacData$1,
        parseId3TagSize: parseId3TagSize,
        parseAdtsSize: parseAdtsSize,
        parseType: parseType$4,
        parseSampleRate: parseSampleRate,
        parseAacTimestamp: parseAacTimestamp
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based aac to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream$1 = stream;
    var aacUtils = utils; // Constants
    var AacStream$1;
    /**
   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
   */ AacStream$1 = function() {
        var everything = new Uint8Array(), timeStamp = 0;
        AacStream$1.prototype.init.call(this);
        this.setTimestamp = function(timestamp) {
            timeStamp = timestamp;
        };
        this.push = function(bytes) {
            var frameSize = 0, byteIndex = 0, bytesLeft, chunk, packet, tempLength; // If there are bytes remaining from the last segment, prepend them to the
            // bytes that were pushed in
            if (everything.length) {
                tempLength = everything.length;
                everything = new Uint8Array(bytes.byteLength + tempLength);
                everything.set(everything.subarray(0, tempLength));
                everything.set(bytes, tempLength);
            } else everything = bytes;
            while(everything.length - byteIndex >= 3){
                if (everything[byteIndex] === "I".charCodeAt(0) && everything[byteIndex + 1] === "D".charCodeAt(0) && everything[byteIndex + 2] === "3".charCodeAt(0)) {
                    // Exit early because we don't have enough to parse
                    // the ID3 tag header
                    if (everything.length - byteIndex < 10) break;
                     // check framesize
                    frameSize = aacUtils.parseId3TagSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    // Add to byteIndex to support multiple ID3 tags in sequence
                    if (byteIndex + frameSize > everything.length) break;
                    chunk = {
                        type: "timed-metadata",
                        data: everything.subarray(byteIndex, byteIndex + frameSize)
                    };
                    this.trigger("data", chunk);
                    byteIndex += frameSize;
                    continue;
                } else if ((everything[byteIndex] & 0xff) === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
                    // Exit early because we don't have enough to parse
                    // the ADTS frame header
                    if (everything.length - byteIndex < 7) break;
                    frameSize = aacUtils.parseAdtsSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (byteIndex + frameSize > everything.length) break;
                    packet = {
                        type: "audio",
                        data: everything.subarray(byteIndex, byteIndex + frameSize),
                        pts: timeStamp,
                        dts: timeStamp
                    };
                    this.trigger("data", packet);
                    byteIndex += frameSize;
                    continue;
                }
                byteIndex++;
            }
            bytesLeft = everything.length - byteIndex;
            if (bytesLeft > 0) everything = everything.subarray(byteIndex);
            else everything = new Uint8Array();
        };
        this.reset = function() {
            everything = new Uint8Array();
            this.trigger("reset");
        };
        this.endTimeline = function() {
            everything = new Uint8Array();
            this.trigger("endedtimeline");
        };
    };
    AacStream$1.prototype = new Stream$1();
    var aac = AacStream$1;
    var AUDIO_PROPERTIES$1 = [
        "audioobjecttype",
        "channelcount",
        "samplerate",
        "samplingfrequencyindex",
        "samplesize"
    ];
    var audioProperties = AUDIO_PROPERTIES$1;
    var VIDEO_PROPERTIES$1 = [
        "width",
        "height",
        "profileIdc",
        "levelIdc",
        "profileCompatibility",
        "sarRatio"
    ];
    var videoProperties = VIDEO_PROPERTIES$1;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A stream-based mp2t to mp4 converter. This utility can be used to
   * deliver mp4s to a SourceBuffer on platforms that support native
   * Media Source Extensions.
   */ var Stream = stream;
    var mp4 = mp4Generator;
    var frameUtils = frameUtils$1;
    var audioFrameUtils = audioFrameUtils$1;
    var trackDecodeInfo = trackDecodeInfo$1;
    var m2ts = m2ts_1;
    var clock = clock$2;
    var AdtsStream = adts;
    var H264Stream = h264.H264Stream;
    var AacStream = aac;
    var isLikelyAacData = utils.isLikelyAacData;
    var ONE_SECOND_IN_TS$1 = clock$2.ONE_SECOND_IN_TS;
    var AUDIO_PROPERTIES = audioProperties;
    var VIDEO_PROPERTIES = videoProperties; // object types
    var VideoSegmentStream, AudioSegmentStream, Transmuxer, CoalesceStream;
    var retriggerForStream = function(key, event) {
        event.stream = key;
        this.trigger("log", event);
    };
    var addPipelineLogRetriggers = function(transmuxer, pipeline) {
        var keys = Object.keys(pipeline);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i]; // skip non-stream keys and headOfPipeline
            // which is just a duplicate
            if (key === "headOfPipeline" || !pipeline[key].on) continue;
            pipeline[key].on("log", retriggerForStream.bind(transmuxer, key));
        }
    };
    /**
   * Compare two arrays (even typed) for same-ness
   */ var arrayEquals = function(a, b) {
        var i;
        if (a.length !== b.length) return false;
         // compare the value of each element in the array
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    };
    var generateSegmentTimingInfo = function(baseMediaDecodeTime, startDts, startPts, endDts, endPts, prependedContentDuration) {
        var ptsOffsetFromDts = startPts - startDts, decodeDuration = endDts - startDts, presentationDuration = endPts - startPts; // The PTS and DTS values are based on the actual stream times from the segment,
        // however, the player time values will reflect a start from the baseMediaDecodeTime.
        // In order to provide relevant values for the player times, base timing info on the
        // baseMediaDecodeTime and the DTS and PTS durations of the segment.
        return {
            start: {
                dts: baseMediaDecodeTime,
                pts: baseMediaDecodeTime + ptsOffsetFromDts
            },
            end: {
                dts: baseMediaDecodeTime + decodeDuration,
                pts: baseMediaDecodeTime + presentationDuration
            },
            prependedContentDuration: prependedContentDuration,
            baseMediaDecodeTime: baseMediaDecodeTime
        };
    };
    /**
   * Constructs a single-track, ISO BMFF media segment from AAC data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ AudioSegmentStream = function(track, options) {
        var adtsFrames = [], sequenceNumber, earliestAllowedDts = 0, audioAppendStartTs = 0, videoBaseMediaDecodeTime = Infinity;
        options = options || {};
        sequenceNumber = options.firstSequenceNumber || 0;
        AudioSegmentStream.prototype.init.call(this);
        this.push = function(data) {
            trackDecodeInfo.collectDtsInfo(track, data);
            if (track) AUDIO_PROPERTIES.forEach(function(prop) {
                track[prop] = data[prop];
            });
             // buffer audio data until end() is called
            adtsFrames.push(data);
        };
        this.setEarliestDts = function(earliestDts) {
            earliestAllowedDts = earliestDts;
        };
        this.setVideoBaseMediaDecodeTime = function(baseMediaDecodeTime) {
            videoBaseMediaDecodeTime = baseMediaDecodeTime;
        };
        this.setAudioAppendStart = function(timestamp) {
            audioAppendStartTs = timestamp;
        };
        this.flush = function() {
            var frames, moof, mdat, boxes, frameDuration, segmentDuration, videoClockCyclesOfSilencePrefixed; // return early if no audio data has been observed
            if (adtsFrames.length === 0) {
                this.trigger("done", "AudioSegmentStream");
                return;
            }
            frames = audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts);
            track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps); // amount of audio filled but the value is in video clock rather than audio clock
            videoClockCyclesOfSilencePrefixed = audioFrameUtils.prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime); // we have to build the index from byte locations to
            // samples (that is, adts frames) in the audio data
            track.samples = audioFrameUtils.generateSampleTable(frames); // concatenate the audio data to constuct the mdat
            mdat = mp4.mdat(audioFrameUtils.concatenateFrameData(frames));
            adtsFrames = [];
            moof = mp4.moof(sequenceNumber, [
                track
            ]);
            boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // bump the sequence number for next time
            sequenceNumber++;
            boxes.set(moof);
            boxes.set(mdat, moof.byteLength);
            trackDecodeInfo.clearDtsInfo(track);
            frameDuration = Math.ceil(ONE_SECOND_IN_TS$1 * 1024 / track.samplerate); // TODO this check was added to maintain backwards compatibility (particularly with
            // tests) on adding the timingInfo event. However, it seems unlikely that there's a
            // valid use-case where an init segment/data should be triggered without associated
            // frames. Leaving for now, but should be looked into.
            if (frames.length) {
                segmentDuration = frames.length * frameDuration;
                this.trigger("segmentTimingInfo", generateSegmentTimingInfo(// The audio track's baseMediaDecodeTime is in audio clock cycles, but the
                // frame info is in video clock cycles. Convert to match expectation of
                // listeners (that all timestamps will be based on video clock cycles).
                clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate), // frame times are already in video clock, as is segment duration
                frames[0].dts, frames[0].pts, frames[0].dts + segmentDuration, frames[0].pts + segmentDuration, videoClockCyclesOfSilencePrefixed || 0));
                this.trigger("timingInfo", {
                    start: frames[0].pts,
                    end: frames[0].pts + segmentDuration
                });
            }
            this.trigger("data", {
                track: track,
                boxes: boxes
            });
            this.trigger("done", "AudioSegmentStream");
        };
        this.reset = function() {
            trackDecodeInfo.clearDtsInfo(track);
            adtsFrames = [];
            this.trigger("reset");
        };
    };
    AudioSegmentStream.prototype = new Stream();
    /**
   * Constructs a single-track, ISO BMFF media segment from H264 data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
   *        gopsToAlignWith list when attempting to align gop pts
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */ VideoSegmentStream = function(track, options) {
        var sequenceNumber, nalUnits = [], gopsToAlignWith = [], config, pps;
        options = options || {};
        sequenceNumber = options.firstSequenceNumber || 0;
        VideoSegmentStream.prototype.init.call(this);
        delete track.minPTS;
        this.gopCache_ = [];
        /**
      * Constructs a ISO BMFF segment given H264 nalUnits
      * @param {Object} nalUnit A data event representing a nalUnit
      * @param {String} nalUnit.nalUnitType
      * @param {Object} nalUnit.config Properties for a mp4 track
      * @param {Uint8Array} nalUnit.data The nalUnit bytes
      * @see lib/codecs/h264.js
     **/ this.push = function(nalUnit) {
            trackDecodeInfo.collectDtsInfo(track, nalUnit); // record the track config
            if (nalUnit.nalUnitType === "seq_parameter_set_rbsp" && !config) {
                config = nalUnit.config;
                track.sps = [
                    nalUnit.data
                ];
                VIDEO_PROPERTIES.forEach(function(prop) {
                    track[prop] = config[prop];
                }, this);
            }
            if (nalUnit.nalUnitType === "pic_parameter_set_rbsp" && !pps) {
                pps = nalUnit.data;
                track.pps = [
                    nalUnit.data
                ];
            } // buffer video until flush() is called
            nalUnits.push(nalUnit);
        };
        /**
      * Pass constructed ISO BMFF track and boxes on to the
      * next stream in the pipeline
     **/ this.flush = function() {
            var frames, gopForFusion, gops, moof, mdat, boxes, prependedContentDuration = 0, firstGop, lastGop; // Throw away nalUnits at the start of the byte stream until
            // we find the first AUD
            while(nalUnits.length){
                if (nalUnits[0].nalUnitType === "access_unit_delimiter_rbsp") break;
                nalUnits.shift();
            } // Return early if no video data has been observed
            if (nalUnits.length === 0) {
                this.resetStream_();
                this.trigger("done", "VideoSegmentStream");
                return;
            } // Organize the raw nal-units into arrays that represent
            // higher-level constructs such as frames and gops
            // (group-of-pictures)
            frames = frameUtils.groupNalsIntoFrames(nalUnits);
            gops = frameUtils.groupFramesIntoGops(frames); // If the first frame of this fragment is not a keyframe we have
            // a problem since MSE (on Chrome) requires a leading keyframe.
            //
            // We have two approaches to repairing this situation:
            // 1) GOP-FUSION:
            //    This is where we keep track of the GOPS (group-of-pictures)
            //    from previous fragments and attempt to find one that we can
            //    prepend to the current fragment in order to create a valid
            //    fragment.
            // 2) KEYFRAME-PULLING:
            //    Here we search for the first keyframe in the fragment and
            //    throw away all the frames between the start of the fragment
            //    and that keyframe. We then extend the duration and pull the
            //    PTS of the keyframe forward so that it covers the time range
            //    of the frames that were disposed of.
            //
            // #1 is far prefereable over #2 which can cause "stuttering" but
            // requires more things to be just right.
            if (!gops[0][0].keyFrame) {
                // Search for a gop for fusion from our gopCache
                gopForFusion = this.getGopForFusion_(nalUnits[0], track);
                if (gopForFusion) {
                    // in order to provide more accurate timing information about the segment, save
                    // the number of seconds prepended to the original segment due to GOP fusion
                    prependedContentDuration = gopForFusion.duration;
                    gops.unshift(gopForFusion); // Adjust Gops' metadata to account for the inclusion of the
                    // new gop at the beginning
                    gops.byteLength += gopForFusion.byteLength;
                    gops.nalCount += gopForFusion.nalCount;
                    gops.pts = gopForFusion.pts;
                    gops.dts = gopForFusion.dts;
                    gops.duration += gopForFusion.duration;
                } else // If we didn't find a candidate gop fall back to keyframe-pulling
                gops = frameUtils.extendFirstKeyFrame(gops);
            } // Trim gops to align with gopsToAlignWith
            if (gopsToAlignWith.length) {
                var alignedGops;
                if (options.alignGopsAtEnd) alignedGops = this.alignGopsAtEnd_(gops);
                else alignedGops = this.alignGopsAtStart_(gops);
                if (!alignedGops) {
                    // save all the nals in the last GOP into the gop cache
                    this.gopCache_.unshift({
                        gop: gops.pop(),
                        pps: track.pps,
                        sps: track.sps
                    }); // Keep a maximum of 6 GOPs in the cache
                    this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
                    nalUnits = []; // return early no gops can be aligned with desired gopsToAlignWith
                    this.resetStream_();
                    this.trigger("done", "VideoSegmentStream");
                    return;
                } // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
                // when recalculated before sending off to CoalesceStream
                trackDecodeInfo.clearDtsInfo(track);
                gops = alignedGops;
            }
            trackDecodeInfo.collectDtsInfo(track, gops); // First, we have to build the index from byte locations to
            // samples (that is, frames) in the video data
            track.samples = frameUtils.generateSampleTable(gops); // Concatenate the video data and construct the mdat
            mdat = mp4.mdat(frameUtils.concatenateNalData(gops));
            track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
            this.trigger("processedGopsInfo", gops.map(function(gop) {
                return {
                    pts: gop.pts,
                    dts: gop.dts,
                    byteLength: gop.byteLength
                };
            }));
            firstGop = gops[0];
            lastGop = gops[gops.length - 1];
            this.trigger("segmentTimingInfo", generateSegmentTimingInfo(track.baseMediaDecodeTime, firstGop.dts, firstGop.pts, lastGop.dts + lastGop.duration, lastGop.pts + lastGop.duration, prependedContentDuration));
            this.trigger("timingInfo", {
                start: gops[0].pts,
                end: gops[gops.length - 1].pts + gops[gops.length - 1].duration
            }); // save all the nals in the last GOP into the gop cache
            this.gopCache_.unshift({
                gop: gops.pop(),
                pps: track.pps,
                sps: track.sps
            }); // Keep a maximum of 6 GOPs in the cache
            this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
            nalUnits = [];
            this.trigger("baseMediaDecodeTime", track.baseMediaDecodeTime);
            this.trigger("timelineStartInfo", track.timelineStartInfo);
            moof = mp4.moof(sequenceNumber, [
                track
            ]); // it would be great to allocate this array up front instead of
            // throwing away hundreds of media segment fragments
            boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // Bump the sequence number for next time
            sequenceNumber++;
            boxes.set(moof);
            boxes.set(mdat, moof.byteLength);
            this.trigger("data", {
                track: track,
                boxes: boxes
            });
            this.resetStream_(); // Continue with the flush process now
            this.trigger("done", "VideoSegmentStream");
        };
        this.reset = function() {
            this.resetStream_();
            nalUnits = [];
            this.gopCache_.length = 0;
            gopsToAlignWith.length = 0;
            this.trigger("reset");
        };
        this.resetStream_ = function() {
            trackDecodeInfo.clearDtsInfo(track); // reset config and pps because they may differ across segments
            // for instance, when we are rendition switching
            config = undefined;
            pps = undefined;
        }; // Search for a candidate Gop for gop-fusion from the gop cache and
        // return it or return null if no good candidate was found
        this.getGopForFusion_ = function(nalUnit) {
            var halfSecond = 45000, // Half-a-second in a 90khz clock
            allowableOverlap = 10000, // About 3 frames @ 30fps
            nearestDistance = Infinity, dtsDistance, nearestGopObj, currentGop, currentGopObj, i; // Search for the GOP nearest to the beginning of this nal unit
            for(i = 0; i < this.gopCache_.length; i++){
                currentGopObj = this.gopCache_[i];
                currentGop = currentGopObj.gop; // Reject Gops with different SPS or PPS
                if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) continue;
                 // Reject Gops that would require a negative baseMediaDecodeTime
                if (currentGop.dts < track.timelineStartInfo.dts) continue;
                 // The distance between the end of the gop and the start of the nalUnit
                dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration; // Only consider GOPS that start before the nal unit and end within
                // a half-second of the nal unit
                if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) // Always use the closest GOP we found if there is more than
                // one candidate
                {
                    if (!nearestGopObj || nearestDistance > dtsDistance) {
                        nearestGopObj = currentGopObj;
                        nearestDistance = dtsDistance;
                    }
                }
            }
            if (nearestGopObj) return nearestGopObj.gop;
            return null;
        }; // trim gop list to the first gop found that has a matching pts with a gop in the list
        // of gopsToAlignWith starting from the START of the list
        this.alignGopsAtStart_ = function(gops) {
            var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
            byteLength = gops.byteLength;
            nalCount = gops.nalCount;
            duration = gops.duration;
            alignIndex = gopIndex = 0;
            while(alignIndex < gopsToAlignWith.length && gopIndex < gops.length){
                align = gopsToAlignWith[alignIndex];
                gop = gops[gopIndex];
                if (align.pts === gop.pts) break;
                if (gop.pts > align.pts) {
                    // this current gop starts after the current gop we want to align on, so increment
                    // align index
                    alignIndex++;
                    continue;
                } // current gop starts before the current gop we want to align on. so increment gop
                // index
                gopIndex++;
                byteLength -= gop.byteLength;
                nalCount -= gop.nalCount;
                duration -= gop.duration;
            }
            if (gopIndex === 0) // no gops to trim
            return gops;
            if (gopIndex === gops.length) // all gops trimmed, skip appending all gops
            return null;
            alignedGops = gops.slice(gopIndex);
            alignedGops.byteLength = byteLength;
            alignedGops.duration = duration;
            alignedGops.nalCount = nalCount;
            alignedGops.pts = alignedGops[0].pts;
            alignedGops.dts = alignedGops[0].dts;
            return alignedGops;
        }; // trim gop list to the first gop found that has a matching pts with a gop in the list
        // of gopsToAlignWith starting from the END of the list
        this.alignGopsAtEnd_ = function(gops) {
            var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
            alignIndex = gopsToAlignWith.length - 1;
            gopIndex = gops.length - 1;
            alignEndIndex = null;
            matchFound = false;
            while(alignIndex >= 0 && gopIndex >= 0){
                align = gopsToAlignWith[alignIndex];
                gop = gops[gopIndex];
                if (align.pts === gop.pts) {
                    matchFound = true;
                    break;
                }
                if (align.pts > gop.pts) {
                    alignIndex--;
                    continue;
                }
                if (alignIndex === gopsToAlignWith.length - 1) // gop.pts is greater than the last alignment candidate. If no match is found
                // by the end of this loop, we still want to append gops that come after this
                // point
                alignEndIndex = gopIndex;
                gopIndex--;
            }
            if (!matchFound && alignEndIndex === null) return null;
            var trimIndex;
            if (matchFound) trimIndex = gopIndex;
            else trimIndex = alignEndIndex;
            if (trimIndex === 0) return gops;
            var alignedGops = gops.slice(trimIndex);
            var metadata = alignedGops.reduce(function(total, gop) {
                total.byteLength += gop.byteLength;
                total.duration += gop.duration;
                total.nalCount += gop.nalCount;
                return total;
            }, {
                byteLength: 0,
                duration: 0,
                nalCount: 0
            });
            alignedGops.byteLength = metadata.byteLength;
            alignedGops.duration = metadata.duration;
            alignedGops.nalCount = metadata.nalCount;
            alignedGops.pts = alignedGops[0].pts;
            alignedGops.dts = alignedGops[0].dts;
            return alignedGops;
        };
        this.alignGopsWith = function(newGopsToAlignWith) {
            gopsToAlignWith = newGopsToAlignWith;
        };
    };
    VideoSegmentStream.prototype = new Stream();
    /**
   * A Stream that can combine multiple streams (ie. audio & video)
   * into a single output segment for MSE. Also supports audio-only
   * and video-only streams.
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at media timeline start.
   */ CoalesceStream = function(options, metadataStream) {
        // Number of Tracks per output segment
        // If greater than 1, we combine multiple
        // tracks into a single segment
        this.numberOfTracks = 0;
        this.metadataStream = metadataStream;
        options = options || {};
        if (typeof options.remux !== "undefined") this.remuxTracks = !!options.remux;
        else this.remuxTracks = true;
        if (typeof options.keepOriginalTimestamps === "boolean") this.keepOriginalTimestamps = options.keepOriginalTimestamps;
        else this.keepOriginalTimestamps = false;
        this.pendingTracks = [];
        this.videoTrack = null;
        this.pendingBoxes = [];
        this.pendingCaptions = [];
        this.pendingMetadata = [];
        this.pendingBytes = 0;
        this.emittedTracks = 0;
        CoalesceStream.prototype.init.call(this); // Take output from multiple
        this.push = function(output) {
            // buffer incoming captions until the associated video segment
            // finishes
            if (output.content || output.text) return this.pendingCaptions.push(output);
             // buffer incoming id3 tags until the final flush
            if (output.frames) return this.pendingMetadata.push(output);
             // Add this track to the list of pending tracks and store
            // important information required for the construction of
            // the final segment
            this.pendingTracks.push(output.track);
            this.pendingBytes += output.boxes.byteLength; // TODO: is there an issue for this against chrome?
            // We unshift audio and push video because
            // as of Chrome 75 when switching from
            // one init segment to another if the video
            // mdat does not appear after the audio mdat
            // only audio will play for the duration of our transmux.
            if (output.track.type === "video") {
                this.videoTrack = output.track;
                this.pendingBoxes.push(output.boxes);
            }
            if (output.track.type === "audio") {
                this.audioTrack = output.track;
                this.pendingBoxes.unshift(output.boxes);
            }
        };
    };
    CoalesceStream.prototype = new Stream();
    CoalesceStream.prototype.flush = function(flushSource) {
        var offset = 0, event = {
            captions: [],
            captionStreams: {},
            metadata: [],
            info: {}
        }, caption, id3, initSegment, timelineStartPts = 0, i;
        if (this.pendingTracks.length < this.numberOfTracks) {
            if (flushSource !== "VideoSegmentStream" && flushSource !== "AudioSegmentStream") // Return because we haven't received a flush from a data-generating
            // portion of the segment (meaning that we have only recieved meta-data
            // or captions.)
            return;
            else if (this.remuxTracks) // Return until we have enough tracks from the pipeline to remux (if we
            // are remuxing audio and video into a single MP4)
            return;
            else if (this.pendingTracks.length === 0) {
                // In the case where we receive a flush without any data having been
                // received we consider it an emitted track for the purposes of coalescing
                // `done` events.
                // We do this for the case where there is an audio and video track in the
                // segment but no audio data. (seen in several playlists with alternate
                // audio tracks and no audio present in the main TS segments.)
                this.emittedTracks++;
                if (this.emittedTracks >= this.numberOfTracks) {
                    this.trigger("done");
                    this.emittedTracks = 0;
                }
                return;
            }
        }
        if (this.videoTrack) {
            timelineStartPts = this.videoTrack.timelineStartInfo.pts;
            VIDEO_PROPERTIES.forEach(function(prop) {
                event.info[prop] = this.videoTrack[prop];
            }, this);
        } else if (this.audioTrack) {
            timelineStartPts = this.audioTrack.timelineStartInfo.pts;
            AUDIO_PROPERTIES.forEach(function(prop) {
                event.info[prop] = this.audioTrack[prop];
            }, this);
        }
        if (this.videoTrack || this.audioTrack) {
            if (this.pendingTracks.length === 1) event.type = this.pendingTracks[0].type;
            else event.type = "combined";
            this.emittedTracks += this.pendingTracks.length;
            initSegment = mp4.initSegment(this.pendingTracks); // Create a new typed array to hold the init segment
            event.initSegment = new Uint8Array(initSegment.byteLength); // Create an init segment containing a moov
            // and track definitions
            event.initSegment.set(initSegment); // Create a new typed array to hold the moof+mdats
            event.data = new Uint8Array(this.pendingBytes); // Append each moof+mdat (one per track) together
            for(i = 0; i < this.pendingBoxes.length; i++){
                event.data.set(this.pendingBoxes[i], offset);
                offset += this.pendingBoxes[i].byteLength;
            } // Translate caption PTS times into second offsets to match the
            // video timeline for the segment, and add track info
            for(i = 0; i < this.pendingCaptions.length; i++){
                caption = this.pendingCaptions[i];
                caption.startTime = clock.metadataTsToSeconds(caption.startPts, timelineStartPts, this.keepOriginalTimestamps);
                caption.endTime = clock.metadataTsToSeconds(caption.endPts, timelineStartPts, this.keepOriginalTimestamps);
                event.captionStreams[caption.stream] = true;
                event.captions.push(caption);
            } // Translate ID3 frame PTS times into second offsets to match the
            // video timeline for the segment
            for(i = 0; i < this.pendingMetadata.length; i++){
                id3 = this.pendingMetadata[i];
                id3.cueTime = clock.metadataTsToSeconds(id3.pts, timelineStartPts, this.keepOriginalTimestamps);
                event.metadata.push(id3);
            } // We add this to every single emitted segment even though we only need
            // it for the first
            event.metadata.dispatchType = this.metadataStream.dispatchType; // Reset stream state
            this.pendingTracks.length = 0;
            this.videoTrack = null;
            this.pendingBoxes.length = 0;
            this.pendingCaptions.length = 0;
            this.pendingBytes = 0;
            this.pendingMetadata.length = 0; // Emit the built segment
            // We include captions and ID3 tags for backwards compatibility,
            // ideally we should send only video and audio in the data event
            this.trigger("data", event); // Emit each caption to the outside world
            // Ideally, this would happen immediately on parsing captions,
            // but we need to ensure that video data is sent back first
            // so that caption timing can be adjusted to match video timing
            for(i = 0; i < event.captions.length; i++){
                caption = event.captions[i];
                this.trigger("caption", caption);
            } // Emit each id3 tag to the outside world
            // Ideally, this would happen immediately on parsing the tag,
            // but we need to ensure that video data is sent back first
            // so that ID3 frame timing can be adjusted to match video timing
            for(i = 0; i < event.metadata.length; i++){
                id3 = event.metadata[i];
                this.trigger("id3Frame", id3);
            }
        } // Only emit `done` if all tracks have been flushed and emitted
        if (this.emittedTracks >= this.numberOfTracks) {
            this.trigger("done");
            this.emittedTracks = 0;
        }
    };
    CoalesceStream.prototype.setRemux = function(val) {
        this.remuxTracks = val;
    };
    /**
   * A Stream that expects MP2T binary data as input and produces
   * corresponding media segments, suitable for use with Media Source
   * Extension (MSE) implementations that support the ISO BMFF byte
   * stream format, like Chrome.
   */ Transmuxer = function(options) {
        var self1 = this, hasFlushed = true, videoTrack, audioTrack;
        Transmuxer.prototype.init.call(this);
        options = options || {};
        this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
        this.transmuxPipeline_ = {};
        this.setupAacPipeline = function() {
            var pipeline = {};
            this.transmuxPipeline_ = pipeline;
            pipeline.type = "aac";
            pipeline.metadataStream = new m2ts.MetadataStream(); // set up the parsing pipeline
            pipeline.aacStream = new AacStream();
            pipeline.audioTimestampRolloverStream = new m2ts.TimestampRolloverStream("audio");
            pipeline.timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream("timed-metadata");
            pipeline.adtsStream = new AdtsStream();
            pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
            pipeline.headOfPipeline = pipeline.aacStream;
            pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
            pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
            pipeline.metadataStream.on("timestamp", function(frame) {
                pipeline.aacStream.setTimestamp(frame.timeStamp);
            });
            pipeline.aacStream.on("data", function(data) {
                if (data.type !== "timed-metadata" && data.type !== "audio" || pipeline.audioSegmentStream) return;
                audioTrack = audioTrack || {
                    timelineStartInfo: {
                        baseMediaDecodeTime: self1.baseMediaDecodeTime
                    },
                    codec: "adts",
                    type: "audio"
                }; // hook up the audio segment stream to the first track with aac data
                pipeline.coalesceStream.numberOfTracks++;
                pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
                pipeline.audioSegmentStream.on("log", self1.getLogTrigger_("audioSegmentStream"));
                pipeline.audioSegmentStream.on("timingInfo", self1.trigger.bind(self1, "audioTimingInfo")); // Set up the final part of the audio pipeline
                pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream); // emit pmt info
                self1.trigger("trackinfo", {
                    hasAudio: !!audioTrack,
                    hasVideo: !!videoTrack
                });
            }); // Re-emit any data coming from the coalesce stream to the outside world
            pipeline.coalesceStream.on("data", this.trigger.bind(this, "data")); // Let the consumer know we have finished flushing the entire pipeline
            pipeline.coalesceStream.on("done", this.trigger.bind(this, "done"));
            addPipelineLogRetriggers(this, pipeline);
        };
        this.setupTsPipeline = function() {
            var pipeline = {};
            this.transmuxPipeline_ = pipeline;
            pipeline.type = "ts";
            pipeline.metadataStream = new m2ts.MetadataStream(); // set up the parsing pipeline
            pipeline.packetStream = new m2ts.TransportPacketStream();
            pipeline.parseStream = new m2ts.TransportParseStream();
            pipeline.elementaryStream = new m2ts.ElementaryStream();
            pipeline.timestampRolloverStream = new m2ts.TimestampRolloverStream();
            pipeline.adtsStream = new AdtsStream();
            pipeline.h264Stream = new H264Stream();
            pipeline.captionStream = new m2ts.CaptionStream(options);
            pipeline.coalesceStream = new CoalesceStream(options, pipeline.metadataStream);
            pipeline.headOfPipeline = pipeline.packetStream; // disassemble MPEG2-TS packets into elementary streams
            pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream); // !!THIS ORDER IS IMPORTANT!!
            // demux the streams
            pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);
            pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);
            pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream); // Hook up CEA-608/708 caption stream
            pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
            pipeline.elementaryStream.on("data", function(data) {
                var i;
                if (data.type === "metadata") {
                    i = data.tracks.length; // scan the tracks listed in the metadata
                    while(i--){
                        if (!videoTrack && data.tracks[i].type === "video") {
                            videoTrack = data.tracks[i];
                            videoTrack.timelineStartInfo.baseMediaDecodeTime = self1.baseMediaDecodeTime;
                        } else if (!audioTrack && data.tracks[i].type === "audio") {
                            audioTrack = data.tracks[i];
                            audioTrack.timelineStartInfo.baseMediaDecodeTime = self1.baseMediaDecodeTime;
                        }
                    } // hook up the video segment stream to the first track with h264 data
                    if (videoTrack && !pipeline.videoSegmentStream) {
                        pipeline.coalesceStream.numberOfTracks++;
                        pipeline.videoSegmentStream = new VideoSegmentStream(videoTrack, options);
                        pipeline.videoSegmentStream.on("log", self1.getLogTrigger_("videoSegmentStream"));
                        pipeline.videoSegmentStream.on("timelineStartInfo", function(timelineStartInfo) {
                            // When video emits timelineStartInfo data after a flush, we forward that
                            // info to the AudioSegmentStream, if it exists, because video timeline
                            // data takes precedence.  Do not do this if keepOriginalTimestamps is set,
                            // because this is a particularly subtle form of timestamp alteration.
                            if (audioTrack && !options.keepOriginalTimestamps) {
                                audioTrack.timelineStartInfo = timelineStartInfo; // On the first segment we trim AAC frames that exist before the
                                // very earliest DTS we have seen in video because Chrome will
                                // interpret any video track with a baseMediaDecodeTime that is
                                // non-zero as a gap.
                                pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts - self1.baseMediaDecodeTime);
                            }
                        });
                        pipeline.videoSegmentStream.on("processedGopsInfo", self1.trigger.bind(self1, "gopInfo"));
                        pipeline.videoSegmentStream.on("segmentTimingInfo", self1.trigger.bind(self1, "videoSegmentTimingInfo"));
                        pipeline.videoSegmentStream.on("baseMediaDecodeTime", function(baseMediaDecodeTime) {
                            if (audioTrack) pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
                        });
                        pipeline.videoSegmentStream.on("timingInfo", self1.trigger.bind(self1, "videoTimingInfo")); // Set up the final part of the video pipeline
                        pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
                    }
                    if (audioTrack && !pipeline.audioSegmentStream) {
                        // hook up the audio segment stream to the first track with aac data
                        pipeline.coalesceStream.numberOfTracks++;
                        pipeline.audioSegmentStream = new AudioSegmentStream(audioTrack, options);
                        pipeline.audioSegmentStream.on("log", self1.getLogTrigger_("audioSegmentStream"));
                        pipeline.audioSegmentStream.on("timingInfo", self1.trigger.bind(self1, "audioTimingInfo"));
                        pipeline.audioSegmentStream.on("segmentTimingInfo", self1.trigger.bind(self1, "audioSegmentTimingInfo")); // Set up the final part of the audio pipeline
                        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
                    } // emit pmt info
                    self1.trigger("trackinfo", {
                        hasAudio: !!audioTrack,
                        hasVideo: !!videoTrack
                    });
                }
            }); // Re-emit any data coming from the coalesce stream to the outside world
            pipeline.coalesceStream.on("data", this.trigger.bind(this, "data"));
            pipeline.coalesceStream.on("id3Frame", function(id3Frame) {
                id3Frame.dispatchType = pipeline.metadataStream.dispatchType;
                self1.trigger("id3Frame", id3Frame);
            });
            pipeline.coalesceStream.on("caption", this.trigger.bind(this, "caption")); // Let the consumer know we have finished flushing the entire pipeline
            pipeline.coalesceStream.on("done", this.trigger.bind(this, "done"));
            addPipelineLogRetriggers(this, pipeline);
        }; // hook up the segment streams once track metadata is delivered
        this.setBaseMediaDecodeTime = function(baseMediaDecodeTime) {
            var pipeline = this.transmuxPipeline_;
            if (!options.keepOriginalTimestamps) this.baseMediaDecodeTime = baseMediaDecodeTime;
            if (audioTrack) {
                audioTrack.timelineStartInfo.dts = undefined;
                audioTrack.timelineStartInfo.pts = undefined;
                trackDecodeInfo.clearDtsInfo(audioTrack);
                if (pipeline.audioTimestampRolloverStream) pipeline.audioTimestampRolloverStream.discontinuity();
            }
            if (videoTrack) {
                if (pipeline.videoSegmentStream) pipeline.videoSegmentStream.gopCache_ = [];
                videoTrack.timelineStartInfo.dts = undefined;
                videoTrack.timelineStartInfo.pts = undefined;
                trackDecodeInfo.clearDtsInfo(videoTrack);
                pipeline.captionStream.reset();
            }
            if (pipeline.timestampRolloverStream) pipeline.timestampRolloverStream.discontinuity();
        };
        this.setAudioAppendStart = function(timestamp) {
            if (audioTrack) this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
        };
        this.setRemux = function(val) {
            var pipeline = this.transmuxPipeline_;
            options.remux = val;
            if (pipeline && pipeline.coalesceStream) pipeline.coalesceStream.setRemux(val);
        };
        this.alignGopsWith = function(gopsToAlignWith) {
            if (videoTrack && this.transmuxPipeline_.videoSegmentStream) this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
        };
        this.getLogTrigger_ = function(key) {
            var self1 = this;
            return function(event) {
                event.stream = key;
                self1.trigger("log", event);
            };
        }; // feed incoming data to the front of the parsing pipeline
        this.push = function(data) {
            if (hasFlushed) {
                var isAac = isLikelyAacData(data);
                if (isAac && this.transmuxPipeline_.type !== "aac") this.setupAacPipeline();
                else if (!isAac && this.transmuxPipeline_.type !== "ts") this.setupTsPipeline();
                hasFlushed = false;
            }
            this.transmuxPipeline_.headOfPipeline.push(data);
        }; // flush any buffered data
        this.flush = function() {
            hasFlushed = true; // Start at the top of the pipeline and flush all pending work
            this.transmuxPipeline_.headOfPipeline.flush();
        };
        this.endTimeline = function() {
            this.transmuxPipeline_.headOfPipeline.endTimeline();
        };
        this.reset = function() {
            if (this.transmuxPipeline_.headOfPipeline) this.transmuxPipeline_.headOfPipeline.reset();
        }; // Caption data has to be reset when seeking outside buffered range
        this.resetCaptions = function() {
            if (this.transmuxPipeline_.captionStream) this.transmuxPipeline_.captionStream.reset();
        };
    };
    Transmuxer.prototype = new Stream();
    var transmuxer = {
        Transmuxer: Transmuxer,
        VideoSegmentStream: VideoSegmentStream,
        AudioSegmentStream: AudioSegmentStream,
        AUDIO_PROPERTIES: AUDIO_PROPERTIES,
        VIDEO_PROPERTIES: VIDEO_PROPERTIES,
        // exported for testing
        generateSegmentTimingInfo: generateSegmentTimingInfo
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ var toUnsigned$3 = function(value) {
        return value >>> 0;
    };
    var toHexString$1 = function(value) {
        return ("00" + value.toString(16)).slice(-2);
    };
    var bin = {
        toUnsigned: toUnsigned$3,
        toHexString: toHexString$1
    };
    var parseType$3 = function(buffer) {
        var result = "";
        result += String.fromCharCode(buffer[0]);
        result += String.fromCharCode(buffer[1]);
        result += String.fromCharCode(buffer[2]);
        result += String.fromCharCode(buffer[3]);
        return result;
    };
    var parseType_1 = parseType$3;
    var toUnsigned$2 = bin.toUnsigned;
    var parseType$2 = parseType_1;
    var findBox$2 = function(data, path) {
        var results = [], i, size, type, end, subresults;
        if (!path.length) // short-circuit the search for empty paths
        return null;
        for(i = 0; i < data.byteLength;){
            size = toUnsigned$2(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
            type = parseType$2(data.subarray(i + 4, i + 8));
            end = size > 1 ? i + size : data.byteLength;
            if (type === path[0]) {
                if (path.length === 1) // this is the end of the path and we've found the box we were
                // looking for
                results.push(data.subarray(i + 8, end));
                else {
                    // recursively search for the next box along the path
                    subresults = findBox$2(data.subarray(i + 8, end), path.slice(1));
                    if (subresults.length) results = results.concat(subresults);
                }
            }
            i = end;
        } // we've finished searching all of data
        return results;
    };
    var findBox_1 = findBox$2;
    var toUnsigned$1 = bin.toUnsigned;
    var getUint64$2 = numbers.getUint64;
    var tfdt = function(data) {
        var result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4))
        };
        if (result.version === 1) result.baseMediaDecodeTime = getUint64$2(data.subarray(4));
        else result.baseMediaDecodeTime = toUnsigned$1(data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]);
        return result;
    };
    var parseTfdt$2 = tfdt;
    var parseSampleFlags$1 = function(flags) {
        return {
            isLeading: (flags[0] & 0x0c) >>> 2,
            dependsOn: flags[0] & 0x03,
            isDependedOn: (flags[1] & 0xc0) >>> 6,
            hasRedundancy: (flags[1] & 0x30) >>> 4,
            paddingValue: (flags[1] & 0x0e) >>> 1,
            isNonSyncSample: flags[1] & 0x01,
            degradationPriority: flags[2] << 8 | flags[3]
        };
    };
    var parseSampleFlags_1 = parseSampleFlags$1;
    var parseSampleFlags = parseSampleFlags_1;
    var trun = function(data) {
        var result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            samples: []
        }, view = new DataView(data.buffer, data.byteOffset, data.byteLength), // Flag interpretation
        dataOffsetPresent = result.flags[2] & 0x01, // compare with 2nd byte of 0x1
        firstSampleFlagsPresent = result.flags[2] & 0x04, // compare with 2nd byte of 0x4
        sampleDurationPresent = result.flags[1] & 0x01, // compare with 2nd byte of 0x100
        sampleSizePresent = result.flags[1] & 0x02, // compare with 2nd byte of 0x200
        sampleFlagsPresent = result.flags[1] & 0x04, // compare with 2nd byte of 0x400
        sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08, // compare with 2nd byte of 0x800
        sampleCount = view.getUint32(4), offset = 8, sample;
        if (dataOffsetPresent) {
            // 32 bit signed integer
            result.dataOffset = view.getInt32(offset);
            offset += 4;
        } // Overrides the flags for the first sample only. The order of
        // optional values will be: duration, size, compositionTimeOffset
        if (firstSampleFlagsPresent && sampleCount) {
            sample = {
                flags: parseSampleFlags(data.subarray(offset, offset + 4))
            };
            offset += 4;
            if (sampleDurationPresent) {
                sample.duration = view.getUint32(offset);
                offset += 4;
            }
            if (sampleSizePresent) {
                sample.size = view.getUint32(offset);
                offset += 4;
            }
            if (sampleCompositionTimeOffsetPresent) {
                if (result.version === 1) sample.compositionTimeOffset = view.getInt32(offset);
                else sample.compositionTimeOffset = view.getUint32(offset);
                offset += 4;
            }
            result.samples.push(sample);
            sampleCount--;
        }
        while(sampleCount--){
            sample = {};
            if (sampleDurationPresent) {
                sample.duration = view.getUint32(offset);
                offset += 4;
            }
            if (sampleSizePresent) {
                sample.size = view.getUint32(offset);
                offset += 4;
            }
            if (sampleFlagsPresent) {
                sample.flags = parseSampleFlags(data.subarray(offset, offset + 4));
                offset += 4;
            }
            if (sampleCompositionTimeOffsetPresent) {
                if (result.version === 1) sample.compositionTimeOffset = view.getInt32(offset);
                else sample.compositionTimeOffset = view.getUint32(offset);
                offset += 4;
            }
            result.samples.push(sample);
        }
        return result;
    };
    var parseTrun$2 = trun;
    var tfhd = function(data) {
        var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {
            version: data[0],
            flags: new Uint8Array(data.subarray(1, 4)),
            trackId: view.getUint32(4)
        }, baseDataOffsetPresent = result.flags[2] & 0x01, sampleDescriptionIndexPresent = result.flags[2] & 0x02, defaultSampleDurationPresent = result.flags[2] & 0x08, defaultSampleSizePresent = result.flags[2] & 0x10, defaultSampleFlagsPresent = result.flags[2] & 0x20, durationIsEmpty = result.flags[0] & 0x010000, defaultBaseIsMoof = result.flags[0] & 0x020000, i;
        i = 8;
        if (baseDataOffsetPresent) {
            i += 4; // truncate top 4 bytes
            // FIXME: should we read the full 64 bits?
            result.baseDataOffset = view.getUint32(12);
            i += 4;
        }
        if (sampleDescriptionIndexPresent) {
            result.sampleDescriptionIndex = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleDurationPresent) {
            result.defaultSampleDuration = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleSizePresent) {
            result.defaultSampleSize = view.getUint32(i);
            i += 4;
        }
        if (defaultSampleFlagsPresent) result.defaultSampleFlags = view.getUint32(i);
        if (durationIsEmpty) result.durationIsEmpty = true;
        if (!baseDataOffsetPresent && defaultBaseIsMoof) result.baseDataOffsetIsMoof = true;
        return result;
    };
    var parseTfhd$2 = tfhd;
    var win;
    if (typeof window !== "undefined") win = window;
    else if (typeof commonjsGlobal !== "undefined") win = commonjsGlobal;
    else if (typeof self !== "undefined") win = self;
    else win = {};
    var window_1 = win;
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band CEA-708 captions out of FMP4 segments.
   * @see https://en.wikipedia.org/wiki/CEA-708
   */ var discardEmulationPreventionBytes = captionPacketParser.discardEmulationPreventionBytes;
    var CaptionStream = captionStream.CaptionStream;
    var findBox$1 = findBox_1;
    var parseTfdt$1 = parseTfdt$2;
    var parseTrun$1 = parseTrun$2;
    var parseTfhd$1 = parseTfhd$2;
    var window$2 = window_1;
    /**
    * Maps an offset in the mdat to a sample based on the the size of the samples.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Number} offset - The offset into the mdat
    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
    * @return {?Object} The matching sample, or null if no match was found.
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/ var mapToSample = function(offset, samples) {
        var approximateOffset = offset;
        for(var i = 0; i < samples.length; i++){
            var sample = samples[i];
            if (approximateOffset < sample.size) return sample;
            approximateOffset -= sample.size;
        }
        return null;
    };
    /**
    * Finds SEI nal units contained in a Media Data Box.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Uint8Array} avcStream - The bytes of the mdat
    * @param {Object[]} samples - The samples parsed out by `parseSamples`
    * @param {Number} trackId - The trackId of this video track
    * @return {Object[]} seiNals - the parsed SEI NALUs found.
    *   The contents of the seiNal should match what is expected by
    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
    *
    * @see ISO-BMFF-12/2015, Section 8.1.1
    * @see Rec. ITU-T H.264, 7.3.2.3.1
   **/ var findSeiNals = function(avcStream, samples, trackId) {
        var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength), result = {
            logs: [],
            seiNals: []
        }, seiNal, i, length, lastMatchedSample;
        for(i = 0; i + 4 < avcStream.length; i += length){
            length = avcView.getUint32(i);
            i += 4; // Bail if this doesn't appear to be an H264 stream
            if (length <= 0) continue;
            switch(avcStream[i] & 0x1F){
                case 0x06:
                    var data = avcStream.subarray(i + 1, i + 1 + length);
                    var matchingSample = mapToSample(i, samples);
                    seiNal = {
                        nalUnitType: "sei_rbsp",
                        size: length,
                        data: data,
                        escapedRBSP: discardEmulationPreventionBytes(data),
                        trackId: trackId
                    };
                    if (matchingSample) {
                        seiNal.pts = matchingSample.pts;
                        seiNal.dts = matchingSample.dts;
                        lastMatchedSample = matchingSample;
                    } else if (lastMatchedSample) {
                        // If a matching sample cannot be found, use the last
                        // sample's values as they should be as close as possible
                        seiNal.pts = lastMatchedSample.pts;
                        seiNal.dts = lastMatchedSample.dts;
                    } else {
                        result.logs.push({
                            level: "warn",
                            message: "We've encountered a nal unit without data at " + i + " for trackId " + trackId + ". See mux.js#223."
                        });
                        break;
                    }
                    result.seiNals.push(seiNal);
                    break;
            }
        }
        return result;
    };
    /**
    * Parses sample information out of Track Run Boxes and calculates
    * the absolute presentation and decode timestamps of each sample.
    *
    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
        @see ISO-BMFF-12/2015, Section 8.8.12
    * @param {Object} tfhd - The parsed Track Fragment Header
    *   @see inspect.parseTfhd
    * @return {Object[]} the parsed samples
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/ var parseSamples = function(truns, baseMediaDecodeTime, tfhd) {
        var currentDts = baseMediaDecodeTime;
        var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
        var defaultSampleSize = tfhd.defaultSampleSize || 0;
        var trackId = tfhd.trackId;
        var allSamples = [];
        truns.forEach(function(trun) {
            // Note: We currently do not parse the sample table as well
            // as the trun. It's possible some sources will require this.
            // moov > trak > mdia > minf > stbl
            var trackRun = parseTrun$1(trun);
            var samples = trackRun.samples;
            samples.forEach(function(sample) {
                if (sample.duration === undefined) sample.duration = defaultSampleDuration;
                if (sample.size === undefined) sample.size = defaultSampleSize;
                sample.trackId = trackId;
                sample.dts = currentDts;
                if (sample.compositionTimeOffset === undefined) sample.compositionTimeOffset = 0;
                if (typeof currentDts === "bigint") {
                    sample.pts = currentDts + window$2.BigInt(sample.compositionTimeOffset);
                    currentDts += window$2.BigInt(sample.duration);
                } else {
                    sample.pts = currentDts + sample.compositionTimeOffset;
                    currentDts += sample.duration;
                }
            });
            allSamples = allSamples.concat(samples);
        });
        return allSamples;
    };
    /**
    * Parses out caption nals from an FMP4 segment's video tracks.
    *
    * @param {Uint8Array} segment - The bytes of a single segment
    * @param {Number} videoTrackId - The trackId of a video track in the segment
    * @return {Object.<Number, Object[]>} A mapping of video trackId to
    *   a list of seiNals found in that track
   **/ var parseCaptionNals = function(segment, videoTrackId) {
        // To get the samples
        var trafs = findBox$1(segment, [
            "moof",
            "traf"
        ]); // To get SEI NAL units
        var mdats = findBox$1(segment, [
            "mdat"
        ]);
        var captionNals = {};
        var mdatTrafPairs = []; // Pair up each traf with a mdat as moofs and mdats are in pairs
        mdats.forEach(function(mdat, index) {
            var matchingTraf = trafs[index];
            mdatTrafPairs.push({
                mdat: mdat,
                traf: matchingTraf
            });
        });
        mdatTrafPairs.forEach(function(pair) {
            var mdat = pair.mdat;
            var traf = pair.traf;
            var tfhd = findBox$1(traf, [
                "tfhd"
            ]); // Exactly 1 tfhd per traf
            var headerInfo = parseTfhd$1(tfhd[0]);
            var trackId = headerInfo.trackId;
            var tfdt = findBox$1(traf, [
                "tfdt"
            ]); // Either 0 or 1 tfdt per traf
            var baseMediaDecodeTime = tfdt.length > 0 ? parseTfdt$1(tfdt[0]).baseMediaDecodeTime : 0;
            var truns = findBox$1(traf, [
                "trun"
            ]);
            var samples;
            var result; // Only parse video data for the chosen video track
            if (videoTrackId === trackId && truns.length > 0) {
                samples = parseSamples(truns, baseMediaDecodeTime, headerInfo);
                result = findSeiNals(mdat, samples, trackId);
                if (!captionNals[trackId]) captionNals[trackId] = {
                    seiNals: [],
                    logs: []
                };
                captionNals[trackId].seiNals = captionNals[trackId].seiNals.concat(result.seiNals);
                captionNals[trackId].logs = captionNals[trackId].logs.concat(result.logs);
            }
        });
        return captionNals;
    };
    /**
    * Parses out inband captions from an MP4 container and returns
    * caption objects that can be used by WebVTT and the TextTrack API.
    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
    *
    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
    * @param {Number} trackId - The id of the video track to parse
    * @param {Number} timescale - The timescale for the video track from the init segment
    *
    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
    * @return {Object[]} parsedCaptions[].content - A list of individual caption segments
    * @return {String} parsedCaptions[].content.text - The visible content of the caption segment
    * @return {Number} parsedCaptions[].content.line - The line height from 1-15 for positioning of the caption segment
    * @return {Number} parsedCaptions[].content.position - The column indent percentage for cue positioning from 10-80
   **/ var parseEmbeddedCaptions = function(segment, trackId, timescale) {
        var captionNals; // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
        if (trackId === null) return null;
        captionNals = parseCaptionNals(segment, trackId);
        var trackNals = captionNals[trackId] || {};
        return {
            seiNals: trackNals.seiNals,
            logs: trackNals.logs,
            timescale: timescale
        };
    };
    /**
    * Converts SEI NALUs into captions that can be used by video.js
   **/ var CaptionParser = function() {
        var isInitialized = false;
        var captionStream; // Stores segments seen before trackId and timescale are set
        var segmentCache; // Stores video track ID of the track being parsed
        var trackId; // Stores the timescale of the track being parsed
        var timescale; // Stores captions parsed so far
        var parsedCaptions; // Stores whether we are receiving partial data or not
        var parsingPartial;
        /**
      * A method to indicate whether a CaptionParser has been initalized
      * @returns {Boolean}
     **/ this.isInitialized = function() {
            return isInitialized;
        };
        /**
      * Initializes the underlying CaptionStream, SEI NAL parsing
      * and management, and caption collection
     **/ this.init = function(options) {
            captionStream = new CaptionStream();
            isInitialized = true;
            parsingPartial = options ? options.isPartial : false; // Collect dispatched captions
            captionStream.on("data", function(event) {
                // Convert to seconds in the source's timescale
                event.startTime = event.startPts / timescale;
                event.endTime = event.endPts / timescale;
                parsedCaptions.captions.push(event);
                parsedCaptions.captionStreams[event.stream] = true;
            });
            captionStream.on("log", function(log) {
                parsedCaptions.logs.push(log);
            });
        };
        /**
      * Determines if a new video track will be selected
      * or if the timescale changed
      * @return {Boolean}
     **/ this.isNewInit = function(videoTrackIds, timescales) {
            if (videoTrackIds && videoTrackIds.length === 0 || timescales && typeof timescales === "object" && Object.keys(timescales).length === 0) return false;
            return trackId !== videoTrackIds[0] || timescale !== timescales[trackId];
        };
        /**
      * Parses out SEI captions and interacts with underlying
      * CaptionStream to return dispatched captions
      *
      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
      * @see parseEmbeddedCaptions
      * @see m2ts/caption-stream.js
     **/ this.parse = function(segment, videoTrackIds, timescales) {
            var parsedData;
            if (!this.isInitialized()) return null; // This is not likely to be a video segment
            else if (!videoTrackIds || !timescales) return null;
            else if (this.isNewInit(videoTrackIds, timescales)) {
                // Use the first video track only as there is no
                // mechanism to switch to other video tracks
                trackId = videoTrackIds[0];
                timescale = timescales[trackId]; // If an init segment has not been seen yet, hold onto segment
            // data until we have one.
            // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
            } else if (trackId === null || !timescale) {
                segmentCache.push(segment);
                return null;
            } // Now that a timescale and trackId is set, parse cached segments
            while(segmentCache.length > 0){
                var cachedSegment = segmentCache.shift();
                this.parse(cachedSegment, videoTrackIds, timescales);
            }
            parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
            if (parsedData && parsedData.logs) parsedCaptions.logs = parsedCaptions.logs.concat(parsedData.logs);
            if (parsedData === null || !parsedData.seiNals) {
                if (parsedCaptions.logs.length) return {
                    logs: parsedCaptions.logs,
                    captions: [],
                    captionStreams: []
                };
                return null;
            }
            this.pushNals(parsedData.seiNals); // Force the parsed captions to be dispatched
            this.flushStream();
            return parsedCaptions;
        };
        /**
      * Pushes SEI NALUs onto CaptionStream
      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
      * Assumes that `parseCaptionNals` has been called first
      * @see m2ts/caption-stream.js
      **/ this.pushNals = function(nals) {
            if (!this.isInitialized() || !nals || nals.length === 0) return null;
            nals.forEach(function(nal) {
                captionStream.push(nal);
            });
        };
        /**
      * Flushes underlying CaptionStream to dispatch processed, displayable captions
      * @see m2ts/caption-stream.js
     **/ this.flushStream = function() {
            if (!this.isInitialized()) return null;
            if (!parsingPartial) captionStream.flush();
            else captionStream.partialFlush();
        };
        /**
      * Reset caption buckets for new data
     **/ this.clearParsedCaptions = function() {
            parsedCaptions.captions = [];
            parsedCaptions.captionStreams = {};
            parsedCaptions.logs = [];
        };
        /**
      * Resets underlying CaptionStream
      * @see m2ts/caption-stream.js
     **/ this.resetCaptionStream = function() {
            if (!this.isInitialized()) return null;
            captionStream.reset();
        };
        /**
      * Convenience method to clear all captions flushed from the
      * CaptionStream and still being parsed
      * @see m2ts/caption-stream.js
     **/ this.clearAllCaptions = function() {
            this.clearParsedCaptions();
            this.resetCaptionStream();
        };
        /**
      * Reset caption parser
     **/ this.reset = function() {
            segmentCache = [];
            trackId = null;
            timescale = null;
            if (!parsedCaptions) parsedCaptions = {
                captions: [],
                // CC1, CC2, CC3, CC4
                captionStreams: {},
                logs: []
            };
            else this.clearParsedCaptions();
            this.resetCaptionStream();
        };
        this.reset();
    };
    var captionParser = CaptionParser;
    /**
   * Returns the first string in the data array ending with a null char '\0'
   * @param {UInt8} data 
   * @returns the string with the null char
   */ var uint8ToCString$1 = function(data) {
        var index = 0;
        var curChar = String.fromCharCode(data[index]);
        var retString = "";
        while(curChar !== "\x00"){
            retString += curChar;
            index++;
            curChar = String.fromCharCode(data[index]);
        } // Add nullChar
        retString += curChar;
        return retString;
    };
    var string = {
        uint8ToCString: uint8ToCString$1
    };
    var uint8ToCString = string.uint8ToCString;
    var getUint64$1 = numbers.getUint64;
    /**
   * Based on: ISO/IEC 23009 Section: 5.10.3.3
   * References:
   * https://dashif-documents.azurewebsites.net/Events/master/event.html#emsg-format
   * https://aomediacodec.github.io/id3-emsg/
   * 
   * Takes emsg box data as a uint8 array and returns a emsg box object
   * @param {UInt8Array} boxData data from emsg box
   * @returns A parsed emsg box object
   */ var parseEmsgBox = function(boxData) {
        // version + flags
        var offset = 4;
        var version = boxData[0];
        var scheme_id_uri, value, timescale, presentation_time, presentation_time_delta, event_duration, id, message_data;
        if (version === 0) {
            scheme_id_uri = uint8ToCString(boxData.subarray(offset));
            offset += scheme_id_uri.length;
            value = uint8ToCString(boxData.subarray(offset));
            offset += value.length;
            var dv = new DataView(boxData.buffer);
            timescale = dv.getUint32(offset);
            offset += 4;
            presentation_time_delta = dv.getUint32(offset);
            offset += 4;
            event_duration = dv.getUint32(offset);
            offset += 4;
            id = dv.getUint32(offset);
            offset += 4;
        } else if (version === 1) {
            var dv = new DataView(boxData.buffer);
            timescale = dv.getUint32(offset);
            offset += 4;
            presentation_time = getUint64$1(boxData.subarray(offset));
            offset += 8;
            event_duration = dv.getUint32(offset);
            offset += 4;
            id = dv.getUint32(offset);
            offset += 4;
            scheme_id_uri = uint8ToCString(boxData.subarray(offset));
            offset += scheme_id_uri.length;
            value = uint8ToCString(boxData.subarray(offset));
            offset += value.length;
        }
        message_data = new Uint8Array(boxData.subarray(offset, boxData.byteLength));
        var emsgBox = {
            scheme_id_uri: scheme_id_uri,
            value: value,
            // if timescale is undefined or 0 set to 1 
            timescale: timescale ? timescale : 1,
            presentation_time: presentation_time,
            presentation_time_delta: presentation_time_delta,
            event_duration: event_duration,
            id: id,
            message_data: message_data
        };
        return isValidEmsgBox(version, emsgBox) ? emsgBox : undefined;
    };
    /**
   * Scales a presentation time or time delta with an offset with a provided timescale
   * @param {number} presentationTime 
   * @param {number} timescale 
   * @param {number} timeDelta 
   * @param {number} offset 
   * @returns the scaled time as a number
   */ var scaleTime = function(presentationTime, timescale, timeDelta, offset) {
        return presentationTime || presentationTime === 0 ? presentationTime / timescale : offset + timeDelta / timescale;
    };
    /**
   * Checks the emsg box data for validity based on the version
   * @param {number} version of the emsg box to validate
   * @param {Object} emsg the emsg data to validate
   * @returns if the box is valid as a boolean
   */ var isValidEmsgBox = function(version, emsg) {
        var hasScheme = emsg.scheme_id_uri !== "\x00";
        var isValidV0Box = version === 0 && isDefined(emsg.presentation_time_delta) && hasScheme;
        var isValidV1Box = version === 1 && isDefined(emsg.presentation_time) && hasScheme; // Only valid versions of emsg are 0 and 1
        return !(version > 1) && isValidV0Box || isValidV1Box;
    }; // Utility function to check if an object is defined
    var isDefined = function(data) {
        return data !== undefined || data !== null;
    };
    var emsg$1 = {
        parseEmsgBox: parseEmsgBox,
        scaleTime: scaleTime
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about MP4s.
   */ var toUnsigned = bin.toUnsigned;
    var toHexString = bin.toHexString;
    var findBox = findBox_1;
    var parseType$1 = parseType_1;
    var emsg = emsg$1;
    var parseTfhd = parseTfhd$2;
    var parseTrun = parseTrun$2;
    var parseTfdt = parseTfdt$2;
    var getUint64 = numbers.getUint64;
    var timescale, startTime, compositionStartTime, getVideoTrackIds, getTracks, getTimescaleFromMediaHeader, getEmsgID3;
    var window$1 = window_1;
    var parseId3Frames = parseId3.parseId3Frames;
    /**
   * Parses an MP4 initialization segment and extracts the timescale
   * values for any declared tracks. Timescale values indicate the
   * number of clock ticks per second to assume for time-based values
   * elsewhere in the MP4.
   *
   * To determine the start time of an MP4, you need two pieces of
   * information: the timescale unit and the earliest base media decode
   * time. Multiple timescales can be specified within an MP4 but the
   * base media decode time is always expressed in the timescale from
   * the media header box for the track:
   * ```
   * moov > trak > mdia > mdhd.timescale
   * ```
   * @param init {Uint8Array} the bytes of the init segment
   * @return {object} a hash of track ids to timescale values or null if
   * the init segment is malformed.
   */ timescale = function(init) {
        var result = {}, traks = findBox(init, [
            "moov",
            "trak"
        ]); // mdhd timescale
        return traks.reduce(function(result, trak) {
            var tkhd, version, index, id, mdhd;
            tkhd = findBox(trak, [
                "tkhd"
            ])[0];
            if (!tkhd) return null;
            version = tkhd[0];
            index = version === 0 ? 12 : 20;
            id = toUnsigned(tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3]);
            mdhd = findBox(trak, [
                "mdia",
                "mdhd"
            ])[0];
            if (!mdhd) return null;
            version = mdhd[0];
            index = version === 0 ? 12 : 20;
            result[id] = toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
            return result;
        }, result);
    };
    /**
   * Determine the base media decode start time, in seconds, for an MP4
   * fragment. If multiple fragments are specified, the earliest time is
   * returned.
   *
   * The base media decode time can be parsed from track fragment
   * metadata:
   * ```
   * moof > traf > tfdt.baseMediaDecodeTime
   * ```
   * It requires the timescale value from the mdhd to interpret.
   *
   * @param timescale {object} a hash of track ids to timescale values.
   * @return {number} the earliest base media decode start time for the
   * fragment, in seconds
   */ startTime = function(timescale, fragment) {
        var trafs; // we need info from two childrend of each track fragment box
        trafs = findBox(fragment, [
            "moof",
            "traf"
        ]); // determine the start times for each track
        var lowestTime = trafs.reduce(function(acc, traf) {
            var tfhd = findBox(traf, [
                "tfhd"
            ])[0]; // get the track id from the tfhd
            var id = toUnsigned(tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7]); // assume a 90kHz clock if no timescale was specified
            var scale = timescale[id] || 90e3; // get the base media decode time from the tfdt
            var tfdt = findBox(traf, [
                "tfdt"
            ])[0];
            var dv = new DataView(tfdt.buffer, tfdt.byteOffset, tfdt.byteLength);
            var baseTime; // version 1 is 64 bit
            if (tfdt[0] === 1) baseTime = getUint64(tfdt.subarray(4, 12));
            else baseTime = dv.getUint32(4);
             // convert base time to seconds if it is a valid number.
            let seconds;
            if (typeof baseTime === "bigint") seconds = baseTime / window$1.BigInt(scale);
            else if (typeof baseTime === "number" && !isNaN(baseTime)) seconds = baseTime / scale;
            if (seconds < Number.MAX_SAFE_INTEGER) seconds = Number(seconds);
            if (seconds < acc) acc = seconds;
            return acc;
        }, Infinity);
        return typeof lowestTime === "bigint" || isFinite(lowestTime) ? lowestTime : 0;
    };
    /**
   * Determine the composition start, in seconds, for an MP4
   * fragment.
   *
   * The composition start time of a fragment can be calculated using the base
   * media decode time, composition time offset, and timescale, as follows:
   *
   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
   *
   * All of the aforementioned information is contained within a media fragment's
   * `traf` box, except for timescale info, which comes from the initialization
   * segment, so a track id (also contained within a `traf`) is also necessary to
   * associate it with a timescale
   *
   *
   * @param timescales {object} - a hash of track ids to timescale values.
   * @param fragment {Unit8Array} - the bytes of a media segment
   * @return {number} the composition start time for the fragment, in seconds
   **/ compositionStartTime = function(timescales, fragment) {
        var trafBoxes = findBox(fragment, [
            "moof",
            "traf"
        ]);
        var baseMediaDecodeTime = 0;
        var compositionTimeOffset = 0;
        var trackId;
        if (trafBoxes && trafBoxes.length) {
            // The spec states that track run samples contained within a `traf` box are contiguous, but
            // it does not explicitly state whether the `traf` boxes themselves are contiguous.
            // We will assume that they are, so we only need the first to calculate start time.
            var tfhd = findBox(trafBoxes[0], [
                "tfhd"
            ])[0];
            var trun = findBox(trafBoxes[0], [
                "trun"
            ])[0];
            var tfdt = findBox(trafBoxes[0], [
                "tfdt"
            ])[0];
            if (tfhd) {
                var parsedTfhd = parseTfhd(tfhd);
                trackId = parsedTfhd.trackId;
            }
            if (tfdt) {
                var parsedTfdt = parseTfdt(tfdt);
                baseMediaDecodeTime = parsedTfdt.baseMediaDecodeTime;
            }
            if (trun) {
                var parsedTrun = parseTrun(trun);
                if (parsedTrun.samples && parsedTrun.samples.length) compositionTimeOffset = parsedTrun.samples[0].compositionTimeOffset || 0;
            }
        } // Get timescale for this specific track. Assume a 90kHz clock if no timescale was
        // specified.
        var timescale = timescales[trackId] || 90e3; // return the composition start time, in seconds
        if (typeof baseMediaDecodeTime === "bigint") {
            compositionTimeOffset = window$1.BigInt(compositionTimeOffset);
            timescale = window$1.BigInt(timescale);
        }
        var result = (baseMediaDecodeTime + compositionTimeOffset) / timescale;
        if (typeof result === "bigint" && result < Number.MAX_SAFE_INTEGER) result = Number(result);
        return result;
    };
    /**
    * Find the trackIds of the video tracks in this source.
    * Found by parsing the Handler Reference and Track Header Boxes:
    *   moov > trak > mdia > hdlr
    *   moov > trak > tkhd
    *
    * @param {Uint8Array} init - The bytes of the init segment for this source
    * @return {Number[]} A list of trackIds
    *
    * @see ISO-BMFF-12/2015, Section 8.4.3
   **/ getVideoTrackIds = function(init) {
        var traks = findBox(init, [
            "moov",
            "trak"
        ]);
        var videoTrackIds = [];
        traks.forEach(function(trak) {
            var hdlrs = findBox(trak, [
                "mdia",
                "hdlr"
            ]);
            var tkhds = findBox(trak, [
                "tkhd"
            ]);
            hdlrs.forEach(function(hdlr, index) {
                var handlerType = parseType$1(hdlr.subarray(8, 12));
                var tkhd = tkhds[index];
                var view;
                var version;
                var trackId;
                if (handlerType === "vide") {
                    view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
                    version = view.getUint8(0);
                    trackId = version === 0 ? view.getUint32(12) : view.getUint32(20);
                    videoTrackIds.push(trackId);
                }
            });
        });
        return videoTrackIds;
    };
    getTimescaleFromMediaHeader = function(mdhd) {
        // mdhd is a FullBox, meaning it will have its own version as the first byte
        var version = mdhd[0];
        var index = version === 0 ? 12 : 20;
        return toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
    };
    /**
   * Get all the video, audio, and hint tracks from a non fragmented
   * mp4 segment
   */ getTracks = function(init) {
        var traks = findBox(init, [
            "moov",
            "trak"
        ]);
        var tracks = [];
        traks.forEach(function(trak) {
            var track = {};
            var tkhd = findBox(trak, [
                "tkhd"
            ])[0];
            var view, tkhdVersion; // id
            if (tkhd) {
                view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
                tkhdVersion = view.getUint8(0);
                track.id = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
            }
            var hdlr = findBox(trak, [
                "mdia",
                "hdlr"
            ])[0]; // type
            if (hdlr) {
                var type = parseType$1(hdlr.subarray(8, 12));
                if (type === "vide") track.type = "video";
                else if (type === "soun") track.type = "audio";
                else track.type = type;
            } // codec
            var stsd = findBox(trak, [
                "mdia",
                "minf",
                "stbl",
                "stsd"
            ])[0];
            if (stsd) {
                var sampleDescriptions = stsd.subarray(8); // gives the codec type string
                track.codec = parseType$1(sampleDescriptions.subarray(4, 8));
                var codecBox = findBox(sampleDescriptions, [
                    track.codec
                ])[0];
                var codecConfig, codecConfigType;
                if (codecBox) {
                    // https://tools.ietf.org/html/rfc6381#section-3.3
                    if (/^[asm]vc[1-9]$/i.test(track.codec)) {
                        // we don't need anything but the "config" parameter of the
                        // avc1 codecBox
                        codecConfig = codecBox.subarray(78);
                        codecConfigType = parseType$1(codecConfig.subarray(4, 8));
                        if (codecConfigType === "avcC" && codecConfig.length > 11) {
                            track.codec += "."; // left padded with zeroes for single digit hex
                            // profile idc
                            track.codec += toHexString(codecConfig[9]); // the byte containing the constraint_set flags
                            track.codec += toHexString(codecConfig[10]); // level idc
                            track.codec += toHexString(codecConfig[11]);
                        } else // TODO: show a warning that we couldn't parse the codec
                        // and are using the default
                        track.codec = "avc1.4d400d";
                    } else if (/^mp4[a,v]$/i.test(track.codec)) {
                        // we do not need anything but the streamDescriptor of the mp4a codecBox
                        codecConfig = codecBox.subarray(28);
                        codecConfigType = parseType$1(codecConfig.subarray(4, 8));
                        if (codecConfigType === "esds" && codecConfig.length > 20 && codecConfig[19] !== 0) {
                            track.codec += "." + toHexString(codecConfig[19]); // this value is only a single digit
                            track.codec += "." + toHexString(codecConfig[20] >>> 2 & 0x3f).replace(/^0/, "");
                        } else // TODO: show a warning that we couldn't parse the codec
                        // and are using the default
                        track.codec = "mp4a.40.2";
                    } else // flac, opus, etc
                    track.codec = track.codec.toLowerCase();
                }
            }
            var mdhd = findBox(trak, [
                "mdia",
                "mdhd"
            ])[0];
            if (mdhd) track.timescale = getTimescaleFromMediaHeader(mdhd);
            tracks.push(track);
        });
        return tracks;
    };
    /**
   * Returns an array of emsg ID3 data from the provided segmentData.
   * An offset can also be provided as the Latest Arrival Time to calculate 
   * the Event Start Time of v0 EMSG boxes. 
   * See: https://dashif-documents.azurewebsites.net/Events/master/event.html#Inband-event-timing
   * 
   * @param {Uint8Array} segmentData the segment byte array.
   * @param {number} offset the segment start time or Latest Arrival Time, 
   * @return {Object[]} an array of ID3 parsed from EMSG boxes
   */ getEmsgID3 = function(segmentData, offset = 0) {
        var emsgBoxes = findBox(segmentData, [
            "emsg"
        ]);
        return emsgBoxes.map((data)=>{
            var parsedBox = emsg.parseEmsgBox(new Uint8Array(data));
            var parsedId3Frames = parseId3Frames(parsedBox.message_data);
            return {
                cueTime: emsg.scaleTime(parsedBox.presentation_time, parsedBox.timescale, parsedBox.presentation_time_delta, offset),
                duration: emsg.scaleTime(parsedBox.event_duration, parsedBox.timescale),
                frames: parsedId3Frames
            };
        });
    };
    var probe$2 = {
        // export mp4 inspector's findBox and parseType for backwards compatibility
        findBox: findBox,
        parseType: parseType$1,
        timescale: timescale,
        startTime: startTime,
        compositionStartTime: compositionStartTime,
        videoTrackIds: getVideoTrackIds,
        tracks: getTracks,
        getTimescaleFromMediaHeader: getTimescaleFromMediaHeader,
        getEmsgID3: getEmsgID3
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about TS Segments.
   */ var StreamTypes$1 = streamTypes;
    var parsePid = function(packet) {
        var pid = packet[1] & 0x1f;
        pid <<= 8;
        pid |= packet[2];
        return pid;
    };
    var parsePayloadUnitStartIndicator = function(packet) {
        return !!(packet[1] & 0x40);
    };
    var parseAdaptionField = function(packet) {
        var offset = 0; // if an adaption field is present, its length is specified by the
        // fifth byte of the TS packet header. The adaptation field is
        // used to add stuffing to PES packets that don't fill a complete
        // TS packet, and to specify some forms of timing and control data
        // that we do not currently use.
        if ((packet[3] & 0x30) >>> 4 > 0x01) offset += packet[4] + 1;
        return offset;
    };
    var parseType = function(packet, pmtPid) {
        var pid = parsePid(packet);
        if (pid === 0) return "pat";
        else if (pid === pmtPid) return "pmt";
        else if (pmtPid) return "pes";
        return null;
    };
    var parsePat = function(packet) {
        var pusi = parsePayloadUnitStartIndicator(packet);
        var offset = 4 + parseAdaptionField(packet);
        if (pusi) offset += packet[offset] + 1;
        return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
    };
    var parsePmt = function(packet) {
        var programMapTable = {};
        var pusi = parsePayloadUnitStartIndicator(packet);
        var payloadOffset = 4 + parseAdaptionField(packet);
        if (pusi) payloadOffset += packet[payloadOffset] + 1;
         // PMTs can be sent ahead of the time when they should actually
        // take effect. We don't believe this should ever be the case
        // for HLS but we'll ignore "forward" PMT declarations if we see
        // them. Future PMT declarations have the current_next_indicator
        // set to zero.
        if (!(packet[payloadOffset + 5] & 0x01)) return;
        var sectionLength, tableEnd, programInfoLength; // the mapping table ends at the end of the current section
        sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
        tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
        // long the program info descriptors are
        programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11]; // advance the offset to the first entry in the mapping table
        var offset = 12 + programInfoLength;
        while(offset < tableEnd){
            var i = payloadOffset + offset; // add an entry that maps the elementary_pid to the stream_type
            programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i]; // move to the next table entry
            // skip past the elementary stream descriptors, if present
            offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
        }
        return programMapTable;
    };
    var parsePesType = function(packet, programMapTable) {
        var pid = parsePid(packet);
        var type = programMapTable[pid];
        switch(type){
            case StreamTypes$1.H264_STREAM_TYPE:
                return "video";
            case StreamTypes$1.ADTS_STREAM_TYPE:
                return "audio";
            case StreamTypes$1.METADATA_STREAM_TYPE:
                return "timed-metadata";
            default:
                return null;
        }
    };
    var parsePesTime = function(packet) {
        var pusi = parsePayloadUnitStartIndicator(packet);
        if (!pusi) return null;
        var offset = 4 + parseAdaptionField(packet);
        if (offset >= packet.byteLength) // From the H 222.0 MPEG-TS spec
        // "For transport stream packets carrying PES packets, stuffing is needed when there
        //  is insufficient PES packet data to completely fill the transport stream packet
        //  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
        //  the sum of the lengths of the data elements in it, so that the payload bytes
        //  remaining after the adaptation field exactly accommodates the available PES packet
        //  data."
        //
        // If the offset is >= the length of the packet, then the packet contains no data
        // and instead is just adaption field stuffing bytes
        return null;
        var pes = null;
        var ptsDtsFlags; // PES packets may be annotated with a PTS value, or a PTS value
        // and a DTS value. Determine what combination of values is
        // available to work with.
        ptsDtsFlags = packet[offset + 7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
        // performs all bitwise operations on 32-bit integers but javascript
        // supports a much greater range (52-bits) of integer using standard
        // mathematical operations.
        // We construct a 31-bit value using bitwise operators over the 31
        // most significant bits and then multiply by 4 (equal to a left-shift
        // of 2) before we add the final 2 least significant bits of the
        // timestamp (equal to an OR.)
        if (ptsDtsFlags & 0xC0) {
            pes = {}; // the PTS and DTS are not written out directly. For information
            // on how they are encoded, see
            // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
            pes.pts = (packet[offset + 9] & 0x0E) << 27 | (packet[offset + 10] & 0xFF) << 20 | (packet[offset + 11] & 0xFE) << 12 | (packet[offset + 12] & 0xFF) << 5 | (packet[offset + 13] & 0xFE) >>> 3;
            pes.pts *= 4; // Left shift by 2
            pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
            pes.dts = pes.pts;
            if (ptsDtsFlags & 0x40) {
                pes.dts = (packet[offset + 14] & 0x0E) << 27 | (packet[offset + 15] & 0xFF) << 20 | (packet[offset + 16] & 0xFE) << 12 | (packet[offset + 17] & 0xFF) << 5 | (packet[offset + 18] & 0xFE) >>> 3;
                pes.dts *= 4; // Left shift by 2
                pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
            }
        }
        return pes;
    };
    var parseNalUnitType = function(type) {
        switch(type){
            case 0x05:
                return "slice_layer_without_partitioning_rbsp_idr";
            case 0x06:
                return "sei_rbsp";
            case 0x07:
                return "seq_parameter_set_rbsp";
            case 0x08:
                return "pic_parameter_set_rbsp";
            case 0x09:
                return "access_unit_delimiter_rbsp";
            default:
                return null;
        }
    };
    var videoPacketContainsKeyFrame = function(packet) {
        var offset = 4 + parseAdaptionField(packet);
        var frameBuffer = packet.subarray(offset);
        var frameI = 0;
        var frameSyncPoint = 0;
        var foundKeyFrame = false;
        var nalType; // advance the sync point to a NAL start, if necessary
        for(; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++)if (frameBuffer[frameSyncPoint + 2] === 1) {
            // the sync point is properly aligned
            frameI = frameSyncPoint + 5;
            break;
        }
        while(frameI < frameBuffer.byteLength)// look at the current byte to determine if we've hit the end of
        // a NAL unit boundary
        switch(frameBuffer[frameI]){
            case 0:
                // skip past non-sync sequences
                if (frameBuffer[frameI - 1] !== 0) {
                    frameI += 2;
                    break;
                } else if (frameBuffer[frameI - 2] !== 0) {
                    frameI++;
                    break;
                }
                if (frameSyncPoint + 3 !== frameI - 2) {
                    nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
                    if (nalType === "slice_layer_without_partitioning_rbsp_idr") foundKeyFrame = true;
                } // drop trailing zeroes
                do frameI++;
                while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
                frameSyncPoint = frameI - 2;
                frameI += 3;
                break;
            case 1:
                // skip past non-sync sequences
                if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
                    frameI += 3;
                    break;
                }
                nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
                if (nalType === "slice_layer_without_partitioning_rbsp_idr") foundKeyFrame = true;
                frameSyncPoint = frameI - 2;
                frameI += 3;
                break;
            default:
                // the current byte isn't a one or zero, so it cannot be part
                // of a sync sequence
                frameI += 3;
                break;
        }
        frameBuffer = frameBuffer.subarray(frameSyncPoint);
        frameI -= frameSyncPoint;
        frameSyncPoint = 0; // parse the final nal
        if (frameBuffer && frameBuffer.byteLength > 3) {
            nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
            if (nalType === "slice_layer_without_partitioning_rbsp_idr") foundKeyFrame = true;
        }
        return foundKeyFrame;
    };
    var probe$1 = {
        parseType: parseType,
        parsePat: parsePat,
        parsePmt: parsePmt,
        parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
        parsePesType: parsePesType,
        parsePesTime: parsePesTime,
        videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
    };
    /**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Parse mpeg2 transport stream packets to extract basic timing information
   */ var StreamTypes = streamTypes;
    var handleRollover = timestampRolloverStream.handleRollover;
    var probe = {};
    probe.ts = probe$1;
    probe.aac = utils;
    var ONE_SECOND_IN_TS = clock$2.ONE_SECOND_IN_TS;
    var MP2T_PACKET_LENGTH = 188, // bytes
    SYNC_BYTE = 0x47;
    /**
   * walks through segment data looking for pat and pmt packets to parse out
   * program map table information
   */ var parsePsi_ = function(bytes, pmt) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type;
        while(endIndex < bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case "pat":
                        pmt.pid = probe.ts.parsePat(packet);
                        break;
                    case "pmt":
                        var table = probe.ts.parsePmt(packet);
                        pmt.table = pmt.table || {};
                        Object.keys(table).forEach(function(key) {
                            pmt.table[key] = table[key];
                        });
                        break;
                }
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        }
    };
    /**
   * walks through the segment data from the start and end to get timing information
   * for the first and last audio pes packets
   */ var parseAudioPes_ = function(bytes, pmt, result) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type, pesType, pusi, parsed;
        var endLoop = false; // Start walking from start of segment to get first audio packet
        while(endIndex <= bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case "pes":
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === "audio" && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = "audio";
                                result.audio.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        } // Start walking from end of segment to get last audio packet
        endIndex = bytes.byteLength;
        startIndex = endIndex - MP2T_PACKET_LENGTH;
        endLoop = false;
        while(startIndex >= 0){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case "pes":
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === "audio" && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = "audio";
                                result.audio.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex -= MP2T_PACKET_LENGTH;
                endIndex -= MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex--;
            endIndex--;
        }
    };
    /**
   * walks through the segment data from the start and end to get timing information
   * for the first and last video pes packets as well as timing information for the first
   * key frame.
   */ var parseVideoPes_ = function(bytes, pmt, result) {
        var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type, pesType, pusi, parsed, frame, i, pes;
        var endLoop = false;
        var currentFrame = {
            data: [],
            size: 0
        }; // Start walking from start of segment to get first video packet
        while(endIndex < bytes.byteLength){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case "pes":
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === "video") {
                            if (pusi && !endLoop) {
                                parsed = probe.ts.parsePesTime(packet);
                                if (parsed) {
                                    parsed.type = "video";
                                    result.video.push(parsed);
                                    endLoop = true;
                                }
                            }
                            if (!result.firstKeyFrame) {
                                if (pusi) {
                                    if (currentFrame.size !== 0) {
                                        frame = new Uint8Array(currentFrame.size);
                                        i = 0;
                                        while(currentFrame.data.length){
                                            pes = currentFrame.data.shift();
                                            frame.set(pes, i);
                                            i += pes.byteLength;
                                        }
                                        if (probe.ts.videoPacketContainsKeyFrame(frame)) {
                                            var firstKeyFrame = probe.ts.parsePesTime(frame); // PTS/DTS may not be available. Simply *not* setting
                                            // the keyframe seems to work fine with HLS playback
                                            // and definitely preferable to a crash with TypeError...
                                            if (firstKeyFrame) {
                                                result.firstKeyFrame = firstKeyFrame;
                                                result.firstKeyFrame.type = "video";
                                            } else // eslint-disable-next-line
                                            console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                                        }
                                        currentFrame.size = 0;
                                    }
                                }
                                currentFrame.data.push(packet);
                                currentFrame.size += packet.byteLength;
                            }
                        }
                        break;
                }
                if (endLoop && result.firstKeyFrame) break;
                startIndex += MP2T_PACKET_LENGTH;
                endIndex += MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex++;
            endIndex++;
        } // Start walking from end of segment to get last video packet
        endIndex = bytes.byteLength;
        startIndex = endIndex - MP2T_PACKET_LENGTH;
        endLoop = false;
        while(startIndex >= 0){
            // Look for a pair of start and end sync bytes in the data..
            if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
                // We found a packet
                packet = bytes.subarray(startIndex, endIndex);
                type = probe.ts.parseType(packet, pmt.pid);
                switch(type){
                    case "pes":
                        pesType = probe.ts.parsePesType(packet, pmt.table);
                        pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
                        if (pesType === "video" && pusi) {
                            parsed = probe.ts.parsePesTime(packet);
                            if (parsed) {
                                parsed.type = "video";
                                result.video.push(parsed);
                                endLoop = true;
                            }
                        }
                        break;
                }
                if (endLoop) break;
                startIndex -= MP2T_PACKET_LENGTH;
                endIndex -= MP2T_PACKET_LENGTH;
                continue;
            } // If we get here, we have somehow become de-synchronized and we need to step
            // forward one byte at a time until we find a pair of sync bytes that denote
            // a packet
            startIndex--;
            endIndex--;
        }
    };
    /**
   * Adjusts the timestamp information for the segment to account for
   * rollover and convert to seconds based on pes packet timescale (90khz clock)
   */ var adjustTimestamp_ = function(segmentInfo, baseTimestamp) {
        if (segmentInfo.audio && segmentInfo.audio.length) {
            var audioBaseTimestamp = baseTimestamp;
            if (typeof audioBaseTimestamp === "undefined" || isNaN(audioBaseTimestamp)) audioBaseTimestamp = segmentInfo.audio[0].dts;
            segmentInfo.audio.forEach(function(info) {
                info.dts = handleRollover(info.dts, audioBaseTimestamp);
                info.pts = handleRollover(info.pts, audioBaseTimestamp); // time in seconds
                info.dtsTime = info.dts / ONE_SECOND_IN_TS;
                info.ptsTime = info.pts / ONE_SECOND_IN_TS;
            });
        }
        if (segmentInfo.video && segmentInfo.video.length) {
            var videoBaseTimestamp = baseTimestamp;
            if (typeof videoBaseTimestamp === "undefined" || isNaN(videoBaseTimestamp)) videoBaseTimestamp = segmentInfo.video[0].dts;
            segmentInfo.video.forEach(function(info) {
                info.dts = handleRollover(info.dts, videoBaseTimestamp);
                info.pts = handleRollover(info.pts, videoBaseTimestamp); // time in seconds
                info.dtsTime = info.dts / ONE_SECOND_IN_TS;
                info.ptsTime = info.pts / ONE_SECOND_IN_TS;
            });
            if (segmentInfo.firstKeyFrame) {
                var frame = segmentInfo.firstKeyFrame;
                frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
                frame.pts = handleRollover(frame.pts, videoBaseTimestamp); // time in seconds
                frame.dtsTime = frame.dts / ONE_SECOND_IN_TS;
                frame.ptsTime = frame.pts / ONE_SECOND_IN_TS;
            }
        }
    };
    /**
   * inspects the aac data stream for start and end time information
   */ var inspectAac_ = function(bytes) {
        var endLoop = false, audioCount = 0, sampleRate = null, timestamp = null, frameSize = 0, byteIndex = 0, packet;
        while(bytes.length - byteIndex >= 3){
            var type = probe.aac.parseType(bytes, byteIndex);
            switch(type){
                case "timed-metadata":
                    // Exit early because we don't have enough to parse
                    // the ID3 tag header
                    if (bytes.length - byteIndex < 10) {
                        endLoop = true;
                        break;
                    }
                    frameSize = probe.aac.parseId3TagSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (frameSize > bytes.length) {
                        endLoop = true;
                        break;
                    }
                    if (timestamp === null) {
                        packet = bytes.subarray(byteIndex, byteIndex + frameSize);
                        timestamp = probe.aac.parseAacTimestamp(packet);
                    }
                    byteIndex += frameSize;
                    break;
                case "audio":
                    // Exit early because we don't have enough to parse
                    // the ADTS frame header
                    if (bytes.length - byteIndex < 7) {
                        endLoop = true;
                        break;
                    }
                    frameSize = probe.aac.parseAdtsSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
                    // to emit a full packet
                    if (frameSize > bytes.length) {
                        endLoop = true;
                        break;
                    }
                    if (sampleRate === null) {
                        packet = bytes.subarray(byteIndex, byteIndex + frameSize);
                        sampleRate = probe.aac.parseSampleRate(packet);
                    }
                    audioCount++;
                    byteIndex += frameSize;
                    break;
                default:
                    byteIndex++;
                    break;
            }
            if (endLoop) return null;
        }
        if (sampleRate === null || timestamp === null) return null;
        var audioTimescale = ONE_SECOND_IN_TS / sampleRate;
        var result = {
            audio: [
                {
                    type: "audio",
                    dts: timestamp,
                    pts: timestamp
                },
                {
                    type: "audio",
                    dts: timestamp + audioCount * 1024 * audioTimescale,
                    pts: timestamp + audioCount * 1024 * audioTimescale
                }
            ]
        };
        return result;
    };
    /**
   * inspects the transport stream segment data for start and end time information
   * of the audio and video tracks (when present) as well as the first key frame's
   * start time.
   */ var inspectTs_ = function(bytes) {
        var pmt = {
            pid: null,
            table: null
        };
        var result = {};
        parsePsi_(bytes, pmt);
        for(var pid in pmt.table)if (pmt.table.hasOwnProperty(pid)) {
            var type = pmt.table[pid];
            switch(type){
                case StreamTypes.H264_STREAM_TYPE:
                    result.video = [];
                    parseVideoPes_(bytes, pmt, result);
                    if (result.video.length === 0) delete result.video;
                    break;
                case StreamTypes.ADTS_STREAM_TYPE:
                    result.audio = [];
                    parseAudioPes_(bytes, pmt, result);
                    if (result.audio.length === 0) delete result.audio;
                    break;
            }
        }
        return result;
    };
    /**
   * Inspects segment byte data and returns an object with start and end timing information
   *
   * @param {Uint8Array} bytes The segment byte data
   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
   *  timestamps for rollover. This value must be in 90khz clock.
   * @return {Object} Object containing start and end frame timing info of segment.
   */ var inspect = function(bytes, baseTimestamp) {
        var isAacData = probe.aac.isLikelyAacData(bytes);
        var result;
        if (isAacData) result = inspectAac_(bytes);
        else result = inspectTs_(bytes);
        if (!result || !result.audio && !result.video) return null;
        adjustTimestamp_(result, baseTimestamp);
        return result;
    };
    var tsInspector = {
        inspect: inspect,
        parseAudioPes_: parseAudioPes_
    };
    /* global self */ /**
   * Re-emits transmuxer events by converting them into messages to the
   * world outside the worker.
   *
   * @param {Object} transmuxer the transmuxer to wire events on
   * @private
   */ const wireTransmuxerEvents = function(self1, transmuxer) {
        transmuxer.on("data", function(segment) {
            // transfer ownership of the underlying ArrayBuffer
            // instead of doing a copy to save memory
            // ArrayBuffers are transferable but generic TypedArrays are not
            // @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
            const initArray = segment.initSegment;
            segment.initSegment = {
                data: initArray.buffer,
                byteOffset: initArray.byteOffset,
                byteLength: initArray.byteLength
            };
            const typedArray = segment.data;
            segment.data = typedArray.buffer;
            self1.postMessage({
                action: "data",
                segment: segment,
                byteOffset: typedArray.byteOffset,
                byteLength: typedArray.byteLength
            }, [
                segment.data
            ]);
        });
        transmuxer.on("done", function(data) {
            self1.postMessage({
                action: "done"
            });
        });
        transmuxer.on("gopInfo", function(gopInfo) {
            self1.postMessage({
                action: "gopInfo",
                gopInfo: gopInfo
            });
        });
        transmuxer.on("videoSegmentTimingInfo", function(timingInfo) {
            const videoSegmentTimingInfo = {
                start: {
                    decode: clock$2.videoTsToSeconds(timingInfo.start.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.start.pts)
                },
                end: {
                    decode: clock$2.videoTsToSeconds(timingInfo.end.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.end.pts)
                },
                baseMediaDecodeTime: clock$2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
            };
            if (timingInfo.prependedContentDuration) videoSegmentTimingInfo.prependedContentDuration = clock$2.videoTsToSeconds(timingInfo.prependedContentDuration);
            self1.postMessage({
                action: "videoSegmentTimingInfo",
                videoSegmentTimingInfo: videoSegmentTimingInfo
            });
        });
        transmuxer.on("audioSegmentTimingInfo", function(timingInfo) {
            // Note that all times for [audio/video]SegmentTimingInfo events are in video clock
            const audioSegmentTimingInfo = {
                start: {
                    decode: clock$2.videoTsToSeconds(timingInfo.start.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.start.pts)
                },
                end: {
                    decode: clock$2.videoTsToSeconds(timingInfo.end.dts),
                    presentation: clock$2.videoTsToSeconds(timingInfo.end.pts)
                },
                baseMediaDecodeTime: clock$2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
            };
            if (timingInfo.prependedContentDuration) audioSegmentTimingInfo.prependedContentDuration = clock$2.videoTsToSeconds(timingInfo.prependedContentDuration);
            self1.postMessage({
                action: "audioSegmentTimingInfo",
                audioSegmentTimingInfo: audioSegmentTimingInfo
            });
        });
        transmuxer.on("id3Frame", function(id3Frame) {
            self1.postMessage({
                action: "id3Frame",
                id3Frame: id3Frame
            });
        });
        transmuxer.on("caption", function(caption) {
            self1.postMessage({
                action: "caption",
                caption: caption
            });
        });
        transmuxer.on("trackinfo", function(trackInfo) {
            self1.postMessage({
                action: "trackinfo",
                trackInfo: trackInfo
            });
        });
        transmuxer.on("audioTimingInfo", function(audioTimingInfo) {
            // convert to video TS since we prioritize video time over audio
            self1.postMessage({
                action: "audioTimingInfo",
                audioTimingInfo: {
                    start: clock$2.videoTsToSeconds(audioTimingInfo.start),
                    end: clock$2.videoTsToSeconds(audioTimingInfo.end)
                }
            });
        });
        transmuxer.on("videoTimingInfo", function(videoTimingInfo) {
            self1.postMessage({
                action: "videoTimingInfo",
                videoTimingInfo: {
                    start: clock$2.videoTsToSeconds(videoTimingInfo.start),
                    end: clock$2.videoTsToSeconds(videoTimingInfo.end)
                }
            });
        });
        transmuxer.on("log", function(log) {
            self1.postMessage({
                action: "log",
                log: log
            });
        });
    };
    /**
   * All incoming messages route through this hash. If no function exists
   * to handle an incoming message, then we ignore the message.
   *
   * @class MessageHandlers
   * @param {Object} options the options to initialize with
   */ class MessageHandlers {
        constructor(self1, options){
            this.options = options || {};
            this.self = self1;
            this.init();
        }
        /**
     * initialize our web worker and wire all the events.
     */ init() {
            if (this.transmuxer) this.transmuxer.dispose();
            this.transmuxer = new transmuxer.Transmuxer(this.options);
            wireTransmuxerEvents(this.self, this.transmuxer);
        }
        pushMp4Captions(data) {
            if (!this.captionParser) {
                this.captionParser = new captionParser();
                this.captionParser.init();
            }
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            const parsed = this.captionParser.parse(segment, data.trackIds, data.timescales);
            this.self.postMessage({
                action: "mp4Captions",
                captions: parsed && parsed.captions || [],
                logs: parsed && parsed.logs || [],
                data: segment.buffer
            }, [
                segment.buffer
            ]);
        }
        probeMp4StartTime({ timescales: timescales, data: data }) {
            const startTime = probe$2.startTime(timescales, data);
            this.self.postMessage({
                action: "probeMp4StartTime",
                startTime: startTime,
                data: data
            }, [
                data.buffer
            ]);
        }
        probeMp4Tracks({ data: data }) {
            const tracks = probe$2.tracks(data);
            this.self.postMessage({
                action: "probeMp4Tracks",
                tracks: tracks,
                data: data
            }, [
                data.buffer
            ]);
        }
        /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */ probeEmsgID3({ data: data, offset: offset }) {
            const id3Frames = probe$2.getEmsgID3(data, offset);
            this.self.postMessage({
                action: "probeEmsgID3",
                id3Frames: id3Frames,
                emsgData: data
            }, [
                data.buffer
            ]);
        }
        /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */ probeTs({ data: data, baseStartTime: baseStartTime }) {
            const tsStartTime = typeof baseStartTime === "number" && !isNaN(baseStartTime) ? baseStartTime * clock$2.ONE_SECOND_IN_TS : void 0;
            const timeInfo = tsInspector.inspect(data, tsStartTime);
            let result = null;
            if (timeInfo) {
                result = {
                    // each type's time info comes back as an array of 2 times, start and end
                    hasVideo: timeInfo.video && timeInfo.video.length === 2 || false,
                    hasAudio: timeInfo.audio && timeInfo.audio.length === 2 || false
                };
                if (result.hasVideo) result.videoStart = timeInfo.video[0].ptsTime;
                if (result.hasAudio) result.audioStart = timeInfo.audio[0].ptsTime;
            }
            this.self.postMessage({
                action: "probeTs",
                result: result,
                data: data
            }, [
                data.buffer
            ]);
        }
        clearAllMp4Captions() {
            if (this.captionParser) this.captionParser.clearAllCaptions();
        }
        clearParsedMp4Captions() {
            if (this.captionParser) this.captionParser.clearParsedCaptions();
        }
        /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */ push(data) {
            // Cast array buffer to correct type for transmuxer
            const segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
            this.transmuxer.push(segment);
        }
        /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */ reset() {
            this.transmuxer.reset();
        }
        /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */ setTimestampOffset(data) {
            const timestampOffset = data.timestampOffset || 0;
            this.transmuxer.setBaseMediaDecodeTime(Math.round(clock$2.secondsToVideoTs(timestampOffset)));
        }
        setAudioAppendStart(data) {
            this.transmuxer.setAudioAppendStart(Math.ceil(clock$2.secondsToVideoTs(data.appendStart)));
        }
        setRemux(data) {
            this.transmuxer.setRemux(data.remux);
        }
        /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */ flush(data) {
            this.transmuxer.flush(); // transmuxed done action is fired after both audio/video pipelines are flushed
            self.postMessage({
                action: "done",
                type: "transmuxed"
            });
        }
        endTimeline() {
            this.transmuxer.endTimeline(); // transmuxed endedtimeline action is fired after both audio/video pipelines end their
            // timelines
            self.postMessage({
                action: "endedtimeline",
                type: "transmuxed"
            });
        }
        alignGopsWith(data) {
            this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
        }
    }
    /**
   * Our web worker interface so that things can talk to mux.js
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   *
   * @param {Object} self the scope for the web worker
   */ self.onmessage = function(event) {
        if (event.data.action === "init" && event.data.options) {
            this.messageHandlers = new MessageHandlers(self, event.data.options);
            return;
        }
        if (!this.messageHandlers) this.messageHandlers = new MessageHandlers(self);
        if (event.data && event.data.action && event.data.action !== "init") {
            if (this.messageHandlers[event.data.action]) this.messageHandlers[event.data.action](event.data);
        }
    };
}));
var $cb03b711053a4297$var$TransmuxWorker = $cb03b711053a4297$var$factory($cb03b711053a4297$var$workerCode$1);
/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */ const $cb03b711053a4297$var$handleData_ = (event, transmuxedData, callback)=>{
    const { type: type, initSegment: initSegment, captions: captions, captionStreams: captionStreams, metadata: metadata, videoFrameDtsTime: videoFrameDtsTime, videoFramePtsTime: videoFramePtsTime } = event.data.segment;
    transmuxedData.buffer.push({
        captions: captions,
        captionStreams: captionStreams,
        metadata: metadata
    });
    const boxes = event.data.segment.boxes || {
        data: event.data.segment.data
    };
    const result = {
        type: type,
        // cast ArrayBuffer to TypedArray
        data: new Uint8Array(boxes.data, boxes.data.byteOffset, boxes.data.byteLength),
        initSegment: new Uint8Array(initSegment.data, initSegment.byteOffset, initSegment.byteLength)
    };
    if (typeof videoFrameDtsTime !== "undefined") result.videoFrameDtsTime = videoFrameDtsTime;
    if (typeof videoFramePtsTime !== "undefined") result.videoFramePtsTime = videoFramePtsTime;
    callback(result);
};
const $cb03b711053a4297$var$handleDone_ = ({ transmuxedData: transmuxedData, callback: callback })=>{
    // Previously we only returned data on data events,
    // not on done events. Clear out the buffer to keep that consistent.
    transmuxedData.buffer = []; // all buffers should have been flushed from the muxer, so start processing anything we
    // have received
    callback(transmuxedData);
};
const $cb03b711053a4297$var$handleGopInfo_ = (event, transmuxedData)=>{
    transmuxedData.gopInfo = event.data.gopInfo;
};
const $cb03b711053a4297$var$processTransmux = (options)=>{
    const { transmuxer: transmuxer, bytes: bytes, audioAppendStart: audioAppendStart, gopsToAlignWith: gopsToAlignWith, remux: remux, onData: onData, onTrackInfo: onTrackInfo, onAudioTimingInfo: onAudioTimingInfo, onVideoTimingInfo: onVideoTimingInfo, onVideoSegmentTimingInfo: onVideoSegmentTimingInfo, onAudioSegmentTimingInfo: onAudioSegmentTimingInfo, onId3: onId3, onCaptions: onCaptions, onDone: onDone, onEndedTimeline: onEndedTimeline, onTransmuxerLog: onTransmuxerLog, isEndOfTimeline: isEndOfTimeline } = options;
    const transmuxedData = {
        buffer: []
    };
    let waitForEndedTimelineEvent = isEndOfTimeline;
    const handleMessage = (event)=>{
        if (transmuxer.currentTransmux !== options) // disposed
        return;
        if (event.data.action === "data") $cb03b711053a4297$var$handleData_(event, transmuxedData, onData);
        if (event.data.action === "trackinfo") onTrackInfo(event.data.trackInfo);
        if (event.data.action === "gopInfo") $cb03b711053a4297$var$handleGopInfo_(event, transmuxedData);
        if (event.data.action === "audioTimingInfo") onAudioTimingInfo(event.data.audioTimingInfo);
        if (event.data.action === "videoTimingInfo") onVideoTimingInfo(event.data.videoTimingInfo);
        if (event.data.action === "videoSegmentTimingInfo") onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);
        if (event.data.action === "audioSegmentTimingInfo") onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);
        if (event.data.action === "id3Frame") onId3([
            event.data.id3Frame
        ], event.data.id3Frame.dispatchType);
        if (event.data.action === "caption") onCaptions(event.data.caption);
        if (event.data.action === "endedtimeline") {
            waitForEndedTimelineEvent = false;
            onEndedTimeline();
        }
        if (event.data.action === "log") onTransmuxerLog(event.data.log);
         // wait for the transmuxed event since we may have audio and video
        if (event.data.type !== "transmuxed") return;
         // If the "endedtimeline" event has not yet fired, and this segment represents the end
        // of a timeline, that means there may still be data events before the segment
        // processing can be considerred complete. In that case, the final event should be
        // an "endedtimeline" event with the type "transmuxed."
        if (waitForEndedTimelineEvent) return;
        transmuxer.onmessage = null;
        $cb03b711053a4297$var$handleDone_({
            transmuxedData: transmuxedData,
            callback: onDone
        });
        /* eslint-disable no-use-before-define */ $cb03b711053a4297$var$dequeue(transmuxer);
    /* eslint-enable */ };
    transmuxer.onmessage = handleMessage;
    if (audioAppendStart) transmuxer.postMessage({
        action: "setAudioAppendStart",
        appendStart: audioAppendStart
    });
     // allow empty arrays to be passed to clear out GOPs
    if (Array.isArray(gopsToAlignWith)) transmuxer.postMessage({
        action: "alignGopsWith",
        gopsToAlignWith: gopsToAlignWith
    });
    if (typeof remux !== "undefined") transmuxer.postMessage({
        action: "setRemux",
        remux: remux
    });
    if (bytes.byteLength) {
        const buffer = bytes instanceof ArrayBuffer ? bytes : bytes.buffer;
        const byteOffset = bytes instanceof ArrayBuffer ? 0 : bytes.byteOffset;
        transmuxer.postMessage({
            action: "push",
            // Send the typed-array of data as an ArrayBuffer so that
            // it can be sent as a "Transferable" and avoid the costly
            // memory copy
            data: buffer,
            byteOffset: // To recreate the original typed-array, we need information
            // about what portion of the ArrayBuffer it was a view into
            byteOffset,
            byteLength: bytes.byteLength
        }, [
            buffer
        ]);
    }
    if (isEndOfTimeline) transmuxer.postMessage({
        action: "endTimeline"
    });
     // even if we didn't push any bytes, we have to make sure we flush in case we reached
    // the end of the segment
    transmuxer.postMessage({
        action: "flush"
    });
};
const $cb03b711053a4297$var$dequeue = (transmuxer)=>{
    transmuxer.currentTransmux = null;
    if (transmuxer.transmuxQueue.length) {
        transmuxer.currentTransmux = transmuxer.transmuxQueue.shift();
        if (typeof transmuxer.currentTransmux === "function") transmuxer.currentTransmux();
        else $cb03b711053a4297$var$processTransmux(transmuxer.currentTransmux);
    }
};
const $cb03b711053a4297$var$processAction = (transmuxer, action)=>{
    transmuxer.postMessage({
        action: action
    });
    $cb03b711053a4297$var$dequeue(transmuxer);
};
const $cb03b711053a4297$var$enqueueAction = (action, transmuxer)=>{
    if (!transmuxer.currentTransmux) {
        transmuxer.currentTransmux = action;
        $cb03b711053a4297$var$processAction(transmuxer, action);
        return;
    }
    transmuxer.transmuxQueue.push($cb03b711053a4297$var$processAction.bind(null, transmuxer, action));
};
const $cb03b711053a4297$var$reset = (transmuxer)=>{
    $cb03b711053a4297$var$enqueueAction("reset", transmuxer);
};
const $cb03b711053a4297$var$endTimeline = (transmuxer)=>{
    $cb03b711053a4297$var$enqueueAction("endTimeline", transmuxer);
};
const $cb03b711053a4297$var$transmux = (options)=>{
    if (!options.transmuxer.currentTransmux) {
        options.transmuxer.currentTransmux = options;
        $cb03b711053a4297$var$processTransmux(options);
        return;
    }
    options.transmuxer.transmuxQueue.push(options);
};
const $cb03b711053a4297$var$createTransmuxer = (options)=>{
    const transmuxer = new $cb03b711053a4297$var$TransmuxWorker();
    transmuxer.currentTransmux = null;
    transmuxer.transmuxQueue = [];
    const term = transmuxer.terminate;
    transmuxer.terminate = ()=>{
        transmuxer.currentTransmux = null;
        transmuxer.transmuxQueue.length = 0;
        return term.call(transmuxer);
    };
    transmuxer.postMessage({
        action: "init",
        options: options
    });
    return transmuxer;
};
var $cb03b711053a4297$var$segmentTransmuxer = {
    reset: $cb03b711053a4297$var$reset,
    endTimeline: $cb03b711053a4297$var$endTimeline,
    transmux: $cb03b711053a4297$var$transmux,
    createTransmuxer: $cb03b711053a4297$var$createTransmuxer
};
const $cb03b711053a4297$var$workerCallback = function(options) {
    const transmuxer = options.transmuxer;
    const endAction = options.endAction || options.action;
    const callback = options.callback;
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, options, {
        endAction: null,
        transmuxer: null,
        callback: null
    });
    const listenForEndEvent = (event)=>{
        if (event.data.action !== endAction) return;
        transmuxer.removeEventListener("message", listenForEndEvent); // transfer ownership of bytes back to us.
        if (event.data.data) {
            event.data.data = new Uint8Array(event.data.data, options.byteOffset || 0, options.byteLength || event.data.data.byteLength);
            if (options.data) options.data = event.data.data;
        }
        callback(event.data);
    };
    transmuxer.addEventListener("message", listenForEndEvent);
    if (options.data) {
        const isArrayBuffer = options.data instanceof ArrayBuffer;
        message.byteOffset = isArrayBuffer ? 0 : options.data.byteOffset;
        message.byteLength = options.data.byteLength;
        const transfers = [
            isArrayBuffer ? options.data : options.data.buffer
        ];
        transmuxer.postMessage(message, transfers);
    } else transmuxer.postMessage(message);
};
const $cb03b711053a4297$var$REQUEST_ERRORS = {
    FAILURE: 2,
    TIMEOUT: -101,
    ABORTED: -102
};
/**
 * Abort all requests
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 */ const $cb03b711053a4297$var$abortAll = (activeXhrs)=>{
    activeXhrs.forEach((xhr)=>{
        xhr.abort();
    });
};
/**
 * Gather important bandwidth stats once a request has completed
 *
 * @param {Object} request - the XHR request from which to gather stats
 */ const $cb03b711053a4297$var$getRequestStats = (request)=>{
    return {
        bandwidth: request.bandwidth,
        bytesReceived: request.bytesReceived || 0,
        roundTripTime: request.roundTripTime || 0
    };
};
/**
 * If possible gather bandwidth stats as a request is in
 * progress
 *
 * @param {Event} progressEvent - an event object from an XHR's progress event
 */ const $cb03b711053a4297$var$getProgressStats = (progressEvent)=>{
    const request = progressEvent.target;
    const roundTripTime = Date.now() - request.requestTime;
    const stats = {
        bandwidth: Infinity,
        bytesReceived: 0,
        roundTripTime: roundTripTime || 0
    };
    stats.bytesReceived = progressEvent.loaded; // This can result in Infinity if stats.roundTripTime is 0 but that is ok
    // because we should only use bandwidth stats on progress to determine when
    // abort a request early due to insufficient bandwidth
    stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8000);
    return stats;
};
/**
 * Handle all error conditions in one place and return an object
 * with all the information
 *
 * @param {Error|null} error - if non-null signals an error occured with the XHR
 * @param {Object} request -  the XHR request that possibly generated the error
 */ const $cb03b711053a4297$var$handleErrors = (error, request)=>{
    if (request.timedout) return {
        status: request.status,
        message: "HLS request timed-out at URL: " + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.TIMEOUT,
        xhr: request
    };
    if (request.aborted) return {
        status: request.status,
        message: "HLS request aborted at URL: " + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.ABORTED,
        xhr: request
    };
    if (error) return {
        status: request.status,
        message: "HLS request errored at URL: " + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE,
        xhr: request
    };
    if (request.responseType === "arraybuffer" && request.response.byteLength === 0) return {
        status: request.status,
        message: "Empty HLS response at URL: " + request.uri,
        code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE,
        xhr: request
    };
    return null;
};
/**
 * Handle responses for key data and convert the key data to the correct format
 * for the decryption step later
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Array} objects - objects to add the key bytes to.
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $cb03b711053a4297$var$handleKeyResponse = (segment, objects, finishProcessingFn)=>(error, request)=>{
        const response = request.response;
        const errorObj = $cb03b711053a4297$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        if (response.byteLength !== 16) return finishProcessingFn({
            status: request.status,
            message: "Invalid HLS key at URL: " + request.uri,
            code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE,
            xhr: request
        }, segment);
        const view = new DataView(response);
        const bytes = new Uint32Array([
            view.getUint32(0),
            view.getUint32(4),
            view.getUint32(8),
            view.getUint32(12)
        ]);
        for(let i = 0; i < objects.length; i++)objects[i].bytes = bytes;
        return finishProcessingFn(null, segment);
    };
const $cb03b711053a4297$var$parseInitSegment = (segment, callback)=>{
    const type = (0, $87512779f8f2edc4$export$894319e75ed840c3)(segment.map.bytes); // TODO: We should also handle ts init segments here, but we
    // only know how to parse mp4 init segments at the moment
    if (type !== "mp4") {
        const uri = segment.map.resolvedUri || segment.map.uri;
        return callback({
            internal: true,
            message: `Found unsupported ${type || "unknown"} container for initialization segment at URL: ${uri}`,
            code: $cb03b711053a4297$var$REQUEST_ERRORS.FAILURE
        });
    }
    $cb03b711053a4297$var$workerCallback({
        action: "probeMp4Tracks",
        data: segment.map.bytes,
        transmuxer: segment.transmuxer,
        callback: ({ tracks: tracks, data: data })=>{
            // transfer bytes back to us
            segment.map.bytes = data;
            tracks.forEach(function(track) {
                segment.map.tracks = segment.map.tracks || {}; // only support one track of each type for now
                if (segment.map.tracks[track.type]) return;
                segment.map.tracks[track.type] = track;
                if (typeof track.id === "number" && track.timescale) {
                    segment.map.timescales = segment.map.timescales || {};
                    segment.map.timescales[track.id] = track.timescale;
                }
            });
            return callback(null);
        }
    });
};
/**
 * Handle init-segment responses
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $cb03b711053a4297$var$handleInitSegmentResponse = ({ segment: segment, finishProcessingFn: finishProcessingFn })=>(error, request)=>{
        const errorObj = $cb03b711053a4297$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        const bytes = new Uint8Array(request.response); // init segment is encypted, we will have to wait
        // until the key request is done to decrypt.
        if (segment.map.key) {
            segment.map.encryptedBytes = bytes;
            return finishProcessingFn(null, segment);
        }
        segment.map.bytes = bytes;
        $cb03b711053a4297$var$parseInitSegment(segment, function(parseError) {
            if (parseError) {
                parseError.xhr = request;
                parseError.status = request.status;
                return finishProcessingFn(parseError, segment);
            }
            finishProcessingFn(null, segment);
        });
    };
/**
 * Response handler for segment-requests being sure to set the correct
 * property depending on whether the segment is encryped or not
 * Also records and keeps track of stats that are used for ABR purposes
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */ const $cb03b711053a4297$var$handleSegmentResponse = ({ segment: segment, finishProcessingFn: finishProcessingFn, responseType: responseType })=>(error, request)=>{
        const errorObj = $cb03b711053a4297$var$handleErrors(error, request);
        if (errorObj) return finishProcessingFn(errorObj, segment);
        const newBytes = // although responseText "should" exist, this guard serves to prevent an error being
        // thrown for two primary cases:
        // 1. the mime type override stops working, or is not implemented for a specific
        //    browser
        // 2. when using mock XHR libraries like sinon that do not allow the override behavior
        responseType === "arraybuffer" || !request.responseText ? request.response : $cb03b711053a4297$var$stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar || 0));
        segment.stats = $cb03b711053a4297$var$getRequestStats(request);
        if (segment.key) segment.encryptedBytes = new Uint8Array(newBytes);
        else segment.bytes = new Uint8Array(newBytes);
        return finishProcessingFn(null, segment);
    };
const $cb03b711053a4297$var$transmuxAndNotify = ({ segment: segment, bytes: bytes, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog })=>{
    const fmp4Tracks = segment.map && segment.map.tracks || {};
    const isMuxed = Boolean(fmp4Tracks.audio && fmp4Tracks.video); // Keep references to each function so we can null them out after we're done with them.
    // One reason for this is that in the case of full segments, we want to trust start
    // times from the probe, rather than the transmuxer.
    let audioStartFn = timingInfoFn.bind(null, segment, "audio", "start");
    const audioEndFn = timingInfoFn.bind(null, segment, "audio", "end");
    let videoStartFn = timingInfoFn.bind(null, segment, "video", "start");
    const videoEndFn = timingInfoFn.bind(null, segment, "video", "end");
    const finish = ()=>$cb03b711053a4297$var$transmux({
            bytes: bytes,
            transmuxer: segment.transmuxer,
            audioAppendStart: segment.audioAppendStart,
            gopsToAlignWith: segment.gopsToAlignWith,
            remux: isMuxed,
            onData: (result)=>{
                result.type = result.type === "combined" ? "video" : result.type;
                dataFn(segment, result);
            },
            onTrackInfo: (trackInfo)=>{
                if (trackInfoFn) {
                    if (isMuxed) trackInfo.isMuxed = true;
                    trackInfoFn(segment, trackInfo);
                }
            },
            onAudioTimingInfo: (audioTimingInfo)=>{
                // we only want the first start value we encounter
                if (audioStartFn && typeof audioTimingInfo.start !== "undefined") {
                    audioStartFn(audioTimingInfo.start);
                    audioStartFn = null;
                } // we want to continually update the end time
                if (audioEndFn && typeof audioTimingInfo.end !== "undefined") audioEndFn(audioTimingInfo.end);
            },
            onVideoTimingInfo: (videoTimingInfo)=>{
                // we only want the first start value we encounter
                if (videoStartFn && typeof videoTimingInfo.start !== "undefined") {
                    videoStartFn(videoTimingInfo.start);
                    videoStartFn = null;
                } // we want to continually update the end time
                if (videoEndFn && typeof videoTimingInfo.end !== "undefined") videoEndFn(videoTimingInfo.end);
            },
            onVideoSegmentTimingInfo: (videoSegmentTimingInfo)=>{
                videoSegmentTimingInfoFn(videoSegmentTimingInfo);
            },
            onAudioSegmentTimingInfo: (audioSegmentTimingInfo)=>{
                audioSegmentTimingInfoFn(audioSegmentTimingInfo);
            },
            onId3: (id3Frames, dispatchType)=>{
                id3Fn(segment, id3Frames, dispatchType);
            },
            onCaptions: (captions)=>{
                captionsFn(segment, [
                    captions
                ]);
            },
            isEndOfTimeline: isEndOfTimeline,
            onEndedTimeline: ()=>{
                endedTimelineFn();
            },
            onTransmuxerLog: onTransmuxerLog,
            onDone: (result)=>{
                if (!doneFn) return;
                result.type = result.type === "combined" ? "video" : result.type;
                doneFn(null, segment, result);
            }
        }); // In the transmuxer, we don't yet have the ability to extract a "proper" start time.
    // Meaning cached frame data may corrupt our notion of where this segment
    // really starts. To get around this, probe for the info needed.
    $cb03b711053a4297$var$workerCallback({
        action: "probeTs",
        transmuxer: segment.transmuxer,
        data: bytes,
        baseStartTime: segment.baseStartTime,
        callback: (data)=>{
            segment.bytes = bytes = data.data;
            const probeResult = data.result;
            if (probeResult) {
                trackInfoFn(segment, {
                    hasAudio: probeResult.hasAudio,
                    hasVideo: probeResult.hasVideo,
                    isMuxed: isMuxed
                });
                trackInfoFn = null;
            }
            finish();
        }
    });
};
const $cb03b711053a4297$var$handleSegmentBytes = ({ segment: segment, bytes: bytes, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog })=>{
    let bytesAsUint8Array = new Uint8Array(bytes); // TODO:
    // We should have a handler that fetches the number of bytes required
    // to check if something is fmp4. This will allow us to save bandwidth
    // because we can only exclude a playlist and abort requests
    // by codec after trackinfo triggers.
    if ((0, $87512779f8f2edc4$export$7d0b693bd7ec7827)(bytesAsUint8Array)) {
        segment.isFmp4 = true;
        const { tracks: tracks } = segment.map;
        const trackInfo = {
            isFmp4: true,
            hasVideo: !!tracks.video,
            hasAudio: !!tracks.audio
        }; // if we have a audio track, with a codec that is not set to
        // encrypted audio
        if (tracks.audio && tracks.audio.codec && tracks.audio.codec !== "enca") trackInfo.audioCodec = tracks.audio.codec;
         // if we have a video track, with a codec that is not set to
        // encrypted video
        if (tracks.video && tracks.video.codec && tracks.video.codec !== "encv") trackInfo.videoCodec = tracks.video.codec;
        if (tracks.video && tracks.audio) trackInfo.isMuxed = true;
         // since we don't support appending fmp4 data on progress, we know we have the full
        // segment here
        trackInfoFn(segment, trackInfo); // The probe doesn't provide the segment end time, so only callback with the start
        // time. The end time can be roughly calculated by the receiver using the duration.
        //
        // Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
        // that is the true start of the segment (where the playback engine should begin
        // decoding).
        const finishLoading = (captions, id3Frames)=>{
            // if the track still has audio at this point it is only possible
            // for it to be audio only. See `tracks.video && tracks.audio` if statement
            // above.
            // we make sure to use segment.bytes here as that
            dataFn(segment, {
                data: bytesAsUint8Array,
                type: trackInfo.hasAudio && !trackInfo.isMuxed ? "audio" : "video"
            });
            if (id3Frames && id3Frames.length) id3Fn(segment, id3Frames);
            if (captions && captions.length) captionsFn(segment, captions);
            doneFn(null, segment, {});
        };
        $cb03b711053a4297$var$workerCallback({
            action: "probeMp4StartTime",
            timescales: segment.map.timescales,
            data: bytesAsUint8Array,
            transmuxer: segment.transmuxer,
            callback: ({ data: data, startTime: startTime })=>{
                // transfer bytes back to us
                bytes = data.buffer;
                segment.bytes = bytesAsUint8Array = data;
                if (trackInfo.hasAudio && !trackInfo.isMuxed) timingInfoFn(segment, "audio", "start", startTime);
                if (trackInfo.hasVideo) timingInfoFn(segment, "video", "start", startTime);
                $cb03b711053a4297$var$workerCallback({
                    action: "probeEmsgID3",
                    data: bytesAsUint8Array,
                    transmuxer: segment.transmuxer,
                    offset: startTime,
                    callback: ({ emsgData: emsgData, id3Frames: id3Frames })=>{
                        // transfer bytes back to us
                        bytes = emsgData.buffer;
                        segment.bytes = bytesAsUint8Array = emsgData; // Run through the CaptionParser in case there are captions.
                        // Initialize CaptionParser if it hasn't been yet
                        if (!tracks.video || !emsgData.byteLength || !segment.transmuxer) {
                            finishLoading(undefined, id3Frames);
                            return;
                        }
                        $cb03b711053a4297$var$workerCallback({
                            action: "pushMp4Captions",
                            endAction: "mp4Captions",
                            transmuxer: segment.transmuxer,
                            data: bytesAsUint8Array,
                            timescales: segment.map.timescales,
                            trackIds: [
                                tracks.video.id
                            ],
                            callback: (message)=>{
                                // transfer bytes back to us
                                bytes = message.data.buffer;
                                segment.bytes = bytesAsUint8Array = message.data;
                                message.logs.forEach(function(log) {
                                    onTransmuxerLog($cb03b711053a4297$var$merge(log, {
                                        stream: "mp4CaptionParser"
                                    }));
                                });
                                finishLoading(message.captions, id3Frames);
                            }
                        });
                    }
                });
            }
        });
        return;
    } // VTT or other segments that don't need processing
    if (!segment.transmuxer) {
        doneFn(null, segment, {});
        return;
    }
    if (typeof segment.container === "undefined") segment.container = (0, $87512779f8f2edc4$export$894319e75ed840c3)(bytesAsUint8Array);
    if (segment.container !== "ts" && segment.container !== "aac") {
        trackInfoFn(segment, {
            hasAudio: false,
            hasVideo: false
        });
        doneFn(null, segment, {});
        return;
    } // ts or aac
    $cb03b711053a4297$var$transmuxAndNotify({
        segment: segment,
        bytes: bytes,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn,
        doneFn: doneFn,
        onTransmuxerLog: onTransmuxerLog
    });
};
const $cb03b711053a4297$var$decrypt = function({ id: id, key: key, encryptedBytes: encryptedBytes, decryptionWorker: decryptionWorker }, callback) {
    const decryptionHandler = (event)=>{
        if (event.data.source === id) {
            decryptionWorker.removeEventListener("message", decryptionHandler);
            const decrypted = event.data.decrypted;
            callback(new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength));
        }
    };
    decryptionWorker.addEventListener("message", decryptionHandler);
    let keyBytes;
    if (key.bytes.slice) keyBytes = key.bytes.slice();
    else keyBytes = new Uint32Array(Array.prototype.slice.call(key.bytes));
     // incrementally decrypt the bytes
    decryptionWorker.postMessage($cb03b711053a4297$var$createTransferableMessage({
        source: id,
        encrypted: encryptedBytes,
        key: keyBytes,
        iv: key.iv
    }), [
        encryptedBytes.buffer,
        keyBytes.buffer
    ]);
};
/**
 * Decrypt the segment via the decryption web worker
 *
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after decryption has completed
 */ const $cb03b711053a4297$var$decryptSegment = ({ decryptionWorker: decryptionWorker, segment: segment, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog })=>{
    $cb03b711053a4297$var$decrypt({
        id: segment.requestId,
        key: segment.key,
        encryptedBytes: segment.encryptedBytes,
        decryptionWorker: decryptionWorker
    }, (decryptedBytes)=>{
        segment.bytes = decryptedBytes;
        $cb03b711053a4297$var$handleSegmentBytes({
            segment: segment,
            bytes: segment.bytes,
            trackInfoFn: trackInfoFn,
            timingInfoFn: timingInfoFn,
            videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
            audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
            id3Fn: id3Fn,
            captionsFn: captionsFn,
            isEndOfTimeline: isEndOfTimeline,
            endedTimelineFn: endedTimelineFn,
            dataFn: dataFn,
            doneFn: doneFn,
            onTransmuxerLog: onTransmuxerLog
        });
    });
};
/**
 * This function waits for all XHRs to finish (with either success or failure)
 * before continueing processing via it's callback. The function gathers errors
 * from each request into a single errors array so that the error status for
 * each request can be examined later.
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after all resources have been
 *                            downloaded and any decryption completed
 */ const $cb03b711053a4297$var$waitForCompletion = ({ activeXhrs: activeXhrs, decryptionWorker: decryptionWorker, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog })=>{
    let count = 0;
    let didError = false;
    return (error, segment)=>{
        if (didError) return;
        if (error) {
            didError = true; // If there are errors, we have to abort any outstanding requests
            $cb03b711053a4297$var$abortAll(activeXhrs); // Even though the requests above are aborted, and in theory we could wait until we
            // handle the aborted events from those requests, there are some cases where we may
            // never get an aborted event. For instance, if the network connection is lost and
            // there were two requests, the first may have triggered an error immediately, while
            // the second request remains unsent. In that case, the aborted algorithm will not
            // trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
            //
            // We also can't rely on the ready state of the XHR, since the request that
            // triggered the connection error may also show as a ready state of 0 (unsent).
            // Therefore, we have to finish this group of requests immediately after the first
            // seen error.
            return doneFn(error, segment);
        }
        count += 1;
        if (count === activeXhrs.length) {
            const segmentFinish = function() {
                if (segment.encryptedBytes) return $cb03b711053a4297$var$decryptSegment({
                    decryptionWorker: decryptionWorker,
                    segment: segment,
                    trackInfoFn: trackInfoFn,
                    timingInfoFn: timingInfoFn,
                    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
                    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
                    id3Fn: id3Fn,
                    captionsFn: captionsFn,
                    isEndOfTimeline: isEndOfTimeline,
                    endedTimelineFn: endedTimelineFn,
                    dataFn: dataFn,
                    doneFn: doneFn,
                    onTransmuxerLog: onTransmuxerLog
                });
                 // Otherwise, everything is ready just continue
                $cb03b711053a4297$var$handleSegmentBytes({
                    segment: segment,
                    bytes: segment.bytes,
                    trackInfoFn: trackInfoFn,
                    timingInfoFn: timingInfoFn,
                    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
                    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
                    id3Fn: id3Fn,
                    captionsFn: captionsFn,
                    isEndOfTimeline: isEndOfTimeline,
                    endedTimelineFn: endedTimelineFn,
                    dataFn: dataFn,
                    doneFn: doneFn,
                    onTransmuxerLog: onTransmuxerLog
                });
            }; // Keep track of when *all* of the requests have completed
            segment.endOfAllRequests = Date.now();
            if (segment.map && segment.map.encryptedBytes && !segment.map.bytes) return $cb03b711053a4297$var$decrypt({
                decryptionWorker: decryptionWorker,
                // add -init to the "id" to differentiate between segment
                // and init segment decryption, just in case they happen
                // at the same time at some point in the future.
                id: segment.requestId + "-init",
                encryptedBytes: segment.map.encryptedBytes,
                key: segment.map.key
            }, (decryptedBytes)=>{
                segment.map.bytes = decryptedBytes;
                $cb03b711053a4297$var$parseInitSegment(segment, (parseError)=>{
                    if (parseError) {
                        $cb03b711053a4297$var$abortAll(activeXhrs);
                        return doneFn(parseError, segment);
                    }
                    segmentFinish();
                });
            });
            segmentFinish();
        }
    };
};
/**
 * Calls the abort callback if any request within the batch was aborted. Will only call
 * the callback once per batch of requests, even if multiple were aborted.
 *
 * @param {Object} loadendState - state to check to see if the abort function was called
 * @param {Function} abortFn - callback to call for abort
 */ const $cb03b711053a4297$var$handleLoadEnd = ({ loadendState: loadendState, abortFn: abortFn })=>(event)=>{
        const request = event.target;
        if (request.aborted && abortFn && !loadendState.calledAbortFn) {
            abortFn();
            loadendState.calledAbortFn = true;
        }
    };
/**
 * Simple progress event callback handler that gathers some stats before
 * executing a provided callback with the `segment` object
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} progressFn - a callback that is executed each time a progress event
 *                                is received
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Event} event - the progress event object from XMLHttpRequest
 */ const $cb03b711053a4297$var$handleProgress = ({ segment: segment, progressFn: progressFn, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn })=>(event)=>{
        const request = event.target;
        if (request.aborted) return;
        segment.stats = $cb03b711053a4297$var$merge(segment.stats, $cb03b711053a4297$var$getProgressStats(event)); // record the time that we receive the first byte of data
        if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) segment.stats.firstBytesReceivedAt = Date.now();
        return progressFn(event, segment);
    };
/**
 * Load all resources and does any processing necessary for a media-segment
 *
 * Features:
 *   decrypts the media-segment if it has a key uri and an iv
 *   aborts *all* requests if *any* one request fails
 *
 * The segment object, at minimum, has the following format:
 * {
 *   resolvedUri: String,
 *   [transmuxer]: Object,
 *   [byterange]: {
 *     offset: Number,
 *     length: Number
 *   },
 *   [key]: {
 *     resolvedUri: String
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     iv: {
 *       bytes: Uint32Array
 *     }
 *   },
 *   [map]: {
 *     resolvedUri: String,
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     [bytes]: Uint8Array
 *   }
 * }
 * ...where [name] denotes optional properties
 *
 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
 * @param {Object} xhrOptions - the base options to provide to all xhr requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
 *                                       decryption routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
 *                             aborted
 * @param {Function} progressFn - a callback that receives progress events from the main
 *                                segment's xhr request
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
 *                            request, transmuxed if needed
 * @param {Function} doneFn - a callback that is executed only once all requests have
 *                            succeeded or failed
 * @return {Function} a function that, when invoked, immediately aborts all
 *                     outstanding requests
 */ const $cb03b711053a4297$var$mediaSegmentRequest = ({ xhr: xhr, xhrOptions: xhrOptions, decryptionWorker: decryptionWorker, segment: segment, abortFn: abortFn, progressFn: progressFn, trackInfoFn: trackInfoFn, timingInfoFn: timingInfoFn, videoSegmentTimingInfoFn: videoSegmentTimingInfoFn, audioSegmentTimingInfoFn: audioSegmentTimingInfoFn, id3Fn: id3Fn, captionsFn: captionsFn, isEndOfTimeline: isEndOfTimeline, endedTimelineFn: endedTimelineFn, dataFn: dataFn, doneFn: doneFn, onTransmuxerLog: onTransmuxerLog })=>{
    const activeXhrs = [];
    const finishProcessingFn = $cb03b711053a4297$var$waitForCompletion({
        activeXhrs: activeXhrs,
        decryptionWorker: decryptionWorker,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn,
        doneFn: doneFn,
        onTransmuxerLog: onTransmuxerLog
    }); // optionally, request the decryption key
    if (segment.key && !segment.key.bytes) {
        const objects = [
            segment.key
        ];
        if (segment.map && !segment.map.bytes && segment.map.key && segment.map.key.resolvedUri === segment.key.resolvedUri) objects.push(segment.map.key);
        const keyRequestOptions = $cb03b711053a4297$var$merge(xhrOptions, {
            uri: segment.key.resolvedUri,
            responseType: "arraybuffer"
        });
        const keyRequestCallback = $cb03b711053a4297$var$handleKeyResponse(segment, objects, finishProcessingFn);
        const keyXhr = xhr(keyRequestOptions, keyRequestCallback);
        activeXhrs.push(keyXhr);
    } // optionally, request the associated media init segment
    if (segment.map && !segment.map.bytes) {
        const differentMapKey = segment.map.key && (!segment.key || segment.key.resolvedUri !== segment.map.key.resolvedUri);
        if (differentMapKey) {
            const mapKeyRequestOptions = $cb03b711053a4297$var$merge(xhrOptions, {
                uri: segment.map.key.resolvedUri,
                responseType: "arraybuffer"
            });
            const mapKeyRequestCallback = $cb03b711053a4297$var$handleKeyResponse(segment, [
                segment.map.key
            ], finishProcessingFn);
            const mapKeyXhr = xhr(mapKeyRequestOptions, mapKeyRequestCallback);
            activeXhrs.push(mapKeyXhr);
        }
        const initSegmentOptions = $cb03b711053a4297$var$merge(xhrOptions, {
            uri: segment.map.resolvedUri,
            responseType: "arraybuffer",
            headers: $cb03b711053a4297$var$segmentXhrHeaders(segment.map)
        });
        const initSegmentRequestCallback = $cb03b711053a4297$var$handleInitSegmentResponse({
            segment: segment,
            finishProcessingFn: finishProcessingFn
        });
        const initSegmentXhr = xhr(initSegmentOptions, initSegmentRequestCallback);
        activeXhrs.push(initSegmentXhr);
    }
    const segmentRequestOptions = $cb03b711053a4297$var$merge(xhrOptions, {
        uri: segment.part && segment.part.resolvedUri || segment.resolvedUri,
        responseType: "arraybuffer",
        headers: $cb03b711053a4297$var$segmentXhrHeaders(segment)
    });
    const segmentRequestCallback = $cb03b711053a4297$var$handleSegmentResponse({
        segment: segment,
        finishProcessingFn: finishProcessingFn,
        responseType: segmentRequestOptions.responseType
    });
    const segmentXhr = xhr(segmentRequestOptions, segmentRequestCallback);
    segmentXhr.addEventListener("progress", $cb03b711053a4297$var$handleProgress({
        segment: segment,
        progressFn: progressFn,
        trackInfoFn: trackInfoFn,
        timingInfoFn: timingInfoFn,
        videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
        audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
        id3Fn: id3Fn,
        captionsFn: captionsFn,
        isEndOfTimeline: isEndOfTimeline,
        endedTimelineFn: endedTimelineFn,
        dataFn: dataFn
    }));
    activeXhrs.push(segmentXhr); // since all parts of the request must be considered, but should not make callbacks
    // multiple times, provide a shared state object
    const loadendState = {};
    activeXhrs.forEach((activeXhr)=>{
        activeXhr.addEventListener("loadend", $cb03b711053a4297$var$handleLoadEnd({
            loadendState: loadendState,
            abortFn: abortFn
        }));
    });
    return ()=>$cb03b711053a4297$var$abortAll(activeXhrs);
};
/**
 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
 * codec strings, or translating codec strings into objects that can be examined.
 */ const $cb03b711053a4297$var$logFn$1 = $cb03b711053a4297$var$logger("CodecUtils");
/**
 * Returns a set of codec strings parsed from the playlist or the default
 * codec strings if no codecs were specified in the playlist
 *
 * @param {Playlist} media the current media playlist
 * @return {Object} an object with the video and audio codecs
 */ const $cb03b711053a4297$var$getCodecs = function(media) {
    // if the codecs were explicitly specified, use them instead of the
    // defaults
    const mediaAttributes = media.attributes || {};
    if (mediaAttributes.CODECS) return (0, $e324d09415701181$export$56679b562aa2891c)(mediaAttributes.CODECS);
};
const $cb03b711053a4297$var$isMaat = (main, media)=>{
    const mediaAttributes = media.attributes || {};
    return main && main.mediaGroups && main.mediaGroups.AUDIO && mediaAttributes.AUDIO && main.mediaGroups.AUDIO[mediaAttributes.AUDIO];
};
const $cb03b711053a4297$var$isMuxed = (main, media)=>{
    if (!$cb03b711053a4297$var$isMaat(main, media)) return true;
    const mediaAttributes = media.attributes || {};
    const audioGroup = main.mediaGroups.AUDIO[mediaAttributes.AUDIO];
    for(const groupId in audioGroup){
        // If an audio group has a URI (the case for HLS, as HLS will use external playlists),
        // or there are listed playlists (the case for DASH, as the manifest will have already
        // provided all of the details necessary to generate the audio playlist, as opposed to
        // HLS' externally requested playlists), then the content is demuxed.
        if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) return true;
    }
    return false;
};
const $cb03b711053a4297$var$unwrapCodecList = function(codecList) {
    const codecs = {};
    codecList.forEach(({ mediaType: mediaType, type: type, details: details })=>{
        codecs[mediaType] = codecs[mediaType] || [];
        codecs[mediaType].push((0, $e324d09415701181$export$4e61c3c458a5b005)(`${type}${details}`));
    });
    Object.keys(codecs).forEach(function(mediaType) {
        if (codecs[mediaType].length > 1) {
            $cb03b711053a4297$var$logFn$1(`multiple ${mediaType} codecs found as attributes: ${codecs[mediaType].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`);
            codecs[mediaType] = null;
            return;
        }
        codecs[mediaType] = codecs[mediaType][0];
    });
    return codecs;
};
const $cb03b711053a4297$var$codecCount = function(codecObj) {
    let count = 0;
    if (codecObj.audio) count++;
    if (codecObj.video) count++;
    return count;
};
/**
 * Calculates the codec strings for a working configuration of
 * SourceBuffers to play variant streams in a main playlist. If
 * there is no possible working configuration, an empty object will be
 * returned.
 *
 * @param main {Object} the m3u8 object for the main playlist
 * @param media {Object} the m3u8 object for the variant playlist
 * @return {Object} the codec strings.
 *
 * @private
 */ const $cb03b711053a4297$var$codecsForPlaylist = function(main, media) {
    const mediaAttributes = media.attributes || {};
    const codecInfo = $cb03b711053a4297$var$unwrapCodecList($cb03b711053a4297$var$getCodecs(media) || []); // HLS with multiple-audio tracks must always get an audio codec.
    // Put another way, there is no way to have a video-only multiple-audio HLS!
    if ($cb03b711053a4297$var$isMaat(main, media) && !codecInfo.audio) {
        if (!$cb03b711053a4297$var$isMuxed(main, media)) {
            // It is possible for codecs to be specified on the audio media group playlist but
            // not on the rendition playlist. This is mostly the case for DASH, where audio and
            // video are always separate (and separately specified).
            const defaultCodecs = $cb03b711053a4297$var$unwrapCodecList((0, $e324d09415701181$export$e192782a4d0b5c5c)(main, mediaAttributes.AUDIO) || []);
            if (defaultCodecs.audio) codecInfo.audio = defaultCodecs.audio;
        }
    }
    return codecInfo;
};
const $cb03b711053a4297$var$logFn = $cb03b711053a4297$var$logger("PlaylistSelector");
const $cb03b711053a4297$var$representationToString = function(representation) {
    if (!representation || !representation.playlist) return;
    const playlist = representation.playlist;
    return JSON.stringify({
        id: playlist.id,
        bandwidth: representation.bandwidth,
        width: representation.width,
        height: representation.height,
        codecs: playlist.attributes && playlist.attributes.CODECS || ""
    });
}; // Utilities
/**
 * Returns the CSS value for the specified property on an element
 * using `getComputedStyle`. Firefox has a long-standing issue where
 * getComputedStyle() may return null when running in an iframe with
 * `display: none`.
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 * @param {HTMLElement} el the htmlelement to work on
 * @param {string} the proprety to get the style for
 */ const $cb03b711053a4297$var$safeGetComputedStyle = function(el, property) {
    if (!el) return "";
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).getComputedStyle(el);
    if (!result) return "";
    return result[property];
};
/**
 * Resuable stable sort function
 *
 * @param {Playlists} array
 * @param {Function} sortFn Different comparators
 * @function stableSort
 */ const $cb03b711053a4297$var$stableSort = function(array, sortFn) {
    const newArray = array.slice();
    array.sort(function(left, right) {
        const cmp = sortFn(left, right);
        if (cmp === 0) return newArray.indexOf(left) - newArray.indexOf(right);
        return cmp;
    });
};
/**
 * A comparator function to sort two playlist object by bandwidth.
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the bandwidth attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the bandwidth of right is greater than left and
 * exactly zero if the two are equal.
 */ const $cb03b711053a4297$var$comparePlaylistBandwidth = function(left, right) {
    let leftBandwidth;
    let rightBandwidth;
    if (left.attributes.BANDWIDTH) leftBandwidth = left.attributes.BANDWIDTH;
    leftBandwidth = leftBandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
    if (right.attributes.BANDWIDTH) rightBandwidth = right.attributes.BANDWIDTH;
    rightBandwidth = rightBandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
    return leftBandwidth - rightBandwidth;
};
/**
 * A comparator function to sort two playlist object by resolution (width).
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the resolution.width attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the resolution.width of right is greater than left and
 * exactly zero if the two are equal.
 */ const $cb03b711053a4297$var$comparePlaylistResolution = function(left, right) {
    let leftWidth;
    let rightWidth;
    if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) leftWidth = left.attributes.RESOLUTION.width;
    leftWidth = leftWidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
    if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) rightWidth = right.attributes.RESOLUTION.width;
    rightWidth = rightWidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE; // NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
    // have the same media dimensions/ resolution
    if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
    return leftWidth - rightWidth;
};
/**
 * Chooses the appropriate media playlist based on bandwidth and player size
 *
 * @param {Object} main
 *        Object representation of the main manifest
 * @param {number} playerBandwidth
 *        Current calculated bandwidth of the player
 * @param {number} playerWidth
 *        Current width of the player element (should account for the device pixel ratio)
 * @param {number} playerHeight
 *        Current height of the player element (should account for the device pixel ratio)
 * @param {boolean} limitRenditionByPlayerDimensions
 *        True if the player width and height should be used during the selection, false otherwise
 * @param {Object} playlistController
 *        the current playlistController object
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */ let $cb03b711053a4297$var$simpleSelector = function(main, playerBandwidth, playerWidth, playerHeight, limitRenditionByPlayerDimensions, playlistController) {
    // If we end up getting called before `main` is available, exit early
    if (!main) return;
    const options = {
        bandwidth: playerBandwidth,
        width: playerWidth,
        height: playerHeight,
        limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions
    };
    let playlists = main.playlists; // if playlist is audio only, select between currently active audio group playlists.
    if ($cb03b711053a4297$var$Playlist.isAudioOnly(main)) {
        playlists = playlistController.getAudioTrackPlaylists_(); // add audioOnly to options so that we log audioOnly: true
        // at the buttom of this function for debugging.
        options.audioOnly = true;
    } // convert the playlists to an intermediary representation to make comparisons easier
    let sortedPlaylistReps = playlists.map((playlist)=>{
        let bandwidth;
        const width = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
        const height = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
        bandwidth = playlist.attributes && playlist.attributes.BANDWIDTH;
        bandwidth = bandwidth || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).Number.MAX_VALUE;
        return {
            bandwidth: bandwidth,
            width: width,
            height: height,
            playlist: playlist
        };
    });
    $cb03b711053a4297$var$stableSort(sortedPlaylistReps, (left, right)=>left.bandwidth - right.bandwidth); // filter out any playlists that have been excluded due to
    // incompatible configurations
    sortedPlaylistReps = sortedPlaylistReps.filter((rep)=>!$cb03b711053a4297$var$Playlist.isIncompatible(rep.playlist)); // filter out any playlists that have been disabled manually through the representations
    // api or excluded temporarily due to playback errors.
    let enabledPlaylistReps = sortedPlaylistReps.filter((rep)=>$cb03b711053a4297$var$Playlist.isEnabled(rep.playlist));
    if (!enabledPlaylistReps.length) // if there are no enabled playlists, then they have all been excluded or disabled
    // by the user through the representations api. In this case, ignore exclusion and
    // fallback to what the user wants by using playlists the user has not disabled.
    enabledPlaylistReps = sortedPlaylistReps.filter((rep)=>!$cb03b711053a4297$var$Playlist.isDisabled(rep.playlist));
     // filter out any variant that has greater effective bitrate
    // than the current estimated bandwidth
    const bandwidthPlaylistReps = enabledPlaylistReps.filter((rep)=>rep.bandwidth * $cb03b711053a4297$var$Config.BANDWIDTH_VARIANCE < playerBandwidth);
    let highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1]; // get all of the renditions with the same (highest) bandwidth
    // and then taking the very first element
    const bandwidthBestRep = bandwidthPlaylistReps.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0]; // if we're not going to limit renditions by player size, make an early decision.
    if (limitRenditionByPlayerDimensions === false) {
        const chosenRep = bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
        if (chosenRep && chosenRep.playlist) {
            let type = "sortedPlaylistReps";
            if (bandwidthBestRep) type = "bandwidthBestRep";
            if (enabledPlaylistReps[0]) type = "enabledPlaylistReps";
            $cb03b711053a4297$var$logFn(`choosing ${$cb03b711053a4297$var$representationToString(chosenRep)} using ${type} with options`, options);
            return chosenRep.playlist;
        }
        $cb03b711053a4297$var$logFn("could not choose a playlist with options", options);
        return null;
    } // filter out playlists without resolution information
    const haveResolution = bandwidthPlaylistReps.filter((rep)=>rep.width && rep.height); // sort variants by resolution
    $cb03b711053a4297$var$stableSort(haveResolution, (left, right)=>left.width - right.width); // if we have the exact resolution as the player use it
    const resolutionBestRepList = haveResolution.filter((rep)=>rep.width === playerWidth && rep.height === playerHeight);
    highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1]; // ensure that we pick the highest bandwidth variant that have exact resolution
    const resolutionBestRep = resolutionBestRepList.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0];
    let resolutionPlusOneList;
    let resolutionPlusOneSmallest;
    let resolutionPlusOneRep; // find the smallest variant that is larger than the player
    // if there is no match of exact resolution
    if (!resolutionBestRep) {
        resolutionPlusOneList = haveResolution.filter((rep)=>rep.width > playerWidth || rep.height > playerHeight); // find all the variants have the same smallest resolution
        resolutionPlusOneSmallest = resolutionPlusOneList.filter((rep)=>rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height); // ensure that we also pick the highest bandwidth variant that
        // is just-larger-than the video player
        highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
        resolutionPlusOneRep = resolutionPlusOneSmallest.filter((rep)=>rep.bandwidth === highestRemainingBandwidthRep.bandwidth)[0];
    }
    let leastPixelDiffRep; // If this selector proves to be better than others,
    // resolutionPlusOneRep and resolutionBestRep and all
    // the code involving them should be removed.
    if (playlistController.leastPixelDiffSelector) {
        // find the variant that is closest to the player's pixel size
        const leastPixelDiffList = haveResolution.map((rep)=>{
            rep.pixelDiff = Math.abs(rep.width - playerWidth) + Math.abs(rep.height - playerHeight);
            return rep;
        }); // get the highest bandwidth, closest resolution playlist
        $cb03b711053a4297$var$stableSort(leastPixelDiffList, (left, right)=>{
            // sort by highest bandwidth if pixelDiff is the same
            if (left.pixelDiff === right.pixelDiff) return right.bandwidth - left.bandwidth;
            return left.pixelDiff - right.pixelDiff;
        });
        leastPixelDiffRep = leastPixelDiffList[0];
    } // fallback chain of variants
    const chosenRep = leastPixelDiffRep || resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
    if (chosenRep && chosenRep.playlist) {
        let type = "sortedPlaylistReps";
        if (leastPixelDiffRep) type = "leastPixelDiffRep";
        else if (resolutionPlusOneRep) type = "resolutionPlusOneRep";
        else if (resolutionBestRep) type = "resolutionBestRep";
        else if (bandwidthBestRep) type = "bandwidthBestRep";
        else if (enabledPlaylistReps[0]) type = "enabledPlaylistReps";
        $cb03b711053a4297$var$logFn(`choosing ${$cb03b711053a4297$var$representationToString(chosenRep)} using ${type} with options`, options);
        return chosenRep.playlist;
    }
    $cb03b711053a4297$var$logFn("could not choose a playlist with options", options);
    return null;
};
/**
 * Chooses the appropriate media playlist based on the most recent
 * bandwidth estimate and the player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */ const $cb03b711053a4297$var$lastBandwidthSelector = function() {
    const pixelRatio = this.useDevicePixelRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).devicePixelRatio || 1 : 1;
    return $cb03b711053a4297$var$simpleSelector(this.playlists.main, this.systemBandwidth, parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), "width"), 10) * pixelRatio, parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), "height"), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.playlistController_);
};
/**
 * Chooses the appropriate media playlist based on an
 * exponential-weighted moving average of the bandwidth after
 * filtering for player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @param {number} decay - a number between 0 and 1. Higher values of
 * this parameter will cause previous bandwidth estimates to lose
 * significance more quickly.
 * @return {Function} a function which can be invoked to create a new
 * playlist selector function.
 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 */ const $cb03b711053a4297$var$movingAverageBandwidthSelector = function(decay) {
    let average = -1;
    let lastSystemBandwidth = -1;
    if (decay < 0 || decay > 1) throw new Error("Moving average bandwidth decay must be between 0 and 1.");
    return function() {
        const pixelRatio = this.useDevicePixelRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).devicePixelRatio || 1 : 1;
        if (average < 0) {
            average = this.systemBandwidth;
            lastSystemBandwidth = this.systemBandwidth;
        } // stop the average value from decaying for every 250ms
        // when the systemBandwidth is constant
        // and
        // stop average from setting to a very low value when the
        // systemBandwidth becomes 0 in case of chunk cancellation
        if (this.systemBandwidth > 0 && this.systemBandwidth !== lastSystemBandwidth) {
            average = decay * this.systemBandwidth + (1 - decay) * average;
            lastSystemBandwidth = this.systemBandwidth;
        }
        return $cb03b711053a4297$var$simpleSelector(this.playlists.main, average, parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), "width"), 10) * pixelRatio, parseInt($cb03b711053a4297$var$safeGetComputedStyle(this.tech_.el(), "height"), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.playlistController_);
    };
};
/**
 * Chooses the appropriate media playlist based on the potential to rebuffer
 *
 * @param {Object} settings
 *        Object of information required to use this selector
 * @param {Object} settings.main
 *        Object representation of the main manifest
 * @param {number} settings.currentTime
 *        The current time of the player
 * @param {number} settings.bandwidth
 *        Current measured bandwidth
 * @param {number} settings.duration
 *        Duration of the media
 * @param {number} settings.segmentDuration
 *        Segment duration to be used in round trip time calculations
 * @param {number} settings.timeUntilRebuffer
 *        Time left in seconds until the player has to rebuffer
 * @param {number} settings.currentTimeline
 *        The current timeline segments are being loaded from
 * @param {SyncController} settings.syncController
 *        SyncController for determining if we have a sync point for a given playlist
 * @return {Object|null}
 *         {Object} return.playlist
 *         The highest bandwidth playlist with the least amount of rebuffering
 *         {Number} return.rebufferingImpact
 *         The amount of time in seconds switching to this playlist will rebuffer. A
 *         negative value means that switching will cause zero rebuffering.
 */ const $cb03b711053a4297$var$minRebufferMaxBandwidthSelector = function(settings) {
    const { main: main, currentTime: currentTime, bandwidth: bandwidth, duration: duration, segmentDuration: segmentDuration, timeUntilRebuffer: timeUntilRebuffer, currentTimeline: currentTimeline, syncController: syncController } = settings; // filter out any playlists that have been excluded due to
    // incompatible configurations
    const compatiblePlaylists = main.playlists.filter((playlist)=>!$cb03b711053a4297$var$Playlist.isIncompatible(playlist)); // filter out any playlists that have been disabled manually through the representations
    // api or excluded temporarily due to playback errors.
    let enabledPlaylists = compatiblePlaylists.filter($cb03b711053a4297$var$Playlist.isEnabled);
    if (!enabledPlaylists.length) // if there are no enabled playlists, then they have all been excluded or disabled
    // by the user through the representations api. In this case, ignore exclusion and
    // fallback to what the user wants by using playlists the user has not disabled.
    enabledPlaylists = compatiblePlaylists.filter((playlist)=>!$cb03b711053a4297$var$Playlist.isDisabled(playlist));
    const bandwidthPlaylists = enabledPlaylists.filter($cb03b711053a4297$var$Playlist.hasAttribute.bind(null, "BANDWIDTH"));
    const rebufferingEstimates = bandwidthPlaylists.map((playlist)=>{
        const syncPoint = syncController.getSyncPoint(playlist, duration, currentTimeline, currentTime); // If there is no sync point for this playlist, switching to it will require a
        // sync request first. This will double the request time
        const numRequests = syncPoint ? 1 : 2;
        const requestTimeEstimate = $cb03b711053a4297$var$Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth, playlist);
        const rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer;
        return {
            playlist: playlist,
            rebufferingImpact: rebufferingImpact
        };
    });
    const noRebufferingPlaylists = rebufferingEstimates.filter((estimate)=>estimate.rebufferingImpact <= 0); // Sort by bandwidth DESC
    $cb03b711053a4297$var$stableSort(noRebufferingPlaylists, (a, b)=>$cb03b711053a4297$var$comparePlaylistBandwidth(b.playlist, a.playlist));
    if (noRebufferingPlaylists.length) return noRebufferingPlaylists[0];
    $cb03b711053a4297$var$stableSort(rebufferingEstimates, (a, b)=>a.rebufferingImpact - b.rebufferingImpact);
    return rebufferingEstimates[0] || null;
};
/**
 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
 * one with video.  If no renditions with video exist, return the lowest audio rendition.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Object|null}
 *         {Object} return.playlist
 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
 *         exists pick the lowest audio rendition.
 */ const $cb03b711053a4297$var$lowestBitrateCompatibleVariantSelector = function() {
    // filter out any playlists that have been excluded due to
    // incompatible configurations or playback errors
    const playlists = this.playlists.main.playlists.filter($cb03b711053a4297$var$Playlist.isEnabled); // Sort ascending by bitrate
    $cb03b711053a4297$var$stableSort(playlists, (a, b)=>$cb03b711053a4297$var$comparePlaylistBandwidth(a, b)); // Parse and assume that playlists with no video codec have no video
    // (this is not necessarily true, although it is generally true).
    //
    // If an entire manifest has no valid videos everything will get filtered
    // out.
    const playlistsWithVideo = playlists.filter((playlist)=>!!$cb03b711053a4297$var$codecsForPlaylist(this.playlists.main, playlist).video);
    return playlistsWithVideo[0] || null;
};
/**
 * Combine all segments into a single Uint8Array
 *
 * @param {Object} segmentObj
 * @return {Uint8Array} concatenated bytes
 * @private
 */ const $cb03b711053a4297$var$concatSegments = (segmentObj)=>{
    let offset = 0;
    let tempBuffer;
    if (segmentObj.bytes) {
        tempBuffer = new Uint8Array(segmentObj.bytes); // combine the individual segments into one large typed-array
        segmentObj.segments.forEach((segment)=>{
            tempBuffer.set(segment, offset);
            offset += segment.byteLength;
        });
    }
    return tempBuffer;
};
/**
 * @file text-tracks.js
 */ /**
 * Create captions text tracks on video.js if they do not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {Object} tech the video.js tech
 * @param {Object} captionStream the caption stream to create
 * @private
 */ const $cb03b711053a4297$var$createCaptionsTrackIfNotExists = function(inbandTextTracks, tech, captionStream) {
    if (!inbandTextTracks[captionStream]) {
        tech.trigger({
            type: "usage",
            name: "vhs-608"
        });
        let instreamId = captionStream; // we need to translate SERVICEn for 708 to how mux.js currently labels them
        if (/^cc708_/.test(captionStream)) instreamId = "SERVICE" + captionStream.split("_")[1];
        const track = tech.textTracks().getTrackById(instreamId);
        if (track) // Resuse an existing track with a CC# id because this was
        // very likely created by videojs-contrib-hls from information
        // in the m3u8 for us to use
        inbandTextTracks[captionStream] = track;
        else {
            // This section gets called when we have caption services that aren't specified in the manifest.
            // Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
            const captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
            let label = captionStream;
            let language = captionStream;
            let def = false;
            const captionService = captionServices[instreamId];
            if (captionService) {
                label = captionService.label;
                language = captionService.language;
                def = captionService.default;
            } // Otherwise, create a track with the default `CC#` label and
            // without a language
            inbandTextTracks[captionStream] = tech.addRemoteTextTrack({
                kind: "captions",
                id: instreamId,
                // TODO: investigate why this doesn't seem to turn the caption on by default
                default: def,
                label: label,
                language: language
            }, false).track;
        }
    }
};
/**
 * Add caption text track data to a source handler given an array of captions
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {Array} captionArray an array of caption data
 * @private
 */ const $cb03b711053a4297$var$addCaptionData = function({ inbandTextTracks: inbandTextTracks, captionArray: captionArray, timestampOffset: timestampOffset }) {
    if (!captionArray) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
    captionArray.forEach((caption)=>{
        const track = caption.stream; // in CEA 608 captions, video.js/mux.js sends a content array
        // with positioning data
        if (caption.content) caption.content.forEach((value)=>{
            const cue = new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, value.text);
            cue.line = value.line;
            cue.align = "left";
            cue.position = value.position;
            cue.positionAlign = "line-left";
            inbandTextTracks[track].addCue(cue);
        });
        else // otherwise, a text value with combined captions is sent
        inbandTextTracks[track].addCue(new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, caption.text));
    });
};
/**
 * Define properties on a cue for backwards compatability,
 * but warn the user that the way that they are using it
 * is depricated and will be removed at a later date.
 *
 * @param {Cue} cue the cue to add the properties on
 * @private
 */ const $cb03b711053a4297$var$deprecateOldCue = function(cue) {
    Object.defineProperties(cue.frame, {
        id: {
            get () {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("cue.frame.id is deprecated. Use cue.value.key instead.");
                return cue.value.key;
            }
        },
        value: {
            get () {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("cue.frame.value is deprecated. Use cue.value.data instead.");
                return cue.value.data;
            }
        },
        privateData: {
            get () {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead.");
                return cue.value.data;
            }
        }
    });
};
/**
 * Add metadata text track data to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} metadataArray an array of meta data
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {number} videoDuration the duration of the video
 * @private
 */ const $cb03b711053a4297$var$addMetadata = ({ inbandTextTracks: inbandTextTracks, metadataArray: metadataArray, timestampOffset: timestampOffset, videoDuration: videoDuration })=>{
    if (!metadataArray) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
    const metadataTrack = inbandTextTracks.metadataTrack_;
    if (!metadataTrack) return;
    metadataArray.forEach((metadata)=>{
        const time = metadata.cueTime + timestampOffset; // if time isn't a finite number between 0 and Infinity, like NaN,
        // ignore this bit of metadata.
        // This likely occurs when you have an non-timed ID3 tag like TIT2,
        // which is the "Title/Songname/Content description" frame
        if (typeof time !== "number" || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).isNaN(time) || time < 0 || !(time < Infinity)) return;
         // If we have no frames, we can't create a cue.
        if (!metadata.frames || !metadata.frames.length) return;
        metadata.frames.forEach((frame)=>{
            const cue = new Cue(time, time, frame.value || frame.url || frame.data || "");
            cue.frame = frame;
            cue.value = frame;
            $cb03b711053a4297$var$deprecateOldCue(cue);
            metadataTrack.addCue(cue);
        });
    });
    if (!metadataTrack.cues || !metadataTrack.cues.length) return;
     // Updating the metadeta cues so that
    // the endTime of each cue is the startTime of the next cue
    // the endTime of last cue is the duration of the video
    const cues = metadataTrack.cues;
    const cuesArray = []; // Create a copy of the TextTrackCueList...
    // ...disregarding cues with a falsey value
    for(let i = 0; i < cues.length; i++)if (cues[i]) cuesArray.push(cues[i]);
     // Group cues by their startTime value
    const cuesGroupedByStartTime = cuesArray.reduce((obj, cue)=>{
        const timeSlot = obj[cue.startTime] || [];
        timeSlot.push(cue);
        obj[cue.startTime] = timeSlot;
        return obj;
    }, {}); // Sort startTimes by ascending order
    const sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort((a, b)=>Number(a) - Number(b)); // Map each cue group's endTime to the next group's startTime
    sortedStartTimes.forEach((startTime, idx)=>{
        const cueGroup = cuesGroupedByStartTime[startTime];
        const finiteDuration = isFinite(videoDuration) ? videoDuration : 0;
        const nextTime = Number(sortedStartTimes[idx + 1]) || finiteDuration; // Map each cue's endTime the next group's startTime
        cueGroup.forEach((cue)=>{
            cue.endTime = nextTime;
        });
    });
}; // object for mapping daterange attributes
const $cb03b711053a4297$var$dateRangeAttr = {
    id: "ID",
    class: "CLASS",
    startDate: "START-DATE",
    duration: "DURATION",
    endDate: "END-DATE",
    endOnNext: "END-ON-NEXT",
    plannedDuration: "PLANNED-DURATION",
    scte35Out: "SCTE35-OUT",
    scte35In: "SCTE35-IN"
};
const $cb03b711053a4297$var$dateRangeKeysToOmit = new Set([
    "id",
    "class",
    "startDate",
    "duration",
    "endDate",
    "endOnNext",
    "startTime",
    "endTime",
    "processDateRange"
]);
/**
 * Add DateRange metadata text track to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} dateRanges parsed media playlist
 * @private
 */ const $cb03b711053a4297$var$addDateRangeMetadata = ({ inbandTextTracks: inbandTextTracks, dateRanges: dateRanges })=>{
    const metadataTrack = inbandTextTracks.metadataTrack_;
    if (!metadataTrack) return;
    const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
    dateRanges.forEach((dateRange)=>{
        // we generate multiple cues for each date range with different attributes
        for (const key of Object.keys(dateRange)){
            if ($cb03b711053a4297$var$dateRangeKeysToOmit.has(key)) continue;
            const cue = new Cue(dateRange.startTime, dateRange.endTime, "");
            cue.id = dateRange.id;
            cue.type = "com.apple.quicktime.HLS";
            cue.value = {
                key: $cb03b711053a4297$var$dateRangeAttr[key],
                data: dateRange[key]
            };
            if (key === "scte35Out" || key === "scte35In") cue.value.data = new Uint8Array(cue.value.data.match(/[\da-f]{2}/gi)).buffer;
            metadataTrack.addCue(cue);
        }
        dateRange.processDateRange();
    });
};
/**
 * Create metadata text track on video.js if it does not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {string} dispatchType the inband metadata track dispatch type
 * @param {Object} tech the video.js tech
 * @private
 */ const $cb03b711053a4297$var$createMetadataTrackIfNotExists = (inbandTextTracks, dispatchType, tech)=>{
    if (inbandTextTracks.metadataTrack_) return;
    inbandTextTracks.metadataTrack_ = tech.addRemoteTextTrack({
        kind: "metadata",
        label: "Timed Metadata"
    }, false).track;
    if (!$cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI) inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType = dispatchType;
};
/**
 * Remove cues from a track on video.js.
 *
 * @param {Double} start start of where we should remove the cue
 * @param {Double} end end of where the we should remove the cue
 * @param {Object} track the text track to remove the cues from
 * @private
 */ const $cb03b711053a4297$var$removeCuesFromTrack = function(start, end, track) {
    let i;
    let cue;
    if (!track) return;
    if (!track.cues) return;
    i = track.cues.length;
    while(i--){
        cue = track.cues[i]; // Remove any cue within the provided start and end time
        if (cue.startTime >= start && cue.endTime <= end) track.removeCue(cue);
    }
};
/**
 * Remove duplicate cues from a track on video.js (a cue is considered a
 * duplicate if it has the same time interval and text as another)
 *
 * @param {Object} track the text track to remove the duplicate cues from
 * @private
 */ const $cb03b711053a4297$var$removeDuplicateCuesFromTrack = function(track) {
    const cues = track.cues;
    if (!cues) return;
    const uniqueCues = {};
    for(let i = cues.length - 1; i >= 0; i--){
        const cue = cues[i];
        const cueKey = `${cue.startTime}-${cue.endTime}-${cue.text}`;
        if (uniqueCues[cueKey]) track.removeCue(cue);
        else uniqueCues[cueKey] = cue;
    }
};
/**
 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
 * front of current time.
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {number} currentTime
 *        The current time
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 * @return {Array}
 *         List of gops considered safe to append over
 */ const $cb03b711053a4297$var$gopsSafeToAlignWith = (buffer, currentTime, mapping)=>{
    if (typeof currentTime === "undefined" || currentTime === null || !buffer.length) return [];
     // pts value for current time + 3 seconds to give a bit more wiggle room
    const currentTimePts = Math.ceil((currentTime - mapping + 3) * (0, $2a252b448d50d133$exports.ONE_SECOND_IN_TS));
    let i;
    for(i = 0; i < buffer.length; i++){
        if (buffer[i].pts > currentTimePts) break;
    }
    return buffer.slice(i);
};
/**
 * Appends gop information (timing and byteLength) received by the transmuxer for the
 * gops appended in the last call to appendBuffer
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Array} gops
 *        List of new gop information
 * @param {boolean} replace
 *        If true, replace the buffer with the new gop information. If false, append the
 *        new gop information to the buffer in the right location of time.
 * @return {Array}
 *         Updated list of gop information
 */ const $cb03b711053a4297$var$updateGopBuffer = (buffer, gops, replace)=>{
    if (!gops.length) return buffer;
    if (replace) // If we are in safe append mode, then completely overwrite the gop buffer
    // with the most recent appeneded data. This will make sure that when appending
    // future segments, we only try to align with gops that are both ahead of current
    // time and in the last segment appended.
    return gops.slice();
    const start = gops[0].pts;
    let i = 0;
    for(i; i < buffer.length; i++){
        if (buffer[i].pts >= start) break;
    }
    return buffer.slice(0, i).concat(gops);
};
/**
 * Removes gop information in buffer that overlaps with provided start and end
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Double} start
 *        position to start the remove at
 * @param {Double} end
 *        position to end the remove at
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 */ const $cb03b711053a4297$var$removeGopBuffer = (buffer, start, end, mapping)=>{
    const startPts = Math.ceil((start - mapping) * (0, $2a252b448d50d133$exports.ONE_SECOND_IN_TS));
    const endPts = Math.ceil((end - mapping) * (0, $2a252b448d50d133$exports.ONE_SECOND_IN_TS));
    const updatedBuffer = buffer.slice();
    let i = buffer.length;
    while(i--){
        if (buffer[i].pts <= endPts) break;
    }
    if (i === -1) // no removal because end of remove range is before start of buffer
    return updatedBuffer;
    let j = i + 1;
    while(j--){
        if (buffer[j].pts <= startPts) break;
    } // clamp remove range start to 0 index
    j = Math.max(j, 0);
    updatedBuffer.splice(j, i - j + 1);
    return updatedBuffer;
};
const $cb03b711053a4297$var$shallowEqual = function(a, b) {
    // if both are undefined
    // or one or the other is undefined
    // they are not equal
    if (!a && !b || !a && b || a && !b) return false;
     // they are the same object and thus, equal
    if (a === b) return true;
     // sort keys so we can make sure they have
    // all the same keys later.
    const akeys = Object.keys(a).sort();
    const bkeys = Object.keys(b).sort(); // different number of keys, not equal
    if (akeys.length !== bkeys.length) return false;
    for(let i = 0; i < akeys.length; i++){
        const key = akeys[i]; // different sorted keys, not equal
        if (key !== bkeys[i]) return false;
         // different values, not equal
        if (a[key] !== b[key]) return false;
    }
    return true;
};
// https://www.w3.org/TR/WebIDL-1/#quotaexceedederror
const $cb03b711053a4297$var$QUOTA_EXCEEDED_ERR = 22;
/**
 * The segment loader has no recourse except to fetch a segment in the
 * current playlist and use the internal timestamps in that segment to
 * generate a syncPoint. This function returns a good candidate index
 * for that process.
 *
 * @param {Array} segments - the segments array from a playlist.
 * @return {number} An index of a segment from the playlist to load
 */ const $cb03b711053a4297$var$getSyncSegmentCandidate = function(currentTimeline, segments, targetTime) {
    segments = segments || [];
    const timelineSegments = [];
    let time = 0;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        if (currentTimeline === segment.timeline) {
            timelineSegments.push(i);
            time += segment.duration;
            if (time > targetTime) return i;
        }
    }
    if (timelineSegments.length === 0) return 0;
     // default to the last timeline segment
    return timelineSegments[timelineSegments.length - 1];
}; // In the event of a quota exceeded error, keep at least one second of back buffer. This
// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
// as a start to prevent any potential issues with removing content too close to the
// playhead.
const $cb03b711053a4297$var$MIN_BACK_BUFFER = 1; // in ms
const $cb03b711053a4297$var$CHECK_BUFFER_DELAY = 500;
const $cb03b711053a4297$var$finite = (num)=>typeof num === "number" && isFinite(num); // With most content hovering around 30fps, if a segment has a duration less than a half
// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
// not accurately reflect the rest of the content.
const $cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS = 1 / 60;
const $cb03b711053a4297$var$illegalMediaSwitch = (loaderType, startingMedia, trackInfo)=>{
    // Although these checks should most likely cover non 'main' types, for now it narrows
    // the scope of our checks.
    if (loaderType !== "main" || !startingMedia || !trackInfo) return null;
    if (!trackInfo.hasAudio && !trackInfo.hasVideo) return "Neither audio nor video found in segment.";
    if (startingMedia.hasVideo && !trackInfo.hasVideo) return "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest.";
    if (!startingMedia.hasVideo && trackInfo.hasVideo) return "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest.";
    return null;
};
/**
 * Calculates a time value that is safe to remove from the back buffer without interrupting
 * playback.
 *
 * @param {TimeRange} seekable
 *        The current seekable range
 * @param {number} currentTime
 *        The current time of the player
 * @param {number} targetDuration
 *        The target duration of the current playlist
 * @return {number}
 *         Time that is safe to remove from the back buffer without interrupting playback
 */ const $cb03b711053a4297$var$safeBackBufferTrimTime = (seekable, currentTime, targetDuration)=>{
    // 30 seconds before the playhead provides a safe default for trimming.
    //
    // Choosing a reasonable default is particularly important for high bitrate content and
    // VOD videos/live streams with large windows, as the buffer may end up overfilled and
    // throw an APPEND_BUFFER_ERR.
    let trimTime = currentTime - $cb03b711053a4297$var$Config.BACK_BUFFER_LENGTH;
    if (seekable.length) // Some live playlists may have a shorter window of content than the full allowed back
    // buffer. For these playlists, don't save content that's no longer within the window.
    trimTime = Math.max(trimTime, seekable.start(0));
     // Don't remove within target duration of the current time to avoid the possibility of
    // removing the GOP currently being played, as removing it can cause playback stalls.
    const maxTrimTime = currentTime - targetDuration;
    return Math.min(maxTrimTime, trimTime);
};
const $cb03b711053a4297$var$segmentInfoString = (segmentInfo)=>{
    const { startOfSegment: startOfSegment, duration: duration, segment: segment, part: part, playlist: { mediaSequence: seq, id: id, segments: segments = [] }, mediaIndex: index, partIndex: partIndex, timeline: timeline } = segmentInfo;
    const segmentLen = segments.length - 1;
    let selection = "mediaIndex/partIndex increment";
    if (segmentInfo.getMediaInfoForTime) selection = `getMediaInfoForTime (${segmentInfo.getMediaInfoForTime})`;
    else if (segmentInfo.isSyncRequest) selection = "getSyncSegmentCandidate (isSyncRequest)";
    if (segmentInfo.independent) selection += ` with independent ${segmentInfo.independent}`;
    const hasPartIndex = typeof partIndex === "number";
    const name = segmentInfo.segment.uri ? "segment" : "pre-segment";
    const zeroBasedPartCount = hasPartIndex ? $cb03b711053a4297$var$getKnownPartCount({
        preloadSegment: segment
    }) - 1 : 0;
    return `${name} [${seq + index}/${seq + segmentLen}]` + (hasPartIndex ? ` part [${partIndex}/${zeroBasedPartCount}]` : "") + ` segment start/end [${segment.start} => ${segment.end}]` + (hasPartIndex ? ` part start/end [${part.start} => ${part.end}]` : "") + ` startOfSegment [${startOfSegment}]` + ` duration [${duration}]` + ` timeline [${timeline}]` + ` selected by [${selection}]` + ` playlist [${id}]`;
};
const $cb03b711053a4297$var$timingInfoPropertyForMedia = (mediaType)=>`${mediaType}TimingInfo`;
const $cb03b711053a4297$var$getBufferedEndOrFallback = (buffered, fallback)=>buffered.length ? buffered.end(buffered.length - 1) : fallback;
/**
 * Returns the timestamp offset to use for the segment.
 *
 * @param {number} segmentTimeline
 *        The timeline of the segment
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} startOfSegment
 *        The estimated segment start
 * @param {TimeRange[]} buffered
 *        The loader's buffer
 * @param {boolean} calculateTimestampOffsetForEachSegment
 *        Feature flag to always calculate timestampOffset
 * @param {boolean} overrideCheck
 *        If true, no checks are made to see if the timestamp offset value should be set,
 *        but sets it directly to a value.
 *
 * @return {number|null}
 *         Either a number representing a new timestamp offset, or null if the segment is
 *         part of the same timeline
 */ const $cb03b711053a4297$var$timestampOffsetForSegment = ({ segmentTimeline: segmentTimeline, currentTimeline: currentTimeline, startOfSegment: startOfSegment, buffered: buffered, calculateTimestampOffsetForEachSegment: calculateTimestampOffsetForEachSegment, overrideCheck: overrideCheck })=>{
    if (calculateTimestampOffsetForEachSegment) return $cb03b711053a4297$var$getBufferedEndOrFallback(buffered, startOfSegment);
     // Check to see if we are crossing a discontinuity to see if we need to set the
    // timestamp offset on the transmuxer and source buffer.
    //
    // Previously, we changed the timestampOffset if the start of this segment was less than
    // the currently set timestampOffset, but this isn't desirable as it can produce bad
    // behavior, especially around long running live streams.
    if (!overrideCheck && segmentTimeline === currentTimeline) return null;
     // When changing renditions, it's possible to request a segment on an older timeline. For
    // instance, given two renditions with the following:
    //
    // #EXTINF:10
    // segment1
    // #EXT-X-DISCONTINUITY
    // #EXTINF:10
    // segment2
    // #EXTINF:10
    // segment3
    //
    // And the current player state:
    //
    // current time: 8
    // buffer: 0 => 20
    //
    // The next segment on the current rendition would be segment3, filling the buffer from
    // 20s onwards. However, if a rendition switch happens after segment2 was requested,
    // then the next segment to be requested will be segment1 from the new rendition in
    // order to fill time 8 and onwards. Using the buffered end would result in repeated
    // content (since it would position segment1 of the new rendition starting at 20s). This
    // case can be identified when the new segment's timeline is a prior value. Instead of
    // using the buffered end, the startOfSegment can be used, which, hopefully, will be
    // more accurate to the actual start time of the segment.
    if (segmentTimeline < currentTimeline) return startOfSegment;
     // segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
    // value uses the end of the last segment if it is available. While this value
    // should often be correct, it's better to rely on the buffered end, as the new
    // content post discontinuity should line up with the buffered end as if it were
    // time 0 for the new content.
    return $cb03b711053a4297$var$getBufferedEndOrFallback(buffered, startOfSegment);
};
/**
 * Returns whether or not the loader should wait for a timeline change from the timeline
 * change controller before processing the segment.
 *
 * Primary timing in VHS goes by video. This is different from most media players, as
 * audio is more often used as the primary timing source. For the foreseeable future, VHS
 * will continue to use video as the primary timing source, due to the current logic and
 * expectations built around it.

 * Since the timing follows video, in order to maintain sync, the video loader is
 * responsible for setting both audio and video source buffer timestamp offsets.
 *
 * Setting different values for audio and video source buffers could lead to
 * desyncing. The following examples demonstrate some of the situations where this
 * distinction is important. Note that all of these cases involve demuxed content. When
 * content is muxed, the audio and video are packaged together, therefore syncing
 * separate media playlists is not an issue.
 *
 * CASE 1: Audio prepares to load a new timeline before video:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:                     ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader              ^
 *
 * In the above example, the audio loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the video loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the audio loader goes ahead and loads and appends the 6th segment before the video
 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
 * the audio loader must provide the audioAppendStart value to trim the content in the
 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
 * segment until that value is provided.
 *
 * CASE 2: Video prepares to load a new timeline before audio:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:             ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader                      ^
 *
 * In the above example, the video loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the audio loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the video loader goes ahead and loads and appends the 6th segment, then once the
 * segment is loaded and processed, both the video and audio timestamp offsets will be
 * set, since video is used as the primary timing source. This is to ensure content lines
 * up appropriately, as any modifications to the video timing are reflected by audio when
 * the video loader sets the audio and video timestamp offsets to the same value. However,
 * setting the timestamp offset for audio before audio has had a chance to change
 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
 *
 * CASE 3: When seeking, audio prepares to load a new timeline before video
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:           ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader            ^
 *
 * In the above example, both audio and video loaders are loading segments from timeline
 * 0, but imagine that the seek originated from timeline 1.
 *
 * When seeking to a new timeline, the timestamp offset will be set based on the expected
 * segment start of the loaded video segment. In order to maintain sync, the audio loader
 * must wait for the video loader to load its segment and update both the audio and video
 * timestamp offsets before it may load and append its own segment. This is the case
 * whether the seek results in a mismatched segment request (e.g., the audio loader
 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
 * loaders choose to load the same segment index from each playlist, as the segments may
 * not be aligned perfectly, even for matching segment indexes.
 *
 * @param {Object} timelinechangeController
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} segmentTimeline
 *        The timeline of the segment being loaded
 * @param {('main'|'audio')} loaderType
 *        The loader type
 * @param {boolean} audioDisabled
 *        Whether the audio is disabled for the loader. This should only be true when the
 *        loader may have muxed audio in its segment, but should not append it, e.g., for
 *        the main loader when an alternate audio playlist is active.
 *
 * @return {boolean}
 *         Whether the loader should wait for a timeline change from the timeline change
 *         controller before processing the segment
 */ const $cb03b711053a4297$var$shouldWaitForTimelineChange = ({ timelineChangeController: timelineChangeController, currentTimeline: currentTimeline, segmentTimeline: segmentTimeline, loaderType: loaderType, audioDisabled: audioDisabled })=>{
    if (currentTimeline === segmentTimeline) return false;
    if (loaderType === "audio") {
        const lastMainTimelineChange = timelineChangeController.lastTimelineChange({
            type: "main"
        }); // Audio loader should wait if:
        //
        // * main hasn't had a timeline change yet (thus has not loaded its first segment)
        // * main hasn't yet changed to the timeline audio is looking to load
        return !lastMainTimelineChange || lastMainTimelineChange.to !== segmentTimeline;
    } // The main loader only needs to wait for timeline changes if there's demuxed audio.
    // Otherwise, there's nothing to wait for, since audio would be muxed into the main
    // loader's segments (or the content is audio/video only and handled by the main
    // loader).
    if (loaderType === "main" && audioDisabled) {
        const pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
            type: "audio"
        }); // Main loader should wait for the audio loader if audio is not pending a timeline
        // change to the current timeline.
        //
        // Since the main loader is responsible for setting the timestamp offset for both
        // audio and video, the main loader must wait for audio to be about to change to its
        // timeline before setting the offset, otherwise, if audio is behind in loading,
        // segments from the previous timeline would be adjusted by the new timestamp offset.
        //
        // This requirement means that video will not cross a timeline until the audio is
        // about to cross to it, so that way audio and video will always cross the timeline
        // together.
        //
        // In addition to normal timeline changes, these rules also apply to the start of a
        // stream (going from a non-existent timeline, -1, to timeline 0). It's important
        // that these rules apply to the first timeline change because if they did not, it's
        // possible that the main loader will cross two timelines before the audio loader has
        // crossed one. Logic may be implemented to handle the startup as a special case, but
        // it's easier to simply treat all timeline changes the same.
        if (pendingAudioTimelineChange && pendingAudioTimelineChange.to === segmentTimeline) return false;
        return true;
    }
    return false;
};
const $cb03b711053a4297$var$mediaDuration = (timingInfos)=>{
    let maxDuration = 0;
    [
        "video",
        "audio"
    ].forEach(function(type) {
        const typeTimingInfo = timingInfos[`${type}TimingInfo`];
        if (!typeTimingInfo) return;
        const { start: start, end: end } = typeTimingInfo;
        let duration;
        if (typeof start === "bigint" || typeof end === "bigint") duration = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(end) - (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).BigInt(start);
        else if (typeof start === "number" && typeof end === "number") duration = end - start;
        if (typeof duration !== "undefined" && duration > maxDuration) maxDuration = duration;
    }); // convert back to a number if it is lower than MAX_SAFE_INTEGER
    // as we only need BigInt when we are above that.
    if (typeof maxDuration === "bigint" && maxDuration < Number.MAX_SAFE_INTEGER) maxDuration = Number(maxDuration);
    return maxDuration;
};
const $cb03b711053a4297$var$segmentTooLong = ({ segmentDuration: segmentDuration, maxDuration: maxDuration })=>{
    // 0 duration segments are most likely due to metadata only segments or a lack of
    // information.
    if (!segmentDuration) return false;
     // For HLS:
    //
    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
    // The EXTINF duration of each Media Segment in the Playlist
    // file, when rounded to the nearest integer, MUST be less than or equal
    // to the target duration; longer segments can trigger playback stalls
    // or other errors.
    //
    // For DASH, the mpd-parser uses the largest reported segment duration as the target
    // duration. Although that reported duration is occasionally approximate (i.e., not
    // exact), a strict check may report that a segment is too long more often in DASH.
    return Math.round(segmentDuration) > maxDuration + $cb03b711053a4297$var$TIME_FUDGE_FACTOR;
};
const $cb03b711053a4297$var$getTroublesomeSegmentDurationMessage = (segmentInfo, sourceType)=>{
    // Right now we aren't following DASH's timing model exactly, so only perform
    // this check for HLS content.
    if (sourceType !== "hls") return null;
    const segmentDuration = $cb03b711053a4297$var$mediaDuration({
        audioTimingInfo: segmentInfo.audioTimingInfo,
        videoTimingInfo: segmentInfo.videoTimingInfo
    }); // Don't report if we lack information.
    //
    // If the segment has a duration of 0 it is either a lack of information or a
    // metadata only segment and shouldn't be reported here.
    if (!segmentDuration) return null;
    const targetDuration = segmentInfo.playlist.targetDuration;
    const isSegmentWayTooLong = $cb03b711053a4297$var$segmentTooLong({
        segmentDuration: segmentDuration,
        maxDuration: targetDuration * 2
    });
    const isSegmentSlightlyTooLong = $cb03b711053a4297$var$segmentTooLong({
        segmentDuration: segmentDuration,
        maxDuration: targetDuration
    });
    const segmentTooLongMessage = `Segment with index ${segmentInfo.mediaIndex} ` + `from playlist ${segmentInfo.playlist.id} ` + `has a duration of ${segmentDuration} ` + `when the reported duration is ${segmentInfo.duration} ` + `and the target duration is ${targetDuration}. ` + "For HLS content, a duration in excess of the target duration may result in " + "playback issues. See the HLS specification section on EXT-X-TARGETDURATION for " + "more details: " + "https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1";
    if (isSegmentWayTooLong || isSegmentSlightlyTooLong) return {
        severity: isSegmentWayTooLong ? "warn" : "info",
        message: segmentTooLongMessage
    };
    return null;
};
/**
 * An object that manages segment loading and appending.
 *
 * @class SegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$SegmentLoader extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(settings, options = {}){
        super(); // check pre-conditions
        if (!settings) throw new TypeError("Initialization settings are required");
        if (typeof settings.currentTime !== "function") throw new TypeError("No currentTime getter specified");
        if (!settings.mediaSource) throw new TypeError("No MediaSource specified");
         // public properties
        this.bandwidth = settings.bandwidth;
        this.throughput = {
            rate: 0,
            count: 0
        };
        this.roundTrip = NaN;
        this.resetStats_();
        this.mediaIndex = null;
        this.partIndex = null; // private settings
        this.hasPlayed_ = settings.hasPlayed;
        this.currentTime_ = settings.currentTime;
        this.seekable_ = settings.seekable;
        this.seeking_ = settings.seeking;
        this.duration_ = settings.duration;
        this.mediaSource_ = settings.mediaSource;
        this.vhs_ = settings.vhs;
        this.loaderType_ = settings.loaderType;
        this.currentMediaInfo_ = void 0;
        this.startingMediaInfo_ = void 0;
        this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
        this.goalBufferLength_ = settings.goalBufferLength;
        this.sourceType_ = settings.sourceType;
        this.sourceUpdater_ = settings.sourceUpdater;
        this.inbandTextTracks_ = settings.inbandTextTracks;
        this.state_ = "INIT";
        this.timelineChangeController_ = settings.timelineChangeController;
        this.shouldSaveSegmentTimingInfo_ = true;
        this.parse708captions_ = settings.parse708captions;
        this.useDtsForTimestampOffset_ = settings.useDtsForTimestampOffset;
        this.calculateTimestampOffsetForEachSegment_ = settings.calculateTimestampOffsetForEachSegment;
        this.captionServices_ = settings.captionServices;
        this.exactManifestTimings = settings.exactManifestTimings;
        this.addMetadataToTextTrack = settings.addMetadataToTextTrack; // private instance variables
        this.checkBufferTimeout_ = null;
        this.error_ = void 0;
        this.currentTimeline_ = -1;
        this.pendingSegment_ = null;
        this.xhrOptions_ = null;
        this.pendingSegments_ = [];
        this.audioDisabled_ = false;
        this.isPendingTimestampOffset_ = false; // TODO possibly move gopBuffer and timeMapping info to a separate controller
        this.gopBuffer_ = [];
        this.timeMapping_ = 0;
        this.safeAppend_ = false;
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        this.playlistOfLastInitSegment_ = {
            audio: null,
            video: null
        };
        this.callQueue_ = []; // If the segment loader prepares to load a segment, but does not have enough
        // information yet to start the loading process (e.g., if the audio loader wants to
        // load a segment from the next timeline but the main loader hasn't yet crossed that
        // timeline), then the load call will be added to the queue until it is ready to be
        // processed.
        this.loadQueue_ = [];
        this.metadataQueue_ = {
            id3: [],
            caption: []
        };
        this.waitingOnRemove_ = false;
        this.quotaExceededErrorRetryTimeout_ = null; // Fragmented mp4 playback
        this.activeInitSegmentId_ = null;
        this.initSegments_ = {}; // HLSe playback
        this.cacheEncryptionKeys_ = settings.cacheEncryptionKeys;
        this.keyCache_ = {};
        this.decrypter_ = settings.decrypter; // Manages the tracking and generation of sync-points, mappings
        // between a time in the display time and a segment index within
        // a playlist
        this.syncController_ = settings.syncController;
        this.syncPoint_ = {
            segmentIndex: 0,
            time: 0
        };
        this.transmuxer_ = this.createTransmuxer_();
        this.triggerSyncInfoUpdate_ = ()=>this.trigger("syncinfoupdate");
        this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_);
        this.mediaSource_.addEventListener("sourceopen", ()=>{
            if (!this.isEndOfStream_()) this.ended_ = false;
        }); // ...for determining the fetch location
        this.fetchAtBuffer_ = false; // For comparing with currentTime when overwriting segments on fastQualityChange_ changes. Use -1 as the inactive flag.
        this.replaceSegmentsUntil_ = -1;
        this.logger_ = $cb03b711053a4297$var$logger(`SegmentLoader[${this.loaderType_}]`);
        Object.defineProperty(this, "state", {
            get () {
                return this.state_;
            },
            set (newState) {
                if (newState !== this.state_) {
                    this.logger_(`${this.state_} -> ${newState}`);
                    this.state_ = newState;
                    this.trigger("statechange");
                }
            }
        });
        this.sourceUpdater_.on("ready", ()=>{
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
        }); // Only the main loader needs to listen for pending timeline changes, as the main
        // loader should wait for audio to be ready to change its timeline so that both main
        // and audio timelines change together. For more details, see the
        // shouldWaitForTimelineChange function.
        if (this.loaderType_ === "main") this.timelineChangeController_.on("pendingtimelinechange", ()=>{
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
        });
         // The main loader only listens on pending timeline changes, but the audio loader,
        // since its loads follow main, needs to listen on timeline changes. For more details,
        // see the shouldWaitForTimelineChange function.
        if (this.loaderType_ === "audio") this.timelineChangeController_.on("timelinechange", ()=>{
            if (this.hasEnoughInfoToLoad_()) this.processLoadQueue_();
            if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
        });
    }
    createTransmuxer_() {
        return $cb03b711053a4297$var$segmentTransmuxer.createTransmuxer({
            remux: false,
            alignGopsAtEnd: this.safeAppend_,
            keepOriginalTimestamps: true,
            parse708captions: this.parse708captions_,
            captionServices: this.captionServices_
        });
    }
    /**
   * reset all of our media stats
   *
   * @private
   */ resetStats_() {
        this.mediaBytesTransferred = 0;
        this.mediaRequests = 0;
        this.mediaRequestsAborted = 0;
        this.mediaRequestsTimedout = 0;
        this.mediaRequestsErrored = 0;
        this.mediaTransferDuration = 0;
        this.mediaSecondsLoaded = 0;
        this.mediaAppends = 0;
    }
    /**
   * dispose of the SegmentLoader and reset to the default state
   */ dispose() {
        this.trigger("dispose");
        this.state = "DISPOSED";
        this.pause();
        this.abort_();
        if (this.transmuxer_) this.transmuxer_.terminate();
        this.resetStats_();
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
        if (this.syncController_ && this.triggerSyncInfoUpdate_) this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_);
        this.off();
    }
    setAudio(enable) {
        this.audioDisabled_ = !enable;
        if (enable) this.appendInitSegment_.audio = true;
        else // remove current track audio if it gets disabled
        this.sourceUpdater_.removeAudio(0, this.duration_());
    }
    /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */ abort() {
        if (this.state !== "WAITING") {
            if (this.pendingSegment_) this.pendingSegment_ = null;
            return;
        }
        this.abort_(); // We aborted the requests we were waiting on, so reset the loader's state to READY
        // since we are no longer "waiting" on any requests. XHR callback is not always run
        // when the request is aborted. This will prevent the loader from being stuck in the
        // WAITING state indefinitely.
        this.state = "READY"; // don't wait for buffer check timeouts to begin fetching the
        // next segment
        if (!this.paused()) this.monitorBuffer_();
    }
    /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */ abort_() {
        if (this.pendingSegment_ && this.pendingSegment_.abortRequests) this.pendingSegment_.abortRequests();
         // clear out the segment being processed
        this.pendingSegment_ = null;
        this.callQueue_ = [];
        this.loadQueue_ = [];
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
        this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
        this.waitingOnRemove_ = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.quotaExceededErrorRetryTimeout_);
        this.quotaExceededErrorRetryTimeout_ = null;
    }
    checkForAbort_(requestId) {
        // If the state is APPENDING, then aborts will not modify the state, meaning the first
        // callback that happens should reset the state to READY so that loading can continue.
        if (this.state === "APPENDING" && !this.pendingSegment_) {
            this.state = "READY";
            return true;
        }
        if (!this.pendingSegment_ || this.pendingSegment_.requestId !== requestId) return true;
        return false;
    }
    /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */ error(error) {
        if (typeof error !== "undefined") {
            this.logger_("error occurred:", error);
            this.error_ = error;
        }
        this.pendingSegment_ = null;
        return this.error_;
    }
    endOfStream() {
        this.ended_ = true;
        if (this.transmuxer_) // need to clear out any cached data to prepare for the new segment
        $cb03b711053a4297$var$segmentTransmuxer.reset(this.transmuxer_);
        this.gopBuffer_.length = 0;
        this.pause();
        this.trigger("ended");
    }
    /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */ buffered_() {
        const trackInfo = this.getMediaInfo_();
        if (!this.sourceUpdater_ || !trackInfo) return $cb03b711053a4297$var$createTimeRanges();
        if (this.loaderType_ === "main") {
            const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
            if (hasVideo && hasAudio && !this.audioDisabled_ && !isMuxed) return this.sourceUpdater_.buffered();
            if (hasVideo) return this.sourceUpdater_.videoBuffered();
        } // One case that can be ignored for now is audio only with alt audio,
        // as we don't yet have proper support for that.
        return this.sourceUpdater_.audioBuffered();
    }
    /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */ initSegmentForMap(map, set = false) {
        if (!map) return null;
        const id = $cb03b711053a4297$var$initSegmentId(map);
        let storedMap = this.initSegments_[id];
        if (set && !storedMap && map.bytes) this.initSegments_[id] = storedMap = {
            resolvedUri: map.resolvedUri,
            byterange: map.byterange,
            bytes: map.bytes,
            tracks: map.tracks,
            timescales: map.timescales
        };
        return storedMap || map;
    }
    /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */ segmentKey(key, set = false) {
        if (!key) return null;
        const id = $cb03b711053a4297$var$segmentKeyId(key);
        let storedKey = this.keyCache_[id]; // TODO: We should use the HTTP Expires header to invalidate our cache per
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
        if (this.cacheEncryptionKeys_ && set && !storedKey && key.bytes) this.keyCache_[id] = storedKey = {
            resolvedUri: key.resolvedUri,
            bytes: key.bytes
        };
        const result = {
            resolvedUri: (storedKey || key).resolvedUri
        };
        if (storedKey) result.bytes = storedKey.bytes;
        return result;
    }
    /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */ couldBeginLoading_() {
        return this.playlist_ && !this.paused();
    }
    /**
   * load a playlist and start to fill the buffer
   */ load() {
        // un-pause
        this.monitorBuffer_(); // if we don't have a playlist yet, keep waiting for one to be
        // specified
        if (!this.playlist_) return;
         // if all the configuration is ready, initialize and begin loading
        if (this.state === "INIT" && this.couldBeginLoading_()) return this.init_();
         // if we're in the middle of processing a segment already, don't
        // kick off an additional segment request
        if (!this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT") return;
        this.state = "READY";
    }
    /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */ init_() {
        this.state = "READY"; // if this is the audio segment loader, and it hasn't been inited before, then any old
        // audio data from the muxed content should be removed
        this.resetEverything();
        return this.monitorBuffer_();
    }
    /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */ playlist(newPlaylist, options = {}) {
        if (!newPlaylist) return;
        const oldPlaylist = this.playlist_;
        const segmentInfo = this.pendingSegment_;
        this.playlist_ = newPlaylist;
        this.xhrOptions_ = options; // when we haven't started playing yet, the start of a live playlist
        // is always our zero-time so force a sync update each time the playlist
        // is refreshed from the server
        //
        // Use the INIT state to determine if playback has started, as the playlist sync info
        // should be fixed once requests begin (as sync points are generated based on sync
        // info), but not before then.
        if (this.state === "INIT") {
            newPlaylist.syncInfo = {
                mediaSequence: newPlaylist.mediaSequence,
                time: 0
            }; // Setting the date time mapping means mapping the program date time (if available)
            // to time 0 on the player's timeline. The playlist's syncInfo serves a similar
            // purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
            // be updated as the playlist is refreshed before the loader starts loading, the
            // program date time mapping needs to be updated as well.
            //
            // This mapping is only done for the main loader because a program date time should
            // map equivalently between playlists.
            if (this.loaderType_ === "main") this.syncController_.setDateTimeMappingForStart(newPlaylist);
        }
        let oldId = null;
        if (oldPlaylist) {
            if (oldPlaylist.id) oldId = oldPlaylist.id;
            else if (oldPlaylist.uri) oldId = oldPlaylist.uri;
        }
        this.logger_(`playlist update [${oldId} => ${newPlaylist.id || newPlaylist.uri}]`); // in VOD, this is always a rendition switch (or we updated our syncInfo above)
        // in LIVE, we always want to update with new playlists (including refreshes)
        this.trigger("syncinfoupdate"); // if we were unpaused but waiting for a playlist, start
        // buffering now
        if (this.state === "INIT" && this.couldBeginLoading_()) return this.init_();
        if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
            if (this.mediaIndex !== null) {
                // we must reset/resync the segment loader when we switch renditions and
                // the segment loader is already synced to the previous rendition
                // We only want to reset the loader here for LLHLS playback, as resetLoader sets fetchAtBuffer_
                // to false, resulting in fetching segments at currentTime and causing repeated
                // same-segment requests on playlist change. This erroneously drives up the playback watcher
                // stalled segment count, as re-requesting segments at the currentTime or browser cached segments
                // will not change the buffer.
                // Reference for LLHLS fixes: https://github.com/videojs/http-streaming/pull/1201
                const isLLHLS = !newPlaylist.endList && typeof newPlaylist.partTargetDuration === "number";
                if (isLLHLS) this.resetLoader();
                else this.resyncLoader();
            }
            this.currentMediaInfo_ = void 0;
            this.trigger("playlistupdate"); // the rest of this function depends on `oldPlaylist` being defined
            return;
        } // we reloaded the same playlist so we are in a live scenario
        // and we will likely need to adjust the mediaIndex
        const mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
        this.logger_(`live window shift [${mediaSequenceDiff}]`); // update the mediaIndex on the SegmentLoader
        // this is important because we can abort a request and this value must be
        // equal to the last appended mediaIndex
        if (this.mediaIndex !== null) {
            this.mediaIndex -= mediaSequenceDiff; // this can happen if we are going to load the first segment, but get a playlist
            // update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
            // new playlist was incremented by 1.
            if (this.mediaIndex < 0) {
                this.mediaIndex = null;
                this.partIndex = null;
            } else {
                const segment = this.playlist_.segments[this.mediaIndex]; // partIndex should remain the same for the same segment
                // unless parts fell off of the playlist for this segment.
                // In that case we need to reset partIndex and resync
                if (this.partIndex && (!segment.parts || !segment.parts.length || !segment.parts[this.partIndex])) {
                    const mediaIndex = this.mediaIndex;
                    this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`);
                    this.resetLoader(); // We want to throw away the partIndex and the data associated with it,
                    // as the part was dropped from our current playlists segment.
                    // The mediaIndex will still be valid so keep that around.
                    this.mediaIndex = mediaIndex;
                }
            }
        } // update the mediaIndex on the SegmentInfo object
        // this is important because we will update this.mediaIndex with this value
        // in `handleAppendsDone_` after the segment has been successfully appended
        if (segmentInfo) {
            segmentInfo.mediaIndex -= mediaSequenceDiff;
            if (segmentInfo.mediaIndex < 0) {
                segmentInfo.mediaIndex = null;
                segmentInfo.partIndex = null;
            } else {
                // we need to update the referenced segment so that timing information is
                // saved for the new playlist's segment, however, if the segment fell off the
                // playlist, we can leave the old reference and just lose the timing info
                if (segmentInfo.mediaIndex >= 0) segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
                if (segmentInfo.partIndex >= 0 && segmentInfo.segment.parts) segmentInfo.part = segmentInfo.segment.parts[segmentInfo.partIndex];
            }
        }
        this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
    }
    /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */ pause() {
        if (this.checkBufferTimeout_) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
            this.checkBufferTimeout_ = null;
        }
    }
    /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */ paused() {
        return this.checkBufferTimeout_ === null;
    }
    /**
   * Resets the segment loader ended and init properties.
   */ resetLoaderProperties() {
        this.ended_ = false;
        this.activeInitSegmentId_ = null;
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
    }
    /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */ resetEverything(done) {
        this.resetLoaderProperties();
        this.resetLoader(); // remove from 0, the earliest point, to Infinity, to signify removal of everything.
        // VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
        // we then clamp the value to duration if necessary.
        this.remove(0, Infinity, done); // clears fmp4 captions
        if (this.transmuxer_) {
            this.transmuxer_.postMessage({
                action: "clearAllMp4Captions"
            }); // reset the cache in the transmuxer
            this.transmuxer_.postMessage({
                action: "reset"
            });
        }
    }
    /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */ resetLoader() {
        this.fetchAtBuffer_ = false;
        this.resyncLoader();
    }
    /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */ resyncLoader() {
        if (this.transmuxer_) // need to clear out any cached data to prepare for the new segment
        $cb03b711053a4297$var$segmentTransmuxer.reset(this.transmuxer_);
        this.mediaIndex = null;
        this.partIndex = null;
        this.syncPoint_ = null;
        this.isPendingTimestampOffset_ = false;
        this.callQueue_ = [];
        this.loadQueue_ = [];
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
        this.abort();
        if (this.transmuxer_) this.transmuxer_.postMessage({
            action: "clearParsedMp4Captions"
        });
    }
    /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */ remove(start, end, done = ()=>{}, force = false) {
        // clamp end to duration if we need to remove everything.
        // This is due to a browser bug that causes issues if we remove to Infinity.
        // videojs/videojs-contrib-hls#1225
        if (end === Infinity) end = this.duration_();
         // skip removes that would throw an error
        // commonly happens during a rendition switch at the start of a video
        // from start 0 to end 0
        if (end <= start) {
            this.logger_("skipping remove because end ${end} is <= start ${start}");
            return;
        }
        if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
            this.logger_("skipping remove because no source updater or starting media info"); // nothing to remove if we haven't processed any media
            return;
        } // set it to one to complete this function's removes
        let removesRemaining = 1;
        const removeFinished = ()=>{
            removesRemaining--;
            if (removesRemaining === 0) done();
        };
        if (force || !this.audioDisabled_) {
            removesRemaining++;
            this.sourceUpdater_.removeAudio(start, end, removeFinished);
        } // While it would be better to only remove video if the main loader has video, this
        // should be safe with audio only as removeVideo will call back even if there's no
        // video buffer.
        //
        // In theory we can check to see if there's video before calling the remove, but in
        // the event that we're switching between renditions and from video to audio only
        // (when we add support for that), we may need to clear the video contents despite
        // what the new media will contain.
        if (force || this.loaderType_ === "main") {
            this.gopBuffer_ = $cb03b711053a4297$var$removeGopBuffer(this.gopBuffer_, start, end, this.timeMapping_);
            removesRemaining++;
            this.sourceUpdater_.removeVideo(start, end, removeFinished);
        } // remove any captions and ID3 tags
        for(const track in this.inbandTextTracks_)$cb03b711053a4297$var$removeCuesFromTrack(start, end, this.inbandTextTracks_[track]);
        $cb03b711053a4297$var$removeCuesFromTrack(start, end, this.segmentMetadataTrack_); // finished this function's removes
        removeFinished();
    }
    /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */ monitorBuffer_() {
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
        this.checkBufferTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.monitorBufferTick_.bind(this), 1);
    }
    /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */ monitorBufferTick_() {
        if (this.state === "READY") this.fillBuffer_();
        if (this.checkBufferTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkBufferTimeout_);
        this.checkBufferTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.monitorBufferTick_.bind(this), $cb03b711053a4297$var$CHECK_BUFFER_DELAY);
    }
    /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */ fillBuffer_() {
        // TODO since the source buffer maintains a queue, and we shouldn't call this function
        // except when we're ready for the next segment, this check can most likely be removed
        if (this.sourceUpdater_.updating()) return;
         // see if we need to begin loading immediately
        const segmentInfo = this.chooseNextRequest_();
        if (!segmentInfo) return;
        if (typeof segmentInfo.timestampOffset === "number") {
            this.isPendingTimestampOffset_ = false;
            this.timelineChangeController_.pendingTimelineChange({
                type: this.loaderType_,
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            });
        }
        this.loadSegment_(segmentInfo);
    }
    /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */ isEndOfStream_(mediaIndex = this.mediaIndex, playlist = this.playlist_, partIndex = this.partIndex) {
        if (!playlist || !this.mediaSource_) return false;
        const segment = typeof mediaIndex === "number" && playlist.segments[mediaIndex]; // mediaIndex is zero based but length is 1 based
        const appendedLastSegment = mediaIndex + 1 === playlist.segments.length; // true if there are no parts, or this is the last part.
        const appendedLastPart = !segment || !segment.parts || partIndex + 1 === segment.parts.length; // if we've buffered to the end of the video, we need to call endOfStream
        // so that MediaSources can trigger the `ended` event when it runs out of
        // buffered data instead of waiting for me
        return playlist.endList && this.mediaSource_.readyState === "open" && appendedLastSegment && appendedLastPart;
    }
    /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */ chooseNextRequest_() {
        const buffered = this.buffered_();
        const bufferedEnd = $cb03b711053a4297$var$lastBufferedEnd(buffered) || 0;
        const bufferedTime = $cb03b711053a4297$var$timeAheadOf(buffered, this.currentTime_());
        const preloaded = !this.hasPlayed_() && bufferedTime >= 1;
        const haveEnoughBuffer = bufferedTime >= this.goalBufferLength_();
        const segments = this.playlist_.segments; // return no segment if:
        // 1. we don't have segments
        // 2. The video has not yet played and we already downloaded a segment
        // 3. we already have enough buffered time
        if (!segments.length || preloaded || haveEnoughBuffer) return null;
        this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
        const next = {
            partIndex: null,
            mediaIndex: null,
            startOfSegment: null,
            playlist: this.playlist_,
            isSyncRequest: Boolean(!this.syncPoint_)
        };
        if (next.isSyncRequest) next.mediaIndex = $cb03b711053a4297$var$getSyncSegmentCandidate(this.currentTimeline_, segments, bufferedEnd);
        else if (this.mediaIndex !== null) {
            const segment = segments[this.mediaIndex];
            const partIndex = typeof this.partIndex === "number" ? this.partIndex : -1;
            next.startOfSegment = segment.end ? segment.end : bufferedEnd;
            if (segment.parts && segment.parts[partIndex + 1]) {
                next.mediaIndex = this.mediaIndex;
                next.partIndex = partIndex + 1;
            } else next.mediaIndex = this.mediaIndex + 1;
        } else {
            // Find the segment containing the end of the buffer or current time.
            const { segmentIndex: segmentIndex, startTime: startTime, partIndex: partIndex } = $cb03b711053a4297$var$Playlist.getMediaInfoForTime({
                exactManifestTimings: this.exactManifestTimings,
                playlist: this.playlist_,
                currentTime: this.fetchAtBuffer_ ? bufferedEnd : this.currentTime_(),
                startingPartIndex: this.syncPoint_.partIndex,
                startingSegmentIndex: this.syncPoint_.segmentIndex,
                startTime: this.syncPoint_.time
            });
            next.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${bufferedEnd}` : `currentTime ${this.currentTime_()}`;
            next.mediaIndex = segmentIndex;
            next.startOfSegment = startTime;
            next.partIndex = partIndex;
        }
        const nextSegment = segments[next.mediaIndex];
        let nextPart = nextSegment && typeof next.partIndex === "number" && nextSegment.parts && nextSegment.parts[next.partIndex]; // if the next segment index is invalid or
        // the next partIndex is invalid do not choose a next segment.
        if (!nextSegment || typeof next.partIndex === "number" && !nextPart) return null;
         // if the next segment has parts, and we don't have a partIndex.
        // Set partIndex to 0
        if (typeof next.partIndex !== "number" && nextSegment.parts) {
            next.partIndex = 0;
            nextPart = nextSegment.parts[0];
        } // independentSegments applies to every segment in a playlist. If independentSegments appears in a main playlist,
        // it applies to each segment in each media playlist.
        // https://datatracker.ietf.org/doc/html/draft-pantos-http-live-streaming-23#section-4.3.5.1
        const hasIndependentSegments = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments; // if we have no buffered data then we need to make sure
        // that the next part we append is "independent" if possible.
        // So we check if the previous part is independent, and request
        // it if it is.
        if (!bufferedTime && nextPart && !hasIndependentSegments && !nextPart.independent) {
            if (next.partIndex === 0) {
                const lastSegment = segments[next.mediaIndex - 1];
                const lastSegmentLastPart = lastSegment.parts && lastSegment.parts.length && lastSegment.parts[lastSegment.parts.length - 1];
                if (lastSegmentLastPart && lastSegmentLastPart.independent) {
                    next.mediaIndex -= 1;
                    next.partIndex = lastSegment.parts.length - 1;
                    next.independent = "previous segment";
                }
            } else if (nextSegment.parts[next.partIndex - 1].independent) {
                next.partIndex -= 1;
                next.independent = "previous part";
            }
        }
        const ended = this.mediaSource_ && this.mediaSource_.readyState === "ended"; // do not choose a next segment if all of the following:
        // 1. this is the last segment in the playlist
        // 2. end of stream has been called on the media source already
        // 3. the player is not seeking
        if (next.mediaIndex >= segments.length - 1 && ended && !this.seeking_()) return null;
        return this.generateSegmentInfo_(next);
    }
    generateSegmentInfo_(options) {
        const { independent: independent, playlist: playlist, mediaIndex: mediaIndex, startOfSegment: startOfSegment, isSyncRequest: isSyncRequest, partIndex: partIndex, forceTimestampOffset: forceTimestampOffset, getMediaInfoForTime: getMediaInfoForTime } = options;
        const segment = playlist.segments[mediaIndex];
        const part = typeof partIndex === "number" && segment.parts[partIndex];
        const segmentInfo = {
            requestId: "segment-loader-" + Math.random(),
            // resolve the segment URL relative to the playlist
            uri: part && part.resolvedUri || segment.resolvedUri,
            mediaIndex: // the segment's mediaIndex at the time it was requested
            mediaIndex,
            partIndex: part ? partIndex : null,
            isSyncRequest: // whether or not to update the SegmentLoader's state with this
            // segment's mediaIndex
            isSyncRequest,
            startOfSegment: startOfSegment,
            playlist: // the segment's playlist
            playlist,
            // unencrypted bytes of the segment
            bytes: null,
            // when a key is defined for this segment, the encrypted bytes
            encryptedBytes: null,
            // The target timestampOffset for this segment when we append it
            // to the source buffer
            timestampOffset: null,
            // The timeline that the segment is in
            timeline: segment.timeline,
            // The expected duration of the segment in seconds
            duration: part && part.duration || segment.duration,
            segment: // retain the segment in case the playlist updates while doing an async process
            segment,
            part: part,
            byteLength: 0,
            transmuxer: this.transmuxer_,
            getMediaInfoForTime: // type of getMediaInfoForTime that was used to get this segment
            getMediaInfoForTime,
            independent: independent
        };
        const overrideCheck = typeof forceTimestampOffset !== "undefined" ? forceTimestampOffset : this.isPendingTimestampOffset_;
        segmentInfo.timestampOffset = this.timestampOffsetForSegment_({
            segmentTimeline: segment.timeline,
            currentTimeline: this.currentTimeline_,
            startOfSegment: startOfSegment,
            buffered: this.buffered_(),
            calculateTimestampOffsetForEachSegment: this.calculateTimestampOffsetForEachSegment_,
            overrideCheck: overrideCheck
        });
        const audioBufferedEnd = $cb03b711053a4297$var$lastBufferedEnd(this.sourceUpdater_.audioBuffered());
        if (typeof audioBufferedEnd === "number") // since the transmuxer is using the actual timing values, but the buffer is
        // adjusted by the timestamp offset, we must adjust the value here
        segmentInfo.audioAppendStart = audioBufferedEnd - this.sourceUpdater_.audioTimestampOffset();
        if (this.sourceUpdater_.videoBuffered().length) segmentInfo.gopsToAlignWith = $cb03b711053a4297$var$gopsSafeToAlignWith(this.gopBuffer_, // since the transmuxer is using the actual timing values, but the time is
        // adjusted by the timestmap offset, we must adjust the value here
        this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_);
        return segmentInfo;
    }
    // added so that vtt segment loader can override and prevent
    // adding timestamp offsets.
    timestampOffsetForSegment_(options) {
        return $cb03b711053a4297$var$timestampOffsetForSegment(options);
    }
    /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */ earlyAbortWhenNeeded_(stats) {
        if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
        // TODO: Replace using timeout with a boolean indicating whether this playlist is
        //       the lowestEnabledRendition.
        !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
        !this.playlist_.attributes.BANDWIDTH) return;
         // Wait at least 1 second since the first byte of data has been received before
        // using the calculated bandwidth from the progress event to allow the bitrate
        // to stabilize
        if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1000) return;
        const currentTime = this.currentTime_();
        const measuredBandwidth = stats.bandwidth;
        const segmentDuration = this.pendingSegment_.duration;
        const requestTimeRemaining = $cb03b711053a4297$var$Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived); // Subtract 1 from the timeUntilRebuffer so we still consider an early abort
        // if we are only left with less than 1 second when the request completes.
        // A negative timeUntilRebuffering indicates we are already rebuffering
        const timeUntilRebuffer$1 = $cb03b711053a4297$var$timeUntilRebuffer(this.buffered_(), currentTime, this.vhs_.tech_.playbackRate()) - 1; // Only consider aborting early if the estimated time to finish the download
        // is larger than the estimated time until the player runs out of forward buffer
        if (requestTimeRemaining <= timeUntilRebuffer$1) return;
        const switchCandidate = $cb03b711053a4297$var$minRebufferMaxBandwidthSelector({
            main: this.vhs_.playlists.main,
            currentTime: currentTime,
            bandwidth: measuredBandwidth,
            duration: this.duration_(),
            segmentDuration: segmentDuration,
            timeUntilRebuffer: timeUntilRebuffer$1,
            currentTimeline: this.currentTimeline_,
            syncController: this.syncController_
        });
        if (!switchCandidate) return;
        const rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$1;
        const timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
        let minimumTimeSaving = 0.5; // If we are already rebuffering, increase the amount of variance we add to the
        // potential round trip time of the new request so that we are not too aggressive
        // with switching to a playlist that might save us a fraction of a second.
        if (timeUntilRebuffer$1 <= $cb03b711053a4297$var$TIME_FUDGE_FACTOR) minimumTimeSaving = 1;
        if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) return;
         // set the bandwidth to that of the desired playlist being sure to scale by
        // BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
        // don't trigger a bandwidthupdate as the bandwidth is artifial
        this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * $cb03b711053a4297$var$Config.BANDWIDTH_VARIANCE + 1;
        this.trigger("earlyabort");
    }
    handleAbort_(segmentInfo) {
        this.logger_(`Aborting ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
        this.mediaRequestsAborted += 1;
    }
    /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */ handleProgress_(event, simpleSegment) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        this.trigger("progress");
    }
    handleTrackInfo_(simpleSegment, trackInfo) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        if (this.checkForIllegalMediaSwitch(trackInfo)) return;
        trackInfo = trackInfo || {}; // When we have track info, determine what media types this loader is dealing with.
        // Guard against cases where we're not getting track info at all until we are
        // certain that all streams will provide it.
        if (!$cb03b711053a4297$var$shallowEqual(this.currentMediaInfo_, trackInfo)) {
            this.appendInitSegment_ = {
                audio: true,
                video: true
            };
            this.startingMediaInfo_ = trackInfo;
            this.currentMediaInfo_ = trackInfo;
            this.logger_("trackinfo update", trackInfo);
            this.trigger("trackinfo");
        } // trackinfo may cause an abort if the trackinfo
        // causes a codec change to an unsupported codec.
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // set trackinfo on the pending segment so that
        // it can append.
        this.pendingSegment_.trackInfo = trackInfo; // check if any calls were waiting on the track info
        if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
    }
    handleTimingInfo_(simpleSegment, mediaType, timeType, time) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        const segmentInfo = this.pendingSegment_;
        const timingInfoProperty = $cb03b711053a4297$var$timingInfoPropertyForMedia(mediaType);
        segmentInfo[timingInfoProperty] = segmentInfo[timingInfoProperty] || {};
        segmentInfo[timingInfoProperty][timeType] = time;
        this.logger_(`timinginfo: ${mediaType} - ${timeType} - ${time}`); // check if any calls were waiting on the timing info
        if (this.hasEnoughInfoToAppend_()) this.processCallQueue_();
    }
    handleCaptions_(simpleSegment, captionData) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // This could only happen with fmp4 segments, but
        // should still not happen in general
        if (captionData.length === 0) {
            this.logger_("SegmentLoader received no captions from a caption event");
            return;
        }
        const segmentInfo = this.pendingSegment_; // Wait until we have some video data so that caption timing
        // can be adjusted by the timestamp offset
        if (!segmentInfo.hasAppendedData_) {
            this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, simpleSegment, captionData));
            return;
        }
        const timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
        const captionTracks = {}; // get total start/end and captions for each track/stream
        captionData.forEach((caption)=>{
            // caption.stream is actually a track name...
            // set to the existing values in tracks or default values
            captionTracks[caption.stream] = captionTracks[caption.stream] || {
                // Infinity, as any other value will be less than this
                startTime: Infinity,
                captions: [],
                // 0 as an other value will be more than this
                endTime: 0
            };
            const captionTrack = captionTracks[caption.stream];
            captionTrack.startTime = Math.min(captionTrack.startTime, caption.startTime + timestampOffset);
            captionTrack.endTime = Math.max(captionTrack.endTime, caption.endTime + timestampOffset);
            captionTrack.captions.push(caption);
        });
        Object.keys(captionTracks).forEach((trackName)=>{
            const { startTime: startTime, endTime: endTime, captions: captions } = captionTracks[trackName];
            const inbandTextTracks = this.inbandTextTracks_;
            this.logger_(`adding cues from ${startTime} -> ${endTime} for ${trackName}`);
            $cb03b711053a4297$var$createCaptionsTrackIfNotExists(inbandTextTracks, this.vhs_.tech_, trackName); // clear out any cues that start and end at the same time period for the same track.
            // We do this because a rendition change that also changes the timescale for captions
            // will result in captions being re-parsed for certain segments. If we add them again
            // without clearing we will have two of the same captions visible.
            $cb03b711053a4297$var$removeCuesFromTrack(startTime, endTime, inbandTextTracks[trackName]);
            $cb03b711053a4297$var$addCaptionData({
                captionArray: captions,
                inbandTextTracks: inbandTextTracks,
                timestampOffset: timestampOffset
            });
        }); // Reset stored captions since we added parsed
        // captions to a text track at this point
        if (this.transmuxer_) this.transmuxer_.postMessage({
            action: "clearParsedMp4Captions"
        });
    }
    handleId3_(simpleSegment, id3Frames, dispatchType) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
        const segmentInfo = this.pendingSegment_; // we need to have appended data in order for the timestamp offset to be set
        if (!segmentInfo.hasAppendedData_) {
            this.metadataQueue_.id3.push(this.handleId3_.bind(this, simpleSegment, id3Frames, dispatchType));
            return;
        }
        this.addMetadataToTextTrack(dispatchType, id3Frames, this.duration_());
    }
    processMetadataQueue_() {
        this.metadataQueue_.id3.forEach((fn)=>fn());
        this.metadataQueue_.caption.forEach((fn)=>fn());
        this.metadataQueue_.id3 = [];
        this.metadataQueue_.caption = [];
    }
    processCallQueue_() {
        const callQueue = this.callQueue_; // Clear out the queue before the queued functions are run, since some of the
        // functions may check the length of the load queue and default to pushing themselves
        // back onto the queue.
        this.callQueue_ = [];
        callQueue.forEach((fun)=>fun());
    }
    processLoadQueue_() {
        const loadQueue = this.loadQueue_; // Clear out the queue before the queued functions are run, since some of the
        // functions may check the length of the load queue and default to pushing themselves
        // back onto the queue.
        this.loadQueue_ = [];
        loadQueue.forEach((fun)=>fun());
    }
    /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */ hasEnoughInfoToLoad_() {
        // Since primary timing goes by video, only the audio loader potentially needs to wait
        // to load.
        if (this.loaderType_ !== "audio") return true;
        const segmentInfo = this.pendingSegment_; // A fill buffer must have already run to establish a pending segment before there's
        // enough info to load.
        if (!segmentInfo) return false;
         // The first segment can and should be loaded immediately so that source buffers are
        // created together (before appending). Source buffer creation uses the presence of
        // audio and video data to determine whether to create audio/video source buffers, and
        // uses processed (transmuxed or parsed) media to determine the types required.
        if (!this.getCurrentMediaInfo_()) return true;
        if (// Technically, instead of waiting to load a segment on timeline changes, a segment
        // can be requested and downloaded and only wait before it is transmuxed or parsed.
        // But in practice, there are a few reasons why it is better to wait until a loader
        // is ready to append that segment before requesting and downloading:
        //
        // 1. Because audio and main loaders cross discontinuities together, if this loader
        //    is waiting for the other to catch up, then instead of requesting another
        //    segment and using up more bandwidth, by not yet loading, more bandwidth is
        //    allotted to the loader currently behind.
        // 2. media-segment-request doesn't have to have logic to consider whether a segment
        // is ready to be processed or not, isolating the queueing behavior to the loader.
        // 3. The audio loader bases some of its segment properties on timing information
        //    provided by the main loader, meaning that, if the logic for waiting on
        //    processing was in media-segment-request, then it would also need to know how
        //    to re-generate the segment information after the main loader caught up.
        $cb03b711053a4297$var$shouldWaitForTimelineChange({
            timelineChangeController: this.timelineChangeController_,
            currentTimeline: this.currentTimeline_,
            segmentTimeline: segmentInfo.timeline,
            loaderType: this.loaderType_,
            audioDisabled: this.audioDisabled_
        })) return false;
        return true;
    }
    getCurrentMediaInfo_(segmentInfo = this.pendingSegment_) {
        return segmentInfo && segmentInfo.trackInfo || this.currentMediaInfo_;
    }
    getMediaInfo_(segmentInfo = this.pendingSegment_) {
        return this.getCurrentMediaInfo_(segmentInfo) || this.startingMediaInfo_;
    }
    getPendingSegmentPlaylist() {
        return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
    }
    hasEnoughInfoToAppend_() {
        if (!this.sourceUpdater_.ready()) return false;
         // If content needs to be removed or the loader is waiting on an append reattempt,
        // then no additional content should be appended until the prior append is resolved.
        if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) return false;
        const segmentInfo = this.pendingSegment_;
        const trackInfo = this.getCurrentMediaInfo_(); // no segment to append any data for or
        // we do not have information on this specific
        // segment yet
        if (!segmentInfo || !trackInfo) return false;
        const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
        if (hasVideo && !segmentInfo.videoTimingInfo) return false;
         // muxed content only relies on video timing information for now.
        if (hasAudio && !this.audioDisabled_ && !isMuxed && !segmentInfo.audioTimingInfo) return false;
        if ($cb03b711053a4297$var$shouldWaitForTimelineChange({
            timelineChangeController: this.timelineChangeController_,
            currentTimeline: this.currentTimeline_,
            segmentTimeline: segmentInfo.timeline,
            loaderType: this.loaderType_,
            audioDisabled: this.audioDisabled_
        })) return false;
        return true;
    }
    handleData_(simpleSegment, result) {
        this.earlyAbortWhenNeeded_(simpleSegment.stats);
        if (this.checkForAbort_(simpleSegment.requestId)) return;
         // If there's anything in the call queue, then this data came later and should be
        // executed after the calls currently queued.
        if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
            this.callQueue_.push(this.handleData_.bind(this, simpleSegment, result));
            return;
        }
        const segmentInfo = this.pendingSegment_; // update the time mapping so we can translate from display time to media time
        this.setTimeMapping_(segmentInfo.timeline); // for tracking overall stats
        this.updateMediaSecondsLoaded_(segmentInfo.part || segmentInfo.segment); // Note that the state isn't changed from loading to appending. This is because abort
        // logic may change behavior depending on the state, and changing state too early may
        // inflate our estimates of bandwidth. In the future this should be re-examined to
        // note more granular states.
        // don't process and append data if the mediaSource is closed
        if (this.mediaSource_.readyState === "closed") return;
         // if this request included an initialization segment, save that data
        // to the initSegment cache
        if (simpleSegment.map) {
            simpleSegment.map = this.initSegmentForMap(simpleSegment.map, true); // move over init segment properties to media request
            segmentInfo.segment.map = simpleSegment.map;
        } // if this request included a segment key, save that data in the cache
        if (simpleSegment.key) this.segmentKey(simpleSegment.key, true);
        segmentInfo.isFmp4 = simpleSegment.isFmp4;
        segmentInfo.timingInfo = segmentInfo.timingInfo || {};
        if (segmentInfo.isFmp4) {
            this.trigger("fmp4");
            segmentInfo.timingInfo.start = segmentInfo[$cb03b711053a4297$var$timingInfoPropertyForMedia(result.type)].start;
        } else {
            const trackInfo = this.getCurrentMediaInfo_();
            const useVideoTimingInfo = this.loaderType_ === "main" && trackInfo && trackInfo.hasVideo;
            let firstVideoFrameTimeForData;
            if (useVideoTimingInfo) firstVideoFrameTimeForData = segmentInfo.videoTimingInfo.start;
             // Segment loader knows more about segment timing than the transmuxer (in certain
            // aspects), so make any changes required for a more accurate start time.
            // Don't set the end time yet, as the segment may not be finished processing.
            segmentInfo.timingInfo.start = this.trueSegmentStart_({
                currentStart: segmentInfo.timingInfo.start,
                playlist: segmentInfo.playlist,
                mediaIndex: segmentInfo.mediaIndex,
                currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
                useVideoTimingInfo: useVideoTimingInfo,
                firstVideoFrameTimeForData: firstVideoFrameTimeForData,
                videoTimingInfo: segmentInfo.videoTimingInfo,
                audioTimingInfo: segmentInfo.audioTimingInfo
            });
        } // Init segments for audio and video only need to be appended in certain cases. Now
        // that data is about to be appended, we can check the final cases to determine
        // whether we should append an init segment.
        this.updateAppendInitSegmentStatus(segmentInfo, result.type); // Timestamp offset should be updated once we get new data and have its timing info,
        // as we use the start of the segment to offset the best guess (playlist provided)
        // timestamp offset.
        this.updateSourceBufferTimestampOffset_(segmentInfo); // if this is a sync request we need to determine whether it should
        // be appended or not.
        if (segmentInfo.isSyncRequest) {
            // first save/update our timing info for this segment.
            // this is what allows us to choose an accurate segment
            // and the main reason we make a sync request.
            this.updateTimingInfoEnd_(segmentInfo);
            this.syncController_.saveSegmentTimingInfo({
                segmentInfo: segmentInfo,
                shouldSaveTimelineMapping: this.loaderType_ === "main"
            });
            const next = this.chooseNextRequest_(); // If the sync request isn't the segment that would be requested next
            // after taking into account its timing info, do not append it.
            if (next.mediaIndex !== segmentInfo.mediaIndex || next.partIndex !== segmentInfo.partIndex) {
                this.logger_("sync segment was incorrect, not appending");
                return;
            } // otherwise append it like any other segment as our guess was correct.
            this.logger_("sync segment was correct, appending");
        } // Save some state so that in the future anything waiting on first append (and/or
        // timestamp offset(s)) can process immediately. While the extra state isn't optimal,
        // we need some notion of whether the timestamp offset or other relevant information
        // has had a chance to be set.
        segmentInfo.hasAppendedData_ = true; // Now that the timestamp offset should be set, we can append any waiting ID3 tags.
        this.processMetadataQueue_();
        this.appendData_(segmentInfo, result);
    }
    updateAppendInitSegmentStatus(segmentInfo, type) {
        // alt audio doesn't manage timestamp offset
        if (this.loaderType_ === "main" && typeof segmentInfo.timestampOffset === "number" && // in the case that we're handling partial data, we don't want to append an init
        // segment for each chunk
        !segmentInfo.changedTimestampOffset) // if the timestamp offset changed, the timeline may have changed, so we have to re-
        // append init segments
        this.appendInitSegment_ = {
            audio: true,
            video: true
        };
        if (this.playlistOfLastInitSegment_[type] !== segmentInfo.playlist) // make sure we append init segment on playlist changes, in case the media config
        // changed
        this.appendInitSegment_[type] = true;
    }
    getInitSegmentAndUpdateState_({ type: type, initSegment: initSegment, map: map, playlist: playlist }) {
        // "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
        // (Section 3) required to parse the applicable Media Segments.  It applies to every
        // Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
        // or until the end of the playlist."
        // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
        if (map) {
            const id = $cb03b711053a4297$var$initSegmentId(map);
            if (this.activeInitSegmentId_ === id) // don't need to re-append the init segment if the ID matches
            return null;
             // a map-specified init segment takes priority over any transmuxed (or otherwise
            // obtained) init segment
            //
            // this also caches the init segment for later use
            initSegment = this.initSegmentForMap(map, true).bytes;
            this.activeInitSegmentId_ = id;
        } // We used to always prepend init segments for video, however, that shouldn't be
        // necessary. Instead, we should only append on changes, similar to what we've always
        // done for audio. This is more important (though may not be that important) for
        // frame-by-frame appending for LHLS, simply because of the increased quantity of
        // appends.
        if (initSegment && this.appendInitSegment_[type]) {
            // Make sure we track the playlist that we last used for the init segment, so that
            // we can re-append the init segment in the event that we get data from a new
            // playlist. Discontinuities and track changes are handled in other sections.
            this.playlistOfLastInitSegment_[type] = playlist; // Disable future init segment appends for this type. Until a change is necessary.
            this.appendInitSegment_[type] = false; // we need to clear out the fmp4 active init segment id, since
            // we are appending the muxer init segment
            this.activeInitSegmentId_ = null;
            return initSegment;
        }
        return null;
    }
    handleQuotaExceededError_({ segmentInfo: segmentInfo, type: type, bytes: bytes }, error) {
        const audioBuffered = this.sourceUpdater_.audioBuffered();
        const videoBuffered = this.sourceUpdater_.videoBuffered(); // For now we're ignoring any notion of gaps in the buffer, but they, in theory,
        // should be cleared out during the buffer removals. However, log in case it helps
        // debug.
        if (audioBuffered.length > 1) this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + $cb03b711053a4297$var$timeRangesToArray(audioBuffered).join(", "));
        if (videoBuffered.length > 1) this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + $cb03b711053a4297$var$timeRangesToArray(videoBuffered).join(", "));
        const audioBufferStart = audioBuffered.length ? audioBuffered.start(0) : 0;
        const audioBufferEnd = audioBuffered.length ? audioBuffered.end(audioBuffered.length - 1) : 0;
        const videoBufferStart = videoBuffered.length ? videoBuffered.start(0) : 0;
        const videoBufferEnd = videoBuffered.length ? videoBuffered.end(videoBuffered.length - 1) : 0;
        if (audioBufferEnd - audioBufferStart <= $cb03b711053a4297$var$MIN_BACK_BUFFER && videoBufferEnd - videoBufferStart <= $cb03b711053a4297$var$MIN_BACK_BUFFER) {
            // Can't remove enough buffer to make room for new segment (or the browser doesn't
            // allow for appends of segments this size). In the future, it may be possible to
            // split up the segment and append in pieces, but for now, error out this playlist
            // in an attempt to switch to a more manageable rendition.
            this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. " + `Appended byte length: ${bytes.byteLength}, ` + `audio buffer: ${$cb03b711053a4297$var$timeRangesToArray(audioBuffered).join(", ")}, ` + `video buffer: ${$cb03b711053a4297$var$timeRangesToArray(videoBuffered).join(", ")}, `);
            this.error({
                message: "Quota exceeded error with append of a single segment of content",
                excludeUntil: Infinity
            });
            this.trigger("error");
            return;
        } // To try to resolve the quota exceeded error, clear back buffer and retry. This means
        // that the segment-loader should block on future events until this one is handled, so
        // that it doesn't keep moving onto further segments. Adding the call to the call
        // queue will prevent further appends until waitingOnRemove_ and
        // quotaExceededErrorRetryTimeout_ are cleared.
        //
        // Note that this will only block the current loader. In the case of demuxed content,
        // the other load may keep filling as fast as possible. In practice, this should be
        // OK, as it is a rare case when either audio has a high enough bitrate to fill up a
        // source buffer, or video fills without enough room for audio to append (and without
        // the availability of clearing out seconds of back buffer to make room for audio).
        // But it might still be good to handle this case in the future as a TODO.
        this.waitingOnRemove_ = true;
        this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }));
        const currentTime = this.currentTime_(); // Try to remove as much audio and video as possible to make room for new content
        // before retrying.
        const timeToRemoveUntil = currentTime - $cb03b711053a4297$var$MIN_BACK_BUFFER;
        this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${timeToRemoveUntil}`);
        this.remove(0, timeToRemoveUntil, ()=>{
            this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${$cb03b711053a4297$var$MIN_BACK_BUFFER}s`);
            this.waitingOnRemove_ = false; // wait the length of time alotted in the back buffer to prevent wasted
            // attempts (since we can't clear less than the minimum)
            this.quotaExceededErrorRetryTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
                this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue");
                this.quotaExceededErrorRetryTimeout_ = null;
                this.processCallQueue_();
            }, $cb03b711053a4297$var$MIN_BACK_BUFFER * 1000);
        }, true);
    }
    handleAppendError_({ segmentInfo: segmentInfo, type: type, bytes: bytes }, error) {
        // if there's no error, nothing to do
        if (!error) return;
        if (error.code === $cb03b711053a4297$var$QUOTA_EXCEEDED_ERR) {
            this.handleQuotaExceededError_({
                segmentInfo: segmentInfo,
                type: type,
                bytes: bytes
            }); // A quota exceeded error should be recoverable with a future re-append, so no need
            // to trigger an append error.
            return;
        }
        this.logger_("Received non QUOTA_EXCEEDED_ERR on append", error);
        this.error(`${type} append of ${bytes.length}b failed for segment ` + `#${segmentInfo.mediaIndex} in playlist ${segmentInfo.playlist.id}`); // If an append errors, we often can't recover.
        // (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
        //
        // Trigger a special error so that it can be handled separately from normal,
        // recoverable errors.
        this.trigger("appenderror");
    }
    appendToSourceBuffer_({ segmentInfo: segmentInfo, type: type, initSegment: initSegment, data: data, bytes: bytes }) {
        // If this is a re-append, bytes were already created and don't need to be recreated
        if (!bytes) {
            const segments = [
                data
            ];
            let byteLength = data.byteLength;
            if (initSegment) {
                // if the media initialization segment is changing, append it before the content
                // segment
                segments.unshift(initSegment);
                byteLength += initSegment.byteLength;
            } // Technically we should be OK appending the init segment separately, however, we
            // haven't yet tested that, and prepending is how we have always done things.
            bytes = $cb03b711053a4297$var$concatSegments({
                bytes: byteLength,
                segments: segments
            });
        }
        this.sourceUpdater_.appendBuffer({
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }, this.handleAppendError_.bind(this, {
            segmentInfo: segmentInfo,
            type: type,
            bytes: bytes
        }));
    }
    handleSegmentTimingInfo_(type, requestId, segmentTimingInfo) {
        if (!this.pendingSegment_ || requestId !== this.pendingSegment_.requestId) return;
        const segment = this.pendingSegment_.segment;
        const timingInfoProperty = `${type}TimingInfo`;
        if (!segment[timingInfoProperty]) segment[timingInfoProperty] = {};
        segment[timingInfoProperty].transmuxerPrependedSeconds = segmentTimingInfo.prependedContentDuration || 0;
        segment[timingInfoProperty].transmuxedPresentationStart = segmentTimingInfo.start.presentation;
        segment[timingInfoProperty].transmuxedDecodeStart = segmentTimingInfo.start.decode;
        segment[timingInfoProperty].transmuxedPresentationEnd = segmentTimingInfo.end.presentation;
        segment[timingInfoProperty].transmuxedDecodeEnd = segmentTimingInfo.end.decode; // mainly used as a reference for debugging
        segment[timingInfoProperty].baseMediaDecodeTime = segmentTimingInfo.baseMediaDecodeTime;
    }
    appendData_(segmentInfo, result) {
        const { type: type, data: data } = result;
        if (!data || !data.byteLength) return;
        if (type === "audio" && this.audioDisabled_) return;
        const initSegment = this.getInitSegmentAndUpdateState_({
            type: type,
            initSegment: result.initSegment,
            playlist: segmentInfo.playlist,
            map: segmentInfo.isFmp4 ? segmentInfo.segment.map : null
        });
        this.appendToSourceBuffer_({
            segmentInfo: segmentInfo,
            type: type,
            initSegment: initSegment,
            data: data
        });
    }
    /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */ loadSegment_(segmentInfo) {
        this.state = "WAITING";
        this.pendingSegment_ = segmentInfo;
        this.trimBackBuffer_(segmentInfo);
        if (typeof segmentInfo.timestampOffset === "number") {
            if (this.transmuxer_) this.transmuxer_.postMessage({
                action: "clearAllMp4Captions"
            });
        }
        if (!this.hasEnoughInfoToLoad_()) {
            this.loadQueue_.push(()=>{
                // regenerate the audioAppendStart, timestampOffset, etc as they
                // may have changed since this function was added to the queue.
                const options = (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, segmentInfo, {
                    forceTimestampOffset: true
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))(segmentInfo, this.generateSegmentInfo_(options));
                this.isPendingTimestampOffset_ = false;
                this.updateTransmuxerAndRequestSegment_(segmentInfo);
            });
            return;
        }
        this.updateTransmuxerAndRequestSegment_(segmentInfo);
    }
    updateTransmuxerAndRequestSegment_(segmentInfo) {
        // We'll update the source buffer's timestamp offset once we have transmuxed data, but
        // the transmuxer still needs to be updated before then.
        //
        // Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
        // offset must be passed to the transmuxer for stream correcting adjustments.
        if (this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)) {
            this.gopBuffer_.length = 0; // gopsToAlignWith was set before the GOP buffer was cleared
            segmentInfo.gopsToAlignWith = [];
            this.timeMapping_ = 0; // reset values in the transmuxer since a discontinuity should start fresh
            this.transmuxer_.postMessage({
                action: "reset"
            });
            this.transmuxer_.postMessage({
                action: "setTimestampOffset",
                timestampOffset: segmentInfo.timestampOffset
            });
        }
        const simpleSegment = this.createSimplifiedSegmentObj_(segmentInfo);
        const isEndOfStream = this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex);
        const isWalkingForward = this.mediaIndex !== null;
        const isDiscontinuity = segmentInfo.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
        // the first timeline
        segmentInfo.timeline > 0;
        const isEndOfTimeline = isEndOfStream || isWalkingForward && isDiscontinuity;
        this.logger_(`Requesting ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`); // If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
        // then this init segment has never been seen before and should be appended.
        //
        // At this point the content type (audio/video or both) is not yet known, but it should be safe to set
        // both to true and leave the decision of whether to append the init segment to append time.
        if (simpleSegment.map && !simpleSegment.map.bytes) {
            this.logger_("going to request init segment.");
            this.appendInitSegment_ = {
                video: true,
                audio: true
            };
        }
        segmentInfo.abortRequests = $cb03b711053a4297$var$mediaSegmentRequest({
            xhr: this.vhs_.xhr,
            xhrOptions: this.xhrOptions_,
            decryptionWorker: this.decrypter_,
            segment: simpleSegment,
            abortFn: this.handleAbort_.bind(this, segmentInfo),
            progressFn: this.handleProgress_.bind(this),
            trackInfoFn: this.handleTrackInfo_.bind(this),
            timingInfoFn: this.handleTimingInfo_.bind(this),
            videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", segmentInfo.requestId),
            audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", segmentInfo.requestId),
            captionsFn: this.handleCaptions_.bind(this),
            isEndOfTimeline: isEndOfTimeline,
            endedTimelineFn: ()=>{
                this.logger_("received endedtimeline callback");
            },
            id3Fn: this.handleId3_.bind(this),
            dataFn: this.handleData_.bind(this),
            doneFn: this.segmentRequestFinished_.bind(this),
            onTransmuxerLog: ({ message: message, level: level, stream: stream })=>{
                this.logger_(`${$cb03b711053a4297$var$segmentInfoString(segmentInfo)} logged from transmuxer stream ${stream} as a ${level}: ${message}`);
            }
        });
    }
    /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */ trimBackBuffer_(segmentInfo) {
        const removeToTime = $cb03b711053a4297$var$safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10); // Chrome has a hard limit of 150MB of
        // buffer and a very conservative "garbage collector"
        // We manually clear out the old buffer to ensure
        // we don't trigger the QuotaExceeded error
        // on the source buffer during subsequent appends
        if (removeToTime > 0) this.remove(0, removeToTime);
    }
    /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */ createSimplifiedSegmentObj_(segmentInfo) {
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        const simpleSegment = {
            resolvedUri: part ? part.resolvedUri : segment.resolvedUri,
            byterange: part ? part.byterange : segment.byterange,
            requestId: segmentInfo.requestId,
            transmuxer: segmentInfo.transmuxer,
            audioAppendStart: segmentInfo.audioAppendStart,
            gopsToAlignWith: segmentInfo.gopsToAlignWith,
            part: segmentInfo.part
        };
        const previousSegment = segmentInfo.playlist.segments[segmentInfo.mediaIndex - 1];
        if (previousSegment && previousSegment.timeline === segment.timeline) {
            // The baseStartTime of a segment is used to handle rollover when probing the TS
            // segment to retrieve timing information. Since the probe only looks at the media's
            // times (e.g., PTS and DTS values of the segment), and doesn't consider the
            // player's time (e.g., player.currentTime()), baseStartTime should reflect the
            // media time as well. transmuxedDecodeEnd represents the end time of a segment, in
            // seconds of media time, so should be used here. The previous segment is used since
            // the end of the previous segment should represent the beginning of the current
            // segment, so long as they are on the same timeline.
            if (previousSegment.videoTimingInfo) simpleSegment.baseStartTime = previousSegment.videoTimingInfo.transmuxedDecodeEnd;
            else if (previousSegment.audioTimingInfo) simpleSegment.baseStartTime = previousSegment.audioTimingInfo.transmuxedDecodeEnd;
        }
        if (segment.key) {
            // if the media sequence is greater than 2^32, the IV will be incorrect
            // assuming 10s segments, that would be about 1300 years
            const iv = segment.key.iv || new Uint32Array([
                0,
                0,
                0,
                segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence
            ]);
            simpleSegment.key = this.segmentKey(segment.key);
            simpleSegment.key.iv = iv;
        }
        if (segment.map) simpleSegment.map = this.initSegmentForMap(segment.map);
        return simpleSegment;
    }
    saveTransferStats_(stats) {
        // every request counts as a media request even if it has been aborted
        // or canceled due to a timeout
        this.mediaRequests += 1;
        if (stats) {
            this.mediaBytesTransferred += stats.bytesReceived;
            this.mediaTransferDuration += stats.roundTripTime;
        }
    }
    saveBandwidthRelatedStats_(duration, stats) {
        // byteLength will be used for throughput, and should be based on bytes receieved,
        // which we only know at the end of the request and should reflect total bytes
        // downloaded rather than just bytes processed from components of the segment
        this.pendingSegment_.byteLength = stats.bytesReceived;
        if (duration < $cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
            this.logger_(`Ignoring segment's bandwidth because its duration of ${duration}` + ` is less than the min to record ${$cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS}`);
            return;
        }
        this.bandwidth = stats.bandwidth;
        this.roundTrip = stats.roundTripTime;
    }
    handleTimeout_() {
        // although the VTT segment loader bandwidth isn't really used, it's good to
        // maintain functinality between segment loaders
        this.mediaRequestsTimedout += 1;
        this.bandwidth = 1;
        this.roundTrip = NaN;
        this.trigger("bandwidthupdate");
        this.trigger("timeout");
    }
    /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */ segmentRequestFinished_(error, simpleSegment, result) {
        // TODO handle special cases, e.g., muxed audio/video but only audio in the segment
        // check the call queue directly since this function doesn't need to deal with any
        // data, and can continue even if the source buffers are not set up and we didn't get
        // any data from the segment
        if (this.callQueue_.length) {
            this.callQueue_.push(this.segmentRequestFinished_.bind(this, error, simpleSegment, result));
            return;
        }
        this.saveTransferStats_(simpleSegment.stats); // The request was aborted and the SegmentLoader has already been reset
        if (!this.pendingSegment_) return;
         // the request was aborted and the SegmentLoader has already started
        // another request. this can happen when the timeout for an aborted
        // request triggers due to a limitation in the XHR library
        // do not count this as any sort of request or we risk double-counting
        if (simpleSegment.requestId !== this.pendingSegment_.requestId) return;
         // an error occurred from the active pendingSegment_ so reset everything
        if (error) {
            this.pendingSegment_ = null;
            this.state = "READY"; // aborts are not a true error condition and nothing corrective needs to be done
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.ABORTED) return;
            this.pause(); // the error is really just that at least one of the requests timed-out
            // set the bandwidth to a very low value and trigger an ABR switch to
            // take emergency action
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.TIMEOUT) {
                this.handleTimeout_();
                return;
            } // if control-flow has arrived here, then the error is real
            // emit an error event to exclude the current playlist
            this.mediaRequestsErrored += 1;
            this.error(error);
            this.trigger("error");
            return;
        }
        const segmentInfo = this.pendingSegment_; // the response was a success so set any bandwidth stats the request
        // generated for ABR purposes
        this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
        segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
        if (result.gopInfo) this.gopBuffer_ = $cb03b711053a4297$var$updateGopBuffer(this.gopBuffer_, result.gopInfo, this.safeAppend_);
         // Although we may have already started appending on progress, we shouldn't switch the
        // state away from loading until we are officially done loading the segment data.
        this.state = "APPENDING"; // used for testing
        this.trigger("appending");
        this.waitForAppendsToComplete_(segmentInfo);
    }
    setTimeMapping_(timeline) {
        const timelineMapping = this.syncController_.mappingForTimeline(timeline);
        if (timelineMapping !== null) this.timeMapping_ = timelineMapping;
    }
    updateMediaSecondsLoaded_(segment) {
        if (typeof segment.start === "number" && typeof segment.end === "number") this.mediaSecondsLoaded += segment.end - segment.start;
        else this.mediaSecondsLoaded += segment.duration;
    }
    shouldUpdateTransmuxerTimestampOffset_(timestampOffset) {
        if (timestampOffset === null) return false;
         // note that we're potentially using the same timestamp offset for both video and
        // audio
        if (this.loaderType_ === "main" && timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) return true;
        if (!this.audioDisabled_ && timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) return true;
        return false;
    }
    trueSegmentStart_({ currentStart: currentStart, playlist: playlist, mediaIndex: mediaIndex, firstVideoFrameTimeForData: firstVideoFrameTimeForData, currentVideoTimestampOffset: currentVideoTimestampOffset, useVideoTimingInfo: useVideoTimingInfo, videoTimingInfo: videoTimingInfo, audioTimingInfo: audioTimingInfo }) {
        if (typeof currentStart !== "undefined") // if start was set once, keep using it
        return currentStart;
        if (!useVideoTimingInfo) return audioTimingInfo.start;
        const previousSegment = playlist.segments[mediaIndex - 1]; // The start of a segment should be the start of the first full frame contained
        // within that segment. Since the transmuxer maintains a cache of incomplete data
        // from and/or the last frame seen, the start time may reflect a frame that starts
        // in the previous segment. Check for that case and ensure the start time is
        // accurate for the segment.
        if (mediaIndex === 0 || !previousSegment || typeof previousSegment.start === "undefined" || previousSegment.end !== firstVideoFrameTimeForData + currentVideoTimestampOffset) return firstVideoFrameTimeForData;
        return videoTimingInfo.start;
    }
    waitForAppendsToComplete_(segmentInfo) {
        const trackInfo = this.getCurrentMediaInfo_(segmentInfo);
        if (!trackInfo) {
            this.error({
                message: "No starting media returned, likely due to an unsupported media format.",
                playlistExclusionDuration: Infinity
            });
            this.trigger("error");
            return;
        } // Although transmuxing is done, appends may not yet be finished. Throw a marker
        // on each queue this loader is responsible for to ensure that the appends are
        // complete.
        const { hasAudio: hasAudio, hasVideo: hasVideo, isMuxed: isMuxed } = trackInfo;
        const waitForVideo = this.loaderType_ === "main" && hasVideo;
        const waitForAudio = !this.audioDisabled_ && hasAudio && !isMuxed;
        segmentInfo.waitingOnAppends = 0; // segments with no data
        if (!segmentInfo.hasAppendedData_) {
            if (!segmentInfo.timingInfo && typeof segmentInfo.timestampOffset === "number") // When there's no audio or video data in the segment, there's no audio or video
            // timing information.
            //
            // If there's no audio or video timing information, then the timestamp offset
            // can't be adjusted to the appropriate value for the transmuxer and source
            // buffers.
            //
            // Therefore, the next segment should be used to set the timestamp offset.
            this.isPendingTimestampOffset_ = true;
             // override settings for metadata only segments
            segmentInfo.timingInfo = {
                start: 0
            };
            segmentInfo.waitingOnAppends++;
            if (!this.isPendingTimestampOffset_) {
                // update the timestampoffset
                this.updateSourceBufferTimestampOffset_(segmentInfo); // make sure the metadata queue is processed even though we have
                // no video/audio data.
                this.processMetadataQueue_();
            } // append is "done" instantly with no data.
            this.checkAppendsDone_(segmentInfo);
            return;
        } // Since source updater could call back synchronously, do the increments first.
        if (waitForVideo) segmentInfo.waitingOnAppends++;
        if (waitForAudio) segmentInfo.waitingOnAppends++;
        if (waitForVideo) this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
        if (waitForAudio) this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
    }
    checkAppendsDone_(segmentInfo) {
        if (this.checkForAbort_(segmentInfo.requestId)) return;
        segmentInfo.waitingOnAppends--;
        if (segmentInfo.waitingOnAppends === 0) this.handleAppendsDone_();
    }
    checkForIllegalMediaSwitch(trackInfo) {
        const illegalMediaSwitchError = $cb03b711053a4297$var$illegalMediaSwitch(this.loaderType_, this.getCurrentMediaInfo_(), trackInfo);
        if (illegalMediaSwitchError) {
            this.error({
                message: illegalMediaSwitchError,
                playlistExclusionDuration: Infinity
            });
            this.trigger("error");
            return true;
        }
        return false;
    }
    updateSourceBufferTimestampOffset_(segmentInfo) {
        if (segmentInfo.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
        // priority, timing-wise, so we must wait
        typeof segmentInfo.timingInfo.start !== "number" || // already updated the timestamp offset for this segment
        segmentInfo.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
        this.loaderType_ !== "main") return;
        let didChange = false; // Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
        // the timing info here comes from video. In the event that the audio is longer than
        // the video, this will trim the start of the audio.
        // This also trims any offset from 0 at the beginning of the media
        segmentInfo.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
            videoTimingInfo: segmentInfo.segment.videoTimingInfo,
            audioTimingInfo: segmentInfo.segment.audioTimingInfo,
            timingInfo: segmentInfo.timingInfo
        }); // In the event that there are part segment downloads, each will try to update the
        // timestamp offset. Retaining this bit of state prevents us from updating in the
        // future (within the same segment), however, there may be a better way to handle it.
        segmentInfo.changedTimestampOffset = true;
        if (segmentInfo.timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
            this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);
            didChange = true;
        }
        if (segmentInfo.timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
            this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);
            didChange = true;
        }
        if (didChange) this.trigger("timestampoffset");
    }
    getSegmentStartTimeForTimestampOffsetCalculation_({ videoTimingInfo: videoTimingInfo, audioTimingInfo: audioTimingInfo, timingInfo: timingInfo }) {
        if (!this.useDtsForTimestampOffset_) return timingInfo.start;
        if (videoTimingInfo && typeof videoTimingInfo.transmuxedDecodeStart === "number") return videoTimingInfo.transmuxedDecodeStart;
         // handle audio only
        if (audioTimingInfo && typeof audioTimingInfo.transmuxedDecodeStart === "number") return audioTimingInfo.transmuxedDecodeStart;
         // handle content not transmuxed (e.g., MP4)
        return timingInfo.start;
    }
    updateTimingInfoEnd_(segmentInfo) {
        segmentInfo.timingInfo = segmentInfo.timingInfo || {};
        const trackInfo = this.getMediaInfo_();
        const useVideoTimingInfo = this.loaderType_ === "main" && trackInfo && trackInfo.hasVideo;
        const prioritizedTimingInfo = useVideoTimingInfo && segmentInfo.videoTimingInfo ? segmentInfo.videoTimingInfo : segmentInfo.audioTimingInfo;
        if (!prioritizedTimingInfo) return;
        segmentInfo.timingInfo.end = typeof prioritizedTimingInfo.end === "number" ? // End time may not exist in a case where we aren't parsing the full segment (one
        // current example is the case of fmp4), so use the rough duration to calculate an
        // end time.
        prioritizedTimingInfo.end : prioritizedTimingInfo.start + segmentInfo.duration;
    }
    /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */ handleAppendsDone_() {
        // appendsdone can cause an abort
        if (this.pendingSegment_) this.trigger("appendsdone");
        if (!this.pendingSegment_) {
            this.state = "READY"; // TODO should this move into this.checkForAbort to speed up requests post abort in
            // all appending cases?
            if (!this.paused()) this.monitorBuffer_();
            return;
        }
        const segmentInfo = this.pendingSegment_; // Now that the end of the segment has been reached, we can set the end time. It's
        // best to wait until all appends are done so we're sure that the primary media is
        // finished (and we have its end time).
        this.updateTimingInfoEnd_(segmentInfo);
        if (this.shouldSaveSegmentTimingInfo_) // Timeline mappings should only be saved for the main loader. This is for multiple
        // reasons:
        //
        // 1) Only one mapping is saved per timeline, meaning that if both the audio loader
        //    and the main loader try to save the timeline mapping, whichever comes later
        //    will overwrite the first. In theory this is OK, as the mappings should be the
        //    same, however, it breaks for (2)
        // 2) In the event of a live stream, the initial live point will make for a somewhat
        //    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
        //    the mapping will be off for one of the streams, dependent on which one was
        //    first saved (see (1)).
        // 3) Primary timing goes by video in VHS, so the mapping should be video.
        //
        // Since the audio loader will wait for the main loader to load the first segment,
        // the main loader will save the first timeline mapping, and ensure that there won't
        // be a case where audio loads two segments without saving a mapping (thus leading
        // to missing segment timing info).
        this.syncController_.saveSegmentTimingInfo({
            segmentInfo: segmentInfo,
            shouldSaveTimelineMapping: this.loaderType_ === "main"
        });
        const segmentDurationMessage = $cb03b711053a4297$var$getTroublesomeSegmentDurationMessage(segmentInfo, this.sourceType_);
        if (segmentDurationMessage) {
            if (segmentDurationMessage.severity === "warn") $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(segmentDurationMessage.message);
            else this.logger_(segmentDurationMessage.message);
        }
        this.recordThroughput_(segmentInfo);
        this.pendingSegment_ = null;
        this.state = "READY";
        if (segmentInfo.isSyncRequest) {
            this.trigger("syncinfoupdate"); // if the sync request was not appended
            // then it was not the correct segment.
            // throw it away and use the data it gave us
            // to get the correct one.
            if (!segmentInfo.hasAppendedData_) {
                this.logger_(`Throwing away un-appended sync request ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
                return;
            }
        }
        this.logger_(`Appended ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
        this.addSegmentMetadataCue_(segmentInfo);
        if (this.currentTime_() >= this.replaceSegmentsUntil_) {
            this.replaceSegmentsUntil_ = -1;
            this.fetchAtBuffer_ = true;
        }
        if (this.currentTimeline_ !== segmentInfo.timeline) {
            this.timelineChangeController_.lastTimelineChange({
                type: this.loaderType_,
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            }); // If audio is not disabled, the main segment loader is responsible for updating
            // the audio timeline as well. If the content is video only, this won't have any
            // impact.
            if (this.loaderType_ === "main" && !this.audioDisabled_) this.timelineChangeController_.lastTimelineChange({
                type: "audio",
                from: this.currentTimeline_,
                to: segmentInfo.timeline
            });
        }
        this.currentTimeline_ = segmentInfo.timeline; // We must update the syncinfo to recalculate the seekable range before
        // the following conditional otherwise it may consider this a bad "guess"
        // and attempt to resync when the post-update seekable window and live
        // point would mean that this was the perfect segment to fetch
        this.trigger("syncinfoupdate");
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        const badSegmentGuess = segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3;
        const badPartGuess = part && part.end && this.currentTime_() - part.end > segmentInfo.playlist.partTargetDuration * 3; // If we previously appended a segment/part that ends more than 3 part/targetDurations before
        // the currentTime_ that means that our conservative guess was too conservative.
        // In that case, reset the loader state so that we try to use any information gained
        // from the previous request to create a new, more accurate, sync-point.
        if (badSegmentGuess || badPartGuess) {
            this.logger_(`bad ${badSegmentGuess ? "segment" : "part"} ${$cb03b711053a4297$var$segmentInfoString(segmentInfo)}`);
            this.resetEverything();
            return;
        }
        const isWalkingForward = this.mediaIndex !== null; // Don't do a rendition switch unless we have enough time to get a sync segment
        // and conservatively guess
        if (isWalkingForward) this.trigger("bandwidthupdate");
        this.trigger("progress");
        this.mediaIndex = segmentInfo.mediaIndex;
        this.partIndex = segmentInfo.partIndex; // any time an update finishes and the last segment is in the
        // buffer, end the stream. this ensures the "ended" event will
        // fire if playback reaches that point.
        if (this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex)) this.endOfStream();
         // used for testing
        this.trigger("appended");
        if (segmentInfo.hasAppendedData_) this.mediaAppends++;
        if (!this.paused()) this.monitorBuffer_();
    }
    /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */ recordThroughput_(segmentInfo) {
        if (segmentInfo.duration < $cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
            this.logger_(`Ignoring segment's throughput because its duration of ${segmentInfo.duration}` + ` is less than the min to record ${$cb03b711053a4297$var$MIN_SEGMENT_DURATION_TO_SAVE_STATS}`);
            return;
        }
        const rate = this.throughput.rate; // Add one to the time to ensure that we don't accidentally attempt to divide
        // by zero in the case where the throughput is ridiculously high
        const segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1; // Multiply by 8000 to convert from bytes/millisecond to bits/second
        const segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8000); // This is just a cumulative moving average calculation:
        //   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
        this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
    }
    /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */ addSegmentMetadataCue_(segmentInfo) {
        if (!this.segmentMetadataTrack_) return;
        const segment = segmentInfo.segment;
        const start = segment.start;
        const end = segment.end; // Do not try adding the cue if the start and end times are invalid.
        if (!$cb03b711053a4297$var$finite(start) || !$cb03b711053a4297$var$finite(end)) return;
        $cb03b711053a4297$var$removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
        const Cue = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebKitDataCue || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue;
        const value = {
            custom: segment.custom,
            dateTimeObject: segment.dateTimeObject,
            dateTimeString: segment.dateTimeString,
            programDateTime: segment.programDateTime,
            bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
            resolution: segmentInfo.playlist.attributes.RESOLUTION,
            codecs: segmentInfo.playlist.attributes.CODECS,
            byteLength: segmentInfo.byteLength,
            uri: segmentInfo.uri,
            timeline: segmentInfo.timeline,
            playlist: segmentInfo.playlist.id,
            start: start,
            end: end
        };
        const data = JSON.stringify(value);
        const cue = new Cue(start, end, data); // Attach the metadata to the value property of the cue to keep consistency between
        // the differences of WebKitDataCue in safari and VTTCue in other browsers
        cue.value = value;
        this.segmentMetadataTrack_.addCue(cue);
    }
    /**
   * Public setter for defining the private replaceSegmentsUntil_ property, which
   * determines when we can return fetchAtBuffer to true if overwriting the buffer.
   *
   * @param {number} bufferedEnd the end of the buffered range to replace segments
   * until currentTime reaches this time.
   */ set replaceSegmentsUntil(bufferedEnd) {
        this.logger_(`Replacing currently buffered segments until ${bufferedEnd}`);
        this.replaceSegmentsUntil_ = bufferedEnd;
    }
}
function $cb03b711053a4297$var$noop() {}
const $cb03b711053a4297$var$toTitleCase = function(string) {
    if (typeof string !== "string") return string;
    return string.replace(/./, (w)=>w.toUpperCase());
};
/**
 * @file source-updater.js
 */ const $cb03b711053a4297$var$bufferTypes = [
    "video",
    "audio"
];
const $cb03b711053a4297$var$updating = (type, sourceUpdater)=>{
    const sourceBuffer = sourceUpdater[`${type}Buffer`];
    return sourceBuffer && sourceBuffer.updating || sourceUpdater.queuePending[type];
};
const $cb03b711053a4297$var$nextQueueIndexOfType = (type, queue)=>{
    for(let i = 0; i < queue.length; i++){
        const queueEntry = queue[i];
        if (queueEntry.type === "mediaSource") // If the next entry is a media source entry (uses multiple source buffers), block
        // processing to allow it to go through first.
        return null;
        if (queueEntry.type === type) return i;
    }
    return null;
};
const $cb03b711053a4297$var$shiftQueue = (type, sourceUpdater)=>{
    if (sourceUpdater.queue.length === 0) return;
    let queueIndex = 0;
    let queueEntry = sourceUpdater.queue[queueIndex];
    if (queueEntry.type === "mediaSource") {
        if (!sourceUpdater.updating() && sourceUpdater.mediaSource.readyState !== "closed") {
            sourceUpdater.queue.shift();
            queueEntry.action(sourceUpdater);
            if (queueEntry.doneFn) queueEntry.doneFn();
             // Only specific source buffer actions must wait for async updateend events. Media
            // Source actions process synchronously. Therefore, both audio and video source
            // buffers are now clear to process the next queue entries.
            $cb03b711053a4297$var$shiftQueue("audio", sourceUpdater);
            $cb03b711053a4297$var$shiftQueue("video", sourceUpdater);
        } // Media Source actions require both source buffers, so if the media source action
        // couldn't process yet (because one or both source buffers are busy), block other
        // queue actions until both are available and the media source action can process.
        return;
    }
    if (type === "mediaSource") // If the queue was shifted by a media source action (this happens when pushing a
    // media source action onto the queue), then it wasn't from an updateend event from an
    // audio or video source buffer, so there's no change from previous state, and no
    // processing should be done.
    return;
     // Media source queue entries don't need to consider whether the source updater is
    // started (i.e., source buffers are created) as they don't need the source buffers, but
    // source buffer queue entries do.
    if (!sourceUpdater.ready() || sourceUpdater.mediaSource.readyState === "closed" || $cb03b711053a4297$var$updating(type, sourceUpdater)) return;
    if (queueEntry.type !== type) {
        queueIndex = $cb03b711053a4297$var$nextQueueIndexOfType(type, sourceUpdater.queue);
        if (queueIndex === null) // Either there's no queue entry that uses this source buffer type in the queue, or
        // there's a media source queue entry before the next entry of this type, in which
        // case wait for that action to process first.
        return;
        queueEntry = sourceUpdater.queue[queueIndex];
    }
    sourceUpdater.queue.splice(queueIndex, 1); // Keep a record that this source buffer type is in use.
    //
    // The queue pending operation must be set before the action is performed in the event
    // that the action results in a synchronous event that is acted upon. For instance, if
    // an exception is thrown that can be handled, it's possible that new actions will be
    // appended to an empty queue and immediately executed, but would not have the correct
    // pending information if this property was set after the action was performed.
    sourceUpdater.queuePending[type] = queueEntry;
    queueEntry.action(type, sourceUpdater);
    if (!queueEntry.doneFn) {
        // synchronous operation, process next entry
        sourceUpdater.queuePending[type] = null;
        $cb03b711053a4297$var$shiftQueue(type, sourceUpdater);
        return;
    }
};
const $cb03b711053a4297$var$cleanupBuffer = (type, sourceUpdater)=>{
    const buffer = sourceUpdater[`${type}Buffer`];
    const titleType = $cb03b711053a4297$var$toTitleCase(type);
    if (!buffer) return;
    buffer.removeEventListener("updateend", sourceUpdater[`on${titleType}UpdateEnd_`]);
    buffer.removeEventListener("error", sourceUpdater[`on${titleType}Error_`]);
    sourceUpdater.codecs[type] = null;
    sourceUpdater[`${type}Buffer`] = null;
};
const $cb03b711053a4297$var$inSourceBuffers = (mediaSource, sourceBuffer)=>mediaSource && sourceBuffer && Array.prototype.indexOf.call(mediaSource.sourceBuffers, sourceBuffer) !== -1;
const $cb03b711053a4297$var$actions = {
    appendBuffer: (bytes, segmentInfo, onError)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Appending segment ${segmentInfo.mediaIndex}'s ${bytes.length} bytes to ${type}Buffer`);
            try {
                sourceBuffer.appendBuffer(bytes);
            } catch (e) {
                sourceUpdater.logger_(`Error with code ${e.code} ` + (e.code === $cb03b711053a4297$var$QUOTA_EXCEEDED_ERR ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${segmentInfo.mediaIndex} to ${type}Buffer`);
                sourceUpdater.queuePending[type] = null;
                onError(e);
            }
        },
    remove: (start, end)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Removing ${start} to ${end} from ${type}Buffer`);
            try {
                sourceBuffer.remove(start, end);
            } catch (e) {
                sourceUpdater.logger_(`Remove ${start} to ${end} from ${type}Buffer failed`);
            }
        },
    timestampOffset: (offset)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Setting ${type}timestampOffset to ${offset}`);
            sourceBuffer.timestampOffset = offset;
        },
    callback: (callback)=>(type, sourceUpdater)=>{
            callback();
        },
    endOfStream: (error)=>(sourceUpdater)=>{
            if (sourceUpdater.mediaSource.readyState !== "open") return;
            sourceUpdater.logger_(`Calling mediaSource endOfStream(${error || ""})`);
            try {
                sourceUpdater.mediaSource.endOfStream(error);
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Failed to call media source endOfStream", e);
            }
        },
    duration: (duration)=>(sourceUpdater)=>{
            sourceUpdater.logger_(`Setting mediaSource duration to ${duration}`);
            try {
                sourceUpdater.mediaSource.duration = duration;
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Failed to set media source duration", e);
            }
        },
    abort: ()=>(type, sourceUpdater)=>{
            if (sourceUpdater.mediaSource.readyState !== "open") return;
            const sourceBuffer = sourceUpdater[`${type}Buffer`]; // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`calling abort on ${type}Buffer`);
            try {
                sourceBuffer.abort();
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Failed to abort on ${type}Buffer`, e);
            }
        },
    addSourceBuffer: (type, codec)=>(sourceUpdater)=>{
            const titleType = $cb03b711053a4297$var$toTitleCase(type);
            const mime = (0, $e324d09415701181$export$4b64fc0a026b9981)(codec);
            sourceUpdater.logger_(`Adding ${type}Buffer with codec ${codec} to mediaSource`);
            const sourceBuffer = sourceUpdater.mediaSource.addSourceBuffer(mime);
            sourceBuffer.addEventListener("updateend", sourceUpdater[`on${titleType}UpdateEnd_`]);
            sourceBuffer.addEventListener("error", sourceUpdater[`on${titleType}Error_`]);
            sourceUpdater.codecs[type] = codec;
            sourceUpdater[`${type}Buffer`] = sourceBuffer;
        },
    removeSourceBuffer: (type)=>(sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`];
            $cb03b711053a4297$var$cleanupBuffer(type, sourceUpdater); // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
            sourceUpdater.logger_(`Removing ${type}Buffer with codec ${sourceUpdater.codecs[type]} from mediaSource`);
            try {
                sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);
            } catch (e) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Failed to removeSourceBuffer ${type}Buffer`, e);
            }
        },
    changeType: (codec)=>(type, sourceUpdater)=>{
            const sourceBuffer = sourceUpdater[`${type}Buffer`];
            const mime = (0, $e324d09415701181$export$4b64fc0a026b9981)(codec); // can't do anything if the media source / source buffer is null
            // or the media source does not contain this source buffer.
            if (!$cb03b711053a4297$var$inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) return;
             // do not update codec if we don't need to.
            if (sourceUpdater.codecs[type] === codec) return;
            sourceUpdater.logger_(`changing ${type}Buffer codec from ${sourceUpdater.codecs[type]} to ${codec}`);
            sourceBuffer.changeType(mime);
            sourceUpdater.codecs[type] = codec;
        }
};
const $cb03b711053a4297$var$pushQueue = ({ type: type, sourceUpdater: sourceUpdater, action: action, doneFn: doneFn, name: name })=>{
    sourceUpdater.queue.push({
        type: type,
        action: action,
        doneFn: doneFn,
        name: name
    });
    $cb03b711053a4297$var$shiftQueue(type, sourceUpdater);
};
const $cb03b711053a4297$var$onUpdateend = (type, sourceUpdater)=>(e)=>{
        const buffered = sourceUpdater[`${type}Buffered`]();
        const bufferedAsString = $cb03b711053a4297$var$prettyBuffered(buffered);
        sourceUpdater.logger_(`${type} source buffer update end. Buffered: \n`, bufferedAsString); // Although there should, in theory, be a pending action for any updateend receieved,
        // there are some actions that may trigger updateend events without set definitions in
        // the w3c spec. For instance, setting the duration on the media source may trigger
        // updateend events on source buffers. This does not appear to be in the spec. As such,
        // if we encounter an updateend without a corresponding pending action from our queue
        // for that source buffer type, process the next action.
        if (sourceUpdater.queuePending[type]) {
            const doneFn = sourceUpdater.queuePending[type].doneFn;
            sourceUpdater.queuePending[type] = null;
            if (doneFn) // if there's an error, report it
            doneFn(sourceUpdater[`${type}Error_`]);
        }
        $cb03b711053a4297$var$shiftQueue(type, sourceUpdater);
    };
/**
 * A queue of callbacks to be serialized and applied when a
 * MediaSource and its associated SourceBuffers are not in the
 * updating state. It is used by the segment loader to update the
 * underlying SourceBuffers when new data is loaded, for instance.
 *
 * @class SourceUpdater
 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
 */ class $cb03b711053a4297$var$SourceUpdater extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(mediaSource){
        super();
        this.mediaSource = mediaSource;
        this.sourceopenListener_ = ()=>$cb03b711053a4297$var$shiftQueue("mediaSource", this);
        this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_);
        this.logger_ = $cb03b711053a4297$var$logger("SourceUpdater"); // initial timestamp offset is 0
        this.audioTimestampOffset_ = 0;
        this.videoTimestampOffset_ = 0;
        this.queue = [];
        this.queuePending = {
            audio: null,
            video: null
        };
        this.delayedAudioAppendQueue_ = [];
        this.videoAppendQueued_ = false;
        this.codecs = {};
        this.onVideoUpdateEnd_ = $cb03b711053a4297$var$onUpdateend("video", this);
        this.onAudioUpdateEnd_ = $cb03b711053a4297$var$onUpdateend("audio", this);
        this.onVideoError_ = (e)=>{
            // used for debugging
            this.videoError_ = e;
        };
        this.onAudioError_ = (e)=>{
            // used for debugging
            this.audioError_ = e;
        };
        this.createdSourceBuffers_ = false;
        this.initializedEme_ = false;
        this.triggeredReady_ = false;
    }
    initializedEme() {
        this.initializedEme_ = true;
        this.triggerReady();
    }
    hasCreatedSourceBuffers() {
        // if false, likely waiting on one of the segment loaders to get enough data to create
        // source buffers
        return this.createdSourceBuffers_;
    }
    hasInitializedAnyEme() {
        return this.initializedEme_;
    }
    ready() {
        return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
    }
    createSourceBuffers(codecs) {
        if (this.hasCreatedSourceBuffers()) // already created them before
        return;
         // the intial addOrChangeSourceBuffers will always be
        // two add buffers.
        this.addOrChangeSourceBuffers(codecs);
        this.createdSourceBuffers_ = true;
        this.trigger("createdsourcebuffers");
        this.triggerReady();
    }
    triggerReady() {
        // only allow ready to be triggered once, this prevents the case
        // where:
        // 1. we trigger createdsourcebuffers
        // 2. ie 11 synchronously initializates eme
        // 3. the synchronous initialization causes us to trigger ready
        // 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
        if (this.ready() && !this.triggeredReady_) {
            this.triggeredReady_ = true;
            this.trigger("ready");
        }
    }
    /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */ addSourceBuffer(type, codec) {
        $cb03b711053a4297$var$pushQueue({
            type: "mediaSource",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.addSourceBuffer(type, codec),
            name: "addSourceBuffer"
        });
    }
    /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */ abort(type) {
        $cb03b711053a4297$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.abort(type),
            name: "abort"
        });
    }
    /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */ removeSourceBuffer(type) {
        if (!this.canRemoveSourceBuffer()) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.error("removeSourceBuffer is not supported!");
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: "mediaSource",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.removeSourceBuffer(type),
            name: "removeSourceBuffer"
        });
    }
    /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */ canRemoveSourceBuffer() {
        // As of Firefox 83 removeSourceBuffer
        // throws errors, so we report that it does not support this.
        return !$cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_FIREFOX && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.prototype && typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource.prototype.removeSourceBuffer === "function";
    }
    /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */ static canChangeType() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).SourceBuffer && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).SourceBuffer.prototype && typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).SourceBuffer.prototype.changeType === "function";
    }
    /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */ canChangeType() {
        return this.constructor.canChangeType();
    }
    /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */ changeType(type, codec) {
        if (!this.canChangeType()) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.error("changeType is not supported!");
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.changeType(codec),
            name: "changeType"
        });
    }
    /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */ addOrChangeSourceBuffers(codecs) {
        if (!codecs || typeof codecs !== "object" || Object.keys(codecs).length === 0) throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
        Object.keys(codecs).forEach((type)=>{
            const codec = codecs[type];
            if (!this.hasCreatedSourceBuffers()) return this.addSourceBuffer(type, codec);
            if (this.canChangeType()) this.changeType(type, codec);
        });
    }
    /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */ appendBuffer(options, doneFn) {
        const { segmentInfo: segmentInfo, type: type, bytes: bytes } = options;
        this.processedAppend_ = true;
        if (type === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
            this.delayedAudioAppendQueue_.push([
                options,
                doneFn
            ]);
            this.logger_(`delayed audio append of ${bytes.length} until video append`);
            return;
        } // In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
        // not be fired. This means that the queue will be blocked until the next action
        // taken by the segment-loader. Provide a mechanism for segment-loader to handle
        // these errors by calling the doneFn with the specific error.
        const onError = doneFn;
        $cb03b711053a4297$var$pushQueue({
            type: type,
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.appendBuffer(bytes, segmentInfo || {
                mediaIndex: -1
            }, onError),
            doneFn: doneFn,
            name: "appendBuffer"
        });
        if (type === "video") {
            this.videoAppendQueued_ = true;
            if (!this.delayedAudioAppendQueue_.length) return;
            const queue = this.delayedAudioAppendQueue_.slice();
            this.logger_(`queuing delayed audio ${queue.length} appendBuffers`);
            this.delayedAudioAppendQueue_.length = 0;
            queue.forEach((que)=>{
                this.appendBuffer.apply(this, que);
            });
        }
    }
    /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */ audioBuffered() {
        // no media source/source buffer or it isn't in the media sources
        // source buffer list
        if (!$cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.audioBuffer)) return $cb03b711053a4297$var$createTimeRanges();
        return this.audioBuffer.buffered ? this.audioBuffer.buffered : $cb03b711053a4297$var$createTimeRanges();
    }
    /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */ videoBuffered() {
        // no media source/source buffer or it isn't in the media sources
        // source buffer list
        if (!$cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.videoBuffer)) return $cb03b711053a4297$var$createTimeRanges();
        return this.videoBuffer.buffered ? this.videoBuffer.buffered : $cb03b711053a4297$var$createTimeRanges();
    }
    /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */ buffered() {
        const video = $cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null;
        const audio = $cb03b711053a4297$var$inSourceBuffers(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
        if (audio && !video) return this.audioBuffered();
        if (video && !audio) return this.videoBuffered();
        return $cb03b711053a4297$var$bufferIntersection(this.audioBuffered(), this.videoBuffered());
    }
    /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */ setDuration(duration, doneFn = $cb03b711053a4297$var$noop) {
        // In order to set the duration on the media source, it's necessary to wait for all
        // source buffers to no longer be updating. "If the updating attribute equals true on
        // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
        // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
        $cb03b711053a4297$var$pushQueue({
            type: "mediaSource",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.duration(duration),
            name: "duration",
            doneFn: doneFn
        });
    }
    /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */ endOfStream(error = null, doneFn = $cb03b711053a4297$var$noop) {
        if (typeof error !== "string") error = undefined;
         // In order to set the duration on the media source, it's necessary to wait for all
        // source buffers to no longer be updating. "If the updating attribute equals true on
        // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
        // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
        $cb03b711053a4297$var$pushQueue({
            type: "mediaSource",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.endOfStream(error),
            name: "endOfStream",
            doneFn: doneFn
        });
    }
    /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */ removeAudio(start, end, done = $cb03b711053a4297$var$noop) {
        if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
            done();
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: "audio",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.remove(start, end),
            doneFn: done,
            name: "remove"
        });
    }
    /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */ removeVideo(start, end, done = $cb03b711053a4297$var$noop) {
        if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
            done();
            return;
        }
        $cb03b711053a4297$var$pushQueue({
            type: "video",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.remove(start, end),
            doneFn: done,
            name: "remove"
        });
    }
    /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */ updating() {
        // the audio/video source buffer is updating
        if ($cb03b711053a4297$var$updating("audio", this) || $cb03b711053a4297$var$updating("video", this)) return true;
        return false;
    }
    /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */ audioTimestampOffset(offset) {
        if (typeof offset !== "undefined" && this.audioBuffer && // no point in updating if it's the same
        this.audioTimestampOffset_ !== offset) {
            $cb03b711053a4297$var$pushQueue({
                type: "audio",
                sourceUpdater: this,
                action: $cb03b711053a4297$var$actions.timestampOffset(offset),
                name: "timestampOffset"
            });
            this.audioTimestampOffset_ = offset;
        }
        return this.audioTimestampOffset_;
    }
    /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */ videoTimestampOffset(offset) {
        if (typeof offset !== "undefined" && this.videoBuffer && // no point in updating if it's the same
        this.videoTimestampOffset !== offset) {
            $cb03b711053a4297$var$pushQueue({
                type: "video",
                sourceUpdater: this,
                action: $cb03b711053a4297$var$actions.timestampOffset(offset),
                name: "timestampOffset"
            });
            this.videoTimestampOffset_ = offset;
        }
        return this.videoTimestampOffset_;
    }
    /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */ audioQueueCallback(callback) {
        if (!this.audioBuffer) return;
        $cb03b711053a4297$var$pushQueue({
            type: "audio",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.callback(callback),
            name: "callback"
        });
    }
    /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */ videoQueueCallback(callback) {
        if (!this.videoBuffer) return;
        $cb03b711053a4297$var$pushQueue({
            type: "video",
            sourceUpdater: this,
            action: $cb03b711053a4297$var$actions.callback(callback),
            name: "callback"
        });
    }
    /**
   * dispose of the source updater and the underlying sourceBuffer
   */ dispose() {
        this.trigger("dispose");
        $cb03b711053a4297$var$bufferTypes.forEach((type)=>{
            this.abort(type);
            if (this.canRemoveSourceBuffer()) this.removeSourceBuffer(type);
            else this[`${type}QueueCallback`](()=>$cb03b711053a4297$var$cleanupBuffer(type, this));
        });
        this.videoAppendQueued_ = false;
        this.delayedAudioAppendQueue_.length = 0;
        if (this.sourceopenListener_) this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_);
        this.off();
    }
}
const $cb03b711053a4297$var$uint8ToUtf8 = (uintArray)=>decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
/**
 * @file vtt-segment-loader.js
 */ const $cb03b711053a4297$var$VTT_LINE_TERMINATORS = new Uint8Array("\n\n".split("").map((char)=>char.charCodeAt(0)));
class $cb03b711053a4297$var$NoVttJsError extends Error {
    constructor(){
        super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
    }
}
/**
 * An object that manages segment loading and appending.
 *
 * @class VTTSegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$VTTSegmentLoader extends $cb03b711053a4297$var$SegmentLoader {
    constructor(settings, options = {}){
        super(settings, options); // SegmentLoader requires a MediaSource be specified or it will throw an error;
        // however, VTTSegmentLoader has no need of a media source, so delete the reference
        this.mediaSource_ = null;
        this.subtitlesTrack_ = null;
        this.loaderType_ = "subtitle";
        this.featuresNativeTextTracks_ = settings.featuresNativeTextTracks;
        this.loadVttJs = settings.loadVttJs; // The VTT segment will have its own time mappings. Saving VTT segment timing info in
        // the sync controller leads to improper behavior.
        this.shouldSaveSegmentTimingInfo_ = false;
    }
    createTransmuxer_() {
        // don't need to transmux any subtitles
        return null;
    }
    /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */ buffered_() {
        if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) return $cb03b711053a4297$var$createTimeRanges();
        const cues = this.subtitlesTrack_.cues;
        const start = cues[0].startTime;
        const end = cues[cues.length - 1].startTime;
        return $cb03b711053a4297$var$createTimeRanges([
            [
                start,
                end
            ]
        ]);
    }
    /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */ initSegmentForMap(map, set = false) {
        if (!map) return null;
        const id = $cb03b711053a4297$var$initSegmentId(map);
        let storedMap = this.initSegments_[id];
        if (set && !storedMap && map.bytes) {
            // append WebVTT line terminators to the media initialization segment if it exists
            // to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
            // requires two or more WebVTT line terminators between the WebVTT header and the
            // rest of the file
            const combinedByteLength = $cb03b711053a4297$var$VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
            const combinedSegment = new Uint8Array(combinedByteLength);
            combinedSegment.set(map.bytes);
            combinedSegment.set($cb03b711053a4297$var$VTT_LINE_TERMINATORS, map.bytes.byteLength);
            this.initSegments_[id] = storedMap = {
                resolvedUri: map.resolvedUri,
                byterange: map.byterange,
                bytes: combinedSegment
            };
        }
        return storedMap || map;
    }
    /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */ couldBeginLoading_() {
        return this.playlist_ && this.subtitlesTrack_ && !this.paused();
    }
    /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */ init_() {
        this.state = "READY";
        this.resetEverything();
        return this.monitorBuffer_();
    }
    /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */ track(track) {
        if (typeof track === "undefined") return this.subtitlesTrack_;
        this.subtitlesTrack_ = track; // if we were unpaused but waiting for a sourceUpdater, start
        // buffering now
        if (this.state === "INIT" && this.couldBeginLoading_()) this.init_();
        return this.subtitlesTrack_;
    }
    /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */ remove(start, end) {
        $cb03b711053a4297$var$removeCuesFromTrack(start, end, this.subtitlesTrack_);
    }
    /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */ fillBuffer_() {
        // see if we need to begin loading immediately
        const segmentInfo = this.chooseNextRequest_();
        if (!segmentInfo) return;
        if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
            // We don't have the timestamp offset that we need to sync subtitles.
            // Rerun on a timestamp offset or user interaction.
            const checkTimestampOffset = ()=>{
                this.state = "READY";
                if (!this.paused()) // if not paused, queue a buffer check as soon as possible
                this.monitorBuffer_();
            };
            this.syncController_.one("timestampoffset", checkTimestampOffset);
            this.state = "WAITING_ON_TIMELINE";
            return;
        }
        this.loadSegment_(segmentInfo);
    }
    timestampOffsetForSegment_() {
        return null;
    }
    chooseNextRequest_() {
        return this.skipEmptySegments_(super.chooseNextRequest_());
    }
    /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */ skipEmptySegments_(segmentInfo) {
        while(segmentInfo && segmentInfo.segment.empty){
            // stop at the last possible segmentInfo
            if (segmentInfo.mediaIndex + 1 >= segmentInfo.playlist.segments.length) {
                segmentInfo = null;
                break;
            }
            segmentInfo = this.generateSegmentInfo_({
                playlist: segmentInfo.playlist,
                mediaIndex: segmentInfo.mediaIndex + 1,
                startOfSegment: segmentInfo.startOfSegment + segmentInfo.duration,
                isSyncRequest: segmentInfo.isSyncRequest
            });
        }
        return segmentInfo;
    }
    stopForError(error) {
        this.error(error);
        this.state = "READY";
        this.pause();
        this.trigger("error");
    }
    /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */ segmentRequestFinished_(error, simpleSegment, result) {
        if (!this.subtitlesTrack_) {
            this.state = "READY";
            return;
        }
        this.saveTransferStats_(simpleSegment.stats); // the request was aborted
        if (!this.pendingSegment_) {
            this.state = "READY";
            this.mediaRequestsAborted += 1;
            return;
        }
        if (error) {
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.TIMEOUT) this.handleTimeout_();
            if (error.code === $cb03b711053a4297$var$REQUEST_ERRORS.ABORTED) this.mediaRequestsAborted += 1;
            else this.mediaRequestsErrored += 1;
            this.stopForError(error);
            return;
        }
        const segmentInfo = this.pendingSegment_; // although the VTT segment loader bandwidth isn't really used, it's good to
        // maintain functionality between segment loaders
        this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats); // if this request included a segment key, save that data in the cache
        if (simpleSegment.key) this.segmentKey(simpleSegment.key, true);
        this.state = "APPENDING"; // used for tests
        this.trigger("appending");
        const segment = segmentInfo.segment;
        if (segment.map) segment.map.bytes = simpleSegment.map.bytes;
        segmentInfo.bytes = simpleSegment.bytes; // Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== "function" && typeof this.loadVttJs === "function") {
            this.state = "WAITING_ON_VTTJS"; // should be fine to call multiple times
            // script will be loaded once but multiple listeners will be added to the queue, which is expected.
            this.loadVttJs().then(()=>this.segmentRequestFinished_(error, simpleSegment, result), ()=>this.stopForError({
                    message: "Error loading vtt.js"
                }));
            return;
        }
        segment.requested = true;
        try {
            this.parseVTTCues_(segmentInfo);
        } catch (e) {
            this.stopForError({
                message: e.message
            });
            return;
        }
        this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
        if (segmentInfo.cues.length) segmentInfo.timingInfo = {
            start: segmentInfo.cues[0].startTime,
            end: segmentInfo.cues[segmentInfo.cues.length - 1].endTime
        };
        else segmentInfo.timingInfo = {
            start: segmentInfo.startOfSegment,
            end: segmentInfo.startOfSegment + segmentInfo.duration
        };
        if (segmentInfo.isSyncRequest) {
            this.trigger("syncinfoupdate");
            this.pendingSegment_ = null;
            this.state = "READY";
            return;
        }
        segmentInfo.byteLength = segmentInfo.bytes.byteLength;
        this.mediaSecondsLoaded += segment.duration; // Create VTTCue instances for each cue in the new segment and add them to
        // the subtitle track
        segmentInfo.cues.forEach((cue)=>{
            this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue(cue.startTime, cue.endTime, cue.text) : cue);
        }); // Remove any duplicate cues from the subtitle track. The WebVTT spec allows
        // cues to have identical time-intervals, but if the text is also identical
        // we can safely assume it is a duplicate that can be removed (ex. when a cue
        // "overlaps" VTT segments)
        $cb03b711053a4297$var$removeDuplicateCuesFromTrack(this.subtitlesTrack_);
        this.handleAppendsDone_();
    }
    handleData_() {
    // that we do not support here.
    }
    updateTimingInfoEnd_() {}
    /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */ parseVTTCues_(segmentInfo) {
        let decoder;
        let decodeBytesToString = false;
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT !== "function") // caller is responsible for exception handling.
        throw new $cb03b711053a4297$var$NoVttJsError();
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).TextDecoder === "function") decoder = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).TextDecoder("utf8");
        else {
            decoder = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.StringDecoder();
            decodeBytesToString = true;
        }
        const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).WebVTT.Parser((0, (/*@__PURE__*/$parcel$interopDefault($eDick))), (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).vttjs, decoder);
        segmentInfo.cues = [];
        segmentInfo.timestampmap = {
            MPEGTS: 0,
            LOCAL: 0
        };
        parser.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
        parser.ontimestampmap = (map)=>{
            segmentInfo.timestampmap = map;
        };
        parser.onparsingerror = (error)=>{
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Error encountered when parsing cues: " + error.message);
        };
        if (segmentInfo.segment.map) {
            let mapData = segmentInfo.segment.map.bytes;
            if (decodeBytesToString) mapData = $cb03b711053a4297$var$uint8ToUtf8(mapData);
            parser.parse(mapData);
        }
        let segmentData = segmentInfo.bytes;
        if (decodeBytesToString) segmentData = $cb03b711053a4297$var$uint8ToUtf8(segmentData);
        parser.parse(segmentData);
        parser.flush();
    }
    /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */ updateTimeMapping_(segmentInfo, mappingObj, playlist) {
        const segment = segmentInfo.segment;
        if (!mappingObj) // If the sync controller does not have a mapping of TS to Media Time for the
        // timeline, then we don't have enough information to update the cue
        // start/end times
        return;
        if (!segmentInfo.cues.length) {
            // If there are no cues, we also do not have enough information to figure out
            // segment timing. Mark that the segment contains no cues so we don't re-request
            // an empty segment.
            segment.empty = true;
            return;
        }
        const timestampmap = segmentInfo.timestampmap;
        const diff = timestampmap.MPEGTS / (0, $2a252b448d50d133$exports.ONE_SECOND_IN_TS) - timestampmap.LOCAL + mappingObj.mapping;
        segmentInfo.cues.forEach((cue)=>{
            // First convert cue time to TS time using the timestamp-map provided within the vtt
            cue.startTime += diff;
            cue.endTime += diff;
        });
        if (!playlist.syncInfo) {
            const firstStart = segmentInfo.cues[0].startTime;
            const lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
            playlist.syncInfo = {
                mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
                time: Math.min(firstStart, lastStart - segment.duration)
            };
        }
    }
}
/**
 * @file ad-cue-tags.js
 */ /**
 * Searches for an ad cue that overlaps with the given mediaTime
 *
 * @param {Object} track
 *        the track to find the cue for
 *
 * @param {number} mediaTime
 *        the time to find the cue at
 *
 * @return {Object|null}
 *         the found cue or null
 */ const $cb03b711053a4297$var$findAdCue = function(track, mediaTime) {
    const cues = track.cues;
    for(let i = 0; i < cues.length; i++){
        const cue = cues[i];
        if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) return cue;
    }
    return null;
};
const $cb03b711053a4297$var$updateAdCues = function(media, track, offset = 0) {
    if (!media.segments) return;
    let mediaTime = offset;
    let cue;
    for(let i = 0; i < media.segments.length; i++){
        const segment = media.segments[i];
        if (!cue) // Since the cues will span for at least the segment duration, adding a fudge
        // factor of half segment duration will prevent duplicate cues from being
        // created when timing info is not exact (e.g. cue start time initialized
        // at 10.006677, but next call mediaTime is 10.003332 )
        cue = $cb03b711053a4297$var$findAdCue(track, mediaTime + segment.duration / 2);
        if (cue) {
            if ("cueIn" in segment) {
                // Found a CUE-IN so end the cue
                cue.endTime = mediaTime;
                cue.adEndTime = mediaTime;
                mediaTime += segment.duration;
                cue = null;
                continue;
            }
            if (mediaTime < cue.endTime) {
                // Already processed this mediaTime for this cue
                mediaTime += segment.duration;
                continue;
            } // otherwise extend cue until a CUE-IN is found
            cue.endTime += segment.duration;
        } else {
            if ("cueOut" in segment) {
                cue = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
                cue.adStartTime = mediaTime; // Assumes tag format to be
                // #EXT-X-CUE-OUT:30
                cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
                track.addCue(cue);
            }
            if ("cueOutCont" in segment) {
                // Entered into the middle of an ad cue
                // Assumes tag formate to be
                // #EXT-X-CUE-OUT-CONT:10/30
                const [adOffset, adTotal] = segment.cueOutCont.split("/").map(parseFloat);
                cue = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).VTTCue(mediaTime, mediaTime + segment.duration, "");
                cue.adStartTime = mediaTime - adOffset;
                cue.adEndTime = cue.adStartTime + adTotal;
                track.addCue(cue);
            }
        }
        mediaTime += segment.duration;
    }
};
/**
 * @file sync-controller.js
 */ // synchronize expired playlist segments.
// the max media sequence diff is 48 hours of live stream
// content with two second segments. Anything larger than that
// will likely be invalid.
const $cb03b711053a4297$var$MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC = 86400;
const $cb03b711053a4297$var$syncPointStrategies = [
    // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
    //                the equivalence display-time 0 === segment-index 0
    {
        name: "VOD",
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (duration !== Infinity) {
                const syncPoint = {
                    time: 0,
                    segmentIndex: 0,
                    partIndex: null
                };
                return syncPoint;
            }
            return null;
        }
    },
    // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
    {
        name: "ProgramDateTime",
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (!Object.keys(syncController.timelineToDatetimeMappings).length) return null;
            let syncPoint = null;
            let lastDistance = null;
            const partsAndSegments = $cb03b711053a4297$var$getPartsAndSegments(playlist);
            currentTime = currentTime || 0;
            for(let i = 0; i < partsAndSegments.length; i++){
                // start from the end and loop backwards for live
                // or start from the front and loop forwards for non-live
                const index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
                const partAndSegment = partsAndSegments[index];
                const segment = partAndSegment.segment;
                const datetimeMapping = syncController.timelineToDatetimeMappings[segment.timeline];
                if (!datetimeMapping || !segment.dateTimeObject) continue;
                const segmentTime = segment.dateTimeObject.getTime() / 1000;
                let start = segmentTime + datetimeMapping; // take part duration into account.
                if (segment.parts && typeof partAndSegment.partIndex === "number") for(let z = 0; z < partAndSegment.partIndex; z++)start += segment.parts[z].duration;
                const distance = Math.abs(currentTime - start); // Once the distance begins to increase, or if distance is 0, we have passed
                // currentTime and can stop looking for better candidates
                if (lastDistance !== null && (distance === 0 || lastDistance < distance)) break;
                lastDistance = distance;
                syncPoint = {
                    time: start,
                    segmentIndex: partAndSegment.segmentIndex,
                    partIndex: partAndSegment.partIndex
                };
            }
            return syncPoint;
        }
    },
    // Stategy "Segment": We have a known time mapping for a timeline and a
    //                    segment in the current timeline with timing data
    {
        name: "Segment",
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            let syncPoint = null;
            let lastDistance = null;
            currentTime = currentTime || 0;
            const partsAndSegments = $cb03b711053a4297$var$getPartsAndSegments(playlist);
            for(let i = 0; i < partsAndSegments.length; i++){
                // start from the end and loop backwards for live
                // or start from the front and loop forwards for non-live
                const index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
                const partAndSegment = partsAndSegments[index];
                const segment = partAndSegment.segment;
                const start = partAndSegment.part && partAndSegment.part.start || segment && segment.start;
                if (segment.timeline === currentTimeline && typeof start !== "undefined") {
                    const distance = Math.abs(currentTime - start); // Once the distance begins to increase, we have passed
                    // currentTime and can stop looking for better candidates
                    if (lastDistance !== null && lastDistance < distance) break;
                    if (!syncPoint || lastDistance === null || lastDistance >= distance) {
                        lastDistance = distance;
                        syncPoint = {
                            time: start,
                            segmentIndex: partAndSegment.segmentIndex,
                            partIndex: partAndSegment.partIndex
                        };
                    }
                }
            }
            return syncPoint;
        }
    },
    // Stategy "Discontinuity": We have a discontinuity with a known
    //                          display-time
    {
        name: "Discontinuity",
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            let syncPoint = null;
            currentTime = currentTime || 0;
            if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
                let lastDistance = null;
                for(let i = 0; i < playlist.discontinuityStarts.length; i++){
                    const segmentIndex = playlist.discontinuityStarts[i];
                    const discontinuity = playlist.discontinuitySequence + i + 1;
                    const discontinuitySync = syncController.discontinuities[discontinuity];
                    if (discontinuitySync) {
                        const distance = Math.abs(currentTime - discontinuitySync.time); // Once the distance begins to increase, we have passed
                        // currentTime and can stop looking for better candidates
                        if (lastDistance !== null && lastDistance < distance) break;
                        if (!syncPoint || lastDistance === null || lastDistance >= distance) {
                            lastDistance = distance;
                            syncPoint = {
                                time: discontinuitySync.time,
                                segmentIndex: segmentIndex,
                                partIndex: null
                            };
                        }
                    }
                }
            }
            return syncPoint;
        }
    },
    // Stategy "Playlist": We have a playlist with a known mapping of
    //                     segment index to display time
    {
        name: "Playlist",
        run: (syncController, playlist, duration, currentTimeline, currentTime)=>{
            if (playlist.syncInfo) {
                const syncPoint = {
                    time: playlist.syncInfo.time,
                    segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence,
                    partIndex: null
                };
                return syncPoint;
            }
            return null;
        }
    }
];
class $cb03b711053a4297$var$SyncController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(options = {}){
        super(); // ...for synching across variants
        this.timelines = [];
        this.discontinuities = [];
        this.timelineToDatetimeMappings = {};
        this.logger_ = $cb03b711053a4297$var$logger("SyncController");
    }
    /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @return {Object}
   *          A sync-point object
   */ getSyncPoint(playlist, duration, currentTimeline, currentTime) {
        const syncPoints = this.runStrategies_(playlist, duration, currentTimeline, currentTime);
        if (!syncPoints.length) // Signal that we need to attempt to get a sync-point manually
        // by fetching a segment in the playlist and constructing
        // a sync-point from that information
        return null;
         // Now find the sync-point that is closest to the currentTime because
        // that should result in the most accurate guess about which segment
        // to fetch
        return this.selectSyncPoint_(syncPoints, {
            key: "time",
            value: currentTime
        });
    }
    /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */ getExpiredTime(playlist, duration) {
        if (!playlist || !playlist.segments) return null;
        const syncPoints = this.runStrategies_(playlist, duration, playlist.discontinuitySequence, 0); // Without sync-points, there is not enough information to determine the expired time
        if (!syncPoints.length) return null;
        const syncPoint = this.selectSyncPoint_(syncPoints, {
            key: "segmentIndex",
            value: 0
        }); // If the sync-point is beyond the start of the playlist, we want to subtract the
        // duration from index 0 to syncPoint.segmentIndex instead of adding.
        if (syncPoint.segmentIndex > 0) syncPoint.time *= -1;
        return Math.abs(syncPoint.time + $cb03b711053a4297$var$sumDurations({
            defaultDuration: playlist.targetDuration,
            durationList: playlist.segments,
            startIndex: syncPoint.segmentIndex,
            endIndex: 0
        }));
    }
    /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @return {Array}
   *          A list of sync-point objects
   */ runStrategies_(playlist, duration, currentTimeline, currentTime) {
        const syncPoints = []; // Try to find a sync-point in by utilizing various strategies...
        for(let i = 0; i < $cb03b711053a4297$var$syncPointStrategies.length; i++){
            const strategy = $cb03b711053a4297$var$syncPointStrategies[i];
            const syncPoint = strategy.run(this, playlist, duration, currentTimeline, currentTime);
            if (syncPoint) {
                syncPoint.strategy = strategy.name;
                syncPoints.push({
                    strategy: strategy.name,
                    syncPoint: syncPoint
                });
            }
        }
        return syncPoints;
    }
    /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */ selectSyncPoint_(syncPoints, target) {
        let bestSyncPoint = syncPoints[0].syncPoint;
        let bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
        let bestStrategy = syncPoints[0].strategy;
        for(let i = 1; i < syncPoints.length; i++){
            const newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
            if (newDistance < bestDistance) {
                bestDistance = newDistance;
                bestSyncPoint = syncPoints[i].syncPoint;
                bestStrategy = syncPoints[i].strategy;
            }
        }
        this.logger_(`syncPoint for [${target.key}: ${target.value}] chosen with strategy` + ` [${bestStrategy}]: [time:${bestSyncPoint.time},` + ` segmentIndex:${bestSyncPoint.segmentIndex}` + (typeof bestSyncPoint.partIndex === "number" ? `,partIndex:${bestSyncPoint.partIndex}` : "") + "]");
        return bestSyncPoint;
    }
    /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */ saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
        const mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence; // Ignore large media sequence gaps
        if (mediaSequenceDiff > $cb03b711053a4297$var$MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Not saving expired segment info. Media sequence gap ${mediaSequenceDiff} is too large.`);
            return;
        } // When a segment expires from the playlist and it has a start time
        // save that information as a possible sync-point reference in future
        for(let i = mediaSequenceDiff - 1; i >= 0; i--){
            const lastRemovedSegment = oldPlaylist.segments[i];
            if (lastRemovedSegment && typeof lastRemovedSegment.start !== "undefined") {
                newPlaylist.syncInfo = {
                    mediaSequence: oldPlaylist.mediaSequence + i,
                    time: lastRemovedSegment.start
                };
                this.logger_(`playlist refresh sync: [time:${newPlaylist.syncInfo.time},` + ` mediaSequence: ${newPlaylist.syncInfo.mediaSequence}]`);
                this.trigger("syncinfoupdate");
                break;
            }
        }
    }
    /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */ setDateTimeMappingForStart(playlist) {
        // It's possible for the playlist to be updated before playback starts, meaning time
        // zero is not yet set. If, during these playlist refreshes, a discontinuity is
        // crossed, then the old time zero mapping (for the prior timeline) would be retained
        // unless the mappings are cleared.
        this.timelineToDatetimeMappings = {};
        if (playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
            const firstSegment = playlist.segments[0];
            const playlistTimestamp = firstSegment.dateTimeObject.getTime() / 1000;
            this.timelineToDatetimeMappings[firstSegment.timeline] = -playlistTimestamp;
        }
    }
    /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */ saveSegmentTimingInfo({ segmentInfo: segmentInfo, shouldSaveTimelineMapping: shouldSaveTimelineMapping }) {
        const didCalculateSegmentTimeMapping = this.calculateSegmentTimeMapping_(segmentInfo, segmentInfo.timingInfo, shouldSaveTimelineMapping);
        const segment = segmentInfo.segment;
        if (didCalculateSegmentTimeMapping) {
            this.saveDiscontinuitySyncInfo_(segmentInfo); // If the playlist does not have sync information yet, record that information
            // now with segment timing information
            if (!segmentInfo.playlist.syncInfo) segmentInfo.playlist.syncInfo = {
                mediaSequence: segmentInfo.playlist.mediaSequence + segmentInfo.mediaIndex,
                time: segment.start
            };
        }
        const dateTime = segment.dateTimeObject;
        if (segment.discontinuity && shouldSaveTimelineMapping && dateTime) this.timelineToDatetimeMappings[segment.timeline] = -(dateTime.getTime() / 1000);
    }
    timestampOffsetForTimeline(timeline) {
        if (typeof this.timelines[timeline] === "undefined") return null;
        return this.timelines[timeline].time;
    }
    mappingForTimeline(timeline) {
        if (typeof this.timelines[timeline] === "undefined") return null;
        return this.timelines[timeline].mapping;
    }
    /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */ calculateSegmentTimeMapping_(segmentInfo, timingInfo, shouldSaveTimelineMapping) {
        // TODO: remove side effects
        const segment = segmentInfo.segment;
        const part = segmentInfo.part;
        let mappingObj = this.timelines[segmentInfo.timeline];
        let start;
        let end;
        if (typeof segmentInfo.timestampOffset === "number") {
            mappingObj = {
                time: segmentInfo.startOfSegment,
                mapping: segmentInfo.startOfSegment - timingInfo.start
            };
            if (shouldSaveTimelineMapping) {
                this.timelines[segmentInfo.timeline] = mappingObj;
                this.trigger("timestampoffset");
                this.logger_(`time mapping for timeline ${segmentInfo.timeline}: ` + `[time: ${mappingObj.time}] [mapping: ${mappingObj.mapping}]`);
            }
            start = segmentInfo.startOfSegment;
            end = timingInfo.end + mappingObj.mapping;
        } else if (mappingObj) {
            start = timingInfo.start + mappingObj.mapping;
            end = timingInfo.end + mappingObj.mapping;
        } else return false;
        if (part) {
            part.start = start;
            part.end = end;
        } // If we don't have a segment start yet or the start value we got
        // is less than our current segment.start value, save a new start value.
        // We have to do this because parts will have segment timing info saved
        // multiple times and we want segment start to be the earliest part start
        // value for that segment.
        if (!segment.start || start < segment.start) segment.start = start;
        segment.end = end;
        return true;
    }
    /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */ saveDiscontinuitySyncInfo_(segmentInfo) {
        const playlist = segmentInfo.playlist;
        const segment = segmentInfo.segment; // If the current segment is a discontinuity then we know exactly where
        // the start of the range and it's accuracy is 0 (greater accuracy values
        // mean more approximation)
        if (segment.discontinuity) this.discontinuities[segment.timeline] = {
            time: segment.start,
            accuracy: 0
        };
        else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) // Search for future discontinuities that we can provide better timing
        // information for and save that information for sync purposes
        for(let i = 0; i < playlist.discontinuityStarts.length; i++){
            const segmentIndex = playlist.discontinuityStarts[i];
            const discontinuity = playlist.discontinuitySequence + i + 1;
            const mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
            const accuracy = Math.abs(mediaIndexDiff);
            if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
                let time;
                if (mediaIndexDiff < 0) time = segment.start - $cb03b711053a4297$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: playlist.segments,
                    startIndex: segmentInfo.mediaIndex,
                    endIndex: segmentIndex
                });
                else time = segment.end + $cb03b711053a4297$var$sumDurations({
                    defaultDuration: playlist.targetDuration,
                    durationList: playlist.segments,
                    startIndex: segmentInfo.mediaIndex + 1,
                    endIndex: segmentIndex
                });
                this.discontinuities[discontinuity] = {
                    time: time,
                    accuracy: accuracy
                };
            }
        }
    }
    dispose() {
        this.trigger("dispose");
        this.off();
    }
}
/**
 * The TimelineChangeController acts as a source for segment loaders to listen for and
 * keep track of latest and pending timeline changes. This is useful to ensure proper
 * sync, as each loader may need to make a consideration for what timeline the other
 * loader is on before making changes which could impact the other loader's media.
 *
 * @class TimelineChangeController
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$TimelineChangeController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(){
        super();
        this.pendingTimelineChanges_ = {};
        this.lastTimelineChanges_ = {};
    }
    clearPendingTimelineChange(type) {
        this.pendingTimelineChanges_[type] = null;
        this.trigger("pendingtimelinechange");
    }
    pendingTimelineChange({ type: type, from: from, to: to }) {
        if (typeof from === "number" && typeof to === "number") {
            this.pendingTimelineChanges_[type] = {
                type: type,
                from: from,
                to: to
            };
            this.trigger("pendingtimelinechange");
        }
        return this.pendingTimelineChanges_[type];
    }
    lastTimelineChange({ type: type, from: from, to: to }) {
        if (typeof from === "number" && typeof to === "number") {
            this.lastTimelineChanges_[type] = {
                type: type,
                from: from,
                to: to
            };
            delete this.pendingTimelineChanges_[type];
            this.trigger("timelinechange");
        }
        return this.lastTimelineChanges_[type];
    }
    dispose() {
        this.trigger("dispose");
        this.pendingTimelineChanges_ = {};
        this.lastTimelineChanges_ = {};
        this.off();
    }
}
/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */ const $cb03b711053a4297$var$workerCode = $cb03b711053a4297$var$transform($cb03b711053a4297$var$getWorkerString(function() {
    /**
   * @file stream.js
   */ /**
   * A lightweight readable stream implemention that handles event dispatching.
   *
   * @class Stream
   */ var Stream = /*#__PURE__*/ function() {
        function Stream() {
            this.listeners = {};
        }
        /**
     * Add a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener the callback to be invoked when an event of
     * the specified type occurs
     */ var _proto = Stream.prototype;
        _proto.on = function on(type, listener) {
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push(listener);
        } /**
     * Remove a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener  a function previously registered for this
     * type of event through `on`
     * @return {boolean} if we could turn it off or not
     */ ;
        _proto.off = function off(type, listener) {
            if (!this.listeners[type]) return false;
            var index = this.listeners[type].indexOf(listener); // TODO: which is better?
            // In Video.js we slice listener functions
            // on trigger so that it does not mess up the order
            // while we loop through.
            //
            // Here we slice on off so that the loop in trigger
            // can continue using it's old reference to loop without
            // messing up the order.
            this.listeners[type] = this.listeners[type].slice(0);
            this.listeners[type].splice(index, 1);
            return index > -1;
        } /**
     * Trigger an event of the specified type on this stream. Any additional
     * arguments to this function are passed as parameters to event listeners.
     *
     * @param {string} type the event name
     */ ;
        _proto.trigger = function trigger(type) {
            var callbacks = this.listeners[type];
            if (!callbacks) return;
             // Slicing the arguments on every invocation of this method
            // can add a significant amount of overhead. Avoid the
            // intermediate object creation for the common case of a
            // single callback argument
            if (arguments.length === 2) {
                var length = callbacks.length;
                for(var i = 0; i < length; ++i)callbacks[i].call(this, arguments[1]);
            } else {
                var args = Array.prototype.slice.call(arguments, 1);
                var _length = callbacks.length;
                for(var _i = 0; _i < _length; ++_i)callbacks[_i].apply(this, args);
            }
        } /**
     * Destroys the stream and cleans up.
     */ ;
        _proto.dispose = function dispose() {
            this.listeners = {};
        } /**
     * Forwards all `data` events on this stream to the destination stream. The
     * destination stream should provide a method `push` to receive the data
     * events as they arrive.
     *
     * @param {Stream} destination the stream that will receive all `data` events
     * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
     */ ;
        _proto.pipe = function pipe(destination) {
            this.on("data", function(data) {
                destination.push(data);
            });
        };
        return Stream;
    }();
    /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */ /**
   * Returns the subarray of a Uint8Array without PKCS#7 padding.
   *
   * @param padded {Uint8Array} unencrypted bytes that have been padded
   * @return {Uint8Array} the unpadded bytes
   * @see http://tools.ietf.org/html/rfc5652
   */ function unpad(padded) {
        return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
    }
    /*! @name aes-decrypter @version 4.0.1 @license Apache-2.0 */ /**
   * @file aes.js
   *
   * This file contains an adaptation of the AES decryption algorithm
   * from the Standford Javascript Cryptography Library. That work is
   * covered by the following copyright and permissions notice:
   *
   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are
   * met:
   *
   * 1. Redistributions of source code must retain the above copyright
   *    notice, this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above
   *    copyright notice, this list of conditions and the following
   *    disclaimer in the documentation and/or other materials provided
   *    with the distribution.
   *
   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   * The views and conclusions contained in the software and documentation
   * are those of the authors and should not be interpreted as representing
   * official policies, either expressed or implied, of the authors.
   */ /**
   * Expand the S-box tables.
   *
   * @private
   */ const precompute = function() {
        const tables = [
            [
                [],
                [],
                [],
                [],
                []
            ],
            [
                [],
                [],
                [],
                [],
                []
            ]
        ];
        const encTable = tables[0];
        const decTable = tables[1];
        const sbox = encTable[4];
        const sboxInv = decTable[4];
        let i;
        let x;
        let xInv;
        const d = [];
        const th = [];
        let x2;
        let x4;
        let x8;
        let s;
        let tEnc;
        let tDec; // Compute double and third tables
        for(i = 0; i < 256; i++)th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
        for(x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1){
            // Compute sbox
            s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
            s = s >> 8 ^ s & 255 ^ 99;
            sbox[x] = s;
            sboxInv[s] = x; // Compute MixColumns
            x8 = d[x4 = d[x2 = d[x]]];
            tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            tEnc = d[s] * 0x101 ^ s * 0x1010100;
            for(i = 0; i < 4; i++){
                encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
                decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
            }
        } // Compactify. Considerable speedup on Firefox.
        for(i = 0; i < 5; i++){
            encTable[i] = encTable[i].slice(0);
            decTable[i] = decTable[i].slice(0);
        }
        return tables;
    };
    let aesTables = null;
    /**
   * Schedule out an AES key for both encryption and decryption. This
   * is a low-level class. Use a cipher mode to do bulk encryption.
   *
   * @class AES
   * @param key {Array} The key as an array of 4, 6 or 8 words.
   */ class AES {
        constructor(key){
            /**
      * The expanded S-box and inverse S-box tables. These will be computed
      * on the client so that we don't have to send them down the wire.
      *
      * There are two tables, _tables[0] is for encryption and
      * _tables[1] is for decryption.
      *
      * The first 4 sub-tables are the expanded S-box with MixColumns. The
      * last (_tables[01][4]) is the S-box itself.
      *
      * @private
      */ // if we have yet to precompute the S-box tables
            // do so now
            if (!aesTables) aesTables = precompute();
             // then make a copy of that object for use
            this._tables = [
                [
                    aesTables[0][0].slice(),
                    aesTables[0][1].slice(),
                    aesTables[0][2].slice(),
                    aesTables[0][3].slice(),
                    aesTables[0][4].slice()
                ],
                [
                    aesTables[1][0].slice(),
                    aesTables[1][1].slice(),
                    aesTables[1][2].slice(),
                    aesTables[1][3].slice(),
                    aesTables[1][4].slice()
                ]
            ];
            let i;
            let j;
            let tmp;
            const sbox = this._tables[0][4];
            const decTable = this._tables[1];
            const keyLen = key.length;
            let rcon = 1;
            if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) throw new Error("Invalid aes key size");
            const encKey = key.slice(0);
            const decKey = [];
            this._key = [
                encKey,
                decKey
            ]; // schedule encryption keys
            for(i = keyLen; i < 4 * keyLen + 28; i++){
                tmp = encKey[i - 1]; // apply sbox
                if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
                    tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255]; // shift rows and add rcon
                    if (i % keyLen === 0) {
                        tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
                        rcon = rcon << 1 ^ (rcon >> 7) * 283;
                    }
                }
                encKey[i] = encKey[i - keyLen] ^ tmp;
            } // schedule decryption keys
            for(j = 0; i; j++, i--){
                tmp = encKey[j & 3 ? i : i - 4];
                if (i <= 4 || j < 4) decKey[j] = tmp;
                else decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
            }
        }
        /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */ decrypt(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
            const key = this._key[1]; // state variables a,b,c,d are loaded with pre-whitened data
            let a = encrypted0 ^ key[0];
            let b = encrypted3 ^ key[1];
            let c = encrypted2 ^ key[2];
            let d = encrypted1 ^ key[3];
            let a2;
            let b2;
            let c2; // key.length === 2 ?
            const nInnerRounds = key.length / 4 - 2;
            let i;
            let kIndex = 4;
            const table = this._tables[1]; // load up the tables
            const table0 = table[0];
            const table1 = table[1];
            const table2 = table[2];
            const table3 = table[3];
            const sbox = table[4]; // Inner rounds. Cribbed from OpenSSL.
            for(i = 0; i < nInnerRounds; i++){
                a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
                b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
                c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
                d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
                kIndex += 4;
                a = a2;
                b = b2;
                c = c2;
            } // Last round.
            for(i = 0; i < 4; i++){
                out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
                a2 = a;
                a = b;
                b = c;
                c = d;
                d = a2;
            }
        }
    }
    /**
   * @file async-stream.js
   */ /**
   * A wrapper around the Stream class to use setTimeout
   * and run stream "jobs" Asynchronously
   *
   * @class AsyncStream
   * @extends Stream
   */ class AsyncStream extends Stream {
        constructor(){
            super(Stream);
            this.jobs = [];
            this.delay = 1;
            this.timeout_ = null;
        }
        /**
     * process an async job
     *
     * @private
     */ processJob_() {
            this.jobs.shift()();
            if (this.jobs.length) this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
            else this.timeout_ = null;
        }
        /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */ push(job) {
            this.jobs.push(job);
            if (!this.timeout_) this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
        }
    }
    /**
   * @file decrypter.js
   *
   * An asynchronous implementation of AES-128 CBC decryption with
   * PKCS#7 padding.
   */ /**
   * Convert network-order (big-endian) bytes into their little-endian
   * representation.
   */ const ntoh = function(word) {
        return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    };
    /**
   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * use for the first round of CBC.
   * @return {Uint8Array} the decrypted bytes
   *
   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
   * @see https://tools.ietf.org/html/rfc2315
   */ const decrypt = function(encrypted, key, initVector) {
        // word-level access to the encrypted bytes
        const encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
        const decipher = new AES(Array.prototype.slice.call(key)); // byte and word-level access for the decrypted output
        const decrypted = new Uint8Array(encrypted.byteLength);
        const decrypted32 = new Int32Array(decrypted.buffer); // temporary variables for working with the IV, encrypted, and
        // decrypted data
        let init0;
        let init1;
        let init2;
        let init3;
        let encrypted0;
        let encrypted1;
        let encrypted2;
        let encrypted3; // iteration variable
        let wordIx; // pull out the words of the IV to ensure we don't modify the
        // passed-in reference and easier access
        init0 = initVector[0];
        init1 = initVector[1];
        init2 = initVector[2];
        init3 = initVector[3]; // decrypt four word sequences, applying cipher-block chaining (CBC)
        // to each decrypted block
        for(wordIx = 0; wordIx < encrypted32.length; wordIx += 4){
            // convert big-endian (network order) words into little-endian
            // (javascript order)
            encrypted0 = ntoh(encrypted32[wordIx]);
            encrypted1 = ntoh(encrypted32[wordIx + 1]);
            encrypted2 = ntoh(encrypted32[wordIx + 2]);
            encrypted3 = ntoh(encrypted32[wordIx + 3]); // decrypt the block
            decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx); // XOR with the IV, and restore network byte-order to obtain the
            // plaintext
            decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
            decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
            decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
            decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3); // setup the IV for the next round
            init0 = encrypted0;
            init1 = encrypted1;
            init2 = encrypted2;
            init3 = encrypted3;
        }
        return decrypted;
    };
    /**
   * The `Decrypter` class that manages decryption of AES
   * data through `AsyncStream` objects and the `decrypt`
   * function
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * @param {Function} done the function to run when done
   * @class Decrypter
   */ class Decrypter {
        constructor(encrypted, key, initVector, done){
            const step = Decrypter.STEP;
            const encrypted32 = new Int32Array(encrypted.buffer);
            const decrypted = new Uint8Array(encrypted.byteLength);
            let i = 0;
            this.asyncStream_ = new AsyncStream(); // split up the encryption job and do the individual chunks asynchronously
            this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
            for(i = step; i < encrypted32.length; i += step){
                initVector = new Uint32Array([
                    ntoh(encrypted32[i - 4]),
                    ntoh(encrypted32[i - 3]),
                    ntoh(encrypted32[i - 2]),
                    ntoh(encrypted32[i - 1])
                ]);
                this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
            } // invoke the done() callback when everything is finished
            this.asyncStream_.push(function() {
                // remove pkcs#7 padding from the decrypted bytes
                done(null, unpad(decrypted));
            });
        }
        /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */ static get STEP() {
            // 4 * 8000;
            return 32000;
        }
        /**
     * @private
     */ decryptChunk_(encrypted, key, initVector, decrypted) {
            return function() {
                const bytes = decrypt(encrypted, key, initVector);
                decrypted.set(bytes, encrypted.byteOffset);
            };
        }
    }
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    var win;
    if (typeof window !== "undefined") win = window;
    else if (typeof commonjsGlobal !== "undefined") win = commonjsGlobal;
    else if (typeof self !== "undefined") win = self;
    else win = {};
    var window_1 = win;
    var isArrayBufferView = function isArrayBufferView(obj) {
        if (ArrayBuffer.isView === "function") return ArrayBuffer.isView(obj);
        return obj && obj.buffer instanceof ArrayBuffer;
    };
    var BigInt = window_1.BigInt || Number;
    BigInt("0x1"), BigInt("0x100"), BigInt("0x10000"), BigInt("0x1000000"), BigInt("0x100000000"), BigInt("0x10000000000"), BigInt("0x1000000000000"), BigInt("0x100000000000000"), BigInt("0x10000000000000000");
    (function() {
        var a = new Uint16Array([
            0xFFCC
        ]);
        var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
        if (b[0] === 0xFF) return "big";
        if (b[0] === 0xCC) return "little";
        return "unknown";
    })();
    /**
   * Creates an object for sending to a web worker modifying properties that are TypedArrays
   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
   *
   * @param {Object} message
   *        Object of properties and values to send to the web worker
   * @return {Object}
   *         Modified message with TypedArray values expanded
   * @function createTransferableMessage
   */ const createTransferableMessage = function(message) {
        const transferable = {};
        Object.keys(message).forEach((key)=>{
            const value = message[key];
            if (isArrayBufferView(value)) transferable[key] = {
                bytes: value.buffer,
                byteOffset: value.byteOffset,
                byteLength: value.byteLength
            };
            else transferable[key] = value;
        });
        return transferable;
    };
    /* global self */ /**
   * Our web worker interface so that things can talk to aes-decrypter
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   */ self.onmessage = function(event) {
        const data = event.data;
        const encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
        const key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
        const iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
        /* eslint-disable no-new, handle-callback-err */ new Decrypter(encrypted, key, iv, function(err, bytes) {
            self.postMessage(createTransferableMessage({
                source: data.source,
                decrypted: bytes
            }), [
                bytes.buffer
            ]);
        });
    /* eslint-enable */ };
}));
var $cb03b711053a4297$var$Decrypter = $cb03b711053a4297$var$factory($cb03b711053a4297$var$workerCode);
/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */ /**
 * Convert the properties of an HLS track into an audioTrackKind.
 *
 * @private
 */ const $cb03b711053a4297$var$audioTrackKind_ = (properties)=>{
    let kind = properties.default ? "main" : "alternative";
    if (properties.characteristics && properties.characteristics.indexOf("public.accessibility.describes-video") >= 0) kind = "main-desc";
    return kind;
};
/**
 * Pause provided segment loader and playlist loader if active
 *
 * @param {SegmentLoader} segmentLoader
 *        SegmentLoader to pause
 * @param {Object} mediaType
 *        Active media type
 * @function stopLoaders
 */ const $cb03b711053a4297$var$stopLoaders = (segmentLoader, mediaType)=>{
    segmentLoader.abort();
    segmentLoader.pause();
    if (mediaType && mediaType.activePlaylistLoader) {
        mediaType.activePlaylistLoader.pause();
        mediaType.activePlaylistLoader = null;
    }
};
/**
 * Start loading provided segment loader and playlist loader
 *
 * @param {PlaylistLoader} playlistLoader
 *        PlaylistLoader to start loading
 * @param {Object} mediaType
 *        Active media type
 * @function startLoaders
 */ const $cb03b711053a4297$var$startLoaders = (playlistLoader, mediaType)=>{
    // Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
    // playlist loader
    mediaType.activePlaylistLoader = playlistLoader;
    playlistLoader.load();
};
/**
 * Returns a function to be called when the media group changes. It performs a
 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
 * change of group is merely a rendition switch of the same content at another encoding,
 * rather than a change of content, such as switching audio from English to Spanish.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a non-destructive resync of SegmentLoader when the active media
 *         group changes.
 * @function onGroupChanged
 */ const $cb03b711053a4297$var$onGroupChanged = (type, settings)=>()=>{
        const { segmentLoaders: { [type]: segmentLoader, main: mainSegmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        const activeTrack = mediaType.activeTrack();
        const activeGroup = mediaType.getActiveGroup();
        const previousActiveLoader = mediaType.activePlaylistLoader;
        const lastGroup = mediaType.lastGroup_; // the group did not change do nothing
        if (activeGroup && lastGroup && activeGroup.id === lastGroup.id) return;
        mediaType.lastGroup_ = activeGroup;
        mediaType.lastTrack_ = activeTrack;
        $cb03b711053a4297$var$stopLoaders(segmentLoader, mediaType);
        if (!activeGroup || activeGroup.isMainPlaylist) // there is no group active or active group is a main playlist and won't change
        return;
        if (!activeGroup.playlistLoader) {
            if (previousActiveLoader) // The previous group had a playlist loader but the new active group does not
            // this means we are switching from demuxed to muxed audio. In this case we want to
            // do a destructive reset of the main segment loader and not restart the audio
            // loaders.
            mainSegmentLoader.resetEverything();
            return;
        } // Non-destructive resync
        segmentLoader.resyncLoader();
        $cb03b711053a4297$var$startLoaders(activeGroup.playlistLoader, mediaType);
    };
const $cb03b711053a4297$var$onGroupChanging = (type, settings)=>()=>{
        const { segmentLoaders: { [type]: segmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        mediaType.lastGroup_ = null;
        segmentLoader.abort();
        segmentLoader.pause();
    };
/**
 * Returns a function to be called when the media track changes. It performs a
 * destructive reset of the SegmentLoader to ensure we start loading as close to
 * currentTime as possible.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a destructive reset of SegmentLoader when the active media
 *         track changes.
 * @function onTrackChanged
 */ const $cb03b711053a4297$var$onTrackChanged = (type, settings)=>()=>{
        const { mainPlaylistLoader: mainPlaylistLoader, segmentLoaders: { [type]: segmentLoader, main: mainSegmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        const activeTrack = mediaType.activeTrack();
        const activeGroup = mediaType.getActiveGroup();
        const previousActiveLoader = mediaType.activePlaylistLoader;
        const lastTrack = mediaType.lastTrack_; // track did not change, do nothing
        if (lastTrack && activeTrack && lastTrack.id === activeTrack.id) return;
        mediaType.lastGroup_ = activeGroup;
        mediaType.lastTrack_ = activeTrack;
        $cb03b711053a4297$var$stopLoaders(segmentLoader, mediaType);
        if (!activeGroup) // there is no group active so we do not want to restart loaders
        return;
        if (activeGroup.isMainPlaylist) {
            // track did not change, do nothing
            if (!activeTrack || !lastTrack || activeTrack.id === lastTrack.id) return;
            const pc = settings.vhs.playlistController_;
            const newPlaylist = pc.selectPlaylist(); // media will not change do nothing
            if (pc.media() === newPlaylist) return;
            mediaType.logger_(`track change. Switching main audio from ${lastTrack.id} to ${activeTrack.id}`);
            mainPlaylistLoader.pause();
            mainSegmentLoader.resetEverything();
            pc.fastQualityChange_(newPlaylist);
            return;
        }
        if (type === "AUDIO") {
            if (!activeGroup.playlistLoader) {
                // when switching from demuxed audio/video to muxed audio/video (noted by no
                // playlist loader for the audio group), we want to do a destructive reset of the
                // main segment loader and not restart the audio loaders
                mainSegmentLoader.setAudio(true); // don't have to worry about disabling the audio of the audio segment loader since
                // it should be stopped
                mainSegmentLoader.resetEverything();
                return;
            } // although the segment loader is an audio segment loader, call the setAudio
            // function to ensure it is prepared to re-append the init segment (or handle other
            // config changes)
            segmentLoader.setAudio(true);
            mainSegmentLoader.setAudio(false);
        }
        if (previousActiveLoader === activeGroup.playlistLoader) {
            // Nothing has actually changed. This can happen because track change events can fire
            // multiple times for a "single" change. One for enabling the new active track, and
            // one for disabling the track that was active
            $cb03b711053a4297$var$startLoaders(activeGroup.playlistLoader, mediaType);
            return;
        }
        if (segmentLoader.track) // For WebVTT, set the new text track in the segmentloader
        segmentLoader.track(activeTrack);
         // destructive reset
        segmentLoader.resetEverything();
        $cb03b711053a4297$var$startLoaders(activeGroup.playlistLoader, mediaType);
    };
const $cb03b711053a4297$var$onError = {
    /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */ AUDIO: (type, settings)=>()=>{
            const { mediaTypes: { [type]: mediaType }, excludePlaylist: excludePlaylist } = settings; // switch back to default audio track
            const activeTrack = mediaType.activeTrack();
            const activeGroup = mediaType.activeGroup();
            const id = (activeGroup.filter((group)=>group.default)[0] || activeGroup[0]).id;
            const defaultTrack = mediaType.tracks[id];
            if (activeTrack === defaultTrack) {
                // Default track encountered an error. All we can do now is exclude the current
                // rendition and hope another will switch audio groups
                excludePlaylist({
                    error: {
                        message: "Problem encountered loading the default audio track."
                    }
                });
                return;
            }
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
            for(const trackId in mediaType.tracks)mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
            mediaType.onTrackChanged();
        },
    /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */ SUBTITLES: (type, settings)=>()=>{
            const { mediaTypes: { [type]: mediaType } } = settings;
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
            const track = mediaType.activeTrack();
            if (track) track.mode = "disabled";
            mediaType.onTrackChanged();
        }
};
const $cb03b711053a4297$var$setupListeners = {
    /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */ AUDIO: (type, playlistLoader, settings)=>{
        if (!playlistLoader) // no playlist loader means audio will be muxed with the video
        return;
        const { tech: tech, requestOptions: requestOptions, segmentLoaders: { [type]: segmentLoader } } = settings;
        playlistLoader.on("loadedmetadata", ()=>{
            const media = playlistLoader.media();
            segmentLoader.playlist(media, requestOptions); // if the video is already playing, or if this isn't a live video and preload
            // permits, start downloading segments
            if (!tech.paused() || media.endList && tech.preload() !== "none") segmentLoader.load();
        });
        playlistLoader.on("loadedplaylist", ()=>{
            segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
            if (!tech.paused()) segmentLoader.load();
        });
        playlistLoader.on("error", $cb03b711053a4297$var$onError[type](type, settings));
    },
    /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */ SUBTITLES: (type, playlistLoader, settings)=>{
        const { tech: tech, requestOptions: requestOptions, segmentLoaders: { [type]: segmentLoader }, mediaTypes: { [type]: mediaType } } = settings;
        playlistLoader.on("loadedmetadata", ()=>{
            const media = playlistLoader.media();
            segmentLoader.playlist(media, requestOptions);
            segmentLoader.track(mediaType.activeTrack()); // if the video is already playing, or if this isn't a live video and preload
            // permits, start downloading segments
            if (!tech.paused() || media.endList && tech.preload() !== "none") segmentLoader.load();
        });
        playlistLoader.on("loadedplaylist", ()=>{
            segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
            if (!tech.paused()) segmentLoader.load();
        });
        playlistLoader.on("error", $cb03b711053a4297$var$onError[type](type, settings));
    }
};
const $cb03b711053a4297$var$initialize = {
    /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */ "AUDIO": (type, settings)=>{
        const { vhs: vhs, sourceType: sourceType, segmentLoaders: { [type]: segmentLoader }, requestOptions: requestOptions, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks, logger_: logger_ } }, mainPlaylistLoader: mainPlaylistLoader } = settings;
        const audioOnlyMain = $cb03b711053a4297$var$isAudioOnly(mainPlaylistLoader.main); // force a default if we have none
        if (!mediaGroups[type] || Object.keys(mediaGroups[type]).length === 0) {
            mediaGroups[type] = {
                main: {
                    default: {
                        default: true
                    }
                }
            };
            if (audioOnlyMain) mediaGroups[type].main.default.playlists = mainPlaylistLoader.main.playlists;
        }
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                let properties = mediaGroups[type][groupId][variantLabel];
                let playlistLoader;
                if (audioOnlyMain) {
                    logger_(`AUDIO group '${groupId}' label '${variantLabel}' is a main playlist`);
                    properties.isMainPlaylist = true;
                    playlistLoader = null; // if vhs-json was provided as the source, and the media playlist was resolved,
                // use the resolved media playlist object
                } else if (sourceType === "vhs-json" && properties.playlists) playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(properties.playlists[0], vhs, requestOptions);
                else if (properties.resolvedUri) playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(properties.resolvedUri, vhs, requestOptions); // TODO: dash isn't the only type with properties.playlists
                else if (properties.playlists && sourceType === "dash") playlistLoader = new $cb03b711053a4297$var$DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, mainPlaylistLoader);
                else // no resolvedUri means the audio is muxed with the video when using this
                // audio track
                playlistLoader = null;
                properties = $cb03b711053a4297$var$merge({
                    id: variantLabel,
                    playlistLoader: playlistLoader
                }, properties);
                $cb03b711053a4297$var$setupListeners[type](type, properties.playlistLoader, settings);
                groups[groupId].push(properties);
                if (typeof tracks[variantLabel] === "undefined") {
                    const track = new $cb03b711053a4297$export$2e2bcd8739ae039.AudioTrack({
                        id: variantLabel,
                        kind: $cb03b711053a4297$var$audioTrackKind_(properties),
                        enabled: false,
                        language: properties.language,
                        default: properties.default,
                        label: variantLabel
                    });
                    tracks[variantLabel] = track;
                }
            }
        } // setup single error event handler for the segment loader
        segmentLoader.on("error", $cb03b711053a4297$var$onError[type](type, settings));
    },
    /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */ "SUBTITLES": (type, settings)=>{
        const { tech: tech, vhs: vhs, sourceType: sourceType, segmentLoaders: { [type]: segmentLoader }, requestOptions: requestOptions, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks } }, mainPlaylistLoader: mainPlaylistLoader } = settings;
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                if (!vhs.options_.useForcedSubtitles && mediaGroups[type][groupId][variantLabel].forced) continue;
                let properties = mediaGroups[type][groupId][variantLabel];
                let playlistLoader;
                if (sourceType === "hls") playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
                else if (sourceType === "dash") {
                    const playlists = properties.playlists.filter((p)=>p.excludeUntil !== Infinity);
                    if (!playlists.length) return;
                    playlistLoader = new $cb03b711053a4297$var$DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, mainPlaylistLoader);
                } else if (sourceType === "vhs-json") playlistLoader = new $cb03b711053a4297$var$PlaylistLoader(// if the vhs-json object included the media playlist, use the media playlist
                // as provided, otherwise use the resolved URI to load the playlist
                properties.playlists ? properties.playlists[0] : properties.resolvedUri, vhs, requestOptions);
                properties = $cb03b711053a4297$var$merge({
                    id: variantLabel,
                    playlistLoader: playlistLoader
                }, properties);
                $cb03b711053a4297$var$setupListeners[type](type, properties.playlistLoader, settings);
                groups[groupId].push(properties);
                if (typeof tracks[variantLabel] === "undefined") {
                    const track = tech.addRemoteTextTrack({
                        id: variantLabel,
                        kind: "subtitles",
                        default: properties.default && properties.autoselect,
                        language: properties.language,
                        label: variantLabel
                    }, false).track;
                    tracks[variantLabel] = track;
                }
            }
        } // setup single error event handler for the segment loader
        segmentLoader.on("error", $cb03b711053a4297$var$onError[type](type, settings));
    },
    /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */ "CLOSED-CAPTIONS": (type, settings)=>{
        const { tech: tech, main: { mediaGroups: mediaGroups }, mediaTypes: { [type]: { groups: groups, tracks: tracks } } } = settings;
        for(const groupId in mediaGroups[type]){
            if (!groups[groupId]) groups[groupId] = [];
            for(const variantLabel in mediaGroups[type][groupId]){
                const properties = mediaGroups[type][groupId][variantLabel]; // Look for either 608 (CCn) or 708 (SERVICEn) caption services
                if (!/^(?:CC|SERVICE)/.test(properties.instreamId)) continue;
                const captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
                let newProps = {
                    label: variantLabel,
                    language: properties.language,
                    instreamId: properties.instreamId,
                    default: properties.default && properties.autoselect
                };
                if (captionServices[newProps.instreamId]) newProps = $cb03b711053a4297$var$merge(newProps, captionServices[newProps.instreamId]);
                if (newProps.default === undefined) delete newProps.default;
                 // No PlaylistLoader is required for Closed-Captions because the captions are
                // embedded within the video stream
                groups[groupId].push($cb03b711053a4297$var$merge({
                    id: variantLabel
                }, properties));
                if (typeof tracks[variantLabel] === "undefined") {
                    const track = tech.addRemoteTextTrack({
                        id: newProps.instreamId,
                        kind: "captions",
                        default: newProps.default,
                        language: newProps.language,
                        label: newProps.label
                    }, false).track;
                    tracks[variantLabel] = track;
                }
            }
        }
    }
};
const $cb03b711053a4297$var$groupMatch = (list, media)=>{
    for(let i = 0; i < list.length; i++){
        if ($cb03b711053a4297$var$playlistMatch(media, list[i])) return true;
        if (list[i].playlists && $cb03b711053a4297$var$groupMatch(list[i].playlists, media)) return true;
    }
    return false;
};
/**
 * Returns a function used to get the active group of the provided type
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Function that returns the active media group for the provided type. Takes an
 *         optional parameter {TextTrack} track. If no track is provided, a list of all
 *         variants in the group, otherwise the variant corresponding to the provided
 *         track is returned.
 * @function activeGroup
 */ const $cb03b711053a4297$var$activeGroup = (type, settings)=>(track)=>{
        const { mainPlaylistLoader: mainPlaylistLoader, mediaTypes: { [type]: { groups: groups } } } = settings;
        const media = mainPlaylistLoader.media();
        if (!media) return null;
        let variants = null; // set to variants to main media active group
        if (media.attributes[type]) variants = groups[media.attributes[type]];
        const groupKeys = Object.keys(groups);
        if (!variants) {
            // find the mainPlaylistLoader media
            // that is in a media group if we are dealing
            // with audio only
            if (type === "AUDIO" && groupKeys.length > 1 && $cb03b711053a4297$var$isAudioOnly(settings.main)) for(let i = 0; i < groupKeys.length; i++){
                const groupPropertyList = groups[groupKeys[i]];
                if ($cb03b711053a4297$var$groupMatch(groupPropertyList, media)) {
                    variants = groupPropertyList;
                    break;
                }
            } // use the main group if it exists
            else if (groups.main) variants = groups.main; // only one group, use that one
            else if (groupKeys.length === 1) variants = groups[groupKeys[0]];
        }
        if (typeof track === "undefined") return variants;
        if (track === null || !variants) // An active track was specified so a corresponding group is expected. track === null
        // means no track is currently active so there is no corresponding group
        return null;
        return variants.filter((props)=>props.id === track.id)[0] || null;
    };
const $cb03b711053a4297$var$activeTrack = {
    /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */ AUDIO: (type, settings)=>()=>{
            const { mediaTypes: { [type]: { tracks: tracks } } } = settings;
            for(const id in tracks){
                if (tracks[id].enabled) return tracks[id];
            }
            return null;
        },
    /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */ SUBTITLES: (type, settings)=>()=>{
            const { mediaTypes: { [type]: { tracks: tracks } } } = settings;
            for(const id in tracks){
                if (tracks[id].mode === "showing" || tracks[id].mode === "hidden") return tracks[id];
            }
            return null;
        }
};
const $cb03b711053a4297$var$getActiveGroup = (type, { mediaTypes: mediaTypes })=>()=>{
        const activeTrack_ = mediaTypes[type].activeTrack();
        if (!activeTrack_) return null;
        return mediaTypes[type].activeGroup(activeTrack_);
    };
/**
 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
 * Closed-Captions) specified in the main manifest.
 *
 * @param {Object} settings
 *        Object containing required information for setting up the media groups
 * @param {Tech} settings.tech
 *        The tech of the player
 * @param {Object} settings.requestOptions
 *        XHR request options used by the segment loaders
 * @param {PlaylistLoader} settings.mainPlaylistLoader
 *        PlaylistLoader for the main source
 * @param {VhsHandler} settings.vhs
 *        VHS SourceHandler
 * @param {Object} settings.main
 *        The parsed main manifest
 * @param {Object} settings.mediaTypes
 *        Object to store the loaders, tracks, and utility methods for each media type
 * @param {Function} settings.excludePlaylist
 *        Excludes the current rendition and forces a rendition switch.
 * @function setupMediaGroups
 */ const $cb03b711053a4297$var$setupMediaGroups = (settings)=>{
    [
        "AUDIO",
        "SUBTITLES",
        "CLOSED-CAPTIONS"
    ].forEach((type)=>{
        $cb03b711053a4297$var$initialize[type](type, settings);
    });
    const { mediaTypes: mediaTypes, mainPlaylistLoader: mainPlaylistLoader, tech: tech, vhs: vhs, segmentLoaders: { ["AUDIO"]: audioSegmentLoader, main: mainSegmentLoader } } = settings; // setup active group and track getters and change event handlers
    [
        "AUDIO",
        "SUBTITLES"
    ].forEach((type)=>{
        mediaTypes[type].activeGroup = $cb03b711053a4297$var$activeGroup(type, settings);
        mediaTypes[type].activeTrack = $cb03b711053a4297$var$activeTrack[type](type, settings);
        mediaTypes[type].onGroupChanged = $cb03b711053a4297$var$onGroupChanged(type, settings);
        mediaTypes[type].onGroupChanging = $cb03b711053a4297$var$onGroupChanging(type, settings);
        mediaTypes[type].onTrackChanged = $cb03b711053a4297$var$onTrackChanged(type, settings);
        mediaTypes[type].getActiveGroup = $cb03b711053a4297$var$getActiveGroup(type, settings);
    }); // DO NOT enable the default subtitle or caption track.
    // DO enable the default audio track
    const audioGroup = mediaTypes.AUDIO.activeGroup();
    if (audioGroup) {
        const groupId = (audioGroup.filter((group)=>group.default)[0] || audioGroup[0]).id;
        mediaTypes.AUDIO.tracks[groupId].enabled = true;
        mediaTypes.AUDIO.onGroupChanged();
        mediaTypes.AUDIO.onTrackChanged();
        const activeAudioGroup = mediaTypes.AUDIO.getActiveGroup(); // a similar check for handling setAudio on each loader is run again each time the
        // track is changed, but needs to be handled here since the track may not be considered
        // changed on the first call to onTrackChanged
        if (!activeAudioGroup.playlistLoader) // either audio is muxed with video or the stream is audio only
        mainSegmentLoader.setAudio(true);
        else {
            // audio is demuxed
            mainSegmentLoader.setAudio(false);
            audioSegmentLoader.setAudio(true);
        }
    }
    mainPlaylistLoader.on("mediachange", ()=>{
        [
            "AUDIO",
            "SUBTITLES"
        ].forEach((type)=>mediaTypes[type].onGroupChanged());
    });
    mainPlaylistLoader.on("mediachanging", ()=>{
        [
            "AUDIO",
            "SUBTITLES"
        ].forEach((type)=>mediaTypes[type].onGroupChanging());
    }); // custom audio track change event handler for usage event
    const onAudioTrackChanged = ()=>{
        mediaTypes.AUDIO.onTrackChanged();
        tech.trigger({
            type: "usage",
            name: "vhs-audio-change"
        });
    };
    tech.audioTracks().addEventListener("change", onAudioTrackChanged);
    tech.remoteTextTracks().addEventListener("change", mediaTypes.SUBTITLES.onTrackChanged);
    vhs.on("dispose", ()=>{
        tech.audioTracks().removeEventListener("change", onAudioTrackChanged);
        tech.remoteTextTracks().removeEventListener("change", mediaTypes.SUBTITLES.onTrackChanged);
    }); // clear existing audio tracks and add the ones we just created
    tech.clearTracks("audio");
    for(const id in mediaTypes.AUDIO.tracks)tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);
};
/**
 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
 * media type
 *
 * @return {Object}
 *         Object to store the loaders, tracks, and utility methods for each media type
 * @function createMediaTypes
 */ const $cb03b711053a4297$var$createMediaTypes = ()=>{
    const mediaTypes = {};
    [
        "AUDIO",
        "SUBTITLES",
        "CLOSED-CAPTIONS"
    ].forEach((type)=>{
        mediaTypes[type] = {
            groups: {},
            tracks: {},
            activePlaylistLoader: null,
            activeGroup: $cb03b711053a4297$var$noop,
            activeTrack: $cb03b711053a4297$var$noop,
            getActiveGroup: $cb03b711053a4297$var$noop,
            onGroupChanged: $cb03b711053a4297$var$noop,
            onTrackChanged: $cb03b711053a4297$var$noop,
            lastTrack_: null,
            logger_: $cb03b711053a4297$var$logger(`MediaGroups[${type}]`)
        };
    });
    return mediaTypes;
};
/**
 * A utility class for setting properties and maintaining the state of the content steering manifest.
 *
 * Content Steering manifest format:
 * VERSION: number (required) currently only version 1 is supported.
 * TTL: number in seconds (optional) until the next content steering manifest reload.
 * RELOAD-URI: string (optional) uri to fetch the next content steering manifest.
 * SERVICE-LOCATION-PRIORITY or PATHWAY-PRIORITY a non empty array of unique string values.
 */ class $cb03b711053a4297$var$SteeringManifest {
    constructor(){
        this.priority_ = [];
    }
    set version(number) {
        // Only version 1 is currently supported for both DASH and HLS.
        if (number === 1) this.version_ = number;
    }
    set ttl(seconds) {
        // TTL = time-to-live, default = 300 seconds.
        this.ttl_ = seconds || 300;
    }
    set reloadUri(uri) {
        if (uri) // reload URI can be relative to the previous reloadUri.
        this.reloadUri_ = $cb03b711053a4297$var$resolveUrl(this.reloadUri_, uri);
    }
    set priority(array) {
        // priority must be non-empty and unique values.
        if (array && array.length) this.priority_ = array;
    }
    get version() {
        return this.version_;
    }
    get ttl() {
        return this.ttl_;
    }
    get reloadUri() {
        return this.reloadUri_;
    }
    get priority() {
        return this.priority_;
    }
}
/**
 * This class represents a content steering manifest and associated state. See both HLS and DASH specifications.
 * HLS: https://developer.apple.com/streaming/HLSContentSteeringSpecification.pdf and
 * https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/ section 4.4.6.6.
 * DASH: https://dashif.org/docs/DASH-IF-CTS-00XX-Content-Steering-Community-Review.pdf
 *
 * @param {function} xhr for making a network request from the browser.
 * @param {function} bandwidth for fetching the current bandwidth from the main segment loader.
 */ class $cb03b711053a4297$var$ContentSteeringController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(xhr, bandwidth){
        super();
        this.currentPathway = null;
        this.defaultPathway = null;
        this.queryBeforeStart = null;
        this.availablePathways_ = new Set();
        this.excludedPathways_ = new Set();
        this.steeringManifest = new $cb03b711053a4297$var$SteeringManifest();
        this.proxyServerUrl_ = null;
        this.manifestType_ = null;
        this.ttlTimeout_ = null;
        this.request_ = null;
        this.excludedSteeringManifestURLs = new Set();
        this.logger_ = $cb03b711053a4297$var$logger("Content Steering");
        this.xhr_ = xhr;
        this.getBandwidth_ = bandwidth;
    }
    /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */ assignTagProperties(baseUrl, steeringTag) {
        this.manifestType_ = steeringTag.serverUri ? "HLS" : "DASH"; // serverUri is HLS serverURL is DASH
        const steeringUri = steeringTag.serverUri || steeringTag.serverURL;
        if (!steeringUri) {
            this.logger_(`steering manifest URL is ${steeringUri}, cannot request steering manifest.`);
            this.trigger("error");
            return;
        } // Content steering manifests can be encoded as a data URI. We can decode, parse and return early if that's the case.
        if (steeringUri.startsWith("data:")) {
            this.decodeDataUriManifest_(steeringUri.substring(steeringUri.indexOf(",") + 1));
            return;
        } // With DASH queryBeforeStart, we want to use the steeringUri as soon as possible for the request.
        this.steeringManifest.reloadUri = this.queryBeforeStart ? steeringUri : $cb03b711053a4297$var$resolveUrl(baseUrl, steeringUri); // pathwayId is HLS defaultServiceLocation is DASH
        this.defaultPathway = steeringTag.pathwayId || steeringTag.defaultServiceLocation; // currently only DASH supports the following properties on <ContentSteering> tags.
        this.queryBeforeStart = steeringTag.queryBeforeStart || false;
        this.proxyServerUrl_ = steeringTag.proxyServerURL || null; // trigger a steering event if we have a pathway from the content steering tag.
        // this tells VHS which segment pathway to start with.
        // If queryBeforeStart is true we need to wait for the steering manifest response.
        if (this.defaultPathway && !this.queryBeforeStart) this.trigger("content-steering");
        if (this.queryBeforeStart) this.requestSteeringManifest(this.steeringManifest.reloadUri);
    }
    /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario is specific to DASH when the queryBeforeStart parameter is true.
   *    This scenario should only happen once on initalization.
   */ requestSteeringManifest(initialUri) {
        const reloadUri = this.steeringManifest.reloadUri;
        if (!initialUri && !reloadUri) return;
         // We currently don't support passing MPD query parameters directly to the content steering URL as this requires
        // ExtUrlQueryInfo tag support. See the DASH content steering spec section 8.1.
        // This request URI accounts for manifest URIs that have been excluded.
        const uri = initialUri || this.getRequestURI(reloadUri); // If there are no valid manifest URIs, we should stop content steering.
        if (!uri) {
            this.logger_("No valid content steering manifest URIs. Stopping content steering.");
            this.trigger("error");
            this.dispose();
            return;
        }
        this.request_ = this.xhr_({
            uri: uri
        }, (error, errorInfo)=>{
            if (error) {
                // If the client receives HTTP 410 Gone in response to a manifest request,
                // it MUST NOT issue another request for that URI for the remainder of the
                // playback session. It MAY continue to use the most-recently obtained set
                // of Pathways.
                if (errorInfo.status === 410) {
                    this.logger_(`manifest request 410 ${error}.`);
                    this.logger_(`There will be no more content steering requests to ${uri} this session.`);
                    this.excludedSteeringManifestURLs.add(uri);
                    return;
                } // If the client receives HTTP 429 Too Many Requests with a Retry-After
                // header in response to a manifest request, it SHOULD wait until the time
                // specified by the Retry-After header to reissue the request.
                if (errorInfo.status === 429) {
                    const retrySeconds = errorInfo.responseHeaders["retry-after"];
                    this.logger_(`manifest request 429 ${error}.`);
                    this.logger_(`content steering will retry in ${retrySeconds} seconds.`);
                    this.startTTLTimeout_(parseInt(retrySeconds, 10));
                    return;
                } // If the Steering Manifest cannot be loaded and parsed correctly, the
                // client SHOULD continue to use the previous values and attempt to reload
                // it after waiting for the previously-specified TTL (or 5 minutes if
                // none).
                this.logger_(`manifest failed to load ${error}.`);
                this.startTTLTimeout_();
                return;
            }
            const steeringManifestJson = JSON.parse(this.request_.responseText);
            this.startTTLTimeout_();
            this.assignSteeringProperties_(steeringManifestJson);
        });
    }
    /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */ setProxyServerUrl_(steeringUrl) {
        const steeringUrlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(steeringUrl);
        const proxyServerUrlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(this.proxyServerUrl_);
        proxyServerUrlObject.searchParams.set("url", encodeURI(steeringUrlObject.toString()));
        return this.setSteeringParams_(proxyServerUrlObject.toString());
    }
    /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */ decodeDataUriManifest_(dataUri) {
        const steeringManifestJson = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($eDick))).atob(dataUri));
        this.assignSteeringProperties_(steeringManifestJson);
    }
    /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */ setSteeringParams_(url) {
        const urlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL(url);
        const path = this.getPathway();
        const networkThroughput = this.getBandwidth_();
        if (path) {
            const pathwayKey = `_${this.manifestType_}_pathway`;
            urlObject.searchParams.set(pathwayKey, path);
        }
        if (networkThroughput) {
            const throughputKey = `_${this.manifestType_}_throughput`;
            urlObject.searchParams.set(throughputKey, networkThroughput);
        }
        return urlObject.toString();
    }
    /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */ assignSteeringProperties_(steeringJson) {
        this.steeringManifest.version = steeringJson.VERSION;
        if (!this.steeringManifest.version) {
            this.logger_(`manifest version is ${steeringJson.VERSION}, which is not supported.`);
            this.trigger("error");
            return;
        }
        this.steeringManifest.ttl = steeringJson.TTL;
        this.steeringManifest.reloadUri = steeringJson["RELOAD-URI"]; // HLS = PATHWAY-PRIORITY required. DASH = SERVICE-LOCATION-PRIORITY optional
        this.steeringManifest.priority = steeringJson["PATHWAY-PRIORITY"] || steeringJson["SERVICE-LOCATION-PRIORITY"]; // TODO: HLS handle PATHWAY-CLONES. See section 7.2 https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
        // 1. apply first pathway from the array.
        // 2. if first pathway doesn't exist in manifest, try next pathway.
        //    a. if all pathways are exhausted, ignore the steering manifest priority.
        // 3. if segments fail from an established pathway, try all variants/renditions, then exclude the failed pathway.
        //    a. exclude a pathway for a minimum of the last TTL duration. Meaning, from the next steering response,
        //       the excluded pathway will be ignored.
        //       See excludePathway usage in excludePlaylist().
        // If there are no available pathways, we need to stop content steering.
        if (!this.availablePathways_.size) {
            this.logger_("There are no available pathways for content steering. Ending content steering.");
            this.trigger("error");
            this.dispose();
        }
        const chooseNextPathway = (pathwaysByPriority)=>{
            for (const path of pathwaysByPriority){
                if (this.availablePathways_.has(path)) return path;
            } // If no pathway matches, ignore the manifest and choose the first available.
            return [
                ...this.availablePathways_
            ][0];
        };
        const nextPathway = chooseNextPathway(this.steeringManifest.priority);
        if (this.currentPathway !== nextPathway) {
            this.currentPathway = nextPathway;
            this.trigger("content-steering");
        }
    }
    /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */ getPathway() {
        return this.currentPathway || this.defaultPathway;
    }
    /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */ getRequestURI(reloadUri) {
        if (!reloadUri) return null;
        const isExcluded = (uri)=>this.excludedSteeringManifestURLs.has(uri);
        if (this.proxyServerUrl_) {
            const proxyURI = this.setProxyServerUrl_(reloadUri);
            if (!isExcluded(proxyURI)) return proxyURI;
        }
        const steeringURI = this.setSteeringParams_(reloadUri);
        if (!isExcluded(steeringURI)) return steeringURI;
         // Return nothing if all valid manifest URIs are excluded.
        return null;
    }
    /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */ startTTLTimeout_(ttl = this.steeringManifest.ttl) {
        // 300 (5 minutes) is the default value.
        const ttlMS = ttl * 1000;
        this.ttlTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(()=>{
            this.requestSteeringManifest();
        }, ttlMS);
    }
    /**
   * Clear the TTL timeout if necessary.
   */ clearTTLTimeout_() {
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.ttlTimeout_);
        this.ttlTimeout_ = null;
    }
    /**
   * aborts any current steering xhr and sets the current request object to null
   */ abort() {
        if (this.request_) this.request_.abort();
        this.request_ = null;
    }
    /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */ dispose() {
        this.off("content-steering");
        this.off("error");
        this.abort();
        this.clearTTLTimeout_();
        this.currentPathway = null;
        this.defaultPathway = null;
        this.queryBeforeStart = null;
        this.proxyServerUrl_ = null;
        this.manifestType_ = null;
        this.ttlTimeout_ = null;
        this.request_ = null;
        this.excludedSteeringManifestURLs = new Set();
        this.availablePathways_ = new Set();
        this.excludedPathways_ = new Set();
        this.steeringManifest = new $cb03b711053a4297$var$SteeringManifest();
    }
    /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */ addAvailablePathway(pathway) {
        if (pathway) this.availablePathways_.add(pathway);
    }
    /**
   * clears all pathways from the available pathways set
   */ clearAvailablePathways() {
        this.availablePathways_.clear();
    }
    excludePathway(pathway) {
        return this.availablePathways_.delete(pathway);
    }
}
/**
 * @file playlist-controller.js
 */ const $cb03b711053a4297$var$ABORT_EARLY_EXCLUSION_SECONDS = 10;
let $cb03b711053a4297$var$Vhs$1; // SegmentLoader stats that need to have each loader's
// values summed to calculate the final value
const $cb03b711053a4297$var$loaderStats = [
    "mediaRequests",
    "mediaRequestsAborted",
    "mediaRequestsTimedout",
    "mediaRequestsErrored",
    "mediaTransferDuration",
    "mediaBytesTransferred",
    "mediaAppends"
];
const $cb03b711053a4297$var$sumLoaderStat = function(stat) {
    return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
};
const $cb03b711053a4297$var$shouldSwitchToMedia = function({ currentPlaylist: currentPlaylist, buffered: buffered, currentTime: currentTime, nextPlaylist: nextPlaylist, bufferLowWaterLine: bufferLowWaterLine, bufferHighWaterLine: bufferHighWaterLine, duration: duration, bufferBasedABR: bufferBasedABR, log: log }) {
    // we have no other playlist to switch to
    if (!nextPlaylist) {
        $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("We received no playlist to switch to. Please check your stream.");
        return false;
    }
    const sharedLogLine = `allowing switch ${currentPlaylist && currentPlaylist.id || "null"} -> ${nextPlaylist.id}`;
    if (!currentPlaylist) {
        log(`${sharedLogLine} as current playlist is not set`);
        return true;
    } // no need to switch if playlist is the same
    if (nextPlaylist.id === currentPlaylist.id) return false;
     // determine if current time is in a buffered range.
    const isBuffered = Boolean($cb03b711053a4297$var$findRange(buffered, currentTime).length); // If the playlist is live, then we want to not take low water line into account.
    // This is because in LIVE, the player plays 3 segments from the end of the
    // playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
    // in those segments, a viewer will never experience a rendition upswitch.
    if (!currentPlaylist.endList) {
        // For LLHLS live streams, don't switch renditions before playback has started, as it almost
        // doubles the time to first playback.
        if (!isBuffered && typeof currentPlaylist.partTargetDuration === "number") {
            log(`not ${sharedLogLine} as current playlist is live llhls, but currentTime isn't in buffered.`);
            return false;
        }
        log(`${sharedLogLine} as current playlist is live`);
        return true;
    }
    const forwardBuffer = $cb03b711053a4297$var$timeAheadOf(buffered, currentTime);
    const maxBufferLowWaterLine = bufferBasedABR ? $cb03b711053a4297$var$Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : $cb03b711053a4297$var$Config.MAX_BUFFER_LOW_WATER_LINE; // For the same reason as LIVE, we ignore the low water line when the VOD
    // duration is below the max potential low water line
    if (duration < maxBufferLowWaterLine) {
        log(`${sharedLogLine} as duration < max low water line (${duration} < ${maxBufferLowWaterLine})`);
        return true;
    }
    const nextBandwidth = nextPlaylist.attributes.BANDWIDTH;
    const currBandwidth = currentPlaylist.attributes.BANDWIDTH; // when switching down, if our buffer is lower than the high water line,
    // we can switch down
    if (nextBandwidth < currBandwidth && (!bufferBasedABR || forwardBuffer < bufferHighWaterLine)) {
        let logLine = `${sharedLogLine} as next bandwidth < current bandwidth (${nextBandwidth} < ${currBandwidth})`;
        if (bufferBasedABR) logLine += ` and forwardBuffer < bufferHighWaterLine (${forwardBuffer} < ${bufferHighWaterLine})`;
        log(logLine);
        return true;
    } // and if our buffer is higher than the low water line,
    // we can switch up
    if ((!bufferBasedABR || nextBandwidth > currBandwidth) && forwardBuffer >= bufferLowWaterLine) {
        let logLine = `${sharedLogLine} as forwardBuffer >= bufferLowWaterLine (${forwardBuffer} >= ${bufferLowWaterLine})`;
        if (bufferBasedABR) logLine += ` and next bandwidth > current bandwidth (${nextBandwidth} > ${currBandwidth})`;
        log(logLine);
        return true;
    }
    log(`not ${sharedLogLine} as no switching criteria met`);
    return false;
};
/**
 * the main playlist controller controller all interactons
 * between playlists and segmentloaders. At this time this mainly
 * involves a main playlist and a series of audio playlists
 * if they are available
 *
 * @class PlaylistController
 * @extends videojs.EventTarget
 */ class $cb03b711053a4297$var$PlaylistController extends $cb03b711053a4297$export$2e2bcd8739ae039.EventTarget {
    constructor(options){
        super();
        const { src: src, withCredentials: withCredentials, tech: tech, bandwidth: bandwidth, externVhs: externVhs, useCueTags: useCueTags, playlistExclusionDuration: playlistExclusionDuration, enableLowInitialPlaylist: enableLowInitialPlaylist, sourceType: sourceType, cacheEncryptionKeys: cacheEncryptionKeys, bufferBasedABR: bufferBasedABR, leastPixelDiffSelector: leastPixelDiffSelector, captionServices: captionServices } = options;
        if (!src) throw new Error("A non-empty playlist URL or JSON manifest string is required");
        let { maxPlaylistRetries: maxPlaylistRetries } = options;
        if (maxPlaylistRetries === null || typeof maxPlaylistRetries === "undefined") maxPlaylistRetries = Infinity;
        $cb03b711053a4297$var$Vhs$1 = externVhs;
        this.bufferBasedABR = Boolean(bufferBasedABR);
        this.leastPixelDiffSelector = Boolean(leastPixelDiffSelector);
        this.withCredentials = withCredentials;
        this.tech_ = tech;
        this.vhs_ = tech.vhs;
        this.sourceType_ = sourceType;
        this.useCueTags_ = useCueTags;
        this.playlistExclusionDuration = playlistExclusionDuration;
        this.maxPlaylistRetries = maxPlaylistRetries;
        this.enableLowInitialPlaylist = enableLowInitialPlaylist;
        if (this.useCueTags_) {
            this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues");
            this.cueTagsTrack_.inBandMetadataTrackDispatchType = "";
        }
        this.requestOptions_ = {
            withCredentials: withCredentials,
            maxPlaylistRetries: maxPlaylistRetries,
            timeout: null
        };
        this.on("error", this.pauseLoading);
        this.mediaTypes_ = $cb03b711053a4297$var$createMediaTypes();
        this.mediaSource = new (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).MediaSource();
        this.handleDurationChange_ = this.handleDurationChange_.bind(this);
        this.handleSourceOpen_ = this.handleSourceOpen_.bind(this);
        this.handleSourceEnded_ = this.handleSourceEnded_.bind(this);
        this.mediaSource.addEventListener("durationchange", this.handleDurationChange_); // load the media source into the player
        this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_);
        this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_); // we don't have to handle sourceclose since dispose will handle termination of
        // everything, and the MediaSource should not be detached without a proper disposal
        this.seekable_ = $cb03b711053a4297$var$createTimeRanges();
        this.hasPlayed_ = false;
        this.syncController_ = new $cb03b711053a4297$var$SyncController(options);
        this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
            kind: "metadata",
            label: "segment-metadata"
        }, false).track;
        this.decrypter_ = new $cb03b711053a4297$var$Decrypter();
        this.sourceUpdater_ = new $cb03b711053a4297$var$SourceUpdater(this.mediaSource);
        this.inbandTextTracks_ = {};
        this.timelineChangeController_ = new $cb03b711053a4297$var$TimelineChangeController();
        const segmentLoaderSettings = {
            vhs: this.vhs_,
            parse708captions: options.parse708captions,
            useDtsForTimestampOffset: options.useDtsForTimestampOffset,
            calculateTimestampOffsetForEachSegment: options.calculateTimestampOffsetForEachSegment,
            captionServices: captionServices,
            mediaSource: this.mediaSource,
            currentTime: this.tech_.currentTime.bind(this.tech_),
            seekable: ()=>this.seekable(),
            seeking: ()=>this.tech_.seeking(),
            duration: ()=>this.duration(),
            hasPlayed: ()=>this.hasPlayed_,
            goalBufferLength: ()=>this.goalBufferLength(),
            bandwidth: bandwidth,
            syncController: this.syncController_,
            decrypter: this.decrypter_,
            sourceType: this.sourceType_,
            inbandTextTracks: this.inbandTextTracks_,
            cacheEncryptionKeys: cacheEncryptionKeys,
            sourceUpdater: this.sourceUpdater_,
            timelineChangeController: this.timelineChangeController_,
            exactManifestTimings: options.exactManifestTimings,
            addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
        }; // The source type check not only determines whether a special DASH playlist loader
        // should be used, but also covers the case where the provided src is a vhs-json
        // manifest object (instead of a URL). In the case of vhs-json, the default
        // PlaylistLoader should be used.
        this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new $cb03b711053a4297$var$DashPlaylistLoader(src, this.vhs_, $cb03b711053a4297$var$merge(this.requestOptions_, {
            addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
        })) : new $cb03b711053a4297$var$PlaylistLoader(src, this.vhs_, $cb03b711053a4297$var$merge(this.requestOptions_, {
            addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
        }));
        this.setupMainPlaylistLoaderListeners_(); // setup segment loaders
        // combined audio/video or just video when alternate audio track is selected
        this.mainSegmentLoader_ = new $cb03b711053a4297$var$SegmentLoader($cb03b711053a4297$var$merge(segmentLoaderSettings, {
            segmentMetadataTrack: this.segmentMetadataTrack_,
            loaderType: "main"
        }), options); // alternate audio track
        this.audioSegmentLoader_ = new $cb03b711053a4297$var$SegmentLoader($cb03b711053a4297$var$merge(segmentLoaderSettings, {
            loaderType: "audio"
        }), options);
        this.subtitleSegmentLoader_ = new $cb03b711053a4297$var$VTTSegmentLoader($cb03b711053a4297$var$merge(segmentLoaderSettings, {
            loaderType: "vtt",
            featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
            loadVttJs: ()=>new Promise((resolve, reject)=>{
                    function onLoad() {
                        tech.off("vttjserror", onError);
                        resolve();
                    }
                    function onError() {
                        tech.off("vttjsloaded", onLoad);
                        reject();
                    }
                    tech.one("vttjsloaded", onLoad);
                    tech.one("vttjserror", onError); // safe to call multiple times, script will be loaded only once:
                    tech.addWebVttScript_();
                })
        }), options);
        const getBandwidth = ()=>{
            return this.mainSegmentLoader_.bandwidth;
        };
        this.contentSteeringController_ = new $cb03b711053a4297$var$ContentSteeringController(this.vhs_.xhr, getBandwidth);
        this.setupSegmentLoaderListeners_();
        if (this.bufferBasedABR) {
            this.mainPlaylistLoader_.one("loadedplaylist", ()=>this.startABRTimer_());
            this.tech_.on("pause", ()=>this.stopABRTimer_());
            this.tech_.on("play", ()=>this.startABRTimer_());
        } // Create SegmentLoader stat-getters
        // mediaRequests_
        // mediaRequestsAborted_
        // mediaRequestsTimedout_
        // mediaRequestsErrored_
        // mediaTransferDuration_
        // mediaBytesTransferred_
        // mediaAppends_
        $cb03b711053a4297$var$loaderStats.forEach((stat)=>{
            this[stat + "_"] = $cb03b711053a4297$var$sumLoaderStat.bind(this, stat);
        });
        this.logger_ = $cb03b711053a4297$var$logger("pc");
        this.triggeredFmp4Usage = false;
        if (this.tech_.preload() === "none") {
            this.loadOnPlay_ = ()=>{
                this.loadOnPlay_ = null;
                this.mainPlaylistLoader_.load();
            };
            this.tech_.one("play", this.loadOnPlay_);
        } else this.mainPlaylistLoader_.load();
        this.timeToLoadedData__ = -1;
        this.mainAppendsToLoadedData__ = -1;
        this.audioAppendsToLoadedData__ = -1;
        const event = this.tech_.preload() === "none" ? "play" : "loadstart"; // start the first frame timer on loadstart or play (for preload none)
        this.tech_.one(event, ()=>{
            const timeToLoadedDataStart = Date.now();
            this.tech_.one("loadeddata", ()=>{
                this.timeToLoadedData__ = Date.now() - timeToLoadedDataStart;
                this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends;
                this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
            });
        });
    }
    mainAppendsToLoadedData_() {
        return this.mainAppendsToLoadedData__;
    }
    audioAppendsToLoadedData_() {
        return this.audioAppendsToLoadedData__;
    }
    appendsToLoadedData_() {
        const main = this.mainAppendsToLoadedData_();
        const audio = this.audioAppendsToLoadedData_();
        if (main === -1 || audio === -1) return -1;
        return main + audio;
    }
    timeToLoadedData_() {
        return this.timeToLoadedData__;
    }
    /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */ checkABR_(reason = "abr") {
        const nextPlaylist = this.selectPlaylist();
        if (nextPlaylist && this.shouldSwitchToMedia_(nextPlaylist)) this.switchMedia_(nextPlaylist, reason);
    }
    switchMedia_(playlist, cause, delay) {
        const oldMedia = this.media();
        const oldId = oldMedia && (oldMedia.id || oldMedia.uri);
        const newId = playlist.id || playlist.uri;
        if (oldId && oldId !== newId) {
            this.logger_(`switch media ${oldId} -> ${newId} from ${cause}`);
            this.tech_.trigger({
                type: "usage",
                name: `vhs-rendition-change-${cause}`
            });
        }
        this.mainPlaylistLoader_.media(playlist, delay);
    }
    /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */ switchMediaForDASHContentSteering_() {
        [
            "AUDIO",
            "SUBTITLES",
            "CLOSED-CAPTIONS"
        ].forEach((type)=>{
            const mediaType = this.mediaTypes_[type];
            const activeGroup = mediaType ? mediaType.activeGroup() : null;
            const pathway = this.contentSteeringController_.getPathway();
            if (activeGroup && pathway) {
                // activeGroup can be an array or a single group
                const mediaPlaylists = activeGroup.length ? activeGroup[0].playlists : activeGroup.playlists;
                const dashMediaPlaylists = mediaPlaylists.filter((p)=>p.attributes.serviceLocation === pathway); // Switch the current active playlist to the correct CDN
                if (dashMediaPlaylists.length) this.mediaTypes_[type].activePlaylistLoader.media(dashMediaPlaylists[0]);
            }
        });
    }
    /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */ startABRTimer_() {
        this.stopABRTimer_();
        this.abrTimer_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setInterval(()=>this.checkABR_(), 250);
    }
    /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */ stopABRTimer_() {
        // if we're scrubbing, we don't need to pause.
        // This getter will be added to Video.js in version 7.11.
        if (this.tech_.scrubbing && this.tech_.scrubbing()) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearInterval(this.abrTimer_);
        this.abrTimer_ = null;
    }
    /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */ getAudioTrackPlaylists_() {
        const main = this.main();
        const defaultPlaylists = main && main.playlists || []; // if we don't have any audio groups then we can only
        // assume that the audio tracks are contained in main
        // playlist array, use that or an empty array.
        if (!main || !main.mediaGroups || !main.mediaGroups.AUDIO) return defaultPlaylists;
        const AUDIO = main.mediaGroups.AUDIO;
        const groupKeys = Object.keys(AUDIO);
        let track; // get the current active track
        if (Object.keys(this.mediaTypes_.AUDIO.groups).length) track = this.mediaTypes_.AUDIO.activeTrack(); // or get the default track from main if mediaTypes_ isn't setup yet
        else {
            // default group is `main` or just the first group.
            const defaultGroup = AUDIO.main || groupKeys.length && AUDIO[groupKeys[0]];
            for(const label in defaultGroup)if (defaultGroup[label].default) {
                track = {
                    label: label
                };
                break;
            }
        } // no active track no playlists.
        if (!track) return defaultPlaylists;
        const playlists = []; // get all of the playlists that are possible for the
        // active track.
        for(const group in AUDIO)if (AUDIO[group][track.label]) {
            const properties = AUDIO[group][track.label];
            if (properties.playlists && properties.playlists.length) playlists.push.apply(playlists, properties.playlists);
            else if (properties.uri) playlists.push(properties);
            else if (main.playlists.length) // if an audio group does not have a uri
            // see if we have main playlists that use it as a group.
            // if we do then add those to the playlists list.
            for(let i = 0; i < main.playlists.length; i++){
                const playlist = main.playlists[i];
                if (playlist.attributes && playlist.attributes.AUDIO && playlist.attributes.AUDIO === group) playlists.push(playlist);
            }
        }
        if (!playlists.length) return defaultPlaylists;
        return playlists;
    }
    /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */ setupMainPlaylistLoaderListeners_() {
        this.mainPlaylistLoader_.on("loadedmetadata", ()=>{
            const media = this.mainPlaylistLoader_.media();
            const requestTimeout = media.targetDuration * 1500; // If we don't have any more available playlists, we don't want to
            // timeout the request.
            if ($cb03b711053a4297$var$isLowestEnabledRendition(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media())) this.requestOptions_.timeout = 0;
            else this.requestOptions_.timeout = requestTimeout;
             // if this isn't a live video and preload permits, start
            // downloading segments
            if (media.endList && this.tech_.preload() !== "none") {
                this.mainSegmentLoader_.playlist(media, this.requestOptions_);
                this.mainSegmentLoader_.load();
            }
            $cb03b711053a4297$var$setupMediaGroups({
                sourceType: this.sourceType_,
                segmentLoaders: {
                    AUDIO: this.audioSegmentLoader_,
                    SUBTITLES: this.subtitleSegmentLoader_,
                    main: this.mainSegmentLoader_
                },
                tech: this.tech_,
                requestOptions: this.requestOptions_,
                mainPlaylistLoader: this.mainPlaylistLoader_,
                vhs: this.vhs_,
                main: this.main(),
                mediaTypes: this.mediaTypes_,
                excludePlaylist: this.excludePlaylist.bind(this)
            });
            this.triggerPresenceUsage_(this.main(), media);
            this.setupFirstPlay();
            if (!this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media()) this.trigger("selectedinitialmedia");
            else // We must wait for the active audio playlist loader to
            // finish setting up before triggering this event so the
            // representations API and EME setup is correct
            this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", ()=>{
                this.trigger("selectedinitialmedia");
            });
        });
        this.mainPlaylistLoader_.on("loadedplaylist", ()=>{
            if (this.loadOnPlay_) this.tech_.off("play", this.loadOnPlay_);
            let updatedPlaylist = this.mainPlaylistLoader_.media();
            if (!updatedPlaylist) {
                this.initContentSteeringController_(); // exclude any variants that are not supported by the browser before selecting
                // an initial media as the playlist selectors do not consider browser support
                this.excludeUnsupportedVariants_();
                let selectedMedia;
                if (this.enableLowInitialPlaylist) selectedMedia = this.selectInitialPlaylist();
                if (!selectedMedia) selectedMedia = this.selectPlaylist();
                if (!selectedMedia || !this.shouldSwitchToMedia_(selectedMedia)) return;
                this.initialMedia_ = selectedMedia;
                this.switchMedia_(this.initialMedia_, "initial"); // Under the standard case where a source URL is provided, loadedplaylist will
                // fire again since the playlist will be requested. In the case of vhs-json
                // (where the manifest object is provided as the source), when the media
                // playlist's `segments` list is already available, a media playlist won't be
                // requested, and loadedplaylist won't fire again, so the playlist handler must be
                // called on its own here.
                const haveJsonSource = this.sourceType_ === "vhs-json" && this.initialMedia_.segments;
                if (!haveJsonSource) return;
                updatedPlaylist = this.initialMedia_;
            }
            this.handleUpdatedMediaPlaylist(updatedPlaylist);
        });
        this.mainPlaylistLoader_.on("error", ()=>{
            const error = this.mainPlaylistLoader_.error;
            this.excludePlaylist({
                playlistToExclude: error.playlist,
                error: error
            });
        });
        this.mainPlaylistLoader_.on("mediachanging", ()=>{
            this.mainSegmentLoader_.abort();
            this.mainSegmentLoader_.pause();
        });
        this.mainPlaylistLoader_.on("mediachange", ()=>{
            const media = this.mainPlaylistLoader_.media();
            const requestTimeout = media.targetDuration * 1500; // If we don't have any more available playlists, we don't want to
            // timeout the request.
            if ($cb03b711053a4297$var$isLowestEnabledRendition(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media())) this.requestOptions_.timeout = 0;
            else this.requestOptions_.timeout = requestTimeout;
            this.mainPlaylistLoader_.load(); // TODO: Create a new event on the PlaylistLoader that signals
            // that the segments have changed in some way and use that to
            // update the SegmentLoader instead of doing it twice here and
            // on `loadedplaylist`
            this.mainSegmentLoader_.playlist(media, this.requestOptions_);
            this.mainSegmentLoader_.load();
            this.tech_.trigger({
                type: "mediachange",
                bubbles: true
            });
        });
        this.mainPlaylistLoader_.on("playlistunchanged", ()=>{
            const updatedPlaylist = this.mainPlaylistLoader_.media(); // ignore unchanged playlists that have already been
            // excluded for not-changing. We likely just have a really slowly updating
            // playlist.
            if (updatedPlaylist.lastExcludeReason_ === "playlist-unchanged") return;
            const playlistOutdated = this.stuckAtPlaylistEnd_(updatedPlaylist);
            if (playlistOutdated) {
                // Playlist has stopped updating and we're stuck at its end. Try to
                // exclude it and switch to another playlist in the hope that that
                // one is updating (and give the player a chance to re-adjust to the
                // safe live point).
                this.excludePlaylist({
                    error: {
                        message: "Playlist no longer updating.",
                        reason: "playlist-unchanged"
                    }
                }); // useful for monitoring QoS
                this.tech_.trigger("playliststuck");
            }
        });
        this.mainPlaylistLoader_.on("renditiondisabled", ()=>{
            this.tech_.trigger({
                type: "usage",
                name: "vhs-rendition-disabled"
            });
        });
        this.mainPlaylistLoader_.on("renditionenabled", ()=>{
            this.tech_.trigger({
                type: "usage",
                name: "vhs-rendition-enabled"
            });
        });
    }
    /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */ handleUpdatedMediaPlaylist(updatedPlaylist) {
        if (this.useCueTags_) this.updateAdCues_(updatedPlaylist);
         // TODO: Create a new event on the PlaylistLoader that signals
        // that the segments have changed in some way and use that to
        // update the SegmentLoader instead of doing it twice here and
        // on `mediachange`
        this.mainSegmentLoader_.playlist(updatedPlaylist, this.requestOptions_);
        this.updateDuration(!updatedPlaylist.endList); // If the player isn't paused, ensure that the segment loader is running,
        // as it is possible that it was temporarily stopped while waiting for
        // a playlist (e.g., in case the playlist errored and we re-requested it).
        if (!this.tech_.paused()) {
            this.mainSegmentLoader_.load();
            if (this.audioSegmentLoader_) this.audioSegmentLoader_.load();
        }
    }
    /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */ triggerPresenceUsage_(main, media) {
        const mediaGroups = main.mediaGroups || {};
        let defaultDemuxed = true;
        const audioGroupKeys = Object.keys(mediaGroups.AUDIO);
        for(const mediaGroup in mediaGroups.AUDIO)for(const label in mediaGroups.AUDIO[mediaGroup]){
            const properties = mediaGroups.AUDIO[mediaGroup][label];
            if (!properties.uri) defaultDemuxed = false;
        }
        if (defaultDemuxed) this.tech_.trigger({
            type: "usage",
            name: "vhs-demuxed"
        });
        if (Object.keys(mediaGroups.SUBTITLES).length) this.tech_.trigger({
            type: "usage",
            name: "vhs-webvtt"
        });
        if ($cb03b711053a4297$var$Vhs$1.Playlist.isAes(media)) this.tech_.trigger({
            type: "usage",
            name: "vhs-aes"
        });
        if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) this.tech_.trigger({
            type: "usage",
            name: "vhs-alternate-audio"
        });
        if (this.useCueTags_) this.tech_.trigger({
            type: "usage",
            name: "vhs-playlist-cue-tags"
        });
    }
    shouldSwitchToMedia_(nextPlaylist) {
        const currentPlaylist = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_;
        const currentTime = this.tech_.currentTime();
        const bufferLowWaterLine = this.bufferLowWaterLine();
        const bufferHighWaterLine = this.bufferHighWaterLine();
        const buffered = this.tech_.buffered();
        return $cb03b711053a4297$var$shouldSwitchToMedia({
            buffered: buffered,
            currentTime: currentTime,
            currentPlaylist: currentPlaylist,
            nextPlaylist: nextPlaylist,
            bufferLowWaterLine: bufferLowWaterLine,
            bufferHighWaterLine: bufferHighWaterLine,
            duration: this.duration(),
            bufferBasedABR: this.bufferBasedABR,
            log: this.logger_
        });
    }
    /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */ setupSegmentLoaderListeners_() {
        this.mainSegmentLoader_.on("bandwidthupdate", ()=>{
            // Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
            // useful to check to see if a rendition switch should be made.
            this.checkABR_("bandwidthupdate");
            this.tech_.trigger("bandwidthupdate");
        });
        this.mainSegmentLoader_.on("timeout", ()=>{
            if (this.bufferBasedABR) // If a rendition change is needed, then it would've be done on `bandwidthupdate`.
            // Here the only consideration is that for buffer based ABR there's no guarantee
            // of an immediate switch (since the bandwidth is averaged with a timeout
            // bandwidth value of 1), so force a load on the segment loader to keep it going.
            this.mainSegmentLoader_.load();
        }); // `progress` events are not reliable enough of a bandwidth measure to trigger buffer
        // based ABR.
        if (!this.bufferBasedABR) this.mainSegmentLoader_.on("progress", ()=>{
            this.trigger("progress");
        });
        this.mainSegmentLoader_.on("error", ()=>{
            const error = this.mainSegmentLoader_.error();
            this.excludePlaylist({
                playlistToExclude: error.playlist,
                error: error
            });
        });
        this.mainSegmentLoader_.on("appenderror", ()=>{
            this.error = this.mainSegmentLoader_.error_;
            this.trigger("error");
        });
        this.mainSegmentLoader_.on("syncinfoupdate", ()=>{
            this.onSyncInfoUpdate_();
        });
        this.mainSegmentLoader_.on("timestampoffset", ()=>{
            this.tech_.trigger({
                type: "usage",
                name: "vhs-timestamp-offset"
            });
        });
        this.audioSegmentLoader_.on("syncinfoupdate", ()=>{
            this.onSyncInfoUpdate_();
        });
        this.audioSegmentLoader_.on("appenderror", ()=>{
            this.error = this.audioSegmentLoader_.error_;
            this.trigger("error");
        });
        this.mainSegmentLoader_.on("ended", ()=>{
            this.logger_("main segment loader ended");
            this.onEndOfStream();
        });
        this.mainSegmentLoader_.on("earlyabort", (event)=>{
            // never try to early abort with the new ABR algorithm
            if (this.bufferBasedABR) return;
            this.delegateLoaders_("all", [
                "abort"
            ]);
            this.excludePlaylist({
                error: {
                    message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
                },
                playlistExclusionDuration: $cb03b711053a4297$var$ABORT_EARLY_EXCLUSION_SECONDS
            });
        });
        const updateCodecs = ()=>{
            if (!this.sourceUpdater_.hasCreatedSourceBuffers()) return this.tryToCreateSourceBuffers_();
            const codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
            if (!codecs) return;
            this.sourceUpdater_.addOrChangeSourceBuffers(codecs);
        };
        this.mainSegmentLoader_.on("trackinfo", updateCodecs);
        this.audioSegmentLoader_.on("trackinfo", updateCodecs);
        this.mainSegmentLoader_.on("fmp4", ()=>{
            if (!this.triggeredFmp4Usage) {
                this.tech_.trigger({
                    type: "usage",
                    name: "vhs-fmp4"
                });
                this.triggeredFmp4Usage = true;
            }
        });
        this.audioSegmentLoader_.on("fmp4", ()=>{
            if (!this.triggeredFmp4Usage) {
                this.tech_.trigger({
                    type: "usage",
                    name: "vhs-fmp4"
                });
                this.triggeredFmp4Usage = true;
            }
        });
        this.audioSegmentLoader_.on("ended", ()=>{
            this.logger_("audioSegmentLoader ended");
            this.onEndOfStream();
        });
    }
    mediaSecondsLoaded_() {
        return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
    }
    /**
   * Call load on our SegmentLoaders
   */ load() {
        this.mainSegmentLoader_.load();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) this.audioSegmentLoader_.load();
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) this.subtitleSegmentLoader_.load();
    }
    /**
   * Re-tune playback quality level for the current player
   * conditions. This will reset the main segment loader
   * and the next segment position to the currentTime.
   * This is good for manual quality changes.
   *
   * @private
   */ fastQualityChange_(media = this.selectPlaylist()) {
        if (media === this.mainPlaylistLoader_.media()) {
            this.logger_("skipping fastQualityChange because new media is same as old");
            return;
        }
        this.switchMedia_(media, "fast-quality"); // Reset main segment loader properties and next segment position information.
        // Don't need to reset audio as it is reset when media changes.
        // We resetLoaderProperties separately here as we want to fetch init segments if
        // necessary and ensure we're not in an ended state when we switch playlists.
        this.resetMainLoaderReplaceSegments();
    }
    /**
   * Sets the replaceUntil flag on the main segment soader to the buffered end
   * and resets the main segment loaders properties.
   */ resetMainLoaderReplaceSegments() {
        const buffered = this.tech_.buffered();
        const bufferedEnd = buffered.end(buffered.length - 1); // Set the replace segments flag to the buffered end, this forces fetchAtBuffer
        // on the main loader to remain, false after the resetLoader call, until we have
        // replaced all content buffered ahead of the currentTime.
        this.mainSegmentLoader_.replaceSegmentsUntil = bufferedEnd;
        this.mainSegmentLoader_.resetLoaderProperties();
        this.mainSegmentLoader_.resetLoader();
    }
    /**
   * Begin playback.
   */ play() {
        if (this.setupFirstPlay()) return;
        if (this.tech_.ended()) this.tech_.setCurrentTime(0);
        if (this.hasPlayed_) this.load();
        const seekable = this.tech_.seekable(); // if the viewer has paused and we fell out of the live window,
        // seek forward to the live point
        if (this.tech_.duration() === Infinity) {
            if (this.tech_.currentTime() < seekable.start(0)) return this.tech_.setCurrentTime(seekable.end(seekable.length - 1));
        }
    }
    /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */ setupFirstPlay() {
        const media = this.mainPlaylistLoader_.media(); // Check that everything is ready to begin buffering for the first call to play
        //  If 1) there is no active media
        //     2) the player is paused
        //     3) the first play has already been setup
        // then exit early
        if (!media || this.tech_.paused() || this.hasPlayed_) return false;
         // when the video is a live stream and/or has a start time
        if (!media.endList || media.start) {
            const seekable = this.seekable();
            if (!seekable.length) // without a seekable range, the player cannot seek to begin buffering at the
            // live or start point
            return false;
            const seekableEnd = seekable.end(0);
            let startPoint = seekableEnd;
            if (media.start) {
                const offset = media.start.timeOffset;
                if (offset < 0) startPoint = Math.max(seekableEnd + offset, seekable.start(0));
                else startPoint = Math.min(seekableEnd, offset);
            } // trigger firstplay to inform the source handler to ignore the next seek event
            this.trigger("firstplay"); // seek to the live point
            this.tech_.setCurrentTime(startPoint);
        }
        this.hasPlayed_ = true; // we can begin loading now that everything is ready
        this.load();
        return true;
    }
    /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */ handleSourceOpen_() {
        // Only attempt to create the source buffer if none already exist.
        // handleSourceOpen is also called when we are "re-opening" a source buffer
        // after `endOfStream` has been called (in response to a seek for instance)
        this.tryToCreateSourceBuffers_(); // if autoplay is enabled, begin playback. This is duplicative of
        // code in video.js but is required because play() must be invoked
        // *after* the media source has opened.
        if (this.tech_.autoplay()) {
            const playPromise = this.tech_.play(); // Catch/silence error when a pause interrupts a play request
            // on browsers which return a promise
            if (typeof playPromise !== "undefined" && typeof playPromise.then === "function") playPromise.then(null, (e)=>{});
        }
        this.trigger("sourceopen");
    }
    /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */ handleSourceEnded_() {
        if (!this.inbandTextTracks_.metadataTrack_) return;
        const cues = this.inbandTextTracks_.metadataTrack_.cues;
        if (!cues || !cues.length) return;
        const duration = this.duration();
        cues[cues.length - 1].endTime = isNaN(duration) || Math.abs(duration) === Infinity ? Number.MAX_VALUE : duration;
    }
    /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */ handleDurationChange_() {
        this.tech_.trigger("durationchange");
    }
    /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */ onEndOfStream() {
        let isEndOfStream = this.mainSegmentLoader_.ended_;
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            const mainMediaInfo = this.mainSegmentLoader_.getCurrentMediaInfo_(); // if the audio playlist loader exists, then alternate audio is active
            if (!mainMediaInfo || mainMediaInfo.hasVideo) // if we do not know if the main segment loader contains video yet or if we
            // definitively know the main segment loader contains video, then we need to wait
            // for both main and audio segment loaders to call endOfStream
            isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
            else // otherwise just rely on the audio loader
            isEndOfStream = this.audioSegmentLoader_.ended_;
        }
        if (!isEndOfStream) return;
        this.stopABRTimer_();
        this.sourceUpdater_.endOfStream();
    }
    /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */ stuckAtPlaylistEnd_(playlist) {
        const seekable = this.seekable();
        if (!seekable.length) // playlist doesn't have enough information to determine whether we are stuck
        return false;
        const expired = this.syncController_.getExpiredTime(playlist, this.duration());
        if (expired === null) return false;
         // does not use the safe live end to calculate playlist end, since we
        // don't want to say we are stuck while there is still content
        const absolutePlaylistEnd = $cb03b711053a4297$var$Vhs$1.Playlist.playlistEnd(playlist, expired);
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        if (!buffered.length) // return true if the playhead reached the absolute end of the playlist
        return absolutePlaylistEnd - currentTime <= $cb03b711053a4297$var$SAFE_TIME_DELTA;
        const bufferedEnd = buffered.end(buffered.length - 1); // return true if there is too little buffer left and buffer has reached absolute
        // end of playlist
        return bufferedEnd - currentTime <= $cb03b711053a4297$var$SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= $cb03b711053a4297$var$SAFE_TIME_DELTA;
    }
    /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */ excludePlaylist({ playlistToExclude: playlistToExclude = this.mainPlaylistLoader_.media(), error: error = {}, playlistExclusionDuration: playlistExclusionDuration }) {
        // If the `error` was generated by the playlist loader, it will contain
        // the playlist we were trying to load (but failed) and that should be
        // excluded instead of the currently selected playlist which is likely
        // out-of-date in this scenario
        playlistToExclude = playlistToExclude || this.mainPlaylistLoader_.media();
        playlistExclusionDuration = playlistExclusionDuration || error.playlistExclusionDuration || this.playlistExclusionDuration; // If there is no current playlist, then an error occurred while we were
        // trying to load the main OR while we were disposing of the tech
        if (!playlistToExclude) {
            this.error = error;
            if (this.mediaSource.readyState !== "open") this.trigger("error");
            else this.sourceUpdater_.endOfStream("network");
            return;
        }
        playlistToExclude.playlistErrors_++;
        const playlists = this.mainPlaylistLoader_.main.playlists;
        const enabledPlaylists = playlists.filter($cb03b711053a4297$var$isEnabled);
        const isFinalRendition = enabledPlaylists.length === 1 && enabledPlaylists[0] === playlistToExclude; // Don't exclude the only playlist unless it was excluded
        // forever
        if (playlists.length === 1 && playlistExclusionDuration !== Infinity) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`Problem encountered with playlist ${playlistToExclude.id}. ` + "Trying again since it is the only playlist.");
            this.tech_.trigger("retryplaylist"); // if this is a final rendition, we should delay
            return this.mainPlaylistLoader_.load(isFinalRendition);
        }
        if (isFinalRendition) {
            // If we're content steering, try other pathways.
            if (this.main().contentSteering) {
                const pathway = this.pathwayAttribute_(playlistToExclude); // Ignore at least 1 steering manifest refresh.
                const reIncludeDelay = this.contentSteeringController_.steeringManifest.ttl * 1000;
                this.contentSteeringController_.excludePathway(pathway);
                this.excludeThenChangePathway_();
                setTimeout(()=>{
                    this.contentSteeringController_.addAvailablePathway(pathway);
                }, reIncludeDelay);
                return;
            } // Since we're on the final non-excluded playlist, and we're about to exclude
            // it, instead of erring the player or retrying this playlist, clear out the current
            // exclusion list. This allows other playlists to be attempted in case any have been
            // fixed.
            let reincluded = false;
            playlists.forEach((playlist)=>{
                // skip current playlist which is about to be excluded
                if (playlist === playlistToExclude) return;
                const excludeUntil = playlist.excludeUntil; // a playlist cannot be reincluded if it wasn't excluded to begin with.
                if (typeof excludeUntil !== "undefined" && excludeUntil !== Infinity) {
                    reincluded = true;
                    delete playlist.excludeUntil;
                }
            });
            if (reincluded) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."); // Technically we are retrying a playlist, in that we are simply retrying a previous
                // playlist. This is needed for users relying on the retryplaylist event to catch a
                // case where the player might be stuck and looping through "dead" playlists.
                this.tech_.trigger("retryplaylist");
            }
        } // Exclude this playlist
        let excludeUntil;
        if (playlistToExclude.playlistErrors_ > this.maxPlaylistRetries) excludeUntil = Infinity;
        else excludeUntil = Date.now() + playlistExclusionDuration * 1000;
        playlistToExclude.excludeUntil = excludeUntil;
        if (error.reason) playlistToExclude.lastExcludeReason_ = error.reason;
        this.tech_.trigger("excludeplaylist");
        this.tech_.trigger({
            type: "usage",
            name: "vhs-rendition-excluded"
        }); // TODO: only load a new playlist if we're excluding the current playlist
        // If this function was called with a playlist that's not the current active playlist
        // (e.g., media().id !== playlistToExclude.id),
        // then a new playlist should not be selected and loaded, as there's nothing wrong with the current playlist.
        const nextPlaylist = this.selectPlaylist();
        if (!nextPlaylist) {
            this.error = "Playback cannot continue. No available working or supported playlists.";
            this.trigger("error");
            return;
        }
        const logFn = error.internal ? this.logger_ : $cb03b711053a4297$export$2e2bcd8739ae039.log.warn;
        const errorMessage = error.message ? " " + error.message : "";
        logFn(`${error.internal ? "Internal problem" : "Problem"} encountered with playlist ${playlistToExclude.id}.` + `${errorMessage} Switching to playlist ${nextPlaylist.id}.`); // if audio group changed reset audio loaders
        if (nextPlaylist.attributes.AUDIO !== playlistToExclude.attributes.AUDIO) this.delegateLoaders_("audio", [
            "abort",
            "pause"
        ]);
         // if subtitle group changed reset subtitle loaders
        if (nextPlaylist.attributes.SUBTITLES !== playlistToExclude.attributes.SUBTITLES) this.delegateLoaders_("subtitle", [
            "abort",
            "pause"
        ]);
        this.delegateLoaders_("main", [
            "abort",
            "pause"
        ]);
        const delayDuration = nextPlaylist.targetDuration / 2 * 1000 || 5000;
        const shouldDelay = typeof nextPlaylist.lastRequest === "number" && Date.now() - nextPlaylist.lastRequest <= delayDuration; // delay if it's a final rendition or if the last refresh is sooner than half targetDuration
        return this.switchMedia_(nextPlaylist, "exclude", isFinalRendition || shouldDelay);
    }
    /**
   * Pause all segment/playlist loaders
   */ pauseLoading() {
        this.delegateLoaders_("all", [
            "abort",
            "pause"
        ]);
        this.stopABRTimer_();
    }
    /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */ delegateLoaders_(filter, fnNames) {
        const loaders = [];
        const dontFilterPlaylist = filter === "all";
        if (dontFilterPlaylist || filter === "main") loaders.push(this.mainPlaylistLoader_);
        const mediaTypes = [];
        if (dontFilterPlaylist || filter === "audio") mediaTypes.push("AUDIO");
        if (dontFilterPlaylist || filter === "subtitle") {
            mediaTypes.push("CLOSED-CAPTIONS");
            mediaTypes.push("SUBTITLES");
        }
        mediaTypes.forEach((mediaType)=>{
            const loader = this.mediaTypes_[mediaType] && this.mediaTypes_[mediaType].activePlaylistLoader;
            if (loader) loaders.push(loader);
        });
        [
            "main",
            "audio",
            "subtitle"
        ].forEach((name)=>{
            const loader = this[`${name}SegmentLoader_`];
            if (loader && (filter === name || filter === "all")) loaders.push(loader);
        });
        loaders.forEach((loader)=>fnNames.forEach((fnName)=>{
                if (typeof loader[fnName] === "function") loader[fnName]();
            }));
    }
    /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */ setCurrentTime(currentTime) {
        const buffered = $cb03b711053a4297$var$findRange(this.tech_.buffered(), currentTime);
        if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media())) // return immediately if the metadata is not ready yet
        return 0;
         // it's clearly an edge-case but don't thrown an error if asked to
        // seek within an empty playlist
        if (!this.mainPlaylistLoader_.media().segments) return 0;
         // if the seek location is already buffered, continue buffering as usual
        if (buffered && buffered.length) return currentTime;
         // cancel outstanding requests so we begin buffering at the new
        // location
        this.mainSegmentLoader_.resetEverything();
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) this.audioSegmentLoader_.resetEverything();
        if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) this.subtitleSegmentLoader_.resetEverything();
         // start segment loader loading in case they are paused
        this.load();
    }
    /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */ duration() {
        if (!this.mainPlaylistLoader_) return 0;
        const media = this.mainPlaylistLoader_.media();
        if (!media) // no playlists loaded yet, so can't determine a duration
        return 0;
         // Don't rely on the media source for duration in the case of a live playlist since
        // setting the native MediaSource's duration to infinity ends up with consequences to
        // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
        //
        // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
        // however, few browsers have support for setLiveSeekableRange()
        // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
        //
        // Until a time when the duration of the media source can be set to infinity, and a
        // seekable range specified across browsers, just return Infinity.
        if (!media.endList) return Infinity;
         // Since this is a VOD video, it is safe to rely on the media source's duration (if
        // available). If it's not available, fall back to a playlist-calculated estimate.
        if (this.mediaSource) return this.mediaSource.duration;
        return $cb03b711053a4297$var$Vhs$1.Playlist.duration(media);
    }
    /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */ seekable() {
        return this.seekable_;
    }
    onSyncInfoUpdate_() {
        let audioSeekable; // TODO check for creation of both source buffers before updating seekable
        //
        // A fix was made to this function where a check for
        // this.sourceUpdater_.hasCreatedSourceBuffers
        // was added to ensure that both source buffers were created before seekable was
        // updated. However, it originally had a bug where it was checking for a true and
        // returning early instead of checking for false. Setting it to check for false to
        // return early though created other issues. A call to play() would check for seekable
        // end without verifying that a seekable range was present. In addition, even checking
        // for that didn't solve some issues, as handleFirstPlay is sometimes worked around
        // due to a media update calling load on the segment loaders, skipping a seek to live,
        // thereby starting live streams at the beginning of the stream rather than at the end.
        //
        // This conditional should be fixed to wait for the creation of two source buffers at
        // the same time as the other sections of code are fixed to properly seek to live and
        // not throw an error due to checking for a seekable end when no seekable range exists.
        //
        // For now, fall back to the older behavior, with the understanding that the seekable
        // range may not be completely correct, leading to a suboptimal initial live point.
        if (!this.mainPlaylistLoader_) return;
        let media = this.mainPlaylistLoader_.media();
        if (!media) return;
        let expired = this.syncController_.getExpiredTime(media, this.duration());
        if (expired === null) // not enough information to update seekable
        return;
        const main = this.mainPlaylistLoader_.main;
        const mainSeekable = $cb03b711053a4297$var$Vhs$1.Playlist.seekable(media, expired, $cb03b711053a4297$var$Vhs$1.Playlist.liveEdgeDelay(main, media));
        if (mainSeekable.length === 0) return;
        if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
            media = this.mediaTypes_.AUDIO.activePlaylistLoader.media();
            expired = this.syncController_.getExpiredTime(media, this.duration());
            if (expired === null) return;
            audioSeekable = $cb03b711053a4297$var$Vhs$1.Playlist.seekable(media, expired, $cb03b711053a4297$var$Vhs$1.Playlist.liveEdgeDelay(main, media));
            if (audioSeekable.length === 0) return;
        }
        let oldEnd;
        let oldStart;
        if (this.seekable_ && this.seekable_.length) {
            oldEnd = this.seekable_.end(0);
            oldStart = this.seekable_.start(0);
        }
        if (!audioSeekable) // seekable has been calculated based on buffering video data so it
        // can be returned directly
        this.seekable_ = mainSeekable;
        else if (audioSeekable.start(0) > mainSeekable.end(0) || mainSeekable.start(0) > audioSeekable.end(0)) // seekables are pretty far off, rely on main
        this.seekable_ = mainSeekable;
        else this.seekable_ = $cb03b711053a4297$var$createTimeRanges([
            [
                audioSeekable.start(0) > mainSeekable.start(0) ? audioSeekable.start(0) : mainSeekable.start(0),
                audioSeekable.end(0) < mainSeekable.end(0) ? audioSeekable.end(0) : mainSeekable.end(0)
            ]
        ]);
         // seekable is the same as last time
        if (this.seekable_ && this.seekable_.length) {
            if (this.seekable_.end(0) === oldEnd && this.seekable_.start(0) === oldStart) return;
        }
        this.logger_(`seekable updated [${$cb03b711053a4297$var$printableRange(this.seekable_)}]`);
        this.tech_.trigger("seekablechanged");
    }
    /**
   * Update the player duration
   */ updateDuration(isLive) {
        if (this.updateDuration_) {
            this.mediaSource.removeEventListener("sourceopen", this.updateDuration_);
            this.updateDuration_ = null;
        }
        if (this.mediaSource.readyState !== "open") {
            this.updateDuration_ = this.updateDuration.bind(this, isLive);
            this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
            return;
        }
        if (isLive) {
            const seekable = this.seekable();
            if (!seekable.length) return;
             // Even in the case of a live playlist, the native MediaSource's duration should not
            // be set to Infinity (even though this would be expected for a live playlist), since
            // setting the native MediaSource's duration to infinity ends up with consequences to
            // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
            //
            // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
            // however, few browsers have support for setLiveSeekableRange()
            // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
            //
            // Until a time when the duration of the media source can be set to infinity, and a
            // seekable range specified across browsers, the duration should be greater than or
            // equal to the last possible seekable value.
            // MediaSource duration starts as NaN
            // It is possible (and probable) that this case will never be reached for many
            // sources, since the MediaSource reports duration as the highest value without
            // accounting for timestamp offset. For example, if the timestamp offset is -100 and
            // we buffered times 0 to 100 with real times of 100 to 200, even though current
            // time will be between 0 and 100, the native media source may report the duration
            // as 200. However, since we report duration separate from the media source (as
            // Infinity), and as long as the native media source duration value is greater than
            // our reported seekable range, seeks will work as expected. The large number as
            // duration for live is actually a strategy used by some players to work around the
            // issue of live seekable ranges cited above.
            if (isNaN(this.mediaSource.duration) || this.mediaSource.duration < seekable.end(seekable.length - 1)) this.sourceUpdater_.setDuration(seekable.end(seekable.length - 1));
            return;
        }
        const buffered = this.tech_.buffered();
        let duration = $cb03b711053a4297$var$Vhs$1.Playlist.duration(this.mainPlaylistLoader_.media());
        if (buffered.length > 0) duration = Math.max(duration, buffered.end(buffered.length - 1));
        if (this.mediaSource.duration !== duration) this.sourceUpdater_.setDuration(duration);
    }
    /**
   * dispose of the PlaylistController and everything
   * that it controls
   */ dispose() {
        this.trigger("dispose");
        this.decrypter_.terminate();
        this.mainPlaylistLoader_.dispose();
        this.mainSegmentLoader_.dispose();
        this.contentSteeringController_.dispose();
        if (this.loadOnPlay_) this.tech_.off("play", this.loadOnPlay_);
        [
            "AUDIO",
            "SUBTITLES"
        ].forEach((type)=>{
            const groups = this.mediaTypes_[type].groups;
            for(const id in groups)groups[id].forEach((group)=>{
                if (group.playlistLoader) group.playlistLoader.dispose();
            });
        });
        this.audioSegmentLoader_.dispose();
        this.subtitleSegmentLoader_.dispose();
        this.sourceUpdater_.dispose();
        this.timelineChangeController_.dispose();
        this.stopABRTimer_();
        if (this.updateDuration_) this.mediaSource.removeEventListener("sourceopen", this.updateDuration_);
        this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_); // load the media source into the player
        this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_);
        this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_);
        this.off();
    }
    /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */ main() {
        return this.mainPlaylistLoader_.main;
    }
    /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */ media() {
        // playlist loader will not return media if it has not been fully loaded
        return this.mainPlaylistLoader_.media() || this.initialMedia_;
    }
    areMediaTypesKnown_() {
        const usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        const hasMainMediaInfo = !!this.mainSegmentLoader_.getCurrentMediaInfo_(); // if we are not using an audio loader, then we have audio media info
        // otherwise check on the segment loader.
        const hasAudioMediaInfo = !usingAudioLoader ? true : !!this.audioSegmentLoader_.getCurrentMediaInfo_(); // one or both loaders has not loaded sufficently to get codecs
        if (!hasMainMediaInfo || !hasAudioMediaInfo) return false;
        return true;
    }
    getCodecsOrExclude_() {
        const media = {
            main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
            audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
        };
        const playlist = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media(); // set "main" media equal to video
        media.video = media.main;
        const playlistCodecs = $cb03b711053a4297$var$codecsForPlaylist(this.main(), playlist);
        const codecs = {};
        const usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        if (media.main.hasVideo) codecs.video = playlistCodecs.video || media.main.videoCodec || (0, $e324d09415701181$export$77d6196664053611);
        if (media.main.isMuxed) codecs.video += `,${playlistCodecs.audio || media.main.audioCodec || (0, $e324d09415701181$export$615de1d7b49571dc)}`;
        if (media.main.hasAudio && !media.main.isMuxed || media.audio.hasAudio || usingAudioLoader) {
            codecs.audio = playlistCodecs.audio || media.main.audioCodec || media.audio.audioCodec || (0, $e324d09415701181$export$615de1d7b49571dc); // set audio isFmp4 so we use the correct "supports" function below
            media.audio.isFmp4 = media.main.hasAudio && !media.main.isMuxed ? media.main.isFmp4 : media.audio.isFmp4;
        } // no codecs, no playback.
        if (!codecs.audio && !codecs.video) {
            this.excludePlaylist({
                playlistToExclude: playlist,
                error: {
                    message: "Could not determine codecs for playlist."
                },
                playlistExclusionDuration: Infinity
            });
            return;
        } // fmp4 relies on browser support, while ts relies on muxer support
        const supportFunction = (isFmp4, codec)=>isFmp4 ? (0, $e324d09415701181$export$3ee949df8fbc592f)(codec) : (0, $e324d09415701181$export$614fda2d02e4a9d7)(codec);
        const unsupportedCodecs = {};
        let unsupportedAudio;
        [
            "video",
            "audio"
        ].forEach(function(type) {
            if (codecs.hasOwnProperty(type) && !supportFunction(media[type].isFmp4, codecs[type])) {
                const supporter = media[type].isFmp4 ? "browser" : "muxer";
                unsupportedCodecs[supporter] = unsupportedCodecs[supporter] || [];
                unsupportedCodecs[supporter].push(codecs[type]);
                if (type === "audio") unsupportedAudio = supporter;
            }
        });
        if (usingAudioLoader && unsupportedAudio && playlist.attributes.AUDIO) {
            const audioGroup = playlist.attributes.AUDIO;
            this.main().playlists.forEach((variant)=>{
                const variantAudioGroup = variant.attributes && variant.attributes.AUDIO;
                if (variantAudioGroup === audioGroup && variant !== playlist) variant.excludeUntil = Infinity;
            });
            this.logger_(`excluding audio group ${audioGroup} as ${unsupportedAudio} does not support codec(s): "${codecs.audio}"`);
        } // if we have any unsupported codecs exclude this playlist.
        if (Object.keys(unsupportedCodecs).length) {
            const message = Object.keys(unsupportedCodecs).reduce((acc, supporter)=>{
                if (acc) acc += ", ";
                acc += `${supporter} does not support codec(s): "${unsupportedCodecs[supporter].join(",")}"`;
                return acc;
            }, "") + ".";
            this.excludePlaylist({
                playlistToExclude: playlist,
                error: {
                    internal: true,
                    message: message
                },
                playlistExclusionDuration: Infinity
            });
            return;
        } // check if codec switching is happening
        if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
            const switchMessages = [];
            [
                "video",
                "audio"
            ].forEach((type)=>{
                const newCodec = ((0, $e324d09415701181$export$56679b562aa2891c)(this.sourceUpdater_.codecs[type] || "")[0] || {}).type;
                const oldCodec = ((0, $e324d09415701181$export$56679b562aa2891c)(codecs[type] || "")[0] || {}).type;
                if (newCodec && oldCodec && newCodec.toLowerCase() !== oldCodec.toLowerCase()) switchMessages.push(`"${this.sourceUpdater_.codecs[type]}" -> "${codecs[type]}"`);
            });
            if (switchMessages.length) {
                this.excludePlaylist({
                    playlistToExclude: playlist,
                    error: {
                        message: `Codec switching not supported: ${switchMessages.join(", ")}.`,
                        internal: true
                    },
                    playlistExclusionDuration: Infinity
                });
                return;
            }
        } // TODO: when using the muxer shouldn't we just return
        // the codecs that the muxer outputs?
        return codecs;
    }
    /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */ tryToCreateSourceBuffers_() {
        // media source is not ready yet or sourceBuffers are already
        // created.
        if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers()) return;
        if (!this.areMediaTypesKnown_()) return;
        const codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
        if (!codecs) return;
        this.sourceUpdater_.createSourceBuffers(codecs);
        const codecString = [
            codecs.video,
            codecs.audio
        ].filter(Boolean).join(",");
        this.excludeIncompatibleVariants_(codecString);
    }
    /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */ excludeUnsupportedVariants_() {
        const playlists = this.main().playlists;
        const ids = []; // TODO: why don't we have a property to loop through all
        // playlist? Why did we ever mix indexes and keys?
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key]; // check if we already processed this playlist.
            if (ids.indexOf(variant.id) !== -1) return;
            ids.push(variant.id);
            const codecs = $cb03b711053a4297$var$codecsForPlaylist(this.main, variant);
            const unsupported = [];
            if (codecs.audio && !(0, $e324d09415701181$export$614fda2d02e4a9d7)(codecs.audio) && !(0, $e324d09415701181$export$3ee949df8fbc592f)(codecs.audio)) unsupported.push(`audio codec ${codecs.audio}`);
            if (codecs.video && !(0, $e324d09415701181$export$614fda2d02e4a9d7)(codecs.video) && !(0, $e324d09415701181$export$3ee949df8fbc592f)(codecs.video)) unsupported.push(`video codec ${codecs.video}`);
            if (codecs.text && codecs.text === "stpp.ttml.im1t") unsupported.push(`text codec ${codecs.text}`);
            if (unsupported.length) {
                variant.excludeUntil = Infinity;
                this.logger_(`excluding ${variant.id} for unsupported: ${unsupported.join(", ")}`);
            }
        });
    }
    /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */ excludeIncompatibleVariants_(codecString) {
        const ids = [];
        const playlists = this.main().playlists;
        const codecs = $cb03b711053a4297$var$unwrapCodecList((0, $e324d09415701181$export$56679b562aa2891c)(codecString));
        const codecCount_ = $cb03b711053a4297$var$codecCount(codecs);
        const videoDetails = codecs.video && (0, $e324d09415701181$export$56679b562aa2891c)(codecs.video)[0] || null;
        const audioDetails = codecs.audio && (0, $e324d09415701181$export$56679b562aa2891c)(codecs.audio)[0] || null;
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key]; // check if we already processed this playlist.
            // or it if it is already excluded forever.
            if (ids.indexOf(variant.id) !== -1 || variant.excludeUntil === Infinity) return;
            ids.push(variant.id);
            const exclusionReasons = []; // get codecs from the playlist for this variant
            const variantCodecs = $cb03b711053a4297$var$codecsForPlaylist(this.mainPlaylistLoader_.main, variant);
            const variantCodecCount = $cb03b711053a4297$var$codecCount(variantCodecs); // if no codecs are listed, we cannot determine that this
            // variant is incompatible. Wait for mux.js to probe
            if (!variantCodecs.audio && !variantCodecs.video) return;
             // TODO: we can support this by removing the
            // old media source and creating a new one, but it will take some work.
            // The number of streams cannot change
            if (variantCodecCount !== codecCount_) exclusionReasons.push(`codec count "${variantCodecCount}" !== "${codecCount_}"`);
             // only exclude playlists by codec change, if codecs cannot switch
            // during playback.
            if (!this.sourceUpdater_.canChangeType()) {
                const variantVideoDetails = variantCodecs.video && (0, $e324d09415701181$export$56679b562aa2891c)(variantCodecs.video)[0] || null;
                const variantAudioDetails = variantCodecs.audio && (0, $e324d09415701181$export$56679b562aa2891c)(variantCodecs.audio)[0] || null; // the video codec cannot change
                if (variantVideoDetails && videoDetails && variantVideoDetails.type.toLowerCase() !== videoDetails.type.toLowerCase()) exclusionReasons.push(`video codec "${variantVideoDetails.type}" !== "${videoDetails.type}"`);
                 // the audio codec cannot change
                if (variantAudioDetails && audioDetails && variantAudioDetails.type.toLowerCase() !== audioDetails.type.toLowerCase()) exclusionReasons.push(`audio codec "${variantAudioDetails.type}" !== "${audioDetails.type}"`);
            }
            if (exclusionReasons.length) {
                variant.excludeUntil = Infinity;
                this.logger_(`excluding ${variant.id}: ${exclusionReasons.join(" && ")}`);
            }
        });
    }
    updateAdCues_(media) {
        let offset = 0;
        const seekable = this.seekable();
        if (seekable.length) offset = seekable.start(0);
        $cb03b711053a4297$var$updateAdCues(media, this.cueTagsTrack_, offset);
    }
    /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */ goalBufferLength() {
        const currentTime = this.tech_.currentTime();
        const initial = $cb03b711053a4297$var$Config.GOAL_BUFFER_LENGTH;
        const rate = $cb03b711053a4297$var$Config.GOAL_BUFFER_LENGTH_RATE;
        const max = Math.max(initial, $cb03b711053a4297$var$Config.MAX_GOAL_BUFFER_LENGTH);
        return Math.min(initial + currentTime * rate, max);
    }
    /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */ bufferLowWaterLine() {
        const currentTime = this.tech_.currentTime();
        const initial = $cb03b711053a4297$var$Config.BUFFER_LOW_WATER_LINE;
        const rate = $cb03b711053a4297$var$Config.BUFFER_LOW_WATER_LINE_RATE;
        const max = Math.max(initial, $cb03b711053a4297$var$Config.MAX_BUFFER_LOW_WATER_LINE);
        const newMax = Math.max(initial, $cb03b711053a4297$var$Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
        return Math.min(initial + currentTime * rate, this.bufferBasedABR ? newMax : max);
    }
    bufferHighWaterLine() {
        return $cb03b711053a4297$var$Config.BUFFER_HIGH_WATER_LINE;
    }
    addDateRangesToTextTrack_(dateRanges) {
        $cb03b711053a4297$var$createMetadataTrackIfNotExists(this.inbandTextTracks_, "com.apple.streaming", this.tech_);
        $cb03b711053a4297$var$addDateRangeMetadata({
            inbandTextTracks: this.inbandTextTracks_,
            dateRanges: dateRanges
        });
    }
    addMetadataToTextTrack(dispatchType, metadataArray, videoDuration) {
        const timestampOffset = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset(); // There's potentially an issue where we could double add metadata if there's a muxed
        // audio/video source with a metadata track, and an alt audio with a metadata track.
        // However, this probably won't happen, and if it does it can be handled then.
        $cb03b711053a4297$var$createMetadataTrackIfNotExists(this.inbandTextTracks_, dispatchType, this.tech_);
        $cb03b711053a4297$var$addMetadata({
            inbandTextTracks: this.inbandTextTracks_,
            metadataArray: metadataArray,
            timestampOffset: timestampOffset,
            videoDuration: videoDuration
        });
    }
    pathwayAttribute_(playlist) {
        return playlist.attributes["PATHWAY-ID"] || playlist.attributes.serviceLocation;
    }
    /**
   * Initialize content steering listeners and apply the tag properties.
   */ initContentSteeringController_() {
        const initialMain = this.main();
        if (!initialMain.contentSteering) return;
        const updateSteeringValues = (main)=>{
            for (const playlist of main.playlists)this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(playlist));
            this.contentSteeringController_.assignTagProperties(main.uri, main.contentSteering);
        };
        updateSteeringValues(initialMain);
        this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)); // We need to ensure we update the content steering values when a new
        // manifest is loaded in live DASH with content steering.
        if (this.sourceType_ === "dash") this.mainPlaylistLoader_.on("mediaupdatetimeout", ()=>{
            this.mainPlaylistLoader_.refreshMedia_(this.mainPlaylistLoader_.media().id); // clear past values
            this.contentSteeringController_.abort();
            this.contentSteeringController_.clearTTLTimeout_();
            this.contentSteeringController_.clearAvailablePathways();
            updateSteeringValues(this.main());
        });
         // Do this at startup only, after that the steering requests are managed by the Content Steering class.
        // DASH queryBeforeStart scenarios will be handled by the Content Steering class.
        if (!this.contentSteeringController_.queryBeforeStart) this.tech_.one("canplay", ()=>{
            this.contentSteeringController_.requestSteeringManifest();
        });
    }
    /**
   * Simple exclude and change playlist logic for content steering.
   */ excludeThenChangePathway_() {
        const currentPathway = this.contentSteeringController_.getPathway();
        if (!currentPathway) return;
        const main = this.main();
        const playlists = main.playlists;
        const ids = new Set();
        let didEnablePlaylists = false;
        Object.keys(playlists).forEach((key)=>{
            const variant = playlists[key];
            const pathwayId = this.pathwayAttribute_(variant);
            const differentPathwayId = pathwayId && currentPathway !== pathwayId;
            const steeringExclusion = variant.excludeUntil === Infinity && variant.lastExcludeReason_ === "content-steering";
            if (steeringExclusion && !differentPathwayId) {
                delete variant.excludeUntil;
                delete variant.lastExcludeReason_;
                didEnablePlaylists = true;
            }
            const noExcludeUntil = !variant.excludeUntil && variant.excludeUntil !== Infinity;
            const shouldExclude = !ids.has(variant.id) && differentPathwayId && noExcludeUntil;
            if (!shouldExclude) return;
            ids.add(variant.id);
            variant.excludeUntil = Infinity;
            variant.lastExcludeReason_ = "content-steering"; // TODO: kind of spammy, maybe move this.
            this.logger_(`excluding ${variant.id} for ${variant.lastExcludeReason_}`);
        });
        if (this.contentSteeringController_.manifestType_ === "DASH") Object.keys(this.mediaTypes_).forEach((key)=>{
            const type = this.mediaTypes_[key];
            if (type.activePlaylistLoader) {
                const currentPlaylist = type.activePlaylistLoader.media_; // Check if the current media playlist matches the current CDN
                if (currentPlaylist && currentPlaylist.attributes.serviceLocation !== currentPathway) didEnablePlaylists = true;
            }
        });
        if (didEnablePlaylists) this.changeSegmentPathway_();
    }
    /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */ changeSegmentPathway_() {
        const nextPlaylist = this.selectPlaylist();
        this.pauseLoading(); // Switch audio and text track playlists if necessary in DASH
        if (this.contentSteeringController_.manifestType_ === "DASH") this.switchMediaForDASHContentSteering_();
        this.switchMedia_(nextPlaylist, "content-steering");
    }
}
/**
 * Returns a function that acts as the Enable/disable playlist function.
 *
 * @param {PlaylistLoader} loader - The main playlist loader
 * @param {string} playlistID - id of the playlist
 * @param {Function} changePlaylistFn - A function to be called after a
 * playlist's enabled-state has been changed. Will NOT be called if a
 * playlist's enabled-state is unchanged
 * @param {boolean=} enable - Value to set the playlist enabled-state to
 * or if undefined returns the current enabled-state for the playlist
 * @return {Function} Function for setting/getting enabled
 */ const $cb03b711053a4297$var$enableFunction = (loader, playlistID, changePlaylistFn)=>(enable)=>{
        const playlist = loader.main.playlists[playlistID];
        const incompatible = $cb03b711053a4297$var$isIncompatible(playlist);
        const currentlyEnabled = $cb03b711053a4297$var$isEnabled(playlist);
        if (typeof enable === "undefined") return currentlyEnabled;
        if (enable) delete playlist.disabled;
        else playlist.disabled = true;
        if (enable !== currentlyEnabled && !incompatible) {
            // Ensure the outside world knows about our changes
            changePlaylistFn();
            if (enable) loader.trigger("renditionenabled");
            else loader.trigger("renditiondisabled");
        }
        return enable;
    };
/**
 * The representation object encapsulates the publicly visible information
 * in a media playlist along with a setter/getter-type function (enabled)
 * for changing the enabled-state of a particular playlist entry
 *
 * @class Representation
 */ class $cb03b711053a4297$var$Representation {
    constructor(vhsHandler, playlist, id){
        const { playlistController_: pc } = vhsHandler;
        const qualityChangeFunction = pc.fastQualityChange_.bind(pc); // some playlist attributes are optional
        if (playlist.attributes) {
            const resolution = playlist.attributes.RESOLUTION;
            this.width = resolution && resolution.width;
            this.height = resolution && resolution.height;
            this.bandwidth = playlist.attributes.BANDWIDTH;
            this.frameRate = playlist.attributes["FRAME-RATE"];
        }
        this.codecs = $cb03b711053a4297$var$codecsForPlaylist(pc.main(), playlist);
        this.playlist = playlist; // The id is simply the ordinality of the media playlist
        // within the main playlist
        this.id = id; // Partially-apply the enableFunction to create a playlist-
        // specific variant
        this.enabled = $cb03b711053a4297$var$enableFunction(vhsHandler.playlists, playlist.id, qualityChangeFunction);
    }
}
/**
 * A mixin function that adds the `representations` api to an instance
 * of the VhsHandler class
 *
 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
 * representation API into
 */ const $cb03b711053a4297$var$renditionSelectionMixin = function(vhsHandler) {
    // Add a single API-specific function to the VhsHandler instance
    vhsHandler.representations = ()=>{
        const main = vhsHandler.playlistController_.main();
        const playlists = $cb03b711053a4297$var$isAudioOnly(main) ? vhsHandler.playlistController_.getAudioTrackPlaylists_() : main.playlists;
        if (!playlists) return [];
        return playlists.filter((media)=>!$cb03b711053a4297$var$isIncompatible(media)).map((e, i)=>new $cb03b711053a4297$var$Representation(vhsHandler, e, e.id));
    };
};
/**
 * @file playback-watcher.js
 *
 * Playback starts, and now my watch begins. It shall not end until my death. I shall
 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
 * my life and honor to the Playback Watch, for this Player and all the Players to come.
 */ const $cb03b711053a4297$var$timerCancelEvents = [
    "seeking",
    "seeked",
    "pause",
    "playing",
    "error"
];
/**
 * @class PlaybackWatcher
 */ class $cb03b711053a4297$var$PlaybackWatcher {
    /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */ constructor(options){
        this.playlistController_ = options.playlistController;
        this.tech_ = options.tech;
        this.seekable = options.seekable;
        this.allowSeeksWithinUnsafeLiveWindow = options.allowSeeksWithinUnsafeLiveWindow;
        this.liveRangeSafeTimeDelta = options.liveRangeSafeTimeDelta;
        this.media = options.media;
        this.consecutiveUpdates = 0;
        this.lastRecordedTime = null;
        this.checkCurrentTimeTimeout_ = null;
        this.logger_ = $cb03b711053a4297$var$logger("PlaybackWatcher");
        this.logger_("initialize");
        const playHandler = ()=>this.monitorCurrentTime_();
        const canPlayHandler = ()=>this.monitorCurrentTime_();
        const waitingHandler = ()=>this.techWaiting_();
        const cancelTimerHandler = ()=>this.resetTimeUpdate_();
        const pc = this.playlistController_;
        const loaderTypes = [
            "main",
            "subtitle",
            "audio"
        ];
        const loaderChecks = {};
        loaderTypes.forEach((type)=>{
            loaderChecks[type] = {
                reset: ()=>this.resetSegmentDownloads_(type),
                updateend: ()=>this.checkSegmentDownloads_(type)
            };
            pc[`${type}SegmentLoader_`].on("appendsdone", loaderChecks[type].updateend); // If a rendition switch happens during a playback stall where the buffer
            // isn't changing we want to reset. We cannot assume that the new rendition
            // will also be stalled, until after new appends.
            pc[`${type}SegmentLoader_`].on("playlistupdate", loaderChecks[type].reset); // Playback stalls should not be detected right after seeking.
            // This prevents one segment playlists (single vtt or single segment content)
            // from being detected as stalling. As the buffer will not change in those cases, since
            // the buffer is the entire video duration.
            this.tech_.on([
                "seeked",
                "seeking"
            ], loaderChecks[type].reset);
        });
        /**
     * We check if a seek was into a gap through the following steps:
     * 1. We get a seeking event and we do not get a seeked event. This means that
     *    a seek was attempted but not completed.
     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
     *    removed everything from our buffer and appended a segment, and should be ready
     *    to check for gaps.
     */ const setSeekingHandlers = (fn)=>{
            [
                "main",
                "audio"
            ].forEach((type)=>{
                pc[`${type}SegmentLoader_`][fn]("appended", this.seekingAppendCheck_);
            });
        };
        this.seekingAppendCheck_ = ()=>{
            if (this.fixesBadSeeks_()) {
                this.consecutiveUpdates = 0;
                this.lastRecordedTime = this.tech_.currentTime();
                setSeekingHandlers("off");
            }
        };
        this.clearSeekingAppendCheck_ = ()=>setSeekingHandlers("off");
        this.watchForBadSeeking_ = ()=>{
            this.clearSeekingAppendCheck_();
            setSeekingHandlers("on");
        };
        this.tech_.on("seeked", this.clearSeekingAppendCheck_);
        this.tech_.on("seeking", this.watchForBadSeeking_);
        this.tech_.on("waiting", waitingHandler);
        this.tech_.on($cb03b711053a4297$var$timerCancelEvents, cancelTimerHandler);
        this.tech_.on("canplay", canPlayHandler);
        /*
      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
      is surfaced in one of two ways:
       1)  The `waiting` event is fired before the player has buffered content, making it impossible
          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
          we can check if playback is stalled due to a gap, and skip the gap if necessary.
      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
          is in a playing state. To catch this case, it's important that our one-time play listener is setup
          even if the player is in a playing state
    */ this.tech_.one("play", playHandler); // Define the dispose function to clean up our events
        this.dispose = ()=>{
            this.clearSeekingAppendCheck_();
            this.logger_("dispose");
            this.tech_.off("waiting", waitingHandler);
            this.tech_.off($cb03b711053a4297$var$timerCancelEvents, cancelTimerHandler);
            this.tech_.off("canplay", canPlayHandler);
            this.tech_.off("play", playHandler);
            this.tech_.off("seeking", this.watchForBadSeeking_);
            this.tech_.off("seeked", this.clearSeekingAppendCheck_);
            loaderTypes.forEach((type)=>{
                pc[`${type}SegmentLoader_`].off("appendsdone", loaderChecks[type].updateend);
                pc[`${type}SegmentLoader_`].off("playlistupdate", loaderChecks[type].reset);
                this.tech_.off([
                    "seeked",
                    "seeking"
                ], loaderChecks[type].reset);
            });
            if (this.checkCurrentTimeTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkCurrentTimeTimeout_);
            this.resetTimeUpdate_();
        };
    }
    /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */ monitorCurrentTime_() {
        this.checkCurrentTime_();
        if (this.checkCurrentTimeTimeout_) (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).clearTimeout(this.checkCurrentTimeTimeout_);
         // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
        this.checkCurrentTimeTimeout_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).setTimeout(this.monitorCurrentTime_.bind(this), 250);
    }
    /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */ resetSegmentDownloads_(type) {
        const loader = this.playlistController_[`${type}SegmentLoader_`];
        if (this[`${type}StalledDownloads_`] > 0) this.logger_(`resetting possible stalled download count for ${type} loader`);
        this[`${type}StalledDownloads_`] = 0;
        this[`${type}Buffered_`] = loader.buffered_();
    }
    /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */ checkSegmentDownloads_(type) {
        const pc = this.playlistController_;
        const loader = pc[`${type}SegmentLoader_`];
        const buffered = loader.buffered_();
        const isBufferedDifferent = $cb03b711053a4297$var$isRangeDifferent(this[`${type}Buffered_`], buffered);
        this[`${type}Buffered_`] = buffered; // if another watcher is going to fix the issue or
        // the buffered value for this loader changed
        // appends are working
        if (isBufferedDifferent) {
            this.resetSegmentDownloads_(type);
            return;
        }
        this[`${type}StalledDownloads_`]++;
        this.logger_(`found #${this[`${type}StalledDownloads_`]} ${type} appends that did not increase buffer (possible stalled download)`, {
            playlistId: loader.playlist_ && loader.playlist_.id,
            buffered: $cb03b711053a4297$var$timeRangesToArray(buffered)
        }); // after 10 possibly stalled appends with no reset, exclude
        if (this[`${type}StalledDownloads_`] < 10) return;
        this.logger_(`${type} loader stalled download exclusion`);
        this.resetSegmentDownloads_(type);
        this.tech_.trigger({
            type: "usage",
            name: `vhs-${type}-download-exclusion`
        });
        if (type === "subtitle") return;
         // TODO: should we exclude audio tracks rather than main tracks
        // when type is audio?
        pc.excludePlaylist({
            error: {
                message: `Excessive ${type} segment downloading detected.`
            },
            playlistExclusionDuration: Infinity
        });
    }
    /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */ checkCurrentTime_() {
        if (this.tech_.paused() || this.tech_.seeking()) return;
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + $cb03b711053a4297$var$SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) // If current time is at the end of the final buffered region, then any playback
        // stall is most likely caused by buffering in a low bandwidth environment. The tech
        // should fire a `waiting` event in this scenario, but due to browser and tech
        // inconsistencies. Calling `techWaiting_` here allows us to simulate
        // responding to a native `waiting` event when the tech fails to emit one.
        return this.techWaiting_();
        if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
            this.consecutiveUpdates++;
            this.waiting_();
        } else if (currentTime === this.lastRecordedTime) this.consecutiveUpdates++;
        else {
            this.consecutiveUpdates = 0;
            this.lastRecordedTime = currentTime;
        }
    }
    /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */ resetTimeUpdate_() {
        this.consecutiveUpdates = 0;
    }
    /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */ fixesBadSeeks_() {
        const seeking = this.tech_.seeking();
        if (!seeking) return false;
         // TODO: It's possible that these seekable checks should be moved out of this function
        // and into a function that runs on seekablechange. It's also possible that we only need
        // afterSeekableWindow as the buffered check at the bottom is good enough to handle before
        // seekable range.
        const seekable = this.seekable();
        const currentTime = this.tech_.currentTime();
        const isAfterSeekableRange = this.afterSeekableWindow_(seekable, currentTime, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
        let seekTo;
        if (isAfterSeekableRange) {
            const seekableEnd = seekable.end(seekable.length - 1); // sync to live point (if VOD, our seekable was updated and we're simply adjusting)
            seekTo = seekableEnd;
        }
        if (this.beforeSeekableWindow_(seekable, currentTime)) {
            const seekableStart = seekable.start(0); // sync to the beginning of the live window
            // provide a buffer of .1 seconds to handle rounding/imprecise numbers
            seekTo = seekableStart + // if the playlist is too short and the seekable range is an exact time (can
            // happen in live with a 3 segment playlist), then don't use a time delta
            (seekableStart === seekable.end(0) ? 0 : $cb03b711053a4297$var$SAFE_TIME_DELTA);
        }
        if (typeof seekTo !== "undefined") {
            this.logger_(`Trying to seek outside of seekable at time ${currentTime} with ` + `seekable range ${$cb03b711053a4297$var$printableRange(seekable)}. Seeking to ` + `${seekTo}.`);
            this.tech_.setCurrentTime(seekTo);
            return true;
        }
        const sourceUpdater = this.playlistController_.sourceUpdater_;
        const buffered = this.tech_.buffered();
        const audioBuffered = sourceUpdater.audioBuffer ? sourceUpdater.audioBuffered() : null;
        const videoBuffered = sourceUpdater.videoBuffer ? sourceUpdater.videoBuffered() : null;
        const media = this.media(); // verify that at least two segment durations or one part duration have been
        // appended before checking for a gap.
        const minAppendedDuration = media.partTargetDuration ? media.partTargetDuration : (media.targetDuration - $cb03b711053a4297$var$TIME_FUDGE_FACTOR) * 2; // verify that at least two segment durations have been
        // appended before checking for a gap.
        const bufferedToCheck = [
            audioBuffered,
            videoBuffered
        ];
        for(let i = 0; i < bufferedToCheck.length; i++){
            // skip null buffered
            if (!bufferedToCheck[i]) continue;
            const timeAhead = $cb03b711053a4297$var$timeAheadOf(bufferedToCheck[i], currentTime); // if we are less than two video/audio segment durations or one part
            // duration behind we haven't appended enough to call this a bad seek.
            if (timeAhead < minAppendedDuration) return false;
        }
        const nextRange = $cb03b711053a4297$var$findNextRange(buffered, currentTime); // we have appended enough content, but we don't have anything buffered
        // to seek over the gap
        if (nextRange.length === 0) return false;
        seekTo = nextRange.start(0) + $cb03b711053a4297$var$SAFE_TIME_DELTA;
        this.logger_(`Buffered region starts (${nextRange.start(0)}) ` + ` just beyond seek point (${currentTime}). Seeking to ${seekTo}.`);
        this.tech_.setCurrentTime(seekTo);
        return true;
    }
    /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */ waiting_() {
        if (this.techWaiting_()) return;
         // All tech waiting checks failed. Use last resort correction
        const currentTime = this.tech_.currentTime();
        const buffered = this.tech_.buffered();
        const currentRange = $cb03b711053a4297$var$findRange(buffered, currentTime); // Sometimes the player can stall for unknown reasons within a contiguous buffered
        // region with no indication that anything is amiss (seen in Firefox). Seeking to
        // currentTime is usually enough to kickstart the player. This checks that the player
        // is currently within a buffered region before attempting a corrective seek.
        // Chrome does not appear to continue `timeupdate` events after a `waiting` event
        // until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
        // make sure there is ~3 seconds of forward buffer before taking any corrective action
        // to avoid triggering an `unknownwaiting` event when the network is slow.
        if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(currentTime);
            this.logger_(`Stopped at ${currentTime} while inside a buffered region ` + `[${currentRange.start(0)} -> ${currentRange.end(0)}]. Attempting to resume ` + "playback by seeking to the current time."); // unknown waiting corrections may be useful for monitoring QoS
            this.tech_.trigger({
                type: "usage",
                name: "vhs-unknown-waiting"
            });
            return;
        }
    }
    /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */ techWaiting_() {
        const seekable = this.seekable();
        const currentTime = this.tech_.currentTime();
        if (this.tech_.seeking()) // Tech is seeking or already waiting on another action, no action needed
        return true;
        if (this.beforeSeekableWindow_(seekable, currentTime)) {
            const livePoint = seekable.end(seekable.length - 1);
            this.logger_(`Fell out of live window at time ${currentTime}. Seeking to ` + `live point (seekable end) ${livePoint}`);
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(livePoint); // live window resyncs may be useful for monitoring QoS
            this.tech_.trigger({
                type: "usage",
                name: "vhs-live-resync"
            });
            return true;
        }
        const sourceUpdater = this.tech_.vhs.playlistController_.sourceUpdater_;
        const buffered = this.tech_.buffered();
        const videoUnderflow = this.videoUnderflow_({
            audioBuffered: sourceUpdater.audioBuffered(),
            videoBuffered: sourceUpdater.videoBuffered(),
            currentTime: currentTime
        });
        if (videoUnderflow) {
            // Even though the video underflowed and was stuck in a gap, the audio overplayed
            // the gap, leading currentTime into a buffered range. Seeking to currentTime
            // allows the video to catch up to the audio position without losing any audio
            // (only suffering ~3 seconds of frozen video and a pause in audio playback).
            this.resetTimeUpdate_();
            this.tech_.setCurrentTime(currentTime); // video underflow may be useful for monitoring QoS
            this.tech_.trigger({
                type: "usage",
                name: "vhs-video-underflow"
            });
            return true;
        }
        const nextRange = $cb03b711053a4297$var$findNextRange(buffered, currentTime); // check for gap
        if (nextRange.length > 0) {
            this.logger_(`Stopped at ${currentTime} and seeking to ${nextRange.start(0)}`);
            this.resetTimeUpdate_();
            this.skipTheGap_(currentTime);
            return true;
        } // All checks failed. Returning false to indicate failure to correct waiting
        return false;
    }
    afterSeekableWindow_(seekable, currentTime, playlist, allowSeeksWithinUnsafeLiveWindow = false) {
        if (!seekable.length) // we can't make a solid case if there's no seekable, default to false
        return false;
        let allowedEnd = seekable.end(seekable.length - 1) + $cb03b711053a4297$var$SAFE_TIME_DELTA;
        const isLive = !playlist.endList;
        const isLLHLS = typeof playlist.partTargetDuration === "number";
        if (isLive && (isLLHLS || allowSeeksWithinUnsafeLiveWindow)) allowedEnd = seekable.end(seekable.length - 1) + playlist.targetDuration * 3;
        if (currentTime > allowedEnd) return true;
        return false;
    }
    beforeSeekableWindow_(seekable, currentTime) {
        if (seekable.length && // can't fall before 0 and 0 seekable start identifies VOD stream
        seekable.start(0) > 0 && currentTime < seekable.start(0) - this.liveRangeSafeTimeDelta) return true;
        return false;
    }
    videoUnderflow_({ videoBuffered: videoBuffered, audioBuffered: audioBuffered, currentTime: currentTime }) {
        // audio only content will not have video underflow :)
        if (!videoBuffered) return;
        let gap; // find a gap in demuxed content.
        if (videoBuffered.length && audioBuffered.length) {
            // in Chrome audio will continue to play for ~3s when we run out of video
            // so we have to check that the video buffer did have some buffer in the
            // past.
            const lastVideoRange = $cb03b711053a4297$var$findRange(videoBuffered, currentTime - 3);
            const videoRange = $cb03b711053a4297$var$findRange(videoBuffered, currentTime);
            const audioRange = $cb03b711053a4297$var$findRange(audioBuffered, currentTime);
            if (audioRange.length && !videoRange.length && lastVideoRange.length) gap = {
                start: lastVideoRange.end(0),
                end: audioRange.end(0)
            };
             // find a gap in muxed content.
        } else {
            const nextRange = $cb03b711053a4297$var$findNextRange(videoBuffered, currentTime); // Even if there is no available next range, there is still a possibility we are
            // stuck in a gap due to video underflow.
            if (!nextRange.length) gap = this.gapFromVideoUnderflow_(videoBuffered, currentTime);
        }
        if (gap) {
            this.logger_(`Encountered a gap in video from ${gap.start} to ${gap.end}. ` + `Seeking to current time ${currentTime}`);
            return true;
        }
        return false;
    }
    /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */ skipTheGap_(scheduledCurrentTime) {
        const buffered = this.tech_.buffered();
        const currentTime = this.tech_.currentTime();
        const nextRange = $cb03b711053a4297$var$findNextRange(buffered, currentTime);
        this.resetTimeUpdate_();
        if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) return;
        this.logger_("skipTheGap_:", "currentTime:", currentTime, "scheduled currentTime:", scheduledCurrentTime, "nextRange start:", nextRange.start(0)); // only seek if we still have not played
        this.tech_.setCurrentTime(nextRange.start(0) + $cb03b711053a4297$var$TIME_FUDGE_FACTOR);
        this.tech_.trigger({
            type: "usage",
            name: "vhs-gap-skip"
        });
    }
    gapFromVideoUnderflow_(buffered, currentTime) {
        // At least in Chrome, if there is a gap in the video buffer, the audio will continue
        // playing for ~3 seconds after the video gap starts. This is done to account for
        // video buffer underflow/underrun (note that this is not done when there is audio
        // buffer underflow/underrun -- in that case the video will stop as soon as it
        // encounters the gap, as audio stalls are more noticeable/jarring to a user than
        // video stalls). The player's time will reflect the playthrough of audio, so the
        // time will appear as if we are in a buffered region, even if we are stuck in a
        // "gap."
        //
        // Example:
        // video buffer:   0 => 10.1, 10.2 => 20
        // audio buffer:   0 => 20
        // overall buffer: 0 => 10.1, 10.2 => 20
        // current time: 13
        //
        // Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
        // however, the audio continued playing until it reached ~3 seconds past the gap
        // (13 seconds), at which point it stops as well. Since current time is past the
        // gap, findNextRange will return no ranges.
        //
        // To check for this issue, we see if there is a gap that starts somewhere within
        // a 3 second range (3 seconds +/- 1 second) back from our current time.
        const gaps = $cb03b711053a4297$var$findGaps(buffered);
        for(let i = 0; i < gaps.length; i++){
            const start = gaps.start(i);
            const end = gaps.end(i); // gap is starts no more than 4 seconds back
            if (currentTime - start < 4 && currentTime - start > 2) return {
                start: start,
                end: end
            };
        }
        return null;
    }
}
const $cb03b711053a4297$var$defaultOptions = {
    errorInterval: 30,
    getSource (next) {
        const tech = this.tech({
            IWillNotUseThisInPlugins: true
        });
        const sourceObj = tech.currentSource_ || this.currentSource();
        return next(sourceObj);
    }
};
/**
 * Main entry point for the plugin
 *
 * @param {Player} player a reference to a videojs Player instance
 * @param {Object} [options] an object with plugin options
 * @private
 */ const $cb03b711053a4297$var$initPlugin = function(player, options) {
    let lastCalled = 0;
    let seekTo = 0;
    const localOptions = $cb03b711053a4297$var$merge($cb03b711053a4297$var$defaultOptions, options);
    player.ready(()=>{
        player.trigger({
            type: "usage",
            name: "vhs-error-reload-initialized"
        });
    });
    /**
   * Player modifications to perform that must wait until `loadedmetadata`
   * has been triggered
   *
   * @private
   */ const loadedMetadataHandler = function() {
        if (seekTo) player.currentTime(seekTo);
    };
    /**
   * Set the source on the player element, play, and seek if necessary
   *
   * @param {Object} sourceObj An object specifying the source url and mime-type to play
   * @private
   */ const setSource = function(sourceObj) {
        if (sourceObj === null || sourceObj === undefined) return;
        seekTo = player.duration() !== Infinity && player.currentTime() || 0;
        player.one("loadedmetadata", loadedMetadataHandler);
        player.src(sourceObj);
        player.trigger({
            type: "usage",
            name: "vhs-error-reload"
        });
        player.play();
    };
    /**
   * Attempt to get a source from either the built-in getSource function
   * or a custom function provided via the options
   *
   * @private
   */ const errorHandler = function() {
        // Do not attempt to reload the source if a source-reload occurred before
        // 'errorInterval' time has elapsed since the last source-reload
        if (Date.now() - lastCalled < localOptions.errorInterval * 1000) {
            player.trigger({
                type: "usage",
                name: "vhs-error-reload-canceled"
            });
            return;
        }
        if (!localOptions.getSource || typeof localOptions.getSource !== "function") {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
            return;
        }
        lastCalled = Date.now();
        return localOptions.getSource.call(player, setSource);
    };
    /**
   * Unbind any event handlers that were bound by the plugin
   *
   * @private
   */ const cleanupEvents = function() {
        player.off("loadedmetadata", loadedMetadataHandler);
        player.off("error", errorHandler);
        player.off("dispose", cleanupEvents);
    };
    /**
   * Cleanup before re-initializing the plugin
   *
   * @param {Object} [newOptions] an object with plugin options
   * @private
   */ const reinitPlugin = function(newOptions) {
        cleanupEvents();
        $cb03b711053a4297$var$initPlugin(player, newOptions);
    };
    player.on("error", errorHandler);
    player.on("dispose", cleanupEvents); // Overwrite the plugin function so that we can correctly cleanup before
    // initializing the plugin
    player.reloadSourceOnError = reinitPlugin;
};
/**
 * Reload the source when an error is detected as long as there
 * wasn't an error previously within the last 30 seconds
 *
 * @param {Object} [options] an object with plugin options
 */ const $cb03b711053a4297$var$reloadSourceOnError = function(options) {
    $cb03b711053a4297$var$initPlugin(this, options);
};
var $cb03b711053a4297$var$version$4 = "3.7.0";
var $cb03b711053a4297$var$version$3 = "7.0.1";
var $cb03b711053a4297$var$version$2 = "1.2.2";
var $cb03b711053a4297$var$version$1 = "7.1.0";
var $cb03b711053a4297$var$version = "4.0.1";
/**
 * @file videojs-http-streaming.js
 *
 * The main file for the VHS project.
 * License: https://github.com/videojs/videojs-http-streaming/blob/main/LICENSE
 */ const $cb03b711053a4297$var$Vhs = {
    PlaylistLoader: $cb03b711053a4297$var$PlaylistLoader,
    Playlist: $cb03b711053a4297$var$Playlist,
    utils: $cb03b711053a4297$var$utils,
    STANDARD_PLAYLIST_SELECTOR: $cb03b711053a4297$var$lastBandwidthSelector,
    INITIAL_PLAYLIST_SELECTOR: $cb03b711053a4297$var$lowestBitrateCompatibleVariantSelector,
    lastBandwidthSelector: $cb03b711053a4297$var$lastBandwidthSelector,
    movingAverageBandwidthSelector: $cb03b711053a4297$var$movingAverageBandwidthSelector,
    comparePlaylistBandwidth: $cb03b711053a4297$var$comparePlaylistBandwidth,
    comparePlaylistResolution: $cb03b711053a4297$var$comparePlaylistResolution,
    xhr: $cb03b711053a4297$var$xhrFactory()
}; // Define getter/setters for config properties
Object.keys($cb03b711053a4297$var$Config).forEach((prop)=>{
    Object.defineProperty($cb03b711053a4297$var$Vhs, prop, {
        get () {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`using Vhs.${prop} is UNSAFE be sure you know what you are doing`);
            return $cb03b711053a4297$var$Config[prop];
        },
        set (value) {
            $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`using Vhs.${prop} is UNSAFE be sure you know what you are doing`);
            if (typeof value !== "number" || value < 0) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn(`value of Vhs.${prop} must be greater than or equal to 0`);
                return;
            }
            $cb03b711053a4297$var$Config[prop] = value;
        }
    });
});
const $cb03b711053a4297$var$LOCAL_STORAGE_KEY = "videojs-vhs";
/**
 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
 * @function handleVhsMediaChange
 */ const $cb03b711053a4297$var$handleVhsMediaChange = function(qualityLevels, playlistLoader) {
    const newPlaylist = playlistLoader.media();
    let selectedIndex = -1;
    for(let i = 0; i < qualityLevels.length; i++)if (qualityLevels[i].id === newPlaylist.id) {
        selectedIndex = i;
        break;
    }
    qualityLevels.selectedIndex_ = selectedIndex;
    qualityLevels.trigger({
        selectedIndex: selectedIndex,
        type: "change"
    });
};
/**
 * Adds quality levels to list once playlist metadata is available
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
 * @param {Object} vhs Vhs object to listen to for media events.
 * @function handleVhsLoadedMetadata
 */ const $cb03b711053a4297$var$handleVhsLoadedMetadata = function(qualityLevels, vhs) {
    vhs.representations().forEach((rep)=>{
        qualityLevels.addQualityLevel(rep);
    });
    $cb03b711053a4297$var$handleVhsMediaChange(qualityLevels, vhs.playlists);
}; // VHS is a source handler, not a tech. Make sure attempts to use it
// as one do not cause exceptions.
$cb03b711053a4297$var$Vhs.canPlaySource = function() {
    return $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const $cb03b711053a4297$var$emeKeySystems = (keySystemOptions, mainPlaylist, audioPlaylist)=>{
    if (!keySystemOptions) return keySystemOptions;
    let codecs = {};
    if (mainPlaylist && mainPlaylist.attributes && mainPlaylist.attributes.CODECS) codecs = $cb03b711053a4297$var$unwrapCodecList((0, $e324d09415701181$export$56679b562aa2891c)(mainPlaylist.attributes.CODECS));
    if (audioPlaylist && audioPlaylist.attributes && audioPlaylist.attributes.CODECS) codecs.audio = audioPlaylist.attributes.CODECS;
    const videoContentType = (0, $e324d09415701181$export$4b64fc0a026b9981)(codecs.video);
    const audioContentType = (0, $e324d09415701181$export$4b64fc0a026b9981)(codecs.audio); // upsert the content types based on the selected playlist
    const keySystemContentTypes = {};
    for(const keySystem in keySystemOptions){
        keySystemContentTypes[keySystem] = {};
        if (audioContentType) keySystemContentTypes[keySystem].audioContentType = audioContentType;
        if (videoContentType) keySystemContentTypes[keySystem].videoContentType = videoContentType;
         // Default to using the video playlist's PSSH even though they may be different, as
        // videojs-contrib-eme will only accept one in the options.
        //
        // This shouldn't be an issue for most cases as early intialization will handle all
        // unique PSSH values, and if they aren't, then encrypted events should have the
        // specific information needed for the unique license.
        if (mainPlaylist.contentProtection && mainPlaylist.contentProtection[keySystem] && mainPlaylist.contentProtection[keySystem].pssh) keySystemContentTypes[keySystem].pssh = mainPlaylist.contentProtection[keySystem].pssh;
         // videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
        // so we need to prevent overwriting the URL entirely
        if (typeof keySystemOptions[keySystem] === "string") keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
    }
    return $cb03b711053a4297$var$merge(keySystemOptions, keySystemContentTypes);
};
/**
 * @typedef {Object} KeySystems
 *
 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
 * Note: not all options are listed here.
 *
 * @property {Uint8Array} [pssh]
 *           Protection System Specific Header
 */ /**
 * Goes through all the playlists and collects an array of KeySystems options objects
 * containing each playlist's keySystems and their pssh values, if available.
 *
 * @param {Object[]} playlists
 *        The playlists to look through
 * @param {string[]} keySystems
 *        The keySystems to collect pssh values for
 *
 * @return {KeySystems[]}
 *         An array of KeySystems objects containing available key systems and their
 *         pssh values
 */ const $cb03b711053a4297$var$getAllPsshKeySystemsOptions = (playlists, keySystems)=>{
    return playlists.reduce((keySystemsArr, playlist)=>{
        if (!playlist.contentProtection) return keySystemsArr;
        const keySystemsOptions = keySystems.reduce((keySystemsObj, keySystem)=>{
            const keySystemOptions = playlist.contentProtection[keySystem];
            if (keySystemOptions && keySystemOptions.pssh) keySystemsObj[keySystem] = {
                pssh: keySystemOptions.pssh
            };
            return keySystemsObj;
        }, {});
        if (Object.keys(keySystemsOptions).length) keySystemsArr.push(keySystemsOptions);
        return keySystemsArr;
    }, []);
};
/**
 * Returns a promise that waits for the
 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
 *
 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
 * browsers.
 *
 * As per the above ticket, this is particularly important for Chrome, where, if
 * unencrypted content is appended before encrypted content and the key session has not
 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
 * during playback.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 * @param {Object[]} mainPlaylists
 *        The playlists found on the main playlist object
 *
 * @return {Object}
 *         Promise that resolves when the key session has been created
 */ const $cb03b711053a4297$var$waitForKeySessionCreation = ({ player: player, sourceKeySystems: sourceKeySystems, audioMedia: audioMedia, mainPlaylists: mainPlaylists })=>{
    if (!player.eme.initializeMediaKeys) return Promise.resolve();
     // TODO should all audio PSSH values be initialized for DRM?
    //
    // All unique video rendition pssh values are initialized for DRM, but here only
    // the initial audio playlist license is initialized. In theory, an encrypted
    // event should be fired if the user switches to an alternative audio playlist
    // where a license is required, but this case hasn't yet been tested. In addition, there
    // may be many alternate audio playlists unlikely to be used (e.g., multiple different
    // languages).
    const playlists = audioMedia ? mainPlaylists.concat([
        audioMedia
    ]) : mainPlaylists;
    const keySystemsOptionsArr = $cb03b711053a4297$var$getAllPsshKeySystemsOptions(playlists, Object.keys(sourceKeySystems));
    const initializationFinishedPromises = [];
    const keySessionCreatedPromises = []; // Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
    // only place where it should not be deduped is for ms-prefixed APIs, but
    // the existence of modern EME APIs in addition to
    // ms-prefixed APIs on Edge should prevent this from being a concern.
    // initializeMediaKeys also won't use the webkit-prefixed APIs.
    keySystemsOptionsArr.forEach((keySystemsOptions)=>{
        keySessionCreatedPromises.push(new Promise((resolve, reject)=>{
            player.tech_.one("keysessioncreated", resolve);
        }));
        initializationFinishedPromises.push(new Promise((resolve, reject)=>{
            player.eme.initializeMediaKeys({
                keySystems: keySystemsOptions
            }, (err)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve();
            });
        }));
    }); // The reasons Promise.race is chosen over Promise.any:
    //
    // * Promise.any is only available in Safari 14+.
    // * None of these promises are expected to reject. If they do reject, it might be
    //   better here for the race to surface the rejection, rather than mask it by using
    //   Promise.any.
    return Promise.race([
        // If a session was previously created, these will all finish resolving without
        // creating a new session, otherwise it will take until the end of all license
        // requests, which is why the key session check is used (to make setup much faster).
        Promise.all(initializationFinishedPromises),
        // Once a single session is created, the browser knows DRM will be used.
        Promise.race(keySessionCreatedPromises)
    ]);
};
/**
 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
 * there are keySystems on the source, sets up source options to prepare the source for
 * eme.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} media
 *        The active media playlist
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 *
 * @return {boolean}
 *         Whether or not options were configured and EME is available
 */ const $cb03b711053a4297$var$setupEmeOptions = ({ player: player, sourceKeySystems: sourceKeySystems, media: media, audioMedia: audioMedia })=>{
    const sourceOptions = $cb03b711053a4297$var$emeKeySystems(sourceKeySystems, media, audioMedia);
    if (!sourceOptions) return false;
    player.currentSource().keySystems = sourceOptions; // eme handles the rest of the setup, so if it is missing
    // do nothing.
    if (sourceOptions && !player.eme) {
        $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin");
        return false;
    }
    return true;
};
const $cb03b711053a4297$var$getVhsLocalStorage = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage) return null;
    const storedObject = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.getItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY);
    if (!storedObject) return null;
    try {
        return JSON.parse(storedObject);
    } catch (e) {
        // someone may have tampered with the value
        return null;
    }
};
const $cb03b711053a4297$var$updateVhsLocalStorage = (options)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage) return false;
    let objectToStore = $cb03b711053a4297$var$getVhsLocalStorage();
    objectToStore = objectToStore ? $cb03b711053a4297$var$merge(objectToStore, options) : options;
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).localStorage.setItem($cb03b711053a4297$var$LOCAL_STORAGE_KEY, JSON.stringify(objectToStore));
    } catch (e) {
        // Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
        // storage is set to 0).
        // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
        // No need to perform any operation.
        return false;
    }
    return objectToStore;
};
/**
 * Parses VHS-supported media types from data URIs. See
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 * for information on data URIs.
 *
 * @param {string} dataUri
 *        The data URI
 *
 * @return {string|Object}
 *         The parsed object/string, or the original string if no supported media type
 *         was found
 */ const $cb03b711053a4297$var$expandDataUri = (dataUri)=>{
    if (dataUri.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0) return JSON.parse(dataUri.substring(dataUri.indexOf(",") + 1));
     // no known case for this data URI, return the string as-is
    return dataUri;
};
/**
 * Adds a request hook to an xhr object
 *
 * @param {Object} xhr object to add the onRequest hook to
 * @param {function} callback hook function for an xhr request
 */ const $cb03b711053a4297$var$addOnRequestHook = (xhr, callback)=>{
    if (!xhr._requestCallbackSet) xhr._requestCallbackSet = new Set();
    xhr._requestCallbackSet.add(callback);
};
/**
 * Adds a response hook to an xhr object
 *
 * @param {Object} xhr object to add the onResponse hook to
 * @param {function} callback hook function for an xhr response
 */ const $cb03b711053a4297$var$addOnResponseHook = (xhr, callback)=>{
    if (!xhr._responseCallbackSet) xhr._responseCallbackSet = new Set();
    xhr._responseCallbackSet.add(callback);
};
/**
 * Removes a request hook on an xhr object, deletes the onRequest set if empty.
 *
 * @param {Object} xhr object to remove the onRequest hook from
 * @param {function} callback hook function to remove
 */ const $cb03b711053a4297$var$removeOnRequestHook = (xhr, callback)=>{
    if (!xhr._requestCallbackSet) return;
    xhr._requestCallbackSet.delete(callback);
    if (!xhr._requestCallbackSet.size) delete xhr._requestCallbackSet;
};
/**
 * Removes a response hook on an xhr object, deletes the onResponse set if empty.
 *
 * @param {Object} xhr object to remove the onResponse hook from
 * @param {function} callback hook function to remove
 */ const $cb03b711053a4297$var$removeOnResponseHook = (xhr, callback)=>{
    if (!xhr._responseCallbackSet) return;
    xhr._responseCallbackSet.delete(callback);
    if (!xhr._responseCallbackSet.size) delete xhr._responseCallbackSet;
};
/**
 * Whether the browser has built-in HLS support.
 */ $cb03b711053a4297$var$Vhs.supportsNativeHls = function() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) || !(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement) return false;
    const video = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("video"); // native HLS is definitely not supported if HTML5 video isn't
    if (!$cb03b711053a4297$export$2e2bcd8739ae039.getTech("Html5").isSupported()) return false;
     // HLS manifests can go by many mime-types
    const canPlay = [
        // Apple santioned
        "application/vnd.apple.mpegurl",
        // Apple sanctioned for backwards compatibility
        "audio/mpegurl",
        // Very common
        "audio/x-mpegurl",
        // Very common
        "application/x-mpegurl",
        // Included for completeness
        "video/x-mpegurl",
        "video/mpegurl",
        "application/mpegurl"
    ];
    return canPlay.some(function(canItPlay) {
        return /maybe|probably/i.test(video.canPlayType(canItPlay));
    });
}();
$cb03b711053a4297$var$Vhs.supportsNativeDash = function() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))) || !(0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement || !$cb03b711053a4297$export$2e2bcd8739ae039.getTech("Html5").isSupported()) return false;
    return /maybe|probably/i.test((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).createElement("video").canPlayType("application/dash+xml"));
}();
$cb03b711053a4297$var$Vhs.supportsTypeNatively = (type)=>{
    if (type === "hls") return $cb03b711053a4297$var$Vhs.supportsNativeHls;
    if (type === "dash") return $cb03b711053a4297$var$Vhs.supportsNativeDash;
    return false;
};
/**
 * VHS is a source handler, not a tech. Make sure attempts to use it
 * as one do not cause exceptions.
 */ $cb03b711053a4297$var$Vhs.isSupported = function() {
    return $cb03b711053a4297$export$2e2bcd8739ae039.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
/**
 * A global function for setting an onRequest hook
 *
 * @param {function} callback for request modifiction
 */ $cb03b711053a4297$var$Vhs.xhr.onRequest = function(callback) {
    $cb03b711053a4297$var$addOnRequestHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
/**
 * A global function for setting an onResponse hook
 *
 * @param {callback} callback for response data retrieval
 */ $cb03b711053a4297$var$Vhs.xhr.onResponse = function(callback) {
    $cb03b711053a4297$var$addOnResponseHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
/**
 * Deletes a global onRequest callback if it exists
 *
 * @param {function} callback to delete from the global set
 */ $cb03b711053a4297$var$Vhs.xhr.offRequest = function(callback) {
    $cb03b711053a4297$var$removeOnRequestHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
/**
 * Deletes a global onResponse callback if it exists
 *
 * @param {function} callback to delete from the global set
 */ $cb03b711053a4297$var$Vhs.xhr.offResponse = function(callback) {
    $cb03b711053a4297$var$removeOnResponseHook($cb03b711053a4297$var$Vhs.xhr, callback);
};
const $cb03b711053a4297$var$Component = $cb03b711053a4297$export$2e2bcd8739ae039.getComponent("Component");
/**
 * The Vhs Handler object, where we orchestrate all of the parts
 * of VHS to interact with video.js
 *
 * @class VhsHandler
 * @extends videojs.Component
 * @param {Object} source the soruce object
 * @param {Tech} tech the parent tech object
 * @param {Object} options optional and required options
 */ class $cb03b711053a4297$var$VhsHandler extends $cb03b711053a4297$var$Component {
    constructor(source, tech, options){
        super(tech, options.vhs); // if a tech level `initialBandwidth` option was passed
        // use that over the VHS level `bandwidth` option
        if (typeof options.initialBandwidth === "number") this.options_.bandwidth = options.initialBandwidth;
        this.logger_ = $cb03b711053a4297$var$logger("VhsHandler"); // we need access to the player in some cases,
        // so, get it from Video.js via the `playerId`
        if (tech.options_ && tech.options_.playerId) {
            const _player = $cb03b711053a4297$export$2e2bcd8739ae039.getPlayer(tech.options_.playerId);
            this.player_ = _player;
        }
        this.tech_ = tech;
        this.source_ = source;
        this.stats = {};
        this.ignoreNextSeekingEvent_ = false;
        this.setOptions_();
        if (this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
            tech.overrideNativeAudioTracks(true);
            tech.overrideNativeVideoTracks(true);
        } else if (this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) // overriding native VHS only works if audio tracks have been emulated
        // error early if we're misconfigured
        throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
         // listen for fullscreenchange events for this player so that we
        // can adjust our quality selection quickly
        this.on((0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))), [
            "fullscreenchange",
            "webkitfullscreenchange",
            "mozfullscreenchange",
            "MSFullscreenChange"
        ], (event)=>{
            const fullscreenElement = (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).fullscreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).webkitFullscreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).mozFullScreenElement || (0, (/*@__PURE__*/$parcel$interopDefault($7pNCM))).msFullscreenElement;
            if (fullscreenElement && fullscreenElement.contains(this.tech_.el())) this.playlistController_.fastQualityChange_();
            else // When leaving fullscreen, since the in page pixel dimensions should be smaller
            // than full screen, see if there should be a rendition switch down to preserve
            // bandwidth.
            this.playlistController_.checkABR_();
        });
        this.on(this.tech_, "seeking", function() {
            if (this.ignoreNextSeekingEvent_) {
                this.ignoreNextSeekingEvent_ = false;
                return;
            }
            this.setCurrentTime(this.tech_.currentTime());
        });
        this.on(this.tech_, "error", function() {
            // verify that the error was real and we are loaded
            // enough to have pc loaded.
            if (this.tech_.error() && this.playlistController_) this.playlistController_.pauseLoading();
        });
        this.on(this.tech_, "play", this.play);
    }
    setOptions_() {
        // defaults
        this.options_.withCredentials = this.options_.withCredentials || false;
        this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions === false ? false : true;
        this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || false;
        this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage !== "undefined" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || false;
        this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || false;
        this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || false;
        this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || false;
        this.options_.calculateTimestampOffsetForEachSegment = this.options_.calculateTimestampOffsetForEachSegment || false;
        this.options_.customTagParsers = this.options_.customTagParsers || [];
        this.options_.customTagMappers = this.options_.customTagMappers || [];
        this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || false;
        this.options_.llhls = this.options_.llhls === false ? false : true;
        this.options_.bufferBasedABR = this.options_.bufferBasedABR || false;
        if (typeof this.options_.playlistExclusionDuration !== "number") this.options_.playlistExclusionDuration = 60;
        if (typeof this.options_.bandwidth !== "number") {
            if (this.options_.useBandwidthFromLocalStorage) {
                const storedObject = $cb03b711053a4297$var$getVhsLocalStorage();
                if (storedObject && storedObject.bandwidth) {
                    this.options_.bandwidth = storedObject.bandwidth;
                    this.tech_.trigger({
                        type: "usage",
                        name: "vhs-bandwidth-from-local-storage"
                    });
                }
                if (storedObject && storedObject.throughput) {
                    this.options_.throughput = storedObject.throughput;
                    this.tech_.trigger({
                        type: "usage",
                        name: "vhs-throughput-from-local-storage"
                    });
                }
            }
        } // if bandwidth was not set by options or pulled from local storage, start playlist
        // selection at a reasonable bandwidth
        if (typeof this.options_.bandwidth !== "number") this.options_.bandwidth = $cb03b711053a4297$var$Config.INITIAL_BANDWIDTH;
         // If the bandwidth number is unchanged from the initial setting
        // then this takes precedence over the enableLowInitialPlaylist option
        this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === $cb03b711053a4297$var$Config.INITIAL_BANDWIDTH; // grab options passed to player.src
        [
            "withCredentials",
            "useDevicePixelRatio",
            "limitRenditionByPlayerDimensions",
            "bandwidth",
            "customTagParsers",
            "customTagMappers",
            "cacheEncryptionKeys",
            "playlistSelector",
            "initialPlaylistSelector",
            "bufferBasedABR",
            "liveRangeSafeTimeDelta",
            "llhls",
            "useForcedSubtitles",
            "useNetworkInformationApi",
            "useDtsForTimestampOffset",
            "calculateTimestampOffsetForEachSegment",
            "exactManifestTimings",
            "leastPixelDiffSelector"
        ].forEach((option)=>{
            if (typeof this.source_[option] !== "undefined") this.options_[option] = this.source_[option];
        });
        this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
        this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
    }
    /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */ src(src, type) {
        // do nothing if the src is falsey
        if (!src) return;
        this.setOptions_(); // add main playlist controller options
        this.options_.src = $cb03b711053a4297$var$expandDataUri(this.source_.src);
        this.options_.tech = this.tech_;
        this.options_.externVhs = $cb03b711053a4297$var$Vhs;
        this.options_.sourceType = (0, $72433138d4bc8325$export$c4f0bf48244d4c05)(type); // Whenever we seek internally, we should update the tech
        this.options_.seekTo = (time)=>{
            this.tech_.setCurrentTime(time);
        };
        this.playlistController_ = new $cb03b711053a4297$var$PlaylistController(this.options_);
        const playbackWatcherOptions = $cb03b711053a4297$var$merge({
            liveRangeSafeTimeDelta: $cb03b711053a4297$var$SAFE_TIME_DELTA
        }, this.options_, {
            seekable: ()=>this.seekable(),
            media: ()=>this.playlistController_.media(),
            playlistController: this.playlistController_
        });
        this.playbackWatcher_ = new $cb03b711053a4297$var$PlaybackWatcher(playbackWatcherOptions);
        this.playlistController_.on("error", ()=>{
            const player = $cb03b711053a4297$export$2e2bcd8739ae039.players[this.tech_.options_.playerId];
            let error = this.playlistController_.error;
            if (typeof error === "object" && !error.code) error.code = 3;
            else if (typeof error === "string") error = {
                message: error,
                code: 3
            };
            player.error(error);
        });
        const defaultSelector = this.options_.bufferBasedABR ? $cb03b711053a4297$var$Vhs.movingAverageBandwidthSelector(0.55) : $cb03b711053a4297$var$Vhs.STANDARD_PLAYLIST_SELECTOR; // `this` in selectPlaylist should be the VhsHandler for backwards
        // compatibility with < v2
        this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : defaultSelector.bind(this);
        this.playlistController_.selectInitialPlaylist = $cb03b711053a4297$var$Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this); // re-expose some internal objects for backwards compatibility with < v2
        this.playlists = this.playlistController_.mainPlaylistLoader_;
        this.mediaSource = this.playlistController_.mediaSource; // Proxy assignment of some properties to the main playlist
        // controller. Using a custom property for backwards compatibility
        // with < v2
        Object.defineProperties(this, {
            selectPlaylist: {
                get () {
                    return this.playlistController_.selectPlaylist;
                },
                set (selectPlaylist) {
                    this.playlistController_.selectPlaylist = selectPlaylist.bind(this);
                }
            },
            throughput: {
                get () {
                    return this.playlistController_.mainSegmentLoader_.throughput.rate;
                },
                set (throughput) {
                    this.playlistController_.mainSegmentLoader_.throughput.rate = throughput; // By setting `count` to 1 the throughput value becomes the starting value
                    // for the cumulative average
                    this.playlistController_.mainSegmentLoader_.throughput.count = 1;
                }
            },
            bandwidth: {
                get () {
                    let playerBandwidthEst = this.playlistController_.mainSegmentLoader_.bandwidth;
                    const networkInformation = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.connection || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.mozConnection || (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).navigator.webkitConnection;
                    const tenMbpsAsBitsPerSecond = 10e6;
                    if (this.options_.useNetworkInformationApi && networkInformation) {
                        // downlink returns Mbps
                        // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
                        const networkInfoBandwidthEstBitsPerSec = networkInformation.downlink * 1000000; // downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
                        // estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
                        // high quality streams are not filtered out.
                        if (networkInfoBandwidthEstBitsPerSec >= tenMbpsAsBitsPerSecond && playerBandwidthEst >= tenMbpsAsBitsPerSecond) playerBandwidthEst = Math.max(playerBandwidthEst, networkInfoBandwidthEstBitsPerSec);
                        else playerBandwidthEst = networkInfoBandwidthEstBitsPerSec;
                    }
                    return playerBandwidthEst;
                },
                set (bandwidth) {
                    this.playlistController_.mainSegmentLoader_.bandwidth = bandwidth; // setting the bandwidth manually resets the throughput counter
                    // `count` is set to zero that current value of `rate` isn't included
                    // in the cumulative average
                    this.playlistController_.mainSegmentLoader_.throughput = {
                        rate: 0,
                        count: 0
                    };
                }
            },
            /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */ systemBandwidth: {
                get () {
                    const invBandwidth = 1 / (this.bandwidth || 1);
                    let invThroughput;
                    if (this.throughput > 0) invThroughput = 1 / this.throughput;
                    else invThroughput = 0;
                    const systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
                    return systemBitrate;
                },
                set () {
                    $cb03b711053a4297$export$2e2bcd8739ae039.log.error('The "systemBandwidth" property is read-only');
                }
            }
        });
        if (this.options_.bandwidth) this.bandwidth = this.options_.bandwidth;
        if (this.options_.throughput) this.throughput = this.options_.throughput;
        Object.defineProperties(this.stats, {
            bandwidth: {
                get: ()=>this.bandwidth || 0,
                enumerable: true
            },
            mediaRequests: {
                get: ()=>this.playlistController_.mediaRequests_() || 0,
                enumerable: true
            },
            mediaRequestsAborted: {
                get: ()=>this.playlistController_.mediaRequestsAborted_() || 0,
                enumerable: true
            },
            mediaRequestsTimedout: {
                get: ()=>this.playlistController_.mediaRequestsTimedout_() || 0,
                enumerable: true
            },
            mediaRequestsErrored: {
                get: ()=>this.playlistController_.mediaRequestsErrored_() || 0,
                enumerable: true
            },
            mediaTransferDuration: {
                get: ()=>this.playlistController_.mediaTransferDuration_() || 0,
                enumerable: true
            },
            mediaBytesTransferred: {
                get: ()=>this.playlistController_.mediaBytesTransferred_() || 0,
                enumerable: true
            },
            mediaSecondsLoaded: {
                get: ()=>this.playlistController_.mediaSecondsLoaded_() || 0,
                enumerable: true
            },
            mediaAppends: {
                get: ()=>this.playlistController_.mediaAppends_() || 0,
                enumerable: true
            },
            mainAppendsToLoadedData: {
                get: ()=>this.playlistController_.mainAppendsToLoadedData_() || 0,
                enumerable: true
            },
            audioAppendsToLoadedData: {
                get: ()=>this.playlistController_.audioAppendsToLoadedData_() || 0,
                enumerable: true
            },
            appendsToLoadedData: {
                get: ()=>this.playlistController_.appendsToLoadedData_() || 0,
                enumerable: true
            },
            timeToLoadedData: {
                get: ()=>this.playlistController_.timeToLoadedData_() || 0,
                enumerable: true
            },
            buffered: {
                get: ()=>$cb03b711053a4297$var$timeRangesToArray(this.tech_.buffered()),
                enumerable: true
            },
            currentTime: {
                get: ()=>this.tech_.currentTime(),
                enumerable: true
            },
            currentSource: {
                get: ()=>this.tech_.currentSource_,
                enumerable: true
            },
            currentTech: {
                get: ()=>this.tech_.name_,
                enumerable: true
            },
            duration: {
                get: ()=>this.tech_.duration(),
                enumerable: true
            },
            main: {
                get: ()=>this.playlists.main,
                enumerable: true
            },
            playerDimensions: {
                get: ()=>this.tech_.currentDimensions(),
                enumerable: true
            },
            seekable: {
                get: ()=>$cb03b711053a4297$var$timeRangesToArray(this.tech_.seekable()),
                enumerable: true
            },
            timestamp: {
                get: ()=>Date.now(),
                enumerable: true
            },
            videoPlaybackQuality: {
                get: ()=>this.tech_.getVideoPlaybackQuality(),
                enumerable: true
            }
        });
        this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_));
        this.tech_.on("bandwidthupdate", ()=>{
            if (this.options_.useBandwidthFromLocalStorage) $cb03b711053a4297$var$updateVhsLocalStorage({
                bandwidth: this.bandwidth,
                throughput: Math.round(this.throughput)
            });
        });
        this.playlistController_.on("selectedinitialmedia", ()=>{
            // Add the manual rendition mix-in to VhsHandler
            $cb03b711053a4297$var$renditionSelectionMixin(this);
        });
        this.playlistController_.sourceUpdater_.on("createdsourcebuffers", ()=>{
            this.setupEme_();
        }); // the bandwidth of the primary segment loader is our best
        // estimate of overall bandwidth
        this.on(this.playlistController_, "progress", function() {
            this.tech_.trigger("progress");
        }); // In the live case, we need to ignore the very first `seeking` event since
        // that will be the result of the seek-to-live behavior
        this.on(this.playlistController_, "firstplay", function() {
            this.ignoreNextSeekingEvent_ = true;
        });
        this.setupQualityLevels_(); // do nothing if the tech has been disposed already
        // this can occur if someone sets the src in player.ready(), for instance
        if (!this.tech_.el()) return;
        this.mediaSourceUrl_ = (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL.createObjectURL(this.playlistController_.mediaSource);
        this.tech_.src(this.mediaSourceUrl_);
    }
    createKeySessions_() {
        const audioPlaylistLoader = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
        this.logger_("waiting for EME key session creation");
        $cb03b711053a4297$var$waitForKeySessionCreation({
            player: this.player_,
            sourceKeySystems: this.source_.keySystems,
            audioMedia: audioPlaylistLoader && audioPlaylistLoader.media(),
            mainPlaylists: this.playlists.main.playlists
        }).then(()=>{
            this.logger_("created EME key session");
            this.playlistController_.sourceUpdater_.initializedEme();
        }).catch((err)=>{
            this.logger_("error while creating EME key session", err);
            this.player_.error({
                message: "Failed to initialize media keys for EME",
                code: 3
            });
        });
    }
    handleWaitingForKey_() {
        // If waitingforkey is fired, it's possible that the data that's necessary to retrieve
        // the key is in the manifest. While this should've happened on initial source load, it
        // may happen again in live streams where the keys change, and the manifest info
        // reflects the update.
        //
        // Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
        // already requested keys for, we don't have to worry about this generating extraneous
        // requests.
        this.logger_("waitingforkey fired, attempting to create any new key sessions");
        this.createKeySessions_();
    }
    /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */ setupEme_() {
        const audioPlaylistLoader = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
        const didSetupEmeOptions = $cb03b711053a4297$var$setupEmeOptions({
            player: this.player_,
            sourceKeySystems: this.source_.keySystems,
            media: this.playlists.media(),
            audioMedia: audioPlaylistLoader && audioPlaylistLoader.media()
        });
        this.player_.tech_.on("keystatuschange", (e)=>{
            if (e.status !== "output-restricted") return;
            const mainPlaylist = this.playlistController_.main();
            if (!mainPlaylist || !mainPlaylist.playlists) return;
            const excludedHDPlaylists = []; // Assume all HD streams are unplayable and exclude them from ABR selection
            mainPlaylist.playlists.forEach((playlist)=>{
                if (playlist && playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height >= 720) {
                    if (!playlist.excludeUntil || playlist.excludeUntil < Infinity) {
                        playlist.excludeUntil = Infinity;
                        excludedHDPlaylists.push(playlist);
                    }
                }
            });
            if (excludedHDPlaylists.length) {
                $cb03b711053a4297$export$2e2bcd8739ae039.log.warn('DRM keystatus changed to "output-restricted." Removing the following HD playlists that will most likely fail to play and clearing the buffer. This may be due to HDCP restrictions on the stream and the capabilities of the current device.', ...excludedHDPlaylists); // Clear the buffer before switching playlists, since it may already contain unplayable segments
                this.playlistController_.mainSegmentLoader_.resetEverything();
                this.playlistController_.fastQualityChange_();
            }
        });
        this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this);
        this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_);
        if (!didSetupEmeOptions) {
            // If EME options were not set up, we've done all we could to initialize EME.
            this.playlistController_.sourceUpdater_.initializedEme();
            return;
        }
        this.createKeySessions_();
    }
    /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */ setupQualityLevels_() {
        const player = $cb03b711053a4297$export$2e2bcd8739ae039.players[this.tech_.options_.playerId]; // if there isn't a player or there isn't a qualityLevels plugin
        // or qualityLevels_ listeners have already been setup, do nothing.
        if (!player || !player.qualityLevels || this.qualityLevels_) return;
        this.qualityLevels_ = player.qualityLevels();
        this.playlistController_.on("selectedinitialmedia", ()=>{
            $cb03b711053a4297$var$handleVhsLoadedMetadata(this.qualityLevels_, this);
        });
        this.playlists.on("mediachange", ()=>{
            $cb03b711053a4297$var$handleVhsMediaChange(this.qualityLevels_, this.playlists);
        });
    }
    /**
   * return the version
   */ static version() {
        return {
            "@videojs/http-streaming": $cb03b711053a4297$var$version$4,
            "mux.js": $cb03b711053a4297$var$version$3,
            "mpd-parser": $cb03b711053a4297$var$version$2,
            "m3u8-parser": $cb03b711053a4297$var$version$1,
            "aes-decrypter": $cb03b711053a4297$var$version
        };
    }
    /**
   * return the version
   */ version() {
        return this.constructor.version();
    }
    canChangeType() {
        return $cb03b711053a4297$var$SourceUpdater.canChangeType();
    }
    /**
   * Begin playing the video.
   */ play() {
        this.playlistController_.play();
    }
    /**
   * a wrapper around the function in PlaylistController
   */ setCurrentTime(currentTime) {
        this.playlistController_.setCurrentTime(currentTime);
    }
    /**
   * a wrapper around the function in PlaylistController
   */ duration() {
        return this.playlistController_.duration();
    }
    /**
   * a wrapper around the function in PlaylistController
   */ seekable() {
        return this.playlistController_.seekable();
    }
    /**
   * Abort all outstanding work and cleanup.
   */ dispose() {
        if (this.playbackWatcher_) this.playbackWatcher_.dispose();
        if (this.playlistController_) this.playlistController_.dispose();
        if (this.qualityLevels_) this.qualityLevels_.dispose();
        if (this.tech_ && this.tech_.vhs) delete this.tech_.vhs;
        if (this.mediaSourceUrl_ && (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL.revokeObjectURL) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eDick))).URL.revokeObjectURL(this.mediaSourceUrl_);
            this.mediaSourceUrl_ = null;
        }
        if (this.tech_) this.tech_.off("waitingforkey", this.handleWaitingForKey_);
        super.dispose();
    }
    convertToProgramTime(time, callback) {
        return $cb03b711053a4297$var$getProgramTime({
            playlist: this.playlistController_.media(),
            time: time,
            callback: callback
        });
    }
    seekToProgramTime(programTime, callback, pauseAfterSeek = true, retryCount = 2) {
        return $cb03b711053a4297$var$seekToProgramTime({
            programTime: programTime,
            playlist: this.playlistController_.media(),
            retryCount: retryCount,
            pauseAfterSeek: pauseAfterSeek,
            seekTo: this.options_.seekTo,
            tech: this.options_.tech,
            callback: callback
        });
    }
    /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */ setupXhrHooks_() {
        /**
     * A player function for setting an onRequest hook
     *
     * @param {function} callback for request modifiction
     */ this.xhr.onRequest = (callback)=>{
            $cb03b711053a4297$var$addOnRequestHook(this.xhr, callback);
        };
        /**
     * A player function for setting an onResponse hook
     *
     * @param {callback} callback for response data retrieval
     */ this.xhr.onResponse = (callback)=>{
            $cb03b711053a4297$var$addOnResponseHook(this.xhr, callback);
        };
        /**
     * Deletes a player onRequest callback if it exists
     *
     * @param {function} callback to delete from the player set
     */ this.xhr.offRequest = (callback)=>{
            $cb03b711053a4297$var$removeOnRequestHook(this.xhr, callback);
        };
        /**
     * Deletes a player onResponse callback if it exists
     *
     * @param {function} callback to delete from the player set
     */ this.xhr.offResponse = (callback)=>{
            $cb03b711053a4297$var$removeOnResponseHook(this.xhr, callback);
        }; // Trigger an event on the player to notify the user that vhs is ready to set xhr hooks.
        // This allows hooks to be set before the source is set to vhs when handleSource is called.
        this.player_.trigger("xhr-hooks-ready");
    }
}
/**
 * The Source Handler object, which informs video.js what additional
 * MIME types are supported and sets up playback. It is registered
 * automatically to the appropriate tech based on the capabilities of
 * the browser it is running in. It is not necessary to use or modify
 * this object in normal usage.
 */ const $cb03b711053a4297$var$VhsSourceHandler = {
    name: "videojs-http-streaming",
    VERSION: $cb03b711053a4297$var$version$4,
    canHandleSource (srcObj, options = {}) {
        const localOptions = $cb03b711053a4297$var$merge($cb03b711053a4297$export$2e2bcd8739ae039.options, options);
        return $cb03b711053a4297$var$VhsSourceHandler.canPlayType(srcObj.type, localOptions);
    },
    handleSource (source, tech, options = {}) {
        const localOptions = $cb03b711053a4297$var$merge($cb03b711053a4297$export$2e2bcd8739ae039.options, options);
        tech.vhs = new $cb03b711053a4297$var$VhsHandler(source, tech, localOptions);
        tech.vhs.xhr = $cb03b711053a4297$var$xhrFactory();
        tech.vhs.setupXhrHooks_();
        tech.vhs.src(source.src, source.type);
        return tech.vhs;
    },
    canPlayType (type, options) {
        const simpleType = (0, $72433138d4bc8325$export$c4f0bf48244d4c05)(type);
        if (!simpleType) return "";
        const overrideNative = $cb03b711053a4297$var$VhsSourceHandler.getOverrideNative(options);
        const supportsTypeNatively = $cb03b711053a4297$var$Vhs.supportsTypeNatively(simpleType);
        const canUseMsePlayback = !supportsTypeNatively || overrideNative;
        return canUseMsePlayback ? "maybe" : "";
    },
    getOverrideNative (options = {}) {
        const { vhs: vhs = {} } = options;
        const defaultOverrideNative = !($cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_ANY_SAFARI || $cb03b711053a4297$export$2e2bcd8739ae039.browser.IS_IOS);
        const { overrideNative: overrideNative = defaultOverrideNative } = vhs;
        return overrideNative;
    }
};
/**
 * Check to see if the native MediaSource object exists and supports
 * an MP4 container with both H.264 video and AAC-LC audio.
 *
 * @return {boolean} if  native media sources are supported
 */ const $cb03b711053a4297$var$supportsNativeMediaSources = ()=>{
    return (0, $e324d09415701181$export$3ee949df8fbc592f)("avc1.4d400d,mp4a.40.2");
}; // register source handlers with the appropriate techs
if ($cb03b711053a4297$var$supportsNativeMediaSources()) $cb03b711053a4297$export$2e2bcd8739ae039.getTech("Html5").registerSourceHandler($cb03b711053a4297$var$VhsSourceHandler, 0);
$cb03b711053a4297$export$2e2bcd8739ae039.VhsHandler = $cb03b711053a4297$var$VhsHandler;
$cb03b711053a4297$export$2e2bcd8739ae039.VhsSourceHandler = $cb03b711053a4297$var$VhsSourceHandler;
$cb03b711053a4297$export$2e2bcd8739ae039.Vhs = $cb03b711053a4297$var$Vhs;
if (!$cb03b711053a4297$export$2e2bcd8739ae039.use) $cb03b711053a4297$export$2e2bcd8739ae039.registerComponent("Vhs", $cb03b711053a4297$var$Vhs);
$cb03b711053a4297$export$2e2bcd8739ae039.options.vhs = $cb03b711053a4297$export$2e2bcd8739ae039.options.vhs || {};
if (!$cb03b711053a4297$export$2e2bcd8739ae039.getPlugin || !$cb03b711053a4297$export$2e2bcd8739ae039.getPlugin("reloadSourceOnError")) $cb03b711053a4297$export$2e2bcd8739ae039.registerPlugin("reloadSourceOnError", $cb03b711053a4297$var$reloadSourceOnError);



const $bad85b7ca97ec128$export$33930a667dafa0ce = (props)=>{
    const videoRef = (0, $acw62.useRef)(null);
    const playerRef = (0, $acw62.useRef)(null);
    const { options: options, onReady: onReady, canPause: canPause } = props;
    const staticOptions = {
        disablePictureInPicture: true,
        controlBar: {
            pictureInPictureToggle: false,
            playToggle: canPause ?? true
        },
        preload: "auto",
        html5: {
            hls: {
                overrideNative: !(0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI
            },
            vhs: {
                overrideNative: !(0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI
            },
            nativeAudioTracks: (0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI,
            nativeVideoTracks: (0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI,
            nativeTextTracks: (0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (!playerRef.current) {
            const videoElement = document.createElement("video-js");
            videoElement.classList.add("vjs-big-play-centered", "video-player");
            if ((0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI) videoElement.setAttribute("playsinline", "");
            videoRef.current?.appendChild(videoElement);
            const player = playerRef.current = (0, $cb03b711053a4297$export$2e2bcd8739ae039)(videoElement, {
                ...options,
                ...staticOptions
            }, ()=>{
                (0, $cb03b711053a4297$export$2e2bcd8739ae039).log("player is ready");
                onReady && onReady(player);
            });
            if ((0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI) {
                let muteButtonEl = videoElement.getElementsByClassName("vjs-mute-control vjs-control vjs-button")[0];
                if (muteButtonEl) {
                    if ((0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_SAFARI) muteButtonEl.addEventListener("click", ()=>player.muted(!player.muted));
                    if ((0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_IOS) muteButtonEl.addEventListener("tap", ()=>player.muted(!player.muted()));
                }
            }
        } else {
            const player = playerRef.current;
            player.autoplay(options.autoplay);
            player.src(options.sources);
        }
    }, [
        options,
        videoRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const player = playerRef.current;
        return ()=>{
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [
        playerRef
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-vjs-player": true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: videoRef
        })
    });
};




function $f195dd442b882af8$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { code: code } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [currentDirection, setCurrentDirection] = (0, $acw62.useState)((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front);
    const [views, setViews] = (0, $acw62.useState)([
        {
            title: t("front"),
            url: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front,
            videoUrl: ""
        },
        {
            title: t("cabin"),
            url: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin,
            videoUrl: ""
        },
        {
            title: t("rear"),
            url: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear,
            videoUrl: ""
        }
    ]);
    (0, $acw62.useEffect)(()=>{
        const rq1 = (0, $33feeae903d89f94$export$2e2bcd8739ae039)().getLinks(code);
        const rq2 = (0, $33feeae903d89f94$export$2e2bcd8739ae039)().getVideos(code);
        const viewsCopy = views.map((view)=>view);
        Promise.all([
            rq1,
            rq2
        ]).then(([thumbnailsRes, videosRes])=>{
            viewsCopy.forEach((view)=>{
                let thumbnail = thumbnailsRes.data.find((res)=>res.direction === view.direction);
                if (thumbnail) view.url = thumbnail.url;
                let video = videosRes.data.find((res)=>res.direction === view.direction);
                if (video) view.videoUrl = video.url;
            });
            setViews(viewsCopy);
            setLoading(false);
        });
    }, []);
    function getView(direction) {
        return views.find((view)=>view.direction === direction);
    }
    function setViewDirection(direction) {
        setCurrentDirection(direction);
    }
    function imageError(direction) {
        const viewsCopy = views.map((view)=>view);
        viewsCopy[direction].url = "";
        setViews(viewsCopy);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-view video mt-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "col-md-8 col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "player-wrap mb-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                    className: "mb-2 ms-2",
                                    children: t("stream_title", {
                                        camera: getView(currentDirection)
                                    })
                                }),
                                getView(currentDirection)?.videoUrl !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "view-box",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad85b7ca97ec128$export$33930a667dafa0ce), {
                                        options: {
                                            autoplay: true,
                                            controls: true,
                                            responsive: true,
                                            fluid: true,
                                            sources: [
                                                {
                                                    src: getView(currentDirection).videoUrl,
                                                    type: "video/mp4"
                                                }
                                            ]
                                        },
                                        onReady: ()=>{}
                                    })
                                }),
                                getView(currentDirection)?.videoUrl === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "no-video d-flex align-items-center justify-content-center",
                                    children: [
                                        !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            children: t("no_camera", {
                                                camera: getView(currentDirection)
                                            })
                                        }),
                                        loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "spinner-border text-white"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "col-md-4 col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "side-bar px-3 pt-1 pb-3",
                            children: views.filter((view)=>view.direction !== currentDirection).map((view)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "view-wrap mt-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                className: "mb-2",
                                                children: t("stream_title", {
                                                    camera: {
                                                        title: view.title
                                                    }
                                                })
                                            }),
                                            view.url === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "view-box not-avail d-flex align-items-center justify-content-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                            children: t("no_camera", {
                                                                camera: {
                                                                    title: view.title
                                                                }
                                                            })
                                                        }),
                                                        loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "spinner-border text-white"
                                                        })
                                                    ]
                                                })
                                            }),
                                            view.url !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "view-box",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    crossOrigin: "anonymous",
                                                    src: view.url,
                                                    className: "img-fluid w-100",
                                                    onClick: ()=>setViewDirection(view.direction),
                                                    onError: ()=>imageError(view.direction)
                                                })
                                            })
                                        ]
                                    })
                                }))
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");






function $307980ad230a366b$export$2e2bcd8739ae039() {
    (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).defaults.headers.common["Content-Type"] = "application/json";
    function acceptInvite(contactId) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $b4b570ff6b0b04ee$export$2e2bcd8739ae039)().witnessApi}/invite/accept/${contactId}`);
    }
    function getStreamUrls(sessionId) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $b4b570ff6b0b04ee$export$2e2bcd8739ae039)().witnessApi}/stream/get-stream-urls/${sessionId}`);
    }
    function getReplayUrls(sessionId, forceHls) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $b4b570ff6b0b04ee$export$2e2bcd8739ae039)().witnessApi}/stream/${forceHls ? "get-hls-replay-stream-urls" : "get-replay-stream-urls"}/${sessionId}`);
    }
    function getIsSessionActive(sessionId) {
        return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $b4b570ff6b0b04ee$export$2e2bcd8739ae039)().witnessApi}/stream/is-active/${sessionId}`);
    }
    return {
        acceptInvite: acceptInvite,
        getStreamUrls: getStreamUrls,
        getReplayUrls: getReplayUrls,
        getIsSessionActive: getIsSessionActive
    };
}



function $a8bc24388f2d364c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { sessionId: sessionId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [finished, setFinished] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [loadError, setLoadError] = (0, $acw62.useState)(false);
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    if (loadError) throw new Response("Not Found", {
        status: 404
    });
    function teardown() {
        document.querySelector("body").className = "default-body";
    }
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>{
            (0, $307980ad230a366b$export$2e2bcd8739ae039)().getIsSessionActive(sessionId).then((res)=>{
                if (!res.data) {
                    setFinished(true);
                    if (searchParams.size > 0) navigate(`/witness/replay/${sessionId}?${searchParams.toString()}`);
                    else navigate(`/witness/replay/${sessionId}`);
                }
            });
        }, 5000);
        return ()=>clearInterval(interval);
    }, []);
    (0, $acw62.useEffect)(()=>{
        document.querySelector("body").className = "dark-body";
        const viewsCopy = views.map((view)=>view);
        (0, $307980ad230a366b$export$2e2bcd8739ae039)().getStreamUrls(sessionId).then((res)=>{
            res.data.forEach((stream)=>{
                let idx = viewsCopy.findIndex((view)=>view.direction === (0, $9f39a4be534e41e6$export$7be13381b28f0165)(stream.direction));
                if (idx > -1) viewsCopy[idx].streamUrl = stream.streamURL;
            });
            setViews(viewsCopy);
            setLoading(false);
        }).catch((err)=>{
            if (err.response.status === 404) {
                if (searchParams.size > 0) navigate(`/witness/replay/${sessionId}?${searchParams.toString()}`);
                else navigate(`/witness/replay/${sessionId}`);
            } else setLoadError(true);
        });
        return ()=>teardown();
    }, [
        sessionId
    ]);
    const [views, setViews] = (0, $acw62.useState)([
        {
            title: t("front"),
            lastThumbnail: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front,
            streamUrl: ""
        },
        {
            title: t("cabin"),
            lastThumbnail: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin,
            streamUrl: ""
        },
        {
            title: t("rear"),
            lastThumbnail: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear,
            streamUrl: ""
        }
    ]);
    function getView(direction) {
        return views.find((view)=>view.direction === direction);
    }
    function onPlayerReady(player) {
        player.play();
        player.on("error", ()=>{
            if (searchParams.size > 0) navigate(`/witness/replay/${sessionId}?${searchParams.toString()}`);
            else navigate(`/witness/replay/${sessionId}`);
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-view witness-live mt-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "col-md-8 col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "player-wrap witness-live mb-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                    className: "mb-2 ms-2",
                                    children: t("stream_title", {
                                        camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)
                                    })
                                }),
                                getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)?.streamUrl !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "view-box spotlight",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad85b7ca97ec128$export$33930a667dafa0ce), {
                                            options: {
                                                autoplay: "muted",
                                                controls: true,
                                                fluid: true,
                                                responsive: true,
                                                sources: [
                                                    {
                                                        src: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front).streamUrl,
                                                        type: "application/x-mpegURL"
                                                    }
                                                ]
                                            },
                                            onReady: (player)=>onPlayerReady(player),
                                            canPause: false
                                        }),
                                        finished && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "dim-box",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "finished-header-container",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                        className: "finished-header",
                                                        children: t("witness_stopped")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "finished-text-container",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "finished-text",
                                                        children: [
                                                            t("watch_again"),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                to: "/",
                                                                children: "iq.nextbase.com"
                                                            }),
                                                            t("watch_again_2")
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        !finished && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "live-banner",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "dot dot-live"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: t("live")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)?.streamUrl === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "no-video d-flex align-items-center justify-content-center",
                                    children: [
                                        !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            children: t("no_camera", {
                                                camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)
                                            })
                                        }),
                                        loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "spinner-border text-white"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "col-md-4 col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "side-bar px-3 pt-1 pb-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "view-wrap mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            className: "mb-2",
                                            children: t("stream_title", {
                                                camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)
                                            })
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)?.streamUrl !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "view-box",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad85b7ca97ec128$export$33930a667dafa0ce), {
                                                    options: {
                                                        autoplay: "muted",
                                                        controls: false,
                                                        fluid: true,
                                                        responsive: true,
                                                        sources: [
                                                            {
                                                                src: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin).streamUrl,
                                                                type: "application/x-mpegURL"
                                                            }
                                                        ]
                                                    },
                                                    onReady: (player)=>onPlayerReady(player)
                                                }),
                                                finished && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "dim-box"
                                                })
                                            ]
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)?.streamUrl === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "not-avail d-flex align-items-center justify-content-center",
                                            children: [
                                                !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                    children: t("no_camera", {
                                                        camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)
                                                    })
                                                }),
                                                loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "spinner-border text-white"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "view-wrap mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            className: "mb-2",
                                            children: t("stream_title", {
                                                camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)
                                            })
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)?.streamUrl !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "view-box",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad85b7ca97ec128$export$33930a667dafa0ce), {
                                                    options: {
                                                        autoplay: "muted",
                                                        controls: false,
                                                        fluid: true,
                                                        responsive: true,
                                                        sources: [
                                                            {
                                                                src: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear).streamUrl,
                                                                type: "application/x-mpegURL"
                                                            }
                                                        ]
                                                    },
                                                    onReady: (player)=>onPlayerReady(player)
                                                }),
                                                finished && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "dim-box"
                                                })
                                            ]
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)?.streamUrl === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "not-avail d-flex align-items-center justify-content-center",
                                            children: [
                                                !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                    children: t("no_camera", {
                                                        camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)
                                                    })
                                                }),
                                                loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "spinner-border text-white"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");







function $8a808e79cf90e827$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { sessionId: sessionId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [loadError, setLoadError] = (0, $acw62.useState)(false);
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    let players = [];
    let retryAttempt = 0;
    if (loadError) throw new Response("Not Found", {
        status: 404
    });
    const [views, setViews] = (0, $acw62.useState)([
        {
            title: t("front"),
            lastThumbnail: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front,
            streamUrl: ""
        },
        {
            title: t("cabin"),
            lastThumbnail: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin,
            streamUrl: ""
        },
        {
            title: t("rear"),
            lastThumbnail: "",
            direction: (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear,
            streamUrl: ""
        }
    ]);
    function getView(direction) {
        return views.find((view)=>view.direction === direction);
    }
    if (searchParams.size) window.history.replaceState(null, "", `/witness/${sessionId}?${searchParams.toString()}`);
    else window.history.replaceState(null, "", `/witness/${sessionId}`);
    function teardown() {
        document.querySelector("body").className = "default-body";
    }
    (0, $acw62.useEffect)(()=>{
        document.querySelector("body").className = "dark-body";
        tryGetReplayUrls();
        return ()=>teardown();
    }, [
        sessionId
    ]);
    function tryGetReplayUrls() {
        const viewsCopy = views.map((view)=>view);
        (0, $307980ad230a366b$export$2e2bcd8739ae039)().getReplayUrls(sessionId, (0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI).then((res)=>{
            res.data.forEach((stream)=>{
                let idx = viewsCopy.findIndex((view)=>view.direction === (0, $9f39a4be534e41e6$export$7be13381b28f0165)(stream.direction));
                if (idx > -1) viewsCopy[idx].streamUrl = stream.streamURL;
            });
            setViews(viewsCopy);
            setLoading(false);
        }).catch((err)=>{
            if (retryAttempt >= 5) setLoadError(true);
            else {
                retryAttempt++;
                setTimeout(()=>tryGetReplayUrls(), retryAttempt * 500); // increase wait before retry 5 seconds each time
            }
        });
    }
    function onPlayerReady(player, direction) {
        players.push({
            player: player,
            direction: direction
        });
        player.play();
        if (direction === (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front) {
            player.on("pause", ()=>pauseSecondaryViews());
            player.on("play", ()=>playSecondaryViews());
            player.on("seeking", ()=>seekSecondaryViews());
            player.on("error", ()=>setLoadError(true));
        }
    }
    function seekSecondaryViews() {
        const seekToTime = players.find((player)=>player.direction === (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)?.player?.currentTime();
        players.filter((player)=>player.direction !== (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front).forEach((player)=>{
            player.player.currentTime(seekToTime);
        });
    }
    function pauseSecondaryViews() {
        players.filter((player)=>player.direction !== (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front).forEach((player)=>{
            player.player.pause();
        });
    }
    function playSecondaryViews() {
        players.filter((player)=>player.direction !== (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front).forEach((player)=>{
            player.player.play();
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-view witness-replay mt-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "front-stream-viewer col-md-8 col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "player-wrap witness-replay mb-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                    className: "mb-2 ms-2",
                                    children: t("stream_title", {
                                        camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)
                                    })
                                }),
                                getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)?.streamUrl !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "view-box",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad85b7ca97ec128$export$33930a667dafa0ce), {
                                        options: {
                                            autoplay: "muted",
                                            controls: true,
                                            fluid: true,
                                            responsive: true,
                                            sources: [
                                                {
                                                    src: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front).streamUrl,
                                                    type: (0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI ? "application/x-mpegURL" : "application/dash+xml"
                                                }
                                            ]
                                        },
                                        onReady: (player)=>onPlayerReady(player, (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)
                                    })
                                }),
                                getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)?.streamUrl === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "no-video d-flex align-items-center justify-content-center",
                                    children: [
                                        !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            children: t("no_camera", {
                                                camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Front)
                                            })
                                        }),
                                        loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "spinner-border text-white"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "col-md-4 col-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "side-bar px-3 pt-1 pb-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "view-wrap mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            className: "mb-2",
                                            children: t("stream_title", {
                                                camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)
                                            })
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)?.streamUrl !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "view-box",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad85b7ca97ec128$export$33930a667dafa0ce), {
                                                    options: {
                                                        autoplay: "muted",
                                                        controls: false,
                                                        fluid: true,
                                                        responsive: true,
                                                        sources: [
                                                            {
                                                                src: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin).streamUrl,
                                                                type: (0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI ? "application/x-mpegURL" : "application/dash+xml"
                                                            }
                                                        ]
                                                    },
                                                    onReady: (player)=>onPlayerReady(player, (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)
                                                })
                                            })
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)?.streamUrl === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "not-avail d-flex align-items-center justify-content-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                        children: t("no_camera", {
                                                            camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Cabin)
                                                        })
                                                    }),
                                                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "spinner-border text-white"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "view-wrap mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                            className: "mb-2",
                                            children: t("stream_title", {
                                                camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)
                                            })
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)?.streamUrl !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "view-box",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bad85b7ca97ec128$export$33930a667dafa0ce), {
                                                    options: {
                                                        autoplay: "muted",
                                                        controls: false,
                                                        fluid: true,
                                                        responsive: true,
                                                        sources: [
                                                            {
                                                                src: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear).streamUrl,
                                                                type: (0, $cb03b711053a4297$export$2e2bcd8739ae039).browser.IS_ANY_SAFARI ? "application/x-mpegURL" : "application/dash+xml"
                                                            }
                                                        ]
                                                    },
                                                    onReady: (player)=>onPlayerReady(player, (0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)
                                                })
                                            })
                                        }),
                                        getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)?.streamUrl === "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "not-avail d-flex align-items-center justify-content-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                        children: t("no_camera", {
                                                            camera: getView((0, $9f39a4be534e41e6$export$cacd6541cfeeb6c1).Rear)
                                                        })
                                                    }),
                                                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "spinner-border text-white"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");



function $b46c589c8c5e5b20$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { contactId: contactId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [acceptSuccess, setAcceptSuccess] = (0, $acw62.useState)(false);
    const [inviteByUser, setInviteByUser] = (0, $acw62.useState)("iQ");
    function teardown() {
        document.querySelector("body").className = "default-body";
    }
    (0, $acw62.useEffect)(()=>{
        document.querySelector("body").className = "dark-body";
        (0, $307980ad230a366b$export$2e2bcd8739ae039)().acceptInvite(contactId).then((res)=>{
            setInviteByUser(res.data.invitedBy);
            setAcceptSuccess(true);
            setLoading(false);
        }).catch((err)=>{
            setLoading(false);
        });
        return ()=>teardown();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-view",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "d-flex justify-content-center",
                children: [
                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "col-md-5 p-3 code-view",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "d-flex justify-content-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "spinner-border text-white"
                            })
                        })
                    }),
                    !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "col-md-5 p-3 code-view",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "iq-logo",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "d-flex justify-content-center",
                                        children: [
                                            acceptSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "56",
                                                height: "57",
                                                viewBox: "0 0 56 57",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M28 0.875C35.4261 0.875 42.548 3.82499 47.799 9.07601C53.05 14.327 56 21.4489 56 28.875C56 36.3011 53.05 43.423 47.799 48.674C42.548 53.925 35.4261 56.875 28 56.875C20.5739 56.875 13.452 53.925 8.20101 48.674C2.94999 43.423 0 36.3011 0 28.875C0 21.4489 2.94999 14.327 8.20101 9.07601C13.452 3.82499 20.5739 0.875 28 0.875ZM24.512 34.399L18.292 28.175C18.069 27.952 17.8043 27.7751 17.513 27.6545C17.2216 27.5338 16.9093 27.4717 16.594 27.4717C16.2787 27.4717 15.9664 27.5338 15.675 27.6545C15.3837 27.7751 15.119 27.952 14.896 28.175C14.4457 28.6253 14.1927 29.2361 14.1927 29.873C14.1927 30.5099 14.4457 31.1207 14.896 31.571L22.816 39.491C23.0384 39.7151 23.3029 39.893 23.5943 40.0144C23.8857 40.1357 24.1983 40.1982 24.514 40.1982C24.8297 40.1982 25.1423 40.1357 25.4337 40.0144C25.7251 39.893 25.9896 39.7151 26.212 39.491L42.612 23.087C42.838 22.8649 43.0177 22.6003 43.1409 22.3085C43.2641 22.0166 43.3283 21.7032 43.3298 21.3864C43.3312 21.0696 43.27 20.7556 43.1495 20.4626C43.029 20.1696 42.8517 19.9033 42.6278 19.6792C42.404 19.455 42.1379 19.2774 41.845 19.1566C41.5522 19.0358 41.2383 18.9741 40.9215 18.9752C40.6046 18.9763 40.2912 19.0402 39.9992 19.163C39.7071 19.2858 39.4423 19.4653 39.22 19.691L24.512 34.399Z",
                                                    fill: "#34C759"
                                                })
                                            }),
                                            !acceptSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "56",
                                                height: "57",
                                                viewBox: "0 0 56 57",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M28 56.875C12.6443 56.875 0 44.2307 0 28.875C0 13.5461 12.6443 0.875 27.9732 0.875C43.3289 0.875 56 13.5461 56 28.875C56 44.2307 43.3557 56.875 28 56.875ZM28 33.2508C29.6644 33.2508 30.6577 32.3112 30.7114 30.5663L31.1409 17.8951C31.1946 16.0965 29.8792 14.8079 27.9732 14.8079C26.0671 14.8079 24.7785 16.0696 24.8591 17.8683L25.2617 30.5663C25.3154 32.3112 26.3087 33.2508 28 33.2508ZM28 42.7005C29.9597 42.7005 31.5168 41.3851 31.5168 39.479C31.5168 37.5998 29.9597 36.2575 28 36.2575C26.0403 36.2575 24.5101 37.5998 24.5101 39.479C24.5101 41.3582 26.0671 42.7005 28 42.7005Z",
                                                    fill: "#F2821B"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "d-flex justify-content-center mb-3",
                                        children: [
                                            acceptSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: t("success")
                                            }),
                                            !acceptSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: t("invite_not_found")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    acceptSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "small mt-2 text-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            i18nKey: "invite_success_body",
                                            values: {
                                                inviteByUser: inviteByUser
                                            }
                                        })
                                    }),
                                    !acceptSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "small mt-2 text-center",
                                        children: t("invite_not_found_body")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "small mt-2 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://nextbase.co.uk/iq-experience",
                                                target: "_blank",
                                                children: t("learn_more")
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                width: "24",
                                                height: "25",
                                                viewBox: "0 0 24 25",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                                        id: "arrow_forward",
                                                        "clip-path": "url(#clip0_32345_10162)",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            id: "Vector",
                                                            d: "M5 13.8752H16.17L11.29 18.7552C10.9 19.1452 10.9 19.7852 11.29 20.1752C11.68 20.5652 12.31 20.5652 12.7 20.1752L19.29 13.5852C19.68 13.1952 19.68 12.5652 19.29 12.1752L12.71 5.57521C12.32 5.18521 11.69 5.18521 11.3 5.57521C10.91 5.96521 10.91 6.59522 11.3 6.98522L16.17 11.8752H5C4.45 11.8752 4 12.3252 4 12.8752C4 13.4252 4.45 13.8752 5 13.8752Z",
                                                            fill: "white"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                            id: "clip0_32345_10162",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                width: "24",
                                                                height: "24",
                                                                fill: "white",
                                                                transform: "translate(0 0.875)"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}






function $c69a3e7d1d2cd06f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-view auth-success",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "col-md-5 p-3 code-view",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "iq-logo",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $367491e86d055a33$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "d-flex justify-content-center mb-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: t("success")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "small mt-2 text-center",
                                children: t("wait_for_redirect")
                            })
                        })
                    ]
                })
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");
function $19f1d227f38c8649$export$2e2bcd8739ae039() {
    (0, $acw62.useEffect)(()=>{
        window.location.href = "https://support.nextbase.com/hc/en-gb/articles/18938346035869-How-to-update-your-IQ-Firmware";
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}


const $21c0a985111b25a6$var$router = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48c43979d6890df9$export$2e2bcd8739ae039), {}),
        errorElement: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba865323121b4875$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ad3099a4963f3ff$export$2e2bcd8739ae039), {})
            },
            {
                path: "/video/:code",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f195dd442b882af8$export$2e2bcd8739ae039), {})
            },
            {
                path: "/witness/:sessionId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8bc24388f2d364c$export$2e2bcd8739ae039), {})
            },
            {
                path: "/witness/replay/:sessionId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a808e79cf90e827$export$2e2bcd8739ae039), {})
            },
            {
                path: "/witness/accept/:contactId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b46c589c8c5e5b20$export$2e2bcd8739ae039), {})
            },
            {
                path: "/auth",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c69a3e7d1d2cd06f$export$2e2bcd8739ae039), {})
            },
            {
                path: "/more-screen/dc-settings/fw-landing",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19f1d227f38c8649$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
var $21c0a985111b25a6$export$2e2bcd8739ae039 = $21c0a985111b25a6$var$router;


function $b2ec325d366241ee$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
        router: (0, $21c0a985111b25a6$export$2e2bcd8739ae039)
    });
}


const $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = [].concat(this.observers["*"]);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $673ff3dfc4a496de$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
}
const $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $673ff3dfc4a496de$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $673ff3dfc4a496de$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== "string") path = path.concat(key);
        if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) path = lng.split(".");
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: resolved,
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $673ff3dfc4a496de$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $673ff3dfc4a496de$var$intlVersions = [
    "v4"
];
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    const rules = {};
    $673ff3dfc4a496de$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $673ff3dfc4a496de$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($673ff3dfc4a496de$var$getCleanedCode(code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$673ff3dfc4a496de$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $673ff3dfc4a496de$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, "g");
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($673ff3dfc4a496de$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $673ff3dfc4a496de$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $673ff3dfc4a496de$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;



function $f6e8edbd6de2d1a8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f6e8edbd6de2d1a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f6e8edbd6de2d1a8$var$_typeof(o);
}
var $f6e8edbd6de2d1a8$var$arr = [];
var $f6e8edbd6de2d1a8$var$each = $f6e8edbd6de2d1a8$var$arr.forEach;
var $f6e8edbd6de2d1a8$var$slice = $f6e8edbd6de2d1a8$var$arr.slice;
function $f6e8edbd6de2d1a8$export$ebe90cb607ad99e(obj) {
    $f6e8edbd6de2d1a8$var$each.call($f6e8edbd6de2d1a8$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $f6e8edbd6de2d1a8$export$87022daa49baf612() {
    return typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $f6e8edbd6de2d1a8$var$_typeof(XMLHttpRequest)) === "object";
}
function $f6e8edbd6de2d1a8$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
function $f6e8edbd6de2d1a8$export$1625492ec82002b9(maybePromise) {
    if ($f6e8edbd6de2d1a8$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



var $24c3677c8ec8d51d$exports = {};
var $24c3677c8ec8d51d$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $24c3677c8ec8d51d$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $24c3677c8ec8d51d$var$fetchApi = window.fetch;
    else $24c3677c8ec8d51d$var$fetchApi = fetch;
}

if (typeof window === "undefined" || typeof window.document === "undefined") {
    var $24c3677c8ec8d51d$var$f = $24c3677c8ec8d51d$var$fetchApi || (parcelRequire("R5nvG"));
    if ($24c3677c8ec8d51d$var$f.default) $24c3677c8ec8d51d$var$f = $24c3677c8ec8d51d$var$f.default;
    $24c3677c8ec8d51d$exports.default = $24c3677c8ec8d51d$var$f;
    $24c3677c8ec8d51d$exports = $24c3677c8ec8d51d$exports.default;
}


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


function $cad892b69e25befc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cad892b69e25befc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cad892b69e25befc$var$_typeof(o);
}
var $cad892b69e25befc$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $cad892b69e25befc$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $cad892b69e25befc$var$fetchApi = window.fetch;
    else $cad892b69e25befc$var$fetchApi = fetch;
}
var $cad892b69e25befc$var$XmlHttpRequestApi;
if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== "undefined" && $parcel$global.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== "undefined" && window.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $cad892b69e25befc$var$ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== "undefined" && window.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$cad892b69e25befc$var$fetchApi && $24c3677c8ec8d51d$exports && !$cad892b69e25befc$var$XmlHttpRequestApi && !$cad892b69e25befc$var$ActiveXObjectApi) $cad892b69e25befc$var$fetchApi = $24c3677c8ec8d51d$exports.default || $24c3677c8ec8d51d$exports;
if (typeof $cad892b69e25befc$var$fetchApi !== "function") $cad892b69e25befc$var$fetchApi = undefined;
var $cad892b69e25befc$var$addQueryString = function addQueryString(url, params) {
    if (params && $cad892b69e25befc$var$_typeof(params) === "object") {
        var queryString = "";
        for(var paramName in params)queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
var $cad892b69e25befc$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (typeof fetch === "function") fetch(url, fetchOptions).then(resolver).catch(callback);
    else $cad892b69e25befc$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $cad892b69e25befc$var$omitFetchOptions = false;
var $cad892b69e25befc$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)({}, typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders);
    if (typeof window === "undefined" && typeof $cfae44f0dfdf62c0$exports !== "undefined" && $cfae44f0dfdf62c0$exports.versions && $cfae44f0dfdf62c0$exports.versions.node) headers["User-Agent"] = "i18next-http-backend (node/".concat($cfae44f0dfdf62c0$exports.version, "; ").concat($cfae44f0dfdf62c0$exports.platform, " ").concat($cfae44f0dfdf62c0$exports.arch, ")");
    if (payload) headers["Content-Type"] = "application/json";
    var reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)({
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $cad892b69e25befc$var$omitFetchOptions ? {} : reqOptions);
    try {
        $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback);
            $cad892b69e25befc$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $cad892b69e25befc$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $cad892b69e25befc$var$_typeof(payload) === "object") payload = $cad892b69e25befc$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($cad892b69e25befc$var$XmlHttpRequestApi) x = new $cad892b69e25befc$var$XmlHttpRequestApi();
        else x = new $cad892b69e25befc$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        var h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $cad892b69e25befc$var$request = function request(options, url, payload, callback) {
    if (typeof payload === "function") {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($cad892b69e25befc$var$fetchApi && url.indexOf("file:") !== 0) return $cad892b69e25befc$var$requestWithFetch(options, url, payload, callback);
    if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)() || typeof ActiveXObject === "function") return $cad892b69e25befc$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error("No fetch and no xhr implementation found!"));
};
var $cad892b69e25befc$export$2e2bcd8739ae039 = $cad892b69e25befc$var$request;


function $3faa45b77b2a48ba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3faa45b77b2a48ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3faa45b77b2a48ba$var$_typeof(o);
}
function $3faa45b77b2a48ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3faa45b77b2a48ba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3faa45b77b2a48ba$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3faa45b77b2a48ba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3faa45b77b2a48ba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3faa45b77b2a48ba$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3faa45b77b2a48ba$var$_defineProperty(obj, key, value) {
    key = $3faa45b77b2a48ba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3faa45b77b2a48ba$var$_toPropertyKey(arg) {
    var key = $3faa45b77b2a48ba$var$_toPrimitive(arg, "string");
    return $3faa45b77b2a48ba$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3faa45b77b2a48ba$var$_toPrimitive(input, hint) {
    if ($3faa45b77b2a48ba$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3faa45b77b2a48ba$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3faa45b77b2a48ba$var$getDefaults = function getDefaults() {
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $3faa45b77b2a48ba$var$_defineProperty({}, key, fallbackValue || "");
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $cad892b69e25befc$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $3faa45b77b2a48ba$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $3faa45b77b2a48ba$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    $3faa45b77b2a48ba$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)(options, this.options || {}, $3faa45b77b2a48ba$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $f6e8edbd6de2d1a8$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join("+"),
                        ns: namespaces.join("+")
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === "string" ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === "string" ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + url + "; status code: " + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + url + "; status code: " + res.status, false);
                    if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1) return callback("failed loading " + url + ": " + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === "string") ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = "failed parsing " + url + " to json";
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === "string") languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === "function") addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === "function") callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$3faa45b77b2a48ba$var$Backend.type = "backend";
var $3faa45b77b2a48ba$export$2e2bcd8739ae039 = $3faa45b77b2a48ba$var$Backend;


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


var $60196a4650e96cb1$var$arr = [];
var $60196a4650e96cb1$var$each = $60196a4650e96cb1$var$arr.forEach;
var $60196a4650e96cb1$var$slice = $60196a4650e96cb1$var$arr.slice;
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$each.call($60196a4650e96cb1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $60196a4650e96cb1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $60196a4650e96cb1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $60196a4650e96cb1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $60196a4650e96cb1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hasLocalStorageSupport = null;
var $60196a4650e96cb1$var$localStorageAvailable = function localStorageAvailable() {
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $60196a4650e96cb1$var$hasSessionStorageSupport = null;
var $60196a4650e96cb1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $60196a4650e96cb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace("-", "_");
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($60196a4650e96cb1$var$cookie$1);
                this.addDetector($60196a4650e96cb1$var$querystring);
                this.addDetector($60196a4650e96cb1$var$localStorage);
                this.addDetector($60196a4650e96cb1$var$sessionStorage);
                this.addDetector($60196a4650e96cb1$var$navigator$1);
                this.addDetector($60196a4650e96cb1$var$htmlTag);
                this.addDetector($60196a4650e96cb1$var$path);
                this.addDetector($60196a4650e96cb1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$60196a4650e96cb1$export$2e2bcd8739ae039.type = "languageDetector";


(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)).use((0, $3faa45b77b2a48ba$export$2e2bcd8739ae039)).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).init({
    supportedLngs: [
        "en",
        "en-US",
        "de",
        "es",
        "fr",
        "pl",
        "ro",
        "nl",
        "sv",
        "cs",
        "no",
        "da",
        "fi"
    ],
    fallbackLng: "en-GB",
    nonExplicitSupportedLngs: true,
    interpolation: {
        escapeValue: false
    },
    debug: false,
    backend: {
        loadPath: "/locales/{{ns}}.{{lng}}.json"
    }
});
var $13d34b821ab5125d$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);


const $a88ea9323d3a23c8$var$domNode = document.getElementById("root");
const $a88ea9323d3a23c8$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($a88ea9323d3a23c8$var$domNode);
$a88ea9323d3a23c8$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Suspense, {
        fallback: "Loading...",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2ec325d366241ee$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.52f8d6e8.js.map
